import { ref, computed, defineComponent, onBeforeUnmount, onMounted, nextTick, reactive, watch, getCurrentInstance, watchEffect, toRefs } from "vue-demi";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var a2 = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d2 = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a2, k, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a2;
}
var require$1 = {};
var I18n$1 = {};
var isArray$d = Array.isArray;
var isArray_1 = isArray$d;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$8 = freeGlobal || freeSelf || Function("return this")();
var _root = root$8;
var root$7 = _root;
var Symbol$6 = root$7.Symbol;
var _Symbol = Symbol$6;
var Symbol$5 = _Symbol;
var objectProto$f = Object.prototype;
var hasOwnProperty$c = objectProto$f.hasOwnProperty;
var nativeObjectToString$1 = objectProto$f.toString;
var symToStringTag$1 = Symbol$5 ? Symbol$5.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$c.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$e = Object.prototype;
var nativeObjectToString = objectProto$e.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$4 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$4 ? Symbol$4.toStringTag : void 0;
function baseGetTag$6(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$6;
function isObjectLike$7(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$7;
var baseGetTag$5 = _baseGetTag, isObjectLike$6 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$5(value) {
  return typeof value == "symbol" || isObjectLike$6(value) && baseGetTag$5(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$5;
var isArray$c = isArray_1, isSymbol$4 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(value, object) {
  if (isArray$c(value)) {
    return false;
  }
  var type2 = typeof value;
  if (type2 == "number" || type2 == "symbol" || type2 == "boolean" || value == null || isSymbol$4(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$3;
function isObject$a(value) {
  var type2 = typeof value;
  return value != null && (type2 == "object" || type2 == "function");
}
var isObject_1 = isObject$a;
var baseGetTag$4 = _baseGetTag, isObject$9 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$4(value) {
  if (!isObject$9(value)) {
    return false;
  }
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$4;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$3 = isFunction_1, isMasked = _isMasked, isObject$8 = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$d = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$b = objectProto$d.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$b).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject$8(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$7;
var getNative$6 = _getNative;
var nativeCreate$4 = getNative$6(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$c = Object.prototype;
var hasOwnProperty$a = objectProto$c.hasOwnProperty;
function hashGet$1(key) {
  var data2 = this.__data__;
  if (nativeCreate$2) {
    var result = data2[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$a.call(data2, key) ? data2[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$b = Object.prototype;
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
function hashHas$1(key) {
  var data2 = this.__data__;
  return nativeCreate$1 ? data2[key] !== void 0 : hasOwnProperty$9.call(data2, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data2 = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data2[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$8(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1$1 = eq$8;
var eq$7 = eq_1$1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$7(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data2 = this.__data__, index2 = assocIndexOf$3(data2, key);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data2.length - 1;
  if (index2 == lastIndex) {
    data2.pop();
  } else {
    splice.call(data2, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data2 = this.__data__, index2 = assocIndexOf$2(data2, key);
  return index2 < 0 ? void 0 : data2[index2][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data2 = this.__data__, index2 = assocIndexOf(data2, key);
  if (index2 < 0) {
    ++this.size;
    data2.push([key, value]);
  } else {
    data2[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var getNative$5 = _getNative, root$5 = _root;
var Map$4 = getNative$5(root$5, "Map");
var _Map = Map$4;
var Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$3)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type2 = typeof value;
  return type2 == "string" || type2 == "number" || type2 == "symbol" || type2 == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data2 = map.__data__;
  return isKeyable(key) ? data2[typeof key == "string" ? "string" : "hash"] : data2.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data2 = getMapData(this, key), size = data2.size;
  data2.set(key, value);
  this.size += data2.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype["delete"] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3;
var MapCache$2 = _MapCache;
var FUNC_ERROR_TEXT = "Expected a function";
function memoize$1(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache2 = memoized.cache;
    if (cache2.has(key)) {
      return cache2.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache2.set(key, result) || cache2;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2)();
  return memoized;
}
memoize$1.Cache = MapCache$2;
var memoize_1 = memoize$1;
var memoize = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache2.size === MAX_MEMOIZE_SIZE) {
      cache2.clear();
    }
    return key;
  });
  var cache2 = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar = /\\(\\)?/g;
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$1;
function arrayMap$2(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
var _arrayMap = arrayMap$2;
var Symbol$3 = _Symbol, arrayMap$1 = _arrayMap, isArray$b = isArray_1, isSymbol$3 = isSymbol_1;
var INFINITY$3 = 1 / 0;
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$b(value)) {
    return arrayMap$1(value, baseToString$1) + "";
  }
  if (isSymbol$3(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$3 ? "-0" : result;
}
var _baseToString = baseToString$1;
var baseToString = _baseToString;
function toString$8(value) {
  return value == null ? "" : baseToString(value);
}
var toString_1 = toString$8;
var isArray$a = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString$7 = toString_1;
function castPath$2(value, object) {
  if (isArray$a(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$7(value));
}
var _castPath = castPath$2;
var isSymbol$2 = isSymbol_1;
var INFINITY$2 = 1 / 0;
function toKey$4(value) {
  if (typeof value == "string" || isSymbol$2(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
var _toKey = toKey$4;
var castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$3(object, path) {
  path = castPath$1(path, object);
  var index2 = 0, length = path.length;
  while (object != null && index2 < length) {
    object = object[toKey$3(path[index2++])];
  }
  return index2 && index2 == length ? object : void 0;
}
var _baseGet = baseGet$3;
var baseGet$2 = _baseGet;
function get$3(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet$2(object, path);
  return result === void 0 ? defaultValue : result;
}
var get_1$1 = get$3;
var objectProto$a = Object.prototype;
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
function baseHas$1(object, key) {
  return object != null && hasOwnProperty$8.call(object, key);
}
var _baseHas = baseHas$1;
var baseGetTag$3 = _baseGetTag, isObjectLike$5 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$5(value) && baseGetTag$3(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$4 = isObjectLike_1;
var objectProto$9 = Object.prototype;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var propertyIsEnumerable$1 = objectProto$9.propertyIsEnumerable;
var isArguments$4 = baseIsArguments(function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$4(value) && hasOwnProperty$7.call(value, "callee") && !propertyIsEnumerable$1.call(value, "callee");
};
var isArguments_1 = isArguments$4;
var MAX_SAFE_INTEGER$4 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(value, length) {
  var type2 = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$4 : length;
  return !!length && (type2 == "number" || type2 != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$3;
var MAX_SAFE_INTEGER$3 = 9007199254740991;
function isLength$3(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
}
var isLength_1 = isLength$3;
var castPath = _castPath, isArguments$3 = isArguments_1, isArray$9 = isArray_1, isIndex$2 = _isIndex, isLength$2 = isLength_1, toKey$2 = _toKey;
function hasPath$2(object, path, hasFunc) {
  path = castPath(path, object);
  var index2 = -1, length = path.length, result = false;
  while (++index2 < length) {
    var key = toKey$2(path[index2]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index2 != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$2(key, length) && (isArray$9(object) || isArguments$3(object));
}
var _hasPath = hasPath$2;
var baseHas = _baseHas, hasPath$1 = _hasPath;
function has(object, path) {
  return object != null && hasPath$1(object, path, baseHas);
}
var has_1$1 = has;
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data2 = this.__data__, result = data2["delete"](key);
  this.size = data2.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(key, value) {
  var data2 = this.__data__;
  if (data2 instanceof ListCache$1) {
    var pairs = data2.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE$1 - 1) {
      pairs.push([key, value]);
      this.size = ++data2.size;
      return this;
    }
    data2 = this.__data__ = new MapCache$1(pairs);
  }
  data2.set(key, value);
  this.size = data2.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$3(entries) {
  var data2 = this.__data__ = new ListCache(entries);
  this.size = data2.size;
}
Stack$3.prototype.clear = stackClear;
Stack$3.prototype["delete"] = stackDelete;
Stack$3.prototype.get = stackGet;
Stack$3.prototype.has = stackHas;
Stack$3.prototype.set = stackSet;
var _Stack = Stack$3;
var getNative$4 = _getNative;
var defineProperty$3 = function() {
  try {
    var func = getNative$4(Object, "defineProperty");
    func({}, "", {});
    return func;
  } catch (e2) {
  }
}();
var _defineProperty = defineProperty$3;
var defineProperty$2 = _defineProperty;
function baseAssignValue$3(object, key, value) {
  if (key == "__proto__" && defineProperty$2) {
    defineProperty$2(object, key, {
      "configurable": true,
      "enumerable": true,
      "value": value,
      "writable": true
    });
  } else {
    object[key] = value;
  }
}
var _baseAssignValue = baseAssignValue$3;
var baseAssignValue$2 = _baseAssignValue, eq$6 = eq_1$1;
function assignMergeValue$2(object, key, value) {
  if (value !== void 0 && !eq$6(object[key], value) || value === void 0 && !(key in object)) {
    baseAssignValue$2(object, key, value);
  }
}
var _assignMergeValue = assignMergeValue$2;
function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index2 = -1, iterable = Object(object), props2 = keysFunc(object), length = props2.length;
    while (length--) {
      var key = props2[fromRight ? length : ++index2];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}
var _createBaseFor = createBaseFor$1;
var createBaseFor = _createBaseFor;
var baseFor$2 = createBaseFor();
var _baseFor = baseFor$2;
var _cloneBuffer = { exports: {} };
(function(module, exports) {
  var root2 = _root;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0, allocUnsafe = Buffer ? Buffer.allocUnsafe : void 0;
  function cloneBuffer2(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module.exports = cloneBuffer2;
})(_cloneBuffer, _cloneBuffer.exports);
var root$4 = _root;
var Uint8Array$3 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$3;
var Uint8Array$2 = _Uint8Array;
function cloneArrayBuffer$1(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$2(result).set(new Uint8Array$2(arrayBuffer));
  return result;
}
var _cloneArrayBuffer = cloneArrayBuffer$1;
var cloneArrayBuffer = _cloneArrayBuffer;
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var _cloneTypedArray = cloneTypedArray$1;
function copyArray$1(source2, array) {
  var index2 = -1, length = source2.length;
  array || (array = Array(length));
  while (++index2 < length) {
    array[index2] = source2[index2];
  }
  return array;
}
var _copyArray = copyArray$1;
var isObject$7 = isObject_1;
var objectCreate = Object.create;
var baseCreate$1 = function() {
  function object() {
  }
  return function(proto) {
    if (!isObject$7(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object();
    object.prototype = void 0;
    return result;
  };
}();
var _baseCreate = baseCreate$1;
function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$2;
var overArg$1 = _overArg;
var getPrototype$2 = overArg$1(Object.getPrototypeOf, Object);
var _getPrototype = getPrototype$2;
var objectProto$8 = Object.prototype;
function isPrototype$3(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$8;
  return value === proto;
}
var _isPrototype = isPrototype$3;
var baseCreate = _baseCreate, getPrototype$1 = _getPrototype, isPrototype$2 = _isPrototype;
function initCloneObject$1(object) {
  return typeof object.constructor == "function" && !isPrototype$2(object) ? baseCreate(getPrototype$1(object)) : {};
}
var _initCloneObject = initCloneObject$1;
var isFunction$2 = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$6(value) {
  return value != null && isLength$1(value.length) && !isFunction$2(value);
}
var isArrayLike_1 = isArrayLike$6;
var isArrayLike$5 = isArrayLike_1, isObjectLike$3 = isObjectLike_1;
function isArrayLikeObject$1(value) {
  return isObjectLike$3(value) && isArrayLike$5(value);
}
var isArrayLikeObject_1 = isArrayLikeObject$1;
var isBuffer$4 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$4, isBuffer$4.exports);
var baseGetTag$2 = _baseGetTag, getPrototype = _getPrototype, isObjectLike$2 = isObjectLike_1;
var objectTag$3 = "[object Object]";
var funcProto = Function.prototype, objectProto$7 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
var objectCtorString = funcToString.call(Object);
function isPlainObject$2(value) {
  if (!isObjectLike$2(value) || baseGetTag$2(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$6.call(proto, "constructor") && proto.constructor;
  return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}
var isPlainObject_1 = isPlainObject$2;
var baseGetTag$1 = _baseGetTag, isLength = isLength_1, isObjectLike$1 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", funcTag = "[object Function]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", objectTag$2 = "[object Object]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag] = typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$2;
var _nodeUtil = { exports: {} };
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e2) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var baseIsTypedArray = _baseIsTypedArray, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtil.exports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$3 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$3;
function safeGet$2(object, key) {
  if (key === "constructor" && typeof object[key] === "function") {
    return;
  }
  if (key == "__proto__") {
    return;
  }
  return object[key];
}
var _safeGet = safeGet$2;
var baseAssignValue$1 = _baseAssignValue, eq$5 = eq_1$1;
var objectProto$6 = Object.prototype;
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq$5(objValue, value)) || value === void 0 && !(key in object)) {
    baseAssignValue$1(object, key, value);
  }
}
var _assignValue = assignValue$2;
var assignValue$1 = _assignValue, baseAssignValue = _baseAssignValue;
function copyObject$1(source2, props2, object, customizer) {
  var isNew = !object;
  object || (object = {});
  var index2 = -1, length = props2.length;
  while (++index2 < length) {
    var key = props2[index2];
    var newValue = customizer ? customizer(object[key], source2[key], key, object, source2) : void 0;
    if (newValue === void 0) {
      newValue = source2[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}
var _copyObject = copyObject$1;
function baseTimes$1(n, iteratee) {
  var index2 = -1, result = Array(n);
  while (++index2 < n) {
    result[index2] = iteratee(index2);
  }
  return result;
}
var _baseTimes = baseTimes$1;
var baseTimes = _baseTimes, isArguments$2 = isArguments_1, isArray$8 = isArray_1, isBuffer$3 = isBuffer$4.exports, isIndex$1 = _isIndex, isTypedArray$2 = isTypedArray_1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$8(value), isArg = !isArr && isArguments$2(value), isBuff = !isArr && !isArg && isBuffer$3(value), isType2 = !isArr && !isArg && !isBuff && isTypedArray$2(value), skipIndexes = isArr || isArg || isBuff || isType2, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$4.call(value, key)) && !(skipIndexes && (key == "length" || isBuff && (key == "offset" || key == "parent") || isType2 && (key == "buffer" || key == "byteLength" || key == "byteOffset") || isIndex$1(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$2;
function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}
var _nativeKeysIn = nativeKeysIn$1;
var isObject$6 = isObject_1, isPrototype$1 = _isPrototype, nativeKeysIn = _nativeKeysIn;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function baseKeysIn$1(object) {
  if (!isObject$6(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object), result = [];
  for (var key in object) {
    if (!(key == "constructor" && (isProto || !hasOwnProperty$3.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}
var _baseKeysIn = baseKeysIn$1;
var arrayLikeKeys$1 = _arrayLikeKeys, baseKeysIn = _baseKeysIn, isArrayLike$4 = isArrayLike_1;
function keysIn$2(object) {
  return isArrayLike$4(object) ? arrayLikeKeys$1(object, true) : baseKeysIn(object);
}
var keysIn_1 = keysIn$2;
var copyObject = _copyObject, keysIn$1 = keysIn_1;
function toPlainObject$1(value) {
  return copyObject(value, keysIn$1(value));
}
var toPlainObject_1 = toPlainObject$1;
var assignMergeValue$1 = _assignMergeValue, cloneBuffer = _cloneBuffer.exports, cloneTypedArray = _cloneTypedArray, copyArray = _copyArray, initCloneObject = _initCloneObject, isArguments$1 = isArguments_1, isArray$7 = isArray_1, isArrayLikeObject = isArrayLikeObject_1, isBuffer$2 = isBuffer$4.exports, isFunction$1 = isFunction_1, isObject$5 = isObject_1, isPlainObject$1 = isPlainObject_1, isTypedArray$1 = isTypedArray_1, safeGet$1 = _safeGet, toPlainObject = toPlainObject_1;
function baseMergeDeep$1(object, source2, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key), srcValue = safeGet$1(source2, key), stacked = stack.get(srcValue);
  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source2, stack) : void 0;
  var isCommon = newValue === void 0;
  if (isCommon) {
    var isArr = isArray$7(srcValue), isBuff = !isArr && isBuffer$2(srcValue), isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);
    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$7(objValue)) {
        newValue = objValue;
      } else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      } else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      } else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      } else {
        newValue = [];
      }
    } else if (isPlainObject$1(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      } else if (!isObject$5(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    } else {
      isCommon = false;
    }
  }
  if (isCommon) {
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack["delete"](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}
var _baseMergeDeep = baseMergeDeep$1;
var Stack$2 = _Stack, assignMergeValue = _assignMergeValue, baseFor$1 = _baseFor, baseMergeDeep = _baseMergeDeep, isObject$4 = isObject_1, keysIn = keysIn_1, safeGet = _safeGet;
function baseMerge$1(object, source2, srcIndex, customizer, stack) {
  if (object === source2) {
    return;
  }
  baseFor$1(source2, function(srcValue, key) {
    stack || (stack = new Stack$2());
    if (isObject$4(srcValue)) {
      baseMergeDeep(object, source2, key, srcIndex, baseMerge$1, customizer, stack);
    } else {
      var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source2, stack) : void 0;
      if (newValue === void 0) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}
var _baseMerge = baseMerge$1;
function identity$4(value) {
  return value;
}
var identity_1 = identity$4;
function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}
var _apply = apply$1;
var apply = _apply;
var nativeMax$1 = Math.max;
function overRest$1(func, start2, transform) {
  start2 = nativeMax$1(start2 === void 0 ? func.length - 1 : start2, 0);
  return function() {
    var args = arguments, index2 = -1, length = nativeMax$1(args.length - start2, 0), array = Array(length);
    while (++index2 < length) {
      array[index2] = args[start2 + index2];
    }
    index2 = -1;
    var otherArgs = Array(start2 + 1);
    while (++index2 < start2) {
      otherArgs[index2] = args[index2];
    }
    otherArgs[start2] = transform(array);
    return apply(func, this, otherArgs);
  };
}
var _overRest = overRest$1;
function constant$1(value) {
  return function() {
    return value;
  };
}
var constant_1 = constant$1;
var constant = constant_1, defineProperty$1 = _defineProperty, identity$3 = identity_1;
var baseSetToString$1 = !defineProperty$1 ? identity$3 : function(func, string) {
  return defineProperty$1(func, "toString", {
    "configurable": true,
    "enumerable": false,
    "value": constant(string),
    "writable": true
  });
};
var _baseSetToString = baseSetToString$1;
var HOT_COUNT = 800, HOT_SPAN = 16;
var nativeNow = Date.now;
function shortOut$1(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1;
var baseSetToString = _baseSetToString, shortOut = _shortOut;
var setToString$1 = shortOut(baseSetToString);
var _setToString = setToString$1;
var identity$2 = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$2(func, start2) {
  return setToString(overRest(func, start2, identity$2), func + "");
}
var _baseRest = baseRest$2;
var eq$4 = eq_1$1, isArrayLike$3 = isArrayLike_1, isIndex = _isIndex, isObject$3 = isObject_1;
function isIterateeCall$4(value, index2, object) {
  if (!isObject$3(object)) {
    return false;
  }
  var type2 = typeof index2;
  if (type2 == "number" ? isArrayLike$3(object) && isIndex(index2, object.length) : type2 == "string" && index2 in object) {
    return eq$4(object[index2], value);
  }
  return false;
}
var _isIterateeCall = isIterateeCall$4;
var baseRest$1 = _baseRest, isIterateeCall$3 = _isIterateeCall;
function createAssigner$1(assigner) {
  return baseRest$1(function(object, sources2) {
    var index2 = -1, length = sources2.length, customizer = length > 1 ? sources2[length - 1] : void 0, guard = length > 2 ? sources2[2] : void 0;
    customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
    if (guard && isIterateeCall$3(sources2[0], sources2[1], guard)) {
      customizer = length < 3 ? void 0 : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index2 < length) {
      var source2 = sources2[index2];
      if (source2) {
        assigner(object, source2, index2, customizer);
      }
    }
    return object;
  });
}
var _createAssigner = createAssigner$1;
var baseMerge = _baseMerge, createAssigner = _createAssigner;
var merge$1 = createAssigner(function(object, source2, srcIndex) {
  baseMerge(object, source2, srcIndex);
});
var merge_1$1 = merge$1;
var Locales = {};
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(values) {
  var index2 = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index2 < length) {
    this.add(values[index2]);
  }
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length, index2 = fromIndex + (fromRight ? 1 : -1);
  while (fromRight ? index2-- : ++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return index2;
    }
  }
  return -1;
}
var _baseFindIndex = baseFindIndex$1;
function baseIsNaN$1(value) {
  return value !== value;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(array, value, fromIndex) {
  var index2 = fromIndex - 1, length = array.length;
  while (++index2 < length) {
    if (array[index2] === value) {
      return index2;
    }
  }
  return -1;
}
var _strictIndexOf = strictIndexOf$1;
var baseFindIndex = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(array, value, fromIndex) {
  return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
var _baseIndexOf = baseIndexOf$1;
var baseIndexOf = _baseIndexOf;
function arrayIncludes$1(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(array, value, comparator2) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (comparator2(value, array[index2])) {
      return true;
    }
  }
  return false;
}
var _arrayIncludesWith = arrayIncludesWith$1;
function cacheHas$2(cache2, key) {
  return cache2.has(key);
}
var _cacheHas = cacheHas$2;
var getNative$3 = _getNative, root$3 = _root;
var Set$3 = getNative$3(root$3, "Set");
var _Set = Set$3;
function noop$3() {
}
var noop_1 = noop$3;
function setToArray$3(set) {
  var index2 = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index2] = value;
  });
  return result;
}
var _setToArray = setToArray$3;
var Set$2 = _Set, noop$2 = noop_1, setToArray$2 = _setToArray;
var INFINITY$1 = 1 / 0;
var createSet$1 = !(Set$2 && 1 / setToArray$2(new Set$2([, -0]))[1] == INFINITY$1) ? noop$2 : function(values) {
  return new Set$2(values);
};
var _createSet = createSet$1;
var SetCache$1 = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, cacheHas$1 = _cacheHas, createSet = _createSet, setToArray$1 = _setToArray;
var LARGE_ARRAY_SIZE = 200;
function baseUniq$1(array, iteratee, comparator2) {
  var index2 = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
  if (comparator2) {
    isCommon = false;
    includes2 = arrayIncludesWith;
  } else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray$1(set);
    }
    isCommon = false;
    includes2 = cacheHas$1;
    seen = new SetCache$1();
  } else {
    seen = iteratee ? [] : result;
  }
  outer:
    while (++index2 < length) {
      var value = array[index2], computed2 = iteratee ? iteratee(value) : value;
      value = comparator2 || value !== 0 ? value : 0;
      if (isCommon && computed2 === computed2) {
        var seenIndex = seen.length;
        while (seenIndex--) {
          if (seen[seenIndex] === computed2) {
            continue outer;
          }
        }
        if (iteratee) {
          seen.push(computed2);
        }
        result.push(value);
      } else if (!includes2(seen, computed2, comparator2)) {
        if (seen !== result) {
          seen.push(computed2);
        }
        result.push(value);
      }
    }
  return result;
}
var _baseUniq = baseUniq$1;
var baseUniq = _baseUniq;
function uniq(array) {
  return array && array.length ? baseUniq(array) : [];
}
var uniq_1 = uniq;
(function(exports) {
  var __importDefault2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Locales = exports.defaultLocaleResolver = void 0;
  const uniq_1$1 = __importDefault2(uniq_1);
  const defaultLocaleResolver = (i18n2, locale2) => {
    const locales = [];
    const list = [];
    locales.push(locale2);
    if (!locale2) {
      locales.push(i18n2.locale);
    }
    if (i18n2.enableFallback) {
      locales.push(i18n2.defaultLocale);
    }
    locales.filter(Boolean).map((entry) => entry.toString()).forEach(function(currentLocale) {
      if (!list.includes(currentLocale)) {
        list.push(currentLocale);
      }
      if (!i18n2.enableFallback) {
        return;
      }
      const codes = currentLocale.split("-");
      if (codes.length === 3) {
        list.push(`${codes[0]}-${codes[1]}`);
      }
      list.push(codes[0]);
    });
    return (0, uniq_1$1.default)(list);
  };
  exports.defaultLocaleResolver = defaultLocaleResolver;
  class Locales2 {
    constructor(i18n2) {
      this.i18n = i18n2;
      this.registry = {};
      this.register("default", exports.defaultLocaleResolver);
    }
    register(locale2, localeResolver) {
      if (typeof localeResolver !== "function") {
        const result = localeResolver;
        localeResolver = () => result;
      }
      this.registry[locale2] = localeResolver;
    }
    get(locale2) {
      let locales = this.registry[locale2] || this.registry[this.i18n.locale] || this.registry.default;
      if (typeof locales === "function") {
        locales = locales(this.i18n, locale2);
      }
      if (!(locales instanceof Array)) {
        locales = [locales];
      }
      return locales;
    }
  }
  exports.Locales = Locales2;
})(Locales);
var Pluralization = {};
const a = (n, ord) => {
  if (ord)
    return "other";
  return n == 1 ? "one" : "other";
};
const b = (n, ord) => {
  if (ord)
    return "other";
  return n == 0 || n == 1 ? "one" : "other";
};
const c = (n, ord) => {
  if (ord)
    return "other";
  return n >= 0 && n <= 1 ? "one" : "other";
};
const d = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1];
  if (ord)
    return "other";
  return n == 1 && v0 ? "one" : "other";
};
const e = (n, ord) => "other";
const f = (n, ord) => {
  if (ord)
    return "other";
  return n == 1 ? "one" : n == 2 ? "two" : "other";
};
const af = a;
const ak = b;
const am = c;
const an = a;
const ar = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord)
    return "other";
  return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 99 ? "many" : "other";
};
const ars = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord)
    return "other";
  return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 99 ? "many" : "other";
};
const as = (n, ord) => {
  if (ord)
    return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
  return n >= 0 && n <= 1 ? "one" : "other";
};
const asa = a;
const ast = d;
const az = (n, ord) => {
  const s = String(n).split("."), i = s[0], i10 = i.slice(-1), i100 = i.slice(-2), i1000 = i.slice(-3);
  if (ord)
    return i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8 || (i100 == 20 || i100 == 50 || i100 == 70 || i100 == 80) ? "one" : i10 == 3 || i10 == 4 || (i1000 == 100 || i1000 == 200 || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700 || i1000 == 800 || i1000 == 900) ? "few" : i == 0 || i10 == 6 || (i100 == 40 || i100 == 60 || i100 == 90) ? "many" : "other";
  return n == 1 ? "one" : "other";
};
const bal = (n, ord) => n == 1 ? "one" : "other";
const be = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord)
    return (n10 == 2 || n10 == 3) && n100 != 12 && n100 != 13 ? "few" : "other";
  return n10 == 1 && n100 != 11 ? "one" : n10 >= 2 && n10 <= 4 && (n100 < 12 || n100 > 14) ? "few" : t0 && n10 == 0 || n10 >= 5 && n10 <= 9 || n100 >= 11 && n100 <= 14 ? "many" : "other";
};
const bem = a;
const bez = a;
const bg = a;
const bho = b;
const blo = (n, ord) => {
  const s = String(n).split("."), i = s[0];
  if (ord)
    return i == 0 ? "zero" : i == 1 ? "one" : i == 2 || i == 3 || i == 4 || i == 5 || i == 6 ? "few" : "other";
  return n == 0 ? "zero" : n == 1 ? "one" : "other";
};
const bm = e;
const bn = (n, ord) => {
  if (ord)
    return n == 1 || n == 5 || n == 7 || n == 8 || n == 9 || n == 10 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
  return n >= 0 && n <= 1 ? "one" : "other";
};
const bo = e;
const br = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), n1000000 = t0 && s[0].slice(-6);
  if (ord)
    return "other";
  return n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91 ? "one" : n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92 ? "two" : (n10 == 3 || n10 == 4 || n10 == 9) && (n100 < 10 || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90 || n100 > 99) ? "few" : n != 0 && t0 && n1000000 == 0 ? "many" : "other";
};
const brx = a;
const bs = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f2.slice(-1), f100 = f2.slice(-2);
  if (ord)
    return "other";
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
};
const ca = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  if (ord)
    return n == 1 || n == 3 ? "one" : n == 2 ? "two" : n == 4 ? "few" : "other";
  return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
};
const ce = a;
const ceb = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), f10 = f2.slice(-1);
  if (ord)
    return "other";
  return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? "one" : "other";
};
const cgg = a;
const chr = a;
const ckb = a;
const cs = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1];
  if (ord)
    return "other";
  return n == 1 && v0 ? "one" : i >= 2 && i <= 4 && v0 ? "few" : !v0 ? "many" : "other";
};
const cy = (n, ord) => {
  if (ord)
    return n == 0 || n == 7 || n == 8 || n == 9 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n == 3 || n == 4 ? "few" : n == 5 || n == 6 ? "many" : "other";
  return n == 0 ? "zero" : n == 1 ? "one" : n == 2 ? "two" : n == 3 ? "few" : n == 6 ? "many" : "other";
};
const da = (n, ord) => {
  const s = String(n).split("."), i = s[0], t0 = Number(s[0]) == n;
  if (ord)
    return "other";
  return n == 1 || !t0 && (i == 0 || i == 1) ? "one" : "other";
};
const de = d;
const doi = c;
const dsb = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i100 = i.slice(-2), f100 = f2.slice(-2);
  if (ord)
    return "other";
  return v0 && i100 == 1 || f100 == 1 ? "one" : v0 && i100 == 2 || f100 == 2 ? "two" : v0 && (i100 == 3 || i100 == 4) || (f100 == 3 || f100 == 4) ? "few" : "other";
};
const dv = a;
const dz = e;
const ee = a;
const el = a;
const en$1 = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord)
    return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
  return n == 1 && v0 ? "one" : "other";
};
const eo = a;
const es = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  if (ord)
    return "other";
  return n == 1 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
};
const et = d;
const eu = a;
const fa = c;
const ff = (n, ord) => {
  if (ord)
    return "other";
  return n >= 0 && n < 2 ? "one" : "other";
};
const fi = d;
const fil = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), f10 = f2.slice(-1);
  if (ord)
    return n == 1 ? "one" : "other";
  return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? "one" : "other";
};
const fo = a;
const fr = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  if (ord)
    return n == 1 ? "one" : "other";
  return n >= 0 && n < 2 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
};
const fur = a;
const fy = d;
const ga = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n;
  if (ord)
    return n == 1 ? "one" : "other";
  return n == 1 ? "one" : n == 2 ? "two" : t0 && n >= 3 && n <= 6 ? "few" : t0 && n >= 7 && n <= 10 ? "many" : "other";
};
const gd = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n;
  if (ord)
    return n == 1 || n == 11 ? "one" : n == 2 || n == 12 ? "two" : n == 3 || n == 13 ? "few" : "other";
  return n == 1 || n == 11 ? "one" : n == 2 || n == 12 ? "two" : t0 && n >= 3 && n <= 10 || t0 && n >= 13 && n <= 19 ? "few" : "other";
};
const gl = d;
const gsw = a;
const gu = (n, ord) => {
  if (ord)
    return n == 1 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
  return n >= 0 && n <= 1 ? "one" : "other";
};
const guw = b;
const gv = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord)
    return "other";
  return v0 && i10 == 1 ? "one" : v0 && i10 == 2 ? "two" : v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60 || i100 == 80) ? "few" : !v0 ? "many" : "other";
};
const ha = a;
const haw = a;
const he = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1];
  if (ord)
    return "other";
  return i == 1 && v0 || i == 0 && !v0 ? "one" : i == 2 && v0 ? "two" : "other";
};
const hi = (n, ord) => {
  if (ord)
    return n == 1 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
  return n >= 0 && n <= 1 ? "one" : "other";
};
const hnj = e;
const hr = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f2.slice(-1), f100 = f2.slice(-2);
  if (ord)
    return "other";
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
};
const hsb = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i100 = i.slice(-2), f100 = f2.slice(-2);
  if (ord)
    return "other";
  return v0 && i100 == 1 || f100 == 1 ? "one" : v0 && i100 == 2 || f100 == 2 ? "two" : v0 && (i100 == 3 || i100 == 4) || (f100 == 3 || f100 == 4) ? "few" : "other";
};
const hu = (n, ord) => {
  if (ord)
    return n == 1 || n == 5 ? "one" : "other";
  return n == 1 ? "one" : "other";
};
const hy = (n, ord) => {
  if (ord)
    return n == 1 ? "one" : "other";
  return n >= 0 && n < 2 ? "one" : "other";
};
const ia = d;
const id = e;
const ig = e;
const ii = e;
const io = d;
const is = (n, ord) => {
  const s = String(n).split("."), i = s[0], t2 = (s[1] || "").replace(/0+$/, ""), t0 = Number(s[0]) == n, i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord)
    return "other";
  return t0 && i10 == 1 && i100 != 11 || t2 % 10 == 1 && t2 % 100 != 11 ? "one" : "other";
};
const it = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  if (ord)
    return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
  return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
};
const iu = f;
const ja = e;
const jbo = e;
const jgo = a;
const jmc = a;
const jv = e;
const jw = e;
const ka = (n, ord) => {
  const s = String(n).split("."), i = s[0], i100 = i.slice(-2);
  if (ord)
    return i == 1 ? "one" : i == 0 || (i100 >= 2 && i100 <= 20 || i100 == 40 || i100 == 60 || i100 == 80) ? "many" : "other";
  return n == 1 ? "one" : "other";
};
const kab = (n, ord) => {
  if (ord)
    return "other";
  return n >= 0 && n < 2 ? "one" : "other";
};
const kaj = a;
const kcg = a;
const kde = e;
const kea = e;
const kk = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
  if (ord)
    return n10 == 6 || n10 == 9 || t0 && n10 == 0 && n != 0 ? "many" : "other";
  return n == 1 ? "one" : "other";
};
const kkj = a;
const kl = a;
const km = e;
const kn = c;
const ko = e;
const ks = a;
const ksb = a;
const ksh = (n, ord) => {
  if (ord)
    return "other";
  return n == 0 ? "zero" : n == 1 ? "one" : "other";
};
const ku = a;
const kw = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2), n1000 = t0 && s[0].slice(-3), n100000 = t0 && s[0].slice(-5), n1000000 = t0 && s[0].slice(-6);
  if (ord)
    return t0 && n >= 1 && n <= 4 || (n100 >= 1 && n100 <= 4 || n100 >= 21 && n100 <= 24 || n100 >= 41 && n100 <= 44 || n100 >= 61 && n100 <= 64 || n100 >= 81 && n100 <= 84) ? "one" : n == 5 || n100 == 5 ? "many" : "other";
  return n == 0 ? "zero" : n == 1 ? "one" : n100 == 2 || n100 == 22 || n100 == 42 || n100 == 62 || n100 == 82 || t0 && n1000 == 0 && (n100000 >= 1e3 && n100000 <= 2e4 || n100000 == 4e4 || n100000 == 6e4 || n100000 == 8e4) || n != 0 && n1000000 == 1e5 ? "two" : n100 == 3 || n100 == 23 || n100 == 43 || n100 == 63 || n100 == 83 ? "few" : n != 1 && (n100 == 1 || n100 == 21 || n100 == 41 || n100 == 61 || n100 == 81) ? "many" : "other";
};
const ky = a;
const lag = (n, ord) => {
  const s = String(n).split("."), i = s[0];
  if (ord)
    return "other";
  return n == 0 ? "zero" : (i == 0 || i == 1) && n != 0 ? "one" : "other";
};
const lb = a;
const lg = a;
const lij = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n;
  if (ord)
    return n == 11 || n == 8 || t0 && n >= 80 && n <= 89 || t0 && n >= 800 && n <= 899 ? "many" : "other";
  return n == 1 && v0 ? "one" : "other";
};
const lkt = e;
const ln = b;
const lo = (n, ord) => {
  if (ord)
    return n == 1 ? "one" : "other";
  return "other";
};
const lt$4 = (n, ord) => {
  const s = String(n).split("."), f2 = s[1] || "", t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord)
    return "other";
  return n10 == 1 && (n100 < 11 || n100 > 19) ? "one" : n10 >= 2 && n10 <= 9 && (n100 < 11 || n100 > 19) ? "few" : f2 != 0 ? "many" : "other";
};
const lv = (n, ord) => {
  const s = String(n).split("."), f2 = s[1] || "", v = f2.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f2.slice(-2), f10 = f2.slice(-1);
  if (ord)
    return "other";
  return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && (f100 >= 11 && f100 <= 19) ? "zero" : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? "one" : "other";
};
const mas = a;
const mg = b;
const mgo = a;
const mk = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f2.slice(-1), f100 = f2.slice(-2);
  if (ord)
    return i10 == 1 && i100 != 11 ? "one" : i10 == 2 && i100 != 12 ? "two" : (i10 == 7 || i10 == 8) && i100 != 17 && i100 != 18 ? "many" : "other";
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : "other";
};
const ml = a;
const mn = a;
const mo = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord)
    return n == 1 ? "one" : "other";
  return n == 1 && v0 ? "one" : !v0 || n == 0 || n != 1 && (n100 >= 1 && n100 <= 19) ? "few" : "other";
};
const mr = (n, ord) => {
  if (ord)
    return n == 1 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : "other";
  return n == 1 ? "one" : "other";
};
const ms = (n, ord) => {
  if (ord)
    return n == 1 ? "one" : "other";
  return "other";
};
const mt = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord)
    return "other";
  return n == 1 ? "one" : n == 2 ? "two" : n == 0 || n100 >= 3 && n100 <= 10 ? "few" : n100 >= 11 && n100 <= 19 ? "many" : "other";
};
const my = e;
const nah = a;
const naq = f;
const nb = a;
const nd = a;
const ne = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n;
  if (ord)
    return t0 && n >= 1 && n <= 4 ? "one" : "other";
  return n == 1 ? "one" : "other";
};
const nl = d;
const nn = a;
const nnh = a;
const no = a;
const nqo = e;
const nr = a;
const nso = b;
const ny = a;
const nyn = a;
const om = a;
const or = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n;
  if (ord)
    return n == 1 || n == 5 || t0 && n >= 7 && n <= 9 ? "one" : n == 2 || n == 3 ? "two" : n == 4 ? "few" : n == 6 ? "many" : "other";
  return n == 1 ? "one" : "other";
};
const os = a;
const osa = e;
const pa = b;
const pap = a;
const pcm = c;
const pl = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord)
    return "other";
  return n == 1 && v0 ? "one" : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? "few" : v0 && i != 1 && (i10 == 0 || i10 == 1) || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 12 && i100 <= 14) ? "many" : "other";
};
const prg = (n, ord) => {
  const s = String(n).split("."), f2 = s[1] || "", v = f2.length, t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), f100 = f2.slice(-2), f10 = f2.slice(-1);
  if (ord)
    return "other";
  return t0 && n10 == 0 || n100 >= 11 && n100 <= 19 || v == 2 && (f100 >= 11 && f100 <= 19) ? "zero" : n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11 || v != 2 && f10 == 1 ? "one" : "other";
};
const ps = a;
const pt = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  if (ord)
    return "other";
  return i == 0 || i == 1 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
};
const pt_PT = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  if (ord)
    return "other";
  return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
};
const rm = a;
const ro = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n100 = t0 && s[0].slice(-2);
  if (ord)
    return n == 1 ? "one" : "other";
  return n == 1 && v0 ? "one" : !v0 || n == 0 || n != 1 && (n100 >= 1 && n100 <= 19) ? "few" : "other";
};
const rof = a;
const ru = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord)
    return "other";
  return v0 && i10 == 1 && i100 != 11 ? "one" : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? "few" : v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 11 && i100 <= 14) ? "many" : "other";
};
const rwk = a;
const sah = e;
const saq = a;
const sat = f;
const sc = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1];
  if (ord)
    return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
  return n == 1 && v0 ? "one" : "other";
};
const scn = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1];
  if (ord)
    return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
  return n == 1 && v0 ? "one" : "other";
};
const sd = a;
const sdh = a;
const se = f;
const seh = a;
const ses = e;
const sg = e;
const sh = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f2.slice(-1), f100 = f2.slice(-2);
  if (ord)
    return "other";
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
};
const shi = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n;
  if (ord)
    return "other";
  return n >= 0 && n <= 1 ? "one" : t0 && n >= 2 && n <= 10 ? "few" : "other";
};
const si = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "";
  if (ord)
    return "other";
  return n == 0 || n == 1 || i == 0 && f2 == 1 ? "one" : "other";
};
const sk = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1];
  if (ord)
    return "other";
  return n == 1 && v0 ? "one" : i >= 2 && i <= 4 && v0 ? "few" : !v0 ? "many" : "other";
};
const sl = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i100 = i.slice(-2);
  if (ord)
    return "other";
  return v0 && i100 == 1 ? "one" : v0 && i100 == 2 ? "two" : v0 && (i100 == 3 || i100 == 4) || !v0 ? "few" : "other";
};
const sma = f;
const smi = f;
const smj = f;
const smn = f;
const sms = f;
const sn = a;
const so = a;
const sq = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord)
    return n == 1 ? "one" : n10 == 4 && n100 != 14 ? "many" : "other";
  return n == 1 ? "one" : "other";
};
const sr = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), i100 = i.slice(-2), f10 = f2.slice(-1), f100 = f2.slice(-2);
  if (ord)
    return "other";
  return v0 && i10 == 1 && i100 != 11 || f10 == 1 && f100 != 11 ? "one" : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) || f10 >= 2 && f10 <= 4 && (f100 < 12 || f100 > 14) ? "few" : "other";
};
const ss = a;
const ssy = a;
const st = a;
const su = e;
const sv = (n, ord) => {
  const s = String(n).split("."), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord)
    return (n10 == 1 || n10 == 2) && n100 != 11 && n100 != 12 ? "one" : "other";
  return n == 1 && v0 ? "one" : "other";
};
const sw = d;
const syr = a;
const ta = a;
const te = a;
const teo = a;
const th = e;
const ti = b;
const tig = a;
const tk = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1);
  if (ord)
    return n10 == 6 || n10 == 9 || n == 10 ? "few" : "other";
  return n == 1 ? "one" : "other";
};
const tl = (n, ord) => {
  const s = String(n).split("."), i = s[0], f2 = s[1] || "", v0 = !s[1], i10 = i.slice(-1), f10 = f2.slice(-1);
  if (ord)
    return n == 1 ? "one" : "other";
  return v0 && (i == 1 || i == 2 || i == 3) || v0 && i10 != 4 && i10 != 6 && i10 != 9 || !v0 && f10 != 4 && f10 != 6 && f10 != 9 ? "one" : "other";
};
const tn = a;
const to = e;
const tpi = e;
const tr = a;
const ts = a;
const tzm = (n, ord) => {
  const s = String(n).split("."), t0 = Number(s[0]) == n;
  if (ord)
    return "other";
  return n == 0 || n == 1 || t0 && n >= 11 && n <= 99 ? "one" : "other";
};
const ug = a;
const uk = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord)
    return n10 == 3 && n100 != 13 ? "few" : "other";
  return v0 && i10 == 1 && i100 != 11 ? "one" : v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14) ? "few" : v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9) || v0 && (i100 >= 11 && i100 <= 14) ? "many" : "other";
};
const und = e;
const ur = d;
const uz = a;
const ve = a;
const vec = (n, ord) => {
  const s = String(n).split("."), i = s[0], v0 = !s[1], i1000000 = i.slice(-6);
  if (ord)
    return n == 11 || n == 8 || n == 80 || n == 800 ? "many" : "other";
  return n == 1 && v0 ? "one" : i != 0 && i1000000 == 0 && v0 ? "many" : "other";
};
const vi = (n, ord) => {
  if (ord)
    return n == 1 ? "one" : "other";
  return "other";
};
const vo = a;
const vun = a;
const wa = b;
const wae = a;
const wo = e;
const xh = a;
const xog = a;
const yi = d;
const yo = e;
const yue = e;
const zh$1 = e;
const zu = c;
var plurals = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  af,
  ak,
  am,
  an,
  ar,
  ars,
  as,
  asa,
  ast,
  az,
  bal,
  be,
  bem,
  bez,
  bg,
  bho,
  blo,
  bm,
  bn,
  bo,
  br,
  brx,
  bs,
  ca,
  ce,
  ceb,
  cgg,
  chr,
  ckb,
  cs,
  cy,
  da,
  de,
  doi,
  dsb,
  dv,
  dz,
  ee,
  el,
  en: en$1,
  eo,
  es,
  et,
  eu,
  fa,
  ff,
  fi,
  fil,
  fo,
  fr,
  fur,
  fy,
  ga,
  gd,
  gl,
  gsw,
  gu,
  guw,
  gv,
  ha,
  haw,
  he,
  hi,
  hnj,
  hr,
  hsb,
  hu,
  hy,
  ia,
  id,
  ig,
  ii,
  io,
  is,
  it,
  iu,
  ja,
  jbo,
  jgo,
  jmc,
  jv,
  jw,
  ka,
  kab,
  kaj,
  kcg,
  kde,
  kea,
  kk,
  kkj,
  kl,
  km,
  kn,
  ko,
  ks,
  ksb,
  ksh,
  ku,
  kw,
  ky,
  lag,
  lb,
  lg,
  lij,
  lkt,
  ln,
  lo,
  lt: lt$4,
  lv,
  mas,
  mg,
  mgo,
  mk,
  ml,
  mn,
  mo,
  mr,
  ms,
  mt,
  my,
  nah,
  naq,
  nb,
  nd,
  ne,
  nl,
  nn,
  nnh,
  no,
  nqo,
  nr,
  nso,
  ny,
  nyn,
  om,
  or,
  os,
  osa,
  pa,
  pap,
  pcm,
  pl,
  prg,
  ps,
  pt,
  pt_PT,
  rm,
  ro,
  rof,
  ru,
  rwk,
  sah,
  saq,
  sat,
  sc,
  scn,
  sd,
  sdh,
  se,
  seh,
  ses,
  sg,
  sh,
  shi,
  si,
  sk,
  sl,
  sma,
  smi,
  smj,
  smn,
  sms,
  sn,
  so,
  sq,
  sr,
  ss,
  ssy,
  st,
  su,
  sv,
  sw,
  syr,
  ta,
  te,
  teo,
  th,
  ti,
  tig,
  tk,
  tl,
  tn,
  to,
  tpi,
  tr,
  ts,
  tzm,
  ug,
  uk,
  und,
  ur,
  uz,
  ve,
  vec,
  vi,
  vo,
  vun,
  wa,
  wae,
  wo,
  xh,
  xog,
  yi,
  yo,
  yue,
  zh: zh$1,
  zu
}, Symbol.toStringTag, { value: "Module" }));
var require$$0 = /* @__PURE__ */ getAugmentedNamespace(plurals);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.Pluralization = exports.defaultPluralizer = exports.useMakePlural = void 0;
  const make_plural_1 = require$$0;
  function useMakePlural({ pluralizer, includeZero = true, ordinal = false }) {
    return function(_i18n, count) {
      return [
        includeZero && count === 0 ? "zero" : "",
        pluralizer(count, ordinal)
      ].filter(Boolean);
    };
  }
  exports.useMakePlural = useMakePlural;
  exports.defaultPluralizer = useMakePlural({
    pluralizer: make_plural_1.en,
    includeZero: true
  });
  class Pluralization2 {
    constructor(i18n2) {
      this.i18n = i18n2;
      this.registry = {};
      this.register("default", exports.defaultPluralizer);
    }
    register(locale2, pluralizer) {
      this.registry[locale2] = pluralizer;
    }
    get(locale2) {
      return this.registry[locale2] || this.registry[this.i18n.locale] || this.registry["default"];
    }
  }
  exports.Pluralization = Pluralization2;
})(Pluralization);
var MissingTranslation = {};
var helpers = {};
var camelCaseKeys$1 = {};
function baseSlice$1(array, start2, end2) {
  var index2 = -1, length = array.length;
  if (start2 < 0) {
    start2 = -start2 > length ? 0 : length + start2;
  }
  end2 = end2 > length ? length : end2;
  if (end2 < 0) {
    end2 += length;
  }
  length = start2 > end2 ? 0 : end2 - start2 >>> 0;
  start2 >>>= 0;
  var result = Array(length);
  while (++index2 < length) {
    result[index2] = array[index2 + start2];
  }
  return result;
}
var _baseSlice = baseSlice$1;
var baseSlice = _baseSlice;
function castSlice$1(array, start2, end2) {
  var length = array.length;
  end2 = end2 === void 0 ? length : end2;
  return !start2 && end2 >= length ? array : baseSlice(array, start2, end2);
}
var _castSlice = castSlice$1;
var rsAstralRange$2 = "\\ud800-\\udfff", rsComboMarksRange$3 = "\\u0300-\\u036f", reComboHalfMarksRange$3 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$3 = "\\u20d0-\\u20ff", rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3, rsVarRange$2 = "\\ufe0e\\ufe0f";
var rsZWJ$2 = "\\u200d";
var reHasUnicode = RegExp("[" + rsZWJ$2 + rsAstralRange$2 + rsComboRange$3 + rsVarRange$2 + "]");
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}
var _hasUnicode = hasUnicode$2;
function asciiToArray$1(string) {
  return string.split("");
}
var _asciiToArray = asciiToArray$1;
var rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$2 = "\\u0300-\\u036f", reComboHalfMarksRange$2 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$2 = "\\u20d0-\\u20ff", rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2, rsVarRange$1 = "\\ufe0e\\ufe0f";
var rsAstral = "[" + rsAstralRange$1 + "]", rsCombo$2 = "[" + rsComboRange$2 + "]", rsFitz$1 = "\\ud83c[\\udffb-\\udfff]", rsModifier$1 = "(?:" + rsCombo$2 + "|" + rsFitz$1 + ")", rsNonAstral$1 = "[^" + rsAstralRange$1 + "]", rsRegional$1 = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair$1 = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ$1 = "\\u200d";
var reOptMod$1 = rsModifier$1 + "?", rsOptVar$1 = "[" + rsVarRange$1 + "]?", rsOptJoin$1 = "(?:" + rsZWJ$1 + "(?:" + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join("|") + ")" + rsOptVar$1 + reOptMod$1 + ")*", rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1, rsSymbol = "(?:" + [rsNonAstral$1 + rsCombo$2 + "?", rsCombo$2, rsRegional$1, rsSurrPair$1, rsAstral].join("|") + ")";
var reUnicode = RegExp(rsFitz$1 + "(?=" + rsFitz$1 + ")|" + rsSymbol + rsSeq$1, "g");
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1;
var asciiToArray = _asciiToArray, hasUnicode$1 = _hasUnicode, unicodeToArray = _unicodeToArray;
function stringToArray$1(string) {
  return hasUnicode$1(string) ? unicodeToArray(string) : asciiToArray(string);
}
var _stringToArray = stringToArray$1;
var castSlice = _castSlice, hasUnicode = _hasUnicode, stringToArray = _stringToArray, toString$6 = toString_1;
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$6(string);
    var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
    var chr2 = strSymbols ? strSymbols[0] : string.charAt(0);
    var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
    return chr2[methodName]() + trailing;
  };
}
var _createCaseFirst = createCaseFirst$1;
var createCaseFirst = _createCaseFirst;
var upperFirst$1 = createCaseFirst("toUpperCase");
var upperFirst_1 = upperFirst$1;
var toString$5 = toString_1, upperFirst = upperFirst_1;
function capitalize$1(string) {
  return upperFirst(toString$5(string).toLowerCase());
}
var capitalize_1 = capitalize$1;
function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index2 = -1, length = array == null ? 0 : array.length;
  if (initAccum && length) {
    accumulator = array[++index2];
  }
  while (++index2 < length) {
    accumulator = iteratee(accumulator, array[index2], index2, array);
  }
  return accumulator;
}
var _arrayReduce = arrayReduce$1;
function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? void 0 : object[key];
  };
}
var _basePropertyOf = basePropertyOf$1;
var basePropertyOf = _basePropertyOf;
var deburredLetters = {
  "\xC0": "A",
  "\xC1": "A",
  "\xC2": "A",
  "\xC3": "A",
  "\xC4": "A",
  "\xC5": "A",
  "\xE0": "a",
  "\xE1": "a",
  "\xE2": "a",
  "\xE3": "a",
  "\xE4": "a",
  "\xE5": "a",
  "\xC7": "C",
  "\xE7": "c",
  "\xD0": "D",
  "\xF0": "d",
  "\xC8": "E",
  "\xC9": "E",
  "\xCA": "E",
  "\xCB": "E",
  "\xE8": "e",
  "\xE9": "e",
  "\xEA": "e",
  "\xEB": "e",
  "\xCC": "I",
  "\xCD": "I",
  "\xCE": "I",
  "\xCF": "I",
  "\xEC": "i",
  "\xED": "i",
  "\xEE": "i",
  "\xEF": "i",
  "\xD1": "N",
  "\xF1": "n",
  "\xD2": "O",
  "\xD3": "O",
  "\xD4": "O",
  "\xD5": "O",
  "\xD6": "O",
  "\xD8": "O",
  "\xF2": "o",
  "\xF3": "o",
  "\xF4": "o",
  "\xF5": "o",
  "\xF6": "o",
  "\xF8": "o",
  "\xD9": "U",
  "\xDA": "U",
  "\xDB": "U",
  "\xDC": "U",
  "\xF9": "u",
  "\xFA": "u",
  "\xFB": "u",
  "\xFC": "u",
  "\xDD": "Y",
  "\xFD": "y",
  "\xFF": "y",
  "\xC6": "Ae",
  "\xE6": "ae",
  "\xDE": "Th",
  "\xFE": "th",
  "\xDF": "ss",
  "\u0100": "A",
  "\u0102": "A",
  "\u0104": "A",
  "\u0101": "a",
  "\u0103": "a",
  "\u0105": "a",
  "\u0106": "C",
  "\u0108": "C",
  "\u010A": "C",
  "\u010C": "C",
  "\u0107": "c",
  "\u0109": "c",
  "\u010B": "c",
  "\u010D": "c",
  "\u010E": "D",
  "\u0110": "D",
  "\u010F": "d",
  "\u0111": "d",
  "\u0112": "E",
  "\u0114": "E",
  "\u0116": "E",
  "\u0118": "E",
  "\u011A": "E",
  "\u0113": "e",
  "\u0115": "e",
  "\u0117": "e",
  "\u0119": "e",
  "\u011B": "e",
  "\u011C": "G",
  "\u011E": "G",
  "\u0120": "G",
  "\u0122": "G",
  "\u011D": "g",
  "\u011F": "g",
  "\u0121": "g",
  "\u0123": "g",
  "\u0124": "H",
  "\u0126": "H",
  "\u0125": "h",
  "\u0127": "h",
  "\u0128": "I",
  "\u012A": "I",
  "\u012C": "I",
  "\u012E": "I",
  "\u0130": "I",
  "\u0129": "i",
  "\u012B": "i",
  "\u012D": "i",
  "\u012F": "i",
  "\u0131": "i",
  "\u0134": "J",
  "\u0135": "j",
  "\u0136": "K",
  "\u0137": "k",
  "\u0138": "k",
  "\u0139": "L",
  "\u013B": "L",
  "\u013D": "L",
  "\u013F": "L",
  "\u0141": "L",
  "\u013A": "l",
  "\u013C": "l",
  "\u013E": "l",
  "\u0140": "l",
  "\u0142": "l",
  "\u0143": "N",
  "\u0145": "N",
  "\u0147": "N",
  "\u014A": "N",
  "\u0144": "n",
  "\u0146": "n",
  "\u0148": "n",
  "\u014B": "n",
  "\u014C": "O",
  "\u014E": "O",
  "\u0150": "O",
  "\u014D": "o",
  "\u014F": "o",
  "\u0151": "o",
  "\u0154": "R",
  "\u0156": "R",
  "\u0158": "R",
  "\u0155": "r",
  "\u0157": "r",
  "\u0159": "r",
  "\u015A": "S",
  "\u015C": "S",
  "\u015E": "S",
  "\u0160": "S",
  "\u015B": "s",
  "\u015D": "s",
  "\u015F": "s",
  "\u0161": "s",
  "\u0162": "T",
  "\u0164": "T",
  "\u0166": "T",
  "\u0163": "t",
  "\u0165": "t",
  "\u0167": "t",
  "\u0168": "U",
  "\u016A": "U",
  "\u016C": "U",
  "\u016E": "U",
  "\u0170": "U",
  "\u0172": "U",
  "\u0169": "u",
  "\u016B": "u",
  "\u016D": "u",
  "\u016F": "u",
  "\u0171": "u",
  "\u0173": "u",
  "\u0174": "W",
  "\u0175": "w",
  "\u0176": "Y",
  "\u0177": "y",
  "\u0178": "Y",
  "\u0179": "Z",
  "\u017B": "Z",
  "\u017D": "Z",
  "\u017A": "z",
  "\u017C": "z",
  "\u017E": "z",
  "\u0132": "IJ",
  "\u0133": "ij",
  "\u0152": "Oe",
  "\u0153": "oe",
  "\u0149": "'n",
  "\u017F": "s"
};
var deburrLetter$1 = basePropertyOf(deburredLetters);
var _deburrLetter = deburrLetter$1;
var deburrLetter = _deburrLetter, toString$4 = toString_1;
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
var rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1;
var rsCombo$1 = "[" + rsComboRange$1 + "]";
var reComboMark = RegExp(rsCombo$1, "g");
function deburr$1(string) {
  string = toString$4(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
}
var deburr_1 = deburr$1;
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}
var _asciiWords = asciiWords$1;
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}
var _hasUnicodeWord = hasUnicodeWord$1;
var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
var rsApos$1 = "['\u2019]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos$1 + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos$1 + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
var reUnicodeWord = RegExp([
  rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
  rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
  rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
  rsUpper + "+" + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join("|"), "g");
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}
var _unicodeWords = unicodeWords$1;
var asciiWords = _asciiWords, hasUnicodeWord = _hasUnicodeWord, toString$3 = toString_1, unicodeWords = _unicodeWords;
function words$1(string, pattern, guard) {
  string = toString$3(string);
  pattern = guard ? void 0 : pattern;
  if (pattern === void 0) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}
var words_1 = words$1;
var arrayReduce = _arrayReduce, deburr = deburr_1, words = words_1;
var rsApos = "['\u2019]";
var reApos = RegExp(rsApos, "g");
function createCompounder$1(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
  };
}
var _createCompounder = createCompounder$1;
var capitalize = capitalize_1, createCompounder = _createCompounder;
var camelCase = createCompounder(function(result, word, index2) {
  word = word.toLowerCase();
  return result + (index2 ? capitalize(word) : word);
});
var camelCase_1$1 = camelCase;
var __importDefault$8 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(camelCaseKeys$1, "__esModule", { value: true });
camelCaseKeys$1.camelCaseKeys = void 0;
const camelCase_1 = __importDefault$8(camelCase_1$1);
function camelCaseKeys(target) {
  if (!target) {
    return {};
  }
  return Object.keys(target).reduce((buffer, key) => {
    buffer[(0, camelCase_1.default)(key)] = target[key];
    return buffer;
  }, {});
}
camelCaseKeys$1.camelCaseKeys = camelCaseKeys;
var createTranslationOptions$1 = {};
var isSet$1 = {};
Object.defineProperty(isSet$1, "__esModule", { value: true });
isSet$1.isSet = void 0;
function isSet(value) {
  return value !== void 0 && value !== null;
}
isSet$1.isSet = isSet;
Object.defineProperty(createTranslationOptions$1, "__esModule", { value: true });
createTranslationOptions$1.createTranslationOptions = void 0;
const isSet_1$3 = isSet$1;
function createTranslationOptions(i18n2, scope, options) {
  let translationOptions = [{ scope }];
  if ((0, isSet_1$3.isSet)(options.defaults)) {
    translationOptions = translationOptions.concat(options.defaults);
  }
  if ((0, isSet_1$3.isSet)(options.defaultValue)) {
    const message = typeof options.defaultValue === "function" ? options.defaultValue(i18n2, scope, options) : options.defaultValue;
    translationOptions.push({ message });
    delete options.defaultValue;
  }
  return translationOptions;
}
createTranslationOptions$1.createTranslationOptions = createTranslationOptions;
var expandRoundMode$1 = {};
var bignumber = { exports: {} };
(function(module) {
  (function(globalObject) {
    var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER2 = 9007199254740991, POWS_TEN = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], SQRT_BASE = 1e7, MAX = 1e9;
    function clone(configObject) {
      var div2, convertBase, parseNumeric, P = BigNumber2.prototype = { constructor: BigNumber2, toString: null, valueOf: null }, ONE = new BigNumber2(1), DECIMAL_PLACES = 20, ROUNDING_MODE = 4, TO_EXP_NEG = -7, TO_EXP_POS = 21, MIN_EXP = -1e7, MAX_EXP = 1e7, CRYPTO = false, MODULO_MODE = 1, POW_PRECISION = 0, FORMAT = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xA0",
        suffix: ""
      }, ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
      function BigNumber2(v, b2) {
        var alphabet, c2, caseChanged, e2, i, isNum, len, str, x = this;
        if (!(x instanceof BigNumber2))
          return new BigNumber2(v, b2);
        if (b2 == null) {
          if (v && v._isBigNumber === true) {
            x.s = v.s;
            if (!v.c || v.e > MAX_EXP) {
              x.c = x.e = null;
            } else if (v.e < MIN_EXP) {
              x.c = [x.e = 0];
            } else {
              x.e = v.e;
              x.c = v.c.slice();
            }
            return;
          }
          if ((isNum = typeof v == "number") && v * 0 == 0) {
            x.s = 1 / v < 0 ? (v = -v, -1) : 1;
            if (v === ~~v) {
              for (e2 = 0, i = v; i >= 10; i /= 10, e2++)
                ;
              if (e2 > MAX_EXP) {
                x.c = x.e = null;
              } else {
                x.e = e2;
                x.c = [v];
              }
              return;
            }
            str = String(v);
          } else {
            if (!isNumeric.test(str = String(v)))
              return parseNumeric(x, str, isNum);
            x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
          }
          if ((e2 = str.indexOf(".")) > -1)
            str = str.replace(".", "");
          if ((i = str.search(/e/i)) > 0) {
            if (e2 < 0)
              e2 = i;
            e2 += +str.slice(i + 1);
            str = str.substring(0, i);
          } else if (e2 < 0) {
            e2 = str.length;
          }
        } else {
          intCheck(b2, 2, ALPHABET.length, "Base");
          if (b2 == 10 && alphabetHasNormalDecimalDigits) {
            x = new BigNumber2(v);
            return round2(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
          }
          str = String(v);
          if (isNum = typeof v == "number") {
            if (v * 0 != 0)
              return parseNumeric(x, str, isNum, b2);
            x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
            if (BigNumber2.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) {
              throw Error(tooManyDigits + v);
            }
          } else {
            x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
          }
          alphabet = ALPHABET.slice(0, b2);
          e2 = i = 0;
          for (len = str.length; i < len; i++) {
            if (alphabet.indexOf(c2 = str.charAt(i)) < 0) {
              if (c2 == ".") {
                if (i > e2) {
                  e2 = len;
                  continue;
                }
              } else if (!caseChanged) {
                if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                  caseChanged = true;
                  i = -1;
                  e2 = 0;
                  continue;
                }
              }
              return parseNumeric(x, String(v), isNum, b2);
            }
          }
          isNum = false;
          str = convertBase(str, b2, 10, x.s);
          if ((e2 = str.indexOf(".")) > -1)
            str = str.replace(".", "");
          else
            e2 = str.length;
        }
        for (i = 0; str.charCodeAt(i) === 48; i++)
          ;
        for (len = str.length; str.charCodeAt(--len) === 48; )
          ;
        if (str = str.slice(i, ++len)) {
          len -= i;
          if (isNum && BigNumber2.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER2 || v !== mathfloor(v))) {
            throw Error(tooManyDigits + x.s * v);
          }
          if ((e2 = e2 - i - 1) > MAX_EXP) {
            x.c = x.e = null;
          } else if (e2 < MIN_EXP) {
            x.c = [x.e = 0];
          } else {
            x.e = e2;
            x.c = [];
            i = (e2 + 1) % LOG_BASE;
            if (e2 < 0)
              i += LOG_BASE;
            if (i < len) {
              if (i)
                x.c.push(+str.slice(0, i));
              for (len -= LOG_BASE; i < len; ) {
                x.c.push(+str.slice(i, i += LOG_BASE));
              }
              i = LOG_BASE - (str = str.slice(i)).length;
            } else {
              i -= len;
            }
            for (; i--; str += "0")
              ;
            x.c.push(+str);
          }
        } else {
          x.c = [x.e = 0];
        }
      }
      BigNumber2.clone = clone;
      BigNumber2.ROUND_UP = 0;
      BigNumber2.ROUND_DOWN = 1;
      BigNumber2.ROUND_CEIL = 2;
      BigNumber2.ROUND_FLOOR = 3;
      BigNumber2.ROUND_HALF_UP = 4;
      BigNumber2.ROUND_HALF_DOWN = 5;
      BigNumber2.ROUND_HALF_EVEN = 6;
      BigNumber2.ROUND_HALF_CEIL = 7;
      BigNumber2.ROUND_HALF_FLOOR = 8;
      BigNumber2.EUCLID = 9;
      BigNumber2.config = BigNumber2.set = function(obj) {
        var p, v;
        if (obj != null) {
          if (typeof obj == "object") {
            if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
              v = obj[p];
              intCheck(v, 0, MAX, p);
              DECIMAL_PLACES = v;
            }
            if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
              v = obj[p];
              intCheck(v, 0, 8, p);
              ROUNDING_MODE = v;
            }
            if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
              v = obj[p];
              if (v && v.pop) {
                intCheck(v[0], -MAX, 0, p);
                intCheck(v[1], 0, MAX, p);
                TO_EXP_NEG = v[0];
                TO_EXP_POS = v[1];
              } else {
                intCheck(v, -MAX, MAX, p);
                TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
              }
            }
            if (obj.hasOwnProperty(p = "RANGE")) {
              v = obj[p];
              if (v && v.pop) {
                intCheck(v[0], -MAX, -1, p);
                intCheck(v[1], 1, MAX, p);
                MIN_EXP = v[0];
                MAX_EXP = v[1];
              } else {
                intCheck(v, -MAX, MAX, p);
                if (v) {
                  MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                } else {
                  throw Error(bignumberError + p + " cannot be zero: " + v);
                }
              }
            }
            if (obj.hasOwnProperty(p = "CRYPTO")) {
              v = obj[p];
              if (v === !!v) {
                if (v) {
                  if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) {
                    CRYPTO = v;
                  } else {
                    CRYPTO = !v;
                    throw Error(bignumberError + "crypto unavailable");
                  }
                } else {
                  CRYPTO = v;
                }
              } else {
                throw Error(bignumberError + p + " not true or false: " + v);
              }
            }
            if (obj.hasOwnProperty(p = "MODULO_MODE")) {
              v = obj[p];
              intCheck(v, 0, 9, p);
              MODULO_MODE = v;
            }
            if (obj.hasOwnProperty(p = "POW_PRECISION")) {
              v = obj[p];
              intCheck(v, 0, MAX, p);
              POW_PRECISION = v;
            }
            if (obj.hasOwnProperty(p = "FORMAT")) {
              v = obj[p];
              if (typeof v == "object")
                FORMAT = v;
              else
                throw Error(bignumberError + p + " not an object: " + v);
            }
            if (obj.hasOwnProperty(p = "ALPHABET")) {
              v = obj[p];
              if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                ALPHABET = v;
              } else {
                throw Error(bignumberError + p + " invalid: " + v);
              }
            }
          } else {
            throw Error(bignumberError + "Object expected: " + obj);
          }
        }
        return {
          DECIMAL_PLACES,
          ROUNDING_MODE,
          EXPONENTIAL_AT: [TO_EXP_NEG, TO_EXP_POS],
          RANGE: [MIN_EXP, MAX_EXP],
          CRYPTO,
          MODULO_MODE,
          POW_PRECISION,
          FORMAT,
          ALPHABET
        };
      };
      BigNumber2.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true)
          return false;
        if (!BigNumber2.DEBUG)
          return true;
        var i, n, c2 = v.c, e2 = v.e, s = v.s;
        out:
          if ({}.toString.call(c2) == "[object Array]") {
            if ((s === 1 || s === -1) && e2 >= -MAX && e2 <= MAX && e2 === mathfloor(e2)) {
              if (c2[0] === 0) {
                if (e2 === 0 && c2.length === 1)
                  return true;
                break out;
              }
              i = (e2 + 1) % LOG_BASE;
              if (i < 1)
                i += LOG_BASE;
              if (String(c2[0]).length == i) {
                for (i = 0; i < c2.length; i++) {
                  n = c2[i];
                  if (n < 0 || n >= BASE || n !== mathfloor(n))
                    break out;
                }
                if (n !== 0)
                  return true;
              }
            }
          } else if (c2 === null && e2 === null && (s === null || s === 1 || s === -1)) {
            return true;
          }
        throw Error(bignumberError + "Invalid BigNumber: " + v);
      };
      BigNumber2.maximum = BigNumber2.max = function() {
        return maxOrMin(arguments, -1);
      };
      BigNumber2.minimum = BigNumber2.min = function() {
        return maxOrMin(arguments, 1);
      };
      BigNumber2.random = function() {
        var pow2_53 = 9007199254740992;
        var random53bitInt = Math.random() * pow2_53 & 2097151 ? function() {
          return mathfloor(Math.random() * pow2_53);
        } : function() {
          return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
        };
        return function(dp) {
          var a2, b2, e2, k, v, i = 0, c2 = [], rand = new BigNumber2(ONE);
          if (dp == null)
            dp = DECIMAL_PLACES;
          else
            intCheck(dp, 0, MAX);
          k = mathceil(dp / LOG_BASE);
          if (CRYPTO) {
            if (crypto.getRandomValues) {
              a2 = crypto.getRandomValues(new Uint32Array(k *= 2));
              for (; i < k; ) {
                v = a2[i] * 131072 + (a2[i + 1] >>> 11);
                if (v >= 9e15) {
                  b2 = crypto.getRandomValues(new Uint32Array(2));
                  a2[i] = b2[0];
                  a2[i + 1] = b2[1];
                } else {
                  c2.push(v % 1e14);
                  i += 2;
                }
              }
              i = k / 2;
            } else if (crypto.randomBytes) {
              a2 = crypto.randomBytes(k *= 7);
              for (; i < k; ) {
                v = (a2[i] & 31) * 281474976710656 + a2[i + 1] * 1099511627776 + a2[i + 2] * 4294967296 + a2[i + 3] * 16777216 + (a2[i + 4] << 16) + (a2[i + 5] << 8) + a2[i + 6];
                if (v >= 9e15) {
                  crypto.randomBytes(7).copy(a2, i);
                } else {
                  c2.push(v % 1e14);
                  i += 7;
                }
              }
              i = k / 7;
            } else {
              CRYPTO = false;
              throw Error(bignumberError + "crypto unavailable");
            }
          }
          if (!CRYPTO) {
            for (; i < k; ) {
              v = random53bitInt();
              if (v < 9e15)
                c2[i++] = v % 1e14;
            }
          }
          k = c2[--i];
          dp %= LOG_BASE;
          if (k && dp) {
            v = POWS_TEN[LOG_BASE - dp];
            c2[i] = mathfloor(k / v) * v;
          }
          for (; c2[i] === 0; c2.pop(), i--)
            ;
          if (i < 0) {
            c2 = [e2 = 0];
          } else {
            for (e2 = -1; c2[0] === 0; c2.splice(0, 1), e2 -= LOG_BASE)
              ;
            for (i = 1, v = c2[0]; v >= 10; v /= 10, i++)
              ;
            if (i < LOG_BASE)
              e2 -= LOG_BASE - i;
          }
          rand.e = e2;
          rand.c = c2;
          return rand;
        };
      }();
      BigNumber2.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber2(args[0]);
        for (; i < args.length; )
          sum = sum.plus(args[i++]);
        return sum;
      };
      convertBase = function() {
        var decimal = "0123456789";
        function toBaseOut(str, baseIn, baseOut, alphabet) {
          var j, arr = [0], arrL, i = 0, len = str.length;
          for (; i < len; ) {
            for (arrL = arr.length; arrL--; arr[arrL] *= baseIn)
              ;
            arr[0] += alphabet.indexOf(str.charAt(i++));
            for (j = 0; j < arr.length; j++) {
              if (arr[j] > baseOut - 1) {
                if (arr[j + 1] == null)
                  arr[j + 1] = 0;
                arr[j + 1] += arr[j] / baseOut | 0;
                arr[j] %= baseOut;
              }
            }
          }
          return arr.reverse();
        }
        return function(str, baseIn, baseOut, sign, callerIsToString) {
          var alphabet, d2, e2, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm2 = ROUNDING_MODE;
          if (i >= 0) {
            k = POW_PRECISION;
            POW_PRECISION = 0;
            str = str.replace(".", "");
            y = new BigNumber2(baseIn);
            x = y.pow(str.length - i);
            POW_PRECISION = k;
            y.c = toBaseOut(
              toFixedPoint(coeffToString(x.c), x.e, "0"),
              10,
              baseOut,
              decimal
            );
            y.e = y.c.length;
          }
          xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
          e2 = k = xc.length;
          for (; xc[--k] == 0; xc.pop())
            ;
          if (!xc[0])
            return alphabet.charAt(0);
          if (i < 0) {
            --e2;
          } else {
            x.c = xc;
            x.e = e2;
            x.s = sign;
            x = div2(x, y, dp, rm2, baseOut);
            xc = x.c;
            r = x.r;
            e2 = x.e;
          }
          d2 = e2 + dp + 1;
          i = xc[d2];
          k = baseOut / 2;
          r = r || d2 < 0 || xc[d2 + 1] != null;
          r = rm2 < 4 ? (i != null || r) && (rm2 == 0 || rm2 == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm2 == 4 || r || rm2 == 6 && xc[d2 - 1] & 1 || rm2 == (x.s < 0 ? 8 : 7));
          if (d2 < 1 || !xc[0]) {
            str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
          } else {
            xc.length = d2;
            if (r) {
              for (--baseOut; ++xc[--d2] > baseOut; ) {
                xc[d2] = 0;
                if (!d2) {
                  ++e2;
                  xc = [1].concat(xc);
                }
              }
            }
            for (k = xc.length; !xc[--k]; )
              ;
            for (i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]))
              ;
            str = toFixedPoint(str, e2, alphabet.charAt(0));
          }
          return str;
        };
      }();
      div2 = function() {
        function multiply(x, k, base) {
          var m2, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
          for (x = x.slice(); i--; ) {
            xlo = x[i] % SQRT_BASE;
            xhi = x[i] / SQRT_BASE | 0;
            m2 = khi * xlo + xhi * klo;
            temp = klo * xlo + m2 % SQRT_BASE * SQRT_BASE + carry;
            carry = (temp / base | 0) + (m2 / SQRT_BASE | 0) + khi * xhi;
            x[i] = temp % base;
          }
          if (carry)
            x = [carry].concat(x);
          return x;
        }
        function compare3(a2, b2, aL, bL) {
          var i, cmp2;
          if (aL != bL) {
            cmp2 = aL > bL ? 1 : -1;
          } else {
            for (i = cmp2 = 0; i < aL; i++) {
              if (a2[i] != b2[i]) {
                cmp2 = a2[i] > b2[i] ? 1 : -1;
                break;
              }
            }
          }
          return cmp2;
        }
        function subtract(a2, b2, aL, base) {
          var i = 0;
          for (; aL--; ) {
            a2[aL] -= i;
            i = a2[aL] < b2[aL] ? 1 : 0;
            a2[aL] = i * base + a2[aL] - b2[aL];
          }
          for (; !a2[0] && a2.length > 1; a2.splice(0, 1))
            ;
        }
        return function(x, y, dp, rm2, base) {
          var cmp2, e2, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
          if (!xc || !xc[0] || !yc || !yc[0]) {
            return new BigNumber2(
              !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : xc && xc[0] == 0 || !yc ? s * 0 : s / 0
            );
          }
          q = new BigNumber2(s);
          qc = q.c = [];
          e2 = x.e - y.e;
          s = dp + e2 + 1;
          if (!base) {
            base = BASE;
            e2 = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
            s = s / LOG_BASE | 0;
          }
          for (i = 0; yc[i] == (xc[i] || 0); i++)
            ;
          if (yc[i] > (xc[i] || 0))
            e2--;
          if (s < 0) {
            qc.push(1);
            more = true;
          } else {
            xL = xc.length;
            yL = yc.length;
            i = 0;
            s += 2;
            n = mathfloor(base / (yc[0] + 1));
            if (n > 1) {
              yc = multiply(yc, n, base);
              xc = multiply(xc, n, base);
              yL = yc.length;
              xL = xc.length;
            }
            xi = yL;
            rem = xc.slice(0, yL);
            remL = rem.length;
            for (; remL < yL; rem[remL++] = 0)
              ;
            yz = yc.slice();
            yz = [0].concat(yz);
            yc0 = yc[0];
            if (yc[1] >= base / 2)
              yc0++;
            do {
              n = 0;
              cmp2 = compare3(yc, rem, yL, remL);
              if (cmp2 < 0) {
                rem0 = rem[0];
                if (yL != remL)
                  rem0 = rem0 * base + (rem[1] || 0);
                n = mathfloor(rem0 / yc0);
                if (n > 1) {
                  if (n >= base)
                    n = base - 1;
                  prod = multiply(yc, n, base);
                  prodL = prod.length;
                  remL = rem.length;
                  while (compare3(prod, rem, prodL, remL) == 1) {
                    n--;
                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                    prodL = prod.length;
                    cmp2 = 1;
                  }
                } else {
                  if (n == 0) {
                    cmp2 = n = 1;
                  }
                  prod = yc.slice();
                  prodL = prod.length;
                }
                if (prodL < remL)
                  prod = [0].concat(prod);
                subtract(rem, prod, remL, base);
                remL = rem.length;
                if (cmp2 == -1) {
                  while (compare3(yc, rem, yL, remL) < 1) {
                    n++;
                    subtract(rem, yL < remL ? yz : yc, remL, base);
                    remL = rem.length;
                  }
                }
              } else if (cmp2 === 0) {
                n++;
                rem = [0];
              }
              qc[i++] = n;
              if (rem[0]) {
                rem[remL++] = xc[xi] || 0;
              } else {
                rem = [xc[xi]];
                remL = 1;
              }
            } while ((xi++ < xL || rem[0] != null) && s--);
            more = rem[0] != null;
            if (!qc[0])
              qc.splice(0, 1);
          }
          if (base == BASE) {
            for (i = 1, s = qc[0]; s >= 10; s /= 10, i++)
              ;
            round2(q, dp + (q.e = i + e2 * LOG_BASE - 1) + 1, rm2, more);
          } else {
            q.e = e2;
            q.r = +more;
          }
          return q;
        };
      }();
      function format(n, i, rm2, id2) {
        var c0, e2, ne2, len, str;
        if (rm2 == null)
          rm2 = ROUNDING_MODE;
        else
          intCheck(rm2, 0, 8);
        if (!n.c)
          return n.toString();
        c0 = n.c[0];
        ne2 = n.e;
        if (i == null) {
          str = coeffToString(n.c);
          str = id2 == 1 || id2 == 2 && (ne2 <= TO_EXP_NEG || ne2 >= TO_EXP_POS) ? toExponential(str, ne2) : toFixedPoint(str, ne2, "0");
        } else {
          n = round2(new BigNumber2(n), i, rm2);
          e2 = n.e;
          str = coeffToString(n.c);
          len = str.length;
          if (id2 == 1 || id2 == 2 && (i <= e2 || e2 <= TO_EXP_NEG)) {
            for (; len < i; str += "0", len++)
              ;
            str = toExponential(str, e2);
          } else {
            i -= ne2 + (id2 === 2 && e2 > ne2);
            str = toFixedPoint(str, e2, "0");
            if (e2 + 1 > len) {
              if (--i > 0)
                for (str += "."; i--; str += "0")
                  ;
            } else {
              i += e2 - len;
              if (i > 0) {
                if (e2 + 1 == len)
                  str += ".";
                for (; i--; str += "0")
                  ;
              }
            }
          }
        }
        return n.s < 0 && c0 ? "-" + str : str;
      }
      function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber2(args[0]);
        for (; i < args.length; i++) {
          y = new BigNumber2(args[i]);
          if (!y.s || (k = compare2(x, y)) === n || k === 0 && x.s === n) {
            x = y;
          }
        }
        return x;
      }
      function normalise(n, c2, e2) {
        var i = 1, j = c2.length;
        for (; !c2[--j]; c2.pop())
          ;
        for (j = c2[0]; j >= 10; j /= 10, i++)
          ;
        if ((e2 = i + e2 * LOG_BASE - 1) > MAX_EXP) {
          n.c = n.e = null;
        } else if (e2 < MIN_EXP) {
          n.c = [n.e = 0];
        } else {
          n.e = e2;
          n.c = c2;
        }
        return n;
      }
      parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b2) {
          var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
          if (isInfinityOrNaN.test(s)) {
            x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
          } else {
            if (!isNum) {
              s = s.replace(basePrefix, function(m2, p1, p2) {
                base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                return !b2 || b2 == base ? p1 : m2;
              });
              if (b2) {
                base = b2;
                s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
              }
              if (str != s)
                return new BigNumber2(s, base);
            }
            if (BigNumber2.DEBUG) {
              throw Error(bignumberError + "Not a" + (b2 ? " base " + b2 : "") + " number: " + str);
            }
            x.s = null;
          }
          x.c = x.e = null;
        };
      }();
      function round2(x, sd2, rm2, r) {
        var d2, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
        if (xc) {
          out: {
            for (d2 = 1, k = xc[0]; k >= 10; k /= 10, d2++)
              ;
            i = sd2 - d2;
            if (i < 0) {
              i += LOG_BASE;
              j = sd2;
              n = xc[ni = 0];
              rd = mathfloor(n / pows10[d2 - j - 1] % 10);
            } else {
              ni = mathceil((i + 1) / LOG_BASE);
              if (ni >= xc.length) {
                if (r) {
                  for (; xc.length <= ni; xc.push(0))
                    ;
                  n = rd = 0;
                  d2 = 1;
                  i %= LOG_BASE;
                  j = i - LOG_BASE + 1;
                } else {
                  break out;
                }
              } else {
                n = k = xc[ni];
                for (d2 = 1; k >= 10; k /= 10, d2++)
                  ;
                i %= LOG_BASE;
                j = i - LOG_BASE + d2;
                rd = j < 0 ? 0 : mathfloor(n / pows10[d2 - j - 1] % 10);
              }
            }
            r = r || sd2 < 0 || xc[ni + 1] != null || (j < 0 ? n : n % pows10[d2 - j - 1]);
            r = rm2 < 4 ? (rd || r) && (rm2 == 0 || rm2 == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm2 == 4 || r || rm2 == 6 && (i > 0 ? j > 0 ? n / pows10[d2 - j] : 0 : xc[ni - 1]) % 10 & 1 || rm2 == (x.s < 0 ? 8 : 7));
            if (sd2 < 1 || !xc[0]) {
              xc.length = 0;
              if (r) {
                sd2 -= x.e + 1;
                xc[0] = pows10[(LOG_BASE - sd2 % LOG_BASE) % LOG_BASE];
                x.e = -sd2 || 0;
              } else {
                xc[0] = x.e = 0;
              }
              return x;
            }
            if (i == 0) {
              xc.length = ni;
              k = 1;
              ni--;
            } else {
              xc.length = ni + 1;
              k = pows10[LOG_BASE - i];
              xc[ni] = j > 0 ? mathfloor(n / pows10[d2 - j] % pows10[j]) * k : 0;
            }
            if (r) {
              for (; ; ) {
                if (ni == 0) {
                  for (i = 1, j = xc[0]; j >= 10; j /= 10, i++)
                    ;
                  j = xc[0] += k;
                  for (k = 1; j >= 10; j /= 10, k++)
                    ;
                  if (i != k) {
                    x.e++;
                    if (xc[0] == BASE)
                      xc[0] = 1;
                  }
                  break;
                } else {
                  xc[ni] += k;
                  if (xc[ni] != BASE)
                    break;
                  xc[ni--] = 0;
                  k = 1;
                }
              }
            }
            for (i = xc.length; xc[--i] === 0; xc.pop())
              ;
          }
          if (x.e > MAX_EXP) {
            x.c = x.e = null;
          } else if (x.e < MIN_EXP) {
            x.c = [x.e = 0];
          }
        }
        return x;
      }
      function valueOf(n) {
        var str, e2 = n.e;
        if (e2 === null)
          return n.toString();
        str = coeffToString(n.c);
        str = e2 <= TO_EXP_NEG || e2 >= TO_EXP_POS ? toExponential(str, e2) : toFixedPoint(str, e2, "0");
        return n.s < 0 ? "-" + str : str;
      }
      P.absoluteValue = P.abs = function() {
        var x = new BigNumber2(this);
        if (x.s < 0)
          x.s = 1;
        return x;
      };
      P.comparedTo = function(y, b2) {
        return compare2(this, new BigNumber2(y, b2));
      };
      P.decimalPlaces = P.dp = function(dp, rm2) {
        var c2, n, v, x = this;
        if (dp != null) {
          intCheck(dp, 0, MAX);
          if (rm2 == null)
            rm2 = ROUNDING_MODE;
          else
            intCheck(rm2, 0, 8);
          return round2(new BigNumber2(x), dp + x.e + 1, rm2);
        }
        if (!(c2 = x.c))
          return null;
        n = ((v = c2.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
        if (v = c2[v])
          for (; v % 10 == 0; v /= 10, n--)
            ;
        if (n < 0)
          n = 0;
        return n;
      };
      P.dividedBy = P.div = function(y, b2) {
        return div2(this, new BigNumber2(y, b2), DECIMAL_PLACES, ROUNDING_MODE);
      };
      P.dividedToIntegerBy = P.idiv = function(y, b2) {
        return div2(this, new BigNumber2(y, b2), 0, 1);
      };
      P.exponentiatedBy = P.pow = function(n, m2) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber2(n);
        if (n.c && !n.isInteger()) {
          throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
        }
        if (m2 != null)
          m2 = new BigNumber2(m2);
        nIsBig = n.e > 14;
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
          y = new BigNumber2(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
          return m2 ? y.mod(m2) : y;
        }
        nIsNeg = n.s < 0;
        if (m2) {
          if (m2.c ? !m2.c[0] : !m2.s)
            return new BigNumber2(NaN);
          isModExp = !nIsNeg && x.isInteger() && m2.isInteger();
          if (isModExp)
            x = x.mod(m2);
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
          k = x.s < 0 && isOdd(n) ? -0 : 0;
          if (x.e > -1)
            k = 1 / k;
          return new BigNumber2(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) {
          k = mathceil(POW_PRECISION / LOG_BASE + 2);
        }
        if (nIsBig) {
          half = new BigNumber2(0.5);
          if (nIsNeg)
            n.s = 1;
          nIsOdd = isOdd(n);
        } else {
          i = Math.abs(+valueOf(n));
          nIsOdd = i % 2;
        }
        y = new BigNumber2(ONE);
        for (; ; ) {
          if (nIsOdd) {
            y = y.times(x);
            if (!y.c)
              break;
            if (k) {
              if (y.c.length > k)
                y.c.length = k;
            } else if (isModExp) {
              y = y.mod(m2);
            }
          }
          if (i) {
            i = mathfloor(i / 2);
            if (i === 0)
              break;
            nIsOdd = i % 2;
          } else {
            n = n.times(half);
            round2(n, n.e + 1, 1);
            if (n.e > 14) {
              nIsOdd = isOdd(n);
            } else {
              i = +valueOf(n);
              if (i === 0)
                break;
              nIsOdd = i % 2;
            }
          }
          x = x.times(x);
          if (k) {
            if (x.c && x.c.length > k)
              x.c.length = k;
          } else if (isModExp) {
            x = x.mod(m2);
          }
        }
        if (isModExp)
          return y;
        if (nIsNeg)
          y = ONE.div(y);
        return m2 ? y.mod(m2) : k ? round2(y, POW_PRECISION, ROUNDING_MODE, more) : y;
      };
      P.integerValue = function(rm2) {
        var n = new BigNumber2(this);
        if (rm2 == null)
          rm2 = ROUNDING_MODE;
        else
          intCheck(rm2, 0, 8);
        return round2(n, n.e + 1, rm2);
      };
      P.isEqualTo = P.eq = function(y, b2) {
        return compare2(this, new BigNumber2(y, b2)) === 0;
      };
      P.isFinite = function() {
        return !!this.c;
      };
      P.isGreaterThan = P.gt = function(y, b2) {
        return compare2(this, new BigNumber2(y, b2)) > 0;
      };
      P.isGreaterThanOrEqualTo = P.gte = function(y, b2) {
        return (b2 = compare2(this, new BigNumber2(y, b2))) === 1 || b2 === 0;
      };
      P.isInteger = function() {
        return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
      };
      P.isLessThan = P.lt = function(y, b2) {
        return compare2(this, new BigNumber2(y, b2)) < 0;
      };
      P.isLessThanOrEqualTo = P.lte = function(y, b2) {
        return (b2 = compare2(this, new BigNumber2(y, b2))) === -1 || b2 === 0;
      };
      P.isNaN = function() {
        return !this.s;
      };
      P.isNegative = function() {
        return this.s < 0;
      };
      P.isPositive = function() {
        return this.s > 0;
      };
      P.isZero = function() {
        return !!this.c && this.c[0] == 0;
      };
      P.minus = function(y, b2) {
        var i, j, t2, xLTy, x = this, a2 = x.s;
        y = new BigNumber2(y, b2);
        b2 = y.s;
        if (!a2 || !b2)
          return new BigNumber2(NaN);
        if (a2 != b2) {
          y.s = -b2;
          return x.plus(y);
        }
        var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
          if (!xc || !yc)
            return xc ? (y.s = -b2, y) : new BigNumber2(yc ? x : NaN);
          if (!xc[0] || !yc[0]) {
            return yc[0] ? (y.s = -b2, y) : new BigNumber2(xc[0] ? x : ROUNDING_MODE == 3 ? -0 : 0);
          }
        }
        xe = bitFloor(xe);
        ye = bitFloor(ye);
        xc = xc.slice();
        if (a2 = xe - ye) {
          if (xLTy = a2 < 0) {
            a2 = -a2;
            t2 = xc;
          } else {
            ye = xe;
            t2 = yc;
          }
          t2.reverse();
          for (b2 = a2; b2--; t2.push(0))
            ;
          t2.reverse();
        } else {
          j = (xLTy = (a2 = xc.length) < (b2 = yc.length)) ? a2 : b2;
          for (a2 = b2 = 0; b2 < j; b2++) {
            if (xc[b2] != yc[b2]) {
              xLTy = xc[b2] < yc[b2];
              break;
            }
          }
        }
        if (xLTy) {
          t2 = xc;
          xc = yc;
          yc = t2;
          y.s = -y.s;
        }
        b2 = (j = yc.length) - (i = xc.length);
        if (b2 > 0)
          for (; b2--; xc[i++] = 0)
            ;
        b2 = BASE - 1;
        for (; j > a2; ) {
          if (xc[--j] < yc[j]) {
            for (i = j; i && !xc[--i]; xc[i] = b2)
              ;
            --xc[i];
            xc[j] += BASE;
          }
          xc[j] -= yc[j];
        }
        for (; xc[0] == 0; xc.splice(0, 1), --ye)
          ;
        if (!xc[0]) {
          y.s = ROUNDING_MODE == 3 ? -1 : 1;
          y.c = [y.e = 0];
          return y;
        }
        return normalise(y, xc, ye);
      };
      P.modulo = P.mod = function(y, b2) {
        var q, s, x = this;
        y = new BigNumber2(y, b2);
        if (!x.c || !y.s || y.c && !y.c[0]) {
          return new BigNumber2(NaN);
        } else if (!y.c || x.c && !x.c[0]) {
          return new BigNumber2(x);
        }
        if (MODULO_MODE == 9) {
          s = y.s;
          y.s = 1;
          q = div2(x, y, 0, 3);
          y.s = s;
          q.s *= s;
        } else {
          q = div2(x, y, 0, MODULO_MODE);
        }
        y = x.minus(q.times(y));
        if (!y.c[0] && MODULO_MODE == 1)
          y.s = x.s;
        return y;
      };
      P.multipliedBy = P.times = function(y, b2) {
        var c2, e2, i, j, k, m2, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber2(y, b2)).c;
        if (!xc || !yc || !xc[0] || !yc[0]) {
          if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) {
            y.c = y.e = y.s = null;
          } else {
            y.s *= x.s;
            if (!xc || !yc) {
              y.c = y.e = null;
            } else {
              y.c = [0];
              y.e = 0;
            }
          }
          return y;
        }
        e2 = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        if (xcL < ycL) {
          zc = xc;
          xc = yc;
          yc = zc;
          i = xcL;
          xcL = ycL;
          ycL = i;
        }
        for (i = xcL + ycL, zc = []; i--; zc.push(0))
          ;
        base = BASE;
        sqrtBase = SQRT_BASE;
        for (i = ycL; --i >= 0; ) {
          c2 = 0;
          ylo = yc[i] % sqrtBase;
          yhi = yc[i] / sqrtBase | 0;
          for (k = xcL, j = i + k; j > i; ) {
            xlo = xc[--k] % sqrtBase;
            xhi = xc[k] / sqrtBase | 0;
            m2 = yhi * xlo + xhi * ylo;
            xlo = ylo * xlo + m2 % sqrtBase * sqrtBase + zc[j] + c2;
            c2 = (xlo / base | 0) + (m2 / sqrtBase | 0) + yhi * xhi;
            zc[j--] = xlo % base;
          }
          zc[j] = c2;
        }
        if (c2) {
          ++e2;
        } else {
          zc.splice(0, 1);
        }
        return normalise(y, zc, e2);
      };
      P.negated = function() {
        var x = new BigNumber2(this);
        x.s = -x.s || null;
        return x;
      };
      P.plus = function(y, b2) {
        var t2, x = this, a2 = x.s;
        y = new BigNumber2(y, b2);
        b2 = y.s;
        if (!a2 || !b2)
          return new BigNumber2(NaN);
        if (a2 != b2) {
          y.s = -b2;
          return x.minus(y);
        }
        var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
          if (!xc || !yc)
            return new BigNumber2(a2 / 0);
          if (!xc[0] || !yc[0])
            return yc[0] ? y : new BigNumber2(xc[0] ? x : a2 * 0);
        }
        xe = bitFloor(xe);
        ye = bitFloor(ye);
        xc = xc.slice();
        if (a2 = xe - ye) {
          if (a2 > 0) {
            ye = xe;
            t2 = yc;
          } else {
            a2 = -a2;
            t2 = xc;
          }
          t2.reverse();
          for (; a2--; t2.push(0))
            ;
          t2.reverse();
        }
        a2 = xc.length;
        b2 = yc.length;
        if (a2 - b2 < 0) {
          t2 = yc;
          yc = xc;
          xc = t2;
          b2 = a2;
        }
        for (a2 = 0; b2; ) {
          a2 = (xc[--b2] = xc[b2] + yc[b2] + a2) / BASE | 0;
          xc[b2] = BASE === xc[b2] ? 0 : xc[b2] % BASE;
        }
        if (a2) {
          xc = [a2].concat(xc);
          ++ye;
        }
        return normalise(y, xc, ye);
      };
      P.precision = P.sd = function(sd2, rm2) {
        var c2, n, v, x = this;
        if (sd2 != null && sd2 !== !!sd2) {
          intCheck(sd2, 1, MAX);
          if (rm2 == null)
            rm2 = ROUNDING_MODE;
          else
            intCheck(rm2, 0, 8);
          return round2(new BigNumber2(x), sd2, rm2);
        }
        if (!(c2 = x.c))
          return null;
        v = c2.length - 1;
        n = v * LOG_BASE + 1;
        if (v = c2[v]) {
          for (; v % 10 == 0; v /= 10, n--)
            ;
          for (v = c2[0]; v >= 10; v /= 10, n++)
            ;
        }
        if (sd2 && x.e + 1 > n)
          n = x.e + 1;
        return n;
      };
      P.shiftedBy = function(k) {
        intCheck(k, -MAX_SAFE_INTEGER2, MAX_SAFE_INTEGER2);
        return this.times("1e" + k);
      };
      P.squareRoot = P.sqrt = function() {
        var m2, n, r, rep, t2, x = this, c2 = x.c, s = x.s, e2 = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber2("0.5");
        if (s !== 1 || !c2 || !c2[0]) {
          return new BigNumber2(!s || s < 0 && (!c2 || c2[0]) ? NaN : c2 ? x : 1 / 0);
        }
        s = Math.sqrt(+valueOf(x));
        if (s == 0 || s == 1 / 0) {
          n = coeffToString(c2);
          if ((n.length + e2) % 2 == 0)
            n += "0";
          s = Math.sqrt(+n);
          e2 = bitFloor((e2 + 1) / 2) - (e2 < 0 || e2 % 2);
          if (s == 1 / 0) {
            n = "5e" + e2;
          } else {
            n = s.toExponential();
            n = n.slice(0, n.indexOf("e") + 1) + e2;
          }
          r = new BigNumber2(n);
        } else {
          r = new BigNumber2(s + "");
        }
        if (r.c[0]) {
          e2 = r.e;
          s = e2 + dp;
          if (s < 3)
            s = 0;
          for (; ; ) {
            t2 = r;
            r = half.times(t2.plus(div2(x, t2, dp, 1)));
            if (coeffToString(t2.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
              if (r.e < e2)
                --s;
              n = n.slice(s - 3, s + 1);
              if (n == "9999" || !rep && n == "4999") {
                if (!rep) {
                  round2(t2, t2.e + DECIMAL_PLACES + 2, 0);
                  if (t2.times(t2).eq(x)) {
                    r = t2;
                    break;
                  }
                }
                dp += 4;
                s += 4;
                rep = 1;
              } else {
                if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                  round2(r, r.e + DECIMAL_PLACES + 2, 1);
                  m2 = !r.times(r).eq(x);
                }
                break;
              }
            }
          }
        }
        return round2(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m2);
      };
      P.toExponential = function(dp, rm2) {
        if (dp != null) {
          intCheck(dp, 0, MAX);
          dp++;
        }
        return format(this, dp, rm2, 1);
      };
      P.toFixed = function(dp, rm2) {
        if (dp != null) {
          intCheck(dp, 0, MAX);
          dp = dp + this.e + 1;
        }
        return format(this, dp, rm2);
      };
      P.toFormat = function(dp, rm2, format2) {
        var str, x = this;
        if (format2 == null) {
          if (dp != null && rm2 && typeof rm2 == "object") {
            format2 = rm2;
            rm2 = null;
          } else if (dp && typeof dp == "object") {
            format2 = dp;
            dp = rm2 = null;
          } else {
            format2 = FORMAT;
          }
        } else if (typeof format2 != "object") {
          throw Error(bignumberError + "Argument not an object: " + format2);
        }
        str = x.toFixed(dp, rm2);
        if (x.c) {
          var i, arr = str.split("."), g1 = +format2.groupSize, g2 = +format2.secondaryGroupSize, groupSeparator = format2.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
          if (g2) {
            i = g1;
            g1 = g2;
            g2 = i;
            len -= i;
          }
          if (g1 > 0 && len > 0) {
            i = len % g1 || g1;
            intPart = intDigits.substr(0, i);
            for (; i < len; i += g1)
              intPart += groupSeparator + intDigits.substr(i, g1);
            if (g2 > 0)
              intPart += groupSeparator + intDigits.slice(i);
            if (isNeg)
              intPart = "-" + intPart;
          }
          str = fractionPart ? intPart + (format2.decimalSeparator || "") + ((g2 = +format2.fractionGroupSize) ? fractionPart.replace(
            new RegExp("\\d{" + g2 + "}\\B", "g"),
            "$&" + (format2.fractionGroupSeparator || "")
          ) : fractionPart) : intPart;
        }
        return (format2.prefix || "") + str + (format2.suffix || "");
      };
      P.toFraction = function(md) {
        var d2, d0, d1, d22, e2, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
          n = new BigNumber2(md);
          if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) {
            throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
          }
        }
        if (!xc)
          return new BigNumber2(x);
        d2 = new BigNumber2(ONE);
        n1 = d0 = new BigNumber2(ONE);
        d1 = n0 = new BigNumber2(ONE);
        s = coeffToString(xc);
        e2 = d2.e = s.length - x.e - 1;
        d2.c[0] = POWS_TEN[(exp = e2 % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d2) > 0 ? e2 > 0 ? d2 : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber2(s);
        n0.c[0] = 0;
        for (; ; ) {
          q = div2(n, d2, 0, 1);
          d22 = d0.plus(q.times(d1));
          if (d22.comparedTo(md) == 1)
            break;
          d0 = d1;
          d1 = d22;
          n1 = n0.plus(q.times(d22 = n1));
          n0 = d22;
          d2 = n.minus(q.times(d22 = d2));
          n = d22;
        }
        d22 = div2(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d22.times(n1));
        d0 = d0.plus(d22.times(d1));
        n0.s = n1.s = x.s;
        e2 = e2 * 2;
        r = div2(n1, d1, e2, ROUNDING_MODE).minus(x).abs().comparedTo(
          div2(n0, d0, e2, ROUNDING_MODE).minus(x).abs()
        ) < 1 ? [n1, d1] : [n0, d0];
        MAX_EXP = exp;
        return r;
      };
      P.toNumber = function() {
        return +valueOf(this);
      };
      P.toPrecision = function(sd2, rm2) {
        if (sd2 != null)
          intCheck(sd2, 1, MAX);
        return format(this, sd2, rm2, 2);
      };
      P.toString = function(b2) {
        var str, n = this, s = n.s, e2 = n.e;
        if (e2 === null) {
          if (s) {
            str = "Infinity";
            if (s < 0)
              str = "-" + str;
          } else {
            str = "NaN";
          }
        } else {
          if (b2 == null) {
            str = e2 <= TO_EXP_NEG || e2 >= TO_EXP_POS ? toExponential(coeffToString(n.c), e2) : toFixedPoint(coeffToString(n.c), e2, "0");
          } else if (b2 === 10 && alphabetHasNormalDecimalDigits) {
            n = round2(new BigNumber2(n), DECIMAL_PLACES + e2 + 1, ROUNDING_MODE);
            str = toFixedPoint(coeffToString(n.c), n.e, "0");
          } else {
            intCheck(b2, 2, ALPHABET.length, "Base");
            str = convertBase(toFixedPoint(coeffToString(n.c), e2, "0"), 10, b2, s, true);
          }
          if (s < 0 && n.c[0])
            str = "-" + str;
        }
        return str;
      };
      P.valueOf = P.toJSON = function() {
        return valueOf(this);
      };
      P._isBigNumber = true;
      if (configObject != null)
        BigNumber2.set(configObject);
      return BigNumber2;
    }
    function bitFloor(n) {
      var i = n | 0;
      return n > 0 || n === i ? i : i - 1;
    }
    function coeffToString(a2) {
      var s, z, i = 1, j = a2.length, r = a2[0] + "";
      for (; i < j; ) {
        s = a2[i++] + "";
        z = LOG_BASE - s.length;
        for (; z--; s = "0" + s)
          ;
        r += s;
      }
      for (j = r.length; r.charCodeAt(--j) === 48; )
        ;
      return r.slice(0, j + 1 || 1);
    }
    function compare2(x, y) {
      var a2, b2, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
      if (!i || !j)
        return null;
      a2 = xc && !xc[0];
      b2 = yc && !yc[0];
      if (a2 || b2)
        return a2 ? b2 ? 0 : -j : i;
      if (i != j)
        return i;
      a2 = i < 0;
      b2 = k == l;
      if (!xc || !yc)
        return b2 ? 0 : !xc ^ a2 ? 1 : -1;
      if (!b2)
        return k > l ^ a2 ? 1 : -1;
      j = (k = xc.length) < (l = yc.length) ? k : l;
      for (i = 0; i < j; i++)
        if (xc[i] != yc[i])
          return xc[i] > yc[i] ^ a2 ? 1 : -1;
      return k == l ? 0 : k > l ^ a2 ? 1 : -1;
    }
    function intCheck(n, min2, max2, name2) {
      if (n < min2 || n > max2 || n !== mathfloor(n)) {
        throw Error(bignumberError + (name2 || "Argument") + (typeof n == "number" ? n < min2 || n > max2 ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
      }
    }
    function isOdd(n) {
      var k = n.c.length - 1;
      return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e2) {
      return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e2 < 0 ? "e" : "e+") + e2;
    }
    function toFixedPoint(str, e2, z) {
      var len, zs;
      if (e2 < 0) {
        for (zs = z + "."; ++e2; zs += z)
          ;
        str = zs + str;
      } else {
        len = str.length;
        if (++e2 > len) {
          for (zs = z, e2 -= len; --e2; zs += z)
            ;
          str += zs;
        } else if (e2 < len) {
          str = str.slice(0, e2) + "." + str.slice(e2);
        }
      }
      return str;
    }
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    if (module.exports) {
      module.exports = BigNumber;
    } else {
      if (!globalObject) {
        globalObject = typeof self != "undefined" && self ? self : window;
      }
      globalObject.BigNumber = BigNumber;
    }
  })(commonjsGlobal);
})(bignumber);
var __importDefault$7 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(expandRoundMode$1, "__esModule", { value: true });
expandRoundMode$1.expandRoundMode = void 0;
const bignumber_js_1$5 = __importDefault$7(bignumber.exports);
var RoundingModeMap;
(function(RoundingModeMap2) {
  RoundingModeMap2[RoundingModeMap2["up"] = bignumber_js_1$5.default.ROUND_UP] = "up";
  RoundingModeMap2[RoundingModeMap2["down"] = bignumber_js_1$5.default.ROUND_DOWN] = "down";
  RoundingModeMap2[RoundingModeMap2["truncate"] = bignumber_js_1$5.default.ROUND_DOWN] = "truncate";
  RoundingModeMap2[RoundingModeMap2["halfUp"] = bignumber_js_1$5.default.ROUND_HALF_UP] = "halfUp";
  RoundingModeMap2[RoundingModeMap2["default"] = bignumber_js_1$5.default.ROUND_HALF_UP] = "default";
  RoundingModeMap2[RoundingModeMap2["halfDown"] = bignumber_js_1$5.default.ROUND_HALF_DOWN] = "halfDown";
  RoundingModeMap2[RoundingModeMap2["halfEven"] = bignumber_js_1$5.default.ROUND_HALF_EVEN] = "halfEven";
  RoundingModeMap2[RoundingModeMap2["banker"] = bignumber_js_1$5.default.ROUND_HALF_EVEN] = "banker";
  RoundingModeMap2[RoundingModeMap2["ceiling"] = bignumber_js_1$5.default.ROUND_CEIL] = "ceiling";
  RoundingModeMap2[RoundingModeMap2["ceil"] = bignumber_js_1$5.default.ROUND_CEIL] = "ceil";
  RoundingModeMap2[RoundingModeMap2["floor"] = bignumber_js_1$5.default.ROUND_FLOOR] = "floor";
})(RoundingModeMap || (RoundingModeMap = {}));
function expandRoundMode(roundMode) {
  var _a2;
  return (_a2 = RoundingModeMap[roundMode]) !== null && _a2 !== void 0 ? _a2 : RoundingModeMap.default;
}
expandRoundMode$1.expandRoundMode = expandRoundMode;
var formatNumber$1 = {};
var MAX_SAFE_INTEGER$2 = 9007199254740991;
var nativeFloor = Math.floor;
function baseRepeat$1(string, n) {
  var result = "";
  if (!string || n < 1 || n > MAX_SAFE_INTEGER$2) {
    return result;
  }
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);
  return result;
}
var _baseRepeat = baseRepeat$1;
var reWhitespace = /\s/;
function trimmedEndIndex$1(string) {
  var index2 = string.length;
  while (index2-- && reWhitespace.test(string.charAt(index2))) {
  }
  return index2;
}
var _trimmedEndIndex = trimmedEndIndex$1;
var trimmedEndIndex = _trimmedEndIndex;
var reTrimStart = /^\s+/;
function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
}
var _baseTrim = baseTrim$1;
var baseTrim = _baseTrim, isObject$2 = isObject_1, isSymbol$1 = isSymbol_1;
var NAN = 0 / 0;
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
var reIsBinary = /^0b[01]+$/i;
var reIsOctal = /^0o[0-7]+$/i;
var freeParseInt = parseInt;
function toNumber$1(value) {
  if (typeof value == "number") {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == "function" ? value.valueOf() : value;
    value = isObject$2(other) ? other + "" : other;
  }
  if (typeof value != "string") {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
var toNumber_1 = toNumber$1;
var toNumber = toNumber_1;
var INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$2(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = value < 0 ? -1 : 1;
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}
var toFinite_1 = toFinite$2;
var toFinite$1 = toFinite_1;
function toInteger$1(value) {
  var result = toFinite$1(value), remainder = result % 1;
  return result === result ? remainder ? result - remainder : result : 0;
}
var toInteger_1 = toInteger$1;
var baseRepeat = _baseRepeat, isIterateeCall$2 = _isIterateeCall, toInteger = toInteger_1, toString$2 = toString_1;
function repeat(string, n, guard) {
  if (guard ? isIterateeCall$2(string, n, guard) : n === void 0) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  return baseRepeat(toString$2(string), n);
}
var repeat_1$1 = repeat;
var roundNumber$1 = {};
var __importDefault$6 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(roundNumber$1, "__esModule", { value: true });
roundNumber$1.roundNumber = void 0;
const bignumber_js_1$4 = __importDefault$6(bignumber.exports);
const expandRoundMode_1$1 = expandRoundMode$1;
function digitCount(numeric2) {
  if (numeric2.isZero()) {
    return 1;
  }
  return Math.floor(Math.log10(numeric2.abs().toNumber()) + 1);
}
function getAbsolutePrecision(numeric2, { precision, significant }) {
  if (significant && precision !== null && precision > 0) {
    return precision - digitCount(numeric2);
  }
  return precision;
}
function roundNumber(numeric2, options) {
  const precision = getAbsolutePrecision(numeric2, options);
  if (precision === null) {
    return numeric2.toString();
  }
  const roundMode = (0, expandRoundMode_1$1.expandRoundMode)(options.roundMode);
  if (precision >= 0) {
    return numeric2.toFixed(precision, roundMode);
  }
  const rounder = Math.pow(10, Math.abs(precision));
  numeric2 = new bignumber_js_1$4.default(numeric2.div(rounder).toFixed(0, roundMode)).times(rounder);
  return numeric2.toString();
}
roundNumber$1.roundNumber = roundNumber;
var __importDefault$5 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(formatNumber$1, "__esModule", { value: true });
formatNumber$1.formatNumber = void 0;
const bignumber_js_1$3 = __importDefault$5(bignumber.exports);
const repeat_1 = __importDefault$5(repeat_1$1);
const roundNumber_1$2 = roundNumber$1;
function replaceInFormat(format, { formattedNumber, unit }) {
  return format.replace("%n", formattedNumber).replace("%u", unit);
}
function computeSignificand({ significand, whole, precision }) {
  if (whole === "0" || precision === null) {
    return significand;
  }
  const limit = Math.max(0, precision - whole.length);
  return (significand !== null && significand !== void 0 ? significand : "").substr(0, limit);
}
function formatNumber(input, options) {
  var _a2, _b, _c;
  const originalNumber = new bignumber_js_1$3.default(input);
  if (options.raise && !originalNumber.isFinite()) {
    throw new Error(`"${input}" is not a valid numeric value`);
  }
  const roundedNumber = (0, roundNumber_1$2.roundNumber)(originalNumber, options);
  const numeric2 = new bignumber_js_1$3.default(roundedNumber);
  const isNegative = numeric2.lt(0);
  const isZero = numeric2.isZero();
  let [whole, significand] = roundedNumber.split(".");
  const buffer = [];
  let formattedNumber;
  const positiveFormat = (_a2 = options.format) !== null && _a2 !== void 0 ? _a2 : "%n";
  const negativeFormat = (_b = options.negativeFormat) !== null && _b !== void 0 ? _b : `-${positiveFormat}`;
  const format = isNegative && !isZero ? negativeFormat : positiveFormat;
  whole = whole.replace("-", "");
  while (whole.length > 0) {
    buffer.unshift(whole.substr(Math.max(0, whole.length - 3), 3));
    whole = whole.substr(0, whole.length - 3);
  }
  whole = buffer.join("");
  formattedNumber = buffer.join(options.delimiter);
  if (options.significant) {
    significand = computeSignificand({
      whole,
      significand,
      precision: options.precision
    });
  } else {
    significand = significand !== null && significand !== void 0 ? significand : (0, repeat_1.default)("0", (_c = options.precision) !== null && _c !== void 0 ? _c : 0);
  }
  if (options.stripInsignificantZeros && significand) {
    significand = significand.replace(/0+$/, "");
  }
  if (originalNumber.isNaN()) {
    formattedNumber = input.toString();
  }
  if (significand && originalNumber.isFinite()) {
    formattedNumber += (options.separator || ".") + significand;
  }
  return replaceInFormat(format, {
    formattedNumber,
    unit: options.unit
  });
}
formatNumber$1.formatNumber = formatNumber;
var getFullScope$1 = {};
Object.defineProperty(getFullScope$1, "__esModule", { value: true });
getFullScope$1.getFullScope = void 0;
function getFullScope(i18n2, scope, options) {
  let result = "";
  if (scope instanceof String || typeof scope === "string") {
    result = scope;
  }
  if (scope instanceof Array) {
    result = scope.join(i18n2.defaultSeparator);
  }
  if (options.scope) {
    result = [options.scope, result].join(i18n2.defaultSeparator);
  }
  return result;
}
getFullScope$1.getFullScope = getFullScope;
var inferType$1 = {};
Object.defineProperty(inferType$1, "__esModule", { value: true });
inferType$1.inferType = void 0;
function inferType(instance) {
  var _a2, _b;
  if (instance === null) {
    return "null";
  }
  const type2 = typeof instance;
  if (type2 !== "object") {
    return type2;
  }
  return ((_b = (_a2 = instance === null || instance === void 0 ? void 0 : instance.constructor) === null || _a2 === void 0 ? void 0 : _a2.name) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "object";
}
inferType$1.inferType = inferType;
var interpolate$1 = {};
Object.defineProperty(interpolate$1, "__esModule", { value: true });
interpolate$1.interpolate = void 0;
const isSet_1$2 = isSet$1;
function interpolate(i18n2, message, options) {
  options = Object.keys(options).reduce((buffer, key) => {
    buffer[i18n2.transformKey(key)] = options[key];
    return buffer;
  }, {});
  const matches = message.match(i18n2.placeholder);
  if (!matches) {
    return message;
  }
  while (matches.length) {
    let value;
    const placeholder = matches.shift();
    const name2 = placeholder.replace(i18n2.placeholder, "$1");
    if ((0, isSet_1$2.isSet)(options[name2])) {
      value = options[name2].toString().replace(/\$/gm, "_#$#_");
    } else if (name2 in options) {
      value = i18n2.nullPlaceholder(i18n2, placeholder, message, options);
    } else {
      value = i18n2.missingPlaceholder(i18n2, placeholder, message, options);
    }
    const regex = new RegExp(placeholder.replace(/\{/gm, "\\{").replace(/\}/gm, "\\}"));
    message = message.replace(regex, value);
  }
  return message.replace(/_#\$#_/g, "$");
}
interpolate$1.interpolate = interpolate;
var lookup$1 = {};
Object.defineProperty(lookup$1, "__esModule", { value: true });
lookup$1.lookup = void 0;
const isSet_1$1 = isSet$1;
const getFullScope_1$1 = getFullScope$1;
const inferType_1$1 = inferType$1;
function lookup(i18n2, scope, options = {}) {
  options = Object.assign({}, options);
  const locale2 = "locale" in options ? options.locale : i18n2.locale;
  const localeType = (0, inferType_1$1.inferType)(locale2);
  const locales = i18n2.locales.get(localeType === "string" ? locale2 : typeof locale2).slice();
  const keys2 = (0, getFullScope_1$1.getFullScope)(i18n2, scope, options).split(i18n2.defaultSeparator).map((component) => i18n2.transformKey(component));
  const entries = locales.map((locale3) => keys2.reduce((path, key) => path && path[key], i18n2.translations[locale3]));
  entries.push(options.defaultValue);
  return entries.find((entry) => (0, isSet_1$1.isSet)(entry));
}
lookup$1.lookup = lookup;
var numberToDelimited$1 = {};
var __importDefault$4 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(numberToDelimited$1, "__esModule", { value: true });
numberToDelimited$1.numberToDelimited = void 0;
const bignumber_js_1$2 = __importDefault$4(bignumber.exports);
function numberToDelimited(input, options) {
  const numeric2 = new bignumber_js_1$2.default(input);
  if (!numeric2.isFinite()) {
    return input.toString();
  }
  if (!options.delimiterPattern.global) {
    throw new Error(`options.delimiterPattern must be a global regular expression; received ${options.delimiterPattern}`);
  }
  let [left2, right2] = numeric2.toString().split(".");
  left2 = left2.replace(options.delimiterPattern, (digitToDelimiter) => `${digitToDelimiter}${options.delimiter}`);
  return [left2, right2].filter(Boolean).join(options.separator);
}
numberToDelimited$1.numberToDelimited = numberToDelimited;
var numberToHuman$1 = {};
function arrayPush$2(array, values) {
  var index2 = -1, length = values.length, offset2 = array.length;
  while (++index2 < length) {
    array[offset2 + index2] = values[index2];
  }
  return array;
}
var _arrayPush = arrayPush$2;
var Symbol$2 = _Symbol, isArguments = isArguments_1, isArray$6 = isArray_1;
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : void 0;
function isFlattenable$1(value) {
  return isArray$6(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1;
var arrayPush$1 = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$1(array, depth, predicate, isStrict, result) {
  var index2 = -1, length = array.length;
  predicate || (predicate = isFlattenable);
  result || (result = []);
  while (++index2 < length) {
    var value = array[index2];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        baseFlatten$1(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}
var _baseFlatten = baseFlatten$1;
function arraySome$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length;
  while (++index2 < length) {
    if (predicate(array[index2], index2, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
var SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index2 = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$3 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index2 < arrLength) {
    var arrValue = array[index2], othValue = other[index2];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index2, other, array, stack) : customizer(arrValue, othValue, index2, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
function mapToArray$1(map) {
  var index2 = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index2] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
var Symbol$1 = _Symbol, Uint8Array$1 = _Uint8Array, eq$3 = eq_1$1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2;
var boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", mapTag$1 = "[object Map]", numberTag = "[object Number]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array$1(object), new Uint8Array$1(other))) {
        return false;
      }
      return true;
    case boolTag:
    case dateTag:
    case numberTag:
      return eq$3(+object, +other);
    case errorTag:
      return object.name == other.name && object.message == other.message;
    case regexpTag:
    case stringTag:
      return object == other + "";
    case mapTag$1:
      var convert = mapToArray;
    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
var arrayPush = _arrayPush, isArray$5 = isArray_1;
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$5(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array, predicate) {
  var index2 = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index2 < length) {
    var value = array[index2];
    if (predicate(value, index2, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter, stubArray = stubArray_1;
var objectProto$3 = Object.prototype;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$2 = isArrayLike_1;
function keys$4(object) {
  return isArrayLike$2(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$4;
var baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$3 = keys_1;
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$3, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$3 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index2 = objLength;
  while (index2--) {
    var key = objProps[index2];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index2 < objLength) {
    key = objProps[index2];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$2 = _getNative, root$2 = _root;
var DataView$1 = getNative$2(root$2, "DataView");
var _DataView = DataView$1;
var getNative$1 = _getNative, root$1 = _root;
var Promise$2 = getNative$1(root$1, "Promise");
var _Promise = Promise$2;
var getNative = _getNative, root = _root;
var WeakMap$2 = getNative(root, "WeakMap");
var _WeakMap = WeakMap$2;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap$1 = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap$1);
var getTag$1 = baseGetTag;
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap$1 && getTag$1(new WeakMap$1()) != weakMapTag) {
  getTag$1 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray$4 = isArray_1, isBuffer$1 = isBuffer$4.exports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG$2 = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$4(object), othIsArr = isArray$4(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer$1(object)) {
    if (!isBuffer$1(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack$1());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}
var _baseIsEqual = baseIsEqual$2;
var Stack = _Stack, baseIsEqual$1 = _baseIsEqual;
var COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(object, source2, matchData, customizer) {
  var index2 = matchData.length, length = index2, noCustomizer = !customizer;
  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index2--) {
    var data2 = matchData[index2];
    if (noCustomizer && data2[2] ? data2[1] !== object[data2[0]] : !(data2[0] in object)) {
      return false;
    }
  }
  while (++index2 < length) {
    data2 = matchData[index2];
    var key = data2[0], objValue = object[key], srcValue = data2[1];
    if (noCustomizer && data2[2]) {
      if (objValue === void 0 && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack();
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source2, stack);
      }
      if (!(result === void 0 ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack) : result)) {
        return false;
      }
    }
  }
  return true;
}
var _baseIsMatch = baseIsMatch$1;
var isObject$1 = isObject_1;
function isStrictComparable$2(value) {
  return value === value && !isObject$1(value);
}
var _isStrictComparable = isStrictComparable$2;
var isStrictComparable$1 = _isStrictComparable, keys$2 = keys_1;
function getMatchData$1(object) {
  var result = keys$2(object), length = result.length;
  while (length--) {
    var key = result[length], value = object[key];
    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2;
var baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(source2) {
  var matchData = getMatchData(source2);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source2 || baseIsMatch(object, source2, matchData);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}
var _baseHasIn = baseHasIn$1;
var baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}
var hasIn_1 = hasIn$1;
var baseIsEqual = _baseIsEqual, get$2 = get_1$1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey;
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get$2(object, path);
    return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function baseProperty$1(key) {
  return function(object) {
    return object == null ? void 0 : object[key];
  };
}
var _baseProperty = baseProperty$1;
var baseGet$1 = _baseGet;
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}
var _basePropertyDeep = basePropertyDeep$1;
var baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
var property_1 = property$1;
var baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$1 = identity_1, isArray$3 = isArray_1, property = property_1;
function baseIteratee$1(value) {
  if (typeof value == "function") {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == "object") {
    return isArray$3(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
  }
  return property(value);
}
var _baseIteratee = baseIteratee$1;
var baseFor = _baseFor, keys$1 = keys_1;
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys$1);
}
var _baseForOwn = baseForOwn$1;
var isArrayLike$1 = isArrayLike_1;
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$1(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length, index2 = fromRight ? length : -1, iterable = Object(collection);
    while (fromRight ? index2-- : ++index2 < length) {
      if (iteratee(iterable[index2], index2, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}
var _createBaseEach = createBaseEach$1;
var baseForOwn = _baseForOwn, createBaseEach = _createBaseEach;
var baseEach$1 = createBaseEach(baseForOwn);
var _baseEach = baseEach$1;
var baseEach = _baseEach, isArrayLike = isArrayLike_1;
function baseMap$1(collection, iteratee) {
  var index2 = -1, result = isArrayLike(collection) ? Array(collection.length) : [];
  baseEach(collection, function(value, key, collection2) {
    result[++index2] = iteratee(value, key, collection2);
  });
  return result;
}
var _baseMap = baseMap$1;
function baseSortBy$1(array, comparer) {
  var length = array.length;
  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}
var _baseSortBy = baseSortBy$1;
var isSymbol = isSymbol_1;
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== void 0, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
    var othIsDefined = other !== void 0, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
    if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
      return 1;
    }
    if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}
var _compareAscending = compareAscending$1;
var compareAscending = _compareAscending;
function compareMultiple$1(object, other, orders) {
  var index2 = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
  while (++index2 < length) {
    var result = compareAscending(objCriteria[index2], othCriteria[index2]);
    if (result) {
      if (index2 >= ordersLength) {
        return result;
      }
      var order2 = orders[index2];
      return result * (order2 == "desc" ? -1 : 1);
    }
  }
  return object.index - other.index;
}
var _compareMultiple = compareMultiple$1;
var arrayMap = _arrayMap, baseGet = _baseGet, baseIteratee = _baseIteratee, baseMap = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity = identity_1, isArray$2 = isArray_1;
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray$2(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }
  var index2 = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
  var result = baseMap(collection, function(value, key, collection2) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { "criteria": criteria, "index": ++index2, "value": value };
  });
  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}
var _baseOrderBy = baseOrderBy$1;
var baseFlatten = _baseFlatten, baseOrderBy = _baseOrderBy, baseRest = _baseRest, isIterateeCall$1 = _isIterateeCall;
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall$1(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall$1(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});
var sortBy_1$1 = sortBy;
function baseZipObject$1(props2, values, assignFunc) {
  var index2 = -1, length = props2.length, valsLength = values.length, result = {};
  while (++index2 < length) {
    var value = index2 < valsLength ? values[index2] : void 0;
    assignFunc(result, props2[index2], value);
  }
  return result;
}
var _baseZipObject = baseZipObject$1;
var assignValue = _assignValue, baseZipObject = _baseZipObject;
function zipObject(props2, values) {
  return baseZipObject(props2 || [], values || [], assignValue);
}
var zipObject_1$1 = zipObject;
var __importDefault$3 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(numberToHuman$1, "__esModule", { value: true });
numberToHuman$1.numberToHuman = void 0;
const bignumber_js_1$1 = __importDefault$3(bignumber.exports);
const sortBy_1 = __importDefault$3(sortBy_1$1);
const zipObject_1 = __importDefault$3(zipObject_1$1);
const getFullScope_1 = getFullScope$1;
const lookup_1$1 = lookup$1;
const roundNumber_1$1 = roundNumber$1;
const inferType_1 = inferType$1;
const DECIMAL_UNITS = {
  "0": "unit",
  "1": "ten",
  "2": "hundred",
  "3": "thousand",
  "6": "million",
  "9": "billion",
  "12": "trillion",
  "15": "quadrillion",
  "-1": "deci",
  "-2": "centi",
  "-3": "mili",
  "-6": "micro",
  "-9": "nano",
  "-12": "pico",
  "-15": "femto"
};
const INVERTED_DECIMAL_UNITS = (0, zipObject_1.default)(Object.values(DECIMAL_UNITS), Object.keys(DECIMAL_UNITS).map((key) => parseInt(key, 10)));
function numberToHuman(i18n2, input, options) {
  const roundOptions = {
    roundMode: options.roundMode,
    precision: options.precision,
    significant: options.significant
  };
  let units;
  if ((0, inferType_1.inferType)(options.units) === "string") {
    const scope = options.units;
    units = (0, lookup_1$1.lookup)(i18n2, scope);
    if (!units) {
      throw new Error(`The scope "${i18n2.locale}${i18n2.defaultSeparator}${(0, getFullScope_1.getFullScope)(i18n2, scope, {})}" couldn't be found`);
    }
  } else {
    units = options.units;
  }
  let formattedNumber = (0, roundNumber_1$1.roundNumber)(new bignumber_js_1$1.default(input), roundOptions);
  const unitExponents = (units2) => (0, sortBy_1.default)(Object.keys(units2).map((name2) => INVERTED_DECIMAL_UNITS[name2]), (numeric2) => numeric2 * -1);
  const calculateExponent = (num, units2) => {
    const exponent2 = num.isZero() ? 0 : Math.floor(Math.log10(num.abs().toNumber()));
    return unitExponents(units2).find((exp) => exponent2 >= exp) || 0;
  };
  const determineUnit = (units2, exponent2) => {
    const expName = DECIMAL_UNITS[exponent2.toString()];
    return units2[expName] || "";
  };
  const exponent = calculateExponent(new bignumber_js_1$1.default(formattedNumber), units);
  const unit = determineUnit(units, exponent);
  formattedNumber = (0, roundNumber_1$1.roundNumber)(new bignumber_js_1$1.default(formattedNumber).div(Math.pow(10, exponent)), roundOptions);
  if (options.stripInsignificantZeros) {
    let [whole, significand] = formattedNumber.split(".");
    significand = (significand || "").replace(/0+$/, "");
    formattedNumber = whole;
    if (significand) {
      formattedNumber += `${options.separator}${significand}`;
    }
  }
  return options.format.replace("%n", formattedNumber || "0").replace("%u", unit).trim();
}
numberToHuman$1.numberToHuman = numberToHuman;
var numberToHumanSize$1 = {};
var __importDefault$2 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(numberToHumanSize$1, "__esModule", { value: true });
numberToHumanSize$1.numberToHumanSize = void 0;
const bignumber_js_1 = __importDefault$2(bignumber.exports);
const roundNumber_1 = roundNumber$1;
const expandRoundMode_1 = expandRoundMode$1;
const STORAGE_UNITS = ["byte", "kb", "mb", "gb", "tb", "pb", "eb"];
function numberToHumanSize(i18n2, input, options) {
  const roundMode = (0, expandRoundMode_1.expandRoundMode)(options.roundMode);
  const base = 1024;
  const num = new bignumber_js_1.default(input).abs();
  const smallerThanBase = num.lt(base);
  let numberToBeFormatted;
  const computeExponent = (numeric2, units) => {
    const max2 = units.length - 1;
    const exp = new bignumber_js_1.default(Math.log(numeric2.toNumber())).div(Math.log(base)).integerValue(bignumber_js_1.default.ROUND_DOWN).toNumber();
    return Math.min(max2, exp);
  };
  const storageUnitKey = (units) => {
    const keyEnd = smallerThanBase ? "byte" : units[exponent];
    return `number.human.storage_units.units.${keyEnd}`;
  };
  const exponent = computeExponent(num, STORAGE_UNITS);
  if (smallerThanBase) {
    numberToBeFormatted = num.integerValue();
  } else {
    numberToBeFormatted = new bignumber_js_1.default((0, roundNumber_1.roundNumber)(num.div(Math.pow(base, exponent)), {
      significant: options.significant,
      precision: options.precision,
      roundMode: options.roundMode
    }));
  }
  const format = i18n2.translate("number.human.storage_units.format", {
    defaultValue: "%n %u"
  });
  const unit = i18n2.translate(storageUnitKey(STORAGE_UNITS), {
    count: num.integerValue().toNumber()
  });
  let formattedNumber = numberToBeFormatted.toFixed(options.precision, roundMode);
  if (options.stripInsignificantZeros) {
    formattedNumber = formattedNumber.replace(/(\..*?)0+$/, "$1").replace(/\.$/, "");
  }
  return format.replace("%n", formattedNumber).replace("%u", unit);
}
numberToHumanSize$1.numberToHumanSize = numberToHumanSize;
var parseDate$1 = {};
Object.defineProperty(parseDate$1, "__esModule", { value: true });
parseDate$1.parseDate = void 0;
function parseDate(input) {
  if (input instanceof Date) {
    return input;
  }
  if (typeof input === "number") {
    const date2 = new Date();
    date2.setTime(input);
    return date2;
  }
  const matches = new String(input).match(/(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2})(?:[.,](\d{1,3}))?)?(Z|\+00:?00)?/);
  if (matches) {
    const parts = matches.slice(1, 8).map((match) => parseInt(match, 10) || 0);
    parts[1] -= 1;
    const [year, month, day, hour, minute, second, milliseconds] = parts;
    const timezone = matches[8];
    if (timezone) {
      return new Date(Date.UTC(year, month, day, hour, minute, second, milliseconds));
    } else {
      return new Date(year, month, day, hour, minute, second, milliseconds);
    }
  }
  if (input.match(/([A-Z][a-z]{2}) ([A-Z][a-z]{2}) (\d+) (\d+:\d+:\d+) ([+-]\d+) (\d+)/)) {
    const date2 = new Date();
    date2.setTime(Date.parse([RegExp.$1, RegExp.$2, RegExp.$3, RegExp.$6, RegExp.$4, RegExp.$5].join(" ")));
  }
  const date = new Date();
  date.setTime(Date.parse(input));
  return date;
}
parseDate$1.parseDate = parseDate;
var pluralize$1 = {};
Object.defineProperty(pluralize$1, "__esModule", { value: true });
pluralize$1.pluralize = void 0;
const isSet_1 = isSet$1;
const lookup_1 = lookup$1;
function pluralize({ i18n: i18n2, count, scope, options, baseScope }) {
  options = Object.assign({}, options);
  let translations2;
  let message;
  if (typeof scope === "object" && scope) {
    translations2 = scope;
  } else {
    translations2 = (0, lookup_1.lookup)(i18n2, scope, options);
  }
  if (!translations2) {
    return i18n2.missingTranslation.get(scope, options);
  }
  const pluralizer = i18n2.pluralization.get(options.locale);
  const keys2 = pluralizer(i18n2, count);
  const missingKeys = [];
  while (keys2.length) {
    const key = keys2.shift();
    if ((0, isSet_1.isSet)(translations2[key])) {
      message = translations2[key];
      break;
    }
    missingKeys.push(key);
  }
  if (!(0, isSet_1.isSet)(message)) {
    return i18n2.missingTranslation.get(baseScope.split(i18n2.defaultSeparator).concat([missingKeys[0]]), options);
  }
  options.count = count;
  return i18n2.interpolate(i18n2, message, options);
}
pluralize$1.pluralize = pluralize;
var strftime$1 = {};
Object.defineProperty(strftime$1, "__esModule", { value: true });
strftime$1.strftime = void 0;
const DEFAULT_OPTIONS$1 = {
  meridian: { am: "AM", pm: "PM" },
  dayNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  abbrDayNames: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  monthNames: [
    null,
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  abbrMonthNames: [
    null,
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
};
function strftime(date, format, options = {}) {
  const { abbrDayNames, dayNames, abbrMonthNames, monthNames, meridian: AM_PM } = Object.assign(Object.assign({}, DEFAULT_OPTIONS$1), options);
  if (isNaN(date.getTime())) {
    throw new Error("strftime() requires a valid date object, but received an invalid date.");
  }
  const weekDay = date.getDay();
  const day = date.getDate();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const hour = date.getHours();
  let hour12 = hour;
  const meridian = hour > 11 ? "pm" : "am";
  const secs = date.getSeconds();
  const mins = date.getMinutes();
  const offset2 = date.getTimezoneOffset();
  const absOffsetHours = Math.floor(Math.abs(offset2 / 60));
  const absOffsetMinutes = Math.abs(offset2) - absOffsetHours * 60;
  const timezoneoffset = (offset2 > 0 ? "-" : "+") + (absOffsetHours.toString().length < 2 ? "0" + absOffsetHours : absOffsetHours) + (absOffsetMinutes.toString().length < 2 ? "0" + absOffsetMinutes : absOffsetMinutes);
  if (hour12 > 12) {
    hour12 = hour12 - 12;
  } else if (hour12 === 0) {
    hour12 = 12;
  }
  format = format.replace("%a", abbrDayNames[weekDay]);
  format = format.replace("%A", dayNames[weekDay]);
  format = format.replace("%b", abbrMonthNames[month]);
  format = format.replace("%B", monthNames[month]);
  format = format.replace("%d", day.toString().padStart(2, "0"));
  format = format.replace("%e", day.toString());
  format = format.replace("%-d", day.toString());
  format = format.replace("%H", hour.toString().padStart(2, "0"));
  format = format.replace("%-H", hour.toString());
  format = format.replace("%k", hour.toString());
  format = format.replace("%I", hour12.toString().padStart(2, "0"));
  format = format.replace("%-I", hour12.toString());
  format = format.replace("%l", hour12.toString());
  format = format.replace("%m", month.toString().padStart(2, "0"));
  format = format.replace("%-m", month.toString());
  format = format.replace("%M", mins.toString().padStart(2, "0"));
  format = format.replace("%-M", mins.toString());
  format = format.replace("%p", AM_PM[meridian]);
  format = format.replace("%P", AM_PM[meridian].toLowerCase());
  format = format.replace("%S", secs.toString().padStart(2, "0"));
  format = format.replace("%-S", secs.toString());
  format = format.replace("%w", weekDay.toString());
  format = format.replace("%y", year.toString().padStart(2, "0").substr(-2));
  format = format.replace("%-y", year.toString().padStart(2, "0").substr(-2).replace(/^0+/, ""));
  format = format.replace("%Y", year.toString());
  format = format.replace(/%z/i, timezoneoffset);
  return format;
}
strftime$1.strftime = strftime;
var timeAgoInWords$1 = {};
var nativeCeil = Math.ceil, nativeMax = Math.max;
function baseRange$1(start2, end2, step, fromRight) {
  var index2 = -1, length = nativeMax(nativeCeil((end2 - start2) / (step || 1)), 0), result = Array(length);
  while (length--) {
    result[fromRight ? length : ++index2] = start2;
    start2 += step;
  }
  return result;
}
var _baseRange = baseRange$1;
var baseRange = _baseRange, isIterateeCall = _isIterateeCall, toFinite = toFinite_1;
function createRange$2(fromRight) {
  return function(start2, end2, step) {
    if (step && typeof step != "number" && isIterateeCall(start2, end2, step)) {
      end2 = step = void 0;
    }
    start2 = toFinite(start2);
    if (end2 === void 0) {
      end2 = start2;
      start2 = 0;
    } else {
      end2 = toFinite(end2);
    }
    step = step === void 0 ? start2 < end2 ? 1 : -1 : toFinite(step);
    return baseRange(start2, end2, step, fromRight);
  };
}
var _createRange = createRange$2;
var createRange$1 = _createRange;
var range$1 = createRange$1();
var range_1$1 = range$1;
var __importDefault$1 = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(timeAgoInWords$1, "__esModule", { value: true });
timeAgoInWords$1.timeAgoInWords = void 0;
const range_1 = __importDefault$1(range_1$1);
const parseDate_1 = parseDate$1;
const within$1 = (start2, end2, actual) => actual >= start2 && actual <= end2;
function timeAgoInWords(i18n2, fromTime, toTime, options = {}) {
  const scope = options.scope || "datetime.distance_in_words";
  const t2 = (name2, count = 0) => i18n2.t(name2, { count, scope });
  fromTime = (0, parseDate_1.parseDate)(fromTime);
  toTime = (0, parseDate_1.parseDate)(toTime);
  let fromInSeconds = fromTime.getTime() / 1e3;
  let toInSeconds = toTime.getTime() / 1e3;
  if (fromInSeconds > toInSeconds) {
    [fromTime, toTime, fromInSeconds, toInSeconds] = [
      toTime,
      fromTime,
      toInSeconds,
      fromInSeconds
    ];
  }
  const distanceInSeconds = Math.round(toInSeconds - fromInSeconds);
  const distanceInMinutes = Math.round((toInSeconds - fromInSeconds) / 60);
  const distanceInHours = distanceInMinutes / 60;
  const distanceInDays = distanceInHours / 24;
  const distanceInHoursRounded = Math.round(distanceInMinutes / 60);
  const distanceInDaysRounded = Math.round(distanceInDays);
  const distanceInMonthsRounded = Math.round(distanceInDaysRounded / 30);
  if (within$1(0, 1, distanceInMinutes)) {
    if (!options.includeSeconds) {
      return distanceInMinutes === 0 ? t2("less_than_x_minutes", 1) : t2("x_minutes", distanceInMinutes);
    }
    if (within$1(0, 4, distanceInSeconds)) {
      return t2("less_than_x_seconds", 5);
    }
    if (within$1(5, 9, distanceInSeconds)) {
      return t2("less_than_x_seconds", 10);
    }
    if (within$1(10, 19, distanceInSeconds)) {
      return t2("less_than_x_seconds", 20);
    }
    if (within$1(20, 39, distanceInSeconds)) {
      return t2("half_a_minute");
    }
    if (within$1(40, 59, distanceInSeconds)) {
      return t2("less_than_x_minutes", 1);
    }
    return t2("x_minutes", 1);
  }
  if (within$1(2, 44, distanceInMinutes)) {
    return t2("x_minutes", distanceInMinutes);
  }
  if (within$1(45, 89, distanceInMinutes)) {
    return t2("about_x_hours", 1);
  }
  if (within$1(90, 1439, distanceInMinutes)) {
    return t2("about_x_hours", distanceInHoursRounded);
  }
  if (within$1(1440, 2519, distanceInMinutes)) {
    return t2("x_days", 1);
  }
  if (within$1(2520, 43199, distanceInMinutes)) {
    return t2("x_days", distanceInDaysRounded);
  }
  if (within$1(43200, 86399, distanceInMinutes)) {
    return t2("about_x_months", Math.round(distanceInMinutes / 43200));
  }
  if (within$1(86400, 525599, distanceInMinutes)) {
    return t2("x_months", distanceInMonthsRounded);
  }
  let fromYear = fromTime.getFullYear();
  if (fromTime.getMonth() + 1 >= 3) {
    fromYear += 1;
  }
  let toYear = toTime.getFullYear();
  if (toTime.getMonth() + 1 < 3) {
    toYear -= 1;
  }
  const leapYears = fromYear > toYear ? 0 : (0, range_1.default)(fromYear, toYear).filter((year) => new Date(year, 1, 29).getMonth() == 1).length;
  const minutesInYear = 525600;
  const minuteOffsetForLeapYear = leapYears * 1440;
  const minutesWithOffset = distanceInMinutes - minuteOffsetForLeapYear;
  const distanceInYears = Math.trunc(minutesWithOffset / minutesInYear);
  const diff2 = parseFloat((minutesWithOffset / minutesInYear - distanceInYears).toPrecision(3));
  if (diff2 < 0.25) {
    return t2("about_x_years", distanceInYears);
  }
  if (diff2 < 0.75) {
    return t2("over_x_years", distanceInYears);
  }
  return t2("almost_x_years", distanceInYears + 1);
}
timeAgoInWords$1.timeAgoInWords = timeAgoInWords;
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.timeAgoInWords = exports.strftime = exports.roundNumber = exports.pluralize = exports.parseDate = exports.numberToHumanSize = exports.numberToHuman = exports.numberToDelimited = exports.lookup = exports.isSet = exports.interpolate = exports.inferType = exports.getFullScope = exports.formatNumber = exports.expandRoundMode = exports.createTranslationOptions = exports.camelCaseKeys = void 0;
  var camelCaseKeys_1 = camelCaseKeys$1;
  Object.defineProperty(exports, "camelCaseKeys", { enumerable: true, get: function() {
    return camelCaseKeys_1.camelCaseKeys;
  } });
  var createTranslationOptions_1 = createTranslationOptions$1;
  Object.defineProperty(exports, "createTranslationOptions", { enumerable: true, get: function() {
    return createTranslationOptions_1.createTranslationOptions;
  } });
  var expandRoundMode_12 = expandRoundMode$1;
  Object.defineProperty(exports, "expandRoundMode", { enumerable: true, get: function() {
    return expandRoundMode_12.expandRoundMode;
  } });
  var formatNumber_1 = formatNumber$1;
  Object.defineProperty(exports, "formatNumber", { enumerable: true, get: function() {
    return formatNumber_1.formatNumber;
  } });
  var getFullScope_12 = getFullScope$1;
  Object.defineProperty(exports, "getFullScope", { enumerable: true, get: function() {
    return getFullScope_12.getFullScope;
  } });
  var inferType_12 = inferType$1;
  Object.defineProperty(exports, "inferType", { enumerable: true, get: function() {
    return inferType_12.inferType;
  } });
  var interpolate_1 = interpolate$1;
  Object.defineProperty(exports, "interpolate", { enumerable: true, get: function() {
    return interpolate_1.interpolate;
  } });
  var isSet_12 = isSet$1;
  Object.defineProperty(exports, "isSet", { enumerable: true, get: function() {
    return isSet_12.isSet;
  } });
  var lookup_12 = lookup$1;
  Object.defineProperty(exports, "lookup", { enumerable: true, get: function() {
    return lookup_12.lookup;
  } });
  var numberToDelimited_1 = numberToDelimited$1;
  Object.defineProperty(exports, "numberToDelimited", { enumerable: true, get: function() {
    return numberToDelimited_1.numberToDelimited;
  } });
  var numberToHuman_1 = numberToHuman$1;
  Object.defineProperty(exports, "numberToHuman", { enumerable: true, get: function() {
    return numberToHuman_1.numberToHuman;
  } });
  var numberToHumanSize_1 = numberToHumanSize$1;
  Object.defineProperty(exports, "numberToHumanSize", { enumerable: true, get: function() {
    return numberToHumanSize_1.numberToHumanSize;
  } });
  var parseDate_12 = parseDate$1;
  Object.defineProperty(exports, "parseDate", { enumerable: true, get: function() {
    return parseDate_12.parseDate;
  } });
  var pluralize_1 = pluralize$1;
  Object.defineProperty(exports, "pluralize", { enumerable: true, get: function() {
    return pluralize_1.pluralize;
  } });
  var roundNumber_12 = roundNumber$1;
  Object.defineProperty(exports, "roundNumber", { enumerable: true, get: function() {
    return roundNumber_12.roundNumber;
  } });
  var strftime_1 = strftime$1;
  Object.defineProperty(exports, "strftime", { enumerable: true, get: function() {
    return strftime_1.strftime;
  } });
  var timeAgoInWords_1 = timeAgoInWords$1;
  Object.defineProperty(exports, "timeAgoInWords", { enumerable: true, get: function() {
    return timeAgoInWords_1.timeAgoInWords;
  } });
})(helpers);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.MissingTranslation = exports.errorStrategy = exports.messageStrategy = exports.guessStrategy = void 0;
  const helpers_12 = helpers;
  const guessStrategy = function(i18n2, scope) {
    if (scope instanceof Array) {
      scope = scope.join(i18n2.defaultSeparator);
    }
    const message = scope.split(i18n2.defaultSeparator).slice(-1)[0];
    return i18n2.missingTranslationPrefix + message.replace("_", " ").replace(/([a-z])([A-Z])/g, (_match, p1, p2) => `${p1} ${p2.toLowerCase()}`);
  };
  exports.guessStrategy = guessStrategy;
  const messageStrategy = (i18n2, scope, options) => {
    const fullScope = (0, helpers_12.getFullScope)(i18n2, scope, options);
    const locale2 = "locale" in options ? options.locale : i18n2.locale;
    const localeType = (0, helpers_12.inferType)(locale2);
    const fullScopeWithLocale = [
      localeType == "string" ? locale2 : localeType,
      fullScope
    ].join(i18n2.defaultSeparator);
    return `[missing "${fullScopeWithLocale}" translation]`;
  };
  exports.messageStrategy = messageStrategy;
  const errorStrategy = (i18n2, scope, options) => {
    const fullScope = (0, helpers_12.getFullScope)(i18n2, scope, options);
    const fullScopeWithLocale = [i18n2.locale, fullScope].join(i18n2.defaultSeparator);
    throw new Error(`Missing translation: ${fullScopeWithLocale}`);
  };
  exports.errorStrategy = errorStrategy;
  class MissingTranslation2 {
    constructor(i18n2) {
      this.i18n = i18n2;
      this.registry = {};
      this.register("guess", exports.guessStrategy);
      this.register("message", exports.messageStrategy);
      this.register("error", exports.errorStrategy);
    }
    register(name2, strategy) {
      this.registry[name2] = strategy;
    }
    get(scope, options) {
      var _a2;
      return this.registry[(_a2 = options.missingBehavior) !== null && _a2 !== void 0 ? _a2 : this.i18n.missingBehavior](this.i18n, scope, options);
    }
  }
  exports.MissingTranslation = MissingTranslation2;
})(MissingTranslation);
var __awaiter$1 = commonjsGlobal && commonjsGlobal.__awaiter || function(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(I18n$1, "__esModule", { value: true });
I18n$1.I18n = void 0;
const get_1 = __importDefault(get_1$1);
const has_1 = __importDefault(has_1$1);
const merge_1 = __importDefault(merge_1$1);
const Locales_1 = Locales;
const Pluralization_1 = Pluralization;
const MissingTranslation_1 = MissingTranslation;
const helpers_1 = helpers;
const DEFAULT_I18N_OPTIONS = {
  defaultLocale: "en",
  availableLocales: ["en"],
  locale: "en",
  defaultSeparator: ".",
  placeholder: /(?:\{\{|%\{)(.*?)(?:\}\}?)/gm,
  enableFallback: false,
  missingBehavior: "message",
  missingTranslationPrefix: "",
  missingPlaceholder: (_i18n, placeholder) => `[missing "${placeholder}" value]`,
  nullPlaceholder: (i18n2, placeholder, message, options) => i18n2.missingPlaceholder(i18n2, placeholder, message, options),
  transformKey: (key) => key
};
class I18n {
  constructor(translations2 = {}, options = {}) {
    this._locale = DEFAULT_I18N_OPTIONS.locale;
    this._defaultLocale = DEFAULT_I18N_OPTIONS.defaultLocale;
    this._version = 0;
    this.onChangeHandlers = [];
    this.translations = {};
    this.availableLocales = [];
    this.t = this.translate;
    this.p = this.pluralize;
    this.l = this.localize;
    this.distanceOfTimeInWords = this.timeAgoInWords;
    const { locale: locale2, enableFallback, missingBehavior, missingTranslationPrefix, missingPlaceholder, nullPlaceholder, defaultLocale: defaultLocale2, defaultSeparator, placeholder, transformKey } = Object.assign(Object.assign({}, DEFAULT_I18N_OPTIONS), options);
    this.locale = locale2;
    this.defaultLocale = defaultLocale2;
    this.defaultSeparator = defaultSeparator;
    this.enableFallback = enableFallback;
    this.locale = locale2;
    this.missingBehavior = missingBehavior;
    this.missingTranslationPrefix = missingTranslationPrefix;
    this.missingPlaceholder = missingPlaceholder;
    this.nullPlaceholder = nullPlaceholder;
    this.placeholder = placeholder;
    this.pluralization = new Pluralization_1.Pluralization(this);
    this.locales = new Locales_1.Locales(this);
    this.missingTranslation = new MissingTranslation_1.MissingTranslation(this);
    this.transformKey = transformKey;
    this.interpolate = helpers_1.interpolate;
    this.store(translations2);
  }
  store(translations2) {
    (0, merge_1.default)(this.translations, translations2);
    this.hasChanged();
  }
  get locale() {
    return this._locale || this.defaultLocale || "en";
  }
  set locale(newLocale) {
    if (typeof newLocale !== "string") {
      throw new Error(`Expected newLocale to be a string; got ${(0, helpers_1.inferType)(newLocale)}`);
    }
    const changed = this._locale !== newLocale;
    this._locale = newLocale;
    if (changed) {
      this.hasChanged();
    }
  }
  get defaultLocale() {
    return this._defaultLocale || "en";
  }
  set defaultLocale(newLocale) {
    if (typeof newLocale !== "string") {
      throw new Error(`Expected newLocale to be a string; got ${(0, helpers_1.inferType)(newLocale)}`);
    }
    const changed = this._defaultLocale !== newLocale;
    this._defaultLocale = newLocale;
    if (changed) {
      this.hasChanged();
    }
  }
  translate(scope, options) {
    options = Object.assign({}, options);
    const translationOptions = (0, helpers_1.createTranslationOptions)(this, scope, options);
    let translation;
    const hasFoundTranslation = translationOptions.some((translationOption) => {
      if ((0, helpers_1.isSet)(translationOption.scope)) {
        translation = (0, helpers_1.lookup)(this, translationOption.scope, options);
      } else if ((0, helpers_1.isSet)(translationOption.message)) {
        translation = translationOption.message;
      }
      return translation !== void 0 && translation !== null;
    });
    if (!hasFoundTranslation) {
      return this.missingTranslation.get(scope, options);
    }
    if (typeof translation === "string") {
      translation = this.interpolate(this, translation, options);
    } else if (typeof translation === "object" && translation && (0, helpers_1.isSet)(options.count)) {
      translation = (0, helpers_1.pluralize)({
        i18n: this,
        count: options.count || 0,
        scope: translation,
        options,
        baseScope: (0, helpers_1.getFullScope)(this, scope, options)
      });
    }
    if (options && translation instanceof Array) {
      translation = translation.map((entry) => typeof entry === "string" ? (0, helpers_1.interpolate)(this, entry, options) : entry);
    }
    return translation;
  }
  pluralize(count, scope, options) {
    return (0, helpers_1.pluralize)({
      i18n: this,
      count,
      scope,
      options: Object.assign({}, options),
      baseScope: (0, helpers_1.getFullScope)(this, scope, options !== null && options !== void 0 ? options : {})
    });
  }
  localize(type2, value, options) {
    options = Object.assign({}, options);
    if (value === void 0 || value === null) {
      return "";
    }
    switch (type2) {
      case "currency":
        return this.numberToCurrency(value);
      case "number":
        return (0, helpers_1.formatNumber)(value, Object.assign({ delimiter: ",", precision: 3, separator: ".", significant: false, stripInsignificantZeros: false }, (0, helpers_1.lookup)(this, "number.format")));
      case "percentage":
        return this.numberToPercentage(value);
      default: {
        let localizedValue;
        if (type2.match(/^(date|time)/)) {
          localizedValue = this.toTime(type2, value);
        } else {
          localizedValue = value.toString();
        }
        return (0, helpers_1.interpolate)(this, localizedValue, options);
      }
    }
  }
  toTime(scope, input) {
    const date = (0, helpers_1.parseDate)(input);
    const format = (0, helpers_1.lookup)(this, scope);
    if (date.toString().match(/invalid/i)) {
      return date.toString();
    }
    if (!format) {
      return date.toString();
    }
    return this.strftime(date, format);
  }
  numberToCurrency(input, options = {}) {
    return (0, helpers_1.formatNumber)(input, Object.assign(Object.assign(Object.assign({ delimiter: ",", format: "%u%n", precision: 2, separator: ".", significant: false, stripInsignificantZeros: false, unit: "$" }, (0, helpers_1.camelCaseKeys)(this.get("number.format"))), (0, helpers_1.camelCaseKeys)(this.get("number.currency.format"))), options));
  }
  numberToPercentage(input, options = {}) {
    return (0, helpers_1.formatNumber)(input, Object.assign(Object.assign(Object.assign({ delimiter: "", format: "%n%", precision: 3, stripInsignificantZeros: false, separator: ".", significant: false }, (0, helpers_1.camelCaseKeys)(this.get("number.format"))), (0, helpers_1.camelCaseKeys)(this.get("number.percentage.format"))), options));
  }
  numberToHumanSize(input, options = {}) {
    return (0, helpers_1.numberToHumanSize)(this, input, Object.assign(Object.assign(Object.assign({ delimiter: "", precision: 3, significant: true, stripInsignificantZeros: true, units: {
      billion: "Billion",
      million: "Million",
      quadrillion: "Quadrillion",
      thousand: "Thousand",
      trillion: "Trillion",
      unit: ""
    } }, (0, helpers_1.camelCaseKeys)(this.get("number.human.format"))), (0, helpers_1.camelCaseKeys)(this.get("number.human.storage_units"))), options));
  }
  numberToHuman(input, options = {}) {
    return (0, helpers_1.numberToHuman)(this, input, Object.assign(Object.assign(Object.assign({ delimiter: "", separator: ".", precision: 3, significant: true, stripInsignificantZeros: true, format: "%n %u", roundMode: "default", units: {
      billion: "Billion",
      million: "Million",
      quadrillion: "Quadrillion",
      thousand: "Thousand",
      trillion: "Trillion",
      unit: ""
    } }, (0, helpers_1.camelCaseKeys)(this.get("number.human.format"))), (0, helpers_1.camelCaseKeys)(this.get("number.human.decimal_units"))), options));
  }
  numberToRounded(input, options) {
    return (0, helpers_1.formatNumber)(input, Object.assign({ unit: "", precision: 3, significant: false, separator: ".", delimiter: "", stripInsignificantZeros: false }, options));
  }
  numberToDelimited(input, options = {}) {
    return (0, helpers_1.numberToDelimited)(input, Object.assign({ delimiterPattern: /(\d)(?=(\d\d\d)+(?!\d))/g, delimiter: ",", separator: "." }, options));
  }
  withLocale(locale2, callback) {
    return __awaiter$1(this, void 0, void 0, function* () {
      const originalLocale = this.locale;
      try {
        this.locale = locale2;
        yield callback();
      } finally {
        this.locale = originalLocale;
      }
    });
  }
  strftime(date, format, options = {}) {
    return (0, helpers_1.strftime)(date, format, Object.assign(Object.assign(Object.assign({}, (0, helpers_1.camelCaseKeys)((0, helpers_1.lookup)(this, "date"))), { meridian: {
      am: (0, helpers_1.lookup)(this, "time.am") || "AM",
      pm: (0, helpers_1.lookup)(this, "time.pm") || "PM"
    } }), options));
  }
  update(path, override2, options = { strict: false }) {
    if (options.strict && !(0, has_1.default)(this.translations, path)) {
      throw new Error(`The path "${path}" is not currently defined`);
    }
    const currentNode = (0, get_1.default)(this.translations, path);
    const currentType = (0, helpers_1.inferType)(currentNode);
    const overrideType = (0, helpers_1.inferType)(override2);
    if (options.strict && currentType !== overrideType) {
      throw new Error(`The current type for "${path}" is "${currentType}", but you're trying to override it with "${overrideType}"`);
    }
    let newNode;
    if (overrideType === "object") {
      newNode = Object.assign(Object.assign({}, currentNode), override2);
    } else {
      newNode = override2;
    }
    const components = path.split(this.defaultSeparator);
    const prop = components.pop();
    let buffer = this.translations;
    for (const component of components) {
      if (!buffer[component]) {
        buffer[component] = {};
      }
      buffer = buffer[component];
    }
    buffer[prop] = newNode;
    this.hasChanged();
  }
  toSentence(items, options = {}) {
    const { wordsConnector, twoWordsConnector, lastWordConnector } = Object.assign(Object.assign({ wordsConnector: ", ", twoWordsConnector: " and ", lastWordConnector: ", and " }, (0, helpers_1.camelCaseKeys)((0, helpers_1.lookup)(this, "support.array"))), options);
    const size = items.length;
    switch (size) {
      case 0:
        return "";
      case 1:
        return `${items[0]}`;
      case 2:
        return items.join(twoWordsConnector);
      default:
        return [
          items.slice(0, size - 1).join(wordsConnector),
          lastWordConnector,
          items[size - 1]
        ].join("");
    }
  }
  timeAgoInWords(fromTime, toTime, options = {}) {
    return (0, helpers_1.timeAgoInWords)(this, fromTime, toTime, options);
  }
  onChange(callback) {
    this.onChangeHandlers.push(callback);
    return () => {
      this.onChangeHandlers.splice(this.onChangeHandlers.indexOf(callback), 1);
    };
  }
  get version() {
    return this._version;
  }
  formatNumber(input, options) {
    return (0, helpers_1.formatNumber)(input, options);
  }
  get(scope) {
    return (0, helpers_1.lookup)(this, scope);
  }
  runCallbacks() {
    this.onChangeHandlers.forEach((callback) => callback(this));
  }
  hasChanged() {
    this._version += 1;
    this.runCallbacks();
  }
}
I18n$1.I18n = I18n;
var typing = {};
Object.defineProperty(typing, "__esModule", { value: true });
(function(exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(o2, m2, k, k2) {
    if (k2 === void 0)
      k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m2, k);
    if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() {
        return m2[k];
      } };
    }
    Object.defineProperty(o2, k2, desc);
  } : function(o2, m2, k, k2) {
    if (k2 === void 0)
      k2 = k;
    o2[k2] = m2[k];
  });
  var __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(m2, exports2) {
    for (var p in m2)
      if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports2, p))
        __createBinding(exports2, m2, p);
  };
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.useMakePlural = exports.Pluralization = exports.MissingTranslation = exports.Locales = exports.I18n = void 0;
  var I18n_1 = I18n$1;
  Object.defineProperty(exports, "I18n", { enumerable: true, get: function() {
    return I18n_1.I18n;
  } });
  var Locales_12 = Locales;
  Object.defineProperty(exports, "Locales", { enumerable: true, get: function() {
    return Locales_12.Locales;
  } });
  var MissingTranslation_12 = MissingTranslation;
  Object.defineProperty(exports, "MissingTranslation", { enumerable: true, get: function() {
    return MissingTranslation_12.MissingTranslation;
  } });
  var Pluralization_12 = Pluralization;
  Object.defineProperty(exports, "Pluralization", { enumerable: true, get: function() {
    return Pluralization_12.Pluralization;
  } });
  Object.defineProperty(exports, "useMakePlural", { enumerable: true, get: function() {
    return Pluralization_12.useMakePlural;
  } });
  __exportStar(typing, exports);
})(require$1);
var zh = {
  "\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8BF7\u4E3A %{account} \u8D26\u53F7\u8BBE\u7F6E\u5BC6\u7801": "\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8BF7\u4E3A %{account} \u8D26\u53F7\u8BBE\u7F6E\u5BC6\u7801",
  "\u8BBE\u8BA1\u7CFB\u7EDF\u53D1\u5E03\u4E3A\u56E2\u961F\u5E93\uFF0C\u7EDF\u4E00\u7BA1\u7406\uFF0C\u5FEB\u901F\u5BF9\u9F50": "\u8BBE\u8BA1\u7CFB\u7EDF\u53D1\u5E03\u4E3A\u56E2\u961F\u5E93\uFF0C\u7EDF\u4E00\u7BA1\u7406\uFF0C\u5FEB\u901F\u5BF9\u9F50",
  "\u8BF7\u5148\u767B\u5F55": "\u8BF7\u5148\u767B\u5F55",
  "\u521B\u5EFA\u5E76\u590D\u7528\u7EC4\u4EF6\u4E0E\u6837\u5F0F\uFF0C\u4E00\u5904\u4FEE\u6539\uFF0C\u5168\u5C40\u540C\u6B65\uFF0C\u4FDD\u6301\u8BBE\u8BA1\u4E00\u81F4\u6027": "\u521B\u5EFA\u5E76\u590D\u7528\u7EC4\u4EF6\u4E0E\u6837\u5F0F\uFF0C\u4E00\u5904\u4FEE\u6539\uFF0C\u5168\u5C40\u540C\u6B65\uFF0C\u4FDD\u6301\u8BBE\u8BA1\u4E00\u81F4\u6027",
  "\u4E13\u4E1A\u77E2\u91CF\u7F16\u8F91\uFF0C\u667A\u80FD\u8F85\u52A9\u5DE5\u5177\uFF0C\u5B9E\u65F6\u5728\u7EBF\u4EA4\u4ED8": "\u4E13\u4E1A\u77E2\u91CF\u7F16\u8F91\uFF0C\u667A\u80FD\u8F85\u52A9\u5DE5\u5177\uFF0C\u5B9E\u65F6\u5728\u7EBF\u4EA4\u4ED8",
  "\u4F7F\u7528 VS code \u6269\u5C55\uFF0C\u7814\u53D1\u65E0\u9700\u79BB\u5F00\u5F00\u53D1\u73AF\u5883\u5373\u53EF\u83B7\u53D6\u8BBE\u8BA1\u6807\u6CE8": "\u4F7F\u7528 VS code \u6269\u5C55\uFF0C\u7814\u53D1\u65E0\u9700\u79BB\u5F00\u5F00\u53D1\u73AF\u5883\u5373\u53EF\u83B7\u53D6\u8BBE\u8BA1\u6807\u6CE8",
  "\u5B9A\u5236\u6807\u6CE8&\u4EE3\u7801\u7247\u6BB5\u63D2\u4EF6\uFF0C\u81EA\u5B9A\u4E49\u6807\u6CE8\u8BED\u8A00": "\u5B9A\u5236\u6807\u6CE8&\u4EE3\u7801\u7247\u6BB5\u63D2\u4EF6\uFF0C\u81EA\u5B9A\u4E49\u6807\u6CE8\u8BED\u8A00",
  "\u4F7F\u7528MasterGo MCP server \u5C06\u8BBE\u8BA1\u7A3F\u76F4\u63A5\u8F6C\u4EE3\u7801": "\u4F7F\u7528MasterGo MCP server \u5C06\u8BBE\u8BA1\u7A3F\u76F4\u63A5\u8F6C\u4EE3\u7801",
  "\u52A8\u6001\u9762\u677F\u3001\u9AD8\u7EA7\u8868\u683C\u3001\u9AD8\u7EA7\u56FE\u8868\u3001\u53EF\u4EA4\u4E92\u63A7\u4EF6\u3001\u4EA4\u4E92\u6CE8\u91CA\u7B49\u80FD\u529B": "\u52A8\u6001\u9762\u677F\u3001\u9AD8\u7EA7\u8868\u683C\u3001\u9AD8\u7EA7\u56FE\u8868\u3001\u53EF\u4EA4\u4E92\u63A7\u4EF6\u3001\u4EA4\u4E92\u6CE8\u91CA\u7B49\u80FD\u529B",
  "\u4EA7\u54C1\u76F4\u63A5\u8C03\u7528\u8BBE\u8BA1\u7EC4\u4EF6\u5E93\uFF0C\u9AD8\u6548\u751F\u6210\u9AD8\u4FDD\u771F\u4E1A\u52A1\u539F\u578B": "\u4EA7\u54C1\u76F4\u63A5\u8C03\u7528\u8BBE\u8BA1\u7EC4\u4EF6\u5E93\uFF0C\u9AD8\u6548\u751F\u6210\u9AD8\u4FDD\u771F\u4E1A\u52A1\u539F\u578B",
  "\u6D77\u91CF\u6A21\u7248\u8D44\u6E90\u548CElement\u3001Ant design\u7B49\u5927\u5382\u8D44\u6E90\u5E93": "\u6D77\u91CF\u6A21\u7248\u8D44\u6E90\u548CElement\u3001Ant design\u7B49\u5927\u5382\u8D44\u6E90\u5E93",
  "\u4EA7\u8BBE\u5DE5\u5177\u4E00\u4F53\u5316\uFF0C\u4E91\u7AEF\u7EDF\u4E00\u7BA1\u7406\u539F\u578B\u548C\u8BBE\u8BA1\u6587\u4EF6\uFF0C\u544A\u522B\u622A\u56FE\u6C9F\u901A": "\u4EA7\u8BBE\u5DE5\u5177\u4E00\u4F53\u5316\uFF0C\u4E91\u7AEF\u7EDF\u4E00\u7BA1\u7406\u539F\u578B\u548C\u8BBE\u8BA1\u6587\u4EF6\uFF0C\u544A\u522B\u622A\u56FE\u6C9F\u901A",
  "\u67E5\u770B\u66F4\u591A\u6743\u76CA": "\u67E5\u770B\u66F4\u591A\u6743\u76CA",
  "\u5E2D\u4F4D\u4E0A\u9650/\u6587\u4EF6\u6570": "\u5E2D\u4F4D\u4E0A\u9650/\u6587\u4EF6\u6570",
  "\u4F7F\u7528\u7814\u53D1\u6A21\u5F0F": "\u4F7F\u7528\u7814\u53D1\u6A21\u5F0F",
  "\u521B\u5EFA/\u7F16\u8F91/\u5206\u4EAB\u539F\u578B\u6587\u4EF6": "\u521B\u5EFA/\u7F16\u8F91/\u5206\u4EAB\u539F\u578B\u6587\u4EF6",
  "\u63A8\u8350\u7248\u672C": "\u63A8\u8350\u7248\u672C",
  "%{num} \u4E2A": "%{num} \u4E2A",
  "\u4E0D\u9650": "\u4E0D\u9650",
  "\u652F\u6301": "\u652F\u6301",
  "\u7EC4\u4EF6\u5C5E\u6027/\u63D2\u69FD": "\u7EC4\u4EF6\u5C5E\u6027/\u63D2\u69FD",
  "\u9884\u7F6E\u56E2\u961F\u5E93": "\u9884\u7F6E\u56E2\u961F\u5E93",
  "\u6587\u4EF6\u6570": "\u6587\u4EF6\u6570",
  "\u8BBE\u8BA1\u5E2D\u4F4D\u4E0A\u9650": "\u8BBE\u8BA1\u5E2D\u4F4D\u4E0A\u9650",
  "\u5F53\u524D\u7248\u672C": "\u5F53\u524D\u7248\u672C",
  "\u8D2D\u4E70\u5E2D\u4F4D": "\u8D2D\u4E70\u5E2D\u4F4D",
  "\u5347\u7EA7\u7248\u672C": "\u5347\u7EA7\u7248\u672C",
  "\u53D6\u6D88": "\u53D6\u6D88",
  "\u5173\u95ED": "\u5173\u95ED",
  "\u786E\u5B9A": "\u786E\u5B9A",
  "\u8BA4\u8BC1\u5931\u8D25": "\u8BA4\u8BC1\u5931\u8D25",
  "\u83B7\u53D6\u9A8C\u8BC1\u7801\u5931\u8D25": "\u83B7\u53D6\u9A8C\u8BC1\u7801\u5931\u8D25",
  "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801": "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
  "%{time}\u79D2\u540E\u91CD\u8BD5": "%{time}\u79D2\u540E\u91CD\u8BD5",
  "\u9A8C\u8BC1\u7801\u683C\u5F0F\u9519\u8BEF": "\u9A8C\u8BC1\u7801\u683C\u5F0F\u9519\u8BEF",
  "\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A": "\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A",
  "\u624B\u673A\u53F7\u683C\u5F0F\u9519\u8BEF": "\u624B\u673A\u53F7\u683C\u5F0F\u9519\u8BEF",
  "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A": "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A",
  "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801": "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801",
  "\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u53CA\u7F51\u7EDC\u5B9E\u540D\u5236\u8981\u6C42\uFF0C\u8BF7\u9A8C\u8BC1\u6709\u6548\u624B\u673A\u53F7\u7801": "\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u53CA\u7F51\u7EDC\u5B9E\u540D\u5236\u8981\u6C42\uFF0C\u8BF7\u9A8C\u8BC1\u6709\u6548\u624B\u673A\u53F7\u7801",
  "\u8BF7\u9A8C\u8BC1\u624B\u673A\u53F7": "\u8BF7\u9A8C\u8BC1\u624B\u673A\u53F7",
  "\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u4EC5\u5141\u8BB8\u4F01\u4E1A\u90AE\u7BB1\u57DF\u7528\u6237\u6CE8\u518C": "\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u4EC5\u5141\u8BB8\u4F01\u4E1A\u90AE\u7BB1\u57DF\u7528\u6237\u6CE8\u518C",
  "\u5207\u6362\u81F3\u82F1\u6587": "\u5207\u6362\u81F3\u82F1\u6587",
  "\u5207\u6362\u81F3\u4E2D\u6587": "\u5207\u6362\u81F3\u4E2D\u6587",
  "\u9A8C\u8BC1\u7801\u53D1\u9001\u9891\u7E41\uFF0C\u8BF75\u5206\u949F\u540E\u518D\u8BD5": "\u9A8C\u8BC1\u7801\u53D1\u9001\u9891\u7E41\uFF0C\u8BF75\u5206\u949F\u540E\u518D\u8BD5\u3002",
  "\u4F7F\u7528\u63A8\u7279\u8D26\u53F7": "\u4F7F\u7528\u63A8\u7279\u8D26\u53F7",
  "\u4F7F\u7528\u9886\u82F1\u8D26\u53F7": "\u4F7F\u7528\u9886\u82F1\u8D26\u53F7",
  "\u591A\u6B21\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5": "\u591A\u6B21\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5",
  "\u56FE\u5F62\u9A8C\u8BC1\u7801\u9519\u8BEF": "\u56FE\u5F62\u9A8C\u8BC1\u7801\u9519\u8BEF",
  "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801": "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801",
  "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u672A\u8F93\u5165\u60C5\u51B5\u3011": "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801",
  "\u6B64\u8D26\u53F7\u5DF2\u6CE8\u518C\uFF0C\u8BF7\u76F4\u63A5\u767B\u5F55": "\u6B64\u8D26\u53F7\u5DF2\u6CE8\u518C\uFF0C\u8BF7\u76F4\u63A5\u767B\u5F55",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7BB1": "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7BB1",
  "\u6682\u4E0D\u652F\u6301\u6B64\u57DF\u540D\u7684\u90AE\u7BB1\u6CE8\u518C\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u6CE8\u518C\u65B9\u5F0F": "\u6682\u4E0D\u652F\u6301\u6B64\u57DF\u540D\u7684\u90AE\u7BB1\u6CE8\u518C\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u6CE8\u518C\u65B9\u5F0F",
  "\u767B\u5F55\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458": "\u767B\u5F55\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u6216\u90AE\u7BB1": "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u6216\u90AE\u7BB1",
  "\u6CA1\u6709\u90AE\u7BB1\u4FE1\u606F\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458": "\u6CA1\u6709\u90AE\u7BB1\u4FE1\u606F\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458",
  "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528": "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528",
  "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528\uFF0C\u88AB\u9650\u5236\u767B\u5F55\u4F01\u4E1A\u3002\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4F01\u4E1A\u7BA1\u7406\u5458": "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528\uFF0C\u88AB\u9650\u5236\u767B\u5F55\u4F01\u4E1A\u3002\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4F01\u4E1A\u7BA1\u7406\u5458",
  "\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1": "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1",
  "\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  "\u4F01\u4E1A\u90AE\u7BB1": "\u4F01\u4E1A\u90AE\u7BB1",
  "\u4E0B\u4E00\u6B65": "\u4E0B\u4E00\u6B65",
  "\u9A8C\u8BC1\u4E2D...": "\u9A8C\u8BC1\u4E2D...",
  "\u9A8C\u8BC1\u53F7\u7801": "\u9A8C\u8BC1\u53F7\u7801",
  "\u5FAE\u4FE1%{slot1}": "\u5FAE\u4FE1%{slot1}",
  "\u626B\u7801\u6CE8\u518C": "\u626B\u7801\u6CE8\u518C",
  "\u5B89\u5168\u767B\u5F55": "\u5B89\u5168\u767B\u5F55",
  "\u5F00\u59CB\u4F7F\u7528": "\u5F00\u59CB\u4F7F\u7528",
  "\u5BC6\u7801": "\u5BC6\u7801",
  "\u624B\u673A\u53F7/\u90AE\u7BB1": "\u624B\u673A\u53F7/\u90AE\u7BB1",
  "\u90AE\u7BB1": "\u90AE\u7BB1",
  "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF": "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF",
  "\u5F88\u62B1\u6B49\uFF0C\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "\u5F88\u62B1\u6B49\uFF0C\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  "\u9A8C\u8BC1\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u4E3A\u672C\u673A\u4E3B\u5361\u69FD\u53F7\u7801": "\u9A8C\u8BC1\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u4E3A\u672C\u673A\u4E3B\u5361\u69FD\u53F7\u7801",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7": "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7",
  "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u9519\u8BEF\u60C5\u51B5\u3011": "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165",
  "\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165": "\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165",
  "\u8BBE\u7F6E\u5BC6\u7801": "\u8BBE\u7F6E\u5BC6\u7801",
  "\u5FAE\u4FE1\u626B\u7801\u6CE8\u518C": "\u5FAE\u4FE1\u626B\u7801\u6CE8\u518C",
  "\u4E00\u952E\u767B\u5F55": "\u4E00\u952E\u767B\u5F55",
  "\u60A8\u8FD8\u672A\u767B\u5F55\uFF0C\u60A8\u53EF\u901A\u8FC7\u84DD\u6E56\u767B\u5F55": "\u60A8\u8FD8\u672A\u767B\u5F55\uFF0C\u60A8\u53EF\u901A\u8FC7\u84DD\u6E56\u767B\u5F55",
  "\u524D\u5F80\u84DD\u6E56\u6388\u6743/\u767B\u9646": "\u524D\u5F80\u84DD\u6E56\u6388\u6743/\u767B\u9646",
  "\u6B22\u8FCE\u56DE\u6765": "\u6B22\u8FCE\u56DE\u6765",
  "\u6CE8\u518C\u65B0\u8D26\u53F7": "\u6CE8\u518C\u65B0\u8D26\u53F7",
  "\u7F51\u7EDC\u72B6\u51B5\u53D1\u751F\u53D8\u5316\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u540E\u91CD\u8BD5\u3002": "\u7F51\u7EDC\u72B6\u51B5\u53D1\u751F\u53D8\u5316\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u540E\u91CD\u8BD5\u3002",
  "\u7ACB\u5373\u767B\u5F55": "\u7ACB\u5373\u767B\u5F55",
  "\u5DF2\u6709\u8D26\u53F7?": "\u5DF2\u6709\u8D26\u53F7?",
  "\u524D\u5F80\u6CE8\u518C": "\u524D\u5F80\u6CE8\u518C",
  "\u8FD8\u6CA1\u6709\u8D26\u53F7?": "\u8FD8\u6CA1\u6709\u8D26\u53F7?",
  "\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F",
  "SSO\u767B\u5F55": "SSO\u767B\u5F55",
  "\u9A8C\u8BC1\u7801\u767B\u5F55": "\u9A8C\u8BC1\u7801\u767B\u5F55",
  "\u5BC6\u7801\u767B\u5F55": "\u5BC6\u7801\u767B\u5F55",
  "\u624B\u673A\u53F7\u4E00\u952E\u767B\u5F55": "\u624B\u673A\u53F7\u4E00\u952E\u767B\u5F55",
  "\u5FD8\u8BB0\u5BC6\u7801": "\u5FD8\u8BB0\u5BC6\u7801",
  "\u9690\u79C1\u534F\u8BAE": "\u9690\u79C1\u534F\u8BAE",
  "\u548C": "\u548C",
  "\u670D\u52A1\u534F\u8BAE": "\u670D\u52A1\u534F\u8BAE",
  "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F": "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F",
  "\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801": "\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801",
  "\u83B7\u53D6\u9A8C\u8BC1\u7801": "\u83B7\u53D6\u9A8C\u8BC1\u7801",
  "%{process} \u79D2": "%{process} \u79D2",
  "\u9A8C\u8BC1\u7801": "\u9A8C\u8BC1\u7801",
  "\u5BC6\u7801\u81F3\u5C11 8 \u4F4D\uFF0C\u542B\u5927\u5C0F\u5199\u3001\u6570\u5B57\u548C\u7B26\u53F7": "\u5BC6\u7801\u81F3\u5C11 8 \u4F4D\uFF0C\u542B\u5927\u5C0F\u5199\u3001\u6570\u5B57\u548C\u7B26\u53F7",
  "\u5BC6\u7801\u81F3\u5C11 %{minLen} \u4F4D": "\u5BC6\u7801\u81F3\u5C11 %{minLen} \u4F4D",
  "\u5927\u5199": "\u5927\u5199",
  "\u5C0F\u5199": "\u5C0F\u5199",
  "\u5927\u5C0F\u5199": "\u5927\u5C0F\u5199",
  "\u6570\u5B57": "\u6570\u5B57",
  "\u7B26\u53F7": "\u7B26\u53F7",
  "\uFF0C\u542B": "\uFF0C\u542B",
  "\u7528\u6237\u540D\u6216\u9A8C\u8BC1\u7801\u9519\u8BEF": "\u7528\u6237\u540D\u6216\u9A8C\u8BC1\u7801\u9519\u8BEF",
  "\u5F53\u524D\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u6BCF %{day} \u5929\u5F3A\u5236\u91CD\u7F6E\u5BC6\u7801\uFF0C\u8BF7\u4FEE\u6539\u5BC6\u7801\u5E76\u91CD\u65B0\u767B\u5F55\u3002": "\u5F53\u524D\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u6BCF %{day} \u5929\u5F3A\u5236\u91CD\u7F6E\u5BC6\u7801\uFF0C\u8BF7\u4FEE\u6539\u5BC6\u7801\u5E76\u91CD\u65B0\u767B\u5F55\u3002",
  "\u5BC6\u7801\u91CD\u7F6E": "\u5BC6\u7801\u91CD\u7F6E",
  "\u5BC6\u7801\u6700\u957F %{maxLength} \u4F4D": "\u5BC6\u7801\u6700\u957F %{maxLength} \u4F4D",
  "\u8BF7\u8F93\u5165\u65E7\u5BC6\u7801": "\u8BF7\u8F93\u5165\u65E7\u5BC6\u7801",
  "\u65E7\u5BC6\u7801\u8F93\u5165\u4E0D\u6B63\u786E": "\u65E7\u5BC6\u7801\u8F93\u5165\u4E0D\u6B63\u786E",
  "\u65B0\u5BC6\u7801\u4E0D\u53EF\u548C\u65E7\u5BC6\u7801\u4E00\u81F4!": "\u65B0\u5BC6\u7801\u4E0D\u53EF\u548C\u65E7\u5BC6\u7801\u4E00\u81F4!",
  "\u5BC6\u7801\u91CD\u7F6E\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5": "\u5BC6\u7801\u91CD\u7F6E\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5",
  "\u6CE8\u518C\u4FE1\u606F\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5": "\u6CE8\u518C\u4FE1\u606F\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5",
  "\u56FE\u5F62\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u83B7\u53D6": "\u56FE\u5F62\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u83B7\u53D6",
  "\u672A\u6CE8\u518C\u8D26\u53F7\u65E0\u6CD5\u767B\u5F55\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458": "\u672A\u6CE8\u518C\u8D26\u53F7\u65E0\u6CD5\u767B\u5F55\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458"
};
var en = {
  "\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8BF7\u4E3A%{account}\u8D26\u53F7\u8BBE\u7F6E\u5BC6\u7801": "For your account security, please set a password for %{account} account",
  "\u8BBE\u8BA1\u7CFB\u7EDF\u53D1\u5E03\u4E3A\u56E2\u961F\u5E93\uFF0C\u7EDF\u4E00\u7BA1\u7406\uFF0C\u5FEB\u901F\u5BF9\u9F50": "Design system released as a team library, unified management, fast alignment",
  "\u8BF7\u5148\u767B\u5F55": "Please log in first",
  "\u521B\u5EFA\u5E76\u590D\u7528\u7EC4\u4EF6\u4E0E\u6837\u5F0F\uFF0C\u4E00\u5904\u4FEE\u6539\uFF0C\u5168\u5C40\u540C\u6B65\uFF0C\u4FDD\u6301\u8BBE\u8BA1\u4E00\u81F4\u6027": "Create and reuse components and styles, one change, global synchronization, keep design consistency",
  "\u4E13\u4E1A\u77E2\u91CF\u7F16\u8F91\uFF0C\u667A\u80FD\u8F85\u52A9\u5DE5\u5177\uFF0C\u5B9E\u65F6\u5728\u7EBF\u4EA4\u4ED8": "Professional vector editing, intelligent auxiliary tools, real-time online delivery",
  "\u4F7F\u7528 VS code \u6269\u5C55\uFF0C\u7814\u53D1\u65E0\u9700\u79BB\u5F00\u5F00\u53D1\u73AF\u5883\u5373\u53EF\u83B7\u53D6\u8BBE\u8BA1\u6807\u6CE8": "Use VS code extension, developers can get design annotations without leaving the development environment",
  "\u5B9A\u5236\u6807\u6CE8&\u4EE3\u7801\u7247\u6BB5\u63D2\u4EF6\uFF0C\u81EA\u5B9A\u4E49\u6807\u6CE8\u8BED\u8A00": "Customize annotation & code snippet plugins, customize annotation language",
  "\u4F7F\u7528MasterGo MCP server \u5C06\u8BBE\u8BA1\u7A3F\u76F4\u63A5\u8F6C\u4EE3\u7801": "Use MasterGo MCP server to convert design drafts directly to code",
  "\u52A8\u6001\u9762\u677F\u3001\u9AD8\u7EA7\u8868\u683C\u3001\u9AD8\u7EA7\u56FE\u8868\u3001\u53EF\u4EA4\u4E92\u63A7\u4EF6\u3001\u4EA4\u4E92\u6CE8\u91CA\u7B49\u80FD\u529B": "Dynamic panel, advanced table, advanced chart, interactive component, interactive annotation, etc.",
  "\u4EA7\u54C1\u76F4\u63A5\u8C03\u7528\u8BBE\u8BA1\u7EC4\u4EF6\u5E93\uFF0C\u9AD8\u6548\u751F\u6210\u9AD8\u4FDD\u771F\u4E1A\u52A1\u539F\u578B": "Product directly call design component library, efficiently generate high-fidelity business prototypes",
  "\u6D77\u91CF\u6A21\u7248\u8D44\u6E90\u548CElement\u3001Ant design\u7B49\u5927\u5382\u8D44\u6E90\u5E93": "Pre-set Element, Ant design, and other large factory resource libraries, supporting direct use",
  "\u4EA7\u8BBE\u5DE5\u5177\u4E00\u4F53\u5316\uFF0C\u4E91\u7AEF\u7EDF\u4E00\u7BA1\u7406\u539F\u578B\u548C\u8BBE\u8BA1\u6587\u4EF6\uFF0C\u544A\u522B\u622A\u56FE\u6C9F\u901A": "Product and design tool integration, unified management of prototypes and design files, say goodbye to screenshot communication",
  "\u67E5\u770B\u66F4\u591A\u6743\u76CA": "View more benefits",
  "\u5E2D\u4F4D\u4E0A\u9650/\u6587\u4EF6\u6570": "Seat limit/file number",
  "\u4F7F\u7528\u7814\u53D1\u6A21\u5F0F": "Use development mode",
  "\u521B\u5EFA/\u7F16\u8F91/\u5206\u4EAB\u539F\u578B\u6587\u4EF6": "Create/edit/share prototype files",
  "\u63A8\u8350\u7248\u672C": "Recommended version",
  "%{num} \u4E2A": "",
  "\u4E0D\u9650": "Unlimited",
  "\u652F\u6301": "Support",
  "\u7EC4\u4EF6\u5C5E\u6027/\u63D2\u69FD": "Component properties/slots",
  "\u9884\u7F6E\u56E2\u961F\u5E93": "Prefab team library",
  "\u6587\u4EF6\u6570": "File number",
  "\u8BBE\u8BA1\u5E2D\u4F4D\u4E0A\u9650": "Design seat limit",
  "\u5F53\u524D\u7248\u672C": "Current version",
  "\u8D2D\u4E70\u5E2D\u4F4D": "Purchase seats",
  "\u5347\u7EA7\u7248\u672C": "Upgrade version",
  "\u53D6\u6D88": "Cancel",
  "\u5173\u95ED": "Close",
  "\u786E\u5B9A": "Confirm",
  "\u8BA4\u8BC1\u5931\u8D25": "Authentication failed",
  "\u83B7\u53D6\u9A8C\u8BC1\u7801\u5931\u8D25": "Failed to get code",
  "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801": "Enter code",
  "%{time}\u79D2\u540E\u91CD\u8BD5": "Retry in %{time} seconds",
  "\u9A8C\u8BC1\u7801\u683C\u5F0F\u9519\u8BEF": "Invalid verification code format",
  "\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A": "Verification code is required",
  "\u624B\u673A\u53F7\u683C\u5F0F\u9519\u8BEF": "Invalid mobile number format",
  "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A": "Mobile number is required",
  "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801": "Enter mobile number",
  "\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u53CA\u7F51\u7EDC\u5B9E\u540D\u5236\u8981\u6C42\uFF0C\u8BF7\u9A8C\u8BC1\u6709\u6548\u624B\u673A\u53F7\u7801": "According to national regulations and real-name requirements, please verify your mobile number",
  "\u8BF7\u9A8C\u8BC1\u624B\u673A\u53F7": "Verify mobile number",
  "\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u4EC5\u5141\u8BB8\u4F01\u4E1A\u90AE\u7BB1\u57DF\u7528\u6237\u6CE8\u518C": "Registration is restricted to users with enterprise email domains.",
  "\u5207\u6362\u81F3\u82F1\u6587": "Switch to English",
  "\u5207\u6362\u81F3\u4E2D\u6587": "Switch to Chinese",
  "\u9A8C\u8BC1\u7801\u53D1\u9001\u9891\u7E41\uFF0C\u8BF75\u5206\u949F\u540E\u518D\u8BD5": "Verification codes are sent frequently, please try again in 5 minutes.",
  "\u4F7F\u7528\u63A8\u7279\u8D26\u53F7": "Continue with Twitter",
  "\u4F7F\u7528\u9886\u82F1\u8D26\u53F7": "Continue with LinkedIn",
  "\u591A\u6B21\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5": "You have recently made too many attempts. Please try again later.",
  "\u56FE\u5F62\u9A8C\u8BC1\u7801\u9519\u8BEF": "Invalid CAPTCHA code",
  "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801": "CAPTHCA code",
  "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u672A\u8F93\u5165\u60C5\u51B5\u3011": "Please enter the verification code.",
  "\u6B64\u8D26\u53F7\u5DF2\u6CE8\u518C\uFF0C\u8BF7\u76F4\u63A5\u767B\u5F55": "Account existing. Log in it.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7BB1": "Please enter a valid email address.",
  "\u6682\u4E0D\u652F\u6301\u6B64\u57DF\u540D\u7684\u90AE\u7BB1\u6CE8\u518C\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u6CE8\u518C\u65B9\u5F0F": "You cannot sign up using email with this domain. Please sign up via another method.",
  "\u767B\u5F55\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458": "Oops! Failed to log in. Contact the org admin if needed.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u6216\u90AE\u7BB1": "Please enter a valid email address.",
  "\u6CA1\u6709\u90AE\u7BB1\u4FE1\u606F\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458": "Email not found. Contact the org admin if needed.",
  "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528": "Your account has been disabled",
  "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528\uFF0C\u88AB\u9650\u5236\u767B\u5F55\u4F01\u4E1A\u3002\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4F01\u4E1A\u7BA1\u7406\u5458": "Your organization account has been disabled. Contact the org admin if needed.",
  "\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "This organization has not enabled SSO login. Please log in via another method.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1": "Please enter a valid organization email.",
  "\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Your account has not joined this organization. Please log in via another method.",
  "\u4F01\u4E1A\u90AE\u7BB1": "Corporate email",
  "\u4E0B\u4E00\u6B65": "Next",
  "\u9A8C\u8BC1\u4E2D...": "Verifying...",
  "\u9A8C\u8BC1\u53F7\u7801": "Verify number",
  "\u5FAE\u4FE1%{slot1}": "WeChat %{slot1}",
  "\u626B\u7801\u6CE8\u518C": "QR code registration",
  "\u5B89\u5168\u767B\u5F55": "Secure login",
  "\u5F00\u59CB\u4F7F\u7528": "Log in",
  "\u5BC6\u7801": "Password",
  "\u624B\u673A\u53F7/\u90AE\u7BB1": "Email",
  "\u90AE\u7BB1": "Email",
  "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF": "Invalid username or password",
  "\u5F88\u62B1\u6B49\uFF0C\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Oops! Failed to log in. Please login via another method.",
  "\u9A8C\u8BC1\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u4E3A\u672C\u673A\u4E3B\u5361\u69FD\u53F7\u7801": "Verification error. Please check if it is the primary slot number of your phone.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7": "Please enter a valid phone number",
  "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u9519\u8BEF\u60C5\u51B5\u3011": "Invalid code entered. Try again.",
  "\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165": "Passwords do not match. Please try again.",
  "\u8BBE\u7F6E\u5BC6\u7801": "Set password",
  "\u5FAE\u4FE1\u626B\u7801\u6CE8\u518C": "Sign up with WeChat QR code",
  "\u4E00\u952E\u767B\u5F55": "One-click login",
  "\u60A8\u8FD8\u672A\u767B\u5F55\uFF0C\u60A8\u53EF\u901A\u8FC7\u84DD\u6E56\u767B\u5F55": "You are not logged in. You can log in through Lanhu.",
  "\u524D\u5F80\u84DD\u6E56\u6388\u6743/\u767B\u9646": "Go to Lanhu for authorization/login.",
  "\u6B22\u8FCE\u56DE\u6765": "Welcome back to Creatie",
  "\u6CE8\u518C\u65B0\u8D26\u53F7": "Welcome to Creatie",
  "\u7F51\u7EDC\u72B6\u51B5\u53D1\u751F\u53D8\u5316\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u540E\u91CD\u8BD5\u3002": "Network conditions have changed, please refresh the page and try again.",
  "\u7ACB\u5373\u767B\u5F55": "Log in here",
  "\u5DF2\u6709\u8D26\u53F7?": "Already have an account?",
  "\u524D\u5F80\u6CE8\u518C": "Sign up here",
  "\u8FD8\u6CA1\u6709\u8D26\u53F7?": "Don't have an account?",
  "\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Other login methods",
  "SSO\u767B\u5F55": "SSO login",
  "\u9A8C\u8BC1\u7801\u767B\u5F55": "Log in with verification code",
  "\u5BC6\u7801\u767B\u5F55": "Log in with password",
  "\u624B\u673A\u53F7\u4E00\u952E\u767B\u5F55": "One-click login with phone number",
  "\u5FD8\u8BB0\u5BC6\u7801": "Forgot password",
  "\u9690\u79C1\u534F\u8BAE": "Privacy Policy",
  "\u548C": "and",
  "\u670D\u52A1\u534F\u8BAE": "Service Agreement",
  "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F": "I agree to join Creatie's mailing list.",
  "\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801": "Confirm password",
  "\u83B7\u53D6\u9A8C\u8BC1\u7801": "Send code",
  "%{process} \u79D2": "%{process} seconds",
  "\u9A8C\u8BC1\u7801": "Enter code",
  "\u5BC6\u7801\u81F3\u5C11 8 \u4F4D\uFF0C\u542B\u5927\u5C0F\u5199\u3001\u6570\u5B57\u548C\u7B26\u53F7": "Password must be at least 8 characters and include uppercase letters, lowercase letters, numbers, and symbols",
  "\u8BF7\u8F93\u5165\u672C\u673A\u53F7\u7801": "Please enter the phone number",
  "\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8BF7\u4E3A %{account} \u8D26\u53F7\u8BBE\u7F6E\u5BC6\u7801": "To ensure your account security\uFF0CPlease set a password for %{account}",
  "\u5BC6\u7801\u6CE8\u518C": "Sign up with password",
  "\u9A8C\u8BC1\u7801\u6CE8\u518C": "Sign up with verification code",
  "\u5FAE\u4FE1\u7528\u6237\u76F4\u63A5\u767B\u5F55": "Log in with WeChat",
  "\u6216": "or",
  "\u4F01\u4E1A\u5FAE\u4FE1\u767B\u5F55": "Log in with WeCom",
  "\u5FAE\u4FE1\u767B\u5F55": "Log in with WeChat",
  "\u70B9\u51FB\u5237\u65B0": "Click to refresh",
  "\u8BF7\u5728\u624B\u673A\u4E0A\u64CD\u4F5C": "Operate on your phone",
  "\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 MasterGo \u516C\u4F17\u53F7 \u5373\u53EF\u5FEB\u901F%{slot1}": "Scan QR code with your WeChat to follow Creatie and quick %{slot1}",
  "\u540E\u518D\u6B21\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8": "scan QR code with your WeChat to follow",
  "\u5237\u65B0\u4E8C\u7EF4\u7801": "Refresh QR code",
  "\u53EF": "can",
  "\u626B\u7801\u9047\u5230\u95EE\u9898?": "Problem with scanning?",
  "\u540E\u518D\u6B21\u5C1D\u8BD5\u6216\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Try again later or log in via other methods",
  "\u5237\u65B0": "Refresh",
  "\u8BF7": "Please",
  "\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548": "QR code has expired",
  "\u5FAE\u4FE1\u4E2D\u70B9\u51FB\u5173\u6CE8\u5373\u53EF\u6CE8\u518C\u6210\u529F": "Click Follow in WeChat to register",
  "\u626B\u7801\u6210\u529F": "Scan successful",
  "\u6CE8\u518C": "Create account",
  "\u767B\u5F55": "Log in",
  '\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 "MasterGo \u4EA7\u54C1\u8BBE\u8BA1\u5DE5\u5177" \u5FEB\u901F': 'Scan QR code to follow "Creatie" with your WeChat',
  "\u4F7F\u7528 Google \u8D26\u53F7": "Continue with Google",
  "\u4E0B\u8F7D\u5E94\u7528\u7A0B\u5E8F": "Downloads",
  "\u624B\u673A\u5BA2\u6237\u7AEF": "Mobile app",
  "\u7535\u8111\u5BA2\u6237\u7AEF": "Desktop app",
  "\u672C\u5730\u5B57\u4F53\u63D2\u4EF6": "Font helper",
  "\u9000\u51FA\u767B\u5F55": "Log out",
  "\u4E2A\u4EBA\u8BBE\u7F6E": "Settings",
  "\u5207\u6362\u81F3\u6DF1\u8272\u6A21\u5F0F": "Dark mode",
  "\u5207\u6362\u81F3\u6D45\u8272\u6A21\u5F0F": "Light mode",
  "\u524D\u5F80\u5B98\u7F51": "Visit Creatie.ai",
  "\u793E\u533A\u4E2A\u4EBA\u4E3B\u9875": "Profile page",
  "\u8D44\u6E90\u793E\u533A": "Creatie community",
  "\u56DE\u5230\u4E3B\u9875": "Back",
  "\u5DE5\u4F5C\u53F0": "Dashboard",
  "\u524D\u5F80\u5DE5\u4F5C\u53F0": "Go to dashboard",
  "\u8BF7\u626B\u7801\u4E0B\u8F7D": "Scan the code to download",
  "\u6211\u7684\u6536\u85CF": "My collection",
  "\u6D25\u6D25": "JinJin",
  "\u79C1\u6709\u90E8\u7F72\u7248": "Private deployment version",
  "\u4F01\u4E1A\u7248": "Enterprise",
  "\u56E2\u961F\u7248": "Team version",
  "\u521D\u521B\u7248": "Original",
  "\u672A\u77E5\u9519\u8BEF": "Unknown error",
  "\u4F01\u4E1A\u5FAE\u4FE1\u626B\u7801\u767B\u5F55": "Enterprise email login",
  "\u5BC6\u7801\u81F3\u5C11 %{minLen} \u4F4D": "Min %{minLen} characters",
  "\u5927\u5199": "Uppercase",
  "\u5C0F\u5199": "Lowercase",
  "\u5927\u5C0F\u5199": "Letter case",
  "\u6570\u5B57": "Number",
  "\u7B26\u53F7": "Symbol",
  "\uFF0C\u542B": ",",
  "\u7528\u6237\u540D\u6216\u9A8C\u8BC1\u7801\u9519\u8BEF": "Invalid username or code",
  "\u5F53\u524D\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u6BCF %{day} \u5929\u5F3A\u5236\u91CD\u7F6E\u5BC6\u7801\uFF0C\u8BF7\u4FEE\u6539\u5BC6\u7801\u5E76\u91CD\u65B0\u767B\u5F55\u3002": "This organization has set a password reset interval of %{day} days. Please reset your password and log in again.",
  "\u5BC6\u7801\u91CD\u7F6E": "Password reset",
  "\u5BC6\u7801\u6700\u957F %{maxLength} \u4F4D": "Password must be less than %{maxLength} characters",
  "\u8BF7\u8F93\u5165\u65E7\u5BC6\u7801": "Please enter the old password",
  "\u65E7\u5BC6\u7801\u8F93\u5165\u4E0D\u6B63\u786E": "The old password is incorrect",
  "\u65B0\u5BC6\u7801\u4E0D\u53EF\u548C\u65E7\u5BC6\u7801\u4E00\u81F4!": "The new password cannot be the same as the old password!",
  "\u5BC6\u7801\u91CD\u7F6E\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5": "Password reset failed. Please try again.",
  "\u6CE8\u518C\u4FE1\u606F\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5": "Registration information is abnormal. Please try again.",
  "\u56FE\u5F62\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u83B7\u53D6": "CAPTCHA has expired. Please get it again.",
  "\u672A\u6CE8\u518C\u8D26\u53F7\u65E0\u6CD5\u767B\u5F55\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458": "The account is not registered. Please contact the administrator."
};
var enMg = {
  "\u6D25\u6D25": "JinJin",
  "\u6211\u7684\u6536\u85CF": "My collection",
  "\u8BF7\u626B\u7801\u4E0B\u8F7D": "Scan the code to download",
  "\u524D\u5F80\u5DE5\u4F5C\u53F0": "Go to dashboard",
  "\u5DE5\u4F5C\u53F0": "Dashboard",
  "\u56DE\u5230\u4E3B\u9875": "Back",
  "\u8D44\u6E90\u793E\u533A": "MasterGo community",
  "\u793E\u533A\u4E2A\u4EBA\u4E3B\u9875": "Profile page",
  "\u524D\u5F80\u5B98\u7F51": "Visit mastergo.com",
  "\u5207\u6362\u81F3\u6D45\u8272\u6A21\u5F0F": "Light mode",
  "\u5207\u6362\u81F3\u6DF1\u8272\u6A21\u5F0F": "Dark mode",
  "\u4E2A\u4EBA\u8BBE\u7F6E": "Settings",
  "\u9000\u51FA\u767B\u5F55": "Log out",
  "\u672C\u5730\u5B57\u4F53\u63D2\u4EF6": "Font helper",
  "\u7535\u8111\u5BA2\u6237\u7AEF": "Desktop app",
  "\u624B\u673A\u5BA2\u6237\u7AEF": "Mobile app",
  "\u4E0B\u8F7D\u5E94\u7528\u7A0B\u5E8F": "Downloads",
  "\u4F7F\u7528 Google \u8D26\u53F7": "Continue with Google",
  '\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 "MasterGo \u4EA7\u54C1\u8BBE\u8BA1\u5DE5\u5177" \u5FEB\u901F': 'Scan QR code to follow "MasterGo" with your WeChat',
  "\u767B\u5F55": "Log in",
  "\u6CE8\u518C": "Create account",
  "\u626B\u7801\u6210\u529F": "Scan successful",
  "\u5FAE\u4FE1\u4E2D\u70B9\u51FB\u5173\u6CE8\u5373\u53EF\u6CE8\u518C\u6210\u529F": "Click Follow in WeChat to register",
  "\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548": "QR code has expired",
  "\u8BF7": "Please",
  "\u5237\u65B0": "Refresh",
  "\u540E\u518D\u6B21\u5C1D\u8BD5\u6216\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Try again later or log in via other methods",
  "\u626B\u7801\u9047\u5230\u95EE\u9898?": "Problem with scanning?",
  "\u53EF": "can",
  "\u5237\u65B0\u4E8C\u7EF4\u7801": "Refresh QR code",
  "\u540E\u518D\u6B21\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8": "scan QR code with your WeChat to follow",
  "\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 MasterGo \u516C\u4F17\u53F7 \u5373\u53EF\u5FEB\u901F%{slot1}": "Scan QR code with your WeChat to follow MasterGo and quick %{slot1}",
  "\u8BF7\u5728\u624B\u673A\u4E0A\u64CD\u4F5C": "Operate on your phone",
  "\u70B9\u51FB\u5237\u65B0": "Click to refresh",
  "\u5FAE\u4FE1\u767B\u5F55": "Log in with WeChat",
  "\u4F01\u4E1A\u5FAE\u4FE1\u767B\u5F55": "Log in with WeCom",
  "\u6216": "or",
  "\u5FAE\u4FE1\u7528\u6237\u76F4\u63A5\u767B\u5F55": "Log in with WeChat",
  "\u9A8C\u8BC1\u7801\u6CE8\u518C": "Verification Sign up",
  "\u5BC6\u7801\u6CE8\u518C": "Password Sign up",
  "\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8BF7\u4E3A %{account} \u8D26\u53F7\u8BBE\u7F6E\u5BC6\u7801": "To ensure your account security\uFF0CPlease set a password for %{account}",
  "\u8BF7\u8F93\u5165\u672C\u673A\u53F7\u7801": "Please enter the phone number",
  "\u5BC6\u7801\u81F3\u5C11 %{minLen} \u4F4D": "Min %{minLen} characters",
  "\u5927\u5199": "Uppercase",
  "\u5C0F\u5199": "Lowercase",
  "\u5927\u5C0F\u5199": "Letter case",
  "\u6570\u5B57": "Number",
  "\u7B26\u53F7": "Symbol",
  "\uFF0C\u542B": ",",
  "\u9A8C\u8BC1\u7801": "Enter code",
  "%{process} \u79D2": "%{process} seconds",
  "\u83B7\u53D6\u9A8C\u8BC1\u7801": "Send code",
  "\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801": "Confirm password",
  "\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F": "I agree to join MasterGo's mailing list.",
  "\u670D\u52A1\u534F\u8BAE": "Service Agreement",
  "\u548C": "and",
  "\u9690\u79C1\u534F\u8BAE": "Privacy Policy",
  "\u5FD8\u8BB0\u5BC6\u7801": "Forgot password",
  "\u624B\u673A\u53F7\u4E00\u952E\u767B\u5F55": "One-click login with phone number",
  "\u5BC6\u7801\u767B\u5F55": "Password login",
  "\u9A8C\u8BC1\u7801\u767B\u5F55": "Verification login",
  "SSO\u767B\u5F55": "SSO login",
  "\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Other login methods",
  "\u8FD8\u6CA1\u6709\u8D26\u53F7?": "Don't have an account?",
  "\u524D\u5F80\u6CE8\u518C": "Sign up here",
  "\u5DF2\u6709\u8D26\u53F7?": "Already have an account?",
  "\u7ACB\u5373\u767B\u5F55": "Log in here",
  "\u7F51\u7EDC\u72B6\u51B5\u53D1\u751F\u53D8\u5316\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u540E\u91CD\u8BD5\u3002": "Network conditions have changed, please refresh the page and try again.",
  "\u6CE8\u518C\u65B0\u8D26\u53F7": "Welcome to MasterGo",
  "\u6B22\u8FCE\u56DE\u6765": "Welcome back to MasterGo",
  "\u524D\u5F80\u84DD\u6E56\u6388\u6743/\u767B\u9646": "Go to Lanhu for authorization/login.",
  "\u60A8\u8FD8\u672A\u767B\u5F55\uFF0C\u60A8\u53EF\u901A\u8FC7\u84DD\u6E56\u767B\u5F55": "You are not logged in. You can log in through Lanhu.",
  "\u4E00\u952E\u767B\u5F55": "One-click login",
  "\u5FAE\u4FE1\u626B\u7801\u6CE8\u518C": "Sign up with WeChat QR code",
  "\u8BBE\u7F6E\u5BC6\u7801": "Set password",
  "\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165": "Passwords do not match. Please try again.",
  "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u9519\u8BEF\u60C5\u51B5\u3011": "Invalid code entered. Try again.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7": "Please enter a valid phone number",
  "\u9A8C\u8BC1\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u4E3A\u672C\u673A\u4E3B\u5361\u69FD\u53F7\u7801": "Verification error. Please check if it is the primary slot number of your phone.",
  "\u5F88\u62B1\u6B49\uFF0C\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Oops! Failed to log in. Please login via another method.",
  "\u7528\u6237\u540D\u6216\u9A8C\u8BC1\u7801\u9519\u8BEF": "Invalid username or code",
  "\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF": "Invalid username or password",
  "\u90AE\u7BB1": "Email",
  "\u624B\u673A\u53F7/\u90AE\u7BB1": "Email",
  "\u5BC6\u7801": "Password",
  "\u5F00\u59CB\u4F7F\u7528": "Log in",
  "\u5B89\u5168\u767B\u5F55": "Secure login",
  "\u626B\u7801\u6CE8\u518C": "QR code registration",
  "\u5FAE\u4FE1%{slot1}": "WeChat %{slot1}",
  "\u9A8C\u8BC1\u53F7\u7801": "Verify number",
  "\u9A8C\u8BC1\u4E2D...": "Verifying...",
  "\u4E0B\u4E00\u6B65": "Next",
  "\u4F01\u4E1A\u90AE\u7BB1": "Corporate email",
  "\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "Your account has not joined this organization. Please log in via another method.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1": "Please enter a valid organization email.",
  "\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F": "This organization has not enabled SSO login. Please log in via another method.",
  "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528\uFF0C\u88AB\u9650\u5236\u767B\u5F55\u4F01\u4E1A\u3002\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4F01\u4E1A\u7BA1\u7406\u5458": "Your organization account has been disabled. Contact the org admin if needed.",
  "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528": "Your account has been disabled",
  "\u6CA1\u6709\u90AE\u7BB1\u4FE1\u606F\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458": "Email not found. Contact the org admin if needed.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u6216\u90AE\u7BB1": "Please enter a valid email address.",
  "\u767B\u5F55\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458": "Oops! Failed to log in. Contact the org admin if needed.",
  "\u6682\u4E0D\u652F\u6301\u6B64\u57DF\u540D\u7684\u90AE\u7BB1\u6CE8\u518C\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u6CE8\u518C\u65B9\u5F0F": "You cannot sign up using email with this domain. Please sign up via another method.",
  "\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7BB1": "Please enter a valid email address.",
  "\u6B64\u8D26\u53F7\u5DF2\u6CE8\u518C\uFF0C\u8BF7\u76F4\u63A5\u767B\u5F55": "Account existing. Log in it.",
  "\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u672A\u8F93\u5165\u60C5\u51B5\u3011": "Please enter the verification code",
  "\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801": "CAPTHCA code",
  "\u56FE\u5F62\u9A8C\u8BC1\u7801\u9519\u8BEF": "Invalid CAPTCHA code",
  "\u591A\u6B21\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5": "You have recently made too many attempts. Please try again later.",
  "\u4F7F\u7528\u9886\u82F1\u8D26\u53F7": "Continue with LinkedIn",
  "\u4F7F\u7528\u63A8\u7279\u8D26\u53F7": "Continue with Twitter",
  "\u9A8C\u8BC1\u7801\u53D1\u9001\u9891\u7E41\uFF0C\u8BF75\u5206\u949F\u540E\u518D\u8BD5": "Verification codes are sent frequently, please try again in 5 minutes.",
  "\u5207\u6362\u81F3\u4E2D\u6587": "Switch to Chinese",
  "\u5207\u6362\u81F3\u82F1\u6587": "Switch to English",
  "\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u4EC5\u5141\u8BB8\u4F01\u4E1A\u90AE\u7BB1\u57DF\u7528\u6237\u6CE8\u518C": "Registration is restricted to users with enterprise email domains.",
  "\u8BF7\u9A8C\u8BC1\u624B\u673A\u53F7": "Verify mobile number",
  "\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u53CA\u7F51\u7EDC\u5B9E\u540D\u5236\u8981\u6C42\uFF0C\u8BF7\u9A8C\u8BC1\u6709\u6548\u624B\u673A\u53F7\u7801": "According to national regulations and real-name requirements, please verify your mobile number",
  "\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801": "Enter mobile number",
  "\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A": "Mobile number is required",
  "\u624B\u673A\u53F7\u683C\u5F0F\u9519\u8BEF": "Invalid mobile number format",
  "\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A": "Verification code is required",
  "\u9A8C\u8BC1\u7801\u683C\u5F0F\u9519\u8BEF": "Invalid verification code format",
  "%{time}\u79D2\u540E\u91CD\u8BD5": "Retry in %{time} seconds",
  "\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801": "Enter code",
  "\u83B7\u53D6\u9A8C\u8BC1\u7801\u5931\u8D25": "Failed to get code",
  "\u8BA4\u8BC1\u5931\u8D25": "Authentication failed",
  "\u786E\u5B9A": "Confirm",
  "\u5173\u95ED": "Close",
  "\u53D6\u6D88": "Cancel",
  "\u5347\u7EA7\u7248\u672C": "Upgrade version",
  "\u8D2D\u4E70\u5E2D\u4F4D": "Purchase seats",
  "\u5F53\u524D\u7248\u672C": "Current version",
  "\u8BBE\u8BA1\u5E2D\u4F4D\u4E0A\u9650": "Design seat limit",
  "\u6587\u4EF6\u6570": "File number",
  "\u9884\u7F6E\u56E2\u961F\u5E93": "Prefab team library",
  "\u7EC4\u4EF6\u5C5E\u6027/\u63D2\u69FD": "Component properties/slots",
  "\u652F\u6301": "Support",
  "\u4E0D\u9650": "Unlimited",
  "\u63A8\u8350\u7248\u672C": "Recommended version",
  "\u521B\u5EFA/\u7F16\u8F91/\u5206\u4EAB\u539F\u578B\u6587\u4EF6": "Create/edit/share prototype files",
  "\u4F7F\u7528\u7814\u53D1\u6A21\u5F0F": "Use development mode",
  "\u5E2D\u4F4D\u4E0A\u9650/\u6587\u4EF6\u6570": "Seat limit/file number",
  "\u67E5\u770B\u66F4\u591A\u6743\u76CA": "View more benefits",
  "\u4EA7\u8BBE\u5DE5\u5177\u4E00\u4F53\u5316\uFF0C\u4E91\u7AEF\u7EDF\u4E00\u7BA1\u7406\u539F\u578B\u548C\u8BBE\u8BA1\u6587\u4EF6\uFF0C\u544A\u522B\u622A\u56FE\u6C9F\u901A": "Product and design tool integration, unified management of prototypes and design files, say goodbye to screenshot communication",
  "\u6D77\u91CF\u6A21\u7248\u8D44\u6E90\u548CElement\u3001Ant design\u7B49\u5927\u5382\u8D44\u6E90\u5E93": "Pre-set Element, Ant design, and other large factory resource libraries, supporting direct use",
  "\u8BF7\u5148\u767B\u5F55": "Please log in first",
  "\u4EA7\u54C1\u76F4\u63A5\u8C03\u7528\u8BBE\u8BA1\u7EC4\u4EF6\u5E93\uFF0C\u9AD8\u6548\u751F\u6210\u9AD8\u4FDD\u771F\u4E1A\u52A1\u539F\u578B": "Product directly call design component library, efficiently generate high-fidelity business prototypes",
  "\u52A8\u6001\u9762\u677F\u3001\u9AD8\u7EA7\u8868\u683C\u3001\u9AD8\u7EA7\u56FE\u8868\u3001\u53EF\u4EA4\u4E92\u63A7\u4EF6\u3001\u4EA4\u4E92\u6CE8\u91CA\u7B49\u80FD\u529B": "Dynamic panel, advanced table, advanced chart, interactive component, interactive annotation, etc.",
  "\u4F7F\u7528MasterGo MCP server \u5C06\u8BBE\u8BA1\u7A3F\u76F4\u63A5\u8F6C\u4EE3\u7801": "Use MasterGo MCP server to convert design drafts directly to code",
  "\u5B9A\u5236\u6807\u6CE8&\u4EE3\u7801\u7247\u6BB5\u63D2\u4EF6\uFF0C\u81EA\u5B9A\u4E49\u6807\u6CE8\u8BED\u8A00": "Customize annotation & code snippet plugins, customize annotation language",
  "\u4F7F\u7528 VS code \u6269\u5C55\uFF0C\u7814\u53D1\u65E0\u9700\u79BB\u5F00\u5F00\u53D1\u73AF\u5883\u5373\u53EF\u83B7\u53D6\u8BBE\u8BA1\u6807\u6CE8": "Use VS code extension, developers can get design annotations without leaving the development environment",
  "\u8BBE\u8BA1\u7CFB\u7EDF\u53D1\u5E03\u4E3A\u56E2\u961F\u5E93\uFF0C\u7EDF\u4E00\u7BA1\u7406\uFF0C\u5FEB\u901F\u5BF9\u9F50": "Design system released as a team library, unified management, fast alignment",
  "\u5F53\u524D\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u6BCF %{day} \u5929\u5F3A\u5236\u91CD\u7F6E\u5BC6\u7801\uFF0C\u8BF7\u4FEE\u6539\u5BC6\u7801\u5E76\u91CD\u65B0\u767B\u5F55\u3002": "This organization has set a password reset interval of %{day} days. Please reset your password and log in again.",
  "\u5BC6\u7801\u91CD\u7F6E": "Password reset",
  "\u5BC6\u7801\u6700\u957F %{maxLength} \u4F4D": "Password must be less than %{maxLength} characters",
  "\u8BF7\u8F93\u5165\u65E7\u5BC6\u7801": "Please enter the old password",
  "\u65E7\u5BC6\u7801\u8F93\u5165\u4E0D\u6B63\u786E": "The old password is incorrect",
  "\u65B0\u5BC6\u7801\u4E0D\u53EF\u548C\u65E7\u5BC6\u7801\u4E00\u81F4!": "The new password cannot be the same as the old password!",
  "\u5BC6\u7801\u91CD\u7F6E\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5": "Password reset failed. Please try again.",
  "\u6CE8\u518C\u4FE1\u606F\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5": "Registration information is abnormal. Please try again.",
  "\u56FE\u5F62\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u83B7\u53D6": "CAPTCHA has expired. Please get it again."
};
const lang = navigator.language || "zh-CN";
const translations = {
  "zh-CN": zh,
  "en-US": en
};
let defaultLocale = Object.keys(translations).includes(lang) ? lang : "zh-CN";
let locale = typeof window !== "undefined" && localStorage.getItem("_MASTER_GO_locale_") || defaultLocale;
if (!!(window == null ? void 0 : window.flutter_inappwebview)) {
  defaultLocale = "zh-CN";
  locale = "zh-CN";
}
const i18n = new require$1.I18n(translations, {
  defaultLocale,
  locale,
  defaultSeparator: "$"
});
i18n.missingTranslation.register(
  "message",
  (obj, scope) => locale === "en-US" ? "" : String(scope)
);
const updateEnLocale = (isI18N) => {
  i18n.locales.i18n.translations["en-US"] = isI18N ? en : enMg;
};
const tFn = (scope, options) => i18n.t(scope, options);
const getIsEn = () => {
  return i18n.locale === "en-US" || i18n.locale === "en-US-mg";
};
const SESSION_KEYS = {
  FILE_URL: "file_url",
  UTM_ITEM: "utm_item",
  Y_TOKEN: "yToken",
  GEN_SIGN: "gen_sign",
  WECHAT_CODE: "wechat_code",
  DING_DING_OAUTH_CODE: "ding_ding_oauth_code",
  SUB_TOKEN: "sub_token",
  GOOGLE_CODE: "google_code",
  WECHAT_LOGIN_START: "wechat_login_start",
  EXPERIMENT_STORAGE: "experimentStorageLogin",
  SOURCE_URL: "source_url",
  WE_CHAT_LOGIN_DONE: "we_chat_login_done",
  DING_JUMP_AUTH_CODE: "ding_jump_auth_code",
  INVITE_TOKEN: "invToken",
  SAML_CODE: "errCode",
  RANDOM_NUM: "randomNum",
  PRIVATE_CODE: "privateCode",
  EXTEND_TRACK: "extend_track",
  REDIRECT: "redirect",
  SLACK_CODE: "slack_code",
  LINKEDIN_CODE: "linkedin_code",
  LOGIN_FROM: "login_from",
  SIGN_IN_DATA: "sign_in_data",
  WECOM_CODE: "wecom_code",
  USER_INFO: "userInfo",
  SESSION_STORAGE_LOGOUT_KEYS: [
    "current_org_id",
    "userInfo",
    "productDemandInfo"
  ]
};
const WEI_XIN_FAST_LOGIN_CONFIG = {
  response_type: "code",
  state: "LanHuVX"
};
const isWeiXinFastPage = () => {
  const state = getUrlValue$1("state");
  return state === WEI_XIN_FAST_LOGIN_CONFIG.state;
};
const UTM_TERM = /* @__PURE__ */ new Set([
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term"
]);
const PROMOTE = {
  bd_vid: 1,
  clickid: 2,
  cb: 3,
  qhclickid: 4,
  sg_vid: 5
};
const experimentClient = function() {
  const experimentStr = getSessionStorageItem$1(SESSION_KEYS.EXPERIMENT_STORAGE);
  if (!experimentStr)
    return {};
  return JSON.parse(experimentStr).reduce(
    (rs, str) => {
      const list = str.split(":");
      if (list.length > 1) {
        rs[list[0]] = list[1];
      }
      return rs;
    },
    {}
  );
}();
const projectConfig = {
  imageResource: "https://image-resource.creatie.ai/"
};
const RESET_PASSWORD_CONFIRM_KEY = "resetPasswordConfirm";
var ROUTER_PATH = /* @__PURE__ */ ((ROUTER_PATH2) => {
  ROUTER_PATH2["FILES_HOME"] = "/files/home";
  ROUTER_PATH2["COMMUNITY"] = "/community";
  ROUTER_PATH2["COMMUNITY_PROFILE"] = "/community/profile/id";
  ROUTER_PATH2["OFFICIAL_WEBSITE"] = "/?";
  ROUTER_PATH2["SETTING"] = "/files/account";
  ROUTER_PATH2["LOGIN"] = "/login";
  ROUTER_PATH2["FORGET_PASSWORD"] = "/login/forget-password";
  return ROUTER_PATH2;
})(ROUTER_PATH || {});
var ThirdPartType = /* @__PURE__ */ ((ThirdPartType2) => {
  ThirdPartType2[ThirdPartType2["WEIXIN"] = 0] = "WEIXIN";
  ThirdPartType2[ThirdPartType2["DINGDING"] = 1] = "DINGDING";
  ThirdPartType2[ThirdPartType2["LANHU"] = 2] = "LANHU";
  ThirdPartType2[ThirdPartType2["WECOM"] = 3] = "WECOM";
  return ThirdPartType2;
})(ThirdPartType || {});
var oneBtnStatus = /* @__PURE__ */ ((oneBtnStatus2) => {
  oneBtnStatus2[oneBtnStatus2["ON_INPUT"] = 1] = "ON_INPUT";
  oneBtnStatus2[oneBtnStatus2["IN_REVIEW"] = 2] = "IN_REVIEW";
  oneBtnStatus2[oneBtnStatus2["CHECK_SUCCESS"] = 3] = "CHECK_SUCCESS";
  return oneBtnStatus2;
})(oneBtnStatus || {});
const samlEmailErrCode = {
  NoSupportSSOError: i18n.t("\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F"),
  NoSupportEmail: i18n.t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1"),
  OrganizationFoundError: i18n.t("\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F"),
  OrganizationSSONotOpen: i18n.t("\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F"),
  OrganizationUserDisabled: i18n.t(
    "\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528\uFF0C\u88AB\u9650\u5236\u767B\u5F55\u4F01\u4E1A\u3002\u5982\u6709\u7591\u95EE\u8BF7\u8054\u7CFB\u4F01\u4E1A\u7BA1\u7406\u5458"
  )
};
const samlErrCode = {
  OrganizationUserDisabled: i18n.t("\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528"),
  OrganizationSSONotOpen: i18n.t("\u8BE5\u4F01\u4E1A\u672A\u5F00\u542F SSO \u767B\u5F55\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F"),
  CannotEmptyEmail: i18n.t("\u6CA1\u6709\u90AE\u7BB1\u4FE1\u606F\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458"),
  NoSupportSSOError: i18n.t("\u4F60\u7684\u8D26\u53F7\u672A\u52A0\u5165\u8BE5\u4F01\u4E1A\uFF0C\u8BF7\u4F7F\u7528\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F")
};
const accountErrorCode = {
  default: i18n.t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u6216\u90AE\u7BB1"),
  saml: i18n.t("\u767B\u5F55\u51FA\u73B0\u4E86\u4E00\u4E9B\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u4F60\u7684\u4F01\u4E1A\u7BA1\u7406\u5458"),
  orgEmailErr: i18n.t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u4F01\u4E1A\u90AE\u7BB1"),
  NoSupportEmail: i18n.t("\u6682\u4E0D\u652F\u6301\u6B64\u57DF\u540D\u7684\u90AE\u7BB1\u6CE8\u518C\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u6CE8\u518C\u65B9\u5F0F"),
  emailError: i18n.t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u90AE\u7BB1"),
  UserExists: i18n.t("\u6B64\u8D26\u53F7\u5DF2\u6CE8\u518C\uFF0C\u8BF7\u76F4\u63A5\u767B\u5F55"),
  noCaptcha: i18n.t("\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801"),
  NeedCaptcha: i18n.t("\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801"),
  InvalidCaptcha: i18n.t("\u56FE\u5F62\u9A8C\u8BC1\u7801\u9519\u8BEF"),
  OrganizationEmailDomainRestricted: i18n.t("\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u4EC5\u5141\u8BB8\u4F01\u4E1A\u90AE\u7BB1\u57DF\u7528\u6237\u6CE8\u518C"),
  RegisterClosed: i18n.t("\u672A\u6CE8\u518C\u8D26\u53F7\u65E0\u6CD5\u767B\u5F55\uFF0C\u8BF7\u8054\u7CFB\u7BA1\u7406\u5458"),
  OrganizationUserDisabled: i18n.t("\u4F60\u7684\u8D26\u53F7\u5DF2\u505C\u7528"),
  InvalidParameter: i18n.t("\u6CE8\u518C\u4FE1\u606F\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5"),
  ExpiredCaptcha: i18n.t("\u56FE\u5F62\u9A8C\u8BC1\u7801\u5DF2\u8FC7\u671F\uFF0C\u8BF7\u91CD\u65B0\u83B7\u53D6")
};
var ThemeColor = /* @__PURE__ */ ((ThemeColor2) => {
  ThemeColor2["Dark"] = "dark";
  ThemeColor2["Light"] = "light";
  return ThemeColor2;
})(ThemeColor || {});
var BannerPosition = /* @__PURE__ */ ((BannerPosition2) => {
  BannerPosition2["leftCenter"] = "leftCenter";
  BannerPosition2["fullBackground"] = "fullBackground";
  return BannerPosition2;
})(BannerPosition || {});
var LoginThemeType = /* @__PURE__ */ ((LoginThemeType2) => {
  LoginThemeType2["MasterGo"] = "MasterGo";
  return LoginThemeType2;
})(LoginThemeType || {});
const CacheThemeColorKey = "themeColor";
const API_ERROR_CODE = {
  PasswordReset: "PasswordReset"
};
const isDebug = () => !!localStorage.getItem("debug");
class Log {
  constructor() {
    this.debug = isDebug();
  }
  log(...args) {
    if (this.debug) {
      console.log(...args);
    }
  }
  error(...args) {
    if (this.debug) {
      console.error(...args);
    }
  }
  warn(...args) {
    if (this.debug) {
      console.warn(...args);
    }
  }
  info(...args) {
    if (this.debug) {
      console.info(...args);
    }
  }
  table(...args) {
    if (this.debug) {
      console.table(...args);
    }
  }
  group(...args) {
    if (this.debug) {
      console.group(...args);
    }
  }
}
new Log();
const getUrlKeyReg = (key) => new RegExp(`[&?]${key}=([^&$#]*)`);
const getPathReg = (key = "") => new RegExp(`${key}/(\\d+)`);
function getUrlValue$1(key, url = "") {
  const result = (url || window.location.href).match(getUrlKeyReg(key));
  return result ? result[1] : "";
}
function getUrlData(list) {
  if (!Array.isArray(list)) {
    return {};
  }
  const result = {};
  list.forEach((item) => {
    const middle = getUrlValue$1(item);
    if (middle) {
      result[item] = middle;
    }
  });
  return result || {};
}
function setSessionStorageItem(name2, value) {
  try {
    sessionStorage.setItem(name2, value);
  } catch (error) {
    console.error("setSessionStorageItem error: ", error);
  }
}
function clearSessionStorageItem() {
  try {
    sessionStorage.clear();
  } catch (error) {
    console.error("clearSessionStorageItem error: ", error);
  }
}
function removeSessionStorageItem(name2) {
  try {
    sessionStorage.removeItem(name2);
  } catch (error) {
    console.error("removeSessionStorageItem error: ", error);
  }
}
function getSessionStorageItem$1(name2) {
  try {
    return sessionStorage.getItem(name2);
  } catch (error) {
    console.error("getSessionStorageItem error: ", error);
    return null;
  }
}
function setLocalStorageItem(name2, value) {
  try {
    localStorage.setItem(name2, value);
  } catch (error) {
    console.error("setLocalStorageItem error: ", error);
  }
}
function getLocalStorageItem(name2) {
  try {
    const value = localStorage.getItem(name2);
    return (value == null ? void 0 : value.includes("{")) ? JSON.parse(value) : value;
  } catch (error) {
    console.error("getLocalStorageItem error: ", error);
    return null;
  }
}
const getPathId = (key = "") => {
  const result = window.location.pathname.match(getPathReg(key));
  return result ? result[1] : "";
};
function startRemoveSession(list = []) {
  let targetList = list.length ? list : Object.values(SESSION_KEYS);
  targetList = Array.isArray(targetList) ? targetList : [];
  targetList.forEach((item = "") => {
    removeSessionStorageItem(item);
  });
}
function isChinese(temp) {
  return !/[^\u4e00-\u9fa5]/.test(temp);
}
function isMobile() {
  const computer = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  return !!computer;
}
function isOnlySsoLogin() {
  const onlySsoLoginDomainArr = ["zyt.mastergo.com"];
  return onlySsoLoginDomainArr.includes(window.location.hostname);
}
function transUrl(url) {
  if (!url)
    return url;
  if (/data:image\/\w+;base64/.test(url)) {
    return url;
  }
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return transMobileImgUrl(url);
  }
  return transMobileImgUrl(`${projectConfig.imageResource}${url}`);
}
function transMobileImgUrl(url) {
  var _a2, _b, _c, _d;
  if (!isMobile()) {
    return url;
  }
  const maxW = (_b = (_a2 = window == null ? void 0 : window.document) == null ? void 0 : _a2.body.clientWidth) != null ? _b : 360;
  const maxH = (_d = (_c = window == null ? void 0 : window.document) == null ? void 0 : _c.body.clientHeight) != null ? _d : 640;
  if (~url.indexOf("?")) {
    return url.replace("?", `?x-oss-process=image/resize,h_${maxH},w_${maxW}&`);
  }
  return `${url}?x-oss-process=image/resize,h_${maxH},w_${maxW}`;
}
function parseExperiment(data2) {
  return Object.keys(data2).map((item) => `${item}:${data2[item]}`);
}
function isVscode() {
  if (getSessionStorageItem$1("VSCODE_SESSION_ID"))
    return true;
  if (window.location.href.includes("env=vscode"))
    return true;
  return false;
}
let info;
function platformInfo() {
  if (info)
    return info;
  const userAgent = navigator.userAgent;
  const platform2 = navigator.platform;
  let isWindows = false;
  let isiOS = false;
  let isChromeOS = false;
  let isLinux = false;
  const isMacOs = /Mac/.test(platform2);
  const isElectron2 = /electron/i.test(userAgent);
  if (!isMacOs) {
    isWindows = /Win/.test(platform2);
    if (!isWindows) {
      isiOS = /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
      if (!isiOS) {
        isChromeOS = /CrOS/.test(userAgent);
        if (!isChromeOS) {
          isLinux = /Linux/.test(platform2);
        }
      }
    }
  }
  const safariResult = /version\/([\d.]+).*safari/i.exec(userAgent);
  info = {
    isElectron: isElectron2,
    isOnlyClient: isElectron2 && !isVscode() && !isInIframe(),
    isMac: isMacOs,
    isWindows,
    isiOS,
    isChromeOS,
    isLinux,
    isChrome: userAgent.indexOf("Chrome") > -1,
    isFirefox: userAgent.indexOf("Firefox") > -1,
    isEdge: userAgent.indexOf("Edge") > -1,
    isWeiXin: userAgent.indexOf("MicroMessenger") > -1,
    isSafari: !!safariResult,
    safariVersion: safariResult && safariResult[1],
    isDingDing: /DingTalk/.test(navigator.userAgent)
  };
  return info;
}
const removeQuery = (str, key) => {
  const replaceReg = new RegExp(`${key}=\\w*&|${key}=\\w*$|\\?${key}=\\w*$|${key}=\\w*`);
  return str.replace(replaceReg, "");
};
function isInIframe() {
  return window.self !== window.top;
}
function canUseThiryLogin() {
  return !/\/files\//.test(window.location.href) || /\/files\/home/.test(window.location.href);
}
function getUrlQueries() {
  const start2 = window.location.href.indexOf("?");
  if (start2 === -1)
    return {};
  const end2 = window.location.href.indexOf("#");
  let search2;
  if (end2 === -1) {
    search2 = window.location.href.substring(start2 + 1);
  } else {
    search2 = window.location.href.substring(start2 + 1, end2);
  }
  return search2.split("&").reduce((rs, str) => {
    if (str) {
      const list = str.split("=");
      rs[list[0]] = list[1];
    }
    return rs;
  }, {});
}
function getUrlHash() {
  let hash2 = window.location.hash;
  const i = hash2.indexOf("?");
  if (i !== -1) {
    hash2 = hash2.substring(0, i);
  }
  return hash2;
}
function toSearch(queries) {
  const search2 = Object.keys(queries).map((key) => `${key}=${queries[key]}`).join("&");
  return search2 ? "?" + search2 : "";
}
function deleteUrlQuery(key) {
  if (!key)
    return;
  const queries = getUrlQueries();
  if (key in queries) {
    delete queries[key];
    const search2 = toSearch(queries);
    const hash2 = getUrlHash();
    const url = window.location.origin + window.location.pathname + search2 + hash2;
    window.history.replaceState({}, "", url);
  }
}
function getCacheThemeColor() {
  const cacheThemeColor = getLocalStorageItem(CacheThemeColorKey);
  if (cacheThemeColor && [ThemeColor.Dark, ThemeColor.Light].includes(cacheThemeColor))
    return cacheThemeColor;
  return "";
}
function getThemeColor() {
  const cacheThemeColor = getCacheThemeColor();
  if (cacheThemeColor)
    return cacheThemeColor;
  return window.document && window.document.documentElement.className.split(/\s+/).includes(ThemeColor.Dark) ? ThemeColor.Dark : ThemeColor.Light;
}
function containEmoji(str) {
  return /[\p{Extended_Pictographic}\u{1F3FB}-\u{1F3FF}\u{1F9B0}-\u{1F9B3}]/u.test(str);
}
function isMirror$1() {
  return !!(window == null ? void 0 : window.flutter_inappwebview);
}
const getMirrorVersion = () => {
  if (navigator.userAgent.indexOf("mirror") !== -1) {
    const versionStr = navigator.userAgent.split("mirror ")[1];
    if (!versionStr)
      return void 0;
    return versionStr;
  }
  return void 0;
};
const log$1 = new Log();
function _isElectron(userAgent) {
  const computer = /electron/i.test(userAgent);
  return !!computer;
}
function isElectron() {
  return _isElectron(navigator.userAgent.toUpperCase()) && !isInIframe();
}
function openTab(url, target = "_blank", noopener = true) {
  var _a2;
  if (isElectron()) {
    (_a2 = window == null ? void 0 : window.open) == null ? void 0 : _a2.call(window, url, target);
    return;
  }
  const href = document.createElement("a");
  href.href = url;
  href.rel = noopener ? "noreferrer noopener" : "opener";
  href.target = target;
  document.body.appendChild(href);
  href.click();
  href.remove();
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign$1 = function() {
  __assign$1 = Object.assign || function __assign2(t2) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t2[p] = s[p];
    }
    return t2;
  };
  return __assign$1.apply(this, arguments);
};
function __spreadArray(to2, from, pack) {
  if (pack || arguments.length === 2)
    for (var i = 0, l = from.length, ar2; i < l; i++) {
      if (ar2 || !(i in from)) {
        if (!ar2)
          ar2 = Array.prototype.slice.call(from, 0, i);
        ar2[i] = from[i];
      }
    }
  return to2.concat(ar2 || Array.prototype.slice.call(from));
}
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
var keys = Object.keys;
var isArray$1 = Array.isArray;
if (typeof Promise !== "undefined" && !_global.Promise) {
  _global.Promise = Promise;
}
function extend$1(obj, extension) {
  if (typeof extension !== "object")
    return obj;
  keys(extension).forEach(function(key) {
    obj[key] = extension[key];
  });
  return obj;
}
var getProto = Object.getPrototypeOf;
var _hasOwn = {}.hasOwnProperty;
function hasOwn(obj, prop) {
  return _hasOwn.call(obj, prop);
}
function props(proto, extension) {
  if (typeof extension === "function")
    extension = extension(getProto(proto));
  (typeof Reflect === "undefined" ? keys : Reflect.ownKeys)(extension).forEach(function(key) {
    setProp(proto, key, extension[key]);
  });
}
var defineProperty = Object.defineProperty;
function setProp(obj, prop, functionOrGetSet, options) {
  defineProperty(obj, prop, extend$1(functionOrGetSet && hasOwn(functionOrGetSet, "get") && typeof functionOrGetSet.get === "function" ? { get: functionOrGetSet.get, set: functionOrGetSet.set, configurable: true } : { value: functionOrGetSet, configurable: true, writable: true }, options));
}
function derive(Child) {
  return {
    from: function(Parent) {
      Child.prototype = Object.create(Parent.prototype);
      setProp(Child.prototype, "constructor", Child);
      return {
        extend: props.bind(null, Child.prototype)
      };
    }
  };
}
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
function getPropertyDescriptor(obj, prop) {
  var pd = getOwnPropertyDescriptor(obj, prop);
  var proto;
  return pd || (proto = getProto(obj)) && getPropertyDescriptor(proto, prop);
}
var _slice = [].slice;
function slice(args, start2, end2) {
  return _slice.call(args, start2, end2);
}
function override(origFunc, overridedFactory) {
  return overridedFactory(origFunc);
}
function assert(b2) {
  if (!b2)
    throw new Error("Assertion Failed");
}
function asap$1(fn2) {
  if (_global.setImmediate)
    setImmediate(fn2);
  else
    setTimeout(fn2, 0);
}
function arrayToObject(array, extractor) {
  return array.reduce(function(result, item, i) {
    var nameAndValue = extractor(item, i);
    if (nameAndValue)
      result[nameAndValue[0]] = nameAndValue[1];
    return result;
  }, {});
}
function tryCatch(fn2, onerror, args) {
  try {
    fn2.apply(null, args);
  } catch (ex) {
    onerror && onerror(ex);
  }
}
function getByKeyPath(obj, keyPath) {
  if (typeof keyPath === "string" && hasOwn(obj, keyPath))
    return obj[keyPath];
  if (!keyPath)
    return obj;
  if (typeof keyPath !== "string") {
    var rv = [];
    for (var i = 0, l = keyPath.length; i < l; ++i) {
      var val = getByKeyPath(obj, keyPath[i]);
      rv.push(val);
    }
    return rv;
  }
  var period = keyPath.indexOf(".");
  if (period !== -1) {
    var innerObj = obj[keyPath.substr(0, period)];
    return innerObj == null ? void 0 : getByKeyPath(innerObj, keyPath.substr(period + 1));
  }
  return void 0;
}
function setByKeyPath(obj, keyPath, value) {
  if (!obj || keyPath === void 0)
    return;
  if ("isFrozen" in Object && Object.isFrozen(obj))
    return;
  if (typeof keyPath !== "string" && "length" in keyPath) {
    assert(typeof value !== "string" && "length" in value);
    for (var i = 0, l = keyPath.length; i < l; ++i) {
      setByKeyPath(obj, keyPath[i], value[i]);
    }
  } else {
    var period = keyPath.indexOf(".");
    if (period !== -1) {
      var currentKeyPath = keyPath.substr(0, period);
      var remainingKeyPath = keyPath.substr(period + 1);
      if (remainingKeyPath === "")
        if (value === void 0) {
          if (isArray$1(obj) && !isNaN(parseInt(currentKeyPath)))
            obj.splice(currentKeyPath, 1);
          else
            delete obj[currentKeyPath];
        } else
          obj[currentKeyPath] = value;
      else {
        var innerObj = obj[currentKeyPath];
        if (!innerObj || !hasOwn(obj, currentKeyPath))
          innerObj = obj[currentKeyPath] = {};
        setByKeyPath(innerObj, remainingKeyPath, value);
      }
    } else {
      if (value === void 0) {
        if (isArray$1(obj) && !isNaN(parseInt(keyPath)))
          obj.splice(keyPath, 1);
        else
          delete obj[keyPath];
      } else
        obj[keyPath] = value;
    }
  }
}
function delByKeyPath(obj, keyPath) {
  if (typeof keyPath === "string")
    setByKeyPath(obj, keyPath, void 0);
  else if ("length" in keyPath)
    [].map.call(keyPath, function(kp) {
      setByKeyPath(obj, kp, void 0);
    });
}
function shallowClone(obj) {
  var rv = {};
  for (var m2 in obj) {
    if (hasOwn(obj, m2))
      rv[m2] = obj[m2];
  }
  return rv;
}
var concat = [].concat;
function flatten(a2) {
  return concat.apply([], a2);
}
var intrinsicTypeNames = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(flatten([8, 16, 32, 64].map(function(num) {
  return ["Int", "Uint", "Float"].map(function(t2) {
    return t2 + num + "Array";
  });
}))).filter(function(t2) {
  return _global[t2];
});
var intrinsicTypes = intrinsicTypeNames.map(function(t2) {
  return _global[t2];
});
arrayToObject(intrinsicTypeNames, function(x) {
  return [x, true];
});
var circularRefs = null;
function deepClone(any) {
  circularRefs = typeof WeakMap !== "undefined" && /* @__PURE__ */ new WeakMap();
  var rv = innerDeepClone(any);
  circularRefs = null;
  return rv;
}
function innerDeepClone(any) {
  if (!any || typeof any !== "object")
    return any;
  var rv = circularRefs && circularRefs.get(any);
  if (rv)
    return rv;
  if (isArray$1(any)) {
    rv = [];
    circularRefs && circularRefs.set(any, rv);
    for (var i = 0, l = any.length; i < l; ++i) {
      rv.push(innerDeepClone(any[i]));
    }
  } else if (intrinsicTypes.indexOf(any.constructor) >= 0) {
    rv = any;
  } else {
    var proto = getProto(any);
    rv = proto === Object.prototype ? {} : Object.create(proto);
    circularRefs && circularRefs.set(any, rv);
    for (var prop in any) {
      if (hasOwn(any, prop)) {
        rv[prop] = innerDeepClone(any[prop]);
      }
    }
  }
  return rv;
}
var toString$1 = {}.toString;
function toStringTag(o2) {
  return toString$1.call(o2).slice(8, -1);
}
var iteratorSymbol = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
var getIteratorOf = typeof iteratorSymbol === "symbol" ? function(x) {
  var i;
  return x != null && (i = x[iteratorSymbol]) && i.apply(x);
} : function() {
  return null;
};
var NO_CHAR_ARRAY = {};
function getArrayOf(arrayLike) {
  var i, a2, x, it2;
  if (arguments.length === 1) {
    if (isArray$1(arrayLike))
      return arrayLike.slice();
    if (this === NO_CHAR_ARRAY && typeof arrayLike === "string")
      return [arrayLike];
    if (it2 = getIteratorOf(arrayLike)) {
      a2 = [];
      while (x = it2.next(), !x.done)
        a2.push(x.value);
      return a2;
    }
    if (arrayLike == null)
      return [arrayLike];
    i = arrayLike.length;
    if (typeof i === "number") {
      a2 = new Array(i);
      while (i--)
        a2[i] = arrayLike[i];
      return a2;
    }
    return [arrayLike];
  }
  i = arguments.length;
  a2 = new Array(i);
  while (i--)
    a2[i] = arguments[i];
  return a2;
}
var isAsyncFunction = typeof Symbol !== "undefined" ? function(fn2) {
  return fn2[Symbol.toStringTag] === "AsyncFunction";
} : function() {
  return false;
};
var debug$4 = typeof location !== "undefined" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function setDebug(value, filter) {
  debug$4 = value;
  libraryFilter = filter;
}
var libraryFilter = function() {
  return true;
};
var NEEDS_THROW_FOR_STACK = !new Error("").stack;
function getErrorWithStack() {
  if (NEEDS_THROW_FOR_STACK)
    try {
      getErrorWithStack.arguments;
      throw new Error();
    } catch (e2) {
      return e2;
    }
  return new Error();
}
function prettyStack(exception, numIgnoredFrames) {
  var stack = exception.stack;
  if (!stack)
    return "";
  numIgnoredFrames = numIgnoredFrames || 0;
  if (stack.indexOf(exception.name) === 0)
    numIgnoredFrames += (exception.name + exception.message).split("\n").length;
  return stack.split("\n").slice(numIgnoredFrames).filter(libraryFilter).map(function(frame) {
    return "\n" + frame;
  }).join("");
}
var dexieErrorNames = [
  "Modify",
  "Bulk",
  "OpenFailed",
  "VersionChange",
  "Schema",
  "Upgrade",
  "InvalidTable",
  "MissingAPI",
  "NoSuchDatabase",
  "InvalidArgument",
  "SubTransaction",
  "Unsupported",
  "Internal",
  "DatabaseClosed",
  "PrematureCommit",
  "ForeignAwait"
];
var idbDomErrorNames = [
  "Unknown",
  "Constraint",
  "Data",
  "TransactionInactive",
  "ReadOnly",
  "Version",
  "NotFound",
  "InvalidState",
  "InvalidAccess",
  "Abort",
  "Timeout",
  "QuotaExceeded",
  "Syntax",
  "DataClone"
];
var errorList = dexieErrorNames.concat(idbDomErrorNames);
var defaultTexts = {
  VersionChanged: "Database version changed by other database connection",
  DatabaseClosed: "Database has been closed",
  Abort: "Transaction aborted",
  TransactionInactive: "Transaction has already completed or failed",
  MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
};
function DexieError(name2, msg) {
  this._e = getErrorWithStack();
  this.name = name2;
  this.message = msg;
}
derive(DexieError).from(Error).extend({
  stack: {
    get: function() {
      return this._stack || (this._stack = this.name + ": " + this.message + prettyStack(this._e, 2));
    }
  },
  toString: function() {
    return this.name + ": " + this.message;
  }
});
function getMultiErrorMessage(msg, failures) {
  return msg + ". Errors: " + Object.keys(failures).map(function(key) {
    return failures[key].toString();
  }).filter(function(v, i, s) {
    return s.indexOf(v) === i;
  }).join("\n");
}
function ModifyError(msg, failures, successCount, failedKeys) {
  this._e = getErrorWithStack();
  this.failures = failures;
  this.failedKeys = failedKeys;
  this.successCount = successCount;
  this.message = getMultiErrorMessage(msg, failures);
}
derive(ModifyError).from(DexieError);
function BulkError(msg, failures) {
  this._e = getErrorWithStack();
  this.name = "BulkError";
  this.failures = Object.keys(failures).map(function(pos) {
    return failures[pos];
  });
  this.failuresByPos = failures;
  this.message = getMultiErrorMessage(msg, failures);
}
derive(BulkError).from(DexieError);
var errnames = errorList.reduce(function(obj, name2) {
  return obj[name2] = name2 + "Error", obj;
}, {});
var BaseException = DexieError;
var exceptions = errorList.reduce(function(obj, name2) {
  var fullName = name2 + "Error";
  function DexieError2(msgOrInner, inner) {
    this._e = getErrorWithStack();
    this.name = fullName;
    if (!msgOrInner) {
      this.message = defaultTexts[name2] || fullName;
      this.inner = null;
    } else if (typeof msgOrInner === "string") {
      this.message = "" + msgOrInner + (!inner ? "" : "\n " + inner);
      this.inner = inner || null;
    } else if (typeof msgOrInner === "object") {
      this.message = msgOrInner.name + " " + msgOrInner.message;
      this.inner = msgOrInner;
    }
  }
  derive(DexieError2).from(BaseException);
  obj[name2] = DexieError2;
  return obj;
}, {});
exceptions.Syntax = SyntaxError;
exceptions.Type = TypeError;
exceptions.Range = RangeError;
var exceptionMap = idbDomErrorNames.reduce(function(obj, name2) {
  obj[name2 + "Error"] = exceptions[name2];
  return obj;
}, {});
function mapError(domError, message) {
  if (!domError || domError instanceof DexieError || domError instanceof TypeError || domError instanceof SyntaxError || !domError.name || !exceptionMap[domError.name])
    return domError;
  var rv = new exceptionMap[domError.name](message || domError.message, domError);
  if ("stack" in domError) {
    setProp(rv, "stack", { get: function() {
      return this.inner.stack;
    } });
  }
  return rv;
}
var fullNameExceptions = errorList.reduce(function(obj, name2) {
  if (["Syntax", "Type", "Range"].indexOf(name2) === -1)
    obj[name2 + "Error"] = exceptions[name2];
  return obj;
}, {});
fullNameExceptions.ModifyError = ModifyError;
fullNameExceptions.DexieError = DexieError;
fullNameExceptions.BulkError = BulkError;
function nop() {
}
function mirror(val) {
  return val;
}
function pureFunctionChain(f1, f2) {
  if (f1 == null || f1 === mirror)
    return f2;
  return function(val) {
    return f2(f1(val));
  };
}
function callBoth(on1, on2) {
  return function() {
    on1.apply(this, arguments);
    on2.apply(this, arguments);
  };
}
function hookCreatingChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    var res = f1.apply(this, arguments);
    if (res !== void 0)
      arguments[0] = res;
    var onsuccess = this.onsuccess, onerror = this.onerror;
    this.onsuccess = null;
    this.onerror = null;
    var res2 = f2.apply(this, arguments);
    if (onsuccess)
      this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
    if (onerror)
      this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
    return res2 !== void 0 ? res2 : res;
  };
}
function hookDeletingChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    f1.apply(this, arguments);
    var onsuccess = this.onsuccess, onerror = this.onerror;
    this.onsuccess = this.onerror = null;
    f2.apply(this, arguments);
    if (onsuccess)
      this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
    if (onerror)
      this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
  };
}
function hookUpdatingChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function(modifications) {
    var res = f1.apply(this, arguments);
    extend$1(modifications, res);
    var onsuccess = this.onsuccess, onerror = this.onerror;
    this.onsuccess = null;
    this.onerror = null;
    var res2 = f2.apply(this, arguments);
    if (onsuccess)
      this.onsuccess = this.onsuccess ? callBoth(onsuccess, this.onsuccess) : onsuccess;
    if (onerror)
      this.onerror = this.onerror ? callBoth(onerror, this.onerror) : onerror;
    return res === void 0 ? res2 === void 0 ? void 0 : res2 : extend$1(res, res2);
  };
}
function reverseStoppableEventChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    if (f2.apply(this, arguments) === false)
      return false;
    return f1.apply(this, arguments);
  };
}
function promisableChain(f1, f2) {
  if (f1 === nop)
    return f2;
  return function() {
    var res = f1.apply(this, arguments);
    if (res && typeof res.then === "function") {
      var thiz = this, i = arguments.length, args = new Array(i);
      while (i--)
        args[i] = arguments[i];
      return res.then(function() {
        return f2.apply(thiz, args);
      });
    }
    return f2.apply(this, arguments);
  };
}
var INTERNAL = {};
var LONG_STACKS_CLIP_LIMIT = 100, MAX_LONG_STACKS = 20, ZONE_ECHO_LIMIT = 100, _a$1$1 = typeof Promise === "undefined" ? [] : function() {
  var globalP = Promise.resolve();
  if (typeof crypto === "undefined" || !crypto.subtle)
    return [globalP, getProto(globalP), globalP];
  var nativeP = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
  return [
    nativeP,
    getProto(nativeP),
    globalP
  ];
}(), resolvedNativePromise = _a$1$1[0], nativePromiseProto = _a$1$1[1], resolvedGlobalPromise = _a$1$1[2], nativePromiseThen = nativePromiseProto && nativePromiseProto.then;
var NativePromise = resolvedNativePromise && resolvedNativePromise.constructor;
var patchGlobalPromise = !!resolvedGlobalPromise;
var stack_being_generated = false;
var schedulePhysicalTick = resolvedGlobalPromise ? function() {
  resolvedGlobalPromise.then(physicalTick);
} : _global.setImmediate ? setImmediate.bind(null, physicalTick) : _global.MutationObserver ? function() {
  var hiddenDiv = document.createElement("div");
  new MutationObserver(function() {
    physicalTick();
    hiddenDiv = null;
  }).observe(hiddenDiv, { attributes: true });
  hiddenDiv.setAttribute("i", "1");
} : function() {
  setTimeout(physicalTick, 0);
};
var asap = function(callback, args) {
  microtickQueue.push([callback, args]);
  if (needsNewPhysicalTick) {
    schedulePhysicalTick();
    needsNewPhysicalTick = false;
  }
};
var isOutsideMicroTick = true, needsNewPhysicalTick = true, unhandledErrors = [], rejectingErrors = [], currentFulfiller = null, rejectionMapper = mirror;
var globalPSD = {
  id: "global",
  global: true,
  ref: 0,
  unhandleds: [],
  onunhandled: globalError,
  pgp: false,
  env: {},
  finalize: function() {
    this.unhandleds.forEach(function(uh) {
      try {
        globalError(uh[0], uh[1]);
      } catch (e2) {
      }
    });
  }
};
var PSD = globalPSD;
var microtickQueue = [];
var numScheduledCalls = 0;
var tickFinalizers = [];
function DexiePromise(fn2) {
  if (typeof this !== "object")
    throw new TypeError("Promises must be constructed via new");
  this._listeners = [];
  this.onuncatched = nop;
  this._lib = false;
  var psd = this._PSD = PSD;
  if (debug$4) {
    this._stackHolder = getErrorWithStack();
    this._prev = null;
    this._numPrev = 0;
  }
  if (typeof fn2 !== "function") {
    if (fn2 !== INTERNAL)
      throw new TypeError("Not a function");
    this._state = arguments[1];
    this._value = arguments[2];
    if (this._state === false)
      handleRejection(this, this._value);
    return;
  }
  this._state = null;
  this._value = null;
  ++psd.ref;
  executePromiseTask(this, fn2);
}
var thenProp = {
  get: function() {
    var psd = PSD, microTaskId = totalEchoes;
    function then(onFulfilled, onRejected) {
      var _this = this;
      var possibleAwait = !psd.global && (psd !== PSD || microTaskId !== totalEchoes);
      var cleanup = possibleAwait && !decrementExpectedAwaits();
      var rv = new DexiePromise(function(resolve, reject) {
        propagateToListener(_this, new Listener(nativeAwaitCompatibleWrap(onFulfilled, psd, possibleAwait, cleanup), nativeAwaitCompatibleWrap(onRejected, psd, possibleAwait, cleanup), resolve, reject, psd));
      });
      debug$4 && linkToPreviousPromise(rv, this);
      return rv;
    }
    then.prototype = INTERNAL;
    return then;
  },
  set: function(value) {
    setProp(this, "then", value && value.prototype === INTERNAL ? thenProp : {
      get: function() {
        return value;
      },
      set: thenProp.set
    });
  }
};
props(DexiePromise.prototype, {
  then: thenProp,
  _then: function(onFulfilled, onRejected) {
    propagateToListener(this, new Listener(null, null, onFulfilled, onRejected, PSD));
  },
  catch: function(onRejected) {
    if (arguments.length === 1)
      return this.then(null, onRejected);
    var type2 = arguments[0], handler = arguments[1];
    return typeof type2 === "function" ? this.then(null, function(err) {
      return err instanceof type2 ? handler(err) : PromiseReject(err);
    }) : this.then(null, function(err) {
      return err && err.name === type2 ? handler(err) : PromiseReject(err);
    });
  },
  finally: function(onFinally) {
    return this.then(function(value) {
      onFinally();
      return value;
    }, function(err) {
      onFinally();
      return PromiseReject(err);
    });
  },
  stack: {
    get: function() {
      if (this._stack)
        return this._stack;
      try {
        stack_being_generated = true;
        var stacks = getStack(this, [], MAX_LONG_STACKS);
        var stack = stacks.join("\nFrom previous: ");
        if (this._state !== null)
          this._stack = stack;
        return stack;
      } finally {
        stack_being_generated = false;
      }
    }
  },
  timeout: function(ms2, msg) {
    var _this = this;
    return ms2 < Infinity ? new DexiePromise(function(resolve, reject) {
      var handle = setTimeout(function() {
        return reject(new exceptions.Timeout(msg));
      }, ms2);
      _this.then(resolve, reject).finally(clearTimeout.bind(null, handle));
    }) : this;
  }
});
if (typeof Symbol !== "undefined" && Symbol.toStringTag)
  setProp(DexiePromise.prototype, Symbol.toStringTag, "Dexie.Promise");
globalPSD.env = snapShot();
function Listener(onFulfilled, onRejected, resolve, reject, zone) {
  this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
  this.onRejected = typeof onRejected === "function" ? onRejected : null;
  this.resolve = resolve;
  this.reject = reject;
  this.psd = zone;
}
props(DexiePromise, {
  all: function() {
    var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
    return new DexiePromise(function(resolve, reject) {
      if (values.length === 0)
        resolve([]);
      var remaining = values.length;
      values.forEach(function(a2, i) {
        return DexiePromise.resolve(a2).then(function(x) {
          values[i] = x;
          if (!--remaining)
            resolve(values);
        }, reject);
      });
    });
  },
  resolve: function(value) {
    if (value instanceof DexiePromise)
      return value;
    if (value && typeof value.then === "function")
      return new DexiePromise(function(resolve, reject) {
        value.then(resolve, reject);
      });
    var rv = new DexiePromise(INTERNAL, true, value);
    linkToPreviousPromise(rv, currentFulfiller);
    return rv;
  },
  reject: PromiseReject,
  race: function() {
    var values = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
    return new DexiePromise(function(resolve, reject) {
      values.map(function(value) {
        return DexiePromise.resolve(value).then(resolve, reject);
      });
    });
  },
  PSD: {
    get: function() {
      return PSD;
    },
    set: function(value) {
      return PSD = value;
    }
  },
  totalEchoes: { get: function() {
    return totalEchoes;
  } },
  newPSD: newScope,
  usePSD,
  scheduler: {
    get: function() {
      return asap;
    },
    set: function(value) {
      asap = value;
    }
  },
  rejectionMapper: {
    get: function() {
      return rejectionMapper;
    },
    set: function(value) {
      rejectionMapper = value;
    }
  },
  follow: function(fn2, zoneProps) {
    return new DexiePromise(function(resolve, reject) {
      return newScope(function(resolve2, reject2) {
        var psd = PSD;
        psd.unhandleds = [];
        psd.onunhandled = reject2;
        psd.finalize = callBoth(function() {
          var _this = this;
          run_at_end_of_this_or_next_physical_tick(function() {
            _this.unhandleds.length === 0 ? resolve2() : reject2(_this.unhandleds[0]);
          });
        }, psd.finalize);
        fn2();
      }, zoneProps, resolve, reject);
    });
  }
});
if (NativePromise) {
  if (NativePromise.allSettled)
    setProp(DexiePromise, "allSettled", function() {
      var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
      return new DexiePromise(function(resolve) {
        if (possiblePromises.length === 0)
          resolve([]);
        var remaining = possiblePromises.length;
        var results = new Array(remaining);
        possiblePromises.forEach(function(p, i) {
          return DexiePromise.resolve(p).then(function(value) {
            return results[i] = { status: "fulfilled", value };
          }, function(reason) {
            return results[i] = { status: "rejected", reason };
          }).then(function() {
            return --remaining || resolve(results);
          });
        });
      });
    });
  if (NativePromise.any && typeof AggregateError !== "undefined")
    setProp(DexiePromise, "any", function() {
      var possiblePromises = getArrayOf.apply(null, arguments).map(onPossibleParallellAsync);
      return new DexiePromise(function(resolve, reject) {
        if (possiblePromises.length === 0)
          reject(new AggregateError([]));
        var remaining = possiblePromises.length;
        var failures = new Array(remaining);
        possiblePromises.forEach(function(p, i) {
          return DexiePromise.resolve(p).then(function(value) {
            return resolve(value);
          }, function(failure) {
            failures[i] = failure;
            if (!--remaining)
              reject(new AggregateError(failures));
          });
        });
      });
    });
}
function executePromiseTask(promise, fn2) {
  try {
    fn2(function(value) {
      if (promise._state !== null)
        return;
      if (value === promise)
        throw new TypeError("A promise cannot be resolved with itself.");
      var shouldExecuteTick = promise._lib && beginMicroTickScope();
      if (value && typeof value.then === "function") {
        executePromiseTask(promise, function(resolve, reject) {
          value instanceof DexiePromise ? value._then(resolve, reject) : value.then(resolve, reject);
        });
      } else {
        promise._state = true;
        promise._value = value;
        propagateAllListeners(promise);
      }
      if (shouldExecuteTick)
        endMicroTickScope();
    }, handleRejection.bind(null, promise));
  } catch (ex) {
    handleRejection(promise, ex);
  }
}
function handleRejection(promise, reason) {
  rejectingErrors.push(reason);
  if (promise._state !== null)
    return;
  var shouldExecuteTick = promise._lib && beginMicroTickScope();
  reason = rejectionMapper(reason);
  promise._state = false;
  promise._value = reason;
  debug$4 && reason !== null && typeof reason === "object" && !reason._promise && tryCatch(function() {
    var origProp = getPropertyDescriptor(reason, "stack");
    reason._promise = promise;
    setProp(reason, "stack", {
      get: function() {
        return stack_being_generated ? origProp && (origProp.get ? origProp.get.apply(reason) : origProp.value) : promise.stack;
      }
    });
  });
  addPossiblyUnhandledError(promise);
  propagateAllListeners(promise);
  if (shouldExecuteTick)
    endMicroTickScope();
}
function propagateAllListeners(promise) {
  var listeners = promise._listeners;
  promise._listeners = [];
  for (var i = 0, len = listeners.length; i < len; ++i) {
    propagateToListener(promise, listeners[i]);
  }
  var psd = promise._PSD;
  --psd.ref || psd.finalize();
  if (numScheduledCalls === 0) {
    ++numScheduledCalls;
    asap(function() {
      if (--numScheduledCalls === 0)
        finalizePhysicalTick();
    }, []);
  }
}
function propagateToListener(promise, listener) {
  if (promise._state === null) {
    promise._listeners.push(listener);
    return;
  }
  var cb = promise._state ? listener.onFulfilled : listener.onRejected;
  if (cb === null) {
    return (promise._state ? listener.resolve : listener.reject)(promise._value);
  }
  ++listener.psd.ref;
  ++numScheduledCalls;
  asap(callListener, [cb, promise, listener]);
}
function callListener(cb, promise, listener) {
  try {
    currentFulfiller = promise;
    var ret, value = promise._value;
    if (promise._state) {
      ret = cb(value);
    } else {
      if (rejectingErrors.length)
        rejectingErrors = [];
      ret = cb(value);
      if (rejectingErrors.indexOf(value) === -1)
        markErrorAsHandled(promise);
    }
    listener.resolve(ret);
  } catch (e2) {
    listener.reject(e2);
  } finally {
    currentFulfiller = null;
    if (--numScheduledCalls === 0)
      finalizePhysicalTick();
    --listener.psd.ref || listener.psd.finalize();
  }
}
function getStack(promise, stacks, limit) {
  if (stacks.length === limit)
    return stacks;
  var stack = "";
  if (promise._state === false) {
    var failure = promise._value, errorName, message;
    if (failure != null) {
      errorName = failure.name || "Error";
      message = failure.message || failure;
      stack = prettyStack(failure, 0);
    } else {
      errorName = failure;
      message = "";
    }
    stacks.push(errorName + (message ? ": " + message : "") + stack);
  }
  if (debug$4) {
    stack = prettyStack(promise._stackHolder, 2);
    if (stack && stacks.indexOf(stack) === -1)
      stacks.push(stack);
    if (promise._prev)
      getStack(promise._prev, stacks, limit);
  }
  return stacks;
}
function linkToPreviousPromise(promise, prev) {
  var numPrev = prev ? prev._numPrev + 1 : 0;
  if (numPrev < LONG_STACKS_CLIP_LIMIT) {
    promise._prev = prev;
    promise._numPrev = numPrev;
  }
}
function physicalTick() {
  beginMicroTickScope() && endMicroTickScope();
}
function beginMicroTickScope() {
  var wasRootExec = isOutsideMicroTick;
  isOutsideMicroTick = false;
  needsNewPhysicalTick = false;
  return wasRootExec;
}
function endMicroTickScope() {
  var callbacks, i, l;
  do {
    while (microtickQueue.length > 0) {
      callbacks = microtickQueue;
      microtickQueue = [];
      l = callbacks.length;
      for (i = 0; i < l; ++i) {
        var item = callbacks[i];
        item[0].apply(null, item[1]);
      }
    }
  } while (microtickQueue.length > 0);
  isOutsideMicroTick = true;
  needsNewPhysicalTick = true;
}
function finalizePhysicalTick() {
  var unhandledErrs = unhandledErrors;
  unhandledErrors = [];
  unhandledErrs.forEach(function(p) {
    p._PSD.onunhandled.call(null, p._value, p);
  });
  var finalizers = tickFinalizers.slice(0);
  var i = finalizers.length;
  while (i)
    finalizers[--i]();
}
function run_at_end_of_this_or_next_physical_tick(fn2) {
  function finalizer() {
    fn2();
    tickFinalizers.splice(tickFinalizers.indexOf(finalizer), 1);
  }
  tickFinalizers.push(finalizer);
  ++numScheduledCalls;
  asap(function() {
    if (--numScheduledCalls === 0)
      finalizePhysicalTick();
  }, []);
}
function addPossiblyUnhandledError(promise) {
  if (!unhandledErrors.some(function(p) {
    return p._value === promise._value;
  }))
    unhandledErrors.push(promise);
}
function markErrorAsHandled(promise) {
  var i = unhandledErrors.length;
  while (i)
    if (unhandledErrors[--i]._value === promise._value) {
      unhandledErrors.splice(i, 1);
      return;
    }
}
function PromiseReject(reason) {
  return new DexiePromise(INTERNAL, false, reason);
}
function wrap(fn2, errorCatcher) {
  var psd = PSD;
  return function() {
    var wasRootExec = beginMicroTickScope(), outerScope = PSD;
    try {
      switchToZone(psd, true);
      return fn2.apply(this, arguments);
    } catch (e2) {
      errorCatcher && errorCatcher(e2);
    } finally {
      switchToZone(outerScope, false);
      if (wasRootExec)
        endMicroTickScope();
    }
  };
}
var task = { awaits: 0, echoes: 0, id: 0 };
var taskCounter = 0;
var zoneStack = [];
var zoneEchoes = 0;
var totalEchoes = 0;
var zone_id_counter = 0;
function newScope(fn2, props2, a1, a2) {
  var parent = PSD, psd = Object.create(parent);
  psd.parent = parent;
  psd.ref = 0;
  psd.global = false;
  psd.id = ++zone_id_counter;
  var globalEnv = globalPSD.env;
  psd.env = patchGlobalPromise ? {
    Promise: DexiePromise,
    PromiseProp: { value: DexiePromise, configurable: true, writable: true },
    all: DexiePromise.all,
    race: DexiePromise.race,
    allSettled: DexiePromise.allSettled,
    any: DexiePromise.any,
    resolve: DexiePromise.resolve,
    reject: DexiePromise.reject,
    nthen: getPatchedPromiseThen(globalEnv.nthen, psd),
    gthen: getPatchedPromiseThen(globalEnv.gthen, psd)
  } : {};
  if (props2)
    extend$1(psd, props2);
  ++parent.ref;
  psd.finalize = function() {
    --this.parent.ref || this.parent.finalize();
  };
  var rv = usePSD(psd, fn2, a1, a2);
  if (psd.ref === 0)
    psd.finalize();
  return rv;
}
function incrementExpectedAwaits() {
  if (!task.id)
    task.id = ++taskCounter;
  ++task.awaits;
  task.echoes += ZONE_ECHO_LIMIT;
  return task.id;
}
function decrementExpectedAwaits() {
  if (!task.awaits)
    return false;
  if (--task.awaits === 0)
    task.id = 0;
  task.echoes = task.awaits * ZONE_ECHO_LIMIT;
  return true;
}
if (("" + nativePromiseThen).indexOf("[native code]") === -1) {
  incrementExpectedAwaits = decrementExpectedAwaits = nop;
}
function onPossibleParallellAsync(possiblePromise) {
  if (task.echoes && possiblePromise && possiblePromise.constructor === NativePromise) {
    incrementExpectedAwaits();
    return possiblePromise.then(function(x) {
      decrementExpectedAwaits();
      return x;
    }, function(e2) {
      decrementExpectedAwaits();
      return rejection(e2);
    });
  }
  return possiblePromise;
}
function zoneEnterEcho(targetZone) {
  ++totalEchoes;
  if (!task.echoes || --task.echoes === 0) {
    task.echoes = task.id = 0;
  }
  zoneStack.push(PSD);
  switchToZone(targetZone, true);
}
function zoneLeaveEcho() {
  var zone = zoneStack[zoneStack.length - 1];
  zoneStack.pop();
  switchToZone(zone, false);
}
function switchToZone(targetZone, bEnteringZone) {
  var currentZone = PSD;
  if (bEnteringZone ? task.echoes && (!zoneEchoes++ || targetZone !== PSD) : zoneEchoes && (!--zoneEchoes || targetZone !== PSD)) {
    enqueueNativeMicroTask(bEnteringZone ? zoneEnterEcho.bind(null, targetZone) : zoneLeaveEcho);
  }
  if (targetZone === PSD)
    return;
  PSD = targetZone;
  if (currentZone === globalPSD)
    globalPSD.env = snapShot();
  if (patchGlobalPromise) {
    var GlobalPromise_1 = globalPSD.env.Promise;
    var targetEnv = targetZone.env;
    nativePromiseProto.then = targetEnv.nthen;
    GlobalPromise_1.prototype.then = targetEnv.gthen;
    if (currentZone.global || targetZone.global) {
      Object.defineProperty(_global, "Promise", targetEnv.PromiseProp);
      GlobalPromise_1.all = targetEnv.all;
      GlobalPromise_1.race = targetEnv.race;
      GlobalPromise_1.resolve = targetEnv.resolve;
      GlobalPromise_1.reject = targetEnv.reject;
      if (targetEnv.allSettled)
        GlobalPromise_1.allSettled = targetEnv.allSettled;
      if (targetEnv.any)
        GlobalPromise_1.any = targetEnv.any;
    }
  }
}
function snapShot() {
  var GlobalPromise = _global.Promise;
  return patchGlobalPromise ? {
    Promise: GlobalPromise,
    PromiseProp: Object.getOwnPropertyDescriptor(_global, "Promise"),
    all: GlobalPromise.all,
    race: GlobalPromise.race,
    allSettled: GlobalPromise.allSettled,
    any: GlobalPromise.any,
    resolve: GlobalPromise.resolve,
    reject: GlobalPromise.reject,
    nthen: nativePromiseProto.then,
    gthen: GlobalPromise.prototype.then
  } : {};
}
function usePSD(psd, fn2, a1, a2, a3) {
  var outerScope = PSD;
  try {
    switchToZone(psd, true);
    return fn2(a1, a2, a3);
  } finally {
    switchToZone(outerScope, false);
  }
}
function enqueueNativeMicroTask(job) {
  nativePromiseThen.call(resolvedNativePromise, job);
}
function nativeAwaitCompatibleWrap(fn2, zone, possibleAwait, cleanup) {
  return typeof fn2 !== "function" ? fn2 : function() {
    var outerZone = PSD;
    if (possibleAwait)
      incrementExpectedAwaits();
    switchToZone(zone, true);
    try {
      return fn2.apply(this, arguments);
    } finally {
      switchToZone(outerZone, false);
      if (cleanup)
        enqueueNativeMicroTask(decrementExpectedAwaits);
    }
  };
}
function getPatchedPromiseThen(origThen, zone) {
  return function(onResolved, onRejected) {
    return origThen.call(this, nativeAwaitCompatibleWrap(onResolved, zone), nativeAwaitCompatibleWrap(onRejected, zone));
  };
}
var UNHANDLEDREJECTION = "unhandledrejection";
function globalError(err, promise) {
  var rv;
  try {
    rv = promise.onuncatched(err);
  } catch (e2) {
  }
  if (rv !== false)
    try {
      var event, eventData = { promise, reason: err };
      if (_global.document && document.createEvent) {
        event = document.createEvent("Event");
        event.initEvent(UNHANDLEDREJECTION, true, true);
        extend$1(event, eventData);
      } else if (_global.CustomEvent) {
        event = new CustomEvent(UNHANDLEDREJECTION, { detail: eventData });
        extend$1(event, eventData);
      }
      if (event && _global.dispatchEvent) {
        dispatchEvent(event);
        if (!_global.PromiseRejectionEvent && _global.onunhandledrejection)
          try {
            _global.onunhandledrejection(event);
          } catch (_2) {
          }
      }
      if (debug$4 && event && !event.defaultPrevented) {
        console.warn("Unhandled rejection: " + (err.stack || err));
      }
    } catch (e2) {
    }
}
var rejection = DexiePromise.reject;
function tempTransaction(db, mode, storeNames, fn2) {
  if (!db.idbdb || !db._state.openComplete && (!PSD.letThrough && !db._vip)) {
    if (db._state.openComplete) {
      return rejection(new exceptions.DatabaseClosed(db._state.dbOpenError));
    }
    if (!db._state.isBeingOpened) {
      if (!db._options.autoOpen)
        return rejection(new exceptions.DatabaseClosed());
      db.open().catch(nop);
    }
    return db._state.dbReadyPromise.then(function() {
      return tempTransaction(db, mode, storeNames, fn2);
    });
  } else {
    var trans = db._createTransaction(mode, storeNames, db._dbSchema);
    try {
      trans.create();
      db._state.PR1398_maxLoop = 3;
    } catch (ex) {
      if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
        console.warn("Dexie: Need to reopen db");
        db._close();
        return db.open().then(function() {
          return tempTransaction(db, mode, storeNames, fn2);
        });
      }
      return rejection(ex);
    }
    return trans._promise(mode, function(resolve, reject) {
      return newScope(function() {
        PSD.trans = trans;
        return fn2(resolve, reject, trans);
      });
    }).then(function(result) {
      return trans._completion.then(function() {
        return result;
      });
    });
  }
}
var DEXIE_VERSION = "3.2.7";
var maxString = String.fromCharCode(65535);
var minKey = -Infinity;
var INVALID_KEY_ARGUMENT = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.";
var STRING_EXPECTED = "String expected.";
var connections = [];
var isIEOrEdge = typeof navigator !== "undefined" && /(MSIE|Trident|Edge)/.test(navigator.userAgent);
var hasIEDeleteObjectStoreBug = isIEOrEdge;
var hangsOnDeleteLargeKeyRange = isIEOrEdge;
var dexieStackFrameFilter = function(frame) {
  return !/(dexie\.js|dexie\.min\.js)/.test(frame);
};
var DBNAMES_DB = "__dbnames";
var READONLY = "readonly";
var READWRITE = "readwrite";
function combine(filter1, filter2) {
  return filter1 ? filter2 ? function() {
    return filter1.apply(this, arguments) && filter2.apply(this, arguments);
  } : filter1 : filter2;
}
var AnyRange = {
  type: 3,
  lower: -Infinity,
  lowerOpen: false,
  upper: [[]],
  upperOpen: false
};
function workaroundForUndefinedPrimKey(keyPath) {
  return typeof keyPath === "string" && !/\./.test(keyPath) ? function(obj) {
    if (obj[keyPath] === void 0 && keyPath in obj) {
      obj = deepClone(obj);
      delete obj[keyPath];
    }
    return obj;
  } : function(obj) {
    return obj;
  };
}
var Table = function() {
  function Table2() {
  }
  Table2.prototype._trans = function(mode, fn2, writeLocked) {
    var trans = this._tx || PSD.trans;
    var tableName = this.name;
    function checkTableInTransaction(resolve, reject, trans2) {
      if (!trans2.schema[tableName])
        throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
      return fn2(trans2.idbtrans, trans2);
    }
    var wasRootExec = beginMicroTickScope();
    try {
      return trans && trans.db === this.db ? trans === PSD.trans ? trans._promise(mode, checkTableInTransaction, writeLocked) : newScope(function() {
        return trans._promise(mode, checkTableInTransaction, writeLocked);
      }, { trans, transless: PSD.transless || PSD }) : tempTransaction(this.db, mode, [this.name], checkTableInTransaction);
    } finally {
      if (wasRootExec)
        endMicroTickScope();
    }
  };
  Table2.prototype.get = function(keyOrCrit, cb) {
    var _this = this;
    if (keyOrCrit && keyOrCrit.constructor === Object)
      return this.where(keyOrCrit).first(cb);
    return this._trans("readonly", function(trans) {
      return _this.core.get({ trans, key: keyOrCrit }).then(function(res) {
        return _this.hook.reading.fire(res);
      });
    }).then(cb);
  };
  Table2.prototype.where = function(indexOrCrit) {
    if (typeof indexOrCrit === "string")
      return new this.db.WhereClause(this, indexOrCrit);
    if (isArray$1(indexOrCrit))
      return new this.db.WhereClause(this, "[" + indexOrCrit.join("+") + "]");
    var keyPaths = keys(indexOrCrit);
    if (keyPaths.length === 1)
      return this.where(keyPaths[0]).equals(indexOrCrit[keyPaths[0]]);
    var compoundIndex = this.schema.indexes.concat(this.schema.primKey).filter(function(ix) {
      if (ix.compound && keyPaths.every(function(keyPath) {
        return ix.keyPath.indexOf(keyPath) >= 0;
      })) {
        for (var i = 0; i < keyPaths.length; ++i) {
          if (keyPaths.indexOf(ix.keyPath[i]) === -1)
            return false;
        }
        return true;
      }
      return false;
    }).sort(function(a2, b2) {
      return a2.keyPath.length - b2.keyPath.length;
    })[0];
    if (compoundIndex && this.db._maxKey !== maxString) {
      var keyPathsInValidOrder = compoundIndex.keyPath.slice(0, keyPaths.length);
      return this.where(keyPathsInValidOrder).equals(keyPathsInValidOrder.map(function(kp) {
        return indexOrCrit[kp];
      }));
    }
    if (!compoundIndex && debug$4)
      console.warn("The query " + JSON.stringify(indexOrCrit) + " on " + this.name + " would benefit of a " + ("compound index [" + keyPaths.join("+") + "]"));
    var idxByName = this.schema.idxByName;
    var idb = this.db._deps.indexedDB;
    function equals(a2, b2) {
      try {
        return idb.cmp(a2, b2) === 0;
      } catch (e2) {
        return false;
      }
    }
    var _a2 = keyPaths.reduce(function(_a3, keyPath) {
      var prevIndex = _a3[0], prevFilterFn = _a3[1];
      var index2 = idxByName[keyPath];
      var value = indexOrCrit[keyPath];
      return [
        prevIndex || index2,
        prevIndex || !index2 ? combine(prevFilterFn, index2 && index2.multi ? function(x) {
          var prop = getByKeyPath(x, keyPath);
          return isArray$1(prop) && prop.some(function(item) {
            return equals(value, item);
          });
        } : function(x) {
          return equals(value, getByKeyPath(x, keyPath));
        }) : prevFilterFn
      ];
    }, [null, null]), idx = _a2[0], filterFunction = _a2[1];
    return idx ? this.where(idx.name).equals(indexOrCrit[idx.keyPath]).filter(filterFunction) : compoundIndex ? this.filter(filterFunction) : this.where(keyPaths).equals("");
  };
  Table2.prototype.filter = function(filterFunction) {
    return this.toCollection().and(filterFunction);
  };
  Table2.prototype.count = function(thenShortcut) {
    return this.toCollection().count(thenShortcut);
  };
  Table2.prototype.offset = function(offset2) {
    return this.toCollection().offset(offset2);
  };
  Table2.prototype.limit = function(numRows) {
    return this.toCollection().limit(numRows);
  };
  Table2.prototype.each = function(callback) {
    return this.toCollection().each(callback);
  };
  Table2.prototype.toArray = function(thenShortcut) {
    return this.toCollection().toArray(thenShortcut);
  };
  Table2.prototype.toCollection = function() {
    return new this.db.Collection(new this.db.WhereClause(this));
  };
  Table2.prototype.orderBy = function(index2) {
    return new this.db.Collection(new this.db.WhereClause(this, isArray$1(index2) ? "[" + index2.join("+") + "]" : index2));
  };
  Table2.prototype.reverse = function() {
    return this.toCollection().reverse();
  };
  Table2.prototype.mapToClass = function(constructor) {
    this.schema.mappedClass = constructor;
    var readHook = function(obj) {
      if (!obj)
        return obj;
      var res = Object.create(constructor.prototype);
      for (var m2 in obj)
        if (hasOwn(obj, m2))
          try {
            res[m2] = obj[m2];
          } catch (_2) {
          }
      return res;
    };
    if (this.schema.readHook) {
      this.hook.reading.unsubscribe(this.schema.readHook);
    }
    this.schema.readHook = readHook;
    this.hook("reading", readHook);
    return constructor;
  };
  Table2.prototype.defineClass = function() {
    function Class(content) {
      extend$1(this, content);
    }
    return this.mapToClass(Class);
  };
  Table2.prototype.add = function(obj, key) {
    var _this = this;
    var _a2 = this.schema.primKey, auto2 = _a2.auto, keyPath = _a2.keyPath;
    var objToAdd = obj;
    if (keyPath && auto2) {
      objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
    }
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "add", keys: key != null ? [key] : null, values: [objToAdd] });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
    }).then(function(lastResult) {
      if (keyPath) {
        try {
          setByKeyPath(obj, keyPath, lastResult);
        } catch (_2) {
        }
      }
      return lastResult;
    });
  };
  Table2.prototype.update = function(keyOrObject, modifications) {
    if (typeof keyOrObject === "object" && !isArray$1(keyOrObject)) {
      var key = getByKeyPath(keyOrObject, this.schema.primKey.keyPath);
      if (key === void 0)
        return rejection(new exceptions.InvalidArgument("Given object does not contain its primary key"));
      try {
        if (typeof modifications !== "function") {
          keys(modifications).forEach(function(keyPath) {
            setByKeyPath(keyOrObject, keyPath, modifications[keyPath]);
          });
        } else {
          modifications(keyOrObject, { value: keyOrObject, primKey: key });
        }
      } catch (_a2) {
      }
      return this.where(":id").equals(key).modify(modifications);
    } else {
      return this.where(":id").equals(keyOrObject).modify(modifications);
    }
  };
  Table2.prototype.put = function(obj, key) {
    var _this = this;
    var _a2 = this.schema.primKey, auto2 = _a2.auto, keyPath = _a2.keyPath;
    var objToAdd = obj;
    if (keyPath && auto2) {
      objToAdd = workaroundForUndefinedPrimKey(keyPath)(obj);
    }
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "put", values: [objToAdd], keys: key != null ? [key] : null });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : res.lastResult;
    }).then(function(lastResult) {
      if (keyPath) {
        try {
          setByKeyPath(obj, keyPath, lastResult);
        } catch (_2) {
        }
      }
      return lastResult;
    });
  };
  Table2.prototype.delete = function(key) {
    var _this = this;
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "delete", keys: [key] });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : void 0;
    });
  };
  Table2.prototype.clear = function() {
    var _this = this;
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "deleteRange", range: AnyRange });
    }).then(function(res) {
      return res.numFailures ? DexiePromise.reject(res.failures[0]) : void 0;
    });
  };
  Table2.prototype.bulkGet = function(keys2) {
    var _this = this;
    return this._trans("readonly", function(trans) {
      return _this.core.getMany({
        keys: keys2,
        trans
      }).then(function(result) {
        return result.map(function(res) {
          return _this.hook.reading.fire(res);
        });
      });
    });
  };
  Table2.prototype.bulkAdd = function(objects, keysOrOptions, options) {
    var _this = this;
    var keys2 = Array.isArray(keysOrOptions) ? keysOrOptions : void 0;
    options = options || (keys2 ? void 0 : keysOrOptions);
    var wantResults = options ? options.allKeys : void 0;
    return this._trans("readwrite", function(trans) {
      var _a2 = _this.schema.primKey, auto2 = _a2.auto, keyPath = _a2.keyPath;
      if (keyPath && keys2)
        throw new exceptions.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
      if (keys2 && keys2.length !== objects.length)
        throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
      var numObjects = objects.length;
      var objectsToAdd = keyPath && auto2 ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
      return _this.core.mutate({ trans, type: "add", keys: keys2, values: objectsToAdd, wantResults }).then(function(_a3) {
        var numFailures = _a3.numFailures, results = _a3.results, lastResult = _a3.lastResult, failures = _a3.failures;
        var result = wantResults ? results : lastResult;
        if (numFailures === 0)
          return result;
        throw new BulkError(_this.name + ".bulkAdd(): " + numFailures + " of " + numObjects + " operations failed", failures);
      });
    });
  };
  Table2.prototype.bulkPut = function(objects, keysOrOptions, options) {
    var _this = this;
    var keys2 = Array.isArray(keysOrOptions) ? keysOrOptions : void 0;
    options = options || (keys2 ? void 0 : keysOrOptions);
    var wantResults = options ? options.allKeys : void 0;
    return this._trans("readwrite", function(trans) {
      var _a2 = _this.schema.primKey, auto2 = _a2.auto, keyPath = _a2.keyPath;
      if (keyPath && keys2)
        throw new exceptions.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
      if (keys2 && keys2.length !== objects.length)
        throw new exceptions.InvalidArgument("Arguments objects and keys must have the same length");
      var numObjects = objects.length;
      var objectsToPut = keyPath && auto2 ? objects.map(workaroundForUndefinedPrimKey(keyPath)) : objects;
      return _this.core.mutate({ trans, type: "put", keys: keys2, values: objectsToPut, wantResults }).then(function(_a3) {
        var numFailures = _a3.numFailures, results = _a3.results, lastResult = _a3.lastResult, failures = _a3.failures;
        var result = wantResults ? results : lastResult;
        if (numFailures === 0)
          return result;
        throw new BulkError(_this.name + ".bulkPut(): " + numFailures + " of " + numObjects + " operations failed", failures);
      });
    });
  };
  Table2.prototype.bulkDelete = function(keys2) {
    var _this = this;
    var numKeys = keys2.length;
    return this._trans("readwrite", function(trans) {
      return _this.core.mutate({ trans, type: "delete", keys: keys2 });
    }).then(function(_a2) {
      var numFailures = _a2.numFailures, lastResult = _a2.lastResult, failures = _a2.failures;
      if (numFailures === 0)
        return lastResult;
      throw new BulkError(_this.name + ".bulkDelete(): " + numFailures + " of " + numKeys + " operations failed", failures);
    });
  };
  return Table2;
}();
function Events(ctx) {
  var evs = {};
  var rv = function(eventName, subscriber) {
    if (subscriber) {
      var i2 = arguments.length, args = new Array(i2 - 1);
      while (--i2)
        args[i2 - 1] = arguments[i2];
      evs[eventName].subscribe.apply(null, args);
      return ctx;
    } else if (typeof eventName === "string") {
      return evs[eventName];
    }
  };
  rv.addEventType = add;
  for (var i = 1, l = arguments.length; i < l; ++i) {
    add(arguments[i]);
  }
  return rv;
  function add(eventName, chainFunction, defaultFunction) {
    if (typeof eventName === "object")
      return addConfiguredEvents(eventName);
    if (!chainFunction)
      chainFunction = reverseStoppableEventChain;
    if (!defaultFunction)
      defaultFunction = nop;
    var context = {
      subscribers: [],
      fire: defaultFunction,
      subscribe: function(cb) {
        if (context.subscribers.indexOf(cb) === -1) {
          context.subscribers.push(cb);
          context.fire = chainFunction(context.fire, cb);
        }
      },
      unsubscribe: function(cb) {
        context.subscribers = context.subscribers.filter(function(fn2) {
          return fn2 !== cb;
        });
        context.fire = context.subscribers.reduce(chainFunction, defaultFunction);
      }
    };
    evs[eventName] = rv[eventName] = context;
    return context;
  }
  function addConfiguredEvents(cfg) {
    keys(cfg).forEach(function(eventName) {
      var args = cfg[eventName];
      if (isArray$1(args)) {
        add(eventName, cfg[eventName][0], cfg[eventName][1]);
      } else if (args === "asap") {
        var context = add(eventName, mirror, function fire() {
          var i2 = arguments.length, args2 = new Array(i2);
          while (i2--)
            args2[i2] = arguments[i2];
          context.subscribers.forEach(function(fn2) {
            asap$1(function fireEvent() {
              fn2.apply(null, args2);
            });
          });
        });
      } else
        throw new exceptions.InvalidArgument("Invalid event config");
    });
  }
}
function makeClassConstructor(prototype, constructor) {
  derive(constructor).from({ prototype });
  return constructor;
}
function createTableConstructor(db) {
  return makeClassConstructor(Table.prototype, function Table2(name2, tableSchema, trans) {
    this.db = db;
    this._tx = trans;
    this.name = name2;
    this.schema = tableSchema;
    this.hook = db._allTables[name2] ? db._allTables[name2].hook : Events(null, {
      "creating": [hookCreatingChain, nop],
      "reading": [pureFunctionChain, mirror],
      "updating": [hookUpdatingChain, nop],
      "deleting": [hookDeletingChain, nop]
    });
  });
}
function isPlainKeyRange(ctx, ignoreLimitFilter) {
  return !(ctx.filter || ctx.algorithm || ctx.or) && (ignoreLimitFilter ? ctx.justLimit : !ctx.replayFilter);
}
function addFilter(ctx, fn2) {
  ctx.filter = combine(ctx.filter, fn2);
}
function addReplayFilter(ctx, factory, isLimitFilter) {
  var curr = ctx.replayFilter;
  ctx.replayFilter = curr ? function() {
    return combine(curr(), factory());
  } : factory;
  ctx.justLimit = isLimitFilter && !curr;
}
function addMatchFilter(ctx, fn2) {
  ctx.isMatch = combine(ctx.isMatch, fn2);
}
function getIndexOrStore(ctx, coreSchema) {
  if (ctx.isPrimKey)
    return coreSchema.primaryKey;
  var index2 = coreSchema.getIndexByKeyPath(ctx.index);
  if (!index2)
    throw new exceptions.Schema("KeyPath " + ctx.index + " on object store " + coreSchema.name + " is not indexed");
  return index2;
}
function openCursor(ctx, coreTable, trans) {
  var index2 = getIndexOrStore(ctx, coreTable.schema);
  return coreTable.openCursor({
    trans,
    values: !ctx.keysOnly,
    reverse: ctx.dir === "prev",
    unique: !!ctx.unique,
    query: {
      index: index2,
      range: ctx.range
    }
  });
}
function iter(ctx, fn2, coreTrans, coreTable) {
  var filter = ctx.replayFilter ? combine(ctx.filter, ctx.replayFilter()) : ctx.filter;
  if (!ctx.or) {
    return iterate(openCursor(ctx, coreTable, coreTrans), combine(ctx.algorithm, filter), fn2, !ctx.keysOnly && ctx.valueMapper);
  } else {
    var set_1 = {};
    var union2 = function(item, cursor, advance) {
      if (!filter || filter(cursor, advance, function(result) {
        return cursor.stop(result);
      }, function(err) {
        return cursor.fail(err);
      })) {
        var primaryKey = cursor.primaryKey;
        var key = "" + primaryKey;
        if (key === "[object ArrayBuffer]")
          key = "" + new Uint8Array(primaryKey);
        if (!hasOwn(set_1, key)) {
          set_1[key] = true;
          fn2(item, cursor, advance);
        }
      }
    };
    return Promise.all([
      ctx.or._iterate(union2, coreTrans),
      iterate(openCursor(ctx, coreTable, coreTrans), ctx.algorithm, union2, !ctx.keysOnly && ctx.valueMapper)
    ]);
  }
}
function iterate(cursorPromise, filter, fn2, valueMapper) {
  var mappedFn = valueMapper ? function(x, c2, a2) {
    return fn2(valueMapper(x), c2, a2);
  } : fn2;
  var wrappedFn = wrap(mappedFn);
  return cursorPromise.then(function(cursor) {
    if (cursor) {
      return cursor.start(function() {
        var c2 = function() {
          return cursor.continue();
        };
        if (!filter || filter(cursor, function(advancer) {
          return c2 = advancer;
        }, function(val) {
          cursor.stop(val);
          c2 = nop;
        }, function(e2) {
          cursor.fail(e2);
          c2 = nop;
        }))
          wrappedFn(cursor.value, cursor, function(advancer) {
            return c2 = advancer;
          });
        c2();
      });
    }
  });
}
function cmp$3(a2, b2) {
  try {
    var ta2 = type(a2);
    var tb = type(b2);
    if (ta2 !== tb) {
      if (ta2 === "Array")
        return 1;
      if (tb === "Array")
        return -1;
      if (ta2 === "binary")
        return 1;
      if (tb === "binary")
        return -1;
      if (ta2 === "string")
        return 1;
      if (tb === "string")
        return -1;
      if (ta2 === "Date")
        return 1;
      if (tb !== "Date")
        return NaN;
      return -1;
    }
    switch (ta2) {
      case "number":
      case "Date":
      case "string":
        return a2 > b2 ? 1 : a2 < b2 ? -1 : 0;
      case "binary": {
        return compareUint8Arrays(getUint8Array(a2), getUint8Array(b2));
      }
      case "Array":
        return compareArrays(a2, b2);
    }
  } catch (_a2) {
  }
  return NaN;
}
function compareArrays(a2, b2) {
  var al = a2.length;
  var bl = b2.length;
  var l = al < bl ? al : bl;
  for (var i = 0; i < l; ++i) {
    var res = cmp$3(a2[i], b2[i]);
    if (res !== 0)
      return res;
  }
  return al === bl ? 0 : al < bl ? -1 : 1;
}
function compareUint8Arrays(a2, b2) {
  var al = a2.length;
  var bl = b2.length;
  var l = al < bl ? al : bl;
  for (var i = 0; i < l; ++i) {
    if (a2[i] !== b2[i])
      return a2[i] < b2[i] ? -1 : 1;
  }
  return al === bl ? 0 : al < bl ? -1 : 1;
}
function type(x) {
  var t2 = typeof x;
  if (t2 !== "object")
    return t2;
  if (ArrayBuffer.isView(x))
    return "binary";
  var tsTag = toStringTag(x);
  return tsTag === "ArrayBuffer" ? "binary" : tsTag;
}
function getUint8Array(a2) {
  if (a2 instanceof Uint8Array)
    return a2;
  if (ArrayBuffer.isView(a2))
    return new Uint8Array(a2.buffer, a2.byteOffset, a2.byteLength);
  return new Uint8Array(a2);
}
var Collection = function() {
  function Collection2() {
  }
  Collection2.prototype._read = function(fn2, cb) {
    var ctx = this._ctx;
    return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans("readonly", fn2).then(cb);
  };
  Collection2.prototype._write = function(fn2) {
    var ctx = this._ctx;
    return ctx.error ? ctx.table._trans(null, rejection.bind(null, ctx.error)) : ctx.table._trans("readwrite", fn2, "locked");
  };
  Collection2.prototype._addAlgorithm = function(fn2) {
    var ctx = this._ctx;
    ctx.algorithm = combine(ctx.algorithm, fn2);
  };
  Collection2.prototype._iterate = function(fn2, coreTrans) {
    return iter(this._ctx, fn2, coreTrans, this._ctx.table.core);
  };
  Collection2.prototype.clone = function(props2) {
    var rv = Object.create(this.constructor.prototype), ctx = Object.create(this._ctx);
    if (props2)
      extend$1(ctx, props2);
    rv._ctx = ctx;
    return rv;
  };
  Collection2.prototype.raw = function() {
    this._ctx.valueMapper = null;
    return this;
  };
  Collection2.prototype.each = function(fn2) {
    var ctx = this._ctx;
    return this._read(function(trans) {
      return iter(ctx, fn2, trans, ctx.table.core);
    });
  };
  Collection2.prototype.count = function(cb) {
    var _this = this;
    return this._read(function(trans) {
      var ctx = _this._ctx;
      var coreTable = ctx.table.core;
      if (isPlainKeyRange(ctx, true)) {
        return coreTable.count({
          trans,
          query: {
            index: getIndexOrStore(ctx, coreTable.schema),
            range: ctx.range
          }
        }).then(function(count2) {
          return Math.min(count2, ctx.limit);
        });
      } else {
        var count = 0;
        return iter(ctx, function() {
          ++count;
          return false;
        }, trans, coreTable).then(function() {
          return count;
        });
      }
    }).then(cb);
  };
  Collection2.prototype.sortBy = function(keyPath, cb) {
    var parts = keyPath.split(".").reverse(), lastPart = parts[0], lastIndex = parts.length - 1;
    function getval(obj, i) {
      if (i)
        return getval(obj[parts[i]], i - 1);
      return obj[lastPart];
    }
    var order2 = this._ctx.dir === "next" ? 1 : -1;
    function sorter(a2, b2) {
      var aVal = getval(a2, lastIndex), bVal = getval(b2, lastIndex);
      return aVal < bVal ? -order2 : aVal > bVal ? order2 : 0;
    }
    return this.toArray(function(a2) {
      return a2.sort(sorter);
    }).then(cb);
  };
  Collection2.prototype.toArray = function(cb) {
    var _this = this;
    return this._read(function(trans) {
      var ctx = _this._ctx;
      if (ctx.dir === "next" && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
        var valueMapper_1 = ctx.valueMapper;
        var index2 = getIndexOrStore(ctx, ctx.table.core.schema);
        return ctx.table.core.query({
          trans,
          limit: ctx.limit,
          values: true,
          query: {
            index: index2,
            range: ctx.range
          }
        }).then(function(_a2) {
          var result = _a2.result;
          return valueMapper_1 ? result.map(valueMapper_1) : result;
        });
      } else {
        var a_1 = [];
        return iter(ctx, function(item) {
          return a_1.push(item);
        }, trans, ctx.table.core).then(function() {
          return a_1;
        });
      }
    }, cb);
  };
  Collection2.prototype.offset = function(offset2) {
    var ctx = this._ctx;
    if (offset2 <= 0)
      return this;
    ctx.offset += offset2;
    if (isPlainKeyRange(ctx)) {
      addReplayFilter(ctx, function() {
        var offsetLeft = offset2;
        return function(cursor, advance) {
          if (offsetLeft === 0)
            return true;
          if (offsetLeft === 1) {
            --offsetLeft;
            return false;
          }
          advance(function() {
            cursor.advance(offsetLeft);
            offsetLeft = 0;
          });
          return false;
        };
      });
    } else {
      addReplayFilter(ctx, function() {
        var offsetLeft = offset2;
        return function() {
          return --offsetLeft < 0;
        };
      });
    }
    return this;
  };
  Collection2.prototype.limit = function(numRows) {
    this._ctx.limit = Math.min(this._ctx.limit, numRows);
    addReplayFilter(this._ctx, function() {
      var rowsLeft = numRows;
      return function(cursor, advance, resolve) {
        if (--rowsLeft <= 0)
          advance(resolve);
        return rowsLeft >= 0;
      };
    }, true);
    return this;
  };
  Collection2.prototype.until = function(filterFunction, bIncludeStopEntry) {
    addFilter(this._ctx, function(cursor, advance, resolve) {
      if (filterFunction(cursor.value)) {
        advance(resolve);
        return bIncludeStopEntry;
      } else {
        return true;
      }
    });
    return this;
  };
  Collection2.prototype.first = function(cb) {
    return this.limit(1).toArray(function(a2) {
      return a2[0];
    }).then(cb);
  };
  Collection2.prototype.last = function(cb) {
    return this.reverse().first(cb);
  };
  Collection2.prototype.filter = function(filterFunction) {
    addFilter(this._ctx, function(cursor) {
      return filterFunction(cursor.value);
    });
    addMatchFilter(this._ctx, filterFunction);
    return this;
  };
  Collection2.prototype.and = function(filter) {
    return this.filter(filter);
  };
  Collection2.prototype.or = function(indexName) {
    return new this.db.WhereClause(this._ctx.table, indexName, this);
  };
  Collection2.prototype.reverse = function() {
    this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev";
    if (this._ondirectionchange)
      this._ondirectionchange(this._ctx.dir);
    return this;
  };
  Collection2.prototype.desc = function() {
    return this.reverse();
  };
  Collection2.prototype.eachKey = function(cb) {
    var ctx = this._ctx;
    ctx.keysOnly = !ctx.isMatch;
    return this.each(function(val, cursor) {
      cb(cursor.key, cursor);
    });
  };
  Collection2.prototype.eachUniqueKey = function(cb) {
    this._ctx.unique = "unique";
    return this.eachKey(cb);
  };
  Collection2.prototype.eachPrimaryKey = function(cb) {
    var ctx = this._ctx;
    ctx.keysOnly = !ctx.isMatch;
    return this.each(function(val, cursor) {
      cb(cursor.primaryKey, cursor);
    });
  };
  Collection2.prototype.keys = function(cb) {
    var ctx = this._ctx;
    ctx.keysOnly = !ctx.isMatch;
    var a2 = [];
    return this.each(function(item, cursor) {
      a2.push(cursor.key);
    }).then(function() {
      return a2;
    }).then(cb);
  };
  Collection2.prototype.primaryKeys = function(cb) {
    var ctx = this._ctx;
    if (ctx.dir === "next" && isPlainKeyRange(ctx, true) && ctx.limit > 0) {
      return this._read(function(trans) {
        var index2 = getIndexOrStore(ctx, ctx.table.core.schema);
        return ctx.table.core.query({
          trans,
          values: false,
          limit: ctx.limit,
          query: {
            index: index2,
            range: ctx.range
          }
        });
      }).then(function(_a2) {
        var result = _a2.result;
        return result;
      }).then(cb);
    }
    ctx.keysOnly = !ctx.isMatch;
    var a2 = [];
    return this.each(function(item, cursor) {
      a2.push(cursor.primaryKey);
    }).then(function() {
      return a2;
    }).then(cb);
  };
  Collection2.prototype.uniqueKeys = function(cb) {
    this._ctx.unique = "unique";
    return this.keys(cb);
  };
  Collection2.prototype.firstKey = function(cb) {
    return this.limit(1).keys(function(a2) {
      return a2[0];
    }).then(cb);
  };
  Collection2.prototype.lastKey = function(cb) {
    return this.reverse().firstKey(cb);
  };
  Collection2.prototype.distinct = function() {
    var ctx = this._ctx, idx = ctx.index && ctx.table.schema.idxByName[ctx.index];
    if (!idx || !idx.multi)
      return this;
    var set = {};
    addFilter(this._ctx, function(cursor) {
      var strKey = cursor.primaryKey.toString();
      var found = hasOwn(set, strKey);
      set[strKey] = true;
      return !found;
    });
    return this;
  };
  Collection2.prototype.modify = function(changes) {
    var _this = this;
    var ctx = this._ctx;
    return this._write(function(trans) {
      var modifyer;
      if (typeof changes === "function") {
        modifyer = changes;
      } else {
        var keyPaths = keys(changes);
        var numKeys = keyPaths.length;
        modifyer = function(item) {
          var anythingModified = false;
          for (var i = 0; i < numKeys; ++i) {
            var keyPath = keyPaths[i], val = changes[keyPath];
            if (getByKeyPath(item, keyPath) !== val) {
              setByKeyPath(item, keyPath, val);
              anythingModified = true;
            }
          }
          return anythingModified;
        };
      }
      var coreTable = ctx.table.core;
      var _a2 = coreTable.schema.primaryKey, outbound = _a2.outbound, extractKey = _a2.extractKey;
      var limit = _this.db._options.modifyChunkSize || 200;
      var totalFailures = [];
      var successCount = 0;
      var failedKeys = [];
      var applyMutateResult = function(expectedCount, res) {
        var failures = res.failures, numFailures = res.numFailures;
        successCount += expectedCount - numFailures;
        for (var _i = 0, _a3 = keys(failures); _i < _a3.length; _i++) {
          var pos = _a3[_i];
          totalFailures.push(failures[pos]);
        }
      };
      return _this.clone().primaryKeys().then(function(keys2) {
        var nextChunk = function(offset2) {
          var count = Math.min(limit, keys2.length - offset2);
          return coreTable.getMany({
            trans,
            keys: keys2.slice(offset2, offset2 + count),
            cache: "immutable"
          }).then(function(values) {
            var addValues = [];
            var putValues = [];
            var putKeys = outbound ? [] : null;
            var deleteKeys = [];
            for (var i = 0; i < count; ++i) {
              var origValue = values[i];
              var ctx_1 = {
                value: deepClone(origValue),
                primKey: keys2[offset2 + i]
              };
              if (modifyer.call(ctx_1, ctx_1.value, ctx_1) !== false) {
                if (ctx_1.value == null) {
                  deleteKeys.push(keys2[offset2 + i]);
                } else if (!outbound && cmp$3(extractKey(origValue), extractKey(ctx_1.value)) !== 0) {
                  deleteKeys.push(keys2[offset2 + i]);
                  addValues.push(ctx_1.value);
                } else {
                  putValues.push(ctx_1.value);
                  if (outbound)
                    putKeys.push(keys2[offset2 + i]);
                }
              }
            }
            var criteria = isPlainKeyRange(ctx) && ctx.limit === Infinity && (typeof changes !== "function" || changes === deleteCallback) && {
              index: ctx.index,
              range: ctx.range
            };
            return Promise.resolve(addValues.length > 0 && coreTable.mutate({ trans, type: "add", values: addValues }).then(function(res) {
              for (var pos in res.failures) {
                deleteKeys.splice(parseInt(pos), 1);
              }
              applyMutateResult(addValues.length, res);
            })).then(function() {
              return (putValues.length > 0 || criteria && typeof changes === "object") && coreTable.mutate({
                trans,
                type: "put",
                keys: putKeys,
                values: putValues,
                criteria,
                changeSpec: typeof changes !== "function" && changes
              }).then(function(res) {
                return applyMutateResult(putValues.length, res);
              });
            }).then(function() {
              return (deleteKeys.length > 0 || criteria && changes === deleteCallback) && coreTable.mutate({
                trans,
                type: "delete",
                keys: deleteKeys,
                criteria
              }).then(function(res) {
                return applyMutateResult(deleteKeys.length, res);
              });
            }).then(function() {
              return keys2.length > offset2 + count && nextChunk(offset2 + limit);
            });
          });
        };
        return nextChunk(0).then(function() {
          if (totalFailures.length > 0)
            throw new ModifyError("Error modifying one or more objects", totalFailures, successCount, failedKeys);
          return keys2.length;
        });
      });
    });
  };
  Collection2.prototype.delete = function() {
    var ctx = this._ctx, range2 = ctx.range;
    if (isPlainKeyRange(ctx) && (ctx.isPrimKey && !hangsOnDeleteLargeKeyRange || range2.type === 3)) {
      return this._write(function(trans) {
        var primaryKey = ctx.table.core.schema.primaryKey;
        var coreRange = range2;
        return ctx.table.core.count({ trans, query: { index: primaryKey, range: coreRange } }).then(function(count) {
          return ctx.table.core.mutate({ trans, type: "deleteRange", range: coreRange }).then(function(_a2) {
            var failures = _a2.failures;
            _a2.lastResult;
            _a2.results;
            var numFailures = _a2.numFailures;
            if (numFailures)
              throw new ModifyError("Could not delete some values", Object.keys(failures).map(function(pos) {
                return failures[pos];
              }), count - numFailures);
            return count - numFailures;
          });
        });
      });
    }
    return this.modify(deleteCallback);
  };
  return Collection2;
}();
var deleteCallback = function(value, ctx) {
  return ctx.value = null;
};
function createCollectionConstructor(db) {
  return makeClassConstructor(Collection.prototype, function Collection2(whereClause, keyRangeGenerator) {
    this.db = db;
    var keyRange = AnyRange, error = null;
    if (keyRangeGenerator)
      try {
        keyRange = keyRangeGenerator();
      } catch (ex) {
        error = ex;
      }
    var whereCtx = whereClause._ctx;
    var table = whereCtx.table;
    var readingHook = table.hook.reading.fire;
    this._ctx = {
      table,
      index: whereCtx.index,
      isPrimKey: !whereCtx.index || table.schema.primKey.keyPath && whereCtx.index === table.schema.primKey.name,
      range: keyRange,
      keysOnly: false,
      dir: "next",
      unique: "",
      algorithm: null,
      filter: null,
      replayFilter: null,
      justLimit: true,
      isMatch: null,
      offset: 0,
      limit: Infinity,
      error,
      or: whereCtx.or,
      valueMapper: readingHook !== mirror ? readingHook : null
    };
  });
}
function simpleCompare(a2, b2) {
  return a2 < b2 ? -1 : a2 === b2 ? 0 : 1;
}
function simpleCompareReverse(a2, b2) {
  return a2 > b2 ? -1 : a2 === b2 ? 0 : 1;
}
function fail(collectionOrWhereClause, err, T) {
  var collection = collectionOrWhereClause instanceof WhereClause ? new collectionOrWhereClause.Collection(collectionOrWhereClause) : collectionOrWhereClause;
  collection._ctx.error = T ? new T(err) : new TypeError(err);
  return collection;
}
function emptyCollection(whereClause) {
  return new whereClause.Collection(whereClause, function() {
    return rangeEqual("");
  }).limit(0);
}
function upperFactory(dir) {
  return dir === "next" ? function(s) {
    return s.toUpperCase();
  } : function(s) {
    return s.toLowerCase();
  };
}
function lowerFactory(dir) {
  return dir === "next" ? function(s) {
    return s.toLowerCase();
  } : function(s) {
    return s.toUpperCase();
  };
}
function nextCasing(key, lowerKey, upperNeedle, lowerNeedle, cmp2, dir) {
  var length = Math.min(key.length, lowerNeedle.length);
  var llp = -1;
  for (var i = 0; i < length; ++i) {
    var lwrKeyChar = lowerKey[i];
    if (lwrKeyChar !== lowerNeedle[i]) {
      if (cmp2(key[i], upperNeedle[i]) < 0)
        return key.substr(0, i) + upperNeedle[i] + upperNeedle.substr(i + 1);
      if (cmp2(key[i], lowerNeedle[i]) < 0)
        return key.substr(0, i) + lowerNeedle[i] + upperNeedle.substr(i + 1);
      if (llp >= 0)
        return key.substr(0, llp) + lowerKey[llp] + upperNeedle.substr(llp + 1);
      return null;
    }
    if (cmp2(key[i], lwrKeyChar) < 0)
      llp = i;
  }
  if (length < lowerNeedle.length && dir === "next")
    return key + upperNeedle.substr(key.length);
  if (length < key.length && dir === "prev")
    return key.substr(0, upperNeedle.length);
  return llp < 0 ? null : key.substr(0, llp) + lowerNeedle[llp] + upperNeedle.substr(llp + 1);
}
function addIgnoreCaseAlgorithm(whereClause, match, needles, suffix) {
  var upper, lower, compare2, upperNeedles, lowerNeedles, direction, nextKeySuffix, needlesLen = needles.length;
  if (!needles.every(function(s) {
    return typeof s === "string";
  })) {
    return fail(whereClause, STRING_EXPECTED);
  }
  function initDirection(dir) {
    upper = upperFactory(dir);
    lower = lowerFactory(dir);
    compare2 = dir === "next" ? simpleCompare : simpleCompareReverse;
    var needleBounds = needles.map(function(needle) {
      return { lower: lower(needle), upper: upper(needle) };
    }).sort(function(a2, b2) {
      return compare2(a2.lower, b2.lower);
    });
    upperNeedles = needleBounds.map(function(nb2) {
      return nb2.upper;
    });
    lowerNeedles = needleBounds.map(function(nb2) {
      return nb2.lower;
    });
    direction = dir;
    nextKeySuffix = dir === "next" ? "" : suffix;
  }
  initDirection("next");
  var c2 = new whereClause.Collection(whereClause, function() {
    return createRange(upperNeedles[0], lowerNeedles[needlesLen - 1] + suffix);
  });
  c2._ondirectionchange = function(direction2) {
    initDirection(direction2);
  };
  var firstPossibleNeedle = 0;
  c2._addAlgorithm(function(cursor, advance, resolve) {
    var key = cursor.key;
    if (typeof key !== "string")
      return false;
    var lowerKey = lower(key);
    if (match(lowerKey, lowerNeedles, firstPossibleNeedle)) {
      return true;
    } else {
      var lowestPossibleCasing = null;
      for (var i = firstPossibleNeedle; i < needlesLen; ++i) {
        var casing = nextCasing(key, lowerKey, upperNeedles[i], lowerNeedles[i], compare2, direction);
        if (casing === null && lowestPossibleCasing === null)
          firstPossibleNeedle = i + 1;
        else if (lowestPossibleCasing === null || compare2(lowestPossibleCasing, casing) > 0) {
          lowestPossibleCasing = casing;
        }
      }
      if (lowestPossibleCasing !== null) {
        advance(function() {
          cursor.continue(lowestPossibleCasing + nextKeySuffix);
        });
      } else {
        advance(resolve);
      }
      return false;
    }
  });
  return c2;
}
function createRange(lower, upper, lowerOpen, upperOpen) {
  return {
    type: 2,
    lower,
    upper,
    lowerOpen,
    upperOpen
  };
}
function rangeEqual(value) {
  return {
    type: 1,
    lower: value,
    upper: value
  };
}
var WhereClause = function() {
  function WhereClause2() {
  }
  Object.defineProperty(WhereClause2.prototype, "Collection", {
    get: function() {
      return this._ctx.table.db.Collection;
    },
    enumerable: false,
    configurable: true
  });
  WhereClause2.prototype.between = function(lower, upper, includeLower, includeUpper) {
    includeLower = includeLower !== false;
    includeUpper = includeUpper === true;
    try {
      if (this._cmp(lower, upper) > 0 || this._cmp(lower, upper) === 0 && (includeLower || includeUpper) && !(includeLower && includeUpper))
        return emptyCollection(this);
      return new this.Collection(this, function() {
        return createRange(lower, upper, !includeLower, !includeUpper);
      });
    } catch (e2) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
  };
  WhereClause2.prototype.equals = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return rangeEqual(value);
    });
  };
  WhereClause2.prototype.above = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(value, void 0, true);
    });
  };
  WhereClause2.prototype.aboveOrEqual = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(value, void 0, false);
    });
  };
  WhereClause2.prototype.below = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(void 0, value, false, true);
    });
  };
  WhereClause2.prototype.belowOrEqual = function(value) {
    if (value == null)
      return fail(this, INVALID_KEY_ARGUMENT);
    return new this.Collection(this, function() {
      return createRange(void 0, value);
    });
  };
  WhereClause2.prototype.startsWith = function(str) {
    if (typeof str !== "string")
      return fail(this, STRING_EXPECTED);
    return this.between(str, str + maxString, true, true);
  };
  WhereClause2.prototype.startsWithIgnoreCase = function(str) {
    if (str === "")
      return this.startsWith(str);
    return addIgnoreCaseAlgorithm(this, function(x, a2) {
      return x.indexOf(a2[0]) === 0;
    }, [str], maxString);
  };
  WhereClause2.prototype.equalsIgnoreCase = function(str) {
    return addIgnoreCaseAlgorithm(this, function(x, a2) {
      return x === a2[0];
    }, [str], "");
  };
  WhereClause2.prototype.anyOfIgnoreCase = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (set.length === 0)
      return emptyCollection(this);
    return addIgnoreCaseAlgorithm(this, function(x, a2) {
      return a2.indexOf(x) !== -1;
    }, set, "");
  };
  WhereClause2.prototype.startsWithAnyOfIgnoreCase = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (set.length === 0)
      return emptyCollection(this);
    return addIgnoreCaseAlgorithm(this, function(x, a2) {
      return a2.some(function(n) {
        return x.indexOf(n) === 0;
      });
    }, set, maxString);
  };
  WhereClause2.prototype.anyOf = function() {
    var _this = this;
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    var compare2 = this._cmp;
    try {
      set.sort(compare2);
    } catch (e2) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    if (set.length === 0)
      return emptyCollection(this);
    var c2 = new this.Collection(this, function() {
      return createRange(set[0], set[set.length - 1]);
    });
    c2._ondirectionchange = function(direction) {
      compare2 = direction === "next" ? _this._ascending : _this._descending;
      set.sort(compare2);
    };
    var i = 0;
    c2._addAlgorithm(function(cursor, advance, resolve) {
      var key = cursor.key;
      while (compare2(key, set[i]) > 0) {
        ++i;
        if (i === set.length) {
          advance(resolve);
          return false;
        }
      }
      if (compare2(key, set[i]) === 0) {
        return true;
      } else {
        advance(function() {
          cursor.continue(set[i]);
        });
        return false;
      }
    });
    return c2;
  };
  WhereClause2.prototype.notEqual = function(value) {
    return this.inAnyRange([[minKey, value], [value, this.db._maxKey]], { includeLowers: false, includeUppers: false });
  };
  WhereClause2.prototype.noneOf = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (set.length === 0)
      return new this.Collection(this);
    try {
      set.sort(this._ascending);
    } catch (e2) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    var ranges = set.reduce(function(res, val) {
      return res ? res.concat([[res[res.length - 1][1], val]]) : [[minKey, val]];
    }, null);
    ranges.push([set[set.length - 1], this.db._maxKey]);
    return this.inAnyRange(ranges, { includeLowers: false, includeUppers: false });
  };
  WhereClause2.prototype.inAnyRange = function(ranges, options) {
    var _this = this;
    var cmp2 = this._cmp, ascending = this._ascending, descending = this._descending, min2 = this._min, max2 = this._max;
    if (ranges.length === 0)
      return emptyCollection(this);
    if (!ranges.every(function(range2) {
      return range2[0] !== void 0 && range2[1] !== void 0 && ascending(range2[0], range2[1]) <= 0;
    })) {
      return fail(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", exceptions.InvalidArgument);
    }
    var includeLowers = !options || options.includeLowers !== false;
    var includeUppers = options && options.includeUppers === true;
    function addRange2(ranges2, newRange) {
      var i = 0, l = ranges2.length;
      for (; i < l; ++i) {
        var range2 = ranges2[i];
        if (cmp2(newRange[0], range2[1]) < 0 && cmp2(newRange[1], range2[0]) > 0) {
          range2[0] = min2(range2[0], newRange[0]);
          range2[1] = max2(range2[1], newRange[1]);
          break;
        }
      }
      if (i === l)
        ranges2.push(newRange);
      return ranges2;
    }
    var sortDirection = ascending;
    function rangeSorter(a2, b2) {
      return sortDirection(a2[0], b2[0]);
    }
    var set;
    try {
      set = ranges.reduce(addRange2, []);
      set.sort(rangeSorter);
    } catch (ex) {
      return fail(this, INVALID_KEY_ARGUMENT);
    }
    var rangePos = 0;
    var keyIsBeyondCurrentEntry = includeUppers ? function(key) {
      return ascending(key, set[rangePos][1]) > 0;
    } : function(key) {
      return ascending(key, set[rangePos][1]) >= 0;
    };
    var keyIsBeforeCurrentEntry = includeLowers ? function(key) {
      return descending(key, set[rangePos][0]) > 0;
    } : function(key) {
      return descending(key, set[rangePos][0]) >= 0;
    };
    function keyWithinCurrentRange(key) {
      return !keyIsBeyondCurrentEntry(key) && !keyIsBeforeCurrentEntry(key);
    }
    var checkKey = keyIsBeyondCurrentEntry;
    var c2 = new this.Collection(this, function() {
      return createRange(set[0][0], set[set.length - 1][1], !includeLowers, !includeUppers);
    });
    c2._ondirectionchange = function(direction) {
      if (direction === "next") {
        checkKey = keyIsBeyondCurrentEntry;
        sortDirection = ascending;
      } else {
        checkKey = keyIsBeforeCurrentEntry;
        sortDirection = descending;
      }
      set.sort(rangeSorter);
    };
    c2._addAlgorithm(function(cursor, advance, resolve) {
      var key = cursor.key;
      while (checkKey(key)) {
        ++rangePos;
        if (rangePos === set.length) {
          advance(resolve);
          return false;
        }
      }
      if (keyWithinCurrentRange(key)) {
        return true;
      } else if (_this._cmp(key, set[rangePos][1]) === 0 || _this._cmp(key, set[rangePos][0]) === 0) {
        return false;
      } else {
        advance(function() {
          if (sortDirection === ascending)
            cursor.continue(set[rangePos][0]);
          else
            cursor.continue(set[rangePos][1]);
        });
        return false;
      }
    });
    return c2;
  };
  WhereClause2.prototype.startsWithAnyOf = function() {
    var set = getArrayOf.apply(NO_CHAR_ARRAY, arguments);
    if (!set.every(function(s) {
      return typeof s === "string";
    })) {
      return fail(this, "startsWithAnyOf() only works with strings");
    }
    if (set.length === 0)
      return emptyCollection(this);
    return this.inAnyRange(set.map(function(str) {
      return [str, str + maxString];
    }));
  };
  return WhereClause2;
}();
function createWhereClauseConstructor(db) {
  return makeClassConstructor(WhereClause.prototype, function WhereClause2(table, index2, orCollection) {
    this.db = db;
    this._ctx = {
      table,
      index: index2 === ":id" ? null : index2,
      or: orCollection
    };
    var indexedDB2 = db._deps.indexedDB;
    if (!indexedDB2)
      throw new exceptions.MissingAPI();
    this._cmp = this._ascending = indexedDB2.cmp.bind(indexedDB2);
    this._descending = function(a2, b2) {
      return indexedDB2.cmp(b2, a2);
    };
    this._max = function(a2, b2) {
      return indexedDB2.cmp(a2, b2) > 0 ? a2 : b2;
    };
    this._min = function(a2, b2) {
      return indexedDB2.cmp(a2, b2) < 0 ? a2 : b2;
    };
    this._IDBKeyRange = db._deps.IDBKeyRange;
  });
}
function eventRejectHandler(reject) {
  return wrap(function(event) {
    preventDefault(event);
    reject(event.target.error);
    return false;
  });
}
function preventDefault(event) {
  if (event.stopPropagation)
    event.stopPropagation();
  if (event.preventDefault)
    event.preventDefault();
}
var DEXIE_STORAGE_MUTATED_EVENT_NAME = "storagemutated";
var STORAGE_MUTATED_DOM_EVENT_NAME = "x-storagemutated-1";
var globalEvents = Events(null, DEXIE_STORAGE_MUTATED_EVENT_NAME);
var Transaction = function() {
  function Transaction2() {
  }
  Transaction2.prototype._lock = function() {
    assert(!PSD.global);
    ++this._reculock;
    if (this._reculock === 1 && !PSD.global)
      PSD.lockOwnerFor = this;
    return this;
  };
  Transaction2.prototype._unlock = function() {
    assert(!PSD.global);
    if (--this._reculock === 0) {
      if (!PSD.global)
        PSD.lockOwnerFor = null;
      while (this._blockedFuncs.length > 0 && !this._locked()) {
        var fnAndPSD = this._blockedFuncs.shift();
        try {
          usePSD(fnAndPSD[1], fnAndPSD[0]);
        } catch (e2) {
        }
      }
    }
    return this;
  };
  Transaction2.prototype._locked = function() {
    return this._reculock && PSD.lockOwnerFor !== this;
  };
  Transaction2.prototype.create = function(idbtrans) {
    var _this = this;
    if (!this.mode)
      return this;
    var idbdb = this.db.idbdb;
    var dbOpenError = this.db._state.dbOpenError;
    assert(!this.idbtrans);
    if (!idbtrans && !idbdb) {
      switch (dbOpenError && dbOpenError.name) {
        case "DatabaseClosedError":
          throw new exceptions.DatabaseClosed(dbOpenError);
        case "MissingAPIError":
          throw new exceptions.MissingAPI(dbOpenError.message, dbOpenError);
        default:
          throw new exceptions.OpenFailed(dbOpenError);
      }
    }
    if (!this.active)
      throw new exceptions.TransactionInactive();
    assert(this._completion._state === null);
    idbtrans = this.idbtrans = idbtrans || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability }) : idbdb.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability }));
    idbtrans.onerror = wrap(function(ev) {
      preventDefault(ev);
      _this._reject(idbtrans.error);
    });
    idbtrans.onabort = wrap(function(ev) {
      preventDefault(ev);
      _this.active && _this._reject(new exceptions.Abort(idbtrans.error));
      _this.active = false;
      _this.on("abort").fire(ev);
    });
    idbtrans.oncomplete = wrap(function() {
      _this.active = false;
      _this._resolve();
      if ("mutatedParts" in idbtrans) {
        globalEvents.storagemutated.fire(idbtrans["mutatedParts"]);
      }
    });
    return this;
  };
  Transaction2.prototype._promise = function(mode, fn2, bWriteLock) {
    var _this = this;
    if (mode === "readwrite" && this.mode !== "readwrite")
      return rejection(new exceptions.ReadOnly("Transaction is readonly"));
    if (!this.active)
      return rejection(new exceptions.TransactionInactive());
    if (this._locked()) {
      return new DexiePromise(function(resolve, reject) {
        _this._blockedFuncs.push([function() {
          _this._promise(mode, fn2, bWriteLock).then(resolve, reject);
        }, PSD]);
      });
    } else if (bWriteLock) {
      return newScope(function() {
        var p2 = new DexiePromise(function(resolve, reject) {
          _this._lock();
          var rv = fn2(resolve, reject, _this);
          if (rv && rv.then)
            rv.then(resolve, reject);
        });
        p2.finally(function() {
          return _this._unlock();
        });
        p2._lib = true;
        return p2;
      });
    } else {
      var p = new DexiePromise(function(resolve, reject) {
        var rv = fn2(resolve, reject, _this);
        if (rv && rv.then)
          rv.then(resolve, reject);
      });
      p._lib = true;
      return p;
    }
  };
  Transaction2.prototype._root = function() {
    return this.parent ? this.parent._root() : this;
  };
  Transaction2.prototype.waitFor = function(promiseLike) {
    var root2 = this._root();
    var promise = DexiePromise.resolve(promiseLike);
    if (root2._waitingFor) {
      root2._waitingFor = root2._waitingFor.then(function() {
        return promise;
      });
    } else {
      root2._waitingFor = promise;
      root2._waitingQueue = [];
      var store2 = root2.idbtrans.objectStore(root2.storeNames[0]);
      (function spin() {
        ++root2._spinCount;
        while (root2._waitingQueue.length)
          root2._waitingQueue.shift()();
        if (root2._waitingFor)
          store2.get(-Infinity).onsuccess = spin;
      })();
    }
    var currentWaitPromise = root2._waitingFor;
    return new DexiePromise(function(resolve, reject) {
      promise.then(function(res) {
        return root2._waitingQueue.push(wrap(resolve.bind(null, res)));
      }, function(err) {
        return root2._waitingQueue.push(wrap(reject.bind(null, err)));
      }).finally(function() {
        if (root2._waitingFor === currentWaitPromise) {
          root2._waitingFor = null;
        }
      });
    });
  };
  Transaction2.prototype.abort = function() {
    if (this.active) {
      this.active = false;
      if (this.idbtrans)
        this.idbtrans.abort();
      this._reject(new exceptions.Abort());
    }
  };
  Transaction2.prototype.table = function(tableName) {
    var memoizedTables = this._memoizedTables || (this._memoizedTables = {});
    if (hasOwn(memoizedTables, tableName))
      return memoizedTables[tableName];
    var tableSchema = this.schema[tableName];
    if (!tableSchema) {
      throw new exceptions.NotFound("Table " + tableName + " not part of transaction");
    }
    var transactionBoundTable = new this.db.Table(tableName, tableSchema, this);
    transactionBoundTable.core = this.db.core.table(tableName);
    memoizedTables[tableName] = transactionBoundTable;
    return transactionBoundTable;
  };
  return Transaction2;
}();
function createTransactionConstructor(db) {
  return makeClassConstructor(Transaction.prototype, function Transaction2(mode, storeNames, dbschema, chromeTransactionDurability, parent) {
    var _this = this;
    this.db = db;
    this.mode = mode;
    this.storeNames = storeNames;
    this.schema = dbschema;
    this.chromeTransactionDurability = chromeTransactionDurability;
    this.idbtrans = null;
    this.on = Events(this, "complete", "error", "abort");
    this.parent = parent || null;
    this.active = true;
    this._reculock = 0;
    this._blockedFuncs = [];
    this._resolve = null;
    this._reject = null;
    this._waitingFor = null;
    this._waitingQueue = null;
    this._spinCount = 0;
    this._completion = new DexiePromise(function(resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
    this._completion.then(function() {
      _this.active = false;
      _this.on.complete.fire();
    }, function(e2) {
      var wasActive = _this.active;
      _this.active = false;
      _this.on.error.fire(e2);
      _this.parent ? _this.parent._reject(e2) : wasActive && _this.idbtrans && _this.idbtrans.abort();
      return rejection(e2);
    });
  });
}
function createIndexSpec(name2, keyPath, unique2, multi, auto2, compound, isPrimKey) {
  return {
    name: name2,
    keyPath,
    unique: unique2,
    multi,
    auto: auto2,
    compound,
    src: (unique2 && !isPrimKey ? "&" : "") + (multi ? "*" : "") + (auto2 ? "++" : "") + nameFromKeyPath(keyPath)
  };
}
function nameFromKeyPath(keyPath) {
  return typeof keyPath === "string" ? keyPath : keyPath ? "[" + [].join.call(keyPath, "+") + "]" : "";
}
function createTableSchema(name2, primKey, indexes) {
  return {
    name: name2,
    primKey,
    indexes,
    mappedClass: null,
    idxByName: arrayToObject(indexes, function(index2) {
      return [index2.name, index2];
    })
  };
}
function safariMultiStoreFix(storeNames) {
  return storeNames.length === 1 ? storeNames[0] : storeNames;
}
var getMaxKey = function(IdbKeyRange) {
  try {
    IdbKeyRange.only([[]]);
    getMaxKey = function() {
      return [[]];
    };
    return [[]];
  } catch (e2) {
    getMaxKey = function() {
      return maxString;
    };
    return maxString;
  }
};
function getKeyExtractor(keyPath) {
  if (keyPath == null) {
    return function() {
      return void 0;
    };
  } else if (typeof keyPath === "string") {
    return getSinglePathKeyExtractor(keyPath);
  } else {
    return function(obj) {
      return getByKeyPath(obj, keyPath);
    };
  }
}
function getSinglePathKeyExtractor(keyPath) {
  var split = keyPath.split(".");
  if (split.length === 1) {
    return function(obj) {
      return obj[keyPath];
    };
  } else {
    return function(obj) {
      return getByKeyPath(obj, keyPath);
    };
  }
}
function arrayify(arrayLike) {
  return [].slice.call(arrayLike);
}
var _id_counter = 0;
function getKeyPathAlias(keyPath) {
  return keyPath == null ? ":id" : typeof keyPath === "string" ? keyPath : "[" + keyPath.join("+") + "]";
}
function createDBCore(db, IdbKeyRange, tmpTrans) {
  function extractSchema(db2, trans) {
    var tables2 = arrayify(db2.objectStoreNames);
    return {
      schema: {
        name: db2.name,
        tables: tables2.map(function(table) {
          return trans.objectStore(table);
        }).map(function(store2) {
          var keyPath = store2.keyPath, autoIncrement = store2.autoIncrement;
          var compound = isArray$1(keyPath);
          var outbound = keyPath == null;
          var indexByKeyPath = {};
          var result = {
            name: store2.name,
            primaryKey: {
              name: null,
              isPrimaryKey: true,
              outbound,
              compound,
              keyPath,
              autoIncrement,
              unique: true,
              extractKey: getKeyExtractor(keyPath)
            },
            indexes: arrayify(store2.indexNames).map(function(indexName) {
              return store2.index(indexName);
            }).map(function(index2) {
              var name2 = index2.name, unique2 = index2.unique, multiEntry = index2.multiEntry, keyPath2 = index2.keyPath;
              var compound2 = isArray$1(keyPath2);
              var result2 = {
                name: name2,
                compound: compound2,
                keyPath: keyPath2,
                unique: unique2,
                multiEntry,
                extractKey: getKeyExtractor(keyPath2)
              };
              indexByKeyPath[getKeyPathAlias(keyPath2)] = result2;
              return result2;
            }),
            getIndexByKeyPath: function(keyPath2) {
              return indexByKeyPath[getKeyPathAlias(keyPath2)];
            }
          };
          indexByKeyPath[":id"] = result.primaryKey;
          if (keyPath != null) {
            indexByKeyPath[getKeyPathAlias(keyPath)] = result.primaryKey;
          }
          return result;
        })
      },
      hasGetAll: tables2.length > 0 && "getAll" in trans.objectStore(tables2[0]) && !(typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604)
    };
  }
  function makeIDBKeyRange(range2) {
    if (range2.type === 3)
      return null;
    if (range2.type === 4)
      throw new Error("Cannot convert never type to IDBKeyRange");
    var lower = range2.lower, upper = range2.upper, lowerOpen = range2.lowerOpen, upperOpen = range2.upperOpen;
    var idbRange = lower === void 0 ? upper === void 0 ? null : IdbKeyRange.upperBound(upper, !!upperOpen) : upper === void 0 ? IdbKeyRange.lowerBound(lower, !!lowerOpen) : IdbKeyRange.bound(lower, upper, !!lowerOpen, !!upperOpen);
    return idbRange;
  }
  function createDbCoreTable(tableSchema) {
    var tableName = tableSchema.name;
    function mutate(_a3) {
      var trans = _a3.trans, type2 = _a3.type, keys2 = _a3.keys, values = _a3.values, range2 = _a3.range;
      return new Promise(function(resolve, reject) {
        resolve = wrap(resolve);
        var store2 = trans.objectStore(tableName);
        var outbound = store2.keyPath == null;
        var isAddOrPut = type2 === "put" || type2 === "add";
        if (!isAddOrPut && type2 !== "delete" && type2 !== "deleteRange")
          throw new Error("Invalid operation type: " + type2);
        var length = (keys2 || values || { length: 1 }).length;
        if (keys2 && values && keys2.length !== values.length) {
          throw new Error("Given keys array must have same length as given values array.");
        }
        if (length === 0)
          return resolve({ numFailures: 0, failures: {}, results: [], lastResult: void 0 });
        var req;
        var reqs = [];
        var failures = [];
        var numFailures = 0;
        var errorHandler = function(event) {
          ++numFailures;
          preventDefault(event);
        };
        if (type2 === "deleteRange") {
          if (range2.type === 4)
            return resolve({ numFailures, failures, results: [], lastResult: void 0 });
          if (range2.type === 3)
            reqs.push(req = store2.clear());
          else
            reqs.push(req = store2.delete(makeIDBKeyRange(range2)));
        } else {
          var _a4 = isAddOrPut ? outbound ? [values, keys2] : [values, null] : [keys2, null], args1 = _a4[0], args2 = _a4[1];
          if (isAddOrPut) {
            for (var i = 0; i < length; ++i) {
              reqs.push(req = args2 && args2[i] !== void 0 ? store2[type2](args1[i], args2[i]) : store2[type2](args1[i]));
              req.onerror = errorHandler;
            }
          } else {
            for (var i = 0; i < length; ++i) {
              reqs.push(req = store2[type2](args1[i]));
              req.onerror = errorHandler;
            }
          }
        }
        var done = function(event) {
          var lastResult = event.target.result;
          reqs.forEach(function(req2, i2) {
            return req2.error != null && (failures[i2] = req2.error);
          });
          resolve({
            numFailures,
            failures,
            results: type2 === "delete" ? keys2 : reqs.map(function(req2) {
              return req2.result;
            }),
            lastResult
          });
        };
        req.onerror = function(event) {
          errorHandler(event);
          done(event);
        };
        req.onsuccess = done;
      });
    }
    function openCursor2(_a3) {
      var trans = _a3.trans, values = _a3.values, query2 = _a3.query, reverse = _a3.reverse, unique2 = _a3.unique;
      return new Promise(function(resolve, reject) {
        resolve = wrap(resolve);
        var index2 = query2.index, range2 = query2.range;
        var store2 = trans.objectStore(tableName);
        var source2 = index2.isPrimaryKey ? store2 : store2.index(index2.name);
        var direction = reverse ? unique2 ? "prevunique" : "prev" : unique2 ? "nextunique" : "next";
        var req = values || !("openKeyCursor" in source2) ? source2.openCursor(makeIDBKeyRange(range2), direction) : source2.openKeyCursor(makeIDBKeyRange(range2), direction);
        req.onerror = eventRejectHandler(reject);
        req.onsuccess = wrap(function(ev) {
          var cursor = req.result;
          if (!cursor) {
            resolve(null);
            return;
          }
          cursor.___id = ++_id_counter;
          cursor.done = false;
          var _cursorContinue = cursor.continue.bind(cursor);
          var _cursorContinuePrimaryKey = cursor.continuePrimaryKey;
          if (_cursorContinuePrimaryKey)
            _cursorContinuePrimaryKey = _cursorContinuePrimaryKey.bind(cursor);
          var _cursorAdvance = cursor.advance.bind(cursor);
          var doThrowCursorIsNotStarted = function() {
            throw new Error("Cursor not started");
          };
          var doThrowCursorIsStopped = function() {
            throw new Error("Cursor not stopped");
          };
          cursor.trans = trans;
          cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsNotStarted;
          cursor.fail = wrap(reject);
          cursor.next = function() {
            var _this = this;
            var gotOne = 1;
            return this.start(function() {
              return gotOne-- ? _this.continue() : _this.stop();
            }).then(function() {
              return _this;
            });
          };
          cursor.start = function(callback) {
            var iterationPromise = new Promise(function(resolveIteration, rejectIteration) {
              resolveIteration = wrap(resolveIteration);
              req.onerror = eventRejectHandler(rejectIteration);
              cursor.fail = rejectIteration;
              cursor.stop = function(value) {
                cursor.stop = cursor.continue = cursor.continuePrimaryKey = cursor.advance = doThrowCursorIsStopped;
                resolveIteration(value);
              };
            });
            var guardedCallback = function() {
              if (req.result) {
                try {
                  callback();
                } catch (err) {
                  cursor.fail(err);
                }
              } else {
                cursor.done = true;
                cursor.start = function() {
                  throw new Error("Cursor behind last entry");
                };
                cursor.stop();
              }
            };
            req.onsuccess = wrap(function(ev2) {
              req.onsuccess = guardedCallback;
              guardedCallback();
            });
            cursor.continue = _cursorContinue;
            cursor.continuePrimaryKey = _cursorContinuePrimaryKey;
            cursor.advance = _cursorAdvance;
            guardedCallback();
            return iterationPromise;
          };
          resolve(cursor);
        }, reject);
      });
    }
    function query(hasGetAll2) {
      return function(request3) {
        return new Promise(function(resolve, reject) {
          resolve = wrap(resolve);
          var trans = request3.trans, values = request3.values, limit = request3.limit, query2 = request3.query;
          var nonInfinitLimit = limit === Infinity ? void 0 : limit;
          var index2 = query2.index, range2 = query2.range;
          var store2 = trans.objectStore(tableName);
          var source2 = index2.isPrimaryKey ? store2 : store2.index(index2.name);
          var idbKeyRange = makeIDBKeyRange(range2);
          if (limit === 0)
            return resolve({ result: [] });
          if (hasGetAll2) {
            var req = values ? source2.getAll(idbKeyRange, nonInfinitLimit) : source2.getAllKeys(idbKeyRange, nonInfinitLimit);
            req.onsuccess = function(event) {
              return resolve({ result: event.target.result });
            };
            req.onerror = eventRejectHandler(reject);
          } else {
            var count_1 = 0;
            var req_1 = values || !("openKeyCursor" in source2) ? source2.openCursor(idbKeyRange) : source2.openKeyCursor(idbKeyRange);
            var result_1 = [];
            req_1.onsuccess = function(event) {
              var cursor = req_1.result;
              if (!cursor)
                return resolve({ result: result_1 });
              result_1.push(values ? cursor.value : cursor.primaryKey);
              if (++count_1 === limit)
                return resolve({ result: result_1 });
              cursor.continue();
            };
            req_1.onerror = eventRejectHandler(reject);
          }
        });
      };
    }
    return {
      name: tableName,
      schema: tableSchema,
      mutate,
      getMany: function(_a3) {
        var trans = _a3.trans, keys2 = _a3.keys;
        return new Promise(function(resolve, reject) {
          resolve = wrap(resolve);
          var store2 = trans.objectStore(tableName);
          var length = keys2.length;
          var result = new Array(length);
          var keyCount = 0;
          var callbackCount = 0;
          var req;
          var successHandler = function(event) {
            var req2 = event.target;
            if ((result[req2._pos] = req2.result) != null)
              ;
            if (++callbackCount === keyCount)
              resolve(result);
          };
          var errorHandler = eventRejectHandler(reject);
          for (var i = 0; i < length; ++i) {
            var key = keys2[i];
            if (key != null) {
              req = store2.get(keys2[i]);
              req._pos = i;
              req.onsuccess = successHandler;
              req.onerror = errorHandler;
              ++keyCount;
            }
          }
          if (keyCount === 0)
            resolve(result);
        });
      },
      get: function(_a3) {
        var trans = _a3.trans, key = _a3.key;
        return new Promise(function(resolve, reject) {
          resolve = wrap(resolve);
          var store2 = trans.objectStore(tableName);
          var req = store2.get(key);
          req.onsuccess = function(event) {
            return resolve(event.target.result);
          };
          req.onerror = eventRejectHandler(reject);
        });
      },
      query: query(hasGetAll),
      openCursor: openCursor2,
      count: function(_a3) {
        var query2 = _a3.query, trans = _a3.trans;
        var index2 = query2.index, range2 = query2.range;
        return new Promise(function(resolve, reject) {
          var store2 = trans.objectStore(tableName);
          var source2 = index2.isPrimaryKey ? store2 : store2.index(index2.name);
          var idbKeyRange = makeIDBKeyRange(range2);
          var req = idbKeyRange ? source2.count(idbKeyRange) : source2.count();
          req.onsuccess = wrap(function(ev) {
            return resolve(ev.target.result);
          });
          req.onerror = eventRejectHandler(reject);
        });
      }
    };
  }
  var _a2 = extractSchema(db, tmpTrans), schema = _a2.schema, hasGetAll = _a2.hasGetAll;
  var tables = schema.tables.map(function(tableSchema) {
    return createDbCoreTable(tableSchema);
  });
  var tableMap = {};
  tables.forEach(function(table) {
    return tableMap[table.name] = table;
  });
  return {
    stack: "dbcore",
    transaction: db.transaction.bind(db),
    table: function(name2) {
      var result = tableMap[name2];
      if (!result)
        throw new Error("Table '" + name2 + "' not found");
      return tableMap[name2];
    },
    MIN_KEY: -Infinity,
    MAX_KEY: getMaxKey(IdbKeyRange),
    schema
  };
}
function createMiddlewareStack(stackImpl, middlewares) {
  return middlewares.reduce(function(down, _a2) {
    var create2 = _a2.create;
    return __assign$1(__assign$1({}, down), create2(down));
  }, stackImpl);
}
function createMiddlewareStacks(middlewares, idbdb, _a2, tmpTrans) {
  var IDBKeyRange = _a2.IDBKeyRange;
  _a2.indexedDB;
  var dbcore = createMiddlewareStack(createDBCore(idbdb, IDBKeyRange, tmpTrans), middlewares.dbcore);
  return {
    dbcore
  };
}
function generateMiddlewareStacks(_a2, tmpTrans) {
  var db = _a2._novip;
  var idbdb = tmpTrans.db;
  var stacks = createMiddlewareStacks(db._middlewares, idbdb, db._deps, tmpTrans);
  db.core = stacks.dbcore;
  db.tables.forEach(function(table) {
    var tableName = table.name;
    if (db.core.schema.tables.some(function(tbl) {
      return tbl.name === tableName;
    })) {
      table.core = db.core.table(tableName);
      if (db[tableName] instanceof db.Table) {
        db[tableName].core = table.core;
      }
    }
  });
}
function setApiOnPlace(_a2, objs, tableNames, dbschema) {
  var db = _a2._novip;
  tableNames.forEach(function(tableName) {
    var schema = dbschema[tableName];
    objs.forEach(function(obj) {
      var propDesc = getPropertyDescriptor(obj, tableName);
      if (!propDesc || "value" in propDesc && propDesc.value === void 0) {
        if (obj === db.Transaction.prototype || obj instanceof db.Transaction) {
          setProp(obj, tableName, {
            get: function() {
              return this.table(tableName);
            },
            set: function(value) {
              defineProperty(this, tableName, { value, writable: true, configurable: true, enumerable: true });
            }
          });
        } else {
          obj[tableName] = new db.Table(tableName, schema);
        }
      }
    });
  });
}
function removeTablesApi(_a2, objs) {
  var db = _a2._novip;
  objs.forEach(function(obj) {
    for (var key in obj) {
      if (obj[key] instanceof db.Table)
        delete obj[key];
    }
  });
}
function lowerVersionFirst(a2, b2) {
  return a2._cfg.version - b2._cfg.version;
}
function runUpgraders(db, oldVersion, idbUpgradeTrans, reject) {
  var globalSchema = db._dbSchema;
  var trans = db._createTransaction("readwrite", db._storeNames, globalSchema);
  trans.create(idbUpgradeTrans);
  trans._completion.catch(reject);
  var rejectTransaction = trans._reject.bind(trans);
  var transless = PSD.transless || PSD;
  newScope(function() {
    PSD.trans = trans;
    PSD.transless = transless;
    if (oldVersion === 0) {
      keys(globalSchema).forEach(function(tableName) {
        createTable(idbUpgradeTrans, tableName, globalSchema[tableName].primKey, globalSchema[tableName].indexes);
      });
      generateMiddlewareStacks(db, idbUpgradeTrans);
      DexiePromise.follow(function() {
        return db.on.populate.fire(trans);
      }).catch(rejectTransaction);
    } else
      updateTablesAndIndexes(db, oldVersion, trans, idbUpgradeTrans).catch(rejectTransaction);
  });
}
function updateTablesAndIndexes(_a2, oldVersion, trans, idbUpgradeTrans) {
  var db = _a2._novip;
  var queue = [];
  var versions = db._versions;
  var globalSchema = db._dbSchema = buildGlobalSchema(db, db.idbdb, idbUpgradeTrans);
  var anyContentUpgraderHasRun = false;
  var versToRun = versions.filter(function(v) {
    return v._cfg.version >= oldVersion;
  });
  versToRun.forEach(function(version2) {
    queue.push(function() {
      var oldSchema = globalSchema;
      var newSchema = version2._cfg.dbschema;
      adjustToExistingIndexNames(db, oldSchema, idbUpgradeTrans);
      adjustToExistingIndexNames(db, newSchema, idbUpgradeTrans);
      globalSchema = db._dbSchema = newSchema;
      var diff2 = getSchemaDiff(oldSchema, newSchema);
      diff2.add.forEach(function(tuple) {
        createTable(idbUpgradeTrans, tuple[0], tuple[1].primKey, tuple[1].indexes);
      });
      diff2.change.forEach(function(change) {
        if (change.recreate) {
          throw new exceptions.Upgrade("Not yet support for changing primary key");
        } else {
          var store_1 = idbUpgradeTrans.objectStore(change.name);
          change.add.forEach(function(idx) {
            return addIndex(store_1, idx);
          });
          change.change.forEach(function(idx) {
            store_1.deleteIndex(idx.name);
            addIndex(store_1, idx);
          });
          change.del.forEach(function(idxName) {
            return store_1.deleteIndex(idxName);
          });
        }
      });
      var contentUpgrade = version2._cfg.contentUpgrade;
      if (contentUpgrade && version2._cfg.version > oldVersion) {
        generateMiddlewareStacks(db, idbUpgradeTrans);
        trans._memoizedTables = {};
        anyContentUpgraderHasRun = true;
        var upgradeSchema_1 = shallowClone(newSchema);
        diff2.del.forEach(function(table) {
          upgradeSchema_1[table] = oldSchema[table];
        });
        removeTablesApi(db, [db.Transaction.prototype]);
        setApiOnPlace(db, [db.Transaction.prototype], keys(upgradeSchema_1), upgradeSchema_1);
        trans.schema = upgradeSchema_1;
        var contentUpgradeIsAsync_1 = isAsyncFunction(contentUpgrade);
        if (contentUpgradeIsAsync_1) {
          incrementExpectedAwaits();
        }
        var returnValue_1;
        var promiseFollowed = DexiePromise.follow(function() {
          returnValue_1 = contentUpgrade(trans);
          if (returnValue_1) {
            if (contentUpgradeIsAsync_1) {
              var decrementor = decrementExpectedAwaits.bind(null, null);
              returnValue_1.then(decrementor, decrementor);
            }
          }
        });
        return returnValue_1 && typeof returnValue_1.then === "function" ? DexiePromise.resolve(returnValue_1) : promiseFollowed.then(function() {
          return returnValue_1;
        });
      }
    });
    queue.push(function(idbtrans) {
      if (!anyContentUpgraderHasRun || !hasIEDeleteObjectStoreBug) {
        var newSchema = version2._cfg.dbschema;
        deleteRemovedTables(newSchema, idbtrans);
      }
      removeTablesApi(db, [db.Transaction.prototype]);
      setApiOnPlace(db, [db.Transaction.prototype], db._storeNames, db._dbSchema);
      trans.schema = db._dbSchema;
    });
  });
  function runQueue() {
    return queue.length ? DexiePromise.resolve(queue.shift()(trans.idbtrans)).then(runQueue) : DexiePromise.resolve();
  }
  return runQueue().then(function() {
    createMissingTables(globalSchema, idbUpgradeTrans);
  });
}
function getSchemaDiff(oldSchema, newSchema) {
  var diff2 = {
    del: [],
    add: [],
    change: []
  };
  var table;
  for (table in oldSchema) {
    if (!newSchema[table])
      diff2.del.push(table);
  }
  for (table in newSchema) {
    var oldDef = oldSchema[table], newDef = newSchema[table];
    if (!oldDef) {
      diff2.add.push([table, newDef]);
    } else {
      var change = {
        name: table,
        def: newDef,
        recreate: false,
        del: [],
        add: [],
        change: []
      };
      if ("" + (oldDef.primKey.keyPath || "") !== "" + (newDef.primKey.keyPath || "") || oldDef.primKey.auto !== newDef.primKey.auto && !isIEOrEdge) {
        change.recreate = true;
        diff2.change.push(change);
      } else {
        var oldIndexes = oldDef.idxByName;
        var newIndexes = newDef.idxByName;
        var idxName = void 0;
        for (idxName in oldIndexes) {
          if (!newIndexes[idxName])
            change.del.push(idxName);
        }
        for (idxName in newIndexes) {
          var oldIdx = oldIndexes[idxName], newIdx = newIndexes[idxName];
          if (!oldIdx)
            change.add.push(newIdx);
          else if (oldIdx.src !== newIdx.src)
            change.change.push(newIdx);
        }
        if (change.del.length > 0 || change.add.length > 0 || change.change.length > 0) {
          diff2.change.push(change);
        }
      }
    }
  }
  return diff2;
}
function createTable(idbtrans, tableName, primKey, indexes) {
  var store2 = idbtrans.db.createObjectStore(tableName, primKey.keyPath ? { keyPath: primKey.keyPath, autoIncrement: primKey.auto } : { autoIncrement: primKey.auto });
  indexes.forEach(function(idx) {
    return addIndex(store2, idx);
  });
  return store2;
}
function createMissingTables(newSchema, idbtrans) {
  keys(newSchema).forEach(function(tableName) {
    if (!idbtrans.db.objectStoreNames.contains(tableName)) {
      createTable(idbtrans, tableName, newSchema[tableName].primKey, newSchema[tableName].indexes);
    }
  });
}
function deleteRemovedTables(newSchema, idbtrans) {
  [].slice.call(idbtrans.db.objectStoreNames).forEach(function(storeName) {
    return newSchema[storeName] == null && idbtrans.db.deleteObjectStore(storeName);
  });
}
function addIndex(store2, idx) {
  store2.createIndex(idx.name, idx.keyPath, { unique: idx.unique, multiEntry: idx.multi });
}
function buildGlobalSchema(db, idbdb, tmpTrans) {
  var globalSchema = {};
  var dbStoreNames = slice(idbdb.objectStoreNames, 0);
  dbStoreNames.forEach(function(storeName) {
    var store2 = tmpTrans.objectStore(storeName);
    var keyPath = store2.keyPath;
    var primKey = createIndexSpec(nameFromKeyPath(keyPath), keyPath || "", false, false, !!store2.autoIncrement, keyPath && typeof keyPath !== "string", true);
    var indexes = [];
    for (var j = 0; j < store2.indexNames.length; ++j) {
      var idbindex = store2.index(store2.indexNames[j]);
      keyPath = idbindex.keyPath;
      var index2 = createIndexSpec(idbindex.name, keyPath, !!idbindex.unique, !!idbindex.multiEntry, false, keyPath && typeof keyPath !== "string", false);
      indexes.push(index2);
    }
    globalSchema[storeName] = createTableSchema(storeName, primKey, indexes);
  });
  return globalSchema;
}
function readGlobalSchema(_a2, idbdb, tmpTrans) {
  var db = _a2._novip;
  db.verno = idbdb.version / 10;
  var globalSchema = db._dbSchema = buildGlobalSchema(db, idbdb, tmpTrans);
  db._storeNames = slice(idbdb.objectStoreNames, 0);
  setApiOnPlace(db, [db._allTables], keys(globalSchema), globalSchema);
}
function verifyInstalledSchema(db, tmpTrans) {
  var installedSchema = buildGlobalSchema(db, db.idbdb, tmpTrans);
  var diff2 = getSchemaDiff(installedSchema, db._dbSchema);
  return !(diff2.add.length || diff2.change.some(function(ch) {
    return ch.add.length || ch.change.length;
  }));
}
function adjustToExistingIndexNames(_a2, schema, idbtrans) {
  var db = _a2._novip;
  var storeNames = idbtrans.db.objectStoreNames;
  for (var i = 0; i < storeNames.length; ++i) {
    var storeName = storeNames[i];
    var store2 = idbtrans.objectStore(storeName);
    db._hasGetAll = "getAll" in store2;
    for (var j = 0; j < store2.indexNames.length; ++j) {
      var indexName = store2.indexNames[j];
      var keyPath = store2.index(indexName).keyPath;
      var dexieName = typeof keyPath === "string" ? keyPath : "[" + slice(keyPath).join("+") + "]";
      if (schema[storeName]) {
        var indexSpec = schema[storeName].idxByName[dexieName];
        if (indexSpec) {
          indexSpec.name = indexName;
          delete schema[storeName].idxByName[dexieName];
          schema[storeName].idxByName[indexName] = indexSpec;
        }
      }
    }
  }
  if (typeof navigator !== "undefined" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && _global.WorkerGlobalScope && _global instanceof _global.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) {
    db._hasGetAll = false;
  }
}
function parseIndexSyntax(primKeyAndIndexes) {
  return primKeyAndIndexes.split(",").map(function(index2, indexNum) {
    index2 = index2.trim();
    var name2 = index2.replace(/([&*]|\+\+)/g, "");
    var keyPath = /^\[/.test(name2) ? name2.match(/^\[(.*)\]$/)[1].split("+") : name2;
    return createIndexSpec(name2, keyPath || null, /\&/.test(index2), /\*/.test(index2), /\+\+/.test(index2), isArray$1(keyPath), indexNum === 0);
  });
}
var Version = function() {
  function Version2() {
  }
  Version2.prototype._parseStoresSpec = function(stores, outSchema) {
    keys(stores).forEach(function(tableName) {
      if (stores[tableName] !== null) {
        var indexes = parseIndexSyntax(stores[tableName]);
        var primKey = indexes.shift();
        if (primKey.multi)
          throw new exceptions.Schema("Primary key cannot be multi-valued");
        indexes.forEach(function(idx) {
          if (idx.auto)
            throw new exceptions.Schema("Only primary key can be marked as autoIncrement (++)");
          if (!idx.keyPath)
            throw new exceptions.Schema("Index must have a name and cannot be an empty string");
        });
        outSchema[tableName] = createTableSchema(tableName, primKey, indexes);
      }
    });
  };
  Version2.prototype.stores = function(stores) {
    var db = this.db;
    this._cfg.storesSource = this._cfg.storesSource ? extend$1(this._cfg.storesSource, stores) : stores;
    var versions = db._versions;
    var storesSpec = {};
    var dbschema = {};
    versions.forEach(function(version2) {
      extend$1(storesSpec, version2._cfg.storesSource);
      dbschema = version2._cfg.dbschema = {};
      version2._parseStoresSpec(storesSpec, dbschema);
    });
    db._dbSchema = dbschema;
    removeTablesApi(db, [db._allTables, db, db.Transaction.prototype]);
    setApiOnPlace(db, [db._allTables, db, db.Transaction.prototype, this._cfg.tables], keys(dbschema), dbschema);
    db._storeNames = keys(dbschema);
    return this;
  };
  Version2.prototype.upgrade = function(upgradeFunction) {
    this._cfg.contentUpgrade = promisableChain(this._cfg.contentUpgrade || nop, upgradeFunction);
    return this;
  };
  return Version2;
}();
function createVersionConstructor(db) {
  return makeClassConstructor(Version.prototype, function Version2(versionNumber) {
    this.db = db;
    this._cfg = {
      version: versionNumber,
      storesSource: null,
      dbschema: {},
      tables: {},
      contentUpgrade: null
    };
  });
}
function getDbNamesTable(indexedDB2, IDBKeyRange) {
  var dbNamesDB = indexedDB2["_dbNamesDB"];
  if (!dbNamesDB) {
    dbNamesDB = indexedDB2["_dbNamesDB"] = new Dexie$1(DBNAMES_DB, {
      addons: [],
      indexedDB: indexedDB2,
      IDBKeyRange
    });
    dbNamesDB.version(1).stores({ dbnames: "name" });
  }
  return dbNamesDB.table("dbnames");
}
function hasDatabasesNative(indexedDB2) {
  return indexedDB2 && typeof indexedDB2.databases === "function";
}
function getDatabaseNames(_a2) {
  var indexedDB2 = _a2.indexedDB, IDBKeyRange = _a2.IDBKeyRange;
  return hasDatabasesNative(indexedDB2) ? Promise.resolve(indexedDB2.databases()).then(function(infos) {
    return infos.map(function(info2) {
      return info2.name;
    }).filter(function(name2) {
      return name2 !== DBNAMES_DB;
    });
  }) : getDbNamesTable(indexedDB2, IDBKeyRange).toCollection().primaryKeys();
}
function _onDatabaseCreated(_a2, name2) {
  var indexedDB2 = _a2.indexedDB, IDBKeyRange = _a2.IDBKeyRange;
  !hasDatabasesNative(indexedDB2) && name2 !== DBNAMES_DB && getDbNamesTable(indexedDB2, IDBKeyRange).put({ name: name2 }).catch(nop);
}
function _onDatabaseDeleted(_a2, name2) {
  var indexedDB2 = _a2.indexedDB, IDBKeyRange = _a2.IDBKeyRange;
  !hasDatabasesNative(indexedDB2) && name2 !== DBNAMES_DB && getDbNamesTable(indexedDB2, IDBKeyRange).delete(name2).catch(nop);
}
function vip(fn2) {
  return newScope(function() {
    PSD.letThrough = true;
    return fn2();
  });
}
function idbReady() {
  var isSafari = !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent);
  if (!isSafari || !indexedDB.databases)
    return Promise.resolve();
  var intervalId;
  return new Promise(function(resolve) {
    var tryIdb = function() {
      return indexedDB.databases().finally(resolve);
    };
    intervalId = setInterval(tryIdb, 100);
    tryIdb();
  }).finally(function() {
    return clearInterval(intervalId);
  });
}
function dexieOpen(db) {
  var state = db._state;
  var indexedDB2 = db._deps.indexedDB;
  if (state.isBeingOpened || db.idbdb)
    return state.dbReadyPromise.then(function() {
      return state.dbOpenError ? rejection(state.dbOpenError) : db;
    });
  debug$4 && (state.openCanceller._stackHolder = getErrorWithStack());
  state.isBeingOpened = true;
  state.dbOpenError = null;
  state.openComplete = false;
  var openCanceller = state.openCanceller;
  function throwIfCancelled() {
    if (state.openCanceller !== openCanceller)
      throw new exceptions.DatabaseClosed("db.open() was cancelled");
  }
  var resolveDbReady = state.dbReadyResolve, upgradeTransaction = null, wasCreated = false;
  var tryOpenDB = function() {
    return new DexiePromise(function(resolve, reject) {
      throwIfCancelled();
      if (!indexedDB2)
        throw new exceptions.MissingAPI();
      var dbName = db.name;
      var req = state.autoSchema ? indexedDB2.open(dbName) : indexedDB2.open(dbName, Math.round(db.verno * 10));
      if (!req)
        throw new exceptions.MissingAPI();
      req.onerror = eventRejectHandler(reject);
      req.onblocked = wrap(db._fireOnBlocked);
      req.onupgradeneeded = wrap(function(e2) {
        upgradeTransaction = req.transaction;
        if (state.autoSchema && !db._options.allowEmptyDB) {
          req.onerror = preventDefault;
          upgradeTransaction.abort();
          req.result.close();
          var delreq = indexedDB2.deleteDatabase(dbName);
          delreq.onsuccess = delreq.onerror = wrap(function() {
            reject(new exceptions.NoSuchDatabase("Database " + dbName + " doesnt exist"));
          });
        } else {
          upgradeTransaction.onerror = eventRejectHandler(reject);
          var oldVer = e2.oldVersion > Math.pow(2, 62) ? 0 : e2.oldVersion;
          wasCreated = oldVer < 1;
          db._novip.idbdb = req.result;
          runUpgraders(db, oldVer / 10, upgradeTransaction, reject);
        }
      }, reject);
      req.onsuccess = wrap(function() {
        upgradeTransaction = null;
        var idbdb = db._novip.idbdb = req.result;
        var objectStoreNames = slice(idbdb.objectStoreNames);
        if (objectStoreNames.length > 0)
          try {
            var tmpTrans = idbdb.transaction(safariMultiStoreFix(objectStoreNames), "readonly");
            if (state.autoSchema)
              readGlobalSchema(db, idbdb, tmpTrans);
            else {
              adjustToExistingIndexNames(db, db._dbSchema, tmpTrans);
              if (!verifyInstalledSchema(db, tmpTrans)) {
                console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.");
              }
            }
            generateMiddlewareStacks(db, tmpTrans);
          } catch (e2) {
          }
        connections.push(db);
        idbdb.onversionchange = wrap(function(ev) {
          state.vcFired = true;
          db.on("versionchange").fire(ev);
        });
        idbdb.onclose = wrap(function(ev) {
          db.on("close").fire(ev);
        });
        if (wasCreated)
          _onDatabaseCreated(db._deps, dbName);
        resolve();
      }, reject);
    }).catch(function(err) {
      if (err && err.name === "UnknownError" && state.PR1398_maxLoop > 0) {
        state.PR1398_maxLoop--;
        console.warn("Dexie: Workaround for Chrome UnknownError on open()");
        return tryOpenDB();
      } else {
        return DexiePromise.reject(err);
      }
    });
  };
  return DexiePromise.race([
    openCanceller,
    (typeof navigator === "undefined" ? DexiePromise.resolve() : idbReady()).then(tryOpenDB)
  ]).then(function() {
    throwIfCancelled();
    state.onReadyBeingFired = [];
    return DexiePromise.resolve(vip(function() {
      return db.on.ready.fire(db.vip);
    })).then(function fireRemainders() {
      if (state.onReadyBeingFired.length > 0) {
        var remainders_1 = state.onReadyBeingFired.reduce(promisableChain, nop);
        state.onReadyBeingFired = [];
        return DexiePromise.resolve(vip(function() {
          return remainders_1(db.vip);
        })).then(fireRemainders);
      }
    });
  }).finally(function() {
    state.onReadyBeingFired = null;
    state.isBeingOpened = false;
  }).then(function() {
    return db;
  }).catch(function(err) {
    state.dbOpenError = err;
    try {
      upgradeTransaction && upgradeTransaction.abort();
    } catch (_a2) {
    }
    if (openCanceller === state.openCanceller) {
      db._close();
    }
    return rejection(err);
  }).finally(function() {
    state.openComplete = true;
    resolveDbReady();
  });
}
function awaitIterator(iterator) {
  var callNext = function(result) {
    return iterator.next(result);
  }, doThrow = function(error) {
    return iterator.throw(error);
  }, onSuccess = step(callNext), onError = step(doThrow);
  function step(getNext) {
    return function(val) {
      var next = getNext(val), value = next.value;
      return next.done ? value : !value || typeof value.then !== "function" ? isArray$1(value) ? Promise.all(value).then(onSuccess, onError) : onSuccess(value) : value.then(onSuccess, onError);
    };
  }
  return step(callNext)();
}
function extractTransactionArgs(mode, _tableArgs_, scopeFunc) {
  var i = arguments.length;
  if (i < 2)
    throw new exceptions.InvalidArgument("Too few arguments");
  var args = new Array(i - 1);
  while (--i)
    args[i - 1] = arguments[i];
  scopeFunc = args.pop();
  var tables = flatten(args);
  return [mode, tables, scopeFunc];
}
function enterTransactionScope(db, mode, storeNames, parentTransaction, scopeFunc) {
  return DexiePromise.resolve().then(function() {
    var transless = PSD.transless || PSD;
    var trans = db._createTransaction(mode, storeNames, db._dbSchema, parentTransaction);
    var zoneProps = {
      trans,
      transless
    };
    if (parentTransaction) {
      trans.idbtrans = parentTransaction.idbtrans;
    } else {
      try {
        trans.create();
        db._state.PR1398_maxLoop = 3;
      } catch (ex) {
        if (ex.name === errnames.InvalidState && db.isOpen() && --db._state.PR1398_maxLoop > 0) {
          console.warn("Dexie: Need to reopen db");
          db._close();
          return db.open().then(function() {
            return enterTransactionScope(db, mode, storeNames, null, scopeFunc);
          });
        }
        return rejection(ex);
      }
    }
    var scopeFuncIsAsync = isAsyncFunction(scopeFunc);
    if (scopeFuncIsAsync) {
      incrementExpectedAwaits();
    }
    var returnValue;
    var promiseFollowed = DexiePromise.follow(function() {
      returnValue = scopeFunc.call(trans, trans);
      if (returnValue) {
        if (scopeFuncIsAsync) {
          var decrementor = decrementExpectedAwaits.bind(null, null);
          returnValue.then(decrementor, decrementor);
        } else if (typeof returnValue.next === "function" && typeof returnValue.throw === "function") {
          returnValue = awaitIterator(returnValue);
        }
      }
    }, zoneProps);
    return (returnValue && typeof returnValue.then === "function" ? DexiePromise.resolve(returnValue).then(function(x) {
      return trans.active ? x : rejection(new exceptions.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
    }) : promiseFollowed.then(function() {
      return returnValue;
    })).then(function(x) {
      if (parentTransaction)
        trans._resolve();
      return trans._completion.then(function() {
        return x;
      });
    }).catch(function(e2) {
      trans._reject(e2);
      return rejection(e2);
    });
  });
}
function pad(a2, value, count) {
  var result = isArray$1(a2) ? a2.slice() : [a2];
  for (var i = 0; i < count; ++i)
    result.push(value);
  return result;
}
function createVirtualIndexMiddleware(down) {
  return __assign$1(__assign$1({}, down), { table: function(tableName) {
    var table = down.table(tableName);
    var schema = table.schema;
    var indexLookup = {};
    var allVirtualIndexes = [];
    function addVirtualIndexes(keyPath, keyTail, lowLevelIndex) {
      var keyPathAlias = getKeyPathAlias(keyPath);
      var indexList = indexLookup[keyPathAlias] = indexLookup[keyPathAlias] || [];
      var keyLength = keyPath == null ? 0 : typeof keyPath === "string" ? 1 : keyPath.length;
      var isVirtual = keyTail > 0;
      var virtualIndex = __assign$1(__assign$1({}, lowLevelIndex), { isVirtual, keyTail, keyLength, extractKey: getKeyExtractor(keyPath), unique: !isVirtual && lowLevelIndex.unique });
      indexList.push(virtualIndex);
      if (!virtualIndex.isPrimaryKey) {
        allVirtualIndexes.push(virtualIndex);
      }
      if (keyLength > 1) {
        var virtualKeyPath = keyLength === 2 ? keyPath[0] : keyPath.slice(0, keyLength - 1);
        addVirtualIndexes(virtualKeyPath, keyTail + 1, lowLevelIndex);
      }
      indexList.sort(function(a2, b2) {
        return a2.keyTail - b2.keyTail;
      });
      return virtualIndex;
    }
    var primaryKey = addVirtualIndexes(schema.primaryKey.keyPath, 0, schema.primaryKey);
    indexLookup[":id"] = [primaryKey];
    for (var _i = 0, _a2 = schema.indexes; _i < _a2.length; _i++) {
      var index2 = _a2[_i];
      addVirtualIndexes(index2.keyPath, 0, index2);
    }
    function findBestIndex(keyPath) {
      var result2 = indexLookup[getKeyPathAlias(keyPath)];
      return result2 && result2[0];
    }
    function translateRange(range2, keyTail) {
      return {
        type: range2.type === 1 ? 2 : range2.type,
        lower: pad(range2.lower, range2.lowerOpen ? down.MAX_KEY : down.MIN_KEY, keyTail),
        lowerOpen: true,
        upper: pad(range2.upper, range2.upperOpen ? down.MIN_KEY : down.MAX_KEY, keyTail),
        upperOpen: true
      };
    }
    function translateRequest(req) {
      var index3 = req.query.index;
      return index3.isVirtual ? __assign$1(__assign$1({}, req), { query: {
        index: index3,
        range: translateRange(req.query.range, index3.keyTail)
      } }) : req;
    }
    var result = __assign$1(__assign$1({}, table), { schema: __assign$1(__assign$1({}, schema), { primaryKey, indexes: allVirtualIndexes, getIndexByKeyPath: findBestIndex }), count: function(req) {
      return table.count(translateRequest(req));
    }, query: function(req) {
      return table.query(translateRequest(req));
    }, openCursor: function(req) {
      var _a3 = req.query.index, keyTail = _a3.keyTail, isVirtual = _a3.isVirtual, keyLength = _a3.keyLength;
      if (!isVirtual)
        return table.openCursor(req);
      function createVirtualCursor(cursor) {
        function _continue(key) {
          key != null ? cursor.continue(pad(key, req.reverse ? down.MAX_KEY : down.MIN_KEY, keyTail)) : req.unique ? cursor.continue(cursor.key.slice(0, keyLength).concat(req.reverse ? down.MIN_KEY : down.MAX_KEY, keyTail)) : cursor.continue();
        }
        var virtualCursor = Object.create(cursor, {
          continue: { value: _continue },
          continuePrimaryKey: {
            value: function(key, primaryKey2) {
              cursor.continuePrimaryKey(pad(key, down.MAX_KEY, keyTail), primaryKey2);
            }
          },
          primaryKey: {
            get: function() {
              return cursor.primaryKey;
            }
          },
          key: {
            get: function() {
              var key = cursor.key;
              return keyLength === 1 ? key[0] : key.slice(0, keyLength);
            }
          },
          value: {
            get: function() {
              return cursor.value;
            }
          }
        });
        return virtualCursor;
      }
      return table.openCursor(translateRequest(req)).then(function(cursor) {
        return cursor && createVirtualCursor(cursor);
      });
    } });
    return result;
  } });
}
var virtualIndexMiddleware = {
  stack: "dbcore",
  name: "VirtualIndexMiddleware",
  level: 1,
  create: createVirtualIndexMiddleware
};
function getObjectDiff(a2, b2, rv, prfx) {
  rv = rv || {};
  prfx = prfx || "";
  keys(a2).forEach(function(prop) {
    if (!hasOwn(b2, prop)) {
      rv[prfx + prop] = void 0;
    } else {
      var ap = a2[prop], bp = b2[prop];
      if (typeof ap === "object" && typeof bp === "object" && ap && bp) {
        var apTypeName = toStringTag(ap);
        var bpTypeName = toStringTag(bp);
        if (apTypeName !== bpTypeName) {
          rv[prfx + prop] = b2[prop];
        } else if (apTypeName === "Object") {
          getObjectDiff(ap, bp, rv, prfx + prop + ".");
        } else if (ap !== bp) {
          rv[prfx + prop] = b2[prop];
        }
      } else if (ap !== bp)
        rv[prfx + prop] = b2[prop];
    }
  });
  keys(b2).forEach(function(prop) {
    if (!hasOwn(a2, prop)) {
      rv[prfx + prop] = b2[prop];
    }
  });
  return rv;
}
function getEffectiveKeys(primaryKey, req) {
  if (req.type === "delete")
    return req.keys;
  return req.keys || req.values.map(primaryKey.extractKey);
}
var hooksMiddleware = {
  stack: "dbcore",
  name: "HooksMiddleware",
  level: 2,
  create: function(downCore) {
    return __assign$1(__assign$1({}, downCore), { table: function(tableName) {
      var downTable = downCore.table(tableName);
      var primaryKey = downTable.schema.primaryKey;
      var tableMiddleware = __assign$1(__assign$1({}, downTable), { mutate: function(req) {
        var dxTrans = PSD.trans;
        var _a2 = dxTrans.table(tableName).hook, deleting = _a2.deleting, creating = _a2.creating, updating = _a2.updating;
        switch (req.type) {
          case "add":
            if (creating.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return addPutOrDelete(req);
            }, true);
          case "put":
            if (creating.fire === nop && updating.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return addPutOrDelete(req);
            }, true);
          case "delete":
            if (deleting.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return addPutOrDelete(req);
            }, true);
          case "deleteRange":
            if (deleting.fire === nop)
              break;
            return dxTrans._promise("readwrite", function() {
              return deleteRange(req);
            }, true);
        }
        return downTable.mutate(req);
        function addPutOrDelete(req2) {
          var dxTrans2 = PSD.trans;
          var keys2 = req2.keys || getEffectiveKeys(primaryKey, req2);
          if (!keys2)
            throw new Error("Keys missing");
          req2 = req2.type === "add" || req2.type === "put" ? __assign$1(__assign$1({}, req2), { keys: keys2 }) : __assign$1({}, req2);
          if (req2.type !== "delete")
            req2.values = __spreadArray([], req2.values, true);
          if (req2.keys)
            req2.keys = __spreadArray([], req2.keys, true);
          return getExistingValues(downTable, req2, keys2).then(function(existingValues) {
            var contexts = keys2.map(function(key, i) {
              var existingValue = existingValues[i];
              var ctx = { onerror: null, onsuccess: null };
              if (req2.type === "delete") {
                deleting.fire.call(ctx, key, existingValue, dxTrans2);
              } else if (req2.type === "add" || existingValue === void 0) {
                var generatedPrimaryKey = creating.fire.call(ctx, key, req2.values[i], dxTrans2);
                if (key == null && generatedPrimaryKey != null) {
                  key = generatedPrimaryKey;
                  req2.keys[i] = key;
                  if (!primaryKey.outbound) {
                    setByKeyPath(req2.values[i], primaryKey.keyPath, key);
                  }
                }
              } else {
                var objectDiff = getObjectDiff(existingValue, req2.values[i]);
                var additionalChanges_1 = updating.fire.call(ctx, objectDiff, key, existingValue, dxTrans2);
                if (additionalChanges_1) {
                  var requestedValue_1 = req2.values[i];
                  Object.keys(additionalChanges_1).forEach(function(keyPath) {
                    if (hasOwn(requestedValue_1, keyPath)) {
                      requestedValue_1[keyPath] = additionalChanges_1[keyPath];
                    } else {
                      setByKeyPath(requestedValue_1, keyPath, additionalChanges_1[keyPath]);
                    }
                  });
                }
              }
              return ctx;
            });
            return downTable.mutate(req2).then(function(_a3) {
              var failures = _a3.failures, results = _a3.results, numFailures = _a3.numFailures, lastResult = _a3.lastResult;
              for (var i = 0; i < keys2.length; ++i) {
                var primKey = results ? results[i] : keys2[i];
                var ctx = contexts[i];
                if (primKey == null) {
                  ctx.onerror && ctx.onerror(failures[i]);
                } else {
                  ctx.onsuccess && ctx.onsuccess(
                    req2.type === "put" && existingValues[i] ? req2.values[i] : primKey
                  );
                }
              }
              return { failures, results, numFailures, lastResult };
            }).catch(function(error) {
              contexts.forEach(function(ctx) {
                return ctx.onerror && ctx.onerror(error);
              });
              return Promise.reject(error);
            });
          });
        }
        function deleteRange(req2) {
          return deleteNextChunk(req2.trans, req2.range, 1e4);
        }
        function deleteNextChunk(trans, range2, limit) {
          return downTable.query({ trans, values: false, query: { index: primaryKey, range: range2 }, limit }).then(function(_a3) {
            var result = _a3.result;
            return addPutOrDelete({ type: "delete", keys: result, trans }).then(function(res) {
              if (res.numFailures > 0)
                return Promise.reject(res.failures[0]);
              if (result.length < limit) {
                return { failures: [], numFailures: 0, lastResult: void 0 };
              } else {
                return deleteNextChunk(trans, __assign$1(__assign$1({}, range2), { lower: result[result.length - 1], lowerOpen: true }), limit);
              }
            });
          });
        }
      } });
      return tableMiddleware;
    } });
  }
};
function getExistingValues(table, req, effectiveKeys) {
  return req.type === "add" ? Promise.resolve([]) : table.getMany({ trans: req.trans, keys: effectiveKeys, cache: "immutable" });
}
function getFromTransactionCache(keys2, cache2, clone) {
  try {
    if (!cache2)
      return null;
    if (cache2.keys.length < keys2.length)
      return null;
    var result = [];
    for (var i = 0, j = 0; i < cache2.keys.length && j < keys2.length; ++i) {
      if (cmp$3(cache2.keys[i], keys2[j]) !== 0)
        continue;
      result.push(clone ? deepClone(cache2.values[i]) : cache2.values[i]);
      ++j;
    }
    return result.length === keys2.length ? result : null;
  } catch (_a2) {
    return null;
  }
}
var cacheExistingValuesMiddleware = {
  stack: "dbcore",
  level: -1,
  create: function(core2) {
    return {
      table: function(tableName) {
        var table = core2.table(tableName);
        return __assign$1(__assign$1({}, table), { getMany: function(req) {
          if (!req.cache) {
            return table.getMany(req);
          }
          var cachedResult = getFromTransactionCache(req.keys, req.trans["_cache"], req.cache === "clone");
          if (cachedResult) {
            return DexiePromise.resolve(cachedResult);
          }
          return table.getMany(req).then(function(res) {
            req.trans["_cache"] = {
              keys: req.keys,
              values: req.cache === "clone" ? deepClone(res) : res
            };
            return res;
          });
        }, mutate: function(req) {
          if (req.type !== "add")
            req.trans["_cache"] = null;
          return table.mutate(req);
        } });
      }
    };
  }
};
var _a$2;
function isEmptyRange(node) {
  return !("from" in node);
}
var RangeSet = function(fromOrTree, to2) {
  if (this) {
    extend$1(this, arguments.length ? { d: 1, from: fromOrTree, to: arguments.length > 1 ? to2 : fromOrTree } : { d: 0 });
  } else {
    var rv = new RangeSet();
    if (fromOrTree && "d" in fromOrTree) {
      extend$1(rv, fromOrTree);
    }
    return rv;
  }
};
props(RangeSet.prototype, (_a$2 = {
  add: function(rangeSet) {
    mergeRanges(this, rangeSet);
    return this;
  },
  addKey: function(key) {
    addRange(this, key, key);
    return this;
  },
  addKeys: function(keys2) {
    var _this = this;
    keys2.forEach(function(key) {
      return addRange(_this, key, key);
    });
    return this;
  }
}, _a$2[iteratorSymbol] = function() {
  return getRangeSetIterator(this);
}, _a$2));
function addRange(target, from, to2) {
  var diff2 = cmp$3(from, to2);
  if (isNaN(diff2))
    return;
  if (diff2 > 0)
    throw RangeError();
  if (isEmptyRange(target))
    return extend$1(target, { from, to: to2, d: 1 });
  var left2 = target.l;
  var right2 = target.r;
  if (cmp$3(to2, target.from) < 0) {
    left2 ? addRange(left2, from, to2) : target.l = { from, to: to2, d: 1, l: null, r: null };
    return rebalance(target);
  }
  if (cmp$3(from, target.to) > 0) {
    right2 ? addRange(right2, from, to2) : target.r = { from, to: to2, d: 1, l: null, r: null };
    return rebalance(target);
  }
  if (cmp$3(from, target.from) < 0) {
    target.from = from;
    target.l = null;
    target.d = right2 ? right2.d + 1 : 1;
  }
  if (cmp$3(to2, target.to) > 0) {
    target.to = to2;
    target.r = null;
    target.d = target.l ? target.l.d + 1 : 1;
  }
  var rightWasCutOff = !target.r;
  if (left2 && !target.l) {
    mergeRanges(target, left2);
  }
  if (right2 && rightWasCutOff) {
    mergeRanges(target, right2);
  }
}
function mergeRanges(target, newSet) {
  function _addRangeSet(target2, _a2) {
    var from = _a2.from, to2 = _a2.to, l = _a2.l, r = _a2.r;
    addRange(target2, from, to2);
    if (l)
      _addRangeSet(target2, l);
    if (r)
      _addRangeSet(target2, r);
  }
  if (!isEmptyRange(newSet))
    _addRangeSet(target, newSet);
}
function rangesOverlap(rangeSet1, rangeSet2) {
  var i1 = getRangeSetIterator(rangeSet2);
  var nextResult1 = i1.next();
  if (nextResult1.done)
    return false;
  var a2 = nextResult1.value;
  var i2 = getRangeSetIterator(rangeSet1);
  var nextResult2 = i2.next(a2.from);
  var b2 = nextResult2.value;
  while (!nextResult1.done && !nextResult2.done) {
    if (cmp$3(b2.from, a2.to) <= 0 && cmp$3(b2.to, a2.from) >= 0)
      return true;
    cmp$3(a2.from, b2.from) < 0 ? a2 = (nextResult1 = i1.next(b2.from)).value : b2 = (nextResult2 = i2.next(a2.from)).value;
  }
  return false;
}
function getRangeSetIterator(node) {
  var state = isEmptyRange(node) ? null : { s: 0, n: node };
  return {
    next: function(key) {
      var keyProvided = arguments.length > 0;
      while (state) {
        switch (state.s) {
          case 0:
            state.s = 1;
            if (keyProvided) {
              while (state.n.l && cmp$3(key, state.n.from) < 0)
                state = { up: state, n: state.n.l, s: 1 };
            } else {
              while (state.n.l)
                state = { up: state, n: state.n.l, s: 1 };
            }
          case 1:
            state.s = 2;
            if (!keyProvided || cmp$3(key, state.n.to) <= 0)
              return { value: state.n, done: false };
          case 2:
            if (state.n.r) {
              state.s = 3;
              state = { up: state, n: state.n.r, s: 0 };
              continue;
            }
          case 3:
            state = state.up;
        }
      }
      return { done: true };
    }
  };
}
function rebalance(target) {
  var _a2, _b;
  var diff2 = (((_a2 = target.r) === null || _a2 === void 0 ? void 0 : _a2.d) || 0) - (((_b = target.l) === null || _b === void 0 ? void 0 : _b.d) || 0);
  var r = diff2 > 1 ? "r" : diff2 < -1 ? "l" : "";
  if (r) {
    var l = r === "r" ? "l" : "r";
    var rootClone = __assign$1({}, target);
    var oldRootRight = target[r];
    target.from = oldRootRight.from;
    target.to = oldRootRight.to;
    target[r] = oldRootRight[r];
    rootClone[r] = oldRootRight[l];
    target[l] = rootClone;
    rootClone.d = computeDepth(rootClone);
  }
  target.d = computeDepth(target);
}
function computeDepth(_a2) {
  var r = _a2.r, l = _a2.l;
  return (r ? l ? Math.max(r.d, l.d) : r.d : l ? l.d : 0) + 1;
}
var observabilityMiddleware = {
  stack: "dbcore",
  level: 0,
  create: function(core2) {
    var dbName = core2.schema.name;
    var FULL_RANGE = new RangeSet(core2.MIN_KEY, core2.MAX_KEY);
    return __assign$1(__assign$1({}, core2), { table: function(tableName) {
      var table = core2.table(tableName);
      var schema = table.schema;
      var primaryKey = schema.primaryKey;
      var extractKey = primaryKey.extractKey, outbound = primaryKey.outbound;
      var tableClone = __assign$1(__assign$1({}, table), { mutate: function(req) {
        var trans = req.trans;
        var mutatedParts = trans.mutatedParts || (trans.mutatedParts = {});
        var getRangeSet = function(indexName) {
          var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
          return mutatedParts[part] || (mutatedParts[part] = new RangeSet());
        };
        var pkRangeSet = getRangeSet("");
        var delsRangeSet = getRangeSet(":dels");
        var type2 = req.type;
        var _a2 = req.type === "deleteRange" ? [req.range] : req.type === "delete" ? [req.keys] : req.values.length < 50 ? [[], req.values] : [], keys2 = _a2[0], newObjs = _a2[1];
        var oldCache = req.trans["_cache"];
        return table.mutate(req).then(function(res) {
          if (isArray$1(keys2)) {
            if (type2 !== "delete")
              keys2 = res.results;
            pkRangeSet.addKeys(keys2);
            var oldObjs = getFromTransactionCache(keys2, oldCache);
            if (!oldObjs && type2 !== "add") {
              delsRangeSet.addKeys(keys2);
            }
            if (oldObjs || newObjs) {
              trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs);
            }
          } else if (keys2) {
            var range2 = { from: keys2.lower, to: keys2.upper };
            delsRangeSet.add(range2);
            pkRangeSet.add(range2);
          } else {
            pkRangeSet.add(FULL_RANGE);
            delsRangeSet.add(FULL_RANGE);
            schema.indexes.forEach(function(idx) {
              return getRangeSet(idx.name).add(FULL_RANGE);
            });
          }
          return res;
        });
      } });
      var getRange = function(_a2) {
        var _b, _c;
        var _d = _a2.query, index2 = _d.index, range2 = _d.range;
        return [
          index2,
          new RangeSet((_b = range2.lower) !== null && _b !== void 0 ? _b : core2.MIN_KEY, (_c = range2.upper) !== null && _c !== void 0 ? _c : core2.MAX_KEY)
        ];
      };
      var readSubscribers = {
        get: function(req) {
          return [primaryKey, new RangeSet(req.key)];
        },
        getMany: function(req) {
          return [primaryKey, new RangeSet().addKeys(req.keys)];
        },
        count: getRange,
        query: getRange,
        openCursor: getRange
      };
      keys(readSubscribers).forEach(function(method) {
        tableClone[method] = function(req) {
          var subscr = PSD.subscr;
          if (subscr) {
            var getRangeSet = function(indexName) {
              var part = "idb://" + dbName + "/" + tableName + "/" + indexName;
              return subscr[part] || (subscr[part] = new RangeSet());
            };
            var pkRangeSet_1 = getRangeSet("");
            var delsRangeSet_1 = getRangeSet(":dels");
            var _a2 = readSubscribers[method](req), queriedIndex = _a2[0], queriedRanges = _a2[1];
            getRangeSet(queriedIndex.name || "").add(queriedRanges);
            if (!queriedIndex.isPrimaryKey) {
              if (method === "count") {
                delsRangeSet_1.add(FULL_RANGE);
              } else {
                var keysPromise_1 = method === "query" && outbound && req.values && table.query(__assign$1(__assign$1({}, req), { values: false }));
                return table[method].apply(this, arguments).then(function(res) {
                  if (method === "query") {
                    if (outbound && req.values) {
                      return keysPromise_1.then(function(_a3) {
                        var resultingKeys = _a3.result;
                        pkRangeSet_1.addKeys(resultingKeys);
                        return res;
                      });
                    }
                    var pKeys = req.values ? res.result.map(extractKey) : res.result;
                    if (req.values) {
                      pkRangeSet_1.addKeys(pKeys);
                    } else {
                      delsRangeSet_1.addKeys(pKeys);
                    }
                  } else if (method === "openCursor") {
                    var cursor_1 = res;
                    var wantValues_1 = req.values;
                    return cursor_1 && Object.create(cursor_1, {
                      key: {
                        get: function() {
                          delsRangeSet_1.addKey(cursor_1.primaryKey);
                          return cursor_1.key;
                        }
                      },
                      primaryKey: {
                        get: function() {
                          var pkey = cursor_1.primaryKey;
                          delsRangeSet_1.addKey(pkey);
                          return pkey;
                        }
                      },
                      value: {
                        get: function() {
                          wantValues_1 && pkRangeSet_1.addKey(cursor_1.primaryKey);
                          return cursor_1.value;
                        }
                      }
                    });
                  }
                  return res;
                });
              }
            }
          }
          return table[method].apply(this, arguments);
        };
      });
      return tableClone;
    } });
  }
};
function trackAffectedIndexes(getRangeSet, schema, oldObjs, newObjs) {
  function addAffectedIndex(ix) {
    var rangeSet = getRangeSet(ix.name || "");
    function extractKey(obj) {
      return obj != null ? ix.extractKey(obj) : null;
    }
    var addKeyOrKeys = function(key) {
      return ix.multiEntry && isArray$1(key) ? key.forEach(function(key2) {
        return rangeSet.addKey(key2);
      }) : rangeSet.addKey(key);
    };
    (oldObjs || newObjs).forEach(function(_2, i) {
      var oldKey = oldObjs && extractKey(oldObjs[i]);
      var newKey = newObjs && extractKey(newObjs[i]);
      if (cmp$3(oldKey, newKey) !== 0) {
        if (oldKey != null)
          addKeyOrKeys(oldKey);
        if (newKey != null)
          addKeyOrKeys(newKey);
      }
    });
  }
  schema.indexes.forEach(addAffectedIndex);
}
var Dexie$1 = function() {
  function Dexie2(name2, options) {
    var _this = this;
    this._middlewares = {};
    this.verno = 0;
    var deps = Dexie2.dependencies;
    this._options = options = __assign$1({
      addons: Dexie2.addons,
      autoOpen: true,
      indexedDB: deps.indexedDB,
      IDBKeyRange: deps.IDBKeyRange
    }, options);
    this._deps = {
      indexedDB: options.indexedDB,
      IDBKeyRange: options.IDBKeyRange
    };
    var addons = options.addons;
    this._dbSchema = {};
    this._versions = [];
    this._storeNames = [];
    this._allTables = {};
    this.idbdb = null;
    this._novip = this;
    var state = {
      dbOpenError: null,
      isBeingOpened: false,
      onReadyBeingFired: null,
      openComplete: false,
      dbReadyResolve: nop,
      dbReadyPromise: null,
      cancelOpen: nop,
      openCanceller: null,
      autoSchema: true,
      PR1398_maxLoop: 3
    };
    state.dbReadyPromise = new DexiePromise(function(resolve) {
      state.dbReadyResolve = resolve;
    });
    state.openCanceller = new DexiePromise(function(_2, reject) {
      state.cancelOpen = reject;
    });
    this._state = state;
    this.name = name2;
    this.on = Events(this, "populate", "blocked", "versionchange", "close", { ready: [promisableChain, nop] });
    this.on.ready.subscribe = override(this.on.ready.subscribe, function(subscribe3) {
      return function(subscriber, bSticky) {
        Dexie2.vip(function() {
          var state2 = _this._state;
          if (state2.openComplete) {
            if (!state2.dbOpenError)
              DexiePromise.resolve().then(subscriber);
            if (bSticky)
              subscribe3(subscriber);
          } else if (state2.onReadyBeingFired) {
            state2.onReadyBeingFired.push(subscriber);
            if (bSticky)
              subscribe3(subscriber);
          } else {
            subscribe3(subscriber);
            var db_1 = _this;
            if (!bSticky)
              subscribe3(function unsubscribe3() {
                db_1.on.ready.unsubscribe(subscriber);
                db_1.on.ready.unsubscribe(unsubscribe3);
              });
          }
        });
      };
    });
    this.Collection = createCollectionConstructor(this);
    this.Table = createTableConstructor(this);
    this.Transaction = createTransactionConstructor(this);
    this.Version = createVersionConstructor(this);
    this.WhereClause = createWhereClauseConstructor(this);
    this.on("versionchange", function(ev) {
      if (ev.newVersion > 0)
        console.warn("Another connection wants to upgrade database '" + _this.name + "'. Closing db now to resume the upgrade.");
      else
        console.warn("Another connection wants to delete database '" + _this.name + "'. Closing db now to resume the delete request.");
      _this.close();
    });
    this.on("blocked", function(ev) {
      if (!ev.newVersion || ev.newVersion < ev.oldVersion)
        console.warn("Dexie.delete('" + _this.name + "') was blocked");
      else
        console.warn("Upgrade '" + _this.name + "' blocked by other connection holding version " + ev.oldVersion / 10);
    });
    this._maxKey = getMaxKey(options.IDBKeyRange);
    this._createTransaction = function(mode, storeNames, dbschema, parentTransaction) {
      return new _this.Transaction(mode, storeNames, dbschema, _this._options.chromeTransactionDurability, parentTransaction);
    };
    this._fireOnBlocked = function(ev) {
      _this.on("blocked").fire(ev);
      connections.filter(function(c2) {
        return c2.name === _this.name && c2 !== _this && !c2._state.vcFired;
      }).map(function(c2) {
        return c2.on("versionchange").fire(ev);
      });
    };
    this.use(virtualIndexMiddleware);
    this.use(hooksMiddleware);
    this.use(observabilityMiddleware);
    this.use(cacheExistingValuesMiddleware);
    this.vip = Object.create(this, { _vip: { value: true } });
    addons.forEach(function(addon) {
      return addon(_this);
    });
  }
  Dexie2.prototype.version = function(versionNumber) {
    if (isNaN(versionNumber) || versionNumber < 0.1)
      throw new exceptions.Type("Given version is not a positive number");
    versionNumber = Math.round(versionNumber * 10) / 10;
    if (this.idbdb || this._state.isBeingOpened)
      throw new exceptions.Schema("Cannot add version when database is open");
    this.verno = Math.max(this.verno, versionNumber);
    var versions = this._versions;
    var versionInstance = versions.filter(function(v) {
      return v._cfg.version === versionNumber;
    })[0];
    if (versionInstance)
      return versionInstance;
    versionInstance = new this.Version(versionNumber);
    versions.push(versionInstance);
    versions.sort(lowerVersionFirst);
    versionInstance.stores({});
    this._state.autoSchema = false;
    return versionInstance;
  };
  Dexie2.prototype._whenReady = function(fn2) {
    var _this = this;
    return this.idbdb && (this._state.openComplete || PSD.letThrough || this._vip) ? fn2() : new DexiePromise(function(resolve, reject) {
      if (_this._state.openComplete) {
        return reject(new exceptions.DatabaseClosed(_this._state.dbOpenError));
      }
      if (!_this._state.isBeingOpened) {
        if (!_this._options.autoOpen) {
          reject(new exceptions.DatabaseClosed());
          return;
        }
        _this.open().catch(nop);
      }
      _this._state.dbReadyPromise.then(resolve, reject);
    }).then(fn2);
  };
  Dexie2.prototype.use = function(_a2) {
    var stack = _a2.stack, create2 = _a2.create, level = _a2.level, name2 = _a2.name;
    if (name2)
      this.unuse({ stack, name: name2 });
    var middlewares = this._middlewares[stack] || (this._middlewares[stack] = []);
    middlewares.push({ stack, create: create2, level: level == null ? 10 : level, name: name2 });
    middlewares.sort(function(a2, b2) {
      return a2.level - b2.level;
    });
    return this;
  };
  Dexie2.prototype.unuse = function(_a2) {
    var stack = _a2.stack, name2 = _a2.name, create2 = _a2.create;
    if (stack && this._middlewares[stack]) {
      this._middlewares[stack] = this._middlewares[stack].filter(function(mw) {
        return create2 ? mw.create !== create2 : name2 ? mw.name !== name2 : false;
      });
    }
    return this;
  };
  Dexie2.prototype.open = function() {
    return dexieOpen(this);
  };
  Dexie2.prototype._close = function() {
    var state = this._state;
    var idx = connections.indexOf(this);
    if (idx >= 0)
      connections.splice(idx, 1);
    if (this.idbdb) {
      try {
        this.idbdb.close();
      } catch (e2) {
      }
      this._novip.idbdb = null;
    }
    state.dbReadyPromise = new DexiePromise(function(resolve) {
      state.dbReadyResolve = resolve;
    });
    state.openCanceller = new DexiePromise(function(_2, reject) {
      state.cancelOpen = reject;
    });
  };
  Dexie2.prototype.close = function() {
    this._close();
    var state = this._state;
    this._options.autoOpen = false;
    state.dbOpenError = new exceptions.DatabaseClosed();
    if (state.isBeingOpened)
      state.cancelOpen(state.dbOpenError);
  };
  Dexie2.prototype.delete = function() {
    var _this = this;
    var hasArguments = arguments.length > 0;
    var state = this._state;
    return new DexiePromise(function(resolve, reject) {
      var doDelete = function() {
        _this.close();
        var req = _this._deps.indexedDB.deleteDatabase(_this.name);
        req.onsuccess = wrap(function() {
          _onDatabaseDeleted(_this._deps, _this.name);
          resolve();
        });
        req.onerror = eventRejectHandler(reject);
        req.onblocked = _this._fireOnBlocked;
      };
      if (hasArguments)
        throw new exceptions.InvalidArgument("Arguments not allowed in db.delete()");
      if (state.isBeingOpened) {
        state.dbReadyPromise.then(doDelete);
      } else {
        doDelete();
      }
    });
  };
  Dexie2.prototype.backendDB = function() {
    return this.idbdb;
  };
  Dexie2.prototype.isOpen = function() {
    return this.idbdb !== null;
  };
  Dexie2.prototype.hasBeenClosed = function() {
    var dbOpenError = this._state.dbOpenError;
    return dbOpenError && dbOpenError.name === "DatabaseClosed";
  };
  Dexie2.prototype.hasFailed = function() {
    return this._state.dbOpenError !== null;
  };
  Dexie2.prototype.dynamicallyOpened = function() {
    return this._state.autoSchema;
  };
  Object.defineProperty(Dexie2.prototype, "tables", {
    get: function() {
      var _this = this;
      return keys(this._allTables).map(function(name2) {
        return _this._allTables[name2];
      });
    },
    enumerable: false,
    configurable: true
  });
  Dexie2.prototype.transaction = function() {
    var args = extractTransactionArgs.apply(this, arguments);
    return this._transaction.apply(this, args);
  };
  Dexie2.prototype._transaction = function(mode, tables, scopeFunc) {
    var _this = this;
    var parentTransaction = PSD.trans;
    if (!parentTransaction || parentTransaction.db !== this || mode.indexOf("!") !== -1)
      parentTransaction = null;
    var onlyIfCompatible = mode.indexOf("?") !== -1;
    mode = mode.replace("!", "").replace("?", "");
    var idbMode, storeNames;
    try {
      storeNames = tables.map(function(table) {
        var storeName = table instanceof _this.Table ? table.name : table;
        if (typeof storeName !== "string")
          throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
        return storeName;
      });
      if (mode == "r" || mode === READONLY)
        idbMode = READONLY;
      else if (mode == "rw" || mode == READWRITE)
        idbMode = READWRITE;
      else
        throw new exceptions.InvalidArgument("Invalid transaction mode: " + mode);
      if (parentTransaction) {
        if (parentTransaction.mode === READONLY && idbMode === READWRITE) {
          if (onlyIfCompatible) {
            parentTransaction = null;
          } else
            throw new exceptions.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
        }
        if (parentTransaction) {
          storeNames.forEach(function(storeName) {
            if (parentTransaction && parentTransaction.storeNames.indexOf(storeName) === -1) {
              if (onlyIfCompatible) {
                parentTransaction = null;
              } else
                throw new exceptions.SubTransaction("Table " + storeName + " not included in parent transaction.");
            }
          });
        }
        if (onlyIfCompatible && parentTransaction && !parentTransaction.active) {
          parentTransaction = null;
        }
      }
    } catch (e2) {
      return parentTransaction ? parentTransaction._promise(null, function(_2, reject) {
        reject(e2);
      }) : rejection(e2);
    }
    var enterTransaction = enterTransactionScope.bind(null, this, idbMode, storeNames, parentTransaction, scopeFunc);
    return parentTransaction ? parentTransaction._promise(idbMode, enterTransaction, "lock") : PSD.trans ? usePSD(PSD.transless, function() {
      return _this._whenReady(enterTransaction);
    }) : this._whenReady(enterTransaction);
  };
  Dexie2.prototype.table = function(tableName) {
    if (!hasOwn(this._allTables, tableName)) {
      throw new exceptions.InvalidTable("Table " + tableName + " does not exist");
    }
    return this._allTables[tableName];
  };
  return Dexie2;
}();
var symbolObservable = typeof Symbol !== "undefined" && "observable" in Symbol ? Symbol.observable : "@@observable";
var Observable = function() {
  function Observable2(subscribe3) {
    this._subscribe = subscribe3;
  }
  Observable2.prototype.subscribe = function(x, error, complete) {
    return this._subscribe(!x || typeof x === "function" ? { next: x, error, complete } : x);
  };
  Observable2.prototype[symbolObservable] = function() {
    return this;
  };
  return Observable2;
}();
function extendObservabilitySet(target, newSet) {
  keys(newSet).forEach(function(part) {
    var rangeSet = target[part] || (target[part] = new RangeSet());
    mergeRanges(rangeSet, newSet[part]);
  });
  return target;
}
function liveQuery(querier) {
  var hasValue = false;
  var currentValue = void 0;
  var observable = new Observable(function(observer) {
    var scopeFuncIsAsync = isAsyncFunction(querier);
    function execute(subscr) {
      if (scopeFuncIsAsync) {
        incrementExpectedAwaits();
      }
      var exec = function() {
        return newScope(querier, { subscr, trans: null });
      };
      var rv = PSD.trans ? usePSD(PSD.transless, exec) : exec();
      if (scopeFuncIsAsync) {
        rv.then(decrementExpectedAwaits, decrementExpectedAwaits);
      }
      return rv;
    }
    var closed = false;
    var accumMuts = {};
    var currentObs = {};
    var subscription = {
      get closed() {
        return closed;
      },
      unsubscribe: function() {
        closed = true;
        globalEvents.storagemutated.unsubscribe(mutationListener);
      }
    };
    observer.start && observer.start(subscription);
    var querying = false, startedListening = false;
    function shouldNotify() {
      return keys(currentObs).some(function(key) {
        return accumMuts[key] && rangesOverlap(accumMuts[key], currentObs[key]);
      });
    }
    var mutationListener = function(parts) {
      extendObservabilitySet(accumMuts, parts);
      if (shouldNotify()) {
        doQuery();
      }
    };
    var doQuery = function() {
      if (querying || closed)
        return;
      accumMuts = {};
      var subscr = {};
      var ret = execute(subscr);
      if (!startedListening) {
        globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, mutationListener);
        startedListening = true;
      }
      querying = true;
      Promise.resolve(ret).then(function(result) {
        hasValue = true;
        currentValue = result;
        querying = false;
        if (closed)
          return;
        if (shouldNotify()) {
          doQuery();
        } else {
          accumMuts = {};
          currentObs = subscr;
          observer.next && observer.next(result);
        }
      }, function(err) {
        querying = false;
        hasValue = false;
        observer.error && observer.error(err);
        subscription.unsubscribe();
      });
    };
    doQuery();
    return subscription;
  });
  observable.hasValue = function() {
    return hasValue;
  };
  observable.getValue = function() {
    return currentValue;
  };
  return observable;
}
var domDeps;
try {
  domDeps = {
    indexedDB: _global.indexedDB || _global.mozIndexedDB || _global.webkitIndexedDB || _global.msIndexedDB,
    IDBKeyRange: _global.IDBKeyRange || _global.webkitIDBKeyRange
  };
} catch (e2) {
  domDeps = { indexedDB: null, IDBKeyRange: null };
}
var Dexie = Dexie$1;
props(Dexie, __assign$1(__assign$1({}, fullNameExceptions), {
  delete: function(databaseName) {
    var db = new Dexie(databaseName, { addons: [] });
    return db.delete();
  },
  exists: function(name2) {
    return new Dexie(name2, { addons: [] }).open().then(function(db) {
      db.close();
      return true;
    }).catch("NoSuchDatabaseError", function() {
      return false;
    });
  },
  getDatabaseNames: function(cb) {
    try {
      return getDatabaseNames(Dexie.dependencies).then(cb);
    } catch (_a2) {
      return rejection(new exceptions.MissingAPI());
    }
  },
  defineClass: function() {
    function Class(content) {
      extend$1(this, content);
    }
    return Class;
  },
  ignoreTransaction: function(scopeFunc) {
    return PSD.trans ? usePSD(PSD.transless, scopeFunc) : scopeFunc();
  },
  vip,
  async: function(generatorFn) {
    return function() {
      try {
        var rv = awaitIterator(generatorFn.apply(this, arguments));
        if (!rv || typeof rv.then !== "function")
          return DexiePromise.resolve(rv);
        return rv;
      } catch (e2) {
        return rejection(e2);
      }
    };
  },
  spawn: function(generatorFn, args, thiz) {
    try {
      var rv = awaitIterator(generatorFn.apply(thiz, args || []));
      if (!rv || typeof rv.then !== "function")
        return DexiePromise.resolve(rv);
      return rv;
    } catch (e2) {
      return rejection(e2);
    }
  },
  currentTransaction: {
    get: function() {
      return PSD.trans || null;
    }
  },
  waitFor: function(promiseOrFunction, optionalTimeout) {
    var promise = DexiePromise.resolve(typeof promiseOrFunction === "function" ? Dexie.ignoreTransaction(promiseOrFunction) : promiseOrFunction).timeout(optionalTimeout || 6e4);
    return PSD.trans ? PSD.trans.waitFor(promise) : promise;
  },
  Promise: DexiePromise,
  debug: {
    get: function() {
      return debug$4;
    },
    set: function(value) {
      setDebug(value, value === "dexie" ? function() {
        return true;
      } : dexieStackFrameFilter);
    }
  },
  derive,
  extend: extend$1,
  props,
  override,
  Events,
  on: globalEvents,
  liveQuery,
  extendObservabilitySet,
  getByKeyPath,
  setByKeyPath,
  delByKeyPath,
  shallowClone,
  deepClone,
  getObjectDiff,
  cmp: cmp$3,
  asap: asap$1,
  minKey,
  addons: [],
  connections,
  errnames,
  dependencies: domDeps,
  semVer: DEXIE_VERSION,
  version: DEXIE_VERSION.split(".").map(function(n) {
    return parseInt(n);
  }).reduce(function(p, c2, i) {
    return p + c2 / Math.pow(10, i * 2);
  })
}));
Dexie.maxKey = getMaxKey(Dexie.dependencies.IDBKeyRange);
if (typeof dispatchEvent !== "undefined" && typeof addEventListener !== "undefined") {
  globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(updatedParts) {
    if (!propagatingLocally) {
      var event_1;
      if (isIEOrEdge) {
        event_1 = document.createEvent("CustomEvent");
        event_1.initCustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, true, true, updatedParts);
      } else {
        event_1 = new CustomEvent(STORAGE_MUTATED_DOM_EVENT_NAME, {
          detail: updatedParts
        });
      }
      propagatingLocally = true;
      dispatchEvent(event_1);
      propagatingLocally = false;
    }
  });
  addEventListener(STORAGE_MUTATED_DOM_EVENT_NAME, function(_a2) {
    var detail = _a2.detail;
    if (!propagatingLocally) {
      propagateLocally(detail);
    }
  });
}
function propagateLocally(updateParts) {
  var wasMe = propagatingLocally;
  try {
    propagatingLocally = true;
    globalEvents.storagemutated.fire(updateParts);
  } finally {
    propagatingLocally = wasMe;
  }
}
var propagatingLocally = false;
if (typeof BroadcastChannel !== "undefined") {
  var bc_1 = new BroadcastChannel(STORAGE_MUTATED_DOM_EVENT_NAME);
  if (typeof bc_1.unref === "function") {
    bc_1.unref();
  }
  globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
    if (!propagatingLocally) {
      bc_1.postMessage(changedParts);
    }
  });
  bc_1.onmessage = function(ev) {
    if (ev.data)
      propagateLocally(ev.data);
  };
} else if (typeof self !== "undefined" && typeof navigator !== "undefined") {
  globalEvents(DEXIE_STORAGE_MUTATED_EVENT_NAME, function(changedParts) {
    try {
      if (!propagatingLocally) {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem(STORAGE_MUTATED_DOM_EVENT_NAME, JSON.stringify({
            trig: Math.random(),
            changedParts
          }));
        }
        if (typeof self["clients"] === "object") {
          __spreadArray([], self["clients"].matchAll({ includeUncontrolled: true }), true).forEach(function(client) {
            return client.postMessage({
              type: STORAGE_MUTATED_DOM_EVENT_NAME,
              changedParts
            });
          });
        }
      }
    } catch (_a2) {
    }
  });
  if (typeof addEventListener !== "undefined") {
    addEventListener("storage", function(ev) {
      if (ev.key === STORAGE_MUTATED_DOM_EVENT_NAME) {
        var data2 = JSON.parse(ev.newValue);
        if (data2)
          propagateLocally(data2.changedParts);
      }
    });
  }
  var swContainer = self.document && navigator.serviceWorker;
  if (swContainer) {
    swContainer.addEventListener("message", propagateMessageLocally);
  }
}
function propagateMessageLocally(_a2) {
  var data2 = _a2.data;
  if (data2 && data2.type === STORAGE_MUTATED_DOM_EVENT_NAME) {
    propagateLocally(data2.changedParts);
  }
}
DexiePromise.rejectionMapper = mapError;
setDebug(debug$4, dexieStackFrameFilter);
var sensorsdata = { exports: {} };
(function(module, exports) {
  !function(e2, t2) {
    module.exports = t2();
  }(0, function() {
    var e2, t2 = {};
    function r(e3) {
      if (!e3)
        return false;
      var t3 = Object.prototype.toString.call(e3);
      return "[object Function]" == t3 || "[object AsyncFunction]" == t3;
    }
    function n() {
      return Date.now && r(Date.now) ? Date.now() : new Date().getTime();
    }
    t2.DEFAULT_SEND_TYPE = "image", function() {
      var e3 = { "function": true, object: true }, t3 = e3[typeof window] && window || this;
      var r2 = t3.JSON, n2 = t3.JSON3, i2 = false, a3 = function o2(r3, n3) {
        r3 || (r3 = t3.Object()), n3 || (n3 = t3.Object());
        var i3 = r3.Number || t3.Number, a4 = r3.String || t3.String, s2 = r3.Object || t3.Object, l2 = r3.Date || t3.Date, u2 = r3.SyntaxError || t3.SyntaxError, c3 = r3.TypeError || t3.TypeError, p2 = r3.Math || t3.Math, d3 = r3.JSON || t3.JSON;
        if ("object" == typeof d3 && d3)
          return n3.stringify = d3.stringify, n3.parse = d3.parse, n3.runInContext = o2, n3;
        var f3, g2 = s2.prototype, _3 = g2.toString, h2 = g2.hasOwnProperty;
        function m2(e4, t4) {
          try {
            e4();
          } catch (r4) {
            t4 && t4();
          }
        }
        var v2 = new l2(-3509827334573292);
        function y2(e4) {
          if (null != y2[e4])
            return y2[e4];
          var t4;
          if ("bug-string-char-index" == e4)
            t4 = "a" != "a"[0];
          else if ("json" == e4)
            t4 = y2("json-stringify") && y2("date-serialization") && y2("json-parse");
          else if ("date-serialization" == e4) {
            if (t4 = y2("json-stringify") && v2) {
              var r4 = n3.stringify;
              m2(function() {
                t4 = '"-271821-04-20T00:00:00.000Z"' == r4(new l2(-864e13)) && '"+275760-09-13T00:00:00.000Z"' == r4(new l2(864e13)) && '"-000001-01-01T00:00:00.000Z"' == r4(new l2(-621987552e5)) && '"1969-12-31T23:59:59.999Z"' == r4(new l2(-1));
              });
            }
          } else {
            var o3, s3 = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
            if ("json-stringify" == e4) {
              var u3 = "function" == typeof (r4 = n3.stringify);
              u3 && ((o3 = function() {
                return 1;
              }).toJSON = o3, m2(function() {
                u3 = "0" === r4(0) && "0" === r4(new i3()) && '""' == r4(new a4()) && r4(_3) === f3 && r4(f3) === f3 && r4() === f3 && "1" === r4(o3) && "[1]" == r4([o3]) && "[null]" == r4([f3]) && "null" == r4(null) && "[null,null,null]" == r4([f3, _3, null]) && r4({ a: [o3, true, false, null, "\0\b\n\f\r	"] }) == s3 && "1" === r4(null, o3) && "[\n 1,\n 2\n]" == r4([1, 2], null, 1);
              }, function() {
                u3 = false;
              })), t4 = u3;
            }
            if ("json-parse" == e4) {
              var c4, p3 = n3.parse;
              "function" == typeof p3 && m2(function() {
                0 !== p3("0") || p3(false) || (o3 = p3(s3), (c4 = 5 == o3.a.length && 1 === o3.a[0]) && (m2(function() {
                  c4 = !p3('"	"');
                }), c4 && m2(function() {
                  c4 = 1 !== p3("01");
                }), c4 && m2(function() {
                  c4 = 1 !== p3("1.");
                })));
              }, function() {
                c4 = false;
              }), t4 = c4;
            }
          }
          return y2[e4] = !!t4;
        }
        if (m2(function() {
          v2 = -109252 == v2.getUTCFullYear() && 0 === v2.getUTCMonth() && 1 === v2.getUTCDate() && 10 == v2.getUTCHours() && 37 == v2.getUTCMinutes() && 6 == v2.getUTCSeconds() && 708 == v2.getUTCMilliseconds();
        }), y2["bug-string-char-index"] = y2["date-serialization"] = y2.json = y2["json-stringify"] = y2["json-parse"] = null, !y2("json")) {
          var b3 = y2("bug-string-char-index"), w2 = function(t4, r4) {
            var n4, i4, a5, o3 = 0;
            for (a5 in (n4 = function() {
              this.valueOf = 0;
            }).prototype.valueOf = 0, i4 = new n4())
              h2.call(i4, a5) && o3++;
            return n4 = i4 = null, o3 ? w2 = function(e4, t5) {
              var r5, n5, i5 = "[object Function]" == _3.call(e4);
              for (r5 in e4)
                i5 && "prototype" == r5 || !h2.call(e4, r5) || (n5 = "constructor" === r5) || t5(r5);
              (n5 || h2.call(e4, r5 = "constructor")) && t5(r5);
            } : (i4 = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"], w2 = function(t5, r5) {
              var n5, a6, o4 = "[object Function]" == _3.call(t5), s3 = !o4 && "function" != typeof t5.constructor && e3[typeof t5.hasOwnProperty] && t5.hasOwnProperty || h2;
              for (n5 in t5)
                o4 && "prototype" == n5 || !s3.call(t5, n5) || r5(n5);
              for (a6 = i4.length; n5 = i4[--a6]; )
                s3.call(t5, n5) && r5(n5);
            }), w2(t4, r4);
          };
          if (!y2("json-stringify") && !y2("date-serialization")) {
            var S2 = { 92: "\\\\", 34: '\\"', 8: "\\b", 12: "\\f", 10: "\\n", 13: "\\r", 9: "\\t" }, k2 = function(e4, t4) {
              return ("000000" + (t4 || 0)).slice(-e4);
            }, P2 = function(e4) {
              var t4, r4, n4, i4, a5, o3, s3, l3, u3;
              if (v2)
                t4 = function(e5) {
                  r4 = e5.getUTCFullYear(), n4 = e5.getUTCMonth(), i4 = e5.getUTCDate(), o3 = e5.getUTCHours(), s3 = e5.getUTCMinutes(), l3 = e5.getUTCSeconds(), u3 = e5.getUTCMilliseconds();
                };
              else {
                var c4 = p2.floor, d4 = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334], f4 = function(e5, t5) {
                  return d4[t5] + 365 * (e5 - 1970) + c4((e5 - 1969 + (t5 = +(t5 > 1))) / 4) - c4((e5 - 1901 + t5) / 100) + c4((e5 - 1601 + t5) / 400);
                };
                t4 = function(e5) {
                  for (i4 = c4(e5 / 864e5), r4 = c4(i4 / 365.2425) + 1970 - 1; f4(r4 + 1, 0) <= i4; r4++)
                    ;
                  for (n4 = c4((i4 - f4(r4, 0)) / 30.42); f4(r4, n4 + 1) <= i4; n4++)
                    ;
                  i4 = 1 + i4 - f4(r4, n4), o3 = c4((a5 = (e5 % 864e5 + 864e5) % 864e5) / 36e5) % 24, s3 = c4(a5 / 6e4) % 60, l3 = c4(a5 / 1e3) % 60, u3 = a5 % 1e3;
                };
              }
              return (P2 = function(e5) {
                return e5 > -1 / 0 && e5 < 1 / 0 ? (t4(e5), e5 = (r4 <= 0 || r4 >= 1e4 ? (r4 < 0 ? "-" : "+") + k2(6, r4 < 0 ? -r4 : r4) : k2(4, r4)) + "-" + k2(2, n4 + 1) + "-" + k2(2, i4) + "T" + k2(2, o3) + ":" + k2(2, s3) + ":" + k2(2, l3) + "." + k2(3, u3) + "Z", r4 = n4 = i4 = o3 = s3 = l3 = u3 = null) : e5 = null, e5;
              })(e4);
            };
            if (y2("json-stringify") && !y2("date-serialization")) {
              let C2 = function(e4) {
                return P2(this);
              };
              var O2 = n3.stringify;
              n3.stringify = function(e4, t4, r4) {
                var n4 = l2.prototype.toJSON;
                l2.prototype.toJSON = C2;
                var i4 = O2(e4, t4, r4);
                return l2.prototype.toJSON = n4, i4;
              };
            } else {
              var j2 = function(e4) {
                var t4 = e4.charCodeAt(0), r4 = S2[t4];
                return r4 || "\\u00" + k2(2, t4.toString(16));
              }, N2 = /[\x00-\x1f\x22\x5c]/g, T2 = function(e4) {
                return N2.lastIndex = 0, '"' + (N2.test(e4) ? e4.replace(N2, j2) : e4) + '"';
              }, I2 = function(e4, t4, r4, n4, i4, a5, o3) {
                var s3, u3, p3, d4, g3, h3, v3, y3, b4;
                if (m2(function() {
                  s3 = t4[e4];
                }), "object" == typeof s3 && s3 && (s3.getUTCFullYear && "[object Date]" == _3.call(s3) && s3.toJSON === l2.prototype.toJSON ? s3 = P2(s3) : "function" == typeof s3.toJSON && (s3 = s3.toJSON(e4))), r4 && (s3 = r4.call(t4, e4, s3)), s3 == f3)
                  return s3 === f3 ? s3 : "null";
                switch ("object" == (u3 = typeof s3) && (p3 = _3.call(s3)), p3 || u3) {
                  case "boolean":
                  case "[object Boolean]":
                    return "" + s3;
                  case "number":
                  case "[object Number]":
                    return s3 > -1 / 0 && s3 < 1 / 0 ? "" + s3 : "null";
                  case "string":
                  case "[object String]":
                    return T2("" + s3);
                }
                if ("object" == typeof s3) {
                  for (v3 = o3.length; v3--; )
                    if (o3[v3] === s3)
                      throw c3();
                  if (o3.push(s3), d4 = [], y3 = a5, a5 += i4, "[object Array]" == p3) {
                    for (h3 = 0, v3 = s3.length; h3 < v3; h3++)
                      g3 = I2(h3, s3, r4, n4, i4, a5, o3), d4.push(g3 === f3 ? "null" : g3);
                    b4 = d4.length ? i4 ? "[\n" + a5 + d4.join(",\n" + a5) + "\n" + y3 + "]" : "[" + d4.join(",") + "]" : "[]";
                  } else
                    w2(n4 || s3, function(e5) {
                      var t5 = I2(e5, s3, r4, n4, i4, a5, o3);
                      t5 !== f3 && d4.push(T2(e5) + ":" + (i4 ? " " : "") + t5);
                    }), b4 = d4.length ? i4 ? "{\n" + a5 + d4.join(",\n" + a5) + "\n" + y3 + "}" : "{" + d4.join(",") + "}" : "{}";
                  return o3.pop(), b4;
                }
              };
              n3.stringify = function(t4, r4, n4) {
                var i4, a5, o3, s3;
                if (e3[typeof r4] && r4) {
                  if ("[object Function]" == (s3 = _3.call(r4)))
                    a5 = r4;
                  else if ("[object Array]" == s3) {
                    o3 = {};
                    for (var l3, u3 = 0, c4 = r4.length; u3 < c4; )
                      l3 = r4[u3++], "[object String]" != (s3 = _3.call(l3)) && "[object Number]" != s3 || (o3[l3] = 1);
                  }
                }
                if (n4)
                  if ("[object Number]" == (s3 = _3.call(n4))) {
                    if ((n4 -= n4 % 1) > 0)
                      for (n4 > 10 && (n4 = 10), i4 = ""; i4.length < n4; )
                        i4 += " ";
                  } else
                    "[object String]" == s3 && (i4 = n4.length <= 10 ? n4 : n4.slice(0, 10));
                return I2("", ((l3 = {})[""] = t4, l3), a5, o3, i4, "", []);
              };
            }
          }
          if (!y2("json-parse")) {
            var A2, D2, $2 = a4.fromCharCode, x2 = { 92: "\\", 34: '"', 47: "/", 98: "\b", 116: "	", 110: "\n", 102: "\f", 114: "\r" }, E2 = function() {
              throw A2 = D2 = null, u2();
            }, L2 = function() {
              for (var e4, t4, r4, n4, i4, a5 = D2, o3 = a5.length; A2 < o3; )
                switch (i4 = a5.charCodeAt(A2)) {
                  case 9:
                  case 10:
                  case 13:
                  case 32:
                    A2++;
                    break;
                  case 123:
                  case 125:
                  case 91:
                  case 93:
                  case 58:
                  case 44:
                    return e4 = b3 ? a5.charAt(A2) : a5[A2], A2++, e4;
                  case 34:
                    for (e4 = "@", A2++; A2 < o3; )
                      if ((i4 = a5.charCodeAt(A2)) < 32)
                        E2();
                      else if (92 == i4)
                        switch (i4 = a5.charCodeAt(++A2)) {
                          case 92:
                          case 34:
                          case 47:
                          case 98:
                          case 116:
                          case 110:
                          case 102:
                          case 114:
                            e4 += x2[i4], A2++;
                            break;
                          case 117:
                            for (t4 = ++A2, r4 = A2 + 4; A2 < r4; A2++)
                              (i4 = a5.charCodeAt(A2)) >= 48 && i4 <= 57 || i4 >= 97 && i4 <= 102 || i4 >= 65 && i4 <= 70 || E2();
                            e4 += $2("0x" + a5.slice(t4, A2));
                            break;
                          default:
                            E2();
                        }
                      else {
                        if (34 == i4)
                          break;
                        for (i4 = a5.charCodeAt(A2), t4 = A2; i4 >= 32 && 92 != i4 && 34 != i4; )
                          i4 = a5.charCodeAt(++A2);
                        e4 += a5.slice(t4, A2);
                      }
                    if (34 == a5.charCodeAt(A2))
                      return A2++, e4;
                    E2();
                  default:
                    if (t4 = A2, 45 == i4 && (n4 = true, i4 = a5.charCodeAt(++A2)), i4 >= 48 && i4 <= 57) {
                      for (48 == i4 && (i4 = a5.charCodeAt(A2 + 1)) >= 48 && i4 <= 57 && E2(), n4 = false; A2 < o3 && (i4 = a5.charCodeAt(A2)) >= 48 && i4 <= 57; A2++)
                        ;
                      if (46 == a5.charCodeAt(A2)) {
                        for (r4 = ++A2; r4 < o3 && !((i4 = a5.charCodeAt(r4)) < 48 || i4 > 57); r4++)
                          ;
                        r4 == A2 && E2(), A2 = r4;
                      }
                      if (101 == (i4 = a5.charCodeAt(A2)) || 69 == i4) {
                        for (43 != (i4 = a5.charCodeAt(++A2)) && 45 != i4 || A2++, r4 = A2; r4 < o3 && !((i4 = a5.charCodeAt(r4)) < 48 || i4 > 57); r4++)
                          ;
                        r4 == A2 && E2(), A2 = r4;
                      }
                      return +a5.slice(t4, A2);
                    }
                    n4 && E2();
                    var s3 = a5.slice(A2, A2 + 4);
                    if ("true" == s3)
                      return A2 += 4, true;
                    if ("fals" == s3 && 101 == a5.charCodeAt(A2 + 4))
                      return A2 += 5, false;
                    if ("null" == s3)
                      return A2 += 4, null;
                    E2();
                }
              return "$";
            }, U2 = function(e4) {
              var t4, r4;
              if ("$" == e4 && E2(), "string" == typeof e4) {
                if ("@" == (b3 ? e4.charAt(0) : e4[0]))
                  return e4.slice(1);
                if ("[" == e4) {
                  for (t4 = []; "]" != (e4 = L2()); )
                    r4 ? "," == e4 ? "]" == (e4 = L2()) && E2() : E2() : r4 = true, "," == e4 && E2(), t4.push(U2(e4));
                  return t4;
                }
                if ("{" == e4) {
                  for (t4 = {}; "}" != (e4 = L2()); )
                    r4 ? "," == e4 ? "}" == (e4 = L2()) && E2() : E2() : r4 = true, "," != e4 && "string" == typeof e4 && "@" == (b3 ? e4.charAt(0) : e4[0]) && ":" == L2() || E2(), t4[e4.slice(1)] = U2(L2());
                  return t4;
                }
                E2();
              }
              return e4;
            }, R2 = function(e4, t4, r4) {
              var n4 = B2(e4, t4, r4);
              n4 === f3 ? delete e4[t4] : e4[t4] = n4;
            }, B2 = function(e4, t4, r4) {
              var n4, i4 = e4[t4];
              if ("object" == typeof i4 && i4)
                if ("[object Array]" == _3.call(i4))
                  for (n4 = i4.length; n4--; )
                    R2(_3, w2, i4);
                else
                  w2(i4, function(e5) {
                    R2(i4, e5, r4);
                  });
              return r4.call(e4, t4, i4);
            };
            n3.parse = function(e4, t4) {
              var r4, n4;
              return A2 = 0, D2 = "" + e4, r4 = U2(L2()), "$" != L2() && E2(), A2 = D2 = null, t4 && "[object Function]" == _3.call(t4) ? B2(((n4 = {})[""] = r4, n4), "", t4) : r4;
            };
          }
        }
        return n3.runInContext = o2, n3;
      }(t3, t3.JSON3 = { noConflict: function() {
        return i2 || (i2 = true, t3.JSON = r2, t3.JSON3 = n2, r2 = n2 = null), a3;
      } });
      t3.JSON ? (t3.JSON.parse = a3.parse, t3.JSON.stringify = a3.stringify) : t3.JSON = { parse: a3.parse, stringify: a3.stringify };
    }.call(window), function(e3) {
      if (e3.atob)
        try {
          e3.atob(" ");
        } catch (a3) {
          e3.atob = (t3 = e3.atob, (r2 = function(e4) {
            return t3(String(e4).replace(/[\t\n\f\r ]+/g, ""));
          }).original = t3, r2);
        }
      else {
        var t3, r2, n2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", i2 = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
        e3.btoa = function(e4) {
          e4 = String(e4);
          for (var t4, r3, i3, a3, o2 = "", s2 = 0, l2 = e4.length % 3; s2 < e4.length; ) {
            if ((r3 = e4.charCodeAt(s2++)) > 255 || (i3 = e4.charCodeAt(s2++)) > 255 || (a3 = e4.charCodeAt(s2++)) > 255)
              return "";
            o2 += n2.charAt((t4 = r3 << 16 | i3 << 8 | a3) >> 18 & 63) + n2.charAt(t4 >> 12 & 63) + n2.charAt(t4 >> 6 & 63) + n2.charAt(63 & t4);
          }
          return l2 ? o2.slice(0, l2 - 3) + "===".substring(l2) : o2;
        }, e3.atob = function(e4) {
          if (e4 = String(e4).replace(/[\t\n\f\r ]+/g, ""), !i2.test(e4))
            return "";
          e4 += "==".slice(2 - (3 & e4.length));
          for (var t4, r3, a3, o2 = "", s2 = 0; s2 < e4.length; )
            t4 = n2.indexOf(e4.charAt(s2++)) << 18 | n2.indexOf(e4.charAt(s2++)) << 12 | (r3 = n2.indexOf(e4.charAt(s2++))) << 6 | (a3 = n2.indexOf(e4.charAt(s2++))), o2 += 64 === r3 ? String.fromCharCode(t4 >> 16 & 255) : 64 === a3 ? String.fromCharCode(t4 >> 16 & 255, t4 >> 8 & 255) : String.fromCharCode(t4 >> 16 & 255, t4 >> 8 & 255, 255 & t4);
          return o2;
        };
      }
    }(window);
    var i = { setup: function(t3) {
      e2 = t3;
    }, log: function() {
      (e2 || console && console.log || function() {
      }).apply(null, arguments);
    } }, a2 = { get: function(e3) {
      return window.localStorage.getItem(e3);
    }, parse: function(e3) {
      var t3;
      try {
        t3 = JSON.parse(a2.get(e3)) || null;
      } catch (r2) {
        i.log(r2);
      }
      return t3;
    }, set: function(e3, t3) {
      try {
        window.localStorage.setItem(e3, t3);
      } catch (r2) {
        i.log(r2);
      }
    }, remove: function(e3) {
      window.localStorage.removeItem(e3);
    }, isSupport: function() {
      var e3 = true;
      try {
        var t3 = "__local_store_support__", r2 = "testIsSupportStorage";
        a2.set(t3, r2), a2.get(t3) !== r2 && (e3 = false), a2.remove(t3);
      } catch (n2) {
        e3 = false;
      }
      return e3;
    } };
    function s(e3) {
      return null != e3 && "[object Object]" == Object.prototype.toString.call(e3);
    }
    var l = function() {
      var e3 = new Date().getTime();
      return function(t3) {
        return Math.ceil((e3 = (9301 * e3 + 49297) % 233280) / 233280 * t3);
      };
    }();
    function u() {
      if ("function" == typeof Uint32Array) {
        var e3 = "";
        if ("undefined" != typeof crypto ? e3 = crypto : "undefined" != typeof msCrypto && (e3 = msCrypto), s(e3) && e3.getRandomValues) {
          var t3 = new Uint32Array(1);
          return e3.getRandomValues(t3)[0] / Math.pow(2, 32);
        }
      }
      return l(1e19) / 1e19;
    }
    function c2(e3) {
      var t3 = null;
      try {
        t3 = JSON.parse(e3);
      } catch (r2) {
      }
      return t3;
    }
    function p(e3, t3) {
      this.lockGetPrefix = e3 || "lock-get-prefix", this.lockSetPrefix = t3 || "lock-set-prefix";
    }
    function d2(e3) {
      return "function" == typeof e3 || !(!e3 || "object" != typeof e3) && d2(e3.listener);
    }
    function f2() {
      this._events = {};
    }
    function g(e3) {
      var t3 = e3;
      try {
        t3 = decodeURIComponent(e3);
      } catch (r2) {
        t3 = e3;
      }
      return t3;
    }
    function _2(e3) {
      e3 = e3 || "";
      for (var t3 = function() {
        function e4() {
        }
        return "function" != typeof Object.create ? (e4.prototype = null, new e4()) : /* @__PURE__ */ Object.create(null);
      }(), r2 = e3.substring(1).split("&"), n2 = 0; n2 < r2.length; n2++) {
        var i2 = r2[n2].indexOf("=");
        if (-1 !== i2) {
          var a3 = r2[n2].substring(0, i2), o2 = r2[n2].substring(i2 + 1);
          a3 = g(a3), o2 = g(o2), "__proto__" !== a3 && "constructor" !== a3 && "prototype" !== a3 && (t3[a3] = o2);
        }
      }
      return t3;
    }
    function h(e3) {
      return "[object String]" == Object.prototype.toString.call(e3);
    }
    function v(e3) {
      return e3.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
    }
    function y(e3) {
      var t3 = function(e4) {
        this._fields = { Username: 4, Password: 5, Port: 7, Protocol: 2, Host: 6, Path: 8, URL: 0, QueryString: 9, Fragment: 10 }, this._values = {}, this._regex = /^((\w+):\/\/)?((\w+):?(\w+)?@)?([^\/\?:]+):?(\d+)?(\/?[^\?#]+)?\??([^#]+)?#?(\w*)/, void 0 !== e4 && this._parse(e4);
      };
      return t3.prototype.setUrl = function(e4) {
        this._parse(e4);
      }, t3.prototype._initValues = function() {
        for (var e4 in this._fields)
          this._values[e4] = "";
      }, t3.prototype.addQueryString = function(e4) {
        if ("object" != typeof e4)
          return false;
        var t4 = this._values.QueryString || "";
        for (var r2 in e4)
          t4 = new RegExp(r2 + "[^&]+").test(t4) ? t4.replace(new RegExp(r2 + "[^&]+"), r2 + "=" + e4[r2]) : "&" === t4.slice(-1) ? t4 + r2 + "=" + e4[r2] : "" === t4 ? r2 + "=" + e4[r2] : t4 + "&" + r2 + "=" + e4[r2];
        this._values.QueryString = t4;
      }, t3.prototype.getUrl = function() {
        var e4 = "";
        return e4 += this._values.Origin, e4 += this._values.Port ? ":" + this._values.Port : "", e4 += this._values.Path, e4 += this._values.QueryString ? "?" + this._values.QueryString : "", e4 += this._values.Fragment ? "#" + this._values.Fragment : "";
      }, t3.prototype._parse = function(e4) {
        this._initValues();
        var t4 = this._regex.exec(e4);
        t4 || i.log("URLParser::_parse -> Invalid URL");
        var r2 = e4.split("#"), n2 = r2[0], a3 = r2.slice(1).join("#");
        for (var o2 in t4 = this._regex.exec(n2), this._fields)
          "undefined" != typeof t4[this._fields[o2]] && (this._values[o2] = t4[this._fields[o2]]);
        this._values.Hostname = this._values.Host.replace(/:\d+$/, ""), this._values.Origin = this._values.Protocol + "://" + this._values.Hostname, this._values.Fragment = a3;
      }, new t3(e3);
    }
    function b2(e3) {
      var t3, r2 = {};
      if ("function" == typeof window.URL && function() {
        try {
          return "http://modernizr.com/" === new URL("http://modernizr.com/").href;
        } catch (e4) {
          return false;
        }
      }())
        (r2 = new URL(e3)).searchParams || (r2.searchParams = (t3 = _2(r2.search), { get: function(e4) {
          return t3[e4];
        } }));
      else {
        h(e3) || (e3 = String(e3)), e3 = v(e3);
        if (false === /^https?:\/\/.+/.test(e3))
          return void i.log("Invalid URL");
        var n2 = y(e3);
        r2.hash = n2._values.Fragment, r2.host = n2._values.Host ? n2._values.Host + (n2._values.Port ? ":" + n2._values.Port : "") : "", r2.href = n2._values.URL, r2.password = n2._values.Password, r2.pathname = n2._values.Path, r2.port = n2._values.Port, r2.search = n2._values.QueryString ? "?" + n2._values.QueryString : "", r2.username = n2._values.Username, r2.hostname = n2._values.Hostname, r2.protocol = n2._values.Protocol ? n2._values.Protocol + ":" : "", r2.origin = n2._values.Origin ? n2._values.Origin + (n2._values.Port ? ":" + n2._values.Port : "") : "", r2.searchParams = function() {
          var e4 = _2("?" + n2._values.QueryString);
          return { get: function(t4) {
            return e4[t4];
          } };
        }();
      }
      return r2;
    }
    p.prototype.get = function(e3, t3, r2, i2) {
      if (!e3)
        throw new Error("key is must");
      t3 = t3 || 1e4, r2 = r2 || 1e3, i2 = i2 || function() {
      };
      var o2 = this.lockGetPrefix + e3, s2 = a2.get(o2), l2 = String(u());
      if (s2 && (s2 = c2(s2) || { randomNum: 0, expireTime: 0 }).expireTime > n())
        return i2(null);
      a2.set(o2, JSON.stringify({ randomNum: l2, expireTime: n() + t3 })), setTimeout(function() {
        (s2 = c2(a2.get(o2)) || { randomNum: 0, expireTime: 0 }) && s2.randomNum === l2 ? (i2(a2.get(e3)), a2.remove(e3), a2.remove(o2)) : i2(null);
      }, r2);
    }, p.prototype.set = function(e3, t3, r2, i2, o2) {
      if (!e3 || !t3)
        throw new Error("key and val is must");
      r2 = r2 || 1e4, i2 = i2 || 1e3, o2 = o2 || function() {
      };
      var s2 = this.lockSetPrefix + e3, l2 = a2.get(s2), p2 = String(u());
      if (l2 && (l2 = c2(l2) || { randomNum: 0, expireTime: 0 }).expireTime > n())
        return o2({ status: "fail", reason: "This key is locked" });
      a2.set(s2, JSON.stringify({ randomNum: p2, expireTime: n() + r2 })), setTimeout(function() {
        (l2 = c2(a2.get(s2)) || { randomNum: 0, expireTime: 0 }).randomNum === p2 ? a2.set(e3, t3) && o2({ status: "success" }) : o2({ status: "fail", reason: "This key is locked" });
      }, i2);
    }, f2.prototype.on = function(e3, t3) {
      if (!e3 || !t3)
        return false;
      if (!d2(t3))
        throw new Error("listener must be a function");
      this._events[e3] = this._events[e3] || [];
      var r2 = "object" == typeof t3;
      return this._events[e3].push(r2 ? t3 : { listener: t3, once: false }), this;
    }, f2.prototype.prepend = function(e3, t3) {
      if (!e3 || !t3)
        return false;
      if (!d2(t3))
        throw new Error("listener must be a function");
      this._events[e3] = this._events[e3] || [];
      var r2 = "object" == typeof t3;
      return this._events[e3].unshift(r2 ? t3 : { listener: t3, once: false }), this;
    }, f2.prototype.prependOnce = function(e3, t3) {
      return this.prepend(e3, { listener: t3, once: true });
    }, f2.prototype.once = function(e3, t3) {
      return this.on(e3, { listener: t3, once: true });
    }, f2.prototype.off = function(e3, t3) {
      var r2 = this._events[e3];
      if (!r2)
        return false;
      if ("number" == typeof t3)
        r2.splice(t3, 1);
      else if ("function" == typeof t3)
        for (var n2 = 0, i2 = r2.length; n2 < i2; n2++)
          r2[n2] && r2[n2].listener === t3 && r2.splice(n2, 1);
      return this;
    }, f2.prototype.emit = function(e3, t3) {
      var r2 = this._events[e3];
      if (!r2)
        return false;
      for (var n2 = 0; n2 < r2.length; n2++) {
        var i2 = r2[n2];
        i2 && (i2.listener.call(this, t3 || {}), i2.once && this.off(e3, n2));
      }
      return this;
    }, f2.prototype.removeAllListeners = function(e3) {
      e3 && this._events[e3] ? this._events[e3] = [] : this._events = {};
    }, f2.prototype.listeners = function(e3) {
      return e3 && "string" == typeof e3 ? this._events[e3] : this._events;
    };
    var w, S = (w = function() {
      for (var e3 = 1 * new Date(), t3 = 0; e3 == 1 * new Date(); )
        t3++;
      return e3.toString(16) + t3.toString(16);
    }, function() {
      var e3 = String(screen.height * screen.width);
      e3 = e3 && /\d{5,}/.test(e3) ? e3.toString(16) : String(31242 * u()).replace(".", "").slice(0, 8);
      var t3 = w() + "-" + u().toString(16).replace(".", "") + "-" + function() {
        var e4, t4, r2 = navigator.userAgent, n2 = [], i2 = 0;
        function a3(e5, t5) {
          var r3, i3 = 0;
          for (r3 = 0; r3 < t5.length; r3++)
            i3 |= n2[r3] << 8 * r3;
          return e5 ^ i3;
        }
        for (e4 = 0; e4 < r2.length; e4++)
          t4 = r2.charCodeAt(e4), n2.unshift(255 & t4), n2.length >= 4 && (i2 = a3(i2, n2), n2 = []);
        return n2.length > 0 && (i2 = a3(i2, n2)), i2.toString(16);
      }() + "-" + e3 + "-" + w();
      return t3 || (String(u()) + String(u()) + String(u())).slice(2, 15);
    });
    function k(e3) {
      return !(!e3 || 1 !== e3.nodeType);
    }
    function P(e3) {
      return void 0 === e3;
    }
    function C(e3) {
      return Array.isArray && r(C) ? Array.isArray(e3) : "[object Array]" === Object.prototype.toString.call(e3);
    }
    function O(e3) {
      return new j(e3);
    }
    var j = function(e3) {
      this.ele = e3;
    }, N = function(e3, t3) {
      for (var r2 = []; e3; e3 = e3.nextSibling)
        1 === e3.nodeType && e3 !== t3 && r2.push(e3);
      return r2;
    };
    function T(e3, t3, r2, n2) {
      function i2(e4) {
        return e4 && (e4.preventDefault = i2.preventDefault, e4.stopPropagation = i2.stopPropagation, e4._getPath = i2._getPath), e4;
      }
      i2._getPath = function() {
        return this.path || this.composedPath && this.composedPath() || O(this.target).getParents();
      }, i2.preventDefault = function() {
        this.returnValue = false;
      }, i2.stopPropagation = function() {
        this.cancelBubble = true;
      };
      (function(e4, t4, r3) {
        if (n2 === void 0 && "click" === t4 && (n2 = true), e4 && e4.addEventListener)
          e4.addEventListener(t4, function(e5) {
            e5._getPath = i2._getPath, r3.call(this, e5);
          }, n2);
        else {
          var a3 = "on" + t4, o2 = e4[a3];
          e4[a3] = function(e5, t5, r4, n3) {
            return function(a4) {
              if (!(a4 = a4 || i2(window.event)))
                return void 0;
              a4.target = a4.srcElement;
              var o3, s2, l2 = true;
              return "function" == typeof r4 && (o3 = r4(a4)), s2 = t5.call(e5, a4), "beforeunload" !== n3 ? (false !== o3 && false !== s2 || (l2 = false), l2) : void 0;
            };
          }(e4, r3, o2, t4);
        }
      }).apply(null, arguments);
    }
    function I(e3) {
      var t3 = "pushState" in window.history ? "popstate" : "hashchange";
      T(window, t3, e3);
    }
    function A(e3) {
      if (e3)
        return "undefined" != typeof window.XMLHttpRequest && "withCredentials" in new XMLHttpRequest() ? new XMLHttpRequest() : "undefined" != typeof XDomainRequest ? new XDomainRequest() : null;
      if ("undefined" != typeof window.XMLHttpRequest)
        return new XMLHttpRequest();
      if (window.ActiveXObject)
        try {
          return new ActiveXObject("Msxml2.XMLHTTP");
        } catch (t3) {
          try {
            return new ActiveXObject("Microsoft.XMLHTTP");
          } catch (t4) {
            i.log(t4);
          }
        }
    }
    function D(e3, t3, r2) {
      if ("object" == typeof e3 && "number" == typeof e3.length && e3.length > 0)
        if (Array.prototype.forEach && e3.forEach)
          e3.forEach(t3, r2);
        else
          for (var n2 = 0; n2 < e3.length; n2++)
            t3.call(r2, e3[n2], n2, e3);
      else if ("[object Object]" === Object.prototype.toString.call(e3))
        for (var i2 in e3)
          Object.prototype.hasOwnProperty.call(e3, i2) && t3.call(r2, e3[i2], i2, e3);
    }
    function $(e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var r2 = arguments[t3];
        if ("[object Object]" === Object.prototype.toString.call(r2))
          for (var n2 in r2)
            Object.prototype.hasOwnProperty.call(r2, n2) && void 0 !== r2[n2] && (e3[n2] = r2[n2]);
      }
      return e3;
    }
    function x(e3) {
      function t3(e4) {
        if (!e4)
          return "";
        try {
          return JSON.parse(e4);
        } catch (t4) {
          return {};
        }
      }
      e3.timeout = e3.timeout || 2e4, e3.credentials = "undefined" == typeof e3.credentials || e3.credentials;
      var r2 = A(e3.cors);
      if (!r2)
        return false;
      e3.type || (e3.type = e3.data ? "POST" : "GET");
      var n2, a3 = (e3 = $({ success: function() {
      }, error: function() {
      } }, e3)).success, o2 = e3.error;
      e3.success = function(e4) {
        a3(e4), n2 && (clearTimeout(n2), n2 = null);
      }, e3.error = function(e4) {
        o2(e4), n2 && (clearTimeout(n2), n2 = null);
      }, n2 = setTimeout(function() {
        !function() {
          try {
            r2 && "object" == typeof r2 && r2.abort && r2.abort();
          } catch (t4) {
            i.log(t4);
          }
          n2 && (clearTimeout(n2), n2 = null, e3.error && e3.error(), r2.onreadystatechange = null, r2.onload = null, r2.onerror = null);
        }();
      }, e3.timeout), "undefined" != typeof XDomainRequest && r2 instanceof XDomainRequest && (r2.onload = function() {
        e3.success && e3.success(t3(r2.responseText)), r2.onreadystatechange = null, r2.onload = null, r2.onerror = null;
      }, r2.onerror = function() {
        e3.error && e3.error(t3(r2.responseText), r2.status), r2.onreadystatechange = null, r2.onerror = null, r2.onload = null;
      }), r2.onreadystatechange = function() {
        try {
          4 == r2.readyState && (r2.status >= 200 && r2.status < 300 || 304 == r2.status ? e3.success(t3(r2.responseText)) : e3.error(t3(r2.responseText), r2.status), r2.onreadystatechange = null, r2.onload = null);
        } catch (n3) {
          r2.onreadystatechange = null, r2.onload = null;
        }
      }, r2.open(e3.type, e3.url, true);
      try {
        e3.credentials && (r2.withCredentials = true), s(e3.header) && D(e3.header, function(e4, t4) {
          r2.setRequestHeader && r2.setRequestHeader(t4, e4);
        }), e3.data && (e3.cors || r2.setRequestHeader && r2.setRequestHeader("X-Requested-With", "XMLHttpRequest"), "application/json" === e3.contentType ? r2.setRequestHeader && r2.setRequestHeader("Content-type", "application/json; charset=UTF-8") : r2.setRequestHeader && r2.setRequestHeader("Content-type", "application/x-www-form-urlencoded"));
      } catch (l2) {
        i.log(l2);
      }
      r2.send(e3.data || null);
    }
    function E(e3, t3) {
      var r2 = [];
      return null == e3 ? r2 : Array.prototype.map && e3.map === Array.prototype.map ? e3.map(t3) : (D(e3, function(e4, n2, i2) {
        r2.push(t3(e4, n2, i2));
      }), r2);
    }
    function L(e3) {
      var t3 = [];
      try {
        t3 = E(atob(e3).split(""), function(e4) {
          return "%" + ("00" + e4.charCodeAt(0).toString(16)).slice(-2);
        });
      } catch (r2) {
        t3 = [];
      }
      try {
        return decodeURIComponent(t3.join(""));
      } catch (r2) {
        return t3.join("");
      }
    }
    function U(e3) {
      var t3 = "";
      try {
        t3 = btoa(encodeURIComponent(e3).replace(/%([0-9A-F]{2})/g, function(e4, t4) {
          return String.fromCharCode("0x" + t4);
        }));
      } catch (r2) {
        t3 = e3;
      }
      return t3;
    }
    j.prototype = { addClass: function(e3) {
      return -1 === (" " + this.ele.className + " ").indexOf(" " + e3 + " ") && (this.ele.className = this.ele.className + ("" === this.ele.className ? "" : " ") + e3), this;
    }, removeClass: function(e3) {
      var t3 = " " + this.ele.className + " ";
      return -1 !== t3.indexOf(" " + e3 + " ") && (this.ele.className = t3.replace(" " + e3 + " ", " ").slice(1, -1)), this;
    }, hasClass: function(e3) {
      return -1 !== (" " + this.ele.className + " ").indexOf(" " + e3 + " ");
    }, attr: function(e3, t3) {
      return "string" == typeof e3 && P(t3) ? this.ele.getAttribute(e3) : ("string" == typeof e3 && (t3 = String(t3), this.ele.setAttribute(e3, t3)), this);
    }, offset: function() {
      var e3 = this.ele.getBoundingClientRect();
      if (e3.width || e3.height) {
        var t3 = this.ele.ownerDocument.documentElement;
        return { top: e3.top + window.pageYOffset - t3.clientTop, left: e3.left + window.pageXOffset - t3.clientLeft };
      }
      return { top: 0, left: 0 };
    }, getSize: function() {
      if (!window.getComputedStyle)
        return { width: this.ele.offsetWidth, height: this.ele.offsetHeight };
      try {
        var e3 = this.ele.getBoundingClientRect();
        return { width: e3.width, height: e3.height };
      } catch (t3) {
        return { width: 0, height: 0 };
      }
    }, getStyle: function(e3) {
      return this.ele.currentStyle ? this.ele.currentStyle[e3] : this.ele.ownerDocument.defaultView.getComputedStyle(this.ele, null).getPropertyValue(e3);
    }, wrap: function(e3) {
      var t3 = document.createElement(e3);
      return this.ele.parentNode.insertBefore(t3, this.ele), t3.appendChild(this.ele), O(t3);
    }, getCssStyle: function(e3) {
      var t3 = this.ele.style.getPropertyValue(e3);
      if (t3)
        return t3;
      var r2 = null;
      if ("function" == typeof window.getMatchedCSSRules && (r2 = window.getMatchedCSSRules(this.ele)), !r2 || !C(r2))
        return null;
      for (var n2 = r2.length - 1; n2 >= 0; n2--) {
        if (t3 = r2[n2].style.getPropertyValue(e3))
          return t3;
      }
    }, sibling: function(e3, t3) {
      for (; (e3 = e3[t3]) && 1 !== e3.nodeType; )
        ;
      return e3;
    }, next: function() {
      return this.sibling(this.ele, "nextSibling");
    }, prev: function() {
      return this.sibling(this.ele, "previousSibling");
    }, siblings: function() {
      return N((this.ele.parentNode || {}).firstChild, this.ele);
    }, children: function() {
      return N(this.ele.firstChild);
    }, parent: function() {
      var e3 = this.ele.parentNode;
      return O(e3 = e3 && 11 !== e3.nodeType ? e3 : null);
    }, previousElementSibling: function() {
      var e3 = this.ele;
      if ("previousElementSibling" in document.documentElement)
        return O(e3.previousElementSibling);
      for (; e3 = e3.previousSibling; )
        if (1 === e3.nodeType)
          return O(e3);
      return O(null);
    }, getSameTypeSiblings: function() {
      for (var e3 = this.ele, t3 = e3.parentNode, r2 = e3.tagName.toLowerCase(), n2 = [], i2 = 0; i2 < t3.children.length; i2++) {
        var a3 = t3.children[i2];
        1 === a3.nodeType && a3.tagName.toLowerCase() === r2 && n2.push(t3.children[i2]);
      }
      return n2;
    }, getParents: function() {
      try {
        var e3 = this.ele;
        if (!k(e3))
          return [];
        var t3 = [e3];
        if (null === e3 || null === e3.parentElement)
          return [];
        for (; null !== e3.parentElement; )
          e3 = e3.parentElement, t3.push(e3);
        return t3;
      } catch (r2) {
        return [];
      }
    } };
    var R = { get: function(e3) {
      for (var t3 = e3 + "=", r2 = document.cookie.split(";"), n2 = 0; n2 < r2.length; n2++) {
        for (var i2 = r2[n2]; " " == i2.charAt(0); )
          i2 = i2.substring(1, i2.length);
        if (0 == i2.indexOf(t3))
          return g(i2.substring(t3.length, i2.length));
      }
      return null;
    }, set: function(e3, t3, r2, n2, i2, a3) {
      var o2 = a3, s2 = "", l2 = "", u2 = "";
      if (0 !== (r2 = null == r2 ? 73e3 : r2)) {
        var c3 = new Date();
        "s" === String(r2).slice(-1) ? c3.setTime(c3.getTime() + 1e3 * Number(String(r2).slice(0, -1))) : c3.setTime(c3.getTime() + 24 * r2 * 60 * 60 * 1e3), s2 = "; expires=" + c3.toGMTString();
      }
      function p2(e4) {
        return !!e4 && e4.replace(/\r\n/g, "");
      }
      n2 && "" !== n2 && (u2 = "; SameSite=" + n2), i2 && (l2 = "; secure");
      var d3 = "", f3 = "", g2 = "";
      e3 && (d3 = p2(e3)), t3 && (f3 = p2(t3)), o2 && (g2 = p2(o2)), d3 && f3 && (document.cookie = d3 + "=" + encodeURIComponent(f3) + s2 + "; path=/" + g2 + u2 + l2);
    }, remove: function(e3, t3) {
      this.set(e3, "1", -1, t3);
    }, isSupport: function(e3, t3, r2, n2, i2) {
      e3 = e3 || "cookie_support_test", t3 = t3 || "1";
      var a3 = this;
      return navigator.cookieEnabled && (a3.set(e3, t3, r2, n2, i2), a3.get(e3) === t3 && (a3.remove(e3), true));
    } };
    function B(e3) {
      return D(Array.prototype.slice.call(arguments, 1), function(t3) {
        for (var r2 in t3)
          void 0 !== t3[r2] && void 0 === e3[r2] && (e3[r2] = t3[r2]);
      }), e3;
    }
    function H(e3) {
      var t3 = e3;
      try {
        t3 = decodeURI(e3);
      } catch (r2) {
        t3 = e3;
      }
      return t3;
    }
    function J(e3) {
      return "[object Date]" == Object.prototype.toString.call(e3);
    }
    function M2(e3) {
      function t3(e4) {
        return e4 < 10 ? "0" + e4 : e4;
      }
      return e3.getFullYear() + "-" + t3(e3.getMonth() + 1) + "-" + t3(e3.getDate()) + " " + t3(e3.getHours()) + ":" + t3(e3.getMinutes()) + ":" + t3(e3.getSeconds()) + "." + t3(e3.getMilliseconds());
    }
    function q(e3) {
      return D(Array.prototype.slice.call(arguments, 1), function(t3) {
        for (var r2 in t3)
          void 0 !== t3[r2] && (s(t3[r2]) && s(e3[r2]) ? $(e3[r2], t3[r2]) : e3[r2] = t3[r2]);
      }), e3;
    }
    function F(e3, t3, r2) {
      var n2 = Object.prototype.hasOwnProperty;
      if (e3.filter)
        return e3.filter(t3);
      for (var i2 = [], a3 = 0; a3 < e3.length; a3++)
        if (n2.call(e3, a3)) {
          var o2 = e3[a3];
          t3.call(r2, o2, a3, e3) && i2.push(o2);
        }
      return i2;
    }
    function K(e3, t3, r2) {
      t3 = t3 || "domain_test";
      var n2 = function(e4) {
        return "string" == typeof e4 && e4.match(/^[a-zA-Z0-9\u4e00-\u9fa5\-\.]+$/) ? e4 : "";
      }(e3 = e3 || location.hostname), i2 = n2.split(".");
      if (C(i2) && i2.length >= 2 && !/^(\d+\.)+\d+$/.test(n2)) {
        for (var a3 = "." + i2.splice(i2.length - 1, 1); i2.length > 0; )
          if (a3 = "." + i2.splice(i2.length - 1, 1) + a3, R.set(t3, "true", 0, null, r2, "; domain=" + a3), -1 !== document.cookie.indexOf(t3 + "=true"))
            return R.set(t3, "true", "-1s", null, r2, "; domain=" + a3), a3;
      }
      return "";
    }
    function V(e3) {
      if (!h(e3))
        return null;
      var t3, r2 = e3.split(">");
      return (t3 = function n2(e4) {
        var t4, a3 = r2.shift();
        if (!a3)
          return e4;
        try {
          t4 = function(e5, t5) {
            var r3;
            if ("body" === (e5 = v(e5)))
              return document.getElementsByTagName("body")[0];
            if (0 === e5.indexOf("#"))
              e5 = e5.slice(1), r3 = document.getElementById(e5);
            else if (e5.indexOf(":nth-of-type") > -1) {
              var n3 = e5.split(":nth-of-type");
              if (!n3[0] || !n3[1])
                return null;
              var i2 = n3[0], a4 = n3[1].match(/\(([0-9]+)\)/);
              if (!a4 || !a4[1])
                return null;
              var o2 = Number(a4[1]);
              if (!(k(t5) && t5.children && t5.children.length > 0))
                return null;
              for (var s2 = t5.children, l2 = 0; l2 < s2.length; l2++)
                if (k(s2[l2]) && s2[l2].tagName.toLowerCase() === i2 && 0 == --o2) {
                  r3 = s2[l2];
                  break;
                }
              if (o2 > 0)
                return null;
            }
            return r3 || null;
          }(a3, e4);
        } catch (o2) {
          i.log(o2);
        }
        return t4 && k(t4) ? n2(t4) : null;
      }()) && k(t3) ? t3 : null;
    }
    function z(e3, t3) {
      var r2 = "", n2 = "";
      return e3.textContent ? r2 = v(e3.textContent) : e3.innerText && (r2 = v(e3.innerText)), r2 && (r2 = r2.replace(/[\r\n]/g, " ").replace(/[ ]+/g, " ").substring(0, 255)), n2 = r2 || "", "input" !== t3 && "INPUT" !== t3 || (n2 = e3.value || ""), n2;
    }
    function W(e3, t3) {
      t3 && "string" == typeof t3 || (t3 = "hostname\u89E3\u6790\u5F02\u5E38");
      var r2 = null;
      try {
        r2 = b2(e3).hostname;
      } catch (n2) {
        i.log("getHostname\u4F20\u5165\u7684url\u53C2\u6570\u4E0D\u5408\u6CD5\uFF01");
      }
      return r2 || t3;
    }
    function X() {
      try {
        var e3 = navigator.appVersion.match(/OS (\d+)[._](\d+)[._]?(\d+)?/);
        return e3 && e3[1] ? Number.parseInt(e3[1], 10) : "";
      } catch (t3) {
        return "";
      }
    }
    function Z(e3, t3) {
      t3 = t3.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]"), e3 = g(e3);
      var r2 = new RegExp("[\\?&]" + t3 + "=([^&#]*)").exec(e3);
      return null === r2 || r2 && "string" != typeof r2[1] && r2[1].length ? "" : g(r2[1]);
    }
    function Y(e3) {
      var t3 = {}, r2 = e3.split("?")[1] || "";
      return r2 && (t3 = _2("?" + r2)), t3;
    }
    function G() {
      return "undefined" != typeof window.matchMedia || "undefined" != typeof window.msMatchMedia;
    }
    function Q() {
      var e3, t3 = {}, r2 = navigator.userAgent.toLowerCase();
      return (e3 = r2.match(/ qq\/([\d.]+)/)) ? t3.qqBuildinBrowser = Number(e3[1].split(".")[0]) : (e3 = r2.match(/mqqbrowser\/([\d.]+)/)) ? t3.qqBrowser = Number(e3[1].split(".")[0]) : (e3 = r2.match(/opera.([\d.]+)/)) ? t3.opera = Number(e3[1].split(".")[0]) : (e3 = r2.match(/msie ([\d.]+)/)) ? t3.ie = Number(e3[1].split(".")[0]) : (e3 = r2.match(/edge.([\d.]+)/)) ? t3.edge = Number(e3[1].split(".")[0]) : (e3 = r2.match(/firefox\/([\d.]+)/)) ? t3.firefox = Number(e3[1].split(".")[0]) : (e3 = r2.match(/chrome\/([\d.]+)/)) ? t3.chrome = Number(e3[1].split(".")[0]) : (e3 = r2.match(/version\/([\d.]+).*safari/)) ? t3.safari = Number(e3[1].match(/^\d*.\d*/)) : (e3 = r2.match(/trident\/([\d.]+)/)) && (t3.ie = 11), t3;
    }
    function ee2(e3) {
      return h(e3) ? H(e3 = v(e3)) : H(location.href);
    }
    function te2(e3) {
      return h(e3) ? H(e3 = v(e3)) : H(location.pathname);
    }
    function re2(e3, t3) {
      return e3.hasAttribute ? e3.hasAttribute(t3) : e3.attributes ? !(!e3.attributes[t3] || !e3.attributes[t3].specified) : void 0;
    }
    function ne2(e3, t3) {
      if ("string" == typeof t3)
        return re2(e3, t3);
      if (C(t3)) {
        for (var r2 = false, n2 = 0; n2 < t3.length; n2++) {
          if (re2(e3, t3[n2])) {
            r2 = true;
            break;
          }
        }
        return r2;
      }
    }
    function ie(e3) {
      if ("string" != typeof e3)
        return 0;
      var t3 = 0;
      if (0 == e3.length)
        return t3;
      for (var r2 = 0; r2 < e3.length; r2++)
        t3 = (t3 << 5) - t3 + e3.charCodeAt(r2), t3 &= t3;
      return t3;
    }
    function ae(e3) {
      var t3 = 9007199254740992, r2 = -9007199254740992, n2 = 0;
      if (e3.length > 0)
        for (var i2 = e3.split(""), a3 = 0; a3 < i2.length; a3++) {
          var o2 = i2[a3].charCodeAt(), s2 = 31 * n2 + o2;
          if (s2 > t3)
            for (n2 = r2 + n2; (s2 = 31 * n2 + o2) < r2; )
              n2 = n2 / 2 + o2;
          if (s2 < r2)
            for (n2 = t3 + n2; (s2 = 31 * n2 + o2) > t3; )
              n2 = n2 / 2 + o2;
          n2 = 31 * n2 + o2;
        }
      return n2;
    }
    function oe(e3, t3) {
      var r2 = e3.indexOf;
      if (r2)
        return r2.call(e3, t3);
      for (var n2 = 0; n2 < e3.length; n2++)
        if (t3 === e3[n2])
          return n2;
      return -1;
    }
    var se2 = Object.prototype.hasOwnProperty;
    function le(e3) {
      return !(!e3 || !se2.call(e3, "callee"));
    }
    function ue(e3) {
      return "[object Boolean]" == Object.prototype.toString.call(e3);
    }
    function ce2(e3) {
      if (s(e3)) {
        for (var t3 in e3)
          if (Object.prototype.hasOwnProperty.call(e3, t3))
            return false;
        return true;
      }
      return false;
    }
    function pe(e3) {
      if ("string" != typeof e3)
        return false;
      return false !== /^https?:\/\/.+/.test(e3) || (i.log("Invalid URL"), false);
    }
    function de2() {
      return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }
    function fe(e3) {
      try {
        JSON.parse(e3);
      } catch (t3) {
        return false;
      }
      return true;
    }
    function ge(e3) {
      return "[object Number]" == Object.prototype.toString.call(e3) && /[\d\.]+/.test(String(e3));
    }
    function _e(e3) {
      if (!s(e3) || !h(e3.callbackName))
        return i.log("JSONP \u8BF7\u6C42\u7F3A\u5C11 callbackName"), false;
      e3.success = r(e3.success) ? e3.success : function() {
      }, e3.error = r(e3.error) ? e3.error : function() {
      }, e3.data = e3.data || "";
      var t3 = document.createElement("script"), n2 = document.getElementsByTagName("head")[0], a3 = null, o2 = false;
      n2.appendChild(t3);
      ge(e3.timeout) && (a3 = setTimeout(function() {
        if (o2)
          return false;
        e3.error("timeout"), window[e3.callbackName] = function() {
          i.log("call jsonp error");
        }, a3 = null, n2.removeChild(t3), o2 = true;
      }, Math.min(e3.timeout, 3e4))), window[e3.callbackName] = function() {
        clearTimeout(a3), a3 = null, e3.success.apply(null, arguments), window[e3.callbackName] = function() {
          i.log("call jsonp error");
        }, n2.removeChild(t3);
      };
      var l2 = encodeURIComponent(e3.callbackName), u2 = "";
      if (e3.url.indexOf("?") > -1 ? e3.url += "&callbackName=" + l2 : e3.url += "?callbackName=" + l2, s(e3.data)) {
        var c3 = [];
        D(e3.data, function(e4, t4) {
          c3.push(encodeURIComponent(t4) + "=" + encodeURIComponent(e4));
        }), (u2 = c3.join("&")) && (e3.url += "&" + u2);
      }
      t3.onerror = function(r2) {
        if (o2)
          return false;
        window[e3.callbackName] = function() {
          i.log("call jsonp error");
        }, clearTimeout(a3), a3 = null, n2.removeChild(t3), e3.error(r2), o2 = true;
      }, t3.src = e3.url;
    }
    function he2(e3) {
      ({ visibleHandler: r(e3.visible) ? e3.visible : function() {
      }, hiddenHandler: r(e3.hidden) ? e3.hidden : function() {
      }, visibilityChange: null, hidden: null, isSupport: function() {
        return "undefined" != typeof document[this.hidden];
      }, init: function() {
        "undefined" != typeof document.hidden ? (this.hidden = "hidden", this.visibilityChange = "visibilitychange") : "undefined" != typeof document.mozHidden ? (this.hidden = "mozHidden", this.visibilityChange = "mozvisibilitychange") : "undefined" != typeof document.msHidden ? (this.hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (this.hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange"), this.listen();
      }, listen: function() {
        if (this.isSupport()) {
          var e4 = this;
          T(document, this.visibilityChange, function() {
            document[e4.hidden] ? e4.hiddenHandler() : e4.visibleHandler();
          }, 1);
        } else
          T(window, "focus", this.visibleHandler), T(window, "blur", this.hiddenHandler);
      } }).init();
    }
    function me(e3) {
      e3 = $({ success: function() {
      }, error: function() {
      }, appendCall: function(e4) {
        document.getElementsByTagName("head")[0].appendChild(e4);
      } }, e3);
      var t3 = null;
      "css" === e3.type && ((t3 = document.createElement("link")).rel = "stylesheet", t3.href = e3.url), "js" === e3.type && ((t3 = document.createElement("script")).async = "async", t3.setAttribute("charset", "UTF-8"), t3.src = e3.url, t3.type = "text/javascript"), t3.onload = t3.onreadystatechange = function() {
        this.readyState && "loaded" !== this.readyState && "complete" !== this.readyState || (e3.success(), t3.onload = t3.onreadystatechange = null);
      }, t3.onerror = function() {
        e3.error(), t3.onerror = null;
      }, e3.appendCall(t3);
    }
    function ve2(e3, t3) {
      t3 = "number" == typeof t3 ? t3 : 13;
      for (var r2 = (e3 = String(e3)).split(""), n2 = 0; n2 < r2.length; n2++) {
        r2[n2].charCodeAt(0) < 126 && (r2[n2] = String.fromCharCode((r2[n2].charCodeAt(0) + t3) % 126));
      }
      return r2.join("");
    }
    function ye(e3) {
      return ve2(e3 = String(e3), 113);
    }
    function be2(e3) {
      s(e3) && D(e3, function(t3, r2) {
        s(t3) ? be2(e3[r2]) : J(t3) && (e3[r2] = M2(t3));
      });
    }
    var we = { isSupport: function() {
      var e3 = true, t3 = "testIsSupportStorage";
      try {
        sessionStorage && sessionStorage.setItem ? (sessionStorage.setItem("__session_storage_support__", t3), sessionStorage.removeItem("__session_storage_support__", t3), e3 = true) : e3 = false;
      } catch (r2) {
        e3 = false;
      }
      return e3;
    } };
    function Se(e3) {
      var t3 = document.createElement("style");
      t3.type = "text/css";
      try {
        t3.appendChild(document.createTextNode(e3));
      } catch (i2) {
        t3.styleSheet.cssText = e3;
      }
      var r2 = document.getElementsByTagName("head")[0], n2 = document.getElementsByTagName("script")[0];
      r2 ? r2.children.length ? r2.insertBefore(t3, r2.children[0]) : r2.appendChild(t3) : n2.parentNode.insertBefore(t3, n2);
    }
    function ke(e3) {
      var t3 = [];
      return null == e3 ? t3 : (D(e3, function(e4) {
        t3[t3.length] = e4;
      }), t3);
    }
    function Pe(e3) {
      for (var t3, r2 = [], n2 = {}, i2 = 0; i2 < e3.length; i2++)
        (t3 = e3[i2]) in n2 || (n2[t3] = true, r2.push(t3));
      return r2;
    }
    var Ce = { "+": "-", "/": "_", "=": "." }, Oe = { "-": "+", _: "/", ".": "=" };
    function je(e3, t3, r2) {
      return r2 = r2 || 0, e3.substr(r2, t3.length) === t3;
    }
    function Ne(e3) {
      return "__proto__" !== e3 && "constructor" !== e3 && "prototype" !== e3;
    }
    var Te = { __proto__: null, noPrototypePollution: Ne, ConcurrentStorage: p, EventEmitter: f2, URL: b2, UUID: S, addEvent: T, addHashEvent: I, ajax: x, base64Decode: L, base64Encode: U, bindReady: function(e3, t3) {
      t3 = t3 || window;
      var r2 = false, n2 = true, a3 = t3.document, o2 = a3.documentElement, s2 = a3.addEventListener, l2 = s2 ? "addEventListener" : "attachEvent", u2 = s2 ? "removeEventListener" : "detachEvent", c3 = s2 ? "" : "on", p2 = function(n3) {
        "readystatechange" == n3.type && "complete" != a3.readyState || (("load" == n3.type ? t3 : a3)[u2](c3 + n3.type, p2, false), !r2 && (r2 = true) && e3.call(t3, n3.type || n3));
      }, d3 = function() {
        try {
          o2.doScroll("left");
        } catch (e4) {
          return void setTimeout(d3, 50);
        }
        p2("poll");
      };
      if ("complete" == a3.readyState)
        e3.call(t3, "lazy");
      else {
        if (!s2 && o2.doScroll) {
          try {
            n2 = !t3.frameElement;
          } catch (f3) {
            i.log(f3);
          }
          n2 && d3();
        }
        a3[l2](c3 + "DOMContentLoaded", p2, false), a3[l2](c3 + "readystatechange", p2, false), t3[l2](c3 + "load", p2, false);
      }
    }, cookie: R, coverExtend: B, decodeURI: H, decodeURIComponent: g, dfmapping: function(e3) {
      var t3 = "t6KJCZa5pDdQ9khoEM3Tj70fbP2eLSyc4BrsYugARqFIw1mzlGNVXOHiWvxUn8", r2 = t3.length - 1, n2 = {}, i2 = 0;
      for (i2 = 0; i2 < t3.length; i2++)
        n2[t3.charAt(i2)] = t3.charAt(r2 - i2);
      var a3 = "";
      for (i2 = 0; i2 < e3.length; i2++)
        e3.charAt(i2) in n2 ? a3 += n2[e3.charAt(i2)] : a3 += e3.charAt(i2);
      return a3;
    }, each: D, encodeDates: function La(e3) {
      return D(e3, function(t3, r2) {
        J(t3) ? e3[r2] = M2(t3) : s(t3) && (e3[r2] = La(t3));
      }), e3;
    }, extend: $, extend2Lev: q, filter: F, formatDate: M2, formatJsonString: function(e3) {
      try {
        return JSON.stringify(e3, null, "  ");
      } catch (t3) {
        return JSON.stringify(e3);
      }
    }, getCookieTopLevelDomain: K, getDomBySelector: V, getElementContent: z, getHostname: W, getIOSVersion: X, getQueryParam: Z, getQueryParamsFromUrl: Y, getRandom: u, getRandomBasic: l, getScreenOrientation: function() {
      var e3 = screen.msOrientation || screen.mozOrientation || (screen.orientation || {}).type, t3 = "\u672A\u53D6\u5230\u503C";
      if (e3)
        t3 = e3.indexOf("landscape") > -1 ? "landscape" : "portrait";
      else if (G()) {
        var r2 = window.matchMedia || window.msMatchMedia;
        r2("(orientation: landscape)").matches ? t3 = "landscape" : r2("(orientation: portrait)").matches && (t3 = "portrait");
      }
      return t3;
    }, getUA: Q, getURL: ee2, getURLPath: te2, getURLSearchParams: _2, hasAttribute: re2, hasAttributes: ne2, hashCode: ie, hashCode53: ae, indexOf: oe, inherit: function(e3, t3) {
      return e3.prototype = new t3(), e3.prototype.constructor = e3, e3.superclass = t3.prototype, e3;
    }, isArguments: le, isArray: C, isBoolean: ue, isDate: J, isElement: k, isEmptyObject: ce2, isFunction: r, isHttpUrl: pe, isIOS: de2, isJSONString: fe, isNumber: ge, isObject: s, isString: h, isSupportBeaconSend: function() {
      var e3 = false;
      if ("object" != typeof navigator || "function" != typeof navigator.sendBeacon)
        return e3;
      var t3 = Q(), r2 = navigator.userAgent.toLowerCase();
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        var n2 = (r2.match(/os [\d._]*/gi) + "").replace(/[^0-9|_.]/gi, "").replace(/_/gi, ".").split(".");
        "undefined" == typeof t3.safari && (t3.safari = n2[0]), n2[0] && (t3.qqBuildinBrowser || t3.qqBrowser) ? e3 = false : n2[0] && n2[0] < 13 ? (t3.chrome > 41 || t3.firefox > 30 || t3.opera > 25 || t3.safari > 12) && (e3 = true) : (t3.chrome > 41 || t3.firefox > 30 || t3.opera > 25 || t3.safari > 11.3) && (e3 = true);
      } else
        (t3.chrome > 38 || t3.edge > 13 || t3.firefox > 30 || t3.opera > 25 || t3.safari > 11) && (e3 = true);
      return e3;
    }, isSupportCors: function() {
      return "undefined" != typeof window.XMLHttpRequest && ("withCredentials" in new XMLHttpRequest() || "undefined" != typeof XDomainRequest);
    }, isUndefined: P, jsonp: _e, listenPageState: he2, loadScript: me, localStorage: a2, logger: i, map: E, mediaQueriesSupported: G, now: n, removeScriptProtocol: function(e3) {
      if ("string" != typeof e3)
        return "";
      for (var t3 = /^\s*javascript/i; t3.test(e3); )
        e3 = e3.replace(t3, "");
      return e3;
    }, rot13defs: ye, rot13obfs: ve2, ry: O, safeJSONParse: c2, searchObjDate: be2, sessionStorage: we, setCssStyle: Se, strToUnicode: function(e3) {
      if ("string" != typeof e3)
        return i.log("\u8F6C\u6362unicode\u9519\u8BEF", e3), e3;
      for (var t3 = "", r2 = 0; r2 < e3.length; r2++)
        t3 += "\\" + e3.charCodeAt(r2).toString(16);
      return t3;
    }, throttle: function(e3, t3, r2) {
      var i2, a3, o2, s2 = null, l2 = 0;
      r2 || (r2 = {});
      var u2 = function() {
        l2 = false === r2.leading ? 0 : n(), s2 = null, o2 = e3.apply(i2, a3), s2 || (i2 = a3 = null);
      };
      return function() {
        var c3 = n();
        l2 || false !== r2.leading || (l2 = c3);
        var p2 = t3 - (c3 - l2);
        return i2 = this, a3 = arguments, p2 <= 0 || p2 > t3 ? (s2 && (clearTimeout(s2), s2 = null), l2 = c3, o2 = e3.apply(i2, a3), s2 || (i2 = a3 = null)) : s2 || false === r2.trailing || (s2 = setTimeout(u2, p2)), o2;
      };
    }, toArray: function(e3) {
      return e3 ? e3.toArray ? e3.toArray() : C(e3) || le(e3) ? Array.prototype.slice.call(e3) : ke(e3) : [];
    }, trim: v, unique: Pe, urlParse: y, urlSafeBase64: { encode: function(e3) {
      return e3.replace(/[+\/=]/g, function(e4) {
        return Ce[e4];
      });
    }, decode: function(e3) {
      return e3.replace(/[-_.]/g, function(e4) {
        return Oe[e4];
      });
    }, trim: function(e3) {
      return e3.replace(/[.=]{1,2}$/, "");
    }, isBase64: function(e3) {
      return /^[A-Za-z0-9+\/]*[=]{0,2}$/.test(e3);
    }, isUrlSafeBase64: function(e3) {
      return /^[A-Za-z0-9_-]*[.]{0,2}$/.test(e3);
    } }, values: ke, xhr: A, startsWith: je }, Ie = [], Ae = { appendWriter: function(e3) {
      Ie.push(e3);
    }, msg: function() {
      var e3 = { module: "", level: "log", brand: "web-sdk", content: null };
      return e3.content = Array.prototype.slice.call(arguments), { module: function(t3) {
        return h(t3) && (e3.module = t3), this;
      }, level: function(t3) {
        return h(t3) && (e3.level = t3), this;
      }, brand: function(t3) {
        return h(t3) && (e3.brand = t3), this;
      }, log: function() {
        if (e3.content && e3.content.length) {
          for (var t3 = 0; t3 < Ie.length; t3++)
            if ("function" == typeof Ie[t3])
              try {
                Ie[t3].call(null, e3);
              } catch (r2) {
              }
        }
        return this;
      } };
    } };
    function De() {
      Ae.msg.apply(Ae, arguments).log();
    }
    function $e2() {
      Ae.msg.apply(Ae, arguments).level("warn").log();
    }
    function xe() {
      Ae.msg.apply(Ae, arguments).level("error").log();
    }
    var Ee = {}, Le = { preset_properties: { search_keyword_baidu: false, latest_utm: true, latest_traffic_source_type: true, latest_search_keyword: true, latest_referrer: true, latest_referrer_host: false, latest_landing_page: false, latest_wx_ad_click_id: void 0, url: true, title: true }, encrypt_cookie: false, enc_cookie: false, img_use_crossorigin: false, name: "sa", max_referrer_string_length: 200, max_string_length: 1024, max_id_length: 255, max_key_length: 100, cross_subdomain: true, show_log: false, is_debug: false, source_channel: [], sdk_id: "", auto_init: true, is_track_single_page: false, is_single_page: false, batch_send: false, custom_server_url: "", source_type: {}, callback_timeout: 200, datasend_timeout: 8e3, is_track_device_id: false, ignore_oom: true, app_js_bridge: false, white_list: {} };
    Le.white_list[location.host] = b2(location.href).hostname;
    var Ue = "utm_source utm_medium utm_campaign utm_content utm_term", Re = "1.27.11", Be = "sensorsdata_domain_test", He = { EMAIL: "$identity_email", MOBILE: "$identity_mobile", LOGIN: "$identity_login_id" };
    function Je(e3) {
      var t3 = Ee.current_domain;
      switch (typeof t3) {
        case "function":
          var r2 = t3();
          return "" === r2 || "" === v(r2) ? "url\u89E3\u6790\u5931\u8D25" : -1 !== r2.indexOf(".") ? r2 : "url\u89E3\u6790\u5931\u8D25";
        case "string":
          return "" === t3 || "" === v(t3) ? "url\u89E3\u6790\u5931\u8D25" : -1 !== t3.indexOf(".") ? t3 : "url\u89E3\u6790\u5931\u8D25";
        default:
          var n2 = K(null, Be, Ee.is_secure_cookie);
          return "" === e3 ? "url\u89E3\u6790\u5931\u8D25" : "" === n2 ? "url\u89E3\u6790\u5931\u8D25" : n2;
      }
    }
    var Me = { get: function(e3) {
      return R.get(e3);
    }, set: function(e3, t3, r2, n2) {
      var i2 = "";
      if (n2 = P(n2) ? Ee.cross_subdomain : n2) {
        var a3 = Je(location.href);
        "url\u89E3\u6790\u5931\u8D25" === a3 && (a3 = ""), i2 = a3 ? "; domain=" + a3 : "";
      }
      return R.set(e3, t3, r2, Ee.set_cookie_samesite, Ee.is_secure_cookie, i2);
    }, remove: function(e3, t3) {
      return t3 = P(t3) ? Ee.cross_subdomain : t3, R.remove(e3, t3);
    }, isSupport: function(e3, t3) {
      return e3 = e3 || "sajssdk_2015_cookie_access_test", t3 = t3 || "1", R.isSupport(e3, t3, 0, null, Ee.is_secure_cookie);
    } };
    function qe(e3, r2) {
      var n2 = "";
      if (false === Ee.cross_subdomain) {
        try {
          if (r2)
            n2 = b2(r2).hostname;
          else {
            var i2 = location.host;
            P(t2.para.white_list[i2]) || (n2 = t2.para.white_list[i2]);
          }
        } catch (a3) {
          xe(a3);
        }
        n2 = "string" == typeof n2 && "" !== n2 ? "sajssdk_2015_" + Ee.sdk_id + e3 + "_" + n2.replace(/\./g, "_") : "sajssdk_2015_root_" + Ee.sdk_id + e3;
      } else
        n2 = "sajssdk_2015_cross_" + Ee.sdk_id + e3;
      return n2;
    }
    function Fe() {
      return Me.isSupport() ? null !== Me.get("sensorsdata_is_new_user") || null !== Me.get(qe("new_user")) : null !== Ke.get(Ke.getNewUserFlagMemoryKey("new_user"));
    }
    Me.getNewUser = Fe;
    var Ke = { data: {}, get: function(e3) {
      var t3 = this.data[e3];
      return t3 === void 0 ? null : t3._expirationTimestamp_ !== void 0 ? new Date().getTime() > t3._expirationTimestamp_ ? null : t3.value : t3;
    }, set: function(e3, t3, r2) {
      if (r2) {
        var n2 = new Date();
        t3 = { value: t3, _expirationTimestamp_: "s" === String(r2).slice(-1) ? n2.getTime() + 1e3 * Number(String(r2).slice(0, -1)) : n2.getTime() + 24 * r2 * 60 * 60 * 1e3 };
      }
      this.data[e3] = t3;
    }, getNewUserFlagMemoryKey: function(e3) {
      return "sajssdk_2015_" + Ee.sdk_id + e3;
    } }, Ve = { checkIsAddSign: function(e3) {
      "track" === e3.type && (Fe() ? e3.properties.$is_first_day = true : e3.properties.$is_first_day = false);
    }, is_first_visit_time: false, is_page_first_visited: false, checkIsFirstTime: function(e3) {
      "track" === e3.type && "$pageview" === e3.event && (this.is_first_visit_time ? (e3.properties.$is_first_time = true, this.is_first_visit_time = false) : e3.properties.$is_first_time = false);
    }, setDeviceId: function() {
    }, storeInitCheck: function() {
      if (t2.is_first_visitor) {
        var e3 = new Date(), r2 = { h: 23 - e3.getHours(), m: 59 - e3.getMinutes(), s: 59 - e3.getSeconds() };
        Me.isSupport() ? Me.set(qe("new_user"), "1", 3600 * r2.h + 60 * r2.m + r2.s + "s") : Ke.set(Ke.getNewUserFlagMemoryKey("new_user"), "1", 3600 * r2.h + 60 * r2.m + r2.s + "s"), this.is_first_visit_time = true, this.is_page_first_visited = true;
      } else
        Fe() || (this.checkIsAddSign = function(e4) {
          "track" === e4.type && (e4.properties.$is_first_day = false);
        }), this.checkIsFirstTime = function(e4) {
          "track" === e4.type && "$pageview" === e4.event && (e4.properties.$is_first_time = false);
        };
    } };
    function ze(e3, t3, r2) {
      var n2 = !(!s(Ee.heatmap) || !Ee.heatmap.useCapture);
      return s(Ee.heatmap) && P(Ee.heatmap.useCapture) && "click" === t3 && (n2 = true), T(e3, t3, r2, n2);
    }
    var We = function() {
      this._events = [], this.pendingEvents = [];
    };
    function Xe() {
      var e3 = document.referrer;
      if (!e3)
        return false;
      try {
        var t3 = b2(e3).hostname;
        return t3 && "baidu.com" === t3.substring(t3.length - "baidu.com".length);
      } catch (r2) {
        return false;
      }
    }
    We.prototype = { emit: function(e3) {
      var t3 = [].slice.call(arguments, 1);
      D(this._events, function(r2) {
        r2.type === e3 && r2.callback.apply(r2.context, t3);
      }), this.pendingEvents.push({ type: e3, data: t3 }), this.pendingEvents.length > 20 && this.pendingEvents.shift();
    }, on: function(e3, t3, n2, i2) {
      r(t3) && (this._events.push({ type: e3, callback: t3, context: n2 || this }), i2 = false !== i2, this.pendingEvents.length > 0 && i2 && D(this.pendingEvents, function(r2) {
        r2.type === e3 && t3.apply(n2, r2.data);
      }));
    }, tempAdd: function(e3, t3) {
      if (t3 && e3)
        return this.emit(e3, t3);
    }, isReady: function() {
    } };
    var Ze = { data: {}, id: function() {
      return this.data.id ? this.data.id : (this.data.id = Ge(), this.data.id);
    }, type: function() {
      return this.data.type ? this.data.type : (this.data.type = Ye(), this.data.type);
    } };
    function Ye() {
      var e3 = Y(document.referrer);
      if (ce2(e3) || !e3.eqid) {
        var t3 = Y(location.href);
        return e3.ck || t3.utm_source ? "baidu_sem_keyword_id" : "baidu_other_keyword_id";
      }
      return "baidu_seo_keyword_id";
    }
    function Ge() {
      var e3 = Y(document.referrer);
      return ce2(e3) || !e3.eqid ? S().replace(/-/g, "") : e3.eqid;
    }
    function Qe(e3, t3) {
      return h(e3 = e3 || document.referrer) ? (0 !== (e3 = H(e3 = v(e3))).indexOf("https://www.baidu.com/") || t3 || (e3 = e3.split("?")[0]), h(e3 = e3.slice(0, Ee.max_referrer_string_length)) ? e3 : "") : "\u53D6\u503C\u5F02\u5E38_referrer\u5F02\u5E38_" + String(e3);
    }
    function et2(e3) {
      if ("" === (e3 = e3 || document.referrer))
        return true;
      var t3 = K(null, Be, Ee.is_secure_cookie), r2 = W(e3);
      return -1 === (r2 = "." + r2).indexOf(t3) && "" !== t3;
    }
    function tt(e3, t3) {
      e3 = e3 || document.referrer;
      var r2 = Ee.source_type.keyword;
      if (document && h(e3)) {
        if (0 === e3.indexOf("http")) {
          var n2 = rt(e3), i2 = Y(e3);
          if (ce2(i2))
            return Ee.preset_properties.search_keyword_baidu && Xe() ? void 0 : "\u672A\u53D6\u5230\u503C";
          var a3 = null;
          for (var o2 in r2)
            if (n2 === o2 && s(i2)) {
              if (C(a3 = r2[o2]))
                for (o2 = 0; o2 < a3.length; o2++) {
                  var l2 = i2[a3[o2]];
                  if (l2)
                    return t3 ? { active: l2 } : l2;
                }
              else if (i2[a3])
                return t3 ? { active: i2[a3] } : i2[a3];
            }
          return Ee.preset_properties.search_keyword_baidu && Xe() ? void 0 : "\u672A\u53D6\u5230\u503C";
        }
        return "" === e3 ? "\u672A\u53D6\u5230\u503C_\u76F4\u63A5\u6253\u5F00" : "\u672A\u53D6\u5230\u503C_\u975Ehttp\u7684url";
      }
      return "\u53D6\u503C\u5F02\u5E38_referrer\u5F02\u5E38_" + String(e3);
    }
    function rt(e3) {
      var t3 = W(e3);
      if (!t3 || "hostname\u89E3\u6790\u5F02\u5E38" === t3)
        return "";
      var r2 = { baidu: [/^.*\.baidu\.com$/], bing: [/^.*\.bing\.com$/], google: [/^www\.google\.com$/, /^www\.google\.com\.[a-z]{2}$/, /^www\.google\.[a-z]{2}$/], sm: [/^m\.sm\.cn$/], so: [/^.+\.so\.com$/], sogou: [/^.*\.sogou\.com$/], yahoo: [/^.*\.yahoo\.com$/] };
      for (var n2 in r2)
        for (var i2 = r2[n2], a3 = 0, o2 = i2.length; a3 < o2; a3++)
          if (i2[a3].test(t3))
            return n2;
      return "\u672A\u77E5\u641C\u7D22\u5F15\u64CE";
    }
    var nt = { distinct_id: function() {
    }, jssdkDebug: function() {
    }, _sendDebug: function(e3) {
    }, apph5: function(e3) {
      var t3 = "app_h5\u6253\u901A\u5931\u8D25-", r2 = { 1: t3 + "use_app_track\u4E3Afalse", 2: t3 + "Android\u6216\u8005iOS\uFF0C\u6CA1\u6709\u66B4\u9732\u76F8\u5E94\u65B9\u6CD5", 3.1: t3 + "Android\u6821\u9A8Cserver_url\u5931\u8D25", 3.2: t3 + "iOS\u6821\u9A8Cserver_url\u5931\u8D25", 4.1: t3 + "H5 \u6821\u9A8C iOS server_url \u5931\u8D25", 4.2: t3 + "H5 \u6821\u9A8C Android server_url \u5931\u8D25" }, n2 = e3.output, i2 = e3.step, a3 = e3.data || "";
      "all" !== n2 && "console" !== n2 || De(r2[i2]), ("all" === n2 || "code" === n2) && s(Ee.is_debug) && Ee.is_debug.apph5 && (a3.type && "profile" === a3.type.slice(0, 7) || (a3.properties._jssdk_debug_info = "apph5-" + String(i2)));
    }, defineMode: function(e3) {
      var t3 = { 1: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "App SDK \u4E0E Web JS SDK \u6CA1\u6709\u8FDB\u884C\u6253\u901A\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u6280\u672F\u4EBA\u5458\u4FEE\u6B63 App SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "", link_url: "" }, 2: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "App SDK \u4E0E Web JS SDK \u6CA1\u6709\u8FDB\u884C\u6253\u901A\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u6280\u672F\u4EBA\u5458\u4FEE\u6B63 Web JS SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "", link_url: "" }, 3: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "Web JS SDK \u6CA1\u6709\u5F00\u542F\u5168\u57CB\u70B9\u914D\u7F6E\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u5DE5\u4F5C\u4EBA\u5458\u4FEE\u6B63 SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "", link_url: "" }, 4: { title: "\u5F53\u524D\u9875\u9762\u65E0\u6CD5\u8FDB\u884C\u53EF\u89C6\u5316\u5168\u57CB\u70B9", message: "Web JS SDK \u914D\u7F6E\u7684\u6570\u636E\u6821\u9A8C\u5730\u5740\u4E0E App SDK \u914D\u7F6E\u7684\u6570\u636E\u6821\u9A8C\u5730\u5740\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u8054\u7CFB\u8D35\u65B9\u5DE5\u4F5C\u4EBA\u5458\u4FEE\u6B63 SDK \u7684\u914D\u7F6E\uFF0C\u8BE6\u7EC6\u4FE1\u606F\u8BF7\u67E5\u770B\u6587\u6863\u3002", link_text: "", link_url: "" } };
      return !(!e3 || !t3[e3]) && t3[e3];
    }, protocol: { protocolIsSame: function(e3, t3) {
      try {
        if (b2(e3).protocol !== b2(t3).protocol)
          return false;
      } catch (r2) {
        return $e2("\u4E0D\u652F\u6301 _.URL \u65B9\u6CD5"), false;
      }
      return true;
    }, serverUrl: function() {
      h(Ee.server_url) && "" !== Ee.server_url && !this.protocolIsSame(Ee.server_url, location.href) && $e2("SDK \u68C0\u6D4B\u5230\u60A8\u7684\u6570\u636E\u53D1\u9001\u5730\u5740\u548C\u5F53\u524D\u9875\u9762\u5730\u5740\u7684\u534F\u8BAE\u4E0D\u4E00\u81F4\uFF0C\u5EFA\u8BAE\u60A8\u4FEE\u6539\u6210\u4E00\u81F4\u7684\u534F\u8BAE\u3002\n\u56E0\u4E3A\uFF1A1\u3001https \u4E0B\u9762\u53D1\u9001 http \u7684\u56FE\u7247\u8BF7\u6C42\u4F1A\u5931\u8D25\u30022\u3001http \u9875\u9762\u4F7F\u7528 https + ajax \u65B9\u5F0F\u53D1\u6570\u636E\uFF0C\u5728 ie9 \u53CA\u4EE5\u4E0B\u4F1A\u4E22\u5931\u6570\u636E\u3002");
    }, ajax: function(e3) {
      if (e3 === Ee.server_url)
        return false;
      h(e3) && "" !== e3 && !this.protocolIsSame(e3, location.href) && $e2("SDK \u68C0\u6D4B\u5230\u60A8\u7684\u6570\u636E\u53D1\u9001\u5730\u5740\u548C\u5F53\u524D\u9875\u9762\u5730\u5740\u7684\u534F\u8BAE\u4E0D\u4E00\u81F4\uFF0C\u5EFA\u8BAE\u60A8\u4FEE\u6539\u6210\u4E00\u81F4\u7684\u534F\u8BAE\u3002\u56E0\u4E3A http \u9875\u9762\u4F7F\u7528 https + ajax \u65B9\u5F0F\u53D1\u6570\u636E\uFF0C\u5728 ie9 \u53CA\u4EE5\u4E0B\u4F1A\u4E22\u5931\u6570\u636E\u3002");
    } } }, it2 = { initPage: function() {
      var e3 = Qe(), t3 = ee2(), r2 = Je(t3);
      r2 || nt.jssdkDebug("url_domain\u5F02\u5E38_" + t3 + "_" + r2), this.pageProp = { referrer: e3, referrer_host: e3 ? W(e3) : "", url: t3, url_host: W(t3, "url_host\u53D6\u503C\u5F02\u5E38"), url_domain: r2 };
    }, pageProp: {}, campaignParams: function() {
      return t2.kit.getUtmData();
    }, campaignParamsStandard: function(e3, t3) {
      e3 = e3 || "", t3 = t3 || "";
      var r2 = it2.campaignParams(), n2 = {}, i2 = {};
      return D(r2, function(r3, a3, o2) {
        -1 !== (" " + Ue + " ").indexOf(" " + a3 + " ") ? n2[e3 + a3] = o2[a3] : i2[t3 + a3] = o2[a3];
      }), { $utms: n2, otherUtms: i2 };
    }, properties: function() {
      var e3 = window.innerHeight || document.documentElement.clientHeight || document.body && document.body.clientHeight || 0, t3 = window.innerWidth || document.documentElement.clientWidth || document.body && document.body.clientWidth || 0;
      return { $timezone_offset: new Date().getTimezoneOffset(), $screen_height: Number(screen.height) || 0, $screen_width: Number(screen.width) || 0, $viewport_height: e3, $viewport_width: t3, $lib: "js", $lib_version: Re };
    }, currentProps: {}, register: function(e3) {
      $(it2.currentProps, e3);
    } };
    function at() {
      function e3(e4, t4) {
        for (var r3 = 0; r3 < e4.length; r3++)
          if (-1 !== t4.split("?")[0].indexOf(e4[r3]))
            return true;
      }
      var t3 = "(" + Ee.source_type.utm.join("|") + ")\\=[^&]+", r2 = Ee.source_type.search, n2 = Ee.source_type.social, i2 = document.referrer || "", a3 = it2.pageProp.url;
      if (a3) {
        var o2 = a3.match(new RegExp(t3));
        return o2 && o2[0] ? "\u4ED8\u8D39\u5E7F\u544A\u6D41\u91CF" : e3(r2, i2) ? "\u81EA\u7136\u641C\u7D22\u6D41\u91CF" : e3(n2, i2) ? "\u793E\u4EA4\u7F51\u7AD9\u6D41\u91CF" : "" === i2 ? "\u76F4\u63A5\u6D41\u91CF" : "\u5F15\u8350\u6D41\u91CF";
      }
      return "\u83B7\u53D6url\u5F02\u5E38";
    }
    function ot(e3) {
      var t3 = Z(e3, "gdt_vid"), r2 = Z(e3, "hash_key"), n2 = Z(e3, "callbacks"), i2 = { click_id: "", hash_key: "", callbacks: "" };
      return h(t3) && t3.length && (i2.click_id = 16 == t3.length || 18 == t3.length ? t3 : "\u53C2\u6570\u89E3\u6790\u4E0D\u5408\u6CD5", h(r2) && r2.length && (i2.hash_key = r2), h(n2) && n2.length && (i2.callbacks = n2)), i2;
    }
    function st2(e3) {
      var t3 = e3.properties, n2 = JSON.parse(JSON.stringify(e3));
      s(t3) && D(t3, function(e4, i2) {
        if (r(e4))
          try {
            t3[i2] = e4(n2), r(t3[i2]) && ($e2("\u60A8\u7684\u5C5E\u6027- " + i2 + " \u683C\u5F0F\u4E0D\u6EE1\u8DB3\u8981\u6C42\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664"), delete t3[i2]);
          } catch (a3) {
            delete t3[i2], $e2("\u60A8\u7684\u5C5E\u6027- " + i2 + " \u629B\u51FA\u4E86\u5F02\u5E38\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664");
          }
      });
    }
    function lt2(e3) {
      if (s(e3) && e3.$option) {
        var t3 = e3.$option;
        return delete e3.$option, t3;
      }
      return {};
    }
    function ut2(e3) {
      var t3 = {};
      return D(e3, function(e4, r2) {
        null != e4 && (t3[r2] = e4);
      }), t3;
    }
    function ct(e3) {
      if (!k(e3.target))
        return false;
      var t3 = e3.target, r2 = h(t3.tagName) ? t3.tagName.toLowerCase() : "unknown", n2 = {};
      return n2.$element_type = r2, n2.$element_name = t3.getAttribute("name"), n2.$element_id = t3.getAttribute("id"), n2.$element_class_name = h(t3.className) ? t3.className : null, n2.$element_target_url = t3.getAttribute("href"), n2.$element_content = pt2(t3, r2), (n2 = ut2(n2)).$url = ee2(), n2.$url_path = te2(), n2.$title = document.title, n2;
    }
    function pt2(e3, t3) {
      return h(t3) && "input" === t3.toLowerCase() ? (n2 = e3, i2 = Ee.heatmap && r(Ee.heatmap.collect_input) && Ee.heatmap.collect_input(n2), ("button" === n2.type || "submit" === n2.type || i2) && n2.value || "") : z(e3, t3);
      var n2, i2;
    }
    function dt(e3) {
      return nt.protocol.ajax(e3.url), x(e3);
    }
    function ft(e3, t3) {
      if ("string" == typeof e3 && (e3 = v(e3)) && ("://" === e3.slice(0, 3) ? e3 = location.protocol.slice(0, -1) + e3 : "//" === e3.slice(0, 2) ? e3 = location.protocol + e3 : "http" !== e3.slice(0, 4) && (e3 = "")), C(e3) && e3.length)
        for (var r2 = 0; r2 < e3.length; r2++)
          /sa\.gif[^\/]*$/.test(e3[r2]) || (e3[r2] = e3[r2].replace(/\/sa$/, "/sa.gif").replace(/(\/sa)(\?[^\/]+)$/, "/sa.gif$2"));
      else
        /sa\.gif[^\/]*$/.test(e3) || "string" != typeof e3 || (e3 = e3.replace(/\/sa$/, "/sa.gif").replace(/(\/sa)(\?[^\/]+)$/, "/sa.gif$2"));
      return t3 && "string" == typeof t3 && (e3 = t3), e3;
    }
    function gt2(e3) {
      h(e3) || (e3 = JSON.stringify(e3));
      var t3 = U(e3), r2 = "crc=" + ie(t3);
      return "data=" + encodeURIComponent(t3) + "&ext=" + encodeURIComponent(r2);
    }
    var _t = {}, ht = new f2();
    function mt2(e3, t3) {
      var r2 = [];
      "string" == typeof e3 && e3 in _t.EVENT_LIST && (r2 = _t.EVENT_LIST[e3], _t[r2[0]].on(r2[1], t3));
    }
    _t.spa = ht, _t.sdk = new f2(), _t.data = new f2(), _t.initSystemEvent = function() {
      var e3, t3, n2, i2, a3;
      e3 = function(e4) {
        ht.emit("switch", e4);
      }, n2 = location.href, i2 = window.history.pushState, a3 = window.history.replaceState, r(window.history.pushState) && (window.history.pushState = function() {
        i2.apply(window.history, arguments), e3(n2), n2 = location.href;
      }), r(window.history.replaceState) && (window.history.replaceState = function() {
        a3.apply(window.history, arguments), e3(n2), n2 = location.href;
      }), t3 = window.document.documentMode ? "hashchange" : i2 ? "popstate" : "hashchange", T(window, t3, function() {
        e3(n2), n2 = location.href;
      });
    }, _t.EVENT_LIST = { spaSwitch: ["spa", "switch"], sdkBeforeInit: ["sdk", "beforeInit"], sdkInitPara: ["sdk", "initPara"], sdkAfterInitPara: ["sdk", "afterInitPara"], sdkInitAPI: ["sdk", "initAPI"], sdkAfterInitAPI: ["sdk", "afterInitAPI"], sdkAfterInit: ["sdk", "afterInit"], sdkReady: ["sdk", "ready"], dataSendSuccess: ["data", "sendSuccess"], dataSendFail: ["data", "sendFail"] };
    var vt = function(e3) {
      this.callback = e3.callback, this.server_url = e3.server_url, this.data = e3.data, this.origin_data = e3.origin_data;
    };
    vt.prototype.start = function() {
      var e3 = this, t3 = new Date();
      dt({ url: this.server_url, type: "POST", data: e3.data, credentials: false, timeout: Ee.datasend_timeout, cors: true, success: function(r2, n2) {
        _t.data.emit("sendSuccess", { status: String(n2), resText: r2, type: "ajax_single", timeout_config: Ee.datasend_timeout, request_timeout: new Date() - t3, data: e3.origin_data }), e3.end();
      }, error: function(r2, n2) {
        _t.data.emit("sendFail", { status: String(n2), resText: r2, type: "ajax_single", timeout_config: Ee.datasend_timeout, request_timeout: new Date() - t3, data: e3.origin_data }), e3.end();
      } });
    }, vt.prototype.end = function() {
      if (this.callback) {
        if (De("warning: sdk callback is deprecated."), !r(this.callback))
          return void De("error: sdk callback must be function.");
        this.callback();
      }
    };
    function yt() {
      this.sendTimeStamp = 0, this.timer = null, this.serverUrl = "", this.hasTabStorage = false;
    }
    yt.prototype = { batchInterval: function() {
      "" === this.serverUrl && this.getServerUrl(), this.hasTabStorage || (this.generateTabStorage(), this.hasTabStorage = true);
      var e3 = this;
      e3.timer = setTimeout(function() {
        e3.updateExpireTime(), e3.recycle(), e3.send(), clearTimeout(e3.timer), e3.batchInterval();
      }, Ee.batch_send.send_interval);
    }, getServerUrl: function() {
      if (!(h(Ee.server_url) && "" !== Ee.server_url || C(Ee.server_url) && Ee.server_url.length))
        return xe("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01");
      this.serverUrl = C(Ee.server_url) ? Ee.server_url[0] : Ee.server_url;
    }, send: function() {
      if (this.sendTimeStamp && n() - this.sendTimeStamp < Ee.batch_send.send_interval)
        return false;
      var e3 = a2.get(this.tabKey);
      if (e3) {
        this.sendTimeStamp = n();
        var r2 = Pe((e3 = c2(e3) || this.generateTabStorageVal()).data);
        if (r2.length) {
          for (var i2 = [], o2 = 0; o2 < r2.length; o2++) {
            var s2 = t2.store.readObjectVal(r2[o2]);
            s2 && (s2._flush_time = new Date().getTime(), i2.push(s2));
          }
          i2.length && this.request(i2, e3.data);
        }
      }
    }, updateExpireTime: function() {
      var e3 = a2.get(this.tabKey);
      e3 && ((e3 = c2(e3) || this.generateTabStorageVal()).expireTime = n() + 2 * Ee.batch_send.send_interval, e3.serverUrl = this.serverUrl, a2.set(this.tabKey, JSON.stringify(e3)));
    }, request: function(e3, t3) {
      var r2 = this, n2 = new Date();
      dt({ url: this.serverUrl, type: "POST", data: "data_list=" + encodeURIComponent(U(JSON.stringify(e3))), credentials: false, timeout: Ee.batch_send.datasend_timeout, cors: true, success: function(i2, a3) {
        _t.data.emit("sendSuccess", { status: String(a3), resText: i2, type: "ajax_batch", timeout_config: Ee.batch_send.datasend_timeout, request_timeout: new Date() - n2, data: e3 }), r2.remove(t3), r2.sendTimeStamp = 0;
      }, error: function(t4, i2) {
        _t.data.emit("sendFail", { status: String(i2), resText: t4, type: "ajax_batch", timeout_config: Ee.batch_send.datasend_timeout, request_timeout: new Date() - n2, data: e3 }), r2.sendTimeStamp = 0;
      } });
    }, remove: function(e3) {
      var t3 = a2.get(this.tabKey);
      if (t3) {
        for (var r2 = (c2(t3) || this.generateTabStorageVal()).data, n2 = 0; n2 < e3.length; n2++) {
          var i2 = oe(r2, e3[n2]);
          i2 > -1 && r2.splice(i2, 1), a2.remove(e3[n2]);
        }
        r2 = Pe(r2), a2.set(this.tabKey, JSON.stringify(this.generateTabStorageVal(r2)));
      }
    }, add: function(e3) {
      var r2 = "sawebjssdk-" + String(u()), i2 = a2.get(this.tabKey);
      null === i2 ? (this.tabKey = "tab-sawebjssdk-" + String(u()), i2 = this.generateTabStorageVal()) : i2 = c2(i2) || this.generateTabStorageVal(), i2.data.push(r2), i2.expireTime = n() + 2 * Ee.batch_send.send_interval, a2.set(this.tabKey, JSON.stringify(i2)), t2.store.saveObjectVal(r2, e3), "track_signup" !== e3.type && "$pageview" !== e3.event || this.sendImmediately();
    }, generateTabStorage: function() {
      this.tabKey = "tab-sawebjssdk-" + String(u()), a2.set(this.tabKey, JSON.stringify(this.generateTabStorageVal()));
    }, generateTabStorageVal: function(e3) {
      return { data: e3 = e3 || [], expireTime: n() + 2 * Ee.batch_send.send_interval, serverUrl: this.serverUrl };
    }, sendImmediately: function() {
      this.send();
    }, recycle: function() {
      for (var e3 = {}, t3 = 0; t3 < localStorage.length; t3++) {
        var r2 = localStorage.key(t3), i2 = this;
        if (0 === r2.indexOf("tab-sawebjssdk-")) {
          for (var o2 = c2(a2.get(r2)) || this.generateTabStorageVal(), s2 = 0; s2 < o2.data.length; s2++)
            e3[o2.data[s2]] = true;
          if (r2 !== i2.tabKey && n() > o2.expireTime && this.serverUrl === o2.serverUrl)
            new p("sajssdk-lock-get-").get(r2, 1e4, 1e3, function(e4) {
              if (e4) {
                null === a2.get(i2.tabKey) && i2.generateTabStorage();
                var t4 = c2(e4) || i2.generateTabStorageVal(), r3 = c2(a2.get(i2.tabKey)) || i2.generateTabStorageVal();
                r3.data = Pe(r3.data.concat(t4.data)), a2.set(i2.tabKey, JSON.stringify(r3));
              }
            });
        } else if (0 === r2.indexOf("sajssdk-lock-get-")) {
          var l2 = c2(a2.get(r2)) || { expireTime: 0 };
          n() - l2.expireTime > 1e4 && a2.remove(r2);
        }
      }
      for (var u2 = 0; u2 < localStorage.length; u2++) {
        var d3 = localStorage.key(u2);
        0 !== d3.indexOf("sawebjssdk-") || e3[d3] || a2.remove(d3);
      }
    } };
    var bt = function(e3) {
      this.callback = e3.callback, this.server_url = e3.server_url, this.data = e3.data;
    };
    bt.prototype.start = function() {
      var e3 = this;
      "object" == typeof navigator && "function" == typeof navigator.sendBeacon && navigator.sendBeacon(this.server_url, this.data), setTimeout(function() {
        e3.end();
      }, 40);
    }, bt.prototype.end = function() {
      if (this.callback) {
        if (De("warning: sdk callback is deprecated."), !r(this.callback))
          return void De("error: sdk callback must be function.");
        this.callback();
      }
    };
    var wt = function(e3) {
      this.callback = e3.callback, this.img = document.createElement("img"), this.img.width = 1, this.img.height = 1, Ee.img_use_crossorigin && (this.img.crossOrigin = "anonymous"), this.server_url = e3.data;
    };
    wt.prototype.start = function() {
      var e3 = this;
      Ee.ignore_oom && (this.img.onload = function() {
        this.onload = null, this.onerror = null, this.onabort = null, e3.end();
      }, this.img.onerror = function() {
        this.onload = null, this.onerror = null, this.onabort = null, e3.end();
      }, this.img.onabort = function() {
        this.onload = null, this.onerror = null, this.onabort = null, e3.end();
      }), this.img.src = this.server_url;
    }, wt.prototype.lastClear = function() {
      Q().ie !== void 0 ? this.img.src = "about:blank" : this.img.src = "";
    }, wt.prototype.end = function() {
      if (this.callback) {
        if (De("warning: sdk callback is deprecated."), !r(this.callback))
          return void De("error: sdk callback must be function.");
        this.callback();
      }
      self.lastClear && self.lastClear();
    };
    var St = { __proto__: null, addEvent: ze, EventEmitterSa: We, cookie: Me, info: it2, getReferrer: Qe, getCurrentDomain: Je, isBaiduTraffic: Xe, getReferrerEqid: Ge, getReferrerEqidType: Ye, getBaiduKeyword: Ze, isReferralTraffic: et2, getKeywordFromReferrer: tt, getReferSearchEngine: rt, getSourceFromReferrer: at, getWxAdIdFromUrl: ot, parseSuperProperties: st2, searchConfigData: lt2, strip_empty_properties: ut2, getEleInfo: ct, getElementContent: pt2, ajax: dt, optimizeServerUrl: ft, encodeTrackData: gt2, AjaxSend: vt, BatchSend: yt, BeaconSend: bt, ImageSend: wt }, kt = new We(), Pt = { requests: [], _sessionState: {}, _state: { distinct_id: "", first_id: "", props: {}, identities: {} }, getProps: function() {
      return this._state.props || {};
    }, getSessionProps: function() {
    }, getOriginDistinctId: function() {
      return this._state._distinct_id || this._state.distinct_id;
    }, getOriginUnionId: function(e3) {
      var t3 = {}, r2 = (e3 = e3 || this._state)._first_id || e3.first_id, n2 = e3._distinct_id || e3.distinct_id;
      return r2 && n2 ? (t3.login_id = n2, t3.anonymous_id = r2) : t3.anonymous_id = n2, t3;
    }, getIdentities: function() {
      var e3 = JSON.parse(JSON.stringify(this._state.identities));
      return e3.$identity_anonymous_id = this.getAnonymousId(), e3;
    }, getAnonymousId: function() {
      return Pt._state._first_id || Pt._state.first_id || Pt._state._distinct_id || Pt._state.distinct_id;
    }, getDistinctId: function() {
      var e3 = this.getUnionId();
      return e3.login_id || e3.anonymous_id;
    }, getUnionId: function(e3) {
      var t3 = this.getOriginUnionId(e3);
      return t3.login_id && this._state.history_login_id && this._state.history_login_id.name && this._state.history_login_id.name !== He.LOGIN && (t3.login_id = this._state.history_login_id.name + "+" + t3.login_id), t3;
    }, getFirstId: function() {
      return this._state._first_id || this._state.first_id;
    }, initSessionState: function() {
    }, setOnce: function(e3, t3) {
      e3 in this._state || this.set(e3, t3);
    }, set: function(e3, t3) {
      this._state = this._state || {};
      var r2 = this._state.distinct_id;
      this._state[e3] = t3, "first_id" === e3 ? delete this._state._first_id : "distinct_id" === e3 && delete this._state._distinct_id, this.save(), "distinct_id" === e3 && r2 && kt.tempAdd("changeDistinctId", t3);
    }, change: function(e3, t3) {
      this._state["_" + e3] = t3;
    }, setSessionProps: function() {
      t2.log("initSessionState \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u8BE5\u529F\u80FD\uFF0C\u5982\u6709\u9700\u6C42\u8054\u7CFB\u6280\u672F\u987E\u95EE");
    }, setSessionPropsOnce: function() {
      t2.log("initSessionState \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u8BE5\u529F\u80FD\uFF0C\u5982\u6709\u9700\u6C42\u8054\u7CFB\u6280\u672F\u987E\u95EE");
    }, setProps: function(e3, r2) {
      var n2 = {};
      for (var i2 in n2 = r2 ? e3 : $(this._state.props || {}, e3))
        "string" == typeof n2[i2] && (n2[i2] = n2[i2].slice(0, t2.para.max_referrer_string_length));
      this.set("props", n2);
    }, setPropsOnce: function(e3) {
      var t3 = this._state.props || {};
      B(t3, e3), this.set("props", t3);
    }, clearAllProps: function(e3) {
      var t3;
      if (C(e3) && e3.length > 0)
        for (t3 = 0; t3 < e3.length; t3++)
          h(e3[t3]) && -1 === e3[t3].indexOf("latest_") && s(this._state.props) && e3[t3] in this._state.props && delete this._state.props[e3[t3]];
      else if (s(this._state.props))
        for (t3 in this._state.props)
          1 !== t3.indexOf("latest_") && delete this._state.props[t3];
      this.sessionSave({}), this.save();
    }, sessionSave: function() {
      t2.log("initSessionState \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u8BF7\u4E0D\u8981\u4F7F\u7528\u8BE5\u529F\u80FD\uFF0C\u5982\u6709\u9700\u6C42\u8054\u7CFB\u6280\u672F\u987E\u95EE");
    }, save: function() {
      var e3 = JSON.parse(JSON.stringify(this._state));
      delete e3._first_id, delete e3._distinct_id, e3.identities && (e3.identities = U(JSON.stringify(e3.identities)));
      var r2 = JSON.stringify(e3);
      t2.para.encrypt_cookie && (r2 = t2.kit.userEncrypt(r2)), Me.set(this.getCookieName(), r2, 360, t2.para.cross_subdomain);
    }, getCookieName: function() {
      var e3 = "";
      if (false === t2.para.cross_subdomain) {
        try {
          var r2 = location.host;
          P(t2.para.white_list[r2]) || (e3 = t2.para.white_list[r2]);
        } catch (n2) {
          $e2(n2);
        }
        e3 = "string" == typeof e3 && "" !== e3 ? "sa_jssdk_2015_" + t2.para.sdk_id + e3.replace(/\./g, "_") : "sa_jssdk_2015_root" + t2.para.sdk_id;
      } else
        e3 = "sensorsdata2015jssdkcross" + t2.para.sdk_id;
      return e3;
    }, init: function() {
      this.initSessionState();
      var e3, r2, n2 = S();
      Me.isSupport() && (e3 = Me.get(this.getCookieName()), r2 = c2(e3 = t2.kit.userDecryptIfNeeded(e3))), Me.isSupport() && null !== e3 && fe(e3) && s(r2) && (!s(r2) || r2.distinct_id) ? (Pt._state = $(function(e4) {
        var t3;
        e4.identities && (0 === e4.identities.indexOf("\n/") ? e4.identities = c2(ye(e4.identities)) : e4.identities = c2(L(e4.identities)));
        var r3 = Pt.getOriginUnionId(e4);
        e4.identities && s(e4.identities) && !ce2(e4.identities) || (e4.identities = {}, e4.identities.$identity_cookie_id = S()), e4.history_login_id = e4.history_login_id || {};
        var n3 = e4.history_login_id.name;
        if (r3.login_id)
          if (n3 && e4.identities.hasOwnProperty(n3)) {
            if (e4.identities[n3] !== r3.login_id) {
              for (t3 in e4.identities[n3] = r3.login_id, e4.identities)
                e4.identities.hasOwnProperty(t3) && "$identity_cookie_id" !== t3 && t3 !== n3 && delete e4.identities[t3];
              e4.history_login_id.value = r3.login_id;
            }
          } else {
            var i2 = n3 || He.LOGIN;
            for (t3 in e4.identities[i2] = r3.login_id, e4.identities)
              e4.identities.hasOwnProperty(t3) && "$identity_cookie_id" !== t3 && t3 !== i2 && delete e4.identities[t3];
            e4.history_login_id = { name: i2, value: r3.login_id };
          }
        else {
          if (e4.identities.hasOwnProperty("$identity_login_id") || e4.identities.hasOwnProperty(n3))
            for (t3 in e4.identities)
              e4.identities.hasOwnProperty(t3) && "$identity_cookie_id" !== t3 && "$identity_anonymous_id" !== t3 && delete e4.identities[t3];
          e4.history_login_id = { name: "", value: "" };
        }
        return e4;
      }(r2)), Pt.save()) : (t2.is_first_visitor = true, function(e4) {
        Pt.set("distinct_id", e4), Pt.set("identities", { $identity_cookie_id: e4 }), Pt.set("history_login_id", { name: "", value: "" });
      }(n2)), Ve.setDeviceId(n2, this), Ve.storeInitCheck();
    }, saveObjectVal: function(e3, r2) {
      h(r2) || (r2 = JSON.stringify(r2)), 1 == t2.para.encrypt_cookie && (r2 = t2.kit.userEncrypt(r2)), a2.set(e3, r2);
    }, readObjectVal: function(e3) {
      var r2 = a2.get(e3);
      return r2 ? c2(r2 = t2.kit.userDecryptIfNeeded(r2)) : null;
    } }, Ct = { string: function(e3) {
      $e2(e3 + " must be string");
    }, emptyString: function(e3) {
      $e2(e3 + "'s is empty");
    }, regexTest: function(e3) {
      $e2(e3 + " is invalid");
    }, idLength: function(e3) {
      $e2(e3 + " length is longer than " + Ee.max_id_length);
    }, keyLength: function(e3) {
      $e2(e3 + " length is longer than " + Ee.max_key_length);
    }, stringLength: function(e3) {
      $e2(e3 + " length is longer than " + Ee.max_string_length);
    }, voidZero: function(e3) {
      $e2(e3 + "'s is undefined");
    }, reservedLoginId: function(e3) {
      $e2(e3 + " is invalid");
    }, reservedBind: function(e3) {
      $e2(e3 + " is invalid");
    }, reservedUnbind: function(e3) {
      $e2(e3 + " is invalid");
    } }, Ot = { regName: /^((?!^distinct_id$|^original_id$|^time$|^properties$|^id$|^first_id$|^second_id$|^users$|^events$|^event$|^user_id$|^date$|^datetime$|^user_tag.*|^user_group.*)[a-zA-Z_$][a-zA-Z\d_$]*)$/i, loginIDReservedNames: ["$identity_anonymous_id", "$identity_cookie_id"], bindReservedNames: ["$identity_login_id", "$identity_anonymous_id", "$identity_cookie_id"], unbindReservedNames: ["$identity_anonymous_id", He.LOGIN], string: function(e3) {
      return !!h(e3);
    }, emptyString: function(e3) {
      return !(!h(e3) || 0 === v(e3).length);
    }, regexTest: function(e3) {
      return !(!h(e3) || !this.regName.test(e3));
    }, idLength: function(e3) {
      return !(!h(e3) || e3.length > Ee.max_id_length);
    }, keyLength: function(e3) {
      return !(!h(e3) || e3.length > Ee.max_key_length);
    }, stringLength: function(e3) {
      return !(!h(e3) || e3.length > Ee.max_string_length);
    }, voidZero: function(e3) {
      return void 0 !== e3;
    }, reservedLoginId: function(e3) {
      return !(oe(this.loginIDReservedNames, e3) > -1);
    }, reservedUnbind: function(e3) {
      return !(oe(this.unbindReservedNames, e3) > -1);
    }, reservedBind: function(e3) {
      var t3 = Pt._state.history_login_id;
      return (!t3 || !t3.name || t3.name !== e3) && !(oe(this.bindReservedNames, e3) > -1);
    } }, jt = { distinct_id: { rules: ["string", "emptyString", "idLength"], onComplete: function(e3, t3, n2) {
      return !e3 && ("emptyString" === n2 && (t3 = "Id"), r(Ct[n2]) && Ct[n2](t3), "idLength" === n2) || e3;
    } }, event: { rules: ["string", "emptyString", "keyLength", "regexTest"], onComplete: function(e3, t3, n2) {
      return e3 || ("emptyString" === n2 && (t3 = "eventName"), r(Ct[n2]) && Ct[n2](t3)), true;
    } }, propertyKey: { rules: ["string", "emptyString", "keyLength", "regexTest"], onComplete: function(e3, t3, n2) {
      return e3 || ("emptyString" === n2 && (t3 = "Property key"), r(Ct[n2]) && Ct[n2](t3)), true;
    } }, propertyValue: { rules: ["voidZero"], onComplete: function(e3, t3, n2) {
      return e3 || r(Ct[n2]) && Ct[n2]("Property Value"), true;
    } }, properties: function(e3) {
      return s(e3) ? D(e3, function(e4, t3) {
        Nt({ propertyKey: t3 });
        Nt({ propertyValue: e4 }, function(e5, n2, i2) {
          return e5 || (n2 = t3 + "'s Value", r(Ct[i2]) && Ct[i2](n2)), true;
        });
      }) : Ot.voidZero(e3) && $e2("properties\u53EF\u4EE5\u6CA1\u6709\uFF0C\u4F46\u6709\u7684\u8BDD\u5FC5\u987B\u662F\u5BF9\u8C61"), true;
    }, propertiesMust: function(e3) {
      return e3 !== void 0 && s(e3) && !ce2(e3) ? this.properties.call(this, e3) : $e2("properties\u5FC5\u987B\u662F\u5BF9\u8C61"), true;
    }, item_type: { rules: ["string", "emptyString", "keyLength", "regexTest"], onComplete: function(e3, t3, n2) {
      return e3 || ("emptyString" === n2 && (t3 = "item_type"), r(Ct[n2]) && Ct[n2](t3)), true;
    } }, item_id: { rules: ["string", "emptyString", "stringLength"], onComplete: function(e3, t3, n2) {
      return e3 || ("emptyString" === n2 && (t3 = "item_id"), r(Ct[n2]) && Ct[n2](t3)), true;
    } }, loginIdKey: { rules: ["string", "emptyString", "keyLength", "regexTest", "reservedLoginId"], onComplete: function(e3, t3, n2) {
      return !e3 && ("emptyString" === n2 && (t3 = "login_id_key"), r(Ct[n2]) && Ct[n2](t3), "keyLength" === n2) || e3;
    } }, bindKey: { rules: ["string", "emptyString", "keyLength", "regexTest", "reservedBind"], onComplete: function(e3, t3, n2) {
      return !e3 && ("emptyString" === n2 && (t3 = "Key"), r(Ct[n2]) && Ct[n2](t3), "keyLength" === n2) || e3;
    } }, unbindKey: { rules: ["string", "emptyString", "keyLength", "regexTest", "reservedUnbind"], onComplete: function(e3, t3, n2) {
      return !e3 && ("emptyString" === n2 && (t3 = "Key"), r(Ct[n2]) && Ct[n2](t3), "keyLength" === n2) || e3;
    } }, bindValue: { rules: ["string", "emptyString", "idLength"], onComplete: function(e3, t3, n2) {
      return !e3 && ("emptyString" === n2 && (t3 = "Value"), r(Ct[n2]) && Ct[n2](t3), "idLength" === n2) || e3;
    } }, check: function(e3, t3, n2) {
      var i2 = this[e3];
      if (r(i2))
        return i2.call(this, t3);
      if (!i2)
        return false;
      for (var a3 = 0; a3 < i2.rules.length; a3++) {
        var o2 = i2.rules[a3], s2 = Ot[o2](t3), l2 = r(n2) ? n2(s2, t3, o2) : i2.onComplete(s2, t3, o2);
        if (!s2)
          return l2;
      }
      return true;
    } };
    function Nt(e3, t3) {
      for (var r2 in e3)
        if (Object.prototype.hasOwnProperty.call(e3, r2) && !jt.check(r2, e3[r2], t3))
          return false;
      return true;
    }
    function Tt(e3) {
      var t3 = ["$element_selector", "$element_path"], r2 = ["sensorsdata_app_visual_properties"];
      s(e3) && D(e3, function(n2, i2) {
        if (s(n2))
          Tt(e3[i2]);
        else if (h(n2)) {
          if (oe(r2, i2) > -1)
            return;
          e3[i2] = (a3 = n2, ge(o2 = oe(t3, i2) > -1 ? 1024 : Ee.max_string_length) && a3.length > o2 ? ($e2("\u5B57\u7B26\u4E32\u957F\u5EA6\u8D85\u8FC7\u9650\u5236\uFF0C\u5DF2\u7ECF\u505A\u622A\u53D6--" + a3), a3.slice(0, o2)) : a3);
        }
        var a3, o2;
      });
    }
    var It = { initUrl: function() {
      var e3, r2, n2 = { server_url: { project: "", host: "" }, page_url: { host: "", pathname: "" } };
      if (!pe(t2.para.server_url))
        return xe("----vcollect---server_url\u5FC5\u987B\u4E3A\u6709\u6548 URL \u5B57\u7B26\u4E32"), false;
      try {
        e3 = b2(t2.para.server_url), n2.server_url.project = e3.searchParams.get("project") || "default", n2.server_url.host = e3.host;
      } catch (i2) {
        return xe("----vcollect---server_url\u89E3\u6790\u5F02\u5E38", i2), false;
      }
      try {
        r2 = b2(location.href), n2.page_url.host = r2.hostname, n2.page_url.pathname = r2.pathname;
      } catch (i2) {
        return xe("----vcollect---\u9875\u9762\u5730\u5740\u89E3\u6790\u5F02\u5E38", i2), false;
      }
      return n2;
    }, isDiv: function(e3) {
      if (e3.element_path && "div" !== v(e3.element_path.split(">").pop()).slice(0, 3))
        return false;
      return true;
    }, configIsMatchNew: function(e3, t3) {
      if (h(e3.$element_selector) && h(t3.element_selector)) {
        if ("element_selector" === t3.element_field && "equal" === t3["function"])
          return e3.$element_selector === t3.element_selector;
        if ("element_selector" === t3.element_field && "contain" === t3["function"])
          return e3.$element_selector.indexOf(t3.element_selector) > -1;
      }
      if (h(e3.$element_path) && h(t3.element_path)) {
        if ("element_path" === t3.element_field && "equal" === t3["function"])
          return e3.$element_path === t3.element_path;
        if ("element_path" === t3.element_field && "contain" === t3["function"])
          return e3.$element_path.indexOf(t3.element_path) > -1;
      }
      return false;
    }, configIsMatch: function(e3, t3) {
      return (!t3.limit_element_content || t3.element_content === e3.$element_content) && ((!t3.limit_element_position || t3.element_position === String(e3.$element_position)) && (t3.element_field && t3["function"] ? It.configIsMatchNew(e3, t3) : It.configIsMatchOldVersion(e3, t3)));
    }, configIsMatchOldVersion: function(e3, t3) {
      if (!t3.element_path)
        return false;
      if (e3.$element_position !== void 0) {
        if (t3.element_path !== e3.$element_path)
          return false;
      } else if (It.isDiv({ element_path: t3.element_path })) {
        if (e3.$element_path.indexOf(t3.element_path) < 0)
          return false;
      } else if (t3.element_path !== e3.$element_path)
        return false;
      return true;
    }, filterConfig: function(e3, t3, r2) {
      var n2 = [];
      if (!r2) {
        var i2 = It.initUrl();
        if (!i2)
          return [];
        r2 = i2.page_url;
      }
      return "$WebClick" === e3.event && D(t3, function(t4) {
        s(t4) && ("webclick" === t4.event_type || "appclick" === t4.event_type) && s(t4.event) && t4.event.url_host === r2.host && t4.event.url_path === r2.pathname && It.configIsMatch(e3.properties, t4.event) && n2.push(t4);
      }), n2;
    }, getPropElInLi: function(e3, r2) {
      if (!(e3 && k(e3) && h(r2)))
        return null;
      if ("li" !== e3.tagName.toLowerCase())
        return null;
      var n2 = t2.heatmap.getDomSelector(e3);
      if (n2) {
        var i2 = V(n2 + r2);
        return i2 || null;
      }
      return $e2("----custom---\u83B7\u53D6\u540C\u7EA7\u5C5E\u6027\u5143\u7D20\u5931\u8D25\uFF0Cselector\u4FE1\u606F\u5F02\u5E38", n2, r2), null;
    }, getProp: function(e3, r2) {
      if (!s(e3))
        return false;
      if (!(h(e3.name) && e3.name.length > 0))
        return $e2("----vcustom----\u5C5E\u6027\u540D\u4E0D\u5408\u6CD5,\u5C5E\u6027\u629B\u5F03", e3.name), false;
      var n2, i2, a3 = {};
      if ("content" === e3.method) {
        var o2;
        if (h(e3.element_selector) && e3.element_selector.length > 0)
          o2 = V(e3.element_selector);
        else {
          if (!r2 || !h(e3.list_selector))
            return $e2("----vcustom----\u5C5E\u6027\u914D\u7F6E\u5F02\u5E38\uFF0C\u5C5E\u6027\u629B\u5F03", e3.name), false;
          var l2 = V(r2.properties.$element_selector);
          if (!l2)
            return $e2("----vcustom----\u70B9\u51FB\u5143\u7D20\u83B7\u53D6\u5F02\u5E38\uFF0C\u5C5E\u6027\u629B\u5F03", e3.name), false;
          var u2 = t2.heatmap.getClosestLi(l2);
          o2 = It.getPropElInLi(u2, e3.list_selector);
        }
        if (!o2 || !k(o2))
          return $e2("----vcustom----\u5C5E\u6027\u5143\u7D20\u83B7\u53D6\u5931\u8D25\uFF0C\u5C5E\u6027\u629B\u5F03", e3.name), false;
        if ("input" === o2.tagName.toLowerCase())
          n2 = o2.value || "";
        else if ("select" === o2.tagName.toLowerCase()) {
          var c3 = o2.selectedIndex;
          ge(c3) && k(o2[c3]) && (n2 = pt2(o2[c3], "select"));
        } else
          n2 = pt2(o2, o2.tagName.toLowerCase());
        if (e3.regular) {
          try {
            i2 = new RegExp(e3.regular).exec(n2);
          } catch (p2) {
            return $e2("----vcustom----\u6B63\u5219\u5904\u7406\u5931\u8D25\uFF0C\u5C5E\u6027\u629B\u5F03", e3.name), false;
          }
          if (null === i2)
            return $e2("----vcustom----\u5C5E\u6027\u89C4\u5219\u5904\u7406\uFF0C\u672A\u5339\u914D\u5230\u7ED3\u679C,\u5C5E\u6027\u629B\u5F03", e3.name), false;
          if (!C(i2) || !h(i2[0]))
            return $e2("----vcustom----\u6B63\u5219\u5904\u7406\u5F02\u5E38\uFF0C\u5C5E\u6027\u629B\u5F03", e3.name, i2), false;
          n2 = i2[0];
        }
        if ("STRING" === e3.type)
          a3[e3.name] = n2;
        else if ("NUMBER" === e3.type) {
          if (n2.length < 1)
            return $e2("----vcustom----\u672A\u83B7\u53D6\u5230\u6570\u5B57\u5185\u5BB9\uFF0C\u5C5E\u6027\u629B\u5F03", e3.name, n2), false;
          if (isNaN(Number(n2)))
            return $e2("----vcustom----\u6570\u5B57\u7C7B\u578B\u5C5E\u6027\u8F6C\u6362\u5931\u8D25\uFF0C\u5C5E\u6027\u629B\u5F03", e3.name, n2), false;
          a3[e3.name] = Number(n2);
        }
        return a3;
      }
      return xe("----vcustom----\u5C5E\u6027\u4E0D\u652F\u6301\u6B64\u83B7\u53D6\u65B9\u5F0F", e3.name, e3.method), false;
    }, getAssignConfigs: function(e3, t3) {
      var r2 = It.initUrl();
      if (!r2 || !r2.page_url)
        return [];
      if (!s(t3))
        return [];
      var n2 = [];
      return t3.events = t3.events || t3.eventList, C(t3.events) && t3.events.length > 0 ? (D(t3.events, function(t4) {
        s(t4) && s(t4.event) && t4.event.url_host === r2.page_url.host && t4.event.url_path === r2.page_url.pathname && e3(t4) && n2.push(t4);
      }), n2) : [];
    } }, At = { events: [], customProp: { events: [], getAssignConfigs: It.getAssignConfigs, filterConfig: It.filterConfig, getProp: It.getProp, initUrl: It.initUrl, updateEvents: function(e3) {
      C(e3) && (this.events = e3);
    }, init: function() {
      this.initAppGetPropsBridge();
    }, geth5Props: function(e3) {
      var r2 = {}, n2 = [], i2 = this;
      if (!this.events.length)
        return {};
      if ("$WebClick" === e3.event) {
        var a3 = this.filterConfig(e3, this.events);
        if (!a3.length)
          return {};
        D(a3, function(t3) {
          s(t3) && (C(t3.properties) && t3.properties.length > 0 && D(t3.properties, function(t4) {
            if (s(t4))
              if (false === t4.h5)
                C(r2.sensorsdata_app_visual_properties) || (r2.sensorsdata_app_visual_properties = []), r2.sensorsdata_app_visual_properties.push(t4);
              else {
                var n3 = i2.getProp(t4, e3);
                s(n3) && (r2 = $(r2, n3));
              }
          }), h(t3.event_name) && n2.push(t3.event_name));
        }), t2.bridge.hasVisualModeBridge() && (r2.sensorsdata_web_visual_eventName = n2);
      }
      return r2.sensorsdata_app_visual_properties && (r2.sensorsdata_app_visual_properties = U(JSON.stringify(r2.sensorsdata_app_visual_properties))), r2;
    }, initAppGetPropsBridge: function() {
      var e3 = this, r2 = new t2.SDKJSBridge("getJSVisualProperties");
      return r2.onAppNotify(function(n2) {
        var i2 = {};
        try {
          n2 = JSON.parse(L(n2));
        } catch (l2) {
          xe("getJSVisualProperties data parse error!");
        }
        if (s(n2)) {
          var a3 = n2.sensorsdata_js_visual_properties, o2 = e3.initUrl();
          o2 && (o2 = o2.page_url, C(a3) && a3.length > 0 && D(a3, function(t3) {
            if (s(t3) && t3.url_host === o2.host && t3.url_path === o2.pathname && t3.h5) {
              var r3 = e3.getProp(t3);
              s(r3) && (i2 = $(i2, r3));
            }
          }));
        }
        return "android" === t2.bridge.bridge_info.platform && r2.notifyApp({ data: i2 }, n2.message_id), i2;
      }), r2;
    } }, getAssignConfigs: It.getAssignConfigs, initUrl: It.initUrl, init: function() {
      if (this.initUrl()) {
        var e3 = this.getConfigFromApp();
        e3 && this.updateConfigs(e3), this.customProp.init(), this.initAppUpdateConfigBridge();
      }
    }, initAppUpdateConfigBridge: function() {
      var e3 = this;
      return new t2.SDKJSBridge("updateH5VisualConfig").onAppNotify(function(t3) {
        if (t3) {
          try {
            t3 = JSON.parse(L(t3));
          } catch (r2) {
            return void xe("updateH5VisualConfig result parse error\uFF01");
          }
          e3.updateConfigs(t3);
        }
      });
    }, getConfigFromApp: function() {
      var e3 = new t2.SDKJSBridge("sensorsdata_get_app_visual_config").notifyApp();
      if (e3)
        try {
          e3 = JSON.parse(L(e3));
        } catch (r2) {
          e3 = null, xe("getAppVisualConfig result parse error\uFF01");
        }
      return e3;
    }, updateConfigs: function(e3) {
      this.events = this.filterConfigs(e3), this.customProp.updateEvents(this.events);
    }, filterConfigs: function(e3) {
      return this.getAssignConfigs(function(e4) {
        return !(!s(e4) || false === e4.h5);
      }, e3);
    } }, Dt = { events: [], init: function(e3) {
      this.filterWebClickEvents(e3);
    }, filterWebClickEvents: function(e3) {
      this.events = xt.getAssignConfigs(function(e4) {
        return !(!s(e4) || true !== e4.event.unlimited_div || "webclick" !== e4.event_type);
      }, e3);
    }, isTargetEle: function(e3) {
      var r2 = t2.heatmap.getEleDetail(e3);
      if (!s(r2) || !h(r2.$element_path))
        return false;
      for (var n2 = 0; n2 < this.events.length; n2++)
        if (s(this.events[n2]) && s(this.events[n2].event) && xt.configIsMatch(r2, this.events[n2].event))
          return true;
      return false;
    } }, $t = { events: [], configSwitch: false, collectAble: function() {
      return this.configSwitch && s(t2.para.heatmap) && t2.para.heatmap.get_vtrack_config;
    }, updateEvents: function(e3) {
      this.events = xt.getAssignConfigs(function(e4) {
        return !!(s(e4) && C(e4.properties) && e4.properties.length > 0);
      }, e3), this.events.length ? this.configSwitch = true : this.configSwitch = false;
    }, getVtrackProps: function(e3) {
      var t3 = {};
      return this.collectAble() ? ("$WebClick" === e3.event && (t3 = this.clickCustomPropMaker(e3, this.events)), t3) : {};
    }, clickCustomPropMaker: function(e3, t3, r2) {
      var n2 = this;
      r2 = r2 || this.filterConfig(e3, t3, xt.url_info.page_url);
      var i2 = {};
      return r2.length ? (D(r2, function(t4) {
        C(t4.properties) && t4.properties.length > 0 && D(t4.properties, function(t5) {
          var r3 = n2.getProp(t5, e3);
          s(r3) && $(i2, r3);
        });
      }), i2) : {};
    }, getProp: It.getProp, getPropElInLi: It.getPropElInLi, filterConfig: It.filterConfig }, xt = { unlimitedDiv: Dt, config: {}, storageEnable: true, storage_name: "webjssdkvtrackcollect", para: { session_time: 18e5, timeout: 5e3, update_interval: 18e5 }, url_info: {}, timer: null, update_time: null, customProp: $t, initUrl: function() {
      var e3 = It.initUrl();
      if (e3) {
        var r2;
        try {
          (r2 = new y(t2.para.server_url))._values.Path = "/config/visualized/Web.conf", e3.api_url = r2.getUrl();
        } catch (n2) {
          return xe("----vtrackcollect---API\u5730\u5740\u89E3\u6790\u5F02\u5E38", n2), false;
        }
        this.url_info = e3;
      }
      return e3;
    }, init: function() {
      if (!s(t2.para.heatmap) || !t2.para.heatmap.get_vtrack_config)
        return false;
      if (a2.isSupport() || (this.storageEnable = false), !this.initUrl())
        return xe("----vtrackcustom----\u521D\u59CB\u5316\u5931\u8D25\uFF0Curl\u4FE1\u606F\u89E3\u6790\u5931\u8D25"), false;
      if (this.storageEnable) {
        var e3 = Pt.readObjectVal(this.storage_name);
        if (s(e3) && s(e3.data))
          if (this.serverUrlIsSame(e3.serverUrl)) {
            this.config = e3.data, this.update_time = e3.updateTime, this.updateConfig(e3.data);
            var r2 = new Date().getTime() - this.update_time;
            if (ge(r2) && r2 > 0 && r2 < this.para.session_time) {
              var n2 = this.para.update_interval - r2;
              this.setNextFetch(n2);
            } else
              this.getConfigFromServer();
          } else
            this.getConfigFromServer();
        else
          this.getConfigFromServer();
      } else
        this.getConfigFromServer();
      this.pageStateListenner();
    }, serverUrlIsSame: function(e3) {
      return !!s(e3) && (e3.host === this.url_info.server_url.host && e3.project === this.url_info.server_url.project);
    }, getConfigFromServer: function() {
      var e3 = this;
      this.sendRequest(function(t3, r2) {
        e3.update_time = new Date().getTime();
        var n2 = {};
        200 === t3 ? r2 && s(r2) && "Web" === r2.os && (n2 = r2, e3.updateConfig(n2)) : 205 === t3 ? e3.updateConfig(n2) : 304 === t3 ? n2 = e3.config : (xe("----vtrackcustom----\u6570\u636E\u5F02\u5E38", t3), e3.updateConfig(n2)), e3.updateStorage(n2), e3.setNextFetch();
      }, function(t3) {
        e3.update_time = new Date().getTime(), xe("----vtrackcustom----\u914D\u7F6E\u62C9\u53D6\u5931\u8D25", t3), e3.setNextFetch();
      });
    }, setNextFetch: function(e3) {
      var t3 = this;
      this.timer && (clearTimeout(this.timer), this.timer = null), e3 = e3 || this.para.update_interval, this.timer = setTimeout(function() {
        t3.getConfigFromServer();
      }, e3);
    }, pageStateListenner: function() {
      var e3 = this;
      he2({ visible: function() {
        var t3 = new Date().getTime() - e3.update_time;
        if (ge(t3) && t3 > 0 && t3 < e3.para.update_interval) {
          var r2 = e3.para.update_interval - t3;
          e3.setNextFetch(r2);
        } else
          e3.getConfigFromServer();
      }, hidden: function() {
        e3.timer && (clearTimeout(e3.timer), e3.timer = null);
      } });
    }, updateConfig: function(e3) {
      if (!s(e3))
        return false;
      this.config = e3, this.customProp.updateEvents(e3), this.unlimitedDiv.init(e3);
    }, updateStorage: function(e3) {
      if (!this.storageEnable)
        return false;
      if (!s(e3))
        return false;
      var t3;
      if (this.url_info.server_url)
        t3 = this.url_info.server_url;
      else {
        var r2 = xt.initUrl();
        if (!r2)
          return false;
        t3 = r2.server_url;
      }
      var n2 = { updateTime: new Date().getTime(), data: e3, serverUrl: t3 };
      Pt.saveObjectVal(this.storage_name, n2);
    }, sendRequest: function(e3, t3) {
      var r2 = { app_id: this.url_info.page_url.host };
      this.config.version && (r2.v = this.config.version), _e({ url: this.url_info.api_url, callbackName: "saJSSDKVtrackCollectConfig", data: r2, timeout: this.para.timeout, success: function(t4, r3) {
        e3(t4, r3);
      }, error: function(e4) {
        t3(e4);
      } });
    }, getAssignConfigs: It.getAssignConfigs, configIsMatch: It.configIsMatch };
    var Et = { stage: null, init: function(e3) {
      this.stage = e3;
    }, interceptor: { basicProps: { priority: 0, entry: function(e3, t3) {
      try {
        var r2 = t3.sensors, n2 = {};
        s(e3) && s(e3.identities) && !ce2(e3.identities) ? $(n2, e3.identities) : $(n2, Pt.getIdentities());
        var i2 = { identities: n2, distinct_id: Pt.getDistinctId(), lib: { $lib: "js", $lib_method: "code", $lib_version: String(r2.lib_version) }, properties: {} };
        return s(e3) && s(e3.properties) && !ce2(e3.properties) && (e3.properties.$lib_detail && (i2.lib.$lib_detail = e3.properties.$lib_detail, delete e3.properties.$lib_detail), e3.properties.$lib_method && (i2.lib.$lib_method = e3.properties.$lib_method, delete e3.properties.$lib_method)), q(i2, Pt.getUnionId(), e3), s(e3.properties) && !ce2(e3.properties) && $(i2.properties, e3.properties), "$UnbindID" === i2.event && (i2.login_id && delete i2.login_id, i2.anonymous_id && delete i2.anonymous_id), e3.type && "profile" === e3.type.slice(0, 7) || (r2.para.properties_priority && 3 === r2.para.properties_priority ? i2.properties = $({}, it2.properties(), Pt.getSessionProps(), it2.currentProps, Pt.getProps(), i2.properties) : i2.properties = $({}, it2.properties(), Pt.getProps(), Pt.getSessionProps(), it2.currentProps, i2.properties), r2.para.preset_properties.latest_referrer && !h(i2.properties.$latest_referrer) && (i2.properties.$latest_referrer = "\u53D6\u503C\u5F02\u5E38"), r2.para.preset_properties.latest_search_keyword && !h(i2.properties.$latest_search_keyword) && (r2.para.preset_properties.search_keyword_baidu && h(i2.properties.$search_keyword_id) && ge(i2.properties.$search_keyword_id_hash) && h(i2.properties.$search_keyword_id_type) || (i2.properties.$latest_search_keyword = "\u53D6\u503C\u5F02\u5E38")), r2.para.preset_properties.latest_traffic_source_type && !h(i2.properties.$latest_traffic_source_type) && (i2.properties.$latest_traffic_source_type = "\u53D6\u503C\u5F02\u5E38"), r2.para.preset_properties.latest_landing_page && !h(i2.properties.$latest_landing_page) && (i2.properties.$latest_landing_page = "\u53D6\u503C\u5F02\u5E38"), "not_collect" === r2.para.preset_properties.latest_wx_ad_click_id ? (delete i2.properties._latest_wx_ad_click_id, delete i2.properties._latest_wx_ad_hash_key, delete i2.properties._latest_wx_ad_callbacks) : r2.para.preset_properties.latest_wx_ad_click_id && !h(i2.properties._latest_wx_ad_click_id) && (i2.properties._latest_wx_ad_click_id = "\u53D6\u503C\u5F02\u5E38", i2.properties._latest_wx_ad_hash_key = "\u53D6\u503C\u5F02\u5E38", i2.properties._latest_wx_ad_callbacks = "\u53D6\u503C\u5F02\u5E38"), h(i2.properties._latest_wx_ad_click_id) && (i2.properties.$url = ee2())), i2.properties.$time && J(i2.properties.$time) ? (i2.time = 1 * i2.properties.$time, delete i2.properties.$time) : i2.time = 1 * new Date(), function(e4) {
          if (r2.bridge && "success" === r2.bridge.bridge_info.verify_success) {
            var t4 = At.customProp.geth5Props(JSON.parse(JSON.stringify(e4)));
            s(t4) && !ce2(t4) && (e4.properties = $(e4.properties, t4));
          }
          var n3 = xt.customProp.getVtrackProps(JSON.parse(JSON.stringify(e4)));
          s(n3) && !ce2(n3) && (e4.properties = $(e4.properties, n3));
        }(i2), st2(i2), Ve.checkIsAddSign(i2), Ve.checkIsFirstTime(i2), function(e4) {
          var t4 = !e4.type || "profile" !== e4.type.slice(0, 7);
          s(e4.properties) && t4 && ("$referrer" in e4.properties && (e4.properties.$referrer_host = "" === e4.properties.$referrer ? "" : W(e4.properties.$referrer, "\u53D6\u503C\u5F02\u5E38")), Ee.preset_properties.latest_referrer && Ee.preset_properties.latest_referrer_host && (e4.properties.$latest_referrer_host = "" === e4.properties.$latest_referrer ? "" : W(e4.properties.$latest_referrer, "\u53D6\u503C\u5F02\u5E38")));
        }(i2), function(e4) {
          var t4 = !e4.type || "profile" !== e4.type.slice(0, 7), r3 = Ee.preset_properties && t4;
          r3 && Ee.preset_properties.url && P(e4.properties.$url) && (e4.properties.$url = ee2()), r3 && Ee.preset_properties.title && P(e4.properties.$title) && (e4.properties.$title = document.title);
        }(i2), i2;
      } catch (a3) {
        return { _debug_web_msg: String(a3) };
      }
    } }, formatData: { priority: 0, entry: function(e3) {
      var t3, i2 = e3.properties;
      be2(e3), s(i2) ? (function(e4, t4) {
        s(e4) && D(e4, function(n2, i3) {
          if (C(n2)) {
            var a3 = [];
            D(n2, function(e5) {
              if (h(e5))
                a3.push(e5);
              else if (P(e5))
                a3.push("null");
              else
                try {
                  a3.push(JSON.stringify(e5));
                } catch (t5) {
                  $e2("\u60A8\u7684\u6570\u636E-", i3, n2, "\u6570\u7EC4\u91CC\u503C\u6709\u9519\u8BEF,\u5DF2\u5C06\u5176\u5220\u9664");
                }
            }), e4[i3] = a3;
          }
          var o2 = oe(t4 || [], i3) > -1;
          if (s(n2) && "$option" !== i3 && !o2)
            try {
              e4[i3] = JSON.stringify(n2);
            } catch (l2) {
              delete e4[i3], $e2("\u60A8\u7684\u6570\u636E-", i3, n2, "\u6570\u636E\u503C\u6709\u9519\u8BEF\uFF0C\u5DF2\u5C06\u5176\u5220\u9664");
            }
          else
            h(n2) || ge(n2) || J(n2) || ue(n2) || C(n2) || r(n2) || "$option" === i3 || o2 || ($e2("\u60A8\u7684\u6570\u636E-", i3, n2, "-\u683C\u5F0F\u4E0D\u6EE1\u8DB3\u8981\u6C42\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664"), delete e4[i3]);
        });
      }(i2), s(t3 = i2) && D(["distinct_id", "user_id", "id", "date", "datetime", "event", "events", "first_id", "original_id", "device_id", "properties", "second_id", "time", "users"], function(e4, r2) {
        e4 in t3 && (oe([], e4) > -1 || (r2 < 3 ? (delete t3[e4], $e2("\u60A8\u7684\u5C5E\u6027- " + e4 + "\u662F\u4FDD\u7559\u5B57\u6BB5\uFF0C\u6211\u4EEC\u5DF2\u7ECF\u5C06\u5176\u5220\u9664")) : $e2("\u60A8\u7684\u5C5E\u6027- " + e4 + "\u662F\u4FDD\u7559\u5B57\u6BB5\uFF0C\u8BF7\u907F\u514D\u5176\u4F5C\u4E3A\u5C5E\u6027\u540D")));
      }), function(e4) {
        "undefined" != typeof e4.properties.$project && (e4.project = e4.properties.$project, delete e4.properties.$project), "undefined" != typeof e4.properties.$token && (e4.token = e4.properties.$token, delete e4.properties.$token);
      }(e3), function(e4, t4) {
        D(e4, function(r2, n2) {
          -1 === oe(t4 || [], n2) && Nt({ propertyKey: n2 }, function(t5, r3, i3) {
            return t5 || "keyLength" === i3 || delete e4[n2], true;
          });
        });
      }(i2), Tt(i2)) : "properties" in e3 && (e3.properties = {}), function(e4) {
        "item_type" in e4 && Nt({ item_type: e4.item_type }, function(t4) {
          return t4 || delete e4.item_type, true;
        }), "item_id" in e4 && Nt({ item_id: e4.item_id }, function(t4, r2, n2) {
          return t4 || "string" !== n2 || delete e4.item_id, true;
        });
      }(e3);
    } }, finalAdjustData: { priority: 0, entry: function(e3, t3) {
      var r2 = t3.sensors;
      return e3._track_id = Number(String(u()).slice(2, 5) + String(u()).slice(2, 4) + String(new Date().getTime()).slice(-4)), e3._flush_time = new Date().getTime(), r2.events.tempAdd("send", e3), e3;
    } } } };
    var Lt = {};
    function Ut(e3, t3, r2, n2) {
      var i2 = null;
      if ((e3 = e3 || {}).ele && (i2 = e3.ele), e3.event && (i2 = e3.target ? e3.target : e3.event.target), r2 = r2 || {}, !i2 || "object" != typeof i2)
        return false;
      if (!i2.href || /^javascript/.test(i2.href) || i2.target || i2.download || i2.onclick)
        return n2(t3, r2), false;
      function a3(e4) {
        e4.stopPropagation(), e4.preventDefault();
        var a4 = false;
        function o2() {
          a4 || (a4 = true, location.href = i2.href);
        }
        setTimeout(o2, 1e3), n2(t3, r2, o2);
      }
      e3.event && a3(e3.event), e3.ele && ze(e3.ele, "click", function(e4) {
        a3(e4);
      });
    }
    function Rt() {
      var e3 = location.protocol;
      return "http:" === e3 || "https:" === e3 ? e3 : "http:";
    }
    Lt.check = Nt, Lt.sendItem = function(e3) {
      var r2 = { lib: { $lib: "js", $lib_method: "code", $lib_version: String(t2.lib_version) }, time: 1 * new Date() };
      $(r2, e3), function(e4) {
        Et.stage.process("formatData", e4);
      }(r2), t2.kit.sendData(r2);
    }, Lt.send = function(e3, r2) {
      var n2 = t2.kit.buildData(e3);
      t2.kit.sendData(n2, r2);
    };
    var Bt = { stage: null, init: function(e3) {
      this.stage = e3;
    } };
    var Ht = { label: false, li: false, a: true, button: true }, Jt = { otherTags: [], initUnlimitedTags: function() {
      D(Jt.otherTags, function(e3) {
        e3 in Ht && (Ht[e3] = true);
      });
    }, isUnlimitedTag: function(e3) {
      if (!e3 || 1 !== e3.nodeType)
        return false;
      var r2 = e3.nodeName.toLowerCase();
      return Ht[r2] || ne2(e3, t2.para.heatmap.track_attr);
    }, getTargetElement: function(e3, r2) {
      var n2 = this, i2 = e3;
      if ("object" != typeof i2)
        return null;
      if ("string" != typeof i2.tagName)
        return null;
      var a3 = i2.tagName.toLowerCase();
      if ("body" === a3.toLowerCase() || "html" === a3.toLowerCase())
        return null;
      if (!i2 || !i2.parentNode || !i2.parentNode.children)
        return null;
      var o2 = i2.parentNode, s2 = n2.otherTags;
      if ("a" === a3 || "button" === a3 || "input" === a3 || "textarea" === a3)
        return i2;
      if (oe(s2, a3) > -1)
        return i2;
      if ("area" === a3 && "map" === o2.tagName.toLowerCase() && O(o2).prev().tagName && "img" === O(o2).prev().tagName.toLowerCase())
        return O(o2).prev();
      if ("div" === a3 && t2.para.heatmap.collect_tags.div && n2.isDivLevelValid(i2) && ((t2.para.heatmap && t2.para.heatmap.collect_tags && t2.para.heatmap.collect_tags.div && t2.para.heatmap.collect_tags.div.max_level || 1) > 1 || n2.isCollectableDiv(i2)))
        return i2;
      if (n2.isStyleTag(a3) && t2.para.heatmap.collect_tags.div) {
        var l2 = n2.getCollectableParent(i2);
        if (l2 && n2.isDivLevelValid(l2))
          return l2;
      }
      return n2.hasElement({ event: r2 && r2.originalEvent || r2, element: e3 }, function(e4) {
        return n2.isUnlimitedTag(e4);
      }) || null;
    }, getDivLevels: function(e3, t3) {
      var r2 = Jt.getElementPath(e3, true, t3).split(" > "), n2 = 0;
      return D(r2, function(e4) {
        "div" === e4 && n2++;
      }), n2;
    }, isDivLevelValid: function(e3) {
      for (var r2 = t2.para.heatmap && t2.para.heatmap.collect_tags && t2.para.heatmap.collect_tags.div && t2.para.heatmap.collect_tags.div.max_level || 1, n2 = e3.getElementsByTagName("div"), i2 = n2.length - 1; i2 >= 0; i2--)
        if (Jt.getDivLevels(n2[i2], e3) > r2)
          return false;
      return true;
    }, getElementPath: function(e3, t3, r2) {
      for (var n2 = []; e3.parentNode && k(e3); ) {
        if (!h(e3.tagName))
          return "unknown";
        if (e3.id && !t3 && /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e3.id)) {
          n2.unshift(e3.tagName.toLowerCase() + "#" + e3.id);
          break;
        }
        if (r2 && e3 === r2) {
          n2.unshift(e3.tagName.toLowerCase());
          break;
        }
        if (e3 === document.body) {
          n2.unshift("body");
          break;
        }
        n2.unshift(e3.tagName.toLowerCase()), e3 = e3.parentNode;
      }
      return n2.join(" > ");
    }, getClosestLi: function(e3) {
      return function(e4, t3) {
        for (; e4 && e4 !== document && 1 === e4.nodeType; e4 = e4.parentNode)
          if (e4.tagName && h(e4.tagName) && e4.tagName.toLowerCase() === t3)
            return e4;
        return null;
      }(e3, "li");
    }, getElementPosition: function(e3, r2, n2) {
      var i2 = t2.heatmap.getClosestLi(e3);
      if (!i2 || !k(e3) || !h(e3.tagName))
        return null;
      var a3 = e3.tagName.toLowerCase(), o2 = i2.getElementsByTagName(a3), s2 = o2.length, l2 = [];
      if (s2 > 1) {
        for (var u2 = 0; u2 < s2; u2++) {
          t2.heatmap.getElementPath(o2[u2], n2) === r2 && l2.push(o2[u2]);
        }
        if (l2.length > 1)
          return oe(l2, e3);
      }
      return function(e4) {
        if (!e4.parentNode)
          return "";
        if (1 === O(e4).getSameTypeSiblings().length)
          return 0;
        for (var t3 = 0, r3 = e4; O(r3).previousElementSibling().ele; r3 = O(r3).previousElementSibling().ele, t3++)
          ;
        return t3;
      }(i2);
    }, setNotice: function(e3) {
      t2.is_heatmap_render_mode = true, t2.para.heatmap || (t2.errorMsg = "\u60A8 SDK \u6CA1\u6709\u914D\u7F6E\u5F00\u542F\u70B9\u51FB\u56FE \uFF01"), e3 && "http:" === e3.slice(0, 5) && "https:" === location.protocol && (t2.errorMsg = "\u60A8\u7684\u5F53\u524D\u9875\u9762\u662F https \u7684\u5730\u5740\uFF0C\u795E\u7B56\u5206\u6790\u73AF\u5883\u4E5F\u5FC5\u987B\u662F https \uFF01"), t2.para.heatmap_url || (t2.para.heatmap_url = Rt() + "//static.sensorsdata.cn/sdk/" + t2.lib_version + "/heatmap.min.js");
    }, getDomIndex: function(e3) {
      if (!e3.parentNode)
        return -1;
      for (var t3 = 0, r2 = e3.tagName, n2 = e3.parentNode.children, i2 = 0; i2 < n2.length; i2++)
        if (n2[i2].tagName === r2) {
          if (e3 === n2[i2])
            return t3;
          t3++;
        }
      return -1;
    }, selector: function(e3, r2) {
      if (!e3 || !k(e3) || !h(e3.tagName))
        return "";
      var n2 = e3.parentNode && 9 == e3.parentNode.nodeType ? -1 : this.getDomIndex(e3);
      return e3.getAttribute && e3.getAttribute("id") && /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e3.getAttribute("id")) && (!t2.para.heatmap || t2.para.heatmap && "not_use_id" !== t2.para.heatmap.element_selector) && !r2 ? "#" + e3.getAttribute("id") : e3.tagName.toLowerCase() + (~n2 ? ":nth-of-type(" + (n2 + 1) + ")" : "");
    }, getDomSelector: function(e3, r2, n2) {
      if (!(e3 && e3.parentNode && e3.parentNode.children && h(e3.tagName)))
        return "unknown";
      r2 = r2 && r2.join ? r2 : [];
      var i2 = e3.nodeName.toLowerCase();
      return e3 && "body" !== i2 && 1 == e3.nodeType ? (r2.unshift(this.selector(e3, n2)), e3.getAttribute && e3.getAttribute("id") && /^[A-Za-z][-A-Za-z0-9_:.]*$/.test(e3.getAttribute("id")) && t2.para.heatmap && "not_use_id" !== t2.para.heatmap.element_selector && !n2 ? r2.join(" > ") : this.getDomSelector(e3.parentNode, r2, n2)) : (r2.unshift("body"), r2.join(" > "));
    }, na: function() {
      var e3 = document.documentElement.scrollLeft || window.pageXOffset;
      return parseInt(isNaN(e3) ? 0 : e3, 10);
    }, i: function() {
      var e3 = 0;
      try {
        e3 = o.documentElement && o.documentElement.scrollTop || m.pageYOffset, e3 = isNaN(e3) ? 0 : e3;
      } catch (t3) {
        e3 = 0;
      }
      return parseInt(e3, 10);
    }, getBrowserWidth: function() {
      var e3 = window.innerWidth || document.body.clientWidth;
      return isNaN(e3) ? 0 : parseInt(e3, 10);
    }, getBrowserHeight: function() {
      var e3 = window.innerHeight || document.body.clientHeight;
      return isNaN(e3) ? 0 : parseInt(e3, 10);
    }, getScrollWidth: function() {
      var e3 = parseInt(document.body.scrollWidth, 10);
      return isNaN(e3) ? 0 : e3;
    }, getEleDetail: function(e3) {
      var r2 = this.getDomSelector(e3), n2 = ct({ target: e3 });
      n2.$element_selector = r2 || "", n2.$element_path = t2.heatmap.getElementPath(e3, t2.para.heatmap && "not_use_id" === t2.para.heatmap.element_selector);
      var i2 = t2.heatmap.getElementPosition(e3, n2.$element_path, t2.para.heatmap && "not_use_id" === t2.para.heatmap.element_selector);
      return ge(i2) && (n2.$element_position = i2), n2;
    }, getPointerEventProp: function(e3, t3) {
      if (!e3)
        return {};
      function r2() {
        return { scrollLeft: document.body.scrollLeft || document.documentElement.scrollLeft || 0, scrollTop: document.body.scrollTop || document.documentElement.scrollTop || 0 };
      }
      function n2(e4) {
        if (document.documentElement.getBoundingClientRect) {
          var t4 = e4.getBoundingClientRect();
          return { targetEleX: t4.left + r2().scrollLeft || 0, targetEleY: t4.top + r2().scrollTop || 0 };
        }
      }
      function i2(e4) {
        return Number(Number(e4).toFixed(3));
      }
      return function(e4) {
        var a3 = e4.pageX || e4.clientX + r2().scrollLeft || e4.offsetX + n2(t3).targetEleX || 0, o2 = e4.pageY || e4.clientY + r2().scrollTop || e4.offsetY + n2(t3).targetEleY || 0;
        return { $page_x: i2(a3), $page_y: i2(o2) };
      }(e3);
    }, start: function(e3, n2, i2, a3, o2) {
      if (s(t2.para.heatmap) && r(t2.para.heatmap.collect_element) && !t2.para.heatmap.collect_element(n2))
        return false;
      var l2, u2 = Jt.getBasicEleInfo(e3, n2, i2, a3, o2);
      l2 = u2, Bt.stage.process("webClickEvent", l2);
    }, getBasicEleInfo: function(e3, n2, i2, a3, o2) {
      var l2 = s(a3) ? a3 : {}, u2 = r(o2) ? o2 : r(a3) ? a3 : void 0, c3 = this.getEleDetail(n2);
      if (t2.para.heatmap && t2.para.heatmap.custom_property) {
        var p2 = t2.para.heatmap.custom_property(n2);
        s(p2) && (c3 = $(c3, p2));
      }
      return { event: e3, target: n2, props: c3 = $(c3, this.getPointerEventProp(e3, n2), l2), tagName: i2, callback: u2 };
    }, hasElement: function(e3, t3) {
      var r2;
      if (e3.event) {
        var n2 = e3.event;
        r2 = n2.path || n2._getPath && n2._getPath();
      } else
        e3.element && (r2 = O(e3.element).getParents());
      if (r2 && C(r2) && r2.length > 0) {
        for (var i2 = 0; i2 < r2.length; i2++)
          if ("object" == typeof r2[i2] && 1 === r2[i2].nodeType && t3(r2[i2]))
            return r2[i2];
      }
    }, isStyleTag: function(e3, r2) {
      return !(oe(["a", "div", "input", "button", "textarea"], e3) > -1) && (!r2 || t2.para.heatmap && t2.para.heatmap.collect_tags && t2.para.heatmap.collect_tags.div ? !!(s(t2.para.heatmap) && s(t2.para.heatmap.collect_tags) && s(t2.para.heatmap.collect_tags.div) && C(t2.para.heatmap.collect_tags.div.ignore_tags) && oe(t2.para.heatmap.collect_tags.div.ignore_tags, e3) > -1) : oe(["mark", "/mark", "strong", "b", "em", "i", "u", "abbr", "ins", "del", "s", "sup"], e3) > -1);
    }, isCollectableDiv: function(e3, r2) {
      try {
        if (0 === e3.children.length)
          return true;
        for (var n2 = 0; n2 < e3.children.length; n2++)
          if (1 === e3.children[n2].nodeType) {
            var i2 = h(e3.children[n2].tagName) ? e3.children[n2].tagName.toLowerCase() : "unknown", a3 = t2.para && t2.para.heatmap && t2.para.heatmap.collect_tags && t2.para.heatmap.collect_tags.div && t2.para.heatmap.collect_tags.div.max_level;
            if (!("div" === i2 && a3 > 1 || this.isStyleTag(i2, r2)))
              return false;
            if (!this.isCollectableDiv(e3.children[n2], r2))
              return false;
          }
        return true;
      } catch (o2) {
        xe("isCollectableDiv:" + o2);
      }
      return false;
    }, getCollectableParent: function(e3, r2) {
      try {
        var n2 = e3.parentNode, i2 = n2 ? n2.tagName.toLowerCase() : "";
        if ("body" === i2)
          return false;
        var a3 = t2.para && t2.para.heatmap && t2.para.heatmap.collect_tags && t2.para.heatmap.collect_tags.div && t2.para.heatmap.collect_tags.div.max_level;
        if (i2 && "div" === i2 && (a3 > 1 || this.isCollectableDiv(n2, r2)))
          return n2;
        if (n2 && this.isStyleTag(i2, r2))
          return this.getCollectableParent(n2, r2);
      } catch (o2) {
        xe("getCollectableParent:" + o2);
      }
      return false;
    }, listenUrlChange: function(e3) {
      e3(), t2.ee.spa.on("switch", function() {
        e3();
      });
    }, initScrollmap: function() {
      if (!s(t2.para.heatmap) || "default" !== t2.para.heatmap.scroll_notice_map)
        return false;
      var e3 = true;
      t2.para.scrollmap && r(t2.para.scrollmap.collect_url) && this.listenUrlChange(function() {
        e3 = !!t2.para.scrollmap.collect_url();
      });
      var n2 = function(e4) {
        var t3 = {};
        return t3.timeout = e4.timeout || 1e3, t3.func = e4.func, t3.hasInit = false, t3.inter = null, t3.main = function(e5, t4) {
          this.func(e5, t4), this.inter = null;
        }, t3.go = function(e5) {
          var r2 = {};
          this.inter || (r2.$viewport_position = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0, r2.$viewport_position = Math.round(r2.$viewport_position) || 0, e5 ? t3.main(r2, true) : this.inter = setTimeout(function() {
            t3.main(r2);
          }, this.timeout));
        }, t3;
      }({ timeout: 1e3, func: function(e4, r2) {
        var n3, i2 = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0, a3 = new Date(), o2 = a3 - this.current_time;
        (o2 > t2.para.heatmap.scroll_delay_time && i2 - e4.$viewport_position != 0 || r2) && (e4.$url = ee2(), e4.$title = document.title, e4.$url_path = te2(), e4.event_duration = Math.min(t2.para.heatmap.scroll_event_duration, parseInt(o2) / 1e3), e4.event_duration = e4.event_duration < 0 ? 0 : e4.event_duration, n3 = e4, Bt.stage.process("webStayEvent", n3)), this.current_time = a3;
      } });
      n2.current_time = new Date(), ze(window, "scroll", function() {
        if (!e3)
          return false;
        n2.go();
      }), ze(window, "beforeunload", function() {
        if (!e3)
          return false;
        n2.go("notime");
      });
    }, initHeatmap: function() {
      var e3 = this, n2 = true;
      if (!s(t2.para.heatmap) || "default" !== t2.para.heatmap.clickmap)
        return false;
      r(t2.para.heatmap.collect_url) && this.listenUrlChange(function() {
        n2 = !!t2.para.heatmap.collect_url();
      }), "all" === t2.para.heatmap.collect_elements ? t2.para.heatmap.collect_elements = "all" : t2.para.heatmap.collect_elements = "interact", "all" === t2.para.heatmap.collect_elements ? ze(document, "click", function(t3) {
        if (!n2)
          return false;
        var r2 = t3 || window.event;
        if (!r2)
          return false;
        var i2 = r2.target || r2.srcElement;
        if ("object" != typeof i2)
          return false;
        if ("string" != typeof i2.tagName)
          return false;
        var a3 = i2.tagName.toLowerCase();
        if ("body" === a3 || "html" === a3)
          return false;
        if (!i2 || !i2.parentNode || !i2.parentNode.children)
          return false;
        var o2 = h(i2.parentNode.tagName) ? i2.parentNode.tagName.toLowerCase() : "unknown";
        "a" === o2 || "button" === o2 ? e3.start(r2, i2.parentNode, o2) : e3.start(r2, i2, a3);
      }) : ze(document, "click", function(r2) {
        if (!n2)
          return false;
        var i2 = r2 || window.event;
        if (!i2)
          return false;
        var a3 = i2.target || i2.srcElement, o2 = t2.heatmap.getTargetElement(a3, r2);
        if (!k(o2) && !h(a3.tagName))
          return false;
        k(o2) && h(o2.tagName) ? e3.start(i2, o2, o2.tagName.toLowerCase()) : k(a3) && "div" === a3.tagName.toLowerCase() && s(t2.para.heatmap) && t2.para.heatmap.get_vtrack_config && Dt.events.length > 0 && Dt.isTargetEle(a3) && e3.start(i2, a3, a3.tagName.toLowerCase(), { $lib_method: "vtrack" });
      });
    } };
    function Mt() {
      var e3 = it2.campaignParams(), r2 = {};
      return D(e3, function(e4, n2, i2) {
        -1 !== (" " + t2.source_channel_standard + " ").indexOf(" " + n2 + " ") ? r2["$" + n2] = i2[n2] : r2[n2] = i2[n2];
      }), r2;
    }
    function qt(e3, r2, n2) {
      if (t2.is_first_visitor && n2) {
        var i2 = {};
        t2.para.preset_properties.search_keyword_baidu && et2(document.referrer) && Xe() && (i2.$search_keyword_id = Ze.id(), i2.$search_keyword_id_type = Ze.type(), i2.$search_keyword_id_hash = ae(i2.$search_keyword_id));
        var a3 = document.characterSet || document.charset, o2 = Qe(null, r2);
        e3($({ $first_visit_time: new Date(), $first_referrer: o2, $first_referrer_host: o2 ? W(o2, "\u53D6\u503C\u5F02\u5E38") : "", $first_browser_language: h(navigator.language) ? navigator.language.toLowerCase() : "\u53D6\u503C\u5F02\u5E38", $first_browser_charset: h(a3) ? a3.toUpperCase() : "\u53D6\u503C\u5F02\u5E38", $first_traffic_source_type: at(), $first_search_keyword: tt(), $timezone_offset: new Date().getTimezoneOffset() }, Mt(), i2)), t2.is_first_visitor = false;
      }
    }
    var Ft = { autoTrackIsUsed: false, isReady: function(e3) {
      r(e3) ? e3() : t2.log("error: isReady callback must be function");
    }, getUtm: function() {
      return it2.campaignParams();
    }, getStayTime: function() {
      return (new Date() - t2._t) / 1e3;
    }, setProfileLocal: function(e3) {
      if (!a2.isSupport())
        return t2.setProfile(e3), false;
      if (!s(e3) || ce2(e3))
        return false;
      var r2 = Pt.readObjectVal("sensorsdata_2015_jssdk_profile"), n2 = false;
      if (s(r2) && !ce2(r2)) {
        for (var i2 in e3)
          !(i2 in r2 && r2[i2] !== e3[i2]) && i2 in r2 || (r2[i2] = e3[i2], n2 = true);
        n2 && (Pt.saveObjectVal("sensorsdata_2015_jssdk_profile", r2), t2.setProfile(e3));
      } else
        Pt.saveObjectVal("sensorsdata_2015_jssdk_profile", e3), t2.setProfile(e3);
    }, setInitReferrer: function() {
      var e3 = Qe();
      t2.setOnceProfile({ _init_referrer: e3, _init_referrer_host: it2.pageProp.referrer_host });
    }, setSessionReferrer: function() {
      var e3 = Qe();
      Pt.setSessionPropsOnce({ _session_referrer: e3, _session_referrer_host: it2.pageProp.referrer_host });
    }, setDefaultAttr: function() {
      it2.register({ _current_url: location.href, _referrer: Qe(), _referring_host: it2.pageProp.referrer_host });
    }, trackHeatMap: function(e3, r2, n2) {
      if ("object" == typeof e3 && e3.tagName && k(e3.parentNode)) {
        var i2 = e3.tagName.toLowerCase(), a3 = e3.parentNode.tagName.toLowerCase(), o2 = t2.para.heatmap && t2.para.heatmap.track_attr ? t2.para.heatmap.track_attr : ["data-sensors-click"];
        "button" === i2 || "a" === i2 || "a" === a3 || "button" === a3 || "input" === i2 || "textarea" === i2 || ne2(e3, o2) || Jt.start(null, e3, i2, r2, n2);
      }
    }, trackAllHeatMap: function(e3, t3, r2) {
      if ("object" == typeof e3 && e3.tagName) {
        var n2 = e3.tagName.toLowerCase();
        Jt.start(null, e3, n2, t3, r2);
      }
    }, autoTrackSinglePage: function(e3, r2) {
      var n2;
      n2 = this.autoTrackIsUsed ? it2.pageProp.url : it2.pageProp.referrer;
      var i2 = !(e3 = s(e3) ? e3 : {}).not_set_profile;
      function a3(e4, r3) {
        t2.track("$pageview", $({ $referrer: n2, $url: ee2(), $url_path: te2(), $title: document.title }, e4, Mt()), r3), n2 = ee2();
      }
      e3.not_set_profile && delete e3.not_set_profile, a3(e3, r2), this.autoTrackSinglePage = a3, qt(t2.setOnceProfile, false, i2);
    }, autoTrackWithoutProfile: function(e3, t3) {
      e3 = s(e3) ? e3 : {}, this.autoTrack($(e3, { not_set_profile: true }), t3);
    }, autoTrack: function(e3, r2) {
      e3 = s(e3) ? e3 : {};
      var n2 = Mt(), i2 = !e3.not_set_profile;
      e3.not_set_profile && delete e3.not_set_profile;
      var a3 = location.href;
      t2.para.is_single_page && I(function() {
        var i3 = Qe(a3, true);
        t2.track("$pageview", $({ $referrer: i3, $url: ee2(), $url_path: te2(), $title: document.title }, n2, e3), r2), a3 = ee2();
      }), t2.track("$pageview", $({ $referrer: Qe(null, true), $url: ee2(), $url_path: te2(), $title: document.title }, n2, e3), r2), qt(t2.setOnceProfile, true, i2), this.autoTrackIsUsed = true;
    }, getAnonymousID: function() {
      return ce2(Pt._state) ? "SDK is not initialized." : Pt.getAnonymousId();
    }, setPlugin: function(e3) {
      if (!s(e3))
        return false;
      D(e3, function(e4, n2) {
        r(e4) && (s(window.SensorsDataWebJSSDKPlugin) && window.SensorsDataWebJSSDKPlugin[n2] ? e4(window.SensorsDataWebJSSDKPlugin[n2]) : s(t2.modules) && t2.modules[n2] ? e4(t2.modules[n2]) : $e2(n2 + "is not found,please check sensorsdata documents."));
      });
    }, useModulePlugin: function() {
      t2.use.apply(t2, arguments);
    }, useAppPlugin: function() {
      this.setPlugin.apply(this, arguments);
    } };
    function Kt(e3, t3) {
      var r2 = e3.id, n2 = e3.callback, i2 = e3.name, a3 = Pt.getFirstId(), o2 = Pt.getOriginDistinctId();
      if (!Nt({ distinct_id: r2 }))
        return xe("login id is invalid"), false;
      if (r2 === Pt.getOriginDistinctId() && !a3)
        return xe("login id is equal to distinct_id"), false;
      if (s(Pt._state.identities) && Pt._state.identities.hasOwnProperty(i2) && r2 === Pt._state.first_id)
        return false;
      if (Pt._state.history_login_id.name !== i2 || r2 !== Pt._state.history_login_id.value) {
        Pt._state.identities[i2] = r2, Pt.set("history_login_id", { name: i2, value: r2 }), a3 || Pt.set("first_id", o2), t3(r2, "$SignUp", {}, n2);
        var l2 = { $identity_cookie_id: Pt._state.identities.$identity_cookie_id };
        return l2[i2] = r2, Vt(l2), true;
      }
      return false;
    }
    function Vt(e3) {
      var t3 = {};
      for (var r2 in e3)
        t3[r2] = e3[r2];
      Pt._state.identities = t3, Pt.save();
    }
    var zt = 1;
    function Wt(e3, n2) {
      if (h(e3) || s(e3)) {
        var i2;
        if (s(e3)) {
          var a3 = t2.modules && t2.modules[e3.plugin_name];
          a3 && a3 !== e3 && $e2(e3.name + " is conflict with builtin plugin, and sdk uses builtin plugin."), i2 = a3 || e3;
        }
        return h(e3) && (s(t2.modules) && s(t2.modules[e3]) ? i2 = t2.modules[e3] : s(window.SensorsDataWebJSSDKPlugin) && s(window.SensorsDataWebJSSDKPlugin[e3]) ? i2 = window.SensorsDataWebJSSDKPlugin[e3] : window.sensorsDataAnalytic201505 && window.sensorsDataAnalytic201505.modules[e3] && (i2 = window.sensorsDataAnalytic201505.modules[e3])), i2 && r(i2.init) ? i2.plugin_is_init ? i2 : (i2.plugin_name || $e2("warning: invalid plugin, plugin_name required."), i2.plugin_version ? i2.plugin_version !== t2.lib_version && $e2("warning: plugin version not match SDK version. plugin may not work correctly. ") : $e2("warning: invalid plugin, plugin version required."), !i2.plugin_is_init && i2.init(t2, n2), i2.plugin_is_init = true, t2.modules = t2.modules || {}, t2.modules[i2.plugin_name || "unnamed_" + zt++] = i2, i2) : ($e2((e3.plugin_name || e3) + " is not found or it's not a standard plugin. Please check sensorsdata official documents."), i2);
      }
      xe("use's first arguments must be string or object.");
    }
    function Xt(e3, t3, r2, n2) {
      var i2 = Pt.getFirstId() || Pt.getDistinctId();
      Pt.set("distinct_id", e3), Lt.send({ original_id: i2, distinct_id: Pt.getDistinctId(), type: "track_signup", event: t3, properties: r2 }, n2);
    }
    function Zt(e3) {
      Nt({ properties: e3 }) ? Pt.setProps(e3) : xe("register\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }
    function Yt(e3, t3) {
      "number" == typeof e3 && (e3 = String(e3)), !Kt({ id: e3, callback: t3, name: He.LOGIN }, Xt) && r(t3) && t3();
    }
    var Gt = { __proto__: null, setInitVar: function() {
      t2._t = t2._t || 1 * new Date(), t2.is_first_visitor = false, t2.source_channel_standard = Ue;
    }, initPara: function(e3) {
      $(Ee, e3 || t2.para || {}), t2.para = Ee;
      var r2, n2 = {};
      if (s(t2.para.is_track_latest))
        for (var i2 in t2.para.is_track_latest)
          n2["latest_" + i2] = t2.para.is_track_latest[i2];
      for (r2 in t2.para.preset_properties = $({}, Le.preset_properties, n2, t2.para.preset_properties || {}), Le)
        void 0 === t2.para[r2] && (t2.para[r2] = Le[r2]);
      "string" != typeof t2.para.web_url || "://" !== t2.para.web_url.slice(0, 3) && "//" !== t2.para.web_url.slice(0, 2) || ("://" === t2.para.web_url.slice(0, 3) ? t2.para.web_url = location.protocol.slice(0, -1) + t2.para.web_url : t2.para.web_url = location.protocol + t2.para.web_url), nt.protocol.serverUrl(), t2.bridge && t2.bridge.initPara();
      var a3 = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"], o2 = ["www.baidu.", "m.baidu.", "m.sm.cn", "so.com", "sogou.com", "youdao.com", "google.", "yahoo.com/", "bing.com/", "ask.com/"], l2 = ["weibo.com", "renren.com", "kaixin001.com", "douban.com", "qzone.qq.com", "zhihu.com", "tieba.baidu.com", "weixin.qq.com"], u2 = { baidu: ["wd", "word", "kw", "keyword"], google: "q", bing: "q", yahoo: "p", sogou: ["query", "keyword"], so: "q", sm: "q" };
      "object" == typeof t2.para.source_type && (t2.para.source_type.utm = C(t2.para.source_type.utm) ? t2.para.source_type.utm.concat(a3) : a3, t2.para.source_type.search = C(t2.para.source_type.search) ? t2.para.source_type.search.concat(o2) : o2, t2.para.source_type.social = C(t2.para.source_type.social) ? t2.para.source_type.social.concat(l2) : l2, t2.para.source_type.keyword = s(t2.para.source_type.keyword) ? $(u2, t2.para.source_type.keyword) : u2);
      var c3 = ["mark", "/mark", "strong", "b", "em", "i", "u", "abbr", "ins", "del", "s", "sup"];
      if (t2.para.heatmap && !s(t2.para.heatmap) && (t2.para.heatmap = {}), s(t2.para.heatmap)) {
        t2.para.heatmap.clickmap = t2.para.heatmap.clickmap || "default", t2.para.heatmap.scroll_notice_map = t2.para.heatmap.scroll_notice_map || "default", t2.para.heatmap.scroll_delay_time = t2.para.heatmap.scroll_delay_time || 4e3, t2.para.heatmap.scroll_event_duration = t2.para.heatmap.scroll_event_duration || 18e3, t2.para.heatmap.renderRefreshTime = t2.para.heatmap.renderRefreshTime || 1e3, t2.para.heatmap.loadTimeout = t2.para.heatmap.loadTimeout || 1e3, t2.para.heatmap.request_timeout = t2.para.heatmap.request_timeout || 1e4, true !== t2.para.heatmap.get_vtrack_config && (t2.para.heatmap.get_vtrack_config = false);
        var p2 = C(t2.para.heatmap.track_attr) ? F(t2.para.heatmap.track_attr, function(e4) {
          return e4 && "string" == typeof e4;
        }) : [];
        p2.push("data-sensors-click"), t2.para.heatmap.track_attr = p2, s(t2.para.heatmap.collect_tags) ? true === t2.para.heatmap.collect_tags.div ? t2.para.heatmap.collect_tags.div = { ignore_tags: c3, max_level: 1 } : s(t2.para.heatmap.collect_tags.div) ? (t2.para.heatmap.collect_tags.div.ignore_tags ? C(t2.para.heatmap.collect_tags.div.ignore_tags) || ($e2("ignore_tags \u53C2\u6570\u5FC5\u987B\u662F\u6570\u7EC4\u683C\u5F0F"), t2.para.heatmap.collect_tags.div.ignore_tags = c3) : t2.para.heatmap.collect_tags.div.ignore_tags = c3, t2.para.heatmap.collect_tags.div.max_level && -1 === oe([1, 2, 3], t2.para.heatmap.collect_tags.div.max_level) && (t2.para.heatmap.collect_tags.div.max_level = 1)) : t2.para.heatmap.collect_tags.div = false : t2.para.heatmap.collect_tags = { div: false };
      }
      t2.para.server_url = ft(t2.para.server_url, t2.para.custom_server_url), true === t2.para.noCache ? t2.para.noCache = "?" + new Date().getTime() : t2.para.noCache = "", t2.para.callback_timeout > t2.para.datasend_timeout && (t2.para.datasend_timeout = t2.para.callback_timeout), t2.para.heatmap && t2.para.heatmap.collect_tags && s(t2.para.heatmap.collect_tags) && D(t2.para.heatmap.collect_tags, function(e4, r3) {
        "div" !== r3 && e4 && t2.heatmap.otherTags.push(r3);
      }), t2.para.heatmap && "default" === t2.para.heatmap.clickmap && t2.heatmap.initUnlimitedTags();
    }, quick: function() {
      var e3 = Array.prototype.slice.call(arguments), r2 = e3[0], n2 = e3.slice(1);
      if ("string" == typeof r2 && Ft[r2])
        return Ft[r2].apply(Ft, n2);
      "function" == typeof r2 ? r2.apply(t2, n2) : $e2("quick\u65B9\u6CD5\u4E2D\u6CA1\u6709\u8FD9\u4E2A\u529F\u80FD" + e3[0]);
    }, use: Wt, track: function(e3, t3, r2) {
      Nt({ event: e3, properties: t3 }) && Lt.send({ type: "track", event: e3, properties: t3 }, r2);
    }, bind: function(e3, t3) {
      if (!Nt({ bindKey: e3, bindValue: t3 }))
        return false;
      Pt._state.identities[e3] = t3, Pt.save(), Lt.send({ type: "track_id_bind", event: "$BindID", properties: {} });
    }, unbind: function(e3, t3) {
      var r2 = function(e4, t4) {
        if (!Nt({ unbindKey: e4, bindValue: t4 }))
          return false;
        if (s(Pt._state.identities) && Pt._state.identities.hasOwnProperty(e4) && Pt._state.identities[e4] === t4) {
          var r3 = Pt.getUnionId().login_id;
          r3 && e4 + "+" + t4 === r3 && (Pt._state.distinct_id = Pt._state.first_id, Pt._state.first_id = "", Pt.set("history_login_id", { name: "", value: "" })), "$identity_cookie_id" !== e4 && (delete Pt._state.identities[e4], Pt.save());
        }
        var n2 = {};
        return n2[e4] = t4, n2;
      }(e3, t3);
      r2 && Lt.send({ identities: r2, type: "track_id_unbind", event: "$UnbindID", properties: {} });
    }, trackLink: function(e3, r2, n2) {
      "object" == typeof e3 && e3.tagName ? Ut({ ele: e3 }, r2, n2, t2.track) : "object" == typeof e3 && e3.target && e3.event && Ut(e3, r2, n2, t2.track);
    }, trackLinks: function(e3, r2, n2) {
      return n2 = n2 || {}, !(!e3 || "object" != typeof e3) && !(!e3.href || /^javascript/.test(e3.href) || e3.target) && void ze(e3, "click", function(i2) {
        i2.preventDefault();
        var a3 = false;
        function o2() {
          a3 || (a3 = true, location.href = e3.href);
        }
        setTimeout(o2, 1e3), t2.track(r2, n2, o2);
      });
    }, setItem: function(e3, t3, r2) {
      Nt({ item_type: e3, item_id: t3, properties: r2 }) && Lt.sendItem({ type: "item_set", item_type: e3, item_id: t3, properties: r2 || {} });
    }, deleteItem: function(e3, t3) {
      Nt({ item_type: e3, item_id: t3 }) && Lt.sendItem({ type: "item_delete", item_type: e3, item_id: t3 });
    }, setProfile: function(e3, t3) {
      Nt({ propertiesMust: e3 }) && Lt.send({ type: "profile_set", properties: e3 }, t3);
    }, setOnceProfile: function(e3, t3) {
      Nt({ propertiesMust: e3 }) && Lt.send({ type: "profile_set_once", properties: e3 }, t3);
    }, appendProfile: function(e3, t3) {
      Nt({ propertiesMust: e3 }) && (D(e3, function(t4, r2) {
        h(t4) && Ne(r2) ? e3[r2] = [t4] : C(t4) && Ne(r2) ? e3[r2] = t4 : (delete e3[r2], $e2("appendProfile\u5C5E\u6027\u7684\u503C\u5FC5\u987B\u662F\u5B57\u7B26\u4E32\u6216\u8005\u6570\u7EC4"));
      }), ce2(e3) || Lt.send({ type: "profile_append", properties: e3 }, t3));
    }, incrementProfile: function(e3, t3) {
      var r2 = e3;
      h(e3) && ((e3 = {})[r2] = 1), Nt({ propertiesMust: e3 }) && (function(e4) {
        for (var t4 in e4)
          if (Object.prototype.hasOwnProperty.call(e4, t4) && !/-*\d+/.test(String(e4[t4])))
            return false;
        return true;
      }(e3) ? Lt.send({ type: "profile_increment", properties: e3 }, t3) : xe("profile_increment\u7684\u503C\u53EA\u80FD\u662F\u6570\u5B57"));
    }, deleteProfile: function(e3) {
      Lt.send({ type: "profile_delete" }, e3), Pt.set("distinct_id", S()), Pt.set("first_id", "");
    }, unsetProfile: function(e3, t3) {
      var r2 = e3, n2 = {};
      h(e3) && (e3 = []).push(r2), C(e3) ? (D(e3, function(e4) {
        h(e4) ? n2[e4] = true : $e2("profile_unset\u7ED9\u7684\u6570\u7EC4\u91CC\u9762\u7684\u503C\u5FC5\u987B\u65F6string,\u5DF2\u7ECF\u8FC7\u6EE4\u6389", e4);
      }), Lt.send({ type: "profile_unset", properties: n2 }, t3)) : xe("profile_unset\u7684\u53C2\u6570\u5FC5\u987B\u662F\u6570\u7EC4");
    }, identify: function(e3) {
      "number" == typeof e3 && (e3 = String(e3));
      var t3 = Pt.getFirstId();
      if (void 0 === e3) {
        var r2 = S();
        t3 ? Pt.set("first_id", r2) : Pt.set("distinct_id", r2);
      } else
        Nt({ distinct_id: e3 }) && (t3 ? Pt.set("first_id", e3) : Pt.set("distinct_id", e3));
    }, resetAnonymousIdentity: function(e3) {
      if (Pt.getFirstId())
        return xe("resetAnonymousIdentity must be used in a logout state \uFF01"), false;
      if ("number" == typeof e3 && (e3 = String(e3)), void 0 === e3) {
        var t3 = S();
        Pt._state.identities.$identity_cookie_id = t3, Pt.set("distinct_id", t3);
      } else
        Nt({ distinct_id: e3 }) && (Pt._state.identities.$identity_cookie_id = e3, Pt.set("distinct_id", e3));
    }, trackSignup: function(e3, t3, r2, n2) {
      "number" == typeof e3 && (e3 = String(e3)), Nt({ distinct_id: e3, event: t3, properties: r2 }) && Xt(e3, t3, r2, n2);
    }, registerPage: function(e3) {
      Nt({ properties: e3 }) ? $(it2.currentProps, e3) : xe("register\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }, clearAllRegister: function(e3) {
      Pt.clearAllProps(e3);
    }, clearPageRegister: function(e3) {
      var t3;
      if (C(e3) && e3.length > 0)
        for (t3 = 0; t3 < e3.length; t3++)
          h(e3[t3]) && e3[t3] in it2.currentProps && delete it2.currentProps[e3[t3]];
      else if (true === e3)
        for (t3 in it2.currentProps)
          delete it2.currentProps[t3];
    }, register: Zt, registerOnce: function(e3) {
      Nt({ properties: e3 }) ? Pt.setPropsOnce(e3) : xe("registerOnce\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }, registerSession: function(e3) {
      t2.log("registerSession \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u6709\u95EE\u9898\u8054\u7CFB\u6280\u672F\u987E\u95EE"), Nt({ properties: e3 }) ? Pt.setSessionProps(e3) : xe("registerSession\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }, registerSessionOnce: function(e3) {
      t2.log("registerSessionOnce \u65B9\u6CD5\u5DF2\u7ECF\u5F03\u7528\uFF0C\u6709\u95EE\u9898\u8054\u7CFB\u6280\u672F\u987E\u95EE"), Nt({ properties: e3 }) ? Pt.setSessionPropsOnce(e3) : xe("registerSessionOnce\u8F93\u5165\u7684\u53C2\u6570\u6709\u8BEF");
    }, login: Yt, loginWithKey: function(e3, t3) {
      return $e2("loginWithKey is deprecated !!!"), "number" == typeof t3 && (t3 = String(t3)), "number" == typeof e3 && (e3 = String(e3)), !!Nt({ loginIdKey: e3 }) && (He.LOGIN === e3 ? (Yt(t3), false) : void Kt({ id: t3, callback: null, name: e3 }, Xt));
    }, logout: function(e3) {
      var t3 = Pt.getFirstId();
      if (t3)
        if (Pt.set("first_id", ""), true === e3) {
          var r2 = S();
          Pt.set("distinct_id", r2);
        } else
          Pt.set("distinct_id", t3);
      Vt({ $identity_cookie_id: Pt._state.identities.$identity_cookie_id }), Pt.set("history_login_id", { name: "", value: "" });
    }, getPresetProperties: function() {
      var e3, r2, n2 = { $is_first_day: Fe(), $is_first_time: Ve.is_page_first_visited, $referrer: it2.pageProp.referrer || "", $referrer_host: it2.pageProp.referrer ? W(it2.pageProp.referrer) : "", $url: ee2(), $url_path: te2(), $title: document.title || "", _distinct_id: Pt.getDistinctId(), identities: Pt.getIdentities() }, i2 = $({}, it2.properties(), Pt.getProps(), (e3 = it2.campaignParams(), r2 = {}, D(e3, function(e4, n3, i3) {
        -1 !== (" " + t2.source_channel_standard + " ").indexOf(" " + n3 + " ") ? r2["$" + n3] = i3[n3] : r2[n3] = i3[n3];
      }), r2), n2);
      return t2.para.preset_properties.latest_referrer && t2.para.preset_properties.latest_referrer_host && (i2.$latest_referrer_host = "" === i2.$latest_referrer ? "" : W(i2.$latest_referrer)), i2;
    }, readyState: { state: 0, historyState: [], stateType: { 1: "1-init\u672A\u5F00\u59CB", 2: "2-init\u5F00\u59CB", 3: "3-store\u5B8C\u6210" }, getState: function() {
      return this.historyState.join("\n");
    }, setState: function(e3) {
      String(e3) in this.stateType && (this.state = e3), this.historyState.push(this.stateType[e3]);
    } }, debug: nt, on: mt2, log: De };
    i.setup(De);
    var Qt = $({}, Te, St);
    var er = { bridge_info: { touch_app_bridge: false, verify_success: false, platform: "", support_two_way_call: false }, is_verify_success: false, initPara: function() {
      var e3 = { is_send: false !== t2.para.use_app_track_is_send && "only" !== t2.para.use_app_track, white_list: [], is_mui: "mui" === t2.para.use_app_track };
      "object" == typeof t2.para.app_js_bridge ? t2.para.app_js_bridge = $({}, e3, t2.para.app_js_bridge) : true !== t2.para.use_app_track && true !== t2.para.app_js_bridge && "only" !== t2.para.use_app_track && "mui" !== t2.para.use_app_track || (t2.para.app_js_bridge = $({}, e3)), false === t2.para.app_js_bridge.is_send && $e2("\u8BBE\u7F6E\u4E86 is_send:false,\u5982\u679C\u6253\u901A\u5931\u8D25\uFF0C\u6570\u636E\u5C06\u88AB\u4E22\u5F03!");
    }, app_js_bridge_v1: function() {
      var e3 = null, r2 = null;
      window.sensorsdata_app_js_bridge_call_js = function(t3) {
        !function(t4) {
          fe(e3 = t4) && (e3 = JSON.parse(e3)), r2 && (r2(e3), r2 = null, e3 = null);
        }(t3);
      }, t2.getAppStatus = function(t3) {
        if (function() {
          if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            var e4 = document.createElement("iframe");
            e4.setAttribute("src", "sensorsanalytics://getAppInfo"), document.documentElement.appendChild(e4), e4.parentNode.removeChild(e4), e4 = null;
          }
        }(), "object" == typeof window.SensorsData_APP_JS_Bridge && window.SensorsData_APP_JS_Bridge.sensorsdata_call_app && fe(e3 = window.SensorsData_APP_JS_Bridge.sensorsdata_call_app()) && (e3 = JSON.parse(e3)), !t3)
          return e3;
        null === e3 ? r2 = t3 : (t3(e3), e3 = null);
      };
    }, hasVisualModeBridge: function() {
      var e3 = window.SensorsData_App_Visual_Bridge, t3 = "sensorsdata_visualized_mode";
      return s(e3) && e3[t3] && (true === e3[t3] || e3[t3]());
    }, validateAppUrl: function(e3) {
      function r2(e4) {
        var t3 = { hostname: "", project: "" };
        try {
          e4 = b2(e4), t3.hostname = e4.hostname, t3.project = e4.searchParams.get("project") || "default";
        } catch (r3) {
          xe("validateAppUrl:" + r3);
        }
        return t3;
      }
      var n2 = r2(e3), i2 = r2(t2.para.server_url);
      if (n2.hostname === i2.hostname && n2.project === i2.project)
        return true;
      if (C(t2.para.app_js_bridge.white_list))
        for (var a3 = 0; a3 < t2.para.app_js_bridge.white_list.length; a3++) {
          var o2 = r2(t2.para.app_js_bridge.white_list[a3]);
          if (o2.hostname === n2.hostname && o2.project === n2.project)
            return true;
        }
      return false;
    } };
    function tr2(e3) {
      var t3 = this;
      this.type = e3, this.resultCbs = {}, this.timeoutCbs = {}, this.timerId = null, this.appCallJsCallback = null, window.sensorsdata_app_call_js || (window.sensorsdata_app_call_js = function(e4, t4) {
        if (e4 in window.sensorsdata_app_call_js.modules)
          return window.sensorsdata_app_call_js.modules[e4](t4);
      }), window.sensorsdata_app_call_js.modules = window.sensorsdata_app_call_js.modules || {}, window.sensorsdata_app_call_js.modules[this.type] = function(e4) {
        try {
          var r2 = L(e4) || e4;
          try {
            r2 = JSON.parse(r2);
          } catch (a3) {
          }
          var n2 = r2 && r2.message_id;
          if (n2 && t3.resultCbs[n2]) {
            if (e4 = r2, t3.timeoutCbs[n2] && t3.timeoutCbs[n2].isTimeout)
              return void (t3.resultCbs[n2].callbacks.length = 0);
            if (t3.resultCbs[n2])
              for (var i2 in t3.resultCbs[n2].result = e4, clearTimeout(t3.timerId), t3.timeoutCbs[n2].callbacks.length = 0, t3.resultCbs[n2].callbacks)
                t3.resultCbs[n2].callbacks[i2].call(null, e4), t3.resultCbs[n2].callbacks.splice(i2, 1);
            return;
          }
          return t3.appCallJsCallback && t3.appCallJsCallback.call(null, e4);
        } catch (o2) {
          xe("app \u56DE\u8C03 js \u5F02\u5E38", e4);
        }
      };
    }
    function rr2(e3) {
      try {
        if (t2.bridge.activeBridge && r(t2.bridge.activeBridge.handleCommand))
          return t2.bridge.activeBridge.handleCommand(e3);
      } catch (n2) {
        xe("Error: handle command exception:" + n2);
      }
      return xe("\u6570\u636E\u53D1\u5F80App\u5931\u8D25\uFF0CApp\u6CA1\u6709\u66B4\u9732bridge,type:" + e3.callType), false;
    }
    function nr2(e3) {
      this.bridge = new tr2(e3.type);
    }
    function ir(e3) {
      var t3 = null;
      try {
        var r2 = JSON.parse(window.name);
        t3 = r2[e3] ? g(r2[e3]) : null;
      } catch (n2) {
        t3 = null;
      }
      return null === t3 && (t3 = Z(location.href, e3) || null), t3;
    }
    tr2.prototype.call = function(e3, t3) {
      var r2 = this, n2 = new Date().getTime().toString(16) + String(u()).replace(".", "").slice(1, 8);
      this.resultCbs[n2] = r2.resultCbs[n2] || { result: null, callbacks: [] }, this.timeoutCbs[n2] = r2.timeoutCbs[n2] || { isTimeout: false, callbacks: [] }, (e3 = e3.data ? e3 : { data: e3 }).data.message_id = n2;
      var i2 = $({ callType: this.type }, e3);
      return t3 && (this.timerId = setTimeout(function() {
        for (var e4 in r2.timeoutCbs[n2].isTimeout = true, r2.timeoutCbs[n2].callbacks)
          r2.timeoutCbs[n2].callbacks[e4].call(null), r2.timeoutCbs[n2].callbacks.splice(e4, 1);
      }, t3)), rr2(i2), { onResult: function(e4) {
        return r2.resultCbs[n2].result ? (e4(r2.resultCbs[n2].result), this) : (!r2.timeoutCbs[n2].isTimeout && r2.resultCbs[n2].callbacks.push(e4), this);
      }, onTimeout: function(e4) {
        return r2.timeoutCbs[n2].isTimeout ? (e4(), this) : (!r2.resultCbs[n2].result && r2.timeoutCbs[n2].callbacks.push(e4), this);
      } };
    }, tr2.prototype.onAppNotify = function(e3) {
      this.appCallJsCallback = e3;
    }, tr2.prototype.notifyApp = function(e3, t3) {
      var r2 = $({ callType: this.type }, e3);
      return t3 && (r2.message_id = t3), rr2(r2);
    }, nr2.prototype = { double: function() {
    }, getAppData: function() {
    }, hasAppBridge: function() {
      return t2.bridge.bridge_info.support_two_way_call;
    }, init: function() {
    }, jsCallApp: function() {
    }, requestToApp: function(e3) {
      this.bridge.call(e3, e3.timeout.time).onResult(function(t3) {
        r(e3.callback) && e3.callback(t3);
      }).onTimeout(function() {
        r(e3.timeout.callback) && e3.timeout.callback();
      });
    } };
    var ar2 = { isSeachHasKeyword: function() {
      return "" !== Z(location.href, "sa-request-id") && ("string" == typeof sessionStorage.getItem("sensors-visual-mode") && sessionStorage.removeItem("sensors-visual-mode"), true);
    }, hasKeywordHandle: function() {
      var e3 = location.href, t3 = Z(e3, "sa-request-id") || null, r2 = Z(e3, "sa-request-type") || null, n2 = Z(e3, "sa-request-url") || null;
      if (Jt.setNotice(n2), we.isSupport())
        if (null !== n2 && sessionStorage.setItem("sensors_heatmap_url", n2), sessionStorage.setItem("sensors_heatmap_id", t3), null !== r2)
          "1" === r2 || "2" === r2 || "3" === r2 ? sessionStorage.setItem("sensors_heatmap_type", r2) : r2 = null;
        else {
          var i2 = sessionStorage.getItem("sensors_heatmap_type");
          r2 = null !== i2 ? i2 : null;
        }
      this.isReady(t3, r2);
    }, isReady: function(e3, r2, n2) {
      t2.para.heatmap_url && t2.para.heatmap ? me({ success: function() {
        setTimeout(function() {
          "undefined" != typeof sa_jssdk_heatmap_render && (sa_jssdk_heatmap_render(t2, e3, r2, n2), "object" == typeof console && "function" == typeof console.log && (t2.heatmap_version && t2.heatmap_version === t2.lib_version || $e2("heatmap.js\u4E0Esensorsdata.js\u7248\u672C\u53F7\u4E0D\u4E00\u81F4\uFF0C\u53EF\u80FD\u5B58\u5728\u98CE\u9669!")));
        }, 0);
      }, error: function() {
      }, type: "js", url: t2.para.heatmap_url }) : $e2("\u6CA1\u6709\u914D\u7F6E heatmap \u5F00\u542F\u70B9\u51FB\u56FE\uFF0C\u6216\u8005\u6CA1\u6709\u6307\u5B9A heatmap_url \u7684\u8DEF\u5F84");
    }, isStorageHasKeyword: function() {
      return we.isSupport() && "string" == typeof sessionStorage.getItem("sensors_heatmap_id");
    }, storageHasKeywordHandle: function() {
      Jt.setNotice(), ar2.isReady(sessionStorage.getItem("sensors_heatmap_id"), sessionStorage.getItem("sensors_heatmap_type"), location.href);
    }, isWindowNameHasKeyword: function() {
      try {
        var e3 = JSON.parse(window.name), t3 = h(e3["sa-heatmap-src"]) ? g(e3["sa-heatmap-src"]) : null;
        return e3["sa-request-id"] && h(e3["sa-request-id"]) && t3 === location.href;
      } catch (r2) {
        return false;
      }
    }, windowNameHasKeywordHandle: function() {
      var e3 = JSON.parse(window.name);
      function t3(t4) {
        var r3 = e3[t4];
        return h(r3) ? g(r3) : null;
      }
      var r2 = t3("sa-request-id"), n2 = t3("sa-request-type"), i2 = t3("sa-request-url"), o2 = t3("sa-request-language");
      Jt.setNotice(i2), a2.isSupport() && h(o2) && a2.set("web_sdk_heatmap_language", o2), we.isSupport() && (null !== i2 && sessionStorage.setItem("sensors_heatmap_url", i2), sessionStorage.setItem("sensors_heatmap_id", r2), null !== n2 ? "1" === n2 || "2" === n2 || "3" === n2 ? sessionStorage.setItem("sensors_heatmap_type", n2) : n2 = null : n2 = null !== sessionStorage.getItem("sensors_heatmap_type") ? sessionStorage.getItem("sensors_heatmap_type") : null), ar2.isReady(r2, n2);
    } }, or2 = { isStorageHasKeyword: function() {
      return we.isSupport() && "string" == typeof sessionStorage.getItem("sensors-visual-mode");
    }, isSearchHasKeyword: function() {
      return (true === ir("sa-visual-mode") || "true" === ir("sa-visual-mode")) && ("string" == typeof sessionStorage.getItem("sensors_heatmap_id") && sessionStorage.removeItem("sensors_heatmap_id"), true);
    }, loadVtrack: function() {
      me({ success: function() {
      }, error: function() {
      }, type: "js", url: t2.para.vtrack_url ? t2.para.vtrack_url : Rt() + "//static.sensorsdata.cn/sdk/" + t2.lib_version + "/vtrack.min.js" });
    }, messageListener: function(e3) {
      if (!e3 || !e3.data || "sa-fe" !== e3.data.source)
        return false;
      if ("v-track-mode" === e3.data.type) {
        if (e3.data.data && e3.data.data.isVtrack)
          if (we.isSupport() && sessionStorage.setItem("sensors-visual-mode", "true"), e3.data.data.userURL && location.href.match(/sa-visual-mode=true/)) {
            var t3 = e3.data.data.userURL;
            h(t3) && (je(t3, "http://") || je(t3, "https://")) && (window.location.href = encodeURI(t3), setTimeout(function() {
              window.location.reload(true);
            }, 1e3));
          } else
            or2.loadVtrack();
        window.removeEventListener("message", or2.messageListener, false);
      }
    }, removeMessageHandle: function() {
      window.removeEventListener && window.removeEventListener("message", or2.messageListener, false);
    }, verifyVtrackMode: function() {
      window.addEventListener && window.addEventListener("message", or2.messageListener, false), or2.postMessage();
    }, postMessage: function() {
      try {
        window.parent && window.parent.postMessage && window.parent.postMessage({ source: "sa-web-sdk", type: "v-is-vtrack", data: { sdkversion: Re } }, "*");
      } catch (e3) {
        xe("\u6D4F\u89C8\u5668\u7248\u672C\u8FC7\u4F4E\uFF0C\u4E0D\u652F\u6301 postMessage API");
      }
    }, notifyUser: function() {
      var e3 = function(t3) {
        if (!t3 || !t3.data || "sa-fe" !== t3.data.source)
          return false;
        "v-track-mode" === t3.data.type && (t3.data.data && t3.data.data.isVtrack && alert("\u5F53\u524D\u7248\u672C\u4E0D\u652F\u6301\uFF0C\u8BF7\u5347\u7EA7\u90E8\u7F72\u795E\u7B56\u6570\u636E\u6CBB\u7406"), window.removeEventListener("message", e3, false));
      };
      window.addEventListener && window.addEventListener("message", e3, false), or2.postMessage();
    } };
    function sr2(e3) {
      var r2 = t2.bridge.bridge_info;
      function n2() {
        var e4 = [];
        r2.touch_app_bridge || e4.push(nt.defineMode("1")), s(t2.para.app_js_bridge) || (e4.push(nt.defineMode("2")), r2.verify_success = false), s(t2.para.heatmap) && "default" == t2.para.heatmap.clickmap || e4.push(nt.defineMode("3")), "fail" === r2.verify_success && e4.push(nt.defineMode("4")), new t2.SDKJSBridge("app_alert").notifyApp({ data: e4 });
      }
      if (t2.bridge.hasVisualModeBridge())
        if (s(t2.para.heatmap) && "default" == t2.para.heatmap.clickmap)
          if (s(t2.para.app_js_bridge) && "success" === r2.verify_success)
            if (e3)
              window.sa_jssdk_app_define_mode(t2, e3);
            else {
              var i2 = location.protocol;
              me({ success: function() {
                setTimeout(function() {
                  "undefined" != typeof sa_jssdk_app_define_mode && window.sa_jssdk_app_define_mode(t2, e3);
                }, 0);
              }, error: function() {
              }, type: "js", url: (i2 = oe(["http:", "https:"], i2) > -1 ? i2 : "https:") + "//static.sensorsdata.cn/sdk/" + t2.lib_version + "/vapph5define.min.js" });
            }
          else
            n2();
        else
          n2();
    }
    function lr() {
      var e3;
      t2.readyState.setState(3), new t2.SDKJSBridge("visualized").onAppNotify(function() {
        "undefined" != typeof sa_jssdk_app_define_mode ? sr2(true) : sr2(false);
      }), sr2(false), t2.bridge.app_js_bridge_v1(), it2.initPage(), t2.para.is_track_single_page && ht.on("switch", function(n2) {
        var i2 = function(i3) {
          if (i3 = i3 || {}, n2 !== location.href) {
            it2.pageProp.referrer = ee2(n2);
            var a4 = $({ $url: ee2(), $referrer: ee2(n2) }, i3);
            r(e3) ? e3(a4) : t2.quick && t2.quick("autoTrack", a4);
          }
        };
        if ("boolean" == typeof t2.para.is_track_single_page)
          i2();
        else if ("function" == typeof t2.para.is_track_single_page) {
          var a3 = t2.para.is_track_single_page();
          s(a3) ? i2(a3) : true === a3 && i2();
        }
      }), Pt.init(), function() {
        var e4 = it2.pageProp.url_domain, t3 = {};
        "" === e4 && (e4 = "url\u89E3\u6790\u5931\u8D25");
        var r2 = tt(document.referrer, true);
        if (Ee.preset_properties.search_keyword_baidu ? et2(document.referrer) && (!Xe() || s(r2) && r2.active ? Pt._state && Pt._state.props && (Pt._state.props.$search_keyword_id && delete Pt._state.props.$search_keyword_id, Pt._state.props.$search_keyword_id_type && delete Pt._state.props.$search_keyword_id_type, Pt._state.props.$search_keyword_id_hash && delete Pt._state.props.$search_keyword_id_hash) : (t3.$search_keyword_id = Ze.id(), t3.$search_keyword_id_type = Ze.type(), t3.$search_keyword_id_hash = ae(t3.$search_keyword_id))) : Pt._state && Pt._state.props && (Pt._state.props.$search_keyword_id && delete Pt._state.props.$search_keyword_id, Pt._state.props.$search_keyword_id_type && delete Pt._state.props.$search_keyword_id_type, Pt._state.props.$search_keyword_id_hash && delete Pt._state.props.$search_keyword_id_hash), Pt.save(), D(Ee.preset_properties, function(r3, n3) {
          if (-1 === n3.indexOf("latest_"))
            return false;
          if (n3 = n3.slice(7), r3) {
            if ("wx_ad_click_id" === n3 && "not_collect" === r3)
              return false;
            if ("utm" !== n3 && "url\u89E3\u6790\u5931\u8D25" === e4)
              "wx_ad_click_id" === n3 ? (t3._latest_wx_ad_click_id = "url\u7684domain\u89E3\u6790\u5931\u8D25", t3._latest_wx_ad_hash_key = "url\u7684domain\u89E3\u6790\u5931\u8D25", t3._latest_wx_ad_callbacks = "url\u7684domain\u89E3\u6790\u5931\u8D25") : t3["$latest_" + n3] = "url\u7684domain\u89E3\u6790\u5931\u8D25";
            else if (et2(document.referrer))
              switch (n3) {
                case "traffic_source_type":
                  t3.$latest_traffic_source_type = at();
                  break;
                case "referrer":
                  t3.$latest_referrer = it2.pageProp.referrer;
                  break;
                case "search_keyword":
                  tt() ? t3.$latest_search_keyword = tt() : s(Pt._state) && s(Pt._state.props) && Pt._state.props.$latest_search_keyword && delete Pt._state.props.$latest_search_keyword;
                  break;
                case "landing_page":
                  t3.$latest_landing_page = ee2();
                  break;
                case "wx_ad_click_id":
                  var i3 = ot(location.href);
                  t3._latest_wx_ad_click_id = i3.click_id, t3._latest_wx_ad_hash_key = i3.hash_key, t3._latest_wx_ad_callbacks = i3.callbacks;
              }
          } else if ("utm" === n3 && Pt._state && Pt._state.props)
            for (var a4 in Pt._state.props)
              (0 === a4.indexOf("$latest_utm") || 0 === a4.indexOf("_latest_") && a4.indexOf("_latest_wx_ad_") < 0) && delete Pt._state.props[a4];
          else
            Pt._state && Pt._state.props && "$latest_" + n3 in Pt._state.props ? delete Pt._state.props["$latest_" + n3] : "wx_ad_click_id" == n3 && Pt._state && Pt._state.props && false === r3 && D(["_latest_wx_ad_click_id", "_latest_wx_ad_hash_key", "_latest_wx_ad_callbacks"], function(e5) {
              e5 in Pt._state.props && delete Pt._state.props[e5];
            });
        }), Ee.preset_properties.latest_utm) {
          var n2 = it2.campaignParamsStandard("$latest_", "_latest_"), i2 = n2.$utms, a3 = n2.otherUtms;
          ce2(i2) || $(t3, i2), ce2(a3) || $(t3, a3);
        }
        Zt(t3);
      }(), xt.init(), "success" === t2.bridge.bridge_info.verify_success && At.init(), t2.readyState.setState(4), t2._q && C(t2._q) && t2._q.length > 0 && D(t2._q, function(e4) {
        t2[e4[0]].apply(t2, Array.prototype.slice.call(e4[1]));
      }), s(t2.para.heatmap) && (Jt.initHeatmap(), Jt.initScrollmap());
    }
    function ur2() {
      ar2.isWindowNameHasKeyword() ? ar2.windowNameHasKeywordHandle() : ar2.isSeachHasKeyword() ? ar2.hasKeywordHandle() : window.parent !== self && or2.isSearchHasKeyword() ? or2.verifyVtrackMode() : ar2.isStorageHasKeyword() ? ar2.storageHasKeywordHandle() : window.parent !== self && or2.isStorageHasKeyword() ? or2.verifyVtrackMode() : (lr(), or2.notifyUser());
    }
    var cr = ["setItem", "deleteItem", "getAppStatus", "track", "quick", "register", "registerPage", "registerOnce", "trackSignup", "setProfile", "setOnceProfile", "appendProfile", "incrementProfile", "deleteProfile", "unsetProfile", "identify", "resetAnonymousIdentity", "login", "logout", "trackLink", "clearAllRegister", "clearPageRegister", "bind", "unbind", "loginWithKey"];
    function pr() {
      D(cr, function(e3) {
        var n2 = t2[e3];
        t2[e3] = function() {
          if (t2.readyState.state < 3)
            return C(t2._q) || (t2._q = []), $e2("calling sdk api before init is deprecated."), t2._q.push([e3, arguments]), false;
          if (!r(t2.getDisabled) || !t2.getDisabled()) {
            if (t2.readyState.getState())
              return n2.apply(t2, arguments);
            xe("\u8BF7\u5148\u521D\u59CB\u5316\u795E\u7B56JS SDK");
          }
        };
      });
    }
    var dr = { track: function(e3, t3, r2) {
    }, quick: function(e3, t3, r2, n2) {
    }, register: function(e3) {
    }, registerPage: function(e3) {
    }, registerOnce: function(e3) {
    }, clearAllRegister: function(e3) {
    }, trackSignup: function(e3, t3, r2, n2) {
    }, setProfile: function(e3, t3) {
    }, setOnceProfile: function(e3, t3) {
    }, appendProfile: function(e3, t3) {
    }, incrementProfile: function(e3, t3) {
    }, deleteProfile: function(e3) {
    }, unsetProfile: function(e3, t3) {
    }, identify: function(e3, t3) {
    }, resetAnonymousIdentity: function(e3) {
    }, login: function(e3, t3) {
    }, logout: function(e3) {
    }, trackLink: function(e3, t3, r2) {
    }, deleteItem: function(e3, t3) {
    }, setItem: function(e3, t3, r2) {
    }, getAppStatus: function(e3) {
    }, clearPageRegister: function(e3) {
    }, bind: function(e3, t3) {
    }, unbind: function(e3, t3) {
    }, registerPropertyPlugin: function(e3) {
    } };
    function fr2(e3, t3) {
      this.cancel = function() {
        e3 = true;
      }, this.getCanceled = function() {
        return e3 || false;
      }, this.stop = function() {
        t3 = true;
      }, this.getStopped = function() {
        return t3 || false;
      };
    }
    function gr(e3, t3, r2) {
      var n2 = null;
      try {
        n2 = JSON.parse(JSON.stringify(e3 || null));
      } catch (i2) {
      }
      this.getOriginalData = function() {
        return n2;
      }, this.getPosition = function() {
        return t3;
      }, this.cancellationToken = new fr2(), this.sensors = r2;
    }
    function _r(e3) {
      if (!s(e3))
        throw "error: Stage constructor requires arguments.";
      this.processDef = e3, this.registeredInterceptors = {};
    }
    _r.prototype.process = function(e3, r2) {
      if (e3 && e3 in this.processDef) {
        var n2 = this.registeredInterceptors[e3];
        if (n2 && C(n2) && n2.length > 0)
          for (var i2 = { current: 0, total: n2.length }, a3 = new gr(r2, i2, t2), o2 = 0; o2 < n2.length; o2++)
            try {
              if (i2.current = o2 + 1, r2 = n2[o2].call(null, r2, a3) || r2, a3.cancellationToken.getCanceled())
                break;
              if (a3.cancellationToken.getStopped())
                return;
            } catch (s2) {
              xe("interceptor error:" + s2);
            }
        return this.processDef[e3] && this.processDef[e3] in this.processDef && (r2 = this.process(this.processDef[e3], r2)), r2;
      }
      xe("process [" + e3 + "] is not supported");
    }, _r.prototype.registerStageImplementation = function(e3) {
      e3 && e3.init && r(e3.init) && (e3.init(this), e3.interceptor && this.registerInterceptor(e3.interceptor));
    }, _r.prototype.registerInterceptor = function(e3) {
      if (e3)
        for (var t3 in e3) {
          var n2 = e3[t3];
          if (n2 && s(n2) && r(n2.entry)) {
            ge(n2.priority) || (n2.priority = Number.MAX_VALUE), this.registeredInterceptors[t3] || (this.registeredInterceptors[t3] = []);
            var i2 = this.registeredInterceptors[t3];
            n2.entry.priority = n2.priority, i2.push(n2.entry), i2.sort(function(e4, t4) {
              return e4.priority - t4.priority;
            });
          }
        }
    };
    var hr2 = new _r({ basicProps: "extendProps", extendProps: "formatData", formatData: "finalAdjustData", finalAdjustData: null }), mr2 = new _r({ send: null }), vr = new _r({ getUtmData: null, callSchema: null }), yr = new _r({ webClickEvent: null, webStayEvent: null });
    function br2(e3) {
      e3 && e3.buildDataStage && hr2.registerStageImplementation(e3.buildDataStage), e3 && e3.businessStage && vr.registerStageImplementation(e3.businessStage), e3 && e3.sendDataStage && mr2.registerStageImplementation(e3.sendDataStage), e3 && e3.viewStage && yr.registerStageImplementation(e3.viewStage);
    }
    var wr = { buildDataStage: function(e3) {
      e3 && hr2.registerInterceptor(e3);
    }, businessStage: function(e3) {
      e3 && vr.registerInterceptor(e3);
    }, sendDataStage: function(e3) {
      e3 && mr2.registerInterceptor(e3);
    }, viewStage: function(e3) {
      e3 && yr.registerInterceptor(e3);
    } };
    function Sr(e3, t3) {
      wr[e3] && wr[e3](t3);
    }
    var kr = { stage: null, init: function(e3) {
      this.stage = e3;
    } };
    var Pr = { stage: null, init: function(e3) {
      this.stage = e3;
    }, interceptor: { send: { entry: function(e3) {
      return e3;
    } } } };
    var Cr = {};
    function Or(e3) {
      e3.kit = Cr, e3.saEvent = Lt, this.buildDataStage = Et, this.sendDataStage = Pr, this.businessStage = kr;
    }
    function jr(e3) {
      e3.heatmap = Jt, this.viewStage = Bt;
    }
    Cr.buildData = function(e3) {
      return t3 = e3, Et.stage.process("basicProps", t3);
      var t3;
    }, Cr.sendData = function(e3, r2) {
      var n2 = lt2(e3.properties);
      !function(e4) {
        Pr.stage.process("send", e4);
      }({ origin_data: e3, server_url: t2.para.server_url, data: e3, config: n2 || {}, callback: r2 }), t2.log(e3);
    }, Cr.encodeTrackData = function(e3) {
      return gt2(e3);
    }, Cr.getUtmData = function() {
      return kr.stage && kr.stage.process("getUtmData");
    };
    var Nr = { webClickEvent: { entry: function(e3, t3) {
      var r2 = t3.sensors;
      "a" === e3.tagName && r2.para.heatmap && true === r2.para.heatmap.isTrackLink ? r2.trackLink({ event: e3.event, target: e3.target }, "$WebClick", e3.props) : r2.track("$WebClick", e3.props, e3.callback);
    } }, webStayEvent: { entry: function(e3, t3) {
      t3.sensors.track("$WebStay", e3);
    } } };
    function Tr(e3) {
      r(e3.properties) ? !e3.isMatchedWithFilter || r(e3.isMatchedWithFilter) ? Sr("buildDataStage", { finalAdjustData: { priority: 100, entry: function(t3) {
        try {
          if (r(e3.isMatchedWithFilter))
            return e3.isMatchedWithFilter(t3) && e3.properties(t3);
          e3.properties(t3);
        } catch (n2) {
          xe("execute registerPropertyPlugin callback error:" + n2);
        }
      } } }) : xe("registerPropertyPlugin arguments error, isMatchedWithFilter must be function") : xe("registerPropertyPlugin arguments error, properties must be function");
    }
    var Ir = window.sensors_data_pre_config, Ar = !!Qt.isObject(Ir) && Ir.is_compliance_enabled;
    function Dr(e3) {
      e3 && (t2.events = kt, t2.bridge = er, t2.SDKJSBridge = tr2, t2.JSBridge = nr2, t2.store = Pt, t2.unlimitedDiv = Dt, t2.customProp = $t, t2.vtrackcollect = xt, t2.vapph5collect = At, t2.detectMode = ur2, t2.registerFeature = br2, t2.registerInterceptor = Sr, t2.commonWays = Ft, br2(new Or(t2)), br2(new jr(t2)), Sr("viewStage", Nr));
      var r2 = e3 ? Gt : dr;
      for (var n2 in r2)
        t2[n2] = r2[n2];
      t2.logger = Ae, t2.log = De, t2._ = Qt, t2.on = mt2, t2.ee = _t, t2.use = Wt, t2.lib_version = Re, t2.registerPropertyPlugin = Tr;
    }
    t2.init = function(e3) {
      if (_t.sdk.emit("beforeInit"), t2.readyState && t2.readyState.state && t2.readyState.state >= 2)
        return false;
      var r2, n2;
      Ar && (Dr(true), pr()), _t.initSystemEvent(), t2.setInitVar(), t2.readyState.setState(2), t2.initPara(e3), _t.sdk.emit("initPara"), _t.sdk.emit("afterInitPara"), _t.sdk.emit("initAPI"), _t.sdk.emit("afterInitAPI"), t2.detectMode(), r2 = "", n2 = " { cursor: pointer; -webkit-tap-highlight-color: rgba(0,0,0,0); }", t2.heatmap && C(t2.heatmap.otherTags) && D(t2.heatmap.otherTags, function(e4) {
        r2 += e4 + n2;
      }), de2() && X() && X() < 13 && (t2.para.heatmap && t2.para.heatmap.collect_tags && t2.para.heatmap.collect_tags.div && Se("div, [data-sensors-click]" + n2), t2.para.heatmap && t2.para.heatmap.track_attr && Se("[" + t2.para.heatmap.track_attr.join("], [") + "]" + n2), "" !== r2 && Se(r2)), _t.sdk.emit("afterInit"), _t.sdk.emit("ready");
    }, Ar ? Dr(false) : (Dr(true), pr());
    var $r = "1.27.11";
    var xr, Er, Lr, Ur = (function(e3, t3, r2) {
      if (t3 && (e3.plugin_name = t3), r2 && e3.init) {
        var n2 = e3.init;
        e3.init = function(i2, a3) {
          if (function(e4, t4, r3) {
            function n3(t5, n4) {
              e4.logger ? e4.logger.msg.apply(e4.logger, n4).module(r3 + "" || "").level(t5).log() : e4.log && e4.log.apply(e4, n4);
            }
            t4.log = function() {
              n3("log", arguments);
            }, t4.warn = function() {
              n3("warn", arguments);
            }, t4.error = function() {
              n3("error", arguments);
            };
          }(i2, e3, t3), i2.readyState && i2.readyState.state >= 3 || !i2.on)
            return o2();
          function o2() {
            n2.call(e3, i2, a3);
          }
          i2.on(r2, o2);
        };
      }
    }(xr = { init: function(e3) {
      var t3 = e3._.isString, r2 = e3._.rot13defs, n2 = e3._.dfmapping, i2 = "data:enc;";
      e3.ee.sdk.on("afterInitPara", function() {
        e3.kit.userEncrypt = function(e4) {
          return "dfm-enc-" + n2(e4);
        }, e3.kit.userDecrypt = function(e4) {
          return 0 === e4.indexOf(i2) ? (e4 = e4.substring(i2.length), e4 = r2(e4)) : 0 === e4.indexOf("dfm-enc-") && (e4 = e4.substring("dfm-enc-".length), e4 = n2(e4)), e4;
        }, e3.kit.userDecryptIfNeeded = function(r3) {
          return !t3(r3) || 0 !== r3.indexOf(i2) && 0 !== r3.indexOf("dfm-enc-") || (r3 = e3.kit.userDecrypt(r3)), r3;
        };
      });
    }, plugin_name: "UserEncryptDefault" }, Er, Lr), xr.plugin_version = $r, xr), Rr = "1.27.11";
    var Br = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Rr, e3;
    }({ sd: null, init: function(e3) {
      if (this.sd)
        return false;
      if (this.sd = e3, !this.sd || !this.sd._)
        return false;
      var t3 = this.sd._.cookie.get("sensors_amp_id"), r2 = this.sd.store._state.distinct_id;
      if (t3 && t3.length > 0) {
        var n2 = "amp-" === t3.slice(0, 4);
        if (t3 !== r2) {
          if (!n2)
            return false;
          this.sd.store._state.first_id ? (this.sd.identify(t3, true), this.sd.saEvent.send({ original_id: t3, distinct_id: r2, type: "track_signup", event: "$SignUp", properties: {} }, null), this.setAmpId(r2)) : this.sd.identify(t3, true);
        }
      } else
        this.setAmpId(r2);
      this.addListener();
    }, addListener: function() {
      var e3 = this;
      this.sd.events.on("changeDistinctId", function(t3) {
        e3.setAmpId(t3);
      }), this.sd.events.isReady();
    }, setAmpId: function(e3) {
      this.sd._.cookie.set("sensors_amp_id", e3);
    } }, "Amp", "sdkReady"), Hr = window.SensorsData_App_Visual_Bridge, Jr = Hr && Hr.sensorsdata_visualized_mode, Mr = Hr && Hr.sensorsdata_visualized_alert_info, qr = Hr && Hr.sensorsdata_hover_web_nodes;
    function Fr(e3) {
      return Jr.call(Hr) && qr && qr.call(Hr, JSON.stringify(e3));
    }
    var Kr, Vr, zr, Wr, Xr, Zr, Yr = { isVerify: function() {
      return Jr && (true === Jr || Jr.call(Hr));
    }, commands: { app_alert: function(e3) {
      return Mr && Mr.call(Hr, JSON.stringify(e3));
    }, visualized_track: Fr, page_info: Fr, sensorsdata_get_app_visual_config: function(e3, t3) {
      return t3 && "function" == typeof t3[e3.callType] && t3[e3.callType]();
    } } }, Gr = "1.27.11";
    var Qr = { init: function(e3) {
      Xr = (Wr = e3) && Wr._, Zr = Wr && Wr.log || console && console.log || function() {
      }, function() {
        if (Kr = window.SensorsData_APP_New_H5_Bridge, Vr = Kr && Kr.sensorsdata_track, zr = Vr && Kr.sensorsdata_get_server_url && Kr.sensorsdata_get_server_url(), Zr("---test---fail---", !Wr, Wr.bridge.activeBridge, !zr), !Wr || Wr.bridge.activeBridge || !zr)
          return;
        Wr.bridge.activeBridge = Qr, Wr.para.app_js_bridge && !Wr.para.app_js_bridge.is_mui && (Wr.bridge.is_verify_success = zr && Wr.bridge.validateAppUrl(zr), Zr("---test---bridge-verify-", Wr.bridge.is_verify_success));
        if (Wr.bridge.bridge_info = { touch_app_bridge: true, platform: "android", verify_success: Wr.bridge.is_verify_success ? "success" : "fail", support_two_way_call: !!Kr.sensorsdata_js_call_app }, !Wr.para.app_js_bridge)
          return void Zr("---test---app_js_bridge is not configured, data will not be sent by android bridge.");
        Wr.registerInterceptor("sendDataStage", { send: { priority: 60, entry: en2 } });
      }();
    }, handleCommand: function(e3) {
      var t3 = e3.callType;
      if (t3 in Yr.commands)
        return Yr.commands[t3](e3, Kr);
      Kr && Xr.isFunction(Kr.sensorsdata_js_call_app) && Kr.sensorsdata_js_call_app(JSON.stringify(e3));
    } };
    function en2(e3, t3) {
      if (Zr("---test---datasend-", Wr.bridge.is_verify_success), Wr.para.app_js_bridge.is_mui || "item_set" === e3.data.type || "item_delete" === e3.data.type)
        return e3;
      var r2 = e3.callback;
      return Wr.bridge.is_verify_success ? (Zr("---test---bridge-verify-success---", e3.data), Vr && Vr.call(Kr, JSON.stringify(Xr.extend({ server_url: Wr.para.server_url }, e3.data))), Xr.isFunction(r2) && r2(), t3.cancellationToken.cancel(), e3) : (Zr("---test---bridge-verify-fail-----", Wr.bridge.is_verify_success), Wr.para.app_js_bridge.is_send ? (Wr.debug.apph5({ data: e3.data, step: "4.2", output: "all" }), e3) : (Xr.isFunction(r2) && r2(), t3.cancellationToken.cancel(), e3));
    }
    var tn2 = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Gr, e3;
    }(Qr, "AndroidBridge", "sdkAfterInitPara"), rn = window.SensorsData_App_Visual_Bridge, nn2 = rn && rn.sensorsdata_visualized_mode, an2 = rn && rn.sensorsdata_visualized_alert_info, on2 = rn && rn.sensorsdata_hover_web_nodes;
    function sn2(e3) {
      return nn2.call(rn) && on2 && on2.call(rn, JSON.stringify(e3));
    }
    var ln2, un, cn, pn, dn, fn2, gn, _n = { isVerify: function() {
      return nn2 && (true === nn2 || nn2.call(rn));
    }, commands: { app_alert: function(e3) {
      return an2 && an2.call(rn, JSON.stringify(e3));
    }, visualized_track: sn2, page_info: sn2, sensorsdata_get_app_visual_config: function(e3, t3) {
      return t3 && "function" == typeof t3[e3.callType] && t3[e3.callType]();
    } } }, hn = "1.27.11";
    var mn2 = { init: function(e3) {
      fn2 = (dn = e3) && dn._, gn = dn && dn.log || console && console.log || function() {
      }, function() {
        if (gn("ObsoleteBridge---test---init---"), ln2 = window.SensorsData_APP_JS_Bridge, un = ln2 && ln2.sensorsdata_track, cn = ln2 && ln2.sensorsdata_verify, pn = ln2 && ln2.sensorsdata_visual_verify, gn("ObsoleteBridge-", dn.bridge.activeBridge, cn, un, pn), !dn || dn.bridge.activeBridge || !(cn || un || pn))
          return;
        dn.bridge.activeBridge = mn2;
        var e4 = cn || un;
        pn && (e4 = !!pn.call(ln2, JSON.stringify({ server_url: dn.para.server_url })), gn("ObsoleteBridge---called-return", e4));
        if (dn.bridge.bridge_info = { touch_app_bridge: true, platform: "android", verify_success: e4 ? "success" : "fail" }, !dn.para.app_js_bridge)
          return void gn("app_js_bridge is not configured, data will not be sent by android obsolete bridge.");
        dn.registerInterceptor("sendDataStage", { send: { priority: 80, entry: vn } }), gn("Android obsolete bridge inits succeed.");
      }();
    }, handleCommand: function(e3) {
      gn("ObsoleteBridge---handleCommadn");
      var t3 = e3.callType;
      if (t3 in _n.commands)
        return gn("ObsoleteBridge---", t3, _n.commands), _n.commands[t3](e3, ln2);
      if (ln2 && fn2.isFunction(ln2.sensorsdata_js_call_app))
        return gn("ObsoleteBridge---handleCommadn-abridge"), ln2.sensorsdata_js_call_app(JSON.stringify(e3));
    } };
    function vn(e3, t3) {
      if (gn("ObsoleteBridge---senddata"), dn.para.app_js_bridge.is_mui || "item_set" === e3.data.type || "item_delete" === e3.data.type)
        return e3;
      var r2 = e3.callback;
      if (cn) {
        var n2 = cn && cn.call(ln2, JSON.stringify(fn2.extend({ server_url: dn.para.server_url }, e3.data)));
        return gn("ObsoleteBridge---anVerify-success", n2), n2 ? (fn2.isFunction(r2) && r2(), t3.cancellationToken.cancel(), e3) : dn.para.app_js_bridge.is_send ? (dn.debug.apph5({ data: e3.data, step: "3.1", output: "all" }), e3) : (fn2.isFunction(r2) && r2(), t3.cancellationToken.cancel(), e3);
      }
      return gn("ObsoleteBridge---is-send-old-way", dn.para.app_js_bridge.is_send), un && un.call(ln2, JSON.stringify(fn2.extend({ server_url: dn.para.server_url }, e3.data))), fn2.isFunction(r2) && r2(), t3.cancellationToken.cancel(), e3;
    }
    var yn, bn2, wn, Sn, kn2 = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = hn, e3;
    }(mn2, "AndroidObsoleteBridge", "sdkAfterInitPara"), Pn = "1.27.11";
    var Cn, On = { event_list: [], latest_event_initial_time: null, max_save_time: 2592e6, init: function(e3, t3) {
      if (bn2 || !e3)
        return false;
      Sn = (t3 = t3 || {}).cookie_name || "sensorsdata2015jssdkchannel", bn2 = e3;
      var r2 = this;
      !function() {
        if (yn = bn2._, wn = bn2.store, !yn.localStorage.isSupport())
          return false;
        r2.eventList.init(), r2.addLatestChannelUrl(), r2.addIsChannelCallbackEvent();
      }();
    }, addIsChannelCallbackEvent: function() {
      bn2.registerPage({ $is_channel_callback_event: function(e3) {
        if (yn.isObject(e3) && e3.event && "$WebClick" !== e3.event && "$pageview" !== e3.event && "$WebStay" !== e3.event && "$SignUp" !== e3.event)
          return !On.eventList.hasEvent(e3.event) && (On.eventList.add(e3.event), true);
      } });
    }, addLatestChannelUrl: function() {
      var e3 = this.getUrlDomain(), t3 = this.cookie.getChannel();
      if ("url\u89E3\u6790\u5931\u8D25" === e3)
        this.registerAndSave({ _sa_channel_landing_url: "", _sa_channel_landing_url_error: "url\u7684domain\u89E3\u6790\u5931\u8D25" });
      else if (yn.isReferralTraffic(document.referrer)) {
        var r2 = yn.getQueryParam(location.href, "sat_cf");
        yn.isString(r2) && r2.length > 0 ? (this.registerAndSave({ _sa_channel_landing_url: location.href }), On.channelLinkHandler()) : this.registerAndSave({ _sa_channel_landing_url: "" });
      } else
        t3 ? bn2.registerPage(t3) : bn2.registerPage({ _sa_channel_landing_url: "", _sa_channel_landing_url_error: "\u53D6\u503C\u5F02\u5E38" });
    }, registerAndSave: function(e3) {
      bn2.registerPage(e3), this.cookie.saveChannel(e3);
    }, cookie: { getChannel: function() {
      var e3 = bn2.kit.userDecryptIfNeeded(yn.cookie.get(Sn));
      return e3 = yn.safeJSONParse(e3), !(!yn.isObject(e3) || !e3.prop) && e3.prop;
    }, saveChannel: function(e3) {
      var t3 = { prop: e3 }, r2 = JSON.stringify(t3);
      bn2.para.encrypt_cookie && (r2 = bn2.kit.userEncrypt(r2)), yn.cookie.set(Sn, r2);
    } }, channelLinkHandler: function() {
      this.eventList.reset(), bn2.track("$ChannelLinkReaching");
    }, getUrlDomain: function() {
      var e3 = yn.info.pageProp.url_domain;
      return "" === e3 && (e3 = "url\u89E3\u6790\u5931\u8D25"), e3;
    }, eventList: { init: function() {
      var e3 = this.get(), t3 = new Date().getTime();
      if (e3 && yn.isNumber(e3.latest_event_initial_time) && yn.isArray(e3.eventList)) {
        var r2 = t3 - e3.latest_event_initial_time;
        r2 > 0 && r2 < On.max_save_time ? (On.event_list = e3.eventList, On.latest_event_initial_time = e3.latest_event_initial_time) : this.reset();
      } else
        this.reset();
    }, get: function() {
      var e3 = {};
      try {
        e3 = wn.readObjectVal("sawebjssdkchannel");
      } catch (t3) {
        bn2.log(t3);
      }
      return e3;
    }, add: function(e3) {
      On.event_list.push(e3), this.save();
    }, save: function() {
      var e3 = { latest_event_initial_time: On.latest_event_initial_time, eventList: On.event_list };
      wn.saveObjectVal("sawebjssdkchannel", e3);
    }, reset: function() {
      On.event_list = [], On.latest_event_initial_time = new Date().getTime(), this.save();
    }, hasEvent: function(e3) {
      var t3 = false;
      return yn.each(On.event_list, function(r2) {
        r2 === e3 && (t3 = true);
      }), t3;
    } } }, jn = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Pn, e3;
    }(On, "SensorsChannel", "sdkAfterInitAPI"), Nn = "1.27.11";
    /micromessenger\/([\d.]+)/i.test(navigator.userAgent || "");
    var Tn = function() {
      var e3 = {};
      return "undefined" != typeof document.hidden ? (e3.hidden = "hidden", e3.visibilityChange = "visibilitychange") : "undefined" != typeof document.msHidden ? (e3.hidden = "msHidden", e3.visibilityChange = "msvisibilitychange") : "undefined" != typeof document.webkitHidden && (e3.hidden = "webkitHidden", e3.visibilityChange = "webkitvisibilitychange"), e3;
    };
    function In() {
      return void 0 !== Cn && document[Cn];
    }
    Cn = Tn().hidden;
    var An, Dn, $n, xn, En, Ln = { android: /Android/i, iOS: /iPhone|iPad|iPod/i, harmony: /OpenHarmony/i }, Un = function() {
      for (var e3 in Ln)
        if (navigator.userAgent.match(Ln[e3]))
          return e3;
      return "";
    }(), Rn = function(e3) {
      return null != e3 && "[object Object]" == Object.prototype.toString.call(e3);
    }, Bn = function(e3, t3, r2) {
      e3.log("\u5C1D\u8BD5\u5524\u8D77 android app");
      var n2 = t3;
      e3.log("\u5524\u8D77APP\u7684\u5730\u5740\uFF1A" + n2), window.location = n2, e3.timer = setTimeout(function() {
        var t4 = In();
        if (e3.log("hide:" + Cn + ":" + document[Cn]), t4)
          return e3.log("The page is hidden, stop navigating to download page"), false;
        e3.log("App\u53EF\u80FD\u672A\u5B89\u88C5\uFF0C\u8DF3\u8F6C\u5230\u4E0B\u8F7D\u5730\u5740"), window.location = r2;
      }, e3.timeout);
    }, Hn = { plugin_name: ["deeplink", "Deeplink"], key: null, timer: null, sd: null, data: null, timeout: 2500, apiURL: "{origin}/sdk/deeplink/param?key={key}&system_type=JS&project={project}", init: function(e3) {
      if (this.sd)
        return this.logger("deeplink\u5DF2\u7ECF\u521D\u59CB\u5316"), false;
      arguments[0] ? Rn(arguments[0]) && "number" == typeof arguments[0].timeout ? this.sd = window.sensorsDataAnalytic201505 : this.sd = e3 : this.sd = window.sensorsDataAnalytic201505;
      var t3 = {};
      if (arguments.length > 0 && (1 === arguments.length && Rn(arguments[0]) ? t3 = arguments[0] : arguments.length >= 2 && Rn(arguments[1]) && (t3 = arguments[1])), !Ln.hasOwnProperty(Un))
        return this.logger("\u4E0D\u652F\u6301\u5F53\u524D\u7CFB\u7EDF\uFF0C\u76EE\u524D\u53EA\u652F\u6301Android\u548CiOS"), false;
      if (Rn(t3) && this.sd._.isNumber(t3.timeout) && t3.timeout >= 2500 && (this.timeout = t3.timeout), !this.sd.para.server_url)
        return this.logger("\u795E\u7B56JS SDK\u914D\u7F6E\u9879server_url\u672A\u6B63\u786E\u914D\u7F6E"), false;
      var r2 = function(e4) {
        var t4 = e4._.URL(e4.para.server_url);
        return { origin: t4.origin, project: t4.searchParams.get("project") || "default" };
      }(this.sd);
      this.apiURL = this.apiURL.replace("{origin}", r2.origin).replace("{project}", r2.project);
      var n2 = this.sd._.getQueryParam(window.location.href, "deeplink");
      if (!n2)
        return this.logger("\u5F53\u524D\u9875\u9762\u7F3A\u5C11deeplink\u53C2\u6570"), false;
      n2 = window.decodeURIComponent(n2);
      var i2 = n2.match(/\/sd\/(\w+)\/(\w+)$/);
      if (!i2)
        return this.logger("\u5F53\u524D\u9875\u9762\u7684deeplink\u53C2\u6570\u65E0\u6548"), false;
      this.key = i2[2], this.apiURL = this.apiURL.replace("{key}", window.encodeURIComponent(i2[2])), this.sd._.ajax({ url: this.apiURL, type: "GET", cors: true, credentials: false, success: function(e4) {
        if (e4.errorMsg)
          return Hn.logger("API\u62A5\u9519\uFF1A" + e4.errorMsg), false;
        Hn.data = e4, Hn.logger("API\u67E5\u8BE2\u6210\u529F\uFF0C\u6570\u636E\uFF1A" + JSON.stringify(e4, null, "  ")), this.data.app_key && (this.data.android_info && this.data.android_info.url_schemes && (this.data.android_info.url_schemes += "://sensorsdata/sd/" + this.data.app_key + "/" + this.key), this.data.ios_info && this.data.ios_info.url_schemes && (this.data.ios_info.url_schemes += "://sensorsdata/sd/" + this.data.app_key + "/" + this.key), this.data.harmony_info && this.data.harmony_info.url_schemes && (this.data.harmony_info.url_schemes += "://sensorsdata/sd/" + this.data.app_key + "/" + this.key));
      }.bind(this), error: function() {
        Hn.logger("API\u67E5\u8BE2\u51FA\u9519");
      } }), this.addListeners();
    }, openDeepLink: function() {
      if (this.logger("openDeeplink()"), !this.data)
        return this.logger("\u6CA1\u6709Deep link\u6570\u636E!"), false;
      if ("iOS" === Un) {
        this.logger("\u5F53\u524D\u7CFB\u7EDF\u662FiOS");
        var e3 = this.sd && this.sd._ && this.sd._.getIOSVersion() >= 9 && this.data.ios_info.ios_wake_url ? this.data.ios_info.ios_wake_url : this.data.ios_info.url_schemes;
        this.logger("\u5524\u8D77APP\u7684\u5730\u5740\uFF1A" + e3), r2 = this, n2 = e3, i2 = this.data.ios_info.download_url, r2.log("\u5C1D\u8BD5\u5524\u8D77 iOS app:" + n2), window.location.href = n2, r2.timer = setTimeout(function() {
          if (In())
            return r2.log("The page is hidden, stop navigating to download page"), false;
          r2.log("App\u53EF\u80FD\u672A\u5B89\u88C5\uFF0C\u8DF3\u8F6C\u5230\u4E0B\u8F7D\u5730\u5740"), window.location.href = i2;
        }, r2.timeout), r2.log("new timer:" + r2.timer);
      } else if ("android" === Un)
        this.logger("\u5F53\u524D\u7CFB\u7EDF\u662F android"), Bn(this, this.data.android_info.url_schemes, this.data.android_info.download_url);
      else if ("harmony" === Un) {
        var t3 = this.data.harmony_info.app_linking_url || this.data.harmony_info.url_schemes;
        this.logger("\u5F53\u524D\u7CFB\u7EDF\u662F HarmonyOS"), Bn(this, t3, this.data.harmony_info.download_url);
      }
      var r2, n2, i2;
    }, logger: function(e3) {
      this.sd && this.sd.log(e3);
    }, addListeners: function() {
      var e3 = Tn().visibilityChange, t3 = this;
      e3 && document.addEventListener(e3, function() {
        clearTimeout(t3.timer), t3.logger("visibilitychange, clear timeout:" + t3.timer);
      }, false), window.addEventListener("pagehide", function() {
        t3.logger("page hide, clear timeout:" + t3.timer), clearTimeout(t3.timer);
      }, false);
    } }, Jn = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Nn, e3;
    }(Hn, null, "sdkReady"), Mn = "1.27.11";
    var qn = { init: function(e3) {
      xn = ($n = e3) && $n._, En = $n && $n.log || console && console.log || function() {
      }, function() {
        if (An = window.SensorsData_iOS_JS_Bridge && window.SensorsData_iOS_JS_Bridge.sensorsdata_app_server_url, Dn = function() {
          return window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.sensorsdataNativeTracker;
        }, !$n || $n.bridge.activeBridge || !Dn() || !Dn().postMessage)
          return;
        $n.bridge.activeBridge = qn, $n.para.app_js_bridge && !$n.para.app_js_bridge.is_mui && ($n.bridge.is_verify_success = An && $n.bridge.validateAppUrl(An));
        if ($n.bridge.bridge_info = { touch_app_bridge: true, platform: "ios", verify_success: $n.bridge.is_verify_success ? "success" : "fail", support_two_way_call: true }, !$n.para.app_js_bridge)
          return void En("app_js_bridge is not configured, data will not be sent by iOS bridge.");
        $n.registerInterceptor("sendDataStage", { send: { priority: 70, entry: Fn } }), En("IOS bridge inits succeed.");
      }();
    }, handleCommand: function(e3) {
      var t3 = e3.callType;
      if (("page_info" === t3 || "visualized_track" === t3) && !$n.bridge.hasVisualModeBridge())
        return null;
      if ("sensorsdata_get_app_visual_config" === t3)
        return xn.isObject(window.SensorsData_APP_New_H5_Bridge) && window.SensorsData_APP_New_H5_Bridge[t3];
      return Dn() && Dn().postMessage(JSON.stringify(e3));
    } };
    function Fn(e3, t3) {
      if ($n.para.app_js_bridge.is_mui || "item_set" === e3.data.type || "item_delete" === e3.data.type)
        return e3;
      var r2 = e3.callback;
      return $n.bridge.is_verify_success ? (Dn() && Dn().postMessage(JSON.stringify({ callType: "app_h5_track", data: xn.extend({ server_url: $n.para.server_url }, e3.data) })), xn.isFunction(r2) && r2(), t3.cancellationToken.cancel(), e3) : $n.para.app_js_bridge.is_send ? ($n.debug.apph5({ data: e3.data, step: "4.1", output: "all" }), e3) : (xn.isFunction(r2) && r2(), t3.cancellationToken.cancel(), e3);
    }
    var Kn, Vn, zn, Wn = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Mn, e3;
    }(qn, "IOSBridge", "sdkAfterInitPara"), Xn = "1.27.11";
    var Zn = { init: function(e3) {
      Vn = (Kn = e3) && Kn._, zn = Kn && Kn.log || console && console.log || function() {
      }, function() {
        if (!Kn || Kn.bridge.activeBridge || !/sensors-verify/.test(navigator.userAgent) && !/sa-sdk-ios/.test(navigator.userAgent) || window.MSStream)
          return;
        if (Kn.bridge.activeBridge = Zn, Kn.bridge.bridge_info = { touch_app_bridge: true, platform: "ios", verify_success: Yn() ? "success" : "fail" }, !Kn.para.app_js_bridge)
          return void zn("app_js_bridge is not configured, data will not be sent by iOS obsolete bridge.");
        Kn.registerInterceptor("sendDataStage", { send: { priority: 90, entry: Gn } }), zn("IOS obsolete bridge inits succeed.");
      }();
    } };
    function Yn() {
      if (/sensors-verify/.test(navigator.userAgent)) {
        var e3 = navigator.userAgent.match(/sensors-verify\/([^\s]+)/);
        if (e3 && e3[0] && "string" == typeof e3[1] && 2 === e3[1].split("?").length) {
          e3 = e3[1].split("?");
          var t3 = null, r2 = null;
          try {
            t3 = Vn.URL(Kn.para.server_url).hostname, r2 = Vn.URL(Kn.para.server_url).searchParams.get("project") || "default";
          } catch (n2) {
            Kn.log(n2);
          }
          return !(!t3 || t3 !== e3[0] || !r2 || r2 !== e3[1]);
        }
        return false;
      }
      return !!/sa-sdk-ios/.test(navigator.userAgent);
    }
    function Gn(e3, t3) {
      if (Kn.para.app_js_bridge.is_mui || "item_set" === e3.data.type || "item_delete" === e3.data.type)
        return e3;
      var r2, n2, i2 = e3.callback;
      if (Kn.bridge.bridge_info.verify_success) {
        var a3 = document.createElement("iframe"), o2 = (r2 = e3.data, n2 = (n2 = JSON.stringify(Vn.extend({ server_url: Kn.para.server_url }, r2))).replace(/\r\n/g, ""), "sensorsanalytics://trackEvent?event=" + (n2 = encodeURIComponent(n2)));
        return a3.setAttribute("src", o2), document.documentElement.appendChild(a3), a3.parentNode.removeChild(a3), a3 = null, Vn.isFunction(i2) && i2(), t3.cancellationToken.cancel(), true;
      }
      return Kn.para.app_js_bridge.is_send ? (Kn.debug.apph5({ data: e3.data, step: "3.2", output: "all" }), e3) : (Vn.isFunction(i2) && i2(), t3.cancellationToken.cancel(), e3);
    }
    var Qn = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Xn, e3;
    }(Zn, "IOSObsoleteBridge", "sdkAfterInitPara"), ei = "1.27.11";
    var ti2 = 432e3;
    function ri() {
      this.sd = null, this.start_time = +new Date(), this.page_show_status = true, this.page_hidden_status = false, this._ = {}, this.timer = null, this.current_page_url = document.referrer, this.url = location.href, this.title = document.title || "", this.option = {}, this.heartbeat_interval_time = 5e3, this.heartbeat_interval_timer = null, this.page_id = null, this.storage_name = "sawebjssdkpageleave", this.max_duration = ti2;
    }
    ri.prototype.init = function(e3, t3) {
      if (e3) {
        if (this.sd = e3, this._ = this.sd._, t3) {
          this.option = t3;
          var r2 = t3.heartbeat_interval_time;
          r2 && (this._.isNumber(r2) || this._.isNumber(1 * r2)) && 1 * r2 > 0 && (this.heartbeat_interval_time = 1e3 * r2);
          var n2 = t3.max_duration;
          n2 && (this._.isNumber(n2) || this._.isNumber(1 * n2)) && 1 * n2 > 0 && (this.max_duration = n2);
        }
        this.page_id = Number(String(this._.getRandom()).slice(2, 5) + String(this._.getRandom()).slice(2, 4) + String(new Date().getTime()).slice(-4)), this.addEventListener(), true === document.hidden ? this.page_show_status = false : this.addHeartBeatInterval(), this.log("PageLeave\u521D\u59CB\u5316\u5B8C\u6BD5");
      } else
        this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    }, ri.prototype.log = function(e3) {
      this.sd && this.sd.log(e3);
    }, ri.prototype.refreshPageEndTimer = function() {
      var e3 = this;
      this.timer && (clearTimeout(this.timer), this.timer = null), this.timer = setTimeout(function() {
        e3.page_hidden_status = false;
      }, 5e3);
    }, ri.prototype.hiddenStatusHandler = function() {
      clearTimeout(this.timer), this.timer = null, this.page_hidden_status = false;
    }, ri.prototype.pageStartHandler = function() {
      this.start_time = +new Date(), true == !document.hidden ? this.page_show_status = true : this.page_show_status = false, this.url = location.href, this.title = document.title;
    }, ri.prototype.pageEndHandler = function() {
      if (true !== this.page_hidden_status) {
        var e3 = this.getPageLeaveProperties();
        false === this.page_show_status && delete e3.event_duration, this.page_show_status = false, this.page_hidden_status = true, this.isCollectUrl(this.url) && this.sd.track("$WebPageLeave", e3), this.refreshPageEndTimer(), this.delHeartBeatData();
      }
    }, ri.prototype.addEventListener = function() {
      this.addPageStartListener(), this.addPageSwitchListener(), this.addSinglePageListener(), this.addPageEndListener();
    }, ri.prototype.addPageStartListener = function() {
      var e3 = this;
      "onpageshow" in window && this._.addEvent(window, "pageshow", function() {
        e3.pageStartHandler(), e3.hiddenStatusHandler();
      });
    }, ri.prototype.isCollectUrl = function(e3) {
      return "function" != typeof this.option.isCollectUrl || ("string" != typeof e3 || "" === e3 || this.option.isCollectUrl(e3));
    }, ri.prototype.addSinglePageListener = function() {
      var e3 = this;
      this.sd.ee && this.sd.ee.spa.prepend("switch", function(t3) {
        t3 !== location.href && (e3.url = t3, e3.pageEndHandler(), e3.stopHeartBeatInterval(), e3.current_page_url = e3.url, e3.pageStartHandler(), e3.hiddenStatusHandler(), e3.addHeartBeatInterval());
      });
    }, ri.prototype.addPageEndListener = function() {
      var e3 = this;
      this._.each(["pagehide", "beforeunload", "unload"], function(t3) {
        "on" + t3 in window && e3._.addEvent(window, t3, function() {
          e3.pageEndHandler(), e3.stopHeartBeatInterval();
        });
      });
    }, ri.prototype.addPageSwitchListener = function() {
      var e3 = this;
      this._.listenPageState({ visible: function() {
        e3.pageStartHandler(), e3.hiddenStatusHandler(), e3.addHeartBeatInterval();
      }, hidden: function() {
        e3.url = location.href, e3.title = document.title, e3.pageEndHandler(), e3.stopHeartBeatInterval();
      } });
    }, ri.prototype.addHeartBeatInterval = function() {
      this._.localStorage.isSupport() && this.startHeartBeatInterval();
    }, ri.prototype.startHeartBeatInterval = function() {
      var e3 = this;
      this.heartbeat_interval_timer && this.stopHeartBeatInterval();
      var t3 = true;
      this.isCollectUrl(this.url) || (t3 = false), this.heartbeat_interval_timer = setInterval(function() {
        t3 && e3.saveHeartBeatData();
      }, this.heartbeat_interval_time), t3 && this.saveHeartBeatData("is_first_heartbeat"), this.reissueHeartBeatData();
    }, ri.prototype.stopHeartBeatInterval = function() {
      clearInterval(this.heartbeat_interval_timer), this.heartbeat_interval_timer = null;
    }, ri.prototype.saveHeartBeatData = function(e3) {
      var t3 = this.getPageLeaveProperties(), r2 = new Date();
      t3.$time = r2, "is_first_heartbeat" === e3 && (t3.event_duration = 3.14);
      var n2 = this.sd.kit.buildData({ type: "track", event: "$WebPageLeave", properties: t3 });
      n2.heartbeat_interval_time = this.heartbeat_interval_time, this.sd.store.saveObjectVal(this.storage_name + "-" + this.page_id, n2);
    }, ri.prototype.delHeartBeatData = function(e3) {
      this._.localStorage.isSupport() && this._.localStorage.remove(e3 || this.storage_name + "-" + this.page_id);
    }, ri.prototype.reissueHeartBeatData = function() {
      for (var e3 = window.localStorage.length - 1; e3 >= 0; e3--) {
        var t3 = window.localStorage.key(e3);
        if (t3 && t3 !== this.storage_name + "-" + this.page_id && 0 === t3.indexOf(this.storage_name + "-")) {
          var r2 = this.sd.store.readObjectVal(t3);
          this._.isObject(r2) && 1 * new Date() - r2.time > r2.heartbeat_interval_time + 5e3 && (delete r2.heartbeat_interval_time, r2._flush_time = new Date().getTime(), this.sd.kit.sendData(r2), this.delHeartBeatData(t3));
        }
      }
    }, ri.prototype.getPageLeaveProperties = function() {
      var e3 = (+new Date() - this.start_time) / 1e3;
      (isNaN(e3) || e3 < 0 || e3 > this.max_duration) && (e3 = 0), e3 = Number(e3.toFixed(3));
      var t3 = this._.getReferrer(this.current_page_url), r2 = document.documentElement && document.documentElement.scrollTop || window.pageYOffset || document.body && document.body.scrollTop || 0;
      r2 = Math.round(r2) || 0;
      var n2 = { $title: this.title, $url: this._.getURL(this.url), $url_path: this._.getURLPath(this._.URL(this.url).pathname), $referrer_host: t3 ? this._.getHostname(t3) : "", $referrer: t3, $viewport_position: r2 };
      return 0 !== e3 && (n2.event_duration = e3), n2 = this._.extend(n2, this.option.custom_props);
    };
    var ni = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = ei, e3;
    }(new ri(), "PageLeave", "sdkReady"), ii2 = "1.27.11";
    var ai = false, oi = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = ii2, e3;
    }({ init: function(e3, t3) {
      function r2() {
        var n2 = 0, i2 = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance, a3 = { $url: e3._.getURL(), $title: document.title, $url_path: e3._.getURLPath(), $referrer: e3._.getReferrer(null, true) };
        if (i2 ? (n2 = function(t4) {
          var r3 = 0;
          return e3._.isFunction(t4.getEntriesByType) && (r3 = ((t4.getEntriesByType("navigation") || [{}])[0] || {}).domContentLoadedEventEnd || 0), r3;
        }(i2) || function(t4) {
          var r3 = 0;
          if (t4.timing) {
            var n3 = t4.timing;
            0 !== n3.fetchStart && e3._.isNumber(n3.fetchStart) && 0 !== n3.domContentLoadedEventEnd && e3._.isNumber(n3.domContentLoadedEventEnd) ? r3 = n3.domContentLoadedEventEnd - n3.fetchStart : e3.log("performance \u6570\u636E\u83B7\u53D6\u5F02\u5E38");
          }
          return r3;
        }(i2), function(t4, r3) {
          if (t4.getEntries && "function" == typeof t4.getEntries) {
            for (var n3 = t4.getEntries(), i3 = null, a4 = 0; a4 < n3.length; a4++)
              "transferSize" in n3[a4] && (i3 += n3[a4].transferSize);
            e3._.isNumber(i3) && i3 >= 0 && i3 < 10737418240 && (r3.$page_resource_size = Number((i3 / 1024).toFixed(3)));
          }
        }(i2, a3)) : e3.log("\u6D4F\u89C8\u5668\u672A\u652F\u6301 performance API."), n2 > 0) {
          var o2 = e3._.isObject(t3) && t3.max_duration || 1800;
          n2 = Number((n2 / 1e3).toFixed(3)), (!e3._.isNumber(o2) || o2 <= 0 || n2 <= o2) && (a3.event_duration = n2);
        }
        ai || (e3.track("$WebPageLoad", a3), ai = true), window.removeEventListener ? window.removeEventListener("load", r2) : window.detachEvent && window.detachEvent("onload", r2);
      }
      "complete" == document.readyState ? r2() : window.addEventListener ? window.addEventListener("load", r2) : window.attachEvent && window.attachEvent("onload", r2);
    } }, "PageLoad", "sdkReady");
    function si2() {
      this.sd = null, this.log = window.console && window.console.log || function() {
      }, this.customRegister = [];
    }
    si2.prototype.init = function(e3) {
      if (e3) {
        this.sd = e3, this._ = e3._, this.log = e3.log;
        var t3 = this;
        e3.registerInterceptor("buildDataStage", { extendProps: { priority: 0, entry: function(e4) {
          return function(e5, t4) {
            if ("track" !== e5.type)
              return e5;
            var r2 = t4.sd, n2 = r2._, i2 = r2.saEvent.check, a3 = n2.extend2Lev({ properties: {} }, e5), o2 = t4.customRegister, s2 = a3.properties, l2 = a3.event, u2 = {};
            return n2.each(o2, function(e6) {
              if (n2.isObject(e6))
                n2.indexOf(e6.events, l2) > -1 && i2({ properties: e6.properties }) && (u2 = n2.extend(u2, e6.properties));
              else if (n2.isFunction(e6)) {
                var t5 = e6({ event: l2, properties: s2, data: a3 });
                n2.isObject(t5) && !n2.isEmptyObject(t5) && i2({ properties: t5 }) && (u2 = n2.extend(u2, t5));
              }
            }), e5.properties = n2.extend(s2, u2), e5;
          }(e4, t3);
        } } });
      } else
        this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    }, si2.prototype.register = function(e3) {
      this.sd ? this._.isObject(e3) && this._.isArray(e3.events) && e3.events.length > 0 && this._.isObject(e3.properties) && !this._.isEmptyObject(e3.properties) ? this.customRegister.push(e3) : this.log("RegisterProperties: register \u53C2\u6570\u9519\u8BEF") : this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    }, si2.prototype.hookRegister = function(e3) {
      this.sd ? this._.isFunction(e3) ? this.customRegister.push(e3) : this.log("RegisterProperties: hookRegister \u53C2\u6570\u9519\u8BEF") : this.log("\u795E\u7B56JS SDK\u672A\u6210\u529F\u5F15\u5165");
    };
    var li = "1.27.11";
    si2.prototype.plugin_name = "RegisterProperties";
    var ui = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = li, e3;
    }(new si2()), ci = "1.27.11";
    var pi, di, fi2 = window.console && window.console.log || function() {
    };
    function gi(e3) {
      try {
        if ("$pageview" !== e3.event && (!e3.type || "profile" !== e3.type.slice(0, 7))) {
          var t3 = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0, r2 = document.documentElement.scrollHeight || 0, n2 = { $page_height: Math.max(t3, r2) || 0 };
          e3.properties = pi._.extend(e3.properties || {}, n2);
        }
      } catch (i2) {
        fi2("\u9875\u9762\u9AD8\u5EA6\u83B7\u53D6\u5F02\u5E38\u3002");
      }
      return di.call(pi.kit, e3);
    }
    var _i = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = ci, e3;
    }({ init: function(e3) {
      fi2 = (pi = e3) && pi.log || fi2, e3 && e3.kit && e3.kit.buildData ? (di = pi.kit.buildData, pi.kit.buildData = gi, fi2("RegisterPropertyPageHeight \u63D2\u4EF6\u521D\u59CB\u5316\u5B8C\u6210")) : fi2("RegisterPropertyPageHeight \u63D2\u4EF6\u521D\u59CB\u5316\u5931\u8D25,\u5F53\u524D\u4E3Bsdk\u4E0D\u652F\u6301 RegisterPropertyPageHeight \u63D2\u4EF6\uFF0C\u8BF7\u5347\u7EA7\u4E3Bsdk");
    } }, "RegisterPropertyPageHeight", "sdkReady"), hi2 = "1.27.11";
    var mi, vi2 = { getPart: function(e3) {
      var t3 = this.option.length;
      if (t3) {
        for (var r2 = 0; r2 < t3; r2++)
          if (e3.indexOf(this.option[r2].part_url) > -1)
            return true;
      }
      return false;
    }, getPartHash: function(e3) {
      var t3 = this.option.length;
      if (t3) {
        for (var r2 = 0; r2 < t3; r2++)
          if (e3.indexOf(this.option[r2].part_url) > -1)
            return this.option[r2].after_hash;
      }
      return false;
    }, getCurrenId: function() {
      var e3 = this.store.getDistinctId() || "", t3 = this.store.getFirstId() || "";
      return this._.urlSafeBase64 && this._.urlSafeBase64.encode ? e3 = e3 ? this._.urlSafeBase64.trim(this._.urlSafeBase64.encode(this._.base64Encode(e3))) : "" : this._.rot13obfs && (e3 = e3 ? this._.rot13obfs(e3) : ""), encodeURIComponent(t3 ? "f" + e3 : "d" + e3);
    }, rewriteUrl: function(e3, t3) {
      var r2 = this, n2 = /([^?#]+)(\?[^#]*)?(#.*)?/.exec(e3), i2 = "";
      if (n2) {
        var a3, o2 = n2[1] || "", s2 = n2[2] || "", l2 = n2[3] || "", u2 = "_sasdk=" + this.getCurrenId(), c3 = function(e4) {
          var t4 = e4.split("&"), n3 = [];
          return r2._.each(t4, function(e5) {
            e5.indexOf("_sasdk=") > -1 ? n3.push(u2) : n3.push(e5);
          }), n3.join("&");
        };
        if (this.getPartHash(e3))
          a3 = l2.indexOf("_sasdk"), i2 = l2.indexOf("?") > -1 ? a3 > -1 ? o2 + s2 + "#" + l2.substring(1, a3) + c3(l2.substring(a3, l2.length)) : o2 + s2 + l2 + "&" + u2 : o2 + s2 + "#" + l2.substring(1) + "?" + u2;
        else
          a3 = s2.indexOf("_sasdk"), i2 = /^\?(\w)+/.test(s2) ? a3 > -1 ? o2 + "?" + c3(s2.substring(1)) + l2 : o2 + s2 + "&" + u2 + l2 : o2 + "?" + u2 + l2;
        return t3 && (t3.href = i2), i2;
      }
    }, getUrlId: function() {
      var e3 = location.href.match(/_sasdk=([aufd][^\?\#\&\=]+)/);
      if (this._.isArray(e3) && e3[1]) {
        var t3 = decodeURIComponent(e3[1]);
        return !t3 || "f" !== t3.substring(0, 1) && "d" !== t3.substring(0, 1) || (this._.urlSafeBase64 && this._.urlSafeBase64.isUrlSafeBase64 && this._.urlSafeBase64.isUrlSafeBase64(t3) ? t3 = t3.substring(0, 1) + this._.base64Decode(this._.urlSafeBase64.decode(t3.substring(1))) : this._.rot13defs && (t3 = t3.substring(0, 1) + this._.rot13defs(t3.substring(1)))), t3;
      }
      return "";
    }, setRefferId: function(e3) {
      var t3 = this.store.getDistinctId(), r2 = this.getUrlId();
      if (r2 && "" !== r2) {
        var n2 = "a" === r2.substring(0, 1) || "d" === r2.substring(0, 1);
        (r2 = r2.substring(1)) !== t3 && (n2 ? (this.sd.identify(r2, true), this.store.getFirstId() && this.sd.saEvent.send({ original_id: r2, distinct_id: t3, type: "track_signup", event: "$SignUp", properties: {} }, null)) : this.store.getFirstId() && !e3.re_login || this.sd.login(r2));
      }
    }, addListen: function() {
      var e3 = this, t3 = function(t4) {
        var r2, n2, i2 = t4.target, a3 = i2.tagName.toLowerCase(), o2 = i2.parentNode;
        if ("a" === a3 && i2.href || o2 && o2.tagName && "a" === o2.tagName.toLowerCase() && o2.href) {
          "a" === a3 && i2.href ? (r2 = i2.href, n2 = i2) : (r2 = o2.href, n2 = o2);
          var s2 = e3._.URL(r2).protocol;
          "http:" !== s2 && "https:" !== s2 || e3.getPart(r2) && e3.rewriteUrl(r2, n2);
        }
      };
      e3._.addEvent(document, "mousedown", t3), window.PointerEvent && "maxTouchPoints" in window.navigator && window.navigator.maxTouchPoints >= 0 && e3._.addEvent(document, "pointerdown", t3);
    }, init: function(e3, t3) {
      this.sd = e3, this._ = e3._, this.store = e3.store, this.para = e3.para, this._.isObject(t3) && this._.isArray(t3.linker) && t3.linker.length > 0 ? (this.setRefferId(t3), this.addListen(), this.option = t3.linker, this.option = function(t4) {
        for (var r2 = t4.length, n2 = [], i2 = 0; i2 < r2; i2++)
          /[A-Za-z0-9]+\./.test(t4[i2].part_url) && "[object Boolean]" == Object.prototype.toString.call(t4[i2].after_hash) ? n2.push(t4[i2]) : e3.log("linker \u914D\u7F6E\u7684\u7B2C " + (i2 + 1) + " \u9879\u683C\u5F0F\u4E0D\u6B63\u786E\uFF0C\u8BF7\u68C0\u67E5\u53C2\u6570\u683C\u5F0F\uFF01");
        return n2;
      }(this.option)) : e3.log("\u8BF7\u914D\u7F6E\u6253\u901A\u57DF\u540D\u53C2\u6570\uFF01");
    } }, yi2 = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = hi2, e3;
    }(vi2, "SiteLinker", "sdkReady"), bi = "utm_source utm_medium utm_campaign utm_content utm_term", wi = "1.27.11";
    var Si = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = wi, e3;
    }({ init: function(e3) {
      e3 && !mi && (mi = e3).registerInterceptor("businessStage", { getUtmData: { priority: 0, entry: function() {
        return function() {
          var e4 = bi.split(" "), t3 = "", r2 = {};
          mi._.isArray(mi.para.source_channel) && mi.para.source_channel.length > 0 && (e4 = e4.concat(mi.para.source_channel), e4 = mi._.unique(e4));
          return mi._.each(e4, function(e5) {
            (t3 = mi._.getQueryParam(location.href, e5)).length && (r2[e5] = t3);
          }), r2;
        }();
      } } });
    } }, "Utm", "sdkAfterInitPara"), ki = "1.27.11";
    var Pi = false, Ci = null;
    function Oi() {
      Pi = true;
    }
    function ji() {
      Pi = false;
    }
    function Ni() {
      return Pi;
    }
    var Ti, Ii, Ai = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = ki, e3;
    }({ init: function(e3) {
      (Ci = e3).disableSDK = Oi, Ci.enableSDK = ji, Ci.getDisabled = Ni;
    } }, "DisableSDK", "sdkInitAPI"), Di = "1.27.11";
    function $i(e3, t3) {
      if (true === Ti.para.debug_mode) {
        var r2 = e3.data;
        e3.callback;
        !function(e4) {
          var t4 = e4, r3 = "";
          r3 = -1 !== Ti.para.debug_mode_url.indexOf("?") ? Ti.para.debug_mode_url + "&" + Ti.kit.encodeTrackData(e4) : Ti.para.debug_mode_url + "?" + Ti.kit.encodeTrackData(e4), Ii.ajax({ url: r3, type: "GET", cors: true, header: { "Dry-Run": String(Ti.para.debug_mode_upload) }, success: function(e5) {
            true === Ii.isEmptyObject(e5) ? alert("debug\u6570\u636E\u53D1\u9001\u6210\u529F" + t4) : alert("debug\u5931\u8D25 \u9519\u8BEF\u539F\u56E0" + JSON.stringify(e5));
          } });
        }(JSON.stringify(r2)), t3.cancellationToken.stop();
      }
      return e3;
    }
    function xi() {
      Ti.on("sdkInitPara", function() {
        true === Ti.para.debug_mode && (Ti.para.debug_mode_upload = Ti.para.debug_mode_upload || false, Ii.isString(Ti.para.debug_mode_url) || (Ii.isString(Ti.para.server_url) ? Ti.para.debug_mode_url = Ti.para.server_url.replace("sa.gif", "debug") : Ii.isArray(Ti.para.server_url) && Ii.isString(Ti.para.server_url[0]) ? Ti.para.debug_mode_url = Ti.para.server_url[0].replace("sa.gif", "debug") : Ti.para.debug_mode = false));
      }), Ti.on("sdkAfterInitPara", function() {
        Ti.registerInterceptor("sendDataStage", { send: { priority: 30, entry: $i } });
      });
    }
    var Ei, Li, Ui = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Di, e3;
    }({ plugin_name: "DebugSender", init: function(e3) {
      Ii = (Ti = e3)._, xi();
    } }), Ri = "1.27.11";
    function Bi(e3, t3) {
      if (Li.isObject(Ei.para.jsapp) && !Ei.para.jsapp.isOnline && "function" == typeof Ei.para.jsapp.setData) {
        var r2 = e3;
        delete r2.callback, r2 = JSON.stringify(r2), Ei.para.jsapp.setData(r2), t3.cancellationToken.stop();
      }
      return e3;
    }
    function Hi(e3) {
      if (true === e3 && Li.isObject(Ei.para.jsapp) && "function" == typeof Ei.para.jsapp.getData) {
        Ei.para.jsapp.isOnline = true;
        var t3 = Ei.para.jsapp.getData();
        Li.isArray(t3) && t3.length > 0 && Li.each(t3, function(e4) {
          Li.isJSONString(e4) && Ei.kit.sendData(JSON.parse(e4));
        });
      } else
        Ei.para.jsapp.isOnline = false;
    }
    var Ji, Mi, qi = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Ri, e3;
    }({ plugin_name: "JsappSender", init: function(e3) {
      Li = (Ei = e3)._, Ei.on("sdkAfterInitAPI", function() {
        Li.isObject(Ei.commonWays) && (Ei.commonWays.setOnlineState = Hi), Ei.registerInterceptor("sendDataStage", { send: { priority: 40, entry: Bi } });
      });
    } }), Fi = "1.27.11";
    var Ki = null;
    function Vi(e3, t3) {
      return !Ji.para.app_js_bridge && Ji.para.batch_send && Mi.localStorage.isSupport() && localStorage.length < Ji.para.batch_send.storage_length && (Ki.add(e3.data), t3.cancellationToken.stop()), e3;
    }
    function zi() {
      Ji.on("sdkInitPara", function() {
        var e3;
        e3 = { datasend_timeout: 6e3, send_interval: 6e3, storage_length: 200 }, Mi.localStorage.isSupport() && Mi.isSupportCors() && "object" == typeof localStorage ? true === Ji.para.batch_send ? Ji.para.batch_send = Mi.extend({}, e3) : "object" == typeof Ji.para.batch_send && (Ji.para.batch_send = Mi.extend({}, e3, Ji.para.batch_send)) : Ji.para.batch_send = false;
      }), Ji.on("sdkAfterInitPara", function() {
        !Ji.para.app_js_bridge && Ji.para.batch_send && Mi.localStorage.isSupport() && (Ki || (Ki = new Mi.BatchSend()), Ki.batchInterval(), Ji.registerInterceptor("sendDataStage", { send: { priority: 100, entry: Vi } }));
      });
    }
    var Wi, Xi, Zi = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Fi, e3;
    }({ plugin_name: "BatchSender", init: function(e3) {
      Mi = (Ji = e3)._, zi();
    } }), Yi = "1.27.11";
    function Gi(e3) {
      new Xi.BeaconSend(e3).start();
    }
    function Qi(e3, t3) {
      var r2 = null, n2 = null;
      if (Xi.isObject(e3.config) && (r2 = e3.config.send_type, n2 = Xi.optimizeServerUrl(e3.config.server_url)), ("beacon" === r2 || !r2 && "beacon" === Wi.para.send_type) && Xi.isSupportBeaconSend()) {
        var i2 = n2 || e3.server_url;
        e3.server_url = i2, e3.data = Wi.kit.encodeTrackData(e3.data), Xi.isArray(i2) && i2.length ? Xi.each(i2, function(t4) {
          e3.callback = null, e3.server_url = t4, Gi(e3);
        }) : "string" == typeof i2 && "" !== i2 ? Gi(e3) : Wi.log("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01"), t3.cancellationToken.stop();
      }
      return e3;
    }
    function ea() {
      Wi.on("sdkInitPara", function() {
        "beacon" !== Wi.para.send_type || Xi.isSupportBeaconSend() || (Wi.para.send_type = Wi.DEFAULT_SEND_TYPE);
      }), Wi.on("sdkAfterInitPara", function() {
        Wi.registerInterceptor("sendDataStage", { send: { priority: 110, entry: Qi } });
      });
    }
    var ta2, ra, na = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Yi, e3;
    }({ plugin_name: "BeaconSender", init: function(e3) {
      Xi = (Wi = e3)._, ea();
    } }), ia2 = "1.27.11";
    function aa(e3) {
      new ra.AjaxSend(e3).start();
    }
    function oa(e3, t3) {
      var r2 = null, n2 = null;
      if (ra.isObject(e3.config) && (r2 = e3.config.send_type, n2 = ra.optimizeServerUrl(e3.config.server_url)), ("ajax" === r2 || !r2 && "ajax" === ta2.para.send_type) && ra.isSupportCors()) {
        var i2 = n2 || e3.server_url;
        e3.server_url = i2, e3.data = ta2.kit.encodeTrackData(e3.data), ra.isArray(i2) && i2.length ? ra.each(i2, function(t4) {
          e3.callback = null, e3.server_url = t4, aa(e3);
        }) : "string" == typeof i2 && "" !== i2 ? aa(e3) : ta2.log("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01"), t3.cancellationToken.stop();
      }
      return e3;
    }
    function sa() {
      ta2.on("sdkInitPara", function() {
        "ajax" !== ta2.para.send_type || ra.isSupportCors() || (ta2.para.send_type = ta2.DEFAULT_SEND_TYPE);
      }), ta2.on("sdkAfterInitPara", function() {
        ta2.registerInterceptor("sendDataStage", { send: { priority: 120, entry: oa } });
      });
    }
    var la, ua2, ca2 = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = ia2, e3;
    }({ plugin_name: "AjaxSender", init: function(e3) {
      ra = (ta2 = e3)._, sa();
    } }), pa2 = "1.27.11";
    function da2(e3, t3) {
      var r2 = la.kit.encodeTrackData(t3);
      return -1 !== e3.indexOf("?") ? e3 + "&" + r2 : e3 + "?" + r2;
    }
    function fa2(e3) {
      new ua2.ImageSend(e3).start();
    }
    function ga2(e3, t3) {
      var r2 = null;
      ua2.isObject(e3.config) && (r2 = ua2.optimizeServerUrl(e3.config.server_url));
      var n2 = r2 || e3.server_url, i2 = e3.data;
      e3.server_url = n2, ua2.isArray(n2) && n2.length ? ua2.each(n2, function(t4) {
        t4 && (e3.data = da2(t4, i2), e3.callback = null, e3.server_url = t4, fa2(e3));
      }) : "string" == typeof n2 && "" !== n2 ? (e3.data = da2(n2, i2), fa2(e3)) : la.logger && la.logger.msg("\u5F53\u524D server_url \u4E3A\u7A7A\u6216\u4E0D\u6B63\u786E\uFF0C\u53EA\u5728\u63A7\u5236\u53F0\u6253\u5370\u65E5\u5FD7\uFF0Cnetwork \u4E2D\u4E0D\u4F1A\u53D1\u6570\u636E\uFF0C\u8BF7\u914D\u7F6E\u6B63\u786E\u7684 server_url\uFF01").level("warn").log(), t3.cancellationToken.stop();
    }
    function _a2() {
      la.on("sdkInitPara", function() {
        "image" !== la.para.send_type && "ajax" !== la.para.send_type && "beacon" !== la.para.send_type && (la.para.send_type = "image");
      }), la.on("sdkAfterInitPara", function() {
        la.registerInterceptor("sendDataStage", { send: { priority: 130, entry: ga2 } });
      });
    }
    var ha2 = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = pa2, e3;
    }({ plugin_name: "ImageSender", init: function(e3) {
      ua2 = (la = e3)._, _a2();
    } });
    var ma = null, va = null, ya = [], ba = function(e3, t3, r2) {
      return function(e4, t4, r3) {
        if (t4 && (e4.plugin_name = t4), r3 && e4.init) {
          var n2 = e4.init;
          e4.init = function(i2, a3) {
            if (function(e5, t5, r4) {
              function n3(t6, n4) {
                e5.logger ? e5.logger.msg.apply(e5.logger, n4).module(r4 + "" || "").level(t6).log() : e5.log && e5.log.apply(e5, n4);
              }
              t5.log = function() {
                n3("log", arguments);
              }, t5.warn = function() {
                n3("warn", arguments);
              }, t5.error = function() {
                n3("error", arguments);
              };
            }(i2, e4, t4), i2.readyState && i2.readyState.state >= 3 || !i2.on)
              return o2();
            function o2() {
              n2.call(e4, i2, a3);
            }
            i2.on(r3, o2);
          };
        }
      }(e3, t3, r2), e3.plugin_version = Re, e3;
    }({ init: function(e3) {
      e3 && (va = (ma = e3)._, ma.logger && ma.logger.appendWriter(wa2), ma.on && ma.on("sdkAfterInitPara", function() {
        for (var e4 = 0; e4 < ya.length; e4++)
          Sa(ya[e4]);
        ya = null;
      }), ma.on && ma.on("sdkInitAPI", function() {
        ma.enableLocalLog = Oa, ma.disableLocalLog = ja2;
      }));
    } }, "ConsoleLogger");
    function wa2(e3) {
      null !== ya ? ya.push(e3) : Sa(e3);
    }
    function Sa(e3) {
      try {
        if ("log" === e3.level && ka2())
          return void Pa(e3);
        if ("warn" === e3.level && function() {
          if (Na())
            return true;
          return ka2() || va.isObject(ma.para.show_log) && "warn" === ma.para.show_log.level;
        }())
          return void Pa(e3);
        if ("error" === e3.level && function() {
          if (Na())
            return true;
          if (va.isObject(ma.para.show_log))
            return "none" !== ma.para.show_log.level;
          return true;
        }())
          return void Pa(e3);
      } catch (t3) {
      }
    }
    function ka2() {
      return !!Na() || (true === ma.para.show_log || va.isObject(ma.para.show_log) && "log" === ma.para.show_log.level);
    }
    function Pa(e3) {
      var t3 = e3.content, r2 = va.isObject(t3[0]) ? va.formatJsonString(t3[0]) : t3[0], n2 = function(e4) {
        var t4 = "", r3 = "", n3 = ma.para.show_log;
        va.isObject(n3) && false === n3.show_brand || (t4 += e4.brand);
        va.isObject(n3) && false === n3.show_level || (t4 += (t4.length > 0 ? "-" : "") + e4.level);
        t4.length > 0 && (t4 = "[" + t4 + "]");
        va.isObject(n3) && false === n3.show_module || (r3 = e4.module);
        return t4 + r3;
      }(e3);
      t3[0] = n2 + (n2.length > 0 ? ": " : "") + r2;
      try {
        console && (va.isFunction(console[e3.level]) ? console[e3.level].apply(console, t3) : va.isObject(console[e3.level]) && console[e3.level](t3[0]));
      } catch (i2) {
      }
    }
    var Ca = "sensorsdata_jssdk_debug";
    function Oa() {
      va.sessionStorage.isSupport() && sessionStorage.setItem(Ca, "true");
    }
    function ja2() {
      va.sessionStorage.isSupport() && sessionStorage.removeItem(Ca);
    }
    function Na() {
      return va.sessionStorage.isSupport() && "true" === sessionStorage.getItem(Ca);
    }
    t2.modules = t2.modules || {};
    for (var Ta = [ba, Br, tn2, kn2, jn, Jn, Wn, Qn, ni, oi, ui, _i, yi2, Si, Ai, Ui, qi, Zi, na, ca2, ha2], Ia = [ba, Ur, Si, Ai, qi, Ui, tn2, Wn, kn2, Qn, Zi, na, ca2, ha2], Aa = 0; Aa < Ta.length; Aa++) {
      var Da = Ta[Aa];
      t2._.isString(Da.plugin_name) ? t2.modules[Da.plugin_name] = Da : t2._.isArray(Da.plugin_name) && t2._.each(Da.plugin_name, function(e3) {
        t2.modules[e3] = Da;
      });
    }
    for (Aa = 0; Aa < Ia.length; Aa++)
      t2.use(Ia[Aa]);
    var $a = t2;
    try {
      "string" == typeof window.sensorsDataAnalytic201505 ? (t2.para = window[sensorsDataAnalytic201505].para, t2._q = window[sensorsDataAnalytic201505]._q, window[sensorsDataAnalytic201505] = t2, window.sensorsDataAnalytic201505 = t2, t2.init()) : "undefined" == typeof window.sensorsDataAnalytic201505 ? window.sensorsDataAnalytic201505 = t2 : $a = window.sensorsDataAnalytic201505;
    } catch (Ea) {
      xe(Ea);
    }
    var xa = $a;
    return xa.DEFAULT_SEND_TYPE = "image", xa;
  });
})(sensorsdata);
var sensors$1 = sensorsdata.exports;
var uaParser = { exports: {} };
(function(module, exports) {
  (function(window2, undefined$1) {
    var LIBVERSION = "0.7.41", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME2 = "name", TYPE = "type", VENDOR = "vendor", VERSION2 = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HONOR = "Honor", HUAWEI = "Huawei", LENOVO = "Lenovo", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", NVIDIA = "Nvidia", ONEPLUS = "OnePlus", OPERA = "Opera", OPPO = "OPPO", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS", SUFFIX_BROWSER = " Browser";
    var extend2 = function(regexes2, extensions) {
      var mergedRegexes = {};
      for (var i in regexes2) {
        if (extensions[i] && extensions[i].length % 2 === 0) {
          mergedRegexes[i] = extensions[i].concat(regexes2[i]);
        } else {
          mergedRegexes[i] = regexes2[i];
        }
      }
      return mergedRegexes;
    }, enumerize = function(arr) {
      var enums = {};
      for (var i = 0; i < arr.length; i++) {
        enums[arr[i].toUpperCase()] = arr[i];
      }
      return enums;
    }, has2 = function(str1, str2) {
      return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
      return str.toLowerCase();
    }, majorize = function(version2) {
      return typeof version2 === STR_TYPE ? version2.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined$1;
    }, trim2 = function(str, len) {
      if (typeof str === STR_TYPE) {
        str = str.replace(/^\s\s*/, EMPTY);
        return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
      }
    };
    var rgxMapper = function(ua2, arrays) {
      var i = 0, j, k, p, q, matches, match;
      while (i < arrays.length && !matches) {
        var regex = arrays[i], props2 = arrays[i + 1];
        j = k = 0;
        while (j < regex.length && !matches) {
          if (!regex[j]) {
            break;
          }
          matches = regex[j++].exec(ua2);
          if (!!matches) {
            for (p = 0; p < props2.length; p++) {
              match = matches[++k];
              q = props2[p];
              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length === 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    this[q[0]] = q[1].call(this, match);
                  } else {
                    this[q[0]] = q[1];
                  }
                } else if (q.length === 3) {
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined$1;
                  } else {
                    this[q[0]] = match ? match.replace(q[1], q[2]) : undefined$1;
                  }
                } else if (q.length === 4) {
                  this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined$1;
                }
              } else {
                this[q] = match ? match : undefined$1;
              }
            }
          }
        }
        i += 2;
      }
    }, strMapper = function(str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (has2(map[i][j], str)) {
              return i === UNKNOWN ? undefined$1 : i;
            }
          }
        } else if (has2(map[i], str)) {
          return i === UNKNOWN ? undefined$1 : i;
        }
      }
      return map.hasOwnProperty("*") ? map["*"] : str;
    };
    var oldSafariMap = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, windowsVersionMap = {
      "ME": "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      "2000": "NT 5.0",
      "XP": ["NT 5.1", "NT 5.2"],
      "Vista": "NT 6.0",
      "7": "NT 6.1",
      "8": "NT 6.2",
      "8.1": "NT 6.3",
      "10": ["NT 6.4", "NT 10.0"],
      "RT": "ARM"
    };
    var regexes = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Edge"]],
        [
          /(opera mini)\/([-\w\.]+)/i,
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /opios[\/ ]+([\w\.]+)/i
        ],
        [VERSION2, [NAME2, OPERA + " Mini"]],
        [
          /\bop(?:rg)?x\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, OPERA + " GX"]],
        [
          /\bopr\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, OPERA]],
        [
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Baidu"]],
        [
          /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i
        ],
        [VERSION2, [NAME2, "Maxthon"]],
        [
          /(kindle)\/([\w\.]+)/i,
          /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
          /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
          /(?:ms|\()(ie) ([\w\.]+)/i,
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
          /(heytap|ovi|115)browser\/([\d\.]+)/i,
          /(weibo)__([\d\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /quark(?:pc)?\/([-\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Quark"]],
        [
          /\bddg\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "DuckDuckGo"]],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "UC" + BROWSER]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
        ],
        [VERSION2, [NAME2, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Smart Lenovo " + BROWSER]],
        [
          /(avast|avg)\/([\w\.]+)/i
        ],
        [[NAME2, /(.+)/, "$1 Secure " + BROWSER], VERSION2],
        [
          /\bfocus\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, FIREFOX + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, OPERA + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, OPERA + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "MIUI" + SUFFIX_BROWSER]],
        [
          /fxios\/([\w\.-]+)/i
        ],
        [VERSION2, [NAME2, FIREFOX]],
        [
          /\bqihoobrowser\/?([\w\.]*)/i
        ],
        [VERSION2, [NAME2, "360"]],
        [
          /\b(qq)\/([\w\.]+)/i
        ],
        [[NAME2, /(.+)/, "$1Browser"], VERSION2],
        [
          /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
        ],
        [[NAME2, /(.+)/, "$1" + SUFFIX_BROWSER], VERSION2],
        [
          /samsungbrowser\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, SAMSUNG + " Internet"]],
        [
          /metasr[\/ ]?([\d\.]+)/i
        ],
        [VERSION2, [NAME2, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
        ],
        [[NAME2, "Sogou Mobile"], VERSION2],
        [
          /(electron)\/([\w\.]+) safari/i,
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /(lbbrowser|rekonq)/i,
          /\[(linkedin)app\]/i
        ],
        [NAME2],
        [
          /ome\/([\w\.]+) \w* ?(iron) saf/i,
          /ome\/([\w\.]+).+qihu (360)[es]e/i
        ],
        [VERSION2, NAME2],
        [
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
        ],
        [[NAME2, FACEBOOK], VERSION2],
        [
          /(Klarna)\/([\w\.]+)/i,
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          /(daum)apps[\/ ]([\w\.]+)/i,
          /safari (line)\/([\w\.]+)/i,
          /\b(line)\/([\w\.]+)\/iab/i,
          /(alipay)client\/([\w\.]+)/i,
          /(twitter)(?:and| f.+e\/([\w\.]+))/i,
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
        ],
        [VERSION2, [NAME2, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
        ],
        [VERSION2, [NAME2, CHROME + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
        ],
        [[NAME2, CHROME + " WebView"], VERSION2],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
        ],
        [VERSION2, [NAME2, "Android " + BROWSER]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
        ],
        [VERSION2, [NAME2, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
        ],
        [VERSION2, NAME2],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
        ],
        [NAME2, [VERSION2, strMapper, oldSafariMap]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /(navigator|netscape\d?)\/([-\w\.]+)/i
        ],
        [[NAME2, "Netscape"], VERSION2],
        [
          /(wolvic|librewolf)\/([\w\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
        ],
        [VERSION2, [NAME2, FIREFOX + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          /(swiftfox)/i,
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          /(firefox)\/([\w\.]+)/i,
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          /(amaya|dillo|doris|icab|ladybird|lynx|mosaic|netsurf|obigo|polaris|w3m|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          /\b(links) \(([\w\.]+)/i
        ],
        [NAME2, [VERSION2, /_/g, "."]],
        [
          /(cobalt)\/([\w\.]+)/i
        ],
        [NAME2, [VERSION2, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /\b((amd|x|x86[-_]?|wow|win)64)\b/i
        ],
        [[ARCHITECTURE, "amd64"]],
        [
          /(ia32(?=;))/i,
          /\b((i[346]|x)86)(pc)?\b/i
        ],
        [[ARCHITECTURE, "ia32"]],
        [
          /\b(aarch64|arm(v?[89]e?l?|_?64))\b/i
        ],
        [[ARCHITECTURE, "arm64"]],
        [
          /\b(arm(v[67])?ht?n?[fl]p?)\b/i
        ],
        [[ARCHITECTURE, "armhf"]],
        [
          /( (ce|mobile); ppc;|\/[\w\.]+arm\b)/i
        ],
        [[ARCHITECTURE, "arm"]],
        [
          /((ppc|powerpc)(64)?)( mac|;|\))/i
        ],
        [[ARCHITECTURE, /ower/, EMPTY, lowerize]],
        [
          / sun4\w[;\)]/i
        ],
        [[ARCHITECTURE, "sparc"]],
        [
          /\b(avr32|ia64(?=;)|68k(?=\))|\barm(?=v([1-7]|[5-7]1)l?|;|eabi)|(irix|mips|sparc)(64)?\b|pa-risc)/i
        ],
        [[ARCHITECTURE, lowerize]]
      ],
      device: [
        [
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]],
        [
          /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]((?!sm-[lr])[-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]],
        [
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, TABLET]],
        [
          /(macintosh);/i
        ],
        [MODEL, [VENDOR, APPLE]],
        [
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]],
        [
          /\b((?:brt|eln|hey2?|gdi|jdn)-a?[lnw]09|(?:ag[rm]3?|jdn2|kob2)-a?[lw]0[09]hn)(?: bui|\)|;)/i
        ],
        [MODEL, [VENDOR, HONOR], [TYPE, TABLET]],
        [
          /honor([-\w ]+)[;\)]/i
        ],
        [MODEL, [VENDOR, HONOR], [TYPE, MOBILE]],
        [
          /\b((?:ag[rs][2356]?k?|bah[234]?|bg[2o]|bt[kv]|cmr|cpn|db[ry]2?|jdn2|got|kob2?k?|mon|pce|scm|sht?|[tw]gr|vrd)-[ad]?[lw][0125][09]b?|605hw|bg2-u03|(?:gem|fdr|m2|ple|t1)-[7a]0[1-4][lu]|t1-a2[13][lw]|mediapad[\w\. ]*(?= bui|\)))\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]],
        [
          /(?:huawei)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]],
        [
          /oid[^\)]+; (2[\dbc]{4}(182|283|rp\w{2})[cgl]|m2105k81a?c)(?: bui|\))/i,
          /\b((?:red)?mi[-_ ]?pad[\w- ]*)(?: bui|\))/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, TABLET]],
        [
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          /\b; (\w+) build\/hm\1/i,
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i,
          / ([\w ]+) miui\/v?\d/i
        ],
        [[MODEL, /_/g, " "], [VENDOR, XIAOMI], [TYPE, MOBILE]],
        [
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [MODEL, [VENDOR, OPPO], [TYPE, MOBILE]],
        [
          /\b(opd2(\d{3}a?))(?: bui|\))/i
        ],
        [MODEL, [VENDOR, strMapper, { "OnePlus": ["304", "403", "203"], "*": OPPO }], [TYPE, TABLET]],
        [
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [MODEL, [VENDOR, "Vivo"], [TYPE, MOBILE]],
        [
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [MODEL, [VENDOR, "Realme"], [TYPE, MOBILE]],
        [
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto(?! 360)[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]],
        [
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, TABLET]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv|watch)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, MOBILE]],
        [
          /(ideatab[-\w ]+|602lv|d-42a|a101lv|a2109a|a3500-hv|s[56]000|pb-6505[my]|tb-?x?\d{3,4}(?:f[cu]|xu|[av])|yt\d?-[jx]?\d+[lfmx])( bui|;|\)|\/)/i,
          /lenovo ?(b[68]0[08]0-?[hf]?|tab(?:[\w- ]+?)|tb[\w-]{6,7})( bui|;|\)|\/)/i
        ],
        [MODEL, [VENDOR, LENOVO], [TYPE, TABLET]],
        [
          /(nokia) (t[12][01])/i
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(?:maemo|nokia).*(n900|lumia \d+|rm-\d+)/i,
          /nokia[-_ ]?(([-\w\. ]*))/i
        ],
        [[MODEL, /_/g, " "], [TYPE, MOBILE], [VENDOR, "Nokia"]],
        [
          /(pixel (c|tablet))\b/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]],
        [
          /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, MOBILE]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[MODEL, "Xperia Tablet"], [VENDOR, SONY], [TYPE, TABLET]],
        [
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [MODEL, [VENDOR, ONEPLUS], [TYPE, MOBILE]],
        [
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
          /(kf[a-z]+)( bui|\)).+silk\//i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
        ],
        [[MODEL, /(.+)/g, "Fire Phone $1"], [VENDOR, AMAZON], [TYPE, MOBILE]],
        [
          /(playbook);[-\w\),; ]+(rim)/i
        ],
        [MODEL, VENDOR, [TYPE, TABLET]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
        ],
        [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]],
        [
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, TABLET]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]],
        [
          /(nexus 9)/i
        ],
        [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
        ],
        [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]],
        [
          /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
        ],
        [MODEL, [VENDOR, "TCL"], [TYPE, TABLET]],
        [
          /(itel) ((\w+))/i
        ],
        [[VENDOR, lowerize], MODEL, [TYPE, strMapper, { "tablet": ["p10001l", "w7001"], "*": "mobile" }]],
        [
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]],
        [
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]],
        [
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [MODEL, [VENDOR, "Ulefone"], [TYPE, MOBILE]],
        [
          /; (energy ?\w+)(?: bui|\))/i,
          /; energizer ([\w ]+)(?: bui|\))/i
        ],
        [MODEL, [VENDOR, "Energizer"], [TYPE, MOBILE]],
        [
          /; cat (b35);/i,
          /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
        ],
        [MODEL, [VENDOR, "Cat"], [TYPE, MOBILE]],
        [
          /((?:new )?andromax[\w- ]+)(?: bui|\))/i
        ],
        [MODEL, [VENDOR, "Smartfren"], [TYPE, MOBILE]],
        [
          /droid.+; (a(?:015|06[35]|142p?))/i
        ],
        [MODEL, [VENDOR, "Nothing"], [TYPE, MOBILE]],
        [
          /; (x67 5g|tikeasy \w+|ac[1789]\d\w+)( b|\))/i,
          /archos ?(5|gamepad2?|([\w ]*[t1789]|hello) ?\d+[\w ]*)( b|\))/i
        ],
        [MODEL, [VENDOR, "Archos"], [TYPE, TABLET]],
        [
          /archos ([\w ]+)( b|\))/i,
          /; (ac[3-6]\d\w{2,8})( b|\))/i
        ],
        [MODEL, [VENDOR, "Archos"], [TYPE, MOBILE]],
        [
          /(imo) (tab \w+)/i,
          /(infinix) (x1101b?)/i
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus(?! zenw)|dell|jolla|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
          /; (hmd|imo) ([\w ]+?)(?: bui|\))/i,
          /(hp) ([\w ]+\w)/i,
          /(microsoft); (lumia[\w ]+)/i,
          /(lenovo)[-_ ]?([-\w ]+?)(?: bui|\)|\/)/i,
          /(oppo) ?([\w ]+) bui/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kobo)\s(ereader|touch)/i,
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          /(kindle)\/([\w\.]+)/i,
          /(nook)[\w ]+build\/(\w+)/i,
          /(dell) (strea[kpr\d ]*[\dko])/i,
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          /(trinity)[- ]*(t\d{3}) bui/i,
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          /(vodafone) ([\w ]+)(?:\)| bui)/i
        ],
        [VENDOR, MODEL, [TYPE, TABLET]],
        [
          /(surface duo)/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
        ],
        [MODEL, [VENDOR, "Fairphone"], [TYPE, MOBILE]],
        [
          /(u304aa)/i
        ],
        [MODEL, [VENDOR, "AT&T"], [TYPE, MOBILE]],
        [
          /\bsie-(\w*)/i
        ],
        [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]],
        [
          /\b(rct\w+) b/i
        ],
        [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]],
        [
          /\b(venue[\d ]{2,7}) b/i
        ],
        [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]],
        [
          /\b(q(?:mv|ta)\w+) b/i
        ],
        [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
        ],
        [MODEL, [VENDOR, "Barnes & Noble"], [TYPE, TABLET]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]],
        [
          /\b(k88) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]],
        [
          /\b(nx\d{3}j) b/i
        ],
        [MODEL, [VENDOR, "ZTE"], [TYPE, MOBILE]],
        [
          /\b(gen\d{3}) b.+49h/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]],
        [
          /\b(zur\d{3}) b/i
        ],
        [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]],
        [
          /\b((zeki)?tb.*\b) b/i
        ],
        [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
        ],
        [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]],
        [
          /\b(ns-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
        ],
        [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
        ],
        [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
        ],
        [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]],
        [
          /\b(ph-1) /i
        ],
        [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
        ],
        [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]],
        [
          /\b(trio[-\w\. ]+) b/i
        ],
        [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]],
        [
          /\btu_(1491) b/i
        ],
        [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]],
        [
          /((?:tegranote|shield t(?!.+d tv))[\w- ]*?)(?: b|\))/i
        ],
        [MODEL, [VENDOR, NVIDIA], [TYPE, TABLET]],
        [
          /(sprint) (\w+)/i
        ],
        [VENDOR, MODEL, [TYPE, MOBILE]],
        [
          /(kin\.[onetw]{3})/i
        ],
        [[MODEL, /\./g, " "], [VENDOR, MICROSOFT], [TYPE, MOBILE]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]],
        [
          /smart-tv.+(samsung)/i
        ],
        [VENDOR, [TYPE, SMARTTV]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[MODEL, /^/, "SmartTV"], [VENDOR, SAMSUNG], [TYPE, SMARTTV]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
        ],
        [[VENDOR, LG], [TYPE, SMARTTV]],
        [
          /(apple) ?tv/i
        ],
        [VENDOR, [MODEL, APPLE + " TV"], [TYPE, SMARTTV]],
        [
          /crkey/i
        ],
        [[MODEL, CHROME + "cast"], [VENDOR, GOOGLE], [TYPE, SMARTTV]],
        [
          /droid.+aft(\w+)( bui|\))/i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]],
        [
          /(shield \w+ tv)/i
        ],
        [MODEL, [VENDOR, NVIDIA], [TYPE, SMARTTV]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
        ],
        [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],
        [
          /(bravia[\w ]+)( bui|\))/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]],
        [
          /(mi(tv|box)-?\w+) bui/i
        ],
        [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]],
        [
          /Hbbtv.*(technisat) (.*);/i
        ],
        [VENDOR, MODEL, [TYPE, SMARTTV]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
        ],
        [[VENDOR, trim2], [MODEL, trim2], [TYPE, SMARTTV]],
        [
          /droid.+; ([\w- ]+) (?:android tv|smart[- ]?tv)/i
        ],
        [MODEL, [TYPE, SMARTTV]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
        ],
        [[TYPE, SMARTTV]],
        [
          /(ouya)/i,
          /(nintendo) ([wids3utch]+)/i
        ],
        [VENDOR, MODEL, [TYPE, CONSOLE]],
        [
          /droid.+; (shield)( bui|\))/i
        ],
        [MODEL, [VENDOR, NVIDIA], [TYPE, CONSOLE]],
        [
          /(playstation \w+)/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
        ],
        [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]],
        [
          /\b(sm-[lr]\d\d[0156][fnuw]?s?|gear live)\b/i
        ],
        [MODEL, [VENDOR, SAMSUNG], [TYPE, WEARABLE]],
        [
          /((pebble))app/i,
          /(asus|google|lg|oppo) ((pixel |zen)?watch[\w ]*)( bui|\))/i
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /(ow(?:19|20)?we?[1-3]{1,3})/i
        ],
        [MODEL, [VENDOR, OPPO], [TYPE, WEARABLE]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, WEARABLE]],
        [
          /(opwwe\d{3})/i
        ],
        [MODEL, [VENDOR, ONEPLUS], [TYPE, WEARABLE]],
        [
          /(moto 360)/i
        ],
        [MODEL, [VENDOR, MOTOROLA], [TYPE, WEARABLE]],
        [
          /(smartwatch 3)/i
        ],
        [MODEL, [VENDOR, SONY], [TYPE, WEARABLE]],
        [
          /(g watch r)/i
        ],
        [MODEL, [VENDOR, LG], [TYPE, WEARABLE]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]],
        [
          /droid.+; (glass) \d/i
        ],
        [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]],
        [
          /(pico) (4|neo3(?: link|pro)?)/i
        ],
        [VENDOR, MODEL, [TYPE, WEARABLE]],
        [
          /; (quest( \d| pro)?)/i
        ],
        [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]],
        [
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
        ],
        [VENDOR, [TYPE, EMBEDDED]],
        [
          /(aeobc)\b/i
        ],
        [MODEL, [VENDOR, AMAZON], [TYPE, EMBEDDED]],
        [
          /(homepod).+mac os/i
        ],
        [MODEL, [VENDOR, APPLE], [TYPE, EMBEDDED]],
        [
          /windows iot/i
        ],
        [[TYPE, EMBEDDED]],
        [
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
        ],
        [MODEL, [TYPE, MOBILE]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
        ],
        [MODEL, [TYPE, TABLET]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
        ],
        [[TYPE, TABLET]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
        ],
        [[TYPE, MOBILE]],
        [
          /droid .+?; ([\w\. -]+)( bui|\))/i
        ],
        [MODEL, [VENDOR, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, EDGE + "HTML"]],
        [
          /(arkweb)\/([\w\.]+)/i
        ],
        [NAME2, VERSION2],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
          /ekioh(flow)\/([\w\.]+)/i,
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          /\b(libweb)/i
        ],
        [NAME2, VERSION2],
        [
          /ladybird\//i
        ],
        [[NAME2, "LibWeb"]],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
        ],
        [VERSION2, NAME2]
      ],
      os: [
        [
          /microsoft (windows) (vista|xp)/i
        ],
        [NAME2, VERSION2],
        [
          /(windows (?:phone(?: os)?|mobile|iot))[\/ ]?([\d\.\w ]*)/i
        ],
        [NAME2, [VERSION2, strMapper, windowsVersionMap]],
        [
          /windows nt 6\.2; (arm)/i,
          /windows[\/ ]([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[VERSION2, strMapper, windowsVersionMap], [NAME2, "Windows"]],
        [
          /[adehimnop]{4,7}\b(?:.*os ([\w]+) like mac|; opera)/i,
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[VERSION2, /_/g, "."], [NAME2, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
        ],
        [[NAME2, MAC_OS], [VERSION2, /_/g, "."]],
        [
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
        ],
        [VERSION2, NAME2],
        [
          /(ubuntu) ([\w\.]+) like android/i
        ],
        [[NAME2, /(.+)/, "$1 Touch"], VERSION2],
        [
          /(android|bada|blackberry|kaios|maemo|meego|openharmony|qnx|rim tablet os|sailfish|series40|symbian|tizen|webos)\w*[-\/; ]?([\d\.]*)/i
        ],
        [NAME2, VERSION2],
        [
          /\(bb(10);/i
        ],
        [VERSION2, [NAME2, BLACKBERRY]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series ?60)[-\/ ]?([\w\.]*)/i
        ],
        [VERSION2, [NAME2, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, FIREFOX + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
        ],
        [VERSION2, [NAME2, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
        ],
        [VERSION2, [NAME2, "watchOS"]],
        [
          /crkey\/([\d\.]+)/i
        ],
        [VERSION2, [NAME2, CHROME + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
        ],
        [[NAME2, CHROMIUM_OS], VERSION2],
        [
          /panasonic;(viera)/i,
          /(netrange)mmh/i,
          /(nettv)\/(\d+\.[\w\.]+)/i,
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          /(xbox); +xbox ([^\);]+)/i,
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          /(mint)[\/\(\) ]?(\w*)/i,
          /(mageia|vectorlinux)[; ]/i,
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          /(hurd|linux)(?: arm\w*| x86\w*| ?)([\w\.]*)/i,
          /(gnu) ?([\w\.]*)/i,
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          /(haiku) (\w+)/i
        ],
        [NAME2, VERSION2],
        [
          /(sunos) ?([\w\.\d]*)/i
        ],
        [[NAME2, "Solaris"], VERSION2],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          /(unix) ?([\w\.]*)/i
        ],
        [NAME2, VERSION2]
      ]
    };
    var UAParser2 = function(ua2, extensions) {
      if (typeof ua2 === OBJ_TYPE) {
        extensions = ua2;
        ua2 = undefined$1;
      }
      if (!(this instanceof UAParser2)) {
        return new UAParser2(ua2, extensions).getResult();
      }
      var _navigator = typeof window2 !== UNDEF_TYPE && window2.navigator ? window2.navigator : undefined$1;
      var _ua = ua2 || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
      var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined$1;
      var _rgxmap = extensions ? extend2(regexes, extensions) : regexes;
      var _isSelfNav = _navigator && _navigator.userAgent == _ua;
      this.getBrowser = function() {
        var _browser = {};
        _browser[NAME2] = undefined$1;
        _browser[VERSION2] = undefined$1;
        rgxMapper.call(_browser, _ua, _rgxmap.browser);
        _browser[MAJOR] = majorize(_browser[VERSION2]);
        if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) {
          _browser[NAME2] = "Brave";
        }
        return _browser;
      };
      this.getCPU = function() {
        var _cpu = {};
        _cpu[ARCHITECTURE] = undefined$1;
        rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
        return _cpu;
      };
      this.getDevice = function() {
        var _device = {};
        _device[VENDOR] = undefined$1;
        _device[MODEL] = undefined$1;
        _device[TYPE] = undefined$1;
        rgxMapper.call(_device, _ua, _rgxmap.device);
        if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) {
          _device[TYPE] = MOBILE;
        }
        if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
          _device[MODEL] = "iPad";
          _device[TYPE] = TABLET;
        }
        return _device;
      };
      this.getEngine = function() {
        var _engine = {};
        _engine[NAME2] = undefined$1;
        _engine[VERSION2] = undefined$1;
        rgxMapper.call(_engine, _ua, _rgxmap.engine);
        return _engine;
      };
      this.getOS = function() {
        var _os = {};
        _os[NAME2] = undefined$1;
        _os[VERSION2] = undefined$1;
        rgxMapper.call(_os, _ua, _rgxmap.os);
        if (_isSelfNav && !_os[NAME2] && _uach && _uach.platform && _uach.platform != "Unknown") {
          _os[NAME2] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
        }
        return _os;
      };
      this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };
      this.getUA = function() {
        return _ua;
      };
      this.setUA = function(ua3) {
        _ua = typeof ua3 === STR_TYPE && ua3.length > UA_MAX_LENGTH ? trim2(ua3, UA_MAX_LENGTH) : ua3;
        return this;
      };
      this.setUA(_ua);
      return this;
    };
    UAParser2.VERSION = LIBVERSION;
    UAParser2.BROWSER = enumerize([NAME2, VERSION2, MAJOR]);
    UAParser2.CPU = enumerize([ARCHITECTURE]);
    UAParser2.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser2.ENGINE = UAParser2.OS = enumerize([NAME2, VERSION2]);
    {
      if (module.exports) {
        exports = module.exports = UAParser2;
      }
      exports.UAParser = UAParser2;
    }
    var $ = typeof window2 !== UNDEF_TYPE && (window2.jQuery || window2.Zepto);
    if ($ && !$.ua) {
      var parser2 = new UAParser2();
      $.ua = parser2.getResult();
      $.ua.get = function() {
        return parser2.getUA();
      };
      $.ua.set = function(ua2) {
        parser2.setUA(ua2);
        var result = parser2.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
})(uaParser, uaParser.exports);
var UAParser = uaParser.exports;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t2[p] = s[p];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e2) {
        reject(e2);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e2) {
        reject(e2);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _2 = { label: 0, sent: function() {
    if (t2[0] & 1)
      throw t2[1];
    return t2[1];
  }, trys: [], ops: [] }, f2, y, t2, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f2)
      throw new TypeError("Generator is already executing.");
    while (_2)
      try {
        if (f2 = 1, y && (t2 = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t2 = y["return"]) && t2.call(y), 0) : y.next) && !(t2 = t2.call(y, op[1])).done)
          return t2;
        if (y = 0, t2)
          op = [op[0] & 2, t2.value];
        switch (op[0]) {
          case 0:
          case 1:
            t2 = op;
            break;
          case 4:
            _2.label++;
            return { value: op[1], done: false };
          case 5:
            _2.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _2.ops.pop();
            _2.trys.pop();
            continue;
          default:
            if (!(t2 = _2.trys, t2 = t2.length > 0 && t2[t2.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _2 = 0;
              continue;
            }
            if (op[0] === 3 && (!t2 || op[1] > t2[0] && op[1] < t2[3])) {
              _2.label = op[1];
              break;
            }
            if (op[0] === 6 && _2.label < t2[1]) {
              _2.label = t2[1];
              t2 = op;
              break;
            }
            if (t2 && _2.label < t2[2]) {
              _2.label = t2[2];
              _2.ops.push(op);
              break;
            }
            if (t2[2])
              _2.ops.pop();
            _2.trys.pop();
            continue;
        }
        op = body.call(thisArg, _2);
      } catch (e2) {
        op = [6, e2];
        y = 0;
      } finally {
        f2 = t2 = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++)
    s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
    for (var a2 = arguments[i], j = 0, jl = a2.length; j < jl; j++, k++)
      r[k] = a2[j];
  return r;
}
class Tools {
  static getUuid() {
    const timeStamp = new Date().getTime();
    return `${"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c2) => {
      const r = Math.random() * 16 | 0;
      const v = c2 === "x" ? r : r & 3 | 8;
      return v.toString(16);
    })}-${timeStamp}`;
  }
  static isOnlyObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
  }
}
/*! js-cookie v3.0.1 | MIT */
function assign$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source2 = arguments[i];
    for (var key in source2) {
      target[key] = source2[key];
    }
  }
  return target;
}
var defaultConverter$1 = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init$1(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign$1({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get2(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies2.length; i++) {
      var parts = cookies2[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e2) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create(
    {
      set,
      get: get2,
      remove: function(key, attributes) {
        set(
          key,
          "",
          assign$1({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function(attributes) {
        return init$1(this.converter, assign$1({}, this.attributes, attributes));
      },
      withConverter: function(converter2) {
        return init$1(assign$1({}, this.converter, converter2), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  );
}
var api$1 = init$1(defaultConverter$1, { path: "/" });
function getLocalClientId() {
  let id2 = api$1.get("_MG_C_CID");
  if (!id2) {
    id2 = Date.parse(new Date() + "") + "-" + Math.floor(Math.random() * 1e8);
    api$1.set("_MG_C_CID", id2);
  }
  return id2;
}
function getGpuInfo() {
  var _a2, _b;
  const canvas = document.createElement("canvas");
  let context;
  let webglInfo = "unknow";
  let gpuVendor = "unknow";
  let gpuApi = "unknow";
  let webglVersion = "experimental";
  try {
    context = canvas.getContext("webgl2");
    if (context) {
      webglVersion = "webgl2";
    }
  } catch (l) {
  }
  if (!context) {
    try {
      context = canvas.getContext("webgl");
      if (context) {
        webglVersion = "webgl";
      }
    } catch (l) {
    }
  }
  if (context) {
    const debugInfo = context === null || context === void 0 ? void 0 : context.getExtension("WEBGL_debug_renderer_info");
    if (debugInfo) {
      webglInfo = context.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL).toLowerCase();
      gpuVendor = ((_a2 = /\bamd\b|\bati\b|\bnvidia\b|\bintel\b/.exec(webglInfo)) === null || _a2 === void 0 ? void 0 : _a2[0]) || "unknow";
      if (gpuVendor === "ati")
        gpuVendor = "amd";
      gpuApi = ((_b = /direct3d9|direct3d11|opengl/.exec(webglInfo)) === null || _b === void 0 ? void 0 : _b[0]) || "unknow";
    }
  }
  return {
    gpuVendor,
    gpuApi,
    webglVersion,
    webglInfo
  };
}
const ua = new UAParser().getResult();
let infoHost;
function hostInfo() {
  var _a2;
  if (infoHost)
    return infoHost;
  infoHost = Object.assign(Object.assign({}, ua), { clientId: getLocalClientId(), gpu: getGpuInfo(), memory: (_a2 = navigator.deviceMemory) !== null && _a2 !== void 0 ? _a2 : "unknow" });
  return infoHost;
}
var version$1 = "3.3.2";
function wait(durationMs, resolveWith) {
  return new Promise(function(resolve) {
    return setTimeout(resolve, durationMs, resolveWith);
  });
}
function requestIdleCallbackIfAvailable(fallbackTimeout, deadlineTimeout) {
  if (deadlineTimeout === void 0) {
    deadlineTimeout = Infinity;
  }
  var requestIdleCallback2 = window.requestIdleCallback;
  if (requestIdleCallback2) {
    return new Promise(function(resolve) {
      return requestIdleCallback2.call(window, function() {
        return resolve();
      }, { timeout: deadlineTimeout });
    });
  } else {
    return wait(Math.min(fallbackTimeout, deadlineTimeout));
  }
}
function isPromise(value) {
  return value && typeof value.then === "function";
}
function awaitIfAsync(action, callback) {
  try {
    var returnedValue = action();
    if (isPromise(returnedValue)) {
      returnedValue.then(function(result) {
        return callback(true, result);
      }, function(error) {
        return callback(false, error);
      });
    } else {
      callback(true, returnedValue);
    }
  } catch (error) {
    callback(false, error);
  }
}
function forEachWithBreaks(items, callback, loopReleaseInterval) {
  if (loopReleaseInterval === void 0) {
    loopReleaseInterval = 16;
  }
  return __awaiter(this, void 0, void 0, function() {
    var lastLoopReleaseTime, i, now;
    return __generator(this, function(_a2) {
      switch (_a2.label) {
        case 0:
          lastLoopReleaseTime = Date.now();
          i = 0;
          _a2.label = 1;
        case 1:
          if (!(i < items.length))
            return [3, 4];
          callback(items[i], i);
          now = Date.now();
          if (!(now >= lastLoopReleaseTime + loopReleaseInterval))
            return [3, 3];
          lastLoopReleaseTime = now;
          return [4, wait(0)];
        case 2:
          _a2.sent();
          _a2.label = 3;
        case 3:
          ++i;
          return [3, 1];
        case 4:
          return [2];
      }
    });
  });
}
function x64Add(m2, n) {
  m2 = [m2[0] >>> 16, m2[0] & 65535, m2[1] >>> 16, m2[1] & 65535];
  n = [n[0] >>> 16, n[0] & 65535, n[1] >>> 16, n[1] & 65535];
  var o2 = [0, 0, 0, 0];
  o2[3] += m2[3] + n[3];
  o2[2] += o2[3] >>> 16;
  o2[3] &= 65535;
  o2[2] += m2[2] + n[2];
  o2[1] += o2[2] >>> 16;
  o2[2] &= 65535;
  o2[1] += m2[1] + n[1];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[0] += m2[0] + n[0];
  o2[0] &= 65535;
  return [o2[0] << 16 | o2[1], o2[2] << 16 | o2[3]];
}
function x64Multiply(m2, n) {
  m2 = [m2[0] >>> 16, m2[0] & 65535, m2[1] >>> 16, m2[1] & 65535];
  n = [n[0] >>> 16, n[0] & 65535, n[1] >>> 16, n[1] & 65535];
  var o2 = [0, 0, 0, 0];
  o2[3] += m2[3] * n[3];
  o2[2] += o2[3] >>> 16;
  o2[3] &= 65535;
  o2[2] += m2[2] * n[3];
  o2[1] += o2[2] >>> 16;
  o2[2] &= 65535;
  o2[2] += m2[3] * n[2];
  o2[1] += o2[2] >>> 16;
  o2[2] &= 65535;
  o2[1] += m2[1] * n[3];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[1] += m2[2] * n[2];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[1] += m2[3] * n[1];
  o2[0] += o2[1] >>> 16;
  o2[1] &= 65535;
  o2[0] += m2[0] * n[3] + m2[1] * n[2] + m2[2] * n[1] + m2[3] * n[0];
  o2[0] &= 65535;
  return [o2[0] << 16 | o2[1], o2[2] << 16 | o2[3]];
}
function x64Rotl(m2, n) {
  n %= 64;
  if (n === 32) {
    return [m2[1], m2[0]];
  } else if (n < 32) {
    return [m2[0] << n | m2[1] >>> 32 - n, m2[1] << n | m2[0] >>> 32 - n];
  } else {
    n -= 32;
    return [m2[1] << n | m2[0] >>> 32 - n, m2[0] << n | m2[1] >>> 32 - n];
  }
}
function x64LeftShift(m2, n) {
  n %= 64;
  if (n === 0) {
    return m2;
  } else if (n < 32) {
    return [m2[0] << n | m2[1] >>> 32 - n, m2[1] << n];
  } else {
    return [m2[1] << n - 32, 0];
  }
}
function x64Xor(m2, n) {
  return [m2[0] ^ n[0], m2[1] ^ n[1]];
}
function x64Fmix(h) {
  h = x64Xor(h, [0, h[0] >>> 1]);
  h = x64Multiply(h, [4283543511, 3981806797]);
  h = x64Xor(h, [0, h[0] >>> 1]);
  h = x64Multiply(h, [3301882366, 444984403]);
  h = x64Xor(h, [0, h[0] >>> 1]);
  return h;
}
function x64hash128(key, seed) {
  key = key || "";
  seed = seed || 0;
  var remainder = key.length % 16;
  var bytes = key.length - remainder;
  var h1 = [0, seed];
  var h2 = [0, seed];
  var k1 = [0, 0];
  var k2 = [0, 0];
  var c1 = [2277735313, 289559509];
  var c2 = [1291169091, 658871167];
  var i;
  for (i = 0; i < bytes; i = i + 16) {
    k1 = [
      key.charCodeAt(i + 4) & 255 | (key.charCodeAt(i + 5) & 255) << 8 | (key.charCodeAt(i + 6) & 255) << 16 | (key.charCodeAt(i + 7) & 255) << 24,
      key.charCodeAt(i) & 255 | (key.charCodeAt(i + 1) & 255) << 8 | (key.charCodeAt(i + 2) & 255) << 16 | (key.charCodeAt(i + 3) & 255) << 24
    ];
    k2 = [
      key.charCodeAt(i + 12) & 255 | (key.charCodeAt(i + 13) & 255) << 8 | (key.charCodeAt(i + 14) & 255) << 16 | (key.charCodeAt(i + 15) & 255) << 24,
      key.charCodeAt(i + 8) & 255 | (key.charCodeAt(i + 9) & 255) << 8 | (key.charCodeAt(i + 10) & 255) << 16 | (key.charCodeAt(i + 11) & 255) << 24
    ];
    k1 = x64Multiply(k1, c1);
    k1 = x64Rotl(k1, 31);
    k1 = x64Multiply(k1, c2);
    h1 = x64Xor(h1, k1);
    h1 = x64Rotl(h1, 27);
    h1 = x64Add(h1, h2);
    h1 = x64Add(x64Multiply(h1, [0, 5]), [0, 1390208809]);
    k2 = x64Multiply(k2, c2);
    k2 = x64Rotl(k2, 33);
    k2 = x64Multiply(k2, c1);
    h2 = x64Xor(h2, k2);
    h2 = x64Rotl(h2, 31);
    h2 = x64Add(h2, h1);
    h2 = x64Add(x64Multiply(h2, [0, 5]), [0, 944331445]);
  }
  k1 = [0, 0];
  k2 = [0, 0];
  switch (remainder) {
    case 15:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 14)], 48));
    case 14:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 13)], 40));
    case 13:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 12)], 32));
    case 12:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 11)], 24));
    case 11:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 10)], 16));
    case 10:
      k2 = x64Xor(k2, x64LeftShift([0, key.charCodeAt(i + 9)], 8));
    case 9:
      k2 = x64Xor(k2, [0, key.charCodeAt(i + 8)]);
      k2 = x64Multiply(k2, c2);
      k2 = x64Rotl(k2, 33);
      k2 = x64Multiply(k2, c1);
      h2 = x64Xor(h2, k2);
    case 8:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 7)], 56));
    case 7:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 6)], 48));
    case 6:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 5)], 40));
    case 5:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 4)], 32));
    case 4:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 3)], 24));
    case 3:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 2)], 16));
    case 2:
      k1 = x64Xor(k1, x64LeftShift([0, key.charCodeAt(i + 1)], 8));
    case 1:
      k1 = x64Xor(k1, [0, key.charCodeAt(i)]);
      k1 = x64Multiply(k1, c1);
      k1 = x64Rotl(k1, 31);
      k1 = x64Multiply(k1, c2);
      h1 = x64Xor(h1, k1);
  }
  h1 = x64Xor(h1, [0, key.length]);
  h2 = x64Xor(h2, [0, key.length]);
  h1 = x64Add(h1, h2);
  h2 = x64Add(h2, h1);
  h1 = x64Fmix(h1);
  h2 = x64Fmix(h2);
  h1 = x64Add(h1, h2);
  h2 = x64Add(h2, h1);
  return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
}
function errorToObject(error) {
  var _a2;
  return __assign({ name: error.name, message: error.message, stack: (_a2 = error.stack) === null || _a2 === void 0 ? void 0 : _a2.split("\n") }, error);
}
function includes(haystack, needle) {
  for (var i = 0, l = haystack.length; i < l; ++i) {
    if (haystack[i] === needle) {
      return true;
    }
  }
  return false;
}
function excludes(haystack, needle) {
  return !includes(haystack, needle);
}
function toInt(value) {
  return parseInt(value);
}
function toFloat(value) {
  return parseFloat(value);
}
function replaceNaN(value, replacement) {
  return typeof value === "number" && isNaN(value) ? replacement : value;
}
function countTruthy(values) {
  return values.reduce(function(sum, value) {
    return sum + (value ? 1 : 0);
  }, 0);
}
function round$1(value, base) {
  if (base === void 0) {
    base = 1;
  }
  if (Math.abs(base) >= 1) {
    return Math.round(value / base) * base;
  } else {
    var counterBase = 1 / base;
    return Math.round(value * counterBase) / counterBase;
  }
}
function parseSimpleCssSelector(selector) {
  var _a2, _b;
  var errorMessage = "Unexpected syntax '" + selector + "'";
  var tagMatch = /^\s*([a-z-]*)(.*)$/i.exec(selector);
  var tag = tagMatch[1] || void 0;
  var attributes = {};
  var partsRegex = /([.:#][\w-]+|\[.+?\])/gi;
  var addAttribute = function(name2, value) {
    attributes[name2] = attributes[name2] || [];
    attributes[name2].push(value);
  };
  for (; ; ) {
    var match = partsRegex.exec(tagMatch[2]);
    if (!match) {
      break;
    }
    var part = match[0];
    switch (part[0]) {
      case ".":
        addAttribute("class", part.slice(1));
        break;
      case "#":
        addAttribute("id", part.slice(1));
        break;
      case "[": {
        var attributeMatch = /^\[([\w-]+)([~|^$*]?=("(.*?)"|([\w-]+)))?(\s+[is])?\]$/.exec(part);
        if (attributeMatch) {
          addAttribute(attributeMatch[1], (_b = (_a2 = attributeMatch[4]) !== null && _a2 !== void 0 ? _a2 : attributeMatch[5]) !== null && _b !== void 0 ? _b : "");
        } else {
          throw new Error(errorMessage);
        }
        break;
      }
      default:
        throw new Error(errorMessage);
    }
  }
  return [tag, attributes];
}
function ensureErrorWithMessage(error) {
  return error && typeof error === "object" && "message" in error ? error : { message: error };
}
function loadSource(source2, sourceOptions) {
  var isFinalResultLoaded = function(loadResult) {
    return typeof loadResult !== "function";
  };
  var sourceLoadPromise = new Promise(function(resolveLoad) {
    var loadStartTime = Date.now();
    awaitIfAsync(source2.bind(null, sourceOptions), function() {
      var loadArgs = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        loadArgs[_i] = arguments[_i];
      }
      var loadDuration = Date.now() - loadStartTime;
      if (!loadArgs[0]) {
        return resolveLoad(function() {
          return { error: ensureErrorWithMessage(loadArgs[1]), duration: loadDuration };
        });
      }
      var loadResult = loadArgs[1];
      if (isFinalResultLoaded(loadResult)) {
        return resolveLoad(function() {
          return { value: loadResult, duration: loadDuration };
        });
      }
      resolveLoad(function() {
        return new Promise(function(resolveGet) {
          var getStartTime = Date.now();
          awaitIfAsync(loadResult, function() {
            var getArgs = [];
            for (var _i2 = 0; _i2 < arguments.length; _i2++) {
              getArgs[_i2] = arguments[_i2];
            }
            var duration = loadDuration + Date.now() - getStartTime;
            if (!getArgs[0]) {
              return resolveGet({ error: ensureErrorWithMessage(getArgs[1]), duration });
            }
            resolveGet({ value: getArgs[1], duration });
          });
        });
      });
    });
  });
  return function getComponent() {
    return sourceLoadPromise.then(function(finalizeSource) {
      return finalizeSource();
    });
  };
}
function loadSources(sources2, sourceOptions, excludeSources) {
  var includedSources = Object.keys(sources2).filter(function(sourceKey) {
    return excludes(excludeSources, sourceKey);
  });
  var sourceGetters = Array(includedSources.length);
  forEachWithBreaks(includedSources, function(sourceKey, index2) {
    sourceGetters[index2] = loadSource(sources2[sourceKey], sourceOptions);
  });
  return function getComponents() {
    return __awaiter(this, void 0, void 0, function() {
      var components, _i, includedSources_1, sourceKey, componentPromises, _loop_1, state_1;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            components = {};
            for (_i = 0, includedSources_1 = includedSources; _i < includedSources_1.length; _i++) {
              sourceKey = includedSources_1[_i];
              components[sourceKey] = void 0;
            }
            componentPromises = Array(includedSources.length);
            _loop_1 = function() {
              var hasAllComponentPromises;
              return __generator(this, function(_a3) {
                switch (_a3.label) {
                  case 0:
                    hasAllComponentPromises = true;
                    return [4, forEachWithBreaks(includedSources, function(sourceKey2, index2) {
                      if (!componentPromises[index2]) {
                        if (sourceGetters[index2]) {
                          componentPromises[index2] = sourceGetters[index2]().then(function(component) {
                            return components[sourceKey2] = component;
                          });
                        } else {
                          hasAllComponentPromises = false;
                        }
                      }
                    })];
                  case 1:
                    _a3.sent();
                    if (hasAllComponentPromises) {
                      return [2, "break"];
                    }
                    return [4, wait(1)];
                  case 2:
                    _a3.sent();
                    return [2];
                }
              });
            };
            _a2.label = 1;
          case 1:
            return [5, _loop_1()];
          case 2:
            state_1 = _a2.sent();
            if (state_1 === "break")
              return [3, 4];
            _a2.label = 3;
          case 3:
            return [3, 1];
          case 4:
            return [4, Promise.all(componentPromises)];
          case 5:
            _a2.sent();
            return [2, components];
        }
      });
    });
  };
}
function isTrident() {
  var w = window;
  var n = navigator;
  return countTruthy([
    "MSCSSMatrix" in w,
    "msSetImmediate" in w,
    "msIndexedDB" in w,
    "msMaxTouchPoints" in n,
    "msPointerEnabled" in n
  ]) >= 4;
}
function isEdgeHTML() {
  var w = window;
  var n = navigator;
  return countTruthy(["msWriteProfilerMark" in w, "MSStream" in w, "msLaunchUri" in n, "msSaveBlob" in n]) >= 3 && !isTrident();
}
function isChromium() {
  var w = window;
  var n = navigator;
  return countTruthy([
    "webkitPersistentStorage" in n,
    "webkitTemporaryStorage" in n,
    n.vendor.indexOf("Google") === 0,
    "webkitResolveLocalFileSystemURL" in w,
    "BatteryManager" in w,
    "webkitMediaStream" in w,
    "webkitSpeechGrammar" in w
  ]) >= 5;
}
function isWebKit() {
  var w = window;
  var n = navigator;
  return countTruthy([
    "ApplePayError" in w,
    "CSSPrimitiveValue" in w,
    "Counter" in w,
    n.vendor.indexOf("Apple") === 0,
    "getStorageUpdates" in n,
    "WebKitMediaKeys" in w
  ]) >= 4;
}
function isDesktopSafari() {
  var w = window;
  return countTruthy([
    "safari" in w,
    !("DeviceMotionEvent" in w),
    !("ongestureend" in w),
    !("standalone" in navigator)
  ]) >= 3;
}
function isGecko() {
  var _a2, _b;
  var w = window;
  return countTruthy([
    "buildID" in navigator,
    "MozAppearance" in ((_b = (_a2 = document.documentElement) === null || _a2 === void 0 ? void 0 : _a2.style) !== null && _b !== void 0 ? _b : {}),
    "onmozfullscreenchange" in w,
    "mozInnerScreenX" in w,
    "CSSMozDocumentRule" in w,
    "CanvasCaptureMediaStream" in w
  ]) >= 4;
}
function isChromium86OrNewer() {
  var w = window;
  return countTruthy([
    !("MediaSettingsRange" in w),
    "RTCEncodedAudioFrame" in w,
    "" + w.Intl === "[object Intl]",
    "" + w.Reflect === "[object Reflect]"
  ]) >= 3;
}
function isWebKit606OrNewer() {
  var w = window;
  return countTruthy([
    "DOMRectList" in w,
    "RTCPeerConnectionIceEvent" in w,
    "SVGGeometryElement" in w,
    "ontransitioncancel" in w
  ]) >= 3;
}
function isIPad() {
  if (navigator.platform === "iPad") {
    return true;
  }
  var s = screen;
  var screenRatio = s.width / s.height;
  return countTruthy([
    "MediaSource" in window,
    !!Element.prototype.webkitRequestFullscreen,
    screenRatio > 0.65 && screenRatio < 1.53
  ]) >= 2;
}
function getFullscreenElement() {
  var d2 = document;
  return d2.fullscreenElement || d2.msFullscreenElement || d2.mozFullScreenElement || d2.webkitFullscreenElement || null;
}
function exitFullscreen() {
  var d2 = document;
  return (d2.exitFullscreen || d2.msExitFullscreen || d2.mozCancelFullScreen || d2.webkitExitFullscreen).call(d2);
}
function isAndroid() {
  var isItChromium = isChromium();
  var isItGecko = isGecko();
  if (!isItChromium && !isItGecko) {
    return false;
  }
  var w = window;
  return countTruthy([
    "onorientationchange" in w,
    "orientation" in w,
    isItChromium && !("SharedWorker" in w),
    isItGecko && /android/i.test(navigator.appVersion)
  ]) >= 2;
}
function getAudioFingerprint() {
  var w = window;
  var AudioContext = w.OfflineAudioContext || w.webkitOfflineAudioContext;
  if (!AudioContext) {
    return -2;
  }
  if (doesCurrentBrowserSuspendAudioContext()) {
    return -1;
  }
  var hashFromIndex = 4500;
  var hashToIndex = 5e3;
  var context = new AudioContext(1, hashToIndex, 44100);
  var oscillator = context.createOscillator();
  oscillator.type = "triangle";
  oscillator.frequency.value = 1e4;
  var compressor = context.createDynamicsCompressor();
  compressor.threshold.value = -50;
  compressor.knee.value = 40;
  compressor.ratio.value = 12;
  compressor.attack.value = 0;
  compressor.release.value = 0.25;
  oscillator.connect(compressor);
  compressor.connect(context.destination);
  oscillator.start(0);
  var _a2 = startRenderingAudio(context), renderPromise = _a2[0], finishRendering = _a2[1];
  var fingerprintPromise = renderPromise.then(function(buffer) {
    return getHash(buffer.getChannelData(0).subarray(hashFromIndex));
  }, function(error) {
    if (error.name === "timeout" || error.name === "suspended") {
      return -3;
    }
    throw error;
  });
  fingerprintPromise.catch(function() {
    return void 0;
  });
  return function() {
    finishRendering();
    return fingerprintPromise;
  };
}
function doesCurrentBrowserSuspendAudioContext() {
  return isWebKit() && !isDesktopSafari() && !isWebKit606OrNewer();
}
function startRenderingAudio(context) {
  var renderTryMaxCount = 3;
  var renderRetryDelay = 500;
  var runningMaxAwaitTime = 500;
  var runningSufficientTime = 5e3;
  var finalize = function() {
    return void 0;
  };
  var resultPromise = new Promise(function(resolve, reject) {
    var isFinalized = false;
    var renderTryCount = 0;
    var startedRunningAt = 0;
    context.oncomplete = function(event) {
      return resolve(event.renderedBuffer);
    };
    var startRunningTimeout = function() {
      setTimeout(function() {
        return reject(makeInnerError("timeout"));
      }, Math.min(runningMaxAwaitTime, startedRunningAt + runningSufficientTime - Date.now()));
    };
    var tryRender = function() {
      try {
        context.startRendering();
        switch (context.state) {
          case "running":
            startedRunningAt = Date.now();
            if (isFinalized) {
              startRunningTimeout();
            }
            break;
          case "suspended":
            if (!document.hidden) {
              renderTryCount++;
            }
            if (isFinalized && renderTryCount >= renderTryMaxCount) {
              reject(makeInnerError("suspended"));
            } else {
              setTimeout(tryRender, renderRetryDelay);
            }
            break;
        }
      } catch (error) {
        reject(error);
      }
    };
    tryRender();
    finalize = function() {
      if (!isFinalized) {
        isFinalized = true;
        if (startedRunningAt > 0) {
          startRunningTimeout();
        }
      }
    };
  });
  return [resultPromise, finalize];
}
function getHash(signal) {
  var hash2 = 0;
  for (var i = 0; i < signal.length; ++i) {
    hash2 += Math.abs(signal[i]);
  }
  return hash2;
}
function makeInnerError(name2) {
  var error = new Error(name2);
  error.name = name2;
  return error;
}
function withIframe(action, initialHtml, domPollInterval) {
  var _a2, _b, _c;
  if (domPollInterval === void 0) {
    domPollInterval = 50;
  }
  return __awaiter(this, void 0, void 0, function() {
    var d2, iframe;
    return __generator(this, function(_d) {
      switch (_d.label) {
        case 0:
          d2 = document;
          _d.label = 1;
        case 1:
          if (!!d2.body)
            return [3, 3];
          return [4, wait(domPollInterval)];
        case 2:
          _d.sent();
          return [3, 1];
        case 3:
          iframe = d2.createElement("iframe");
          _d.label = 4;
        case 4:
          _d.trys.push([4, , 10, 11]);
          return [4, new Promise(function(_resolve, _reject) {
            var isComplete = false;
            var resolve = function() {
              isComplete = true;
              _resolve();
            };
            var reject = function(error) {
              isComplete = true;
              _reject(error);
            };
            iframe.onload = resolve;
            iframe.onerror = reject;
            var style = iframe.style;
            style.setProperty("display", "block", "important");
            style.position = "absolute";
            style.top = "0";
            style.left = "0";
            style.visibility = "hidden";
            if (initialHtml && "srcdoc" in iframe) {
              iframe.srcdoc = initialHtml;
            } else {
              iframe.src = "about:blank";
            }
            d2.body.appendChild(iframe);
            var checkReadyState = function() {
              var _a3, _b2;
              if (isComplete) {
                return;
              }
              if (((_b2 = (_a3 = iframe.contentWindow) === null || _a3 === void 0 ? void 0 : _a3.document) === null || _b2 === void 0 ? void 0 : _b2.readyState) === "complete") {
                resolve();
              } else {
                setTimeout(checkReadyState, 10);
              }
            };
            checkReadyState();
          })];
        case 5:
          _d.sent();
          _d.label = 6;
        case 6:
          if (!!((_b = (_a2 = iframe.contentWindow) === null || _a2 === void 0 ? void 0 : _a2.document) === null || _b === void 0 ? void 0 : _b.body))
            return [3, 8];
          return [4, wait(domPollInterval)];
        case 7:
          _d.sent();
          return [3, 6];
        case 8:
          return [4, action(iframe, iframe.contentWindow)];
        case 9:
          return [2, _d.sent()];
        case 10:
          (_c = iframe.parentNode) === null || _c === void 0 ? void 0 : _c.removeChild(iframe);
          return [7];
        case 11:
          return [2];
      }
    });
  });
}
function selectorToElement(selector) {
  var _a2 = parseSimpleCssSelector(selector), tag = _a2[0], attributes = _a2[1];
  var element = document.createElement(tag !== null && tag !== void 0 ? tag : "div");
  for (var _i = 0, _b = Object.keys(attributes); _i < _b.length; _i++) {
    var name_1 = _b[_i];
    element.setAttribute(name_1, attributes[name_1].join(" "));
  }
  return element;
}
var testString = "mmMwWLliI0O&1";
var textSize = "48px";
var baseFonts = ["monospace", "sans-serif", "serif"];
var fontList = [
  "sans-serif-thin",
  "ARNO PRO",
  "Agency FB",
  "Arabic Typesetting",
  "Arial Unicode MS",
  "AvantGarde Bk BT",
  "BankGothic Md BT",
  "Batang",
  "Bitstream Vera Sans Mono",
  "Calibri",
  "Century",
  "Century Gothic",
  "Clarendon",
  "EUROSTILE",
  "Franklin Gothic",
  "Futura Bk BT",
  "Futura Md BT",
  "GOTHAM",
  "Gill Sans",
  "HELV",
  "Haettenschweiler",
  "Helvetica Neue",
  "Humanst521 BT",
  "Leelawadee",
  "Letter Gothic",
  "Levenim MT",
  "Lucida Bright",
  "Lucida Sans",
  "Menlo",
  "MS Mincho",
  "MS Outlook",
  "MS Reference Specialty",
  "MS UI Gothic",
  "MT Extra",
  "MYRIAD PRO",
  "Marlett",
  "Meiryo UI",
  "Microsoft Uighur",
  "Minion Pro",
  "Monotype Corsiva",
  "PMingLiU",
  "Pristina",
  "SCRIPTINA",
  "Segoe UI Light",
  "Serifa",
  "SimHei",
  "Small Fonts",
  "Staccato222 BT",
  "TRAJAN PRO",
  "Univers CE 55 Medium",
  "Vrinda",
  "ZWAdobeF"
];
function getFonts() {
  return withIframe(function(_2, _a2) {
    var document2 = _a2.document;
    var holder = document2.body;
    holder.style.fontSize = textSize;
    var spansContainer = document2.createElement("div");
    var defaultWidth = {};
    var defaultHeight = {};
    var createSpan = function(fontFamily) {
      var span = document2.createElement("span");
      var style = span.style;
      style.position = "absolute";
      style.top = "0";
      style.left = "0";
      style.fontFamily = fontFamily;
      span.textContent = testString;
      spansContainer.appendChild(span);
      return span;
    };
    var createSpanWithFonts = function(fontToDetect, baseFont) {
      return createSpan("'" + fontToDetect + "'," + baseFont);
    };
    var initializeBaseFontsSpans = function() {
      return baseFonts.map(createSpan);
    };
    var initializeFontsSpans = function() {
      var spans = {};
      var _loop_1 = function(font2) {
        spans[font2] = baseFonts.map(function(baseFont) {
          return createSpanWithFonts(font2, baseFont);
        });
      };
      for (var _i = 0, fontList_1 = fontList; _i < fontList_1.length; _i++) {
        var font = fontList_1[_i];
        _loop_1(font);
      }
      return spans;
    };
    var isFontAvailable = function(fontSpans) {
      return baseFonts.some(function(baseFont, baseFontIndex) {
        return fontSpans[baseFontIndex].offsetWidth !== defaultWidth[baseFont] || fontSpans[baseFontIndex].offsetHeight !== defaultHeight[baseFont];
      });
    };
    var baseFontsSpans = initializeBaseFontsSpans();
    var fontsSpans = initializeFontsSpans();
    holder.appendChild(spansContainer);
    for (var index2 = 0; index2 < baseFonts.length; index2++) {
      defaultWidth[baseFonts[index2]] = baseFontsSpans[index2].offsetWidth;
      defaultHeight[baseFonts[index2]] = baseFontsSpans[index2].offsetHeight;
    }
    return fontList.filter(function(font) {
      return isFontAvailable(fontsSpans[font]);
    });
  });
}
function getPlugins() {
  var rawPlugins = navigator.plugins;
  if (!rawPlugins) {
    return void 0;
  }
  var plugins = [];
  for (var i = 0; i < rawPlugins.length; ++i) {
    var plugin2 = rawPlugins[i];
    if (!plugin2) {
      continue;
    }
    var mimeTypes = [];
    for (var j = 0; j < plugin2.length; ++j) {
      var mimeType = plugin2[j];
      mimeTypes.push({
        type: mimeType.type,
        suffixes: mimeType.suffixes
      });
    }
    plugins.push({
      name: plugin2.name,
      description: plugin2.description,
      mimeTypes
    });
  }
  return plugins;
}
function getCanvasFingerprint() {
  var _a2 = makeCanvasContext(), canvas = _a2[0], context = _a2[1];
  if (!isSupported(canvas, context)) {
    return { winding: false, geometry: "", text: "" };
  }
  return {
    winding: doesSupportWinding(context),
    geometry: makeGeometryImage(canvas, context),
    text: makeTextImage(canvas, context)
  };
}
function makeCanvasContext() {
  var canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = 1;
  return [canvas, canvas.getContext("2d")];
}
function isSupported(canvas, context) {
  return !!(context && canvas.toDataURL);
}
function doesSupportWinding(context) {
  context.rect(0, 0, 10, 10);
  context.rect(2, 2, 6, 6);
  return !context.isPointInPath(5, 5, "evenodd");
}
function makeTextImage(canvas, context) {
  canvas.width = 240;
  canvas.height = 60;
  context.textBaseline = "alphabetic";
  context.fillStyle = "#f60";
  context.fillRect(100, 1, 62, 20);
  context.fillStyle = "#069";
  context.font = '11pt "Times New Roman"';
  var printedText = "Cwm fjordbank gly " + String.fromCharCode(55357, 56835);
  context.fillText(printedText, 2, 15);
  context.fillStyle = "rgba(102, 204, 0, 0.2)";
  context.font = "18pt Arial";
  context.fillText(printedText, 4, 45);
  return save(canvas);
}
function makeGeometryImage(canvas, context) {
  canvas.width = 122;
  canvas.height = 110;
  context.globalCompositeOperation = "multiply";
  for (var _i = 0, _a2 = [
    ["#f2f", 40, 40],
    ["#2ff", 80, 40],
    ["#ff2", 60, 80]
  ]; _i < _a2.length; _i++) {
    var _b = _a2[_i], color = _b[0], x = _b[1], y = _b[2];
    context.fillStyle = color;
    context.beginPath();
    context.arc(x, y, 40, 0, Math.PI * 2, true);
    context.closePath();
    context.fill();
  }
  context.fillStyle = "#f9c";
  context.arc(60, 60, 60, 0, Math.PI * 2, true);
  context.arc(60, 60, 20, 0, Math.PI * 2, true);
  context.fill("evenodd");
  return save(canvas);
}
function save(canvas) {
  return canvas.toDataURL();
}
function getTouchSupport() {
  var n = navigator;
  var maxTouchPoints = 0;
  var touchEvent;
  if (n.maxTouchPoints !== void 0) {
    maxTouchPoints = toInt(n.maxTouchPoints);
  } else if (n.msMaxTouchPoints !== void 0) {
    maxTouchPoints = n.msMaxTouchPoints;
  }
  try {
    document.createEvent("TouchEvent");
    touchEvent = true;
  } catch (_a2) {
    touchEvent = false;
  }
  var touchStart = "ontouchstart" in window;
  return {
    maxTouchPoints,
    touchEvent,
    touchStart
  };
}
function getOsCpu() {
  return navigator.oscpu;
}
function getLanguages() {
  var n = navigator;
  var result = [];
  var language = n.language || n.userLanguage || n.browserLanguage || n.systemLanguage;
  if (language !== void 0) {
    result.push([language]);
  }
  if (Array.isArray(n.languages)) {
    if (!(isChromium() && isChromium86OrNewer())) {
      result.push(n.languages);
    }
  } else if (typeof n.languages === "string") {
    var languages = n.languages;
    if (languages) {
      result.push(languages.split(","));
    }
  }
  return result;
}
function getColorDepth() {
  return window.screen.colorDepth;
}
function getDeviceMemory() {
  return replaceNaN(toFloat(navigator.deviceMemory), void 0);
}
function getScreenResolution() {
  var s = screen;
  var parseDimension = function(value) {
    return replaceNaN(toInt(value), null);
  };
  var dimensions = [parseDimension(s.width), parseDimension(s.height)];
  dimensions.sort().reverse();
  return dimensions;
}
var screenFrameCheckInterval = 2500;
var roundingPrecision = 10;
var screenFrameBackup;
var screenFrameSizeTimeoutId;
function watchScreenFrame() {
  if (screenFrameSizeTimeoutId !== void 0) {
    return;
  }
  var checkScreenFrame = function() {
    var frameSize = getCurrentScreenFrame();
    if (isFrameSizeNull(frameSize)) {
      screenFrameSizeTimeoutId = setTimeout(checkScreenFrame, screenFrameCheckInterval);
    } else {
      screenFrameBackup = frameSize;
      screenFrameSizeTimeoutId = void 0;
    }
  };
  checkScreenFrame();
}
function getScreenFrame() {
  var _this = this;
  watchScreenFrame();
  return function() {
    return __awaiter(_this, void 0, void 0, function() {
      var frameSize;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            frameSize = getCurrentScreenFrame();
            if (!isFrameSizeNull(frameSize))
              return [3, 2];
            if (screenFrameBackup) {
              return [2, __spreadArrays(screenFrameBackup)];
            }
            if (!getFullscreenElement())
              return [3, 2];
            return [4, exitFullscreen()];
          case 1:
            _a2.sent();
            frameSize = getCurrentScreenFrame();
            _a2.label = 2;
          case 2:
            if (!isFrameSizeNull(frameSize)) {
              screenFrameBackup = frameSize;
            }
            return [2, frameSize];
        }
      });
    });
  };
}
function getRoundedScreenFrame() {
  var _this = this;
  var screenFrameGetter = getScreenFrame();
  return function() {
    return __awaiter(_this, void 0, void 0, function() {
      var frameSize, processSize;
      return __generator(this, function(_a2) {
        switch (_a2.label) {
          case 0:
            return [4, screenFrameGetter()];
          case 1:
            frameSize = _a2.sent();
            processSize = function(sideSize) {
              return sideSize === null ? null : round$1(sideSize, roundingPrecision);
            };
            return [2, [processSize(frameSize[0]), processSize(frameSize[1]), processSize(frameSize[2]), processSize(frameSize[3])]];
        }
      });
    });
  };
}
function getCurrentScreenFrame() {
  var s = screen;
  return [
    replaceNaN(toFloat(s.availTop), null),
    replaceNaN(toFloat(s.width) - toFloat(s.availWidth) - replaceNaN(toFloat(s.availLeft), 0), null),
    replaceNaN(toFloat(s.height) - toFloat(s.availHeight) - replaceNaN(toFloat(s.availTop), 0), null),
    replaceNaN(toFloat(s.availLeft), null)
  ];
}
function isFrameSizeNull(frameSize) {
  for (var i = 0; i < 4; ++i) {
    if (frameSize[i]) {
      return false;
    }
  }
  return true;
}
function getHardwareConcurrency() {
  return replaceNaN(toInt(navigator.hardwareConcurrency), void 0);
}
function getTimezone() {
  var _a2;
  var DateTimeFormat = (_a2 = window.Intl) === null || _a2 === void 0 ? void 0 : _a2.DateTimeFormat;
  if (DateTimeFormat) {
    var timezone = new DateTimeFormat().resolvedOptions().timeZone;
    if (timezone) {
      return timezone;
    }
  }
  var offset2 = -getTimezoneOffset();
  return "UTC" + (offset2 >= 0 ? "+" : "") + Math.abs(offset2);
}
function getTimezoneOffset() {
  var currentYear = new Date().getFullYear();
  return Math.max(
    toFloat(new Date(currentYear, 0, 1).getTimezoneOffset()),
    toFloat(new Date(currentYear, 6, 1).getTimezoneOffset())
  );
}
function getSessionStorage() {
  try {
    return !!window.sessionStorage;
  } catch (error) {
    return true;
  }
}
function getLocalStorage() {
  try {
    return !!window.localStorage;
  } catch (e2) {
    return true;
  }
}
function getIndexedDB() {
  if (isTrident() || isEdgeHTML()) {
    return void 0;
  }
  try {
    return !!window.indexedDB;
  } catch (e2) {
    return true;
  }
}
function getOpenDatabase() {
  return !!window.openDatabase;
}
function getCpuClass() {
  return navigator.cpuClass;
}
function getPlatform() {
  var platform2 = navigator.platform;
  if (platform2 === "MacIntel") {
    if (isWebKit() && !isDesktopSafari()) {
      return isIPad() ? "iPad" : "iPhone";
    }
  }
  return platform2;
}
function getVendor() {
  return navigator.vendor || "";
}
function getVendorFlavors() {
  var flavors = [];
  for (var _i = 0, _a2 = [
    "chrome",
    "safari",
    "__crWeb",
    "__gCrWeb",
    "yandex",
    "__yb",
    "__ybro",
    "__firefox__",
    "__edgeTrackingPreventionStatistics",
    "webkit",
    "oprt",
    "samsungAr",
    "ucweb",
    "UCShellJava",
    "puffinDevice"
  ]; _i < _a2.length; _i++) {
    var key = _a2[_i];
    var value = window[key];
    if (value && typeof value === "object") {
      flavors.push(key);
    }
  }
  return flavors.sort();
}
function areCookiesEnabled() {
  var d2 = document;
  try {
    d2.cookie = "cookietest=1; SameSite=Strict;";
    var result = d2.cookie.indexOf("cookietest=") !== -1;
    d2.cookie = "cookietest=1; SameSite=Strict; expires=Thu, 01-Jan-1970 00:00:01 GMT";
    return result;
  } catch (e2) {
    return false;
  }
}
var filters = {
  abpIndo: [
    "#Iklan-Melayang",
    "#Kolom-Iklan-728",
    "#SidebarIklan-wrapper",
    'a[title="7naga poker" i]',
    '[title="ALIENBOLA" i]'
  ],
  abpvn: [
    "#quangcaomb",
    ".iosAdsiosAds-layout",
    ".quangcao",
    '[href^="https://r88.vn/"]',
    '[href^="https://zbet.vn/"]'
  ],
  adBlockFinland: [
    ".mainostila",
    ".sponsorit",
    ".ylamainos",
    'a[href*="/clickthrgh.asp?"]',
    'a[href^="https://app.readpeak.com/ads"]'
  ],
  adBlockPersian: [
    "#navbar_notice_50",
    'a[href^="http://g1.v.fwmrm.net/ad/"]',
    ".kadr",
    'TABLE[width="140px"]',
    "#divAgahi"
  ],
  adBlockWarningRemoval: ["#adblock-honeypot", ".adblocker-root", ".wp_adblock_detect"],
  adGuardAnnoyances: ['amp-embed[type="zen"]', ".hs-sosyal", "#cookieconsentdiv", 'div[class^="app_gdpr"]', ".as-oil"],
  adGuardBase: ["#ad-after", "#ad-p3", ".BetterJsPopOverlay", "#ad_300X250", "#bannerfloat22"],
  adGuardChinese: [
    '#piao_div_0[style*="width:140px;"]',
    'a[href*=".ttz5.cn"]',
    'a[href*=".yabovip2027.com/"]',
    ".tm3all2h4b",
    ".cc5278_banner_ad"
  ],
  adGuardFrench: [
    ".zonepub",
    '[class*="_adLeaderboard"]',
    '[id^="block-xiti_oas-"]',
    'a[href^="http://ptapjmp.com/"]',
    'a[href^="https://go.alvexo.com/"]'
  ],
  adGuardGerman: [
    ".banneritemwerbung_head_1",
    ".boxstartwerbung",
    ".werbung3",
    'a[href^="http://www.eis.de/index.phtml?refid="]',
    'a[href^="https://www.tipico.com/?affiliateId="]'
  ],
  adGuardJapanese: [
    "#kauli_yad_1",
    "#ad-giftext",
    "#adsSPRBlock",
    'a[href^="http://ad2.trafficgate.net/"]',
    'a[href^="http://www.rssad.jp/"]'
  ],
  adGuardMobile: ["amp-auto-ads", "#mgid_iframe", ".amp_ad", 'amp-embed[type="24smi"]', "#mgid_iframe1"],
  adGuardRussian: [
    'a[href^="https://ya-distrib.ru/r/"]',
    'a[href^="https://ad.letmeads.com/"]',
    ".reclama",
    'div[id^="smi2adblock"]',
    'div[id^="AdFox_banner_"]'
  ],
  adGuardSocial: [
    'a[href^="//www.stumbleupon.com/submit?url="]',
    'a[href^="//telegram.me/share/url?"]',
    ".etsy-tweet",
    "#inlineShare",
    ".popup-social"
  ],
  adGuardSpanishPortuguese: [
    "#barraPublicidade",
    "#Publicidade",
    "#publiEspecial",
    "#queTooltip",
    '[href^="http://ads.glispa.com/"]'
  ],
  adGuardTrackingProtection: [
    'amp-embed[type="taboola"]',
    "#qoo-counter",
    'a[href^="http://click.hotlog.ru/"]',
    'a[href^="http://hitcounter.ru/top/stat.php"]',
    'a[href^="http://top.mail.ru/jump"]'
  ],
  adGuardTurkish: [
    "#backkapat",
    "#reklami",
    'a[href^="http://adserv.ontek.com.tr/"]',
    'a[href^="http://izlenzi.com/campaign/"]',
    'a[href^="http://www.installads.net/"]'
  ],
  bulgarian: ["td#freenet_table_ads", "#adbody", "#ea_intext_div", ".lapni-pop-over", "#xenium_hot_offers"],
  easyList: ["#AD_banner_bottom", "#Ads_google_02", "#N-ad-article-rightRail-1", "#ad-fullbanner2", "#ad-zone-2"],
  easyListChina: [
    'a[href*=".wensixuetang.com/"]',
    'A[href*="/hth107.com/"]',
    '.appguide-wrap[onclick*="bcebos.com"]',
    ".frontpageAdvM",
    "#taotaole"
  ],
  easyListCookie: ["#adtoniq-msg-bar", "#CoockiesPage", "#CookieModal_cookiemodal", "#DO_CC_PANEL", "#ShowCookie"],
  easyListCzechSlovak: ["#onlajny-stickers", "#reklamni-box", ".reklama-megaboard", ".sklik", '[id^="sklikReklama"]'],
  easyListDutch: [
    "#advertentie",
    "#vipAdmarktBannerBlock",
    ".adstekst",
    'a[href^="https://xltube.nl/click/"]',
    "#semilo-lrectangle"
  ],
  easyListGermany: [
    'a[href^="http://www.hw-area.com/?dp="]',
    'a[href^="https://ads.sunmaker.com/tracking.php?"]',
    ".werbung-skyscraper2",
    ".bannergroup_werbung",
    ".ads_rechts"
  ],
  easyListItaly: [
    ".box_adv_annunci",
    ".sb-box-pubbliredazionale",
    'a[href^="http://affiliazioniads.snai.it/"]',
    'a[href^="https://adserver.html.it/"]',
    'a[href^="https://affiliazioniads.snai.it/"]'
  ],
  easyListLithuania: [
    ".reklamos_tarpas",
    ".reklamos_nuorodos",
    'img[alt="Reklaminis skydelis"]',
    'img[alt="Dedikuoti.lt serveriai"]',
    'img[alt="Hostingas Serveriai.lt"]'
  ],
  estonian: ['A[href*="http://pay4results24.eu"]'],
  fanboyAnnoyances: [
    "#feedback-tab",
    "#taboola-below-article",
    ".feedburnerFeedBlock",
    ".widget-feedburner-counter",
    '[title="Subscribe to our blog"]'
  ],
  fanboyAntiFacebook: [".util-bar-module-firefly-visible"],
  fanboyEnhancedTrackers: [
    ".open.pushModal",
    "#issuem-leaky-paywall-articles-zero-remaining-nag",
    "#sovrn_container",
    'div[class$="-hide"][zoompage-fontsize][style="display: block;"]',
    ".BlockNag__Card"
  ],
  fanboySocial: [
    ".td-tags-and-social-wrapper-box",
    ".twitterContainer",
    ".youtube-social",
    'a[title^="Like us on Facebook"]',
    'img[alt^="Share on Digg"]'
  ],
  frellwitSwedish: [
    'a[href*="casinopro.se"][target="_blank"]',
    'a[href*="doktor-se.onelink.me"]',
    "article.category-samarbete",
    "div.holidAds",
    "ul.adsmodern"
  ],
  greekAdBlock: [
    'A[href*="adman.otenet.gr/click?"]',
    'A[href*="http://axiabanners.exodus.gr/"]',
    'A[href*="http://interactive.forthnet.gr/click?"]',
    "DIV.agores300",
    "TABLE.advright"
  ],
  hungarian: [
    'A[href*="ad.eval.hu"]',
    'A[href*="ad.netmedia.hu"]',
    'A[href*="daserver.ultraweb.hu"]',
    "#cemp_doboz",
    ".optimonk-iframe-container"
  ],
  iDontCareAboutCookies: [
    '.alert-info[data-block-track*="CookieNotice"]',
    ".ModuleTemplateCookieIndicator",
    ".o--cookies--container",
    ".cookie-msg-info-container",
    "#cookies-policy-sticky"
  ],
  icelandicAbp: ['A[href^="/framework/resources/forms/ads.aspx"]'],
  latvian: [
    'a[href="http://www.salidzini.lv/"][style="display: block; width: 120px; height: 40px; overflow: hidden; position: relative;"]',
    'a[href="http://www.salidzini.lv/"][style="display: block; width: 88px; height: 31px; overflow: hidden; position: relative;"]'
  ],
  listKr: [
    'a[href*="//kingtoon.slnk.kr"]',
    'a[href*="//playdsb.com/kr"]',
    "div.logly-lift-adz",
    'div[data-widget_id="ml6EJ074"]',
    "ins.daum_ddn_area"
  ],
  listeAr: [
    ".geminiLB1Ad",
    ".right-and-left-sponsers",
    'a[href*=".aflam.info"]',
    'a[href*="booraq.org"]',
    'a[href*="dubizzle.com/ar/?utm_source="]'
  ],
  listeFr: [
    'a[href^="http://promo.vador.com/"]',
    "#adcontainer_recherche",
    'a[href*="weborama.fr/fcgi-bin/"]',
    ".site-pub-interstitiel",
    'div[id^="crt-"][data-criteo-id]'
  ],
  officialPolish: [
    "#ceneo-placeholder-ceneo-12",
    '[href^="https://aff.sendhub.pl/"]',
    'a[href^="http://advmanager.techfun.pl/redirect/"]',
    'a[href^="http://www.trizer.pl/?utm_source"]',
    "div#skapiec_ad"
  ],
  ro: [
    'a[href^="//afftrk.altex.ro/Counter/Click"]',
    'a[href^="/magazin/"]',
    'a[href^="https://blackfridaysales.ro/trk/shop/"]',
    'a[href^="https://event.2performant.com/events/click"]',
    'a[href^="https://l.profitshare.ro/"]'
  ],
  ruAd: [
    'a[href*="//febrare.ru/"]',
    'a[href*="//utimg.ru/"]',
    'a[href*="://chikidiki.ru"]',
    "#pgeldiz",
    ".yandex-rtb-block"
  ],
  thaiAds: ["a[href*=macau-uta-popup]", "#ads-google-middle_rectangle-group", ".ads300s", ".bumq", ".img-kosana"],
  webAnnoyancesUltralist: [
    "#mod-social-share-2",
    "#social-tools",
    ".ctpl-fullbanner",
    ".zergnet-recommend",
    ".yt.btn-link.btn-md.btn"
  ]
};
function getDomBlockers(_a2) {
  var debug2 = (_a2 === void 0 ? {} : _a2).debug;
  return __awaiter(this, void 0, void 0, function() {
    var filterNames, allSelectors, blockedSelectors, activeBlockers;
    var _b;
    return __generator(this, function(_c) {
      switch (_c.label) {
        case 0:
          if (!isApplicable()) {
            return [2, void 0];
          }
          filterNames = Object.keys(filters);
          allSelectors = (_b = []).concat.apply(_b, filterNames.map(function(filterName) {
            return filters[filterName];
          }));
          return [4, getBlockedSelectors(allSelectors)];
        case 1:
          blockedSelectors = _c.sent();
          if (debug2) {
            printDebug(blockedSelectors);
          }
          activeBlockers = filterNames.filter(function(filterName) {
            var selectors = filters[filterName];
            var blockedCount = countTruthy(selectors.map(function(selector) {
              return blockedSelectors[selector];
            }));
            return blockedCount > selectors.length * 0.6;
          });
          activeBlockers.sort();
          return [2, activeBlockers];
      }
    });
  });
}
function isApplicable() {
  return isWebKit() || isAndroid();
}
function getBlockedSelectors(selectors) {
  var _a2;
  return __awaiter(this, void 0, void 0, function() {
    var d2, root2, elements, blockedSelectors, i, element, holder, i;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          d2 = document;
          root2 = d2.createElement("div");
          elements = new Array(selectors.length);
          blockedSelectors = {};
          forceShow(root2);
          for (i = 0; i < selectors.length; ++i) {
            element = selectorToElement(selectors[i]);
            holder = d2.createElement("div");
            forceShow(holder);
            holder.appendChild(element);
            root2.appendChild(holder);
            elements[i] = element;
          }
          _b.label = 1;
        case 1:
          if (!!d2.body)
            return [3, 3];
          return [4, wait(50)];
        case 2:
          _b.sent();
          return [3, 1];
        case 3:
          d2.body.appendChild(root2);
          try {
            for (i = 0; i < selectors.length; ++i) {
              if (!elements[i].offsetParent) {
                blockedSelectors[selectors[i]] = true;
              }
            }
          } finally {
            (_a2 = root2.parentNode) === null || _a2 === void 0 ? void 0 : _a2.removeChild(root2);
          }
          return [2, blockedSelectors];
      }
    });
  });
}
function forceShow(element) {
  element.style.setProperty("display", "block", "important");
}
function printDebug(blockedSelectors) {
  var message = "DOM blockers debug:\n```";
  for (var _i = 0, _a2 = Object.keys(filters); _i < _a2.length; _i++) {
    var filterName = _a2[_i];
    message += "\n" + filterName + ":";
    for (var _b = 0, _c = filters[filterName]; _b < _c.length; _b++) {
      var selector = _c[_b];
      message += "\n  " + selector + " " + (blockedSelectors[selector] ? "\u{1F6AB}" : "\u27A1\uFE0F");
    }
  }
  console.log(message + "\n```");
}
function getColorGamut() {
  for (var _i = 0, _a2 = ["rec2020", "p3", "srgb"]; _i < _a2.length; _i++) {
    var gamut = _a2[_i];
    if (matchMedia("(color-gamut: " + gamut + ")").matches) {
      return gamut;
    }
  }
  return void 0;
}
function areColorsInverted() {
  if (doesMatch("inverted")) {
    return true;
  }
  if (doesMatch("none")) {
    return false;
  }
  return void 0;
}
function doesMatch(value) {
  return matchMedia("(inverted-colors: " + value + ")").matches;
}
function areColorsForced() {
  if (doesMatch$1("active")) {
    return true;
  }
  if (doesMatch$1("none")) {
    return false;
  }
  return void 0;
}
function doesMatch$1(value) {
  return matchMedia("(forced-colors: " + value + ")").matches;
}
var maxValueToCheck = 100;
function getMonochromeDepth() {
  if (!matchMedia("(min-monochrome: 0)").matches) {
    return void 0;
  }
  for (var i = 0; i <= maxValueToCheck; ++i) {
    if (matchMedia("(max-monochrome: " + i + ")").matches) {
      return i;
    }
  }
  throw new Error("Too high value");
}
function getContrastPreference() {
  if (doesMatch$2("no-preference")) {
    return 0;
  }
  if (doesMatch$2("high") || doesMatch$2("more")) {
    return 1;
  }
  if (doesMatch$2("low") || doesMatch$2("less")) {
    return -1;
  }
  if (doesMatch$2("forced")) {
    return 10;
  }
  return void 0;
}
function doesMatch$2(value) {
  return matchMedia("(prefers-contrast: " + value + ")").matches;
}
function isMotionReduced() {
  if (doesMatch$3("reduce")) {
    return true;
  }
  if (doesMatch$3("no-preference")) {
    return false;
  }
  return void 0;
}
function doesMatch$3(value) {
  return matchMedia("(prefers-reduced-motion: " + value + ")").matches;
}
function isHDR() {
  if (doesMatch$4("high")) {
    return true;
  }
  if (doesMatch$4("standard")) {
    return false;
  }
  return void 0;
}
function doesMatch$4(value) {
  return matchMedia("(dynamic-range: " + value + ")").matches;
}
var M = Math;
var fallbackFn = function() {
  return 0;
};
function getMathFingerprint() {
  var acos = M.acos || fallbackFn;
  var acosh = M.acosh || fallbackFn;
  var asin = M.asin || fallbackFn;
  var asinh = M.asinh || fallbackFn;
  var atanh = M.atanh || fallbackFn;
  var atan = M.atan || fallbackFn;
  var sin = M.sin || fallbackFn;
  var sinh = M.sinh || fallbackFn;
  var cos = M.cos || fallbackFn;
  var cosh = M.cosh || fallbackFn;
  var tan = M.tan || fallbackFn;
  var tanh = M.tanh || fallbackFn;
  var exp = M.exp || fallbackFn;
  var expm1 = M.expm1 || fallbackFn;
  var log1p = M.log1p || fallbackFn;
  var powPI = function(value) {
    return M.pow(M.PI, value);
  };
  var acoshPf = function(value) {
    return M.log(value + M.sqrt(value * value - 1));
  };
  var asinhPf = function(value) {
    return M.log(value + M.sqrt(value * value + 1));
  };
  var atanhPf = function(value) {
    return M.log((1 + value) / (1 - value)) / 2;
  };
  var sinhPf = function(value) {
    return M.exp(value) - 1 / M.exp(value) / 2;
  };
  var coshPf = function(value) {
    return (M.exp(value) + 1 / M.exp(value)) / 2;
  };
  var expm1Pf = function(value) {
    return M.exp(value) - 1;
  };
  var tanhPf = function(value) {
    return (M.exp(2 * value) - 1) / (M.exp(2 * value) + 1);
  };
  var log1pPf = function(value) {
    return M.log(1 + value);
  };
  return {
    acos: acos(0.12312423423423424),
    acosh: acosh(1e308),
    acoshPf: acoshPf(1e154),
    asin: asin(0.12312423423423424),
    asinh: asinh(1),
    asinhPf: asinhPf(1),
    atanh: atanh(0.5),
    atanhPf: atanhPf(0.5),
    atan: atan(0.5),
    sin: sin(-1e300),
    sinh: sinh(1),
    sinhPf: sinhPf(1),
    cos: cos(10.000000000123),
    cosh: cosh(1),
    coshPf: coshPf(1),
    tan: tan(-1e300),
    tanh: tanh(1),
    tanhPf: tanhPf(1),
    exp: exp(1),
    expm1: expm1(1),
    expm1Pf: expm1Pf(1),
    log1p: log1p(10),
    log1pPf: log1pPf(10),
    powPI: powPI(-100)
  };
}
var defaultText = "mmMwWLliI0fiflO&1";
var presets = {
  default: [],
  apple: [{ font: "-apple-system-body" }],
  serif: [{ fontFamily: "serif" }],
  sans: [{ fontFamily: "sans-serif" }],
  mono: [{ fontFamily: "monospace" }],
  min: [{ fontSize: "1px" }],
  system: [{ fontFamily: "system-ui" }]
};
function getFontPreferences() {
  return withNaturalFonts(function(document2, container) {
    var elements = {};
    var sizes = {};
    for (var _i = 0, _a2 = Object.keys(presets); _i < _a2.length; _i++) {
      var key = _a2[_i];
      var _b = presets[key], _c = _b[0], style = _c === void 0 ? {} : _c, _d = _b[1], text = _d === void 0 ? defaultText : _d;
      var element = document2.createElement("span");
      element.textContent = text;
      element.style.whiteSpace = "nowrap";
      for (var _e = 0, _f = Object.keys(style); _e < _f.length; _e++) {
        var name_1 = _f[_e];
        var value = style[name_1];
        if (value !== void 0) {
          element.style[name_1] = value;
        }
      }
      elements[key] = element;
      container.appendChild(document2.createElement("br"));
      container.appendChild(element);
    }
    for (var _g = 0, _h = Object.keys(presets); _g < _h.length; _g++) {
      var key = _h[_g];
      sizes[key] = elements[key].getBoundingClientRect().width;
    }
    return sizes;
  });
}
function withNaturalFonts(action, containerWidthPx) {
  if (containerWidthPx === void 0) {
    containerWidthPx = 4e3;
  }
  return withIframe(function(_2, iframeWindow) {
    var iframeDocument = iframeWindow.document;
    var iframeBody = iframeDocument.body;
    var bodyStyle = iframeBody.style;
    bodyStyle.width = containerWidthPx + "px";
    bodyStyle.webkitTextSizeAdjust = bodyStyle.textSizeAdjust = "none";
    if (isChromium()) {
      iframeBody.style.zoom = "" + 1 / iframeWindow.devicePixelRatio;
    } else if (isWebKit()) {
      iframeBody.style.zoom = "reset";
    }
    var linesOfText = iframeDocument.createElement("div");
    linesOfText.textContent = __spreadArrays(Array(containerWidthPx / 20 << 0)).map(function() {
      return "word";
    }).join(" ");
    iframeBody.appendChild(linesOfText);
    return action(iframeDocument, iframeBody);
  }, '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1">');
}
var sources = {
  fonts: getFonts,
  domBlockers: getDomBlockers,
  fontPreferences: getFontPreferences,
  audio: getAudioFingerprint,
  screenFrame: getRoundedScreenFrame,
  osCpu: getOsCpu,
  languages: getLanguages,
  colorDepth: getColorDepth,
  deviceMemory: getDeviceMemory,
  screenResolution: getScreenResolution,
  hardwareConcurrency: getHardwareConcurrency,
  timezone: getTimezone,
  sessionStorage: getSessionStorage,
  localStorage: getLocalStorage,
  indexedDB: getIndexedDB,
  openDatabase: getOpenDatabase,
  cpuClass: getCpuClass,
  platform: getPlatform,
  plugins: getPlugins,
  canvas: getCanvasFingerprint,
  touchSupport: getTouchSupport,
  vendor: getVendor,
  vendorFlavors: getVendorFlavors,
  cookiesEnabled: areCookiesEnabled,
  colorGamut: getColorGamut,
  invertedColors: areColorsInverted,
  forcedColors: areColorsForced,
  monochrome: getMonochromeDepth,
  contrast: getContrastPreference,
  reducedMotion: isMotionReduced,
  hdr: isHDR,
  math: getMathFingerprint
};
function loadBuiltinSources(options) {
  return loadSources(sources, options, []);
}
var commentTemplate = "$ if upgrade to Pro: https://fpjs.dev/pro";
function getConfidence(components) {
  var openConfidenceScore = getOpenConfidenceScore(components);
  var proConfidenceScore = deriveProConfidenceScore(openConfidenceScore);
  return { score: openConfidenceScore, comment: commentTemplate.replace(/\$/g, "" + proConfidenceScore) };
}
function getOpenConfidenceScore(components) {
  if (isAndroid()) {
    return 0.4;
  }
  if (isWebKit()) {
    return isDesktopSafari() ? 0.5 : 0.3;
  }
  var platform2 = components.platform.value || "";
  if (/^Win/.test(platform2)) {
    return 0.6;
  }
  if (/^Mac/.test(platform2)) {
    return 0.5;
  }
  return 0.7;
}
function deriveProConfidenceScore(openConfidenceScore) {
  return round$1(0.99 + 0.01 * openConfidenceScore, 1e-4);
}
function componentsToCanonicalString(components) {
  var result = "";
  for (var _i = 0, _a2 = Object.keys(components).sort(); _i < _a2.length; _i++) {
    var componentKey = _a2[_i];
    var component = components[componentKey];
    var value = component.error ? "error" : JSON.stringify(component.value);
    result += (result ? "|" : "") + componentKey.replace(/([:|\\])/g, "\\$1") + ":" + value;
  }
  return result;
}
function componentsToDebugString(components) {
  return JSON.stringify(components, function(_key, value) {
    if (value instanceof Error) {
      return errorToObject(value);
    }
    return value;
  }, 2);
}
function hashComponents(components) {
  return x64hash128(componentsToCanonicalString(components));
}
function makeLazyGetResult(components) {
  var visitorIdCache;
  var confidence = getConfidence(components);
  return {
    get visitorId() {
      if (visitorIdCache === void 0) {
        visitorIdCache = hashComponents(this.components);
      }
      return visitorIdCache;
    },
    set visitorId(visitorId) {
      visitorIdCache = visitorId;
    },
    confidence,
    components,
    version: version$1
  };
}
function prepareForSources(delayFallback) {
  if (delayFallback === void 0) {
    delayFallback = 50;
  }
  return requestIdleCallbackIfAvailable(delayFallback, delayFallback * 2);
}
function makeAgent(getComponents, debug2) {
  var creationTime = Date.now();
  return {
    get: function(options) {
      return __awaiter(this, void 0, void 0, function() {
        var startTime, components, result;
        return __generator(this, function(_a2) {
          switch (_a2.label) {
            case 0:
              startTime = Date.now();
              return [4, getComponents()];
            case 1:
              components = _a2.sent();
              result = makeLazyGetResult(components);
              if (debug2 || (options === null || options === void 0 ? void 0 : options.debug)) {
                console.log("Copy the text below to get the debug data:\n\n```\nversion: " + result.version + "\nuserAgent: " + navigator.userAgent + "\ntimeBetweenLoadAndGet: " + (startTime - creationTime) + "\nvisitorId: " + result.visitorId + "\ncomponents: " + componentsToDebugString(components) + "\n```");
              }
              return [2, result];
          }
        });
      });
    }
  };
}
function monitor() {
  if (window.__fpjs_d_m || Math.random() >= 0.01) {
    return;
  }
  try {
    var request3 = new XMLHttpRequest();
    request3.open("get", "https://openfpcdn.io/fingerprintjs/v" + version$1 + "/npm-monitoring", true);
    request3.send();
  } catch (error) {
    console.error(error);
  }
}
function load(_a2) {
  var _b = _a2 === void 0 ? {} : _a2, delayFallback = _b.delayFallback, debug2 = _b.debug, _c = _b.monitoring, monitoring = _c === void 0 ? true : _c;
  return __awaiter(this, void 0, void 0, function() {
    var getComponents;
    return __generator(this, function(_d) {
      switch (_d.label) {
        case 0:
          if (monitoring) {
            monitor();
          }
          return [4, prepareForSources(delayFallback)];
        case 1:
          _d.sent();
          getComponents = loadBuiltinSources({ debug: debug2 });
          return [2, makeAgent(getComponents, debug2)];
      }
    });
  });
}
const fpPromise = load();
let cacheHash = "";
function getDeviceUUID() {
  if (cacheHash)
    return Promise.resolve(cacheHash);
  return new Promise((resolve) => {
    const task2 = () => {
      fpPromise.then((fp) => fp.get()).then((result) => {
        cacheHash = result.visitorId;
        resolve(cacheHash);
      });
    };
    if (typeof requestIdleCallback !== "undefined") {
      requestIdleCallback(task2);
    } else {
      setTimeout(task2, 600);
    }
  });
}
function debounce$2(handle, time) {
  let starTime = new Date().getTime();
  let timeOut;
  return function dd2(...arg) {
    let nowTime = new Date().getTime();
    if (nowTime - starTime < time) {
      clearTimeout(timeOut);
    }
    starTime = nowTime;
    return new Promise((resolve) => {
      timeOut = setTimeout(() => {
        resolve(handle.call(this, ...arg));
      }, time);
    });
  };
}
function throttle(handle, time) {
  let starTime = performance.now();
  let first = true;
  let dd2 = debounce$2(handle, time);
  return function tt(...arg) {
    let nowTime = performance.now();
    if (nowTime - starTime >= time || first) {
      handle.call(this, ...arg);
      starTime = nowTime;
      first = false;
    } else {
      dd2.call(this, ...arg);
    }
  };
}
function on(eventName, cb, target, options) {
  if (!target.addEventListener) {
    console.warn("addEventListener is not exist");
    return () => null;
  }
  target.addEventListener(eventName, cb, options);
  return () => {
    target.removeEventListener(eventName, cb);
  };
}
function wrapEvent(e2, doc) {
  doc = doc || document;
  const value = Object.assign(Object.assign({}, e2), { timestamp: performance.now(), clienttime: Date.now(), isVisible: doc.visibilityState !== "hidden" });
  return value;
}
function getDayTimestamp(timestamp) {
  return new Date(new Date(timestamp).setHours(0, 0, 0, 0)).getTime();
}
var ObserverName;
(function(ObserverName2) {
  ObserverName2["mouseObserver"] = "mouseObserver";
  ObserverName2["scrollObserver"] = "scrollObserver";
  ObserverName2["keyboardObserver"] = "keyboardObserver";
  ObserverName2["pageChangeObserver"] = "pageChangeObserver";
})(ObserverName || (ObserverName = {}));
var EventType;
(function(EventType2) {
  EventType2[EventType2["interaction"] = 1] = "interaction";
  EventType2[EventType2["pageChange"] = 2] = "pageChange";
  EventType2[EventType2["statistic"] = 3] = "statistic";
})(EventType || (EventType = {}));
var InteractionType;
(function(InteractionType2) {
  InteractionType2[InteractionType2["mousemove"] = 0] = "mousemove";
  InteractionType2[InteractionType2["mouseup"] = 1] = "mouseup";
  InteractionType2[InteractionType2["mousedown"] = 2] = "mousedown";
  InteractionType2[InteractionType2["click"] = 3] = "click";
  InteractionType2[InteractionType2["contextmenu"] = 4] = "contextmenu";
  InteractionType2[InteractionType2["touchmove"] = 5] = "touchmove";
  InteractionType2[InteractionType2["touchstart"] = 6] = "touchstart";
  InteractionType2[InteractionType2["touchend"] = 7] = "touchend";
  InteractionType2[InteractionType2["drag"] = 8] = "drag";
  InteractionType2[InteractionType2["scroll"] = 9] = "scroll";
  InteractionType2[InteractionType2["keydown"] = 10] = "keydown";
  InteractionType2[InteractionType2["keyup"] = 11] = "keyup";
  InteractionType2[InteractionType2["custom"] = 12] = "custom";
})(InteractionType || (InteractionType = {}));
var StatisticEventType;
(function(StatisticEventType2) {
  StatisticEventType2[StatisticEventType2["activeDurationStart"] = 0] = "activeDurationStart";
  StatisticEventType2[StatisticEventType2["activeDuration"] = 1] = "activeDuration";
})(StatisticEventType || (StatisticEventType = {}));
var MouseInteractions;
(function(MouseInteractions2) {
  MouseInteractions2["mouseup"] = "mouseup";
  MouseInteractions2["mousedown"] = "mousedown";
  MouseInteractions2["click"] = "click";
  MouseInteractions2["contextmenu"] = "contextmenu";
  MouseInteractions2["touchstart"] = "touchstart";
  MouseInteractions2["touchend"] = "touchend";
})(MouseInteractions || (MouseInteractions = {}));
class MouseObserver {
  constructor(cb, { localWindow, doc }, options) {
    this.mouseInteractionObserver(cb, { localWindow, doc }, options === null || options === void 0 ? void 0 : options.disabledMap);
    this.mousemoveObserver(cb, { localWindow, doc }, options === null || options === void 0 ? void 0 : options.callbackThreshold);
  }
  static getEvent(mouseEventInfo) {
    return wrapEvent({
      type: EventType.interaction,
      data: Object.assign({}, mouseEventInfo)
    });
  }
  clear() {
    if (this.removeMoveObserver) {
      this.removeMoveObserver();
      this.removeMoveObserver = null;
    }
    if (this.removeInteractionObserver) {
      this.removeInteractionObserver();
      this.removeInteractionObserver = null;
    }
  }
  mouseInteractionObserver(cb, { doc }, disableMap) {
    const handlers = [];
    const getHandler = (eventKey) => {
      return (event) => {
        const eventData = window.TouchEvent && event instanceof window.TouchEvent ? event.changedTouches[0] : event;
        if (!eventData) {
          return;
        }
        const { clientX, clientY } = eventData;
        const interactionEventData = MouseObserver.getEvent({
          tag: InteractionType[eventKey],
          x: clientX,
          y: clientY
        });
        cb(interactionEventData);
      };
    };
    Object.values(MouseInteractions).filter((key) => !disableMap || !disableMap[key]).forEach((eventName) => {
      const handler = getHandler(eventName);
      handlers.push(on(eventName, handler, doc));
    });
    this.removeInteractionObserver = () => {
      handlers.forEach((h) => h());
    };
  }
  mousemoveObserver(cb, { doc }, callbackThreshold) {
    callbackThreshold = callbackThreshold || 300;
    const updatePosition = throttle((event) => {
      const isTouch = isTouchEvent(event);
      const { clientX, clientY } = isTouch ? event.changedTouches[0] : event;
      const actionType = event instanceof MouseEvent ? InteractionType.mousemove : isTouch ? InteractionType.touchmove : InteractionType.drag;
      const eventData = MouseObserver.getEvent({
        tag: actionType,
        x: clientX,
        y: clientY
      });
      cb(eventData);
    }, callbackThreshold);
    const handlers = [
      on("mousemove", updatePosition, doc),
      on("touchmove", updatePosition, doc),
      on("drag", updatePosition, doc)
    ];
    this.removeMoveObserver = () => {
      handlers.forEach((h) => h());
    };
  }
}
MouseObserver.recordName = ObserverName.mouseObserver;
function isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
class ScrollObserver {
  constructor(cb, { localWindow, doc }) {
    const updatePosition = throttle((evt) => {
      if (!evt.target)
        return;
      const scrollEl = evt.target === doc ? doc.scrollingElement || doc.documentElement : evt.target;
      const eventData = ScrollObserver.getEvent({
        x: scrollEl.scrollLeft,
        y: scrollEl.scrollTop
      });
      cb(eventData);
    }, 100);
    this.removeObserver = on("scroll", updatePosition, localWindow, true);
  }
  clear() {
    if (this.removeObserver) {
      this.removeObserver();
      this.removeObserver = null;
    }
  }
  static getEvent(scrollInfo) {
    return wrapEvent({
      type: EventType.interaction,
      data: Object.assign({ tag: InteractionType.scroll }, scrollInfo)
    });
  }
}
ScrollObserver.recordName = ObserverName.scrollObserver;
var KeyboardEventType;
(function(KeyboardEventType2) {
  KeyboardEventType2["keyup"] = "keyup";
  KeyboardEventType2["keydown"] = "keydown";
})(KeyboardEventType || (KeyboardEventType = {}));
class KeyboardObserver {
  constructor(cb, { localWindow }) {
    const getKeyboardInfoCb = (eventName) => {
      return (event) => {
        const eventData = KeyboardObserver.getEvent({
          tag: InteractionType[eventName],
          key: event.key
        });
        cb(eventData);
      };
    };
    const handlers = [
      on("keyup", getKeyboardInfoCb(KeyboardEventType.keyup), localWindow, true),
      on("keydown", getKeyboardInfoCb(KeyboardEventType.keydown), localWindow, true)
    ];
    this.removeObserver = () => {
      handlers.forEach((h) => h());
    };
  }
  clear() {
    if (this.removeObserver) {
      this.removeObserver();
      this.removeObserver = null;
    }
  }
  static getEvent(info2) {
    return wrapEvent({
      type: EventType.interaction,
      data: Object.assign({}, info2)
    });
  }
}
KeyboardObserver.recordName = ObserverName.keyboardObserver;
let groupId = 1;
class ObserverGroup {
  constructor({ doc = document, localWindow = window }, observeOptions) {
    this.emitEventNums = 0;
    this.id = 0;
    this.observerList = [];
    this.id = groupId;
    const observerCreaters = [MouseObserver, ScrollObserver, KeyboardObserver];
    observerCreaters.forEach((creater) => {
      const createrName = creater.recordName;
      observeOptions ? observeOptions[createrName] : null;
      this.addObserver(creater, { doc, localWindow });
    });
  }
  get observerId() {
    return this.id;
  }
  addObserver(observer, envInfo, options) {
    const cb = (event) => {
      this.emit(event);
    };
    this.observerList.push(new observer(cb, envInfo, options));
  }
  clear() {
    this.observerList.forEach((observer) => {
      observer.clear();
    });
    this.observerList = [];
  }
  on(callback) {
    if (typeof callback === "function") {
      this.listenerCallback = callback;
    } else {
      console.error(new Error("callback need a function"));
    }
  }
  emit(event) {
    this.emitEventNums++;
    if (this.listenerCallback)
      this.listenerCallback(event);
  }
  removeCb() {
    this.listenerCallback = null;
  }
}
class ObserverGroupMap {
  constructor() {
    this.emitEventNums = 0;
    this.groupMap = /* @__PURE__ */ new Map();
    this.listenerCallback = null;
  }
  decorateObserverEmit(observers) {
    const that = this;
    observers.emit = function(...arg) {
      this.emitEventNums++;
      if (typeof that.listenerCallback === "function") {
        that.listenerCallback(...arg);
      }
      ObserverGroup.prototype.emit.apply(this, arg);
    };
  }
  on(cb) {
    this.listenerCallback = cb;
  }
  create({ doc, localWindow }, observeOptions) {
    const newGroups = new ObserverGroup({ doc, localWindow }, observeOptions);
    const id2 = newGroups.observerId;
    this.groupMap.set(id2, newGroups);
    this.decorateObserverEmit(newGroups);
    return newGroups;
  }
  set(id2, observers) {
    this.groupMap.set(id2, observers);
    if (observers.emit === ObserverGroup.prototype.emit)
      return;
    this.decorateObserverEmit(observers);
  }
  delete(id2) {
    const observers = this.groupMap.get(id2);
    if (observers === null || observers === void 0 ? void 0 : observers.clear) {
      observers === null || observers === void 0 ? void 0 : observers.clear();
    }
    this.groupMap.delete(id2);
  }
  clear() {
    this.groupMap.forEach((observers) => {
      observers === null || observers === void 0 ? void 0 : observers.clear();
    });
    this.emitEventNums = 0;
    this.groupMap = /* @__PURE__ */ new Map();
  }
}
const globalObserversMap = new ObserverGroupMap();
var PageChangeType;
(function(PageChangeType2) {
  PageChangeType2["hashchange"] = "hashchange";
  PageChangeType2["pushState"] = "pushState";
  PageChangeType2["replaceState"] = "replaceState";
  PageChangeType2["popstate"] = "popstate";
})(PageChangeType || (PageChangeType = {}));
var UrlChangeType;
(function(UrlChangeType2) {
  UrlChangeType2[UrlChangeType2["no"] = 0] = "no";
  UrlChangeType2[UrlChangeType2["path"] = 1] = "path";
  UrlChangeType2[UrlChangeType2["hash"] = 2] = "hash";
  UrlChangeType2[UrlChangeType2["hashPath"] = 3] = "hashPath";
  UrlChangeType2[UrlChangeType2["hashQuery"] = 4] = "hashQuery";
  UrlChangeType2[UrlChangeType2["query"] = 5] = "query";
  UrlChangeType2[UrlChangeType2["error"] = 6] = "error";
})(UrlChangeType || (UrlChangeType = {}));
function getUrlChangeType(routeChangeEvent) {
  const { url: currentUrl, preUrl } = routeChangeEvent.data;
  const defaultUrl = window.location.origin;
  try {
    const currentUrlData = new URL(currentUrl || defaultUrl);
    const preUrlData = new URL(preUrl || defaultUrl);
    if (currentUrlData.pathname !== preUrlData.pathname)
      return UrlChangeType.path;
    if (currentUrlData.hash !== preUrlData.hash) {
      const isHashMode = /^#\//.test(currentUrlData.hash);
      if (!isHashMode)
        return UrlChangeType.hash;
      return compareHashMode(currentUrlData.hash, preUrlData.hash);
    }
    if (currentUrlData.search !== preUrlData.search)
      return UrlChangeType.query;
  } catch (e2) {
    return UrlChangeType.error;
  }
  return UrlChangeType.no;
}
class RouteObserver {
  constructor(cb, { localWindow }) {
    this.pageIndex = 1;
    this.preUrl = "";
    this.preUrl = localWindow.location.href;
    wrapHistoryMethod(PageChangeType.pushState, localWindow);
    wrapHistoryMethod(PageChangeType.replaceState, localWindow);
    const getPageInfoCb = (eventName) => {
      return () => {
        const eventData = RouteObserver.getEvent({
          type: PageChangeType[eventName],
          url: localWindow.location.href,
          preUrl: this.preUrl,
          index: this.pageIndex
        });
        this.preUrl = localWindow.location.href;
        this.pageIndex++;
        cb(eventData);
      };
    };
    const handlers = [
      on("hashchange", getPageInfoCb(PageChangeType.hashchange), localWindow),
      on("pushState", getPageInfoCb(PageChangeType.pushState), localWindow),
      on("replaceState", getPageInfoCb(PageChangeType.replaceState), localWindow),
      on("popstate", getPageInfoCb(PageChangeType.popstate), localWindow)
    ];
    this.removeObserver = () => {
      handlers.forEach((h) => h());
    };
  }
  clear() {
    if (this.removeObserver) {
      this.removeObserver();
      this.removeObserver = null;
    }
  }
  static getEvent(info2) {
    return wrapEvent({
      type: EventType.pageChange,
      data: Object.assign({}, info2)
    });
  }
}
RouteObserver.recordName = ObserverName.pageChangeObserver;
function wrapHistoryMethod(methodName, localWindow) {
  if (!localWindow.__mastergo_origin_change) {
    localWindow.__mastergo_origin_change = {};
  }
  if (localWindow.__mastergo_origin_change[methodName])
    return;
  const oringinMethod = localWindow === null || localWindow === void 0 ? void 0 : localWindow.history[methodName];
  localWindow.history[methodName] = function mastergoPushState(...arg) {
    const res = oringinMethod.apply(this, arg);
    const e2 = new Event(methodName);
    localWindow.dispatchEvent(e2);
    return res;
  };
  localWindow.__mastergo_origin_change[methodName] = true;
}
function compareHashMode(currentHash, preHash) {
  const defaultPreStr = window.location.origin;
  try {
    currentHash = currentHash.replace(/^#/, "");
    preHash = preHash.replace(/^#/, "");
    const currentHashData = new URL(defaultPreStr + currentHash);
    const preHashData = new URL(defaultPreStr + preHash);
    if (currentHashData.pathname !== preHashData.pathname)
      return UrlChangeType.hashPath;
    if (currentHashData.search !== preHashData.search)
      return UrlChangeType.hashQuery;
  } catch (e2) {
    return UrlChangeType.error;
  }
  return UrlChangeType.hash;
}
const DEFAULT_ACTIVE_TIME_THRESHOLD = 3 * 60 * 1e3;
var ActiveStartType;
(function(ActiveStartType2) {
  ActiveStartType2[ActiveStartType2["default"] = 0] = "default";
  ActiveStartType2[ActiveStartType2["overDay"] = 1] = "overDay";
})(ActiveStartType || (ActiveStartType = {}));
var ActiveEndType;
(function(ActiveEndType2) {
  ActiveEndType2[ActiveEndType2["overTime"] = 0] = "overTime";
  ActiveEndType2[ActiveEndType2["overDay"] = 1] = "overDay";
  ActiveEndType2[ActiveEndType2["pageChange"] = 2] = "pageChange";
  ActiveEndType2[ActiveEndType2["pageClose"] = 3] = "pageClose";
})(ActiveEndType || (ActiveEndType = {}));
class ActiveStatistic {
  constructor(options) {
    this.recordIndex = 0;
    this.currentActiveTimes = null;
    this.activeTimeThreshold = DEFAULT_ACTIVE_TIME_THRESHOLD;
    const { threshold, callback } = options || {};
    this.activeTimeThreshold = threshold || DEFAULT_ACTIVE_TIME_THRESHOLD;
    if (callback) {
      this.on(callback);
    }
    window.addEventListener("beforeunload", () => {
      this.creatActiveDurationEvent(ActiveEndType.pageClose);
    });
  }
  on(cb) {
    if (typeof cb === "function") {
      this.callback = cb;
    }
  }
  tracking(event) {
    const isActive = this.isActiveEvent(event);
    const isPageEvent = this.isPageChange(event);
    if (!isActive && !isPageEvent)
      return;
    const eventBirthTime = event.timestamp;
    if (!this.currentActiveTimes && isActive) {
      this.creatActiveStartEvent(eventBirthTime, eventBirthTime, ActiveStartType.default);
      return;
    }
    if (!this.currentActiveTimes)
      return;
    const isOverKeepTimeThreshold = this.isOverTimeThreshold(eventBirthTime);
    if (isOverKeepTimeThreshold) {
      this.finishWithOverTime(eventBirthTime);
      return;
    }
    if (isPageEvent) {
      this.finishWithPageChange(eventBirthTime);
      return;
    }
    this.setEndTime(eventBirthTime);
  }
  clearRecord() {
    const hasRecord = this.currentActiveTimes;
    this.currentActiveTimes = null;
    return hasRecord;
  }
  createActiveItem(startTime, endTime, startIndex) {
    this.recordIndex++;
    return {
      index: this.recordIndex,
      startIndex: startIndex || this.recordIndex,
      startTime,
      endTime,
      pageUrl: window.location.href
    };
  }
  creatActiveStartEvent(startTime, endTime, startType) {
    this.currentActiveTimes = this.createActiveItem(startTime, endTime);
    const startEvent = {
      type: EventType.statistic,
      data: {
        tag: StatisticEventType.activeDurationStart,
        info: Object.assign({}, this.currentActiveTimes),
        startType
      },
      timestamp: this.currentActiveTimes.startTime
    };
    this.pipe(startEvent);
  }
  creatActiveDurationEvent(endType) {
    if (!this.currentActiveTimes)
      return;
    const { startTime, endTime, startIndex } = this.currentActiveTimes;
    let durationPords = [Object.assign({}, this.currentActiveTimes)];
    if (this.isOverDay()) {
      const dayTimestamp = getDayTimestamp(endTime);
      const secendActiveTimes = this.createActiveItem(dayTimestamp, endTime, startIndex);
      this.currentActiveTimes.endTime = dayTimestamp;
      durationPords = [Object.assign({}, this.currentActiveTimes), secendActiveTimes];
    }
    durationPords.forEach((info2) => {
      const endEvent = {
        type: EventType.statistic,
        data: {
          tag: StatisticEventType.activeDuration,
          info: info2,
          endType
        },
        timestamp: info2.endTime
      };
      this.pipe(endEvent);
    });
    this.currentActiveTimes = null;
  }
  pipe(data2) {
    if (this.callback) {
      this.callback(data2);
    }
    return data2;
  }
  isPageChange(event) {
    if (event.type !== EventType.pageChange)
      return false;
    const routeChangeType = getUrlChangeType(event);
    return routeChangeType === UrlChangeType.path || routeChangeType === UrlChangeType.hashPath;
  }
  isActiveEvent(event) {
    return event.type === EventType.interaction && event.isVisible;
  }
  isOverDay() {
    const { startTime, endTime } = this.currentActiveTimes;
    return new Date(startTime).getDate() !== new Date(endTime).getDate();
  }
  isOverTimeThreshold(keepTime) {
    const lastTime = this.currentActiveTimes.endTime;
    return keepTime - lastTime > this.activeTimeThreshold;
  }
  setEndTime(timestamp) {
    if (!this.currentActiveTimes)
      return;
    const { startTime, endTime } = this.currentActiveTimes;
    if (timestamp < startTime || timestamp < endTime)
      return;
    this.currentActiveTimes.endTime = timestamp;
  }
  finishWithOverTime(endTime) {
    this.creatActiveDurationEvent(ActiveEndType.overTime);
    this.creatActiveStartEvent(endTime, endTime, ActiveStartType.default);
  }
  finishWithPageChange(endTime) {
    if (!this.currentActiveTimes)
      return;
    this.currentActiveTimes.endTime = endTime;
    this.creatActiveDurationEvent(ActiveEndType.pageChange);
  }
}
const fetchOrigin = window.fetch.fetchOrigin || window.fetch;
var FetchMethod;
(function(FetchMethod2) {
  FetchMethod2["post"] = "POST";
  FetchMethod2["get"] = "GET";
  FetchMethod2["put"] = "PUT";
  FetchMethod2["del"] = "DELETE";
})(FetchMethod || (FetchMethod = {}));
const DEFAULT_TIMEOUT = 60 * 1e3;
const DEFAULT_FETCH_MODE = "cors";
const DEFAULT_FETCH_METHOD = FetchMethod.get;
const DEFAULT_HEADERS = {
  "Content-Type": "application/json"
};
function fetchRequest(url, options) {
  if (!url) {
    return Promise.resolve(null);
  }
  const reqUrl = new URL(url, location.origin);
  options = options || {};
  const timeout = options.timeout || DEFAULT_TIMEOUT;
  const setQuerys = options.query || {};
  Object.keys(setQuerys).forEach((key) => {
    reqUrl.searchParams.set(key, setQuerys[key]);
  });
  let bodyString = "";
  try {
    bodyString = JSON.stringify(options.body || null);
  } catch (err) {
    return Promise.resolve(null);
  }
  const method = options.method || DEFAULT_FETCH_METHOD;
  bodyString = method === "GET" ? void 0 : bodyString;
  return new Promise((rs) => {
    const reqTimeOut = setTimeout(() => {
      console.error("fetch is timeout:", reqUrl.href);
      rs(null);
    }, timeout);
    fetchOrigin(reqUrl.href, {
      mode: (options === null || options === void 0 ? void 0 : options.mode) || DEFAULT_FETCH_MODE,
      headers: Object.assign(Object.assign({}, DEFAULT_HEADERS), options === null || options === void 0 ? void 0 : options.headers),
      body: bodyString,
      method
    }).then((response) => {
      clearTimeout(reqTimeOut);
      if (response.status !== 200)
        return Promise.reject("Fetch Error:" + response.status);
      rs(response.json());
    }).catch((err) => {
      console.error(err);
      clearTimeout(reqTimeOut);
      rs(null);
    });
  });
}
function fetchGet(url, params, options) {
  options = options || {};
  options.method = FetchMethod.get;
  options.query = params;
  return fetchRequest(url, options);
}
const GET_SERVER_TIME = "/et/t";
const TRY_INTEVALS = [0, 2 * 1e3, 10 * 1e3, 30 * 1e3, 60 * 1e3, 10 * 60 * 1e3, 30 * 60 * 1e3];
const OPERATOR = 0.5;
const MAX_DEVIATION = 10 * 1e3;
function fetchCurrentServerTime() {
  const t1 = performance.now();
  return fetchGet(GET_SERVER_TIME, {}, { timeout: MAX_DEVIATION * 2 }).then((res) => {
    if (!res || res.code !== "ok")
      return null;
    const t2 = res.data.time;
    const t3 = performance.now();
    const reqTime = t3 - t1;
    const span = Math.round(reqTime * OPERATOR);
    if (span > MAX_DEVIATION)
      return null;
    return { currentServerTime: t2 + span, pageNowTime: t3 };
  });
}
function timerFetch(time) {
  if (!time)
    return fetchCurrentServerTime();
  return new Promise((resolve) => {
    setTimeout(() => {
      fetchCurrentServerTime().then((res) => {
        resolve(res);
      });
    }, time);
  });
}
function getServerTime$1() {
  return __awaiter(this, void 0, void 0, function* () {
    let l = TRY_INTEVALS.length;
    for (let i = 0; i < l; i++) {
      const res = yield timerFetch(TRY_INTEVALS[i]);
      if (res)
        return res;
    }
    return { currentServerTime: new Date().getTime(), pageNowTime: performance.now() };
  });
}
const ALLOWED_DEVIATION_THRESHOLD = 10 * 1e3;
class TimeSynchronizationManager {
  constructor() {
    this._startServerTime = 0;
    this._startBrowerTime = 0;
    this._sleepTime = 0;
    this._BrowerChangeTime = 0;
    this._loading = this.init().then(() => {
      this._loading = false;
      return true;
    });
  }
  get ready() {
    return this._loading;
  }
  init() {
    return __awaiter(this, void 0, void 0, function* () {
      const { currentServerTime, pageNowTime } = yield getServerTime$1();
      this._startServerTime = currentServerTime - pageNowTime;
      this._startBrowerTime = new Date().getTime() - performance.now();
    });
  }
  getSleepTime(currentServerTime, pageNowTime) {
    return currentServerTime - pageNowTime - this._startServerTime;
  }
  getBrowerTimeDeviation() {
    const nowPerformanceTime = performance.now();
    const nowTime = new Date().getTime();
    return nowTime - nowPerformanceTime - this._startBrowerTime - this._BrowerChangeTime - this._sleepTime;
  }
  checkTimeValid() {
    const timeTeviation = this.getBrowerTimeDeviation();
    return timeTeviation < ALLOWED_DEVIATION_THRESHOLD;
  }
  timeSynchronization() {
    return __awaiter(this, void 0, void 0, function* () {
      const { currentServerTime, pageNowTime } = yield getServerTime$1();
      const newSleepTime = this.getSleepTime(currentServerTime, pageNowTime);
      const sleepTimeDeviation = newSleepTime - this._sleepTime;
      const hasSleep = sleepTimeDeviation > ALLOWED_DEVIATION_THRESHOLD;
      if (hasSleep) {
        this._sleepTime = newSleepTime;
      }
      const changeTimeTeviation = this.getBrowerTimeDeviation();
      if (changeTimeTeviation > ALLOWED_DEVIATION_THRESHOLD) {
        this._BrowerChangeTime += changeTimeTeviation;
      }
      this._loading = false;
      return hasSleep;
    });
  }
  loadingServeTime() {
    const notNeedFix = this.checkTimeValid();
    if (notNeedFix)
      return false;
    if (this._loading)
      return this._loading;
    this._loading = this.timeSynchronization();
    return this._loading;
  }
  getServerTime(performanceTime) {
    performanceTime = performanceTime === void 0 ? performance.now() : performanceTime;
    const serverTimestamp = performanceTime + this._sleepTime + this._startServerTime;
    return Math.ceil(serverTimestamp);
  }
  get startServerTime() {
    return this._startServerTime;
  }
  get sleepTimePerformaceNow() {
    return performance.now() + this._sleepTime;
  }
  get sleepTime() {
    return this._sleepTime;
  }
}
const timeSynchronizationGlobal = new TimeSynchronizationManager();
const getServerTime = timeSynchronizationGlobal.getServerTime.bind(timeSynchronizationGlobal);
const DEFAULT_LIMIT = 1e5;
class AddTimeManager {
  constructor(queueLimit, cb) {
    this.castId = -1;
    this.id = 0;
    this.timeWaitQueue = /* @__PURE__ */ new Map();
    this.isClearing = false;
    this.max = DEFAULT_LIMIT;
    this.max = queueLimit || DEFAULT_LIMIT;
    if (cb) {
      this.callback = cb;
    }
  }
  get queueLength() {
    return this.id - this.castId - 1;
  }
  on(cb) {
    this.callback = cb;
  }
  add(dataHandle) {
    if (typeof dataHandle !== "function") {
      console.error("time add need function");
      return;
    }
    if (this.max < this.queueLength) {
      this.overLimit();
      return;
    }
    this.timeWaitQueue.set(this.id, dataHandle);
    this.id++;
    this.clearQueue();
  }
  clearQueue() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.isClearing)
        return;
      this.isClearing = true;
      const dateIsLoading = timeSynchronizationGlobal.loadingServeTime();
      if (dateIsLoading) {
        yield dateIsLoading;
      }
      while (this.queueLength) {
        this.castWait();
      }
      this.isClearing = false;
    });
  }
  castWait() {
    this.castId++;
    const dataHandle = this.timeWaitQueue.get(this.castId);
    if (typeof dataHandle === "function") {
      const data2 = dataHandle(getServerTime);
      this.pipe(data2);
    }
    this.timeWaitQueue.delete(this.castId);
  }
  pipe(data2) {
    if (typeof this.callback === "function") {
      this.callback(data2);
    }
    return data2;
  }
  overLimit() {
    return;
  }
}
class InteractionRecord {
  constructor() {
    this.addTime = new AddTimeManager();
    this.activeTimeCreater = new ActiveStatistic();
    this.isObserving = false;
  }
  actionEventHandle(event) {
    this.addTime.add((getServerTime2) => {
      event.timestamp = getServerTime2(event.timestamp);
      return event;
    });
  }
  start() {
    if (this.isObserving) {
      console.warn("record has start observer, retry after stoped");
      return;
    }
    this.addTime.on((event) => {
      this.activeTimeCreater.tracking(event);
      if (this.actionEventCallback) {
        this.actionEventCallback(event);
      }
    });
    this.activeTimeCreater.on((activeTimeRecord) => {
      if (this.statisticEventCallback) {
        this.statisticEventCallback(activeTimeRecord);
      }
    });
    const mainEnv = { doc: document, localWindow: window };
    globalObserversMap.on(this.actionEventHandle.bind(this));
    const mainObserverGroup = globalObserversMap.create(mainEnv);
    mainObserverGroup.addObserver(RouteObserver, mainEnv);
    this.isObserving = true;
  }
  stop() {
    globalObserversMap.clear();
    this.isObserving = false;
  }
  onAction(cb) {
    if (typeof cb === "function") {
      this.actionEventCallback = cb;
    }
  }
  onStatistic(cb) {
    if (typeof cb === "function") {
      this.statisticEventCallback = cb;
    }
  }
}
const globalInteractionRecord = new InteractionRecord();
class SensorsSdk {
  constructor(options) {
    this.url = "";
    this.trackSinglePage = true;
    this.showLog = false;
    this.clickMap = "not_collect";
    this.scrollNOticeMap = "not_collect";
    this.sessionTime = 0;
    this.deviceHash = "";
    this.hasStartRecord = false;
    if (!options) {
      return;
    }
    this.url = options.url || "";
    this.trackSinglePage = options.trackSinglePage;
    this.showLog = options.showLog;
    this.clickMap = options.clickMap;
    this.scrollNOticeMap = options.scrollNOticeMap;
    this.init();
  }
  init() {
    sensors$1.init({
      server_url: this.url,
      is_track_single_page: this.trackSinglePage,
      use_client_time: true,
      send_type: "beacon",
      show_log: this.showLog,
      cross_subdomain: false
    });
    this.setDeviceId();
    this.initPublic();
  }
  startActiveObsever(options) {
    const { statistic, action } = options || {};
    if (this.hasStartRecord)
      return globalInteractionRecord;
    globalInteractionRecord.start();
    this.hasStartRecord = true;
    if (action) {
      globalInteractionRecord.onAction(action);
    }
    if (statistic) {
      globalInteractionRecord.onStatistic(statistic);
    }
    return globalInteractionRecord;
  }
  initPublic() {
    const info2 = hostInfo();
    this.setPublic({
      session_id: Tools.getUuid(),
      data_source: "frontend",
      operation_sysatem: info2.os.name,
      os_version: info2.os.version,
      browser: info2.browser.name
    });
  }
  setDeviceId() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.deviceHash) {
        return this.deviceHash;
      }
      const deviceId = yield getDeviceUUID();
      this.deviceHash = deviceId;
      api$1.set("_mg_cd_uid", deviceId);
      this.setPublic({
        device_hash: deviceId
      });
      return this.deviceHash;
    });
  }
  getDeviceId() {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.deviceHash) {
        return this.deviceHash;
      }
      return yield this.setDeviceId();
    });
  }
  setPublic(obj) {
    if (!Tools.isOnlyObject(obj)) {
      console.error("setPublic arguments must be objects");
      return;
    }
    sensors$1.registerPage(obj);
  }
  setProfile(obj) {
    if (!Tools.isOnlyObject(obj)) {
      console.error("setProfile arguments must be objects");
      return;
    }
    sensors$1.setProfile(obj);
  }
  quick() {
    sensors$1.quick("isReady", () => {
      sensors$1.getPresetProperties();
    });
  }
  track(eventName, obj) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!eventName) {
        console.error("eventName cannot be empty");
        return;
      }
      yield this.setDeviceId();
      const time = Date.now();
      if (time - this.sessionTime > 1e3 * 60 * 30) {
        this.setPublic({
          session_id: Tools.getUuid()
        });
        this.sessionTime = time;
      }
      sensors$1.track(eventName, obj);
    });
  }
}
const sensorConfig = {
  url: `${window.location.origin}/et/event/sa`,
  showLog: false
};
if (window.location.search.includes("showlog=true")) {
  sensorConfig.showLog = true;
}
if (window.location.hash.includes("showlog=true")) {
  sensorConfig.showLog = true;
}
if (window.location.search.includes("showlog=false")) {
  sensorConfig.showLog = false;
}
const noop$1 = () => {
};
const hostList = ["mastergo.com", "dev.mastergo.com", "pre.mastergo.com"];
let sensorsInner = null;
if (hostList.includes(window.location.hostname)) {
  sensorsInner = new SensorsSdk(sensorConfig);
} else {
  sensorsInner = {
    track: noop$1,
    setPublic: noop$1,
    startActiveObsever: noop$1
  };
}
const sensors = sensorsInner;
const sendLog = (actionType = "", actionDetail = "") => {
  if (!actionType)
    return;
  sensors.track("ocpc", {
    action_type: actionType,
    action_detail: actionDetail
  });
};
const store = new Dexie$1("login_plugin_store");
store.version(1).stores({
  drainageData: "id,data"
});
store.open();
async function setStore(name2, data2) {
  const table = store[name2];
  if (!table)
    return;
  await table.put(data2);
}
async function getStore(name2, key) {
  const table = store[name2];
  if (!table)
    return;
  return await table.get(key);
}
async function deleteStore(name2, id2) {
  const table = store[name2];
  if (!table)
    return;
  await table.delete(id2);
}
async function setDrainageData(value) {
  sendLog("save_start", value);
  await setStore("drainageData", { id: 1, data: value });
  sendLog("save_success", value);
}
async function getDrainageData() {
  const res = await getStore("drainageData", 1);
  const value = res ? res.data : "";
  sendLog("get", value);
  return value;
}
async function removeDrainageData() {
  await deleteStore("drainageData", 1);
  sendLog("remove");
}
function filterUTM() {
  const utm = getUrlData([...UTM_TERM]);
  if (Object.keys(utm).length) {
    setSessionStorageItem(SESSION_KEYS.UTM_ITEM, JSON.stringify(utm));
  }
}
function filterPromote() {
  const key = Object.keys(PROMOTE).find((item) => getUrlValue$1(item));
  if (!key)
    return;
  const promote = {
    detail: {
      logidUrl: document.location.href
    },
    advType: PROMOTE[key]
  };
  setDrainageData(JSON.stringify(promote));
}
function filterGenSign() {
  const genSignKey = "gen_sign";
  const genSign = getUrlValue$1(genSignKey);
  if (genSign) {
    setSessionStorageItem(SESSION_KEYS.GEN_SIGN, genSign);
    deleteUrlQuery(genSignKey);
  }
}
function filterWechatCode() {
  const isFromLinkedin = getSessionStorageItem$1(SESSION_KEYS.LOGIN_FROM) === "linkedin";
  const weChatCodeKey = "code";
  const weChatCode = getUrlValue$1(weChatCodeKey);
  const state = getUrlValue$1("state");
  if (weChatCode && state !== "DingDingOAuth" && !isFromLinkedin) {
    setSessionStorageItem(SESSION_KEYS.WECHAT_CODE, weChatCode);
    deleteUrlQuery(weChatCodeKey);
  }
}
function filterSlackCode() {
  if (!window.location.pathname.includes("slack"))
    return;
  const slackCodeKey = "code";
  const slackCode = getUrlValue$1(slackCodeKey);
  if (slackCode) {
    setSessionStorageItem(SESSION_KEYS.SLACK_CODE, slackCode);
    deleteUrlQuery(slackCodeKey);
  }
}
function filterLinkedinCode() {
  const isFromLinkedin = getSessionStorageItem$1(SESSION_KEYS.LOGIN_FROM) === "linkedin";
  if (!isFromLinkedin)
    return;
  const linkedinCodeKey = "code";
  const linkedinCode = getUrlValue$1(linkedinCodeKey);
  if (linkedinCode) {
    setSessionStorageItem(SESSION_KEYS.LINKEDIN_CODE, linkedinCode);
    deleteUrlQuery(linkedinCodeKey);
  }
}
function filterDingDingCode() {
  const dingDingCodeKey = "code";
  const dingDingCode = getUrlValue$1(dingDingCodeKey);
  const dingDingAuthCodeKey = "authCode";
  const dingDingAuthCode = getUrlValue$1(dingDingAuthCodeKey);
  const code = dingDingAuthCode || dingDingCode;
  const dingDingStateKey = "state";
  const dingDingState = getUrlValue$1(dingDingStateKey);
  if (dingDingState === "DingDingOAuth") {
    log$1.info("ding ding auth code: ", code);
    setSessionStorageItem(SESSION_KEYS.DING_DING_OAUTH_CODE, code);
    deleteUrlQuery(dingDingAuthCodeKey);
    deleteUrlQuery(dingDingCodeKey);
  }
}
function filterDingJumpCode() {
  const dingAuthCodeKey = "dingAuthCode";
  const dingAuthCode = getUrlValue$1(dingAuthCodeKey);
  if (dingAuthCode) {
    setSessionStorageItem(SESSION_KEYS.DING_JUMP_AUTH_CODE, dingAuthCode);
    deleteUrlQuery(dingAuthCodeKey);
  }
}
function setWecomCode() {
  const isWecomBind = getUrlValue$1("isWecomBind");
  const isWecom = getUrlValue$1("isWecom");
  const hasWecomCode = getUrlValue$1("code");
  if ((isWecomBind || isWecom) && hasWecomCode) {
    setSessionStorageItem(SESSION_KEYS.WECOM_CODE, hasWecomCode);
    deleteUrlQuery("code");
  }
}
function setInviteToken() {
  const source2 = getUrlValue$1("source");
  const fileId = getPathId("file");
  const inviteMemberId = getPathId("invite-member");
  const documentInvite = getUrlValue$1("inviteDocumentId");
  const inviteBatchId = getUrlValue$1("inviteBatchId");
  const teamInvite = getUrlValue$1("inviteTeamId");
  const inviteOrganizationId = getUrlValue$1("inviteOrganizationId");
  const inviteProjectId = getUrlValue$1("inviteProjectId");
  const tokenList = [];
  if (teamInvite) {
    tokenList[0] = 1;
    tokenList[1] = teamInvite;
  } else if (documentInvite) {
    tokenList[0] = 1;
    tokenList[1] = documentInvite;
  } else if (inviteMemberId) {
    tokenList[0] = 2;
    tokenList[1] = inviteMemberId;
  } else if (source2 && fileId) {
    tokenList[0] = 3;
    tokenList[1] = fileId;
  }
  if (inviteBatchId) {
    tokenList[0] = 4;
    tokenList[2] = inviteBatchId;
  }
  if (inviteOrganizationId) {
    tokenList[0] = 5;
    tokenList[1] = inviteOrganizationId;
  }
  if (inviteProjectId) {
    tokenList[0] = 7;
    tokenList[1] = inviteProjectId;
  }
  if (tokenList.length) {
    setSessionStorageItem(SESSION_KEYS.INVITE_TOKEN, tokenList.join("_"));
  }
}
function filterSubToken() {
  const subToken = getUrlValue$1("subToken");
  if (subToken) {
    setSessionStorageItem(SESSION_KEYS.WECHAT_LOGIN_START, subToken);
  }
}
function filterSamlCode() {
  const key = "errcode";
  const code = getUrlValue$1(key);
  if (code) {
    setSessionStorageItem(SESSION_KEYS.SAML_CODE, code);
    deleteUrlQuery(key);
  }
}
function filterPrivateCode() {
  const key = "private_code";
  const code = getUrlValue$1(key);
  if (code) {
    setSessionStorageItem(SESSION_KEYS.PRIVATE_CODE, code);
    deleteUrlQuery(key);
  }
}
function setLoginData() {
  setWecomCode();
  filterDingJumpCode();
  filterUTM();
  filterPromote();
  filterGenSign();
  filterWechatCode();
  filterDingDingCode();
  setInviteToken();
  filterSubToken();
  filterSamlCode();
  filterPrivateCode();
}
function setLoginDataI18N() {
  filterUTM();
  filterPromote();
  filterSlackCode();
  setInviteToken();
  filterLinkedinCode();
}
var axios$2 = { exports: {} };
var bind$4 = function bind(fn2, thisArg) {
  return function wrap2() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn2.apply(thisArg, args);
  };
};
var bind$3 = bind$4;
var toString = Object.prototype.toString;
function isArray(val) {
  return Array.isArray(val);
}
function isUndefined(val) {
  return typeof val === "undefined";
}
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
function isArrayBuffer(val) {
  return toString.call(val) === "[object ArrayBuffer]";
}
function isFormData(val) {
  return toString.call(val) === "[object FormData]";
}
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result;
}
function isString(val) {
  return typeof val === "string";
}
function isNumber(val) {
  return typeof val === "number";
}
function isObject(val) {
  return val !== null && typeof val === "object";
}
function isPlainObject(val) {
  if (toString.call(val) !== "[object Object]") {
    return false;
  }
  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}
function isDate(val) {
  return toString.call(val) === "[object Date]";
}
function isFile(val) {
  return toString.call(val) === "[object File]";
}
function isBlob(val) {
  return toString.call(val) === "[object Blob]";
}
function isFunction(val) {
  return toString.call(val) === "[object Function]";
}
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}
function isURLSearchParams(val) {
  return toString.call(val) === "[object URLSearchParams]";
}
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
function isStandardBrowserEnv() {
  if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
    return false;
  }
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function forEach(obj, fn2) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      fn2.call(null, obj[i], i, obj);
    }
  } else {
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn2.call(null, obj[key], key, obj);
      }
    }
  }
}
function merge() {
  var result = {};
  function assignValue2(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue2);
  }
  return result;
}
function extend(a2, b2, thisArg) {
  forEach(b2, function assignValue2(val, key) {
    if (thisArg && typeof val === "function") {
      a2[key] = bind$3(val, thisArg);
    } else {
      a2[key] = val;
    }
  });
  return a2;
}
function stripBOM(content) {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
}
var utils$f = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isObject,
  isPlainObject,
  isUndefined,
  isDate,
  isFile,
  isBlob,
  isFunction,
  isStream,
  isURLSearchParams,
  isStandardBrowserEnv,
  forEach,
  merge,
  extend,
  trim,
  stripBOM
};
var utils$e = utils$f;
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$e.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils$e.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === "undefined") {
        return;
      }
      if (utils$e.isArray(val)) {
        key = key + "[]";
      } else {
        val = [val];
      }
      utils$e.forEach(val, function parseValue(v) {
        if (utils$e.isDate(v)) {
          v = v.toISOString();
        } else if (utils$e.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + "=" + encode(v));
      });
    });
    serializedParams = parts.join("&");
  }
  if (serializedParams) {
    var hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
};
var utils$d = utils$f;
function InterceptorManager$1() {
  this.handlers = [];
}
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled,
    rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};
InterceptorManager$1.prototype.eject = function eject(id2) {
  if (this.handlers[id2]) {
    this.handlers[id2] = null;
  }
};
InterceptorManager$1.prototype.forEach = function forEach2(fn2) {
  utils$d.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn2(h);
    }
  });
};
var InterceptorManager_1 = InterceptorManager$1;
var utils$c = utils$f;
var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$c.forEach(headers, function processHeader(value, name2) {
    if (name2 !== normalizedName && name2.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name2];
    }
  });
};
var enhanceError$2 = function enhanceError(error, config, code, request3, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request3;
  error.response = response;
  error.isAxiosError = true;
  error.toJSON = function toJSON() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};
var enhanceError$1 = enhanceError$2;
var createError$2 = function createError(message, config, code, request3, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request3, response);
};
var createError$1 = createError$2;
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject(createError$1(
      "Request failed with status code " + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};
var utils$b = utils$f;
var cookies$1 = utils$b.isStandardBrowserEnv() ? function standardBrowserEnv() {
  return {
    write: function write2(name2, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name2 + "=" + encodeURIComponent(value));
      if (utils$b.isNumber(expires)) {
        cookie.push("expires=" + new Date(expires).toGMTString());
      }
      if (utils$b.isString(path)) {
        cookie.push("path=" + path);
      }
      if (utils$b.isString(domain)) {
        cookie.push("domain=" + domain);
      }
      if (secure === true) {
        cookie.push("secure");
      }
      document.cookie = cookie.join("; ");
    },
    read: function read2(name2) {
      var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name2 + ")=([^;]*)"));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name2) {
      this.write(name2, "", Date.now() - 864e5);
    }
  };
}() : function nonStandardBrowserEnv() {
  return {
    write: function write2() {
    },
    read: function read2() {
      return null;
    },
    remove: function remove() {
    }
  };
}();
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};
var isAbsoluteURL2 = isAbsoluteURL$1;
var combineURLs2 = combineURLs$1;
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL2(requestedURL)) {
    return combineURLs2(baseURL, requestedURL);
  }
  return requestedURL;
};
var utils$a = utils$f;
var ignoreDuplicateOf = [
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
];
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils$a.forEach(headers.split("\n"), function parser2(line) {
    i = line.indexOf(":");
    key = utils$a.trim(line.substr(0, i)).toLowerCase();
    val = utils$a.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === "set-cookie") {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
      }
    }
  });
  return parsed;
};
var utils$9 = utils$f;
var isURLSameOrigin$1 = utils$9.isStandardBrowserEnv() ? function standardBrowserEnv2() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement("a");
  var originURL;
  function resolveURL(url) {
    var href = url;
    if (msie) {
      urlParsingNode.setAttribute("href", href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute("href", href);
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);
  return function isURLSameOrigin2(requestURL) {
    var parsed = utils$9.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() : function nonStandardBrowserEnv2() {
  return function isURLSameOrigin2() {
    return true;
  };
}();
function Cancel$3(message) {
  this.message = message;
}
Cancel$3.prototype.toString = function toString2() {
  return "Cancel" + (this.message ? ": " + this.message : "");
};
Cancel$3.prototype.__CANCEL__ = true;
var Cancel_1 = Cancel$3;
var utils$8 = utils$f;
var settle2 = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath2 = buildFullPath$1;
var parseHeaders2 = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError2 = createError$2;
var defaults$4 = defaults_1;
var Cancel$2 = Cancel_1;
var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }
      if (config.signal) {
        config.signal.removeEventListener("abort", onCanceled);
      }
    }
    if (utils$8.isFormData(requestData)) {
      delete requestHeaders["Content-Type"];
    }
    var request3 = new XMLHttpRequest();
    if (config.auth) {
      var username = config.auth.username || "";
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
      requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
    }
    var fullPath = buildFullPath2(config.baseURL, config.url);
    request3.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);
    request3.timeout = config.timeout;
    function onloadend() {
      if (!request3) {
        return;
      }
      var responseHeaders = "getAllResponseHeaders" in request3 ? parseHeaders2(request3.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === "text" || responseType === "json" ? request3.responseText : request3.response;
      var response = {
        data: responseData,
        status: request3.status,
        statusText: request3.statusText,
        headers: responseHeaders,
        config,
        request: request3
      };
      settle2(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);
      request3 = null;
    }
    if ("onloadend" in request3) {
      request3.onloadend = onloadend;
    } else {
      request3.onreadystatechange = function handleLoad() {
        if (!request3 || request3.readyState !== 4) {
          return;
        }
        if (request3.status === 0 && !(request3.responseURL && request3.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request3.onabort = function handleAbort() {
      if (!request3) {
        return;
      }
      reject(createError2("Request aborted", config, "ECONNABORTED", request3));
      request3 = null;
    };
    request3.onerror = function handleError() {
      reject(createError2("Network Error", config, null, request3));
      request3 = null;
    };
    request3.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
      var transitional2 = config.transitional || defaults$4.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError2(
        timeoutErrorMessage,
        config,
        transitional2.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
        request3
      ));
      request3 = null;
    };
    if (utils$8.isStandardBrowserEnv()) {
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }
    if ("setRequestHeader" in request3) {
      utils$8.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
          delete requestHeaders[key];
        } else {
          request3.setRequestHeader(key, val);
        }
      });
    }
    if (!utils$8.isUndefined(config.withCredentials)) {
      request3.withCredentials = !!config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request3.responseType = config.responseType;
    }
    if (typeof config.onDownloadProgress === "function") {
      request3.addEventListener("progress", config.onDownloadProgress);
    }
    if (typeof config.onUploadProgress === "function" && request3.upload) {
      request3.upload.addEventListener("progress", config.onUploadProgress);
    }
    if (config.cancelToken || config.signal) {
      onCanceled = function(cancel) {
        if (!request3) {
          return;
        }
        reject(!cancel || cancel && cancel.type ? new Cancel$2("canceled") : cancel);
        request3.abort();
        request3 = null;
      };
      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
      }
    }
    if (!requestData) {
      requestData = null;
    }
    request3.send(requestData);
  });
};
var utils$7 = utils$f;
var normalizeHeaderName2 = normalizeHeaderName$1;
var enhanceError2 = enhanceError$2;
var DEFAULT_CONTENT_TYPE = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function setContentTypeIfUnset(headers, value) {
  if (!utils$7.isUndefined(headers) && utils$7.isUndefined(headers["Content-Type"])) {
    headers["Content-Type"] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== "undefined") {
    adapter = xhr;
  } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
    adapter = xhr;
  }
  return adapter;
}
function stringifySafely(rawValue, parser2, encoder) {
  if (utils$7.isString(rawValue)) {
    try {
      (parser2 || JSON.parse)(rawValue);
      return utils$7.trim(rawValue);
    } catch (e2) {
      if (e2.name !== "SyntaxError") {
        throw e2;
      }
    }
  }
  return (encoder || JSON.stringify)(rawValue);
}
var defaults$3 = {
  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data2, headers) {
    normalizeHeaderName2(headers, "Accept");
    normalizeHeaderName2(headers, "Content-Type");
    if (utils$7.isFormData(data2) || utils$7.isArrayBuffer(data2) || utils$7.isBuffer(data2) || utils$7.isStream(data2) || utils$7.isFile(data2) || utils$7.isBlob(data2)) {
      return data2;
    }
    if (utils$7.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$7.isURLSearchParams(data2)) {
      setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
      return data2.toString();
    }
    if (utils$7.isObject(data2) || headers && headers["Content-Type"] === "application/json") {
      setContentTypeIfUnset(headers, "application/json");
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    var transitional2 = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
    var forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
    if (strictJSONParsing || forcedJSONParsing && utils$7.isString(data2) && data2.length) {
      try {
        return JSON.parse(data2);
      } catch (e2) {
        if (strictJSONParsing) {
          if (e2.name === "SyntaxError") {
            throw enhanceError2(e2, this, "E_JSON_PARSE");
          }
          throw e2;
        }
      }
    }
    return data2;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  validateStatus: function validateStatus(status2) {
    return status2 >= 200 && status2 < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*"
    }
  }
};
utils$7.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});
utils$7.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$7.merge(DEFAULT_CONTENT_TYPE);
});
var defaults_1 = defaults$3;
var utils$6 = utils$f;
var defaults$2 = defaults_1;
var transformData$1 = function transformData(data2, headers, fns) {
  var context = this || defaults$2;
  utils$6.forEach(fns, function transform(fn2) {
    data2 = fn2.call(context, data2, headers);
  });
  return data2;
};
var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};
var utils$5 = utils$f;
var transformData2 = transformData$1;
var isCancel2 = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$1 = Cancel_1;
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new Cancel$1("canceled");
  }
}
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = config.headers || {};
  config.data = transformData2.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );
  config.headers = utils$5.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );
  utils$5.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );
  var adapter = config.adapter || defaults$1.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData2.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel2(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData2.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }
    return Promise.reject(reason);
  });
};
var utils$4 = utils$f;
var mergeConfig$2 = function mergeConfig(config1, config2) {
  config2 = config2 || {};
  var config = {};
  function getMergedValue(target, source2) {
    if (utils$4.isPlainObject(target) && utils$4.isPlainObject(source2)) {
      return utils$4.merge(target, source2);
    } else if (utils$4.isPlainObject(source2)) {
      return utils$4.merge({}, source2);
    } else if (utils$4.isArray(source2)) {
      return source2.slice();
    }
    return source2;
  }
  function mergeDeepProperties(prop) {
    if (!utils$4.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$4.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function valueFromConfig2(prop) {
    if (!utils$4.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    }
  }
  function defaultToConfig2(prop) {
    if (!utils$4.isUndefined(config2[prop])) {
      return getMergedValue(void 0, config2[prop]);
    } else if (!utils$4.isUndefined(config1[prop])) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(void 0, config1[prop]);
    }
  }
  var mergeMap = {
    "url": valueFromConfig2,
    "method": valueFromConfig2,
    "data": valueFromConfig2,
    "baseURL": defaultToConfig2,
    "transformRequest": defaultToConfig2,
    "transformResponse": defaultToConfig2,
    "paramsSerializer": defaultToConfig2,
    "timeout": defaultToConfig2,
    "timeoutMessage": defaultToConfig2,
    "withCredentials": defaultToConfig2,
    "adapter": defaultToConfig2,
    "responseType": defaultToConfig2,
    "xsrfCookieName": defaultToConfig2,
    "xsrfHeaderName": defaultToConfig2,
    "onUploadProgress": defaultToConfig2,
    "onDownloadProgress": defaultToConfig2,
    "decompress": defaultToConfig2,
    "maxContentLength": defaultToConfig2,
    "maxBodyLength": defaultToConfig2,
    "transport": defaultToConfig2,
    "httpAgent": defaultToConfig2,
    "httpsAgent": defaultToConfig2,
    "cancelToken": defaultToConfig2,
    "socketPath": defaultToConfig2,
    "responseEncoding": defaultToConfig2,
    "validateStatus": mergeDirectKeys
  };
  utils$4.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge2 = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge2(prop);
    utils$4.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop] = configValue);
  });
  return config;
};
var data = {
  "version": "0.25.0"
};
var VERSION = data.version;
var validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type2, i) {
  validators$1[type2] = function validator2(thing) {
    return typeof thing === type2 || "a" + (i < 1 ? "n " : " ") + type2;
  };
});
var deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
  }
  return function(value, opt, opts) {
    if (validator2 === false) {
      throw new Error(formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")));
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new TypeError("options must be an object");
  }
  var keys2 = Object.keys(options);
  var i = keys2.length;
  while (i-- > 0) {
    var opt = keys2[i];
    var validator2 = schema[opt];
    if (validator2) {
      var value = options[opt];
      var result = value === void 0 || validator2(value, opt, options);
      if (result !== true) {
        throw new TypeError("option " + opt + " must be " + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error("Unknown option " + opt);
    }
  }
}
var validator$1 = {
  assertOptions,
  validators: validators$1
};
var utils$3 = utils$f;
var buildURL2 = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest2 = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;
var validators = validator.validators;
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}
Axios$1.prototype.request = function request(configOrUrl, config) {
  if (typeof configOrUrl === "string") {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$1(this.defaults, config);
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = "get";
  }
  var transitional2 = config.transitional;
  if (transitional2 !== void 0) {
    validator.assertOptions(transitional2, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
      return;
    }
    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });
  var promise;
  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest2, void 0];
    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);
    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }
  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }
  try {
    promise = dispatchRequest2(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }
  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }
  return promise;
};
Axios$1.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error("Provided config url is not valid");
  }
  config = mergeConfig$1(this.defaults, config);
  return buildURL2(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
utils$3.forEach(["delete", "get", "head", "options"], function forEachMethodNoData2(method) {
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$3.forEach(["post", "put", "patch"], function forEachMethodWithData2(method) {
  Axios$1.prototype[method] = function(url, data2, config) {
    return this.request(mergeConfig$1(config || {}, {
      method,
      url,
      data: data2
    }));
  };
});
var Axios_1 = Axios$1;
var Cancel = Cancel_1;
function CancelToken(executor) {
  if (typeof executor !== "function") {
    throw new TypeError("executor must be a function.");
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  this.promise.then(function(cancel) {
    if (!token._listeners)
      return;
    var i;
    var l = token._listeners.length;
    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });
  this.promise.then = function(onfulfilled) {
    var _resolve;
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);
    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };
    return promise;
  };
  executor(function cancel(message) {
    if (token.reason) {
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};
CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }
  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};
CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index2 = this._listeners.indexOf(listener);
  if (index2 !== -1) {
    this._listeners.splice(index2, 1);
  }
};
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c2) {
    cancel = c2;
  });
  return {
    token,
    cancel
  };
};
var CancelToken_1 = CancelToken;
var spread = function spread2(callback) {
  return function wrap2(arr) {
    return callback.apply(null, arr);
  };
};
var utils$2 = utils$f;
var isAxiosError = function isAxiosError2(payload) {
  return utils$2.isObject(payload) && payload.isAxiosError === true;
};
var utils$1 = utils$f;
var bind$2 = bind$4;
var Axios = Axios_1;
var mergeConfig2 = mergeConfig$2;
var defaults = defaults_1;
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind$2(Axios.prototype.request, context);
  utils$1.extend(instance, Axios.prototype, context);
  utils$1.extend(instance, context);
  instance.create = function create2(instanceConfig) {
    return createInstance(mergeConfig2(defaultConfig, instanceConfig));
  };
  return instance;
}
var axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;
axios$1.VERSION = data.version;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$2.exports = axios$1;
axios$2.exports.default = axios$1;
var axios = axios$2.exports;
const onlyLanhuLogin = ref(false);
const lanhuHost = ref("");
const isPri = ref(false);
const openUserRegister = ref(!isPri.value);
const passwordMatchDigit = ref(true);
const passwordMatchSpecial = ref(true);
const passwordMatchLower = ref(true);
const passwordMatchUpper = ref(true);
const passwordMinLength = ref(8);
const passwordResetInterval = ref(0);
const openUserRegisterType = ref([]);
const smtpConfigured = ref(false);
const organizationEmail = ref([]);
const allowPublicEmail = ref(true);
const registerType = ref("");
const showPasswordRegister = computed(() => {
  return openUserRegisterType.value.includes("emailPassword");
});
const showEmailVerifyRegister = computed(() => {
  return openUserRegisterType.value.includes("emailVerify");
});
const usePubSetting = () => {
  const updateOpenUserRegister = (value) => {
    openUserRegister.value = value;
  };
  const updatePri = (value) => {
    isPri.value = value;
    updateOpenUserRegister(!value);
  };
  const updateRegisterType = (value) => {
    registerType.value = value;
  };
  const getOrgPubSettingData = async () => {
    if (!isPri.value) {
      return;
    }
    const res = await getOrgPubSettings();
    return res == null ? void 0 : res.data;
  };
  const isInvalidateData = (data2) => {
    return data2 === void 0 || data2 === null || data2 === "" || data2 === 0 || data2 === -1;
  };
  const setPasswordConfig = ({
    passwordMatchDigit: passwordMatchDigitValue,
    passwordMatchSpecial: passwordMatchSpecialValue,
    passwordMatchLower: passwordMatchLowerValue,
    passwordMatchUpper: passwordMatchUpperValue,
    passwordMinLength: passwordMinLengthValue,
    passwordResetInterval: passwordResetIntervalValue
  }) => {
    if (!isInvalidateData(passwordMatchDigitValue)) {
      passwordMatchDigit.value = passwordMatchDigitValue;
    }
    if (!isInvalidateData(passwordMatchSpecialValue)) {
      passwordMatchSpecial.value = passwordMatchSpecialValue;
    }
    if (!isInvalidateData(passwordMatchLowerValue)) {
      passwordMatchLower.value = passwordMatchLowerValue;
    }
    if (!isInvalidateData(passwordMatchUpperValue)) {
      passwordMatchUpper.value = passwordMatchUpperValue;
    }
    if (!isInvalidateData(passwordMinLengthValue)) {
      passwordMinLength.value = passwordMinLengthValue;
    }
    if (!isInvalidateData(passwordResetIntervalValue)) {
      passwordResetInterval.value = passwordResetIntervalValue;
    }
  };
  const emailsStringToArray = (emails) => {
    if (!emails)
      return [];
    return emails.split(",").map((email) => email.trim());
  };
  const initPubConfig = async (dataParams) => {
    var _a2;
    const data2 = dataParams || await getOrgPubSettingData();
    if (!data2) {
      console.warn("not need to init pub org setting");
      return;
    }
    onlyLanhuLogin.value = !!data2.onlyLanhuLogin;
    lanhuHost.value = data2.lanhuHost || "";
    updateOpenUserRegister(!!data2.openUserRegister);
    openUserRegisterType.value = data2.openUserRegisterType instanceof Array ? data2.openUserRegisterType : [];
    smtpConfigured.value = data2.smtpConfigured;
    organizationEmail.value = emailsStringToArray(data2.organizationEmail);
    allowPublicEmail.value = (_a2 = data2.allowPublicEmail) != null ? _a2 : true;
    setPasswordConfig(data2);
    return getPubConfig();
  };
  const getPubConfig = () => {
    return {
      onlyLanhuLogin,
      lanhuHost,
      openUserRegister,
      registerType,
      openUserRegisterType,
      isPri,
      passwordMatchDigit,
      passwordMatchSpecial,
      passwordMatchLower,
      passwordMatchUpper,
      passwordMinLength,
      passwordResetInterval,
      smtpConfigured,
      organizationEmail,
      allowPublicEmail,
      showPasswordRegister,
      showEmailVerifyRegister
    };
  };
  return {
    getOrgPubSettingData,
    initPubConfig,
    setPasswordConfig,
    getPubConfig,
    updatePri,
    updateRegisterType,
    updateOpenUserRegister
  };
};
const showResetConfirm = ref(false);
const resetPasswordEmail = ref("");
const willGoForgetPassword = ref(false);
const usePasswordReset = () => {
  const updateResetPasswordCache = (value) => {
    setLocalStorageItem(RESET_PASSWORD_CONFIRM_KEY, value.toString());
  };
  const getResetPasswordCache = () => {
    return getLocalStorageItem(RESET_PASSWORD_CONFIRM_KEY);
  };
  const updateShowResetConfirm = async (value) => {
    updateResetPasswordCache(value);
    if (value) {
      const { initPubConfig } = usePubSetting();
      try {
        await initPubConfig();
      } catch (error) {
        console.error("init pub config error: ", error);
      }
    }
    showResetConfirm.value = value;
  };
  const updateResetPasswordEmail = (value) => {
    if (!value) {
      console.warn("reset password email is not found");
      return;
    }
    resetPasswordEmail.value = value;
  };
  const updateWillGoForgetPassword = (value) => {
    willGoForgetPassword.value = value;
    console.info("update will go forget password: ", value);
  };
  const getResetPasswordInfo = () => {
    const resetPasswordConfirm = getResetPasswordCache();
    return {
      showResetConfirm,
      resetPasswordEmail,
      willGoForgetPassword,
      isInResetPassword: resetPasswordConfirm === "true"
    };
  };
  const shouldShowPasswordReset = (errorResponse) => {
    const { config, data: data2 } = errorResponse;
    const isPasswordReset = (data2 == null ? void 0 : data2.code) === API_ERROR_CODE.PasswordReset;
    if (!isPasswordReset) {
      return false;
    }
    const { url, method } = config || {};
    if (url === "/api/v1/user" && method === "get") {
      return false;
    }
    return true;
  };
  const queryUserResetPasswordStatus = async (isPri2) => {
    const { updatePri } = usePubSetting();
    updatePri(isPri2);
    if (!isPri2) {
      return;
    }
    await getUserResetPasswordStatus();
    updateResetPasswordCache(false);
  };
  const toForgetPassword = ({ email, target, timeout = 0 }) => {
    let url = `${window.location.origin}${ROUTER_PATH.FORGET_PASSWORD}`;
    if (email) {
      url += `?email=${resetPasswordEmail.value}`;
    }
    if (isMirror$1()) {
      location.href = url;
    } else {
      if (timeout) {
        setTimeout(() => {
          window.open(url, target);
        }, timeout);
      } else {
        window.open(url, target);
      }
    }
  };
  const toHomePage = () => {
    const url = `${window.location.origin}${ROUTER_PATH.FILES_HOME}`;
    window.open(url, "_self");
  };
  return {
    showResetConfirm,
    updateShowResetConfirm,
    getResetPasswordInfo,
    updateResetPasswordEmail,
    updateResetPasswordCache,
    shouldShowPasswordReset,
    queryUserResetPasswordStatus,
    toForgetPassword,
    updateWillGoForgetPassword,
    toHomePage
  };
};
const request2 = axios.create({
  baseURL: "/",
  timeout: 3e4,
  headers: {
    "Cache-Control": "no-store, no-cache"
  }
});
request2.interceptors.request.use(
  (config) => {
    if (!config.headers)
      return;
    let experiment = "";
    try {
      experiment = JSON.stringify(parseExperiment(experimentClient));
    } catch (e2) {
      console.log(`\u{1F449} parseExperiment error ${e2}: `, e2);
    }
    config.headers["x-mg-experiment"] = experiment;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    config.headers["Time-Zone"] = timeZone;
    return config;
  },
  (error) => Promise.reject(error)
);
request2.interceptors.response.use(
  (res) => {
    var _a2;
    if (((_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.code) === "OK") {
      return res.data;
    }
    return Promise.reject(res);
  },
  (err) => {
    const errorResponse = err == null ? void 0 : err.response;
    if (errorResponse) {
      const { status: status2, data: data2 } = errorResponse;
      const { shouldShowPasswordReset, updateShowResetConfirm } = usePasswordReset();
      const code = data2 == null ? void 0 : data2.code;
      if (status2 === 403 && code === "OrganizationForbidden") {
        const url = "https://mastergo.com/404";
        window.location.href = url;
      } else if (shouldShowPasswordReset(errorResponse)) {
        updateShowResetConfirm(true);
      }
    }
    return Promise.reject(err);
  }
);
const createRequest = (data2) => {
  return new Promise((resolve, reject) => {
    request2(data2).then((res) => {
      resolve(res);
    }).catch((err) => {
      reject(err);
    });
  });
};
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
function int2char(n) {
  return BI_RM.charAt(n);
}
function op_and(x, y) {
  return x & y;
}
function op_or(x, y) {
  return x | y;
}
function op_xor(x, y) {
  return x ^ y;
}
function op_andnot(x, y) {
  return x & ~y;
}
function lbit(x) {
  if (x == 0) {
    return -1;
  }
  var r = 0;
  if ((x & 65535) == 0) {
    x >>= 16;
    r += 16;
  }
  if ((x & 255) == 0) {
    x >>= 8;
    r += 8;
  }
  if ((x & 15) == 0) {
    x >>= 4;
    r += 4;
  }
  if ((x & 3) == 0) {
    x >>= 2;
    r += 2;
  }
  if ((x & 1) == 0) {
    ++r;
  }
  return r;
}
function cbit(x) {
  var r = 0;
  while (x != 0) {
    x &= x - 1;
    ++r;
  }
  return r;
}
var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var b64pad = "=";
function hex2b64(h) {
  var i;
  var c2;
  var ret = "";
  for (i = 0; i + 3 <= h.length; i += 3) {
    c2 = parseInt(h.substring(i, i + 3), 16);
    ret += b64map.charAt(c2 >> 6) + b64map.charAt(c2 & 63);
  }
  if (i + 1 == h.length) {
    c2 = parseInt(h.substring(i, i + 1), 16);
    ret += b64map.charAt(c2 << 2);
  } else if (i + 2 == h.length) {
    c2 = parseInt(h.substring(i, i + 2), 16);
    ret += b64map.charAt(c2 >> 2) + b64map.charAt((c2 & 3) << 4);
  }
  while ((ret.length & 3) > 0) {
    ret += b64pad;
  }
  return ret;
}
function b64tohex(s) {
  var ret = "";
  var i;
  var k = 0;
  var slop = 0;
  for (i = 0; i < s.length; ++i) {
    if (s.charAt(i) == b64pad) {
      break;
    }
    var v = b64map.indexOf(s.charAt(i));
    if (v < 0) {
      continue;
    }
    if (k == 0) {
      ret += int2char(v >> 2);
      slop = v & 3;
      k = 1;
    } else if (k == 1) {
      ret += int2char(slop << 2 | v >> 4);
      slop = v & 15;
      k = 2;
    } else if (k == 2) {
      ret += int2char(slop);
      ret += int2char(v >> 2);
      slop = v & 3;
      k = 3;
    } else {
      ret += int2char(slop << 2 | v >> 4);
      ret += int2char(v & 15);
      k = 0;
    }
  }
  if (k == 1) {
    ret += int2char(slop << 2);
  }
  return ret;
}
var decoder$1;
var Hex = {
  decode: function(a2) {
    var i;
    if (decoder$1 === void 0) {
      var hex = "0123456789ABCDEF";
      var ignore = " \f\n\r	\xA0\u2028\u2029";
      decoder$1 = {};
      for (i = 0; i < 16; ++i) {
        decoder$1[hex.charAt(i)] = i;
      }
      hex = hex.toLowerCase();
      for (i = 10; i < 16; ++i) {
        decoder$1[hex.charAt(i)] = i;
      }
      for (i = 0; i < ignore.length; ++i) {
        decoder$1[ignore.charAt(i)] = -1;
      }
    }
    var out = [];
    var bits = 0;
    var char_count = 0;
    for (i = 0; i < a2.length; ++i) {
      var c2 = a2.charAt(i);
      if (c2 == "=") {
        break;
      }
      c2 = decoder$1[c2];
      if (c2 == -1) {
        continue;
      }
      if (c2 === void 0) {
        throw new Error("Illegal character at offset " + i);
      }
      bits |= c2;
      if (++char_count >= 2) {
        out[out.length] = bits;
        bits = 0;
        char_count = 0;
      } else {
        bits <<= 4;
      }
    }
    if (char_count) {
      throw new Error("Hex encoding incomplete: 4 bits missing");
    }
    return out;
  }
};
var decoder;
var Base64 = {
  decode: function(a2) {
    var i;
    if (decoder === void 0) {
      var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
      var ignore = "= \f\n\r	\xA0\u2028\u2029";
      decoder = /* @__PURE__ */ Object.create(null);
      for (i = 0; i < 64; ++i) {
        decoder[b64.charAt(i)] = i;
      }
      decoder["-"] = 62;
      decoder["_"] = 63;
      for (i = 0; i < ignore.length; ++i) {
        decoder[ignore.charAt(i)] = -1;
      }
    }
    var out = [];
    var bits = 0;
    var char_count = 0;
    for (i = 0; i < a2.length; ++i) {
      var c2 = a2.charAt(i);
      if (c2 == "=") {
        break;
      }
      c2 = decoder[c2];
      if (c2 == -1) {
        continue;
      }
      if (c2 === void 0) {
        throw new Error("Illegal character at offset " + i);
      }
      bits |= c2;
      if (++char_count >= 4) {
        out[out.length] = bits >> 16;
        out[out.length] = bits >> 8 & 255;
        out[out.length] = bits & 255;
        bits = 0;
        char_count = 0;
      } else {
        bits <<= 6;
      }
    }
    switch (char_count) {
      case 1:
        throw new Error("Base64 encoding incomplete: at least 2 bits missing");
      case 2:
        out[out.length] = bits >> 10;
        break;
      case 3:
        out[out.length] = bits >> 16;
        out[out.length] = bits >> 8 & 255;
        break;
    }
    return out;
  },
  re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
  unarmor: function(a2) {
    var m2 = Base64.re.exec(a2);
    if (m2) {
      if (m2[1]) {
        a2 = m2[1];
      } else if (m2[2]) {
        a2 = m2[2];
      } else {
        throw new Error("RegExp out of sync");
      }
    }
    return Base64.decode(a2);
  }
};
var max$1 = 1e13;
var Int10 = function() {
  function Int102(value) {
    this.buf = [+value || 0];
  }
  Int102.prototype.mulAdd = function(m2, c2) {
    var b2 = this.buf;
    var l = b2.length;
    var i;
    var t2;
    for (i = 0; i < l; ++i) {
      t2 = b2[i] * m2 + c2;
      if (t2 < max$1) {
        c2 = 0;
      } else {
        c2 = 0 | t2 / max$1;
        t2 -= c2 * max$1;
      }
      b2[i] = t2;
    }
    if (c2 > 0) {
      b2[i] = c2;
    }
  };
  Int102.prototype.sub = function(c2) {
    var b2 = this.buf;
    var l = b2.length;
    var i;
    var t2;
    for (i = 0; i < l; ++i) {
      t2 = b2[i] - c2;
      if (t2 < 0) {
        t2 += max$1;
        c2 = 1;
      } else {
        c2 = 0;
      }
      b2[i] = t2;
    }
    while (b2[b2.length - 1] === 0) {
      b2.pop();
    }
  };
  Int102.prototype.toString = function(base) {
    if ((base || 10) != 10) {
      throw new Error("only base 10 is supported");
    }
    var b2 = this.buf;
    var s = b2[b2.length - 1].toString();
    for (var i = b2.length - 2; i >= 0; --i) {
      s += (max$1 + b2[i]).toString().substring(1);
    }
    return s;
  };
  Int102.prototype.valueOf = function() {
    var b2 = this.buf;
    var v = 0;
    for (var i = b2.length - 1; i >= 0; --i) {
      v = v * max$1 + b2[i];
    }
    return v;
  };
  Int102.prototype.simplify = function() {
    var b2 = this.buf;
    return b2.length == 1 ? b2[0] : this;
  };
  return Int102;
}();
var ellipsis = "\u2026";
var reTimeS = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
var reTimeL = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
function stringCut(str, len) {
  if (str.length > len) {
    str = str.substring(0, len) + ellipsis;
  }
  return str;
}
var Stream = function() {
  function Stream2(enc, pos) {
    this.hexDigits = "0123456789ABCDEF";
    if (enc instanceof Stream2) {
      this.enc = enc.enc;
      this.pos = enc.pos;
    } else {
      this.enc = enc;
      this.pos = pos;
    }
  }
  Stream2.prototype.get = function(pos) {
    if (pos === void 0) {
      pos = this.pos++;
    }
    if (pos >= this.enc.length) {
      throw new Error("Requesting byte offset ".concat(pos, " on a stream of length ").concat(this.enc.length));
    }
    return "string" === typeof this.enc ? this.enc.charCodeAt(pos) : this.enc[pos];
  };
  Stream2.prototype.hexByte = function(b2) {
    return this.hexDigits.charAt(b2 >> 4 & 15) + this.hexDigits.charAt(b2 & 15);
  };
  Stream2.prototype.hexDump = function(start2, end2, raw) {
    var s = "";
    for (var i = start2; i < end2; ++i) {
      s += this.hexByte(this.get(i));
      if (raw !== true) {
        switch (i & 15) {
          case 7:
            s += "  ";
            break;
          case 15:
            s += "\n";
            break;
          default:
            s += " ";
        }
      }
    }
    return s;
  };
  Stream2.prototype.isASCII = function(start2, end2) {
    for (var i = start2; i < end2; ++i) {
      var c2 = this.get(i);
      if (c2 < 32 || c2 > 176) {
        return false;
      }
    }
    return true;
  };
  Stream2.prototype.parseStringISO = function(start2, end2) {
    var s = "";
    for (var i = start2; i < end2; ++i) {
      s += String.fromCharCode(this.get(i));
    }
    return s;
  };
  Stream2.prototype.parseStringUTF = function(start2, end2) {
    var s = "";
    for (var i = start2; i < end2; ) {
      var c2 = this.get(i++);
      if (c2 < 128) {
        s += String.fromCharCode(c2);
      } else if (c2 > 191 && c2 < 224) {
        s += String.fromCharCode((c2 & 31) << 6 | this.get(i++) & 63);
      } else {
        s += String.fromCharCode((c2 & 15) << 12 | (this.get(i++) & 63) << 6 | this.get(i++) & 63);
      }
    }
    return s;
  };
  Stream2.prototype.parseStringBMP = function(start2, end2) {
    var str = "";
    var hi2;
    var lo2;
    for (var i = start2; i < end2; ) {
      hi2 = this.get(i++);
      lo2 = this.get(i++);
      str += String.fromCharCode(hi2 << 8 | lo2);
    }
    return str;
  };
  Stream2.prototype.parseTime = function(start2, end2, shortYear) {
    var s = this.parseStringISO(start2, end2);
    var m2 = (shortYear ? reTimeS : reTimeL).exec(s);
    if (!m2) {
      return "Unrecognized time: " + s;
    }
    if (shortYear) {
      m2[1] = +m2[1];
      m2[1] += +m2[1] < 70 ? 2e3 : 1900;
    }
    s = m2[1] + "-" + m2[2] + "-" + m2[3] + " " + m2[4];
    if (m2[5]) {
      s += ":" + m2[5];
      if (m2[6]) {
        s += ":" + m2[6];
        if (m2[7]) {
          s += "." + m2[7];
        }
      }
    }
    if (m2[8]) {
      s += " UTC";
      if (m2[8] != "Z") {
        s += m2[8];
        if (m2[9]) {
          s += ":" + m2[9];
        }
      }
    }
    return s;
  };
  Stream2.prototype.parseInteger = function(start2, end2) {
    var v = this.get(start2);
    var neg = v > 127;
    var pad2 = neg ? 255 : 0;
    var len;
    var s = "";
    while (v == pad2 && ++start2 < end2) {
      v = this.get(start2);
    }
    len = end2 - start2;
    if (len === 0) {
      return neg ? -1 : 0;
    }
    if (len > 4) {
      s = v;
      len <<= 3;
      while (((+s ^ pad2) & 128) == 0) {
        s = +s << 1;
        --len;
      }
      s = "(" + len + " bit)\n";
    }
    if (neg) {
      v = v - 256;
    }
    var n = new Int10(v);
    for (var i = start2 + 1; i < end2; ++i) {
      n.mulAdd(256, this.get(i));
    }
    return s + n.toString();
  };
  Stream2.prototype.parseBitString = function(start2, end2, maxLength) {
    var unusedBit = this.get(start2);
    var lenBit = (end2 - start2 - 1 << 3) - unusedBit;
    var intro = "(" + lenBit + " bit)\n";
    var s = "";
    for (var i = start2 + 1; i < end2; ++i) {
      var b2 = this.get(i);
      var skip = i == end2 - 1 ? unusedBit : 0;
      for (var j = 7; j >= skip; --j) {
        s += b2 >> j & 1 ? "1" : "0";
      }
      if (s.length > maxLength) {
        return intro + stringCut(s, maxLength);
      }
    }
    return intro + s;
  };
  Stream2.prototype.parseOctetString = function(start2, end2, maxLength) {
    if (this.isASCII(start2, end2)) {
      return stringCut(this.parseStringISO(start2, end2), maxLength);
    }
    var len = end2 - start2;
    var s = "(" + len + " byte)\n";
    maxLength /= 2;
    if (len > maxLength) {
      end2 = start2 + maxLength;
    }
    for (var i = start2; i < end2; ++i) {
      s += this.hexByte(this.get(i));
    }
    if (len > maxLength) {
      s += ellipsis;
    }
    return s;
  };
  Stream2.prototype.parseOID = function(start2, end2, maxLength) {
    var s = "";
    var n = new Int10();
    var bits = 0;
    for (var i = start2; i < end2; ++i) {
      var v = this.get(i);
      n.mulAdd(128, v & 127);
      bits += 7;
      if (!(v & 128)) {
        if (s === "") {
          n = n.simplify();
          if (n instanceof Int10) {
            n.sub(80);
            s = "2." + n.toString();
          } else {
            var m2 = n < 80 ? n < 40 ? 0 : 1 : 2;
            s = m2 + "." + (n - m2 * 40);
          }
        } else {
          s += "." + n.toString();
        }
        if (s.length > maxLength) {
          return stringCut(s, maxLength);
        }
        n = new Int10();
        bits = 0;
      }
    }
    if (bits > 0) {
      s += ".incomplete";
    }
    return s;
  };
  return Stream2;
}();
var ASN1 = function() {
  function ASN12(stream, header, length, tag, sub) {
    if (!(tag instanceof ASN1Tag)) {
      throw new Error("Invalid tag value.");
    }
    this.stream = stream;
    this.header = header;
    this.length = length;
    this.tag = tag;
    this.sub = sub;
  }
  ASN12.prototype.typeName = function() {
    switch (this.tag.tagClass) {
      case 0:
        switch (this.tag.tagNumber) {
          case 0:
            return "EOC";
          case 1:
            return "BOOLEAN";
          case 2:
            return "INTEGER";
          case 3:
            return "BIT_STRING";
          case 4:
            return "OCTET_STRING";
          case 5:
            return "NULL";
          case 6:
            return "OBJECT_IDENTIFIER";
          case 7:
            return "ObjectDescriptor";
          case 8:
            return "EXTERNAL";
          case 9:
            return "REAL";
          case 10:
            return "ENUMERATED";
          case 11:
            return "EMBEDDED_PDV";
          case 12:
            return "UTF8String";
          case 16:
            return "SEQUENCE";
          case 17:
            return "SET";
          case 18:
            return "NumericString";
          case 19:
            return "PrintableString";
          case 20:
            return "TeletexString";
          case 21:
            return "VideotexString";
          case 22:
            return "IA5String";
          case 23:
            return "UTCTime";
          case 24:
            return "GeneralizedTime";
          case 25:
            return "GraphicString";
          case 26:
            return "VisibleString";
          case 27:
            return "GeneralString";
          case 28:
            return "UniversalString";
          case 30:
            return "BMPString";
        }
        return "Universal_" + this.tag.tagNumber.toString();
      case 1:
        return "Application_" + this.tag.tagNumber.toString();
      case 2:
        return "[" + this.tag.tagNumber.toString() + "]";
      case 3:
        return "Private_" + this.tag.tagNumber.toString();
    }
  };
  ASN12.prototype.content = function(maxLength) {
    if (this.tag === void 0) {
      return null;
    }
    if (maxLength === void 0) {
      maxLength = Infinity;
    }
    var content = this.posContent();
    var len = Math.abs(this.length);
    if (!this.tag.isUniversal()) {
      if (this.sub !== null) {
        return "(" + this.sub.length + " elem)";
      }
      return this.stream.parseOctetString(content, content + len, maxLength);
    }
    switch (this.tag.tagNumber) {
      case 1:
        return this.stream.get(content) === 0 ? "false" : "true";
      case 2:
        return this.stream.parseInteger(content, content + len);
      case 3:
        return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseBitString(content, content + len, maxLength);
      case 4:
        return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(content, content + len, maxLength);
      case 6:
        return this.stream.parseOID(content, content + len, maxLength);
      case 16:
      case 17:
        if (this.sub !== null) {
          return "(" + this.sub.length + " elem)";
        } else {
          return "(no elem)";
        }
      case 12:
        return stringCut(this.stream.parseStringUTF(content, content + len), maxLength);
      case 18:
      case 19:
      case 20:
      case 21:
      case 22:
      case 26:
        return stringCut(this.stream.parseStringISO(content, content + len), maxLength);
      case 30:
        return stringCut(this.stream.parseStringBMP(content, content + len), maxLength);
      case 23:
      case 24:
        return this.stream.parseTime(content, content + len, this.tag.tagNumber == 23);
    }
    return null;
  };
  ASN12.prototype.toString = function() {
    return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + (this.sub === null ? "null" : this.sub.length) + "]";
  };
  ASN12.prototype.toPrettyString = function(indent) {
    if (indent === void 0) {
      indent = "";
    }
    var s = indent + this.typeName() + " @" + this.stream.pos;
    if (this.length >= 0) {
      s += "+";
    }
    s += this.length;
    if (this.tag.tagConstructed) {
      s += " (constructed)";
    } else if (this.tag.isUniversal() && (this.tag.tagNumber == 3 || this.tag.tagNumber == 4) && this.sub !== null) {
      s += " (encapsulates)";
    }
    s += "\n";
    if (this.sub !== null) {
      indent += "  ";
      for (var i = 0, max2 = this.sub.length; i < max2; ++i) {
        s += this.sub[i].toPrettyString(indent);
      }
    }
    return s;
  };
  ASN12.prototype.posStart = function() {
    return this.stream.pos;
  };
  ASN12.prototype.posContent = function() {
    return this.stream.pos + this.header;
  };
  ASN12.prototype.posEnd = function() {
    return this.stream.pos + this.header + Math.abs(this.length);
  };
  ASN12.prototype.toHexString = function() {
    return this.stream.hexDump(this.posStart(), this.posEnd(), true);
  };
  ASN12.decodeLength = function(stream) {
    var buf = stream.get();
    var len = buf & 127;
    if (len == buf) {
      return len;
    }
    if (len > 6) {
      throw new Error("Length over 48 bits not supported at position " + (stream.pos - 1));
    }
    if (len === 0) {
      return null;
    }
    buf = 0;
    for (var i = 0; i < len; ++i) {
      buf = buf * 256 + stream.get();
    }
    return buf;
  };
  ASN12.prototype.getHexStringValue = function() {
    var hexString = this.toHexString();
    var offset2 = this.header * 2;
    var length = this.length * 2;
    return hexString.substring(offset2, offset2 + length);
  };
  ASN12.decode = function(str) {
    var stream;
    if (!(str instanceof Stream)) {
      stream = new Stream(str, 0);
    } else {
      stream = str;
    }
    var streamStart = new Stream(stream);
    var tag = new ASN1Tag(stream);
    var len = ASN12.decodeLength(stream);
    var start2 = stream.pos;
    var header = start2 - streamStart.pos;
    var sub = null;
    var getSub = function() {
      var ret = [];
      if (len !== null) {
        var end2 = start2 + len;
        while (stream.pos < end2) {
          ret[ret.length] = ASN12.decode(stream);
        }
        if (stream.pos != end2) {
          throw new Error("Content size is not correct for container starting at offset " + start2);
        }
      } else {
        try {
          for (; ; ) {
            var s = ASN12.decode(stream);
            if (s.tag.isEOC()) {
              break;
            }
            ret[ret.length] = s;
          }
          len = start2 - stream.pos;
        } catch (e2) {
          throw new Error("Exception while decoding undefined length content: " + e2);
        }
      }
      return ret;
    };
    if (tag.tagConstructed) {
      sub = getSub();
    } else if (tag.isUniversal() && (tag.tagNumber == 3 || tag.tagNumber == 4)) {
      try {
        if (tag.tagNumber == 3) {
          if (stream.get() != 0) {
            throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
          }
        }
        sub = getSub();
        for (var i = 0; i < sub.length; ++i) {
          if (sub[i].tag.isEOC()) {
            throw new Error("EOC is not supposed to be actual content.");
          }
        }
      } catch (e2) {
        sub = null;
      }
    }
    if (sub === null) {
      if (len === null) {
        throw new Error("We can't skip over an invalid tag with undefined length at offset " + start2);
      }
      stream.pos = start2 + Math.abs(len);
    }
    return new ASN12(streamStart, header, len, tag, sub);
  };
  return ASN12;
}();
var ASN1Tag = function() {
  function ASN1Tag2(stream) {
    var buf = stream.get();
    this.tagClass = buf >> 6;
    this.tagConstructed = (buf & 32) !== 0;
    this.tagNumber = buf & 31;
    if (this.tagNumber == 31) {
      var n = new Int10();
      do {
        buf = stream.get();
        n.mulAdd(128, buf & 127);
      } while (buf & 128);
      this.tagNumber = n.simplify();
    }
  }
  ASN1Tag2.prototype.isUniversal = function() {
    return this.tagClass === 0;
  };
  ASN1Tag2.prototype.isEOC = function() {
    return this.tagClass === 0 && this.tagNumber === 0;
  };
  return ASN1Tag2;
}();
var dbits;
var canary = 244837814094590;
var j_lm = (canary & 16777215) == 15715070;
var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997];
var lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
var BigInteger = function() {
  function BigInteger2(a2, b2, c2) {
    if (a2 != null) {
      if ("number" == typeof a2) {
        this.fromNumber(a2, b2, c2);
      } else if (b2 == null && "string" != typeof a2) {
        this.fromString(a2, 256);
      } else {
        this.fromString(a2, b2);
      }
    }
  }
  BigInteger2.prototype.toString = function(b2) {
    if (this.s < 0) {
      return "-" + this.negate().toString(b2);
    }
    var k;
    if (b2 == 16) {
      k = 4;
    } else if (b2 == 8) {
      k = 3;
    } else if (b2 == 2) {
      k = 1;
    } else if (b2 == 32) {
      k = 5;
    } else if (b2 == 4) {
      k = 2;
    } else {
      return this.toRadix(b2);
    }
    var km2 = (1 << k) - 1;
    var d2;
    var m2 = false;
    var r = "";
    var i = this.t;
    var p = this.DB - i * this.DB % k;
    if (i-- > 0) {
      if (p < this.DB && (d2 = this[i] >> p) > 0) {
        m2 = true;
        r = int2char(d2);
      }
      while (i >= 0) {
        if (p < k) {
          d2 = (this[i] & (1 << p) - 1) << k - p;
          d2 |= this[--i] >> (p += this.DB - k);
        } else {
          d2 = this[i] >> (p -= k) & km2;
          if (p <= 0) {
            p += this.DB;
            --i;
          }
        }
        if (d2 > 0) {
          m2 = true;
        }
        if (m2) {
          r += int2char(d2);
        }
      }
    }
    return m2 ? r : "0";
  };
  BigInteger2.prototype.negate = function() {
    var r = nbi();
    BigInteger2.ZERO.subTo(this, r);
    return r;
  };
  BigInteger2.prototype.abs = function() {
    return this.s < 0 ? this.negate() : this;
  };
  BigInteger2.prototype.compareTo = function(a2) {
    var r = this.s - a2.s;
    if (r != 0) {
      return r;
    }
    var i = this.t;
    r = i - a2.t;
    if (r != 0) {
      return this.s < 0 ? -r : r;
    }
    while (--i >= 0) {
      if ((r = this[i] - a2[i]) != 0) {
        return r;
      }
    }
    return 0;
  };
  BigInteger2.prototype.bitLength = function() {
    if (this.t <= 0) {
      return 0;
    }
    return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
  };
  BigInteger2.prototype.mod = function(a2) {
    var r = nbi();
    this.abs().divRemTo(a2, null, r);
    if (this.s < 0 && r.compareTo(BigInteger2.ZERO) > 0) {
      a2.subTo(r, r);
    }
    return r;
  };
  BigInteger2.prototype.modPowInt = function(e2, m2) {
    var z;
    if (e2 < 256 || m2.isEven()) {
      z = new Classic(m2);
    } else {
      z = new Montgomery(m2);
    }
    return this.exp(e2, z);
  };
  BigInteger2.prototype.clone = function() {
    var r = nbi();
    this.copyTo(r);
    return r;
  };
  BigInteger2.prototype.intValue = function() {
    if (this.s < 0) {
      if (this.t == 1) {
        return this[0] - this.DV;
      } else if (this.t == 0) {
        return -1;
      }
    } else if (this.t == 1) {
      return this[0];
    } else if (this.t == 0) {
      return 0;
    }
    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
  };
  BigInteger2.prototype.byteValue = function() {
    return this.t == 0 ? this.s : this[0] << 24 >> 24;
  };
  BigInteger2.prototype.shortValue = function() {
    return this.t == 0 ? this.s : this[0] << 16 >> 16;
  };
  BigInteger2.prototype.signum = function() {
    if (this.s < 0) {
      return -1;
    } else if (this.t <= 0 || this.t == 1 && this[0] <= 0) {
      return 0;
    } else {
      return 1;
    }
  };
  BigInteger2.prototype.toByteArray = function() {
    var i = this.t;
    var r = [];
    r[0] = this.s;
    var p = this.DB - i * this.DB % 8;
    var d2;
    var k = 0;
    if (i-- > 0) {
      if (p < this.DB && (d2 = this[i] >> p) != (this.s & this.DM) >> p) {
        r[k++] = d2 | this.s << this.DB - p;
      }
      while (i >= 0) {
        if (p < 8) {
          d2 = (this[i] & (1 << p) - 1) << 8 - p;
          d2 |= this[--i] >> (p += this.DB - 8);
        } else {
          d2 = this[i] >> (p -= 8) & 255;
          if (p <= 0) {
            p += this.DB;
            --i;
          }
        }
        if ((d2 & 128) != 0) {
          d2 |= -256;
        }
        if (k == 0 && (this.s & 128) != (d2 & 128)) {
          ++k;
        }
        if (k > 0 || d2 != this.s) {
          r[k++] = d2;
        }
      }
    }
    return r;
  };
  BigInteger2.prototype.equals = function(a2) {
    return this.compareTo(a2) == 0;
  };
  BigInteger2.prototype.min = function(a2) {
    return this.compareTo(a2) < 0 ? this : a2;
  };
  BigInteger2.prototype.max = function(a2) {
    return this.compareTo(a2) > 0 ? this : a2;
  };
  BigInteger2.prototype.and = function(a2) {
    var r = nbi();
    this.bitwiseTo(a2, op_and, r);
    return r;
  };
  BigInteger2.prototype.or = function(a2) {
    var r = nbi();
    this.bitwiseTo(a2, op_or, r);
    return r;
  };
  BigInteger2.prototype.xor = function(a2) {
    var r = nbi();
    this.bitwiseTo(a2, op_xor, r);
    return r;
  };
  BigInteger2.prototype.andNot = function(a2) {
    var r = nbi();
    this.bitwiseTo(a2, op_andnot, r);
    return r;
  };
  BigInteger2.prototype.not = function() {
    var r = nbi();
    for (var i = 0; i < this.t; ++i) {
      r[i] = this.DM & ~this[i];
    }
    r.t = this.t;
    r.s = ~this.s;
    return r;
  };
  BigInteger2.prototype.shiftLeft = function(n) {
    var r = nbi();
    if (n < 0) {
      this.rShiftTo(-n, r);
    } else {
      this.lShiftTo(n, r);
    }
    return r;
  };
  BigInteger2.prototype.shiftRight = function(n) {
    var r = nbi();
    if (n < 0) {
      this.lShiftTo(-n, r);
    } else {
      this.rShiftTo(n, r);
    }
    return r;
  };
  BigInteger2.prototype.getLowestSetBit = function() {
    for (var i = 0; i < this.t; ++i) {
      if (this[i] != 0) {
        return i * this.DB + lbit(this[i]);
      }
    }
    if (this.s < 0) {
      return this.t * this.DB;
    }
    return -1;
  };
  BigInteger2.prototype.bitCount = function() {
    var r = 0;
    var x = this.s & this.DM;
    for (var i = 0; i < this.t; ++i) {
      r += cbit(this[i] ^ x);
    }
    return r;
  };
  BigInteger2.prototype.testBit = function(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) {
      return this.s != 0;
    }
    return (this[j] & 1 << n % this.DB) != 0;
  };
  BigInteger2.prototype.setBit = function(n) {
    return this.changeBit(n, op_or);
  };
  BigInteger2.prototype.clearBit = function(n) {
    return this.changeBit(n, op_andnot);
  };
  BigInteger2.prototype.flipBit = function(n) {
    return this.changeBit(n, op_xor);
  };
  BigInteger2.prototype.add = function(a2) {
    var r = nbi();
    this.addTo(a2, r);
    return r;
  };
  BigInteger2.prototype.subtract = function(a2) {
    var r = nbi();
    this.subTo(a2, r);
    return r;
  };
  BigInteger2.prototype.multiply = function(a2) {
    var r = nbi();
    this.multiplyTo(a2, r);
    return r;
  };
  BigInteger2.prototype.divide = function(a2) {
    var r = nbi();
    this.divRemTo(a2, r, null);
    return r;
  };
  BigInteger2.prototype.remainder = function(a2) {
    var r = nbi();
    this.divRemTo(a2, null, r);
    return r;
  };
  BigInteger2.prototype.divideAndRemainder = function(a2) {
    var q = nbi();
    var r = nbi();
    this.divRemTo(a2, q, r);
    return [q, r];
  };
  BigInteger2.prototype.modPow = function(e2, m2) {
    var i = e2.bitLength();
    var k;
    var r = nbv(1);
    var z;
    if (i <= 0) {
      return r;
    } else if (i < 18) {
      k = 1;
    } else if (i < 48) {
      k = 3;
    } else if (i < 144) {
      k = 4;
    } else if (i < 768) {
      k = 5;
    } else {
      k = 6;
    }
    if (i < 8) {
      z = new Classic(m2);
    } else if (m2.isEven()) {
      z = new Barrett(m2);
    } else {
      z = new Montgomery(m2);
    }
    var g = [];
    var n = 3;
    var k1 = k - 1;
    var km2 = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
      var g2 = nbi();
      z.sqrTo(g[1], g2);
      while (n <= km2) {
        g[n] = nbi();
        z.mulTo(g2, g[n - 2], g[n]);
        n += 2;
      }
    }
    var j = e2.t - 1;
    var w;
    var is1 = true;
    var r2 = nbi();
    var t2;
    i = nbits(e2[j]) - 1;
    while (j >= 0) {
      if (i >= k1) {
        w = e2[j] >> i - k1 & km2;
      } else {
        w = (e2[j] & (1 << i + 1) - 1) << k1 - i;
        if (j > 0) {
          w |= e2[j - 1] >> this.DB + i - k1;
        }
      }
      n = k;
      while ((w & 1) == 0) {
        w >>= 1;
        --n;
      }
      if ((i -= n) < 0) {
        i += this.DB;
        --j;
      }
      if (is1) {
        g[w].copyTo(r);
        is1 = false;
      } else {
        while (n > 1) {
          z.sqrTo(r, r2);
          z.sqrTo(r2, r);
          n -= 2;
        }
        if (n > 0) {
          z.sqrTo(r, r2);
        } else {
          t2 = r;
          r = r2;
          r2 = t2;
        }
        z.mulTo(r2, g[w], r);
      }
      while (j >= 0 && (e2[j] & 1 << i) == 0) {
        z.sqrTo(r, r2);
        t2 = r;
        r = r2;
        r2 = t2;
        if (--i < 0) {
          i = this.DB - 1;
          --j;
        }
      }
    }
    return z.revert(r);
  };
  BigInteger2.prototype.modInverse = function(m2) {
    var ac = m2.isEven();
    if (this.isEven() && ac || m2.signum() == 0) {
      return BigInteger2.ZERO;
    }
    var u = m2.clone();
    var v = this.clone();
    var a2 = nbv(1);
    var b2 = nbv(0);
    var c2 = nbv(0);
    var d2 = nbv(1);
    while (u.signum() != 0) {
      while (u.isEven()) {
        u.rShiftTo(1, u);
        if (ac) {
          if (!a2.isEven() || !b2.isEven()) {
            a2.addTo(this, a2);
            b2.subTo(m2, b2);
          }
          a2.rShiftTo(1, a2);
        } else if (!b2.isEven()) {
          b2.subTo(m2, b2);
        }
        b2.rShiftTo(1, b2);
      }
      while (v.isEven()) {
        v.rShiftTo(1, v);
        if (ac) {
          if (!c2.isEven() || !d2.isEven()) {
            c2.addTo(this, c2);
            d2.subTo(m2, d2);
          }
          c2.rShiftTo(1, c2);
        } else if (!d2.isEven()) {
          d2.subTo(m2, d2);
        }
        d2.rShiftTo(1, d2);
      }
      if (u.compareTo(v) >= 0) {
        u.subTo(v, u);
        if (ac) {
          a2.subTo(c2, a2);
        }
        b2.subTo(d2, b2);
      } else {
        v.subTo(u, v);
        if (ac) {
          c2.subTo(a2, c2);
        }
        d2.subTo(b2, d2);
      }
    }
    if (v.compareTo(BigInteger2.ONE) != 0) {
      return BigInteger2.ZERO;
    }
    if (d2.compareTo(m2) >= 0) {
      return d2.subtract(m2);
    }
    if (d2.signum() < 0) {
      d2.addTo(m2, d2);
    } else {
      return d2;
    }
    if (d2.signum() < 0) {
      return d2.add(m2);
    } else {
      return d2;
    }
  };
  BigInteger2.prototype.pow = function(e2) {
    return this.exp(e2, new NullExp());
  };
  BigInteger2.prototype.gcd = function(a2) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a2.s < 0 ? a2.negate() : a2.clone();
    if (x.compareTo(y) < 0) {
      var t2 = x;
      x = y;
      y = t2;
    }
    var i = x.getLowestSetBit();
    var g = y.getLowestSetBit();
    if (g < 0) {
      return x;
    }
    if (i < g) {
      g = i;
    }
    if (g > 0) {
      x.rShiftTo(g, x);
      y.rShiftTo(g, y);
    }
    while (x.signum() > 0) {
      if ((i = x.getLowestSetBit()) > 0) {
        x.rShiftTo(i, x);
      }
      if ((i = y.getLowestSetBit()) > 0) {
        y.rShiftTo(i, y);
      }
      if (x.compareTo(y) >= 0) {
        x.subTo(y, x);
        x.rShiftTo(1, x);
      } else {
        y.subTo(x, y);
        y.rShiftTo(1, y);
      }
    }
    if (g > 0) {
      y.lShiftTo(g, y);
    }
    return y;
  };
  BigInteger2.prototype.isProbablePrime = function(t2) {
    var i;
    var x = this.abs();
    if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
      for (i = 0; i < lowprimes.length; ++i) {
        if (x[0] == lowprimes[i]) {
          return true;
        }
      }
      return false;
    }
    if (x.isEven()) {
      return false;
    }
    i = 1;
    while (i < lowprimes.length) {
      var m2 = lowprimes[i];
      var j = i + 1;
      while (j < lowprimes.length && m2 < lplim) {
        m2 *= lowprimes[j++];
      }
      m2 = x.modInt(m2);
      while (i < j) {
        if (m2 % lowprimes[i++] == 0) {
          return false;
        }
      }
    }
    return x.millerRabin(t2);
  };
  BigInteger2.prototype.copyTo = function(r) {
    for (var i = this.t - 1; i >= 0; --i) {
      r[i] = this[i];
    }
    r.t = this.t;
    r.s = this.s;
  };
  BigInteger2.prototype.fromInt = function(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) {
      this[0] = x;
    } else if (x < -1) {
      this[0] = x + this.DV;
    } else {
      this.t = 0;
    }
  };
  BigInteger2.prototype.fromString = function(s, b2) {
    var k;
    if (b2 == 16) {
      k = 4;
    } else if (b2 == 8) {
      k = 3;
    } else if (b2 == 256) {
      k = 8;
    } else if (b2 == 2) {
      k = 1;
    } else if (b2 == 32) {
      k = 5;
    } else if (b2 == 4) {
      k = 2;
    } else {
      this.fromRadix(s, b2);
      return;
    }
    this.t = 0;
    this.s = 0;
    var i = s.length;
    var mi = false;
    var sh2 = 0;
    while (--i >= 0) {
      var x = k == 8 ? +s[i] & 255 : intAt(s, i);
      if (x < 0) {
        if (s.charAt(i) == "-") {
          mi = true;
        }
        continue;
      }
      mi = false;
      if (sh2 == 0) {
        this[this.t++] = x;
      } else if (sh2 + k > this.DB) {
        this[this.t - 1] |= (x & (1 << this.DB - sh2) - 1) << sh2;
        this[this.t++] = x >> this.DB - sh2;
      } else {
        this[this.t - 1] |= x << sh2;
      }
      sh2 += k;
      if (sh2 >= this.DB) {
        sh2 -= this.DB;
      }
    }
    if (k == 8 && (+s[0] & 128) != 0) {
      this.s = -1;
      if (sh2 > 0) {
        this[this.t - 1] |= (1 << this.DB - sh2) - 1 << sh2;
      }
    }
    this.clamp();
    if (mi) {
      BigInteger2.ZERO.subTo(this, this);
    }
  };
  BigInteger2.prototype.clamp = function() {
    var c2 = this.s & this.DM;
    while (this.t > 0 && this[this.t - 1] == c2) {
      --this.t;
    }
  };
  BigInteger2.prototype.dlShiftTo = function(n, r) {
    var i;
    for (i = this.t - 1; i >= 0; --i) {
      r[i + n] = this[i];
    }
    for (i = n - 1; i >= 0; --i) {
      r[i] = 0;
    }
    r.t = this.t + n;
    r.s = this.s;
  };
  BigInteger2.prototype.drShiftTo = function(n, r) {
    for (var i = n; i < this.t; ++i) {
      r[i - n] = this[i];
    }
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
  };
  BigInteger2.prototype.lShiftTo = function(n, r) {
    var bs2 = n % this.DB;
    var cbs = this.DB - bs2;
    var bm2 = (1 << cbs) - 1;
    var ds = Math.floor(n / this.DB);
    var c2 = this.s << bs2 & this.DM;
    for (var i = this.t - 1; i >= 0; --i) {
      r[i + ds + 1] = this[i] >> cbs | c2;
      c2 = (this[i] & bm2) << bs2;
    }
    for (var i = ds - 1; i >= 0; --i) {
      r[i] = 0;
    }
    r[ds] = c2;
    r.t = this.t + ds + 1;
    r.s = this.s;
    r.clamp();
  };
  BigInteger2.prototype.rShiftTo = function(n, r) {
    r.s = this.s;
    var ds = Math.floor(n / this.DB);
    if (ds >= this.t) {
      r.t = 0;
      return;
    }
    var bs2 = n % this.DB;
    var cbs = this.DB - bs2;
    var bm2 = (1 << bs2) - 1;
    r[0] = this[ds] >> bs2;
    for (var i = ds + 1; i < this.t; ++i) {
      r[i - ds - 1] |= (this[i] & bm2) << cbs;
      r[i - ds] = this[i] >> bs2;
    }
    if (bs2 > 0) {
      r[this.t - ds - 1] |= (this.s & bm2) << cbs;
    }
    r.t = this.t - ds;
    r.clamp();
  };
  BigInteger2.prototype.subTo = function(a2, r) {
    var i = 0;
    var c2 = 0;
    var m2 = Math.min(a2.t, this.t);
    while (i < m2) {
      c2 += this[i] - a2[i];
      r[i++] = c2 & this.DM;
      c2 >>= this.DB;
    }
    if (a2.t < this.t) {
      c2 -= a2.s;
      while (i < this.t) {
        c2 += this[i];
        r[i++] = c2 & this.DM;
        c2 >>= this.DB;
      }
      c2 += this.s;
    } else {
      c2 += this.s;
      while (i < a2.t) {
        c2 -= a2[i];
        r[i++] = c2 & this.DM;
        c2 >>= this.DB;
      }
      c2 -= a2.s;
    }
    r.s = c2 < 0 ? -1 : 0;
    if (c2 < -1) {
      r[i++] = this.DV + c2;
    } else if (c2 > 0) {
      r[i++] = c2;
    }
    r.t = i;
    r.clamp();
  };
  BigInteger2.prototype.multiplyTo = function(a2, r) {
    var x = this.abs();
    var y = a2.abs();
    var i = x.t;
    r.t = i + y.t;
    while (--i >= 0) {
      r[i] = 0;
    }
    for (i = 0; i < y.t; ++i) {
      r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    }
    r.s = 0;
    r.clamp();
    if (this.s != a2.s) {
      BigInteger2.ZERO.subTo(r, r);
    }
  };
  BigInteger2.prototype.squareTo = function(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while (--i >= 0) {
      r[i] = 0;
    }
    for (i = 0; i < x.t - 1; ++i) {
      var c2 = x.am(i, x[i], r, 2 * i, 0, 1);
      if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c2, x.t - i - 1)) >= x.DV) {
        r[i + x.t] -= x.DV;
        r[i + x.t + 1] = 1;
      }
    }
    if (r.t > 0) {
      r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    }
    r.s = 0;
    r.clamp();
  };
  BigInteger2.prototype.divRemTo = function(m2, q, r) {
    var pm = m2.abs();
    if (pm.t <= 0) {
      return;
    }
    var pt2 = this.abs();
    if (pt2.t < pm.t) {
      if (q != null) {
        q.fromInt(0);
      }
      if (r != null) {
        this.copyTo(r);
      }
      return;
    }
    if (r == null) {
      r = nbi();
    }
    var y = nbi();
    var ts2 = this.s;
    var ms2 = m2.s;
    var nsh = this.DB - nbits(pm[pm.t - 1]);
    if (nsh > 0) {
      pm.lShiftTo(nsh, y);
      pt2.lShiftTo(nsh, r);
    } else {
      pm.copyTo(y);
      pt2.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) {
      return;
    }
    var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
    var d1 = this.FV / yt;
    var d2 = (1 << this.F1) / yt;
    var e2 = 1 << this.F2;
    var i = r.t;
    var j = i - ys;
    var t2 = q == null ? nbi() : q;
    y.dlShiftTo(j, t2);
    if (r.compareTo(t2) >= 0) {
      r[r.t++] = 1;
      r.subTo(t2, r);
    }
    BigInteger2.ONE.dlShiftTo(ys, t2);
    t2.subTo(y, y);
    while (y.t < ys) {
      y[y.t++] = 0;
    }
    while (--j >= 0) {
      var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e2) * d2);
      if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
        y.dlShiftTo(j, t2);
        r.subTo(t2, r);
        while (r[i] < --qd) {
          r.subTo(t2, r);
        }
      }
    }
    if (q != null) {
      r.drShiftTo(ys, q);
      if (ts2 != ms2) {
        BigInteger2.ZERO.subTo(q, q);
      }
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) {
      r.rShiftTo(nsh, r);
    }
    if (ts2 < 0) {
      BigInteger2.ZERO.subTo(r, r);
    }
  };
  BigInteger2.prototype.invDigit = function() {
    if (this.t < 1) {
      return 0;
    }
    var x = this[0];
    if ((x & 1) == 0) {
      return 0;
    }
    var y = x & 3;
    y = y * (2 - (x & 15) * y) & 15;
    y = y * (2 - (x & 255) * y) & 255;
    y = y * (2 - ((x & 65535) * y & 65535)) & 65535;
    y = y * (2 - x * y % this.DV) % this.DV;
    return y > 0 ? this.DV - y : -y;
  };
  BigInteger2.prototype.isEven = function() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
  };
  BigInteger2.prototype.exp = function(e2, z) {
    if (e2 > 4294967295 || e2 < 1) {
      return BigInteger2.ONE;
    }
    var r = nbi();
    var r2 = nbi();
    var g = z.convert(this);
    var i = nbits(e2) - 1;
    g.copyTo(r);
    while (--i >= 0) {
      z.sqrTo(r, r2);
      if ((e2 & 1 << i) > 0) {
        z.mulTo(r2, g, r);
      } else {
        var t2 = r;
        r = r2;
        r2 = t2;
      }
    }
    return z.revert(r);
  };
  BigInteger2.prototype.chunkSize = function(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
  };
  BigInteger2.prototype.toRadix = function(b2) {
    if (b2 == null) {
      b2 = 10;
    }
    if (this.signum() == 0 || b2 < 2 || b2 > 36) {
      return "0";
    }
    var cs2 = this.chunkSize(b2);
    var a2 = Math.pow(b2, cs2);
    var d2 = nbv(a2);
    var y = nbi();
    var z = nbi();
    var r = "";
    this.divRemTo(d2, y, z);
    while (y.signum() > 0) {
      r = (a2 + z.intValue()).toString(b2).substring(1) + r;
      y.divRemTo(d2, y, z);
    }
    return z.intValue().toString(b2) + r;
  };
  BigInteger2.prototype.fromRadix = function(s, b2) {
    this.fromInt(0);
    if (b2 == null) {
      b2 = 10;
    }
    var cs2 = this.chunkSize(b2);
    var d2 = Math.pow(b2, cs2);
    var mi = false;
    var j = 0;
    var w = 0;
    for (var i = 0; i < s.length; ++i) {
      var x = intAt(s, i);
      if (x < 0) {
        if (s.charAt(i) == "-" && this.signum() == 0) {
          mi = true;
        }
        continue;
      }
      w = b2 * w + x;
      if (++j >= cs2) {
        this.dMultiply(d2);
        this.dAddOffset(w, 0);
        j = 0;
        w = 0;
      }
    }
    if (j > 0) {
      this.dMultiply(Math.pow(b2, j));
      this.dAddOffset(w, 0);
    }
    if (mi) {
      BigInteger2.ZERO.subTo(this, this);
    }
  };
  BigInteger2.prototype.fromNumber = function(a2, b2, c2) {
    if ("number" == typeof b2) {
      if (a2 < 2) {
        this.fromInt(1);
      } else {
        this.fromNumber(a2, c2);
        if (!this.testBit(a2 - 1)) {
          this.bitwiseTo(BigInteger2.ONE.shiftLeft(a2 - 1), op_or, this);
        }
        if (this.isEven()) {
          this.dAddOffset(1, 0);
        }
        while (!this.isProbablePrime(b2)) {
          this.dAddOffset(2, 0);
          if (this.bitLength() > a2) {
            this.subTo(BigInteger2.ONE.shiftLeft(a2 - 1), this);
          }
        }
      }
    } else {
      var x = [];
      var t2 = a2 & 7;
      x.length = (a2 >> 3) + 1;
      b2.nextBytes(x);
      if (t2 > 0) {
        x[0] &= (1 << t2) - 1;
      } else {
        x[0] = 0;
      }
      this.fromString(x, 256);
    }
  };
  BigInteger2.prototype.bitwiseTo = function(a2, op, r) {
    var i;
    var f2;
    var m2 = Math.min(a2.t, this.t);
    for (i = 0; i < m2; ++i) {
      r[i] = op(this[i], a2[i]);
    }
    if (a2.t < this.t) {
      f2 = a2.s & this.DM;
      for (i = m2; i < this.t; ++i) {
        r[i] = op(this[i], f2);
      }
      r.t = this.t;
    } else {
      f2 = this.s & this.DM;
      for (i = m2; i < a2.t; ++i) {
        r[i] = op(f2, a2[i]);
      }
      r.t = a2.t;
    }
    r.s = op(this.s, a2.s);
    r.clamp();
  };
  BigInteger2.prototype.changeBit = function(n, op) {
    var r = BigInteger2.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
  };
  BigInteger2.prototype.addTo = function(a2, r) {
    var i = 0;
    var c2 = 0;
    var m2 = Math.min(a2.t, this.t);
    while (i < m2) {
      c2 += this[i] + a2[i];
      r[i++] = c2 & this.DM;
      c2 >>= this.DB;
    }
    if (a2.t < this.t) {
      c2 += a2.s;
      while (i < this.t) {
        c2 += this[i];
        r[i++] = c2 & this.DM;
        c2 >>= this.DB;
      }
      c2 += this.s;
    } else {
      c2 += this.s;
      while (i < a2.t) {
        c2 += a2[i];
        r[i++] = c2 & this.DM;
        c2 >>= this.DB;
      }
      c2 += a2.s;
    }
    r.s = c2 < 0 ? -1 : 0;
    if (c2 > 0) {
      r[i++] = c2;
    } else if (c2 < -1) {
      r[i++] = this.DV + c2;
    }
    r.t = i;
    r.clamp();
  };
  BigInteger2.prototype.dMultiply = function(n) {
    this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
  };
  BigInteger2.prototype.dAddOffset = function(n, w) {
    if (n == 0) {
      return;
    }
    while (this.t <= w) {
      this[this.t++] = 0;
    }
    this[w] += n;
    while (this[w] >= this.DV) {
      this[w] -= this.DV;
      if (++w >= this.t) {
        this[this.t++] = 0;
      }
      ++this[w];
    }
  };
  BigInteger2.prototype.multiplyLowerTo = function(a2, n, r) {
    var i = Math.min(this.t + a2.t, n);
    r.s = 0;
    r.t = i;
    while (i > 0) {
      r[--i] = 0;
    }
    for (var j = r.t - this.t; i < j; ++i) {
      r[i + this.t] = this.am(0, a2[i], r, i, 0, this.t);
    }
    for (var j = Math.min(a2.t, n); i < j; ++i) {
      this.am(0, a2[i], r, i, 0, n - i);
    }
    r.clamp();
  };
  BigInteger2.prototype.multiplyUpperTo = function(a2, n, r) {
    --n;
    var i = r.t = this.t + a2.t - n;
    r.s = 0;
    while (--i >= 0) {
      r[i] = 0;
    }
    for (i = Math.max(n - this.t, 0); i < a2.t; ++i) {
      r[this.t + i - n] = this.am(n - i, a2[i], r, 0, 0, this.t + i - n);
    }
    r.clamp();
    r.drShiftTo(1, r);
  };
  BigInteger2.prototype.modInt = function(n) {
    if (n <= 0) {
      return 0;
    }
    var d2 = this.DV % n;
    var r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) {
      if (d2 == 0) {
        r = this[0] % n;
      } else {
        for (var i = this.t - 1; i >= 0; --i) {
          r = (d2 * r + this[i]) % n;
        }
      }
    }
    return r;
  };
  BigInteger2.prototype.millerRabin = function(t2) {
    var n1 = this.subtract(BigInteger2.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) {
      return false;
    }
    var r = n1.shiftRight(k);
    t2 = t2 + 1 >> 1;
    if (t2 > lowprimes.length) {
      t2 = lowprimes.length;
    }
    var a2 = nbi();
    for (var i = 0; i < t2; ++i) {
      a2.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
      var y = a2.modPow(r, this);
      if (y.compareTo(BigInteger2.ONE) != 0 && y.compareTo(n1) != 0) {
        var j = 1;
        while (j++ < k && y.compareTo(n1) != 0) {
          y = y.modPowInt(2, this);
          if (y.compareTo(BigInteger2.ONE) == 0) {
            return false;
          }
        }
        if (y.compareTo(n1) != 0) {
          return false;
        }
      }
    }
    return true;
  };
  BigInteger2.prototype.square = function() {
    var r = nbi();
    this.squareTo(r);
    return r;
  };
  BigInteger2.prototype.gcda = function(a2, callback) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a2.s < 0 ? a2.negate() : a2.clone();
    if (x.compareTo(y) < 0) {
      var t2 = x;
      x = y;
      y = t2;
    }
    var i = x.getLowestSetBit();
    var g = y.getLowestSetBit();
    if (g < 0) {
      callback(x);
      return;
    }
    if (i < g) {
      g = i;
    }
    if (g > 0) {
      x.rShiftTo(g, x);
      y.rShiftTo(g, y);
    }
    var gcda1 = function() {
      if ((i = x.getLowestSetBit()) > 0) {
        x.rShiftTo(i, x);
      }
      if ((i = y.getLowestSetBit()) > 0) {
        y.rShiftTo(i, y);
      }
      if (x.compareTo(y) >= 0) {
        x.subTo(y, x);
        x.rShiftTo(1, x);
      } else {
        y.subTo(x, y);
        y.rShiftTo(1, y);
      }
      if (!(x.signum() > 0)) {
        if (g > 0) {
          y.lShiftTo(g, y);
        }
        setTimeout(function() {
          callback(y);
        }, 0);
      } else {
        setTimeout(gcda1, 0);
      }
    };
    setTimeout(gcda1, 10);
  };
  BigInteger2.prototype.fromNumberAsync = function(a2, b2, c2, callback) {
    if ("number" == typeof b2) {
      if (a2 < 2) {
        this.fromInt(1);
      } else {
        this.fromNumber(a2, c2);
        if (!this.testBit(a2 - 1)) {
          this.bitwiseTo(BigInteger2.ONE.shiftLeft(a2 - 1), op_or, this);
        }
        if (this.isEven()) {
          this.dAddOffset(1, 0);
        }
        var bnp_1 = this;
        var bnpfn1_1 = function() {
          bnp_1.dAddOffset(2, 0);
          if (bnp_1.bitLength() > a2) {
            bnp_1.subTo(BigInteger2.ONE.shiftLeft(a2 - 1), bnp_1);
          }
          if (bnp_1.isProbablePrime(b2)) {
            setTimeout(function() {
              callback();
            }, 0);
          } else {
            setTimeout(bnpfn1_1, 0);
          }
        };
        setTimeout(bnpfn1_1, 0);
      }
    } else {
      var x = [];
      var t2 = a2 & 7;
      x.length = (a2 >> 3) + 1;
      b2.nextBytes(x);
      if (t2 > 0) {
        x[0] &= (1 << t2) - 1;
      } else {
        x[0] = 0;
      }
      this.fromString(x, 256);
    }
  };
  return BigInteger2;
}();
var NullExp = function() {
  function NullExp2() {
  }
  NullExp2.prototype.convert = function(x) {
    return x;
  };
  NullExp2.prototype.revert = function(x) {
    return x;
  };
  NullExp2.prototype.mulTo = function(x, y, r) {
    x.multiplyTo(y, r);
  };
  NullExp2.prototype.sqrTo = function(x, r) {
    x.squareTo(r);
  };
  return NullExp2;
}();
var Classic = function() {
  function Classic2(m2) {
    this.m = m2;
  }
  Classic2.prototype.convert = function(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) {
      return x.mod(this.m);
    } else {
      return x;
    }
  };
  Classic2.prototype.revert = function(x) {
    return x;
  };
  Classic2.prototype.reduce = function(x) {
    x.divRemTo(this.m, null, x);
  };
  Classic2.prototype.mulTo = function(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
  };
  Classic2.prototype.sqrTo = function(x, r) {
    x.squareTo(r);
    this.reduce(r);
  };
  return Classic2;
}();
var Montgomery = function() {
  function Montgomery2(m2) {
    this.m = m2;
    this.mp = m2.invDigit();
    this.mpl = this.mp & 32767;
    this.mph = this.mp >> 15;
    this.um = (1 << m2.DB - 15) - 1;
    this.mt2 = 2 * m2.t;
  }
  Montgomery2.prototype.convert = function(x) {
    var r = nbi();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) {
      this.m.subTo(r, r);
    }
    return r;
  };
  Montgomery2.prototype.revert = function(x) {
    var r = nbi();
    x.copyTo(r);
    this.reduce(r);
    return r;
  };
  Montgomery2.prototype.reduce = function(x) {
    while (x.t <= this.mt2) {
      x[x.t++] = 0;
    }
    for (var i = 0; i < this.m.t; ++i) {
      var j = x[i] & 32767;
      var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
      j = i + this.m.t;
      x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
      while (x[j] >= x.DV) {
        x[j] -= x.DV;
        x[++j]++;
      }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) {
      x.subTo(this.m, x);
    }
  };
  Montgomery2.prototype.mulTo = function(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
  };
  Montgomery2.prototype.sqrTo = function(x, r) {
    x.squareTo(r);
    this.reduce(r);
  };
  return Montgomery2;
}();
var Barrett = function() {
  function Barrett2(m2) {
    this.m = m2;
    this.r2 = nbi();
    this.q3 = nbi();
    BigInteger.ONE.dlShiftTo(2 * m2.t, this.r2);
    this.mu = this.r2.divide(m2);
  }
  Barrett2.prototype.convert = function(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) {
      return x.mod(this.m);
    } else if (x.compareTo(this.m) < 0) {
      return x;
    } else {
      var r = nbi();
      x.copyTo(r);
      this.reduce(r);
      return r;
    }
  };
  Barrett2.prototype.revert = function(x) {
    return x;
  };
  Barrett2.prototype.reduce = function(x) {
    x.drShiftTo(this.m.t - 1, this.r2);
    if (x.t > this.m.t + 1) {
      x.t = this.m.t + 1;
      x.clamp();
    }
    this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
    this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
    while (x.compareTo(this.r2) < 0) {
      x.dAddOffset(1, this.m.t + 1);
    }
    x.subTo(this.r2, x);
    while (x.compareTo(this.m) >= 0) {
      x.subTo(this.m, x);
    }
  };
  Barrett2.prototype.mulTo = function(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
  };
  Barrett2.prototype.sqrTo = function(x, r) {
    x.squareTo(r);
    this.reduce(r);
  };
  return Barrett2;
}();
function nbi() {
  return new BigInteger(null);
}
function parseBigInt(str, r) {
  return new BigInteger(str, r);
}
var inBrowser = typeof navigator !== "undefined";
if (inBrowser && j_lm && navigator.appName == "Microsoft Internet Explorer") {
  BigInteger.prototype.am = function am2(i, x, w, j, c2, n) {
    var xl = x & 32767;
    var xh2 = x >> 15;
    while (--n >= 0) {
      var l = this[i] & 32767;
      var h = this[i++] >> 15;
      var m2 = xh2 * l + h * xl;
      l = xl * l + ((m2 & 32767) << 15) + w[j] + (c2 & 1073741823);
      c2 = (l >>> 30) + (m2 >>> 15) + xh2 * h + (c2 >>> 30);
      w[j++] = l & 1073741823;
    }
    return c2;
  };
  dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != "Netscape") {
  BigInteger.prototype.am = function am1(i, x, w, j, c2, n) {
    while (--n >= 0) {
      var v = x * this[i++] + w[j] + c2;
      c2 = Math.floor(v / 67108864);
      w[j++] = v & 67108863;
    }
    return c2;
  };
  dbits = 26;
} else {
  BigInteger.prototype.am = function am3(i, x, w, j, c2, n) {
    var xl = x & 16383;
    var xh2 = x >> 14;
    while (--n >= 0) {
      var l = this[i] & 16383;
      var h = this[i++] >> 14;
      var m2 = xh2 * l + h * xl;
      l = xl * l + ((m2 & 16383) << 14) + w[j] + c2;
      c2 = (l >> 28) + (m2 >> 14) + xh2 * h;
      w[j++] = l & 268435455;
    }
    return c2;
  };
  dbits = 28;
}
BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP;
var BI_RC = [];
var rr;
var vv;
rr = "0".charCodeAt(0);
for (vv = 0; vv <= 9; ++vv) {
  BI_RC[rr++] = vv;
}
rr = "a".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}
rr = "A".charCodeAt(0);
for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}
function intAt(s, i) {
  var c2 = BI_RC[s.charCodeAt(i)];
  return c2 == null ? -1 : c2;
}
function nbv(i) {
  var r = nbi();
  r.fromInt(i);
  return r;
}
function nbits(x) {
  var r = 1;
  var t2;
  if ((t2 = x >>> 16) != 0) {
    x = t2;
    r += 16;
  }
  if ((t2 = x >> 8) != 0) {
    x = t2;
    r += 8;
  }
  if ((t2 = x >> 4) != 0) {
    x = t2;
    r += 4;
  }
  if ((t2 = x >> 2) != 0) {
    x = t2;
    r += 2;
  }
  if ((t2 = x >> 1) != 0) {
    x = t2;
    r += 1;
  }
  return r;
}
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);
var Arcfour = function() {
  function Arcfour2() {
    this.i = 0;
    this.j = 0;
    this.S = [];
  }
  Arcfour2.prototype.init = function(key) {
    var i;
    var j;
    var t2;
    for (i = 0; i < 256; ++i) {
      this.S[i] = i;
    }
    j = 0;
    for (i = 0; i < 256; ++i) {
      j = j + this.S[i] + key[i % key.length] & 255;
      t2 = this.S[i];
      this.S[i] = this.S[j];
      this.S[j] = t2;
    }
    this.i = 0;
    this.j = 0;
  };
  Arcfour2.prototype.next = function() {
    var t2;
    this.i = this.i + 1 & 255;
    this.j = this.j + this.S[this.i] & 255;
    t2 = this.S[this.i];
    this.S[this.i] = this.S[this.j];
    this.S[this.j] = t2;
    return this.S[t2 + this.S[this.i] & 255];
  };
  return Arcfour2;
}();
function prng_newstate() {
  return new Arcfour();
}
var rng_psize = 256;
var rng_state;
var rng_pool = null;
var rng_pptr;
if (rng_pool == null) {
  rng_pool = [];
  rng_pptr = 0;
  var t$4 = void 0;
  if (typeof window !== "undefined" && self.crypto && self.crypto.getRandomValues) {
    var z = new Uint32Array(256);
    self.crypto.getRandomValues(z);
    for (t$4 = 0; t$4 < z.length; ++t$4) {
      rng_pool[rng_pptr++] = z[t$4] & 255;
    }
  }
  var count = 0;
  var onMouseMoveListener_1 = function(ev) {
    count = count || 0;
    if (count >= 256 || rng_pptr >= rng_psize) {
      if (self.removeEventListener) {
        self.removeEventListener("mousemove", onMouseMoveListener_1, false);
      } else if (self.detachEvent) {
        self.detachEvent("onmousemove", onMouseMoveListener_1);
      }
      return;
    }
    try {
      var mouseCoordinates = ev.x + ev.y;
      rng_pool[rng_pptr++] = mouseCoordinates & 255;
      count += 1;
    } catch (e2) {
    }
  };
  if (typeof window !== "undefined") {
    if (self.addEventListener) {
      self.addEventListener("mousemove", onMouseMoveListener_1, false);
    } else if (self.attachEvent) {
      self.attachEvent("onmousemove", onMouseMoveListener_1);
    }
  }
}
function rng_get_byte() {
  if (rng_state == null) {
    rng_state = prng_newstate();
    while (rng_pptr < rng_psize) {
      var random = Math.floor(65536 * Math.random());
      rng_pool[rng_pptr++] = random & 255;
    }
    rng_state.init(rng_pool);
    for (rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr) {
      rng_pool[rng_pptr] = 0;
    }
    rng_pptr = 0;
  }
  return rng_state.next();
}
var SecureRandom = function() {
  function SecureRandom2() {
  }
  SecureRandom2.prototype.nextBytes = function(ba) {
    for (var i = 0; i < ba.length; ++i) {
      ba[i] = rng_get_byte();
    }
  };
  return SecureRandom2;
}();
function rstr_sha256(s) {
  return binb2rstr(binb_sha256(rstr2binb(s), s.length * 8));
}
function rstr2hex(input) {
  var hex_tab = "0123456789abcdef";
  var output = "";
  for (var i = 0; i < input.length; i++) {
    var x = input.charCodeAt(i);
    output += hex_tab.charAt(x >>> 4 & 15) + hex_tab.charAt(x & 15);
  }
  return output;
}
function rstr2binb(input) {
  var output = Array(input.length >> 2);
  for (var i = 0; i < output.length; i++)
    output[i] = 0;
  for (var i = 0; i < input.length * 8; i += 8)
    output[i >> 5] |= (input.charCodeAt(i / 8) & 255) << 24 - i % 32;
  return output;
}
function binb2rstr(input) {
  var output = "";
  for (var i = 0; i < input.length * 32; i += 8)
    output += String.fromCharCode(input[i >> 5] >>> 24 - i % 32 & 255);
  return output;
}
function sha256_S(X, n) {
  return X >>> n | X << 32 - n;
}
function sha256_R(X, n) {
  return X >>> n;
}
function sha256_Ch(x, y, z) {
  return x & y ^ ~x & z;
}
function sha256_Maj(x, y, z) {
  return x & y ^ x & z ^ y & z;
}
function sha256_Sigma0256(x) {
  return sha256_S(x, 2) ^ sha256_S(x, 13) ^ sha256_S(x, 22);
}
function sha256_Sigma1256(x) {
  return sha256_S(x, 6) ^ sha256_S(x, 11) ^ sha256_S(x, 25);
}
function sha256_Gamma0256(x) {
  return sha256_S(x, 7) ^ sha256_S(x, 18) ^ sha256_R(x, 3);
}
function sha256_Gamma1256(x) {
  return sha256_S(x, 17) ^ sha256_S(x, 19) ^ sha256_R(x, 10);
}
var sha256_K = new Array(1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998);
function binb_sha256(m2, l) {
  var HASH = new Array(1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225);
  var W = new Array(64);
  var a2, b2, c2, d2, e2, f2, g, h;
  var i, j, T1, T2;
  m2[l >> 5] |= 128 << 24 - l % 32;
  m2[(l + 64 >> 9 << 4) + 15] = l;
  for (i = 0; i < m2.length; i += 16) {
    a2 = HASH[0];
    b2 = HASH[1];
    c2 = HASH[2];
    d2 = HASH[3];
    e2 = HASH[4];
    f2 = HASH[5];
    g = HASH[6];
    h = HASH[7];
    for (j = 0; j < 64; j++) {
      if (j < 16)
        W[j] = m2[j + i];
      else
        W[j] = safe_add(safe_add(safe_add(sha256_Gamma1256(W[j - 2]), W[j - 7]), sha256_Gamma0256(W[j - 15])), W[j - 16]);
      T1 = safe_add(safe_add(safe_add(safe_add(h, sha256_Sigma1256(e2)), sha256_Ch(e2, f2, g)), sha256_K[j]), W[j]);
      T2 = safe_add(sha256_Sigma0256(a2), sha256_Maj(a2, b2, c2));
      h = g;
      g = f2;
      f2 = e2;
      e2 = safe_add(d2, T1);
      d2 = c2;
      c2 = b2;
      b2 = a2;
      a2 = safe_add(T1, T2);
    }
    HASH[0] = safe_add(a2, HASH[0]);
    HASH[1] = safe_add(b2, HASH[1]);
    HASH[2] = safe_add(c2, HASH[2]);
    HASH[3] = safe_add(d2, HASH[3]);
    HASH[4] = safe_add(e2, HASH[4]);
    HASH[5] = safe_add(f2, HASH[5]);
    HASH[6] = safe_add(g, HASH[6]);
    HASH[7] = safe_add(h, HASH[7]);
  }
  return HASH;
}
function safe_add(x, y) {
  var lsw = (x & 65535) + (y & 65535);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 65535;
}
function pkcs1pad1(s, n) {
  if (n < s.length + 22) {
    console.error("Message too long for RSA");
    return null;
  }
  var len = n - s.length - 6;
  var filler = "";
  for (var f2 = 0; f2 < len; f2 += 2) {
    filler += "ff";
  }
  var m2 = "0001" + filler + "00" + s;
  return parseBigInt(m2, 16);
}
function pkcs1pad2(s, n) {
  if (n < s.length + 11) {
    console.error("Message too long for RSA");
    return null;
  }
  var ba = [];
  var i = s.length - 1;
  while (i >= 0 && n > 0) {
    var c2 = s.charCodeAt(i--);
    if (c2 < 128) {
      ba[--n] = c2;
    } else if (c2 > 127 && c2 < 2048) {
      ba[--n] = c2 & 63 | 128;
      ba[--n] = c2 >> 6 | 192;
    } else {
      ba[--n] = c2 & 63 | 128;
      ba[--n] = c2 >> 6 & 63 | 128;
      ba[--n] = c2 >> 12 | 224;
    }
  }
  ba[--n] = 0;
  var rng = new SecureRandom();
  var x = [];
  while (n > 2) {
    x[0] = 0;
    while (x[0] == 0) {
      rng.nextBytes(x);
    }
    ba[--n] = x[0];
  }
  ba[--n] = 2;
  ba[--n] = 0;
  return new BigInteger(ba);
}
function oaep_mgf1_arr(seed, len, hashFunc) {
  var mask = "", i = 0;
  while (mask.length < len) {
    mask += hashFunc(String.fromCharCode.apply(String, seed.concat([
      (i & 4278190080) >> 24,
      (i & 16711680) >> 16,
      (i & 65280) >> 8,
      i & 255
    ])));
    i += 1;
  }
  return mask;
}
var SHA256_SIZE = 32;
function oaep_pad(s, n) {
  var hashLen = SHA256_SIZE;
  var hashFunc = rstr_sha256;
  if (s.length + 2 * hashLen + 2 > n) {
    throw "Message too long for RSA";
  }
  var PS = "", i;
  for (i = 0; i < n - s.length - 2 * hashLen - 2; i += 1) {
    PS += "\0";
  }
  var DB = hashFunc("") + PS + "" + s, seed = new Array(hashLen);
  new SecureRandom().nextBytes(seed);
  var dbMask = oaep_mgf1_arr(seed, DB.length, hashFunc), maskedDB = [];
  for (i = 0; i < DB.length; i += 1) {
    maskedDB[i] = DB.charCodeAt(i) ^ dbMask.charCodeAt(i);
  }
  var seedMask = oaep_mgf1_arr(maskedDB, seed.length, hashFunc), maskedSeed = [0];
  for (i = 0; i < seed.length; i += 1) {
    maskedSeed[i + 1] = seed[i] ^ seedMask.charCodeAt(i);
  }
  return new BigInteger(maskedSeed.concat(maskedDB));
}
var RSAKey = function() {
  function RSAKey2() {
    this.n = null;
    this.e = 0;
    this.d = null;
    this.p = null;
    this.q = null;
    this.dmp1 = null;
    this.dmq1 = null;
    this.coeff = null;
  }
  RSAKey2.prototype.doPublic = function(x) {
    return x.modPowInt(this.e, this.n);
  };
  RSAKey2.prototype.doPrivate = function(x) {
    if (this.p == null || this.q == null) {
      return x.modPow(this.d, this.n);
    }
    var xp = x.mod(this.p).modPow(this.dmp1, this.p);
    var xq = x.mod(this.q).modPow(this.dmq1, this.q);
    while (xp.compareTo(xq) < 0) {
      xp = xp.add(this.p);
    }
    return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
  };
  RSAKey2.prototype.setPublic = function(N, E) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
      this.n = parseBigInt(N, 16);
      this.e = parseInt(E, 16);
    } else {
      console.error("Invalid RSA public key");
    }
  };
  RSAKey2.prototype.encrypt = function(text, paddingFunction) {
    if (typeof paddingFunction === "undefined") {
      paddingFunction = pkcs1pad2;
    }
    var maxLength = this.n.bitLength() + 7 >> 3;
    var m2 = paddingFunction(text, maxLength);
    if (m2 == null) {
      return null;
    }
    var c2 = this.doPublic(m2);
    if (c2 == null) {
      return null;
    }
    var h = c2.toString(16);
    var length = h.length;
    for (var i = 0; i < maxLength * 2 - length; i++) {
      h = "0" + h;
    }
    return h;
  };
  RSAKey2.prototype.setPrivate = function(N, E, D) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
      this.n = parseBigInt(N, 16);
      this.e = parseInt(E, 16);
      this.d = parseBigInt(D, 16);
    } else {
      console.error("Invalid RSA private key");
    }
  };
  RSAKey2.prototype.setPrivateEx = function(N, E, D, P, Q, DP, DQ, C) {
    if (N != null && E != null && N.length > 0 && E.length > 0) {
      this.n = parseBigInt(N, 16);
      this.e = parseInt(E, 16);
      this.d = parseBigInt(D, 16);
      this.p = parseBigInt(P, 16);
      this.q = parseBigInt(Q, 16);
      this.dmp1 = parseBigInt(DP, 16);
      this.dmq1 = parseBigInt(DQ, 16);
      this.coeff = parseBigInt(C, 16);
    } else {
      console.error("Invalid RSA private key");
    }
  };
  RSAKey2.prototype.generate = function(B, E) {
    var rng = new SecureRandom();
    var qs = B >> 1;
    this.e = parseInt(E, 16);
    var ee2 = new BigInteger(E, 16);
    for (; ; ) {
      for (; ; ) {
        this.p = new BigInteger(B - qs, 1, rng);
        if (this.p.subtract(BigInteger.ONE).gcd(ee2).compareTo(BigInteger.ONE) == 0 && this.p.isProbablePrime(10)) {
          break;
        }
      }
      for (; ; ) {
        this.q = new BigInteger(qs, 1, rng);
        if (this.q.subtract(BigInteger.ONE).gcd(ee2).compareTo(BigInteger.ONE) == 0 && this.q.isProbablePrime(10)) {
          break;
        }
      }
      if (this.p.compareTo(this.q) <= 0) {
        var t2 = this.p;
        this.p = this.q;
        this.q = t2;
      }
      var p1 = this.p.subtract(BigInteger.ONE);
      var q1 = this.q.subtract(BigInteger.ONE);
      var phi = p1.multiply(q1);
      if (phi.gcd(ee2).compareTo(BigInteger.ONE) == 0) {
        this.n = this.p.multiply(this.q);
        this.d = ee2.modInverse(phi);
        this.dmp1 = this.d.mod(p1);
        this.dmq1 = this.d.mod(q1);
        this.coeff = this.q.modInverse(this.p);
        break;
      }
    }
  };
  RSAKey2.prototype.decrypt = function(ctext) {
    var c2 = parseBigInt(ctext, 16);
    var m2 = this.doPrivate(c2);
    if (m2 == null) {
      return null;
    }
    return pkcs1unpad2(m2, this.n.bitLength() + 7 >> 3);
  };
  RSAKey2.prototype.generateAsync = function(B, E, callback) {
    var rng = new SecureRandom();
    var qs = B >> 1;
    this.e = parseInt(E, 16);
    var ee2 = new BigInteger(E, 16);
    var rsa = this;
    var loop1 = function() {
      var loop4 = function() {
        if (rsa.p.compareTo(rsa.q) <= 0) {
          var t2 = rsa.p;
          rsa.p = rsa.q;
          rsa.q = t2;
        }
        var p1 = rsa.p.subtract(BigInteger.ONE);
        var q1 = rsa.q.subtract(BigInteger.ONE);
        var phi = p1.multiply(q1);
        if (phi.gcd(ee2).compareTo(BigInteger.ONE) == 0) {
          rsa.n = rsa.p.multiply(rsa.q);
          rsa.d = ee2.modInverse(phi);
          rsa.dmp1 = rsa.d.mod(p1);
          rsa.dmq1 = rsa.d.mod(q1);
          rsa.coeff = rsa.q.modInverse(rsa.p);
          setTimeout(function() {
            callback();
          }, 0);
        } else {
          setTimeout(loop1, 0);
        }
      };
      var loop3 = function() {
        rsa.q = nbi();
        rsa.q.fromNumberAsync(qs, 1, rng, function() {
          rsa.q.subtract(BigInteger.ONE).gcda(ee2, function(r) {
            if (r.compareTo(BigInteger.ONE) == 0 && rsa.q.isProbablePrime(10)) {
              setTimeout(loop4, 0);
            } else {
              setTimeout(loop3, 0);
            }
          });
        });
      };
      var loop2 = function() {
        rsa.p = nbi();
        rsa.p.fromNumberAsync(B - qs, 1, rng, function() {
          rsa.p.subtract(BigInteger.ONE).gcda(ee2, function(r) {
            if (r.compareTo(BigInteger.ONE) == 0 && rsa.p.isProbablePrime(10)) {
              setTimeout(loop3, 0);
            } else {
              setTimeout(loop2, 0);
            }
          });
        });
      };
      setTimeout(loop2, 0);
    };
    setTimeout(loop1, 0);
  };
  RSAKey2.prototype.sign = function(text, digestMethod, digestName) {
    var header = getDigestHeader(digestName);
    var digest = header + digestMethod(text).toString();
    var maxLength = this.n.bitLength() / 4;
    var m2 = pkcs1pad1(digest, maxLength);
    if (m2 == null) {
      return null;
    }
    var c2 = this.doPrivate(m2);
    if (c2 == null) {
      return null;
    }
    var h = c2.toString(16);
    var length = h.length;
    for (var i = 0; i < maxLength - length; i++) {
      h = "0" + h;
    }
    return h;
  };
  RSAKey2.prototype.verify = function(text, signature, digestMethod) {
    var c2 = parseBigInt(signature, 16);
    var m2 = this.doPublic(c2);
    if (m2 == null) {
      return null;
    }
    var unpadded = m2.toString(16).replace(/^1f+00/, "");
    var digest = removeDigestHeader(unpadded);
    return digest == digestMethod(text).toString();
  };
  return RSAKey2;
}();
function pkcs1unpad2(d2, n) {
  var b2 = d2.toByteArray();
  var i = 0;
  while (i < b2.length && b2[i] == 0) {
    ++i;
  }
  if (b2.length - i != n - 1 || b2[i] != 2) {
    return null;
  }
  ++i;
  while (b2[i] != 0) {
    if (++i >= b2.length) {
      return null;
    }
  }
  var ret = "";
  while (++i < b2.length) {
    var c2 = b2[i] & 255;
    if (c2 < 128) {
      ret += String.fromCharCode(c2);
    } else if (c2 > 191 && c2 < 224) {
      ret += String.fromCharCode((c2 & 31) << 6 | b2[i + 1] & 63);
      ++i;
    } else {
      ret += String.fromCharCode((c2 & 15) << 12 | (b2[i + 1] & 63) << 6 | b2[i + 2] & 63);
      i += 2;
    }
  }
  return ret;
}
var DIGEST_HEADERS = {
  md2: "3020300c06082a864886f70d020205000410",
  md5: "3020300c06082a864886f70d020505000410",
  sha1: "3021300906052b0e03021a05000414",
  sha224: "302d300d06096086480165030402040500041c",
  sha256: "3031300d060960864801650304020105000420",
  sha384: "3041300d060960864801650304020205000430",
  sha512: "3051300d060960864801650304020305000440",
  ripemd160: "3021300906052b2403020105000414"
};
function getDigestHeader(name2) {
  return DIGEST_HEADERS[name2] || "";
}
function removeDigestHeader(str) {
  for (var name_1 in DIGEST_HEADERS) {
    if (DIGEST_HEADERS.hasOwnProperty(name_1)) {
      var header = DIGEST_HEADERS[name_1];
      var len = header.length;
      if (str.substring(0, len) == header) {
        return str.substring(len);
      }
    }
  }
  return str;
}
function extendClass(subc, superc, overrides) {
  if (!superc || !subc) {
    throw new Error("extend failed, please check that all dependencies are included.");
  }
  var F = function() {
  };
  F.prototype = superc.prototype;
  subc.prototype = new F();
  subc.prototype.constructor = subc;
  subc.superclass = superc.prototype;
  if (superc.prototype.constructor == Object.prototype.constructor) {
    superc.prototype.constructor = superc;
  }
  if (overrides) {
    var i;
    for (i in overrides) {
      subc.prototype[i] = overrides[i];
    }
    var _IEEnumFix = function() {
    }, ADD = ["toString", "valueOf"];
    try {
      if (/MSIE/.test(navigator.userAgent)) {
        _IEEnumFix = function(r, s) {
          for (i = 0; i < ADD.length; i = i + 1) {
            var fname = ADD[i], f2 = s[fname];
            if (typeof f2 === "function" && f2 != Object.prototype[fname]) {
              r[fname] = f2;
            }
          }
        };
      }
    } catch (ex) {
    }
    _IEEnumFix(subc.prototype, overrides);
  }
}
/**
 * @fileOverview
 * @name asn1-1.0.js
 * @author Kenji Urushima kenji.urushima@gmail.com
 * @version asn1 1.0.13 (2017-Jun-02)
 * @since jsrsasign 2.1
 * @license <a href="https://kjur.github.io/jsrsasign/license/">MIT License</a>
 */
var KJUR = {};
if (typeof KJUR.asn1 == "undefined" || !KJUR.asn1)
  KJUR.asn1 = {};
KJUR.asn1.ASN1Util = new function() {
  this.integerToByteHex = function(i) {
    var h = i.toString(16);
    if (h.length % 2 == 1)
      h = "0" + h;
    return h;
  };
  this.bigIntToMinTwosComplementsHex = function(bigIntegerValue) {
    var h = bigIntegerValue.toString(16);
    if (h.substring(0, 1) != "-") {
      if (h.length % 2 == 1) {
        h = "0" + h;
      } else {
        if (!h.match(/^[0-7]/)) {
          h = "00" + h;
        }
      }
    } else {
      var hPos = h.substring(1);
      var xorLen = hPos.length;
      if (xorLen % 2 == 1) {
        xorLen += 1;
      } else {
        if (!h.match(/^[0-7]/)) {
          xorLen += 2;
        }
      }
      var hMask = "";
      for (var i = 0; i < xorLen; i++) {
        hMask += "f";
      }
      var biMask = new BigInteger(hMask, 16);
      var biNeg = biMask.xor(bigIntegerValue).add(BigInteger.ONE);
      h = biNeg.toString(16).replace(/^-/, "");
    }
    return h;
  };
  this.getPEMStringFromHex = function(dataHex, pemHeader) {
    return hextopem(dataHex, pemHeader);
  };
  this.newObject = function(param) {
    var _KJUR = KJUR, _KJUR_asn1 = _KJUR.asn1, _DERBoolean = _KJUR_asn1.DERBoolean, _DERInteger = _KJUR_asn1.DERInteger, _DERBitString = _KJUR_asn1.DERBitString, _DEROctetString = _KJUR_asn1.DEROctetString, _DERNull = _KJUR_asn1.DERNull, _DERObjectIdentifier = _KJUR_asn1.DERObjectIdentifier, _DEREnumerated = _KJUR_asn1.DEREnumerated, _DERUTF8String = _KJUR_asn1.DERUTF8String, _DERNumericString = _KJUR_asn1.DERNumericString, _DERPrintableString = _KJUR_asn1.DERPrintableString, _DERTeletexString = _KJUR_asn1.DERTeletexString, _DERIA5String = _KJUR_asn1.DERIA5String, _DERUTCTime = _KJUR_asn1.DERUTCTime, _DERGeneralizedTime = _KJUR_asn1.DERGeneralizedTime, _DERSequence = _KJUR_asn1.DERSequence, _DERSet = _KJUR_asn1.DERSet, _DERTaggedObject = _KJUR_asn1.DERTaggedObject, _newObject = _KJUR_asn1.ASN1Util.newObject;
    var keys2 = Object.keys(param);
    if (keys2.length != 1)
      throw "key of param shall be only one.";
    var key = keys2[0];
    if (":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + key + ":") == -1)
      throw "undefined key: " + key;
    if (key == "bool")
      return new _DERBoolean(param[key]);
    if (key == "int")
      return new _DERInteger(param[key]);
    if (key == "bitstr")
      return new _DERBitString(param[key]);
    if (key == "octstr")
      return new _DEROctetString(param[key]);
    if (key == "null")
      return new _DERNull(param[key]);
    if (key == "oid")
      return new _DERObjectIdentifier(param[key]);
    if (key == "enum")
      return new _DEREnumerated(param[key]);
    if (key == "utf8str")
      return new _DERUTF8String(param[key]);
    if (key == "numstr")
      return new _DERNumericString(param[key]);
    if (key == "prnstr")
      return new _DERPrintableString(param[key]);
    if (key == "telstr")
      return new _DERTeletexString(param[key]);
    if (key == "ia5str")
      return new _DERIA5String(param[key]);
    if (key == "utctime")
      return new _DERUTCTime(param[key]);
    if (key == "gentime")
      return new _DERGeneralizedTime(param[key]);
    if (key == "seq") {
      var paramList = param[key];
      var a2 = [];
      for (var i = 0; i < paramList.length; i++) {
        var asn1Obj = _newObject(paramList[i]);
        a2.push(asn1Obj);
      }
      return new _DERSequence({ "array": a2 });
    }
    if (key == "set") {
      var paramList = param[key];
      var a2 = [];
      for (var i = 0; i < paramList.length; i++) {
        var asn1Obj = _newObject(paramList[i]);
        a2.push(asn1Obj);
      }
      return new _DERSet({ "array": a2 });
    }
    if (key == "tag") {
      var tagParam = param[key];
      if (Object.prototype.toString.call(tagParam) === "[object Array]" && tagParam.length == 3) {
        var obj = _newObject(tagParam[2]);
        return new _DERTaggedObject({
          tag: tagParam[0],
          explicit: tagParam[1],
          obj
        });
      } else {
        var newParam = {};
        if (tagParam.explicit !== void 0)
          newParam.explicit = tagParam.explicit;
        if (tagParam.tag !== void 0)
          newParam.tag = tagParam.tag;
        if (tagParam.obj === void 0)
          throw "obj shall be specified for 'tag'.";
        newParam.obj = _newObject(tagParam.obj);
        return new _DERTaggedObject(newParam);
      }
    }
  };
  this.jsonToASN1HEX = function(param) {
    var asn1Obj = this.newObject(param);
    return asn1Obj.getEncodedHex();
  };
}();
KJUR.asn1.ASN1Util.oidHexToInt = function(hex) {
  var s = "";
  var i01 = parseInt(hex.substring(0, 2), 16);
  var i0 = Math.floor(i01 / 40);
  var i1 = i01 % 40;
  var s = i0 + "." + i1;
  var binbuf = "";
  for (var i = 2; i < hex.length; i += 2) {
    var value = parseInt(hex.substring(i, i + 2), 16);
    var bin = ("00000000" + value.toString(2)).slice(-8);
    binbuf = binbuf + bin.substring(1, 8);
    if (bin.substring(0, 1) == "0") {
      var bi = new BigInteger(binbuf, 2);
      s = s + "." + bi.toString(10);
      binbuf = "";
    }
  }
  return s;
};
KJUR.asn1.ASN1Util.oidIntToHex = function(oidString) {
  var itox = function(i2) {
    var h2 = i2.toString(16);
    if (h2.length == 1)
      h2 = "0" + h2;
    return h2;
  };
  var roidtox = function(roid) {
    var h2 = "";
    var bi = new BigInteger(roid, 10);
    var b2 = bi.toString(2);
    var padLen = 7 - b2.length % 7;
    if (padLen == 7)
      padLen = 0;
    var bPad = "";
    for (var i2 = 0; i2 < padLen; i2++)
      bPad += "0";
    b2 = bPad + b2;
    for (var i2 = 0; i2 < b2.length - 1; i2 += 7) {
      var b8 = b2.substring(i2, i2 + 7);
      if (i2 != b2.length - 7)
        b8 = "1" + b8;
      h2 += itox(parseInt(b8, 2));
    }
    return h2;
  };
  if (!oidString.match(/^[0-9.]+$/)) {
    throw "malformed oid string: " + oidString;
  }
  var h = "";
  var a2 = oidString.split(".");
  var i0 = parseInt(a2[0]) * 40 + parseInt(a2[1]);
  h += itox(i0);
  a2.splice(0, 2);
  for (var i = 0; i < a2.length; i++) {
    h += roidtox(a2[i]);
  }
  return h;
};
KJUR.asn1.ASN1Object = function() {
  var hV = "";
  this.getLengthHexFromValue = function() {
    if (typeof this.hV == "undefined" || this.hV == null) {
      throw "this.hV is null or undefined.";
    }
    if (this.hV.length % 2 == 1) {
      throw "value hex must be even length: n=" + hV.length + ",v=" + this.hV;
    }
    var n = this.hV.length / 2;
    var hN = n.toString(16);
    if (hN.length % 2 == 1) {
      hN = "0" + hN;
    }
    if (n < 128) {
      return hN;
    } else {
      var hNlen = hN.length / 2;
      if (hNlen > 15) {
        throw "ASN.1 length too long to represent by 8x: n = " + n.toString(16);
      }
      var head = 128 + hNlen;
      return head.toString(16) + hN;
    }
  };
  this.getEncodedHex = function() {
    if (this.hTLV == null || this.isModified) {
      this.hV = this.getFreshValueHex();
      this.hL = this.getLengthHexFromValue();
      this.hTLV = this.hT + this.hL + this.hV;
      this.isModified = false;
    }
    return this.hTLV;
  };
  this.getValueHex = function() {
    this.getEncodedHex();
    return this.hV;
  };
  this.getFreshValueHex = function() {
    return "";
  };
};
KJUR.asn1.DERAbstractString = function(params) {
  KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
  this.getString = function() {
    return this.s;
  };
  this.setString = function(newS) {
    this.hTLV = null;
    this.isModified = true;
    this.s = newS;
    this.hV = stohex(this.s);
  };
  this.setStringHex = function(newHexString) {
    this.hTLV = null;
    this.isModified = true;
    this.s = null;
    this.hV = newHexString;
  };
  this.getFreshValueHex = function() {
    return this.hV;
  };
  if (typeof params != "undefined") {
    if (typeof params == "string") {
      this.setString(params);
    } else if (typeof params["str"] != "undefined") {
      this.setString(params["str"]);
    } else if (typeof params["hex"] != "undefined") {
      this.setStringHex(params["hex"]);
    }
  }
};
extendClass(KJUR.asn1.DERAbstractString, KJUR.asn1.ASN1Object);
KJUR.asn1.DERAbstractTime = function(params) {
  KJUR.asn1.DERAbstractTime.superclass.constructor.call(this);
  this.localDateToUTC = function(d2) {
    utc = d2.getTime() + d2.getTimezoneOffset() * 6e4;
    var utcDate = new Date(utc);
    return utcDate;
  };
  this.formatDate = function(dateObject, type2, withMillis) {
    var pad2 = this.zeroPadding;
    var d2 = this.localDateToUTC(dateObject);
    var year = String(d2.getFullYear());
    if (type2 == "utc")
      year = year.substring(2, 4);
    var month = pad2(String(d2.getMonth() + 1), 2);
    var day = pad2(String(d2.getDate()), 2);
    var hour = pad2(String(d2.getHours()), 2);
    var min2 = pad2(String(d2.getMinutes()), 2);
    var sec = pad2(String(d2.getSeconds()), 2);
    var s = year + month + day + hour + min2 + sec;
    if (withMillis === true) {
      var millis = d2.getMilliseconds();
      if (millis != 0) {
        var sMillis = pad2(String(millis), 3);
        sMillis = sMillis.replace(/[0]+$/, "");
        s = s + "." + sMillis;
      }
    }
    return s + "Z";
  };
  this.zeroPadding = function(s, len) {
    if (s.length >= len)
      return s;
    return new Array(len - s.length + 1).join("0") + s;
  };
  this.getString = function() {
    return this.s;
  };
  this.setString = function(newS) {
    this.hTLV = null;
    this.isModified = true;
    this.s = newS;
    this.hV = stohex(newS);
  };
  this.setByDateValue = function(year, month, day, hour, min2, sec) {
    var dateObject = new Date(Date.UTC(year, month - 1, day, hour, min2, sec, 0));
    this.setByDate(dateObject);
  };
  this.getFreshValueHex = function() {
    return this.hV;
  };
};
extendClass(KJUR.asn1.DERAbstractTime, KJUR.asn1.ASN1Object);
KJUR.asn1.DERAbstractStructured = function(params) {
  KJUR.asn1.DERAbstractString.superclass.constructor.call(this);
  this.setByASN1ObjectArray = function(asn1ObjectArray) {
    this.hTLV = null;
    this.isModified = true;
    this.asn1Array = asn1ObjectArray;
  };
  this.appendASN1Object = function(asn1Object) {
    this.hTLV = null;
    this.isModified = true;
    this.asn1Array.push(asn1Object);
  };
  this.asn1Array = new Array();
  if (typeof params != "undefined") {
    if (typeof params["array"] != "undefined") {
      this.asn1Array = params["array"];
    }
  }
};
extendClass(KJUR.asn1.DERAbstractStructured, KJUR.asn1.ASN1Object);
KJUR.asn1.DERBoolean = function() {
  KJUR.asn1.DERBoolean.superclass.constructor.call(this);
  this.hT = "01";
  this.hTLV = "0101ff";
};
extendClass(KJUR.asn1.DERBoolean, KJUR.asn1.ASN1Object);
KJUR.asn1.DERInteger = function(params) {
  KJUR.asn1.DERInteger.superclass.constructor.call(this);
  this.hT = "02";
  this.setByBigInteger = function(bigIntegerValue) {
    this.hTLV = null;
    this.isModified = true;
    this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
  };
  this.setByInteger = function(intValue) {
    var bi = new BigInteger(String(intValue), 10);
    this.setByBigInteger(bi);
  };
  this.setValueHex = function(newHexString) {
    this.hV = newHexString;
  };
  this.getFreshValueHex = function() {
    return this.hV;
  };
  if (typeof params != "undefined") {
    if (typeof params["bigint"] != "undefined") {
      this.setByBigInteger(params["bigint"]);
    } else if (typeof params["int"] != "undefined") {
      this.setByInteger(params["int"]);
    } else if (typeof params == "number") {
      this.setByInteger(params);
    } else if (typeof params["hex"] != "undefined") {
      this.setValueHex(params["hex"]);
    }
  }
};
extendClass(KJUR.asn1.DERInteger, KJUR.asn1.ASN1Object);
KJUR.asn1.DERBitString = function(params) {
  if (params !== void 0 && typeof params.obj !== "undefined") {
    var o2 = KJUR.asn1.ASN1Util.newObject(params.obj);
    params.hex = "00" + o2.getEncodedHex();
  }
  KJUR.asn1.DERBitString.superclass.constructor.call(this);
  this.hT = "03";
  this.setHexValueIncludingUnusedBits = function(newHexStringIncludingUnusedBits) {
    this.hTLV = null;
    this.isModified = true;
    this.hV = newHexStringIncludingUnusedBits;
  };
  this.setUnusedBitsAndHexValue = function(unusedBits, hValue) {
    if (unusedBits < 0 || 7 < unusedBits) {
      throw "unused bits shall be from 0 to 7: u = " + unusedBits;
    }
    var hUnusedBits = "0" + unusedBits;
    this.hTLV = null;
    this.isModified = true;
    this.hV = hUnusedBits + hValue;
  };
  this.setByBinaryString = function(binaryString) {
    binaryString = binaryString.replace(/0+$/, "");
    var unusedBits = 8 - binaryString.length % 8;
    if (unusedBits == 8)
      unusedBits = 0;
    for (var i = 0; i <= unusedBits; i++) {
      binaryString += "0";
    }
    var h = "";
    for (var i = 0; i < binaryString.length - 1; i += 8) {
      var b2 = binaryString.substring(i, i + 8);
      var x = parseInt(b2, 2).toString(16);
      if (x.length == 1)
        x = "0" + x;
      h += x;
    }
    this.hTLV = null;
    this.isModified = true;
    this.hV = "0" + unusedBits + h;
  };
  this.setByBooleanArray = function(booleanArray) {
    var s = "";
    for (var i = 0; i < booleanArray.length; i++) {
      if (booleanArray[i] == true) {
        s += "1";
      } else {
        s += "0";
      }
    }
    this.setByBinaryString(s);
  };
  this.newFalseArray = function(nLength) {
    var a2 = new Array(nLength);
    for (var i = 0; i < nLength; i++) {
      a2[i] = false;
    }
    return a2;
  };
  this.getFreshValueHex = function() {
    return this.hV;
  };
  if (typeof params != "undefined") {
    if (typeof params == "string" && params.toLowerCase().match(/^[0-9a-f]+$/)) {
      this.setHexValueIncludingUnusedBits(params);
    } else if (typeof params["hex"] != "undefined") {
      this.setHexValueIncludingUnusedBits(params["hex"]);
    } else if (typeof params["bin"] != "undefined") {
      this.setByBinaryString(params["bin"]);
    } else if (typeof params["array"] != "undefined") {
      this.setByBooleanArray(params["array"]);
    }
  }
};
extendClass(KJUR.asn1.DERBitString, KJUR.asn1.ASN1Object);
KJUR.asn1.DEROctetString = function(params) {
  if (params !== void 0 && typeof params.obj !== "undefined") {
    var o2 = KJUR.asn1.ASN1Util.newObject(params.obj);
    params.hex = o2.getEncodedHex();
  }
  KJUR.asn1.DEROctetString.superclass.constructor.call(this, params);
  this.hT = "04";
};
extendClass(KJUR.asn1.DEROctetString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERNull = function() {
  KJUR.asn1.DERNull.superclass.constructor.call(this);
  this.hT = "05";
  this.hTLV = "0500";
};
extendClass(KJUR.asn1.DERNull, KJUR.asn1.ASN1Object);
KJUR.asn1.DERObjectIdentifier = function(params) {
  var itox = function(i) {
    var h = i.toString(16);
    if (h.length == 1)
      h = "0" + h;
    return h;
  };
  var roidtox = function(roid) {
    var h = "";
    var bi = new BigInteger(roid, 10);
    var b2 = bi.toString(2);
    var padLen = 7 - b2.length % 7;
    if (padLen == 7)
      padLen = 0;
    var bPad = "";
    for (var i = 0; i < padLen; i++)
      bPad += "0";
    b2 = bPad + b2;
    for (var i = 0; i < b2.length - 1; i += 7) {
      var b8 = b2.substring(i, i + 7);
      if (i != b2.length - 7)
        b8 = "1" + b8;
      h += itox(parseInt(b8, 2));
    }
    return h;
  };
  KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this);
  this.hT = "06";
  this.setValueHex = function(newHexString) {
    this.hTLV = null;
    this.isModified = true;
    this.s = null;
    this.hV = newHexString;
  };
  this.setValueOidString = function(oidString) {
    if (!oidString.match(/^[0-9.]+$/)) {
      throw "malformed oid string: " + oidString;
    }
    var h = "";
    var a2 = oidString.split(".");
    var i0 = parseInt(a2[0]) * 40 + parseInt(a2[1]);
    h += itox(i0);
    a2.splice(0, 2);
    for (var i = 0; i < a2.length; i++) {
      h += roidtox(a2[i]);
    }
    this.hTLV = null;
    this.isModified = true;
    this.s = null;
    this.hV = h;
  };
  this.setValueName = function(oidName) {
    var oid = KJUR.asn1.x509.OID.name2oid(oidName);
    if (oid !== "") {
      this.setValueOidString(oid);
    } else {
      throw "DERObjectIdentifier oidName undefined: " + oidName;
    }
  };
  this.getFreshValueHex = function() {
    return this.hV;
  };
  if (params !== void 0) {
    if (typeof params === "string") {
      if (params.match(/^[0-2].[0-9.]+$/)) {
        this.setValueOidString(params);
      } else {
        this.setValueName(params);
      }
    } else if (params.oid !== void 0) {
      this.setValueOidString(params.oid);
    } else if (params.hex !== void 0) {
      this.setValueHex(params.hex);
    } else if (params.name !== void 0) {
      this.setValueName(params.name);
    }
  }
};
extendClass(KJUR.asn1.DERObjectIdentifier, KJUR.asn1.ASN1Object);
KJUR.asn1.DEREnumerated = function(params) {
  KJUR.asn1.DEREnumerated.superclass.constructor.call(this);
  this.hT = "0a";
  this.setByBigInteger = function(bigIntegerValue) {
    this.hTLV = null;
    this.isModified = true;
    this.hV = KJUR.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
  };
  this.setByInteger = function(intValue) {
    var bi = new BigInteger(String(intValue), 10);
    this.setByBigInteger(bi);
  };
  this.setValueHex = function(newHexString) {
    this.hV = newHexString;
  };
  this.getFreshValueHex = function() {
    return this.hV;
  };
  if (typeof params != "undefined") {
    if (typeof params["int"] != "undefined") {
      this.setByInteger(params["int"]);
    } else if (typeof params == "number") {
      this.setByInteger(params);
    } else if (typeof params["hex"] != "undefined") {
      this.setValueHex(params["hex"]);
    }
  }
};
extendClass(KJUR.asn1.DEREnumerated, KJUR.asn1.ASN1Object);
KJUR.asn1.DERUTF8String = function(params) {
  KJUR.asn1.DERUTF8String.superclass.constructor.call(this, params);
  this.hT = "0c";
};
extendClass(KJUR.asn1.DERUTF8String, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERNumericString = function(params) {
  KJUR.asn1.DERNumericString.superclass.constructor.call(this, params);
  this.hT = "12";
};
extendClass(KJUR.asn1.DERNumericString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERPrintableString = function(params) {
  KJUR.asn1.DERPrintableString.superclass.constructor.call(this, params);
  this.hT = "13";
};
extendClass(KJUR.asn1.DERPrintableString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERTeletexString = function(params) {
  KJUR.asn1.DERTeletexString.superclass.constructor.call(this, params);
  this.hT = "14";
};
extendClass(KJUR.asn1.DERTeletexString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERIA5String = function(params) {
  KJUR.asn1.DERIA5String.superclass.constructor.call(this, params);
  this.hT = "16";
};
extendClass(KJUR.asn1.DERIA5String, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERUTCTime = function(params) {
  KJUR.asn1.DERUTCTime.superclass.constructor.call(this, params);
  this.hT = "17";
  this.setByDate = function(dateObject) {
    this.hTLV = null;
    this.isModified = true;
    this.date = dateObject;
    this.s = this.formatDate(this.date, "utc");
    this.hV = stohex(this.s);
  };
  this.getFreshValueHex = function() {
    if (typeof this.date == "undefined" && typeof this.s == "undefined") {
      this.date = new Date();
      this.s = this.formatDate(this.date, "utc");
      this.hV = stohex(this.s);
    }
    return this.hV;
  };
  if (params !== void 0) {
    if (params.str !== void 0) {
      this.setString(params.str);
    } else if (typeof params == "string" && params.match(/^[0-9]{12}Z$/)) {
      this.setString(params);
    } else if (params.hex !== void 0) {
      this.setStringHex(params.hex);
    } else if (params.date !== void 0) {
      this.setByDate(params.date);
    }
  }
};
extendClass(KJUR.asn1.DERUTCTime, KJUR.asn1.DERAbstractTime);
KJUR.asn1.DERGeneralizedTime = function(params) {
  KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, params);
  this.hT = "18";
  this.withMillis = false;
  this.setByDate = function(dateObject) {
    this.hTLV = null;
    this.isModified = true;
    this.date = dateObject;
    this.s = this.formatDate(this.date, "gen", this.withMillis);
    this.hV = stohex(this.s);
  };
  this.getFreshValueHex = function() {
    if (this.date === void 0 && this.s === void 0) {
      this.date = new Date();
      this.s = this.formatDate(this.date, "gen", this.withMillis);
      this.hV = stohex(this.s);
    }
    return this.hV;
  };
  if (params !== void 0) {
    if (params.str !== void 0) {
      this.setString(params.str);
    } else if (typeof params == "string" && params.match(/^[0-9]{14}Z$/)) {
      this.setString(params);
    } else if (params.hex !== void 0) {
      this.setStringHex(params.hex);
    } else if (params.date !== void 0) {
      this.setByDate(params.date);
    }
    if (params.millis === true) {
      this.withMillis = true;
    }
  }
};
extendClass(KJUR.asn1.DERGeneralizedTime, KJUR.asn1.DERAbstractTime);
KJUR.asn1.DERSequence = function(params) {
  KJUR.asn1.DERSequence.superclass.constructor.call(this, params);
  this.hT = "30";
  this.getFreshValueHex = function() {
    var h = "";
    for (var i = 0; i < this.asn1Array.length; i++) {
      var asn1Obj = this.asn1Array[i];
      h += asn1Obj.getEncodedHex();
    }
    this.hV = h;
    return this.hV;
  };
};
extendClass(KJUR.asn1.DERSequence, KJUR.asn1.DERAbstractStructured);
KJUR.asn1.DERSet = function(params) {
  KJUR.asn1.DERSet.superclass.constructor.call(this, params);
  this.hT = "31";
  this.sortFlag = true;
  this.getFreshValueHex = function() {
    var a2 = new Array();
    for (var i = 0; i < this.asn1Array.length; i++) {
      var asn1Obj = this.asn1Array[i];
      a2.push(asn1Obj.getEncodedHex());
    }
    if (this.sortFlag == true)
      a2.sort();
    this.hV = a2.join("");
    return this.hV;
  };
  if (typeof params != "undefined") {
    if (typeof params.sortflag != "undefined" && params.sortflag == false)
      this.sortFlag = false;
  }
};
extendClass(KJUR.asn1.DERSet, KJUR.asn1.DERAbstractStructured);
KJUR.asn1.DERTaggedObject = function(params) {
  KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
  this.hT = "a0";
  this.hV = "";
  this.isExplicit = true;
  this.asn1Object = null;
  this.setASN1Object = function(isExplicitFlag, tagNoHex, asn1Object) {
    this.hT = tagNoHex;
    this.isExplicit = isExplicitFlag;
    this.asn1Object = asn1Object;
    if (this.isExplicit) {
      this.hV = this.asn1Object.getEncodedHex();
      this.hTLV = null;
      this.isModified = true;
    } else {
      this.hV = null;
      this.hTLV = asn1Object.getEncodedHex();
      this.hTLV = this.hTLV.replace(/^../, tagNoHex);
      this.isModified = false;
    }
  };
  this.getFreshValueHex = function() {
    return this.hV;
  };
  if (typeof params != "undefined") {
    if (typeof params["tag"] != "undefined") {
      this.hT = params["tag"];
    }
    if (typeof params["explicit"] != "undefined") {
      this.isExplicit = params["explicit"];
    }
    if (typeof params["obj"] != "undefined") {
      this.asn1Object = params["obj"];
      this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
    }
  }
};
extendClass(KJUR.asn1.DERTaggedObject, KJUR.asn1.ASN1Object);
var __extends = globalThis && globalThis.__extends || function() {
  var extendStatics = function(d2, b2) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
      d3.__proto__ = b3;
    } || function(d3, b3) {
      for (var p in b3)
        if (Object.prototype.hasOwnProperty.call(b3, p))
          d3[p] = b3[p];
    };
    return extendStatics(d2, b2);
  };
  return function(d2, b2) {
    if (typeof b2 !== "function" && b2 !== null)
      throw new TypeError("Class extends value " + String(b2) + " is not a constructor or null");
    extendStatics(d2, b2);
    function __() {
      this.constructor = d2;
    }
    d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
  };
}();
var JSEncryptRSAKey = function(_super) {
  __extends(JSEncryptRSAKey2, _super);
  function JSEncryptRSAKey2(key) {
    var _this = _super.call(this) || this;
    if (key) {
      if (typeof key === "string") {
        _this.parseKey(key);
      } else if (JSEncryptRSAKey2.hasPrivateKeyProperty(key) || JSEncryptRSAKey2.hasPublicKeyProperty(key)) {
        _this.parsePropertiesFrom(key);
      }
    }
    return _this;
  }
  JSEncryptRSAKey2.prototype.parseKey = function(pem) {
    try {
      var modulus = 0;
      var public_exponent = 0;
      var reHex = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
      var der = reHex.test(pem) ? Hex.decode(pem) : Base64.unarmor(pem);
      var asn1 = ASN1.decode(der);
      if (asn1.sub.length === 3) {
        asn1 = asn1.sub[2].sub[0];
      }
      if (asn1.sub.length === 9) {
        modulus = asn1.sub[1].getHexStringValue();
        this.n = parseBigInt(modulus, 16);
        public_exponent = asn1.sub[2].getHexStringValue();
        this.e = parseInt(public_exponent, 16);
        var private_exponent = asn1.sub[3].getHexStringValue();
        this.d = parseBigInt(private_exponent, 16);
        var prime1 = asn1.sub[4].getHexStringValue();
        this.p = parseBigInt(prime1, 16);
        var prime2 = asn1.sub[5].getHexStringValue();
        this.q = parseBigInt(prime2, 16);
        var exponent1 = asn1.sub[6].getHexStringValue();
        this.dmp1 = parseBigInt(exponent1, 16);
        var exponent2 = asn1.sub[7].getHexStringValue();
        this.dmq1 = parseBigInt(exponent2, 16);
        var coefficient = asn1.sub[8].getHexStringValue();
        this.coeff = parseBigInt(coefficient, 16);
      } else if (asn1.sub.length === 2) {
        if (asn1.sub[0].sub) {
          var bit_string = asn1.sub[1];
          var sequence = bit_string.sub[0];
          modulus = sequence.sub[0].getHexStringValue();
          this.n = parseBigInt(modulus, 16);
          public_exponent = sequence.sub[1].getHexStringValue();
          this.e = parseInt(public_exponent, 16);
        } else {
          modulus = asn1.sub[0].getHexStringValue();
          this.n = parseBigInt(modulus, 16);
          public_exponent = asn1.sub[1].getHexStringValue();
          this.e = parseInt(public_exponent, 16);
        }
      } else {
        return false;
      }
      return true;
    } catch (ex) {
      return false;
    }
  };
  JSEncryptRSAKey2.prototype.getPrivateBaseKey = function() {
    var options = {
      array: [
        new KJUR.asn1.DERInteger({ int: 0 }),
        new KJUR.asn1.DERInteger({ bigint: this.n }),
        new KJUR.asn1.DERInteger({ int: this.e }),
        new KJUR.asn1.DERInteger({ bigint: this.d }),
        new KJUR.asn1.DERInteger({ bigint: this.p }),
        new KJUR.asn1.DERInteger({ bigint: this.q }),
        new KJUR.asn1.DERInteger({ bigint: this.dmp1 }),
        new KJUR.asn1.DERInteger({ bigint: this.dmq1 }),
        new KJUR.asn1.DERInteger({ bigint: this.coeff })
      ]
    };
    var seq = new KJUR.asn1.DERSequence(options);
    return seq.getEncodedHex();
  };
  JSEncryptRSAKey2.prototype.getPrivateBaseKeyB64 = function() {
    return hex2b64(this.getPrivateBaseKey());
  };
  JSEncryptRSAKey2.prototype.getPublicBaseKey = function() {
    var first_sequence = new KJUR.asn1.DERSequence({
      array: [
        new KJUR.asn1.DERObjectIdentifier({ oid: "1.2.840.113549.1.1.1" }),
        new KJUR.asn1.DERNull()
      ]
    });
    var second_sequence = new KJUR.asn1.DERSequence({
      array: [
        new KJUR.asn1.DERInteger({ bigint: this.n }),
        new KJUR.asn1.DERInteger({ int: this.e })
      ]
    });
    var bit_string = new KJUR.asn1.DERBitString({
      hex: "00" + second_sequence.getEncodedHex()
    });
    var seq = new KJUR.asn1.DERSequence({
      array: [first_sequence, bit_string]
    });
    return seq.getEncodedHex();
  };
  JSEncryptRSAKey2.prototype.getPublicBaseKeyB64 = function() {
    return hex2b64(this.getPublicBaseKey());
  };
  JSEncryptRSAKey2.wordwrap = function(str, width) {
    width = width || 64;
    if (!str) {
      return str;
    }
    var regex = "(.{1," + width + "})( +|$\n?)|(.{1," + width + "})";
    return str.match(RegExp(regex, "g")).join("\n");
  };
  JSEncryptRSAKey2.prototype.getPrivateKey = function() {
    var key = "-----BEGIN RSA PRIVATE KEY-----\n";
    key += JSEncryptRSAKey2.wordwrap(this.getPrivateBaseKeyB64()) + "\n";
    key += "-----END RSA PRIVATE KEY-----";
    return key;
  };
  JSEncryptRSAKey2.prototype.getPublicKey = function() {
    var key = "-----BEGIN PUBLIC KEY-----\n";
    key += JSEncryptRSAKey2.wordwrap(this.getPublicBaseKeyB64()) + "\n";
    key += "-----END PUBLIC KEY-----";
    return key;
  };
  JSEncryptRSAKey2.hasPublicKeyProperty = function(obj) {
    obj = obj || {};
    return obj.hasOwnProperty("n") && obj.hasOwnProperty("e");
  };
  JSEncryptRSAKey2.hasPrivateKeyProperty = function(obj) {
    obj = obj || {};
    return obj.hasOwnProperty("n") && obj.hasOwnProperty("e") && obj.hasOwnProperty("d") && obj.hasOwnProperty("p") && obj.hasOwnProperty("q") && obj.hasOwnProperty("dmp1") && obj.hasOwnProperty("dmq1") && obj.hasOwnProperty("coeff");
  };
  JSEncryptRSAKey2.prototype.parsePropertiesFrom = function(obj) {
    this.n = obj.n;
    this.e = obj.e;
    if (obj.hasOwnProperty("d")) {
      this.d = obj.d;
      this.p = obj.p;
      this.q = obj.q;
      this.dmp1 = obj.dmp1;
      this.dmq1 = obj.dmq1;
      this.coeff = obj.coeff;
    }
  };
  return JSEncryptRSAKey2;
}(RSAKey);
var _a$1;
var version = typeof process !== "undefined" ? (_a$1 = process.env) === null || _a$1 === void 0 ? void 0 : _a$1.npm_package_version : void 0;
var JSEncrypt = function() {
  function JSEncrypt2(options) {
    if (options === void 0) {
      options = {};
    }
    this.default_key_size = options.default_key_size ? parseInt(options.default_key_size, 10) : 1024;
    this.default_public_exponent = options.default_public_exponent || "010001";
    this.log = options.log || false;
    this.key = options.key || null;
  }
  JSEncrypt2.prototype.setKey = function(key) {
    if (key) {
      if (this.log && this.key) {
        console.warn("A key was already set, overriding existing.");
      }
      this.key = new JSEncryptRSAKey(key);
    } else if (!this.key && this.log) {
      console.error("A key was not set.");
    }
  };
  JSEncrypt2.prototype.setPrivateKey = function(privkey) {
    this.setKey(privkey);
  };
  JSEncrypt2.prototype.setPublicKey = function(pubkey) {
    this.setKey(pubkey);
  };
  JSEncrypt2.prototype.decrypt = function(str) {
    try {
      return this.getKey().decrypt(b64tohex(str));
    } catch (ex) {
      return false;
    }
  };
  JSEncrypt2.prototype.encrypt = function(str) {
    try {
      return hex2b64(this.getKey().encrypt(str));
    } catch (ex) {
      return false;
    }
  };
  JSEncrypt2.prototype.encryptOAEP = function(str) {
    try {
      return hex2b64(this.getKey().encrypt(str, oaep_pad));
    } catch (ex) {
      return false;
    }
  };
  JSEncrypt2.prototype.sign = function(str, digestMethod, digestName) {
    if (digestMethod === void 0) {
      digestMethod = function(raw) {
        return raw;
      };
    }
    if (digestName === void 0) {
      digestName = "";
    }
    try {
      return hex2b64(this.getKey().sign(str, digestMethod, digestName));
    } catch (ex) {
      return false;
    }
  };
  JSEncrypt2.prototype.signSha256 = function(str) {
    return this.sign(str, function(text) {
      return rstr2hex(rstr_sha256(text));
    }, "sha256");
  };
  JSEncrypt2.prototype.verify = function(str, signature, digestMethod) {
    if (digestMethod === void 0) {
      digestMethod = function(raw) {
        return raw;
      };
    }
    try {
      return this.getKey().verify(str, b64tohex(signature), digestMethod);
    } catch (ex) {
      return false;
    }
  };
  JSEncrypt2.prototype.verifySha256 = function(str, signature) {
    return this.verify(str, signature, function(text) {
      return rstr2hex(rstr_sha256(text));
    });
  };
  JSEncrypt2.prototype.getKey = function(cb) {
    if (!this.key) {
      this.key = new JSEncryptRSAKey();
      if (cb && {}.toString.call(cb) === "[object Function]") {
        this.key.generateAsync(this.default_key_size, this.default_public_exponent, cb);
        return;
      }
      this.key.generate(this.default_key_size, this.default_public_exponent);
    }
    return this.key;
  };
  JSEncrypt2.prototype.getPrivateKey = function() {
    return this.getKey().getPrivateKey();
  };
  JSEncrypt2.prototype.getPrivateKeyB64 = function() {
    return this.getKey().getPrivateBaseKeyB64();
  };
  JSEncrypt2.prototype.getPublicKey = function() {
    return this.getKey().getPublicKey();
  };
  JSEncrypt2.prototype.getPublicKeyB64 = function() {
    return this.getKey().getPublicBaseKeyB64();
  };
  JSEncrypt2.version = version;
  return JSEncrypt2;
}();
let encryptInstance = null;
const getEncryptInstance = async () => {
  if (!encryptInstance) {
    const res = await getPublicKey();
    encryptInstance = new JSEncrypt();
    encryptInstance.setPublicKey(res.publicKey);
  }
  return encryptInstance;
};
async function getPublicKey() {
  const res = await createRequest({
    url: "/api/v1/public/key",
    method: "get"
  });
  return res.data;
}
function wechatLogin(data2) {
  return createRequest({
    url: "/api/v1/signin/wechat",
    method: "POST",
    data: data2
  });
}
function sendMessageCode(data2) {
  return createRequest({
    url: "/api/v1/message/code",
    method: "POST",
    data: data2
  });
}
async function signinByPassword(data2) {
  const encryptInstance2 = await getEncryptInstance();
  return createRequest({
    url: "/api/v1/signup",
    method: "POST",
    data: {
      ...data2,
      password: encryptInstance2.encrypt(data2.password),
      encrypt: 1
    }
  });
}
function phoneAndEmailSignup(data2) {
  return createRequest({
    url: "/api/v1/signup/code",
    method: "POST",
    data: {
      ...data2
    }
  });
}
async function signupByPassword(data2) {
  const encryptInstance2 = await getEncryptInstance();
  return createRequest({
    url: "/api/v1/signin",
    method: "POST",
    data: {
      ...data2,
      password: encryptInstance2.encrypt(data2.password),
      encrypt: 1
    }
  });
}
function getSigninCaptcha(params) {
  return createRequest({
    url: "/api/v1/signin/captcha",
    method: "GET",
    params
  });
}
async function initpassword(data2) {
  const encryptInstance2 = await getEncryptInstance();
  return createRequest({
    url: "/api/v1/users/initpassword",
    method: "PUT",
    data: {
      ...data2,
      password: encryptInstance2.encrypt(data2.password),
      encrypt: 1
    }
  });
}
function getWeChatQrCode() {
  return createRequest({
    url: "/api/v1/signin/wechatqrcode",
    method: "GET"
  });
}
function getWeChatSubState(token) {
  return createRequest({
    url: "/api/v1/wechat/substate",
    method: "GET",
    params: {
      token
    }
  });
}
function lanHuLogin(data2) {
  return createRequest({
    url: "/api/v1/signin/lanhu",
    method: "POST",
    data: data2
  });
}
function getUserInfo() {
  return createRequest({
    url: "/api/v1/user",
    method: "get"
  });
}
function logOut(data2 = {}) {
  return createRequest({
    url: "/api/v1/signout",
    method: "POST",
    data: data2
  });
}
function getLocalPhoneToken() {
  return createRequest({
    url: "/api/v1/h5verify/token",
    method: "GET"
  });
}
function verifyLocalPhoneToken(data2 = {}) {
  return createRequest({
    url: "/api/v1/h5verify/signup",
    method: "POST",
    data: data2
  });
}
function verifyDingDingToken(data2 = {}) {
  return createRequest({
    url: "/api/v1/signin/dingtalk",
    method: "POST",
    data: data2
  });
}
function getDingAuthCode() {
  return createRequest({
    url: "/api/v1/jump-code",
    method: "get"
  });
}
function googleLogin(data2 = {}) {
  return createRequest({
    url: "/api/v1/signin/google",
    method: "POST",
    data: data2
  });
}
function getThirdPartyPath(params) {
  return createRequest({
    url: "/api/v1/thirdparty/authorization",
    method: "GET",
    params
  });
}
function linkedinLogin(data2 = {}) {
  return createRequest({
    url: "/api/v1/signin/linkedin",
    method: "POST",
    data: data2
  });
}
function getLoginProtocol(params) {
  return createRequest({
    url: "/api/v1/sso",
    method: "get",
    params
  });
}
function verifySaml(params) {
  return createRequest({
    url: "/api/v1/saml/getloginreq",
    method: "get",
    withCredentials: true,
    params
  });
}
function verifyOauth(params) {
  return createRequest({
    url: "/api/v1/oauth/getloginreq",
    method: "get",
    withCredentials: true,
    params
  });
}
function bindAuthMobile(phone, code) {
  return createRequest({
    url: "/api/v1/users/bind",
    method: "post",
    withCredentials: true,
    data: {
      type: "authPhoneNumber",
      phoneNumber: phone,
      code
    }
  });
}
function getUserResetPasswordStatus() {
  return createRequest({
    url: "/api/v1/users/password/reset",
    method: "get"
  });
}
function getLoginType() {
  return createRequest({
    url: "/api/v1/login_method",
    method: "GET"
  });
}
function priLoginByCode(data2) {
  return createRequest({
    url: `/api/v1/code_login`,
    method: "POST",
    data: data2
  });
}
function getOrgPubSettings() {
  return createRequest({
    url: "/org/api/pub/settings",
    method: "GET"
  });
}
const toggles = [
  "web.enableWecomLogin",
  "web.openCodeCaptcha"
];
function getToggles(toggles$1 = [...toggles]) {
  return createRequest({
    url: "/unleash/toggles",
    method: "POST",
    data: { "nameList[]": toggles$1 }
  });
}
const getToggleStatus = (() => {
  let cachedPromise = null;
  let _togglesResult = {};
  return async function(toggleKey) {
    if (!cachedPromise) {
      cachedPromise = (async () => {
        try {
          const res = await getToggles();
          _togglesResult = res.data.reduce(
            (acc, cur) => ({
              ...acc,
              [cur.name]: cur.toggle
            }),
            {}
          );
          const debugToggle = localStorage.getItem("performance-feature-parms");
          if (debugToggle) {
            const parms = JSON.parse(debugToggle);
            for (const key in parms) {
              _togglesResult[`web.${key}`] = !!parms[key];
            }
          }
        } catch (error) {
          console.error("\u83B7\u53D6toggle\u5F00\u5173\u5931\u8D25", error);
        }
      })();
    }
    await cachedPromise;
    return _togglesResult[toggleKey] || false;
  };
})();
var lib$1 = { exports: {} };
var _default$1 = {};
var lib = { exports: {} };
var _default = {};
function getDefaultWhiteList$1() {
  var whiteList = {};
  whiteList["align-content"] = false;
  whiteList["align-items"] = false;
  whiteList["align-self"] = false;
  whiteList["alignment-adjust"] = false;
  whiteList["alignment-baseline"] = false;
  whiteList["all"] = false;
  whiteList["anchor-point"] = false;
  whiteList["animation"] = false;
  whiteList["animation-delay"] = false;
  whiteList["animation-direction"] = false;
  whiteList["animation-duration"] = false;
  whiteList["animation-fill-mode"] = false;
  whiteList["animation-iteration-count"] = false;
  whiteList["animation-name"] = false;
  whiteList["animation-play-state"] = false;
  whiteList["animation-timing-function"] = false;
  whiteList["azimuth"] = false;
  whiteList["backface-visibility"] = false;
  whiteList["background"] = true;
  whiteList["background-attachment"] = true;
  whiteList["background-clip"] = true;
  whiteList["background-color"] = true;
  whiteList["background-image"] = true;
  whiteList["background-origin"] = true;
  whiteList["background-position"] = true;
  whiteList["background-repeat"] = true;
  whiteList["background-size"] = true;
  whiteList["baseline-shift"] = false;
  whiteList["binding"] = false;
  whiteList["bleed"] = false;
  whiteList["bookmark-label"] = false;
  whiteList["bookmark-level"] = false;
  whiteList["bookmark-state"] = false;
  whiteList["border"] = true;
  whiteList["border-bottom"] = true;
  whiteList["border-bottom-color"] = true;
  whiteList["border-bottom-left-radius"] = true;
  whiteList["border-bottom-right-radius"] = true;
  whiteList["border-bottom-style"] = true;
  whiteList["border-bottom-width"] = true;
  whiteList["border-collapse"] = true;
  whiteList["border-color"] = true;
  whiteList["border-image"] = true;
  whiteList["border-image-outset"] = true;
  whiteList["border-image-repeat"] = true;
  whiteList["border-image-slice"] = true;
  whiteList["border-image-source"] = true;
  whiteList["border-image-width"] = true;
  whiteList["border-left"] = true;
  whiteList["border-left-color"] = true;
  whiteList["border-left-style"] = true;
  whiteList["border-left-width"] = true;
  whiteList["border-radius"] = true;
  whiteList["border-right"] = true;
  whiteList["border-right-color"] = true;
  whiteList["border-right-style"] = true;
  whiteList["border-right-width"] = true;
  whiteList["border-spacing"] = true;
  whiteList["border-style"] = true;
  whiteList["border-top"] = true;
  whiteList["border-top-color"] = true;
  whiteList["border-top-left-radius"] = true;
  whiteList["border-top-right-radius"] = true;
  whiteList["border-top-style"] = true;
  whiteList["border-top-width"] = true;
  whiteList["border-width"] = true;
  whiteList["bottom"] = false;
  whiteList["box-decoration-break"] = true;
  whiteList["box-shadow"] = true;
  whiteList["box-sizing"] = true;
  whiteList["box-snap"] = true;
  whiteList["box-suppress"] = true;
  whiteList["break-after"] = true;
  whiteList["break-before"] = true;
  whiteList["break-inside"] = true;
  whiteList["caption-side"] = false;
  whiteList["chains"] = false;
  whiteList["clear"] = true;
  whiteList["clip"] = false;
  whiteList["clip-path"] = false;
  whiteList["clip-rule"] = false;
  whiteList["color"] = true;
  whiteList["color-interpolation-filters"] = true;
  whiteList["column-count"] = false;
  whiteList["column-fill"] = false;
  whiteList["column-gap"] = false;
  whiteList["column-rule"] = false;
  whiteList["column-rule-color"] = false;
  whiteList["column-rule-style"] = false;
  whiteList["column-rule-width"] = false;
  whiteList["column-span"] = false;
  whiteList["column-width"] = false;
  whiteList["columns"] = false;
  whiteList["contain"] = false;
  whiteList["content"] = false;
  whiteList["counter-increment"] = false;
  whiteList["counter-reset"] = false;
  whiteList["counter-set"] = false;
  whiteList["crop"] = false;
  whiteList["cue"] = false;
  whiteList["cue-after"] = false;
  whiteList["cue-before"] = false;
  whiteList["cursor"] = false;
  whiteList["direction"] = false;
  whiteList["display"] = true;
  whiteList["display-inside"] = true;
  whiteList["display-list"] = true;
  whiteList["display-outside"] = true;
  whiteList["dominant-baseline"] = false;
  whiteList["elevation"] = false;
  whiteList["empty-cells"] = false;
  whiteList["filter"] = false;
  whiteList["flex"] = false;
  whiteList["flex-basis"] = false;
  whiteList["flex-direction"] = false;
  whiteList["flex-flow"] = false;
  whiteList["flex-grow"] = false;
  whiteList["flex-shrink"] = false;
  whiteList["flex-wrap"] = false;
  whiteList["float"] = false;
  whiteList["float-offset"] = false;
  whiteList["flood-color"] = false;
  whiteList["flood-opacity"] = false;
  whiteList["flow-from"] = false;
  whiteList["flow-into"] = false;
  whiteList["font"] = true;
  whiteList["font-family"] = true;
  whiteList["font-feature-settings"] = true;
  whiteList["font-kerning"] = true;
  whiteList["font-language-override"] = true;
  whiteList["font-size"] = true;
  whiteList["font-size-adjust"] = true;
  whiteList["font-stretch"] = true;
  whiteList["font-style"] = true;
  whiteList["font-synthesis"] = true;
  whiteList["font-variant"] = true;
  whiteList["font-variant-alternates"] = true;
  whiteList["font-variant-caps"] = true;
  whiteList["font-variant-east-asian"] = true;
  whiteList["font-variant-ligatures"] = true;
  whiteList["font-variant-numeric"] = true;
  whiteList["font-variant-position"] = true;
  whiteList["font-weight"] = true;
  whiteList["grid"] = false;
  whiteList["grid-area"] = false;
  whiteList["grid-auto-columns"] = false;
  whiteList["grid-auto-flow"] = false;
  whiteList["grid-auto-rows"] = false;
  whiteList["grid-column"] = false;
  whiteList["grid-column-end"] = false;
  whiteList["grid-column-start"] = false;
  whiteList["grid-row"] = false;
  whiteList["grid-row-end"] = false;
  whiteList["grid-row-start"] = false;
  whiteList["grid-template"] = false;
  whiteList["grid-template-areas"] = false;
  whiteList["grid-template-columns"] = false;
  whiteList["grid-template-rows"] = false;
  whiteList["hanging-punctuation"] = false;
  whiteList["height"] = true;
  whiteList["hyphens"] = false;
  whiteList["icon"] = false;
  whiteList["image-orientation"] = false;
  whiteList["image-resolution"] = false;
  whiteList["ime-mode"] = false;
  whiteList["initial-letters"] = false;
  whiteList["inline-box-align"] = false;
  whiteList["justify-content"] = false;
  whiteList["justify-items"] = false;
  whiteList["justify-self"] = false;
  whiteList["left"] = false;
  whiteList["letter-spacing"] = true;
  whiteList["lighting-color"] = true;
  whiteList["line-box-contain"] = false;
  whiteList["line-break"] = false;
  whiteList["line-grid"] = false;
  whiteList["line-height"] = false;
  whiteList["line-snap"] = false;
  whiteList["line-stacking"] = false;
  whiteList["line-stacking-ruby"] = false;
  whiteList["line-stacking-shift"] = false;
  whiteList["line-stacking-strategy"] = false;
  whiteList["list-style"] = true;
  whiteList["list-style-image"] = true;
  whiteList["list-style-position"] = true;
  whiteList["list-style-type"] = true;
  whiteList["margin"] = true;
  whiteList["margin-bottom"] = true;
  whiteList["margin-left"] = true;
  whiteList["margin-right"] = true;
  whiteList["margin-top"] = true;
  whiteList["marker-offset"] = false;
  whiteList["marker-side"] = false;
  whiteList["marks"] = false;
  whiteList["mask"] = false;
  whiteList["mask-box"] = false;
  whiteList["mask-box-outset"] = false;
  whiteList["mask-box-repeat"] = false;
  whiteList["mask-box-slice"] = false;
  whiteList["mask-box-source"] = false;
  whiteList["mask-box-width"] = false;
  whiteList["mask-clip"] = false;
  whiteList["mask-image"] = false;
  whiteList["mask-origin"] = false;
  whiteList["mask-position"] = false;
  whiteList["mask-repeat"] = false;
  whiteList["mask-size"] = false;
  whiteList["mask-source-type"] = false;
  whiteList["mask-type"] = false;
  whiteList["max-height"] = true;
  whiteList["max-lines"] = false;
  whiteList["max-width"] = true;
  whiteList["min-height"] = true;
  whiteList["min-width"] = true;
  whiteList["move-to"] = false;
  whiteList["nav-down"] = false;
  whiteList["nav-index"] = false;
  whiteList["nav-left"] = false;
  whiteList["nav-right"] = false;
  whiteList["nav-up"] = false;
  whiteList["object-fit"] = false;
  whiteList["object-position"] = false;
  whiteList["opacity"] = false;
  whiteList["order"] = false;
  whiteList["orphans"] = false;
  whiteList["outline"] = false;
  whiteList["outline-color"] = false;
  whiteList["outline-offset"] = false;
  whiteList["outline-style"] = false;
  whiteList["outline-width"] = false;
  whiteList["overflow"] = false;
  whiteList["overflow-wrap"] = false;
  whiteList["overflow-x"] = false;
  whiteList["overflow-y"] = false;
  whiteList["padding"] = true;
  whiteList["padding-bottom"] = true;
  whiteList["padding-left"] = true;
  whiteList["padding-right"] = true;
  whiteList["padding-top"] = true;
  whiteList["page"] = false;
  whiteList["page-break-after"] = false;
  whiteList["page-break-before"] = false;
  whiteList["page-break-inside"] = false;
  whiteList["page-policy"] = false;
  whiteList["pause"] = false;
  whiteList["pause-after"] = false;
  whiteList["pause-before"] = false;
  whiteList["perspective"] = false;
  whiteList["perspective-origin"] = false;
  whiteList["pitch"] = false;
  whiteList["pitch-range"] = false;
  whiteList["play-during"] = false;
  whiteList["position"] = false;
  whiteList["presentation-level"] = false;
  whiteList["quotes"] = false;
  whiteList["region-fragment"] = false;
  whiteList["resize"] = false;
  whiteList["rest"] = false;
  whiteList["rest-after"] = false;
  whiteList["rest-before"] = false;
  whiteList["richness"] = false;
  whiteList["right"] = false;
  whiteList["rotation"] = false;
  whiteList["rotation-point"] = false;
  whiteList["ruby-align"] = false;
  whiteList["ruby-merge"] = false;
  whiteList["ruby-position"] = false;
  whiteList["shape-image-threshold"] = false;
  whiteList["shape-outside"] = false;
  whiteList["shape-margin"] = false;
  whiteList["size"] = false;
  whiteList["speak"] = false;
  whiteList["speak-as"] = false;
  whiteList["speak-header"] = false;
  whiteList["speak-numeral"] = false;
  whiteList["speak-punctuation"] = false;
  whiteList["speech-rate"] = false;
  whiteList["stress"] = false;
  whiteList["string-set"] = false;
  whiteList["tab-size"] = false;
  whiteList["table-layout"] = false;
  whiteList["text-align"] = true;
  whiteList["text-align-last"] = true;
  whiteList["text-combine-upright"] = true;
  whiteList["text-decoration"] = true;
  whiteList["text-decoration-color"] = true;
  whiteList["text-decoration-line"] = true;
  whiteList["text-decoration-skip"] = true;
  whiteList["text-decoration-style"] = true;
  whiteList["text-emphasis"] = true;
  whiteList["text-emphasis-color"] = true;
  whiteList["text-emphasis-position"] = true;
  whiteList["text-emphasis-style"] = true;
  whiteList["text-height"] = true;
  whiteList["text-indent"] = true;
  whiteList["text-justify"] = true;
  whiteList["text-orientation"] = true;
  whiteList["text-overflow"] = true;
  whiteList["text-shadow"] = true;
  whiteList["text-space-collapse"] = true;
  whiteList["text-transform"] = true;
  whiteList["text-underline-position"] = true;
  whiteList["text-wrap"] = true;
  whiteList["top"] = false;
  whiteList["transform"] = false;
  whiteList["transform-origin"] = false;
  whiteList["transform-style"] = false;
  whiteList["transition"] = false;
  whiteList["transition-delay"] = false;
  whiteList["transition-duration"] = false;
  whiteList["transition-property"] = false;
  whiteList["transition-timing-function"] = false;
  whiteList["unicode-bidi"] = false;
  whiteList["vertical-align"] = false;
  whiteList["visibility"] = false;
  whiteList["voice-balance"] = false;
  whiteList["voice-duration"] = false;
  whiteList["voice-family"] = false;
  whiteList["voice-pitch"] = false;
  whiteList["voice-range"] = false;
  whiteList["voice-rate"] = false;
  whiteList["voice-stress"] = false;
  whiteList["voice-volume"] = false;
  whiteList["volume"] = false;
  whiteList["white-space"] = false;
  whiteList["widows"] = false;
  whiteList["width"] = true;
  whiteList["will-change"] = false;
  whiteList["word-break"] = true;
  whiteList["word-spacing"] = true;
  whiteList["word-wrap"] = true;
  whiteList["wrap-flow"] = false;
  whiteList["wrap-through"] = false;
  whiteList["writing-mode"] = false;
  whiteList["z-index"] = false;
  return whiteList;
}
function onAttr(name2, value, options) {
}
function onIgnoreAttr(name2, value, options) {
}
var REGEXP_URL_JAVASCRIPT = /javascript\s*\:/img;
function safeAttrValue$1(name2, value) {
  if (REGEXP_URL_JAVASCRIPT.test(value))
    return "";
  return value;
}
_default.whiteList = getDefaultWhiteList$1();
_default.getDefaultWhiteList = getDefaultWhiteList$1;
_default.onAttr = onAttr;
_default.onIgnoreAttr = onIgnoreAttr;
_default.safeAttrValue = safeAttrValue$1;
var util$1 = {
  indexOf: function(arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function(arr, fn2, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn2, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn2.call(scope, arr[i], i, arr);
    }
  },
  trim: function(str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  trimRight: function(str) {
    if (String.prototype.trimRight) {
      return str.trimRight();
    }
    return str.replace(/(\s*$)/g, "");
  }
};
var _$3 = util$1;
function parseStyle$1(css2, onAttr2) {
  css2 = _$3.trimRight(css2);
  if (css2[css2.length - 1] !== ";")
    css2 += ";";
  var cssLength = css2.length;
  var isParenthesisOpen = false;
  var lastPos = 0;
  var i = 0;
  var retCSS = "";
  function addNewAttr() {
    if (!isParenthesisOpen) {
      var source2 = _$3.trim(css2.slice(lastPos, i));
      var j2 = source2.indexOf(":");
      if (j2 !== -1) {
        var name2 = _$3.trim(source2.slice(0, j2));
        var value = _$3.trim(source2.slice(j2 + 1));
        if (name2) {
          var ret = onAttr2(lastPos, retCSS.length, name2, value, source2);
          if (ret)
            retCSS += ret + "; ";
        }
      }
    }
    lastPos = i + 1;
  }
  for (; i < cssLength; i++) {
    var c2 = css2[i];
    if (c2 === "/" && css2[i + 1] === "*") {
      var j = css2.indexOf("*/", i + 2);
      if (j === -1)
        break;
      i = j + 1;
      lastPos = i + 1;
      isParenthesisOpen = false;
    } else if (c2 === "(") {
      isParenthesisOpen = true;
    } else if (c2 === ")") {
      isParenthesisOpen = false;
    } else if (c2 === ";") {
      if (isParenthesisOpen)
        ;
      else {
        addNewAttr();
      }
    } else if (c2 === "\n") {
      addNewAttr();
    }
  }
  return _$3.trim(retCSS);
}
var parser$2 = parseStyle$1;
var DEFAULT$1 = _default;
var parseStyle = parser$2;
function isNull$1(obj) {
  return obj === void 0 || obj === null;
}
function shallowCopyObject$1(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}
function FilterCSS$2(options) {
  options = shallowCopyObject$1(options || {});
  options.whiteList = options.whiteList || DEFAULT$1.whiteList;
  options.onAttr = options.onAttr || DEFAULT$1.onAttr;
  options.onIgnoreAttr = options.onIgnoreAttr || DEFAULT$1.onIgnoreAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT$1.safeAttrValue;
  this.options = options;
}
FilterCSS$2.prototype.process = function(css2) {
  css2 = css2 || "";
  css2 = css2.toString();
  if (!css2)
    return "";
  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onAttr2 = options.onAttr;
  var onIgnoreAttr2 = options.onIgnoreAttr;
  var safeAttrValue2 = options.safeAttrValue;
  var retCSS = parseStyle(css2, function(sourcePosition, position, name2, value, source2) {
    var check = whiteList[name2];
    var isWhite = false;
    if (check === true)
      isWhite = check;
    else if (typeof check === "function")
      isWhite = check(value);
    else if (check instanceof RegExp)
      isWhite = check.test(value);
    if (isWhite !== true)
      isWhite = false;
    value = safeAttrValue2(name2, value);
    if (!value)
      return;
    var opts = {
      position,
      sourcePosition,
      source: source2,
      isWhite
    };
    if (isWhite) {
      var ret = onAttr2(name2, value, opts);
      if (isNull$1(ret)) {
        return name2 + ":" + value;
      } else {
        return ret;
      }
    } else {
      var ret = onIgnoreAttr2(name2, value, opts);
      if (!isNull$1(ret)) {
        return ret;
      }
    }
  });
  return retCSS;
};
var css = FilterCSS$2;
(function(module, exports) {
  var DEFAULT2 = _default;
  var FilterCSS2 = css;
  function filterCSS(html, options) {
    var xss2 = new FilterCSS2(options);
    return xss2.process(html);
  }
  exports = module.exports = filterCSS;
  exports.FilterCSS = FilterCSS2;
  for (var i in DEFAULT2)
    exports[i] = DEFAULT2[i];
  if (typeof window !== "undefined") {
    window.filterCSS = module.exports;
  }
})(lib, lib.exports);
var util = {
  indexOf: function(arr, item) {
    var i, j;
    if (Array.prototype.indexOf) {
      return arr.indexOf(item);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      if (arr[i] === item) {
        return i;
      }
    }
    return -1;
  },
  forEach: function(arr, fn2, scope) {
    var i, j;
    if (Array.prototype.forEach) {
      return arr.forEach(fn2, scope);
    }
    for (i = 0, j = arr.length; i < j; i++) {
      fn2.call(scope, arr[i], i, arr);
    }
  },
  trim: function(str) {
    if (String.prototype.trim) {
      return str.trim();
    }
    return str.replace(/(^\s*)|(\s*$)/g, "");
  },
  spaceIndex: function(str) {
    var reg = /\s|\n|\t/;
    var match = reg.exec(str);
    return match ? match.index : -1;
  }
};
var FilterCSS$1 = lib.exports.FilterCSS;
var getDefaultCSSWhiteList = lib.exports.getDefaultWhiteList;
var _$2 = util;
function getDefaultWhiteList() {
  return {
    a: ["target", "href", "title"],
    abbr: ["title"],
    address: [],
    area: ["shape", "coords", "href", "alt"],
    article: [],
    aside: [],
    audio: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "preload",
      "src"
    ],
    b: [],
    bdi: ["dir"],
    bdo: ["dir"],
    big: [],
    blockquote: ["cite"],
    br: [],
    caption: [],
    center: [],
    cite: [],
    code: [],
    col: ["align", "valign", "span", "width"],
    colgroup: ["align", "valign", "span", "width"],
    dd: [],
    del: ["datetime"],
    details: ["open"],
    div: [],
    dl: [],
    dt: [],
    em: [],
    figcaption: [],
    figure: [],
    font: ["color", "size", "face"],
    footer: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    header: [],
    hr: [],
    i: [],
    img: ["src", "alt", "title", "width", "height", "loading"],
    ins: ["datetime"],
    kbd: [],
    li: [],
    mark: [],
    nav: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    section: [],
    small: [],
    span: [],
    sub: [],
    summary: [],
    sup: [],
    strong: [],
    strike: [],
    table: ["width", "border", "align", "valign"],
    tbody: ["align", "valign"],
    td: ["width", "rowspan", "colspan", "align", "valign"],
    tfoot: ["align", "valign"],
    th: ["width", "rowspan", "colspan", "align", "valign"],
    thead: ["align", "valign"],
    tr: ["rowspan", "align", "valign"],
    tt: [],
    u: [],
    ul: [],
    video: [
      "autoplay",
      "controls",
      "crossorigin",
      "loop",
      "muted",
      "playsinline",
      "poster",
      "preload",
      "src",
      "height",
      "width"
    ]
  };
}
var defaultCSSFilter = new FilterCSS$1();
function onTag(tag, html, options) {
}
function onIgnoreTag(tag, html, options) {
}
function onTagAttr(tag, name2, value) {
}
function onIgnoreTagAttr(tag, name2, value) {
}
function escapeHtml(html) {
  return html.replace(REGEXP_LT, "&lt;").replace(REGEXP_GT, "&gt;");
}
function safeAttrValue(tag, name2, value, cssFilter) {
  value = friendlyAttrValue(value);
  if (name2 === "href" || name2 === "src") {
    value = _$2.trim(value);
    if (value === "#")
      return "#";
    if (!(value.substr(0, 7) === "http://" || value.substr(0, 8) === "https://" || value.substr(0, 7) === "mailto:" || value.substr(0, 4) === "tel:" || value.substr(0, 11) === "data:image/" || value.substr(0, 6) === "ftp://" || value.substr(0, 2) === "./" || value.substr(0, 3) === "../" || value[0] === "#" || value[0] === "/")) {
      return "";
    }
  } else if (name2 === "background") {
    REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
      return "";
    }
  } else if (name2 === "style") {
    REGEXP_DEFAULT_ON_TAG_ATTR_7.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_7.test(value)) {
      return "";
    }
    REGEXP_DEFAULT_ON_TAG_ATTR_8.lastIndex = 0;
    if (REGEXP_DEFAULT_ON_TAG_ATTR_8.test(value)) {
      REGEXP_DEFAULT_ON_TAG_ATTR_4.lastIndex = 0;
      if (REGEXP_DEFAULT_ON_TAG_ATTR_4.test(value)) {
        return "";
      }
    }
    if (cssFilter !== false) {
      cssFilter = cssFilter || defaultCSSFilter;
      value = cssFilter.process(value);
    }
  }
  value = escapeAttrValue(value);
  return value;
}
var REGEXP_LT = /</g;
var REGEXP_GT = />/g;
var REGEXP_QUOTE = /"/g;
var REGEXP_QUOTE_2 = /&quot;/g;
var REGEXP_ATTR_VALUE_1 = /&#([a-zA-Z0-9]*);?/gim;
var REGEXP_ATTR_VALUE_COLON = /&colon;?/gim;
var REGEXP_ATTR_VALUE_NEWLINE = /&newline;?/gim;
var REGEXP_DEFAULT_ON_TAG_ATTR_4 = /((j\s*a\s*v\s*a|v\s*b|l\s*i\s*v\s*e)\s*s\s*c\s*r\s*i\s*p\s*t\s*|m\s*o\s*c\s*h\s*a):/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_7 = /e\s*x\s*p\s*r\s*e\s*s\s*s\s*i\s*o\s*n\s*\(.*/gi;
var REGEXP_DEFAULT_ON_TAG_ATTR_8 = /u\s*r\s*l\s*\(.*/gi;
function escapeQuote(str) {
  return str.replace(REGEXP_QUOTE, "&quot;");
}
function unescapeQuote(str) {
  return str.replace(REGEXP_QUOTE_2, '"');
}
function escapeHtmlEntities(str) {
  return str.replace(REGEXP_ATTR_VALUE_1, function replaceUnicode(str2, code) {
    return code[0] === "x" || code[0] === "X" ? String.fromCharCode(parseInt(code.substr(1), 16)) : String.fromCharCode(parseInt(code, 10));
  });
}
function escapeDangerHtml5Entities(str) {
  return str.replace(REGEXP_ATTR_VALUE_COLON, ":").replace(REGEXP_ATTR_VALUE_NEWLINE, " ");
}
function clearNonPrintableCharacter(str) {
  var str2 = "";
  for (var i = 0, len = str.length; i < len; i++) {
    str2 += str.charCodeAt(i) < 32 ? " " : str.charAt(i);
  }
  return _$2.trim(str2);
}
function friendlyAttrValue(str) {
  str = unescapeQuote(str);
  str = escapeHtmlEntities(str);
  str = escapeDangerHtml5Entities(str);
  str = clearNonPrintableCharacter(str);
  return str;
}
function escapeAttrValue(str) {
  str = escapeQuote(str);
  str = escapeHtml(str);
  return str;
}
function onIgnoreTagStripAll() {
  return "";
}
function StripTagBody(tags, next) {
  if (typeof next !== "function") {
    next = function() {
    };
  }
  var isRemoveAllTag = !Array.isArray(tags);
  function isRemoveTag(tag) {
    if (isRemoveAllTag)
      return true;
    return _$2.indexOf(tags, tag) !== -1;
  }
  var removeList = [];
  var posStart = false;
  return {
    onIgnoreTag: function(tag, html, options) {
      if (isRemoveTag(tag)) {
        if (options.isClosing) {
          var ret = "[/removed]";
          var end2 = options.position + ret.length;
          removeList.push([
            posStart !== false ? posStart : options.position,
            end2
          ]);
          posStart = false;
          return ret;
        } else {
          if (!posStart) {
            posStart = options.position;
          }
          return "[removed]";
        }
      } else {
        return next(tag, html, options);
      }
    },
    remove: function(html) {
      var rethtml = "";
      var lastPos = 0;
      _$2.forEach(removeList, function(pos) {
        rethtml += html.slice(lastPos, pos[0]);
        lastPos = pos[1];
      });
      rethtml += html.slice(lastPos);
      return rethtml;
    }
  };
}
function stripCommentTag(html) {
  var retHtml = "";
  var lastPos = 0;
  while (lastPos < html.length) {
    var i = html.indexOf("<!--", lastPos);
    if (i === -1) {
      retHtml += html.slice(lastPos);
      break;
    }
    retHtml += html.slice(lastPos, i);
    var j = html.indexOf("-->", i);
    if (j === -1) {
      break;
    }
    lastPos = j + 3;
  }
  return retHtml;
}
function stripBlankChar(html) {
  var chars = html.split("");
  chars = chars.filter(function(char) {
    var c2 = char.charCodeAt(0);
    if (c2 === 127)
      return false;
    if (c2 <= 31) {
      if (c2 === 10 || c2 === 13)
        return true;
      return false;
    }
    return true;
  });
  return chars.join("");
}
_default$1.whiteList = getDefaultWhiteList();
_default$1.getDefaultWhiteList = getDefaultWhiteList;
_default$1.onTag = onTag;
_default$1.onIgnoreTag = onIgnoreTag;
_default$1.onTagAttr = onTagAttr;
_default$1.onIgnoreTagAttr = onIgnoreTagAttr;
_default$1.safeAttrValue = safeAttrValue;
_default$1.escapeHtml = escapeHtml;
_default$1.escapeQuote = escapeQuote;
_default$1.unescapeQuote = unescapeQuote;
_default$1.escapeHtmlEntities = escapeHtmlEntities;
_default$1.escapeDangerHtml5Entities = escapeDangerHtml5Entities;
_default$1.clearNonPrintableCharacter = clearNonPrintableCharacter;
_default$1.friendlyAttrValue = friendlyAttrValue;
_default$1.escapeAttrValue = escapeAttrValue;
_default$1.onIgnoreTagStripAll = onIgnoreTagStripAll;
_default$1.StripTagBody = StripTagBody;
_default$1.stripCommentTag = stripCommentTag;
_default$1.stripBlankChar = stripBlankChar;
_default$1.attributeWrapSign = '"';
_default$1.cssFilter = defaultCSSFilter;
_default$1.getDefaultCSSWhiteList = getDefaultCSSWhiteList;
var parser$1 = {};
var _$1 = util;
function getTagName(html) {
  var i = _$1.spaceIndex(html);
  var tagName;
  if (i === -1) {
    tagName = html.slice(1, -1);
  } else {
    tagName = html.slice(1, i + 1);
  }
  tagName = _$1.trim(tagName).toLowerCase();
  if (tagName.slice(0, 1) === "/")
    tagName = tagName.slice(1);
  if (tagName.slice(-1) === "/")
    tagName = tagName.slice(0, -1);
  return tagName;
}
function isClosing(html) {
  return html.slice(0, 2) === "</";
}
function parseTag$1(html, onTag2, escapeHtml2) {
  var rethtml = "";
  var lastPos = 0;
  var tagStart = false;
  var quoteStart = false;
  var currentPos = 0;
  var len = html.length;
  var currentTagName = "";
  var currentHtml = "";
  chariterator:
    for (currentPos = 0; currentPos < len; currentPos++) {
      var c2 = html.charAt(currentPos);
      if (tagStart === false) {
        if (c2 === "<") {
          tagStart = currentPos;
          continue;
        }
      } else {
        if (quoteStart === false) {
          if (c2 === "<") {
            rethtml += escapeHtml2(html.slice(lastPos, currentPos));
            tagStart = currentPos;
            lastPos = currentPos;
            continue;
          }
          if (c2 === ">" || currentPos === len - 1) {
            rethtml += escapeHtml2(html.slice(lastPos, tagStart));
            currentHtml = html.slice(tagStart, currentPos + 1);
            currentTagName = getTagName(currentHtml);
            rethtml += onTag2(
              tagStart,
              rethtml.length,
              currentTagName,
              currentHtml,
              isClosing(currentHtml)
            );
            lastPos = currentPos + 1;
            tagStart = false;
            continue;
          }
          if (c2 === '"' || c2 === "'") {
            var i = 1;
            var ic = html.charAt(currentPos - i);
            while (ic.trim() === "" || ic === "=") {
              if (ic === "=") {
                quoteStart = c2;
                continue chariterator;
              }
              ic = html.charAt(currentPos - ++i);
            }
          }
        } else {
          if (c2 === quoteStart) {
            quoteStart = false;
            continue;
          }
        }
      }
    }
  if (lastPos < len) {
    rethtml += escapeHtml2(html.substr(lastPos));
  }
  return rethtml;
}
var REGEXP_ILLEGAL_ATTR_NAME = /[^a-zA-Z0-9\\_:.-]/gim;
function parseAttr$1(html, onAttr2) {
  var lastPos = 0;
  var lastMarkPos = 0;
  var retAttrs = [];
  var tmpName = false;
  var len = html.length;
  function addAttr(name2, value) {
    name2 = _$1.trim(name2);
    name2 = name2.replace(REGEXP_ILLEGAL_ATTR_NAME, "").toLowerCase();
    if (name2.length < 1)
      return;
    var ret = onAttr2(name2, value || "");
    if (ret)
      retAttrs.push(ret);
  }
  for (var i = 0; i < len; i++) {
    var c2 = html.charAt(i);
    var v, j;
    if (tmpName === false && c2 === "=") {
      tmpName = html.slice(lastPos, i);
      lastPos = i + 1;
      lastMarkPos = html.charAt(lastPos) === '"' || html.charAt(lastPos) === "'" ? lastPos : findNextQuotationMark(html, i + 1);
      continue;
    }
    if (tmpName !== false) {
      if (i === lastMarkPos) {
        j = html.indexOf(c2, i + 1);
        if (j === -1) {
          break;
        } else {
          v = _$1.trim(html.slice(lastMarkPos + 1, j));
          addAttr(tmpName, v);
          tmpName = false;
          i = j;
          lastPos = i + 1;
          continue;
        }
      }
    }
    if (/\s|\n|\t/.test(c2)) {
      html = html.replace(/\s|\n|\t/g, " ");
      if (tmpName === false) {
        j = findNextEqual(html, i);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i));
          addAttr(v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          i = j - 1;
          continue;
        }
      } else {
        j = findBeforeEqual(html, i - 1);
        if (j === -1) {
          v = _$1.trim(html.slice(lastPos, i));
          v = stripQuoteWrap(v);
          addAttr(tmpName, v);
          tmpName = false;
          lastPos = i + 1;
          continue;
        } else {
          continue;
        }
      }
    }
  }
  if (lastPos < html.length) {
    if (tmpName === false) {
      addAttr(html.slice(lastPos));
    } else {
      addAttr(tmpName, stripQuoteWrap(_$1.trim(html.slice(lastPos))));
    }
  }
  return _$1.trim(retAttrs.join(" "));
}
function findNextEqual(str, i) {
  for (; i < str.length; i++) {
    var c2 = str[i];
    if (c2 === " ")
      continue;
    if (c2 === "=")
      return i;
    return -1;
  }
}
function findNextQuotationMark(str, i) {
  for (; i < str.length; i++) {
    var c2 = str[i];
    if (c2 === " ")
      continue;
    if (c2 === "'" || c2 === '"')
      return i;
    return -1;
  }
}
function findBeforeEqual(str, i) {
  for (; i > 0; i--) {
    var c2 = str[i];
    if (c2 === " ")
      continue;
    if (c2 === "=")
      return i;
    return -1;
  }
}
function isQuoteWrapString(text) {
  if (text[0] === '"' && text[text.length - 1] === '"' || text[0] === "'" && text[text.length - 1] === "'") {
    return true;
  } else {
    return false;
  }
}
function stripQuoteWrap(text) {
  if (isQuoteWrapString(text)) {
    return text.substr(1, text.length - 2);
  } else {
    return text;
  }
}
parser$1.parseTag = parseTag$1;
parser$1.parseAttr = parseAttr$1;
var FilterCSS = lib.exports.FilterCSS;
var DEFAULT = _default$1;
var parser = parser$1;
var parseTag = parser.parseTag;
var parseAttr = parser.parseAttr;
var _ = util;
function isNull(obj) {
  return obj === void 0 || obj === null;
}
function getAttrs(html) {
  var i = _.spaceIndex(html);
  if (i === -1) {
    return {
      html: "",
      closing: html[html.length - 2] === "/"
    };
  }
  html = _.trim(html.slice(i + 1, -1));
  var isClosing2 = html[html.length - 1] === "/";
  if (isClosing2)
    html = _.trim(html.slice(0, -1));
  return {
    html,
    closing: isClosing2
  };
}
function shallowCopyObject(obj) {
  var ret = {};
  for (var i in obj) {
    ret[i] = obj[i];
  }
  return ret;
}
function keysToLowerCase(obj) {
  var ret = {};
  for (var i in obj) {
    if (Array.isArray(obj[i])) {
      ret[i.toLowerCase()] = obj[i].map(function(item) {
        return item.toLowerCase();
      });
    } else {
      ret[i.toLowerCase()] = obj[i];
    }
  }
  return ret;
}
function FilterXSS(options) {
  options = shallowCopyObject(options || {});
  if (options.stripIgnoreTag) {
    if (options.onIgnoreTag) {
      console.error(
        'Notes: cannot use these two options "stripIgnoreTag" and "onIgnoreTag" at the same time'
      );
    }
    options.onIgnoreTag = DEFAULT.onIgnoreTagStripAll;
  }
  if (options.whiteList || options.allowList) {
    options.whiteList = keysToLowerCase(options.whiteList || options.allowList);
  } else {
    options.whiteList = DEFAULT.whiteList;
  }
  this.attributeWrapSign = options.singleQuotedAttributeValue === true ? "'" : DEFAULT.attributeWrapSign;
  options.onTag = options.onTag || DEFAULT.onTag;
  options.onTagAttr = options.onTagAttr || DEFAULT.onTagAttr;
  options.onIgnoreTag = options.onIgnoreTag || DEFAULT.onIgnoreTag;
  options.onIgnoreTagAttr = options.onIgnoreTagAttr || DEFAULT.onIgnoreTagAttr;
  options.safeAttrValue = options.safeAttrValue || DEFAULT.safeAttrValue;
  options.escapeHtml = options.escapeHtml || DEFAULT.escapeHtml;
  this.options = options;
  if (options.css === false) {
    this.cssFilter = false;
  } else {
    options.css = options.css || {};
    this.cssFilter = new FilterCSS(options.css);
  }
}
FilterXSS.prototype.process = function(html) {
  html = html || "";
  html = html.toString();
  if (!html)
    return "";
  var me = this;
  var options = me.options;
  var whiteList = options.whiteList;
  var onTag2 = options.onTag;
  var onIgnoreTag2 = options.onIgnoreTag;
  var onTagAttr2 = options.onTagAttr;
  var onIgnoreTagAttr2 = options.onIgnoreTagAttr;
  var safeAttrValue2 = options.safeAttrValue;
  var escapeHtml2 = options.escapeHtml;
  var attributeWrapSign = me.attributeWrapSign;
  var cssFilter = me.cssFilter;
  if (options.stripBlankChar) {
    html = DEFAULT.stripBlankChar(html);
  }
  if (!options.allowCommentTag) {
    html = DEFAULT.stripCommentTag(html);
  }
  var stripIgnoreTagBody = false;
  if (options.stripIgnoreTagBody) {
    stripIgnoreTagBody = DEFAULT.StripTagBody(
      options.stripIgnoreTagBody,
      onIgnoreTag2
    );
    onIgnoreTag2 = stripIgnoreTagBody.onIgnoreTag;
  }
  var retHtml = parseTag(
    html,
    function(sourcePosition, position, tag, html2, isClosing2) {
      var info2 = {
        sourcePosition,
        position,
        isClosing: isClosing2,
        isWhite: Object.prototype.hasOwnProperty.call(whiteList, tag)
      };
      var ret = onTag2(tag, html2, info2);
      if (!isNull(ret))
        return ret;
      if (info2.isWhite) {
        if (info2.isClosing) {
          return "</" + tag + ">";
        }
        var attrs = getAttrs(html2);
        var whiteAttrList = whiteList[tag];
        var attrsHtml = parseAttr(attrs.html, function(name2, value) {
          var isWhiteAttr = _.indexOf(whiteAttrList, name2) !== -1;
          var ret2 = onTagAttr2(tag, name2, value, isWhiteAttr);
          if (!isNull(ret2))
            return ret2;
          if (isWhiteAttr) {
            value = safeAttrValue2(tag, name2, value, cssFilter);
            if (value) {
              return name2 + "=" + attributeWrapSign + value + attributeWrapSign;
            } else {
              return name2;
            }
          } else {
            ret2 = onIgnoreTagAttr2(tag, name2, value, isWhiteAttr);
            if (!isNull(ret2))
              return ret2;
            return;
          }
        });
        html2 = "<" + tag;
        if (attrsHtml)
          html2 += " " + attrsHtml;
        if (attrs.closing)
          html2 += " /";
        html2 += ">";
        return html2;
      } else {
        ret = onIgnoreTag2(tag, html2, info2);
        if (!isNull(ret))
          return ret;
        return escapeHtml2(html2);
      }
    },
    escapeHtml2
  );
  if (stripIgnoreTagBody) {
    retHtml = stripIgnoreTagBody.remove(retHtml);
  }
  return retHtml;
};
var xss$1 = FilterXSS;
(function(module, exports) {
  var DEFAULT2 = _default$1;
  var parser2 = parser$1;
  var FilterXSS2 = xss$1;
  function filterXSS(html, options) {
    var xss2 = new FilterXSS2(options);
    return xss2.process(html);
  }
  exports = module.exports = filterXSS;
  exports.filterXSS = filterXSS;
  exports.FilterXSS = FilterXSS2;
  (function() {
    for (var i in DEFAULT2) {
      exports[i] = DEFAULT2[i];
    }
    for (var j in parser2) {
      exports[j] = parser2[j];
    }
  })();
  if (typeof window !== "undefined") {
    window.filterXSS = module.exports;
  }
  function isWorkerEnv() {
    return typeof self !== "undefined" && typeof DedicatedWorkerGlobalScope !== "undefined" && self instanceof DedicatedWorkerGlobalScope;
  }
  if (isWorkerEnv()) {
    self.filterXSS = module.exports;
  }
})(lib$1, lib$1.exports);
var xss = lib$1.exports;
const sendFormData = (params) => {
  let detail = null;
  if (params && params.advType === 3) {
    params.advType = 0;
    detail = params.detail;
  }
  return (user) => {
    if (!detail || !user || !user.data || !user.data.isReg)
      return;
    const { logidUrl } = detail;
    if (!logidUrl)
      return;
    const res = logidUrl.match(/cb=([^\&]+)/);
    if (!res && res[1])
      return;
    let url = window.decodeURIComponent(res[1]);
    const vs = {
      __EVENTTYPE__: "api_submit",
      __TIMESTAMP__: Math.floor(Date.now() / 1e3)
    };
    Object.keys(vs).forEach((key) => {
      if (url.indexOf(key) === -1) {
        url += `&${key}=${vs[key]}`;
      } else {
        url = url.replace(key, vs[key]);
      }
    });
    const image = new Image();
    image.src = url;
  };
};
const getFormData = async () => {
  let promote = {};
  let utm = {};
  let extendTrackInfo = {};
  let naturalGrowth = true;
  try {
    const utmItem = getSessionStorageItem$1(SESSION_KEYS.UTM_ITEM);
    if (utmItem) {
      utm = JSON.parse(utmItem);
      naturalGrowth = false;
    }
    const mgPromote = await getDrainageData();
    if (mgPromote) {
      promote = JSON.parse(mgPromote);
    }
    const extendTrackStr = getSessionStorageItem$1(SESSION_KEYS.EXTEND_TRACK);
    if (extendTrackStr) {
      extendTrackInfo = JSON.parse(extendTrackStr);
    }
  } catch (e2) {
    console.log("getFormData error:", e2);
  }
  const yToken = getSessionStorageItem$1(SESSION_KEYS.Y_TOKEN);
  const invToken = getSessionStorageItem$1(SESSION_KEYS.INVITE_TOKEN);
  const subToken = getSessionStorageItem$1(SESSION_KEYS.WECHAT_LOGIN_START);
  const randomNum = getUrlValue$1(SESSION_KEYS.RANDOM_NUM, getSessionStorageItem$1("appAuth") || "");
  const app = isMirror$1() ? "mirror_app" : randomNum ? "masterdesktop" : "masterweb";
  return {
    action_position: getActionPosition(window.location.href),
    ...promote,
    ...utm,
    ...extendTrackInfo,
    yToken,
    naturalGrowth,
    invToken,
    subToken,
    randomNum,
    app
  };
};
const getPhoneNumberServer = function() {
  let phoneNumberServer = null;
  return () => {
    if (phoneNumberServer)
      return phoneNumberServer;
    if (isInIframe())
      throw Error("phoneNumberServer used in iframe");
    const { PhoneNumberServer } = require("aliyun_numberauthsdk_web");
    phoneNumberServer = new PhoneNumberServer();
    return phoneNumberServer;
  };
}();
function checkAuthAvailable(data2) {
  const phoneNumberServer = getPhoneNumberServer();
  return new Promise((success, error) => phoneNumberServer.checkAuthAvailable({ ...data2, success, error }));
}
function getVerifyToken() {
  const phoneNumberServer = getPhoneNumberServer();
  return new Promise((success, error) => phoneNumberServer.getVerifyToken({ success, error }));
}
function isSafeRedirectUrl(url) {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch (e2) {
    console.log("isSafeRedirectUrl error:", e2);
    return false;
  }
}
function checkRedirectUrl(url) {
  if (isSafeRedirectUrl(url)) {
    if (url.startsWith(window.location.origin)) {
      return xss(url);
    }
    return "";
  }
  return "";
}
function isBindPhoneNumber(data2) {
  return !!data2.authPhoneNumber;
}
function isNeedRealNameAuth(data2, isPri2 = false) {
  if (isPri2 || isMirror$1() || isMobile()) {
    return false;
  }
  return data2.forceAuthPhone && !isBindPhoneNumber(data2);
}
var SensorsType = /* @__PURE__ */ ((SensorsType2) => {
  SensorsType2["CLICK_LOGIN_BTN"] = "click_login_btn";
  SensorsType2["LOGIN_POPOUT_LOAD"] = "login_popout_load";
  SensorsType2["EVENT_CLICK"] = "event_click";
  SensorsType2["USER_LOGIN"] = "user_login";
  SensorsType2["SHOW_LOGIN"] = "show_login";
  SensorsType2["WECHAT_QR_LOAD"] = "wechat_qr_load";
  SensorsType2["SEND_CODE"] = "send_code";
  return SensorsType2;
})(SensorsType || {});
var union = { exports: {} };
var ddSdk = {};
var env$1 = {};
var sdk = {};
var sdkLib = {};
(function(exports) {
  function isFunction2(o2) {
    return "function" == typeof o2;
  }
  function compareVersion(o2, n) {
    function e2(o3) {
      return parseInt(o3, 10) || 0;
    }
    for (var r = o2.split(".").map(e2), E = n.split(".").map(e2), t2 = 0; t2 < r.length; t2++) {
      if (void 0 === E[t2])
        return false;
      if (r[t2] < E[t2])
        return false;
      if (r[t2] > E[t2])
        return true;
    }
    return true;
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.LogLevel = exports.APP_TYPE = exports.ENV_ENUM_SUB = exports.ENV_ENUM = exports.ERROR_CODE = exports.compareVersion = exports.isFunction = void 0, exports.isFunction = isFunction2, exports.compareVersion = compareVersion;
  var ERROR_CODE;
  !function(o2) {
    o2.cancel = "-1", o2.not_exist = "1", o2.no_permission = "7", o2.jsapi_internal_error = "22";
  }(ERROR_CODE || (exports.ERROR_CODE = ERROR_CODE = {}));
  var ENV_ENUM;
  !function(o2) {
    o2.pc = "pc", o2.android = "android", o2.ios = "ios", o2.notInDingTalk = "notInDingTalk", o2.harmony = "harmony";
  }(ENV_ENUM || (exports.ENV_ENUM = ENV_ENUM = {}));
  var ENV_ENUM_SUB;
  !function(o2) {
    o2.mac = "mac", o2.win = "win", o2.noSub = "noSub";
  }(ENV_ENUM_SUB || (exports.ENV_ENUM_SUB = ENV_ENUM_SUB = {}));
  var APP_TYPE;
  !function(o2) {
    o2.WEB = "WEB", o2.MINI_APP = "MINI_APP", o2.WEEX = "WEEX", o2.WEBVIEW_IN_MINIAPP = "WEBVIEW_IN_MINIAPP", o2.WEEX_WIDGET = "WEEX_WIDGET";
  }(APP_TYPE || (exports.APP_TYPE = APP_TYPE = {}));
  var LogLevel;
  !function(o2) {
    o2[o2.INFO = 1] = "INFO", o2[o2.WARNING = 2] = "WARNING", o2[o2.ERROR = 3] = "ERROR";
  }(LogLevel || (exports.LogLevel = LogLevel = {}));
})(sdkLib);
(function(exports) {
  function getTargetApiConfigVS(e2, o2) {
    var i = e2 && e2.vs;
    return "object" == typeof i && (i = i[o2.platformSub]), i;
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.Sdk = exports.LogLevel = exports.APP_TYPE = exports.isFunction = exports.compareVersion = exports.ENV_ENUM_SUB = exports.ENV_ENUM = void 0;
  var sdkLib_1 = sdkLib;
  Object.defineProperty(exports, "APP_TYPE", { enumerable: true, get: function() {
    return sdkLib_1.APP_TYPE;
  } }), Object.defineProperty(exports, "LogLevel", { enumerable: true, get: function() {
    return sdkLib_1.LogLevel;
  } }), Object.defineProperty(exports, "isFunction", { enumerable: true, get: function() {
    return sdkLib_1.isFunction;
  } }), Object.defineProperty(exports, "compareVersion", { enumerable: true, get: function() {
    return sdkLib_1.compareVersion;
  } }), Object.defineProperty(exports, "ENV_ENUM", { enumerable: true, get: function() {
    return sdkLib_1.ENV_ENUM;
  } }), Object.defineProperty(exports, "ENV_ENUM_SUB", { enumerable: true, get: function() {
    return sdkLib_1.ENV_ENUM_SUB;
  } });
  var Sdk = function() {
    function e2(e3, o2) {
      var i = this;
      this.configJsApiList = [], this.hadConfig = false, this.p = {}, this.config$ = new Promise(function(e4, o3) {
        i.p.reject = o3, i.p.resolve = e4;
      }), this.logQueue = [], this.devConfig = { debug: false }, this.platformConfigMap = {}, this.invokeAPIConfigMapByMethod = {}, this.isBridgeDrity = true, this.getExportSdk = function() {
        return i.exportSdk;
      }, this.setAPI = function(e4, o3) {
        i.invokeAPIConfigMapByMethod[e4] = o3;
      }, this.setPlatform = function(e4) {
        i.isBridgeDrity = true, i.platformConfigMap[e4.platform] = e4, e4.platform === i.env.platform && e4.bridgeInit().catch(function(e5) {
          i.customLog(sdkLib_1.LogLevel.WARNING, ["auto bridgeInit error", e5 || ""]);
        });
      }, this.getPlatformConfigMap = function() {
        return i.platformConfigMap;
      }, this.deleteApiConfig = function(e4, o3) {
        var t3 = i.invokeAPIConfigMapByMethod[e4];
        t3 && delete t3[o3];
      }, this.invokeAPI = function(e4, o3, t3) {
        void 0 === o3 && (o3 = {}), void 0 === t3 && (t3 = true), i.customLog(sdkLib_1.LogLevel.INFO, ['==> "'.concat(e4, '" params: '), o3]);
        var n = +new Date(), r = n + "_" + Math.floor(1e3 * Math.random());
        if (i.devConfig.onBeforeInvokeAPI)
          try {
            i.devConfig.onBeforeInvokeAPI({ invokeId: r, method: e4, params: o3, startTime: n });
          } catch (e5) {
            i.customLog(sdkLib_1.LogLevel.ERROR, ["call Hook:onBeforeInvokeAPI failed, reason:", e5]);
          }
        return false === i.devConfig.isAuthApi && (t3 = false), i.bridgeInitFn().then(function(s) {
          var a2 = i.invokeAPIConfigMapByMethod[e4], f2 = i.devConfig.forceEnableDealApiFnMap && i.devConfig.forceEnableDealApiFnMap[e4] && true === i.devConfig.forceEnableDealApiFnMap[e4](o3), c2 = !f2 && (true === i.devConfig.isDisableDeal || i.devConfig.disbaleDealApiWhiteList && -1 !== i.devConfig.disbaleDealApiWhiteList.indexOf(e4));
          if (a2 || !t3) {
            var u;
            if (a2 && (u = a2[i.env.platform]), u || !t3) {
              var d2 = {};
              d2 = !c2 && u && u.paramsDeal && (0, sdkLib_1.isFunction)(u.paramsDeal) ? u.paramsDeal(o3) : Object.assign({}, o3);
              var g = function(e5) {
                return !c2 && u && u.resultDeal && (0, sdkLib_1.isFunction)(u.resultDeal) ? u.resultDeal(e5) : e5;
              };
              if ((0, sdkLib_1.isFunction)(d2.onSuccess)) {
                var l = d2.onSuccess;
                d2.onSuccess = function(e5) {
                  l(g(e5));
                };
              }
              return s(e4, d2).then(g, function(o4) {
                var n2 = i.hadConfig && void 0 === i.isReady && -1 !== i.configJsApiList.indexOf(e4), r2 = "object" == typeof o4 && "string" == typeof o4.errorCode && o4.errorCode === sdkLib_1.ERROR_CODE.no_permission, a3 = "object" == typeof o4 && "string" == typeof o4.errorCode && o4.errorCode === sdkLib_1.ERROR_CODE.cancel, f3 = getTargetApiConfigVS(u, i.env), c3 = f3 && i.env.version && (0, sdkLib_1.compareVersion)(i.env.version, f3), l2 = (i.env.platform === sdkLib_1.ENV_ENUM.ios || i.env.platform === sdkLib_1.ENV_ENUM.android || i.env.platform === sdkLib_1.ENV_ENUM.harmony) && n2 && r2, p2 = i.env.platform === sdkLib_1.ENV_ENUM.pc && n2 && (c3 && !a3 && t3 || r2);
                return l2 || p2 ? i.config$.then(function() {
                  return s(e4, d2).then(g);
                }) : Promise.reject(o4);
              }).then(function(t4) {
                if (i.devConfig.onAfterInvokeAPI)
                  try {
                    i.devConfig.onAfterInvokeAPI({ invokeId: r, method: e4, params: o3, payload: t4, isSuccess: true, startTime: n, duration: +new Date() - n });
                  } catch (e5) {
                    i.customLog(sdkLib_1.LogLevel.ERROR, ["call Hook:onAfterInvokeAPI failed, reason:", e5]);
                  }
                return i.customLog(sdkLib_1.LogLevel.INFO, ['<== "'.concat(e4, '" success result: '), t4]), t4;
              }, function(t4) {
                if (i.devConfig.onAfterInvokeAPI)
                  try {
                    i.devConfig.onAfterInvokeAPI({ invokeId: r, method: e4, params: o3, payload: t4, startTime: n, duration: +new Date() - n, isSuccess: false });
                  } catch (t5) {
                    i.customLog(sdkLib_1.LogLevel.ERROR, ["call Hook:onAfterInvokeAPI failed, reason:", t5]);
                  }
                return i.customLog(sdkLib_1.LogLevel.WARNING, ['<== "'.concat(e4, '" fail result: '), t4]), Promise.reject(t4);
              });
            }
            var p = '"'.concat(e4, '" do not support the current platform (').concat(i.env.platform, ")");
            return i.customLog(sdkLib_1.LogLevel.ERROR, [p]), Promise.reject({ errorCode: sdkLib_1.ERROR_CODE.jsapi_internal_error, errorMessage: p });
          }
          var p = "This API method is not configured for the platform (".concat(i.env.platform, ")");
          return i.customLog(sdkLib_1.LogLevel.ERROR, [p]), Promise.reject({ errorCode: sdkLib_1.ERROR_CODE.jsapi_internal_error, errorMessage: p });
        });
      }, this.isLogQueueTimeout = false, this.customLog = function(e4, o3) {
        var t3 = { level: e4, text: o3, time: new Date() };
        if (true === i.devConfig.debug)
          i.customLogInstance(t3);
        else if (!i.isLogQueueTimeout) {
          i.logQueueTimer || (i.logQueueTimer = setTimeout(function() {
            i.isLogQueueTimeout = true, i.logQueue = [];
          }, 1e4)), i.logQueue.push(t3);
          i.logQueue.length > 10 && (i.logQueue = i.logQueue.slice(i.logQueue.length - 10));
        }
      }, this.clearLogQueue = function() {
        i.logQueue.forEach(function(e4) {
          i.customLogInstance(e4);
        }), i.logQueue = [];
      }, this.customLogInstance = o2, this.env = e3, this.bridgeInitFn = function() {
        if (i.bridgeInitFnPromise && !i.isBridgeDrity)
          return i.bridgeInitFnPromise;
        i.isBridgeDrity = false;
        var o3 = i.platformConfigMap[e3.platform];
        if (o3)
          i.bridgeInitFnPromise = o3.bridgeInit().catch(function(e4) {
            return i.customLog(sdkLib_1.LogLevel.ERROR, ["\b\b\b\b\bJsBridge initialization fails, jsapi will not work"]), Promise.reject(e4);
          });
        else {
          var t3 = "Do not support the current environment\uFF1A".concat(e3.platform);
          i.customLog(sdkLib_1.LogLevel.WARNING, [t3]), i.bridgeInitFnPromise = Promise.reject(new Error(t3));
        }
        return i.bridgeInitFnPromise;
      };
      var t2 = function(e4) {
        void 0 === e4 && (e4 = {}), i.devConfig = Object.assign(i.devConfig, e4), true === e4.debug && i.clearLogQueue(), e4.extraPlatform && i.setPlatform(e4.extraPlatform);
      };
      this.exportSdk = { config: function(o3) {
        void 0 === o3 && (o3 = {});
        var n = true;
        Object.keys(o3).forEach(function(e4) {
          -1 === ["debug", "usePromise"].indexOf(e4) && (n = false);
        }), n ? (i.customLog(sdkLib_1.LogLevel.WARNING, ["This is a deprecated feature, recommend use dd.devConfig"]), t2(o3)) : i.hadConfig ? i.customLog(sdkLib_1.LogLevel.WARNING, ["Config has been executed"]) : (o3.jsApiList && (i.configJsApiList = o3.jsApiList), i.hadConfig = true, i.bridgeInitFn().then(function(t3) {
          var n2 = i.platformConfigMap[e3.platform], r = o3;
          n2.authParamsDeal && (r = n2.authParamsDeal(r)), t3(n2.authMethod, r).then(function(e4) {
            i.isReady = true, i.p.resolve(e4);
          }).catch(function(e4) {
            i.isReady = false, i.p.reject(e4);
          });
        }, function(e4) {
          i.customLog(sdkLib_1.LogLevel.ERROR, ['\b\b\b\b\bJsBridge initialization failed and "dd.config" failed to call']), i.p.reject(e4);
        }));
      }, devConfig: t2, ready: function(e4) {
        false === i.hadConfig ? (i.customLog(sdkLib_1.LogLevel.WARNING, ["You don 't use a dd.config, so you don't need to wrap dd.ready, recommend remove dd.ready"]), i.bridgeInitFn().then(function() {
          e4();
        })) : i.config$.then(function(o3) {
          e4();
        });
      }, error: function(e4) {
        i.config$.catch(function(o3) {
          e4(o3);
        });
      }, on: function(o3, t3) {
        i.bridgeInitFn().then(function() {
          i.platformConfigMap[e3.platform].event.on(o3, t3);
        });
      }, off: function(o3, t3) {
        i.bridgeInitFn().then(function() {
          i.platformConfigMap[e3.platform].event.off(o3, t3);
        });
      }, env: e3, checkJsApi: function(o3) {
        void 0 === o3 && (o3 = {});
        var t3 = {};
        return o3.jsApiList && o3.jsApiList.forEach(function(o4) {
          var n = i.invokeAPIConfigMapByMethod[o4];
          if (n) {
            var r = n[e3.platform], s = getTargetApiConfigVS(r, e3);
            s && e3.version && (0, sdkLib_1.compareVersion)(e3.version, s) && (t3[o4] = true);
          }
          t3[o4] || (t3[o4] = false);
        }), Promise.resolve(t3);
      }, _invoke: function(e4, o3) {
        return void 0 === o3 && (o3 = {}), i.invokeAPI(e4, o3, false);
      } };
    }
    return e2;
  }();
  exports.Sdk = Sdk;
})(sdk);
var dingtalkJavascriptEnv = {};
var whichOneRuntime$1 = {};
function snifferMachine(e2, n) {
  for (var i = e2.length, a2 = 0, f2 = true; a2 < i; a2++)
    try {
      if (!(e2[a2] in n)) {
        f2 = false;
        break;
      }
    } catch (e3) {
      f2 = false;
      break;
    }
  return f2;
}
function whichOneRuntime() {
  return maybeInWebView && maybeInWeexVueEnv ? snifferMachine(snifferWeexVueMap, weex) ? "Web.Vue" : "Web.Unknown" : !maybeInWebView && maybeInWeexVueEnv ? snifferMachine(snifferWeexVueMap, weex) ? "Weex.Vue" : "Weex.Unknown" : maybeInWebView && maybeInNative && !maybeInWeexVueEnv ? snifferMachine(snifferWeexRaxMap, window) ? "Weex.Rax" : "Weex.Unknown" : maybeInWebView && snifferMachine(snifferWebViewMap, window) ? "Web.Unknown" : "Unknown.Unknown";
}
Object.defineProperty(whichOneRuntime$1, "__esModule", { value: true });
var maybeInWebView = "undefined" != typeof window, maybeInWeexVueEnv = "undefined" != typeof weex, maybeInNative = "undefined" != typeof callNative, snifferWeexRaxMap = ["__weex_config__", "__weex_options__", "__weex_require__"], snifferWebViewMap = ["localStorage", "location", "navigator", "XMLHttpRequest"], snifferWeexVueMap = ["config", "requireModule", "document"];
whichOneRuntime$1.default = whichOneRuntime;
var environment$1 = {};
var constants$2 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.FRAMEWORK = exports.PLATFORM = exports.RUNTIME = void 0, exports.RUNTIME = { WEB: "Web", WEEX: "Weex", UNKNOWN: "Unknown" }, exports.PLATFORM = { MAC: "Mac", WINDOWS: "Windows", IOS: "iOS", ANDROID: "Android", IPAD: "iPad", BROWSER: "Browser", UNKNOWN: "Unknown" }, exports.FRAMEWORK = { VUE: "Vue", RAX: "Rax", UNKNOWN: "Unknown" };
})(constants$2);
function environment(n, i, a2) {
  var t2 = "Web" === a2.platform, e2 = "iOS" === a2.platform, r = "android" === a2.platform, o2 = r || e2, s = function() {
    return t2 ? window.navigator.userAgent.toLowerCase() : "";
  }(), c2 = function() {
    var n2 = {};
    if (t2) {
      var i2 = window.name;
      try {
        var a3 = JSON.parse(i2);
        n2.containerId = a3.containerId, n2.version = a3.hostVersion, n2.language = a3.language || "*";
      } catch (n3) {
      }
    }
    return n2;
  }(), d2 = function() {
    return o2 ? "DingTalk" === a2.appName || "com.alibaba.android.rimet" === a2.appName : s.indexOf("dingtalk") > -1 || !!c2.containerId;
  }(), O = function() {
    if (t2) {
      if (c2.version)
        return c2.version;
      var n2 = s.match(/aliapp\(\w+\/([a-zA-Z0-9.-]+)\)/);
      null === n2 && (n2 = s.match(/dingtalk\/([a-zA-Z0-9.-]+)/));
      return n2 && n2[1] || "Unknown";
    }
    return a2.appVersion;
  }(), u = !!c2.containerId, l = /iphone|ipod|ios/.test(s), f2 = /ipad/.test(s), p = s.indexOf("android") > -1, m2 = s.indexOf("mac") > -1 && u, A = s.indexOf("win") > -1 && u, g = !m2 && !A && u, v = u, P = "";
  return P = d2 ? l || e2 ? constants_1$1.PLATFORM.IOS : p || r ? constants_1$1.PLATFORM.ANDROID : f2 ? constants_1$1.PLATFORM.IPAD : m2 ? constants_1$1.PLATFORM.MAC : A ? constants_1$1.PLATFORM.WINDOWS : g ? constants_1$1.PLATFORM.BROWSER : constants_1$1.PLATFORM.UNKNOWN : constants_1$1.PLATFORM.UNKNOWN, { isDingTalk: d2, isWebiOS: l, isWebAndroid: p, isWeexiOS: e2, isWeexAndroid: r, isDingTalkPCMac: m2, isDingTalkPCWeb: g, isDingTalkPCWindows: A, isDingTalkPC: v, runtime: n, framework: i, platform: P, version: O, isWeex: o2 };
}
Object.defineProperty(environment$1, "__esModule", { value: true });
var constants_1$1 = constants$2;
environment$1.default = environment;
function getVirtualEnv() {
  var n = {};
  switch (framework) {
    case constants_1.FRAMEWORK.VUE:
      var t2 = weex.config, e2 = t2.env;
      n.platform = e2.platform, constants_1.RUNTIME.WEEX === runtime && (n.appVersion = e2.appVersion, n.appName = e2.appName);
      break;
    case constants_1.FRAMEWORK.RAX:
      constants_1.RUNTIME.WEEX === runtime && (n.platform = navigator.platform, n.appName = navigator.appName, n.appVersion = navigator.appVersion);
      break;
    case constants_1.FRAMEWORK.UNKNOWN:
      constants_1.RUNTIME.WEB === runtime && (n.platform = constants_1.RUNTIME.WEB), constants_1.RUNTIME.UNKNOWN === runtime && (n.platform = constants_1.RUNTIME.UNKNOWN);
  }
  return n;
}
Object.defineProperty(dingtalkJavascriptEnv, "__esModule", { value: true });
var whichOneRuntime_1 = whichOneRuntime$1, environment_1 = environment$1, constants_1 = constants$2, _a = (0, whichOneRuntime_1.default)().split("."), runtime = _a[0], framework = _a[1], virtualEnv = getVirtualEnv(), env = (0, environment_1.default)(runtime, framework, virtualEnv);
dingtalkJavascriptEnv.default = env;
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getENV = exports.getUA = exports.ENV_ENUM_SUB = exports.APP_TYPE = exports.ENV_ENUM = void 0;
  var sdk_12 = sdk, sdk_2 = sdk;
  Object.defineProperty(exports, "ENV_ENUM", { enumerable: true, get: function() {
    return sdk_2.ENV_ENUM;
  } }), Object.defineProperty(exports, "APP_TYPE", { enumerable: true, get: function() {
    return sdk_2.APP_TYPE;
  } }), Object.defineProperty(exports, "ENV_ENUM_SUB", { enumerable: true, get: function() {
    return sdk_2.ENV_ENUM_SUB;
  } });
  var dingtalk_javascript_env_1 = dingtalkJavascriptEnv, getTopBridge = function() {
    try {
      if ("undefined" != typeof window && void 0 !== window.top) {
        return window.top.__dingtalk_jsapi_top_platfrom_config__;
      }
    } catch (e2) {
      return;
    }
  }, EDdWeexEnv;
  !function(e2) {
    e2.singlePage = "singlePage", e2.miniApp = "miniApp", e2.miniWidget = "miniWidget";
  }(EDdWeexEnv || (EDdWeexEnv = {}));
  var getUA = function() {
    var e2 = "";
    try {
      "undefined" != typeof navigator && (e2 = navigator && (navigator.userAgent || navigator.swuserAgent) || "");
    } catch (t2) {
      e2 = "";
    }
    return e2;
  };
  exports.getUA = getUA;
  var getENV = function() {
    var e2 = (0, exports.getUA)(), t2 = /iPhone|iPad|iPod|iOS/i.test(e2), n = /Android/i.test(e2), i = (/Nebula/i.test(e2), /DingTalk/i.test(e2)), a2 = /dd-web/i.test(e2), r = "object" == typeof nuva, d2 = "object" == typeof dd && "function" == typeof dd.dtBridge, o2 = /OpenHarmony/i.test(e2) && /ArkWeb/i.test(e2), _2 = d2 && t2 || r && t2, s = i || dingtalk_javascript_env_1.default.isDingTalk, E = t2 && s || dingtalk_javascript_env_1.default.isWeexiOS || _2, p = n && s || dingtalk_javascript_env_1.default.isWeexAndroid, g = d2, c2 = a2, v = o2 && s, u = sdk_12.APP_TYPE.WEB;
    if (c2)
      u = sdk_12.APP_TYPE.WEBVIEW_IN_MINIAPP;
    else if (g)
      u = sdk_12.APP_TYPE.MINI_APP;
    else if (dingtalk_javascript_env_1.default.isWeexiOS || dingtalk_javascript_env_1.default.isWeexAndroid)
      try {
        var f2 = weex.config.ddWeexEnv;
        u = f2 === EDdWeexEnv.miniWidget ? sdk_12.APP_TYPE.WEEX_WIDGET : sdk_12.APP_TYPE.WEEX;
      } catch (e3) {
        u = sdk_12.APP_TYPE.WEEX;
      }
    var l, P = "*", N = e2.match(/AliApp\(\w+\/([a-zA-Z0-9.-]+)\)/);
    null === N && (N = e2.match(/DingTalk\/([a-zA-Z0-9.-]+)/));
    var k;
    N && N[1] && (k = N[1]);
    var A = "";
    "undefined" != typeof name && (A = name);
    var U = getTopBridge();
    try {
      U && "undefined" != typeof window && void 0 !== window.top && window.top !== window && (A = top.name);
    } catch (e3) {
    }
    if (A)
      try {
        var x = JSON.parse(A);
        x.hostVersion && (k = x.hostVersion), P = x.language || navigator.language || "*", l = x.containerId;
      } catch (e3) {
      }
    var m2 = !!l;
    m2 && !k && (N = e2.match(/DingTalk\(([a-zA-Z0-9\.-]+)\)/)) && N[1] && (k = N[1]);
    var V, M2 = sdk_12.ENV_ENUM_SUB.noSub;
    if ((V = E ? sdk_12.ENV_ENUM.ios : p && !v ? sdk_12.ENV_ENUM.android : v ? sdk_12.ENV_ENUM.harmony : m2 ? sdk_12.ENV_ENUM.pc : U && U.platform ? U.platform : sdk_12.ENV_ENUM.notInDingTalk) === sdk_12.ENV_ENUM.pc) {
      M2 = e2.indexOf("Macintosh; Intel Mac OS") > -1 ? sdk_12.ENV_ENUM_SUB.mac : sdk_12.ENV_ENUM_SUB.win;
    }
    return { platform: V, platformSub: M2, version: k, appType: u, language: P };
  };
  exports.getENV = getENV;
})(env$1);
var log = {};
(function(exports) {
  function padNumber(e2) {
    return e2 = "00" + e2, e2.substring(e2.length - 2, e2.length);
  }
  var __spreadArray2 = commonjsGlobal && commonjsGlobal.__spreadArray || function(e2, t2, r) {
    if (r || 2 === arguments.length)
      for (var o2, a2 = 0, n = t2.length; a2 < n; a2++)
        !o2 && a2 in t2 || (o2 || (o2 = Array.prototype.slice.call(t2, 0, a2)), o2[a2] = t2[a2]);
    return e2.concat(o2 || Array.prototype.slice.call(t2));
  };
  Object.defineProperty(exports, "__esModule", { value: true }), exports.log = void 0;
  var log2 = function(e2) {
    console.log.apply(console, __spreadArray2(["".concat(padNumber(e2.time.getHours()), ":").concat(padNumber(e2.time.getMinutes()), ":").concat(padNumber(e2.time.getSeconds()))], e2.text, false));
  };
  exports.log = log2;
})(log);
var polyfills = {};
(function(module, exports) {
  (function(global2, factory) {
    factory();
  })(commonjsGlobal, function() {
    var setTimeoutFunc = setTimeout;
    function noop2() {
    }
    function bind3(fn2, thisArg) {
      return function() {
        fn2.apply(thisArg, arguments);
      };
    }
    function Promise2(fn2) {
      if (!(this instanceof Promise2))
        throw new TypeError("Promises must be constructed via new");
      if (typeof fn2 !== "function")
        throw new TypeError("not a function");
      this._state = 0;
      this._handled = false;
      this._value = void 0;
      this._deferreds = [];
      doResolve(fn2, this);
    }
    function handle(self2, deferred) {
      while (self2._state === 3) {
        self2 = self2._value;
      }
      if (self2._state === 0) {
        self2._deferreds.push(deferred);
        return;
      }
      self2._handled = true;
      Promise2._immediateFn(function() {
        var cb = self2._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
          (self2._state === 1 ? resolve : reject)(deferred.promise, self2._value);
          return;
        }
        var ret;
        try {
          ret = cb(self2._value);
        } catch (e2) {
          reject(deferred.promise, e2);
          return;
        }
        resolve(deferred.promise, ret);
      });
    }
    function resolve(self2, newValue) {
      try {
        if (newValue === self2)
          throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
          var then = newValue.then;
          if (newValue instanceof Promise2) {
            self2._state = 3;
            self2._value = newValue;
            finale(self2);
            return;
          } else if (typeof then === "function") {
            doResolve(bind3(then, newValue), self2);
            return;
          }
        }
        self2._state = 1;
        self2._value = newValue;
        finale(self2);
      } catch (e2) {
        reject(self2, e2);
      }
    }
    function reject(self2, newValue) {
      self2._state = 2;
      self2._value = newValue;
      finale(self2);
    }
    function finale(self2) {
      if (self2._state === 2 && self2._deferreds.length === 0) {
        Promise2._immediateFn(function() {
          if (!self2._handled) {
            Promise2._unhandledRejectionFn(self2._value);
          }
        });
      }
      for (var i = 0, len = self2._deferreds.length; i < len; i++) {
        handle(self2, self2._deferreds[i]);
      }
      self2._deferreds = null;
    }
    function Handler(onFulfilled, onRejected, promise) {
      this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
      this.onRejected = typeof onRejected === "function" ? onRejected : null;
      this.promise = promise;
    }
    function doResolve(fn2, self2) {
      var done = false;
      try {
        fn2(
          function(value) {
            if (done)
              return;
            done = true;
            resolve(self2, value);
          },
          function(reason) {
            if (done)
              return;
            done = true;
            reject(self2, reason);
          }
        );
      } catch (ex) {
        if (done)
          return;
        done = true;
        reject(self2, ex);
      }
    }
    Promise2.prototype["catch"] = function(onRejected) {
      return this.then(null, onRejected);
    };
    Promise2.prototype.then = function(onFulfilled, onRejected) {
      var prom = new this.constructor(noop2);
      handle(this, new Handler(onFulfilled, onRejected, prom));
      return prom;
    };
    Promise2.prototype["finally"] = function(callback) {
      var constructor = this.constructor;
      return this.then(
        function(value) {
          return constructor.resolve(callback()).then(function() {
            return value;
          });
        },
        function(reason) {
          return constructor.resolve(callback()).then(function() {
            return constructor.reject(reason);
          });
        }
      );
    };
    Promise2.all = function(arr) {
      return new Promise2(function(resolve2, reject2) {
        if (!arr || typeof arr.length === "undefined")
          throw new TypeError("Promise.all accepts an array");
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0)
          return resolve2([]);
        var remaining = args.length;
        function res(i2, val) {
          try {
            if (val && (typeof val === "object" || typeof val === "function")) {
              var then = val.then;
              if (typeof then === "function") {
                then.call(
                  val,
                  function(val2) {
                    res(i2, val2);
                  },
                  reject2
                );
                return;
              }
            }
            args[i2] = val;
            if (--remaining === 0) {
              resolve2(args);
            }
          } catch (ex) {
            reject2(ex);
          }
        }
        for (var i = 0; i < args.length; i++) {
          res(i, args[i]);
        }
      });
    };
    Promise2.resolve = function(value) {
      if (value && typeof value === "object" && value.constructor === Promise2) {
        return value;
      }
      return new Promise2(function(resolve2) {
        resolve2(value);
      });
    };
    Promise2.reject = function(value) {
      return new Promise2(function(resolve2, reject2) {
        reject2(value);
      });
    };
    Promise2.race = function(values) {
      return new Promise2(function(resolve2, reject2) {
        for (var i = 0, len = values.length; i < len; i++) {
          values[i].then(resolve2, reject2);
        }
      });
    };
    Promise2._immediateFn = typeof setImmediate === "function" && function(fn2) {
      setImmediate(fn2);
    } || function(fn2) {
      setTimeoutFunc(fn2, 0);
    };
    Promise2._unhandledRejectionFn = function _unhandledRejectionFn(err) {
      if (typeof console !== "undefined" && console) {
        console.warn("Possible Unhandled Promise Rejection:", err);
      }
    };
    var globalNS = function() {
      if (typeof self !== "undefined") {
        return self;
      }
      if (typeof window !== "undefined") {
        return window;
      }
      if (typeof commonjsGlobal !== "undefined") {
        return commonjsGlobal;
      }
      throw new Error("unable to locate global object");
    }();
    if (!globalNS.Promise) {
      globalNS.Promise = Promise2;
    }
  });
})();
"function" != typeof Object.assign && Object.defineProperty(Object, "assign", { value: function(e2, t2) {
  if (null == e2)
    throw new TypeError("Cannot convert undefined or null to object");
  for (var n = Object(e2), r = 1; r < arguments.length; r++) {
    var o2 = arguments[r];
    if (null != o2)
      for (var c2 in o2)
        Object.prototype.hasOwnProperty.call(o2, c2) && (n[c2] = o2[c2]);
  }
  return n;
}, writable: true, configurable: true });
Object.keys || (Object.keys = function(e2) {
  if (e2 !== Object(e2))
    throw new TypeError("Object.keys called on a non-object");
  var t2, r = [];
  for (t2 in e2)
    Object.prototype.hasOwnProperty.call(e2, t2) && r.push(t2);
  return r;
});
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
})(polyfills);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.ddSdk = exports.ENV_ENUM_SUB = exports.ENV_ENUM = void 0;
  var env_12 = env$1, log_1 = log, env_2 = env$1;
  Object.defineProperty(exports, "ENV_ENUM", { enumerable: true, get: function() {
    return env_2.ENV_ENUM;
  } }), Object.defineProperty(exports, "ENV_ENUM_SUB", { enumerable: true, get: function() {
    return env_2.ENV_ENUM_SUB;
  } });
  var sdk_12 = sdk;
  exports.ddSdk = new sdk_12.Sdk((0, env_12.getENV)(), log_1.log);
})(ddSdk);
var otherApi$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.version = exports.language = exports.compareVersion = exports.other = exports.harmony = exports.pc = exports.android = exports.ios = void 0;
  var env_12 = env$1, ENV = (0, env_12.getENV)();
  exports.ios = ENV.platform === env_12.ENV_ENUM.ios, exports.android = ENV.platform === env_12.ENV_ENUM.android, exports.pc = ENV.platform === env_12.ENV_ENUM.pc, exports.harmony = ENV.platform === env_12.ENV_ENUM.harmony, exports.other = ENV.platform === env_12.ENV_ENUM.notInDingTalk;
  var compareVersion = function(e2, r, o2) {
    function t2(e3) {
      return parseInt(e3, 10) || 0;
    }
    if ("string" != typeof e2 || "string" != typeof r)
      return false;
    for (var n, p, s = e2.split("-")[0].split(".").map(t2), a2 = r.split("-")[0].split(".").map(t2); n === p && a2.length > 0; )
      n = s.shift(), p = a2.shift();
    return o2 ? (p || 0) >= (n || 0) : (p || 0) > (n || 0);
  };
  exports.compareVersion = compareVersion, exports.language = ENV.language, exports.version = ENV.version;
})(otherApi$1);
var ddSdk_1$3 = ddSdk, otherApi = otherApi$1, core = Object.assign({}, otherApi, ddSdk_1$3.ddSdk.getExportSdk());
var core_1 = core;
var platform = {};
var h5Pc = {};
var frameTalkClientPc = { exports: {} };
(function(module, exports) {
  !function(t2, e2) {
    module.exports = e2();
  }(commonjsGlobal, function() {
    return function(t2) {
      function e2(r) {
        if (n[r])
          return n[r].exports;
        var o2 = n[r] = { i: r, l: false, exports: {} };
        return t2[r].call(o2.exports, o2, o2.exports, e2), o2.l = true, o2.exports;
      }
      var n = {};
      return e2.m = t2, e2.c = n, e2.i = function(t3) {
        return t3;
      }, e2.d = function(t3, n2, r) {
        e2.o(t3, n2) || Object.defineProperty(t3, n2, { configurable: false, enumerable: true, get: r });
      }, e2.n = function(t3) {
        var n2 = t3 && t3.__esModule ? function() {
          return t3.default;
        } : function() {
          return t3;
        };
        return e2.d(n2, "a", n2), n2;
      }, e2.o = function(t3, e3) {
        return Object.prototype.hasOwnProperty.call(t3, e3);
      }, e2.p = "", e2(e2.s = 721);
    }({ 199: function(t2, e2, n) {
      var r = n(201);
      t2.exports = r;
    }, 201: function(t2, e2, n) {
      var r = n(203), o2 = n(204), i = n(202), u = n(205), c2 = new i(), a2 = false, s = "", f2 = null, l = {}, p = /{.*}/;
      try {
        var h = window.name.match(p);
        if (h && h[0])
          var l = JSON.parse(h[0]);
      } catch (t3) {
        l = {};
      }
      l.hostOrigin && ".dingtalk.com" === l.hostOrigin.split(":")[1].slice(0 - ".dingtalk.com".length) && l.containerId && (a2 = true, s = l.hostOrigin, f2 = l.containerId);
      var d2 = {}, v = new Promise(function(t3, e3) {
        d2._resolve = t3, d2._reject = e3;
      }), y = {}, _2 = null;
      window.top !== window ? (_2 = window.top, d2._resolve()) : "object" == typeof dingtalk && "object" == typeof dingtalk.platform && "function" == typeof dingtalk.platform.invokeAPI && (_2 = window, d2._resolve()), y[u.SYS_INIT] = function(t3) {
        _2 = t3.frameWindow, d2._resolve(), t3.respond({});
      }, window.addEventListener("message", function(t3) {
        var e3 = t3.data, n2 = t3.origin;
        if (n2 === s) {
          if ("response" === e3.type && e3.msgId) {
            var r2 = e3.msgId, i2 = c2.getMsyById(r2);
            i2 && i2.methodName !== u.SYS_EVENT && i2.receiveResponse(e3.body, !e3.success);
          } else if ("event" === e3.type && e3.msgId) {
            var r2 = e3.msgId, i2 = c2.getMsyById(r2);
            i2 && i2.receiveEvent(e3.eventName, e3.body);
          } else if ("request" === e3.type && e3.msgId) {
            var i2 = new o2(t3.source, n2, e3);
            y[i2.methodName] && y[i2.methodName](i2);
          }
        }
      }), e2.invokeAPI = function(t3, e3) {
        var n2 = new r(f2, t3, e3);
        return a2 && v.then(function() {
          _2 && _2.postMessage(n2.getPayload(), s), c2.addPending(n2);
        }), n2;
      };
      var b2 = null;
      e2.addEventListener = function(t3, n2) {
        b2 || (b2 = e2.invokeAPI(u.SYS_EVENT, {})), b2.addEventListener(t3, n2);
      }, e2.removeEventListener = function(t3, e3) {
        b2 && b2.removeEventListener(t3, e3);
      };
    }, 202: function(t2, e2, n) {
      var r = function() {
        this.pendingMsgs = {};
      };
      r.prototype.addPending = function(t3) {
        this.pendingMsgs[t3.id] = t3;
        var e3 = function() {
          delete this.pendingMsgs[t3.id], t3.removeEventListener("_finish", e3);
        }.bind(this);
        t3.addEventListener("_finish", e3);
      }, r.prototype.getMsyById = function(t3) {
        return this.pendingMsgs[t3];
      }, t2.exports = r;
    }, 203: function(t2, e2, n) {
      var r = n(716), o2 = n(715), i = 0, u = Math.floor(1e3 * Math.random()), c2 = function() {
        return 1e3 * (1e3 * u + Math.floor(1e3 * Math.random())) + ++i % 1e3;
      }, a2 = { code: 408, reason: "timeout" }, s = { TIMEOUT: "_timeout", FINISH: "_finish" }, f2 = { timeout: -1 }, l = function(t3, e3, n2, r2) {
        this.id = c2(), this.methodName = e3, this.containerId = t3, this.option = o2({}, f2, r2);
        var n2 = n2 || {};
        this._p = {}, this.result = new Promise(function(t4, e4) {
          this._p._resolve = t4, this._p._reject = e4;
        }.bind(this)), this.callbacks = {}, this.plainMsg = this._handleMsg(n2), this._eventsHandle = {}, this._timeoutTimer = null, this._initTimeout(), this.isFinish = false;
      };
      l.prototype._initTimeout = function() {
        this._clearTimeout(), this.option.timeout > 0 && (this._timeoutTimer = setTimeout(function() {
          this.receiveEvent(s.TIMEOUT), this.receiveResponse(a2, true);
        }.bind(this), this.option.timeout));
      }, l.prototype._clearTimeout = function() {
        clearTimeout(this._timeoutTimer);
      }, l.prototype._handleMsg = function(t3) {
        var e3 = {};
        return Object.keys(t3).forEach(function(n2) {
          var o3 = t3[n2];
          "function" == typeof o3 && "on" === n2.slice(0, 2) ? this.callbacks[n2] = o3 : e3[n2] = r(o3);
        }.bind(this)), e3;
      }, l.prototype.getPayload = function() {
        return { msgId: this.id, containerId: this.containerId, methodName: this.methodName, body: this.plainMsg, type: "request" };
      }, l.prototype.receiveEvent = function(t3, e3) {
        if (this.isFinish && t3 !== s.FINISH)
          return false;
        t3 !== s.FINISH && t3 !== s.TIMEOUT && this._initTimeout(), Array.isArray(this._eventsHandle[t3]) && this._eventsHandle[t3].forEach(function(t4) {
          try {
            t4(e3);
          } catch (t5) {
            console.error(e3);
          }
        });
        var n2 = "on" + t3.charAt(0).toUpperCase() + t3.slice(1);
        return this.callbacks[n2] && this.callbacks[n2](e3), true;
      }, l.prototype.addEventListener = function(t3, e3) {
        if (!t3 || "function" != typeof e3)
          throw "eventName is null or handle is not a function, addEventListener fail";
        Array.isArray(this._eventsHandle[t3]) || (this._eventsHandle[t3] = []), this._eventsHandle[t3].push(e3);
      }, l.prototype.removeEventListener = function(t3, e3) {
        if (!t3 || !e3)
          throw "eventName is null or handle is null, invoke removeEventListener fail";
        if (Array.isArray(this._eventsHandle[t3])) {
          var n2 = this._eventsHandle[t3].indexOf(e3);
          -1 !== n2 && this._eventsHandle[t3].splice(n2, 1);
        }
      }, l.prototype.receiveResponse = function(t3, e3) {
        if (true === this.isFinish)
          return false;
        this._clearTimeout();
        var e3 = !!e3;
        return e3 ? this._p._reject(t3) : this._p._resolve(t3), setTimeout(function() {
          this.receiveEvent(s.FINISH);
        }.bind(this), 0), this.isFinish = true, true;
      }, t2.exports = l;
    }, 204: function(t2, e2, n) {
      var r = function(t3, e3, n2) {
        if (this._msgId = n2.msgId, this.frameWindow = t3, this.methodName = n2.methodName, this.clientOrigin = e3, this.containerId = n2.containerId, this.params = n2.body, !this._msgId)
          throw "msgId not exist";
        if (!this.frameWindow)
          throw "frameWindow not exist";
        if (!this.methodName)
          throw "methodName not exits";
        if (!this.clientOrigin)
          throw "clientOrigin not exist";
        this.hasResponded = false;
      };
      r.prototype.respond = function(t3, e3) {
        var e3 = !!e3;
        if (true !== this.hasResponded) {
          var n2 = { type: "response", success: !e3, body: t3, msgId: this._msgId };
          this.frameWindow.postMessage(n2, this.clientOrigin), this.hasResponded = true;
        }
      }, r.prototype.emit = function(t3, e3) {
        var n2 = { type: "event", eventName: t3, body: e3, msgId: this._msgId };
        this.frameWindow.postMessage(n2, this.clientOrigin);
      }, t2.exports = r;
    }, 205: function(t2, e2, n) {
      t2.exports = { SYS_EVENT: "SYS_openAPIContainerInitEvent", SYS_INIT: "SYS_openAPIContainerInit" };
    }, 4: function(t2, e2) {
      var n;
      n = function() {
        return this;
      }();
      try {
        n = n || Function("return this")() || (0, eval)("this");
      } catch (t3) {
        "object" == typeof window && (n = window);
      }
      t2.exports = n;
    }, 714: function(t2, e2, n) {
      (function(t3, n2) {
        function r(t4, e3) {
          return t4.set(e3[0], e3[1]), t4;
        }
        function o2(t4, e3) {
          return t4.add(e3), t4;
        }
        function i(t4, e3) {
          for (var n3 = -1, r2 = t4.length; ++n3 < r2 && false !== e3(t4[n3], n3, t4); )
            ;
          return t4;
        }
        function u(t4, e3) {
          for (var n3 = -1, r2 = e3.length, o3 = t4.length; ++n3 < r2; )
            t4[o3 + n3] = e3[n3];
          return t4;
        }
        function c2(t4, e3, n3, r2) {
          var o3 = -1, i2 = t4.length;
          for (r2 && i2 && (n3 = t4[++o3]); ++o3 < i2; )
            n3 = e3(n3, t4[o3], o3, t4);
          return n3;
        }
        function a2(t4, e3) {
          for (var n3 = -1, r2 = Array(t4); ++n3 < t4; )
            r2[n3] = e3(n3);
          return r2;
        }
        function s(t4) {
          return t4 && t4.Object === Object ? t4 : null;
        }
        function f2(t4) {
          var e3 = false;
          if (null != t4 && "function" != typeof t4.toString)
            try {
              e3 = !!(t4 + "");
            } catch (t5) {
            }
          return e3;
        }
        function l(t4) {
          var e3 = -1, n3 = Array(t4.size);
          return t4.forEach(function(t5, r2) {
            n3[++e3] = [r2, t5];
          }), n3;
        }
        function p(t4) {
          var e3 = -1, n3 = Array(t4.size);
          return t4.forEach(function(t5) {
            n3[++e3] = t5;
          }), n3;
        }
        function h(t4) {
          var e3 = -1, n3 = t4 ? t4.length : 0;
          for (this.clear(); ++e3 < n3; ) {
            var r2 = t4[e3];
            this.set(r2[0], r2[1]);
          }
        }
        function d2() {
          this.__data__ = ke ? ke(null) : {};
        }
        function v(t4) {
          return this.has(t4) && delete this.__data__[t4];
        }
        function y(t4) {
          var e3 = this.__data__;
          if (ke) {
            var n3 = e3[t4];
            return n3 === St ? void 0 : n3;
          }
          return ye.call(e3, t4) ? e3[t4] : void 0;
        }
        function _2(t4) {
          var e3 = this.__data__;
          return ke ? void 0 !== e3[t4] : ye.call(e3, t4);
        }
        function b2(t4, e3) {
          return this.__data__[t4] = ke && void 0 === e3 ? St : e3, this;
        }
        function g(t4) {
          var e3 = -1, n3 = t4 ? t4.length : 0;
          for (this.clear(); ++e3 < n3; ) {
            var r2 = t4[e3];
            this.set(r2[0], r2[1]);
          }
        }
        function m2() {
          this.__data__ = [];
        }
        function j(t4) {
          var e3 = this.__data__, n3 = W(e3, t4);
          return !(n3 < 0 || (n3 == e3.length - 1 ? e3.pop() : xe.call(e3, n3, 1), 0));
        }
        function w(t4) {
          var e3 = this.__data__, n3 = W(e3, t4);
          return n3 < 0 ? void 0 : e3[n3][1];
        }
        function I(t4) {
          return W(this.__data__, t4) > -1;
        }
        function O(t4, e3) {
          var n3 = this.__data__, r2 = W(n3, t4);
          return r2 < 0 ? n3.push([t4, e3]) : n3[r2][1] = e3, this;
        }
        function x(t4) {
          var e3 = -1, n3 = t4 ? t4.length : 0;
          for (this.clear(); ++e3 < n3; ) {
            var r2 = t4[e3];
            this.set(r2[0], r2[1]);
          }
        }
        function A() {
          this.__data__ = { hash: new h(), map: new (Me || g)(), string: new h() };
        }
        function E(t4) {
          return rt(this, t4).delete(t4);
        }
        function S(t4) {
          return rt(this, t4).get(t4);
        }
        function M2(t4) {
          return rt(this, t4).has(t4);
        }
        function N(t4, e3) {
          return rt(this, t4).set(t4, e3), this;
        }
        function P(t4) {
          this.__data__ = new g(t4);
        }
        function T() {
          this.__data__ = new g();
        }
        function k(t4) {
          return this.__data__.delete(t4);
        }
        function F(t4) {
          return this.__data__.get(t4);
        }
        function H(t4) {
          return this.__data__.has(t4);
        }
        function L(t4, e3) {
          var n3 = this.__data__;
          return n3 instanceof g && n3.__data__.length == Et && (n3 = this.__data__ = new x(n3.__data__)), n3.set(t4, e3), this;
        }
        function $(t4, e3, n3) {
          var r2 = t4[e3];
          ye.call(t4, e3) && yt(r2, n3) && (void 0 !== n3 || e3 in t4) || (t4[e3] = n3);
        }
        function W(t4, e3) {
          for (var n3 = t4.length; n3--; )
            if (yt(t4[n3][0], e3))
              return n3;
          return -1;
        }
        function U(t4, e3) {
          return t4 && tt(e3, At(e3), t4);
        }
        function R(t4, e3, n3, r2, o3, u2, c3) {
          var a3;
          if (r2 && (a3 = u2 ? r2(t4, o3, u2, c3) : r2(t4)), void 0 !== a3)
            return a3;
          if (!wt(t4))
            return t4;
          var s2 = Ye(t4);
          if (s2) {
            if (a3 = at(t4), !e3)
              return Z(t4, a3);
          } else {
            var l2 = ct(t4), p2 = l2 == kt || l2 == Ft;
            if (Ce(t4))
              return D(t4, e3);
            if (l2 == $t || l2 == Nt || p2 && !u2) {
              if (f2(t4))
                return u2 ? t4 : {};
              if (a3 = st2(p2 ? {} : t4), !e3)
                return et2(t4, U(a3, t4));
            } else {
              if (!re2[l2])
                return u2 ? t4 : {};
              a3 = ft(t4, l2, R, e3);
            }
          }
          c3 || (c3 = new P());
          var h2 = c3.get(t4);
          if (h2)
            return h2;
          if (c3.set(t4, a3), !s2)
            var d3 = n3 ? nt(t4) : At(t4);
          return i(d3 || t4, function(o4, i2) {
            d3 && (i2 = o4, o4 = t4[i2]), $(a3, i2, R(o4, e3, n3, r2, i2, t4, c3));
          }), a3;
        }
        function B(t4) {
          return wt(t4) ? Ie(t4) : {};
        }
        function Y(t4, e3, n3) {
          var r2 = e3(t4);
          return Ye(t4) ? r2 : u(r2, n3(t4));
        }
        function C(t4, e3) {
          return ye.call(t4, e3) || "object" == typeof t4 && e3 in t4 && null === it2(t4);
        }
        function V(t4) {
          return Ee(Object(t4));
        }
        function D(t4, e3) {
          if (e3)
            return t4.slice();
          var n3 = new t4.constructor(t4.length);
          return t4.copy(n3), n3;
        }
        function G(t4) {
          var e3 = new t4.constructor(t4.byteLength);
          return new je(e3).set(new je(t4)), e3;
        }
        function q(t4, e3) {
          var n3 = e3 ? G(t4.buffer) : t4.buffer;
          return new t4.constructor(n3, t4.byteOffset, t4.byteLength);
        }
        function z(t4, e3, n3) {
          return c2(e3 ? n3(l(t4), true) : l(t4), r, new t4.constructor());
        }
        function J(t4) {
          var e3 = new t4.constructor(t4.source, te2.exec(t4));
          return e3.lastIndex = t4.lastIndex, e3;
        }
        function K(t4, e3, n3) {
          return c2(e3 ? n3(p(t4), true) : p(t4), o2, new t4.constructor());
        }
        function Q(t4) {
          return Re ? Object(Re.call(t4)) : {};
        }
        function X(t4, e3) {
          var n3 = e3 ? G(t4.buffer) : t4.buffer;
          return new t4.constructor(n3, t4.byteOffset, t4.length);
        }
        function Z(t4, e3) {
          var n3 = -1, r2 = t4.length;
          for (e3 || (e3 = Array(r2)); ++n3 < r2; )
            e3[n3] = t4[n3];
          return e3;
        }
        function tt(t4, e3, n3, r2) {
          n3 || (n3 = {});
          for (var o3 = -1, i2 = e3.length; ++o3 < i2; ) {
            var u2 = e3[o3];
            $(n3, u2, r2 ? r2(n3[u2], t4[u2], u2, n3, t4) : t4[u2]);
          }
          return n3;
        }
        function et2(t4, e3) {
          return tt(t4, ut2(t4), e3);
        }
        function nt(t4) {
          return Y(t4, At, ut2);
        }
        function rt(t4, e3) {
          var n3 = t4.__data__;
          return ht(e3) ? n3["string" == typeof e3 ? "string" : "hash"] : n3.map;
        }
        function ot(t4, e3) {
          var n3 = t4[e3];
          return Ot(n3) ? n3 : void 0;
        }
        function it2(t4) {
          return Ae(Object(t4));
        }
        function ut2(t4) {
          return we(Object(t4));
        }
        function ct(t4) {
          return _e.call(t4);
        }
        function at(t4) {
          var e3 = t4.length, n3 = t4.constructor(e3);
          return e3 && "string" == typeof t4[0] && ye.call(t4, "index") && (n3.index = t4.index, n3.input = t4.input), n3;
        }
        function st2(t4) {
          return "function" != typeof t4.constructor || dt(t4) ? {} : B(it2(t4));
        }
        function ft(t4, e3, n3, r2) {
          var o3 = t4.constructor;
          switch (e3) {
            case Yt:
              return G(t4);
            case Pt:
            case Tt:
              return new o3(+t4);
            case Ct:
              return q(t4, r2);
            case Vt:
            case Dt:
            case Gt:
            case qt:
            case zt:
            case Jt:
            case Kt:
            case Qt:
            case Xt:
              return X(t4, r2);
            case Ht:
              return z(t4, r2, n3);
            case Lt:
            case Rt:
              return new o3(t4);
            case Wt:
              return J(t4);
            case Ut:
              return K(t4, r2, n3);
            case Bt:
              return Q(t4);
          }
        }
        function lt2(t4) {
          var e3 = t4 ? t4.length : void 0;
          return jt(e3) && (Ye(t4) || xt(t4) || _t(t4)) ? a2(e3, String) : null;
        }
        function pt2(t4, e3) {
          return !!(e3 = null == e3 ? Mt : e3) && ("number" == typeof t4 || ne2.test(t4)) && t4 > -1 && t4 % 1 == 0 && t4 < e3;
        }
        function ht(t4) {
          var e3 = typeof t4;
          return "string" == e3 || "number" == e3 || "symbol" == e3 || "boolean" == e3 ? "__proto__" !== t4 : null === t4;
        }
        function dt(t4) {
          var e3 = t4 && t4.constructor;
          return t4 === ("function" == typeof e3 && e3.prototype || de2);
        }
        function vt(t4) {
          if (null != t4) {
            try {
              return ve2.call(t4);
            } catch (t5) {
            }
            try {
              return t4 + "";
            } catch (t5) {
            }
          }
          return "";
        }
        function yt(t4, e3) {
          return t4 === e3 || t4 !== t4 && e3 !== e3;
        }
        function _t(t4) {
          return gt2(t4) && ye.call(t4, "callee") && (!Oe.call(t4, "callee") || _e.call(t4) == Nt);
        }
        function bt(t4) {
          return null != t4 && jt(Be(t4)) && !mt2(t4);
        }
        function gt2(t4) {
          return It(t4) && bt(t4);
        }
        function mt2(t4) {
          var e3 = wt(t4) ? _e.call(t4) : "";
          return e3 == kt || e3 == Ft;
        }
        function jt(t4) {
          return "number" == typeof t4 && t4 > -1 && t4 % 1 == 0 && t4 <= Mt;
        }
        function wt(t4) {
          var e3 = typeof t4;
          return !!t4 && ("object" == e3 || "function" == e3);
        }
        function It(t4) {
          return !!t4 && "object" == typeof t4;
        }
        function Ot(t4) {
          return !!wt(t4) && (mt2(t4) || f2(t4) ? be2 : ee2).test(vt(t4));
        }
        function xt(t4) {
          return "string" == typeof t4 || !Ye(t4) && It(t4) && _e.call(t4) == Rt;
        }
        function At(t4) {
          var e3 = dt(t4);
          if (!e3 && !bt(t4))
            return V(t4);
          var n3 = lt2(t4), r2 = !!n3, o3 = n3 || [], i2 = o3.length;
          for (var u2 in t4)
            !C(t4, u2) || r2 && ("length" == u2 || pt2(u2, i2)) || e3 && "constructor" == u2 || o3.push(u2);
          return o3;
        }
        var Et = 200, St = "__lodash_hash_undefined__", Mt = 9007199254740991, Nt = "[object Arguments]", Pt = "[object Boolean]", Tt = "[object Date]", kt = "[object Function]", Ft = "[object GeneratorFunction]", Ht = "[object Map]", Lt = "[object Number]", $t = "[object Object]", Wt = "[object RegExp]", Ut = "[object Set]", Rt = "[object String]", Bt = "[object Symbol]", Yt = "[object ArrayBuffer]", Ct = "[object DataView]", Vt = "[object Float32Array]", Dt = "[object Float64Array]", Gt = "[object Int8Array]", qt = "[object Int16Array]", zt = "[object Int32Array]", Jt = "[object Uint8Array]", Kt = "[object Uint8ClampedArray]", Qt = "[object Uint16Array]", Xt = "[object Uint32Array]", Zt = /[\\^$.*+?()[\]{}|]/g, te2 = /\w*$/, ee2 = /^\[object .+?Constructor\]$/, ne2 = /^(?:0|[1-9]\d*)$/, re2 = {};
        re2[Nt] = re2["[object Array]"] = re2[Yt] = re2[Ct] = re2[Pt] = re2[Tt] = re2[Vt] = re2[Dt] = re2[Gt] = re2[qt] = re2[zt] = re2[Ht] = re2[Lt] = re2[$t] = re2[Wt] = re2[Ut] = re2[Rt] = re2[Bt] = re2[Jt] = re2[Kt] = re2[Qt] = re2[Xt] = true, re2["[object Error]"] = re2[kt] = re2["[object WeakMap]"] = false;
        var oe = { function: true, object: true }, ie = oe[typeof e2] && e2 && !e2.nodeType ? e2 : void 0, ue = oe[typeof t3] && t3 && !t3.nodeType ? t3 : void 0, ce2 = ue && ue.exports === ie ? ie : void 0, ae = s(ie && ue && "object" == typeof n2 && n2), se2 = s(oe[typeof self] && self), fe = s(oe[typeof window] && window), le = s(oe[typeof this] && this), pe = ae || fe !== (le && le.window) && fe || se2 || le || Function("return this")(), he2 = Array.prototype, de2 = Object.prototype, ve2 = Function.prototype.toString, ye = de2.hasOwnProperty, _e = de2.toString, be2 = RegExp("^" + ve2.call(ye).replace(Zt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), ge = ce2 ? pe.Buffer : void 0, me = pe.Symbol, je = pe.Uint8Array, we = Object.getOwnPropertySymbols, Ie = Object.create, Oe = de2.propertyIsEnumerable, xe = he2.splice, Ae = Object.getPrototypeOf, Ee = Object.keys, Se = ot(pe, "DataView"), Me = ot(pe, "Map"), Ne = ot(pe, "Promise"), Pe = ot(pe, "Set"), Te = ot(pe, "WeakMap"), ke = ot(Object, "create"), Fe = vt(Se), He = vt(Me), Le = vt(Ne), $e2 = vt(Pe), We = vt(Te), Ue = me ? me.prototype : void 0, Re = Ue ? Ue.valueOf : void 0;
        h.prototype.clear = d2, h.prototype.delete = v, h.prototype.get = y, h.prototype.has = _2, h.prototype.set = b2, g.prototype.clear = m2, g.prototype.delete = j, g.prototype.get = w, g.prototype.has = I, g.prototype.set = O, x.prototype.clear = A, x.prototype.delete = E, x.prototype.get = S, x.prototype.has = M2, x.prototype.set = N, P.prototype.clear = T, P.prototype.delete = k, P.prototype.get = F, P.prototype.has = H, P.prototype.set = L;
        var Be = function(t4) {
          return function(t5) {
            return null == t5 ? void 0 : t5.length;
          };
        }();
        we || (ut2 = function() {
          return [];
        }), (Se && ct(new Se(new ArrayBuffer(1))) != Ct || Me && ct(new Me()) != Ht || Ne && "[object Promise]" != ct(Ne.resolve()) || Pe && ct(new Pe()) != Ut || Te && "[object WeakMap]" != ct(new Te())) && (ct = function(t4) {
          var e3 = _e.call(t4), n3 = e3 == $t ? t4.constructor : void 0, r2 = n3 ? vt(n3) : void 0;
          if (r2)
            switch (r2) {
              case Fe:
                return Ct;
              case He:
                return Ht;
              case Le:
                return "[object Promise]";
              case $e2:
                return Ut;
              case We:
                return "[object WeakMap]";
            }
          return e3;
        });
        var Ye = Array.isArray, Ce = ge ? function(t4) {
          return t4 instanceof ge;
        } : function(t4) {
          return function() {
            return false;
          };
        }();
        t3.exports = R;
      }).call(e2, n(719)(t2), n(4));
    }, 715: function(t2, e2, n) {
      function r(t3, e3, n2) {
        var r2 = t3[e3];
        m2.call(t3, e3) && a2(r2, n2) && (void 0 !== n2 || e3 in t3) || (t3[e3] = n2);
      }
      function o2(t3, e3, n2, o3) {
        n2 || (n2 = {});
        for (var i2 = -1, u2 = e3.length; ++i2 < u2; ) {
          var c3 = e3[i2];
          r(n2, c3, o3 ? o3(n2[c3], t3[c3], c3, n2, t3) : t3[c3]);
        }
        return n2;
      }
      function i(t3, e3) {
        return !!(e3 = null == e3 ? v : e3) && ("number" == typeof t3 || b2.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < e3;
      }
      function u(t3, e3, n2) {
        if (!p(n2))
          return false;
        var r2 = typeof e3;
        return !!("number" == r2 ? s(n2) && i(e3, n2.length) : "string" == r2 && e3 in n2) && a2(n2[e3], t3);
      }
      function c2(t3) {
        var e3 = t3 && t3.constructor;
        return t3 === ("function" == typeof e3 && e3.prototype || g);
      }
      function a2(t3, e3) {
        return t3 === e3 || t3 !== t3 && e3 !== e3;
      }
      function s(t3) {
        return null != t3 && l(O(t3)) && !f2(t3);
      }
      function f2(t3) {
        var e3 = p(t3) ? j.call(t3) : "";
        return e3 == y || e3 == _2;
      }
      function l(t3) {
        return "number" == typeof t3 && t3 > -1 && t3 % 1 == 0 && t3 <= v;
      }
      function p(t3) {
        var e3 = typeof t3;
        return !!t3 && ("object" == e3 || "function" == e3);
      }
      var h = n(717), d2 = n(718), v = 9007199254740991, y = "[object Function]", _2 = "[object GeneratorFunction]", b2 = /^(?:0|[1-9]\d*)$/, g = Object.prototype, m2 = g.hasOwnProperty, j = g.toString, w = g.propertyIsEnumerable, I = !w.call({ valueOf: 1 }, "valueOf"), O = function(t3) {
        return function(t4) {
          return null == t4 ? void 0 : t4.length;
        };
      }(), x = function(t3) {
        return d2(function(e3, n2) {
          var r2 = -1, o3 = n2.length, i2 = o3 > 1 ? n2[o3 - 1] : void 0, c3 = o3 > 2 ? n2[2] : void 0;
          for (i2 = t3.length > 3 && "function" == typeof i2 ? (o3--, i2) : void 0, c3 && u(n2[0], n2[1], c3) && (i2 = o3 < 3 ? void 0 : i2, o3 = 1), e3 = Object(e3); ++r2 < o3; ) {
            var a3 = n2[r2];
            a3 && t3(e3, a3);
          }
          return e3;
        });
      }(function(t3, e3) {
        if (I || c2(e3) || s(e3))
          return void o2(e3, h(e3), t3);
        for (var n2 in e3)
          m2.call(e3, n2) && r(t3, n2, e3[n2]);
      });
      t2.exports = x;
    }, 716: function(t2, e2, n) {
      function r(t3) {
        return o2(t3, true, true);
      }
      var o2 = n(714);
      t2.exports = r;
    }, 717: function(t2, e2) {
      function n(t3, e3) {
        for (var n2 = -1, r2 = Array(t3); ++n2 < t3; )
          r2[n2] = e3(n2);
        return r2;
      }
      function r(t3, e3) {
        var r2 = x(t3) || c2(t3) ? n(t3.length, String) : [], o3 = r2.length, u2 = !!o3;
        for (var a3 in t3)
          !e3 && !j.call(t3, a3) || u2 && ("length" == a3 || i(a3, o3)) || r2.push(a3);
        return r2;
      }
      function o2(t3) {
        if (!u(t3))
          return O(t3);
        var e3 = [];
        for (var n2 in Object(t3))
          j.call(t3, n2) && "constructor" != n2 && e3.push(n2);
        return e3;
      }
      function i(t3, e3) {
        return !!(e3 = null == e3 ? v : e3) && ("number" == typeof t3 || g.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < e3;
      }
      function u(t3) {
        var e3 = t3 && t3.constructor;
        return t3 === ("function" == typeof e3 && e3.prototype || m2);
      }
      function c2(t3) {
        return s(t3) && j.call(t3, "callee") && (!I.call(t3, "callee") || w.call(t3) == y);
      }
      function a2(t3) {
        return null != t3 && l(t3.length) && !f2(t3);
      }
      function s(t3) {
        return h(t3) && a2(t3);
      }
      function f2(t3) {
        var e3 = p(t3) ? w.call(t3) : "";
        return e3 == _2 || e3 == b2;
      }
      function l(t3) {
        return "number" == typeof t3 && t3 > -1 && t3 % 1 == 0 && t3 <= v;
      }
      function p(t3) {
        var e3 = typeof t3;
        return !!t3 && ("object" == e3 || "function" == e3);
      }
      function h(t3) {
        return !!t3 && "object" == typeof t3;
      }
      function d2(t3) {
        return a2(t3) ? r(t3) : o2(t3);
      }
      var v = 9007199254740991, y = "[object Arguments]", _2 = "[object Function]", b2 = "[object GeneratorFunction]", g = /^(?:0|[1-9]\d*)$/, m2 = Object.prototype, j = m2.hasOwnProperty, w = m2.toString, I = m2.propertyIsEnumerable, O = function(t3, e3) {
        return function(n2) {
          return t3(e3(n2));
        };
      }(Object.keys, Object), x = Array.isArray;
      t2.exports = d2;
    }, 718: function(t2, e2) {
      function n(t3, e3, n2) {
        switch (n2.length) {
          case 0:
            return t3.call(e3);
          case 1:
            return t3.call(e3, n2[0]);
          case 2:
            return t3.call(e3, n2[0], n2[1]);
          case 3:
            return t3.call(e3, n2[0], n2[1], n2[2]);
        }
        return t3.apply(e3, n2);
      }
      function r(t3, e3) {
        return e3 = I(void 0 === e3 ? t3.length - 1 : e3, 0), function() {
          for (var r2 = arguments, o3 = -1, i2 = I(r2.length - e3, 0), u2 = Array(i2); ++o3 < i2; )
            u2[o3] = r2[e3 + o3];
          o3 = -1;
          for (var c3 = Array(e3 + 1); ++o3 < e3; )
            c3[o3] = r2[o3];
          return c3[e3] = u2, n(t3, this, c3);
        };
      }
      function o2(t3, e3) {
        if ("function" != typeof t3)
          throw new TypeError(l);
        return e3 = void 0 === e3 ? e3 : s(e3), r(t3, e3);
      }
      function i(t3) {
        var e3 = typeof t3;
        return !!t3 && ("object" == e3 || "function" == e3);
      }
      function u(t3) {
        return !!t3 && "object" == typeof t3;
      }
      function c2(t3) {
        return "symbol" == typeof t3 || u(t3) && w.call(t3) == v;
      }
      function a2(t3) {
        return t3 ? (t3 = f2(t3)) === p || t3 === -p ? (t3 < 0 ? -1 : 1) * h : t3 === t3 ? t3 : 0 : 0 === t3 ? t3 : 0;
      }
      function s(t3) {
        var e3 = a2(t3), n2 = e3 % 1;
        return e3 === e3 ? n2 ? e3 - n2 : e3 : 0;
      }
      function f2(t3) {
        if ("number" == typeof t3)
          return t3;
        if (c2(t3))
          return d2;
        if (i(t3)) {
          var e3 = "function" == typeof t3.valueOf ? t3.valueOf() : t3;
          t3 = i(e3) ? e3 + "" : e3;
        }
        if ("string" != typeof t3)
          return 0 === t3 ? t3 : +t3;
        t3 = t3.replace(y, "");
        var n2 = b2.test(t3);
        return n2 || g.test(t3) ? m2(t3.slice(2), n2 ? 2 : 8) : _2.test(t3) ? d2 : +t3;
      }
      var l = "Expected a function", p = 1 / 0, h = 17976931348623157e292, d2 = NaN, v = "[object Symbol]", y = /^\s+|\s+$/g, _2 = /^[-+]0x[0-9a-f]+$/i, b2 = /^0b[01]+$/i, g = /^0o[0-7]+$/i, m2 = parseInt, j = Object.prototype, w = j.toString, I = Math.max;
      t2.exports = o2;
    }, 719: function(t2, e2) {
      t2.exports = function(t3) {
        return t3.webpackPolyfill || (t3.deprecate = function() {
        }, t3.paths = [], t3.children || (t3.children = []), Object.defineProperty(t3, "loaded", { enumerable: true, get: function() {
          return t3.l;
        } }), Object.defineProperty(t3, "id", { enumerable: true, get: function() {
          return t3.i;
        } }), t3.webpackPolyfill = 1), t3;
      };
    }, 721: function(t2, e2, n) {
      t2.exports = n(199);
    } });
  });
})(frameTalkClientPc);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.h5PcBridgeInit = void 0;
  var h5PcBridgeInit = function() {
    return Promise.resolve(frameTalkClientPc.exports);
  };
  exports.h5PcBridgeInit = h5PcBridgeInit;
  var h5PcBridge = function(e2, n) {
    return new Promise(function(r, t2) {
      return frameTalkClientPc.exports.invokeAPI(e2, n).result.then(function(e3) {
        return "function" == typeof n.onSuccess && n.onSuccess.call(null, e3), r(e3);
      }, function(e3) {
        return "function" == typeof n.onFail && n.onFail.call(null, e3), t2(e3);
      });
    });
  };
  exports.default = h5PcBridge;
})(h5Pc);
var eapp = {};
Object.defineProperty(eapp, "__esModule", { value: true });
var eappBridge = function(e2, n) {
  return new Promise(function(o2, t2) {
    dd.dtBridge({ m: e2, args: n, onSuccess: function(e3) {
      "function" == typeof n.onSuccess && n.onSuccess(e3), o2(e3);
    }, onFail: function(e3) {
      "function" == typeof n.onFail && n.onFail(e3), t2(e3);
    } });
  });
};
eapp.default = eappBridge;
var h5PcEvent = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.off = exports.on = void 0;
  var on2 = function(e2, o2) {
    frameTalkClientPc.exports.addEventListener(e2, o2);
  };
  exports.on = on2;
  var off = function(e2, o2) {
    frameTalkClientPc.exports.removeEventListener(e2, o2);
  };
  exports.off = off;
})(h5PcEvent);
var ddSdk_1$2 = ddSdk, env_1$2 = env$1, h5Pc_1 = h5Pc, eapp_1$2 = eapp, sdk_1$2 = sdk, h5PcEvent_1 = h5PcEvent;
ddSdk_1$2.ddSdk.setPlatform({ platform: env_1$2.ENV_ENUM.pc, bridgeInit: function() {
  switch ((0, env_1$2.getENV)().appType) {
    case sdk_1$2.APP_TYPE.MINI_APP:
      return Promise.resolve(eapp_1$2.default);
    default:
      return (0, h5Pc_1.h5PcBridgeInit)().then(function() {
        return h5Pc_1.default;
      });
  }
}, authMethod: "config", authParamsDeal: function(e2) {
  var r = Object.assign({}, e2);
  return r.url = window.location.href.split("#")[0], r;
}, event: { on: function(e2, r) {
  if ((0, env_1$2.getENV)().appType === sdk_1$2.APP_TYPE.WEB)
    return (0, h5PcEvent_1.on)(e2, r);
}, off: function(e2, r) {
  if ((0, env_1$2.getENV)().appType === sdk_1$2.APP_TYPE.WEB)
    return (0, h5PcEvent_1.off)(e2, r);
} } });
var webviewInMiniApp = {};
Object.defineProperty(webviewInMiniApp, "__esModule", { value: true });
var noop = function() {
}, webviewInMiniappBridge = function(e2, n) {
  return new Promise(function(r, i) {
    var o2 = n.onSuccess || noop, a2 = n.onFail || noop;
    if (delete n.onSuccess, delete n.onFail, AlipayJSBridge) {
      var p = e2.split("."), l = p.pop() || "", t2 = p.join(".");
      AlipayJSBridge.call.apply(null, ["webDdExec", { serviceName: t2, actionName: l, args: n }, function(e3) {
        var n2 = {}, p2 = e3.content;
        if (p2)
          try {
            n2 = JSON.parse(p2);
          } catch (e4) {
            console.error("parse dt api result error", p2, e4);
          }
        e3.success ? (o2.apply(null, [n2]), r(n2)) : (a2.apply(null, [n2]), i(n2));
      }]);
    } else {
      var c2 = new Error("Fatal error, cannot find bridge ,current env is WebView in MiniApp");
      a2(c2), i(c2);
    }
  });
};
webviewInMiniApp.default = webviewInMiniappBridge;
var h5Android = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.h5AndroidbridgeInit = void 0;
  var h5BridgeReadyPromise, h5AndroidbridgeInit = function() {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = new Promise(function(e2, i) {
      var n = function() {
        try {
          window.WebViewJavascriptBridgeAndroid = window.nuva && window.nuva.require(), e2({});
        } catch (e3) {
          i(e3);
        }
      };
      window.nuva && (void 0 === window.nuva.isReady || window.nuva.isReady) ? n() : (document.addEventListener("runtimeready", function() {
        n();
      }, false), document.addEventListener("runtimefailed", function(e3) {
        var n2 = e3 && e3.detail || { errorCode: "2", errorMessage: "unknown nuvajs bootstrap error" };
        i(n2);
      }, false));
    })), h5BridgeReadyPromise;
  };
  exports.h5AndroidbridgeInit = h5AndroidbridgeInit;
  var h5AndroidBridge = function(e2, i) {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = (0, exports.h5AndroidbridgeInit)()), h5BridgeReadyPromise.then(function() {
      return new Promise(function(n, r) {
        var d2 = e2.split("."), o2 = d2.pop() || "", t2 = d2.join("."), a2 = function(e3) {
          "function" == typeof i.onSuccess && i.onSuccess(e3), n(e3);
        }, u = function(e3) {
          "function" == typeof i.onFail && i.onFail(e3), r(e3);
        };
        "function" == typeof window.WebViewJavascriptBridgeAndroid && window.WebViewJavascriptBridgeAndroid(a2, u, t2, o2, i);
      });
    });
  };
  exports.default = h5AndroidBridge;
})(h5Android);
var weex$1 = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.androidWeexBridge = exports.iosWeexBridge = exports.requireModule = void 0;
  var STATUS_OK = 1, WEEX_IOS_BIZ_SUCCESS_CODE = "0", requireModule = function(e2) {
    return "undefined" != typeof __weex_require__ ? __weex_require__("@weex-module/".concat(e2)) : "undefined" != typeof weex ? weex.requireModule(e2) : void 0;
  };
  exports.requireModule = requireModule;
  var iosWeexBridge = function() {
    return Promise.resolve(function(e2, r) {
      return new Promise(function(o2, i) {
        var n = (0, exports.requireModule)("nuvajs-exec"), s = e2.split("."), t2 = s.pop(), u = s.join(".");
        n.exec({ plugin: u, action: t2, args: r }, function(e3) {
          e3 && e3.errorCode === WEEX_IOS_BIZ_SUCCESS_CODE ? ("function" == typeof r.onSuccess && r.onSuccess(e3.result), o2(e3.result)) : ("function" == typeof r.onFail && r.onFail(e3.result), i(e3.result));
        });
      });
    });
  };
  exports.iosWeexBridge = iosWeexBridge;
  var androidWeexBridge = function() {
    return Promise.resolve(function(e2, r) {
      return new Promise(function(o2, i) {
        var n = (0, exports.requireModule)("nuvajs-exec"), s = e2.split("."), t2 = s.pop(), u = s.join(".");
        n.exec({ plugin: u, action: t2, args: r }, function(e3) {
          var n2 = {};
          try {
            if (e3 && e3.__message__)
              if ("object" == typeof e3.__message__)
                n2 = e3.__message__;
              else
                try {
                  n2 = JSON.parse(e3.__message__);
                } catch (r2) {
                  "string" == typeof e3.__message__ && (n2 = e3.__message__);
                }
          } catch (e4) {
          }
          e3 && parseInt(e3.__status__ + "", 10) === STATUS_OK ? ("function" == typeof r.onSuccess && r.onSuccess(n2), o2(n2)) : ("function" == typeof r.onFail && r.onFail(n2), i(n2));
        });
      });
    });
  };
  exports.androidWeexBridge = androidWeexBridge;
})(weex$1);
var h5Event = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.off = exports.on = void 0;
  var NON_BRIDGE_EVENTS = ["resume", "pause", "online", "offline", "backbutton", "goBack", "pullToRefresh", "message", "recycle", "restore", "drawer", "tab", "navHelpIcon", "navRightButton", "navMenu", "navTitle", "appLinkResponse", "internalPageLinkResponse", "networkEvent", "hostTaskEvent", "deviceOrientationChanged", "autoCheckIn", "deviceFound", "hostCheckIn", "screenshot", "becomeActive", "keepAlive", "navTitleClick", "sharePage", "wxNotify", "editNoteCommand", "updateStyle", "qrscanCommonNotify", "__message__", "dtChannelEvent", "livePlayerEventPlay", "livePlayerEventPause", "livePlayerEventEnded", "livePlayerEventError", "navActions", "attendEvents"], BizEventBridgeType = "dtBizBridgeEvent", EventTypeListKey = "__eventTypeList__", handlerProxyMap = function() {
    return "undefined" == typeof WeakMap ? void 0 : /* @__PURE__ */ new WeakMap();
  }(), getOnHandlerProxy = function(e2, n) {
    if (handlerProxyMap) {
      var t2 = handlerProxyMap.get(n);
      return void 0 === t2 ? (t2 = function(e3) {
        var a2 = e3.detail;
        if (a2.namespace && a2.eventName) {
          var o2 = "".concat(a2.namespace, ".").concat(a2.eventName);
          t2 && -1 !== t2[EventTypeListKey].indexOf(o2) && n(a2.data);
        }
      }, t2[EventTypeListKey] = [e2], handlerProxyMap.set(n, t2)) : -1 === t2[EventTypeListKey].indexOf(e2) && t2[EventTypeListKey].push(e2), t2;
    }
  }, getOffHandlerProxy = function(e2, n) {
    if (handlerProxyMap) {
      var t2 = handlerProxyMap.get(n);
      return t2 && -1 !== t2[EventTypeListKey].indexOf(e2) && t2[EventTypeListKey].splice(t2[EventTypeListKey].indexOf(e2), 1), t2 && t2[EventTypeListKey].length <= 1 ? t2 : void 0;
    }
  }, on2 = function(e2, n) {
    if (-1 !== NON_BRIDGE_EVENTS.indexOf(e2))
      document.addEventListener(e2, n);
    else {
      var t2 = getOnHandlerProxy(e2, n);
      t2 ? document.addEventListener(BizEventBridgeType, t2) : console.log("bind event : ".concat(e2, " need WeakMap support , current environment doesnot"));
    }
  };
  exports.on = on2;
  var off = function(e2, n) {
    if (-1 !== NON_BRIDGE_EVENTS.indexOf(e2))
      document.removeEventListener(e2, n);
    else {
      var t2 = getOffHandlerProxy(e2, n);
      t2 && document.removeEventListener(BizEventBridgeType, t2);
    }
  };
  exports.off = off;
})(h5Event);
var weexEvent = {};
(function(exports) {
  var _this = commonjsGlobal;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.off = exports.on = void 0;
  var weex_12 = weex$1, on2 = function(e2, o2) {
    (0, weex_12.requireModule)("globalEvent").addEventListener(e2, function(e3) {
      var t2 = { preventDefault: function() {
        throw new Error("does not support preventDefault");
      }, detail: e3 };
      o2.call(_this, t2);
    });
  };
  exports.on = on2;
  var off = function(e2, o2) {
    (0, weex_12.requireModule)("globalEvent").removeEventListener(e2, o2);
  };
  exports.off = off;
})(weexEvent);
var ddSdk_1$1 = ddSdk, env_1$1 = env$1, sdk_1$1 = sdk, eapp_1$1 = eapp, webviewInMiniApp_1$1 = webviewInMiniApp, h5Android_1 = h5Android, weex_1$1 = weex$1, h5Event_1$1 = h5Event, weexEvent_1$1 = weexEvent;
ddSdk_1$1.ddSdk.setPlatform({ platform: env_1$1.ENV_ENUM.android, bridgeInit: function() {
  var e2 = (0, env_1$1.getENV)();
  return e2.appType === sdk_1$1.APP_TYPE.MINI_APP ? Promise.resolve(eapp_1$1.default) : e2.appType === sdk_1$1.APP_TYPE.WEBVIEW_IN_MINIAPP ? Promise.resolve(webviewInMiniApp_1$1.default) : e2.appType === sdk_1$1.APP_TYPE.WEEX ? (0, weex_1$1.androidWeexBridge)() : (0, h5Android_1.h5AndroidbridgeInit)().then(function() {
    return h5Android_1.default;
  });
}, authMethod: "runtime.permission.requestJsApis", event: { on: function(e2, r) {
  var i = (0, env_1$1.getENV)();
  switch (i.appType) {
    case sdk_1$1.APP_TYPE.WEB:
    case sdk_1$1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      (0, h5Event_1$1.on)(e2, r);
      break;
    case sdk_1$1.APP_TYPE.WEEX:
      (0, weexEvent_1$1.on)(e2, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: ".concat(i.appType));
  }
}, off: function(e2, r) {
  var i = (0, env_1$1.getENV)();
  switch (i.appType) {
    case sdk_1$1.APP_TYPE.WEB:
    case sdk_1$1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      (0, h5Event_1$1.off)(e2, r);
      break;
    case sdk_1$1.APP_TYPE.WEEX:
      (0, weexEvent_1$1.off)(e2, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: ".concat(i.appType));
  }
} } });
var h5Ios = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.h5IosBridgeInit = void 0;
  var h5BridgeReadyPromise, h5IosBridgeInit = function() {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = new Promise(function(e2, r) {
      if ("undefined" != typeof WebViewJavascriptBridge) {
        try {
          WebViewJavascriptBridge.init(function(e3, r2) {
          });
        } catch (e3) {
          return r();
        }
        return e2({});
      }
      document.addEventListener("WebViewJavascriptBridgeReady", function() {
        if ("undefined" == typeof WebViewJavascriptBridge)
          return r();
        try {
          WebViewJavascriptBridge.init(function(e3, r2) {
          });
        } catch (e3) {
          return r();
        }
        return e2({});
      }, false);
    })), h5BridgeReadyPromise;
  };
  exports.h5IosBridgeInit = h5IosBridgeInit;
  var h5IosBridge = function(e2, r) {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = (0, exports.h5IosBridgeInit)()), h5BridgeReadyPromise.then(function() {
      var i = Object.assign({}, r);
      return new Promise(function(r2, n) {
        if (true === i.watch) {
          var t2 = i.onSuccess;
          delete i.onSuccess, "undefined" != typeof WebViewJavascriptBridge && WebViewJavascriptBridge.registerHandler(e2, function(e3, r3) {
            "function" == typeof t2 && t2.call(null, e3), r3 && r3({ errorCode: "0", errorMessage: "success" });
          });
        }
        void 0 !== window.WebViewJavascriptBridge && window.WebViewJavascriptBridge.callHandler(e2, Object.assign({}, i), function(e3) {
          var t3 = e3 || {};
          "0" === t3.errorCode ? ("function" == typeof i.onSuccess && i.onSuccess.call(null, t3.result), r2(t3.result)) : ("-1" === t3.errorCode && "function" == typeof i.onCancel ? i.onCancel.call(null, t3, t3.errorCode) : "function" == typeof i.onFail && i.onFail.call(null, t3, t3.errorCode), n(t3));
        });
      });
    });
  };
  exports.default = h5IosBridge;
})(h5Ios);
var ddSdk_1 = ddSdk, env_1 = env$1, sdk_1 = sdk, eapp_1 = eapp, webviewInMiniApp_1 = webviewInMiniApp, h5Ios_1 = h5Ios, weex_1 = weex$1, h5Event_1 = h5Event, weexEvent_1 = weexEvent;
ddSdk_1.ddSdk.setPlatform({ platform: env_1.ENV_ENUM.ios, bridgeInit: function() {
  var e2 = (0, env_1.getENV)();
  return e2.appType === sdk_1.APP_TYPE.MINI_APP ? Promise.resolve(eapp_1.default) : e2.appType === sdk_1.APP_TYPE.WEBVIEW_IN_MINIAPP ? Promise.resolve(webviewInMiniApp_1.default) : e2.appType === sdk_1.APP_TYPE.WEEX ? (0, weex_1.iosWeexBridge)() : (0, h5Ios_1.h5IosBridgeInit)().then(function() {
    return h5Ios_1.default;
  });
}, authMethod: "runtime.permission.requestJsApis", event: { on: function(e2, r) {
  var i = (0, env_1.getENV)();
  switch (i.appType) {
    case sdk_1.APP_TYPE.WEB:
    case sdk_1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      (0, h5Event_1.on)(e2, r);
      break;
    case sdk_1.APP_TYPE.WEEX:
      (0, weexEvent_1.on)(e2, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: ".concat(i.appType));
  }
}, off: function(e2, r) {
  var i = (0, env_1.getENV)();
  switch (i.appType) {
    case sdk_1.APP_TYPE.WEB:
    case sdk_1.APP_TYPE.WEBVIEW_IN_MINIAPP:
      (0, h5Event_1.off)(e2, r);
      break;
    case sdk_1.APP_TYPE.WEEX:
      (0, weexEvent_1.off)(e2, r);
      break;
    default:
      throw new Error("Not support global event in the platfrom: ".concat(i.appType));
  }
} } });
var harmony = {};
var h5Harmony = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.h5HarmonyBridgeInit = void 0;
  var h5BridgeReadyPromise, h5HarmonyBridgeInit = function() {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = new Promise(function(e2, n) {
      if ("undefined" != typeof DingTalkJSBridge) {
        try {
          DingTalkJSBridge.init(function(e3, n2) {
          });
        } catch (e3) {
          return n();
        }
        return e2({});
      }
      document.addEventListener("DingTalkJSBridgeReady", function() {
        if ("undefined" == typeof DingTalkJSBridge)
          return n();
        try {
          DingTalkJSBridge.init(function(e3, n2) {
          });
        } catch (e3) {
          return n();
        }
        return e2({});
      }, false);
    })), h5BridgeReadyPromise;
  };
  exports.h5HarmonyBridgeInit = h5HarmonyBridgeInit;
  var h5HarmonyBridge = function(e2, n) {
    return h5BridgeReadyPromise || (h5BridgeReadyPromise = (0, exports.h5HarmonyBridgeInit)()), h5BridgeReadyPromise.then(function() {
      return new Promise(function(i, r) {
        var o2 = function(e3) {
          e3.success ? (!function(e4) {
            "function" == typeof n.success ? n.success(e4) : "function" == typeof n.onSuccess && n.onSuccess(e4);
          }(e3.body), i(e3.body)) : (!function(e4) {
            "function" == typeof n.fail ? n.fail(e4) : "function" == typeof n.onFail && n.onFail(e4);
          }(e3.body), r(e3.body));
        };
        "function" == typeof window.DingTalkJSBridge.call && window.DingTalkJSBridge.call(e2, n, o2);
      });
    });
  };
  exports.default = h5HarmonyBridge;
})(h5Harmony);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.platformConfig = void 0;
  var ddSdk_12 = ddSdk, env_12 = env$1, sdk_12 = sdk, eapp_12 = eapp, webviewInMiniApp_12 = webviewInMiniApp, h5Harmony_1 = h5Harmony, h5Event_12 = h5Event, weexEvent_12 = weexEvent;
  exports.platformConfig = { platform: env_12.ENV_ENUM.harmony, bridgeInit: function() {
    var e2 = (0, env_12.getENV)();
    return e2.appType === sdk_12.APP_TYPE.MINI_APP ? Promise.resolve(eapp_12.default) : e2.appType === sdk_12.APP_TYPE.WEBVIEW_IN_MINIAPP ? Promise.resolve(webviewInMiniApp_12.default) : (0, h5Harmony_1.h5HarmonyBridgeInit)().then(function() {
      return h5Harmony_1.default;
    });
  }, authMethod: "runtime.permission.requestJsApis", event: { on: function(e2, r) {
    var t2 = (0, env_12.getENV)();
    switch (t2.appType) {
      case sdk_12.APP_TYPE.WEB:
      case sdk_12.APP_TYPE.WEBVIEW_IN_MINIAPP:
        (0, h5Event_12.on)(e2, r);
        break;
      case sdk_12.APP_TYPE.WEEX:
        (0, weexEvent_12.on)(e2, r);
        break;
      default:
        throw new Error("Not support global event in the platfrom: ".concat(t2.appType));
    }
  }, off: function(e2, r) {
    var t2 = (0, env_12.getENV)();
    switch (t2.appType) {
      case sdk_12.APP_TYPE.WEB:
      case sdk_12.APP_TYPE.WEBVIEW_IN_MINIAPP:
        (0, h5Event_12.off)(e2, r);
        break;
      case sdk_12.APP_TYPE.WEEX:
        (0, weexEvent_12.off)(e2, r);
        break;
      default:
        throw new Error("Not support global event in the platfrom: ".concat(t2.appType));
    }
  } } }, ddSdk_12.ddSdk.setPlatform(exports.platformConfig);
})(harmony);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
})(platform);
var dd$3 = core_1;
union.exports = dd$3;
var apiObj = {};
var beaconPicker = {};
(function(exports) {
  function beaconPicker$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.beaconPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.beaconPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.7" }, _a2)), exports.beaconPicker$ = beaconPicker$, exports.default = beaconPicker$;
})(beaconPicker);
var detectFace = {};
(function(exports) {
  function detectFace$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.detectFace$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.detectFace";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.18" }, _a2)), exports.detectFace$ = detectFace$, exports.default = detectFace$;
})(detectFace);
var detectFaceFullScreen = {};
(function(exports) {
  function detectFaceFullScreen$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.detectFaceFullScreen$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.detectFaceFullScreen";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.18" }, _a2)), exports.detectFaceFullScreen$ = detectFaceFullScreen$, exports.default = detectFaceFullScreen$;
})(detectFaceFullScreen);
var faceManager = {};
(function(exports) {
  function faceManager$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.faceManager$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.faceManager";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.7" }, _a2)), exports.faceManager$ = faceManager$, exports.default = faceManager$;
})(faceManager);
var punchModePicker = {};
(function(exports) {
  function punchModePicker$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.punchModePicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ATMBle.punchModePicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.7" }, _a2)), exports.punchModePicker$ = punchModePicker$, exports.default = punchModePicker$;
})(punchModePicker);
var bindAlipay = {};
(function(exports) {
  function bindAlipay$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.bindAlipay$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.alipay.bindAlipay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.15" }, _a2)), exports.bindAlipay$ = bindAlipay$, exports.default = bindAlipay$;
})(bindAlipay);
var openAuth = {};
(function(exports) {
  function openAuth$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openAuth$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.alipay.openAuth";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.8" }, _a2)), exports.openAuth$ = openAuth$, exports.default = openAuth$;
})(openAuth);
var pay = {};
(function(exports) {
  function pay$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pay$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.alipay.pay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.pay$ = pay$, exports.default = pay$;
})(pay);
var openAccountPwdLoginPage = {};
(function(exports) {
  function openAccountPwdLoginPage$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openAccountPwdLoginPage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.auth.openAccountPwdLoginPage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.0" }, _a2)), exports.openAccountPwdLoginPage$ = openAccountPwdLoginPage$, exports.default = openAccountPwdLoginPage$;
})(openAccountPwdLoginPage);
var requestAuthInfo = {};
(function(exports) {
  function requestAuthInfo$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestAuthInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.auth.requestAuthInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.19" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.19" }, _a2)), exports.requestAuthInfo$ = requestAuthInfo$, exports.default = requestAuthInfo$;
})(requestAuthInfo);
var chooseDateTime = {};
var apiHelper = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.genBizStoreParamsDealFn = exports.genBoolResultDealFn = exports.forceChangeParamsDealFn = exports.genDefaultParamsDealFn = exports.addDefaultCorpIdParamsDeal = exports.addWatchParamsDeal = void 0;
  var addWatchParamsDeal = function(a2) {
    var e2 = Object.assign({}, a2);
    return e2.watch = true, e2;
  };
  exports.addWatchParamsDeal = addWatchParamsDeal;
  var addDefaultCorpIdParamsDeal = function(a2) {
    var e2 = Object.assign({}, a2);
    return e2.corpId = "corpId", e2;
  };
  exports.addDefaultCorpIdParamsDeal = addDefaultCorpIdParamsDeal;
  var genDefaultParamsDealFn = function(a2) {
    var e2 = Object.assign({}, a2);
    return function(a3) {
      return Object.assign({}, e2, a3);
    };
  };
  exports.genDefaultParamsDealFn = genDefaultParamsDealFn;
  var forceChangeParamsDealFn = function(a2) {
    var e2 = Object.assign({}, a2);
    return function(a3) {
      return Object.assign(a3, e2);
    };
  };
  exports.forceChangeParamsDealFn = forceChangeParamsDealFn;
  var genBoolResultDealFn = function(a2) {
    return function(e2) {
      var r = Object.assign({}, e2);
      return a2.forEach(function(a3) {
        void 0 !== r[a3] && (r[a3] = !!r[a3]);
      }), r;
    };
  };
  exports.genBoolResultDealFn = genBoolResultDealFn;
  var genBizStoreParamsDealFn = function(a2) {
    var e2 = Object.assign({}, a2);
    return "string" != typeof e2.params ? (e2.params = JSON.stringify(e2), e2) : e2;
  };
  exports.genBizStoreParamsDealFn = genBizStoreParamsDealFn;
})(apiHelper);
(function(exports) {
  function chooseDateTime$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseDateTime$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseDateTime";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseDateTime$ = chooseDateTime$, exports.default = chooseDateTime$;
})(chooseDateTime);
var chooseHalfDay = {};
(function(exports) {
  function chooseHalfDay$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseHalfDay$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseHalfDay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseHalfDay$ = chooseHalfDay$, exports.default = chooseHalfDay$;
})(chooseHalfDay);
var chooseInterval = {};
(function(exports) {
  function chooseInterval$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseInterval$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseInterval";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseInterval$ = chooseInterval$, exports.default = chooseInterval$;
})(chooseInterval);
var chooseOneDay = {};
(function(exports) {
  function chooseOneDay$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseOneDay$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.calendar.chooseOneDay";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0", paramsDeal: apiHelper_1.addDefaultCorpIdParamsDeal }, _a2)), exports.chooseOneDay$ = chooseOneDay$, exports.default = chooseOneDay$;
})(chooseOneDay);
var chooseConversationByCorpId = {};
(function(exports) {
  function chooseConversationByCorpId$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseConversationByCorpId$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.chat.chooseConversationByCorpId", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ max: 50 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.11", paramsDeal }, _a2)), exports.chooseConversationByCorpId$ = chooseConversationByCorpId$, exports.default = chooseConversationByCorpId$;
})(chooseConversationByCorpId);
var collectSticker = {};
(function(exports) {
  function collectSticker$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.collectSticker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.collectSticker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.25" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.25" }, _a2)), exports.collectSticker$ = collectSticker$, exports.default = collectSticker$;
})(collectSticker);
var createSceneGroup = {};
(function(exports) {
  function createSceneGroup$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createSceneGroup$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.createSceneGroup";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.17" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.17" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.17" }, _a2)), exports.createSceneGroup$ = createSceneGroup$, exports.default = createSceneGroup$;
})(createSceneGroup);
var getRealmCid = {};
(function(exports) {
  function getRealmCid$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getRealmCid$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.getRealmCid";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.12" }, _a2)), exports.getRealmCid$ = getRealmCid$, exports.default = getRealmCid$;
})(getRealmCid);
var locationChatMessage = {};
(function(exports) {
  function locationChatMessage$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.locationChatMessage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.locationChatMessage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.6" }, _a2)), exports.locationChatMessage$ = locationChatMessage$, exports.default = locationChatMessage$;
})(locationChatMessage);
var openSingleChat = {};
(function(exports) {
  function openSingleChat$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openSingleChat$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.openSingleChat";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.10" }, _a2)), exports.openSingleChat$ = openSingleChat$, exports.default = openSingleChat$;
})(openSingleChat);
var pickConversation = {};
(function(exports) {
  function pickConversation$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pickConversation$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.pickConversation";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.2" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.2" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.9" }, _a2)), exports.pickConversation$ = pickConversation$, exports.default = pickConversation$;
})(pickConversation);
var sendEmotion = {};
(function(exports) {
  function sendEmotion$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.sendEmotion$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.sendEmotion";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.12" }, _a2)), exports.sendEmotion$ = sendEmotion$, exports.default = sendEmotion$;
})(sendEmotion);
var toConversation = {};
(function(exports) {
  function toConversation$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.toConversation$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.toConversation";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.toConversation$ = toConversation$, exports.default = toConversation$;
})(toConversation);
var toConversationByOpenConversationId = {};
(function(exports) {
  function toConversationByOpenConversationId$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.toConversationByOpenConversationId$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.chat.toConversationByOpenConversationId";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.30" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.30" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.33" }, _a2)), exports.toConversationByOpenConversationId$ = toConversationByOpenConversationId$, exports.default = toConversationByOpenConversationId$;
})(toConversationByOpenConversationId);
var setData = {};
(function(exports) {
  function setData$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setData$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.clipboardData.setData";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.1" }, _a2)), exports.setData$ = setData$, exports.default = setData$;
})(setData);
var createCloudCall = {};
(function(exports) {
  function createCloudCall$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createCloudCall$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.createCloudCall";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.9" }, _a2)), exports.createCloudCall$ = createCloudCall$, exports.default = createCloudCall$;
})(createCloudCall);
var getCloudCallInfo = {};
(function(exports) {
  function getCloudCallInfo$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getCloudCallInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.getCloudCallInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.9" }, _a2)), exports.getCloudCallInfo$ = getCloudCallInfo$, exports.default = getCloudCallInfo$;
})(getCloudCallInfo);
var getCloudCallList = {};
(function(exports) {
  function getCloudCallList$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getCloudCallList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.getCloudCallList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.9" }, _a2)), exports.getCloudCallList$ = getCloudCallList$, exports.default = getCloudCallList$;
})(getCloudCallList);
var videoConfCall = {};
(function(exports) {
  function videoConfCall$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.videoConfCall$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.conference.videoConfCall";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.0.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.0.8" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.28" }, _a2)), exports.videoConfCall$ = videoConfCall$, exports.default = videoConfCall$;
})(videoConfCall);
var choose$1 = {};
(function(exports) {
  function choose$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.choose$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.contact.choose", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ multiple: true, startWithDepartmentId: 0, users: [] });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.choose$ = choose$, exports.default = choose$;
})(choose$1);
var chooseMobileContacts = {};
(function(exports) {
  function chooseMobileContacts$(o2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, o2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseMobileContacts$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.chooseMobileContacts";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.1" }, _a2)), exports.chooseMobileContacts$ = chooseMobileContacts$, exports.default = chooseMobileContacts$;
})(chooseMobileContacts);
var complexPicker = {};
(function(exports) {
  function complexPicker$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.complexPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.complexPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.3.5" }, _a2)), exports.complexPicker$ = complexPicker$, exports.default = complexPicker$;
})(complexPicker);
var createGroup$1 = {};
(function(exports) {
  function createGroup$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createGroup$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.createGroup";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.1" }, _a2)), exports.createGroup$ = createGroup$, exports.default = createGroup$;
})(createGroup$1);
var departmentsPicker = {};
(function(exports) {
  function departmentsPicker$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.departmentsPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.departmentsPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.2.5" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0" }, _a2)), exports.departmentsPicker$ = departmentsPicker$, exports.default = departmentsPicker$;
})(departmentsPicker);
var externalComplexPicker = {};
(function(exports) {
  function externalComplexPicker$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.externalComplexPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.externalComplexPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0" }, _a2)), exports.externalComplexPicker$ = externalComplexPicker$, exports.default = externalComplexPicker$;
})(externalComplexPicker);
var externalEditForm = {};
(function(exports) {
  function externalEditForm$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.externalEditForm$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.externalEditForm";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0" }, _a2)), exports.externalEditForm$ = externalEditForm$, exports.default = externalEditForm$;
})(externalEditForm);
var rolesPicker = {};
(function(exports) {
  function rolesPicker$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.rolesPicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.rolesPicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.16" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.16" }, _a2)), exports.rolesPicker$ = rolesPicker$, exports.default = rolesPicker$;
})(rolesPicker);
var setRule = {};
(function(exports) {
  function setRule$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setRule$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.contact.setRule";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.15" }, _a2)), exports.setRule$ = setRule$, exports.default = setRule$;
})(setRule);
var chooseSpaceDir = {};
(function(exports) {
  function chooseSpaceDir$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseSpaceDir$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.chooseSpaceDir";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.27" }, _a2)), exports.chooseSpaceDir$ = chooseSpaceDir$, exports.default = chooseSpaceDir$;
})(chooseSpaceDir);
var _delete = {};
(function(exports) {
  function delete$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.delete$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.delete";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.21" }, _a2)), exports.delete$ = delete$, exports.default = delete$;
})(_delete);
var preview = {};
(function(exports) {
  function preview$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.preview$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.preview";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.0" }, _a2)), exports.preview$ = preview$, exports.default = preview$;
})(preview);
var saveFile = {};
(function(exports) {
  function saveFile$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.saveFile$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.cspace.saveFile";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.6" }, _a2)), exports.saveFile$ = saveFile$, exports.default = saveFile$;
})(saveFile);
var choose = {};
(function(exports) {
  function choose$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.choose$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.customContact.choose", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ isShowCompanyName: false, max: 50 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.5.2", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.5.2", paramsDeal }, _a2)), exports.choose$ = choose$, exports.default = choose$;
})(choose);
var multipleChoose = {};
(function(exports) {
  function multipleChoose$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.multipleChoose$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.customContact.multipleChoose", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ isShowCompanyName: false, max: 50 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.multipleChoose$ = multipleChoose$, exports.default = multipleChoose$;
})(multipleChoose);
var create = {};
(function(exports) {
  function create$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.create$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ding.create";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.1", resultDeal: function(e2) {
    return "" === e2 ? e2 = { dingCreateResult: false } : "object" == typeof e2 && (e2.dingCreateResult = !!e2.dingCreateResult), e2;
  } }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.1" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.9" }, _a2)), exports.create$ = create$, exports.default = create$;
})(create);
var post$1 = {};
(function(exports) {
  function post$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.post$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.ding.post";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.post$ = post$, exports.default = post$;
})(post$1);
var finishMiniCourseByRecordId = {};
(function(exports) {
  function finishMiniCourseByRecordId$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.finishMiniCourseByRecordId$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.finishMiniCourseByRecordId";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2)), exports.finishMiniCourseByRecordId$ = finishMiniCourseByRecordId$, exports.default = finishMiniCourseByRecordId$;
})(finishMiniCourseByRecordId);
var getMiniCourseDraftList = {};
(function(exports) {
  function getMiniCourseDraftList$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getMiniCourseDraftList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.getMiniCourseDraftList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2)), exports.getMiniCourseDraftList$ = getMiniCourseDraftList$, exports.default = getMiniCourseDraftList$;
})(getMiniCourseDraftList);
var joinClassroom = {};
(function(exports) {
  function joinClassroom$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.joinClassroom$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.joinClassroom";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.15" }, _a2)), exports.joinClassroom$ = joinClassroom$, exports.default = joinClassroom$;
})(joinClassroom);
var makeMiniCourse = {};
(function(exports) {
  function makeMiniCourse$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.makeMiniCourse$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.makeMiniCourse";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.15" }, _a2)), exports.makeMiniCourse$ = makeMiniCourse$, exports.default = makeMiniCourse$;
})(makeMiniCourse);
var newMsgNotificationStatus = {};
(function(exports) {
  function newMsgNotificationStatus$(t2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, t2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.newMsgNotificationStatus$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.newMsgNotificationStatus";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.20" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.20" }, _a2)), exports.newMsgNotificationStatus$ = newMsgNotificationStatus$, exports.default = newMsgNotificationStatus$;
})(newMsgNotificationStatus);
var startAuth$1 = {};
(function(exports) {
  function startAuth$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startAuth$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.startAuth";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.20" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.20" }, _a2)), exports.startAuth$ = startAuth$, exports.default = startAuth$;
})(startAuth$1);
var tokenFaceImg = {};
(function(exports) {
  function tokenFaceImg$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.tokenFaceImg$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.edu.tokenFaceImg";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.20" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.20" }, _a2)), exports.tokenFaceImg$ = tokenFaceImg$, exports.default = tokenFaceImg$;
})(tokenFaceImg);
var notifyWeex = {};
(function(exports) {
  function notifyWeex$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.notifyWeex$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.event.notifyWeex";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.0" }, _a2)), exports.notifyWeex$ = notifyWeex$, exports.default = notifyWeex$;
})(notifyWeex);
var fetchData = {};
(function(exports) {
  function fetchData$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.fetchData$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.intent.fetchData";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.6" }, _a2)), exports.fetchData$ = fetchData$, exports.default = fetchData$;
})(fetchData);
var bind$1 = {};
(function(exports) {
  function bind$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.bind$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.bind";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.bind$ = bind$, exports.default = bind$;
})(bind$1);
var bindMeetingRoom = {};
(function(exports) {
  function bindMeetingRoom$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.bindMeetingRoom$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.bindMeetingRoom";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.bindMeetingRoom$ = bindMeetingRoom$, exports.default = bindMeetingRoom$;
})(bindMeetingRoom);
var getDeviceProperties = {};
(function(exports) {
  function getDeviceProperties$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getDeviceProperties$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.getDeviceProperties";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.42" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.42" }, _a2)), exports.getDeviceProperties$ = getDeviceProperties$, exports.default = getDeviceProperties$;
})(getDeviceProperties);
var invokeThingService = {};
(function(exports) {
  function invokeThingService$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.invokeThingService$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.invokeThingService";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.42" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.42" }, _a2)), exports.invokeThingService$ = invokeThingService$, exports.default = invokeThingService$;
})(invokeThingService);
var queryMeetingRoomList = {};
(function(exports) {
  function queryMeetingRoomList$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.queryMeetingRoomList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.queryMeetingRoomList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.queryMeetingRoomList$ = queryMeetingRoomList$, exports.default = queryMeetingRoomList$;
})(queryMeetingRoomList);
var setDeviceProperties = {};
(function(exports) {
  function setDeviceProperties$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setDeviceProperties$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.setDeviceProperties";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.42" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.42" }, _a2)), exports.setDeviceProperties$ = setDeviceProperties$, exports.default = setDeviceProperties$;
})(setDeviceProperties);
var unbind$1 = {};
(function(exports) {
  function unbind$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.unbind$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.iot.unbind";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.34" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.34" }, _a2)), exports.unbind$ = unbind$, exports.default = unbind$;
})(unbind$1);
var startClassRoom = {};
(function(exports) {
  function startClassRoom$(s) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, s);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startClassRoom$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.live.startClassRoom";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.19" }, _a2)), exports.startClassRoom$ = startClassRoom$, exports.default = startClassRoom$;
})(startClassRoom);
var startUnifiedLive = {};
(function(exports) {
  function startUnifiedLive$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startUnifiedLive$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.live.startUnifiedLive";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.18" }, _a2)), exports.startUnifiedLive$ = startUnifiedLive$, exports.default = startUnifiedLive$;
})(startUnifiedLive);
var locate = {};
(function(exports) {
  function locate$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.locate$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.map.locate";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.locate$ = locate$, exports.default = locate$;
})(locate);
var search = {};
(function(exports) {
  function search$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.search$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.map.search", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ scope: 500 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.search$ = search$, exports.default = search$;
})(search);
var view = {};
(function(exports) {
  function view$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.view$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.map.view";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.view$ = view$, exports.default = view$;
})(view);
var compressVideo = {};
(function(exports) {
  function compressVideo$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.compressVideo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.media.compressVideo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.37" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.37" }, _a2)), exports.compressVideo$ = compressVideo$, exports.default = compressVideo$;
})(compressVideo);
var openApp = {};
(function(exports) {
  function openApp$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openApp$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.microApp.openApp";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.6" }, _a2)), exports.openApp$ = openApp$, exports.default = openApp$;
})(openApp);
var close$1 = {};
(function(exports) {
  function close$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.close$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.close";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.3.5" }, _a2)), exports.close$ = close$, exports.default = close$;
})(close$1);
var goBack = {};
(function(exports) {
  function goBack$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.goBack$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.goBack";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.goBack$ = goBack$, exports.default = goBack$;
})(goBack);
var hideBar = {};
(function(exports) {
  function hideBar$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.hideBar$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.hideBar";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2)), exports.hideBar$ = hideBar$, exports.default = hideBar$;
})(hideBar);
var navigateToMiniProgram = {};
(function(exports) {
  function navigateToMiniProgram$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.navigateToMiniProgram$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.navigateToMiniProgram";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.31" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.31" }, _a2)), exports.navigateToMiniProgram$ = navigateToMiniProgram$, exports.default = navigateToMiniProgram$;
})(navigateToMiniProgram);
var quit = {};
(function(exports) {
  function quit$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.quit$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.quit";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.quit$ = quit$, exports.default = quit$;
})(quit);
var replace = {};
(function(exports) {
  function replace$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.replace$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.replace";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.6" }, _a2)), exports.replace$ = replace$, exports.default = replace$;
})(replace);
var setIcon = {};
(function(exports) {
  function setIcon$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setIcon$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setIcon", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ watch: true, showIcon: true, iconIndex: 1 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.setIcon$ = setIcon$, exports.default = setIcon$;
})(setIcon);
var setLeft = {};
(function(exports) {
  function setLeft$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setLeft$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setLeft", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ watch: true, show: true, control: false, showIcon: true, text: "" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.setLeft$ = setLeft$, exports.default = setLeft$;
})(setLeft);
var setMenu = {};
(function(exports) {
  function setMenu$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setMenu$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setMenu";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2)), exports.setMenu$ = setMenu$, exports.default = setMenu$;
})(setMenu);
var setRight = {};
(function(exports) {
  function setRight$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setRight$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.navigation.setRight", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ watch: true, show: true, control: false, showIcon: true, text: "" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.setRight$ = setRight$, exports.default = setRight$;
})(setRight);
var setTitle = {};
(function(exports) {
  function setTitle$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setTitle$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.navigation.setTitle";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.setTitle$ = setTitle$, exports.default = setTitle$;
})(setTitle);
var componentPunchFromPartner = {};
(function(exports) {
  function componentPunchFromPartner$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.componentPunchFromPartner$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.pbp.componentPunchFromPartner";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.10" }, _a2)), exports.componentPunchFromPartner$ = componentPunchFromPartner$, exports.default = componentPunchFromPartner$;
})(componentPunchFromPartner);
var startMatchRuleFromPartner = {};
(function(exports) {
  function startMatchRuleFromPartner$(r) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, r);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startMatchRuleFromPartner$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.pbp.startMatchRuleFromPartner";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.10" }, _a2)), exports.startMatchRuleFromPartner$ = startMatchRuleFromPartner$, exports.default = startMatchRuleFromPartner$;
})(startMatchRuleFromPartner);
var stopMatchRuleFromPartner = {};
(function(exports) {
  function stopMatchRuleFromPartner$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stopMatchRuleFromPartner$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.pbp.stopMatchRuleFromPartner";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.10" }, _a2)), exports.stopMatchRuleFromPartner$ = stopMatchRuleFromPartner$, exports.default = stopMatchRuleFromPartner$;
})(stopMatchRuleFromPartner);
var getRealtimeTracingStatus = {};
(function(exports) {
  function getRealtimeTracingStatus$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getRealtimeTracingStatus$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.getRealtimeTracingStatus";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.13" }, _a2)), exports.getRealtimeTracingStatus$ = getRealtimeTracingStatus$, exports.default = getRealtimeTracingStatus$;
})(getRealtimeTracingStatus);
var getUserExclusiveInfo = {};
(function(exports) {
  function getUserExclusiveInfo$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getUserExclusiveInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.getUserExclusiveInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.14" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.14" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.17" }, _a2)), exports.getUserExclusiveInfo$ = getUserExclusiveInfo$, exports.default = getUserExclusiveInfo$;
})(getUserExclusiveInfo);
var startRealtimeTracing = {};
(function(exports) {
  function startRealtimeTracing$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startRealtimeTracing$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.startRealtimeTracing";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.13" }, _a2)), exports.startRealtimeTracing$ = startRealtimeTracing$, exports.default = startRealtimeTracing$;
})(startRealtimeTracing);
var stopRealtimeTracing = {};
(function(exports) {
  function stopRealtimeTracing$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stopRealtimeTracing$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.stopRealtimeTracing";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.13" }, _a2)), exports.stopRealtimeTracing$ = stopRealtimeTracing$, exports.default = stopRealtimeTracing$;
})(stopRealtimeTracing);
var subscribe2 = {};
(function(exports) {
  function subscribe$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.subscribe$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.subscribe";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.18" }, _a2)), exports.subscribe$ = subscribe$, exports.default = subscribe$;
})(subscribe2);
var unsubscribe2 = {};
(function(exports) {
  function unsubscribe$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.unsubscribe$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.realm.unsubscribe";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.7.18" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.18" }, _a2)), exports.unsubscribe$ = unsubscribe$, exports.default = unsubscribe$;
})(unsubscribe2);
var getInfo = {};
(function(exports) {
  function getInfo$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.resource.getInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.10" }, _a2)), exports.getInfo$ = getInfo$, exports.default = getInfo$;
})(getInfo);
var reportDebugMessage = {};
(function(exports) {
  function reportDebugMessage$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.reportDebugMessage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.resource.reportDebugMessage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.20" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.20" }, _a2)), exports.reportDebugMessage$ = reportDebugMessage$, exports.default = reportDebugMessage$;
})(reportDebugMessage);
var addShortCut = {};
(function(exports) {
  function addShortCut$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.addShortCut$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.shortCut.addShortCut";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.7.32" }, _a2)), exports.addShortCut$ = addShortCut$, exports.default = addShortCut$;
})(addShortCut);
var closeUnpayOrder = {};
(function(exports) {
  function closeUnpayOrder$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.closeUnpayOrder$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.closeUnpayOrder";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.closeUnpayOrder$ = closeUnpayOrder$, exports.default = closeUnpayOrder$;
})(closeUnpayOrder);
var createOrder = {};
(function(exports) {
  function createOrder$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createOrder$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.createOrder";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.createOrder$ = createOrder$, exports.default = createOrder$;
})(createOrder);
var getPayUrl = {};
(function(exports) {
  function getPayUrl$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getPayUrl$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.getPayUrl";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.getPayUrl$ = getPayUrl$, exports.default = getPayUrl$;
})(getPayUrl);
var inquiry = {};
(function(exports) {
  function inquiry$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.inquiry$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.store.inquiry";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.5.3", paramsDeal: apiHelper_1.genBizStoreParamsDealFn }, _a2)), exports.inquiry$ = inquiry$, exports.default = inquiry$;
})(inquiry);
var isTab = {};
(function(exports) {
  function isTab$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.isTab$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.tabwindow.isTab";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.5.10" }, _a2)), exports.isTab$ = isTab$, exports.default = isTab$;
})(isTab);
var call = {};
(function(exports) {
  function call$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.call$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.call";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.call$ = call$, exports.default = call$;
})(call);
var checkBizCall = {};
(function(exports) {
  function checkBizCall$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkBizCall$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.checkBizCall";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2)), exports.checkBizCall$ = checkBizCall$, exports.default = checkBizCall$;
})(checkBizCall);
var quickCallList = {};
(function(exports) {
  function quickCallList$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.quickCallList$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.quickCallList";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.6" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.6" }, _a2)), exports.quickCallList$ = quickCallList$, exports.default = quickCallList$;
})(quickCallList);
var showCallMenu = {};
(function(exports) {
  function showCallMenu$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.showCallMenu$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.telephone.showCallMenu";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.showCallMenu$ = showCallMenu$, exports.default = showCallMenu$;
})(showCallMenu);
var checkPassword = {};
(function(exports) {
  function checkPassword$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkPassword$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.user.checkPassword";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.8" }, _a2)), exports.checkPassword$ = checkPassword$, exports.default = checkPassword$;
})(checkPassword);
var get$1 = {};
(function(exports) {
  function get$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.get$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.user.get";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.get$ = get$, exports.default = get$;
})(get$1);
var callComponent = {};
(function(exports) {
  function callComponent$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.callComponent$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.callComponent";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.35" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.35" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.3.35" }, _a2)), exports.callComponent$ = callComponent$, exports.default = callComponent$;
})(callComponent);
var chooseImage = {};
(function(exports) {
  function chooseImage$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chooseImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.chooseImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.1" }, _a2)), exports.chooseImage$ = chooseImage$, exports.default = chooseImage$;
})(chooseImage);
var chosen = {};
(function(exports) {
  function chosen$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.chosen$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.chosen";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.chosen$ = chosen$, exports.default = chosen$;
})(chosen);
var clearWebStoreCache = {};
(function(exports) {
  function clearWebStoreCache$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.clearWebStoreCache$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.clearWebStoreCache";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.22" }, _a2)), exports.clearWebStoreCache$ = clearWebStoreCache$, exports.default = clearWebStoreCache$;
})(clearWebStoreCache);
var closePreviewImage = {};
(function(exports) {
  function closePreviewImage$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.closePreviewImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.closePreviewImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.19" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.17" }, _a2)), exports.closePreviewImage$ = closePreviewImage$, exports.default = closePreviewImage$;
})(closePreviewImage);
var compressImage = {};
(function(exports) {
  function compressImage$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.compressImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.compressImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.1" }, _a2)), exports.compressImage$ = compressImage$, exports.default = compressImage$;
})(compressImage);
var datepicker = {};
(function(exports) {
  function datepicker$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.datepicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.datepicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.datepicker$ = datepicker$, exports.default = datepicker$;
})(datepicker);
var datetimepicker = {};
(function(exports) {
  function datetimepicker$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.datetimepicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.datetimepicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.datetimepicker$ = datetimepicker$, exports.default = datetimepicker$;
})(datetimepicker);
var decrypt = {};
(function(exports) {
  function decrypt$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.decrypt$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.decrypt";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.1" }, _a2)), exports.decrypt$ = decrypt$, exports.default = decrypt$;
})(decrypt);
var downloadFile = {};
(function(exports) {
  function downloadFile$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.downloadFile$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.downloadFile";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.downloadFile$ = downloadFile$, exports.default = downloadFile$;
})(downloadFile);
var encrypt = {};
(function(exports) {
  function encrypt$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.encrypt$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.encrypt";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.1" }, _a2)), exports.encrypt$ = encrypt$, exports.default = encrypt$;
})(encrypt);
var getPerfInfo = {};
(function(exports) {
  function getPerfInfo$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getPerfInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.getPerfInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.14" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.14" }, _a2)), exports.getPerfInfo$ = getPerfInfo$, exports.default = getPerfInfo$;
})(getPerfInfo);
var invokeWorkbench = {};
(function(exports) {
  function invokeWorkbench$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.invokeWorkbench$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.invokeWorkbench";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.8" }, _a2)), exports.invokeWorkbench$ = invokeWorkbench$, exports.default = invokeWorkbench$;
})(invokeWorkbench);
var isEnableGPUAcceleration = {};
(function(exports) {
  function isEnableGPUAcceleration$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.isEnableGPUAcceleration$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.isEnableGPUAcceleration";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.22" }, _a2)), exports.isEnableGPUAcceleration$ = isEnableGPUAcceleration$, exports.default = isEnableGPUAcceleration$;
})(isEnableGPUAcceleration);
var isLocalFileExist = {};
(function(exports) {
  function isLocalFileExist$(i) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, i);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.isLocalFileExist$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.isLocalFileExist";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.isLocalFileExist$ = isLocalFileExist$, exports.default = isLocalFileExist$;
})(isLocalFileExist);
var multiSelect = {};
(function(exports) {
  function multiSelect$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.multiSelect$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.multiSelect";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0.0" }, _a2)), exports.multiSelect$ = multiSelect$, exports.default = multiSelect$;
})(multiSelect);
var open = {};
(function(exports) {
  function open$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.open$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.open";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.open$ = open$, exports.default = open$;
})(open);
var openLink = {};
(function(exports) {
  function openLink$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openLink$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.openLink", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ credible: true, showMenuBar: true });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.openLink$ = openLink$, exports.default = openLink$;
})(openLink);
var openLocalFile = {};
(function(exports) {
  function openLocalFile$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openLocalFile$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.openLocalFile";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.openLocalFile$ = openLocalFile$, exports.default = openLocalFile$;
})(openLocalFile);
var openModal = {};
(function(exports) {
  function openModal$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openModal$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.openModal";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.openModal$ = openModal$, exports.default = openModal$;
})(openModal);
var openSlidePanel = {};
(function(exports) {
  function openSlidePanel$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openSlidePanel$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.openSlidePanel";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2)), exports.openSlidePanel$ = openSlidePanel$, exports.default = openSlidePanel$;
})(openSlidePanel);
var presentWindow = {};
(function(exports) {
  function presentWindow$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.presentWindow$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.presentWindow";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.presentWindow$ = presentWindow$, exports.default = presentWindow$;
})(presentWindow);
var previewImage = {};
(function(exports) {
  function previewImage$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.previewImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.previewImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.previewImage$ = previewImage$, exports.default = previewImage$;
})(previewImage);
var previewVideo = {};
(function(exports) {
  function previewVideo$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.previewVideo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.previewVideo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.7" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.33" }, _a2)), exports.previewVideo$ = previewVideo$, exports.default = previewVideo$;
})(previewVideo);
var saveImage = {};
(function(exports) {
  function saveImage$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.saveImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.saveImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.1" }, _a2)), exports.saveImage$ = saveImage$, exports.default = saveImage$;
})(saveImage);
var scan = {};
(function(exports) {
  function scan$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.scan$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.scan", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ type: "qrCode" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.scan$ = scan$, exports.default = scan$;
})(scan);
var scanCard = {};
(function(exports) {
  function scanCard$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.scanCard$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.scanCard";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.scanCard$ = scanCard$, exports.default = scanCard$;
})(scanCard);
var setGPUAcceleration = {};
(function(exports) {
  function setGPUAcceleration$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setGPUAcceleration$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.setGPUAcceleration";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "6.0.22" }, _a2)), exports.setGPUAcceleration$ = setGPUAcceleration$, exports.default = setGPUAcceleration$;
})(setGPUAcceleration);
var setScreenBrightnessAndKeepOn = {};
(function(exports) {
  function setScreenBrightnessAndKeepOn$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setScreenBrightnessAndKeepOn$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.setScreenBrightnessAndKeepOn";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.37" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.3" }, _a2)), exports.setScreenBrightnessAndKeepOn$ = setScreenBrightnessAndKeepOn$, exports.default = setScreenBrightnessAndKeepOn$;
})(setScreenBrightnessAndKeepOn);
var setScreenKeepOn = {};
(function(exports) {
  function setScreenKeepOn$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setScreenKeepOn$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.setScreenKeepOn";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.26" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.26" }, _a2)), exports.setScreenKeepOn$ = setScreenKeepOn$, exports.default = setScreenKeepOn$;
})(setScreenKeepOn);
var share = {};
(function(exports) {
  function share$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.share$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.share", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ title: "", buttonName: "\u786E\u5B9A" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.37", paramsDeal }, _a2)), exports.share$ = share$, exports.default = share$;
})(share);
var shareImage = {};
(function(exports) {
  function shareImage$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.shareImage$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.shareImage";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.1" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.1" }, _a2)), exports.shareImage$ = shareImage$, exports.default = shareImage$;
})(shareImage);
var startDocSign = {};
(function(exports) {
  function startDocSign$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startDocSign$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.startDocSign";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.6.33" }, _a2)), exports.startDocSign$ = startDocSign$, exports.default = startDocSign$;
})(startDocSign);
var systemShare = {};
(function(exports) {
  function systemShare$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.systemShare$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.systemShare";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.11" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.11" }, _a2)), exports.systemShare$ = systemShare$, exports.default = systemShare$;
})(systemShare);
var timepicker = {};
(function(exports) {
  function timepicker$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.timepicker$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.timepicker";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.timepicker$ = timepicker$, exports.default = timepicker$;
})(timepicker);
var uploadAttachment = {};
(function(exports) {
  function uploadAttachment$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.uploadAttachment$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.uploadAttachment";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.7.0" }, _a2)), exports.uploadAttachment$ = uploadAttachment$, exports.default = uploadAttachment$;
})(uploadAttachment);
var uploadFile = {};
(function(exports) {
  function uploadFile$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.uploadFile$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.uploadFile";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.28" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.27" }, _a2)), exports.uploadFile$ = uploadFile$, exports.default = uploadFile$;
})(uploadFile);
var uploadImage = {};
(function(exports) {
  function uploadImage$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.uploadImage$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "biz.util.uploadImage", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ multiple: false });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.uploadImage$ = uploadImage$, exports.default = uploadImage$;
})(uploadImage);
var uploadImageFromCamera = {};
(function(exports) {
  function uploadImageFromCamera$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.uploadImageFromCamera$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.uploadImageFromCamera";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.uploadImageFromCamera$ = uploadImageFromCamera$, exports.default = uploadImageFromCamera$;
})(uploadImageFromCamera);
var ut = {};
(function(exports) {
  function ut$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.ut$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.util.ut", utParamsObj2Str = function(a2) {
    var d2 = Object.assign({}, a2), e2 = d2.value, t2 = [];
    if (e2 && "object" == typeof e2) {
      for (var r in e2)
        void 0 !== e2[r] && t2.push(r + "=" + e2[r]);
      e2 = t2.join(",");
    }
    return d2.value = e2 || "", d2;
  };
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.5.0", paramsDeal: utParamsObj2Str }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal: function(a2) {
    var d2 = Object.assign({}, a2), e2 = d2.value;
    return e2 && "object" == typeof e2 && (e2 = JSON.stringify(e2)), d2.value = e2, d2;
  } }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal: utParamsObj2Str }, _a2)), exports.ut$ = ut$, exports.default = ut$;
})(ut);
var openBindIDCard = {};
(function(exports) {
  function openBindIDCard$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openBindIDCard$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.verify.openBindIDCard";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.21" }, _a2)), exports.openBindIDCard$ = openBindIDCard$, exports.default = openBindIDCard$;
})(openBindIDCard);
var startAuth = {};
(function(exports) {
  function startAuth$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startAuth$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.verify.startAuth";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.5.21" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.21" }, _a2)), exports.startAuth$ = startAuth$, exports.default = startAuth$;
})(startAuth);
var getWatermarkInfo = {};
(function(exports) {
  function getWatermarkInfo$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getWatermarkInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.watermarkCamera.getWatermarkInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.25" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.25" }, _a2)), exports.getWatermarkInfo$ = getWatermarkInfo$, exports.default = getWatermarkInfo$;
})(getWatermarkInfo);
var setWatermarkInfo = {};
(function(exports) {
  function setWatermarkInfo$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setWatermarkInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "biz.watermarkCamera.setWatermarkInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.25" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.25" }, _a2)), exports.setWatermarkInfo$ = setWatermarkInfo$, exports.default = setWatermarkInfo$;
})(setWatermarkInfo);
var requestAuthCode$1 = {};
(function(exports) {
  function requestAuthCode$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestAuthCode$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "channel.permission.requestAuthCode";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.0.0" }, _a2)), exports.requestAuthCode$ = requestAuthCode$, exports.default = requestAuthCode$;
})(requestAuthCode$1);
var clearShake = {};
(function(exports) {
  function clearShake$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.clearShake$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.accelerometer.clearShake";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.clearShake$ = clearShake$, exports.default = clearShake$;
})(clearShake);
var watchShake = {};
(function(exports) {
  function watchShake$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.watchShake$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.accelerometer.watchShake";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal: function(a2) {
    return (0, apiHelper_1.forceChangeParamsDealFn)({ sensitivity: 3.2 })((0, apiHelper_1.addWatchParamsDeal)(a2));
  } }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2)), exports.watchShake$ = watchShake$, exports.default = watchShake$;
})(watchShake);
var download = {};
(function(exports) {
  function download$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.download$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.download";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.download$ = download$, exports.default = download$;
})(download);
var onPlayEnd = {};
(function(exports) {
  function onPlayEnd$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.onPlayEnd$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.onPlayEnd";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.onPlayEnd$ = onPlayEnd$, exports.default = onPlayEnd$;
})(onPlayEnd);
var onRecordEnd = {};
(function(exports) {
  function onRecordEnd$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.onRecordEnd$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.onRecordEnd";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.onRecordEnd$ = onRecordEnd$, exports.default = onRecordEnd$;
})(onRecordEnd);
var pause$1 = {};
(function(exports) {
  function pause$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pause$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.pause";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.pause$ = pause$, exports.default = pause$;
})(pause$1);
var play = {};
(function(exports) {
  function play$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.play$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.play";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.play$ = play$, exports.default = play$;
})(play);
var resume$1 = {};
(function(exports) {
  function resume$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.resume$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.resume";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.resume$ = resume$, exports.default = resume$;
})(resume$1);
var startRecord = {};
(function(exports) {
  function startRecord$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.startRecord$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.startRecord";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.startRecord$ = startRecord$, exports.default = startRecord$;
})(startRecord);
var stop$3 = {};
(function(exports) {
  function stop$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop$3);
var stopRecord = {};
(function(exports) {
  function stopRecord$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stopRecord$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.stopRecord";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.stopRecord$ = stopRecord$, exports.default = stopRecord$;
})(stopRecord);
var translateVoice = {};
(function(exports) {
  function translateVoice$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.translateVoice$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.audio.translateVoice";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.8.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.8.0" }, _a2)), exports.translateVoice$ = translateVoice$, exports.default = translateVoice$;
})(translateVoice);
var getInterface = {};
(function(exports) {
  function getInterface$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getInterface$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getInterface";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.getInterface$ = getInterface$, exports.default = getInterface$;
})(getInterface);
var getPhoneInfo = {};
(function(exports) {
  function getPhoneInfo$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getPhoneInfo$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getPhoneInfo";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.5.0" }, _a2)), exports.getPhoneInfo$ = getPhoneInfo$, exports.default = getPhoneInfo$;
})(getPhoneInfo);
var getUUID = {};
(function(exports) {
  function getUUID$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getUUID$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getUUID";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.7.6" }, _a2)), exports.getUUID$ = getUUID$, exports.default = getUUID$;
})(getUUID);
var getWifiStatus = {};
(function(exports) {
  function getWifiStatus$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getWifiStatus$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.getWifiStatus";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.11.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.11.0" }, _a2)), exports.getWifiStatus$ = getWifiStatus$, exports.default = getWifiStatus$;
})(getWifiStatus);
var openSystemSetting = {};
(function(exports) {
  function openSystemSetting$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.openSystemSetting$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.base.openSystemSetting";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.27" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.15" }, _a2)), exports.openSystemSetting$ = openSystemSetting$, exports.default = openSystemSetting$;
})(openSystemSetting);
var getNetworkType = {};
(function(exports) {
  function getNetworkType$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getNetworkType$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.connection.getNetworkType";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.getNetworkType$ = getNetworkType$, exports.default = getNetworkType$;
})(getNetworkType);
var checkPermission = {};
(function(exports) {
  function checkPermission$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkPermission$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.checkPermission";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.0" }, _a2)), exports.checkPermission$ = checkPermission$, exports.default = checkPermission$;
})(checkPermission);
var get = {};
(function(exports) {
  function get$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.get$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.get";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.get$ = get$, exports.default = get$;
})(get);
var start$2 = {};
(function(exports) {
  function start$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.start$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.start";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.7" }, _a2)), exports.start$ = start$, exports.default = start$;
})(start$2);
var status = {};
(function(exports) {
  function status$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.status$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.status";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.8" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.8" }, _a2)), exports.status$ = status$, exports.default = status$;
})(status);
var stop$2 = {};
(function(exports) {
  function stop$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.geolocation.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.4.7" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.4.7" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop$2);
var checkInstalledApps = {};
(function(exports) {
  function checkInstalledApps$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.checkInstalledApps$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.launcher.checkInstalledApps";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.checkInstalledApps$ = checkInstalledApps$, exports.default = checkInstalledApps$;
})(checkInstalledApps);
var launchApp = {};
(function(exports) {
  function launchApp$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.launchApp$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.launcher.launchApp";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.launchApp$ = launchApp$, exports.default = launchApp$;
})(launchApp);
var nfcRead = {};
(function(exports) {
  function nfcRead$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.nfcRead$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.nfc.nfcRead";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.11.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.11.0" }, _a2)), exports.nfcRead$ = nfcRead$, exports.default = nfcRead$;
})(nfcRead);
var nfcStop = {};
(function(exports) {
  function nfcStop$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.nfcStop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.nfc.nfcStop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.3.9" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.3.9" }, _a2)), exports.nfcStop$ = nfcStop$, exports.default = nfcStop$;
})(nfcStop);
var nfcWrite = {};
(function(exports) {
  function nfcWrite$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.nfcWrite$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.nfc.nfcWrite";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.11.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.11.0" }, _a2)), exports.nfcWrite$ = nfcWrite$, exports.default = nfcWrite$;
})(nfcWrite);
var actionSheet = {};
(function(exports) {
  function actionSheet$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.actionSheet$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.actionSheet";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.actionSheet$ = actionSheet$, exports.default = actionSheet$;
})(actionSheet);
var alert$1 = {};
(function(exports) {
  function alert$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.alert$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.alert", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ title: "", buttonName: "\u786E\u5B9A" });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.alert$ = alert$, exports.default = alert$;
})(alert$1);
var confirm = {};
(function(exports) {
  function confirm$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.confirm$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.confirm", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ title: "", buttonLabels: ["\u786E\u5B9A", "\u53D6\u6D88"] });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.confirm$ = confirm$, exports.default = confirm$;
})(confirm);
var extendModal = {};
(function(exports) {
  function extendModal$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.extendModal$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.extendModal";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.5.0" }, _a2)), exports.extendModal$ = extendModal$, exports.default = extendModal$;
})(extendModal);
var hidePreloader = {};
(function(exports) {
  function hidePreloader$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.hidePreloader$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.hidePreloader";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.hidePreloader$ = hidePreloader$, exports.default = hidePreloader$;
})(hidePreloader);
var modal = {};
(function(exports) {
  function modal$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.modal$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.notification.modal";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.2.5" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.modal$ = modal$, exports.default = modal$;
})(modal);
var prompt = {};
(function(exports) {
  function prompt$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.prompt$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.prompt", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ title: "", buttonLabels: ["\u786E\u5B9A", "\u53D6\u6D88"] });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.7.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.prompt$ = prompt$, exports.default = prompt$;
})(prompt);
var showPreloader = {};
(function(exports) {
  function showPreloader$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.showPreloader$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.showPreloader", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ text: "\u52A0\u8F7D\u4E2D...", showIcon: true });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.showPreloader$ = showPreloader$, exports.default = showPreloader$;
})(showPreloader);
var toast = {};
(function(exports) {
  function toast$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.toast$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.toast", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ text: "toast", duration: 3, delay: 0 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "2.5.0", paramsDeal: function(a2) {
    return a2.icon && !a2.type && ("success" === a2.icon ? a2.type = "success" : "error" === a2.icon && (a2.type = "error")), a2;
  } }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.toast$ = toast$, exports.default = toast$;
})(toast);
var vibrate = {};
(function(exports) {
  function vibrate$(a2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, a2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.vibrate$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "device.notification.vibrate", paramsDeal = (0, apiHelper_1.genDefaultParamsDealFn)({ duration: 300 });
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal }, _a2)), exports.vibrate$ = vibrate$, exports.default = vibrate$;
})(vibrate);
var insetAdjust = {};
(function(exports) {
  function insetAdjust$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.insetAdjust$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.screen.insetAdjust";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.6.18" }, _a2)), exports.insetAdjust$ = insetAdjust$, exports.default = insetAdjust$;
})(insetAdjust);
var resetView = {};
(function(exports) {
  function resetView$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.resetView$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.screen.resetView";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.0.0" }, _a2)), exports.resetView$ = resetView$, exports.default = resetView$;
})(resetView);
var rotateView = {};
(function(exports) {
  function rotateView$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.rotateView$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "device.screen.rotateView";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "4.0.0" }, _a2)), exports.rotateView$ = rotateView$, exports.default = rotateView$;
})(rotateView);
var keepAlive = {};
(function(exports) {
  function keepAlive$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.keepAlive$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.keepAlive";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.keepAlive$ = keepAlive$, exports.default = keepAlive$;
})(keepAlive);
var pause = {};
(function(exports) {
  function pause$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.pause$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.pause";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.pause$ = pause$, exports.default = pause$;
})(pause);
var resume = {};
(function(exports) {
  function resume$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.resume$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.resume";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.resume$ = resume$, exports.default = resume$;
})(resume);
var start$1 = {};
(function(exports) {
  function start$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.start$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.start";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.start$ = start$, exports.default = start$;
})(start$1);
var stop$1 = {};
(function(exports) {
  function stop$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "media.voiceRecorder.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "5.1.12" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "5.1.12" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop$1);
var loginGovNet = {};
(function(exports) {
  function loginGovNet$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.loginGovNet$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "net.bjGovApn.loginGovNet";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "4.5.16" }, _a2)), exports.loginGovNet$ = loginGovNet$, exports.default = loginGovNet$;
})(loginGovNet);
var fetch = {};
(function(exports) {
  function fetch$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.fetch$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.message.fetch";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.fetch$ = fetch$, exports.default = fetch$;
})(fetch);
var post = {};
(function(exports) {
  function post$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.post$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.message.post";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.post$ = post$, exports.default = post$;
})(post);
var getLoadTime = {};
(function(exports) {
  function getLoadTime$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getLoadTime$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.monitor.getLoadTime";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.0.10" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.0.10" }, _a2)), exports.getLoadTime$ = getLoadTime$, exports.default = getLoadTime$;
})(getLoadTime);
var requestAuthCode = {};
(function(exports) {
  function requestAuthCode$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestAuthCode$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.permission.requestAuthCode", paramsDeal = function(e2) {
    return Object.assign(e2, { url: location.href.split("#")[0] });
  };
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.0.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.requestAuthCode$ = requestAuthCode$, exports.default = requestAuthCode$;
})(requestAuthCode);
var requestOperateAuthCode = {};
(function(exports) {
  function requestOperateAuthCode$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.requestOperateAuthCode$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "runtime.permission.requestOperateAuthCode", paramsDeal = function(e2) {
    return Object.assign(e2, { url: location.href.split("#")[0] });
  };
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "3.3.0", paramsDeal }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "3.3.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "3.3.0" }, _a2)), exports.requestOperateAuthCode$ = requestOperateAuthCode$, exports.default = requestOperateAuthCode$;
})(requestOperateAuthCode);
var plain = {};
(function(exports) {
  function plain$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.plain$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.input.plain";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.plain$ = plain$, exports.default = plain$;
})(plain);
var addToFloat = {};
(function(exports) {
  function addToFloat$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.addToFloat$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.multitask.addToFloat";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.0" }, _a2)), exports.addToFloat$ = addToFloat$, exports.default = addToFloat$;
})(addToFloat);
var removeFromFloat = {};
(function(exports) {
  function removeFromFloat$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.removeFromFloat$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.multitask.removeFromFloat";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.5.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.5.0" }, _a2)), exports.removeFromFloat$ = removeFromFloat$, exports.default = removeFromFloat$;
})(removeFromFloat);
var close = {};
(function(exports) {
  function close$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.close$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.close";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.close$ = close$, exports.default = close$;
})(close);
var getCurrentId = {};
(function(exports) {
  function getCurrentId$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getCurrentId$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.getCurrentId";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.getCurrentId$ = getCurrentId$, exports.default = getCurrentId$;
})(getCurrentId);
var go = {};
(function(exports) {
  function go$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.go$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.go";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.go$ = go$, exports.default = go$;
})(go);
var preload = {};
(function(exports) {
  function preload$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.preload$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.preload";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.preload$ = preload$, exports.default = preload$;
})(preload);
var recycle = {};
(function(exports) {
  function recycle$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.recycle$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.nav.recycle";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.6.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.6.0" }, _a2)), exports.recycle$ = recycle$, exports.default = recycle$;
})(recycle);
var setColors = {};
(function(exports) {
  function setColors$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setColors$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.progressBar.setColors";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.setColors$ = setColors$, exports.default = setColors$;
})(setColors);
var disable$1 = {};
(function(exports) {
  function disable$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.disable$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.pullToRefresh.disable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.disable$ = disable$, exports.default = disable$;
})(disable$1);
var enable$1 = {};
(function(exports) {
  function enable$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.enable$ = void 0;
  var ddSdk_12 = ddSdk, apiHelper_1 = apiHelper, apiName = "ui.pullToRefresh.enable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0", paramsDeal: apiHelper_1.addWatchParamsDeal }, _a2)), exports.enable$ = enable$, exports.default = enable$;
})(enable$1);
var stop = {};
(function(exports) {
  function stop$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.stop$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.pullToRefresh.stop";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.stop$ = stop$, exports.default = stop$;
})(stop);
var disable = {};
(function(exports) {
  function disable$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.disable$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.webViewBounce.disable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.disable$ = disable$, exports.default = disable$;
})(disable);
var enable = {};
(function(exports) {
  function enable$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.enable$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "ui.webViewBounce.enable";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.4.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.4.0" }, _a2)), exports.enable$ = enable$, exports.default = enable$;
})(enable);
var getItem = {};
(function(exports) {
  function getItem$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getItem$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.domainStorage.getItem";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.29" }, _a2)), exports.getItem$ = getItem$, exports.default = getItem$;
})(getItem);
var removeItem = {};
(function(exports) {
  function removeItem$(e2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, e2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.removeItem$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.domainStorage.removeItem";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.29" }, _a2)), exports.removeItem$ = removeItem$, exports.default = removeItem$;
})(removeItem);
var setItem = {};
(function(exports) {
  function setItem$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.setItem$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.domainStorage.setItem";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.harmony] = { vs: "7.0.0" }, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "2.9.0" }, _a2[ddSdk_12.ENV_ENUM.pc] = { vs: "4.6.9" }, _a2)), exports.setItem$ = setItem$, exports.default = setItem$;
})(setItem);
var getData = {};
(function(exports) {
  function getData$(d2) {
    return ddSdk_12.ddSdk.invokeAPI(apiName, d2);
  }
  var _a2;
  Object.defineProperty(exports, "__esModule", { value: true }), exports.getData$ = void 0;
  var ddSdk_12 = ddSdk, apiName = "util.openTemporary.getData";
  ddSdk_12.ddSdk.setAPI(apiName, (_a2 = {}, _a2[ddSdk_12.ENV_ENUM.ios] = { vs: "6.3.15" }, _a2[ddSdk_12.ENV_ENUM.android] = { vs: "6.3.15" }, _a2)), exports.getData$ = getData$, exports.default = getData$;
})(getData);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.apiObj = void 0;
  var beaconPicker_1 = beaconPicker, detectFace_1 = detectFace, detectFaceFullScreen_1 = detectFaceFullScreen, faceManager_1 = faceManager, punchModePicker_1 = punchModePicker, bindAlipay_1 = bindAlipay, openAuth_1 = openAuth, pay_1 = pay, openAccountPwdLoginPage_1 = openAccountPwdLoginPage, requestAuthInfo_1 = requestAuthInfo, chooseDateTime_1 = chooseDateTime, chooseHalfDay_1 = chooseHalfDay, chooseInterval_1 = chooseInterval, chooseOneDay_1 = chooseOneDay, chooseConversationByCorpId_1 = chooseConversationByCorpId, collectSticker_1 = collectSticker, createSceneGroup_1 = createSceneGroup, getRealmCid_1 = getRealmCid, locationChatMessage_1 = locationChatMessage, openSingleChat_1 = openSingleChat, pickConversation_1 = pickConversation, sendEmotion_1 = sendEmotion, toConversation_1 = toConversation, toConversationByOpenConversationId_1 = toConversationByOpenConversationId, setData_1 = setData, createCloudCall_1 = createCloudCall, getCloudCallInfo_1 = getCloudCallInfo, getCloudCallList_1 = getCloudCallList, videoConfCall_1 = videoConfCall, choose_1 = choose$1, chooseMobileContacts_1 = chooseMobileContacts, complexPicker_1 = complexPicker, createGroup_1 = createGroup$1, departmentsPicker_1 = departmentsPicker, externalComplexPicker_1 = externalComplexPicker, externalEditForm_1 = externalEditForm, rolesPicker_1 = rolesPicker, setRule_1 = setRule, chooseSpaceDir_1 = chooseSpaceDir, delete_1 = _delete, preview_1 = preview, saveFile_1 = saveFile, choose_2 = choose, multipleChoose_1 = multipleChoose, create_1 = create, post_1 = post$1, finishMiniCourseByRecordId_1 = finishMiniCourseByRecordId, getMiniCourseDraftList_1 = getMiniCourseDraftList, joinClassroom_1 = joinClassroom, makeMiniCourse_1 = makeMiniCourse, newMsgNotificationStatus_1 = newMsgNotificationStatus, startAuth_1 = startAuth$1, tokenFaceImg_1 = tokenFaceImg, notifyWeex_1 = notifyWeex, fetchData_1 = fetchData, bind_1 = bind$1, bindMeetingRoom_1 = bindMeetingRoom, getDeviceProperties_1 = getDeviceProperties, invokeThingService_1 = invokeThingService, queryMeetingRoomList_1 = queryMeetingRoomList, setDeviceProperties_1 = setDeviceProperties, unbind_1 = unbind$1, startClassRoom_1 = startClassRoom, startUnifiedLive_1 = startUnifiedLive, locate_1 = locate, search_1 = search, view_1 = view, compressVideo_1 = compressVideo, openApp_1 = openApp, close_1 = close$1, goBack_1 = goBack, hideBar_1 = hideBar, navigateToMiniProgram_1 = navigateToMiniProgram, quit_1 = quit, replace_1 = replace, setIcon_1 = setIcon, setLeft_1 = setLeft, setMenu_1 = setMenu, setRight_1 = setRight, setTitle_1 = setTitle, componentPunchFromPartner_1 = componentPunchFromPartner, startMatchRuleFromPartner_1 = startMatchRuleFromPartner, stopMatchRuleFromPartner_1 = stopMatchRuleFromPartner, getRealtimeTracingStatus_1 = getRealtimeTracingStatus, getUserExclusiveInfo_1 = getUserExclusiveInfo, startRealtimeTracing_1 = startRealtimeTracing, stopRealtimeTracing_1 = stopRealtimeTracing, subscribe_1 = subscribe2, unsubscribe_1 = unsubscribe2, getInfo_1 = getInfo, reportDebugMessage_1 = reportDebugMessage, addShortCut_1 = addShortCut, closeUnpayOrder_1 = closeUnpayOrder, createOrder_1 = createOrder, getPayUrl_1 = getPayUrl, inquiry_1 = inquiry, isTab_1 = isTab, call_1 = call, checkBizCall_1 = checkBizCall, quickCallList_1 = quickCallList, showCallMenu_1 = showCallMenu, checkPassword_1 = checkPassword, get_12 = get$1, callComponent_1 = callComponent, chooseImage_1 = chooseImage, chosen_1 = chosen, clearWebStoreCache_1 = clearWebStoreCache, closePreviewImage_1 = closePreviewImage, compressImage_1 = compressImage, datepicker_1 = datepicker, datetimepicker_1 = datetimepicker, decrypt_1 = decrypt, downloadFile_1 = downloadFile, encrypt_1 = encrypt, getPerfInfo_1 = getPerfInfo, invokeWorkbench_1 = invokeWorkbench, isEnableGPUAcceleration_1 = isEnableGPUAcceleration, isLocalFileExist_1 = isLocalFileExist, multiSelect_1 = multiSelect, open_1 = open, openLink_1 = openLink, openLocalFile_1 = openLocalFile, openModal_1 = openModal, openSlidePanel_1 = openSlidePanel, presentWindow_1 = presentWindow, previewImage_1 = previewImage, previewVideo_1 = previewVideo, saveImage_1 = saveImage, scan_1 = scan, scanCard_1 = scanCard, setGPUAcceleration_1 = setGPUAcceleration, setScreenBrightnessAndKeepOn_1 = setScreenBrightnessAndKeepOn, setScreenKeepOn_1 = setScreenKeepOn, share_1 = share, shareImage_1 = shareImage, startDocSign_1 = startDocSign, systemShare_1 = systemShare, timepicker_1 = timepicker, uploadAttachment_1 = uploadAttachment, uploadFile_1 = uploadFile, uploadImage_1 = uploadImage, uploadImageFromCamera_1 = uploadImageFromCamera, ut_1 = ut, openBindIDCard_1 = openBindIDCard, startAuth_2 = startAuth, getWatermarkInfo_1 = getWatermarkInfo, setWatermarkInfo_1 = setWatermarkInfo, requestAuthCode_1 = requestAuthCode$1, clearShake_1 = clearShake, watchShake_1 = watchShake, download_1 = download, onPlayEnd_1 = onPlayEnd, onRecordEnd_1 = onRecordEnd, pause_1 = pause$1, play_1 = play, resume_1 = resume$1, startRecord_1 = startRecord, stop_1 = stop$3, stopRecord_1 = stopRecord, translateVoice_1 = translateVoice, getInterface_1 = getInterface, getPhoneInfo_1 = getPhoneInfo, getUUID_1 = getUUID, getWifiStatus_1 = getWifiStatus, openSystemSetting_1 = openSystemSetting, getNetworkType_1 = getNetworkType, checkPermission_1 = checkPermission, get_2 = get, start_1 = start$2, status_1 = status, stop_2 = stop$2, checkInstalledApps_1 = checkInstalledApps, launchApp_1 = launchApp, nfcRead_1 = nfcRead, nfcStop_1 = nfcStop, nfcWrite_1 = nfcWrite, actionSheet_1 = actionSheet, alert_1 = alert$1, confirm_1 = confirm, extendModal_1 = extendModal, hidePreloader_1 = hidePreloader, modal_1 = modal, prompt_1 = prompt, showPreloader_1 = showPreloader, toast_1 = toast, vibrate_1 = vibrate, insetAdjust_1 = insetAdjust, resetView_1 = resetView, rotateView_1 = rotateView, keepAlive_1 = keepAlive, pause_2 = pause, resume_2 = resume, start_2 = start$1, stop_3 = stop$1, loginGovNet_1 = loginGovNet, fetch_1 = fetch, post_2 = post, getLoadTime_1 = getLoadTime, requestAuthCode_2 = requestAuthCode, requestOperateAuthCode_1 = requestOperateAuthCode, plain_1 = plain, addToFloat_1 = addToFloat, removeFromFloat_1 = removeFromFloat, close_2 = close, getCurrentId_1 = getCurrentId, go_1 = go, preload_1 = preload, recycle_1 = recycle, setColors_1 = setColors, disable_1 = disable$1, enable_1 = enable$1, stop_4 = stop, disable_2 = disable, enable_2 = enable, getItem_1 = getItem, removeItem_1 = removeItem, setItem_1 = setItem, getData_1 = getData;
  exports.apiObj = { biz: { ATMBle: { beaconPicker: beaconPicker_1.beaconPicker$, detectFace: detectFace_1.detectFace$, detectFaceFullScreen: detectFaceFullScreen_1.detectFaceFullScreen$, faceManager: faceManager_1.faceManager$, punchModePicker: punchModePicker_1.punchModePicker$ }, alipay: { bindAlipay: bindAlipay_1.bindAlipay$, openAuth: openAuth_1.openAuth$, pay: pay_1.pay$ }, auth: { openAccountPwdLoginPage: openAccountPwdLoginPage_1.openAccountPwdLoginPage$, requestAuthInfo: requestAuthInfo_1.requestAuthInfo$ }, calendar: { chooseDateTime: chooseDateTime_1.chooseDateTime$, chooseHalfDay: chooseHalfDay_1.chooseHalfDay$, chooseInterval: chooseInterval_1.chooseInterval$, chooseOneDay: chooseOneDay_1.chooseOneDay$ }, chat: { chooseConversationByCorpId: chooseConversationByCorpId_1.chooseConversationByCorpId$, collectSticker: collectSticker_1.collectSticker$, createSceneGroup: createSceneGroup_1.createSceneGroup$, getRealmCid: getRealmCid_1.getRealmCid$, locationChatMessage: locationChatMessage_1.locationChatMessage$, openSingleChat: openSingleChat_1.openSingleChat$, pickConversation: pickConversation_1.pickConversation$, sendEmotion: sendEmotion_1.sendEmotion$, toConversation: toConversation_1.toConversation$, toConversationByOpenConversationId: toConversationByOpenConversationId_1.toConversationByOpenConversationId$ }, clipboardData: { setData: setData_1.setData$ }, conference: { createCloudCall: createCloudCall_1.createCloudCall$, getCloudCallInfo: getCloudCallInfo_1.getCloudCallInfo$, getCloudCallList: getCloudCallList_1.getCloudCallList$, videoConfCall: videoConfCall_1.videoConfCall$ }, contact: { choose: choose_1.choose$, chooseMobileContacts: chooseMobileContacts_1.chooseMobileContacts$, complexPicker: complexPicker_1.complexPicker$, createGroup: createGroup_1.createGroup$, departmentsPicker: departmentsPicker_1.departmentsPicker$, externalComplexPicker: externalComplexPicker_1.externalComplexPicker$, externalEditForm: externalEditForm_1.externalEditForm$, rolesPicker: rolesPicker_1.rolesPicker$, setRule: setRule_1.setRule$ }, cspace: { chooseSpaceDir: chooseSpaceDir_1.chooseSpaceDir$, delete: delete_1.delete$, preview: preview_1.preview$, saveFile: saveFile_1.saveFile$ }, customContact: { choose: choose_2.choose$, multipleChoose: multipleChoose_1.multipleChoose$ }, ding: { create: create_1.create$, post: post_1.post$ }, edu: { finishMiniCourseByRecordId: finishMiniCourseByRecordId_1.finishMiniCourseByRecordId$, getMiniCourseDraftList: getMiniCourseDraftList_1.getMiniCourseDraftList$, joinClassroom: joinClassroom_1.joinClassroom$, makeMiniCourse: makeMiniCourse_1.makeMiniCourse$, newMsgNotificationStatus: newMsgNotificationStatus_1.newMsgNotificationStatus$, startAuth: startAuth_1.startAuth$, tokenFaceImg: tokenFaceImg_1.tokenFaceImg$ }, event: { notifyWeex: notifyWeex_1.notifyWeex$ }, intent: { fetchData: fetchData_1.fetchData$ }, iot: { bind: bind_1.bind$, bindMeetingRoom: bindMeetingRoom_1.bindMeetingRoom$, getDeviceProperties: getDeviceProperties_1.getDeviceProperties$, invokeThingService: invokeThingService_1.invokeThingService$, queryMeetingRoomList: queryMeetingRoomList_1.queryMeetingRoomList$, setDeviceProperties: setDeviceProperties_1.setDeviceProperties$, unbind: unbind_1.unbind$ }, live: { startClassRoom: startClassRoom_1.startClassRoom$, startUnifiedLive: startUnifiedLive_1.startUnifiedLive$ }, map: { locate: locate_1.locate$, search: search_1.search$, view: view_1.view$ }, media: { compressVideo: compressVideo_1.compressVideo$ }, microApp: { openApp: openApp_1.openApp$ }, navigation: { close: close_1.close$, goBack: goBack_1.goBack$, hideBar: hideBar_1.hideBar$, navigateToMiniProgram: navigateToMiniProgram_1.navigateToMiniProgram$, quit: quit_1.quit$, replace: replace_1.replace$, setIcon: setIcon_1.setIcon$, setLeft: setLeft_1.setLeft$, setMenu: setMenu_1.setMenu$, setRight: setRight_1.setRight$, setTitle: setTitle_1.setTitle$ }, pbp: { componentPunchFromPartner: componentPunchFromPartner_1.componentPunchFromPartner$, startMatchRuleFromPartner: startMatchRuleFromPartner_1.startMatchRuleFromPartner$, stopMatchRuleFromPartner: stopMatchRuleFromPartner_1.stopMatchRuleFromPartner$ }, realm: { getRealtimeTracingStatus: getRealtimeTracingStatus_1.getRealtimeTracingStatus$, getUserExclusiveInfo: getUserExclusiveInfo_1.getUserExclusiveInfo$, startRealtimeTracing: startRealtimeTracing_1.startRealtimeTracing$, stopRealtimeTracing: stopRealtimeTracing_1.stopRealtimeTracing$, subscribe: subscribe_1.subscribe$, unsubscribe: unsubscribe_1.unsubscribe$ }, resource: { getInfo: getInfo_1.getInfo$, reportDebugMessage: reportDebugMessage_1.reportDebugMessage$ }, shortCut: { addShortCut: addShortCut_1.addShortCut$ }, store: { closeUnpayOrder: closeUnpayOrder_1.closeUnpayOrder$, createOrder: createOrder_1.createOrder$, getPayUrl: getPayUrl_1.getPayUrl$, inquiry: inquiry_1.inquiry$ }, tabwindow: { isTab: isTab_1.isTab$ }, telephone: { call: call_1.call$, checkBizCall: checkBizCall_1.checkBizCall$, quickCallList: quickCallList_1.quickCallList$, showCallMenu: showCallMenu_1.showCallMenu$ }, user: { checkPassword: checkPassword_1.checkPassword$, get: get_12.get$ }, util: { callComponent: callComponent_1.callComponent$, chooseImage: chooseImage_1.chooseImage$, chosen: chosen_1.chosen$, clearWebStoreCache: clearWebStoreCache_1.clearWebStoreCache$, closePreviewImage: closePreviewImage_1.closePreviewImage$, compressImage: compressImage_1.compressImage$, datepicker: datepicker_1.datepicker$, datetimepicker: datetimepicker_1.datetimepicker$, decrypt: decrypt_1.decrypt$, downloadFile: downloadFile_1.downloadFile$, encrypt: encrypt_1.encrypt$, getPerfInfo: getPerfInfo_1.getPerfInfo$, invokeWorkbench: invokeWorkbench_1.invokeWorkbench$, isEnableGPUAcceleration: isEnableGPUAcceleration_1.isEnableGPUAcceleration$, isLocalFileExist: isLocalFileExist_1.isLocalFileExist$, multiSelect: multiSelect_1.multiSelect$, open: open_1.open$, openLink: openLink_1.openLink$, openLocalFile: openLocalFile_1.openLocalFile$, openModal: openModal_1.openModal$, openSlidePanel: openSlidePanel_1.openSlidePanel$, presentWindow: presentWindow_1.presentWindow$, previewImage: previewImage_1.previewImage$, previewVideo: previewVideo_1.previewVideo$, saveImage: saveImage_1.saveImage$, scan: scan_1.scan$, scanCard: scanCard_1.scanCard$, setGPUAcceleration: setGPUAcceleration_1.setGPUAcceleration$, setScreenBrightnessAndKeepOn: setScreenBrightnessAndKeepOn_1.setScreenBrightnessAndKeepOn$, setScreenKeepOn: setScreenKeepOn_1.setScreenKeepOn$, share: share_1.share$, shareImage: shareImage_1.shareImage$, startDocSign: startDocSign_1.startDocSign$, systemShare: systemShare_1.systemShare$, timepicker: timepicker_1.timepicker$, uploadAttachment: uploadAttachment_1.uploadAttachment$, uploadFile: uploadFile_1.uploadFile$, uploadImage: uploadImage_1.uploadImage$, uploadImageFromCamera: uploadImageFromCamera_1.uploadImageFromCamera$, ut: ut_1.ut$ }, verify: { openBindIDCard: openBindIDCard_1.openBindIDCard$, startAuth: startAuth_2.startAuth$ }, watermarkCamera: { getWatermarkInfo: getWatermarkInfo_1.getWatermarkInfo$, setWatermarkInfo: setWatermarkInfo_1.setWatermarkInfo$ } }, channel: { permission: { requestAuthCode: requestAuthCode_1.requestAuthCode$ } }, device: { accelerometer: { clearShake: clearShake_1.clearShake$, watchShake: watchShake_1.watchShake$ }, audio: { download: download_1.download$, onPlayEnd: onPlayEnd_1.onPlayEnd$, onRecordEnd: onRecordEnd_1.onRecordEnd$, pause: pause_1.pause$, play: play_1.play$, resume: resume_1.resume$, startRecord: startRecord_1.startRecord$, stop: stop_1.stop$, stopRecord: stopRecord_1.stopRecord$, translateVoice: translateVoice_1.translateVoice$ }, base: { getInterface: getInterface_1.getInterface$, getPhoneInfo: getPhoneInfo_1.getPhoneInfo$, getUUID: getUUID_1.getUUID$, getWifiStatus: getWifiStatus_1.getWifiStatus$, openSystemSetting: openSystemSetting_1.openSystemSetting$ }, connection: { getNetworkType: getNetworkType_1.getNetworkType$ }, geolocation: { checkPermission: checkPermission_1.checkPermission$, get: get_2.get$, start: start_1.start$, status: status_1.status$, stop: stop_2.stop$ }, launcher: { checkInstalledApps: checkInstalledApps_1.checkInstalledApps$, launchApp: launchApp_1.launchApp$ }, nfc: { nfcRead: nfcRead_1.nfcRead$, nfcStop: nfcStop_1.nfcStop$, nfcWrite: nfcWrite_1.nfcWrite$ }, notification: { actionSheet: actionSheet_1.actionSheet$, alert: alert_1.alert$, confirm: confirm_1.confirm$, extendModal: extendModal_1.extendModal$, hidePreloader: hidePreloader_1.hidePreloader$, modal: modal_1.modal$, prompt: prompt_1.prompt$, showPreloader: showPreloader_1.showPreloader$, toast: toast_1.toast$, vibrate: vibrate_1.vibrate$ }, screen: { insetAdjust: insetAdjust_1.insetAdjust$, resetView: resetView_1.resetView$, rotateView: rotateView_1.rotateView$ } }, media: { voiceRecorder: { keepAlive: keepAlive_1.keepAlive$, pause: pause_2.pause$, resume: resume_2.resume$, start: start_2.start$, stop: stop_3.stop$ } }, net: { bjGovApn: { loginGovNet: loginGovNet_1.loginGovNet$ } }, runtime: { message: { fetch: fetch_1.fetch$, post: post_2.post$ }, monitor: { getLoadTime: getLoadTime_1.getLoadTime$ }, permission: { requestAuthCode: requestAuthCode_2.requestAuthCode$, requestOperateAuthCode: requestOperateAuthCode_1.requestOperateAuthCode$ } }, ui: { input: { plain: plain_1.plain$ }, multitask: { addToFloat: addToFloat_1.addToFloat$, removeFromFloat: removeFromFloat_1.removeFromFloat$ }, nav: { close: close_2.close$, getCurrentId: getCurrentId_1.getCurrentId$, go: go_1.go$, preload: preload_1.preload$, recycle: recycle_1.recycle$ }, progressBar: { setColors: setColors_1.setColors$ }, pullToRefresh: { disable: disable_1.disable$, enable: enable_1.enable$, stop: stop_4.stop$ }, webViewBounce: { disable: disable_2.disable$, enable: enable_2.enable$ } }, util: { domainStorage: { getItem: getItem_1.getItem$, removeItem: removeItem_1.removeItem$, setItem: setItem_1.setItem$ }, openTemporary: { getData: getData_1.getData$ } } };
})(apiObj);
var plugin$1 = {};
var coolAppSdk = {};
var installToGroup = {};
var mobile = { exports: {} };
var dd$2 = core_1;
mobile.exports = dd$2;
var utils = {};
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.isMobile = void 0;
  var env_12 = env$1, dingtalkEnv = (0, env_12.getENV)(), isAndroidDingTalk = function() {
    return dingtalkEnv.platform === env_12.ENV_ENUM.android;
  }, isIOSDingTalk = function() {
    return dingtalkEnv.platform === env_12.ENV_ENUM.ios;
  }, isHarmonyDingTalk = function() {
    return dingtalkEnv.platform === env_12.ENV_ENUM.harmony;
  };
  exports.isMobile = isIOSDingTalk() || isAndroidDingTalk() || isHarmonyDingTalk();
})(utils);
(function(exports) {
  function installCoolAppToGroup(o2) {
    return (0, mobile_1._invoke)("biz.util.callComponent", { componentType: "h5", params: { url: "/resource-picker/".concat(utils_1.isMobile ? "mob" : "index", ".html?scene=addCoolAppToGroup&params=").concat(encodeURIComponent(JSON.stringify(o2))), target: utils_1.isMobile ? "" : "float", title: "\u9009\u62E9\u7FA4\u6DFB\u52A0\u5E94\u7528", wnId: "addCoolAppToGroup", panelHeight: "percent90" } });
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.installCoolAppToGroup = void 0;
  var mobile_1 = mobile.exports, utils_1 = utils;
  exports.installCoolAppToGroup = installCoolAppToGroup;
})(installToGroup);
var sendMessageToGroup = {};
(function(exports) {
  function sendMessageToGroup2(e2) {
    var o2, n = JSON.stringify(e2).length;
    return (0, mobile_1._invoke)("biz.util.callComponent", { componentType: "h5", params: { url: "/im/cool-app-component.html?corpId=".concat(encodeURIComponent(null === (o2 = null === e2 || void 0 === e2 ? void 0 : e2.context) || void 0 === o2 ? void 0 : o2.corpId), "#/send-message?params=").concat(encodeURIComponent(JSON.stringify({ body: e2, bodyLengthList: [n] }))), target: "float", title: "\u63D0\u793A", wnId: "sendMessageToGroup", panelHeight: "percent83" } });
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.sendMessageToGroup = void 0;
  var mobile_1 = mobile.exports;
  exports.sendMessageToGroup = sendMessageToGroup2;
})(sendMessageToGroup);
var createGroup = {};
(function(exports) {
  function createGroup2(e2) {
    var o2;
    return (0, mobile_1._invoke)("biz.util.callComponent", { componentType: "h5", params: { url: "/im/cool-app-component.html?corpId=".concat(encodeURIComponent(null === (o2 = null === e2 || void 0 === e2 ? void 0 : e2.context) || void 0 === o2 ? void 0 : o2.corpId), "#/create-group?params=").concat(encodeURIComponent(JSON.stringify(e2))), target: "float", title: "\u63D0\u793A", wnId: "createGroup", panelHeight: "percent83" } });
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.createGroup = void 0;
  var mobile_1 = mobile.exports;
  exports.createGroup = createGroup2;
})(createGroup);
var addMembers = {};
(function(exports) {
  function addMembers2(e2) {
    var o2;
    return (0, mobile_1._invoke)("biz.util.callComponent", { componentType: "h5", params: { url: "/im/cool-app-component.html?corpId=".concat(encodeURIComponent(null === (o2 = null === e2 || void 0 === e2 ? void 0 : e2.context) || void 0 === o2 ? void 0 : o2.corpId), "#/add-members?params=").concat(encodeURIComponent(JSON.stringify(e2))), target: "float", title: "\u63D0\u793A", wnId: "addMembers", panelHeight: "percent83" } });
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.addMembers = void 0;
  var mobile_1 = mobile.exports;
  exports.addMembers = addMembers2;
})(addMembers);
var sendMessageToSingleChat = {};
(function(exports) {
  function sendMessageToSingleChat2(e2) {
    var n, o2 = JSON.stringify(e2).length;
    return (0, mobile_1._invoke)("biz.util.callComponent", { componentType: "h5", params: { url: "/im/cool-app-component.html?corpId=".concat(encodeURIComponent(null === (n = null === e2 || void 0 === e2 ? void 0 : e2.context) || void 0 === n ? void 0 : n.corpId), "#/send-message-to-single-chat?params=").concat(encodeURIComponent(JSON.stringify({ body: e2, bodyLengthList: [o2] }))), target: "float", title: "\u63D0\u793A", wnId: "sendMessageToSingleChat", panelHeight: "percent83" } });
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.sendMessageToSingleChat = void 0;
  var mobile_1 = mobile.exports;
  exports.sendMessageToSingleChat = sendMessageToSingleChat2;
})(sendMessageToSingleChat);
var batchInstallToGroup = {};
(function(exports) {
  function batchInstallCoolApp(e2) {
    var o2 = Object.assign({}, e2, { isBatchApi: true });
    return (0, mobile_1._invoke)("biz.util.callComponent", { componentType: "h5", params: { url: "/resource-picker/".concat(utils_1.isMobile ? "mob" : "index", ".html?scene=addCoolAppToGroup&params=").concat(encodeURIComponent(JSON.stringify(o2))), target: utils_1.isMobile ? "" : "float", title: "\u9009\u62E9\u4F1A\u8BDD\u6DFB\u52A0\u5E94\u7528", wnId: "addCoolAppToGroup", panelHeight: "percent90" } });
  }
  Object.defineProperty(exports, "__esModule", { value: true }), exports.batchInstallCoolApp = void 0;
  var mobile_1 = mobile.exports, utils_1 = utils;
  exports.batchInstallCoolApp = batchInstallCoolApp;
})(batchInstallToGroup);
(function(exports) {
  var __createBinding = commonjsGlobal && commonjsGlobal.__createBinding || (Object.create ? function(e2, r, t2, o2) {
    void 0 === o2 && (o2 = t2);
    var i = Object.getOwnPropertyDescriptor(r, t2);
    i && ("get" in i ? r.__esModule : !i.writable && !i.configurable) || (i = { enumerable: true, get: function() {
      return r[t2];
    } }), Object.defineProperty(e2, o2, i);
  } : function(e2, r, t2, o2) {
    void 0 === o2 && (o2 = t2), e2[o2] = r[t2];
  }), __exportStar = commonjsGlobal && commonjsGlobal.__exportStar || function(e2, r) {
    for (var t2 in e2)
      "default" === t2 || Object.prototype.hasOwnProperty.call(r, t2) || __createBinding(r, e2, t2);
  };
  Object.defineProperty(exports, "__esModule", { value: true }), __exportStar(installToGroup, exports), __exportStar(sendMessageToGroup, exports), __exportStar(createGroup, exports), __exportStar(addMembers, exports), __exportStar(sendMessageToSingleChat, exports), __exportStar(batchInstallToGroup, exports);
})(coolAppSdk);
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true }), exports.coolAppSdk = void 0;
  var coolAppSdk$1 = coolAppSdk;
  exports.coolAppSdk = coolAppSdk$1;
})(plugin$1);
var ddWithoutApi = union.exports, apiObj_1 = apiObj, plugin = plugin$1, dd$1 = Object.assign(ddWithoutApi, apiObj_1.apiObj, { plugin });
var dingtalkJsapi = dd$1;
const envs = [
  {
    env: 0,
    LAN_HU_HOST: "https://lanhuapp.com",
    MAIN_ORIGIN: "https://mastergo.com",
    LYH_ORIGIN: "https://lyh.mastergo.com",
    DING_CLIENT_ID: "suitesghrhw6xhswidjzx"
  },
  {
    env: 1,
    LAN_HU_HOST: "https://pre.lanhuapp.com",
    MAIN_ORIGIN: "https://pre.mastergo.com",
    LYH_ORIGIN: "https://lyh-pre.mastergo.com",
    DING_CLIENT_ID: "suitekdyyuv5inpc47llz"
  },
  {
    env: 2,
    LAN_HU_HOST: "https://www-cicd-test.develop.lanhuapp.com",
    MAIN_ORIGIN: "https://dev.mastergo.com",
    LYH_ORIGIN: "https://tongbin.mastergo.com",
    DING_CLIENT_ID: "suitedle9yfyuww1wrffa"
  },
  {
    env: 3,
    LAN_HU_HOST: "https://lanhuapp.com",
    MAIN_ORIGIN: "https://mastergo.com",
    LYH_ORIGIN: "https://tongbin.mastergo.com",
    DING_CLIENT_ID: "suitepck5onjucarcxowr"
  }
];
var configs = envs.find((item) => [item.MAIN_ORIGIN, item.LYH_ORIGIN].includes(window.location.origin)) || envs[0];
function getDingDingToken() {
  if (!platformInfo().isDingDing)
    return;
  const corpId = getUrlValue$1("corpId");
  if (!corpId)
    return;
  return new Promise((rs, re2) => {
    dingtalkJsapi.ready(() => {
      dingtalkJsapi.runtime.permission.requestAuthCode({
        corpId,
        onSuccess(info2) {
          const code = info2.code;
          rs({
            code,
            corpId
          });
        }
      });
      dingtalkJsapi.error(() => {
        re2();
      });
    });
  });
}
const dingQuery = {
  response_type: "code",
  scope: "openid",
  state: "DingDingOAuth",
  prompt: "consent",
  client_id: configs.DING_CLIENT_ID
};
function jumpDingOAuth(url) {
  const query = {
    ...dingQuery,
    redirect_uri: window.encodeURIComponent(url)
  };
  const href = "https://login.dingtalk.com/oauth2/auth?" + Object.keys(query).map((key) => `${key}=${query[key]}`).join("&");
  window.location.href = href;
}
function dingOpenWindowWithOAuth() {
  if (!platformInfo().isDingDing)
    return;
  return (urlParam) => new Promise(async (rs, re2) => {
    let url = urlParam;
    const res = await getDingAuthCode();
    if (!res || !res.data)
      return re2();
    const dingAuthCode = res.data.jumpCode;
    if (url.indexOf("?") === -1) {
      url += `?dingAuthCode=${dingAuthCode}`;
    } else {
      url += `&dingAuthCode=${dingAuthCode}`;
    }
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      url = window.location.origin + url;
    }
    dingtalkJsapi.biz.util.openLink({
      url,
      onSuccess(data2) {
        rs(data2);
      },
      onFail(err) {
        re2(err);
      }
    });
  });
}
const getActionPosition = (url) => {
  if (!url)
    return 0;
  if (/mastergo\.com\/community\/plugin/.test(url)) {
    return 5;
  } else if (/mastergo\.com\/community/.test(url)) {
    return 3;
  } else if (/mastergo\.com\/file/.test(url)) {
    return 1;
  } else if (/mastergo\.com/.test(url)) {
    return 2;
  } else if (/lyh(\-\w+)\.mastergo\.com\/tvc/.test(url)) {
    return 20220511;
  } else if (/lyh(\-\w+)\.mastergo\.com/.test(url)) {
    return 20220510;
  }
  return 0;
};
const lanhu = async (genSign = "") => {
  var _a2, _b;
  const formData = await getFormData();
  const fn2 = sendFormData(formData);
  const data2 = {
    token: genSign,
    ...formData,
    action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.SOURCE_URL) || "")
  };
  try {
    const res = await lanHuLogin(data2);
    fn2(res);
    sensors.track(SensorsType.USER_LOGIN, {
      action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.SOURCE_URL) || ""),
      action_detail: "lanhu"
    });
    return res;
  } catch (err) {
    sensors.track(SensorsType.USER_LOGIN, {
      action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.SOURCE_URL) || ""),
      action_detail: "lanhu",
      action_successed: false,
      action_error: ((_b = (_a2 = err == null ? void 0 : err.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code) || "js_err"
    });
    return {};
  }
};
function isValidHttpProtocal(url) {
  const lowerCase = url.toLowerCase();
  return lowerCase.startsWith("http://") || lowerCase.startsWith("https://");
}
function backToFile() {
  const url = getSessionStorageItem$1(SESSION_KEYS.FILE_URL);
  if (url && isValidHttpProtocal(url)) {
    window.location.href = url;
  }
}
const google = async (code = "") => {
  const formData = await getFormData();
  const fn2 = sendFormData(formData);
  const res = await googleLogin({
    code,
    ...formData,
    action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.FILE_URL) || "")
  });
  setLocalStorageItem(SESSION_KEYS.WE_CHAT_LOGIN_DONE, "1");
  fn2(res);
  return res;
};
const linkedin = async (code = "") => {
  const formData = await getFormData();
  const fn2 = sendFormData(formData);
  const res = await linkedinLogin({
    code,
    ...formData,
    action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.FILE_URL) || "")
  });
  fn2(res);
  return res;
};
const wechat = async (code = "") => {
  const formData = await getFormData();
  const fn2 = sendFormData(formData);
  const res = await wechatLogin({
    code,
    source: "wechat_h5",
    oauthType: "web",
    ...formData,
    action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.FILE_URL) || "")
  });
  setLocalStorageItem(SESSION_KEYS.WE_CHAT_LOGIN_DONE, "1");
  fn2(res);
  return res;
};
const dingDing = async (code) => {
  const data2 = {
    action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.FILE_URL) || "")
  };
  if (code) {
    Object.assign(data2, {
      code,
      oauthType: "web"
    });
  } else {
    const rs = await getDingDingToken();
    if (!rs)
      return;
    Object.assign(data2, rs, {
      oauthType: "app"
    });
  }
  const formData = await getFormData();
  const fn2 = sendFormData(formData);
  Object.assign(data2, formData);
  const res = await verifyDingDingToken(data2);
  if (fn2) {
    fn2(res);
  }
  return res;
};
const normal = () => {
  if (isInIframe())
    return Promise.resolve({});
  return getUserInfo();
};
const loginFirst = async () => {
  var _a2, _b;
  const genSign = getSessionStorageItem$1(SESSION_KEYS.GEN_SIGN);
  const wechatLogin2 = getSessionStorageItem$1(SESSION_KEYS.WECHAT_LOGIN_START);
  const dingDingOAuthCode = getSessionStorageItem$1(SESSION_KEYS.DING_DING_OAUTH_CODE);
  const dingAuthCode = getSessionStorageItem$1(SESSION_KEYS.DING_JUMP_AUTH_CODE);
  const googleCode = getSessionStorageItem$1(SESSION_KEYS.GOOGLE_CODE);
  const linkedinCode = getSessionStorageItem$1(SESSION_KEYS.LINKEDIN_CODE);
  let res = {};
  if (dingAuthCode) {
    try {
      res = await verifyDingDingToken({
        code: dingAuthCode,
        oauthType: "jump"
      });
      if (res) {
        startRemoveSession();
        return res;
      }
    } catch {
    }
  }
  res = await dingDing();
  if (res)
    return res;
  if (canUseThiryLogin()) {
    if (genSign) {
      res = await lanhu(genSign);
    } else if (wechatLogin2) {
      res = await wechat();
    } else if (dingDingOAuthCode) {
      try {
        res = await dingDing(dingDingOAuthCode);
        sensors.track(SensorsType.USER_LOGIN, {
          action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.SOURCE_URL) || ""),
          action_detail: "dingtalk",
          action_successed: true
        });
      } catch (err) {
        sensors.track(SensorsType.USER_LOGIN, {
          action_position: getActionPosition(getSessionStorageItem$1(SESSION_KEYS.SOURCE_URL) || ""),
          action_detail: "dingtalk",
          action_successed: false,
          action_error: ((_b = (_a2 = err == null ? void 0 : err.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code) || "js_err"
        });
      }
    }
    if (googleCode) {
      res = await google(googleCode);
    } else if (linkedinCode) {
      res = await linkedin(linkedinCode);
    }
    if (res) {
      backToFile();
      removeDrainageData();
      startRemoveSession();
      return res;
    }
  }
  return res;
};
const login = async () => {
  let res = null;
  try {
    res = await loginFirst();
    if (!res) {
      res = await normal();
      if (isDebug()) {
        console.log("\u6B63\u5E38\u767B\u5F55 res", res);
      }
    }
  } catch {
  }
  return res;
};
const initWeiXin = () => {
  const headEl = document.querySelector("head");
  const weixin = document.createElement("script");
  weixin.type = "text/javascript";
  weixin.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
  if (headEl) {
    headEl.append(weixin);
  }
};
/*! js-cookie v3.0.1 | MIT */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source2 = arguments[i];
    for (var key in source2) {
      target[key] = source2[key];
    }
  }
  return target;
}
var defaultConverter = {
  read: function(value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === "undefined") {
      return;
    }
    attributes = assign({}, defaultAttributes, attributes);
    if (typeof attributes.expires === "number") {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }
    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = "";
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }
      stringifiedAttributes += "; " + attributeName;
      if (attributes[attributeName] === true) {
        continue;
      }
      stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
    }
    return document.cookie = key + "=" + converter.write(value, key) + stringifiedAttributes;
  }
  function get2(key) {
    if (typeof document === "undefined" || arguments.length && !key) {
      return;
    }
    var cookies2 = document.cookie ? document.cookie.split("; ") : [];
    var jar = {};
    for (var i = 0; i < cookies2.length; i++) {
      var parts = cookies2[i].split("=");
      var value = parts.slice(1).join("=");
      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);
        if (key === foundKey) {
          break;
        }
      } catch (e2) {
      }
    }
    return key ? jar[key] : jar;
  }
  return Object.create(
    {
      set,
      get: get2,
      remove: function(key, attributes) {
        set(
          key,
          "",
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function(attributes) {
        return init(this.converter, assign({}, this.attributes, attributes));
      },
      withConverter: function(converter2) {
        return init(assign({}, this.converter, converter2), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  );
}
var api = init(defaultConverter, { path: "/" });
const logout = async () => {
  const deviceID = api.get("_mg_cd_uid");
  if (deviceID) {
    await logOut({ deviceID });
  }
};
function addExperimentData(data2) {
  if (typeof data2 === "object") {
    Object.assign(experimentClient, data2);
  }
}
function setExtendTrack(key, value) {
  const extendTrack = getExtendTrackJson();
  extendTrack[key] = value;
  const newExtendInfo = JSON.stringify(extendTrack);
  setSessionStorageItem(SESSION_KEYS.EXTEND_TRACK, newExtendInfo);
}
function getExtendTrack(key) {
  return getExtendTrackJson()[key];
}
function clearExtendTrack() {
  removeSessionStorageItem(SESSION_KEYS.EXTEND_TRACK);
}
function deleteExtendTrack(key) {
  const extendTrack = getExtendTrackJson();
  try {
    delete extendTrack[key];
    setSessionStorageItem(SESSION_KEYS.EXTEND_TRACK, JSON.stringify(extendTrack));
  } catch (error) {
    console.error(error);
  }
}
function getExtendTrackJson() {
  const extendTrackStr = getSessionStorageItem$1(SESSION_KEYS.EXTEND_TRACK);
  try {
    return JSON.parse(extendTrackStr || "");
  } catch (e2) {
    console.error(e2);
    return {};
  }
}
const PasswordError = computed(() => {
  const passwordPlaceholder = getPasswordPlaceholder();
  return {
    accountError: i18n.t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7\u6216\u90AE\u7BB1\uFF01"),
    passwordError: passwordPlaceholder,
    passwordNotSame: i18n.t("\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165"),
    passwordCheckError: i18n.t("\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165"),
    oldPasswordEmptyError: i18n.t("\u8BF7\u8F93\u5165\u65E7\u5BC6\u7801"),
    oldPasswordError: i18n.t("\u65E7\u5BC6\u7801\u8F93\u5165\u4E0D\u6B63\u786E"),
    passwordSameError: i18n.t("\u65B0\u5BC6\u7801\u4E0D\u53EF\u548C\u65E7\u5BC6\u7801\u4E00\u81F4!"),
    updatePasswordError: i18n.t("\u5BC6\u7801\u91CD\u7F6E\u5F02\u5E38\uFF0C\u8BF7\u91CD\u8BD5"),
    passwordMaxLengthError: i18n.t("\u5BC6\u7801\u6700\u957F %{maxLength} \u4F4D", { maxLength: PASSWORD_MAX_LENGTH })
  };
});
const PASSWORD_MAX_LENGTH = 24;
const checkPasswordMaxLength = (pwd, maxLength = PASSWORD_MAX_LENGTH) => {
  return (pwd == null ? void 0 : pwd.length) > maxLength;
};
function validatePassword(pwd) {
  if (!pwd)
    return false;
  const { getPubConfig } = usePubSetting();
  const {
    passwordMatchDigit: passwordMatchDigit2,
    passwordMatchLower: passwordMatchLower2,
    passwordMatchUpper: passwordMatchUpper2,
    passwordMatchSpecial: passwordMatchSpecial2,
    passwordMinLength: passwordMinLength2
  } = getPubConfig();
  const minLen = passwordMinLength2.value || 8;
  const lookAHeads = [];
  if (passwordMatchUpper2.value)
    lookAHeads.push("(?=.*[A-Z])");
  if (passwordMatchLower2.value)
    lookAHeads.push("(?=.*[a-z])");
  if (passwordMatchDigit2.value)
    lookAHeads.push("(?=.*\\d)");
  if (passwordMatchSpecial2.value) {
    const specialChars = "!@#$%^&*_\\-+=,.<>?|/`~()[]{}'\";:";
    const safeSpecialChars = specialChars.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
    lookAHeads.push(`(?=.*[${safeSpecialChars}])`);
  }
  let pattern = "";
  if (lookAHeads.length > 0) {
    pattern = `^${lookAHeads.join("")}.{${minLen},}$`;
  } else {
    pattern = `^.{${minLen},}$`;
  }
  const reg = new RegExp(pattern);
  return reg.test(pwd);
}
function replaceLastCommaToAnd(str) {
  const isEn = getIsEn();
  return str.includes("\u3001") ? str.replace(/、([^、]*)$/, isEn ? " and $1" : "\u548C$1") : str;
}
const getPasswordPlaceholder = () => {
  const { getPubConfig } = usePubSetting();
  const {
    passwordMatchDigit: passwordMatchDigit2,
    passwordMatchLower: passwordMatchLower2,
    passwordMatchUpper: passwordMatchUpper2,
    passwordMatchSpecial: passwordMatchSpecial2,
    passwordMinLength: passwordMinLength2
  } = getPubConfig();
  const minLen = passwordMinLength2.value || 8;
  const requirements = [];
  if (passwordMatchUpper2.value && passwordMatchLower2.value) {
    requirements.push(i18n.t("\u5927\u5C0F\u5199"));
  } else if (passwordMatchUpper2.value) {
    requirements.push(i18n.t("\u5927\u5199"));
  } else if (passwordMatchLower2.value) {
    requirements.push(i18n.t("\u5C0F\u5199"));
  }
  if (passwordMatchDigit2.value)
    requirements.push(i18n.t("\u6570\u5B57"));
  if (passwordMatchSpecial2.value)
    requirements.push(i18n.t("\u7B26\u53F7"));
  let placeholder = i18n.t("\u5BC6\u7801\u81F3\u5C11 %{minLen} \u4F4D", { minLen });
  const joinPattern = "\u3001";
  if (requirements.length > 0) {
    placeholder += i18n.t("\uFF0C\u542B") + requirements.join(joinPattern);
  }
  placeholder = replaceLastCommaToAnd(placeholder);
  return placeholder;
};
var index$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  setLoginData,
  setLoginDataI18N,
  login,
  initWeiXin,
  logout,
  addExperimentData,
  jumpDingOAuth,
  dingOpenWindowWithOAuth,
  getExtendTrack,
  setExtendTrack,
  clearExtendTrack,
  deleteExtendTrack,
  usePasswordReset,
  getPasswordPlaceholder,
  validatePassword,
  checkPasswordMaxLength,
  PasswordError,
  usePubSetting
}, Symbol.toStringTag, { value: "Module" }));
var index = "";
var render$12 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16"
    }
  }, [_c("clipPath", {
    attrs: {
      "id": "master_svg0_517_0937/517_0500"
    }
  }, [_c("rect", {
    attrs: {
      "x": "3.2001953125",
      "y": "0.533447265625",
      "width": "9.504701614379883",
      "height": "14.933334350585938",
      "rx": "0"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", [_c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_517_0937/517_0500)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M12.2070653125,7.526027265625C9.8282153125,5.689417265625,7.1460653125,3.256957265625,4.2050453125,0.648331265625C3.9737443125,0.443072165625,3.7684863125,0.524256575625,3.6643253125,0.796913265625C3.0025953125,2.547737265625,3.6444113125,4.100967265625,4.6829553125,4.997057265625C5.724565312499999,5.896217265625,7.2747353125,6.724907265625,8.2229053125,7.164527265625C8.259665312500001,7.181377265625,8.2275053125,7.236517265625,8.1907353125,7.219677265625C6.4475753125,6.452247265625,5.2344053125,5.897747265625,3.5907993125,4.629427265625C3.4131133125,4.4931072656249995,3.2338947125,4.545187265625,3.2124497125,4.813247265625C3.0776533125,6.482887265625,4.1468353125,7.797157265625,5.3416253125,8.241367265625C6.0814753125,8.515557265624999,6.8902553125,8.668737265625,7.6392953125,8.759117265625C7.6775953125,8.763707265625,7.6699353125,8.821917265625,7.6301053125,8.821917265625C6.6635553125,8.824977265625,5.4948053125000005,8.593677265625,4.4853553125,8.204607265625C4.2724453125,8.121887265625,4.1989163125,8.291917265624999,4.2326153125,8.426717265625001C4.4057053125,9.132867265625,5.2788253125,10.214307265625,6.6712153125,10.441007265625C6.9316153125,10.483897265625,7.2088653125,10.488497265625,7.4554853125,10.482367265625C7.5136853125,10.480837265625,7.5290053125,10.512997265625,7.5090953125,10.558947265625Q6.5639853125,12.178047265625,6.522625312500001,12.246947265625C6.4904553125,12.300547265625,6.5103753125,12.343447265625,6.5777753125,12.343447265625C6.6451753125,12.343447265625,7.7679653125,12.343447265625,7.8246453125,12.343447265625C7.8828453125,12.343447265625,7.9180853125,12.380247265625,7.8889753125,12.429247265625C7.8598753125,12.478247265625,6.2239353125,15.191047265625,6.1458053125,15.321247265625C6.0784153125,15.433047265625,6.1580653125,15.520347265625,6.2852053125000005,15.426947265625C6.4123353125,15.333547265625,11.6403053125,11.507147265625,11.7888953125,11.396847265625C11.8578253125,11.346247265625,11.8409753125,11.278847265625,11.7444653125,11.278847265625C11.6479653125,11.278847265625,10.6982653125,11.278847265625,10.6262653125,11.278847265625C10.5527453125,11.278847265625,10.5374253125,11.229847265625,10.5864453125,11.180847265625C10.6369953125,11.131847265625,11.8562853125,9.915607265625,12.2882553125,9.460667265625C12.7401253125,8.985817265625,12.9698953125,8.115767265625,12.2070653125,7.526027265625Z",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  })])])])])]);
};
var staticRenderFns$11 = [];
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$11 = defineComponent({
  name: "DingDingLogoIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    }
  }
});
const __cssModules$11 = {};
var __component__$11 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$11,
  render$12,
  staticRenderFns$11,
  false,
  __vue2_injectStyles$11,
  null,
  null,
  null
);
function __vue2_injectStyles$11(context) {
  for (let o2 in __cssModules$11) {
    this[o2] = __cssModules$11[o2];
  }
}
var DingDingLogoIcon = /* @__PURE__ */ function() {
  return __component__$11.exports;
}();
var render$11 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_2856_3065"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "20",
      "height": "20",
      "rx": "0"
    }
  })]), _c("clipPath", {
    attrs: {
      "id": "master_svg1_2856_3065/202_353"
    }
  }, [_c("rect", {
    attrs: {
      "x": "2.142578125",
      "y": "1.4287109375",
      "width": "15.584417343139648",
      "height": "17.142858505249023",
      "rx": "0"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_2856_3065)"
    }
  }, [_c("g", {
    attrs: {
      "clip-path": "url(#master_svg1_2856_3065/202_353)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M17.4295078125,15.71138125C16.5219078125,14.69878125,15.7221078125,13.52848125,15.7199078125,9.23132125C15.7244078125,9.13304125,15.7244078125,9.12847125,15.7244078125,9.02789125C15.7244078125,7.27247125,15.0919078125,5.68389125,14.0675078125,4.52275125C14.1454078125,4.42447125,14.2233078125,4.30561125,14.3035078125,4.17304125C14.3127078125,4.15704125,14.3218078125,4.14104125,14.3310078125,4.12275125C14.4227078125,3.96504125,14.5144078125,3.79132125,14.6014078125,3.60618125C14.6862078125,3.42332125,14.7619078125,3.23361125,14.8260078125,3.0438912499999997C14.8329078125,3.0210412499999997,14.8421078125,2.9958912499999997,14.8490078125,2.97304125C14.8879078125,2.8496112499999997,14.9223078125,2.72847125,14.9498078125,2.60961125C15.0804078125,2.05190025,15.0552078125,1.57647125,14.7321078125,1.44161385C14.5487078125,1.36389955,14.3287078125,1.58104225,14.0720078125,1.90104225C14.0629078125,1.91247125,14.0537078125,1.92390025,14.0422078125,1.93532825C14.0308078125,1.94904225,14.0193078125,1.9627572500000001,14.0079078125,1.9787572500000001C13.8406078125,2.19361425,13.6549078125,2.44504125,13.4532078125,2.67590125C13.4372078125,2.6941812499999997,13.4234078125,2.7101812499999998,13.4074078125,2.72847125C13.3982078125,2.73761125,13.3891078125,2.7490412500000003,13.3799078125,2.75818125C13.1599078125,3.00504125,12.9192078125,3.22218125,12.6603078125,3.3501812500000003C11.8535478125,2.8724712500000003,10.9322378125,2.60276125,9.9536378125,2.60276125C8.9498078125,2.60276125,8.007867812499999,2.8884712500000003,7.1851078125,3.38904125C6.8940378125,3.2701812500000003,6.6258978125,3.03247125,6.3829678125,2.76047125C6.3737978125,2.75133125,6.3646378125,2.73990125,6.3554678125,2.73076125C6.3394178125,2.71247125,6.3256678125,2.69647125,6.3096178125,2.6781812499999997C6.1079478125,2.44504125,5.9223078125,2.19361425,5.755007812500001,1.98104225C5.7435478125,1.96504225,5.7320978125,1.95132825,5.7206178125000005,1.93761425C5.7114678125000005,1.92390025,5.7000078125,1.91475725,5.6908378125,1.90332825C5.4341478125,1.58332825,5.2118378125,1.36618525,5.0307978124999995,1.44389955C4.7076378125,1.57875725,4.684717812500001,2.05647125,4.8130678125,2.61190125C4.8405678125,2.72847125,4.8749478125,2.85190125,4.9139078125,2.97532125C4.9207778125,2.99818125,4.9299478125,3.02332125,4.9368178125,3.04618125C5.0009978125,3.23589125,5.0789178125,3.42561125,5.1614178125,3.60847125C5.246217812499999,3.79361125,5.3378978125,3.96732125,5.4318478125,4.125041250000001C5.4410178125,4.14104125,5.4501978125,4.15704125,5.4593678125,4.17532125C5.5624978125,4.3467512500000005,5.6656178125,4.49532125,5.7641778125,4.60961125C4.7832678125,5.76161125,4.1805178125,7.31589125,4.1805178125,9.02789125C4.1805178125,9.16504125,4.1736378125,9.21305125,4.1805178125,9.34791125C4.1621778124999995,13.55588125,3.3142078125000003,14.70558125,2.4158118125,15.71138125C1.7695168125,16.43138125,2.3195568125,17.94448125,3.6671478125,17.27018125C6.3829678125,15.91018125,7.0155078125,18.43588125,9.9215478125,18.35138125C12.8276078125,18.26678125,13.3822078125,15.91018125,16.182807812500002,17.27018125C17.5326078125,17.92848125,18.0735078125,16.43138125,17.4295078125,15.71138125C17.4295078125,15.71138125,17.4295078125,15.71138125,17.4295078125,15.71138125ZM9.9215478125,12.03588125C8.9200178125,12.03588125,8.0193278125,11.60388125,7.3936678125,10.91818125C6.8436178125,10.31248125,6.5067178125,9.50789125,6.5067178125,8.62561125C6.5067178125,6.74218125,8.0353778125,5.21761125,9.9215478125,5.21761125C11.1545478125,5.21761125,12.2340078125,5.86904125,12.8322078125,6.84504125C12.8344078125,6.84732125,12.8344078125,6.84732125,12.8344078125,6.84961125C13.1530078125,7.36847125,13.3364078125,7.97647125,13.3364078125,8.627891250000001C13.3341078125,10.50904125,11.8077278125,12.03588125,9.9215478125,12.03588125C9.9215478125,12.03588125,9.9215478125,12.03588125,9.9215478125,12.03588125Z",
      "fill": "#FFFFFF",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", [_c("path", {
    attrs: {
      "d": "M13.065445,8.1329365625C13.065445,9.0860865625,12.290805,9.8586565625,11.337415,9.8586565625C10.384012,9.8586565625,9.609375,9.0860865625,9.609375,8.1329365625C9.609375,7.1797975625,10.384012,6.4072265625,11.337415,6.4072265625C12.293105,6.4072265625,13.065445,7.1797975625,13.065445,8.1329365625C13.065445,8.1329365625,13.065445,8.1329365625,13.065445,8.1329365625Z",
      "fill": "#FFFFFF",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$10 = [];
const __vue2_script$10 = defineComponent({
  name: "LogoLanhuIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$10 = {};
var __component__$10 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$10,
  render$11,
  staticRenderFns$10,
  false,
  __vue2_injectStyles$10,
  null,
  null,
  null
);
function __vue2_injectStyles$10(context) {
  for (let o2 in __cssModules$10) {
    this[o2] = __cssModules$10[o2];
  }
}
var LogoLanhuIcon = /* @__PURE__ */ function() {
  return __component__$10.exports;
}();
var render$10 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "20",
      "height": "20",
      "viewBox": "0 0 20 20"
    }
  }, [_c("clipPath", {
    attrs: {
      "id": "master_svg0_298_0507"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "20",
      "height": "20",
      "rx": "0"
    }
  })]), _c("clipPath", {
    attrs: {
      "id": "master_svg1_298_0507/20_089"
    }
  }, [_c("rect", {
    attrs: {
      "x": "2.14306640625",
      "y": "1.428466796875",
      "width": "15.584417343139648",
      "height": "17.142858505249023",
      "rx": "0"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_298_0507)"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg1_298_0507/20_089)"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M17.42999609375,15.71138125C16.52239609375,14.69878125,15.72259609375,13.52848125,15.72039609375,9.23132125C15.72489609375,9.13304125,15.72489609375,9.12847125,15.72489609375,9.02789125C15.72489609375,7.27247125,15.09239609375,5.68389125,14.06799609375,4.52275125C14.14589609375,4.42447125,14.22379609375,4.30561125,14.30399609375,4.17304125C14.31319609375,4.15704125,14.32229609375,4.14104125,14.33149609375,4.12275125C14.42319609375,3.96504125,14.51489609375,3.79132125,14.60189609375,3.60618125C14.68669609375,3.42332125,14.76239609375,3.23361125,14.82649609375,3.0438912499999997C14.83339609375,3.0210412499999997,14.84259609375,2.9958912499999997,14.84949609375,2.97304125C14.88839609375,2.8496112499999997,14.92279609375,2.72847125,14.95029609375,2.60961125C15.08089609375,2.05190025,15.05569609375,1.57647125,14.73259609375,1.44161385C14.54919609375,1.36389955,14.32919609375,1.58104225,14.07249609375,1.90104225C14.06339609375,1.91247125,14.05419609375,1.92390025,14.04269609375,1.93532825C14.03129609375,1.94904225,14.01979609375,1.9627572500000001,14.00839609375,1.9787572500000001C13.84109609375,2.19361425,13.65539609375,2.44504125,13.45369609375,2.67590125C13.43769609375,2.6941812499999997,13.42389609375,2.7101812499999998,13.40789609375,2.72847125C13.39869609375,2.73761125,13.38959609375,2.7490412500000003,13.38039609375,2.75818125C13.16039609375,3.00504125,12.91969609375,3.22218125,12.66079609375,3.3501812500000003C11.85403609375,2.8724712500000003,10.93272609375,2.60276125,9.95412609375,2.60276125C8.95029609375,2.60276125,8.008356093749999,2.8884712500000003,7.18559609375,3.38904125C6.89452609375,3.2701812500000003,6.62638609375,3.03247125,6.38345609375,2.76047125C6.37428609375,2.75133125,6.36512609375,2.73990125,6.35595609375,2.73076125C6.33990609375,2.71247125,6.32615609375,2.69647125,6.31010609375,2.6781812499999997C6.10843609375,2.44504125,5.92279609375,2.19361425,5.755496093750001,1.98104225C5.74403609375,1.96504225,5.73258609375,1.95132825,5.7211060937500005,1.93761425C5.7119560937500005,1.92390025,5.70049609375,1.91475725,5.69132609375,1.90332825C5.43463609375,1.58332825,5.21232609375,1.36618525,5.0312860937499995,1.44389955C4.70812609375,1.57875725,4.685206093750001,2.05647125,4.81355609375,2.61190125C4.84105609375,2.72847125,4.87543609375,2.85190125,4.91439609375,2.97532125C4.92126609375,2.99818125,4.93043609375,3.02332125,4.93730609375,3.04618125C5.00148609375,3.23589125,5.07940609375,3.42561125,5.16190609375,3.60847125C5.246706093749999,3.79361125,5.33838609375,3.96732125,5.43233609375,4.125041250000001C5.44150609375,4.14104125,5.45068609375,4.15704125,5.45985609375,4.17532125C5.56298609375,4.3467512500000005,5.66610609375,4.49532125,5.76466609375,4.60961125C4.78375609375,5.76161125,4.18100609375,7.31589125,4.18100609375,9.02789125C4.18100609375,9.16504125,4.17412609375,9.21305125,4.18100609375,9.34791125C4.1626660937499995,13.55588125,3.3146960937500003,14.70558125,2.41630009375,15.71138125C1.77000509375,16.43138125,2.32004509375,17.94448125,3.66763609375,17.27018125C6.38345609375,15.91018125,7.01599609375,18.43588125,9.92203609375,18.35138125C12.82809609375,18.26678125,13.38269609375,15.91018125,16.183296093750002,17.27018125C17.53309609375,17.92848125,18.07399609375,16.43138125,17.42999609375,15.71138125C17.42999609375,15.71138125,17.42999609375,15.71138125,17.42999609375,15.71138125ZM9.92203609375,12.03588125C8.92050609375,12.03588125,8.019806093749999,11.60388125,7.39415609375,10.91818125C6.84410609375,10.31248125,6.50720609375,9.50789125,6.50720609375,8.62561125C6.50720609375,6.74218125,8.03586609375,5.21761125,9.92203609375,5.21761125C11.15503609375,5.21761125,12.23449609375,5.86904125,12.83269609375,6.84504125C12.83489609375,6.84732125,12.83489609375,6.84732125,12.83489609375,6.84961125C13.15349609375,7.36847125,13.33689609375,7.97647125,13.33689609375,8.627891250000001C13.33459609375,10.50904125,11.80820609375,12.03588125,9.92203609375,12.03588125C9.92203609375,12.03588125,9.92203609375,12.03588125,9.92203609375,12.03588125Z",
      "fill": "#2D78EE",
      "fill-opacity": "1"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M13.065445,8.13244828125C13.065445,9.08559828125,12.290805,9.85816828125,11.337415,9.85816828125C10.384012,9.85816828125,9.609375,9.08559828125,9.609375,8.13244828125C9.609375,7.17930928125,10.384012,6.40673828125,11.337415,6.40673828125C12.293105,6.40673828125,13.065445,7.17930928125,13.065445,8.13244828125C13.065445,8.13244828125,13.065445,8.13244828125,13.065445,8.13244828125Z",
      "fill": "#2D3C4D",
      "fill-opacity": "1"
    }
  })])])])])])]);
};
var staticRenderFns$$ = [];
const __vue2_script$$ = defineComponent({
  name: "LogoLanhuIconLight",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$$ = {};
var __component__$$ = /* @__PURE__ */ normalizeComponent(
  __vue2_script$$,
  render$10,
  staticRenderFns$$,
  false,
  __vue2_injectStyles$$,
  null,
  null,
  null
);
function __vue2_injectStyles$$(context) {
  for (let o2 in __cssModules$$) {
    this[o2] = __cssModules$$[o2];
  }
}
var LogoLanhuIconLight = /* @__PURE__ */ function() {
  return __component__$$.exports;
}();
var __$_require_cc2260aa__ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAA8FBMVEUAAABDhfTqQzbnSDjrRDQ0p1Q0p1TrRDU0qFM1qFPqQzU4p1g0qFP7uwbpRDZChvQ0qFTrQzZChvQwr1A8qVDtVi77vAX6vAZDhfQ0qVPqQzXrRDXqQjUzqVPpQzZEg/NAgO/vQDBAit81pV7guhD6tAlDhvRDhvX8vAY1qFNChfNChPTqQzT6uwXqRTX/vwA4noBSq0fuuwpChfRAit4+jsg7mJyAsDaptCb1lhTzghzqRDX7vAV/sDY2pGfLtxj3nhH7vAXyeiD8vQU9la80qVT7vQX7uwY0qFJChfQ1p1L/vwjqQzU0qFNChfT7vAVCfSr7AAAATHRSTlMAn98g8IBAQO/fvyC/QIDfz6+PEPPx8d/Pr5+PYFBQQBAQ8+/v77+vr5+AcHBwMBDz8/Pv5+fn5+fn18/Py8fDv7+vn5OPj4BwYGAgAyVhWwAAAYdJREFUOMud0td2gkAQgOEJ0kUFW+wlGo0lmt57L6y8/9sEkcEVFlfz363nO3vGWSBUWxlbgmCLgm5VFVibUhVtKtGqxVPdjqSzr08gDWUlorYh2jEJk7BN22sab2GFxL9tw6abL1m/FWNsQqRlWmkvFlkRGBYqlK22qUvSUVujxlNC+9TRYk8FajxOKWe/wLXYs+M4Nx6uce206LhduwupAPCn8HJHmfDxh7Oo+AL8Dhy/Q6DaYTQE2EWcovGMUYnCvzycAXAwiMXYVpgaY7oBvtv4D2ZCq+Nt49O3J/cxe+4j7gfP3c0TGZiNEGfdQ3Fur/KEGGzcQ9x0D6+uvSRu7KubaE9b3mfXPSZeapKBS4h73vExT/y0qM7OsJF3ltFGdWtpMy3wMsgyiebyw16Av2FRUqW0OpD9X7/cSzrnwfNhdbKaaRgmXnCBewuSSHxH81GGKHm6c+Y9Hk9jbxDqR4u1EkRKltlUk4FVnXG5KuUgJnmgrlADKbucLJVNjaiaWX6vh+UfrFkKY5h0pzsAAAAASUVORK5CYII=";
var render$$ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "google-button-container"
  }, [_c("div", {
    staticClass: "google-button",
    attrs: {
      "id": _vm.buttonId
    }
  }), _c("div", {
    staticClass: "fake-button"
  }, [_c("img", {
    staticClass: "google-icon",
    attrs: {
      "src": __$_require_cc2260aa__,
      "alt": "google"
    }
  }), _c("span", {
    staticClass: "fake-button-text"
  }, [_vm._v(_vm._s(_vm.$_t("\u4F7F\u7528 Google \u8D26\u53F7")))])])]);
};
var staticRenderFns$_ = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$a = "";
let hasInit = false;
const __vue2_script$_ = defineComponent({
  name: "GoogleLogin",
  props: {
    clientId: {
      type: String,
      default: ""
    },
    loginCallback: {
      type: Function,
      default: () => {
      }
    },
    isReceiveMail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonId: "google-login"
    };
  },
  emits: ["setUserInfo"],
  methods: {
    googleClientInit() {
      hasInit = true;
      console.log("googleClientInit", this.clientId, this.loginCallback);
      window.google.accounts.id.initialize({
        client_id: this.clientId,
        callback: async (response) => {
          var _a2;
          if (response && response.credential) {
            const data2 = await getFormData();
            const fn2 = sendFormData(data2);
            try {
              const params = {
                id_token: response.credential,
                ...data2
              };
              if (this.isI18N) {
                params.isReceiveMail = (_a2 = this.isReceiveMail) != null ? _a2 : true;
              }
              const res = await googleLogin(params);
              this.$emit("setUserInfo", res.data);
              removeDrainageData();
              fn2(res);
              this.loginCallback();
            } catch (e2) {
            }
          }
        }
      });
    },
    renderButton() {
      window.google.accounts.id.renderButton(
        document.getElementById(this.buttonId),
        { theme: "outline", size: "large" }
      );
    },
    init() {
      if (hasInit)
        return Promise.resolve();
      return new Promise((resolve) => {
        if (document.readyState === "complete") {
          googleClient = this.googleClientInit();
          resolve(true);
        } else {
          window.addEventListener("load", () => {
            googleClient = this.googleClientInit();
            resolve(true);
          });
        }
      });
    },
    loadScript() {
      if (hasInit)
        return Promise.resolve();
      return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    }
  },
  async mounted() {
    await this.loadScript();
    await this.init();
    this.renderButton();
  }
});
const __cssModules$_ = {};
var __component__$_ = /* @__PURE__ */ normalizeComponent(
  __vue2_script$_,
  render$$,
  staticRenderFns$_,
  false,
  __vue2_injectStyles$_,
  "c6dfd16e",
  null,
  null
);
function __vue2_injectStyles$_(context) {
  for (let o2 in __cssModules$_) {
    this[o2] = __cssModules$_[o2];
  }
}
var GoogleLogin = /* @__PURE__ */ function() {
  return __component__$_.exports;
}();
var LinkedInIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACxElEQVRoBWNgGAWjITCyQ4ARw/u5k/gYfrLXAcVjgFgcQ35gBG4DrZ3IMCt9Krr1TOgCQMc3AMWKgXiwOB7kRFUgnsKQOisCxEEGmB5gYIhFVjCo2Iz/Q9Ddg80DIuiKBg2fkVEY3S3YPICuZlDzh7wHWEgNXgNZSCw+ePuZ4cO3X6Rqp7p6oj0Acvj6TDcGBWFesCM+fPvJ0LjlHMOEvZep7ihSDCQqCQlwsTHsL/KBOx5kgQAXO0N/mCWKGCkWU0stUR4AhTrIwdiAg5okNmG6iRHlAXyu+fB9YPMBUR648PgtAyjTogOQ2IFbz9CF6conOhMbtqxlKHDSZYi3UgOXPheevGVo3Hx2wEsizMZc2sz/dA1CUixjZDzAMDPNEVkLUUkIWcNgYxOdhObHO2B1e+LCA3DxBEs1Bns1KTgfxlh4/CYwrzwHF7n5zjoMDkA1CsI8YOkHb78wLDx+i2HDhQdY8xnMDFw00R5IAKZ9bADZAyDHY1N3EJjREyx5GeYnOGAYYQAsng1kLRlAHgucvosBVGCQAuiShPwNFLA6HtmhoLoGvbJElsfFposHAoAeIAaAKsv5CfbEKIWroYsHYLaB2k+gJAKicQFI/oC0t3CpQRanmwdAjT7F6uUMoPpEsHAhsCF4FtkdKOwAA3kUPj4OXTwAqrELVx1HqfQagJUgrlpcX4b4TiFdPDARR5N7I7DopBTQxQO4Oj64xBVEIHUEMZ6jiwdwOQRbAxGXWlziA+oBXI4iRXzUA6SEFi3UjsYALUKVFDNHY4CU0KKF2iEfA0R3aEAdeEJg48UHDA+xjF6ABgCwAVBvDJu5pFRwo516bCFLT7EhnweweeANPUOQJLv+/8fITNg8sJgkQ+mpmJFpNbp1zOgCDFZuxxn+srABxZWBmPiGOYZBVBUATbPWM8xKm09VU0cNGw2BYRACAN93soV0Ob9WAAAAAElFTkSuQmCC";
var twitterDarkIcon = "data:image/png;base64,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";
var twitterLightIcon = "data:image/png;base64,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";
const iconList = {
  linkedin_oauth: {
    dark: LinkedInIcon,
    light: LinkedInIcon
  },
  twitter_oauth: {
    dark: twitterDarkIcon,
    light: twitterLightIcon
  }
};
var render$_ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "login-button-container",
    on: {
      "click": _vm.openAuthTab
    }
  }, [_c("div", {
    staticClass: "login-button"
  }, [_c("img", {
    staticClass: "login-icon",
    attrs: {
      "src": _vm.appIcon,
      "alt": "login"
    }
  }), _c("div", [_vm._v(_vm._s(_vm.buttonTxt))])])]);
};
var staticRenderFns$Z = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$9 = "";
const __vue2_script$Z = defineComponent({
  name: "thirdLogin",
  props: {
    loginCallback: {
      type: Function,
      default: () => {
      }
    },
    loginFrom: {
      type: String,
      default: "linkedin_oauth"
    },
    isReceiveMail: {
      type: Boolean,
      default: true
    }
  },
  emits: ["setUserInfo"],
  computed: {
    buttonTxt() {
      if (this.loginFrom === "linkedin_oauth")
        return i18n.t("\u4F7F\u7528\u9886\u82F1\u8D26\u53F7");
      else if (this.loginFrom === "twitter_oauth")
        return i18n.t("\u4F7F\u7528\u63A8\u7279\u8D26\u53F7");
      return "";
    },
    appIcon() {
      return iconList[this.loginFrom][getThemeColor()];
    }
  },
  methods: {
    async openAuthTab() {
      try {
        setSessionStorageItem("isReceiveMail", this.isReceiveMail);
        const randomNum = getUrlValue(SESSION_KEYS.RANDOM_NUM, getSessionStorageItem("appAuth") || "");
        const data2 = await getFormData();
        setSessionStorageItem("thirdLoginParam", JSON.stringify(data2));
        const app = isMirror() ? "mirror_app" : randomNum ? "masterdesktop" : "masterweb";
        const res = await getThirdPartyPath({
          source: this.loginFrom,
          callback_url: window.location.href,
          app
        });
        const newTabUrl = res.data;
        window.location.href = newTabUrl;
      } catch (error) {
        throw new Error(error);
      }
    }
  }
});
const __cssModules$Z = {};
var __component__$Z = /* @__PURE__ */ normalizeComponent(
  __vue2_script$Z,
  render$_,
  staticRenderFns$Z,
  false,
  __vue2_injectStyles$Z,
  "b89ed382",
  null,
  null
);
function __vue2_injectStyles$Z(context) {
  for (let o2 in __cssModules$Z) {
    this[o2] = __cssModules$Z[o2];
  }
}
var otherLogin = /* @__PURE__ */ function() {
  return __component__$Z.exports;
}();
var __$_require_763d9331__ = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAgCAYAAABgrToAAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAOzSURBVFiFtZg/c+JGGIefXbDboE8gp7guc+SccRmYFEkXV77STIq7NBloTGl5GOTy0jjVJRQZrsxVtHc3GWjtSYIzkyJprE8gPJMqgN4UEmiFJDAYfjPMSLvvrh5Wu+8fKR6qll+iQAWhiuIpgg0cRL2j6HcLeCj6TBnQskYPnj9HaqWF6x8Dxwi1NeceAW+AHhdWfwM2YBngpW8jOEvA7lB4AASUUHxEvKKLT+kypbnJimYDur6D4CTaBA9NH+ENAcPMh5nbAE6BktE7Ap6vu5ppQNd/hdBIgClcLqzuOhNHsHWEegJU4eJY7maAi3BrTpYLqvkFqG4ybwzY9hvAK6OvyYV19Sg4U+k/f4Jj9R4GeOnbBFwTv4rtwmVBCh7C0aqDowEI6MzhFFc7gQNwrCYSnXyFTYH6qiGaS98m3h8jplzuBG4mxYv5dbDat+qEn1P8sA3vv1QXVj+xim2/usxcI1Tmd8Jgp3DxU80tdLzcFOz53SNC0loSbo07O9eOEPAgur7bEU6W4m0UhshcFY3rUq7VthXgUeQJE+4pGFssQ0WEIYoyUKLll3Z+SICnFasiAXWB+z3F2e9LAcOMpAyApgzsdB9++iul6ZS3EEaJSUAZeJJnr4E43ChOdwkHMB1HixE/0372If+gaLSxYkItctw7059fEfvBSNOAXF+oObc8FHEqFYa9nUhuaMgNjUKRI1GcKegijAScvFWMk4Up71GR0TbSLBPsN2ygTkANzZE6jFfw2QfssfC9EsqFIkd/fEHikJrpVhV4Z/Rc4VjNR4FdU0NzGmXYoDlRh2SmWJ+8p3H3V2/47+hzG/AI8GhZd4sJazLVfwSk3OBAYq6++owvcwek81FQuDrR4FguivjVmgnm2oQLMTYZ3rL0dcYc9WKq0bFc2v4pYQiMT3jbr6GoAEOE21ThFKb2ZRQVFF0KVp/AcClB9qudjyXjJAteGjDULHkdROVnB6GKGBYaaPvpkQII9+qQplxzi6KMpjt5TUm+oaR+Jh2pCpzP5w4jmx0Vay/SVV3LP0Dzt2FcTtmsVqrEHH+LI0INzcn+a4Zzy7ZfAzoouihczq2Ej0wDtv0ycJ1om5WeAT3j88csC5n5Lw/wEAZ5dfPkJR2BmoIu0CuMGaiP/Xdo3LwCKqsuPkbCWLlxTZwj+Q578h//GE0j4PneT/nxf9mXBW9bYKbGL3mLmUUr+ns/5ruf7EOyxSiyKBF6ShmAwv0ye72scxfa79AVotiv6Bf3OVtm/z+V5mEJfut5mQAAAABJRU5ErkJggg==";
var wechatIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAcWSURBVHgB7VdNTFxVFD7nMcyUPx0EWhgWMI21NbaWpqlprJG/GlcmRJcuCqkmNjECumpiIo1uFUxs0mgMsDDubJu4tCmNG22TQliIoukMtYXWthkKI2Vg3r2ee+7PewO00oZGFxx+7rs/79zvnnPud84D2JRN+W8F17Poq8w7LUV56IAiuZdeaZQSGhFBUoueBylqp6gzJjw8+3blqRHYQLkvwMFMTzwvFroJRw9IjAMSDIlI/+glek31QcEE9RsoQ0hTfyjvecPHKk+l4XEA/PLO0W7atY+BKUDGWvyC7diGW/rvYIKdm/IQ+t6q/noYNgrgYKozniuD0zTcgsZCUtpNpQESejYIrXXVnGSg6JRTfyhWDL1dlUOz8AjiAPYTuFiJOE/bNBnV2oVOVvbDIkNuDr3LB+GBsdyC19qbfHiQnn2IluYHJYgmIQVt5ktqUbd52kSAENRXrZqXPrW+WadaQQiFXqf6ZF7VqnfMeFN0y3I/PIKwRb64+eYR0jxkBwPnIv48/hdMpu7CtuoSeOXFeus3HXysQIfij5dmYGo6Cy88XwPPJONrB7eUve8mvh2AhxDsT3XEvVhslBQ26h0NAtri7nwOTn4z4RYrgAcIgLkk7l6MT2bg+/NX3boPuvZALOaxDpAybI5ZP5dL9ibPrNvVHhQXd5ALiNt8qVzFrmE35pWbZXhxNOoZF6p5NUsupZ/F3HKBUqFDRIWCXuFCQ8S9aKQZHkIipO6I1FzmqMLwB1aUFcGh/TXwe3oeYgTu6YYyCinf2JfvMl+K53Y8Se79G27euQcHdldBcQR0vIJVjGFjdtDf2fUCxE+vdmSojeveKpcYMpb3eRs0b6/sh1sjFbiV13kYSb9RenJfZSWuy80RMn2cwwn5MqIjCrunBMds0oCgMeT1xoIFZ5J8RtzilcGe2GuYKN4NVZEkxLDMnp/SpMxks0IBHKM3hpaX4QIBTq8JkOOJHyWjZO4CsyunNtBjNluYdMeg6VkgnwqsJaNYDofKjsLOWLsxqj6Y2se4RLOE9loLaWqJUKBlsz4B9U6sBEoW9NVAg8XoXIYONxa4yz4L0OCVNXVKkdsjB7GtvAeiXqkBFEDUa12WkcYbiiZNiGBnJCKas9ml18vLo2MWoEc7jShSVqRqbpr+474f3EhF1HpMSkPa+iJoUt9Z3IqvVhwnC5boc6jsx38i9Kxtzz+S9bm+ThAiSXgvz83ljziA+bw/LJk6fJch1GLfAmEwvqEfnSVsxrBrEpHd0Fb+HtuFQQhhQiYABhacEBqcHjfhr/94Tu83kMksNVn7w8d/tKXoqQGl4QNzxnDuLbg4EK5dADqfGoQKb2sByc/Pz8G5C+cgt5SD9pfbobq6BlwY0bL5+Xma/4HnDzcfhuqqamlowASTHInHS1o5F5N9uhRyplWZB184SynLmf++zbXSEC+P7oq1MTjjNufWickJuD5zHW7fuQ0XL1+yYWMunJQTk7+E5i9yVUH6tGWB9bRkMvMtDLBvx8gIbdkndYLnBRxbQr3AJg9iU5o45HGBu+i2ilCcsfWprSivcBaur0uE3c0hkqhLOCckahMonNuFi1WAou6CnN7360sDNNG9lk+l+UWwNSFwIjxW/R1GsVTXhe56aj9O35i2AGywyDBLTM9Ms+5Ebb05WED6qMl+alXR8eFvBz8icuszJYvbkgtSzZHMf+o5huV4rOa0ASZD1XagdsV4mPOtNtBVO0LIJLpMpzFvJcBPdv50glw4zHEmdE0nzK3l+k71Qd/ee/6cDgmpb60wrQzTFRS6nmONb6rNP3oyWMP7oR4SqlhYS0SDLEhx2m9oMostElQ0zfk38ImibYHFgobrCVAxp92ljlBQkktH1yGogR6uxFcB7BltivtCtJhlafC8Xsz5aVlU1Cg8Qd8q2KDKJlWpqRNeWxpvfLbkcKMGYL743AeexSVd3GnuczN6GF2iKQw5hLFVMXh8fH8HGXkQPTmwuASfD+wbe2DVcetWppkcORLodJYJaNSU6ABBZYFhVPYrzKR+6yCRx+1rVubKiv8GLCw3b90+TcbscDcZgtpc45UhwxbUYwWFEpO0UUBv99durXofYQMklcnES5byo1J9NsCDsw5ahKESSX/iIHOrOcmVewvZ/clkctaDDZBkZeUs+aNVxazOtVIDkZpyrYECopbMAqA/HBAMQatldMNHSVe7Aqde2hCASurq6tKLC8X7aPshtR2lS50dhC0gfAT+CFDgTMGh6cZ+rygrnsktLrQpXVbvhgFUkkxWztbX1nZRkmwjE54BXS2aHK74z3AgCFNvmjLHWHd5eXnKWs7KhsTg/WRmZqaRbNBMhUYTRdleHtQ1yyw1aUI7TvSVpjN8RjOqvErX19VtR3yssB5Nrl671vnn9PSVVCoVh03ZlP+R/AMcBIawgdkROgAAAABJRU5ErkJggg==";
var render$Z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("div", {
    staticClass: "login-register-other"
  }, [!_vm.disableOptions.wecom ? _c("div", {
    staticClass: "login-register-wechat"
  }, [_c("button", {
    staticClass: "normal-btn",
    on: {
      "click": function($event) {
        return _vm.onThirdPartLoginBtnClick(_vm.ThirdPartType.WECOM);
      }
    }
  }, [_c("img", {
    attrs: {
      "src": __$_require_763d9331__,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.$_t("\u4F01\u4E1A\u5FAE\u4FE1\u767B\u5F55")) + " ")])]) : _vm._e(), !_vm.disableOptions.wechat ? _c("div", {
    staticClass: "login-register-wechat"
  }, [_c("button", {
    staticClass: "normal-btn",
    on: {
      "click": function($event) {
        return _vm.onThirdPartLoginBtnClick(_vm.ThirdPartType.WEIXIN);
      }
    }
  }, [_c("img", {
    attrs: {
      "src": wechatIcon,
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.$_t("\u5FAE\u4FE1\u767B\u5F55")) + " ")])]) : _vm._e(), !_vm.disableOptions.dingding ? _c("div", {
    staticClass: "login-register-ding-ding"
  }, [_c("button", {
    staticClass: "normal-btn",
    on: {
      "click": _vm.toDingDing
    }
  }, [_c("DingDingLogoIcon")], 1)]) : _vm._e(), !_vm.disableOptions.lanhu ? _c("div", {
    staticClass: "login-register-lanhu"
  }, [_c("button", {
    staticClass: "normal-btn",
    on: {
      "click": _vm.toLanhu
    }
  }, [_vm.isDarkTheme ? _c("LogoLanhuIcon") : _c("LogoLanhuIconLight", {
    attrs: {
      "size": "18"
    }
  })], 1)]) : _vm._e(), !_vm.disableOptions.google ? _c("div", {
    staticClass: "login-register-google"
  }, [_c("GoogleLogin", {
    attrs: {
      "clientId": _vm.googleOptions.clientId,
      "loginCallback": _vm.googleOptions.loginCallback,
      "isReceiveMail": _vm.isReceiveMail,
      "login_uri": _vm.googleOptions.login_uri
    },
    on: {
      "setUserInfo": _vm.setUserInfo
    }
  })], 1) : _vm._e(), !_vm.disableOptions.linkedin ? _c("div", {
    staticClass: "login-register-third"
  }, [_c("otherLogin", {
    attrs: {
      "isReceiveMail": _vm.isReceiveMail,
      "loginFrom": "linkedin_oauth"
    },
    on: {
      "setUserInfo": _vm.setUserInfo
    }
  })], 1) : _vm._e(), !_vm.disableOptions.twitter ? _c("div", {
    staticClass: "login-register-third"
  }, [_c("otherLogin", {
    attrs: {
      "isReceiveMail": _vm.isReceiveMail,
      "loginFrom": "twitter_oauth"
    },
    on: {
      "setUserInfo": _vm.setUserInfo
    }
  })], 1) : _vm._e()]), _c("div", {
    staticClass: "or-online"
  }, [_c("span", [_vm._v(_vm._s(_vm.$_t("\u6216")))])])]);
};
var staticRenderFns$Y = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$8 = "";
const __vue2_script$Y = defineComponent({
  name: "ThirdParty",
  components: {
    DingDingLogoIcon,
    LogoLanhuIcon,
    LogoLanhuIconLight,
    GoogleLogin,
    otherLogin
  },
  props: {
    redirectUri: {
      type: String,
      default: ""
    },
    disableOptions: {
      type: Object,
      default: () => ({
        thirdPartLogin: false,
        lanhu: false,
        wechat: false,
        dingding: false,
        google: true,
        linkedin: true,
        twitter: true,
        wecom: false
      })
    },
    googleOptions: {
      type: Object,
      default: () => ({
        clientId: "",
        loginCallback: () => {
        },
        login_uri: ""
      })
    },
    isReceiveMail: {
      type: Boolean,
      default: false
    }
  },
  emits: ["log", "onThirdPartBtnClick", "setUserInfo"],
  watch: {
    googleOptions(val) {
      console.log("googleOptions in third part login", val);
    }
  },
  setup(props2, { emit }) {
    const themeColor = ref(getThemeColor());
    const isDarkTheme = computed(() => themeColor.value === ThemeColor.Dark);
    const onThirdPartLoginBtnClick = (type2) => {
      emit("onThirdPartBtnClick", type2);
    };
    const toDingDing = () => {
      setSessionStorageItem(SESSION_KEYS.SOURCE_URL, window.location.href);
      emit("log", SensorsType.CLICK_LOGIN_BTN, {
        action_type: "dingding"
      });
      let redirectUri = props2.redirectUri;
      if (["https://", "http://"].every((url) => !redirectUri.startsWith(url))) {
        redirectUri = window.location.origin + "/" + redirectUri;
      }
      jumpDingOAuth(redirectUri);
    };
    const toLanhu = () => {
      setSessionStorageItem(SESSION_KEYS.SOURCE_URL, window.location.href);
      emit("log", SensorsType.CLICK_LOGIN_BTN, {
        action_type: "lanhu"
      });
      window.location.href = configs.LAN_HU_HOST + "/web/#/user/login?uselocal=true&platformName=mastergo";
    };
    const setUserInfo = (data2) => {
      emit("setUserInfo", data2);
    };
    return {
      themeColor,
      isDarkTheme,
      ThirdPartType,
      onThirdPartLoginBtnClick,
      toDingDing,
      toLanhu,
      setUserInfo
    };
  }
});
const __cssModules$Y = {};
var __component__$Y = /* @__PURE__ */ normalizeComponent(
  __vue2_script$Y,
  render$Z,
  staticRenderFns$Y,
  false,
  __vue2_injectStyles$Y,
  "239df212",
  null,
  null
);
function __vue2_injectStyles$Y(context) {
  for (let o2 in __cssModules$Y) {
    this[o2] = __cssModules$Y[o2];
  }
}
var ThirdPartLogin = /* @__PURE__ */ function() {
  return __component__$Y.exports;
}();
var render$Y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    attrs: {
      "id": "wxLoginCodeContainer"
    }
  });
};
var staticRenderFns$X = [];
var authQrCode_vue_vue_type_style_index_0_lang = "";
const __vue2_script$X = defineComponent({
  components: {},
  props: [
    "redirectUri"
  ],
  emits: ["changeState"],
  setup(props2, { emit }) {
    const timer = ref(null);
    onBeforeUnmount(() => {
      clearTimeout(timer.value);
    });
    onMounted(() => {
      timer.value = setTimeout(() => {
        emit("changeState", "retry");
        timer.value = null;
      }, 10 * 60 * 1e3);
      nextTick(() => {
        if (!window.WxLogin) {
          return;
        }
        let state = props2.redirectUri;
        if (["https://", "http://"].every((url) => !state.startsWith(url))) {
          state = window.location.origin + "/" + state;
        }
        const href = getThemeColor() === "dark" ? "https://static.mastergo.com/master-login/1.2.30/wechatIframeDark.css" : "https://static.mastergo.com/master-login/1.2.30/wechatIframeLight.css";
        new window.WxLogin({
          id: "wxLoginCodeContainer",
          appid: "wx030af9b07a55fbde",
          scope: "snsapi_login",
          redirect_uri: encodeURIComponent("https://mastergo.com/api/v1/wechat/proxy"),
          state: encodeURIComponent(state),
          style: "black",
          href
        });
      });
    });
  }
});
const __cssModules$X = {};
var __component__$X = /* @__PURE__ */ normalizeComponent(
  __vue2_script$X,
  render$Y,
  staticRenderFns$X,
  false,
  __vue2_injectStyles$X,
  null,
  null,
  null
);
function __vue2_injectStyles$X(context) {
  for (let o2 in __cssModules$X) {
    this[o2] = __cssModules$X[o2];
  }
}
var AuthQrCode = /* @__PURE__ */ function() {
  return __component__$X.exports;
}();
var render$X = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "qrcode-img"
  }, [_vm.qrCodeUrl ? _c("img", {
    staticClass: "img",
    attrs: {
      "src": _vm.qrCodeUrl,
      "alt": ""
    }
  }) : _vm._e()]);
};
var staticRenderFns$W = [];
var FollowQrCode_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$W = defineComponent({
  components: {},
  props: {
    state: {
      type: String,
      require: true
    }
  },
  emits: ["wechat", "changeState"],
  setup(props2, { emit }) {
    const interval = ref(null);
    const expireQrCodeInt = ref(null);
    const wechatToken = ref("");
    const wechatExpiresIn = ref(0);
    const qrCodeUrl = ref("");
    const init2 = () => {
      initData();
      cleanInterval();
      getTokenAndQrCode();
    };
    const initData = () => {
      wechatToken.value = "";
      emit("changeState", "");
      wechatExpiresIn.value = 0;
    };
    const getTokenAndQrCode = async () => {
      try {
        const res = await getWeChatQrCode();
        const { qrcode: qrcode2, token, expiresIn } = res.data;
        wechatToken.value = token;
        wechatExpiresIn.value = Date.now() + expiresIn * 1e3;
        qrCodeUrl.value = qrcode2;
        interval.value = setInterval(getSubstate, 1e3);
        expireQrCodeInt.value = setInterval(expireQrCode, 1e3);
      } catch {
      }
    };
    const getSubstate = async () => {
      if (!wechatToken.value)
        return;
      try {
        const res = await getWeChatSubState(wechatToken.value);
        const { state: code, token } = res.data;
        if (code === 2 && !props2.state) {
          emit("changeState", "success");
          setSessionStorageItem(SESSION_KEYS.WECHAT_LOGIN_START, token);
          cleanInterval();
          emit("wechat");
        }
      } catch (e2) {
        if (e2.response && e2.response.status === 400 && e2.response.data.code === "InvalidWeChatToken") {
          qrCodeExpire();
        }
      }
    };
    const qrCodeExpire = () => {
      emit("changeState", "retry");
      cleanInterval();
    };
    const expireQrCode = () => {
      if (!wechatExpiresIn.value || wechatExpiresIn.value > Date.now())
        return;
      qrCodeExpire();
    };
    const cleanInterval = () => {
      clearInterval(interval.value);
      clearInterval(expireQrCodeInt.value);
    };
    onMounted(() => {
      nextTick(() => {
        init2();
      });
    });
    onBeforeUnmount(() => {
      cleanInterval();
    });
    return {
      qrCodeUrl
    };
  }
});
const __cssModules$W = {};
var __component__$W = /* @__PURE__ */ normalizeComponent(
  __vue2_script$W,
  render$X,
  staticRenderFns$W,
  false,
  __vue2_injectStyles$W,
  "390b98d8",
  null,
  null
);
function __vue2_injectStyles$W(context) {
  for (let o2 in __cssModules$W) {
    this[o2] = __cssModules$W[o2];
  }
}
var FollowQrCode = /* @__PURE__ */ function() {
  return __component__$W.exports;
}();
var stateSuccessIcon = "data:image/png;base64,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";
var stateRetryIcon = "data:image/png;base64,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";
var render$W = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "34",
      "height": "34",
      "viewBox": "0 0 34 34"
    }
  }, [_c("clipPath", {
    attrs: {
      "id": "master_svg0_449_1154"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "34",
      "height": "34",
      "rx": "0"
    }
  })]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_449_1154)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M17.0011541015625,32.78575546875Q17.3886541015625,32.78575546875,17.7757541015625,32.76675546875Q18.1627541015625,32.74775546875,18.5484541015625,32.709755468750004Q18.9340541015625,32.67175546875,19.3174541015625,32.61495546875Q19.7007541015625,32.55805546875,20.0808541015625,32.482455468750004Q20.4608541015625,32.406855468749995,20.8367541015625,32.312655468749995Q21.2126541015625,32.21855546875,21.5835541015625,32.10605546875Q21.9543541015625,31.99355546875,22.3192541015625,31.86305546875Q22.6840541015625,31.73245546875,23.0420541015625,31.58415546875Q23.4001541015625,31.43585546875,23.7504541015625,31.27015546875Q24.1007541015625,31.10445546875,24.4424541015625,30.92185546875Q24.7842541015625,30.73915546875,25.1166541015625,30.53995546875Q25.4490541015625,30.34065546875,25.7712541015625,30.12545546875Q26.0934541015625,29.91015546875,26.4046541015625,29.67925546875Q26.7159541015625,29.44845546875,27.0155541015625,29.20255546875Q27.3150541015625,28.95675546875,27.6022541015625,28.69655546875Q27.8893541015625,28.43625546875,28.1633541015625,28.16225546875Q28.4373541015625,27.88825546875,28.6976541015625,27.60105546875Q28.9578541015625,27.31395546875,29.2036541015625,27.01445546875Q29.4495541015625,26.71485546875,29.6803541015625,26.40355546875Q29.9112541015625,26.09235546875,30.1265541015625,25.77015546875Q30.3417541015625,25.44795546875,30.5410541015625,25.11555546875Q30.7402541015625,24.78315546875,30.9229541015625,24.44135546875Q31.1055541015625,24.09965546875,31.2712541015625,23.74935546875Q31.4369541015625,23.39905546875,31.5852541015625,23.04095546875Q31.7335541015625,22.68295546875,31.8641541015625,22.31815546875Q31.9946541015625,21.95325546875,32.1071541015625,21.58245546875Q32.2196541015625,21.21155546875,32.313754101562495,20.83565546875Q32.407954101562495,20.45975546875,32.483554101562504,20.07975546875Q32.5591541015625,19.69965546875,32.6160541015625,19.31635546875Q32.6728541015625,18.93295546875,32.710854101562504,18.54735546875Q32.7488541015625,18.16165546875,32.7678541015625,17.77465546875Q32.7868541015625,17.38755546875,32.7868541015625,17.00005546875Q32.7868541015625,16.61255546875,32.7678541015625,16.22545546875Q32.7488541015625,15.83845546875,32.710854101562504,15.45275546875Q32.6728541015625,15.06715546875,32.6160541015625,14.68385546875Q32.5591541015625,14.30045546875,32.483554101562504,13.92045546875Q32.407954101562495,13.54035546875,32.313754101562495,13.16445546875Q32.2196541015625,12.78855546875,32.1071541015625,12.41775546875Q31.9946541015625,12.04685546875,31.8641541015625,11.68205546875Q31.7335541015625,11.31715546875,31.5852541015625,10.95913546875Q31.4369541015625,10.60111546875,31.2712541015625,10.25080546875Q31.1055541015625,9.90049546875,30.9229541015625,9.55873546875Q30.7402541015625,9.21697546875,30.5410541015625,8.88458546875Q30.3417541015625,8.55220546875,30.1265541015625,8.229995468750001Q29.9112541015625,7.90778546875,29.6803541015625,7.59652546875Q29.4495541015625,7.28527546875,29.2036541015625,6.98571546875Q28.9578541015625,6.68616546875,28.6976541015625,6.39903546875Q28.4373541015625,6.11189546875,28.1633541015625,5.83788546875Q27.8893541015625,5.56386546875,27.6021541015625,5.30362546875Q27.3150541015625,5.0433854687499995,27.0155541015625,4.79754546875Q26.7159541015625,4.55170546875,26.4046541015625,4.32086546875Q26.0934541015625,4.0900254687499995,25.7712541015625,3.87472546875Q25.4490541015625,3.65943546875,25.1166541015625,3.46021546875Q24.7842541015625,3.26098546875,24.4424541015625,3.07831546875Q24.1007541015625,2.89563546875,23.7504541015625,2.72995546875Q23.4001541015625,2.56426546875,23.0420541015625,2.41597546875Q22.6840541015625,2.2676754687500003,22.3192541015625,2.1371244687499997Q21.9543541015625,2.00657346875,21.5835541015625,1.89408246875Q21.2126541015625,1.78159246875,20.8367541015625,1.68743346875Q20.4608541015625,1.59327446875,20.0808541015625,1.51767346875Q19.7007541015625,1.44207246875,19.3174541015625,1.3852114687500001Q18.9340541015625,1.32835146875,18.5484541015625,1.29036796875Q18.1627541015625,1.25238466875,17.7757541015625,1.23337006875Q17.3886541015625,1.21435546875,17.0011541015625,1.21435546875Q16.6136541015625,1.21435546875,16.2265541015625,1.23337006875Q15.8395541015625,1.25238466875,15.4538541015625,1.29036796875Q15.0682541015625,1.32835146875,14.6849541015625,1.3852114687500001Q14.3015541015625,1.44207246875,13.9215541015625,1.51767346875Q13.5414541015625,1.59327446875,13.1655541015625,1.68743346875Q12.7896541015625,1.78159246875,12.4188541015625,1.89408246875Q12.0479541015625,2.00657346875,11.6831541015625,2.1371244687499997Q11.3182541015625,2.2676754687500003,10.9602341015625,2.41597546875Q10.6022141015625,2.56426546875,10.2519041015625,2.72995546875Q9.9015941015625,2.89563546875,9.5598341015625,3.07831546875Q9.2180741015625,3.26098546875,8.8856841015625,3.46021546875Q8.5533041015625,3.65943546875,8.231094101562501,3.87472546875Q7.9088841015625,4.0900254687499995,7.5976241015625,4.32086546875Q7.2863741015625,4.55170546875,6.9868141015625,4.79754546875Q6.6872641015625,5.0433854687499995,6.4001341015625,5.30362546875Q6.1129941015625,5.56386546875,5.8389841015625,5.83788546875Q5.5649641015625,6.11189546875,5.3047241015625,6.39903546875Q5.0444841015624995,6.68616546875,4.7986441015625,6.98571546875Q4.5528041015625,7.28527546875,4.3219641015625,7.59652546875Q4.0911241015624995,7.90778546875,3.8758241015625,8.229995468750001Q3.6605341015625,8.55220546875,3.4613141015625,8.88458546875Q3.2620841015625,9.21697546875,3.0794141015625,9.55873546875Q2.8967341015625,9.90049546875,2.7310541015625,10.25080546875Q2.5653641015625,10.60111546875,2.4170741015625,10.95913546875Q2.2687741015625003,11.31715546875,2.1382231015624997,11.68205546875Q2.0076721015625,12.04685546875,1.8951811015625,12.41775546875Q1.7826911015625,12.78855546875,1.6885321015625,13.16445546875Q1.5943731015625,13.54035546875,1.5187721015625,13.92045546875Q1.4431711015625,14.30045546875,1.3863101015625001,14.68385546875Q1.3294501015625,15.06715546875,1.2914666015625,15.45275546875Q1.2534833015625,15.83845546875,1.2344687015625,16.22545546875Q1.2154541015625,16.61255546875,1.2154541015625,17.00005546875Q1.2154541015625,17.38755546875,1.2344687015625,17.77465546875Q1.2534833015625,18.16165546875,1.2914666015625,18.54735546875Q1.3294501015625,18.93295546875,1.3863101015625001,19.31635546875Q1.4431711015625,19.69965546875,1.5187721015625,20.07975546875Q1.5943731015625,20.45975546875,1.6885321015625,20.83565546875Q1.7826911015625,21.21155546875,1.8951811015625,21.58245546875Q2.0076721015625,21.95325546875,2.1382231015624997,22.31815546875Q2.2687741015625003,22.68295546875,2.4170741015625,23.04095546875Q2.5653641015625,23.39905546875,2.7310541015625,23.74935546875Q2.8967341015625,24.09965546875,3.0794141015625,24.44135546875Q3.2620841015625,24.78315546875,3.4613141015625,25.11555546875Q3.6605341015625,25.44795546875,3.8758241015625,25.77015546875Q4.0911241015624995,26.09235546875,4.3219641015625,26.40355546875Q4.5528041015625,26.71485546875,4.7986441015625,27.01445546875Q5.0444841015624995,27.31395546875,5.3047241015625,27.60115546875Q5.5649641015625,27.88825546875,5.8389841015625,28.16225546875Q6.1129941015625,28.43625546875,6.4001341015625,28.69655546875Q6.6872641015625,28.95675546875,6.9868141015625,29.20255546875Q7.2863741015625,29.44845546875,7.5976241015625,29.67925546875Q7.9088841015625,29.91015546875,8.231094101562501,30.12545546875Q8.5533041015625,30.34065546875,8.8856841015625,30.53995546875Q9.2180741015625,30.73915546875,9.5598341015625,30.92185546875Q9.9015941015625,31.10445546875,10.2519041015625,31.27015546875Q10.6022141015625,31.43585546875,10.9602341015625,31.58415546875Q11.3182541015625,31.73245546875,11.6831541015625,31.86305546875Q12.0479541015625,31.99355546875,12.4188541015625,32.10605546875Q12.7896541015625,32.21855546875,13.1655541015625,32.312655468749995Q13.5414541015625,32.406855468749995,13.9215541015625,32.482455468750004Q14.3015541015625,32.55805546875,14.6849541015625,32.61495546875Q15.0682541015625,32.67175546875,15.4538541015625,32.709755468750004Q15.8395541015625,32.74775546875,16.2265541015625,32.76675546875Q16.6136541015625,32.78575546875,17.0011541015625,32.78575546875ZM26.9478541015625,13.05375546875C27.2323541015625,12.76915546875,27.2323541015625,12.30785546875,26.9478541015625,12.02335546875L25.4023541015625,10.47782546875C25.1177541015625,10.19330546875,24.6564541015625,10.19329546875,24.3719541015625,10.47782546875L15.6252541015625,19.22445546875L11.5107541015625,15.08495546875C11.2271541015625,14.79955546875,10.7658141015625,14.79815546875,10.4804241015625,15.08175546875L8.930194101562499,16.62255546875C8.6448041015625,16.90625546875,8.6434041015625,17.36755546875,8.9270541015625,17.65295546875L15.1021541015625,23.86575546875C15.3864541015625,24.15175546875,15.8489541015625,24.15245546875,16.134054101562498,23.86735546875L26.9478541015625,13.05375546875Z",
      "fill-rule": "evenodd",
      "fill": "#0AC700",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$V = [];
const __vue2_script$V = defineComponent({
  name: "CheckedGreen",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$V = {};
var __component__$V = /* @__PURE__ */ normalizeComponent(
  __vue2_script$V,
  render$W,
  staticRenderFns$V,
  false,
  __vue2_injectStyles$V,
  null,
  null,
  null
);
function __vue2_injectStyles$V(context) {
  for (let o2 in __cssModules$V) {
    this[o2] = __cssModules$V[o2];
  }
}
var CheckedGreen = /* @__PURE__ */ function() {
  return __component__$V.exports;
}();
var render$V = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "34",
      "height": "34",
      "viewBox": "0 0 34 34"
    }
  }, [_c("clipPath", {
    attrs: {
      "id": "master_svg0_472_1500"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "34",
      "height": "34",
      "rx": "0"
    }
  })]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_472_1500)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M17.5,34.5Q17.9173,34.5,18.3342,34.4795Q18.751,34.459,19.1663,34.4181Q19.5816,34.3772,19.9944,34.316Q20.4072,34.2548,20.8165,34.1733Q21.2258,34.0919,21.6307,33.9905Q22.0355,33.8891,22.4348,33.768Q22.8342,33.6468,23.2271,33.5062Q23.6201,33.3657,24.0056,33.2059Q24.3912,33.0462,24.7684,32.8678Q25.1457,32.6894,25.5137,32.4927Q25.8818,32.2959,26.2397,32.0814Q26.5977,31.8668,26.9447,31.635Q27.2917,31.4031,27.6269,31.1545Q27.9621,30.9059,28.2847,30.6412Q28.6073,30.3764,28.9165,30.0962Q29.2257,29.8159,29.5208,29.5208Q29.8159,29.2257,30.0962,28.9165Q30.3764,28.6073,30.6412,28.2847Q30.9059,27.9621,31.1545,27.6269Q31.4031,27.2917,31.635,26.9447Q31.8668,26.5977,32.0814,26.2397Q32.2959,25.8818,32.4927,25.5137Q32.6894,25.1457,32.8678,24.7684Q33.0462,24.3912,33.2059,24.0056Q33.3657,23.6201,33.5062,23.2271Q33.6468,22.8342,33.768,22.4348Q33.8891,22.0355,33.9905,21.6307Q34.0919,21.2258,34.1733,20.8165Q34.2548,20.4072,34.316,19.9944Q34.3772,19.5816,34.4181,19.1663Q34.459,18.751,34.4795,18.3342Q34.5,17.9173,34.5,17.5Q34.5,17.0827,34.4795,16.6658Q34.459,16.249000000000002,34.4181,15.8337Q34.3772,15.4184,34.316,15.0056Q34.2548,14.5928,34.1733,14.1835Q34.0919,13.7742,33.9905,13.3693Q33.8891,12.9645,33.768,12.5652Q33.6468,12.1658,33.5062,11.7729Q33.3657,11.3799,33.2059,10.9944Q33.0462,10.6088,32.8678,10.23156Q32.6894,9.8543,32.4927,9.48625Q32.2959,9.11821,32.0814,8.76025Q31.8668,8.4023,31.635,8.05531Q31.4031,7.70831,31.1545,7.37311Q30.9059,7.03791,30.6412,6.71531Q30.3764,6.39272,30.0962,6.0835Q29.8159,5.77428,29.5208,5.47918Q29.2257,5.18409,28.9165,4.90383Q28.6073,4.62357,28.2847,4.35882Q27.9621,4.09407,27.6269,3.84547Q27.2917,3.59687,26.9447,3.36502Q26.5977,3.13316,26.2397,2.91861Q25.8818,2.70406,25.5137,2.50734Q25.1457,2.31061,24.7684,2.13218Q24.3912,1.95375,24.0056,1.79405Q23.6201,1.63434,23.2271,1.493751Q22.8342,1.353158,22.4348,1.232014Q22.0355,1.110871,21.6307,1.009469Q21.2258,0.908067,20.8165,0.82665Q20.4072,0.745234,19.9944,0.683999Q19.5816,0.622765,19.1663,0.5818596Q18.751,0.5409545,18.3342,0.5204772Q17.9173,0.5,17.5,0.5Q17.0827,0.5,16.6658,0.5204772Q16.249000000000002,0.5409545,15.8337,0.5818596Q15.4184,0.622765,15.0056,0.683999Q14.5928,0.745234,14.1835,0.82665Q13.7742,0.908067,13.3693,1.009469Q12.9645,1.110871,12.5652,1.232014Q12.1658,1.353158,11.7729,1.493751Q11.3799,1.63434,10.9944,1.79405Q10.6088,1.95375,10.23156,2.13218Q9.8543,2.31061,9.48625,2.50734Q9.11821,2.70406,8.76025,2.91861Q8.4023,3.13316,8.05531,3.36502Q7.70831,3.59687,7.37311,3.84547Q7.03791,4.09407,6.71531,4.35882Q6.39272,4.62357,6.0835,4.90383Q5.77428,5.18409,5.47918,5.47918Q5.18409,5.77428,4.90383,6.0835Q4.62357,6.39272,4.35882,6.71531Q4.09407,7.03791,3.84547,7.37311Q3.59687,7.70831,3.36502,8.05531Q3.13316,8.4023,2.91861,8.76025Q2.70406,9.11821,2.50734,9.48625Q2.31061,9.8543,2.13218,10.23156Q1.95375,10.6088,1.79405,10.9944Q1.63434,11.3799,1.493751,11.7729Q1.353158,12.1658,1.232014,12.5652Q1.110871,12.9645,1.009469,13.3693Q0.908067,13.7742,0.82665,14.1835Q0.745234,14.5928,0.683999,15.0056Q0.622765,15.4184,0.5818596,15.8337Q0.5409545,16.249000000000002,0.5204772,16.6658Q0.5,17.0827,0.5,17.5Q0.5,17.9173,0.5204772,18.3342Q0.5409545,18.751,0.5818596,19.1663Q0.622765,19.5816,0.683999,19.9944Q0.745234,20.4072,0.82665,20.8165Q0.908067,21.2258,1.009469,21.6307Q1.110871,22.0355,1.232014,22.4348Q1.353158,22.8342,1.493751,23.2271Q1.63434,23.6201,1.79405,24.0056Q1.95375,24.3912,2.13218,24.7684Q2.31061,25.1457,2.50734,25.5137Q2.70406,25.8818,2.91861,26.2397Q3.13316,26.5977,3.36502,26.9447Q3.59687,27.2917,3.84547,27.6269Q4.09407,27.9621,4.35882,28.2847Q4.62357,28.6073,4.90383,28.9165Q5.18409,29.2257,5.47918,29.5208Q5.77428,29.8159,6.0835,30.0962Q6.39272,30.3764,6.71531,30.6412Q7.03791,30.9059,7.37311,31.1545Q7.70831,31.4031,8.05531,31.635Q8.4023,31.8668,8.76025,32.0814Q9.11821,32.2959,9.48625,32.4927Q9.8543,32.6894,10.23156,32.8678Q10.6088,33.0462,10.9944,33.2059Q11.3799,33.3657,11.7729,33.5062Q12.1658,33.6468,12.5652,33.768Q12.9645,33.8891,13.3693,33.9905Q13.7742,34.0919,14.1835,34.1733Q14.5928,34.2548,15.0056,34.316Q15.4184,34.3772,15.8337,34.4181Q16.249000000000002,34.459,16.6658,34.4795Q17.0827,34.5,17.5,34.5ZM17.8329,7.03845C14.7277,7.03845,12.2105,9.80707,12.2105,11.9832L12.2105,12.7428L14.925,12.7428C15.1901,12.7428,15.4133,12.5445,15.4444,12.2813L15.4797,11.9832C15.5548,11.1119,16.5333,10.25532,17.8329,10.25532C19.1325,10.25532,20.186,11.292,20.186,12.5708L20.186,12.7428L23.4552,12.7428L23.4552,12.5708C23.4552,9.51536,20.938,7.03845,17.8329,7.03845ZM20.1864,12.7428C20.1864,13.5061,19.8056,13.8492,18.5502,14.8937C17.3773,15.8695,15.7556,17.309,15.7556,20.1154L19.0248,20.1154C19.0248,18.8259,19.6185,18.2175,20.661,17.3502C20.7319,17.2912,20.8076,17.2294,20.887,17.1647C21.882,16.3535,23.4556,15.0705,23.4556,12.7428L20.1864,12.7428ZM20.1154,25.3461Q20.1154,25.4746,20.1028,25.6025Q20.0902,25.7303,20.0652,25.8563Q20.0401,25.9824,20.0028,26.1053Q19.9655,26.2283,19.9163,26.347Q19.8672,26.4657,19.8066,26.579Q19.746,26.6923,19.6746,26.7991Q19.6033,26.906,19.5217,27.0053Q19.4402,27.1046,19.3494,27.1955Q19.2585,27.2863,19.1592,27.3678Q19.0599,27.4493,18.9531,27.5207Q18.8462,27.5921,18.7329,27.6527Q18.6196,27.7132,18.5009,27.7624Q18.3822,27.8116,18.2592,27.8489Q18.1363,27.8862,18.0103,27.9112Q17.8842,27.9363,17.7564,27.9489Q17.6285,27.9615,17.5,27.9615Q17.3715,27.9615,17.2437,27.9489Q17.1158,27.9363,16.9898,27.9112Q16.8638,27.8862,16.7408,27.8489Q16.6179,27.8116,16.499200000000002,27.7624Q16.380499999999998,27.7132,16.2671,27.6527Q16.1538,27.5921,16.047,27.5207Q15.9402,27.4493,15.8408,27.3678Q15.7415,27.2863,15.6507,27.1955Q15.5598,27.1046,15.4783,27.0053Q15.3968,26.906,15.3254,26.7991Q15.254,26.6923,15.1935,26.579Q15.1329,26.4657,15.0837,26.347Q15.0346,26.2283,14.9973,26.1053Q14.96,25.9824,14.9349,25.8563Q14.9098,25.7303,14.8972,25.6025Q14.8846,25.4746,14.8846,25.3461Q14.8846,25.2176,14.8972,25.0897Q14.9098,24.9619,14.9349,24.8359Q14.96,24.7098,14.9973,24.5869Q15.0346,24.4639,15.0837,24.3452Q15.1329,24.2265,15.1935,24.1132Q15.254,23.9999,15.3254,23.8931Q15.3968,23.7862,15.4783,23.6869Q15.5598,23.5876,15.6507,23.4967Q15.7415,23.4059,15.8408,23.3244Q15.9402,23.2429,16.047,23.1715Q16.1538,23.1001,16.2671,23.0395Q16.380499999999998,22.979,16.499200000000002,22.9298Q16.6179,22.8806,16.7408,22.8433Q16.8638,22.806,16.9898,22.781Q17.1158,22.7559,17.2437,22.7433Q17.3715,22.7307,17.5,22.7307Q17.6285,22.7307,17.7564,22.7433Q17.8842,22.7559,18.0103,22.781Q18.1363,22.806,18.2592,22.8433Q18.3822,22.8806,18.5009,22.9298Q18.6196,22.979,18.7329,23.0395Q18.8462,23.1001,18.9531,23.1715Q19.0599,23.2429,19.1592,23.3244Q19.2585,23.4059,19.3494,23.4967Q19.4402,23.5876,19.5217,23.6869Q19.6033,23.7862,19.6746,23.8931Q19.746,23.9999,19.8066,24.1132Q19.8672,24.2265,19.9163,24.3452Q19.9655,24.4639,20.0028,24.5869Q20.0401,24.7098,20.0652,24.8359Q20.0902,24.9619,20.1028,25.0897Q20.1154,25.2176,20.1154,25.3461Z",
      "fill-rule": "evenodd",
      "fill": "#0256FF",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$U = [];
const __vue2_script$U = defineComponent({
  name: "QuestionIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$U = {};
var __component__$U = /* @__PURE__ */ normalizeComponent(
  __vue2_script$U,
  render$V,
  staticRenderFns$U,
  false,
  __vue2_injectStyles$U,
  null,
  null,
  null
);
function __vue2_injectStyles$U(context) {
  for (let o2 in __cssModules$U) {
    this[o2] = __cssModules$U[o2];
  }
}
var QuestionIcon = /* @__PURE__ */ function() {
  return __component__$U.exports;
}();
var render$U = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      marginTop: "2px",
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "34",
      "height": "34",
      "viewBox": "0 0 34 34"
    }
  }, [_c("g", [_c("g"), _c("path", {
    attrs: {
      "d": "M32.78569443359375,16.9999333984375C32.78569443359375,25.7182333984375,25.71829443359375,32.7856333984375,16.99999443359375,32.7856333984375C8.28180443359375,32.7856333984375,1.21429443359375,25.7182333984375,1.21429443359375,16.9999333984375C1.21429443359375,8.2817433984375,8.28180443359375,1.2142333984375,16.99999443359375,1.2142333984375C25.71829443359375,1.2142333984375,32.78569443359375,8.2817433984375,32.78569443359375,16.9999333984375ZM14.81309443359375,9.7022833984375C14.68369443359375,8.408463398437501,15.69969443359375,7.2857633984375,16.99999443359375,7.2857633984375C18.30029443359375,7.2857633984375,19.31629443359375,8.4084533984375,19.18689443359375,9.7022833984375L18.33509443359375,18.2203333984375C18.26649443359375,18.9063333984375,17.68929443359375,19.4286333984375,16.99999443359375,19.4286333984375C16.31069443359375,19.4286333984375,15.73349443359375,18.9063333984375,15.66489443359375,18.2203333984375L14.81309443359375,9.7022833984375ZM16.99999443359375,26.7107333984375C15.65719443359375,26.7107333984375,14.57139443359375,25.6345333984375,14.57139443359375,24.2822333984375C14.57139443359375,22.9575333984375,15.65719443359375,21.8536333984375,16.99999443359375,21.8536333984375C18.34289443359375,21.8536333984375,19.42859443359375,22.9299333984375,19.42859443359375,24.2822333984375C19.42859443359375,25.6345333984375,18.34289443359375,26.7107333984375,16.99999443359375,26.7107333984375Z",
      "fill-rule": "evenodd",
      "fill": "#F4B60C",
      "fill-opacity": "1"
    }
  })])]);
};
var staticRenderFns$T = [];
const __vue2_script$T = defineComponent({
  name: "WarningTipsIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$T = {};
var __component__$T = /* @__PURE__ */ normalizeComponent(
  __vue2_script$T,
  render$U,
  staticRenderFns$T,
  false,
  __vue2_injectStyles$T,
  null,
  null,
  null
);
function __vue2_injectStyles$T(context) {
  for (let o2 in __cssModules$T) {
    this[o2] = __cssModules$T[o2];
  }
}
var WarningTipsIcon = /* @__PURE__ */ function() {
  return __component__$T.exports;
}();
var render$T = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.loaded ? _c("div", {
    staticClass: "qrcode",
    class: !_vm.useFollowCode && "qrcode__no-bottom",
    style: {
      width: _vm.width
    }
  }, [_c("div", {
    staticClass: "qrcode-act"
  }, [_vm.showCode ? _c(_vm.useFollowCode ? "FollowQrCode" : "AuthQrCode", {
    tag: "component",
    staticClass: "img",
    class: "m-img__" + _vm.state,
    attrs: {
      "state": _vm.state,
      "redirectUri": _vm.redirectUri
    },
    on: {
      "changeState": _vm.changeState,
      "wechat": _vm.weChat
    }
  }) : _vm._e(), !!_vm.state && _vm.useOldTip ? _c("div", {
    staticClass: "qrcode-display",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadCode.apply(null, arguments);
      }
    }
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      "src": _vm.stateInfo[_vm.state].img,
      "alt": ""
    }
  }), _c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.stateInfo[_vm.state].title))]), _c("div", {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.stateInfo[_vm.state].desc))])]) : !_vm.useOldTip && _vm.state === "retry" ? _c("div", {
    staticClass: "qrcode-cover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadCode.apply(null, arguments);
      }
    }
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      "src": _vm.stateInfo[_vm.state].img,
      "alt": ""
    }
  })]) : _vm._e()], 1), _vm.useOldTip ? _c("div", {
    staticClass: "qrcode-text"
  }, [_vm._v(" " + _vm._s(_vm.$_t('\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 "MasterGo \u4EA7\u54C1\u8BBE\u8BA1\u5DE5\u5177" \u5FEB\u901F')) + _vm._s(_vm.isLogin ? _vm.$_t("\u767B\u5F55") : _vm.$_t("\u6CE8\u518C")) + " ")]) : _vm.state === "success" ? [_c("div", {
    staticClass: "qrcode-tip-wrap"
  }, [_c("div", {
    staticClass: "qrcode-tip-text"
  }, [_c("div", {
    staticClass: "qrcode-tip-icon"
  }, [_c("CheckedGreen")], 1), _c("span", {
    staticClass: "qrcode-tip-text-title"
  }, [_vm._v(_vm._s(_vm.$_t("\u626B\u7801\u6210\u529F")))])])]), _c("div", {
    staticClass: "qrcode-tip-text-context"
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5FAE\u4FE1\u4E2D\u70B9\u51FB\u5173\u6CE8\u5373\u53EF\u6CE8\u518C\u6210\u529F")) + " ")])] : _vm.state === "retry" ? [_c("div", {
    staticClass: "qrcode-tip-wrap"
  }, [_c("div", {
    staticClass: "qrcode-tip-text"
  }, [_c("div", {
    staticClass: "qrcode-tip-icon"
  }, [_c("WarningTipsIcon")], 1), _c("span", {
    staticClass: "qrcode-tip-text-title"
  }, [_vm._v(_vm._s(_vm.$_t("\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548")))])])]), _c("div", {
    staticClass: "qrcode-tip-text-context"
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u8BF7")) + " "), _c("button", {
    staticClass: "refresh-btn",
    on: {
      "click": _vm.reloadCode
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5237\u65B0")) + " ")]), _vm._v(" " + _vm._s(_vm.$_t("\u540E\u518D\u6B21\u5C1D\u8BD5\u6216\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F")) + " ")])] : _vm.tipUserLogin && _vm.useFollowCode ? [_c("div", {
    staticClass: "qrcode-tip-wrap"
  }, [_c("div", {
    staticClass: "qrcode-tip-text"
  }, [_c("div", {
    staticClass: "qrcode-tip-icon"
  }, [_c("QuestionIcon")], 1), _c("span", {
    staticClass: "qrcode-tip-text-title"
  }, [_vm._v(_vm._s(_vm.$_t("\u626B\u7801\u9047\u5230\u95EE\u9898?")))])])]), _c("div", {
    staticClass: "qrcode-tip-text-context"
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u53EF")) + " "), _c("button", {
    staticClass: "refresh-btn",
    on: {
      "click": _vm.reloadCode
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5237\u65B0\u4E8C\u7EF4\u7801")) + " ")]), _vm._v(" " + _vm._s(_vm.$_t("\u540E\u518D\u6B21\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8")) + " ")])] : _vm.useFollowCode ? _c("div", {
    staticClass: "qrcode-default-text"
  }, [_vm._v(" " + _vm._s(_vm.useFollowCode ? _vm.$_t("\u5FAE\u4FE1\u626B\u7801\u5173\u6CE8 MasterGo \u516C\u4F17\u53F7 \u5373\u53EF\u5FEB\u901F%{slot1}", {
    slot1: _vm.isLogin ? _vm.$_t("\u767B\u5F55") : _vm.$_t("\u6CE8\u518C")
  }) : "") + " ")]) : _vm._e()], 2) : _vm._e();
};
var staticRenderFns$S = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$7 = "";
const __vue2_script$S = defineComponent({
  name: "WeChatQrCode",
  components: {
    AuthQrCode,
    FollowQrCode,
    CheckedGreen,
    QuestionIcon,
    WarningTipsIcon
  },
  props: {
    isLogin: {
      type: Boolean,
      require: true
    },
    width: {
      type: String,
      default: "312px"
    },
    redirectUri: {
      type: String,
      default: ""
    }
  },
  emits: ["log", "wechat"],
  setup(props2, { emit }) {
    const state = ref("");
    const stateInfo = reactive({
      success: {
        title: i18n.t("\u626B\u7801\u6210\u529F"),
        img: stateSuccessIcon,
        desc: i18n.t("\u8BF7\u5728\u624B\u673A\u4E0A\u64CD\u4F5C")
      },
      retry: {
        title: i18n.t("\u4E8C\u7EF4\u7801\u5DF2\u5931\u6548"),
        img: stateRetryIcon,
        desc: i18n.t("\u70B9\u51FB\u5237\u65B0")
      }
    });
    const loaded = ref(true);
    const useFollowCode = ref(true);
    const showCode = ref(true);
    const useOldTip = ref(true);
    const tipUserLogin = ref(false);
    const timer = ref(null);
    watch(showCode, (flag) => {
      state.value = "";
      if (useOldTip.value)
        return;
      if (!useFollowCode.value)
        return;
      if (flag) {
        timer.value = setTimeout(() => {
          tipUserLogin.value = true;
          timer.value = null;
        }, 60 * 1e3);
      } else {
        if (timer.value) {
          clearTimeout(timer.value);
          timer.value = null;
        }
      }
    });
    const reloadCode = () => {
      console.log("reload");
      if (state.value === "retry") {
        showCode.value = false;
        nextTick(() => {
          showCode.value = true;
        });
      }
    };
    const changeState = (s) => {
      state.value = s;
    };
    const weChat = (code) => {
      emit("wechat", code);
    };
    onMounted(async () => {
      initWeiXin();
      loaded.value = true;
      nextTick(() => {
        emit("log", SensorsType.CLICK_LOGIN_BTN, {
          action_type: "wechat"
        });
        emit("log", SensorsType.WECHAT_QR_LOAD, {
          action_type: props2.isLogin ? "login" : "register"
        });
      });
    });
    return {
      stateInfo,
      state,
      reloadCode,
      loaded,
      changeState,
      weChat,
      showCode,
      useFollowCode,
      tipUserLogin,
      useOldTip
    };
  }
});
const __cssModules$S = {};
var __component__$S = /* @__PURE__ */ normalizeComponent(
  __vue2_script$S,
  render$T,
  staticRenderFns$S,
  false,
  __vue2_injectStyles$S,
  "3c068a1c",
  null,
  null
);
function __vue2_injectStyles$S(context) {
  for (let o2 in __cssModules$S) {
    this[o2] = __cssModules$S[o2];
  }
}
var WeChatQrCode = /* @__PURE__ */ function() {
  return __component__$S.exports;
}();
var render$S = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    ref: "container",
    staticClass: "wecom-qrcode"
  });
};
var staticRenderFns$R = [];
var WecomQrCode_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$R = defineComponent({
  name: "WecomQrCode",
  props: {
    isLogin: {
      type: Boolean,
      default: true
    },
    redirectUri: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "312px"
    }
  },
  emits: ["wecom", "log"],
  setup(props2, { emit }) {
    const container = ref(null);
    const scriptLoaded = /* @__PURE__ */ new Set();
    const loadScript = (src) => new Promise((resolve, reject) => {
      if (scriptLoaded.has(src))
        return resolve();
      const existed = document.querySelector(`script[src="${src}"]`);
      if (existed) {
        scriptLoaded.add(src);
        return resolve();
      }
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        scriptLoaded.add(src);
        resolve();
      };
      script.onerror = reject;
      document.body.appendChild(script);
    });
    const fetchWecomConfig = async () => {
      const res = await axios.get("/api/v1/signin/wecom/config");
      return res.data || {};
    };
    const handlePostMessage = (ev) => {
      var _a2;
      try {
        if (typeof ev.data === "string" && ev.data.includes("wework_wechat_auth_code")) {
          const params = new URLSearchParams(ev.data);
          const code = params.get("code");
          if (code) {
            emit("wecom", code);
          }
        } else if (typeof ev.data === "object" && ((_a2 = ev.data) == null ? void 0 : _a2.code)) {
          emit("wecom", ev.data.code);
        }
      } catch (e2) {
      }
    };
    onMounted(async () => {
      window.addEventListener("message", handlePostMessage);
      const cfg = await fetchWecomConfig();
      const saasSDK = "https://wwcdn.weixin.qq.com/node/wework/wwopen/js/wwLogin-1.2.7.js";
      const { corpID: appid, agentID: agentid, state = "mg_" + Date.now(), jssdk_url: sdkUrl, host } = cfg.data;
      try {
        await loadScript(sdkUrl || saasSDK);
      } catch (error) {
        console.error("Failed to load WeCom SDK:", error);
        return;
      }
      const id2 = `wecom_login_container_${Date.now()}`;
      if (container.value) {
        container.value.id = id2;
      }
      await nextTick();
      try {
        new window.WwLogin({
          id: id2,
          appid,
          agentid,
          redirect_uri: `${window.location.origin}/files/home?isWecom=true`,
          state,
          self_redirect: true,
          host: host || "http://103.160.25.88"
        });
      } catch (error) {
        console.error("Failed to create WeCom login:", error);
      }
    });
    onBeforeUnmount(() => {
      window.removeEventListener("message", handlePostMessage);
    });
    return {
      container
    };
  }
});
const __cssModules$R = {};
var __component__$R = /* @__PURE__ */ normalizeComponent(
  __vue2_script$R,
  render$S,
  staticRenderFns$R,
  false,
  __vue2_injectStyles$R,
  "5467cb5e",
  null,
  null
);
function __vue2_injectStyles$R(context) {
  for (let o2 in __cssModules$R) {
    this[o2] = __cssModules$R[o2];
  }
}
var WecomQrCode = /* @__PURE__ */ function() {
  return __component__$R.exports;
}();
var __$_require_7ebacaba__ = "data:image/svg+xml;base64,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";
var render$R = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isWeiXin && _vm.showWechatLogin ? _c("div", {
    staticClass: "wechat-login"
  }, [_c("div", {
    staticClass: "weixin-login-wrap",
    on: {
      "click": function($event) {
        return _vm.replaceWeiXin("snsapi_userinfo");
      }
    }
  }, [_vm._m(0), _c("div", {
    staticClass: "weixin-login-text"
  }, [_vm._v(_vm._s(_vm.$_t("\u5FAE\u4FE1\u7528\u6237\u76F4\u63A5\u767B\u5F55")))]), _vm.dialogVisible ? _c("div", {
    staticClass: "auth-login-model"
  }) : _vm._e()])]) : _vm._e();
};
var staticRenderFns$Q = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "weixin-logo-wrap"
  }, [_c("img", {
    staticClass: "weixin-logo",
    attrs: {
      "src": __$_require_7ebacaba__
    }
  })]);
}];
var index_vue_vue_type_style_index_0_scoped_true_lang$6 = "";
const __vue2_script$Q = {
  props: {
    appId: {
      type: String,
      default: "wx02a77173f79b5fcb"
    },
    actionPosition: {
      type: String,
      default: "masterWeb"
    }
  },
  emits: ["loginEnd"],
  setup(props2, { emit }) {
    const dialogVisible = ref(false);
    const isWeiXin = ref(platformInfo().isWeiXin);
    const isLoading = ref(false);
    const showWechatLogin = ref(true);
    const replaceWeiXin = (scope = "snsapi_base") => {
      if (isLoading.value)
        return;
      const redirectUri = removeQuery(
        removeQuery(
          window.location.href,
          WEI_XIN_FAST_LOGIN_CONFIG.response_type
        ),
        "state"
      );
      const url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${props2.appId}&redirect_uri=${window.encodeURIComponent(redirectUri)}&response_type=${WEI_XIN_FAST_LOGIN_CONFIG.response_type}&scope=${scope}&state=${WEI_XIN_FAST_LOGIN_CONFIG.state}#wechat_redirect`;
      window.location.replace(url);
    };
    const weiXinLogin = () => {
      if (!isWeiXin.value) {
        showWechatLogin.value = false;
        return;
      }
      if (isWeiXinFastPage()) {
        const code = getUrlValue$1(WEI_XIN_FAST_LOGIN_CONFIG.response_type);
        if (!code)
          return;
        dialogVisible.value = true;
        isLoading.value = true;
        wechatLogin({
          code,
          subToken: "",
          source: "wechat_h5",
          oauthType: "web"
        }).then((res) => {
          isLoading.value = false;
          emit("loginEnd", null, res.data);
        }).catch((err) => {
          isLoading.value = false;
          dialogVisible.value = false;
          emit("loginEnd", err);
        });
      } else {
        const KEY = "WEI_XIN_SNSAPI_BASE_DONE";
        if (getSessionStorageItem$1(KEY))
          return;
        dialogVisible.value = true;
        setSessionStorageItem(KEY, "1");
        replaceWeiXin();
      }
    };
    onMounted(() => {
      weiXinLogin();
    });
    return {
      isWeiXin,
      dialogVisible,
      replaceWeiXin,
      showWechatLogin
    };
  }
};
const __cssModules$Q = {};
var __component__$Q = /* @__PURE__ */ normalizeComponent(
  __vue2_script$Q,
  render$R,
  staticRenderFns$Q,
  false,
  __vue2_injectStyles$Q,
  "2fb8084c",
  null,
  null
);
function __vue2_injectStyles$Q(context) {
  for (let o2 in __cssModules$Q) {
    this[o2] = __cssModules$Q[o2];
  }
}
var WechatDialog = /* @__PURE__ */ function() {
  return __component__$Q.exports;
}();
var render$Q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M3.18711 6.58315L8.94645 1.19991C9.0654 1.08872 9.25133 1.09272 9.3654 1.20892L9.78465 1.63604C9.90272 1.75633 9.89855 1.95026 9.77541 2.06536L4.48531 7.01L9.7741 11.9334C9.89747 12.0483 9.90204 12.2422 9.78421 12.3627L9.36586 12.7907C9.25203 12.9071 9.06611 12.9115 8.94693 12.8005L3.18799 7.43941C3.06809 7.32779 3.00017 7.17318 3 7.01147C2.99983 6.84975 3.06743 6.69501 3.18711 6.58315Z",
      "fill": "currentcolor"
    }
  })]);
};
var staticRenderFns$P = [];
const __vue2_script$P = defineComponent({
  name: "ChevronLeftIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$P = {};
var __component__$P = /* @__PURE__ */ normalizeComponent(
  __vue2_script$P,
  render$Q,
  staticRenderFns$P,
  false,
  __vue2_injectStyles$P,
  null,
  null,
  null
);
function __vue2_injectStyles$P(context) {
  for (let o2 in __cssModules$P) {
    this[o2] = __cssModules$P[o2];
  }
}
var ChevronLeftIcon = /* @__PURE__ */ function() {
  return __component__$P.exports;
}();
var render$P = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7ZM13.5 7C13.5 10.5899 10.5899 13.5 7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7ZM6.0995 3.99504C6.04623 3.46229 6.46459 3 7 3C7.53541 3 7.95377 3.46229 7.9005 3.99504L7.54975 7.50248C7.52151 7.78492 7.28384 8 7 8C6.71616 8 6.47849 7.78492 6.45025 7.50249L6.0995 3.99504ZM7 10.9985C6.44706 10.9985 6 10.5554 6 9.99854C6 9.45308 6.44706 8.99854 7 8.99854C7.55294 8.99854 8 9.44172 8 9.99854C8 10.5554 7.55294 10.9985 7 10.9985Z",
      "fill": "currentcolor"
    }
  })]);
};
var staticRenderFns$O = [];
const __vue2_script$O = defineComponent({
  name: "WarningIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$O = {};
var __component__$O = /* @__PURE__ */ normalizeComponent(
  __vue2_script$O,
  render$P,
  staticRenderFns$O,
  false,
  __vue2_injectStyles$O,
  null,
  null,
  null
);
function __vue2_injectStyles$O(context) {
  for (let o2 in __cssModules$O) {
    this[o2] = __cssModules$O[o2];
  }
}
var WarningIcon = /* @__PURE__ */ function() {
  return __component__$O.exports;
}();
var render$O = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "height": "17.59999999999991",
      "version": "1.1",
      "width": "17.59999999999991",
      "viewBox": "0 0 17.59999999999991 17.59999999999991",
      "fill": "none"
    }
  }, [_c("defs"), _c("g", [_c("path", {
    staticStyle: {
      "fill-opacity": "1"
    },
    attrs: {
      "d": "M13.446444375000182,3.4464466154999545L8.800004375000182,8.092894374999954L4.153553375000182,3.4464466154999545L3.446446615500182,4.153553374999954L8.092894375000181,8.800004374999954L3.4464462280001817,13.446444374999954L4.153553375000182,14.153584374999955L8.800004375000182,9.507104374999955L13.446444375000182,14.153584374999955L14.153584375000182,13.446444374999954L9.507104375000182,8.800004374999954L14.153584375000182,4.153553374999954L13.446444375000182,3.4464466154999545Z",
      "fill": "currentcolor"
    }
  })])]);
};
var staticRenderFns$N = [];
const __vue2_script$N = defineComponent({
  name: "WindowsCloseIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$N = {};
var __component__$N = /* @__PURE__ */ normalizeComponent(
  __vue2_script$N,
  render$O,
  staticRenderFns$N,
  false,
  __vue2_injectStyles$N,
  null,
  null,
  null
);
function __vue2_injectStyles$N(context) {
  for (let o2 in __cssModules$N) {
    this[o2] = __cssModules$N[o2];
  }
}
var WindowsCloseIcon = /* @__PURE__ */ function() {
  return __component__$N.exports;
}();
var render$N = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g")]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M8.000103203125,15.4283890625C12.102833203125,15.4283890625,15.428633203125,12.1025890625,15.428633203125,7.9998590625C15.428633203125,3.8971690625,12.102833203125,0.5712890625,8.000103203125,0.5712890625C3.897413203125,0.5712890625,0.571533203125,3.8971690625,0.571533203125,7.9998590625C0.571533203125,12.1025890625,3.897413203125,15.4283890625,8.000103203125,15.4283890625C8.000103203125,15.4283890625,8.000103203125,15.4283890625,8.000103203125,15.4283890625Z",
      "fill-rule": "evenodd",
      "fill": "#E05F42",
      "fill-opacity": "1"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M8.000002925262452,3.428572177886963C7.388101925262451,3.428572177886963,6.909975325262451,3.956896177886963,6.970861925262451,4.565762177886963L7.371711925262451,8.574262177886963C7.403990925262451,8.897052177886962,7.675605925262452,9.142852177886962,8.000002925262452,9.142852177886962C8.324392925262451,9.142852177886962,8.596012925262452,8.897052177886962,8.62828292526245,8.574262177886963L9.029142925262452,4.565752177886963C9.090022925262451,3.956896177886963,8.61189292526245,3.428572177886963,8.000002925262452,3.428572177886963ZM6.857142925262451,11.426902177886962C6.857142925262451,12.063262177886964,7.368066925262451,12.569762177886963,8.000002925262452,12.569762177886963C8.63193292526245,12.569762177886963,9.142852925262451,12.063262177886964,9.142852925262451,11.426902177886962C9.142852925262451,10.790532177886963,8.63193292526245,10.284042177886963,8.000002925262452,10.284042177886963C7.368066925262451,10.284042177886963,6.857142925262451,10.803522177886963,6.857142925262451,11.426902177886962Z",
      "fill-rule": "evenodd",
      "fill": "#FFFFFF",
      "fill-opacity": "1"
    }
  })])])])]);
};
var staticRenderFns$M = [];
const __vue2_script$M = defineComponent({
  name: "ErrorRedBorder",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$M = {};
var __component__$M = /* @__PURE__ */ normalizeComponent(
  __vue2_script$M,
  render$N,
  staticRenderFns$M,
  false,
  __vue2_injectStyles$M,
  null,
  null,
  null
);
function __vue2_injectStyles$M(context) {
  for (let o2 in __cssModules$M) {
    this[o2] = __cssModules$M[o2];
  }
}
var ErrorRedBorderIcon = /* @__PURE__ */ function() {
  return __component__$M.exports;
}();
var render$M = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "privacy_background"
  }, [_c("div", {
    staticClass: "dialog"
  }, [_vm._m(0), _c("iframe", {
    staticClass: "privacy",
    attrs: {
      "src": _vm.privacyURL
    }
  }), _c("div", {
    staticClass: "footer"
  }, [_c("button", {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.buttonClick(false);
      }
    }
  }, [_vm._v("\u4E0D\u540C\u610F")]), _c("button", {
    staticClass: "button-2",
    on: {
      "click": function($event) {
        return _vm.buttonClick(true);
      }
    }
  }, [_vm._v("\u540C\u610F")])])])]);
};
var staticRenderFns$L = [function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "header"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("\u9690\u79C1\u534F\u8BAE")])]);
}];
var index_vue_vue_type_style_index_0_scoped_true_lang$5 = "";
const __vue2_script$L = defineComponent({
  name: "AppPrivacy",
  emits: ["privacyStatus"],
  setup(props2, { emit }) {
    const buttonClick = (status2) => {
      emit("privacyStatus", status2);
    };
    const privacyURL = ref(`${configs.MAIN_ORIGIN}/privacyPolicy?isMirror=1`);
    return {
      buttonClick,
      privacyURL
    };
  }
});
const __cssModules$L = {};
var __component__$L = /* @__PURE__ */ normalizeComponent(
  __vue2_script$L,
  render$M,
  staticRenderFns$L,
  false,
  __vue2_injectStyles$L,
  "d06886d8",
  null,
  null
);
function __vue2_injectStyles$L(context) {
  for (let o2 in __cssModules$L) {
    this[o2] = __cssModules$L[o2];
  }
}
var AppPrivacy = /* @__PURE__ */ function() {
  return __component__$L.exports;
}();
var re$4 = { exports: {} };
const SEMVER_SPEC_VERSION = "2.0.0";
const MAX_LENGTH$1 = 256;
const MAX_SAFE_INTEGER$1 = Number.MAX_SAFE_INTEGER || 9007199254740991;
const MAX_SAFE_COMPONENT_LENGTH = 16;
const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH$1 - 6;
const RELEASE_TYPES = [
  "major",
  "premajor",
  "minor",
  "preminor",
  "patch",
  "prepatch",
  "prerelease"
];
var constants$1 = {
  MAX_LENGTH: MAX_LENGTH$1,
  MAX_SAFE_COMPONENT_LENGTH,
  MAX_SAFE_BUILD_LENGTH,
  MAX_SAFE_INTEGER: MAX_SAFE_INTEGER$1,
  RELEASE_TYPES,
  SEMVER_SPEC_VERSION,
  FLAG_INCLUDE_PRERELEASE: 1,
  FLAG_LOOSE: 2
};
const debug$3 = typeof process === "object" && process.env && {}.NODE_DEBUG && /\bsemver\b/i.test({}.NODE_DEBUG) ? (...args) => console.error("SEMVER", ...args) : () => {
};
var debug_1 = debug$3;
(function(module, exports) {
  const {
    MAX_SAFE_COMPONENT_LENGTH: MAX_SAFE_COMPONENT_LENGTH2,
    MAX_SAFE_BUILD_LENGTH: MAX_SAFE_BUILD_LENGTH2,
    MAX_LENGTH: MAX_LENGTH2
  } = constants$1;
  const debug2 = debug_1;
  exports = module.exports = {};
  const re2 = exports.re = [];
  const safeRe = exports.safeRe = [];
  const src = exports.src = [];
  const safeSrc = exports.safeSrc = [];
  const t2 = exports.t = {};
  let R = 0;
  const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
  const safeRegexReplacements = [
    ["\\s", 1],
    ["\\d", MAX_LENGTH2],
    [LETTERDASHNUMBER, MAX_SAFE_BUILD_LENGTH2]
  ];
  const makeSafeRegex = (value) => {
    for (const [token, max2] of safeRegexReplacements) {
      value = value.split(`${token}*`).join(`${token}{0,${max2}}`).split(`${token}+`).join(`${token}{1,${max2}}`);
    }
    return value;
  };
  const createToken = (name2, value, isGlobal) => {
    const safe = makeSafeRegex(value);
    const index2 = R++;
    debug2(name2, index2, value);
    t2[name2] = index2;
    src[index2] = value;
    safeSrc[index2] = safe;
    re2[index2] = new RegExp(value, isGlobal ? "g" : void 0);
    safeRe[index2] = new RegExp(safe, isGlobal ? "g" : void 0);
  };
  createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
  createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
  createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
  createToken("MAINVERSION", `(${src[t2.NUMERICIDENTIFIER]})\\.(${src[t2.NUMERICIDENTIFIER]})\\.(${src[t2.NUMERICIDENTIFIER]})`);
  createToken("MAINVERSIONLOOSE", `(${src[t2.NUMERICIDENTIFIERLOOSE]})\\.(${src[t2.NUMERICIDENTIFIERLOOSE]})\\.(${src[t2.NUMERICIDENTIFIERLOOSE]})`);
  createToken("PRERELEASEIDENTIFIER", `(?:${src[t2.NONNUMERICIDENTIFIER]}|${src[t2.NUMERICIDENTIFIER]})`);
  createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t2.NONNUMERICIDENTIFIER]}|${src[t2.NUMERICIDENTIFIERLOOSE]})`);
  createToken("PRERELEASE", `(?:-(${src[t2.PRERELEASEIDENTIFIER]}(?:\\.${src[t2.PRERELEASEIDENTIFIER]})*))`);
  createToken("PRERELEASELOOSE", `(?:-?(${src[t2.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t2.PRERELEASEIDENTIFIERLOOSE]})*))`);
  createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
  createToken("BUILD", `(?:\\+(${src[t2.BUILDIDENTIFIER]}(?:\\.${src[t2.BUILDIDENTIFIER]})*))`);
  createToken("FULLPLAIN", `v?${src[t2.MAINVERSION]}${src[t2.PRERELEASE]}?${src[t2.BUILD]}?`);
  createToken("FULL", `^${src[t2.FULLPLAIN]}$`);
  createToken("LOOSEPLAIN", `[v=\\s]*${src[t2.MAINVERSIONLOOSE]}${src[t2.PRERELEASELOOSE]}?${src[t2.BUILD]}?`);
  createToken("LOOSE", `^${src[t2.LOOSEPLAIN]}$`);
  createToken("GTLT", "((?:<|>)?=?)");
  createToken("XRANGEIDENTIFIERLOOSE", `${src[t2.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
  createToken("XRANGEIDENTIFIER", `${src[t2.NUMERICIDENTIFIER]}|x|X|\\*`);
  createToken("XRANGEPLAIN", `[v=\\s]*(${src[t2.XRANGEIDENTIFIER]})(?:\\.(${src[t2.XRANGEIDENTIFIER]})(?:\\.(${src[t2.XRANGEIDENTIFIER]})(?:${src[t2.PRERELEASE]})?${src[t2.BUILD]}?)?)?`);
  createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t2.XRANGEIDENTIFIERLOOSE]})(?:\\.(${src[t2.XRANGEIDENTIFIERLOOSE]})(?:${src[t2.PRERELEASELOOSE]})?${src[t2.BUILD]}?)?)?`);
  createToken("XRANGE", `^${src[t2.GTLT]}\\s*${src[t2.XRANGEPLAIN]}$`);
  createToken("XRANGELOOSE", `^${src[t2.GTLT]}\\s*${src[t2.XRANGEPLAINLOOSE]}$`);
  createToken("COERCEPLAIN", `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH2}})(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH2}}))?(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH2}}))?`);
  createToken("COERCE", `${src[t2.COERCEPLAIN]}(?:$|[^\\d])`);
  createToken("COERCEFULL", src[t2.COERCEPLAIN] + `(?:${src[t2.PRERELEASE]})?(?:${src[t2.BUILD]})?(?:$|[^\\d])`);
  createToken("COERCERTL", src[t2.COERCE], true);
  createToken("COERCERTLFULL", src[t2.COERCEFULL], true);
  createToken("LONETILDE", "(?:~>?)");
  createToken("TILDETRIM", `(\\s*)${src[t2.LONETILDE]}\\s+`, true);
  exports.tildeTrimReplace = "$1~";
  createToken("TILDE", `^${src[t2.LONETILDE]}${src[t2.XRANGEPLAIN]}$`);
  createToken("TILDELOOSE", `^${src[t2.LONETILDE]}${src[t2.XRANGEPLAINLOOSE]}$`);
  createToken("LONECARET", "(?:\\^)");
  createToken("CARETTRIM", `(\\s*)${src[t2.LONECARET]}\\s+`, true);
  exports.caretTrimReplace = "$1^";
  createToken("CARET", `^${src[t2.LONECARET]}${src[t2.XRANGEPLAIN]}$`);
  createToken("CARETLOOSE", `^${src[t2.LONECARET]}${src[t2.XRANGEPLAINLOOSE]}$`);
  createToken("COMPARATORLOOSE", `^${src[t2.GTLT]}\\s*(${src[t2.LOOSEPLAIN]})$|^$`);
  createToken("COMPARATOR", `^${src[t2.GTLT]}\\s*(${src[t2.FULLPLAIN]})$|^$`);
  createToken("COMPARATORTRIM", `(\\s*)${src[t2.GTLT]}\\s*(${src[t2.LOOSEPLAIN]}|${src[t2.XRANGEPLAIN]})`, true);
  exports.comparatorTrimReplace = "$1$2$3";
  createToken("HYPHENRANGE", `^\\s*(${src[t2.XRANGEPLAIN]})\\s+-\\s+(${src[t2.XRANGEPLAIN]})\\s*$`);
  createToken("HYPHENRANGELOOSE", `^\\s*(${src[t2.XRANGEPLAINLOOSE]})\\s+-\\s+(${src[t2.XRANGEPLAINLOOSE]})\\s*$`);
  createToken("STAR", "(<|>)?=?\\s*\\*");
  createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
  createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");
})(re$4, re$4.exports);
const looseOption = Object.freeze({ loose: true });
const emptyOpts = Object.freeze({});
const parseOptions$3 = (options) => {
  if (!options) {
    return emptyOpts;
  }
  if (typeof options !== "object") {
    return looseOption;
  }
  return options;
};
var parseOptions_1 = parseOptions$3;
const numeric = /^[0-9]+$/;
const compareIdentifiers$1 = (a2, b2) => {
  if (typeof a2 === "number" && typeof b2 === "number") {
    return a2 === b2 ? 0 : a2 < b2 ? -1 : 1;
  }
  const anum = numeric.test(a2);
  const bnum = numeric.test(b2);
  if (anum && bnum) {
    a2 = +a2;
    b2 = +b2;
  }
  return a2 === b2 ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a2 < b2 ? -1 : 1;
};
const rcompareIdentifiers = (a2, b2) => compareIdentifiers$1(b2, a2);
var identifiers$1 = {
  compareIdentifiers: compareIdentifiers$1,
  rcompareIdentifiers
};
const debug$2 = debug_1;
const { MAX_LENGTH, MAX_SAFE_INTEGER } = constants$1;
const { safeRe: re$3, t: t$3 } = re$4.exports;
const parseOptions$2 = parseOptions_1;
const { compareIdentifiers } = identifiers$1;
class SemVer$f {
  constructor(version2, options) {
    options = parseOptions$2(options);
    if (version2 instanceof SemVer$f) {
      if (version2.loose === !!options.loose && version2.includePrerelease === !!options.includePrerelease) {
        return version2;
      } else {
        version2 = version2.version;
      }
    } else if (typeof version2 !== "string") {
      throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version2}".`);
    }
    if (version2.length > MAX_LENGTH) {
      throw new TypeError(
        `version is longer than ${MAX_LENGTH} characters`
      );
    }
    debug$2("SemVer", version2, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    const m2 = version2.trim().match(options.loose ? re$3[t$3.LOOSE] : re$3[t$3.FULL]);
    if (!m2) {
      throw new TypeError(`Invalid Version: ${version2}`);
    }
    this.raw = version2;
    this.major = +m2[1];
    this.minor = +m2[2];
    this.patch = +m2[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
      throw new TypeError("Invalid major version");
    }
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
      throw new TypeError("Invalid minor version");
    }
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
      throw new TypeError("Invalid patch version");
    }
    if (!m2[4]) {
      this.prerelease = [];
    } else {
      this.prerelease = m2[4].split(".").map((id2) => {
        if (/^[0-9]+$/.test(id2)) {
          const num = +id2;
          if (num >= 0 && num < MAX_SAFE_INTEGER) {
            return num;
          }
        }
        return id2;
      });
    }
    this.build = m2[5] ? m2[5].split(".") : [];
    this.format();
  }
  format() {
    this.version = `${this.major}.${this.minor}.${this.patch}`;
    if (this.prerelease.length) {
      this.version += `-${this.prerelease.join(".")}`;
    }
    return this.version;
  }
  toString() {
    return this.version;
  }
  compare(other) {
    debug$2("SemVer.compare", this.version, this.options, other);
    if (!(other instanceof SemVer$f)) {
      if (typeof other === "string" && other === this.version) {
        return 0;
      }
      other = new SemVer$f(other, this.options);
    }
    if (other.version === this.version) {
      return 0;
    }
    return this.compareMain(other) || this.comparePre(other);
  }
  compareMain(other) {
    if (!(other instanceof SemVer$f)) {
      other = new SemVer$f(other, this.options);
    }
    if (this.major < other.major) {
      return -1;
    }
    if (this.major > other.major) {
      return 1;
    }
    if (this.minor < other.minor) {
      return -1;
    }
    if (this.minor > other.minor) {
      return 1;
    }
    if (this.patch < other.patch) {
      return -1;
    }
    if (this.patch > other.patch) {
      return 1;
    }
    return 0;
  }
  comparePre(other) {
    if (!(other instanceof SemVer$f)) {
      other = new SemVer$f(other, this.options);
    }
    if (this.prerelease.length && !other.prerelease.length) {
      return -1;
    } else if (!this.prerelease.length && other.prerelease.length) {
      return 1;
    } else if (!this.prerelease.length && !other.prerelease.length) {
      return 0;
    }
    let i = 0;
    do {
      const a2 = this.prerelease[i];
      const b2 = other.prerelease[i];
      debug$2("prerelease compare", i, a2, b2);
      if (a2 === void 0 && b2 === void 0) {
        return 0;
      } else if (b2 === void 0) {
        return 1;
      } else if (a2 === void 0) {
        return -1;
      } else if (a2 === b2) {
        continue;
      } else {
        return compareIdentifiers(a2, b2);
      }
    } while (++i);
  }
  compareBuild(other) {
    if (!(other instanceof SemVer$f)) {
      other = new SemVer$f(other, this.options);
    }
    let i = 0;
    do {
      const a2 = this.build[i];
      const b2 = other.build[i];
      debug$2("build compare", i, a2, b2);
      if (a2 === void 0 && b2 === void 0) {
        return 0;
      } else if (b2 === void 0) {
        return 1;
      } else if (a2 === void 0) {
        return -1;
      } else if (a2 === b2) {
        continue;
      } else {
        return compareIdentifiers(a2, b2);
      }
    } while (++i);
  }
  inc(release, identifier, identifierBase) {
    if (release.startsWith("pre")) {
      if (!identifier && identifierBase === false) {
        throw new Error("invalid increment argument: identifier is empty");
      }
      if (identifier) {
        const match = `-${identifier}`.match(this.options.loose ? re$3[t$3.PRERELEASELOOSE] : re$3[t$3.PRERELEASE]);
        if (!match || match[1] !== identifier) {
          throw new Error(`invalid identifier: ${identifier}`);
        }
      }
    }
    switch (release) {
      case "premajor":
        this.prerelease.length = 0;
        this.patch = 0;
        this.minor = 0;
        this.major++;
        this.inc("pre", identifier, identifierBase);
        break;
      case "preminor":
        this.prerelease.length = 0;
        this.patch = 0;
        this.minor++;
        this.inc("pre", identifier, identifierBase);
        break;
      case "prepatch":
        this.prerelease.length = 0;
        this.inc("patch", identifier, identifierBase);
        this.inc("pre", identifier, identifierBase);
        break;
      case "prerelease":
        if (this.prerelease.length === 0) {
          this.inc("patch", identifier, identifierBase);
        }
        this.inc("pre", identifier, identifierBase);
        break;
      case "release":
        if (this.prerelease.length === 0) {
          throw new Error(`version ${this.raw} is not a prerelease`);
        }
        this.prerelease.length = 0;
        break;
      case "major":
        if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) {
          this.major++;
        }
        this.minor = 0;
        this.patch = 0;
        this.prerelease = [];
        break;
      case "minor":
        if (this.patch !== 0 || this.prerelease.length === 0) {
          this.minor++;
        }
        this.patch = 0;
        this.prerelease = [];
        break;
      case "patch":
        if (this.prerelease.length === 0) {
          this.patch++;
        }
        this.prerelease = [];
        break;
      case "pre": {
        const base = Number(identifierBase) ? 1 : 0;
        if (this.prerelease.length === 0) {
          this.prerelease = [base];
        } else {
          let i = this.prerelease.length;
          while (--i >= 0) {
            if (typeof this.prerelease[i] === "number") {
              this.prerelease[i]++;
              i = -2;
            }
          }
          if (i === -1) {
            if (identifier === this.prerelease.join(".") && identifierBase === false) {
              throw new Error("invalid increment argument: identifier already exists");
            }
            this.prerelease.push(base);
          }
        }
        if (identifier) {
          let prerelease2 = [identifier, base];
          if (identifierBase === false) {
            prerelease2 = [identifier];
          }
          if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
            if (isNaN(this.prerelease[1])) {
              this.prerelease = prerelease2;
            }
          } else {
            this.prerelease = prerelease2;
          }
        }
        break;
      }
      default:
        throw new Error(`invalid increment argument: ${release}`);
    }
    this.raw = this.format();
    if (this.build.length) {
      this.raw += `+${this.build.join(".")}`;
    }
    return this;
  }
}
var semver$1 = SemVer$f;
const SemVer$e = semver$1;
const parse$6 = (version2, options, throwErrors = false) => {
  if (version2 instanceof SemVer$e) {
    return version2;
  }
  try {
    return new SemVer$e(version2, options);
  } catch (er) {
    if (!throwErrors) {
      return null;
    }
    throw er;
  }
};
var parse_1 = parse$6;
const parse$5 = parse_1;
const valid$2 = (version2, options) => {
  const v = parse$5(version2, options);
  return v ? v.version : null;
};
var valid_1 = valid$2;
const parse$4 = parse_1;
const clean$1 = (version2, options) => {
  const s = parse$4(version2.trim().replace(/^[=v]+/, ""), options);
  return s ? s.version : null;
};
var clean_1 = clean$1;
const SemVer$d = semver$1;
const inc$1 = (version2, release, options, identifier, identifierBase) => {
  if (typeof options === "string") {
    identifierBase = identifier;
    identifier = options;
    options = void 0;
  }
  try {
    return new SemVer$d(
      version2 instanceof SemVer$d ? version2.version : version2,
      options
    ).inc(release, identifier, identifierBase).version;
  } catch (er) {
    return null;
  }
};
var inc_1 = inc$1;
const parse$3 = parse_1;
const diff$1 = (version1, version2) => {
  const v1 = parse$3(version1, null, true);
  const v2 = parse$3(version2, null, true);
  const comparison = v1.compare(v2);
  if (comparison === 0) {
    return null;
  }
  const v1Higher = comparison > 0;
  const highVersion = v1Higher ? v1 : v2;
  const lowVersion = v1Higher ? v2 : v1;
  const highHasPre = !!highVersion.prerelease.length;
  const lowHasPre = !!lowVersion.prerelease.length;
  if (lowHasPre && !highHasPre) {
    if (!lowVersion.patch && !lowVersion.minor) {
      return "major";
    }
    if (lowVersion.compareMain(highVersion) === 0) {
      if (lowVersion.minor && !lowVersion.patch) {
        return "minor";
      }
      return "patch";
    }
  }
  const prefix = highHasPre ? "pre" : "";
  if (v1.major !== v2.major) {
    return prefix + "major";
  }
  if (v1.minor !== v2.minor) {
    return prefix + "minor";
  }
  if (v1.patch !== v2.patch) {
    return prefix + "patch";
  }
  return "prerelease";
};
var diff_1 = diff$1;
const SemVer$c = semver$1;
const major$1 = (a2, loose) => new SemVer$c(a2, loose).major;
var major_1 = major$1;
const SemVer$b = semver$1;
const minor$1 = (a2, loose) => new SemVer$b(a2, loose).minor;
var minor_1 = minor$1;
const SemVer$a = semver$1;
const patch$1 = (a2, loose) => new SemVer$a(a2, loose).patch;
var patch_1 = patch$1;
const parse$2 = parse_1;
const prerelease$1 = (version2, options) => {
  const parsed = parse$2(version2, options);
  return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
var prerelease_1 = prerelease$1;
const SemVer$9 = semver$1;
const compare$b = (a2, b2, loose) => new SemVer$9(a2, loose).compare(new SemVer$9(b2, loose));
var compare_1 = compare$b;
const compare$a = compare_1;
const rcompare$1 = (a2, b2, loose) => compare$a(b2, a2, loose);
var rcompare_1 = rcompare$1;
const compare$9 = compare_1;
const compareLoose$1 = (a2, b2) => compare$9(a2, b2, true);
var compareLoose_1 = compareLoose$1;
const SemVer$8 = semver$1;
const compareBuild$3 = (a2, b2, loose) => {
  const versionA = new SemVer$8(a2, loose);
  const versionB = new SemVer$8(b2, loose);
  return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
var compareBuild_1 = compareBuild$3;
const compareBuild$2 = compareBuild_1;
const sort$1 = (list, loose) => list.sort((a2, b2) => compareBuild$2(a2, b2, loose));
var sort_1 = sort$1;
const compareBuild$1 = compareBuild_1;
const rsort$1 = (list, loose) => list.sort((a2, b2) => compareBuild$1(b2, a2, loose));
var rsort_1 = rsort$1;
const compare$8 = compare_1;
const gt$4 = (a2, b2, loose) => compare$8(a2, b2, loose) > 0;
var gt_1 = gt$4;
const compare$7 = compare_1;
const lt$3 = (a2, b2, loose) => compare$7(a2, b2, loose) < 0;
var lt_1 = lt$3;
const compare$6 = compare_1;
const eq$2 = (a2, b2, loose) => compare$6(a2, b2, loose) === 0;
var eq_1 = eq$2;
const compare$5 = compare_1;
const neq$2 = (a2, b2, loose) => compare$5(a2, b2, loose) !== 0;
var neq_1 = neq$2;
const compare$4 = compare_1;
const gte$3 = (a2, b2, loose) => compare$4(a2, b2, loose) >= 0;
var gte_1 = gte$3;
const compare$3 = compare_1;
const lte$3 = (a2, b2, loose) => compare$3(a2, b2, loose) <= 0;
var lte_1 = lte$3;
const eq$1 = eq_1;
const neq$1 = neq_1;
const gt$3 = gt_1;
const gte$2 = gte_1;
const lt$2 = lt_1;
const lte$2 = lte_1;
const cmp$2 = (a2, op, b2, loose) => {
  switch (op) {
    case "===":
      if (typeof a2 === "object") {
        a2 = a2.version;
      }
      if (typeof b2 === "object") {
        b2 = b2.version;
      }
      return a2 === b2;
    case "!==":
      if (typeof a2 === "object") {
        a2 = a2.version;
      }
      if (typeof b2 === "object") {
        b2 = b2.version;
      }
      return a2 !== b2;
    case "":
    case "=":
    case "==":
      return eq$1(a2, b2, loose);
    case "!=":
      return neq$1(a2, b2, loose);
    case ">":
      return gt$3(a2, b2, loose);
    case ">=":
      return gte$2(a2, b2, loose);
    case "<":
      return lt$2(a2, b2, loose);
    case "<=":
      return lte$2(a2, b2, loose);
    default:
      throw new TypeError(`Invalid operator: ${op}`);
  }
};
var cmp_1 = cmp$2;
const SemVer$7 = semver$1;
const parse$1 = parse_1;
const { safeRe: re$2, t: t$2 } = re$4.exports;
const coerce$1 = (version2, options) => {
  if (version2 instanceof SemVer$7) {
    return version2;
  }
  if (typeof version2 === "number") {
    version2 = String(version2);
  }
  if (typeof version2 !== "string") {
    return null;
  }
  options = options || {};
  let match = null;
  if (!options.rtl) {
    match = version2.match(options.includePrerelease ? re$2[t$2.COERCEFULL] : re$2[t$2.COERCE]);
  } else {
    const coerceRtlRegex = options.includePrerelease ? re$2[t$2.COERCERTLFULL] : re$2[t$2.COERCERTL];
    let next;
    while ((next = coerceRtlRegex.exec(version2)) && (!match || match.index + match[0].length !== version2.length)) {
      if (!match || next.index + next[0].length !== match.index + match[0].length) {
        match = next;
      }
      coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
    }
    coerceRtlRegex.lastIndex = -1;
  }
  if (match === null) {
    return null;
  }
  const major2 = match[2];
  const minor2 = match[3] || "0";
  const patch2 = match[4] || "0";
  const prerelease2 = options.includePrerelease && match[5] ? `-${match[5]}` : "";
  const build = options.includePrerelease && match[6] ? `+${match[6]}` : "";
  return parse$1(`${major2}.${minor2}.${patch2}${prerelease2}${build}`, options);
};
var coerce_1 = coerce$1;
class LRUCache {
  constructor() {
    this.max = 1e3;
    this.map = /* @__PURE__ */ new Map();
  }
  get(key) {
    const value = this.map.get(key);
    if (value === void 0) {
      return void 0;
    } else {
      this.map.delete(key);
      this.map.set(key, value);
      return value;
    }
  }
  delete(key) {
    return this.map.delete(key);
  }
  set(key, value) {
    const deleted = this.delete(key);
    if (!deleted && value !== void 0) {
      if (this.map.size >= this.max) {
        const firstKey = this.map.keys().next().value;
        this.delete(firstKey);
      }
      this.map.set(key, value);
    }
    return this;
  }
}
var lrucache = LRUCache;
const SPACE_CHARACTERS = /\s+/g;
class Range$b {
  constructor(range2, options) {
    options = parseOptions$1(options);
    if (range2 instanceof Range$b) {
      if (range2.loose === !!options.loose && range2.includePrerelease === !!options.includePrerelease) {
        return range2;
      } else {
        return new Range$b(range2.raw, options);
      }
    }
    if (range2 instanceof Comparator$4) {
      this.raw = range2.value;
      this.set = [[range2]];
      this.formatted = void 0;
      return this;
    }
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    this.raw = range2.trim().replace(SPACE_CHARACTERS, " ");
    this.set = this.raw.split("||").map((r) => this.parseRange(r.trim())).filter((c2) => c2.length);
    if (!this.set.length) {
      throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
    }
    if (this.set.length > 1) {
      const first = this.set[0];
      this.set = this.set.filter((c2) => !isNullSet(c2[0]));
      if (this.set.length === 0) {
        this.set = [first];
      } else if (this.set.length > 1) {
        for (const c2 of this.set) {
          if (c2.length === 1 && isAny(c2[0])) {
            this.set = [c2];
            break;
          }
        }
      }
    }
    this.formatted = void 0;
  }
  get range() {
    if (this.formatted === void 0) {
      this.formatted = "";
      for (let i = 0; i < this.set.length; i++) {
        if (i > 0) {
          this.formatted += "||";
        }
        const comps = this.set[i];
        for (let k = 0; k < comps.length; k++) {
          if (k > 0) {
            this.formatted += " ";
          }
          this.formatted += comps[k].toString().trim();
        }
      }
    }
    return this.formatted;
  }
  format() {
    return this.range;
  }
  toString() {
    return this.range;
  }
  parseRange(range2) {
    const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
    const memoKey = memoOpts + ":" + range2;
    const cached = cache.get(memoKey);
    if (cached) {
      return cached;
    }
    const loose = this.options.loose;
    const hr2 = loose ? re$1[t$1.HYPHENRANGELOOSE] : re$1[t$1.HYPHENRANGE];
    range2 = range2.replace(hr2, hyphenReplace(this.options.includePrerelease));
    debug$1("hyphen replace", range2);
    range2 = range2.replace(re$1[t$1.COMPARATORTRIM], comparatorTrimReplace);
    debug$1("comparator trim", range2);
    range2 = range2.replace(re$1[t$1.TILDETRIM], tildeTrimReplace);
    debug$1("tilde trim", range2);
    range2 = range2.replace(re$1[t$1.CARETTRIM], caretTrimReplace);
    debug$1("caret trim", range2);
    let rangeList = range2.split(" ").map((comp) => parseComparator(comp, this.options)).join(" ").split(/\s+/).map((comp) => replaceGTE0(comp, this.options));
    if (loose) {
      rangeList = rangeList.filter((comp) => {
        debug$1("loose invalid filter", comp, this.options);
        return !!comp.match(re$1[t$1.COMPARATORLOOSE]);
      });
    }
    debug$1("range list", rangeList);
    const rangeMap = /* @__PURE__ */ new Map();
    const comparators = rangeList.map((comp) => new Comparator$4(comp, this.options));
    for (const comp of comparators) {
      if (isNullSet(comp)) {
        return [comp];
      }
      rangeMap.set(comp.value, comp);
    }
    if (rangeMap.size > 1 && rangeMap.has("")) {
      rangeMap.delete("");
    }
    const result = [...rangeMap.values()];
    cache.set(memoKey, result);
    return result;
  }
  intersects(range2, options) {
    if (!(range2 instanceof Range$b)) {
      throw new TypeError("a Range is required");
    }
    return this.set.some((thisComparators) => {
      return isSatisfiable(thisComparators, options) && range2.set.some((rangeComparators) => {
        return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator) => {
          return rangeComparators.every((rangeComparator) => {
            return thisComparator.intersects(rangeComparator, options);
          });
        });
      });
    });
  }
  test(version2) {
    if (!version2) {
      return false;
    }
    if (typeof version2 === "string") {
      try {
        version2 = new SemVer$6(version2, this.options);
      } catch (er) {
        return false;
      }
    }
    for (let i = 0; i < this.set.length; i++) {
      if (testSet(this.set[i], version2, this.options)) {
        return true;
      }
    }
    return false;
  }
}
var range = Range$b;
const LRU = lrucache;
const cache = new LRU();
const parseOptions$1 = parseOptions_1;
const Comparator$4 = comparator;
const debug$1 = debug_1;
const SemVer$6 = semver$1;
const {
  safeRe: re$1,
  t: t$1,
  comparatorTrimReplace,
  tildeTrimReplace,
  caretTrimReplace
} = re$4.exports;
const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = constants$1;
const isNullSet = (c2) => c2.value === "<0.0.0-0";
const isAny = (c2) => c2.value === "";
const isSatisfiable = (comparators, options) => {
  let result = true;
  const remainingComparators = comparators.slice();
  let testComparator = remainingComparators.pop();
  while (result && remainingComparators.length) {
    result = remainingComparators.every((otherComparator) => {
      return testComparator.intersects(otherComparator, options);
    });
    testComparator = remainingComparators.pop();
  }
  return result;
};
const parseComparator = (comp, options) => {
  comp = comp.replace(re$1[t$1.BUILD], "");
  debug$1("comp", comp, options);
  comp = replaceCarets(comp, options);
  debug$1("caret", comp);
  comp = replaceTildes(comp, options);
  debug$1("tildes", comp);
  comp = replaceXRanges(comp, options);
  debug$1("xrange", comp);
  comp = replaceStars(comp, options);
  debug$1("stars", comp);
  return comp;
};
const isX = (id2) => !id2 || id2.toLowerCase() === "x" || id2 === "*";
const replaceTildes = (comp, options) => {
  return comp.trim().split(/\s+/).map((c2) => replaceTilde(c2, options)).join(" ");
};
const replaceTilde = (comp, options) => {
  const r = options.loose ? re$1[t$1.TILDELOOSE] : re$1[t$1.TILDE];
  return comp.replace(r, (_2, M2, m2, p, pr) => {
    debug$1("tilde", comp, _2, M2, m2, p, pr);
    let ret;
    if (isX(M2)) {
      ret = "";
    } else if (isX(m2)) {
      ret = `>=${M2}.0.0 <${+M2 + 1}.0.0-0`;
    } else if (isX(p)) {
      ret = `>=${M2}.${m2}.0 <${M2}.${+m2 + 1}.0-0`;
    } else if (pr) {
      debug$1("replaceTilde pr", pr);
      ret = `>=${M2}.${m2}.${p}-${pr} <${M2}.${+m2 + 1}.0-0`;
    } else {
      ret = `>=${M2}.${m2}.${p} <${M2}.${+m2 + 1}.0-0`;
    }
    debug$1("tilde return", ret);
    return ret;
  });
};
const replaceCarets = (comp, options) => {
  return comp.trim().split(/\s+/).map((c2) => replaceCaret(c2, options)).join(" ");
};
const replaceCaret = (comp, options) => {
  debug$1("caret", comp, options);
  const r = options.loose ? re$1[t$1.CARETLOOSE] : re$1[t$1.CARET];
  const z = options.includePrerelease ? "-0" : "";
  return comp.replace(r, (_2, M2, m2, p, pr) => {
    debug$1("caret", comp, _2, M2, m2, p, pr);
    let ret;
    if (isX(M2)) {
      ret = "";
    } else if (isX(m2)) {
      ret = `>=${M2}.0.0${z} <${+M2 + 1}.0.0-0`;
    } else if (isX(p)) {
      if (M2 === "0") {
        ret = `>=${M2}.${m2}.0${z} <${M2}.${+m2 + 1}.0-0`;
      } else {
        ret = `>=${M2}.${m2}.0${z} <${+M2 + 1}.0.0-0`;
      }
    } else if (pr) {
      debug$1("replaceCaret pr", pr);
      if (M2 === "0") {
        if (m2 === "0") {
          ret = `>=${M2}.${m2}.${p}-${pr} <${M2}.${m2}.${+p + 1}-0`;
        } else {
          ret = `>=${M2}.${m2}.${p}-${pr} <${M2}.${+m2 + 1}.0-0`;
        }
      } else {
        ret = `>=${M2}.${m2}.${p}-${pr} <${+M2 + 1}.0.0-0`;
      }
    } else {
      debug$1("no pr");
      if (M2 === "0") {
        if (m2 === "0") {
          ret = `>=${M2}.${m2}.${p}${z} <${M2}.${m2}.${+p + 1}-0`;
        } else {
          ret = `>=${M2}.${m2}.${p}${z} <${M2}.${+m2 + 1}.0-0`;
        }
      } else {
        ret = `>=${M2}.${m2}.${p} <${+M2 + 1}.0.0-0`;
      }
    }
    debug$1("caret return", ret);
    return ret;
  });
};
const replaceXRanges = (comp, options) => {
  debug$1("replaceXRanges", comp, options);
  return comp.split(/\s+/).map((c2) => replaceXRange(c2, options)).join(" ");
};
const replaceXRange = (comp, options) => {
  comp = comp.trim();
  const r = options.loose ? re$1[t$1.XRANGELOOSE] : re$1[t$1.XRANGE];
  return comp.replace(r, (ret, gtlt, M2, m2, p, pr) => {
    debug$1("xRange", comp, ret, gtlt, M2, m2, p, pr);
    const xM = isX(M2);
    const xm = xM || isX(m2);
    const xp = xm || isX(p);
    const anyX = xp;
    if (gtlt === "=" && anyX) {
      gtlt = "";
    }
    pr = options.includePrerelease ? "-0" : "";
    if (xM) {
      if (gtlt === ">" || gtlt === "<") {
        ret = "<0.0.0-0";
      } else {
        ret = "*";
      }
    } else if (gtlt && anyX) {
      if (xm) {
        m2 = 0;
      }
      p = 0;
      if (gtlt === ">") {
        gtlt = ">=";
        if (xm) {
          M2 = +M2 + 1;
          m2 = 0;
          p = 0;
        } else {
          m2 = +m2 + 1;
          p = 0;
        }
      } else if (gtlt === "<=") {
        gtlt = "<";
        if (xm) {
          M2 = +M2 + 1;
        } else {
          m2 = +m2 + 1;
        }
      }
      if (gtlt === "<") {
        pr = "-0";
      }
      ret = `${gtlt + M2}.${m2}.${p}${pr}`;
    } else if (xm) {
      ret = `>=${M2}.0.0${pr} <${+M2 + 1}.0.0-0`;
    } else if (xp) {
      ret = `>=${M2}.${m2}.0${pr} <${M2}.${+m2 + 1}.0-0`;
    }
    debug$1("xRange return", ret);
    return ret;
  });
};
const replaceStars = (comp, options) => {
  debug$1("replaceStars", comp, options);
  return comp.trim().replace(re$1[t$1.STAR], "");
};
const replaceGTE0 = (comp, options) => {
  debug$1("replaceGTE0", comp, options);
  return comp.trim().replace(re$1[options.includePrerelease ? t$1.GTE0PRE : t$1.GTE0], "");
};
const hyphenReplace = (incPr) => ($0, from, fM, fm, fp, fpr, fb, to2, tM, tm, tp, tpr) => {
  if (isX(fM)) {
    from = "";
  } else if (isX(fm)) {
    from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
  } else if (isX(fp)) {
    from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
  } else if (fpr) {
    from = `>=${from}`;
  } else {
    from = `>=${from}${incPr ? "-0" : ""}`;
  }
  if (isX(tM)) {
    to2 = "";
  } else if (isX(tm)) {
    to2 = `<${+tM + 1}.0.0-0`;
  } else if (isX(tp)) {
    to2 = `<${tM}.${+tm + 1}.0-0`;
  } else if (tpr) {
    to2 = `<=${tM}.${tm}.${tp}-${tpr}`;
  } else if (incPr) {
    to2 = `<${tM}.${tm}.${+tp + 1}-0`;
  } else {
    to2 = `<=${to2}`;
  }
  return `${from} ${to2}`.trim();
};
const testSet = (set, version2, options) => {
  for (let i = 0; i < set.length; i++) {
    if (!set[i].test(version2)) {
      return false;
    }
  }
  if (version2.prerelease.length && !options.includePrerelease) {
    for (let i = 0; i < set.length; i++) {
      debug$1(set[i].semver);
      if (set[i].semver === Comparator$4.ANY) {
        continue;
      }
      if (set[i].semver.prerelease.length > 0) {
        const allowed = set[i].semver;
        if (allowed.major === version2.major && allowed.minor === version2.minor && allowed.patch === version2.patch) {
          return true;
        }
      }
    }
    return false;
  }
  return true;
};
const ANY$2 = Symbol("SemVer ANY");
class Comparator$3 {
  static get ANY() {
    return ANY$2;
  }
  constructor(comp, options) {
    options = parseOptions(options);
    if (comp instanceof Comparator$3) {
      if (comp.loose === !!options.loose) {
        return comp;
      } else {
        comp = comp.value;
      }
    }
    comp = comp.trim().split(/\s+/).join(" ");
    debug("comparator", comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY$2) {
      this.value = "";
    } else {
      this.value = this.operator + this.semver.version;
    }
    debug("comp", this);
  }
  parse(comp) {
    const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
    const m2 = comp.match(r);
    if (!m2) {
      throw new TypeError(`Invalid comparator: ${comp}`);
    }
    this.operator = m2[1] !== void 0 ? m2[1] : "";
    if (this.operator === "=") {
      this.operator = "";
    }
    if (!m2[2]) {
      this.semver = ANY$2;
    } else {
      this.semver = new SemVer$5(m2[2], this.options.loose);
    }
  }
  toString() {
    return this.value;
  }
  test(version2) {
    debug("Comparator.test", version2, this.options.loose);
    if (this.semver === ANY$2 || version2 === ANY$2) {
      return true;
    }
    if (typeof version2 === "string") {
      try {
        version2 = new SemVer$5(version2, this.options);
      } catch (er) {
        return false;
      }
    }
    return cmp$1(version2, this.operator, this.semver, this.options);
  }
  intersects(comp, options) {
    if (!(comp instanceof Comparator$3)) {
      throw new TypeError("a Comparator is required");
    }
    if (this.operator === "") {
      if (this.value === "") {
        return true;
      }
      return new Range$a(comp.value, options).test(this.value);
    } else if (comp.operator === "") {
      if (comp.value === "") {
        return true;
      }
      return new Range$a(this.value, options).test(comp.semver);
    }
    options = parseOptions(options);
    if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) {
      return false;
    }
    if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) {
      return false;
    }
    if (this.operator.startsWith(">") && comp.operator.startsWith(">")) {
      return true;
    }
    if (this.operator.startsWith("<") && comp.operator.startsWith("<")) {
      return true;
    }
    if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) {
      return true;
    }
    if (cmp$1(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) {
      return true;
    }
    if (cmp$1(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) {
      return true;
    }
    return false;
  }
}
var comparator = Comparator$3;
const parseOptions = parseOptions_1;
const { safeRe: re, t } = re$4.exports;
const cmp$1 = cmp_1;
const debug = debug_1;
const SemVer$5 = semver$1;
const Range$a = range;
const Range$9 = range;
const satisfies$4 = (version2, range2, options) => {
  try {
    range2 = new Range$9(range2, options);
  } catch (er) {
    return false;
  }
  return range2.test(version2);
};
var satisfies_1 = satisfies$4;
const Range$8 = range;
const toComparators$1 = (range2, options) => new Range$8(range2, options).set.map((comp) => comp.map((c2) => c2.value).join(" ").trim().split(" "));
var toComparators_1 = toComparators$1;
const SemVer$4 = semver$1;
const Range$7 = range;
const maxSatisfying$1 = (versions, range2, options) => {
  let max2 = null;
  let maxSV = null;
  let rangeObj = null;
  try {
    rangeObj = new Range$7(range2, options);
  } catch (er) {
    return null;
  }
  versions.forEach((v) => {
    if (rangeObj.test(v)) {
      if (!max2 || maxSV.compare(v) === -1) {
        max2 = v;
        maxSV = new SemVer$4(max2, options);
      }
    }
  });
  return max2;
};
var maxSatisfying_1 = maxSatisfying$1;
const SemVer$3 = semver$1;
const Range$6 = range;
const minSatisfying$1 = (versions, range2, options) => {
  let min2 = null;
  let minSV = null;
  let rangeObj = null;
  try {
    rangeObj = new Range$6(range2, options);
  } catch (er) {
    return null;
  }
  versions.forEach((v) => {
    if (rangeObj.test(v)) {
      if (!min2 || minSV.compare(v) === 1) {
        min2 = v;
        minSV = new SemVer$3(min2, options);
      }
    }
  });
  return min2;
};
var minSatisfying_1 = minSatisfying$1;
const SemVer$2 = semver$1;
const Range$5 = range;
const gt$2 = gt_1;
const minVersion$1 = (range2, loose) => {
  range2 = new Range$5(range2, loose);
  let minver = new SemVer$2("0.0.0");
  if (range2.test(minver)) {
    return minver;
  }
  minver = new SemVer$2("0.0.0-0");
  if (range2.test(minver)) {
    return minver;
  }
  minver = null;
  for (let i = 0; i < range2.set.length; ++i) {
    const comparators = range2.set[i];
    let setMin = null;
    comparators.forEach((comparator2) => {
      const compver = new SemVer$2(comparator2.semver.version);
      switch (comparator2.operator) {
        case ">":
          if (compver.prerelease.length === 0) {
            compver.patch++;
          } else {
            compver.prerelease.push(0);
          }
          compver.raw = compver.format();
        case "":
        case ">=":
          if (!setMin || gt$2(compver, setMin)) {
            setMin = compver;
          }
          break;
        case "<":
        case "<=":
          break;
        default:
          throw new Error(`Unexpected operation: ${comparator2.operator}`);
      }
    });
    if (setMin && (!minver || gt$2(minver, setMin))) {
      minver = setMin;
    }
  }
  if (minver && range2.test(minver)) {
    return minver;
  }
  return null;
};
var minVersion_1 = minVersion$1;
const Range$4 = range;
const validRange$1 = (range2, options) => {
  try {
    return new Range$4(range2, options).range || "*";
  } catch (er) {
    return null;
  }
};
var valid$1 = validRange$1;
const SemVer$1 = semver$1;
const Comparator$2 = comparator;
const { ANY: ANY$1 } = Comparator$2;
const Range$3 = range;
const satisfies$3 = satisfies_1;
const gt$1 = gt_1;
const lt$1 = lt_1;
const lte$1 = lte_1;
const gte$1 = gte_1;
const outside$3 = (version2, range2, hilo, options) => {
  version2 = new SemVer$1(version2, options);
  range2 = new Range$3(range2, options);
  let gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case ">":
      gtfn = gt$1;
      ltefn = lte$1;
      ltfn = lt$1;
      comp = ">";
      ecomp = ">=";
      break;
    case "<":
      gtfn = lt$1;
      ltefn = gte$1;
      ltfn = gt$1;
      comp = "<";
      ecomp = "<=";
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }
  if (satisfies$3(version2, range2, options)) {
    return false;
  }
  for (let i = 0; i < range2.set.length; ++i) {
    const comparators = range2.set[i];
    let high = null;
    let low = null;
    comparators.forEach((comparator2) => {
      if (comparator2.semver === ANY$1) {
        comparator2 = new Comparator$2(">=0.0.0");
      }
      high = high || comparator2;
      low = low || comparator2;
      if (gtfn(comparator2.semver, high.semver, options)) {
        high = comparator2;
      } else if (ltfn(comparator2.semver, low.semver, options)) {
        low = comparator2;
      }
    });
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }
    if ((!low.operator || low.operator === comp) && ltefn(version2, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version2, low.semver)) {
      return false;
    }
  }
  return true;
};
var outside_1 = outside$3;
const outside$2 = outside_1;
const gtr$1 = (version2, range2, options) => outside$2(version2, range2, ">", options);
var gtr_1 = gtr$1;
const outside$1 = outside_1;
const ltr$1 = (version2, range2, options) => outside$1(version2, range2, "<", options);
var ltr_1 = ltr$1;
const Range$2 = range;
const intersects$1 = (r1, r2, options) => {
  r1 = new Range$2(r1, options);
  r2 = new Range$2(r2, options);
  return r1.intersects(r2, options);
};
var intersects_1 = intersects$1;
const satisfies$2 = satisfies_1;
const compare$2 = compare_1;
var simplify = (versions, range2, options) => {
  const set = [];
  let first = null;
  let prev = null;
  const v = versions.sort((a2, b2) => compare$2(a2, b2, options));
  for (const version2 of v) {
    const included = satisfies$2(version2, range2, options);
    if (included) {
      prev = version2;
      if (!first) {
        first = version2;
      }
    } else {
      if (prev) {
        set.push([first, prev]);
      }
      prev = null;
      first = null;
    }
  }
  if (first) {
    set.push([first, null]);
  }
  const ranges = [];
  for (const [min2, max2] of set) {
    if (min2 === max2) {
      ranges.push(min2);
    } else if (!max2 && min2 === v[0]) {
      ranges.push("*");
    } else if (!max2) {
      ranges.push(`>=${min2}`);
    } else if (min2 === v[0]) {
      ranges.push(`<=${max2}`);
    } else {
      ranges.push(`${min2} - ${max2}`);
    }
  }
  const simplified = ranges.join(" || ");
  const original = typeof range2.raw === "string" ? range2.raw : String(range2);
  return simplified.length < original.length ? simplified : range2;
};
const Range$1 = range;
const Comparator$1 = comparator;
const { ANY } = Comparator$1;
const satisfies$1 = satisfies_1;
const compare$1 = compare_1;
const subset$1 = (sub, dom, options = {}) => {
  if (sub === dom) {
    return true;
  }
  sub = new Range$1(sub, options);
  dom = new Range$1(dom, options);
  let sawNonNull = false;
  OUTER:
    for (const simpleSub of sub.set) {
      for (const simpleDom of dom.set) {
        const isSub = simpleSubset(simpleSub, simpleDom, options);
        sawNonNull = sawNonNull || isSub !== null;
        if (isSub) {
          continue OUTER;
        }
      }
      if (sawNonNull) {
        return false;
      }
    }
  return true;
};
const minimumVersionWithPreRelease = [new Comparator$1(">=0.0.0-0")];
const minimumVersion = [new Comparator$1(">=0.0.0")];
const simpleSubset = (sub, dom, options) => {
  if (sub === dom) {
    return true;
  }
  if (sub.length === 1 && sub[0].semver === ANY) {
    if (dom.length === 1 && dom[0].semver === ANY) {
      return true;
    } else if (options.includePrerelease) {
      sub = minimumVersionWithPreRelease;
    } else {
      sub = minimumVersion;
    }
  }
  if (dom.length === 1 && dom[0].semver === ANY) {
    if (options.includePrerelease) {
      return true;
    } else {
      dom = minimumVersion;
    }
  }
  const eqSet = /* @__PURE__ */ new Set();
  let gt2, lt2;
  for (const c2 of sub) {
    if (c2.operator === ">" || c2.operator === ">=") {
      gt2 = higherGT(gt2, c2, options);
    } else if (c2.operator === "<" || c2.operator === "<=") {
      lt2 = lowerLT(lt2, c2, options);
    } else {
      eqSet.add(c2.semver);
    }
  }
  if (eqSet.size > 1) {
    return null;
  }
  let gtltComp;
  if (gt2 && lt2) {
    gtltComp = compare$1(gt2.semver, lt2.semver, options);
    if (gtltComp > 0) {
      return null;
    } else if (gtltComp === 0 && (gt2.operator !== ">=" || lt2.operator !== "<=")) {
      return null;
    }
  }
  for (const eq2 of eqSet) {
    if (gt2 && !satisfies$1(eq2, String(gt2), options)) {
      return null;
    }
    if (lt2 && !satisfies$1(eq2, String(lt2), options)) {
      return null;
    }
    for (const c2 of dom) {
      if (!satisfies$1(eq2, String(c2), options)) {
        return false;
      }
    }
    return true;
  }
  let higher, lower;
  let hasDomLT, hasDomGT;
  let needDomLTPre = lt2 && !options.includePrerelease && lt2.semver.prerelease.length ? lt2.semver : false;
  let needDomGTPre = gt2 && !options.includePrerelease && gt2.semver.prerelease.length ? gt2.semver : false;
  if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt2.operator === "<" && needDomLTPre.prerelease[0] === 0) {
    needDomLTPre = false;
  }
  for (const c2 of dom) {
    hasDomGT = hasDomGT || c2.operator === ">" || c2.operator === ">=";
    hasDomLT = hasDomLT || c2.operator === "<" || c2.operator === "<=";
    if (gt2) {
      if (needDomGTPre) {
        if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomGTPre.major && c2.semver.minor === needDomGTPre.minor && c2.semver.patch === needDomGTPre.patch) {
          needDomGTPre = false;
        }
      }
      if (c2.operator === ">" || c2.operator === ">=") {
        higher = higherGT(gt2, c2, options);
        if (higher === c2 && higher !== gt2) {
          return false;
        }
      } else if (gt2.operator === ">=" && !satisfies$1(gt2.semver, String(c2), options)) {
        return false;
      }
    }
    if (lt2) {
      if (needDomLTPre) {
        if (c2.semver.prerelease && c2.semver.prerelease.length && c2.semver.major === needDomLTPre.major && c2.semver.minor === needDomLTPre.minor && c2.semver.patch === needDomLTPre.patch) {
          needDomLTPre = false;
        }
      }
      if (c2.operator === "<" || c2.operator === "<=") {
        lower = lowerLT(lt2, c2, options);
        if (lower === c2 && lower !== lt2) {
          return false;
        }
      } else if (lt2.operator === "<=" && !satisfies$1(lt2.semver, String(c2), options)) {
        return false;
      }
    }
    if (!c2.operator && (lt2 || gt2) && gtltComp !== 0) {
      return false;
    }
  }
  if (gt2 && hasDomLT && !lt2 && gtltComp !== 0) {
    return false;
  }
  if (lt2 && hasDomGT && !gt2 && gtltComp !== 0) {
    return false;
  }
  if (needDomGTPre || needDomLTPre) {
    return false;
  }
  return true;
};
const higherGT = (a2, b2, options) => {
  if (!a2) {
    return b2;
  }
  const comp = compare$1(a2.semver, b2.semver, options);
  return comp > 0 ? a2 : comp < 0 ? b2 : b2.operator === ">" && a2.operator === ">=" ? b2 : a2;
};
const lowerLT = (a2, b2, options) => {
  if (!a2) {
    return b2;
  }
  const comp = compare$1(a2.semver, b2.semver, options);
  return comp < 0 ? a2 : comp > 0 ? b2 : b2.operator === "<" && a2.operator === "<=" ? b2 : a2;
};
var subset_1 = subset$1;
const internalRe = re$4.exports;
const constants = constants$1;
const SemVer = semver$1;
const identifiers = identifiers$1;
const parse = parse_1;
const valid = valid_1;
const clean = clean_1;
const inc = inc_1;
const diff = diff_1;
const major = major_1;
const minor = minor_1;
const patch = patch_1;
const prerelease = prerelease_1;
const compare = compare_1;
const rcompare = rcompare_1;
const compareLoose = compareLoose_1;
const compareBuild = compareBuild_1;
const sort = sort_1;
const rsort = rsort_1;
const gt = gt_1;
const lt = lt_1;
const eq = eq_1;
const neq = neq_1;
const gte = gte_1;
const lte = lte_1;
const cmp = cmp_1;
const coerce = coerce_1;
const Comparator = comparator;
const Range = range;
const satisfies = satisfies_1;
const toComparators = toComparators_1;
const maxSatisfying = maxSatisfying_1;
const minSatisfying = minSatisfying_1;
const minVersion = minVersion_1;
const validRange = valid$1;
const outside = outside_1;
const gtr = gtr_1;
const ltr = ltr_1;
const intersects = intersects_1;
const simplifyRange = simplify;
const subset = subset_1;
var semver = {
  parse,
  valid,
  clean,
  inc,
  diff,
  major,
  minor,
  patch,
  prerelease,
  compare,
  rcompare,
  compareLoose,
  compareBuild,
  sort,
  rsort,
  gt,
  lt,
  eq,
  neq,
  gte,
  lte,
  cmp,
  coerce,
  Comparator,
  Range,
  satisfies,
  toComparators,
  maxSatisfying,
  minSatisfying,
  minVersion,
  validRange,
  outside,
  gtr,
  ltr,
  intersects,
  simplifyRange,
  subset,
  SemVer,
  re: internalRe.re,
  src: internalRe.src,
  tokens: internalRe.t,
  SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
  RELEASE_TYPES: constants.RELEASE_TYPES,
  compareIdentifiers: identifiers.compareIdentifiers,
  rcompareIdentifiers: identifiers.rcompareIdentifiers
};
var render$L = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": _vm.size,
      "height": _vm.size,
      "viewBox": "0 0 14 14"
    }
  }, [_c("defs", [_c("filter", {
    attrs: {
      "id": "master_svg1_627_65/627_01",
      "filterUnits": "userSpaceOnUse",
      "color-interpolation-filters": "sRGB",
      "x": "2.978515625",
      "y": "4.0418701171875",
      "width": "10.310088157653809",
      "height": "8.331117630004883"
    }
  }, [_c("feFlood", {
    attrs: {
      "flood-opacity": "0",
      "result": "BackgroundImageFix"
    }
  }), _c("feColorMatrix", {
    attrs: {
      "in": "SourceAlpha",
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }
  }), _c("feOffset", {
    attrs: {
      "dy": "1",
      "dx": "1"
    }
  }), _c("feGaussianBlur", {
    attrs: {
      "stdDeviation": "1"
    }
  }), _c("feColorMatrix", {
    attrs: {
      "type": "matrix",
      "values": "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.20000000298023224 0"
    }
  }), _c("feBlend", {
    attrs: {
      "mode": "normal",
      "in2": "BackgroundImageFix",
      "result": "effect1_dropShadow"
    }
  }), _c("feBlend", {
    attrs: {
      "mode": "normal",
      "in": "SourceGraphic",
      "in2": "effect1_dropShadow",
      "result": "shape"
    }
  })], 1)]), _c("clipPath", {
    attrs: {
      "id": "master_svg0_627_65"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "14",
      "height": "14",
      "rx": "0"
    }
  })]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_627_65)"
    }
  }, [_c("g", [_c("rect", {
    attrs: {
      "x": "1",
      "y": "1",
      "width": "12",
      "height": "12",
      "rx": "2",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  }), _c("g", {
    attrs: {
      "filter": "url(#master_svg1_627_65/627_01)"
    }
  }, [_c("path", {
    attrs: {
      "d": "M10.783575625000001,5.5368451171875L6.452455625,9.8679601171875Q6.403705625000001,9.916710117187499,6.346385625,9.9550201171875Q6.289055625,9.993320117187501,6.225365625,10.0197001171875Q6.1616656249999995,10.0460901171875,6.094045625,10.059540117187499Q6.026425625,10.0729901171875,5.957485625,10.0729901171875Q5.888545625,10.0729901171875,5.820925625,10.059540117187499Q5.753305625,10.0460901171875,5.689605625,10.0197001171875Q5.625915625,9.993320117187501,5.568585625,9.9550201171875Q5.511265625,9.916710117187499,5.462505625,9.8679601171875Q5.458435625,9.8638901171875,5.454425625,9.8597401171875L3.4754546250000002,7.814470117187501L4.481576625,6.8409701171875L6.460545625,8.8862301171875L5.957485625,9.3729901171875L5.462515625,8.8780101171875L9.793625625,4.5468951171875L10.783575625000001,5.5368451171875ZM10.988605625,5.0418701171875Q10.988605625,5.1108141171875,10.975155625,5.1784331171875Q10.961705625,5.2460521171875,10.935315625000001,5.3097481171875Q10.908935625,5.3734441171875,10.870635625,5.4307691171875Q10.832325625,5.4880941171875,10.783575625000001,5.5368451171875Q10.734825625,5.5855951171875,10.677505625,5.6238991171875Q10.620175625,5.6622021171875,10.556485625,5.6885861171875Q10.492785625,5.7149691171875,10.425165625,5.7284201171875Q10.357545625,5.7418701171875,10.288605624999999,5.7418701171875Q10.219655625,5.7418701171875,10.152035625,5.7284201171875Q10.084425625,5.7149691171875,10.020725625,5.6885861171875Q9.957025625,5.6622021171875,9.899705625,5.6238991171875Q9.842375624999999,5.5855951171875,9.793625625,5.5368451171875Q9.744875624999999,5.4880941171875,9.706575625,5.4307691171875Q9.668265625,5.3734441171875,9.641885625,5.3097481171875Q9.615505625,5.2460521171875,9.602055625,5.1784331171875Q9.588605625,5.1108141171875,9.588605625,5.0418701171875Q9.588605625,4.9729261171875,9.602055625,4.9053071171875Q9.615505625,4.8376881171875,9.641885625,4.7739921171875Q9.668265625,4.7102961171875,9.706575625,4.6529711171875Q9.744875624999999,4.5956461171875,9.793625625,4.5468951171875Q9.842375624999999,4.4981451171875,9.899705625,4.4598411171875Q9.957025625,4.4215381171875,10.020725625,4.3951541171875Q10.084425625,4.3687711171875,10.152035625,4.3553201171875Q10.219655625,4.3418701171875,10.288605624999999,4.3418701171875Q10.357545625,4.3418701171875,10.425165625,4.3553201171875Q10.492785625,4.3687711171875,10.556485625,4.3951541171875Q10.620175625,4.4215381171875,10.677505625,4.4598411171875Q10.734825625,4.4981451171875,10.783575625000001,4.5468951171875Q10.832325625,4.5956461171875,10.870635625,4.6529711171875Q10.908935625,4.7102961171875,10.935315625000001,4.7739921171875Q10.961705625,4.8376881171875,10.975155625,4.9053071171875Q10.988605625,4.9729261171875,10.988605625,5.0418701171875ZM4.678515625,7.3277201171875Q4.678515625,7.3966601171874995,4.665065625,7.4642801171875Q4.651614625,7.5319001171875,4.625231625,7.5956001171875Q4.598847625,7.6592901171875,4.560544625,7.7166201171874995Q4.522240625,7.7739401171875,4.473490625,7.8226901171875Q4.424739625,7.8714501171875,4.367414625,7.9097501171874995Q4.310089625,7.9480501171875,4.246393625,7.9744301171875005Q4.182697625,8.0008201171875,4.115078625,8.0142701171875Q4.047459625,8.0277201171875,3.978515625,8.0277201171875Q3.909571625,8.0277201171875,3.8419526250000002,8.0142701171875Q3.774333625,8.0008201171875,3.710637625,7.9744301171875005Q3.646941625,7.9480501171875,3.589616625,7.9097501171874995Q3.532291625,7.8714401171875,3.483540625,7.8226901171875Q3.4347906249999998,7.7739401171875,3.396486625,7.7166201171874995Q3.358183625,7.6592901171875,3.331799625,7.5956001171875Q3.305416625,7.5319001171875,3.291965625,7.4642801171875Q3.278515625,7.3966601171874995,3.278515625,7.3277201171875Q3.278515625,7.2587801171875,3.291965625,7.191160117187501Q3.305416625,7.1235401171875,3.331799625,7.0598401171875Q3.358183625,6.9961501171875,3.396486625,6.9388201171875Q3.4347906249999998,6.8815001171875,3.483540625,6.8327401171875Q3.532291625,6.7839901171875,3.589616625,6.7456901171875Q3.646941625,6.7073901171875,3.710637625,6.6810001171875Q3.774333625,6.6546201171875,3.8419526250000002,6.6411701171874995Q3.909571625,6.6277201171875,3.978515625,6.6277201171875Q4.047459625,6.6277201171875,4.115078625,6.6411701171874995Q4.182697625,6.6546201171875,4.246393625,6.6810001171875Q4.310089625,6.7073901171875,4.367414625,6.7456901171875Q4.424739625,6.7839901171875,4.473490625,6.8327401171875Q4.522240625,6.8815001171875,4.560544625,6.9388201171875Q4.598847625,6.9961501171875,4.625231625,7.0598401171875Q4.651614625,7.1235401171875,4.665065625,7.191160117187501Q4.678515625,7.2587801171875,4.678515625,7.3277201171875Z",
      "fill": "#FFFFFF",
      "fill-opacity": "1"
    }
  })])])])]);
};
var staticRenderFns$K = [];
const __vue2_script$K = defineComponent({
  name: "CheckedBox",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$K = {};
var __component__$K = /* @__PURE__ */ normalizeComponent(
  __vue2_script$K,
  render$L,
  staticRenderFns$K,
  false,
  __vue2_injectStyles$K,
  null,
  null,
  null
);
function __vue2_injectStyles$K(context) {
  for (let o2 in __cssModules$K) {
    this[o2] = __cssModules$K[o2];
  }
}
var CheckedBox = /* @__PURE__ */ function() {
  return __component__$K.exports;
}();
const Logo = `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" width="107.579" height="28"><path d="M.214 20.353 7.674 5.83c.686-1.333 2.574-1.364 3.302-.053l8.027 14.465c.812 1.464-.547 3.182-2.152 2.721l-6.611-1.898a1.866 1.866 0 0 0-1.03 0l-6.817 1.955c-1.578.452-2.931-1.205-2.18-2.668z" fill="#3970E3"/><path d="m22.429 22.08 3.082.884c1.605.46 2.963-1.257 2.151-2.72L19.635 5.776c-.727-1.31-2.616-1.28-3.3.054L15.012 8.4 22.43 22.08z" fill="#3970E3" style="opacity:.5"/><g><path d="M86.672 19.526c-.845 0-1.59-.17-2.236-.51a3.736 3.736 0 0 1-1.49-1.436c-.349-.616-.523-1.329-.523-2.137v-3.27c0-.808.174-1.516.523-2.122a3.736 3.736 0 0 1 1.49-1.435c.645-.34 1.39-.51 2.236-.51.835 0 1.575.164 2.22.494.644.319 1.141.76 1.49 1.324a3.4 3.4 0 0 1 .539 1.866v.08a.199.199 0 0 1-.063.143.171.171 0 0 1-.127.048h-2.252a.23.23 0 0 1-.142-.048.235.235 0 0 1-.048-.143 1.41 1.41 0 0 0-.444-1.053c-.285-.298-.676-.447-1.173-.447-.486 0-.877.16-1.173.479q-.444.478-.444 1.244v3.43c0 .51.164.925.491 1.244.328.319.74.478 1.237.478.465 0 .84-.122 1.126-.367.285-.255.428-.606.428-1.052v-.447c0-.053-.027-.08-.08-.08h-1.585a.232.232 0 0 1-.143-.048.235.235 0 0 1-.047-.143v-1.755c0-.053.016-.095.047-.127a.197.197 0 0 1 .143-.064h4.059a.15.15 0 0 1 .127.064.152.152 0 0 1 .063.127v2.17c0 .797-.18 1.499-.539 2.105a3.533 3.533 0 0 1-1.49 1.404c-.634.33-1.374.494-2.22.494zM41.12 8.233c-.106 0-.18.042-.222.128l-2.172 3.477c-.032.064-.063.064-.095 0L36.427 8.36a.248.248 0 0 0-.222-.128H33.97c-.053 0-.1.021-.143.064a.173.173 0 0 0-.048.127v10.783c0 .053.016.101.048.144a.23.23 0 0 0 .143.048h2.25q.08 0 .128-.048a.199.199 0 0 0 .063-.144V12.78c0-.043.01-.064.032-.064.021 0 .042.016.063.048l1.38 2.217c.042.085.116.128.222.128h1.125c.106 0 .18-.043.222-.128l1.364-2.201c.02-.032.042-.048.063-.048.021 0 .032.021.032.064v6.412c0 .053.016.101.047.144.043.032.09.048.143.048h2.252a.17.17 0 0 0 .126-.048.199.199 0 0 0 .064-.144V8.424a.152.152 0 0 0-.064-.127.15.15 0 0 0-.126-.064H41.12zm25.475 4.85a.199.199 0 0 1-.063.143.17.17 0 0 1-.127.047h-1.443c-.052 0-.079.027-.079.08v2.903c0 .607.243.91.73.91h.586a.15.15 0 0 1 .127.063.152.152 0 0 1 .063.128v1.85c0 .117-.063.186-.19.208-.507.021-.877.032-1.11.032-.92 0-1.601-.144-2.045-.431-.444-.298-.671-.856-.682-1.675v-3.988c0-.053-.026-.08-.079-.08h-.904a.23.23 0 0 1-.142-.047.234.234 0 0 1-.048-.144v-1.739c0-.053.016-.095.048-.127a.197.197 0 0 1 .142-.064h.904c.053 0 .08-.027.08-.08v-1.93c0-.053.015-.096.047-.127a.196.196 0 0 1 .143-.064h2.14a.15.15 0 0 1 .127.064.152.152 0 0 1 .063.127v1.93c0 .053.027.08.08.08h1.442a.15.15 0 0 1 .127.064.152.152 0 0 1 .063.127v1.74zm8.638 2.727c.022-.521.006-.941-.047-1.26a4.544 4.544 0 0 0-.682-1.819 3.53 3.53 0 0 0-1.331-1.26c-.55-.308-1.174-.463-1.871-.463-.867 0-1.617.229-2.252.686-.623.447-1.073 1.064-1.347 1.85q-.254.766-.254 1.596c0 .797.111 1.462.333 1.994a3.605 3.605 0 0 0 1.443 1.77c.676.415 1.495.622 2.457.622.645 0 1.237-.106 1.776-.319a3.6 3.6 0 0 0 1.38-.925c.042-.042.063-.085.063-.128a.152.152 0 0 0-.064-.127l-1.22-1.404a.15.15 0 0 0-.128-.064c-.052 0-.1.027-.142.08-.38.436-.904.654-1.57.654-.37 0-.681-.069-.935-.207a1.412 1.412 0 0 1-.57-.543 2.188 2.188 0 0 1-.16-.462c-.01-.021-.005-.037.016-.048.022-.021.043-.032.064-.032h4.836c.126 0 .195-.064.205-.191zm-26.822-4.786c.708 0 1.348.123 1.918.367.571.234 1.02.564 1.348.99.328.414.492.877.492 1.387v5.44a.199.199 0 0 1-.064.143.17.17 0 0 1-.127.048h-2.251a.23.23 0 0 1-.143-.048.234.234 0 0 1-.047-.144v-.558c0-.043-.01-.064-.032-.064-.021-.01-.042.006-.063.048-.402.596-1.09.893-2.062.893q-1.268 0-2.029-.59c-.497-.404-.745-.994-.745-1.77 0-.82.28-1.452.84-1.899.571-.446 1.395-.67 2.474-.67h1.537c.053 0 .08-.026.08-.08v-.302c0-.288-.095-.51-.286-.67-.19-.17-.454-.256-.792-.256-.254 0-.476.048-.666.144-.18.096-.296.218-.35.367-.052.117-.126.17-.221.16l-2.283-.304c-.127-.021-.19-.069-.19-.143.042-.468.222-.888.539-1.26.327-.383.76-.681 1.3-.894a4.801 4.801 0 0 1 1.823-.335zm8.548 8.502c-.75 0-1.406-.1-1.966-.303-.56-.212-.993-.505-1.3-.877a2.082 2.082 0 0 1-.444-1.308v-.175c0-.054.016-.096.048-.128a.197.197 0 0 1 .142-.064h2.14a.15.15 0 0 1 .128.064.152.152 0 0 1 .063.128c0 .202.111.372.333.51.222.128.502.191.84.191.296 0 .529-.048.698-.143.18-.107.27-.245.27-.415 0-.17-.096-.292-.286-.367-.18-.085-.476-.165-.888-.24-.666-.127-1.205-.28-1.617-.462-.539-.223-.967-.5-1.284-.83-.317-.34-.476-.802-.476-1.387 0-.83.317-1.483.951-1.962.645-.49 1.49-.734 2.537-.734.708 0 1.327.117 1.855.351.54.224.957.543 1.253.957.296.415.444.894.444 1.436a.199.199 0 0 1-.064.144.17.17 0 0 1-.127.047h-2.077a.231.231 0 0 1-.142-.047.235.235 0 0 1-.048-.144c0-.202-.095-.367-.285-.495-.19-.127-.45-.19-.777-.19-.296 0-.54.052-.73.159-.18.095-.269.234-.269.414 0 .181.1.314.301.4.201.074.54.159 1.015.254.613.128 1.041.229 1.284.303.656.213 1.163.5 1.522.862.37.361.555.845.555 1.451 0 .83-.328 1.473-.983 1.93-.645.447-1.517.67-2.616.67zm36.536-.765c.666.51 1.475.765 2.426.765.962 0 1.776-.26 2.442-.781.665-.521 1.11-1.229 1.331-2.122.117-.446.175-.914.175-1.403 0-.543-.074-1.053-.222-1.532-.254-.83-.703-1.478-1.348-1.946-.645-.478-1.432-.718-2.362-.718-.94 0-1.744.24-2.41.718-.655.468-1.105 1.122-1.348 1.962-.137.447-.206.963-.206 1.547 0 .521.063 1 .19 1.436.222.872.666 1.563 1.332 2.074zm-11.939-7.513c-.21-.139-.507-.208-.887-.208-.677 0-1.226.282-1.65.846-.01.032-.026.042-.047.032-.02-.011-.032-.032-.032-.064v-.51a.152.152 0 0 0-.063-.128.151.151 0 0 0-.127-.064H76.5c-.053 0-.1.021-.143.064a.172.172 0 0 0-.047.127v7.864c0 .053.015.101.047.144.043.032.09.048.143.048h2.251a.172.172 0 0 0 .127-.048.199.199 0 0 0 .063-.144v-4.195c0-.35.112-.633.333-.845a1.5 1.5 0 0 1 .84-.383 2.474 2.474 0 0 1 .951.032c.138.053.213.016.223-.112l.365-2.217c.02-.106-.01-.186-.096-.24zM70.208 14.07c.18-.521.544-.782 1.094-.782.295 0 .539.07.73.208.2.138.337.34.411.606.043.128.064.234.064.319 0 .042-.021.064-.064.064h-2.251c-.064 0-.085-.027-.064-.08a1.39 1.39 0 0 1 .08-.335zm26.474 2.903c-.2.192-.454.287-.761.287s-.565-.095-.777-.287c-.2-.202-.344-.473-.428-.813a4.063 4.063 0 0 1-.095-.91c0-.361.031-.67.095-.925.19-.691.592-1.037 1.205-1.037.307 0 .56.09.761.272.2.18.343.436.428.765.074.298.111.606.111.925 0 .33-.032.633-.095.91-.095.34-.243.611-.444.813zm-48.525.654c.402 0 .73-.1.983-.303.265-.213.397-.49.397-.83v-.382c0-.053-.027-.08-.08-.08h-.95c-.403 0-.714.07-.936.207-.212.139-.317.346-.317.623 0 .233.079.42.237.558.159.138.381.207.666.207z" fill-rule="evenodd" fill="currentColor"/></g></svg>

`;
var Banner = "data:image/png;base64,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";
var BannerEn = "data:image/png;base64,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";
const logoColor = {
  dark: "rgb(255, 255, 255)",
  light: "#000"
};
const theme = {
  logo: Logo,
  logoColor,
  logoForgetPasswordColor: "",
  banner: i18n.locale === "zh-CN" ? Banner : BannerEn,
  bannerBackgroundColor: "var(--mg-color-bg)",
  bannerPosition: BannerPosition.leftCenter,
  loginContainerBackgroundColor: "var(--color-main)",
  loginContainerPadding: "",
  loginContainerBorderRadius: "",
  loginBackgroundColor: "",
  loginTitle: "\u6B22\u8FCE\u56DE\u6765",
  loginTitleFontSize: "18px",
  loginTitleFontWeight: "600",
  loginTitleFontColor: "var(--color-text)",
  loginTitleLineHeight: "27px",
  textBtnLabelColor: "var(--color-tran-50)",
  textBtnColor: "var(--color-blue)",
  textBtnHoverColor: "var(--color-blue)",
  textBtnHoverBackgroundColor: "rgba(54, 98, 236, .15)",
  textBtnActiveBackgroundColor: "rgba(54, 98, 236, .1)",
  primaryBtnBackgroundColor: "#3662ec",
  primaryBtnHoverBackgroundColor: "var(--color-button-normal-bg-hover)",
  primaryBtnActiveBackgroundColor: "var(--color-button-normal-bg-pressing)",
  primaryBtnDisabledBackgroundColor: "var(--color-button-disable)",
  primaryBtnDisabledColor: "var(--mg-btn-disabled-color)",
  primaryBtnPressingBackgroundColor: "var(--color-button-normal-bg-pressing)",
  outlineBtnColor: "var(--color-text)",
  outlineBtnHoverColor: "var(--color-text)",
  outlineBtnBorder: "1px solid var(--color-tran-18)",
  outlineBtnBorderHover: "1px solid var(--color-tran-30)",
  outlineBtnBorderDisable: "1px solid var(--color-tran-18)",
  outlineBtnColorDisable: "var(--mg-btn-disabled-color)",
  inputPlaceholderColor: "var(--color-text-assistant)",
  inputTextColor: "var(--color-text)",
  inputBackgroundColor: "var(--color-tran-8)",
  inputHoverBackgroundColor: "var(--color-tran-12)",
  inputFocusShadow: "0 0 0 1px #507afc",
  inputErrorShadow: "0 0 0 1px var(--color-error)",
  inputErrorColor: "#e05f42",
  hideSSO: false,
  noUseThemeColor: false
};
const loginThemes = {
  MasterGo: theme
};
class LoginThemeManager {
  constructor() {
    this.loginTheme = {};
    this.initialized = false;
  }
  initLoginTheme(payload) {
    const loginTheme = loginThemes[payload] || loginThemes[LoginThemeType.MasterGo];
    this.loginTheme = loginTheme;
    this.initialized = true;
    const themeColor = this.initThemeColor();
    return {
      loginTheme,
      themeColor
    };
  }
  initThemeColor() {
    const cacheThemeColor = window.localStorage.getItem(CacheThemeColorKey);
    if (this.loginTheme.noUseThemeColor) {
      window.document.documentElement.className = ThemeColor.Light;
      return ThemeColor.Light;
    }
    const isValidate = cacheThemeColor && Object.values(ThemeColor).includes(cacheThemeColor);
    const themeColor = isValidate ? cacheThemeColor : ThemeColor.Light;
    const isDark = themeColor === ThemeColor.Dark;
    const root2 = document.documentElement;
    if (isDark) {
      root2.classList.add(ThemeColor.Dark);
      root2.classList.remove(ThemeColor.Light);
    } else {
      root2.classList.add(ThemeColor.Light);
      root2.classList.remove(ThemeColor.Dark);
    }
    return themeColor;
  }
}
const loginThemeManager = new LoginThemeManager();
const createLoginTheme = (_loginTheme) => {
  const loginTheme = computed(() => {
    var _a2;
    return (_loginTheme == null ? void 0 : _loginTheme.loginTheme) || ((_a2 = loginThemeManager.initLoginTheme(LoginThemeType.MasterGo)) == null ? void 0 : _a2.loginTheme);
  });
  const loginThemeStyle = ref("");
  const loginTitle = ref("");
  const hideSSO = ref(false);
  if (!loginTheme.value) {
    return {
      hasTheme: ref(false),
      loginThemeStyle,
      loginTitle,
      hideSSO
    };
  }
  function initLoginTheme(theme2) {
    log$1.log("[debug] theme: ", theme2);
    loginThemeStyle.value = `
    --theme-login-container-color: ${theme2.loginContainerBackgroundColor};
    --theme-login-container-border-radius: ${theme2.loginContainerBorderRadius};
    --theme-login-container-padding: ${theme2.loginContainerPadding};
    --theme-login-bg-color: ${theme2.loginBackgroundColor};
    --theme-login-title-font-size: ${theme2.loginTitleFontSize};
    --theme-login-title-font-weight: ${theme2.loginTitleFontWeight};
    --theme-login-title-font-color: ${theme2.loginTitleFontColor};
    --theme-login-title-line-height: ${theme2.loginTitleLineHeight};
    --theme-text-btn-label-color: ${theme2.textBtnLabelColor};
    --theme-text-btn-color: ${theme2.textBtnColor};
    --theme-text-btn-hover-color: ${theme2.textBtnHoverColor};
    --theme-text-btn-hover-bg-color: ${theme2.textBtnHoverBackgroundColor};
    --theme-text-btn-active-bg-color: ${theme2.textBtnActiveBackgroundColor};
    --theme-primary-btn-bg-color: ${theme2.primaryBtnBackgroundColor};
    --theme-primary-btn-hover-bg-color: ${theme2.primaryBtnHoverBackgroundColor};
    --theme-primary-btn-active-bg-color: ${theme2.primaryBtnActiveBackgroundColor};
    --theme-primary-btn-disabled-bg-color: ${theme2.primaryBtnDisabledBackgroundColor};
    --theme-primary-btn-disabled-color: ${theme2.primaryBtnDisabledColor};
    --theme-primary-btn-pressing-bg-color: ${theme2.primaryBtnPressingBackgroundColor};
    --theme-outline-btn-color: ${theme2.outlineBtnColor};
    --theme-outline-btn-hover-color: ${theme2.outlineBtnHoverColor};
    --theme-outline-btn-border: ${theme2.outlineBtnBorder};
    --theme-outline-btn-border-hover: ${theme2.outlineBtnBorderHover};
    --theme-outline-btn-border-disable: ${theme2.outlineBtnBorderDisable};
    --theme-outline-btn-color-disable: ${theme2.outlineBtnColorDisable};
    --theme-input-text-color: ${theme2.inputTextColor};
    --theme-input-placeholder-color: ${theme2.inputPlaceholderColor};
    --theme-input-bg-color: ${theme2.inputBackgroundColor};
    --theme-input-hover-bg-color: ${theme2.inputHoverBackgroundColor};
    --theme-input-focus-shadow: ${theme2.inputFocusShadow};
    --theme-input-error-shadow: ${theme2.inputErrorShadow};
    --theme-input-error-color: ${theme2.inputErrorColor};
    `;
    loginTitle.value = tFn(theme2.loginTitle) || theme2.loginTitle;
    hideSSO.value = theme2.hideSSO;
  }
  watch(loginTheme.value, () => {
    initLoginTheme(loginTheme.value);
  }, { immediate: true });
  return {
    hasTheme: ref(true),
    loginThemeStyle,
    loginTitle,
    hideSSO
  };
};
const loginByThirdCode = async () => {
  var _a2, _b, _c;
  const code = getSessionStorageItem$1(SESSION_KEYS.PRIVATE_CODE);
  if (code) {
    const redirectUrl = getSessionStorageItem$1(SESSION_KEYS.SOURCE_URL);
    startRemoveSession();
    try {
      const data2 = await priLoginByCode({
        private_code: code,
        platformName: "mastergo"
      });
      if ((data2 == null ? void 0 : data2.code) === "OK") {
        location.href = redirectUrl || window.location.origin + "/files/home";
      }
    } catch (e2) {
      const code2 = (_b = (_a2 = e2 == null ? void 0 : e2.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code;
      if (code2 && samlEmailErrCode[code2]) {
        return samlEmailErrCode[code2];
      }
    }
  } else {
    const res = await getLoginType();
    const data2 = (res == null ? void 0 : res.data) || {};
    const firstMethod = (_c = data2.login_methods) == null ? void 0 : _c[0];
    if (data2.login_type === "sso" && (firstMethod == null ? void 0 : firstMethod.redirect_url)) {
      location.href = firstMethod.redirect_url;
    }
  }
};
const wecomLoginMethodFn = async ({
  params,
  emit
}) => {
  const data2 = await getFormData();
  const fn2 = sendFormData(data2);
  try {
    const res = await wechatLogin({
      ...params,
      ...data2,
      loginFrom: "wecom"
    });
    emit("setUserInfo", (res == null ? void 0 : res.data) || void 0);
    fn2(res);
  } catch {
  }
};
const wechatLoginMethodFn = async ({
  params,
  emit,
  isPri: isPri2,
  callback
}) => {
  const data2 = await getFormData();
  const fn2 = sendFormData(data2);
  try {
    const wxRes = await wechatLogin({
      ...params,
      ...data2
    });
    const cb = () => {
      removeSessionStorageItem(SESSION_KEYS.WECHAT_LOGIN_START);
      emit("setUserInfo", (wxRes == null ? void 0 : wxRes.data) || void 0);
      removeDrainageData();
      fn2(wxRes);
    };
    if (isNeedRealNameAuth(wxRes == null ? void 0 : wxRes.data, isPri2)) {
      callback == null ? void 0 : callback({
        showRealNamePhone: true,
        successCallback: cb
      });
      return;
    }
    cb();
  } catch {
  }
};
var render$K = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "16",
      "height": "30",
      "viewBox": "0 0 16 30"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_57_9233"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "16",
      "height": "30",
      "rx": "0"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_57_9233)"
    }
  }, [_c("g", {
    attrs: {
      "transform": "matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,8.878679692745209,-5.435028612613678)"
    }
  }, [_c("path", {
    attrs: {
      "d": "M12,8.5C12,8.223858,11.776142,8,11.5,8C11.5,8,11.5,8,11.5,8C11.223858,8,11,8.223858,11,8.5C11,8.5,11,18,11,18C11,18,20.5,18,20.5,18C20.776139999999998,18,21,17.776139999999998,21,17.5C21,17.5,21,17.5,21,17.5C21,17.223860000000002,20.776139999999998,17,20.5,17C20.5,17,12,17,12,17C12,17,12,8.5,12,8.5C12,8.5,12,8.5,12,8.5Z",
      "fill": "currentcolor",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$J = [];
const __vue2_script$J = defineComponent({
  name: "WindowsCloseIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$J = {};
var __component__$J = /* @__PURE__ */ normalizeComponent(
  __vue2_script$J,
  render$K,
  staticRenderFns$J,
  false,
  __vue2_injectStyles$J,
  null,
  null,
  null
);
function __vue2_injectStyles$J(context) {
  for (let o2 in __cssModules$J) {
    this[o2] = __cssModules$J[o2];
  }
}
var BackIcon = /* @__PURE__ */ function() {
  return __component__$J.exports;
}();
var render$J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "box"
  }, [_c("div", {
    staticClass: "title"
  }, [_c("BackIcon", {
    staticClass: "canClick goBack",
    attrs: {
      "size": "12px"
    },
    on: {
      "click": _vm.goBack
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$_t("\u8BF7\u9A8C\u8BC1\u624B\u673A\u53F7")))])], 1), _c("div", {
    staticClass: "desc"
  }, [_c("span", [_vm._v(_vm._s(_vm.$_t("\u6839\u636E\u56FD\u5BB6\u76F8\u5173\u6CD5\u5F8B\u89C4\u5B9A\u53CA\u7F51\u7EDC\u5B9E\u540D\u5236\u8981\u6C42\uFF0C\u8BF7\u9A8C\u8BC1\u6709\u6548\u624B\u673A\u53F7\u7801")))])]), _c("div", {
    staticClass: "form-item"
  }, [_c("div", {
    staticClass: "form-item-content phone",
    class: {
      error: _vm.phoneErrorTip
    }
  }, [_c("div", {
    staticClass: "text-86"
  }, [_vm._v("+86")]), _c("div", {
    staticClass: "line"
  }), _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.phone,
      expression: "phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "text-2",
    attrs: {
      "placeholder": _vm.$_t("\u8BF7\u8F93\u5165\u624B\u673A\u53F7\u7801")
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "focus": _vm.phoneFocus,
      "blur": [_vm.phoneBlur, function($event) {
        return _vm.$forceUpdate();
      }],
      "input": function($event) {
        if ($event.target.composing)
          return;
        _vm.phone = $event.target.value.trim();
      }
    }
  })]), _c("div", {
    staticClass: "error-tip"
  }, [_c("WarningIcon", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.phoneErrorTip,
      expression: "phoneErrorTip"
    }],
    staticClass: "error-icon",
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.phoneErrorTip))])], 1)]), _c("div", {
    staticClass: "row"
  }, [_c("div", {
    staticClass: "form-item flex1"
  }, [_c("div", {
    staticClass: "form-item-content sms-code",
    class: {
      error: _vm.codeErrorTip
    }
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.code,
      expression: "code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "code",
    attrs: {
      "placeholder": _vm.$_t("\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801")
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "focus": _vm.codeFocus,
      "blur": [_vm.codeBlur, function($event) {
        return _vm.$forceUpdate();
      }],
      "input": function($event) {
        if ($event.target.composing)
          return;
        _vm.code = $event.target.value.trim();
      }
    }
  })]), _c("div", {
    staticClass: "error-tip"
  }, [_c("WarningIcon", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codeErrorTip,
      expression: "codeErrorTip"
    }],
    staticClass: "error-icon",
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.codeErrorTip))])], 1)]), _c("div", {
    staticClass: "button get-code",
    class: {
      disabled: _vm.timer
    },
    on: {
      "click": _vm.getCode
    }
  }, [_vm.timer ? _c("span", [_vm._v(_vm._s(_vm.$_t("%{time}\u79D2\u540E\u91CD\u8BD5", {
    time: _vm.time
  })))]) : _c("span", [_vm._v(_vm._s(_vm.$_t("\u83B7\u53D6\u9A8C\u8BC1\u7801")))])])]), _c("div", {
    class: ["button", "submit", {
      disabled: _vm.disableSubmit
    }],
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$_t("\u786E\u5B9A")))])]);
};
var staticRenderFns$I = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$4 = "";
const __vue2_script$I = {
  props: {
    sendLog: {
      default: (type2, data2) => {
        console.log("sendLog:", type2, data2);
      }
    },
    userInfo: {
      default: () => ({})
    }
  },
  emits: ["toast", "bindSuccess", "back"],
  components: {
    BackIcon,
    WarningIcon
  },
  setup(props2, { emit }) {
    const phone = ref("");
    const code = ref("");
    const goBack2 = () => {
      emit("back");
    };
    const toast2 = (msg, type2 = "destructive") => {
      emit("toast", { content: msg, timeout: 3e3, position: "top", type: type2 });
    };
    const phoneErrorTip = ref("");
    const codeErrorTip = ref("");
    const loading = ref(false);
    const disableSubmit = computed(() => {
      return !!(!phone.value || !code.value || phoneErrorTip.value || codeErrorTip.value || loading.value);
    });
    const phoneBlur = () => {
      validatePhone();
    };
    const phoneFocus = () => {
      phoneErrorTip.value = "";
    };
    const codeBlur = () => {
      validateCode();
    };
    const codeFocus = () => {
      codeErrorTip.value = "";
    };
    const validatePhone = () => {
      if (!phone.value) {
        phoneErrorTip.value = i18n.t("\u624B\u673A\u53F7\u4E0D\u80FD\u4E3A\u7A7A");
        return false;
      }
      const reg = /^1[3-9]\d{9}$/;
      const isValidPhone = reg.test(phone.value);
      if (!isValidPhone) {
        phoneErrorTip.value = i18n.t("\u624B\u673A\u53F7\u683C\u5F0F\u9519\u8BEF");
        return false;
      }
      phoneErrorTip.value = "";
      return true;
    };
    const validateCode = () => {
      if (!code.value) {
        codeErrorTip.value = i18n.t("\u9A8C\u8BC1\u7801\u4E0D\u80FD\u4E3A\u7A7A");
        return false;
      }
      const reg = /^\d{6}$/;
      const isCodeValid = reg.test(code.value);
      if (!isCodeValid) {
        codeErrorTip.value = i18n.t("\u9A8C\u8BC1\u7801\u683C\u5F0F\u9519\u8BEF");
        return false;
      }
      codeErrorTip.value = "";
      return true;
    };
    const validate = () => {
      if (!validatePhone()) {
        return false;
      }
      if (!validateCode()) {
        return false;
      }
      return true;
    };
    const timer = ref(null);
    const time = ref(60);
    const getCode = async () => {
      var _a2;
      if (!validatePhone())
        return;
      if (timer.value) {
        return;
      }
      try {
        const res = await sendMessageCode({ identity: phone.value });
        if (res.code !== "OK") {
          toast2(res.message);
          return;
        }
        time.value = 60;
        timer.value = setInterval(() => {
          if (time.value > 1) {
            time.value--;
          } else {
            time.value = 60;
            clearInterval(timer.value);
            timer.value = null;
          }
        }, 1e3);
      } catch (error) {
        console.error(error);
        const err = (_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.data;
        if ((err == null ? void 0 : err.code) === "FrequencyAttainLockFiveMinute") {
          toast2(i18n.t("\u9A8C\u8BC1\u7801\u53D1\u9001\u9891\u7E41\uFF0C\u8BF75\u5206\u949F\u540E\u518D\u8BD5"));
        } else if (accountErrorCode[err == null ? void 0 : err.code]) {
          codeErrorTip.value = accountErrorCode[err.code];
        } else {
          toast2(i18n.t("\u83B7\u53D6\u9A8C\u8BC1\u7801\u5931\u8D25"));
        }
      }
    };
    const submit = async () => {
      var _a2, _b, _c, _d;
      if (!validate())
        return;
      try {
        loading.value = true;
        const res = await bindAuthMobile(phone.value, code.value);
        if (res.code === "OK") {
          const userInfo = props2.userInfo;
          props2.sendLog("action_interaction", {
            action_detail: "verified_phone_success",
            uid: (userInfo == null ? void 0 : userInfo.id) || getUrlValue$1("realNameUserId"),
            mobile: phone.value
          });
          emit("bindSuccess", res.data);
        } else {
          toast2(res.message);
        }
      } catch (error) {
        console.log("%O", error);
        if (((_a2 = error == null ? void 0 : error.response) == null ? void 0 : _a2.status) === 401) {
          toast2(i18n.t("\u8BF7\u5148\u767B\u5F55"));
          return;
        } else if (((_b = error == null ? void 0 : error.response) == null ? void 0 : _b.status) === 400) {
          if (["InvalidVerifyCode", "UserInfoNotChecked"].includes((_d = (_c = error == null ? void 0 : error.response) == null ? void 0 : _c.data) == null ? void 0 : _d.code)) {
            codeErrorTip.value = i18n.t("\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u9519\u8BEF\u60C5\u51B5\u3011");
            return;
          }
        }
        toast2(i18n.t("\u8BA4\u8BC1\u5931\u8D25"));
      } finally {
        loading.value = false;
      }
    };
    onMounted(() => {
      props2.sendLog("page_view", { action_detail: "verified_phone" });
    });
    onBeforeUnmount(() => {
      if (timer.value)
        clearInterval(timer.value);
    });
    return {
      phone,
      code,
      phoneErrorTip,
      codeErrorTip,
      loading,
      disableSubmit,
      phoneBlur,
      phoneFocus,
      codeBlur,
      codeFocus,
      validatePhone,
      validateCode,
      validate,
      getCode,
      submit,
      goBack: goBack2,
      time,
      timer
    };
  }
};
const __cssModules$I = {};
var __component__$I = /* @__PURE__ */ normalizeComponent(
  __vue2_script$I,
  render$J,
  staticRenderFns$I,
  false,
  __vue2_injectStyles$I,
  "c8493daa",
  null,
  null
);
function __vue2_injectStyles$I(context) {
  for (let o2 in __cssModules$I) {
    this[o2] = __cssModules$I[o2];
  }
}
var RealNamePhone = /* @__PURE__ */ function() {
  return __component__$I.exports;
}();
var render$I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.99594 7.63334C9.20735 7.63334 11.1002 6.33666 11.9012 5.14847C11.9938 5.01109 12.1753 4.9575 12.3206 5.03717L12.6713 5.22952C12.8166 5.30919 12.8706 5.49174 12.7807 5.6309C12.496 6.07159 12.0995 6.51496 11.615 6.92067L12.8027 8.23973C12.9135 8.36286 12.9036 8.55255 12.7805 8.66341L12.4832 8.93107C12.3601 9.04193 12.1704 9.03199 12.0595 8.90886L10.801 7.51108C10.2768 7.83936 9.68826 8.11805 9.05372 8.3156L9.54834 10.1616C9.59123 10.3216 9.49625 10.4861 9.33621 10.529L8.94984 10.6325C8.7898 10.6754 8.6253 10.5804 8.58242 10.4204L8.08004 8.54546C7.7278 8.60256 7.36556 8.63334 6.99594 8.63334C6.62145 8.63334 6.25455 8.60174 5.89795 8.5432L5.39497 10.4204C5.35208 10.5804 5.18758 10.6754 5.02754 10.6325L4.64117 10.529C4.48113 10.4861 4.38616 10.3216 4.42904 10.1616L4.92478 8.31143C4.2974 8.11478 3.71517 7.83886 3.19601 7.51427L1.94032 8.90886C1.82946 9.03199 1.63977 9.04193 1.51664 8.93107L1.21938 8.66341C1.09625 8.55255 1.08631 8.36286 1.19718 8.23973L2.38144 6.92447C1.89483 6.51774 1.49678 6.07297 1.21115 5.6309C1.12123 5.49174 1.17531 5.30919 1.32058 5.22952L1.67129 5.03717C1.81657 4.9575 1.99808 5.01109 2.0907 5.14847C2.89169 6.33666 4.78452 7.63334 6.99594 7.63334Z",
      "fill": "currentcolor"
    }
  })]);
};
var staticRenderFns$H = [];
const __vue2_script$H = defineComponent({
  name: "EyeSlashIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$H = {};
var __component__$H = /* @__PURE__ */ normalizeComponent(
  __vue2_script$H,
  render$I,
  staticRenderFns$H,
  false,
  __vue2_injectStyles$H,
  null,
  null,
  null
);
function __vue2_injectStyles$H(context) {
  for (let o2 in __cssModules$H) {
    this[o2] = __cssModules$H[o2];
  }
}
var EyeSlashIcon = /* @__PURE__ */ function() {
  return __component__$H.exports;
}();
var render$H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 14 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c("path", {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M12 7C12 7.09687 11.9457 7.33736 11.7023 7.69448C11.47 8.03513 11.1123 8.41103 10.6435 8.76185C9.70317 9.46551 8.40887 10 7 10C5.59113 10 4.29683 9.46551 3.35649 8.76185C2.88767 8.41103 2.53 8.03513 2.29774 7.69448C2.05425 7.33736 2 7.09687 2 7C2 6.90313 2.05425 6.66264 2.29774 6.30552C2.53 5.96487 2.88767 5.58897 3.35649 5.23815C4.29683 4.53449 5.59113 4 7 4C8.40887 4 9.70317 4.53449 10.6435 5.23815C11.1123 5.58897 11.47 5.96487 11.7023 6.30552C11.9457 6.66264 12 6.90313 12 7ZM13 7C13 8.5 10.3137 11 7 11C3.68629 11 1 8.5 1 7C1 5.5 3.68629 3 7 3C10.3137 3 13 5.5 13 7ZM5 7C5 8.10891 5.89109 9 7 9C8.10891 9 9 8.10891 9 7C9 5.89109 8.10891 5 7 5C5.89109 5 5 5.89109 5 7Z",
      "fill": "currentcolor"
    }
  })]);
};
var staticRenderFns$G = [];
const __vue2_script$G = defineComponent({
  name: "EyeIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$G = {};
var __component__$G = /* @__PURE__ */ normalizeComponent(
  __vue2_script$G,
  render$H,
  staticRenderFns$G,
  false,
  __vue2_injectStyles$G,
  null,
  null,
  null
);
function __vue2_injectStyles$G(context) {
  for (let o2 in __cssModules$G) {
    this[o2] = __cssModules$G[o2];
  }
}
var EyeIcon = /* @__PURE__ */ function() {
  return __component__$G.exports;
}();
var render$G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "password-input-wrap"
  }, [_c("div", {
    staticClass: "login-password"
  }, [_c("input", {
    staticClass: "text-input password_input",
    class: {
      "error-border": _vm.error,
      "error-border-i18n": _vm.isI18N && _vm.error
    },
    attrs: {
      "type": _vm.eyeStatus ? "password" : "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.modelValue
    },
    on: {
      "input": _vm.handleInput,
      "change": function($event) {
        return _vm.$emit("change", $event);
      }
    }
  }), _c("span", {
    staticClass: "login-eye-icon",
    on: {
      "click": function($event) {
        _vm.eyeStatus = !_vm.eyeStatus;
      }
    }
  }, [_vm.eyeStatus ? _c("EyeSlashIcon") : _c("EyeIcon")], 1)]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.error,
      expression: "error"
    }],
    staticClass: "error",
    class: {
      "error-i18n": _vm.isI18N
    }
  }, [_c("WarningIcon", {
    staticStyle: {
      "flex-shrink": "0",
      "margin-top": "5px",
      "align-self": "flex-start"
    },
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.error))])], 1)]);
};
var staticRenderFns$F = [];
var PasswordInput_vue_vue_type_style_index_0_lang = "";
var PasswordInput_vue_vue_type_style_index_1_scoped_true_lang = "";
const __vue2_script$F = defineComponent({
  name: "PasswordInput",
  components: {
    EyeSlashIcon,
    EyeIcon,
    WarningIcon
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    isI18N: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue", "change"],
  setup(props2, { emit }) {
    const eyeStatus = ref(true);
    const handleInput = (event) => {
      const value = event.target.value;
      emit("update:modelValue", value);
    };
    return {
      eyeStatus,
      handleInput
    };
  }
});
const __cssModules$F = {};
var __component__$F = /* @__PURE__ */ normalizeComponent(
  __vue2_script$F,
  render$G,
  staticRenderFns$F,
  false,
  __vue2_injectStyles$F,
  "17e268c4",
  null,
  null
);
function __vue2_injectStyles$F(context) {
  for (let o2 in __cssModules$F) {
    this[o2] = __cssModules$F[o2];
  }
}
var PasswordInput = /* @__PURE__ */ function() {
  return __component__$F.exports;
}();
var VersionType = /* @__PURE__ */ ((VersionType2) => {
  VersionType2["Free"] = "free";
  VersionType2["Team"] = "team";
  VersionType2["Enterprise"] = "enterprise";
  VersionType2["Private"] = "private";
  return VersionType2;
})(VersionType || {});
const Z_INDEX = 99999;
var render$F = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 16 16"
    }
  }, [_c("g", [_c("g", [_c("path", {
    attrs: {
      "d": "M8.000025832672119,8.707120069885253L12.646465832672119,13.353570069885254L13.35360583267212,12.646460069885254L8.70712583267212,8.000020069885254L13.35360583267212,3.353570069885254L12.646465832672119,2.646462827925254L8.000025832672119,7.292910069885254L3.353574832672119,2.646462827925254L2.646468073172119,3.353570069885254L7.2929158326721195,8.000020069885254L2.646468073172119,12.646460069885254L3.353574832672119,13.353570069885254L8.000025832672119,8.707120069885253Z",
      "fill-rule": "evenodd",
      "fill": "currentcolor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])]);
};
var staticRenderFns$E = [];
const __vue2_script$E = defineComponent({
  name: "CloseIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$E = {};
var __component__$E = /* @__PURE__ */ normalizeComponent(
  __vue2_script$E,
  render$F,
  staticRenderFns$E,
  false,
  __vue2_injectStyles$E,
  null,
  null,
  null
);
function __vue2_injectStyles$E(context) {
  for (let o2 in __cssModules$E) {
    this[o2] = __cssModules$E[o2];
  }
}
var CloseIcon = /* @__PURE__ */ function() {
  return __component__$E.exports;
}();
var render$E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 12 12"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_462_006211/433_054256/397_009160"
    }
  }, [_c("rect", {
    attrs: {
      "x": "1.2001953125",
      "y": "1.2001953125",
      "width": "9.600000381469727",
      "height": "9.600000381469727",
      "rx": "0"
    }
  })])]), _c("g", [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "12",
      "height": "12",
      "rx": "2.4000000953674316",
      "fill": "#48A838",
      "fill-opacity": "0.800000011920929"
    }
  }), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_462_006211/433_054256/397_009160)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M2.224088760799408,6.000429289245606L4.111959760799408,4.112563289245606L3.687689760799408,3.6882995962456055L1.375561058519408,6.000429289245606L3.687689760799408,8.312559289245605L4.111959760799408,7.888299289245605L2.224088760799408,6.000429289245606ZM10.624089760799407,6.000429289245606L8.311959760799407,3.6882995962456055L7.887689760799408,4.112563289245606L9.775559760799409,6.000429289245606L7.887689760799408,7.888299289245605L8.311959760799407,8.312559289245605L10.624089760799407,6.000429289245606Z",
      "fill-rule": "evenodd",
      "fill": "#FFFFFF",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", [_c("path", {
    attrs: {
      "d": "M4.2001953125,9.600195360183715L4.8001953125,9.600195360183715L7.8001953125,2.400195360183716L7.2001953125,2.400195360183716L4.2001953125,9.600195360183715Z",
      "fill": "#FFFFFF",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$D = [];
const __vue2_script$D = defineComponent({
  name: "DevSeatIcon",
  props: {
    size: {
      type: String,
      default: "12px"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$D = {};
var __component__$D = /* @__PURE__ */ normalizeComponent(
  __vue2_script$D,
  render$E,
  staticRenderFns$D,
  false,
  __vue2_injectStyles$D,
  null,
  null,
  null
);
function __vue2_injectStyles$D(context) {
  for (let o2 in __cssModules$D) {
    this[o2] = __cssModules$D[o2];
  }
}
var DevSeatIcon = /* @__PURE__ */ function() {
  return __component__$D.exports;
}();
var render$D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 12 12"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_462_006211/433_054486/397_009159"
    }
  }, [_c("rect", {
    attrs: {
      "x": "1.2001953125",
      "y": "1.2001953125",
      "width": "9.600000381469727",
      "height": "9.600000381469727",
      "rx": "0"
    }
  })])]), _c("g", [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "12",
      "height": "12",
      "rx": "2.4000000953674316",
      "fill": "#7553FF",
      "fill-opacity": "0.800000011920929"
    }
  }), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_462_006211/433_054486/397_009159)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M2.4004030230473634,9.600146484375L9.600401636047362,9.600146484375L9.600401636047362,2.400146484375L2.4004030230473634,2.400146484375L2.4004030230473634,9.600146484375ZM4.799821636047364,4.200146484375L4.799821636047364,4.199946484375L9.000401636047364,4.199946484375L9.000401636047364,3.000146484375L3.0004026360473635,3.000146484375L3.0004026360473635,4.200146484375L4.799821636047364,4.200146484375ZM4.799821636047364,4.800146484375L3.0004026360473635,4.800146484375L3.0004026360473635,9.000146484375L4.799821636047364,9.000146484375L4.799821636047364,4.800146484375ZM5.399821636047363,4.800146484375L8.999821636047363,4.800146484375L8.999821636047363,8.999946484375L5.399821636047363,8.999946484375L5.399821636047363,4.800146484375Z",
      "fill-rule": "evenodd",
      "fill": "#FFFFFF",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$C = [];
const __vue2_script$C = defineComponent({
  name: "PrototypeSeatIcon",
  props: {
    size: {
      type: String,
      default: "12px"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$C = {};
var __component__$C = /* @__PURE__ */ normalizeComponent(
  __vue2_script$C,
  render$D,
  staticRenderFns$C,
  false,
  __vue2_injectStyles$C,
  null,
  null,
  null
);
function __vue2_injectStyles$C(context) {
  for (let o2 in __cssModules$C) {
    this[o2] = __cssModules$C[o2];
  }
}
var PrototypeSeatIcon = /* @__PURE__ */ function() {
  return __component__$C.exports;
}();
var render$C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 12 12"
    }
  }, [_c("g", [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "12",
      "height": "12",
      "rx": "2.4000000953674316",
      "fill": "#2B5CD9",
      "fill-opacity": "0.800000011920929"
    }
  }), _c("g", [_c("g", [_c("path", {
    attrs: {
      "d": "M8.69240972755432,6.651318150634766L8.16161972755432,3.7078881506347656L2.924003727554321,2.4289771506347657L2.7582867275543212,2.3885121506347655L2.7195007275543213,2.3497266506347656L2.695938727554321,2.3732881506347656L2.2671916484543213,2.268598079634766L2.371908727554321,2.6973181506347657L2.3482692275543213,2.7209581506347655L2.3871887275543213,2.7598781506347656L2.4276187275543215,2.9253991506347656L3.7068497275543213,8.162658150634766L6.650639727554322,8.693088150634765L7.659969727554321,9.702418150634767L9.701739727554322,7.660648150634765L8.69240972755432,6.651318150634766ZM3.2044477275543213,3.5771381506347657L4.197149727554321,7.641348150634766L6.941999727554322,8.135928150634765L7.659969727554321,8.853888150634766L8.853209727554322,7.660648150634765L8.135279727554321,6.942718150634765L7.640359727554321,4.198238150634766L3.5754497275543216,3.2056731506347655L5.288319727554321,4.9185481506347655Q5.363079727554322,4.8946881506347655,5.441499727554321,4.891928150634765Q5.5199197275543215,4.889158150634765,5.596169727554321,4.907678150634766Q5.672429727554322,4.926198150634765,5.740839727554322,4.964628150634766Q5.809259727554322,5.003068150634766,5.864739727554321,5.058558150634766Q5.904449727554321,5.0982581506347655,5.935649727554321,5.144948150634765Q5.966839727554321,5.191638150634766,5.988329727554321,5.243508150634765Q6.009819727554321,5.295388150634766,6.020769727554321,5.350458150634766Q6.031729727554321,5.405538150634765,6.031729727554321,5.461688150634766Q6.031729727554321,5.517838150634766,6.020769727554321,5.572908150634765Q6.009819727554321,5.627988150634765,5.988329727554321,5.679858150634766Q5.966839727554321,5.731738150634765,5.935649727554321,5.778428150634765Q5.904449727554321,5.825118150634766,5.864739727554321,5.864818150634766Q5.825039727554321,5.904528150634766,5.778349727554321,5.935718150634766Q5.731659727554321,5.966918150634766,5.679779727554321,5.988408150634766Q5.6279097275543215,6.009898150634766,5.572829727554321,6.020848150634766Q5.517759727554321,6.031808150634766,5.461609727554322,6.031808150634766Q5.405459727554321,6.031808150634766,5.350389727554321,6.020848150634766Q5.295309727554321,6.009898150634766,5.243439727554321,5.988408150634766Q5.1915597275543215,5.966918150634766,5.144869727554321,5.935718150634766Q5.098179727554321,5.904528150634766,5.058479727554321,5.864818150634766Q5.003189727554322,5.809528150634765,4.964829727554321,5.741398150634765Q4.926459727554321,5.673268150634765,4.907859727554321,5.597318150634766Q4.889259727554322,5.5213781506347654,4.891789727554322,5.4432281506347655Q4.894329727554322,5.365078150634766,4.917799727554321,5.290488150634765L3.2044477275543213,3.5771381506347657Z",
      "fill-rule": "evenodd",
      "fill": "#FFFFFF",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$B = [];
const __vue2_script$B = defineComponent({
  name: "EditSeatIcon",
  props: {
    size: {
      type: String,
      default: "12px"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$B = {};
var __component__$B = /* @__PURE__ */ normalizeComponent(
  __vue2_script$B,
  render$C,
  staticRenderFns$B,
  false,
  __vue2_injectStyles$B,
  null,
  null,
  null
);
function __vue2_injectStyles$B(context) {
  for (let o2 in __cssModules$B) {
    this[o2] = __cssModules$B[o2];
  }
}
var EditSeatIcon = /* @__PURE__ */ function() {
  return __component__$B.exports;
}();
var render$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "version": "1.1",
      "width": "70",
      "height": "14",
      "viewBox": "0 0 70 14"
    }
  }, [_c("defs", [_c("linearGradient", {
    attrs: {
      "x1": "0.05631156638264656",
      "y1": "2.2799274921417236",
      "x2": "1.3209755386090731",
      "y2": "2.1732736916216897",
      "id": "master_svg0_433_96057"
    }
  }, [_c("stop", {
    attrs: {
      "offset": "4.285714402794838%",
      "stop-color": "#48CBFF",
      "stop-opacity": "1"
    }
  }), _c("stop", {
    attrs: {
      "offset": "50.319355726242065%",
      "stop-color": "#895DFF",
      "stop-opacity": "1"
    }
  }), _c("stop", {
    attrs: {
      "offset": "100%",
      "stop-color": "#7643FF",
      "stop-opacity": "1"
    }
  })], 1), _c("clipPath", {
    attrs: {
      "id": "master_svg1_901_068883/397_012298"
    }
  }, [_c("rect", {
    attrs: {
      "x": "2.0999984741210938",
      "y": "2.0999999046325684",
      "width": "9.800000190734863",
      "height": "9.800000190734863",
      "rx": "0"
    }
  })])], 1), _c("g", [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "70",
      "height": "14",
      "rx": "2.799999952316284",
      "fill": "url(#master_svg0_433_96057)",
      "fill-opacity": "1"
    }
  }), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg1_901_068883/397_012298)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M5.262818499984741,5.946956393280029C5.438498499984741,5.394776393280029,6.2040584999847415,5.38401639328003,6.394718499984741,5.931046393280029L6.708528499984741,6.831406393280029L7.474028499984741,7.081406393280029C8.024858499984742,7.261306393280029,8.029758499984741,8.02690639328003,7.481278499984741,8.21337639328003L6.674998499984741,8.48747639328003L6.394688499984741,9.29171639328003C6.204018499984741,9.838756393280029,5.438458499984741,9.827986393280028,5.262788499984741,9.275796393280029L5.018638499984741,8.508346393280029L4.120629499984741,8.18763639328003C3.5750544999847413,7.992796393280029,3.5916794999847412,7.227356393280029,4.145209499984741,7.055916393280029L4.9935884999847415,6.793166393280029L5.262818499984741,5.946956393280029ZM8.863178499984741,5.654706393280029C9.02488849998474,6.09195639328003,9.647968499984742,6.09202639328003,9.81011849998474,5.655096393280029C10.247708499984741,5.493416393280029,10.247638499984742,4.869759393280029,9.810138499984742,4.7079013932800295C9.648138499984741,4.271064393280029,9.025308499984742,4.2712143932800295,8.863318499984741,4.708135393280029C8.42681849998474,4.870158393280029,8.42682849998474,5.492416393280029,8.863178499984741,5.654706393280029Z",
      "fill-rule": "evenodd",
      "fill": "#FFFFFF",
      "fill-opacity": "1"
    }
  })])]), _c("g", [_c("path", {
    attrs: {
      "d": "M16.851328664855956,5.0067L15.068668664855958,5.0067L14.984668664855956,5.715999999999999L13.211328664855957,5.715999999999999L13.435328664855957,4.119999999999999L18.745998664855957,4.119999999999999L18.297998664855957,7.311999999999999L14.573998664855957,7.311999999999999L14.405998664855957,8.5533L17.775328664855955,8.5533L18.176668664855956,8.1987L17.99932866485596,9.440000000000001L13.323328664855957,9.440000000000001Q13.052668664855958,9.440000000000001,12.893999664855958,9.258Q12.735333664855958,9.076,12.772666664855958,8.8053L13.108668664855957,6.4253L16.64599866485596,6.4253L16.851328664855956,5.0067ZM23.244698664855957,8.5533L23.477998664855956,6.9573L19.931328664855958,6.9573L20.285998664855956,4.465299999999999L19.977998664855956,4.148L25.643298664855955,4.148L25.521998664855957,5.0067L21.984698664855955,5.0067L21.82599866485596,6.0707L25.372698664855957,6.0707L25.027298664855955,8.5533L24.989998664855957,8.8053Q24.94329866485596,9.076,24.737998664855958,9.258Q24.532698664855957,9.440000000000001,24.26199866485596,9.440000000000001L19.585998664855957,9.440000000000001L19.753998664855956,8.1987L20.061998664855956,8.5533L23.244698664855957,8.5533ZM27.136698664855956,4.763999999999999Q27.173998664855958,4.4933,27.38399866485596,4.311299999999999Q27.59399866485596,4.129300000000001,27.864698664855958,4.129300000000001L32.54069866485595,4.129300000000001L31.887298664855958,8.8053Q31.840698664855957,9.076,31.635298664855956,9.258Q31.429998664855958,9.440000000000001,31.159298664855957,9.440000000000001L26.48329866485596,9.440000000000001L27.136698664855956,4.763999999999999ZM28.881998664855956,5.0067L28.37799866485596,8.5533L30.141998664855958,8.5533L30.645998664855956,5.0067L28.881998664855956,5.0067ZM34.03399866485596,4.763999999999999Q34.07129866485596,4.4933,34.28129866485595,4.311299999999999Q34.49129866485596,4.129300000000001,34.76199866485595,4.129300000000001L39.437998664855954,4.129300000000001L38.78469866485595,8.8053Q38.73799866485596,9.076,38.53269866485596,9.258Q38.32729866485596,9.440000000000001,38.05669866485596,9.440000000000001L33.380698664855956,9.440000000000001L34.03399866485596,4.763999999999999ZM35.77929866485596,5.0067L35.27529866485595,8.5533L37.039298664855956,8.5533L37.54329866485595,5.0067L35.77929866485596,5.0067ZM45.728698664855955,4.157299999999999L46.437998664855954,9.440000000000001L44.832698664855954,9.440000000000001L44.64599866485596,8.0027L42.40599866485596,8.0027L41.78069866485596,9.440000000000001L40.25929866485596,9.440000000000001L42.321998664855954,4.418699999999999L42.051298664855956,4.157299999999999L45.728698664855955,4.157299999999999ZM43.665998664855955,5.0533L42.76999866485596,7.1067L44.561998664855956,7.1067L44.29129866485596,5.0533L43.665998664855955,5.0533ZM49.816698664855956,4.157299999999999L49.00469866485596,9.440000000000001L47.305998664855956,9.440000000000001L47.93129866485596,4.5120000000000005L47.66069866485596,4.157299999999999L49.816698664855956,4.157299999999999ZM58.29129866485596,7.274699999999999L54.371298664855956,7.274699999999999L54.847298664855956,3.9053000000000004L54.62329866485596,3.532L58.823298664855955,3.532L58.29129866485596,7.274699999999999ZM54.29669866485596,4.4L53.409998664855955,4.4747L53.307298664855956,5.2493L54.31529866485596,5.2493L54.18469866485596,6.2013L53.167298664855956,6.2013L52.625998664855956,10.084L51.347298664855956,10.084L51.88869866485596,6.2013L50.833998664855955,6.2013L50.96469866485596,5.2493L52.02869866485596,5.2493L52.12199866485596,4.5867L51.12329866485596,4.6707L51.253998664855956,3.7187L54.427298664855954,3.4480000000000004L54.29669866485596,4.4ZM55.295298664855956,10.056000000000001L53.90469866485596,10.056000000000001L54.79129866485596,7.6107L56.10729866485595,7.6107L55.295298664855956,10.056000000000001ZM58.039298664855956,10.0747L56.73269866485596,10.0747L56.555298664855954,7.619999999999999L57.86199866485596,7.619999999999999L58.039298664855956,10.0747ZM52.896698664855954,9.748000000000001L53.21399866485596,6.4627L54.08199866485596,6.4627L53.75529866485596,9.748000000000001L52.896698664855954,9.748000000000001ZM50.32999866485596,9.748000000000001L50.93669866485596,6.4627L51.804698664855955,6.4627L51.188698664855956,9.748000000000001L50.32999866485596,9.748000000000001ZM57.124698664855956,6.3787L57.39529866485596,4.428000000000001L56.051298664855956,4.428000000000001L55.780698664855954,6.3787L57.124698664855956,6.3787ZM59.14999866485596,10.084L60.792698664855955,7.1813L59.91529866485596,7.1813L60.04599866485596,6.285299999999999L66.42999866485596,6.285299999999999L65.98199866485595,9.468Q65.94469866485596,9.729299999999999,65.73469866485596,9.9067Q65.52469866485595,10.084,65.25399866485596,10.084L63.40599866485596,10.084L64.24599866485596,9.216000000000001L64.52599866485596,7.1813L62.565998664855954,7.1813L60.923298664855956,10.084L59.14999866485596,10.084ZM61.14729866485596,6.023999999999999L59.373998664855954,6.023999999999999L61.34329866485596,3.5786999999999995L61.165998664855955,3.3640000000000008L63.293998664855955,3.3640000000000008L61.14729866485596,6.023999999999999ZM65.77669866485596,3.3640000000000008L67.17669866485596,6.023999999999999L65.40329866485595,6.023999999999999L64.00329866485595,3.3640000000000008L65.77669866485596,3.3640000000000008Z",
      "fill": "#FFFFFF",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$A = [];
const __vue2_script$A = defineComponent({
  name: "AIIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$A = {};
var __component__$A = /* @__PURE__ */ normalizeComponent(
  __vue2_script$A,
  render$B,
  staticRenderFns$A,
  false,
  __vue2_injectStyles$A,
  null,
  null,
  null
);
function __vue2_injectStyles$A(context) {
  for (let o2 in __cssModules$A) {
    this[o2] = __cssModules$A[o2];
  }
}
var AIIcon = /* @__PURE__ */ function() {
  return __component__$A.exports;
}();
var render$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": "20.533233642578125",
      "height": "10",
      "viewBox": "0 0 20.533233642578125 10"
    }
  }, [_c("defs", [_c("linearGradient", {
    attrs: {
      "x1": "1.0121136903762817",
      "y1": "0.0986182689666748",
      "x2": "0.04859644000732542",
      "y2": "0.1744582771191272",
      "id": "master_svg0_397_009915"
    }
  }, [_c("stop", {
    attrs: {
      "offset": "0%",
      "stop-color": "#FF49A1",
      "stop-opacity": "1"
    }
  }), _c("stop", {
    attrs: {
      "offset": "100%",
      "stop-color": "#FFB260",
      "stop-opacity": "1"
    }
  })], 1)], 1), _c("g", [_c("g", {
    attrs: {
      "transform": "matrix(1,0,-0.10452845692634583,0.9945218563079834,0.2772132755784966,0.01452823663152003)"
    }
  }, [_c("path", {
    attrs: {
      "d": "M7.430859823760986,2.652036428451538L6.212649823760986,2.652036428451538L5.670429823760987,5.114056428451538L4.554939823760986,2.652036428451538L3.5421598237609864,2.652036428451538L2.4935498237609863,7.373716428451538L3.7117498237609863,7.373716428451538L4.2611398237609865,4.920126428451538L5.3694598237609865,7.373716428451538L6.382249823760986,7.373716428451538L7.430859823760986,2.652036428451538ZM11.802059823760986,2.652036428451538L8.434079823760985,2.652036428451538L7.385469823760986,7.373716428451538L10.803609823760986,7.373716428451538L11.016189823760987,6.429376428451539L8.823429823760986,6.429376428451539L9.028849823760986,5.485046428451538L10.884819823760987,5.485046428451538L11.097409823760986,4.540706428451538L9.241439823760986,4.540706428451538L9.439699823760986,3.598480428451538L11.589469823760986,3.598480428451538L11.802059823760986,2.652036428451538ZM18.533249823760986,2.652036428451538L17.243349823760987,2.652036428451538L16.046649823760987,5.213126428451538L15.795849823760987,2.652036428451538L14.931149823760986,2.652036428451538L13.550549823760987,5.213126428451538L13.447849823760986,2.652036428451538L12.193789823760987,2.652036428451538L12.537749823760986,7.373716428451538L13.529049823760987,7.373716428451538L14.892949823760986,4.9812564284515375L15.165249823760986,7.373716428451538L16.156549823760987,7.373716428451538L18.533249823760986,2.652036428451538Z",
      "fill": "url(#master_svg0_397_009915)",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$z = [];
const __vue2_script$z = defineComponent({
  name: "AIIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$z = {};
var __component__$z = /* @__PURE__ */ normalizeComponent(
  __vue2_script$z,
  render$A,
  staticRenderFns$z,
  false,
  __vue2_injectStyles$z,
  null,
  null,
  null
);
function __vue2_injectStyles$z(context) {
  for (let o2 in __cssModules$z) {
    this[o2] = __cssModules$z[o2];
  }
}
var NewIcon = /* @__PURE__ */ function() {
  return __component__$z.exports;
}();
var render$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "width": "19",
      "height": "10",
      "viewBox": "0 0 19 10"
    }
  }, [_c("defs", [_c("linearGradient", {
    attrs: {
      "x1": "17",
      "y1": "3.3604736328125",
      "x2": "1.4169398956000805",
      "y2": "8.407623291015625",
      "gradientUnits": "userSpaceOnUse",
      "id": "master_svg0_838_052666"
    }
  }, [_c("stop", {
    attrs: {
      "offset": "0%",
      "stop-color": "#FF227D",
      "stop-opacity": "1"
    }
  }), _c("stop", {
    attrs: {
      "offset": "100%",
      "stop-color": "#FF9421",
      "stop-opacity": "1"
    }
  })], 1)], 1), _c("g", [_c("g", [_c("path", {
    attrs: {
      "d": "M5.825,1.3425C5.0075,1.71,3.9125,1.9649999999999999,2.54,2.1075L2.7875,2.82C3.2375,2.7825,3.6799999999999997,2.7225,4.115,2.64L4.115,4.1025L2.3825,4.1025L2.3825,4.8675L4.1,4.8675C3.995,6.1875,3.4475,7.1625,2.45,7.785L3.035,8.31C4.16,7.567500000000001,4.782500000000001,6.42,4.895,4.8675L6.68,4.8675L6.68,8.28L7.4675,8.28L7.4675,4.8675L9.11,4.8675L9.11,4.1025L7.4675,4.1025L7.4675,1.41L6.68,1.41L6.68,4.1025L4.91,4.1025L4.91,2.445C5.345000000000001,2.3175,5.779999999999999,2.16,6.2,1.9725000000000001L5.825,1.3425ZM12.11,6.555C11.435,6.81,10.655,7.005,9.7625,7.155L9.8675,7.92C10.67,7.77,11.39,7.567500000000001,12.035,7.32C11.93,7.47,11.825,7.612500000000001,11.7125,7.7475000000000005L12.305,8.265C12.9875,7.47,13.4525,6.3675,13.6925,4.9575C13.895,5.535,14.165,6.0675,14.5025,6.555C14.105,6.96,13.61,7.305,13.025,7.59L13.46,8.3025C14.06,8.025,14.585,7.664999999999999,15.0275,7.215C15.3875,7.605,15.8075,7.965,16.2875,8.2875L16.7825,7.619999999999999C16.302500000000002,7.3275,15.8825,6.9975,15.5075,6.63C15.9875,5.94,16.310000000000002,5.0925,16.475,4.08L16.475,3.6449999999999996L15.56,3.6449999999999996C15.6725,3.195,15.785,2.67,15.8975,2.0625L15.8975,1.5750000000000002L12.47,1.5750000000000002L12.47,2.31L13.1225,2.31L13.1225,2.595C13.1075,4.59,12.77,6.12,12.11,7.2L12.11,6.555ZM14.96,6.0075C14.42,5.3025,14.0525,4.4775,13.8575,3.5475000000000003C13.8725,3.2475,13.8875,2.925,13.8875,2.595L13.8875,2.31L15.095,2.31C14.93,3.1875,14.7875,3.8625,14.66,4.3275L15.695,4.3275C15.5525,4.95,15.305,5.5125,14.96,6.0075ZM11.0675,1.3125C10.7975,2.0925,10.475,2.805,10.1075,3.45C10.01,3.5925000000000002,9.905000000000001,3.6900000000000004,9.785,3.7350000000000003L9.9725,4.4475C10.3475,4.4025,10.715,4.35,11.06,4.305C10.7225,4.83,10.4375,5.205,10.2125,5.415C10.115,5.5125,9.995000000000001,5.5875,9.86,5.64L10.0625,6.345C10.7975,6.2625,11.57,6.0975,12.395,5.85L12.395,5.145C11.93,5.2875,11.4725,5.4,11.0225,5.49C11.45,4.9725,11.975,4.17,12.605,3.0825L11.9225,2.82C11.7725,3.0975,11.6225,3.36,11.4875,3.5999999999999996C11.225,3.6375,10.97,3.6675000000000004,10.715,3.6975C11.09,3.15,11.4575,2.4525,11.8175,1.6124999999999998L11.0675,1.3125Z",
      "fill": "url(#master_svg0_838_052666)",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$y = [];
const __vue2_script$y = defineComponent({
  name: "UpgradeIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$y = {};
var __component__$y = /* @__PURE__ */ normalizeComponent(
  __vue2_script$y,
  render$z,
  staticRenderFns$y,
  false,
  __vue2_injectStyles$y,
  null,
  null,
  null
);
function __vue2_injectStyles$y(context) {
  for (let o2 in __cssModules$y) {
    this[o2] = __cssModules$y[o2];
  }
}
var UpgradeIcon = /* @__PURE__ */ function() {
  return __component__$y.exports;
}();
const icons = {
  "dev": DevSeatIcon,
  "prototype": PrototypeSeatIcon,
  "edit": EditSeatIcon,
  "ai": AIIcon,
  "new": NewIcon,
  "upgrade": UpgradeIcon
};
function createBEM(blockName) {
  return {
    block() {
      return `${blockName}`;
    },
    element(elementName) {
      return `${blockName}__${elementName}`;
    },
    modifier(elementNameParam, modifierParam) {
      let elementName = elementNameParam;
      let modifier = modifierParam;
      if (!modifier) {
        modifier = elementName;
        elementName = "";
      }
      return elementName ? `${blockName}__${elementName}--${modifier}` : `${blockName}--${modifier}`;
    }
  };
}
const hyphenateRE = /\B([A-Z])/g;
const hyphenate = (str) => str.replace(hyphenateRE, "-$1").toLowerCase();
function getClassClac(name2) {
  const { block, element, modifier } = createBEM(hyphenate(name2));
  return {
    $b: block,
    $e: element,
    $m: modifier
  };
}
var render$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("button", {
    ref: "mButton",
    class: _vm.rootClass,
    style: {
      width: _vm.width ? _vm.width + "px" : _vm.padding ? "fit-content" : "100%",
      padding: `0 ${_vm.padding}px`
    },
    attrs: {
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    on: {
      "click": _vm.click
    }
  }, [!!_vm.icon ? _c("div", {
    class: _vm.$e("icon")
  }, [_c(_vm.icon, {
    tag: "component",
    attrs: {
      "size": _vm.iconSize
    }
  })], 1) : _vm._e(), _c("span", {
    class: _vm.$e("content")
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns$x = [];
var Button_vue_vue_type_style_index_0_lang = "";
const NAME = "MButton";
const { $b, $m, $e } = getClassClac(NAME);
const __vue2_script$x = defineComponent({
  name: NAME,
  props: {
    size: {
      type: String,
      default: "md"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "highlight"
    },
    width: {
      type: [Number, String],
      default: 0
    },
    padding: {
      type: [Number, String],
      default: 0
    },
    iconSize: {
      type: [Number, String],
      default: "14"
    },
    icon: {
      type: String,
      default: ""
    },
    asyncClick: {
      type: Function
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClass() {
      const { $b: $b2, $m: $m2, size, type: type2, disabled, round: round2, circle } = this;
      const cls = [$b2(), $m2(size), $m2(type2)];
      if (disabled)
        cls.push($m2("disabled"));
      if (round2)
        cls.push($m2("round"));
      if (circle)
        cls.push($m2("circle"));
      return cls;
    }
  },
  created() {
  },
  data() {
    return {
      isLock: false
    };
  },
  methods: {
    $b,
    $m,
    $e,
    async click(e2) {
      if (this.asyncClick) {
        if (this.isLock)
          return;
        this.isLock = true;
        try {
          await this.asyncClick();
        } catch (error) {
        } finally {
          this.isLock = false;
        }
      } else {
        this.$refs.mButton.blur();
        this.$emit("click", e2);
      }
    }
  }
});
const __cssModules$x = {};
var __component__$x = /* @__PURE__ */ normalizeComponent(
  __vue2_script$x,
  render$y,
  staticRenderFns$x,
  false,
  __vue2_injectStyles$x,
  null,
  null,
  null
);
function __vue2_injectStyles$x(context) {
  for (let o2 in __cssModules$x) {
    this[o2] = __cssModules$x[o2];
  }
}
var MVersionButton = /* @__PURE__ */ function() {
  return __component__$x.exports;
}();
var __vue2_script$w = defineComponent({
  name: "MgDialog",
  components: {
    CloseIcon,
    Button: MVersionButton
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    titleSize: {
      type: Number,
      default: 14
    },
    closable: {
      type: Boolean,
      default: true
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    okText: {
      type: String,
      default: "\u786E\u5B9A"
    },
    okBtnProps: {
      type: Object,
      default: () => ({})
    },
    cancelText: {
      type: String,
      default: "\u53D6\u6D88"
    },
    cancelBtnProps: {
      type: Object,
      default: () => ({})
    },
    maskClosable: {
      type: Boolean,
      default: false
    },
    mask: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: "360px"
    },
    visible: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
      default: Z_INDEX
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    }
  },
  emits: ["close", "okClick", "cancelClick", "update:visible"],
  setup(props2, { emit }) {
    const dialogRef = ref();
    const showVisible = computed(() => props2.visible);
    const dialogStyle = computed(() => ({
      "z-index": props2.zIndex
    }));
    const width = computed(() => props2.width || "360px");
    const titleSize = computed(() => props2.titleSize || 14);
    const title = computed(() => props2.title || "");
    const cancelText = computed(() => props2.cancelText || tFn("\u53D6\u6D88"));
    const cancelBtnProps = computed(() => props2.cancelBtnProps || {});
    const okText = computed(() => props2.okText || tFn("\u786E\u5B9A"));
    const okBtnProps = computed(() => props2.okBtnProps || {});
    const handleClose = () => {
      emit("close");
      emit("update:visible", false);
    };
    const handleMaskClose = () => {
      if (props2.maskClosable) {
        handleClose();
      }
    };
    const handleEscClose = (e2) => {
      if (props2.closeOnEsc && e2.key === "Escape") {
        handleClose();
      }
    };
    const handleCancelClick = () => {
      emit("cancelClick");
    };
    const handleOkClick = () => {
      emit("okClick");
    };
    const _updateElStatus = (status2) => {
      const el2 = dialogRef.value;
      if (!el2)
        return;
      try {
        if (status2) {
          document.body.appendChild(el2);
        } else {
          el2.remove();
        }
      } catch (error) {
        console.error(error);
      }
    };
    watch(showVisible, (val) => {
      _updateElStatus(val);
    });
    onMounted(() => {
      _updateElStatus(true);
      if (props2.closeOnEsc) {
        window.addEventListener("keydown", handleEscClose);
      }
    });
    onBeforeUnmount(() => {
      _updateElStatus(false);
      if (props2.closeOnEsc) {
        window.removeEventListener("keydown", handleEscClose);
      }
    });
    return {
      showVisible,
      width,
      titleSize,
      title,
      cancelText,
      cancelBtnProps,
      okText,
      okBtnProps,
      dialogRef,
      dialogStyle,
      handleClose,
      handleMaskClose,
      handleCancelClick,
      handleOkClick
    };
  }
});
var render$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showVisible,
      expression: "showVisible"
    }],
    ref: "dialogRef",
    staticClass: "dialog-mask",
    style: _vm.dialogStyle,
    on: {
      "click": _vm.handleMaskClose
    }
  }, [_c("div", {
    staticClass: "dialog",
    style: {
      width: _vm.width
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.showHeader ? _vm._t("header", function() {
    return [!_vm.$slots.header ? _c("div", {
      staticClass: "dialog__header"
    }, [_c("div", {
      staticClass: "dialog__title",
      style: {
        fontSize: `${_vm.titleSize}px`
      }
    }, [_vm._v(_vm._s(_vm.title))])]) : _vm._e()];
  }) : _vm._e(), _vm.closable ? _c("a", {
    staticClass: "dialog__close-button",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c("CloseIcon", {
    attrs: {
      "size": "16"
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "dialog__content"
  }, [_vm._t("default")], 2), _vm.showFooter ? _vm._t("footer", function() {
    return [!_vm.$slots.footer ? _c("div", {
      staticClass: "dialog__footer"
    }, [_vm.cancelText ? _c("Button", _vm._b({
      staticClass: "dialog__button",
      attrs: {
        "type": "outline"
      },
      on: {
        "click": _vm.handleCancelClick
      }
    }, "Button", _vm.cancelBtnProps, false), [_vm._v(_vm._s(_vm.cancelText))]) : _vm._e(), _vm.okText ? _c("Button", _vm._b({
      staticClass: "dialog__button dialog__button--primary",
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.handleOkClick
      }
    }, "Button", _vm.okBtnProps, false), [_vm._v(_vm._s(_vm.okText))]) : _vm._e()], 1) : _vm._e()];
  }) : _vm._e()], 2)]);
};
var staticRenderFns$w = [];
var Dialog_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent(
  __vue2_script$w,
  render$x,
  staticRenderFns$w,
  false,
  __vue2_injectStyles$w,
  "3fe212c7",
  null,
  null
);
function __vue2_injectStyles$w(context) {
  for (let o2 in __cssModules$w) {
    this[o2] = __cssModules$w[o2];
  }
}
var MVersionDialog = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
const logoutLoading = ref(false);
const useLogin = () => {
  const updateLogoutLoading = (value) => {
    logoutLoading.value = value;
  };
  const getLogoutLoading = () => {
    return logoutLoading;
  };
  const clearSessionStorage = (isClearAll = false) => {
    if (isClearAll) {
      clearSessionStorageItem();
      return;
    }
    SESSION_KEYS.SESSION_STORAGE_LOGOUT_KEYS.forEach((key) => {
      removeSessionStorageItem(key);
    });
  };
  const logout$1 = async (isClearAll = false) => {
    await logout();
    clearSessionStorage(isClearAll);
  };
  const getUserInfo2 = () => {
    return getLocalStorageItem(SESSION_KEYS.USER_INFO);
  };
  return {
    logout: logout$1,
    getLogoutLoading,
    updateLogoutLoading,
    getUserInfo: getUserInfo2
  };
};
var __vue2_script$v = defineComponent({
  name: "ResetConfirm",
  components: {
    Dialog: MVersionDialog,
    MVersionButton
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  emits: ["update:show"],
  setup(props2, { emit }) {
    const content = computed(() => {
      const { passwordResetInterval: passwordResetInterval2 } = usePubSetting().getPubConfig();
      return i18n.t("\u5F53\u524D\u4F01\u4E1A\u5DF2\u8BBE\u7F6E\u6BCF %{day} \u5929\u5F3A\u5236\u91CD\u7F6E\u5BC6\u7801\uFF0C\u8BF7\u4FEE\u6539\u5BC6\u7801\u5E76\u91CD\u65B0\u767B\u5F55\u3002", {
        day: passwordResetInterval2.value
      });
    });
    const updateShow = (value) => {
      emit("update:show", value);
    };
    const handleClose = () => {
      updateShow(false);
    };
    const handleOk = async () => {
      const { logout: logout2, updateLogoutLoading, getLogoutLoading, getUserInfo: getUserInfo2 } = useLogin();
      const { updateResetPasswordEmail, updateWillGoForgetPassword } = usePasswordReset();
      updateWillGoForgetPassword(true);
      const userInfo = getUserInfo2();
      if (userInfo == null ? void 0 : userInfo.email) {
        updateResetPasswordEmail(userInfo.email);
      }
      if (getLogoutLoading().value) {
        console.warn("logout is loading");
        return;
      }
      try {
        updateLogoutLoading(true);
        await logout2(true);
      } catch (error) {
        console.error("logout error: ", error);
      } finally {
        updateLogoutLoading(false);
      }
      const { toForgetPassword, getResetPasswordInfo, toHomePage } = usePasswordReset();
      const { resetPasswordEmail: resetPasswordEmail2 } = getResetPasswordInfo();
      updateShow(false);
      if (platformInfo().isElectron) {
        toHomePage();
        return;
      }
      toForgetPassword({
        email: resetPasswordEmail2.value,
        target: "_self"
      });
      setTimeout(() => {
        updateWillGoForgetPassword(false);
      }, 1e3);
    };
    return {
      $_t: i18n.t.bind(i18n),
      content,
      handleClose,
      handleOk
    };
  }
});
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("Dialog", {
    attrs: {
      "visible": _vm.show,
      "width": 400 + "px",
      "closable": false,
      "showHeader": false,
      "showFooter": false
    },
    on: {
      "close": _vm.handleClose
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return void 0;
      },
      proxy: true
    }, {
      key: "footer",
      fn: function() {
        return void 0;
      },
      proxy: true
    }])
  }, [_c("div", {
    staticClass: "reset-confirm"
  }, [_c("div", {
    staticClass: "reset-confirm__title"
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5BC6\u7801\u91CD\u7F6E")) + " ")]), _c("div", {
    staticClass: "reset-confirm__content"
  }, [_vm._v(" " + _vm._s(_vm.content) + " ")]), _c("div", {
    staticClass: "footer"
  }, [_c("ul", {
    staticClass: "buttons"
  }, [_c("li", {
    staticClass: "button-item"
  }, [_c("MVersionButton", {
    staticClass: "button-item-btn",
    attrs: {
      "type": "highlight",
      "size": "sm",
      "width": "76"
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.$_t("\u786E\u5B9A")))])], 1)])])])]);
};
var staticRenderFns$v = [];
var ResetConfirm_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent(
  __vue2_script$v,
  render$w,
  staticRenderFns$v,
  false,
  __vue2_injectStyles$v,
  "234592d8",
  null,
  null
);
function __vue2_injectStyles$v(context) {
  for (let o2 in __cssModules$v) {
    this[o2] = __cssModules$v[o2];
  }
}
var ResetConfirm = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
var render$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.featureLoading,
      expression: "!featureLoading"
    }],
    staticClass: "login-register__wrap",
    style: _vm.loginThemeStyle
  }, [_c("div", {
    class: {
      "login-register-container-dialog": _vm.isDialog,
      "login-register-container": !_vm.isDialog
    },
    on: {
      "mousedown": _vm.closeForModal
    }
  }, [_c("div", {
    class: {
      "login-register-wrap": !_vm.isDialog,
      "login-register-wrap-dialog": _vm.isDialog
    }
  }, [_c("div", {
    class: {
      "login-register-wrap-dialog__border": _vm.isDialog
    }
  }, [!_vm.showRealNamePhone ? _c("div", {
    staticClass: "login-types-wrap"
  }, [_c("div", {
    staticClass: "email-phone-wrap"
  }, [_vm.onlyLanhuLogin ? _c("div", {
    staticClass: "input-wrap"
  }, [_c("div", {
    staticClass: "login-register-title"
  }, [_vm._v(_vm._s(_vm.$_t("\u6B22\u8FCE\u56DE\u6765")))]), _c("div", {
    staticClass: "login-container"
  }, [_c("button", {
    staticClass: "normal-btn lanhu-logo",
    on: {
      "click": _vm.toLanhu
    }
  }, [_vm.isDarkTheme ? _c("LogoLanhuIcon") : _c("LogoLanhuIconLight", {
    attrs: {
      "size": "18"
    }
  })], 1), _c("button", {
    staticClass: "light-btn",
    on: {
      "click": _vm.toLanhu
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u524D\u5F80\u84DD\u6E56\u6388\u6743/\u767B\u9646")) + " ")]), _c("div", {
    staticClass: "text-btn-wrap"
  }, [_vm._v(_vm._s(_vm.$_t("\u60A8\u8FD8\u672A\u767B\u5F55\uFF0C\u60A8\u53EF\u901A\u8FC7\u84DD\u6E56\u767B\u5F55")))])])]) : _c("div", {
    staticClass: "input-wrap"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.title || _vm.dialogTitle,
      expression: "pageInit.title || dialogTitle"
    }],
    staticClass: "login-register-title"
  }, [_c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.showBack,
      expression: "pageInit.showBack"
    }],
    staticClass: "login-register-back",
    on: {
      "click": function($event) {
        return _vm.turnDialogType(_vm.originLoginType);
      }
    }
  }, [_c("ChevronLeftIcon", {
    attrs: {
      "size": "20"
    }
  })], 1), _vm.pageInit.dialogTitle ? _c("p", [_vm._v(_vm._s(_vm.dialogTitle))]) : _c("p", [_vm._v(_vm._s(_vm.pageInit.title))]), _vm.allowCloseDialog && _vm.targetLoginType !== "setPassword" ? _c("span", {
    staticClass: "login-register-close",
    on: {
      "click": function($event) {
        return _vm.closeDialog($event);
      }
    }
  }, [_c("WindowsCloseIcon", {
    attrs: {
      "size": "20px"
    }
  })], 1) : _vm._e()]), _vm.showRegisterTab ? _c("div", {
    staticClass: "login-register-tab"
  }, [_vm.showEmailVerifyRegister ? _c("div", {
    class: {
      active: _vm.registerType === "code"
    },
    on: {
      "click": function($event) {
        return _vm.changeRegisterType("code");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u9A8C\u8BC1\u7801\u6CE8\u518C")) + " ")]) : _vm._e(), _vm.showPasswordRegister ? _c("div", {
    class: {
      active: _vm.registerType === "password"
    },
    on: {
      "click": function($event) {
        return _vm.changeRegisterType("password");
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5BC6\u7801\u6CE8\u518C")) + " ")]) : _vm._e()]) : _vm._e(), (_vm.isEnableThirdPartLogin || !_vm.IS_PRI) && _vm.targetLoginType !== "sso" && _vm.targetLoginType !== "setPassword" && _vm.targetLoginType !== "wecom" && !_vm.disableOptions.mirrorDisabled ? _c("ThirdPartLogin", {
    attrs: {
      "redirectUri": _vm.redirectUri,
      "googleOptions": _vm.configs.googleOptions,
      "disableOptions": _vm.disableOptions,
      "isReceiveMail": _vm.policy
    },
    on: {
      "log": _vm.sendLog,
      "onThirdPartBtnClick": _vm.onThirdPartLoginBtnClick,
      "setUserInfo": _vm.setUserInfo
    }
  }) : _vm._e(), _vm.pageInit.firstLogin ? _c("div", {
    staticClass: "text-btn-wrap align-left",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u4E3A\u4E86\u60A8\u7684\u8D26\u53F7\u5B89\u5168\uFF0C\u8BF7\u4E3A %{account} \u8D26\u53F7\u8BBE\u7F6E\u5BC6\u7801", {
    account: _vm.account
  })) + " ")]) : _vm._e(), _vm.pageInit.inputPlaceholder ? _c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.account,
      expression: "account"
    }],
    staticClass: "text-input phone-mail",
    class: {
      "error-border": _vm.accountError || _vm.accountErrorBorder,
      "error-border-i18n": (_vm.accountError || _vm.accountErrorBorder) && _vm.isI18N
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.pageInit.inputPlaceholder
    },
    domProps: {
      "value": _vm.account
    },
    on: {
      "keyup": _vm.onAccountChange,
      "change": _vm.checkAccount,
      "input": function($event) {
        if ($event.target.composing)
          return;
        _vm.account = $event.target.value;
      }
    }
  }) : _vm._e(), !_vm.isOneBtnLogin && _vm.accountError ? _c("div", {
    staticClass: "error",
    class: {
      "error-i18n": _vm.isI18N
    }
  }, [_c("WarningIcon", {
    staticStyle: {
      "flex-shrink": "0",
      "margin-top": "5px",
      "align-self": "flex-start"
    },
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.accountError))])], 1) : _vm._e(), _c("input", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.showLocalPhone,
      expression: "pageInit.showLocalPhone"
    }, {
      name: "model",
      rawName: "v-model",
      value: _vm.localPhone,
      expression: "localPhone"
    }],
    staticClass: "text-input one-btn",
    class: {
      "error-border": _vm.oneBtnPhoneError,
      "error-border-i18n": _vm.isI18N && _vm.oneBtnPhoneError,
      "no-text-input": !_vm.localPhone
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$_t("\u8BF7\u8F93\u5165\u672C\u673A\u53F7\u7801")
    },
    domProps: {
      "value": _vm.localPhone
    },
    on: {
      "input": function($event) {
        if ($event.target.composing)
          return;
        _vm.localPhone = $event.target.value;
      }
    }
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOneBtnLogin && _vm.oneBtnPhoneError,
      expression: "isOneBtnLogin && oneBtnPhoneError"
    }],
    staticClass: "error local-phone-error",
    class: {
      "error-i18n": _vm.isI18N
    }
  }, [_c("WarningIcon", {
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.oneBtnPhoneError))])], 1), _vm.pageInit.showPassword ? _c("PasswordInput", {
    attrs: {
      "placeholder": _vm.pageInit.passwordPlaceholder || _vm.$_t("\u5BC6\u7801"),
      "error": _vm.passwordError,
      "isI18N": _vm.isI18N
    },
    on: {
      "change": _vm.passwordChange
    },
    model: {
      value: _vm.password,
      callback: function($$v) {
        _vm.password = $$v;
      },
      expression: "password"
    }
  }) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.IS_PRI && _vm.needCaptchaCode && _vm.targetLoginType === "login",
      expression: "IS_PRI && needCaptchaCode && targetLoginType === 'login'"
    }],
    staticClass: "captcha-wrap"
  }, [_c("div", {
    staticClass: "captcha-code"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.captchaCode,
      expression: "captchaCode"
    }],
    staticClass: "text-input verification-code",
    class: {
      "error-border": _vm.captchaCodeError,
      "error-border-i18n": _vm.isI18N && _vm.captchaCodeError
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$_t("\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801"),
      "maxlength": "6"
    },
    domProps: {
      "value": _vm.captchaCode
    },
    on: {
      "input": function($event) {
        if ($event.target.composing)
          return;
        _vm.captchaCode = $event.target.value;
      }
    }
  })]), _c("div", {
    staticClass: "captcha-code-btn",
    on: {
      "click": _vm.handleGetSigninCaptcha
    }
  }, [_c("img", {
    attrs: {
      "src": _vm.captchaCodeUrl,
      "alt": "\u56FE\u5F62\u9A8C\u8BC1\u7801"
    }
  })])]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.IS_PRI && _vm.needCaptchaCode && _vm.targetLoginType === "login" && _vm.captchaCodeError,
      expression: "IS_PRI && needCaptchaCode && targetLoginType === 'login' && captchaCodeError"
    }],
    staticClass: "error",
    class: {
      "error-i18n": _vm.isI18N
    }
  }, [_c("WarningIcon", {
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.captchaCodeError))])], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.showCode,
      expression: "pageInit.showCode"
    }],
    staticClass: "register-container"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.targetLoginType === "code" || _vm.targetLoginType === "register" && _vm.registerType !== "password",
      expression: "\n                    targetLoginType === 'code' || (targetLoginType === 'register' && registerType !== 'password')\n                  "
    }],
    staticClass: "register-wrap"
  }, [_c("div", {
    staticClass: "register-code"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.verificationCode,
      expression: "verificationCode"
    }],
    staticClass: "text-input verification-code",
    class: {
      "error-border": _vm.codeError,
      "error-border-i18n": _vm.isI18N && _vm.codeError
    },
    attrs: {
      "type": "tel",
      "placeholder": _vm.$_t("\u9A8C\u8BC1\u7801"),
      "maxlength": "6"
    },
    domProps: {
      "value": _vm.verificationCode
    },
    on: {
      "input": function($event) {
        if ($event.target.composing)
          return;
        _vm.verificationCode = $event.target.value;
      }
    }
  })]), _c("div", {
    staticClass: "register-code-btn"
  }, [_c("button", {
    staticClass: "normal-btn",
    attrs: {
      "disabled": !!_vm.process
    },
    on: {
      "click": _vm.sendVerificationCode
    }
  }, [_vm._v(" " + _vm._s(_vm.process ? _vm.$_t("%{process} \u79D2", {
    process: _vm.process
  }) : _vm.$_t("\u83B7\u53D6\u9A8C\u8BC1\u7801")) + " ")])])]), _vm.showPasswordInput ? _c("PasswordInput", {
    attrs: {
      "placeholder": _vm.passwordPlaceholder,
      "error": _vm.passwordError,
      "isI18N": _vm.isI18N
    },
    on: {
      "change": _vm.passwordChange
    },
    model: {
      value: _vm.password1,
      callback: function($$v) {
        _vm.password1 = $$v;
      },
      expression: "password1"
    }
  }) : _vm._e(), _vm.showPasswordInput ? _c("PasswordInput", {
    attrs: {
      "placeholder": _vm.$_t("\u8BF7\u518D\u6B21\u786E\u8BA4\u5BC6\u7801"),
      "error": _vm.password2Error,
      "isI18N": _vm.isI18N
    },
    on: {
      "change": _vm.password2Change
    },
    model: {
      value: _vm.password2,
      callback: function($$v) {
        _vm.password2 = $$v;
      },
      expression: "password2"
    }
  }) : _vm._e(), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.codeError,
      expression: "codeError"
    }],
    staticClass: "error",
    class: {
      "error-i18n": _vm.isI18N
    }
  }, [_c("WarningIcon", {
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.codeError))])], 1)], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.showCode && _vm.isEnableCodeCaptcha,
      expression: "pageInit.showCode && isEnableCodeCaptcha"
    }],
    staticClass: "captcha-wrap"
  }, [_c("div", {
    staticClass: "captcha-code"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.captchaCode,
      expression: "captchaCode"
    }],
    staticClass: "text-input verification-code",
    class: {
      "error-border": _vm.captchaCodeError,
      "error-border-i18n": _vm.isI18N && _vm.captchaCodeError
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$_t("\u8BF7\u8F93\u5165\u56FE\u5F62\u9A8C\u8BC1\u7801"),
      "maxlength": "6"
    },
    domProps: {
      "value": _vm.captchaCode
    },
    on: {
      "input": function($event) {
        if ($event.target.composing)
          return;
        _vm.captchaCode = $event.target.value;
      }
    }
  })]), _c("div", {
    staticClass: "captcha-code-btn",
    on: {
      "click": _vm.handleGetSigninCaptcha
    }
  }, [_c("img", {
    attrs: {
      "src": _vm.captchaCodeUrl,
      "alt": "\u56FE\u5F62\u9A8C\u8BC1\u7801"
    }
  })])]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.showCode && _vm.captchaCodeError,
      expression: "pageInit.showCode && captchaCodeError"
    }],
    staticClass: "error",
    class: {
      "error-i18n": _vm.isI18N
    }
  }, [_c("WarningIcon", {
    attrs: {
      "size": "12"
    }
  }), _c("span", [_vm._v(_vm._s(_vm.captchaCodeError))])], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.needPolicy,
      expression: "needPolicy"
    }],
    staticClass: "text-btn-wrap policy-container",
    class: {
      "local-policy": _vm.isOneBtnLogin,
      "hide-policy": _vm.isOneBtnLogin && (_vm.localPhone.length !== 11 || _vm.oneBtnPhoneError),
      "register-no-policy-label": _vm.registerNoPolicy,
      "is-en-us": _vm.isEnUS
    },
    on: {
      "animationend": _vm.registerNoPolicyEnd
    }
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.policy,
      expression: "policy"
    }, {
      name: "show",
      rawName: "v-show",
      value: _vm.policy,
      expression: "policy"
    }],
    attrs: {
      "type": "checkbox",
      "id": "policy"
    },
    domProps: {
      "checked": Array.isArray(_vm.policy) ? _vm._i(_vm.policy, null) > -1 : _vm.policy
    },
    on: {
      "change": function($event) {
        var $$a = _vm.policy, $$el = $event.target, $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null, $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.policy = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.policy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.policy = $$c;
        }
      }
    }
  }), _c("label", {
    attrs: {
      "for": "policy"
    }
  }, [_c("CheckedBox", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.policy,
      expression: "policy"
    }],
    staticClass: "policy-checked",
    attrs: {
      "size": "14px",
      "fill": "var(--mg-color-bg-brand)"
    }
  }), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.policy,
      expression: "!policy"
    }],
    staticClass: "label-check"
  }), _c("span", [_vm._v(_vm._s(_vm.$_t("\u6211\u5DF2\u9605\u8BFB\u5E76\u540C\u610F")))])], 1), !_vm.isI18N ? [_c("a", {
    staticClass: "text-btn",
    class: {
      "ml-12": _vm.isEnUS
    },
    attrs: {
      "rel": "noopener noreferrer",
      "target": _vm.isMirror() ? "_self" : "_blank",
      "href": "/serviceAgreement"
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u670D\u52A1\u534F\u8BAE")) + " ")]), _vm._v(" " + _vm._s(_vm.$_t("\u548C")) + " "), _c("a", {
    staticClass: "text-btn",
    attrs: {
      "rel": "noopener noreferrer",
      "target": _vm.isMirror() ? "_self" : "_blank",
      "href": "/privacyPolicy"
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u9690\u79C1\u534F\u8BAE")) + " ")])] : _vm._e()], 2), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.buttonText,
      expression: "pageInit.buttonText"
    }],
    staticClass: "login-btn",
    class: {
      "local-phone-btn": _vm.targetLoginType === "oneBtn",
      withoutPolicy: _vm.IS_PRI
    },
    on: {
      "click": _vm.buttonClick
    }
  }, [_c("button", {
    ref: _vm.loginBtn,
    staticClass: "light-btn",
    class: (_vm.isOneBtnLogin && _vm.oneLoginBtnStatus === 2 && "light-btn-pressing", {
      "light-btn-i18n": _vm.isI18N
    })
  }, [_vm._v(" " + _vm._s(_vm.pageInit.buttonText) + " ")])]), _vm.isOneBtnLogin && _vm.oneLoginBtnStatus === 3 ? _c("div", {
    staticClass: "one-btn-login-success"
  }, [_c("CheckedBlueIcon", {
    staticClass: "success-icon"
  })], 1) : _vm._e(), _vm.pageInit.showFollowWeChat ? _c("WeChatQrCode", {
    staticClass: "column-code",
    attrs: {
      "isLogin": _vm.isLogin,
      "experimentInfo": true,
      "text": _vm.pageInit.text,
      "redirectUri": _vm.redirectUri
    },
    on: {
      "wechat": _vm.wechatLoginMethod,
      "log": _vm.sendLog
    }
  }) : _vm._e(), _vm.pageInit.showWecomQrCode ? _c("WecomQrCode", {
    staticClass: "column-code",
    attrs: {
      "redirectUri": _vm.redirectUri
    },
    on: {
      "wecom": _vm.wecomLoginMethod,
      "log": _vm.sendLog
    }
  }) : _vm._e()], 1), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isOnlySsoLogin2 && _vm.targetLoginType !== "setPassword" && !_vm.onlyLanhuLogin,
      expression: "!isOnlySsoLogin2 && targetLoginType !== 'setPassword' && !onlyLanhuLogin"
    }],
    staticClass: "operations-wrap"
  }, [_vm.isI18N && _vm.targetLoginType === "register" ? _c("div", {
    staticClass: "text-btn-wrap"
  }, [_c("span", {
    staticClass: "text-btn-label",
    class: {
      "text-btn-label-i18n": _vm.isI18N
    }
  }, [_vm._v(' By clicking "Create account" or "Continue with Google", you agree to the Creatie '), _c("a", {
    staticClass: "text-btn",
    attrs: {
      "rel": "noopener noreferrer",
      "target": _vm.isMirror() ? "_self" : "_blank",
      "href": "/service-agreement"
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u670D\u52A1\u534F\u8BAE")) + " ")]), _vm._v(" " + _vm._s(_vm.$_t("\u548C")) + " "), _c("a", {
    staticClass: "text-btn",
    attrs: {
      "rel": "noopener noreferrer",
      "target": _vm.isMirror() ? "_self" : "_blank",
      "href": "/privacy-policy"
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u9690\u79C1\u534F\u8BAE")) + ". ")])])]) : _vm._e(), _vm.isI18N && _vm.pageInit.forgetPassword ? _c("div", {
    staticClass: "text-btn-wrap-i18n"
  }, [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.forgetPassword,
      expression: "pageInit.forgetPassword"
    }],
    staticClass: "text-btn-wrap"
  }, [_c("span", {
    staticClass: "text-btn",
    class: {
      "text-btn-i18n": _vm.isI18N
    },
    on: {
      "click": _vm.forgetPassword
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5FD8\u8BB0\u5BC6\u7801")) + " ")])]), _c("div", {
    staticClass: "text-btn-wrap"
  }, [_vm._l(_vm.loginStyle, function(item, index2) {
    return [index2 > 0 ? _c("span", {
      staticStyle: {
        "color": "var(--color-tran-18)"
      }
    }, [_vm._v("|")]) : _vm._e(), _c("span", {
      staticClass: "text-btn",
      class: {
        "text-btn-i18n": _vm.isI18N
      },
      on: {
        "click": function($event) {
          return _vm.turnDialogType(item.code);
        }
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")])];
  })], 2)]) : [_c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.forgetPassword,
      expression: "pageInit.forgetPassword"
    }],
    staticClass: "text-btn-wrap"
  }, [_c("span", {
    staticClass: "text-btn",
    class: {
      "text-btn-i18n": _vm.isI18N
    },
    on: {
      "click": _vm.forgetPassword
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5FD8\u8BB0\u5BC6\u7801")) + " ")])]), _c("div", {
    staticClass: "text-btn-wrap"
  }, [_vm._l(_vm.loginStyle, function(item, index2) {
    return [index2 > 0 ? _c("span", {
      staticStyle: {
        "color": "var(--color-tran-18)"
      }
    }, [_vm._v("|")]) : _vm._e(), _c("span", {
      staticClass: "text-btn",
      class: {
        "text-btn-i18n": _vm.isI18N
      },
      on: {
        "click": function($event) {
          return _vm.turnDialogType(item.code);
        }
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")])];
  })], 2)], _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.showNotOneBtnLogin,
      expression: "pageInit.showNotOneBtnLogin"
    }],
    staticClass: "text-btn-wrap"
  }, [_c("span", {
    staticClass: "text-btn",
    on: {
      "click": _vm.turnOriginLogin
    }
  }, [_vm._v(_vm._s(_vm.$_t("\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F")))])]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.noRegister && _vm.openUserRegister && !_vm.disableOptions.mirrorDisabled,
      expression: "pageInit.noRegister && openUserRegister && !disableOptions.mirrorDisabled"
    }],
    staticClass: "text-btn-wrap"
  }, [_c("span", {
    staticClass: "text-btn-label"
  }, [_vm._v(_vm._s(_vm.$_t("\u8FD8\u6CA1\u6709\u8D26\u53F7?")))]), _c("span", {
    staticClass: "text-btn",
    on: {
      "click": function($event) {
        return _vm.turnDialogType("register");
      }
    }
  }, [_vm._v(_vm._s(_vm.$_t("\u524D\u5F80\u6CE8\u518C")))])]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.pageInit.hasAccount,
      expression: "pageInit.hasAccount"
    }],
    staticClass: "text-btn-wrap",
    class: {
      "mb-16": _vm.isI18N
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u5DF2\u6709\u8D26\u53F7?")) + " "), _c("span", {
    staticClass: "text-btn",
    on: {
      "click": _vm.turnOriginLogin
    }
  }, [_vm._v(_vm._s(_vm.$_t("\u7ACB\u5373\u767B\u5F55")))])]), ["code", "login", "register"].includes(_vm.targetLoginType) && !_vm.isI18N ? _c("div", [_c("WechatDialog", {
    on: {
      "loginEnd": _vm.weiXinLoginEnd
    }
  })], 1) : _vm._e()], 2)])]) : _vm._e(), _vm.showReloadConfirm ? _c("div", {
    staticClass: "reload-confirm"
  }, [_c("div", {
    staticClass: "reload-confirm_content",
    style: {
      marginTop: _vm.dialogContentTop + "px"
    }
  }, [_c("div", {
    staticClass: "reload-confirm_content-title"
  }, [_c("ErrorRedBorderIcon", {
    staticClass: "reload-confirm_error-icon"
  }), _c("span", {
    staticClass: "reload-confirm_error-text"
  }, [_vm._v(_vm._s(_vm.$_t("\u7F51\u7EDC\u72B6\u51B5\u53D1\u751F\u53D8\u5316\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u540E\u91CD\u8BD5\u3002")))])], 1), _c("div", {
    staticClass: "login-btn reload-confirm_btn",
    on: {
      "click": _vm.reloadPage
    }
  }, [_c("button", {
    staticClass: "light-btn"
  }, [_vm._v(_vm._s(_vm.$_t("\u5237\u65B0")))])])])]) : _vm._e(), _vm.showRealNamePhone ? _c("RealNamePhone", {
    attrs: {
      "userInfo": _vm.userInfo,
      "sendLog": _vm.sendLog
    },
    on: {
      "bindSuccess": _vm.bindSuccess,
      "back": _vm.cancelBindAuthPhone,
      "toast": _vm.onToast
    }
  }) : _vm._e()], 1)])]), _vm.showPrivacy ? _c("app-privacy", {
    on: {
      "privacyStatus": _vm.privacyStatus
    }
  }) : _vm._e(), _vm.showResetConfirm ? _c("ResetConfirm", {
    attrs: {
      "show": _vm.showResetConfirm
    },
    on: {
      "close": function($event) {
        return _vm.updateShowResetConfirm(false);
      }
    }
  }) : _vm._e()], 1);
};
var staticRenderFns$u = [];
var index_vue_vue_type_style_index_0_lang = "";
var index_vue_vue_type_style_index_1_scoped_true_lang = "";
const __vue2_script$u = {
  name: "MLogin",
  components: {
    ThirdPartLogin,
    WeChatQrCode,
    WecomQrCode,
    ChevronLeftIcon,
    WarningIcon,
    WindowsCloseIcon,
    ErrorRedBorderIcon,
    WechatDialog,
    RealNamePhone,
    AppPrivacy,
    CheckedBox,
    LogoLanhuIcon,
    LogoLanhuIconLight,
    PasswordInput,
    ResetConfirm
  },
  props: {
    allowCloseDialog: {
      type: Boolean,
      default: false
    },
    redirectUri: {
      type: String,
      default: "files/home?lastPath=login&connect_redirect=1"
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: ""
    },
    targetType: {
      type: String,
      default: "login"
    },
    actionData: {
      type: Object,
      default: () => ({
        actionDetail: null,
        actionPosition: "masterWeb",
        actionType: "",
        appVersion: ""
      })
    },
    disableOptions: {
      type: Object,
      default: () => ({
        thirdPartLogin: false,
        lanhu: false,
        wechat: false,
        dingding: false,
        google: true,
        mirrorDisabled: false,
        linkedin: true,
        wecom: false
      })
    },
    configs: {
      type: Object,
      default: () => ({
        isRequiredLoginMethod: false,
        loginTheme: null,
        googleOptions: {
          clientId: "",
          loginCallback: () => {
          }
        }
      })
    }
  },
  emits: ["turnType", "setUserInfo", "refreshPassword", "close", "toast", "onThirdPartBtnClick", "savePrivacyStatus"],
  setup(props2, { emit }) {
    const themeColor = ref(getThemeColor());
    const isDarkTheme = computed(() => themeColor.value === ThemeColor.Dark);
    let defaultLogin = "login";
    if (isMobile()) {
      defaultLogin = "code";
    } else if (isOnlySsoLogin()) {
      defaultLogin = "sso";
    }
    const account = ref("");
    const localPhone = ref("");
    const password = ref("");
    const password1 = ref("");
    const password2 = ref("");
    const verificationCode = ref("");
    const needCaptchaCode = ref(false);
    const captchaCode = ref("");
    const captchaCodeId = ref("");
    const captchaCodeUrl = ref("");
    const policy = ref(false);
    const registerNoPolicy = ref(false);
    const process2 = ref(0);
    const originLoginType = ref(defaultLogin);
    const targetLoginType = ref(defaultLogin);
    const eyeStatus = ref(true);
    const accountError = ref("");
    const accountErrorBorder = ref(false);
    const passwordError = ref("");
    const password2Error = ref("");
    const captchaCodeError = ref("");
    const codeError = ref("");
    const featureLoading = ref(true);
    const oneBtnPhoneError = ref("");
    const oneLoginBtnStatus = ref(oneBtnStatus.ON_INPUT);
    const showReloadConfirm = ref(false);
    const hasOneBtnLogin = ref(false);
    const dialogContentTop = ref(226);
    const loginBtn = ref(null);
    const userInfo = ref(null);
    const isMobile2 = ref(isMobile());
    const isOnlySsoLogin2 = ref(isOnlySsoLogin());
    const showPrivacy = ref(false);
    const buttonDisabled = ref(false);
    const verificationButtonDisabled = ref(false);
    const showRealNamePhone = ref(false);
    const loginSuccessCb = ref(() => {
    });
    const { getResetPasswordInfo, updateShowResetConfirm, updateResetPasswordEmail } = usePasswordReset();
    if (isDebug()) {
      window.updateShowResetConfirm = updateShowResetConfirm;
    }
    const { showResetConfirm: showResetConfirm2 } = getResetPasswordInfo();
    const _hideSSO = computed(() => props2.configs.hideSSO);
    const passwordPlaceholder = computed(() => getPasswordPlaceholder());
    const { loginThemeStyle, loginTitle, hasTheme, hideSSO } = createLoginTheme(props2.configs.loginTheme);
    const roleReg = {
      phone: /^1[3456789]\d{9}$/,
      email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
      verificationCode: /^.{6}$/
    };
    const listener = ref(null);
    const formData = reactive({});
    const titleMap = computed(() => {
      return {
        register: i18n.t("\u6CE8\u518C\u65B0\u8D26\u53F7"),
        login: loginTitle.value || i18n.t("\u6B22\u8FCE\u56DE\u6765"),
        code: loginTitle.value || i18n.t("\u6B22\u8FCE\u56DE\u6765"),
        oneBtn: i18n.t("\u4E00\u952E\u767B\u5F55"),
        sso: i18n.t("SSO\u767B\u5F55"),
        followWeChat: i18n.t("\u5FAE\u4FE1\u767B\u5F55"),
        wecom: i18n.t("\u4F01\u4E1A\u5FAE\u4FE1\u626B\u7801\u767B\u5F55"),
        wechat: i18n.t("\u5FAE\u4FE1\u626B\u7801\u6CE8\u518C"),
        setPassword: i18n.t("\u8BBE\u7F6E\u5BC6\u7801")
      };
    });
    const loginStyle = computed(() => {
      const list = [];
      if (pageInit.value.showOneBtnLogin) {
        list.push({ code: "oneBtn", text: i18n.t("\u624B\u673A\u53F7\u4E00\u952E\u767B\u5F55") });
      }
      if (pageInit.value.showPasswordLoginBtn) {
        list.push({ code: "login", text: i18n.t("\u5BC6\u7801\u767B\u5F55") });
      }
      if (pageInit.value.showCodeLoginBtn) {
        list.push({ code: "code", text: i18n.t("\u9A8C\u8BC1\u7801\u767B\u5F55") });
      }
      if (pageInit.value.showSSOBtn) {
        list.push({ code: "sso", text: i18n.t("SSO\u767B\u5F55") });
      }
      return list;
    });
    const title = computed(() => titleMap.value[targetLoginType.value]);
    const randomNum = getUrlValue$1(SESSION_KEYS.RANDOM_NUM, getSessionStorageItem$1("appAuth") || "");
    const basePointForBackend = {
      app_version: props2.actionData.appVersion,
      app: isMirror$1() ? "mirror_app" : randomNum ? "masterdesktop" : "masterweb",
      position: `${props2.actionData.actionPosition || ""}+${window.location.pathname}`
    };
    const IS_PRI = computed(() => props2.configs.isRequiredLoginMethod);
    const { updatePri, initPubConfig, updateRegisterType, getPubConfig } = usePubSetting();
    const {
      onlyLanhuLogin: onlyLanhuLogin2,
      lanhuHost: lanhuHost2,
      openUserRegister: openUserRegister2,
      openUserRegisterType: openUserRegisterType2,
      smtpConfigured: smtpConfigured2,
      organizationEmail: organizationEmail2,
      allowPublicEmail: allowPublicEmail2,
      registerType: registerType2,
      showPasswordRegister: showPasswordRegister2,
      showEmailVerifyRegister: showEmailVerifyRegister2
    } = getPubConfig();
    updatePri(IS_PRI.value);
    const showRegisterTab = computed(() => {
      return pageInit.value.hasAccount && openUserRegister2.value && smtpConfigured2.value && openUserRegisterType2.value.length > 1;
    });
    const showPasswordInput = computed(() => {
      const isRegisterPassword = registerType2.value === "password";
      return IS_PRI.value && pageInit.value.hasAccount && isRegisterPassword;
    });
    const { proxy } = getCurrentInstance();
    const isI18N = computed(() => proxy.isI18N);
    onMounted(async () => {
      getEnableThirdPartLogin();
      getEnableCodeCaptcha();
      handleGetSigninCaptcha();
      if (props2.configs.isRequiredLoginMethod) {
        await getLoginStatus();
      }
      const code = getSessionStorageItem$1(SESSION_KEYS.SAML_CODE);
      if (code) {
        removeSessionStorageItem(SESSION_KEYS.SAML_CODE);
        if (samlErrCode[code]) {
          emit("toast", {
            content: samlErrCode[code],
            timeout: 3e3,
            position: "top"
          });
        } else {
          emit("toast", {
            content: accountErrorCode.saml,
            timeout: 3e3,
            position: "top"
          });
        }
      }
      sendLog2(SensorsType.SHOW_LOGIN, {
        action_parameter9: randomNum
      });
      if (isMobile2.value && !platformInfo().isWeiXin) {
        const meta = window.document.createElement("meta");
        meta.setAttribute("name", "referrer");
        meta.setAttribute("content", "origin");
        window.document.head.appendChild(meta);
      }
      if (props2.targetType && !IS_PRI.value) {
        turnDialogType(props2.targetType);
      }
      nextTick(() => {
        listener.value = (ev) => {
          if (ev.keyCode === 13) {
            buttonClick();
          }
        };
        window.addEventListener("keyup", listener.value);
      });
      if (props2.isDialog) {
        sendLog2(SensorsType.LOGIN_POPOUT_LOAD, {
          url_name: window.location.pathname
        });
      }
      await getPageInitData();
      nextTick(() => {
        const mirrorVersion = getMirrorVersion();
        if (props2.disableOptions.showPrivacy && isMirror$1() && mirrorVersion && semver.gte(mirrorVersion, "1.1.5")) {
          showPrivacy.value = true;
        }
      });
      if (isOnlySsoLogin2.value) {
        turnDialogType("sso");
      }
      if (location.href.includes("realNameAuth=true")) {
        const cb = async (data2) => {
          try {
            emit("setUserInfo", data2);
          } catch (e2) {
            console.error(e2);
            emit("toast", {
              content: e2.message || i18n.t("\u672A\u77E5\u9519\u8BEF"),
              timeout: 3e3,
              position: "top"
            });
          }
        };
        showRealNamePhone.value = true;
        loginSuccessCb.value = cb;
      }
    });
    const changeRegisterType = (type2) => {
      initErrors();
      updateRegisterType(type2);
    };
    const privacyStatus = (status2) => {
      showPrivacy.value = false;
      emit("savePrivacyStatus", status2);
      if (status2) {
        policy.value = true;
      }
    };
    async function getLoginStatus() {
      try {
        const { smtpConfigured: smtpConfigured3 } = await initPubConfig();
        if (smtpConfigured3.value) {
          turnDialogType("code");
        }
      } catch (e2) {
        console.log("getLoginStatus error", e2);
        return;
      }
      const message = await loginByThirdCode();
      if (message) {
        emit("toast", {
          content: message,
          timeout: 3e3,
          position: "top"
        });
      }
    }
    const weiXinLoginEnd = (error, data2) => {
      if (error)
        return;
      emit("setUserInfo", data2);
    };
    watchEffect(() => {
      if (isI18N.value) {
        policy.value = true;
      }
    });
    watch(account, (val, oldVal) => {
      if (val !== oldVal) {
        accountError.value = "";
        accountErrorBorder.value = false;
      }
      updateResetPasswordEmail(val);
    });
    watch(localPhone, (val, oldVal) => {
      if (/\D/.test(val) || val.length > 11) {
        localPhone.value = oldVal;
        return;
      }
      if (val !== oldVal) {
        oneBtnPhoneError.value = "";
      }
    });
    watch(password, (val, oldVal) => {
      if (val !== oldVal) {
        codeError.value = "";
      }
      passwordError.value = "";
    });
    watch(password1, () => {
      passwordError.value = "";
    });
    watch(password2, () => {
      password2Error.value = "";
    });
    watch(verificationCode, (val, oldVal) => {
      if (val !== oldVal) {
        codeError.value = "";
      }
    });
    watch(
      () => props2.targetType,
      (val) => {
        turnDialogType(val);
      }
    );
    const passwordChange = () => {
      const priFlag = IS_PRI.value && targetLoginType.value === "register" && registerType2.value === "password";
      const isSetPassword = targetLoginType.value === "setPassword";
      if (priFlag || isSetPassword) {
        let passVal = password1.value;
        if (isSetPassword) {
          passVal = password.value;
        }
        if ((passVal == null ? void 0 : passVal.length) > PASSWORD_MAX_LENGTH) {
          passwordError.value = PasswordError.value.passwordMaxLengthError;
          return false;
        }
        if (!validatePassword(passVal)) {
          passwordError.value = passwordPlaceholder.value;
          return false;
        } else {
          passwordError.value = "";
          return true;
        }
      } else {
        return true;
      }
    };
    const password2Change = () => {
      if (password1.value !== password2.value) {
        password2Error.value = i18n.t("\u4E24\u6B21\u5BC6\u7801\u8F93\u5165\u4E0D\u4E00\u81F4\uFF0C\u8BF7\u786E\u8BA4\u540E\u91CD\u65B0\u8F93\u5165");
        return false;
      } else {
        password2Error.value = "";
        return true;
      }
    };
    const isLogin = computed(() => {
      return ["code", "login"].includes(props2.targetType);
    });
    const closeDialog = () => {
      emit("close");
    };
    const closeForModal = (ev) => {
      if (`${ev.target.className}`.indexOf("login-register-container") === -1) {
        return;
      }
      if (!props2.isDialog || !props2.allowCloseDialog) {
        return;
      }
      closeDialog();
    };
    const wecomLoginMethod = async (code = "") => {
      await wecomLoginMethodFn({
        emit,
        params: {
          code,
          ...basePointForBackend
        }
      });
    };
    const wechatLoginMethod = async (code = "") => {
      await wechatLoginMethodFn({
        params: {
          code,
          ...basePointForBackend
        },
        emit,
        isPri: IS_PRI.value,
        callback: ({ showRealNamePhone: _showRealNamePhone, successCallback }) => {
          showRealNamePhone.value = _showRealNamePhone;
          loginSuccessCb.value = successCallback;
        }
      });
    };
    const initPassword = async () => {
      try {
        await initpassword({
          password: password.value
        });
      } catch {
      }
      emit("refreshPassword", {
        userState: 1
      });
      emit("setUserInfo", { ...userInfo.value, userState: 1 });
    };
    function initErrors() {
      passwordError.value = "";
      password2Error.value = "";
      codeError.value = "";
      accountError.value = "";
      captchaCodeError.value = "";
      accountErrorBorder.value = false;
      oneBtnPhoneError.value = "";
    }
    function setTitle2(title2 = "") {
      if (!props2.isDialog) {
        document.title = title2;
      }
    }
    function onThirdPartLoginBtnClick(thirdPartType) {
      sendLog2(SensorsType.CLICK_LOGIN_BTN, {
        action_type: "wechat"
      });
      if (!!(window == null ? void 0 : window.flutter_inappwebview)) {
        emit("onThirdPartBtnClick", { thirdPartType });
      } else {
        if (thirdPartType === ThirdPartType.WECOM) {
          turnDialogType("wecom");
        } else {
          turnDialogType("followWeChat");
        }
      }
    }
    function getDefaultRegisterMethod() {
      if (!openUserRegisterType2.value.length) {
        return "";
      }
      if (openUserRegisterType2.value.length >= 2) {
        if (showEmailVerifyRegister2.value && showPasswordRegister2.value) {
          return smtpConfigured2.value ? "code" : "password";
        }
      }
      if (showEmailVerifyRegister2.value) {
        return "code";
      }
      if (showPasswordRegister2.value) {
        return "password";
      }
      return "";
    }
    function turnDialogType(type2) {
      initErrors();
      if (!titleMap.value[type2])
        return;
      verificationCode.value = "";
      originLoginType.value = targetLoginType.value;
      targetLoginType.value = type2;
      const isRegister = type2 === "register";
      const pageTitle = isRegister ? i18n.t("\u6CE8\u518C") : i18n.t("\u767B\u5F55");
      setTitle2(document.title.replace(/.*/, pageTitle));
      if (isRegister && IS_PRI.value) {
        updateRegisterType(getDefaultRegisterMethod());
      }
      if (type2 === "code" && isEnableCodeCaptcha.value) {
        handleGetSigninCaptcha();
      }
      emit("turnType", type2);
    }
    const turnOriginLogin = () => {
      turnDialogType(defaultLogin);
      updateRegisterType("");
    };
    const { toForgetPassword } = usePasswordReset();
    const forgetPassword = toForgetPassword;
    const isEmail = () => {
      return account.value.indexOf("@") !== -1;
    };
    const onAccountChange = () => {
      if (!IS_PRI.value)
        return;
      needCaptchaCode.value = false;
      captchaCodeError.value = "";
    };
    const checkAccount = () => {
      const regName = isI18N.value ? "email" : isEmail() ? "email" : "phone";
      const status2 = roleReg[regName].test(account.value);
      if (IS_PRI.value && (!status2 || regName === "phone")) {
        accountError.value = accountErrorCode.emailError;
        return false;
      }
      if (!status2) {
        accountError.value = accountErrorCode.default;
        return false;
      }
      const isCurrentRegister = targetLoginType.value === "register";
      if (IS_PRI.value && isCurrentRegister && !allowPublicEmail2.value && organizationEmail2.value.length && !organizationEmail2.value.some((item) => account.value.includes(item))) {
        accountError.value = accountErrorCode.OrganizationEmailDomainRestricted;
        return false;
      }
      if (IS_PRI.value && needCaptchaCode.value && !captchaCode.value) {
        captchaCodeError.value = accountErrorCode.noCaptcha;
        return false;
      }
      accountError.value = "";
      return true;
    };
    const checkCode = () => {
      if (!verificationCode.value) {
        codeError.value = i18n.t("\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u672A\u8F93\u5165\u60C5\u51B5\u3011");
        return false;
      }
      const status2 = roleReg.verificationCode.test(verificationCode.value);
      if (!status2) {
        codeError.value = i18n.t("\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u9519\u8BEF\u60C5\u51B5\u3011");
        return false;
      }
      codeError.value = "";
      return checkPolicy();
    };
    const checkLocalPhone = () => {
      const status2 = roleReg.phone.test(localPhone.value);
      if (!status2) {
        oneBtnPhoneError.value = i18n.t("\u8BF7\u8F93\u5165\u6B63\u786E\u7684\u624B\u673A\u53F7");
        return false;
      }
      oneBtnPhoneError.value = "";
      return checkPolicy();
    };
    const checkPolicy = () => {
      if (isI18N.value && targetLoginType.value === "register") {
        return true;
      }
      if (needPolicy.value && !policy.value) {
        registerNoPolicy.value = true;
        return false;
      }
      return true;
    };
    const registerNoPolicyEnd = () => {
      registerNoPolicy.value = false;
    };
    const cutTime = () => {
      const timer = setTimeout(() => {
        if (process2.value > 0) {
          process2.value--;
          cutTime();
        }
        clearTimeout(timer);
      }, 1e3);
    };
    const sendCode = () => {
      if (verificationButtonDisabled.value)
        return;
      verificationButtonDisabled.value = true;
      sendLog2(SensorsType.SEND_CODE, {
        ...basePointForBackend,
        action_type: ["code", "login"].includes(targetLoginType.value) ? "login" : "register"
      });
      const params = {
        identity: account.value
      };
      if (isEnableCodeCaptcha.value) {
        params.captchaId = captchaCodeId.value;
        params.captchaValue = captchaCode.value;
      }
      return sendMessageCode(params).then(() => {
        process2.value = 60;
        cutTime();
      }).catch((e2) => {
        var _a2, _b, _c, _d;
        const err = (_a2 = e2 == null ? void 0 : e2.response) == null ? void 0 : _a2.data;
        if ((err == null ? void 0 : err.code) === "FrequencyAttainLockFiveMinute") {
          emit("toast", {
            content: i18n.t("\u9A8C\u8BC1\u7801\u53D1\u9001\u9891\u7E41\uFF0C\u8BF75\u5206\u949F\u540E\u518D\u8BD5"),
            timeout: 3e3,
            position: "top"
          });
        } else if ((err == null ? void 0 : err.code) === "ExpiredCaptcha" || (err == null ? void 0 : err.code) === "InvalidCaptcha") {
          captchaCodeError.value = accountErrorCode[err == null ? void 0 : err.code];
          captchaCodeId.value = (_b = err == null ? void 0 : err.data) == null ? void 0 : _b.captchaId;
          captchaCodeUrl.value = `data:image/png;base64,${(_c = err == null ? void 0 : err.data) == null ? void 0 : _c.captchaValue}`;
        } else {
          accountError.value = accountErrorCode[err == null ? void 0 : err.code];
        }
        process2.value = (err == null ? void 0 : err.meta) ? (_d = err == null ? void 0 : err.meta) == null ? void 0 : _d.sec : process2.value;
        cutTime();
      }).finally(() => {
        verificationButtonDisabled.value = false;
      });
    };
    const handleGetSigninCaptcha = async () => {
      try {
        const {
          data: { id: id2, image }
        } = await getSigninCaptcha({ identity: account.value });
        captchaCodeId.value = id2;
        captchaCodeUrl.value = `data:image/png;base64,${image}`;
      } catch (e2) {
        console.error("\u9A8C\u8BC1\u7801\u83B7\u53D6\u5931\u8D25\uFF1A", JSON.stringify(e2));
      }
    };
    const sendVerificationCode = () => {
      if (isEnableCodeCaptcha.value && !captchaCode.value) {
        captchaCodeError.value = accountErrorCode.noCaptcha;
        return;
      }
      if (process2.value) {
        return;
      }
      if (!checkAccount()) {
        return;
      }
      sendCode();
    };
    const buttonClick = async () => {
      if (buttonDisabled.value)
        return;
      buttonDisabled.value = true;
      initErrors();
      if (targetLoginType.value === "setPassword") {
        if (passwordChange()) {
          await initPassword();
        }
      } else if (["code", "register"].includes(targetLoginType.value)) {
        if (registerType2.value === "password" && IS_PRI.value) {
          if (checkAccount() && passwordChange() && password2Change()) {
            await passwordSignin();
          }
        } else {
          if (checkAccount() && checkCode()) {
            await signUpByCode();
          }
        }
      } else if (["login"].includes(targetLoginType.value)) {
        if (checkAccount() && checkPolicy()) {
          await signUpByPassword();
        }
      } else if (["oneBtn"].includes(targetLoginType.value)) {
        if (checkLocalPhone()) {
          await verifyLocalPhone();
        }
        sendLog2(SensorsType.CLICK_LOGIN_BTN, {
          action_type: "one_click_login"
        });
      } else if (["sso"].includes(targetLoginType.value)) {
        await signUpBySSO();
        sendLog2(SensorsType.CLICK_LOGIN_BTN, {
          action_type: "sso_saml"
        });
      }
      buttonDisabled.value = false;
    };
    const checkOneBtnLogin = async () => {
      const {
        data: { JwtToken, AccessToken }
      } = await getLocalPhoneToken();
      await checkAuthAvailable({
        jwtToken: JwtToken,
        accessToken: AccessToken,
        phoneNumber: localPhone.value
      });
      const { spToken } = await getVerifyToken();
      return spToken;
    };
    const verifyLocalPhone = async () => {
      if (oneLoginBtnStatus.value !== oneBtnStatus.ON_INPUT)
        return;
      try {
        oneLoginBtnStatus.value = oneBtnStatus.IN_REVIEW;
        const spToken = await checkOneBtnLogin();
        const data2 = await getFromData();
        const fn2 = sendFormData(data2);
        const res = await verifyLocalPhoneToken({
          identity: "" + localPhone.value,
          code: spToken,
          ...data2,
          ...basePointForBackend
        });
        oneLoginBtnStatus.value = oneBtnStatus.CHECK_SUCCESS;
        removeDrainageData();
        fn2(res);
        setTimeout(() => showSetPassDialog(res.data), 500);
      } catch (e2) {
        oneLoginBtnStatus.value = oneBtnStatus.ON_INPUT;
        const code = e2 && e2.code;
        switch (code) {
          case 600008: {
            showReloadConfirm.value = true;
            if (loginBtn.value) {
              dialogContentTop.value = +loginBtn.value.offsetTop - 12;
            }
            break;
          }
          case 600025: {
            oneBtnPhoneError.value = i18n.t("\u9A8C\u8BC1\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u662F\u5426\u4E3A\u672C\u673A\u4E3B\u5361\u69FD\u53F7\u7801");
            break;
          }
          default: {
            emit("toast", {
              content: i18n.t("\u5F88\u62B1\u6B49\uFF0C\u767B\u5F55\u5931\u8D25\uFF0C\u8BF7\u9009\u62E9\u5176\u4ED6\u767B\u5F55\u65B9\u5F0F"),
              timeout: 3e3,
              position: "top"
            });
            break;
          }
        }
      }
    };
    const signUpByCode = async () => {
      var _a2, _b;
      try {
        const data2 = await getFromData();
        const fn2 = sendFormData(data2);
        const params = {
          identity: account.value,
          code: verificationCode.value.toString(),
          ...data2,
          ...basePointForBackend
        };
        if (isI18N.value) {
          params.isReceiveMail = policy.value;
        }
        const res = await phoneAndEmailSignup(params);
        const cb = async () => {
          try {
            await removeDrainageData();
            await showSetPassDialog(res.data);
            startRemoveSession();
            fn2(res);
          } catch (e2) {
            console.error(e2);
            emit("toast", {
              content: e2.message || "\u672A\u77E5\u9519\u8BEF",
              timeout: 3e3,
              position: "top"
            });
          }
        };
        if (isNeedRealNameAuth(res.data, IS_PRI.value)) {
          showRealNamePhone.value = true;
          loginSuccessCb.value = cb;
          return;
        }
        await cb();
      } catch (e2) {
        console.error(e2);
        const code = (_b = (_a2 = e2 == null ? void 0 : e2.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code;
        if (code === API_ERROR_CODE.PasswordReset) {
          return;
        }
        if (code && samlEmailErrCode[code]) {
          emit("toast", {
            content: samlEmailErrCode[code],
            timeout: 3e3,
            position: "top"
          });
        } else if (code === "OrganizationEmailDomainRestricted") {
          accountErrorBorder.value = true;
          accountError.value = accountErrorCode.OrganizationEmailDomainRestricted;
        } else if (code === "registerClosed") {
          accountErrorBorder.value = true;
          codeError.value = accountErrorCode.RegisterClosed;
        } else {
          accountErrorBorder.value = true;
          codeError.value = i18n.t("\u9A8C\u8BC1\u7801\u9519\u8BEF\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165\u3010\u9519\u8BEF\u60C5\u51B5\u3011");
        }
      }
    };
    const passwordSignin = async () => {
      try {
        const data2 = await getFromData();
        const fn2 = sendFormData(data2);
        const res = await signinByPassword({
          email: account.value,
          password: password1.value,
          ...data2,
          ...basePointForBackend
        }).catch((e2) => {
          var _a2;
          console.error("signin by password error", e2);
          const err = (_a2 = e2 == null ? void 0 : e2.response) == null ? void 0 : _a2.data;
          const code = err == null ? void 0 : err.code;
          if (code && accountErrorCode[code]) {
            accountError.value = accountErrorCode[code];
          }
        });
        await removeDrainageData();
        await showSetPassDialog(res.data);
        startRemoveSession();
        fn2(res);
      } catch (error) {
      }
    };
    const signUpByPassword = async () => {
      var _a2, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q;
      try {
        const yToken = getSessionStorageItem$1("yToken");
        const params = {
          identity: account.value,
          password: password.value,
          yToken,
          ...basePointForBackend
        };
        if (needCaptchaCode.value) {
          params.captchaId = captchaCodeId.value;
          params.captchaValue = captchaCode.value;
        }
        const res = await signupByPassword(params);
        const cb = async () => {
          try {
            await showSetPassDialog(res.data);
          } catch (e2) {
            console.error(e2);
            emit("toast", {
              content: e2.message || "\u672A\u77E5\u9519\u8BEF",
              timeout: 3e3,
              position: "top"
            });
          }
        };
        if (isNeedRealNameAuth(res.data, IS_PRI.value)) {
          showRealNamePhone.value = true;
          loginSuccessCb.value = cb;
          return;
        }
        await cb();
      } catch (e2) {
        const code = (_b = (_a2 = e2 == null ? void 0 : e2.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.code;
        if (code && samlEmailErrCode[code]) {
          emit("toast", {
            content: samlEmailErrCode[code],
            timeout: 3e3,
            position: "top"
          });
        } else if (IS_PRI.value && (code === "NeedCaptcha" || code === "InvalidCaptcha")) {
          captchaCodeError.value = accountErrorCode[code];
          needCaptchaCode.value = true;
          captchaCodeId.value = (_e = (_d = (_c = e2 == null ? void 0 : e2.response) == null ? void 0 : _c.data) == null ? void 0 : _d.data) == null ? void 0 : _e.captchaId;
          captchaCodeUrl.value = `data:image/png;base64,${(_h = (_g = (_f = e2 == null ? void 0 : e2.response) == null ? void 0 : _f.data) == null ? void 0 : _g.data) == null ? void 0 : _h.captchaValue}`;
        } else if (code === "LoginTooManyTimes") {
          accountErrorBorder.value = true;
          passwordError.value = i18n.t("\u591A\u6B21\u9A8C\u8BC1\u5931\u8D25\uFF0C\u8BF7\u7A0D\u540E\u91CD\u8BD5");
        } else if (code === "OrganizationEmailDomainRestricted") {
          accountErrorBorder.value = true;
          accountError.value = accountErrorCode.OrganizationEmailDomainRestricted;
        } else {
          accountErrorBorder.value = true;
          passwordError.value = i18n.t("\u7528\u6237\u540D\u6216\u5BC6\u7801\u9519\u8BEF");
          if ((_k = (_j = (_i = e2 == null ? void 0 : e2.response) == null ? void 0 : _i.data) == null ? void 0 : _j.data) == null ? void 0 : _k.captchaId) {
            captchaCodeId.value = (_n = (_m = (_l = e2 == null ? void 0 : e2.response) == null ? void 0 : _l.data) == null ? void 0 : _m.data) == null ? void 0 : _n.captchaId;
            captchaCodeUrl.value = `data:image/png;base64,${(_q = (_p = (_o = e2 == null ? void 0 : e2.response) == null ? void 0 : _o.data) == null ? void 0 : _p.data) == null ? void 0 : _q.captchaValue}`;
          } else {
            needCaptchaCode.value = false;
          }
        }
      }
    };
    const getSSOverifyMethod = (type2) => {
      switch (type2) {
        case "saml":
          return verifySaml;
        case "oauth":
          return verifyOauth;
        default:
          return verifySaml;
      }
    };
    const signUpBySSO = async () => {
      var _a2, _b, _c;
      if (!roleReg.email.test(account.value)) {
        accountError.value = accountErrorCode.orgEmailErr;
        return;
      }
      try {
        let sourceUrl = getSessionStorageItem$1(SESSION_KEYS.SOURCE_URL);
        sourceUrl = checkRedirectUrl(sourceUrl);
        const redirect = sourceUrl ? sourceUrl : window.location.origin + "/files/home";
        const loginProtocol = await getLoginProtocol({ email: account.value });
        const verifyMethod = getSSOverifyMethod((_a2 = loginProtocol == null ? void 0 : loginProtocol.data) == null ? void 0 : _a2.loginType);
        const params = {
          email: account.value,
          redirect_url: redirect
        };
        const res = await verifyMethod(params);
        window.open(res.data.auth_req_url, "_self");
      } catch (e2) {
        console.error("Failed: ", e2);
        const code = (_c = (_b = e2 == null ? void 0 : e2.response) == null ? void 0 : _b.data) == null ? void 0 : _c.code;
        if (samlEmailErrCode[code]) {
          accountError.value = samlEmailErrCode[code];
        } else {
          accountError.value = accountErrorCode.saml;
        }
      }
    };
    const showSetPassDialog = async (res = {}) => {
      emit("setUserInfo", res, !res.userState);
      if (!res.userState) {
        if (isMirror$1())
          return;
        turnDialogType("setPassword");
        userInfo.value = res;
      }
    };
    const getFromData = async () => {
      const source2 = getSessionStorageItem$1("setRegistrationCode");
      formData.value = await getFormData();
      const naturalGrowth = formData.value.naturalGrowth;
      return {
        ...formData.value,
        source: source2,
        naturalGrowth
      };
    };
    const reloadWithReason = () => {
      window.location.reload();
    };
    function sendLog2(type2, dataParams) {
      const data2 = dataParams || {};
      const actionDetail = props2.actionData.actionDetail;
      if (actionDetail && actionDetail[type2]) {
        data2.action_detail = actionDetail;
      }
      if (type2 === "click_login_btn") {
        data2.app = isMirror$1() ? "mirror_app" : "masterweb";
      }
      data2.action_position = `${props2.actionData.actionPosition || ""}+${window.location.pathname}`;
      if (props2.actionData.actionType) {
        data2.action_type = props2.actionData.actionType;
      }
      sensors.track(type2, data2);
    }
    const reloadPage = () => {
      showReloadConfirm.value = false;
      reloadWithReason();
    };
    async function getOneBtnUse() {
      try {
        if (isMobile2.value && !platformInfo().isWeiXin) {
          await checkOneBtnLogin();
          await turnDialogType("oneBtn");
          hasOneBtnLogin.value = true;
          return;
        }
        return null;
      } catch {
        return null;
      }
    }
    async function getPageInitData() {
      await getOneBtnUse();
      featureLoading.value = false;
    }
    const isOneBtnLogin = computed(() => targetLoginType.value === "oneBtn");
    const pageInit = computed(() => {
      let data2 = {};
      if (props2.targetType === "wechat") {
        Object.assign(data2, {
          showFollowWeChat: true
        });
      } else if (isOnlySsoLogin2.value) {
        data2 = {
          buttonText: i18n.t("\u4E0B\u4E00\u6B65"),
          showCodeLoginBtn: true,
          showPasswordLoginBtn: true,
          noRegister: true,
          inputPlaceholder: i18n.t("\u4F01\u4E1A\u90AE\u7BB1")
        };
      } else {
        const isRequiredLoginMethod = props2.configs.isRequiredLoginMethod;
        switch (targetLoginType.value) {
          case "code": {
            data2 = {
              inputPlaceholder: isRequiredLoginMethod ? i18n.t("\u90AE\u7BB1") : i18n.t("\u624B\u673A\u53F7/\u90AE\u7BB1"),
              policy: true,
              buttonText: i18n.t("\u5F00\u59CB\u4F7F\u7528"),
              showPasswordLoginBtn: true,
              noRegister: true,
              showCode: true,
              showOneBtnLogin: hasOneBtnLogin.value,
              showSSOBtn: !isI18N.value && !hideSSO.value && !_hideSSO.value
            };
            break;
          }
          case "login": {
            data2 = {
              showBack: false,
              inputPlaceholder: isRequiredLoginMethod ? i18n.t("\u90AE\u7BB1") : i18n.t("\u624B\u673A\u53F7/\u90AE\u7BB1"),
              showPassword: true,
              policy: true,
              buttonText: i18n.t("\u5F00\u59CB\u4F7F\u7528"),
              forgetPassword: true,
              showCodeLoginBtn: true,
              showSSOBtn: !isI18N.value && !hideSSO.value && !_hideSSO.value,
              noRegister: true
            };
            break;
          }
          case "register": {
            data2 = {
              inputPlaceholder: isRequiredLoginMethod ? i18n.t("\u90AE\u7BB1") : i18n.t("\u624B\u673A\u53F7/\u90AE\u7BB1"),
              showCode: true,
              hasAccount: true,
              policy: true,
              buttonText: i18n.t("\u6CE8\u518C")
            };
            break;
          }
          case "wecom": {
            data2 = {
              showWecomQrCode: true,
              title: i18n.t("\u4F01\u4E1A\u5FAE\u4FE1\u626B\u7801\u767B\u5F55"),
              showBack: true
            };
            break;
          }
          case "followWeChat": {
            data2 = {
              title: i18n.t("\u5FAE\u4FE1%{slot1}", {
                slot1: isLogin.value ? i18n.t("\u5B89\u5168\u767B\u5F55") : i18n.t("\u626B\u7801\u6CE8\u518C")
              }),
              showBack: true,
              showFollowWeChat: true
            };
            break;
          }
          case "setPassword": {
            data2 = {
              firstLogin: true,
              passwordPlaceholder: passwordPlaceholder.value,
              showPassword: true,
              buttonText: i18n.t("\u5F00\u59CB\u4F7F\u7528")
            };
            break;
          }
          case "oneBtn": {
            let buttonText;
            switch (oneLoginBtnStatus.value) {
              case oneBtnStatus.ON_INPUT: {
                buttonText = i18n.t("\u9A8C\u8BC1\u53F7\u7801");
                break;
              }
              case oneBtnStatus.IN_REVIEW: {
                buttonText = i18n.t("\u9A8C\u8BC1\u4E2D...");
                break;
              }
              case oneBtnStatus.CHECK_SUCCESS: {
                buttonText = "";
                break;
              }
              default: {
                buttonText = i18n.t("\u9A8C\u8BC1\u53F7\u7801");
              }
            }
            data2 = {
              showLocalPhone: true,
              showNotOneBtnLogin: true,
              policy: false,
              buttonText
            };
            break;
          }
          case "sso": {
            data2 = {
              buttonText: i18n.t("\u4E0B\u4E00\u6B65"),
              showCodeLoginBtn: true,
              showPasswordLoginBtn: true,
              noRegister: true,
              inputPlaceholder: i18n.t("\u4F01\u4E1A\u90AE\u7BB1")
            };
          }
        }
      }
      return {
        title: title.value,
        dialogTitle: props2.dialogTitle,
        showBack: false,
        firstLogin: false,
        showPassword: false,
        showCode: false,
        policy: false,
        buttonText: "",
        showPasswordLoginBtn: false,
        forgetPassword: false,
        noRegister: false,
        hasAccount: false,
        showFollowWeChat: false,
        showLocalPhone: false,
        showOneBtnLogin: false,
        showNotOneBtnLogin: false,
        showCodeLoginBtn: false,
        showSSOBtn: false,
        inputPlaceholder: "",
        ...data2
      };
    });
    const needPolicy = computed(
      () => pageInit.value.policy && !IS_PRI.value && (!isI18N.value || isI18N.value && targetLoginType.value === "register")
    );
    onBeforeUnmount(() => {
      window.removeEventListener("keyup", listener.value);
      removeSessionStorageItem(SESSION_KEYS.RANDOM_NUM);
    });
    const setUserInfo = (data2) => {
      emit("setUserInfo", data2);
    };
    const isEnableThirdPartLogin = ref();
    const getEnableThirdPartLogin = async () => {
      if (IS_PRI.value) {
        try {
          const res = await getToggleStatus("web.enableWecomLogin");
          isEnableThirdPartLogin.value = res;
        } catch (e2) {
          throw new Error("function: getEnableThirdPartLogin, error: " + e2);
        }
      }
    };
    const isEnableCodeCaptcha = ref();
    const getEnableCodeCaptcha = async () => {
      try {
        const res = await getToggleStatus("web.openCodeCaptcha");
        isEnableCodeCaptcha.value = res;
      } catch (e2) {
        throw new Error("function: getEnableCodeCaptcha, error: " + e2);
      }
    };
    const toLanhu = () => {
      setSessionStorageItem(SESSION_KEYS.SOURCE_URL, window.location.href);
      emit("log", SensorsType.CLICK_LOGIN_BTN, {
        action_type: "lanhu"
      });
      window.location.href = props2.lanhuHost + "/web/#/user/login?uselocal=true&platformName=mastergo";
    };
    const bindSuccess = async (data2) => {
      var _a2;
      await ((_a2 = loginSuccessCb.value) == null ? void 0 : _a2.call(loginSuccessCb, data2));
      showRealNamePhone.value = false;
      console.log("\u7ED1\u5B9A\u6210\u529F", data2);
    };
    const cancelBindAuthPhone = () => {
      showRealNamePhone.value = false;
    };
    const onToast = (msgOption) => {
      emit("toast", msgOption);
    };
    return {
      isLogin,
      pageInit,
      needPolicy,
      wechatIcon,
      closeForModal,
      closeDialog,
      onThirdPartLoginBtnClick,
      turnDialogType,
      account,
      accountError,
      accountErrorBorder,
      eyeStatus,
      passwordError,
      password,
      needCaptchaCode,
      captchaCode,
      captchaCodeUrl,
      verificationCode,
      handleGetSigninCaptcha,
      sendVerificationCode,
      process: process2,
      captchaCodeError,
      codeError,
      policy,
      registerNoPolicy,
      registerNoPolicyEnd,
      buttonClick,
      wechatLoginMethod,
      forgetPassword,
      turnOriginLogin,
      originLoginType,
      targetLoginType,
      featureLoading,
      sendLog: sendLog2,
      localPhone,
      oneBtnPhoneError,
      oneLoginBtnStatus,
      wecomLoginMethod,
      showReloadConfirm,
      reloadPage,
      hasOneBtnLogin,
      dialogContentTop,
      isOneBtnLogin,
      loginBtn,
      isMobile2,
      isOnlySsoLogin2,
      ThirdPartType,
      openUserRegister: openUserRegister2,
      smtpConfigured: smtpConfigured2,
      registerType: registerType2,
      password1,
      password2,
      password2Error,
      passwordChange,
      password2Change,
      checkAccount,
      onAccountChange,
      changeRegisterType,
      IS_PRI,
      onlyLanhuLogin: onlyLanhuLogin2,
      lanhuHost: lanhuHost2,
      passwordPlaceholder,
      isMirror: isMirror$1,
      setUserInfo,
      loginStyle,
      weiXinLoginEnd,
      showPrivacy,
      privacyStatus,
      loginThemeStyle,
      hasTheme,
      isEnUS: i18n.locale === "en-US",
      openUserRegisterType: openUserRegisterType2,
      showPasswordRegister: showPasswordRegister2,
      showEmailVerifyRegister: showEmailVerifyRegister2,
      showRegisterTab,
      showRealNamePhone,
      bindSuccess,
      cancelBindAuthPhone,
      onToast,
      isEnableThirdPartLogin,
      isEnableCodeCaptcha,
      toLanhu,
      isDarkTheme,
      showPasswordInput,
      showResetConfirm: showResetConfirm2,
      updateShowResetConfirm
    };
  }
};
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent(
  __vue2_script$u,
  render$v,
  staticRenderFns$u,
  false,
  __vue2_injectStyles$u,
  "62bed9c3",
  null,
  null
);
function __vue2_injectStyles$u(context) {
  for (let o2 in __cssModules$u) {
    this[o2] = __cssModules$u[o2];
  }
}
var MLogin = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var defaultIcon = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAHgAeAMBEQACEQEDEQH/xABUAAEBAAAAAAAAAAAAAAAAAAAACBABAQADAAAAAAAAAAAAAAAAAAERUZEBAQEBAAAAAAAAAAAAAAAAAAAJChEBAAMAAAAAAAAAAAAAAAAAAAERUf/aAAwDAQACEQMRAD8AiRpjT1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMXV4XGhi6vC40MXV4XGhi6vC40MXV4XGhi6vC40MXV4XGj//Z";
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "avatar",
    class: _vm.size ? "avatar_" + _vm.size : ""
  }, [_vm.info.avatar ? _c("img", {
    attrs: {
      "src": _vm.img || _vm.info.avatar
    },
    on: {
      "error": _vm.onerror
    }
  }) : _c("div", {
    staticClass: "name-container text-white",
    class: [_vm.info.type ? "type-" + _vm.info.type : "", _vm.isI18N ? "bg-g-purple" : "bg-g-blue"]
  }, [_vm._v(" " + _vm._s(_vm.name) + " ")])]);
};
var staticRenderFns$t = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$3 = "";
const __vue2_script$t = defineComponent({
  name: "MAvatar",
  props: {
    size: {
      type: String,
      default: "middle"
    },
    info: {
      type: Object,
      default: () => ({
        name: "",
        avatar: ""
      })
    },
    showBorder: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const img = ref("");
    const name2 = ref("");
    watch(
      () => props2.info,
      (val) => {
        img.value = transUrl(props2.info.avatar || "");
        if (!val.avatar) {
          if (val.name) {
            name2.value = val.name.trim() || "";
          }
          const len = name2.value.length;
          if (!isChinese(name2.value)) {
            if (name2.value[0] !== "+") {
              const firstChar = Array.from(name2.value)[0];
              if (containEmoji(firstChar)) {
                name2.value = firstChar;
              } else {
                name2.value = firstChar.toUpperCase();
              }
            }
          } else if (len <= 2) {
            name2.value = name2.value.substring(len - 1);
          } else {
            name2.value = props2.size === "small" ? name2.value.substring(len - 1) : name2.value.substring(len - 2);
          }
        }
      },
      { immediate: true, deep: true }
    );
    const onerror = () => {
      img.value = defaultIcon;
    };
    return {
      img,
      name: name2,
      onerror
    };
  }
});
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent(
  __vue2_script$t,
  render$u,
  staticRenderFns$t,
  false,
  __vue2_injectStyles$t,
  "7feb9139",
  null,
  null
);
function __vue2_injectStyles$t(context) {
  for (let o2 in __cssModules$t) {
    this[o2] = __cssModules$t[o2];
  }
}
var MAvatar = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
var qrcode$1 = { exports: {} };
(function(module, exports) {
  var QRCode2;
  (function(root2, factory) {
    module.exports = factory();
  })(commonjsGlobal, function() {
    function QR8bitByte(data2) {
      this.mode = QRMode.MODE_8BIT_BYTE;
      this.data = data2;
      this.parsedData = [];
      for (var i2 = 0, l = this.data.length; i2 < l; i2++) {
        var byteArray = [];
        var code = this.data.charCodeAt(i2);
        if (code > 65536) {
          byteArray[0] = 240 | (code & 1835008) >>> 18;
          byteArray[1] = 128 | (code & 258048) >>> 12;
          byteArray[2] = 128 | (code & 4032) >>> 6;
          byteArray[3] = 128 | code & 63;
        } else if (code > 2048) {
          byteArray[0] = 224 | (code & 61440) >>> 12;
          byteArray[1] = 128 | (code & 4032) >>> 6;
          byteArray[2] = 128 | code & 63;
        } else if (code > 128) {
          byteArray[0] = 192 | (code & 1984) >>> 6;
          byteArray[1] = 128 | code & 63;
        } else {
          byteArray[0] = code;
        }
        this.parsedData.push(byteArray);
      }
      this.parsedData = Array.prototype.concat.apply([], this.parsedData);
      if (this.parsedData.length != this.data.length) {
        this.parsedData.unshift(191);
        this.parsedData.unshift(187);
        this.parsedData.unshift(239);
      }
    }
    QR8bitByte.prototype = {
      getLength: function(buffer) {
        return this.parsedData.length;
      },
      write: function(buffer) {
        for (var i2 = 0, l = this.parsedData.length; i2 < l; i2++) {
          buffer.put(this.parsedData[i2], 8);
        }
      }
    };
    function QRCodeModel(typeNumber, errorCorrectLevel) {
      this.typeNumber = typeNumber;
      this.errorCorrectLevel = errorCorrectLevel;
      this.modules = null;
      this.moduleCount = 0;
      this.dataCache = null;
      this.dataList = [];
    }
    QRCodeModel.prototype = { addData: function(data2) {
      var newData = new QR8bitByte(data2);
      this.dataList.push(newData);
      this.dataCache = null;
    }, isDark: function(row, col) {
      if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
        throw new Error(row + "," + col);
      }
      return this.modules[row][col];
    }, getModuleCount: function() {
      return this.moduleCount;
    }, make: function() {
      this.makeImpl(false, this.getBestMaskPattern());
    }, makeImpl: function(test, maskPattern) {
      this.moduleCount = this.typeNumber * 4 + 17;
      this.modules = new Array(this.moduleCount);
      for (var row = 0; row < this.moduleCount; row++) {
        this.modules[row] = new Array(this.moduleCount);
        for (var col = 0; col < this.moduleCount; col++) {
          this.modules[row][col] = null;
        }
      }
      this.setupPositionProbePattern(0, 0);
      this.setupPositionProbePattern(this.moduleCount - 7, 0);
      this.setupPositionProbePattern(0, this.moduleCount - 7);
      this.setupPositionAdjustPattern();
      this.setupTimingPattern();
      this.setupTypeInfo(test, maskPattern);
      if (this.typeNumber >= 7) {
        this.setupTypeNumber(test);
      }
      if (this.dataCache == null) {
        this.dataCache = QRCodeModel.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
      }
      this.mapData(this.dataCache, maskPattern);
    }, setupPositionProbePattern: function(row, col) {
      for (var r = -1; r <= 7; r++) {
        if (row + r <= -1 || this.moduleCount <= row + r)
          continue;
        for (var c2 = -1; c2 <= 7; c2++) {
          if (col + c2 <= -1 || this.moduleCount <= col + c2)
            continue;
          if (0 <= r && r <= 6 && (c2 == 0 || c2 == 6) || 0 <= c2 && c2 <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c2 && c2 <= 4) {
            this.modules[row + r][col + c2] = true;
          } else {
            this.modules[row + r][col + c2] = false;
          }
        }
      }
    }, getBestMaskPattern: function() {
      var minLostPoint = 0;
      var pattern = 0;
      for (var i2 = 0; i2 < 8; i2++) {
        this.makeImpl(true, i2);
        var lostPoint = QRUtil.getLostPoint(this);
        if (i2 == 0 || minLostPoint > lostPoint) {
          minLostPoint = lostPoint;
          pattern = i2;
        }
      }
      return pattern;
    }, createMovieClip: function(target_mc, instance_name, depth) {
      var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
      var cs2 = 1;
      this.make();
      for (var row = 0; row < this.modules.length; row++) {
        var y = row * cs2;
        for (var col = 0; col < this.modules[row].length; col++) {
          var x = col * cs2;
          var dark = this.modules[row][col];
          if (dark) {
            qr_mc.beginFill(0, 100);
            qr_mc.moveTo(x, y);
            qr_mc.lineTo(x + cs2, y);
            qr_mc.lineTo(x + cs2, y + cs2);
            qr_mc.lineTo(x, y + cs2);
            qr_mc.endFill();
          }
        }
      }
      return qr_mc;
    }, setupTimingPattern: function() {
      for (var r = 8; r < this.moduleCount - 8; r++) {
        if (this.modules[r][6] != null) {
          continue;
        }
        this.modules[r][6] = r % 2 == 0;
      }
      for (var c2 = 8; c2 < this.moduleCount - 8; c2++) {
        if (this.modules[6][c2] != null) {
          continue;
        }
        this.modules[6][c2] = c2 % 2 == 0;
      }
    }, setupPositionAdjustPattern: function() {
      var pos = QRUtil.getPatternPosition(this.typeNumber);
      for (var i2 = 0; i2 < pos.length; i2++) {
        for (var j = 0; j < pos.length; j++) {
          var row = pos[i2];
          var col = pos[j];
          if (this.modules[row][col] != null) {
            continue;
          }
          for (var r = -2; r <= 2; r++) {
            for (var c2 = -2; c2 <= 2; c2++) {
              if (r == -2 || r == 2 || c2 == -2 || c2 == 2 || r == 0 && c2 == 0) {
                this.modules[row + r][col + c2] = true;
              } else {
                this.modules[row + r][col + c2] = false;
              }
            }
          }
        }
      }
    }, setupTypeNumber: function(test) {
      var bits = QRUtil.getBCHTypeNumber(this.typeNumber);
      for (var i2 = 0; i2 < 18; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        this.modules[Math.floor(i2 / 3)][i2 % 3 + this.moduleCount - 8 - 3] = mod;
      }
      for (var i2 = 0; i2 < 18; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        this.modules[i2 % 3 + this.moduleCount - 8 - 3][Math.floor(i2 / 3)] = mod;
      }
    }, setupTypeInfo: function(test, maskPattern) {
      var data2 = this.errorCorrectLevel << 3 | maskPattern;
      var bits = QRUtil.getBCHTypeInfo(data2);
      for (var i2 = 0; i2 < 15; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        if (i2 < 6) {
          this.modules[i2][8] = mod;
        } else if (i2 < 8) {
          this.modules[i2 + 1][8] = mod;
        } else {
          this.modules[this.moduleCount - 15 + i2][8] = mod;
        }
      }
      for (var i2 = 0; i2 < 15; i2++) {
        var mod = !test && (bits >> i2 & 1) == 1;
        if (i2 < 8) {
          this.modules[8][this.moduleCount - i2 - 1] = mod;
        } else if (i2 < 9) {
          this.modules[8][15 - i2 - 1 + 1] = mod;
        } else {
          this.modules[8][15 - i2 - 1] = mod;
        }
      }
      this.modules[this.moduleCount - 8][8] = !test;
    }, mapData: function(data2, maskPattern) {
      var inc2 = -1;
      var row = this.moduleCount - 1;
      var bitIndex = 7;
      var byteIndex = 0;
      for (var col = this.moduleCount - 1; col > 0; col -= 2) {
        if (col == 6)
          col--;
        while (true) {
          for (var c2 = 0; c2 < 2; c2++) {
            if (this.modules[row][col - c2] == null) {
              var dark = false;
              if (byteIndex < data2.length) {
                dark = (data2[byteIndex] >>> bitIndex & 1) == 1;
              }
              var mask = QRUtil.getMask(maskPattern, row, col - c2);
              if (mask) {
                dark = !dark;
              }
              this.modules[row][col - c2] = dark;
              bitIndex--;
              if (bitIndex == -1) {
                byteIndex++;
                bitIndex = 7;
              }
            }
          }
          row += inc2;
          if (row < 0 || this.moduleCount <= row) {
            row -= inc2;
            inc2 = -inc2;
            break;
          }
        }
      }
    } };
    QRCodeModel.PAD0 = 236;
    QRCodeModel.PAD1 = 17;
    QRCodeModel.createData = function(typeNumber, errorCorrectLevel, dataList) {
      var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
      var buffer = new QRBitBuffer();
      for (var i2 = 0; i2 < dataList.length; i2++) {
        var data2 = dataList[i2];
        buffer.put(data2.mode, 4);
        buffer.put(data2.getLength(), QRUtil.getLengthInBits(data2.mode, typeNumber));
        data2.write(buffer);
      }
      var totalDataCount = 0;
      for (var i2 = 0; i2 < rsBlocks.length; i2++) {
        totalDataCount += rsBlocks[i2].dataCount;
      }
      if (buffer.getLengthInBits() > totalDataCount * 8) {
        throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
      }
      if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
        buffer.put(0, 4);
      }
      while (buffer.getLengthInBits() % 8 != 0) {
        buffer.putBit(false);
      }
      while (true) {
        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(QRCodeModel.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) {
          break;
        }
        buffer.put(QRCodeModel.PAD1, 8);
      }
      return QRCodeModel.createBytes(buffer, rsBlocks);
    };
    QRCodeModel.createBytes = function(buffer, rsBlocks) {
      var offset2 = 0;
      var maxDcCount = 0;
      var maxEcCount = 0;
      var dcdata = new Array(rsBlocks.length);
      var ecdata = new Array(rsBlocks.length);
      for (var r = 0; r < rsBlocks.length; r++) {
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for (var i2 = 0; i2 < dcdata[r].length; i2++) {
          dcdata[r][i2] = 255 & buffer.buffer[i2 + offset2];
        }
        offset2 += dcCount;
        var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for (var i2 = 0; i2 < ecdata[r].length; i2++) {
          var modIndex = i2 + modPoly.getLength() - ecdata[r].length;
          ecdata[r][i2] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
      }
      var totalCodeCount = 0;
      for (var i2 = 0; i2 < rsBlocks.length; i2++) {
        totalCodeCount += rsBlocks[i2].totalCount;
      }
      var data2 = new Array(totalCodeCount);
      var index2 = 0;
      for (var i2 = 0; i2 < maxDcCount; i2++) {
        for (var r = 0; r < rsBlocks.length; r++) {
          if (i2 < dcdata[r].length) {
            data2[index2++] = dcdata[r][i2];
          }
        }
      }
      for (var i2 = 0; i2 < maxEcCount; i2++) {
        for (var r = 0; r < rsBlocks.length; r++) {
          if (i2 < ecdata[r].length) {
            data2[index2++] = ecdata[r][i2];
          }
        }
      }
      return data2;
    };
    var QRMode = { MODE_NUMBER: 1 << 0, MODE_ALPHA_NUM: 1 << 1, MODE_8BIT_BYTE: 1 << 2, MODE_KANJI: 1 << 3 };
    var QRErrorCorrectLevel = { L: 1, M: 0, Q: 3, H: 2 };
    var QRMaskPattern = { PATTERN000: 0, PATTERN001: 1, PATTERN010: 2, PATTERN011: 3, PATTERN100: 4, PATTERN101: 5, PATTERN110: 6, PATTERN111: 7 };
    var QRUtil = { PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]], G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0, G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0, G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1, getBCHTypeInfo: function(data2) {
      var d2 = data2 << 10;
      while (QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
        d2 ^= QRUtil.G15 << QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G15);
      }
      return (data2 << 10 | d2) ^ QRUtil.G15_MASK;
    }, getBCHTypeNumber: function(data2) {
      var d2 = data2 << 12;
      while (QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
        d2 ^= QRUtil.G18 << QRUtil.getBCHDigit(d2) - QRUtil.getBCHDigit(QRUtil.G18);
      }
      return data2 << 12 | d2;
    }, getBCHDigit: function(data2) {
      var digit = 0;
      while (data2 != 0) {
        digit++;
        data2 >>>= 1;
      }
      return digit;
    }, getPatternPosition: function(typeNumber) {
      return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    }, getMask: function(maskPattern, i2, j) {
      switch (maskPattern) {
        case QRMaskPattern.PATTERN000:
          return (i2 + j) % 2 == 0;
        case QRMaskPattern.PATTERN001:
          return i2 % 2 == 0;
        case QRMaskPattern.PATTERN010:
          return j % 3 == 0;
        case QRMaskPattern.PATTERN011:
          return (i2 + j) % 3 == 0;
        case QRMaskPattern.PATTERN100:
          return (Math.floor(i2 / 2) + Math.floor(j / 3)) % 2 == 0;
        case QRMaskPattern.PATTERN101:
          return i2 * j % 2 + i2 * j % 3 == 0;
        case QRMaskPattern.PATTERN110:
          return (i2 * j % 2 + i2 * j % 3) % 2 == 0;
        case QRMaskPattern.PATTERN111:
          return (i2 * j % 3 + (i2 + j) % 2) % 2 == 0;
        default:
          throw new Error("bad maskPattern:" + maskPattern);
      }
    }, getErrorCorrectPolynomial: function(errorCorrectLength) {
      var a2 = new QRPolynomial([1], 0);
      for (var i2 = 0; i2 < errorCorrectLength; i2++) {
        a2 = a2.multiply(new QRPolynomial([1, QRMath.gexp(i2)], 0));
      }
      return a2;
    }, getLengthInBits: function(mode, type2) {
      if (1 <= type2 && type2 < 10) {
        switch (mode) {
          case QRMode.MODE_NUMBER:
            return 10;
          case QRMode.MODE_ALPHA_NUM:
            return 9;
          case QRMode.MODE_8BIT_BYTE:
            return 8;
          case QRMode.MODE_KANJI:
            return 8;
          default:
            throw new Error("mode:" + mode);
        }
      } else if (type2 < 27) {
        switch (mode) {
          case QRMode.MODE_NUMBER:
            return 12;
          case QRMode.MODE_ALPHA_NUM:
            return 11;
          case QRMode.MODE_8BIT_BYTE:
            return 16;
          case QRMode.MODE_KANJI:
            return 10;
          default:
            throw new Error("mode:" + mode);
        }
      } else if (type2 < 41) {
        switch (mode) {
          case QRMode.MODE_NUMBER:
            return 14;
          case QRMode.MODE_ALPHA_NUM:
            return 13;
          case QRMode.MODE_8BIT_BYTE:
            return 16;
          case QRMode.MODE_KANJI:
            return 12;
          default:
            throw new Error("mode:" + mode);
        }
      } else {
        throw new Error("type:" + type2);
      }
    }, getLostPoint: function(qrCode) {
      var moduleCount = qrCode.getModuleCount();
      var lostPoint = 0;
      for (var row = 0; row < moduleCount; row++) {
        for (var col = 0; col < moduleCount; col++) {
          var sameCount = 0;
          var dark = qrCode.isDark(row, col);
          for (var r = -1; r <= 1; r++) {
            if (row + r < 0 || moduleCount <= row + r) {
              continue;
            }
            for (var c2 = -1; c2 <= 1; c2++) {
              if (col + c2 < 0 || moduleCount <= col + c2) {
                continue;
              }
              if (r == 0 && c2 == 0) {
                continue;
              }
              if (dark == qrCode.isDark(row + r, col + c2)) {
                sameCount++;
              }
            }
          }
          if (sameCount > 5) {
            lostPoint += 3 + sameCount - 5;
          }
        }
      }
      for (var row = 0; row < moduleCount - 1; row++) {
        for (var col = 0; col < moduleCount - 1; col++) {
          var count = 0;
          if (qrCode.isDark(row, col))
            count++;
          if (qrCode.isDark(row + 1, col))
            count++;
          if (qrCode.isDark(row, col + 1))
            count++;
          if (qrCode.isDark(row + 1, col + 1))
            count++;
          if (count == 0 || count == 4) {
            lostPoint += 3;
          }
        }
      }
      for (var row = 0; row < moduleCount; row++) {
        for (var col = 0; col < moduleCount - 6; col++) {
          if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
            lostPoint += 40;
          }
        }
      }
      for (var col = 0; col < moduleCount; col++) {
        for (var row = 0; row < moduleCount - 6; row++) {
          if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
            lostPoint += 40;
          }
        }
      }
      var darkCount = 0;
      for (var col = 0; col < moduleCount; col++) {
        for (var row = 0; row < moduleCount; row++) {
          if (qrCode.isDark(row, col)) {
            darkCount++;
          }
        }
      }
      var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
      lostPoint += ratio * 10;
      return lostPoint;
    } };
    var QRMath = { glog: function(n) {
      if (n < 1) {
        throw new Error("glog(" + n + ")");
      }
      return QRMath.LOG_TABLE[n];
    }, gexp: function(n) {
      while (n < 0) {
        n += 255;
      }
      while (n >= 256) {
        n -= 255;
      }
      return QRMath.EXP_TABLE[n];
    }, EXP_TABLE: new Array(256), LOG_TABLE: new Array(256) };
    for (var i = 0; i < 8; i++) {
      QRMath.EXP_TABLE[i] = 1 << i;
    }
    for (var i = 8; i < 256; i++) {
      QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
    }
    for (var i = 0; i < 255; i++) {
      QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
    }
    function QRPolynomial(num, shift) {
      if (num.length == void 0) {
        throw new Error(num.length + "/" + shift);
      }
      var offset2 = 0;
      while (offset2 < num.length && num[offset2] == 0) {
        offset2++;
      }
      this.num = new Array(num.length - offset2 + shift);
      for (var i2 = 0; i2 < num.length - offset2; i2++) {
        this.num[i2] = num[i2 + offset2];
      }
    }
    QRPolynomial.prototype = { get: function(index2) {
      return this.num[index2];
    }, getLength: function() {
      return this.num.length;
    }, multiply: function(e2) {
      var num = new Array(this.getLength() + e2.getLength() - 1);
      for (var i2 = 0; i2 < this.getLength(); i2++) {
        for (var j = 0; j < e2.getLength(); j++) {
          num[i2 + j] ^= QRMath.gexp(QRMath.glog(this.get(i2)) + QRMath.glog(e2.get(j)));
        }
      }
      return new QRPolynomial(num, 0);
    }, mod: function(e2) {
      if (this.getLength() - e2.getLength() < 0) {
        return this;
      }
      var ratio = QRMath.glog(this.get(0)) - QRMath.glog(e2.get(0));
      var num = new Array(this.getLength());
      for (var i2 = 0; i2 < this.getLength(); i2++) {
        num[i2] = this.get(i2);
      }
      for (var i2 = 0; i2 < e2.getLength(); i2++) {
        num[i2] ^= QRMath.gexp(QRMath.glog(e2.get(i2)) + ratio);
      }
      return new QRPolynomial(num, 0).mod(e2);
    } };
    function QRRSBlock(totalCount, dataCount) {
      this.totalCount = totalCount;
      this.dataCount = dataCount;
    }
    QRRSBlock.RS_BLOCK_TABLE = [[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], [1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], [1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], [1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], [1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], [2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], [2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], [2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], [2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], [2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], [4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], [2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], [4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], [3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], [5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], [5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], [1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], [5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], [3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], [3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], [4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], [2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], [4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], [6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], [8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], [10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], [8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], [3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], [7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], [5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], [13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], [17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], [17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], [13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], [12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], [6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], [17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], [4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], [20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], [19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];
    QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
      var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
      if (rsBlock == void 0) {
        throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
      }
      var length = rsBlock.length / 3;
      var list = [];
      for (var i2 = 0; i2 < length; i2++) {
        var count = rsBlock[i2 * 3 + 0];
        var totalCount = rsBlock[i2 * 3 + 1];
        var dataCount = rsBlock[i2 * 3 + 2];
        for (var j = 0; j < count; j++) {
          list.push(new QRRSBlock(totalCount, dataCount));
        }
      }
      return list;
    };
    QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
      switch (errorCorrectLevel) {
        case QRErrorCorrectLevel.L:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case QRErrorCorrectLevel.M:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case QRErrorCorrectLevel.Q:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case QRErrorCorrectLevel.H:
          return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
          return void 0;
      }
    };
    function QRBitBuffer() {
      this.buffer = [];
      this.length = 0;
    }
    QRBitBuffer.prototype = { get: function(index2) {
      var bufIndex = Math.floor(index2 / 8);
      return (this.buffer[bufIndex] >>> 7 - index2 % 8 & 1) == 1;
    }, put: function(num, length) {
      for (var i2 = 0; i2 < length; i2++) {
        this.putBit((num >>> length - i2 - 1 & 1) == 1);
      }
    }, getLengthInBits: function() {
      return this.length;
    }, putBit: function(bit) {
      var bufIndex = Math.floor(this.length / 8);
      if (this.buffer.length <= bufIndex) {
        this.buffer.push(0);
      }
      if (bit) {
        this.buffer[bufIndex] |= 128 >>> this.length % 8;
      }
      this.length++;
    } };
    var QRCodeLimitLength = [[17, 14, 11, 7], [32, 26, 20, 14], [53, 42, 32, 24], [78, 62, 46, 34], [106, 84, 60, 44], [134, 106, 74, 58], [154, 122, 86, 64], [192, 152, 108, 84], [230, 180, 130, 98], [271, 213, 151, 119], [321, 251, 177, 137], [367, 287, 203, 155], [425, 331, 241, 177], [458, 362, 258, 194], [520, 412, 292, 220], [586, 450, 322, 250], [644, 504, 364, 280], [718, 560, 394, 310], [792, 624, 442, 338], [858, 666, 482, 382], [929, 711, 509, 403], [1003, 779, 565, 439], [1091, 857, 611, 461], [1171, 911, 661, 511], [1273, 997, 715, 535], [1367, 1059, 751, 593], [1465, 1125, 805, 625], [1528, 1190, 868, 658], [1628, 1264, 908, 698], [1732, 1370, 982, 742], [1840, 1452, 1030, 790], [1952, 1538, 1112, 842], [2068, 1628, 1168, 898], [2188, 1722, 1228, 958], [2303, 1809, 1283, 983], [2431, 1911, 1351, 1051], [2563, 1989, 1423, 1093], [2699, 2099, 1499, 1139], [2809, 2213, 1579, 1219], [2953, 2331, 1663, 1273]];
    function _isSupportCanvas() {
      return typeof CanvasRenderingContext2D != "undefined";
    }
    function _getAndroid() {
      var android = false;
      var sAgent = navigator.userAgent;
      if (/android/i.test(sAgent)) {
        android = true;
        var aMat = sAgent.toString().match(/android ([0-9]\.[0-9])/i);
        if (aMat && aMat[1]) {
          android = parseFloat(aMat[1]);
        }
      }
      return android;
    }
    var svgDrawer = function() {
      var Drawing2 = function(el2, htOption) {
        this._el = el2;
        this._htOption = htOption;
      };
      Drawing2.prototype.draw = function(oQRCode) {
        var _htOption = this._htOption;
        var _el = this._el;
        var nCount = oQRCode.getModuleCount();
        Math.floor(_htOption.width / nCount);
        Math.floor(_htOption.height / nCount);
        this.clear();
        function makeSVG(tag, attrs) {
          var el2 = document.createElementNS("http://www.w3.org/2000/svg", tag);
          for (var k in attrs)
            if (attrs.hasOwnProperty(k))
              el2.setAttribute(k, attrs[k]);
          return el2;
        }
        var svg = makeSVG("svg", { "viewBox": "0 0 " + String(nCount) + " " + String(nCount), "width": "100%", "height": "100%", "fill": _htOption.colorLight });
        svg.setAttributeNS("http://www.w3.org/2000/xmlns/", "xmlns:xlink", "http://www.w3.org/1999/xlink");
        _el.appendChild(svg);
        svg.appendChild(makeSVG("rect", { "fill": _htOption.colorLight, "width": "100%", "height": "100%" }));
        svg.appendChild(makeSVG("rect", { "fill": _htOption.colorDark, "width": "1", "height": "1", "id": "template" }));
        for (var row = 0; row < nCount; row++) {
          for (var col = 0; col < nCount; col++) {
            if (oQRCode.isDark(row, col)) {
              var child = makeSVG("use", { "x": String(col), "y": String(row) });
              child.setAttributeNS("http://www.w3.org/1999/xlink", "href", "#template");
              svg.appendChild(child);
            }
          }
        }
      };
      Drawing2.prototype.clear = function() {
        while (this._el.hasChildNodes())
          this._el.removeChild(this._el.lastChild);
      };
      return Drawing2;
    }();
    var useSVG = document.documentElement.tagName.toLowerCase() === "svg";
    var Drawing = useSVG ? svgDrawer : !_isSupportCanvas() ? function() {
      var Drawing2 = function(el2, htOption) {
        this._el = el2;
        this._htOption = htOption;
      };
      Drawing2.prototype.draw = function(oQRCode) {
        var _htOption = this._htOption;
        var _el = this._el;
        var nCount = oQRCode.getModuleCount();
        var nWidth = Math.floor(_htOption.width / nCount);
        var nHeight = Math.floor(_htOption.height / nCount);
        var aHTML = ['<table style="border:0;border-collapse:collapse;">'];
        for (var row = 0; row < nCount; row++) {
          aHTML.push("<tr>");
          for (var col = 0; col < nCount; col++) {
            aHTML.push('<td style="border:0;border-collapse:collapse;padding:0;margin:0;width:' + nWidth + "px;height:" + nHeight + "px;background-color:" + (oQRCode.isDark(row, col) ? _htOption.colorDark : _htOption.colorLight) + ';"></td>');
          }
          aHTML.push("</tr>");
        }
        aHTML.push("</table>");
        _el.innerHTML = aHTML.join("");
        var elTable = _el.childNodes[0];
        var nLeftMarginTable = (_htOption.width - elTable.offsetWidth) / 2;
        var nTopMarginTable = (_htOption.height - elTable.offsetHeight) / 2;
        if (nLeftMarginTable > 0 && nTopMarginTable > 0) {
          elTable.style.margin = nTopMarginTable + "px " + nLeftMarginTable + "px";
        }
      };
      Drawing2.prototype.clear = function() {
        this._el.innerHTML = "";
      };
      return Drawing2;
    }() : function() {
      function _onMakeImage() {
        this._elImage.src = this._elCanvas.toDataURL("image/png");
        this._elImage.style.display = "block";
        this._elCanvas.style.display = "none";
      }
      if (this && this._android && this._android <= 2.1) {
        var factor = 1 / window.devicePixelRatio;
        var drawImage = CanvasRenderingContext2D.prototype.drawImage;
        CanvasRenderingContext2D.prototype.drawImage = function(image, sx, sy, sw2, sh2, dx, dy, dw, dh) {
          if ("nodeName" in image && /img/i.test(image.nodeName)) {
            for (var i2 = arguments.length - 1; i2 >= 1; i2--) {
              arguments[i2] = arguments[i2] * factor;
            }
          } else if (typeof dw == "undefined") {
            arguments[1] *= factor;
            arguments[2] *= factor;
            arguments[3] *= factor;
            arguments[4] *= factor;
          }
          drawImage.apply(this, arguments);
        };
      }
      function _safeSetDataURI(fSuccess, fFail) {
        var self2 = this;
        self2._fFail = fFail;
        self2._fSuccess = fSuccess;
        if (self2._bSupportDataURI === null) {
          var el2 = document.createElement("img");
          var fOnError = function() {
            self2._bSupportDataURI = false;
            if (self2._fFail) {
              self2._fFail.call(self2);
            }
          };
          var fOnSuccess = function() {
            self2._bSupportDataURI = true;
            if (self2._fSuccess) {
              self2._fSuccess.call(self2);
            }
          };
          el2.onabort = fOnError;
          el2.onerror = fOnError;
          el2.onload = fOnSuccess;
          el2.src = "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAHElEQVQI12P4//8/w38GIAXDIBKE0DHxgljNBAAO9TXL0Y4OHwAAAABJRU5ErkJggg==";
          return;
        } else if (self2._bSupportDataURI === true && self2._fSuccess) {
          self2._fSuccess.call(self2);
        } else if (self2._bSupportDataURI === false && self2._fFail) {
          self2._fFail.call(self2);
        }
      }
      var Drawing2 = function(el2, htOption) {
        this._bIsPainted = false;
        this._android = _getAndroid();
        this._htOption = htOption;
        this._elCanvas = document.createElement("canvas");
        this._elCanvas.width = htOption.width;
        this._elCanvas.height = htOption.height;
        el2.appendChild(this._elCanvas);
        this._el = el2;
        this._oContext = this._elCanvas.getContext("2d");
        this._bIsPainted = false;
        this._elImage = document.createElement("img");
        this._elImage.alt = "Scan me!";
        this._elImage.style.display = "none";
        this._el.appendChild(this._elImage);
        this._bSupportDataURI = null;
      };
      Drawing2.prototype.draw = function(oQRCode) {
        var _elImage = this._elImage;
        var _oContext = this._oContext;
        var _htOption = this._htOption;
        var nCount = oQRCode.getModuleCount();
        var nWidth = _htOption.width / nCount;
        var nHeight = _htOption.height / nCount;
        var nRoundedWidth = Math.round(nWidth);
        var nRoundedHeight = Math.round(nHeight);
        _elImage.style.display = "none";
        this.clear();
        for (var row = 0; row < nCount; row++) {
          for (var col = 0; col < nCount; col++) {
            var bIsDark = oQRCode.isDark(row, col);
            var nLeft = col * nWidth;
            var nTop = row * nHeight;
            _oContext.strokeStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
            _oContext.lineWidth = 1;
            _oContext.fillStyle = bIsDark ? _htOption.colorDark : _htOption.colorLight;
            _oContext.fillRect(nLeft, nTop, nWidth, nHeight);
            _oContext.strokeRect(
              Math.floor(nLeft) + 0.5,
              Math.floor(nTop) + 0.5,
              nRoundedWidth,
              nRoundedHeight
            );
            _oContext.strokeRect(
              Math.ceil(nLeft) - 0.5,
              Math.ceil(nTop) - 0.5,
              nRoundedWidth,
              nRoundedHeight
            );
          }
        }
        this._bIsPainted = true;
      };
      Drawing2.prototype.makeImage = function() {
        if (this._bIsPainted) {
          _safeSetDataURI.call(this, _onMakeImage);
        }
      };
      Drawing2.prototype.isPainted = function() {
        return this._bIsPainted;
      };
      Drawing2.prototype.clear = function() {
        this._oContext.clearRect(0, 0, this._elCanvas.width, this._elCanvas.height);
        this._bIsPainted = false;
      };
      Drawing2.prototype.round = function(nNumber) {
        if (!nNumber) {
          return nNumber;
        }
        return Math.floor(nNumber * 1e3) / 1e3;
      };
      return Drawing2;
    }();
    function _getTypeNumber(sText, nCorrectLevel) {
      var nType = 1;
      var length = _getUTF8Length(sText);
      for (var i2 = 0, len = QRCodeLimitLength.length; i2 <= len; i2++) {
        var nLimit = 0;
        switch (nCorrectLevel) {
          case QRErrorCorrectLevel.L:
            nLimit = QRCodeLimitLength[i2][0];
            break;
          case QRErrorCorrectLevel.M:
            nLimit = QRCodeLimitLength[i2][1];
            break;
          case QRErrorCorrectLevel.Q:
            nLimit = QRCodeLimitLength[i2][2];
            break;
          case QRErrorCorrectLevel.H:
            nLimit = QRCodeLimitLength[i2][3];
            break;
        }
        if (length <= nLimit) {
          break;
        } else {
          nType++;
        }
      }
      if (nType > QRCodeLimitLength.length) {
        throw new Error("Too long data");
      }
      return nType;
    }
    function _getUTF8Length(sText) {
      var replacedText = encodeURI(sText).toString().replace(/\%[0-9a-fA-F]{2}/g, "a");
      return replacedText.length + (replacedText.length != sText ? 3 : 0);
    }
    QRCode2 = function(el2, vOption) {
      this._htOption = {
        width: 256,
        height: 256,
        typeNumber: 4,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRErrorCorrectLevel.H
      };
      if (typeof vOption === "string") {
        vOption = {
          text: vOption
        };
      }
      if (vOption) {
        for (var i2 in vOption) {
          this._htOption[i2] = vOption[i2];
        }
      }
      if (typeof el2 == "string") {
        el2 = document.getElementById(el2);
      }
      if (this._htOption.useSVG) {
        Drawing = svgDrawer;
      }
      this._android = _getAndroid();
      this._el = el2;
      this._oQRCode = null;
      this._oDrawing = new Drawing(this._el, this._htOption);
      if (this._htOption.text) {
        this.makeCode(this._htOption.text);
      }
    };
    QRCode2.prototype.makeCode = function(sText) {
      this._oQRCode = new QRCodeModel(_getTypeNumber(sText, this._htOption.correctLevel), this._htOption.correctLevel);
      this._oQRCode.addData(sText);
      this._oQRCode.make();
      this._el.title = sText;
      this._oDrawing.draw(this._oQRCode);
      this.makeImage();
    };
    QRCode2.prototype.makeImage = function() {
      if (typeof this._oDrawing.makeImage == "function" && (!this._android || this._android >= 3)) {
        this._oDrawing.makeImage();
      }
    };
    QRCode2.prototype.clear = function() {
      this._oDrawing.clear();
    };
    QRCode2.CorrectLevel = QRErrorCorrectLevel;
    return QRCode2;
  });
})(qrcode$1);
var QRCode = qrcode$1.exports;
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("div", {
    staticClass: "code_wrapper"
  }, [_c("div", {
    ref: "omni-qrcode",
    attrs: {
      "id": "omni-qrcode"
    }
  })]), _c("p", {
    staticClass: "qrcode_tip"
  }, [_vm._v(_vm._s(_vm.$_t("\u8BF7\u626B\u7801\u4E0B\u8F7D")))])]);
};
var staticRenderFns$s = [];
var qrcode_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$s = defineComponent({
  name: "selectMenu",
  props: {
    text: {
      type: String,
      require: true
    },
    size: {
      type: Number,
      require: false
    }
  },
  data() {
    return {
      theme: "light",
      qrcode: null
    };
  },
  computed: {
    isThemeLight() {
      return this.theme === "light";
    }
  },
  mounted() {
    this.initTheme();
    this.initQrCode();
  },
  methods: {
    initTheme() {
      this.theme = getThemeColor();
    },
    initQrCode() {
      this.qrcode = new QRCode(this.$refs["omni-qrcode"], {
        text: this.text,
        width: this.size,
        height: this.size,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
    }
  }
});
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent(
  __vue2_script$s,
  render$t,
  staticRenderFns$s,
  false,
  __vue2_injectStyles$s,
  "321f7221",
  null,
  null
);
function __vue2_injectStyles$s(context) {
  for (let o2 in __cssModules$s) {
    this[o2] = __cssModules$s[o2];
  }
}
var qrcode = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_10675_19132"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_10675_19132)"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M7.75736,7.75736Q6,9.51472,6,12Q6,14.48528,7.75736,16.2426Q9.51472,18,12,18Q14.48528,18,16.2426,16.2426Q18,14.48528,18,12Q18,9.51472,16.2426,7.75736Q14.48528,6,12,6Q9.51472,6,7.75736,7.75736ZM8.46447,15.53553Q7,14.07107,7,12Q7,9.92893,8.46447,8.46447Q9.92893,7,12,7Q14.07107,7,15.53553,8.46447Q17,9.92893,17,12Q17,14.07107,15.53553,15.53553Q14.07107,17,12,17Q9.92893,17,8.46447,15.53553ZM13.53073,15.69552Q12.79565,16,12,16L12,8Q12.79565,8,13.53073,8.30448C14.02079,8.50747,14.45335,8.7965,14.82843,9.17157Q15.39104,9.73418,15.69552,10.46927Q16,11.20435,16,12Q16,12.79565,15.69552,13.53073C15.49253,14.02079,15.2035,14.45335,14.82843,14.82843Q14.26582,15.39104,13.53073,15.69552Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$r = [];
const __vue2_script$r = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent(
  __vue2_script$r,
  render$s,
  staticRenderFns$r,
  false,
  __vue2_injectStyles$r,
  null,
  null,
  null
);
function __vue2_injectStyles$r(context) {
  for (let o2 in __cssModules$r) {
    this[o2] = __cssModules$r[o2];
  }
}
var colormodeIcon = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_10464_08031"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })]), _c("clipPath", {
    attrs: {
      "id": "master_svg1_10483_08692"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_10464_08031)"
    }
  }, [_c("g", {
    attrs: {
      "clip-path": "url(#master_svg1_10483_08692)"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M15,7.5L16.5,7.5Q17.1212,7.49999114871,17.560499999999998,7.939331Q18,8.378679,18,9L18,15Q17.9998,15.8284,17.414099999999998,16.41418Q16.828400000000002,17,16,17L8,17Q7.1717200000000005,16.999969999999998,6.585938,16.41418Q6,15.82843,6,15L6,9Q6.000113279,8.378671,6.439453,7.939331Q6.87868,7.5,7.5,7.5L9,7.5L9,8.5L7.5,8.5Q7.29293,8.499977,7.14648,8.646419999999999Q7,8.79289,7,9L7,15Q7.0000800000000005,15.414200000000001,7.29297,15.70709Q7.58579,16,8,16L16,16Q16.414099999999998,15.99998,16.707,15.70709Q17,15.41421,17,15L17,9Q17,8.79287,16.8535,8.646419999999999Q16.7071,8.5,16.5,8.5L15,8.5L15,7.5ZM12.5,7.5L12.5,12.53693L13.76822,11.26788L14.47556,11.97476L12.00207,14.449860000000001L9.52708,11.97487L10.23419,11.26777L11.5,12.53358L11.5,7.5L12.5,7.5Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])])])])]);
};
var staticRenderFns$q = [];
const __vue2_script$q = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent(
  __vue2_script$q,
  render$r,
  staticRenderFns$q,
  false,
  __vue2_injectStyles$q,
  null,
  null,
  null
);
function __vue2_injectStyles$q(context) {
  for (let o2 in __cssModules$q) {
    this[o2] = __cssModules$q[o2];
  }
}
var downloadIcon = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_10675_05875"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })]), _c("clipPath", {
    attrs: {
      "id": "master_svg1_10675_05881"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_10675_05875)"
    }
  }, [_c("g", {
    attrs: {
      "clip-path": "url(#master_svg1_10675_05881)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M13.5,15.5L15.5,15.5Q15.91421,15.5,16.20711,15.20711Q16.5,14.91421,16.5,14.5L16.5,8.5Q16.5,8.08579,16.20711,7.792893Q15.91421,7.5,15.5,7.5L8.5,7.5Q8.08579,7.5,7.792893,7.792893Q7.5,8.08579,7.5,8.5L7.5,14.5Q7.5,14.91421,7.792893,15.20711Q8.08579,15.5,8.5,15.5L10.5,15.5Q10.65139,15.5,10.77735,15.58397L12.27735,16.58397L12,17L11.72265,16.58397L13.22265,15.58397Q13.34861,15.5,13.5,15.5ZM13.5,16.5L13.5,16L13.77735,16.41603L12.27735,17.416Q12.21575,17.4571,12.14489,17.4785Q12.07403,17.5,12,17.5Q11.92597,17.5,11.85511,17.4785Q11.78425,17.4571,11.72265,17.416L10.22265,16.41603L10.5,16L10.5,16.5L8.5,16.5Q7.671572,16.5,7.0857865,15.91421Q6.5,15.32843,6.5,14.5L6.5,8.5Q6.5,7.671573,7.0857865,7.0857865Q7.671573,6.5,8.5,6.5L15.5,6.5Q16.32843,6.5,16.91421,7.0857865Q17.5,7.671572,17.5,8.5L17.5,14.5Q17.5,15.32843,16.91421,15.91421Q16.32843,16.5,15.5,16.5L13.5,16.5Z",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M11.5,13.25L11.5,9.75L12.5,9.75L12.5,13.25L11.5,13.25ZM12.5,13.25Q12.5,13.29925,12.490393,13.34754Q12.480785000000001,13.39584,12.46194,13.44134Q12.443094,13.48684,12.415735,13.52778Q12.388375,13.56873,12.353553,13.60355Q12.318731,13.63838,12.277785,13.66573Q12.236839,13.69309,12.191342,13.71194Q12.145845,13.73078,12.0975451,13.74039Q12.0492457,13.75,12,13.75Q11.9507543,13.75,11.9024549,13.74039Q11.854155,13.73078,11.808658,13.71194Q11.763161,13.69309,11.722215,13.66573Q11.681269,13.63838,11.646447,13.60355Q11.611625,13.56873,11.584265,13.52778Q11.556906,13.48684,11.53806,13.44134Q11.519214999999999,13.39584,11.509607,13.34754Q11.5,13.29925,11.5,13.25Q11.5,13.20075,11.509607,13.15245Q11.519214999999999,13.10415,11.53806,13.05866Q11.556906,13.01316,11.584265,12.97221Q11.611625,12.93127,11.646447,12.89645Q11.681269,12.86162,11.722215,12.83426Q11.763161,12.80691,11.808658,12.78806Q11.854155,12.769210000000001,11.9024549,12.75961Q11.9507543,12.75,12,12.75Q12.0492457,12.75,12.0975451,12.75961Q12.145845,12.769210000000001,12.191342,12.78806Q12.236839,12.80691,12.277785,12.83426Q12.318731,12.86162,12.353553,12.89645Q12.388375,12.93127,12.415735,12.97221Q12.443094,13.01316,12.46194,13.05866Q12.480785000000001,13.10415,12.490393,13.15245Q12.5,13.20075,12.5,13.25ZM12.5,9.75Q12.5,9.7992457,12.490393,9.8475451Q12.480785000000001,9.895845,12.46194,9.941342Q12.443094,9.986839,12.415735,10.027785Q12.388375,10.068731,12.353553,10.103553Q12.318731,10.138375,12.277785,10.165735Q12.236839,10.193094,12.191342,10.21194Q12.145845,10.230785000000001,12.0975451,10.240393Q12.0492457,10.25,12,10.25Q11.9507543,10.25,11.9024549,10.240393Q11.854155,10.230785000000001,11.808658,10.21194Q11.763161,10.193094,11.722215,10.165735Q11.681269,10.138375,11.646447,10.103553Q11.611625,10.068731,11.584265,10.027785Q11.556906,9.986839,11.53806,9.941342Q11.519214999999999,9.895845,11.509607,9.8475451Q11.5,9.7992457,11.5,9.75Q11.5,9.7007543,11.509607,9.6524549Q11.519214999999999,9.604155,11.53806,9.558658Q11.556906,9.513161,11.584265,9.472215Q11.611625,9.431269,11.646447,9.396447Q11.681269,9.361625,11.722215,9.334265Q11.763161,9.306906,11.808658,9.28806Q11.854155,9.269214999999999,11.9024549,9.259607Q11.9507543,9.25,12,9.25Q12.0492457,9.25,12.0975451,9.259607Q12.145845,9.269214999999999,12.191342,9.28806Q12.236839,9.306906,12.277785,9.334265Q12.318731,9.361625,12.353553,9.396447Q12.388375,9.431269,12.415735,9.472215Q12.443094,9.513161,12.46194,9.558658Q12.480785000000001,9.604155,12.490393,9.6524549Q12.5,9.7007543,12.5,9.75Z",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "transform": "matrix(0,1,-1,0,23.25,-3.75)"
    }
  }, [_c("path", {
    attrs: {
      "d": "M13,12.75L13,9.75L14,9.75L14,12.75L13,12.75ZM14,12.75Q14,12.79925,13.990393,12.84754Q13.980785000000001,12.89584,13.96194,12.94134Q13.943094,12.98684,13.915735,13.02778Q13.888375,13.06873,13.853553,13.10355Q13.818731,13.13837,13.777785,13.16573Q13.736839,13.19309,13.691342,13.21194Q13.645845,13.23078,13.5975451,13.24039Q13.5492457,13.25,13.5,13.25Q13.4507543,13.25,13.4024549,13.24039Q13.354155,13.23078,13.308658,13.21194Q13.263161,13.19309,13.222215,13.16573Q13.181269,13.13837,13.146447,13.10355Q13.111625,13.06873,13.084265,13.02778Q13.056906,12.98684,13.03806,12.94134Q13.019214999999999,12.89584,13.009607,12.84754Q13,12.79925,13,12.75Q13,12.70075,13.009607,12.65245Q13.019214999999999,12.60415,13.03806,12.55866Q13.056906,12.51316,13.084265,12.47221Q13.111625,12.43127,13.146447,12.39645Q13.181269,12.36162,13.222215,12.33426Q13.263161,12.30691,13.308658,12.28806Q13.354155,12.269210000000001,13.4024549,12.25961Q13.4507543,12.25,13.5,12.25Q13.5492457,12.25,13.5975451,12.25961Q13.645845,12.269210000000001,13.691342,12.28806Q13.736839,12.30691,13.777785,12.33426Q13.818731,12.36162,13.853553,12.39645Q13.888375,12.43127,13.915735,12.47221Q13.943094,12.51316,13.96194,12.55866Q13.980785000000001,12.60415,13.990393,12.65245Q14,12.70075,14,12.75ZM14,9.75Q14,9.7992457,13.990393,9.8475451Q13.980785000000001,9.895845,13.96194,9.941342Q13.943094,9.986839,13.915735,10.027785Q13.888375,10.068731,13.853553,10.103553Q13.818731,10.138375,13.777785,10.165735Q13.736839,10.193094,13.691342,10.21194Q13.645845,10.230785000000001,13.5975451,10.240393Q13.5492457,10.25,13.5,10.25Q13.4507543,10.25,13.4024549,10.240393Q13.354155,10.230785000000001,13.308658,10.21194Q13.263161,10.193094,13.222215,10.165735Q13.181269,10.138375,13.146447,10.103553Q13.111625,10.068731,13.084265,10.027785Q13.056906,9.986839,13.03806,9.941342Q13.019214999999999,9.895845,13.009607,9.8475451Q13,9.7992457,13,9.75Q13,9.7007543,13.009607,9.6524549Q13.019214999999999,9.604155,13.03806,9.558658Q13.056906,9.513161,13.084265,9.472215Q13.111625,9.431269,13.146447,9.396447Q13.181269,9.361625,13.222215,9.334265Q13.263161,9.306906,13.308658,9.28806Q13.354155,9.269214999999999,13.4024549,9.259607Q13.4507543,9.25,13.5,9.25Q13.5492457,9.25,13.5975451,9.259607Q13.645845,9.269214999999999,13.691342,9.28806Q13.736839,9.306906,13.777785,9.334265Q13.818731,9.361625,13.853553,9.396447Q13.888375,9.431269,13.915735,9.472215Q13.943094,9.513161,13.96194,9.558658Q13.980785000000001,9.604155,13.990393,9.6524549Q14,9.7007543,14,9.75Z",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  })])])])])])]);
};
var staticRenderFns$p = [];
const __vue2_script$p = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent(
  __vue2_script$p,
  render$q,
  staticRenderFns$p,
  false,
  __vue2_injectStyles$p,
  null,
  null,
  null
);
function __vue2_injectStyles$p(context) {
  for (let o2 in __cssModules$p) {
    this[o2] = __cssModules$p[o2];
  }
}
var fontIcon = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_14563_05605/10675_05855"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })]), _c("clipPath", {
    attrs: {
      "id": "master_svg1_14563_05605/10675_05861"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_14563_05605/10675_05855)"
    }
  }, [_c("g", {
    attrs: {
      "clip-path": "url(#master_svg1_14563_05605/10675_05861)"
    }
  }, [_c("g", [_c("g", [_c("g", [_c("rect", {
    attrs: {
      "x": "8.00048828125",
      "y": "7",
      "width": "8",
      "height": "10",
      "rx": "1.5",
      "fill-opacity": "0",
      "stroke-opacity": "0.8500000238418579",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-width": "1"
    }
  })])])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M10 7.5C10 7.5 10 7.5 10 7.5L14 7.5C14 7.5 14 7.5 14 7.5L14 7.875C14 8.082106781186548 13.832106781186548 8.25 13.625 8.25L10.375 8.25C10.167893218813452 8.25 10 8.082106781186548 10 7.875Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("ellipse", {
    attrs: {
      "cx": "12",
      "cy": "15",
      "rx": "0.5",
      "ry": "0.5",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  })])])])])])]);
};
var staticRenderFns$o = [];
const __vue2_script$o = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent(
  __vue2_script$o,
  render$p,
  staticRenderFns$o,
  false,
  __vue2_injectStyles$o,
  null,
  null,
  null
);
function __vue2_injectStyles$o(context) {
  for (let o2 in __cssModules$o) {
    this[o2] = __cssModules$o[o2];
  }
}
var mobileIcon = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_76_66"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "rx": "0"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_76_66)"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M14.5,15L14.5,16Q14.5,16.621299999999998,14.06066,17.0607Q13.62132,17.5,13,17.5L8.5,17.5Q7.878679,17.5,7.43934,17.0607Q7,16.621299999999998,7,16L7,8Q7,7.37868,7.43934,6.93934Q7.87868,6.5,8.5,6.5L13,6.5Q13.62132,6.5,14.06066,6.93934Q14.5,7.37868,14.5,8L14.5,9L13.5,9L13.5,8Q13.5,7.79289,13.35355,7.64645Q13.20711,7.5,13,7.5L8.5,7.5Q8.29289,7.5,8.14645,7.64645Q8,7.79289,8,8L8,16Q8,16.20711,8.14645,16.35355Q8.29289,16.5,8.5,16.5L13,16.5Q13.20711,16.5,13.35355,16.35355Q13.5,16.20711,13.5,16L13.5,15L14.5,15ZM15.14645,14.14645L17.6464,11.64645L18,12L17.6464,12.35355L15.14645,9.85355L15.85355,9.14645L18.7071,12L15.85355,14.85355L15.14645,14.14645ZM18,12.5L11,12.5L11,11.5L18,11.5L18,12.5Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])])])]);
};
var staticRenderFns$n = [];
const __vue2_script$n = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent(
  __vue2_script$n,
  render$o,
  staticRenderFns$n,
  false,
  __vue2_injectStyles$n,
  null,
  null,
  null
);
function __vue2_injectStyles$n(context) {
  for (let o2 in __cssModules$n) {
    this[o2] = __cssModules$n[o2];
  }
}
var logoutIcon = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "4",
      "height": "6",
      "viewBox": "0 0 4 6"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M0,5C0,5.41202,0.470382,5.64721,0.8,5.4L3.46667,3.4C3.73333,3.2,3.73333,2.8,3.46667,2.6L0.8,0.6C0.470382,0.352786,0,0.587977,0,1L0,5Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])]);
};
var staticRenderFns$m = [];
const __vue2_script$m = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent(
  __vue2_script$m,
  render$n,
  staticRenderFns$m,
  false,
  __vue2_injectStyles$m,
  null,
  null,
  null
);
function __vue2_injectStyles$m(context) {
  for (let o2 in __cssModules$m) {
    this[o2] = __cssModules$m[o2];
  }
}
var moreIcon = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("ellipse", {
    attrs: {
      "cx": "12",
      "cy": "9.5",
      "rx": "2.5",
      "ry": "2.5",
      "fill-opacity": "0",
      "stroke-opacity": "1",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-width": "1"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M6,17.5Q6,16.05025,7.025126,15.025126Q8.05025,14,9.5,14L14.5,14Q15.94975,14,16.974899999999998,15.025126Q18,16.05025,18,17.5L17,17.5Q17,16.46447,16.26777,15.73223Q15.53553,15,14.5,15L9.5,15Q8.46447,15,7.7322299999999995,15.73223Q7,16.46447,7,17.5L6,17.5Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$l = [];
const __vue2_script$l = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(
  __vue2_script$l,
  render$m,
  staticRenderFns$l,
  false,
  __vue2_injectStyles$l,
  null,
  null,
  null
);
function __vue2_injectStyles$l(context) {
  for (let o2 in __cssModules$l) {
    this[o2] = __cssModules$l[o2];
  }
}
var settingIcon = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_76_215"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_76_215)"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M7.75736,7.75736Q6,9.51472,6,12Q6,14.48528,7.75736,16.2426Q9.51472,18,12,18Q14.48528,18,16.2426,16.2426Q18,14.48528,18,12Q18,9.51472,16.2426,7.75736Q14.48528,6,12,6Q9.51472,6,7.75736,7.75736ZM10.82727,7.1282700000000006Q9.49553,7.43341,8.46447,8.46447Q7.18002,9.74891,7.02213,11.5L9.019,11.5Q9.18634,9.30005,10.82727,7.1282700000000006ZM7.02213,12.5Q7.18002,14.25109,8.46447,15.53553Q9.49553,16.5666,10.82727,16.8717Q9.18634,14.69995,9.019,12.5L7.02213,12.5ZM13.17273,16.8717Q14.50447,16.5666,15.53553,15.53553Q16.82,14.25109,16.977899999999998,12.5L14.981,12.5Q14.81366,14.69995,13.17273,16.8717ZM16.977899999999998,11.5L14.981,11.5Q14.81366,9.30005,13.17273,7.1282700000000006Q14.50447,7.43341,15.53553,8.46447Q16.82,9.74891,16.977899999999998,11.5ZM10.02262,11.5Q10.212679999999999,9.39706,12,7.26023Q13.787320000000001,9.39706,13.97738,11.5L10.02262,11.5ZM12,16.739800000000002Q10.212679999999999,14.60294,10.02262,12.5L13.97738,12.5Q13.787320000000001,14.60294,12,16.739800000000002Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])])]);
};
var staticRenderFns$k = [];
const __vue2_script$k = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(
  __vue2_script$k,
  render$l,
  staticRenderFns$k,
  false,
  __vue2_injectStyles$k,
  null,
  null,
  null
);
function __vue2_injectStyles$k(context) {
  for (let o2 in __cssModules$k) {
    this[o2] = __cssModules$k[o2];
  }
}
var websiteIcon = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_14563_05598/10675_05846"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })]), _c("clipPath", {
    attrs: {
      "id": "master_svg1_14563_05598/10675_05848"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_14563_05598/10675_05846)"
    }
  }, [_c("g", {
    attrs: {
      "clip-path": "url(#master_svg1_14563_05598/10675_05848)"
    }
  }, [_c("g", [_c("g", [_c("g", [_c("rect", {
    attrs: {
      "x": "7.00048828125",
      "y": "7",
      "width": "10",
      "height": "7.5",
      "rx": "1.5",
      "fill-opacity": "0",
      "stroke-opacity": "0.8500000238418579",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-width": "1"
    }
  })]), _c("g", [_c("rect", {
    attrs: {
      "x": "8.00048828125",
      "y": "16",
      "width": "8",
      "height": "1",
      "rx": "0.30000001192092896",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M10 7.5C10 7.5 10 7.5 10 7.5L14 7.5C14 7.5 14 7.5 14 7.5L14 7.75C14 7.888071187457698 13.8880711874577 8 13.75 8L10.25 8C10.1119288125423 8 10 7.888071187457698 10 7.75Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])])])]);
};
var staticRenderFns$j = [];
const __vue2_script$j = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(
  __vue2_script$j,
  render$k,
  staticRenderFns$j,
  false,
  __vue2_injectStyles$j,
  null,
  null,
  null
);
function __vue2_injectStyles$j(context) {
  for (let o2 in __cssModules$j) {
    this[o2] = __cssModules$j[o2];
  }
}
var pcIcon = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_14563_05521"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "rx": "0"
    }
  })]), _c("clipPath", {
    attrs: {
      "id": "master_svg1_14563_05523"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "rx": "0"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_14563_05521)"
    }
  }, [_c("g", {
    attrs: {
      "clip-path": "url(#master_svg1_14563_05523)"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M17.99976356496811,12.00028818359375L14.999723564968109,6.80413818359375L8.999723564968109,6.80413818359375L5.9997269509681095,12.00028818359375L8.999723564968109,17.19643818359375L14.999723564968109,17.19643818359375L17.99976356496811,12.00028818359375ZM16.845063564968108,12.00028818359375L14.42237356496811,7.80413818359375L9.57707356496811,7.80413818359375L7.154423564968109,12.00028818359375L9.57707356496811,16.196448183593752L14.42237356496811,16.196448183593752L16.845063564968108,12.00028818359375Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M11.5,14.5L11.5,12L12.5,12L12.5,14.5L11.5,14.5Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M9.757248,10.071254L12.257249999999999,11.57125L11.742750000000001,12.42875L9.242752,10.928746L9.757248,10.071254Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M11.742752,11.57125L14.242750000000001,10.071254L14.757249999999999,10.928746L12.257248,12.42875L11.742752,11.57125Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])])]);
};
var staticRenderFns$i = [];
const __vue2_script$i = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(
  __vue2_script$i,
  render$j,
  staticRenderFns$i,
  false,
  __vue2_injectStyles$i,
  null,
  null,
  null
);
function __vue2_injectStyles$i(context) {
  for (let o2 in __cssModules$i) {
    this[o2] = __cssModules$i[o2];
  }
}
var workspaceIcon = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M14,13.7L14,16.4Q14,16,13.6,16L16.9,16Q16.5,16,16.5,16.4L16.5,10.05662Q16.5,10.283100000000001,16.694200000000002,10.39962L11.7942,7.4596160000000005Q12,7.583095,12.2058,7.4596160000000005L7.305798,10.39962Q7.5,10.28309,7.5,10.05662L7.5,16.4Q7.5,16,7.1,16L10.4,16Q10.23431,16,10.11716,16.11716Q10,16.23432,10,16.4L10,13.7Q10,13.41005,10.20503,13.205020000000001Q10.41005,13,10.7,13L13.3,13Q13.58995,13,13.79497,13.20503Q14,13.41005,14,13.7ZM13,13.7Q13,14,13.3,14L10.7,14Q11,14,11,13.7L11,16.4Q11,16.64853,10.82427,16.824260000000002Q10.648530000000001,17,10.4,17L7.1,17Q6.851471,17,6.6757349999999995,16.824260000000002Q6.5,16.64853,6.5,16.4L6.5,10.05662Q6.5,9.71691,6.791302,9.54212L11.6913,6.602123Q12,6.416904,12.3087,6.602123L17.2087,9.54212Q17.5,9.716899999999999,17.5,10.05662L17.5,16.4Q17.5,16.64853,17.3243,16.824260000000002Q17.1485,17,16.9,17L13.6,17Q13.351469999999999,17,13.17573,16.824260000000002Q13,16.64853,13,16.4L13,13.7Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$h = [];
const __vue2_script$h = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(
  __vue2_script$h,
  render$i,
  staticRenderFns$h,
  false,
  __vue2_injectStyles$h,
  null,
  null,
  null
);
function __vue2_injectStyles$h(context) {
  for (let o2 in __cssModules$h) {
    this[o2] = __cssModules$h[o2];
  }
}
var profileIcon = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_76_226"
    }
  }, [_c("rect", {
    attrs: {
      "x": "6",
      "y": "6",
      "width": "12",
      "height": "12",
      "rx": "0"
    }
  })])]), _c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "clip-path": "url(#master_svg0_76_226)"
    }
  }, [_c("g", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    }
  }, [_c("path", {
    attrs: {
      "d": "M9.48071,9.626999999999999L11.500779999999999,6.597418Q11.67892,6.330252,12.000029999999999,6.330278Q12.32114,6.330303,12.49924,6.597497L14.51861,9.62707L14.10256,9.90439L14.22279,9.41906L17.465899999999998,10.22243Q17.787599999999998,10.30212,17.8914,10.61685Q17.9953,10.93159,17.784100000000002,11.187059999999999L15.53943,13.903030000000001L15.15403,13.5845L15.65289,13.55079L15.88682,17.0118Q15.90972,17.3505,15.63112,17.544600000000003Q15.35252,17.7387,15.04272,17.599800000000002L11.795079999999999,16.14367L11.99964,15.68743L12.204229999999999,16.14365L8.94633,17.6047Q8.6486,17.7382,8.3747,17.5608Q8.10081,17.383499999999998,8.10082,17.0572L8.10087,13.5845L8.60087,13.5845L8.19897,13.88196L6.187291,11.16394Q5.9963180000000005,10.90591,6.104998,10.603860000000001Q6.213678,10.30181,6.5252674,10.2246L9.77647,9.41906L9.89672,9.90439L9.48071,9.626999999999999ZM10.20516,10.34308L6.765765,11.19525Q6.973491,11.14379,7.045945,10.94242Q7.118398,10.74105,6.991083,10.56903L9.10087,13.419599999999999L9.10082,17.0572Q9.10082,16.8397,8.91822,16.721420000000002Q8.73563,16.603189999999998,8.53714,16.6922L11.99962,15.13946L15.45183,16.687269999999998Q15.24529,16.59467,15.05957,16.724040000000002Q14.87383,16.8534,14.8891,17.0792L14.64173,13.4195L17.0133,10.55Q16.8726,10.72031,16.9418,10.93014Q17.011,11.13996,17.2255,11.19309L13.79409,10.34308L11.66715,7.152131Q11.785879999999999,7.330261,11.99995,7.330278Q12.214030000000001,7.330294,12.33279,7.152184L10.31272,10.18177L10.20516,10.34308Z",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])]);
};
var staticRenderFns$g = [];
const __vue2_script$g = {
  name: "AddCircleIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(
  __vue2_script$g,
  render$h,
  staticRenderFns$g,
  false,
  __vue2_injectStyles$g,
  null,
  null,
  null
);
function __vue2_injectStyles$g(context) {
  for (let o2 in __cssModules$g) {
    this[o2] = __cssModules$g[o2];
  }
}
var starIcon = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_1_0"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "rx": "0"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_1_0)"
    }
  }, [_c("g", [_c("g", [_c("g", [_c("path", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "d": "M6,10.645434030666351L6,7.843694030666351C6,7.263437030666351,6.470391,6.793044030666351,7.05065,6.793044030666351L9.85237,6.793044030666351C10.43263,6.793044030666351,10.90302,7.263437030666351,10.90302,7.843694030666351L10.90302,10.645434030666351C10.90302,11.22569403066635,10.43263,11.696084030666352,9.85237,11.696084030666352L7.05065,11.696084030666352C6.470391,11.696084030666352,6,11.22569403066635,6,10.645434030666351ZM7.05065,10.645434030666351L9.85237,10.645434030666351L9.85237,7.843694030666351L7.05065,7.843694030666351L7.05065,10.645434030666351Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])]), _c("g", [_c("g", [_c("path", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "d": "M6,16.949346729888916L6,14.147606729888917C6,13.567349729888916,6.470391,13.096956729888916,7.05065,13.096956729888916L9.85237,13.096956729888916C10.43263,13.096956729888916,10.90302,13.567349729888916,10.90302,14.147606729888917L10.90302,16.949346729888916C10.90302,17.529606729888915,10.43263,17.999996729888917,9.85237,17.999996729888917L7.05065,17.999996729888917C6.470391,17.999996729888917,6,17.529606729888915,6,16.949346729888916ZM7.05065,16.949346729888916L9.85237,16.949346729888916L9.85237,14.147606729888917L7.05065,14.147606729888917L7.05065,16.949346729888916Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])]), _c("g", {
    attrs: {
      "transform": "matrix(0.7071049809455872,0.7071085572242737,-0.7071049809455872,0.7071085572242737,8.56439620353865,-8.67628027821786)"
    }
  }, [_c("g", [_c("path", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "d": "M14.755342483520508,9.53783L14.755342483520508,7.05065C14.755342483520508,6.470392,15.225734483520508,6,15.805992483520509,6L18.293342483520508,6C18.873602483520507,6,19.34399248352051,6.470392,19.34399248352051,7.05065L19.34399248352051,9.53783C19.34399248352051,10.118089999999999,18.873602483520507,10.58848,18.293342483520508,10.58848L15.805992483520509,10.58848C15.225734483520508,10.58848,14.755342483520508,10.118089999999999,14.755342483520508,9.53783ZM15.805992483520509,9.53783L18.293342483520508,9.53783L18.293342483520508,7.05065L15.805992483520509,7.05065L15.805992483520509,9.53783Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])]), _c("g", [_c("g", [_c("path", {
    staticStyle: {
      "mix-blend-mode": "passthrough"
    },
    attrs: {
      "d": "M12.303882122039795,16.949346729888916L12.303882122039795,14.147606729888917C12.303882122039795,13.567349729888916,12.774273122039794,13.096956729888916,13.354532122039796,13.096956729888916L16.156252122039795,13.096956729888916C16.736512122039795,13.096956729888916,17.206902122039793,13.567349729888916,17.206902122039793,14.147606729888917L17.206902122039793,16.949346729888916C17.206902122039793,17.529606729888915,16.736512122039795,17.999996729888917,16.156252122039795,17.999996729888917L13.354532122039796,17.999996729888917C12.774273122039794,17.999996729888917,12.303882122039795,17.529606729888915,12.303882122039795,16.949346729888916ZM13.354532122039796,16.949346729888916L16.156252122039795,16.949346729888916L16.156252122039795,14.147606729888917L13.354532122039796,14.147606729888917L13.354532122039796,16.949346729888916Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])])])]);
};
var staticRenderFns$f = [];
const __vue2_script$f = {};
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(
  __vue2_script$f,
  render$g,
  staticRenderFns$f,
  false,
  __vue2_injectStyles$f,
  null,
  null,
  null
);
function __vue2_injectStyles$f(context) {
  for (let o2 in __cssModules$f) {
    this[o2] = __cssModules$f[o2];
  }
}
var communityIcon = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_45_4193"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "rx": "0.6000000238418579"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_45_4193)"
    }
  }, [_c("g", {
    attrs: {
      "transform": "matrix(0.7071067690849304,-0.7071068286895752,0.7071068286895752,0.7071067690849304,-9.410030064493185,7.817824349462171)"
    }
  }, [_c("path", {
    attrs: {
      "d": "M18.19253359375,19.156492265625L17.13113359375,20.218002265625L17.83833359375,20.925062265625L18.89963359375,19.863552265625Q19.63173359375,19.131352265625,19.63173359375,18.095942265625Q19.631833593750002,17.060532265625,18.89973359375,16.328322265625L17.83893359375,15.267331123625L17.13173359375,15.974368265625L18.19253359375,17.035352265625Q18.631833593750002,17.474682265625,18.63173359375,18.095932265625Q18.63173359375,18.717172265625,18.19253359375,19.156492265625ZM5.46384259375,19.863122265625L6.52507359375,20.924562265625L7.23225359375,20.217522265625L6.17102359375,19.156082265625Q5.73177059375,18.716752265625,5.73178359375,18.095492265625Q5.73179859375,17.474232265624998,6.17107359375,17.034922265625L7.23150359375,15.974385265625L6.5243635937499995,15.267313718625L5.46392959375,16.327852265625Q4.73180675475,17.060042265625,4.73178291275,18.095462265625Q4.73176002475,19.130892265625,5.46384259375,19.863122265625Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", [_c("path", {
    attrs: {
      "d": "M9.005736328125,6.982137875C9.005736328125,6.982137875,9.005736328125,5.998046875,9.005736328125,5.998046875C9.005736328125,5.998046875,10.005736328125,5.998046875,10.005736328125,5.998046875C10.005736328125,5.998046875,10.005736328125,6.982137875,10.005736328125,6.982137875C10.005736328125,6.982137875,12.505736328125,6.982137875,12.505736328125,6.982137875C12.505736328125,6.982137875,12.505736328125,11.059046875,12.505736328125,11.059046875C12.505736328125,11.059046875,11.505736328125,11.059046875,11.505736328125,11.059046875C11.505736328125,11.059046875,11.505736328125,10.637396875,11.505736328125,10.637396875C11.505736328125,10.637396875,10.005736328125,10.637396875,10.005736328125,10.637396875C10.005736328125,10.637396875,10.005736328125,12.889806875,10.005736328125,12.889806875C10.005736328125,12.889806875,9.005736328125,12.889806875,9.005736328125,12.889806875C9.005736328125,12.889806875,9.005736328125,10.637396875,9.005736328125,10.637396875C9.005736328125,10.637396875,7.505737328125,10.637396875,7.505737328125,10.637396875C7.505737328125,10.637396875,7.505737328125,11.059046875,7.505737328125,11.059046875C7.505737328125,11.059046875,6.505737308125,11.059046875,6.505737308125,11.059046875C6.505737308125,11.059046875,6.505737308125,6.982137875,6.505737308125,6.982137875C6.505737308125,6.982137875,9.005736328125,6.982137875,9.005736328125,6.982137875C9.005736328125,6.982137875,9.005736328125,6.982137875,9.005736328125,6.982137875ZM7.505737328125,7.966466875C7.505737328125,7.966466875,7.505737328125,9.793856875,7.505737328125,9.793856875C7.505737328125,9.793856875,9.005736328125,9.818366875,9.005736328125,9.818366875C9.005736328125,9.818366875,9.005736328125,7.966466875,9.005736328125,7.966466875C9.005736328125,7.966466875,7.505737328125,7.966466875,7.505737328125,7.966466875C7.505737328125,7.966466875,7.505737328125,7.966466875,7.505737328125,7.966466875ZM10.005736328125,7.966466875C10.005736328125,7.966466875,10.005736328125,9.793856875,10.005736328125,9.793856875C10.005736328125,9.793856875,11.505736328125,9.793856875,11.505736328125,9.793856875C11.505736328125,9.793856875,11.505736328125,7.966466875,11.505736328125,7.966466875C11.505736328125,7.966466875,10.005736328125,7.966466875,10.005736328125,7.966466875C10.005736328125,7.966466875,10.005736328125,7.966466875,10.005736328125,7.966466875Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })]), _c("g", [_c("path", {
    attrs: {
      "d": "M13.840358984375,11.741350875L11.574241984375,17.668021875C11.524174784375,17.798971875,11.620863984375,17.939451875,11.761051984375,17.939451875L12.331505984375,17.939451875C12.499778984375,17.939451875,12.650058984375,17.834141875,12.707488984375,17.675971875000002L13.205318984375,16.304931875L15.935548984375,16.304931875L16.433378984375,17.675971875000002C16.490808984375,17.834141875,16.641088984375,17.939451875,16.809358984375,17.939451875L17.379818984375,17.939451875C17.520008984375,17.939451875,17.616698984375,17.798971875,17.566628984375,17.668031875L15.300628984374999,11.741358875C15.226618984375,11.547776875,15.040848984375,11.419921875,14.833608984375001,11.419921875L14.307378984375,11.419921875C14.100138984375,11.419921875,13.914368984374999,11.547772875,13.840358984375,11.741350875M13.524898984375,15.428461875L14.556758984375,12.570551875L14.593258984375,12.570551875L15.615968984375,15.428461875L13.524898984375,15.428461875Z",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$e = [];
const __vue2_script$e = {
  name: "switchLanguageIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(
  __vue2_script$e,
  render$f,
  staticRenderFns$e,
  false,
  __vue2_injectStyles$e,
  null,
  null,
  null
);
function __vue2_injectStyles$e(context) {
  for (let o2 in __cssModules$e) {
    this[o2] = __cssModules$e[o2];
  }
}
var switchLanguageIcon = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_55_4065"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "24",
      "height": "24",
      "rx": "0"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_55_4065)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M14.3337379296875,6L14.3337379296875,11.00389L13.3337379296875,11.00389L13.3337379296875,6L14.3337379296875,6ZM11.6015579296875,8L5.9999999996875,8L5.9999999996875,9L11.6015579296875,9L11.6015579296875,8ZM15.6002179296875,8L18.0004779296875,8L18.0004779296875,9L15.6002179296875,9L15.6002179296875,8ZM10.656007929687501,13.22214L10.656007929687501,12.99585L9.656007929687501,12.99585L9.656007929687501,17.9997L9.959777929687501,17.9997L9.9661779296875,17.9998L10.366177929687499,17.9999L10.3766779296875,17.9997L10.656007929687501,17.9997L10.656007929687501,17.778C10.6626979296875,17.7531,10.6662579296875,17.7269,10.6662579296875,17.6999L10.6662579296875,13.30019C10.6662579296875,13.27319,10.6626979296875,13.247029999999999,10.656007929687501,13.22214ZM5.9999999996875,14.98779L8.4002679296875,14.98779L8.4002679296875,15.98779L5.9999999996875,15.98779L5.9999999996875,14.98779ZM12.398927929687499,14.98779L18.0004779296875,14.98779L18.0004779296875,15.98779L12.398927929687499,15.98779L12.398927929687499,14.98779Z",
      "fill-rule": "evenodd",
      "fill": "currentColor",
      "fill-opacity": "0.8500000238418579"
    }
  })])])]);
};
var staticRenderFns$d = [];
const __vue2_script$d = {
  name: "AdminSettingIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
};
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(
  __vue2_script$d,
  render$e,
  staticRenderFns$d,
  false,
  __vue2_injectStyles$d,
  null,
  null,
  null
);
function __vue2_injectStyles$d(context) {
  for (let o2 in __cssModules$d) {
    this[o2] = __cssModules$d[o2];
  }
}
var AdminSettingIcon = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    class: [!!_vm.level && "select bg-gray-600 radius-m submenu", {
      "no-info-select": !_vm.showInfo
    }],
    style: !_vm.level && {
      width: _vm.width,
      right: `${_vm.right}px`,
      top: `${_vm.top}px`
    }
  }, [_c("ul", {
    staticClass: "select_ul"
  }, _vm._l(_vm.list, function(value, key) {
    return _c("li", {
      key,
      staticClass: "transition h5 hover--text-tran-85",
      class: {
        "has-border": value.divid,
        "qr-code-wrapper": value.qrCodeUrl
      },
      attrs: {
        "data-tours-name": value.toursName
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.clickHandler(value);
        },
        "mouseenter": function($event) {
          return _vm.hoverHandler(value);
        }
      }
    }, [value.qrCodeUrl ? _c("qrcode", {
      attrs: {
        "text": value.qrCodeUrl,
        "size": 124
      }
    }) : [_c("span", {
      staticClass: "icon"
    }, [_c(value.icon, {
      tag: "component"
    })], 1), _c("span", [_vm._v(_vm._s(value.title))]), value.child ? _c("span", {
      staticClass: "more"
    }, [_c("moreIcon", {
      tag: "component"
    })], 1) : _vm._e()], value.child && _vm.checked === value.title ? _c("select-menu", {
      attrs: {
        "list": value.child,
        "level": _vm.level + 1
      },
      on: {
        "clickItem": function(value2) {
          return _vm.$emit("clickItem", value2);
        }
      }
    }) : _vm._e()], 2);
  }), 0)]);
};
var staticRenderFns$c = [];
var selectMenu_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$c = defineComponent({
  name: "selectMenu",
  props: {
    list: {
      type: Array,
      require: true
    },
    level: {
      type: Number,
      require: false
    },
    top: {
      type: Number,
      require: true,
      default: 0
    },
    right: {
      type: Number,
      require: false,
      default: 0
    },
    triangleLeft: {
      type: Number,
      require: true
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "240px"
    }
  },
  emits: ["clickItem"],
  components: { qrcode, colormodeIcon, downloadIcon, fontIcon, mobileIcon, logoutIcon, moreIcon, settingIcon, websiteIcon, pcIcon, workspaceIcon, profileIcon, starIcon, communityIcon, switchLanguageIcon, AdminSettingIcon },
  data() {
    return {
      checked: ""
    };
  },
  methods: {
    hoverHandler(value) {
      this.checked = value.title;
    },
    clickHandler(value) {
      this.$emit("clickItem", value);
    }
  }
});
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(
  __vue2_script$c,
  render$d,
  staticRenderFns$c,
  false,
  __vue2_injectStyles$c,
  "96b4778a",
  null,
  null
);
function __vue2_injectStyles$c(context) {
  for (let o2 in __cssModules$c) {
    this[o2] = __cssModules$c[o2];
  }
}
var selectMenu = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "select bg-gray-600 radius-m",
    class: {
      "no-info-select": !_vm.showInfo
    },
    style: {
      width: _vm.width,
      right: `${_vm.right}px`,
      top: `${_vm.top}px`
    }
  }, [_vm.showArrow ? _c("div", {
    staticClass: "select_triangle",
    style: {
      left: `${_vm.triangleLeft}px`
    }
  }) : _vm._e(), _vm.showInfo ? _c("div", {
    staticClass: "header transition h5"
  }, [_vm._t("front")], 2) : _vm._e(), _c("select-menu", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.list,
      expression: "list"
    }],
    attrs: {
      "list": _vm.list,
      "top": _vm.top,
      "right": _vm.right,
      "level": 0
    },
    on: {
      "clickItem": function(value) {
        return _vm.$emit("clickItem", value);
      }
    }
  })], 1);
};
var staticRenderFns$b = [];
var selectPortrait_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$b = defineComponent({
  props: {
    list: {
      type: Array,
      require: true
    },
    top: {
      type: Number,
      require: true
    },
    right: {
      type: Number,
      require: true
    },
    triangleLeft: {
      type: Number,
      require: true
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: "240px"
    }
  },
  emits: ["clickItem"],
  components: { selectMenu }
});
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(
  __vue2_script$b,
  render$c,
  staticRenderFns$b,
  false,
  __vue2_injectStyles$b,
  "06e00325",
  null,
  null
);
function __vue2_injectStyles$b(context) {
  for (let o2 in __cssModules$b) {
    this[o2] = __cssModules$b[o2];
  }
}
var selectPortrait = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
function onEvent(el2, event, value) {
  const path = event.path || event.composedPath && event.composedPath();
  const isClickOutside = path ? path.indexOf(el2) < 0 : !el2.contains(event.target);
  if (!isClickOutside) {
    return;
  }
  event.stopPropagation();
  value();
}
function bind2(el2, binding) {
  const eventHandler = (ev) => {
    onEvent(el2, ev, binding.value);
  };
  el2.clickoutsideHandler = eventHandler;
  setTimeout(() => {
    document.addEventListener(
      "click",
      eventHandler,
      { capture: true }
    );
  }, 0);
}
function unbind(el2) {
  const eventHandler = el2.clickoutsideHandler;
  if (eventHandler && typeof eventHandler === "function") {
    document.removeEventListener(
      "click",
      eventHandler,
      { capture: true }
    );
  }
  el2.clickoutsideHandler = void 0;
}
const clickoutside = {
  mounted: bind2,
  beforeUnmount: unbind,
  bind: bind2,
  unbind
};
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "m-head-container",
    class: {
      "m-head-pointer": _vm.usePointer,
      "working-space": _vm.headType === "withButton"
    },
    attrs: {
      "data-tours-name": "avatar"
    },
    on: {
      "click": function($event) {
        return _vm.sendLog({
          action_detail: "image"
        });
      }
    }
  }, [_c("MAvatar", {
    attrs: {
      "info": _vm.userInfo,
      "size": _vm.avatarSize
    }
  }), _vm.headType === "withButton" ? _c("span", {
    staticClass: "working-space-text",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.jumpHome.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.$_t("\u524D\u5F80\u5DE5\u4F5C\u53F0")))]) : _vm._e(), _c("transition", {
    attrs: {
      "name": "fade-out"
    }
  }, [_vm.selectChoose ? _c("selectPortrait", {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: _vm.closePortrait,
      expression: "closePortrait"
    }],
    attrs: {
      "top": _vm.config.top,
      "right": _vm.config.right,
      "triangleLeft": _vm.config.triangleLeft,
      "list": _vm.list,
      "showInfo": _vm.headType === "OnlyAvatar"
    },
    on: {
      "clickItem": _vm.emitEvent
    },
    scopedSlots: _vm._u([_vm.headType === "OnlyAvatar" ? {
      key: "front",
      fn: function() {
        return [_c("div", {
          staticClass: "menu-info"
        }, [_c("div", {
          staticStyle: {
            "margin-right": "15px"
          }
        }, [_c("MAvatar", {
          attrs: {
            "info": _vm.userInfo,
            "size": _vm.avatarSize
          }
        })], 1), _c("div", {
          staticStyle: {
            "flex": "1",
            "overflow": "hidden"
          }
        }, [_c("div", {
          staticClass: "menu-info-name truncate h4"
        }, [_vm._v(" " + _vm._s(_vm.userInfo.name) + " ")]), _c("div", {
          staticClass: "menu-info-mail truncate p6"
        }, [_vm._v(" " + _vm._s(_vm.userInfo.email) + " ")])])])];
      },
      proxy: true
    } : null], null, true)
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns$a = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$2 = "";
const __vue2_script$a = defineComponent({
  name: "MHead",
  components: {
    MAvatar,
    selectPortrait
  },
  directives: {
    clickoutside
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        name: "",
        avatar: "",
        email: ""
      })
    },
    isPri: {
      type: Boolean,
      default: false
    },
    isResourceSquare: {
      type: Boolean,
      default: false
    },
    expandList: {
      type: Array,
      default: () => []
    },
    listMode: {
      type: Object,
      default: () => ({})
    },
    avatarSize: {
      type: String,
      default: "middle"
    },
    theme: {
      type: String,
      default: "light"
    },
    language: {
      type: String,
      default: "zh-CN"
    },
    usePointer: {
      type: Boolean,
      default: false
    },
    headType: {
      type: String,
      default: "OnlyAvatar"
    },
    actionPosition: {
      type: String,
      default: "workplace"
    }
  },
  setup(props2, { emit }) {
    const selectChoose = ref(false);
    const { proxy } = getCurrentInstance();
    const isI18N = computed(() => proxy.isI18N);
    const config = computed(
      () => props2.type === "withButton" ? {
        right: 0,
        triangleLeft: 0
      } : {
        top: 50,
        right: 0,
        triangleLeft: 189
      }
    );
    const list = computed(() => {
      const {
        home = true,
        theme: theme2 = true,
        switchLanguage = false,
        community = true,
        personal = false,
        website = true,
        setting = true,
        logout: logout2 = true
      } = props2.listMode;
      const origin = [
        {
          title: i18n.t("\u5DE5\u4F5C\u53F0"),
          enabled: home,
          type: "router",
          path: ROUTER_PATH.FILES_HOME,
          toursName: "home",
          icon: "workspaceIcon"
        },
        {
          title: props2.isResourceSquare ? i18n.t("\u56DE\u5230\u4E3B\u9875") : i18n.t("\u8D44\u6E90\u793E\u533A"),
          enabled: isMobile() && community && !isI18N.value,
          type: "router",
          path: props2.isResourceSquare ? ROUTER_PATH.FILES_HOME : ROUTER_PATH.COMMUNITY,
          toursName: "community",
          icon: "websiteIcon"
        },
        {
          title: i18n.t("\u793E\u533A\u4E2A\u4EBA\u4E3B\u9875"),
          enabled: personal,
          type: "router",
          path: ROUTER_PATH.COMMUNITY_PROFILE,
          toursName: "personal",
          icon: "profileIcon"
        },
        {
          title: i18n.t("\u524D\u5F80\u5B98\u7F51"),
          enabled: !props2.isPri && website,
          type: "router",
          path: ROUTER_PATH.OFFICIAL_WEBSITE,
          toursName: "website",
          icon: "websiteIcon"
        },
        {
          title: props2.isResourceSquare ? i18n.t("\u56DE\u5230\u4E3B\u9875") : i18n.t("\u8D44\u6E90\u793E\u533A"),
          enabled: isI18N.value && community,
          type: "router",
          path: props2.isResourceSquare ? ROUTER_PATH.FILES_HOME : ROUTER_PATH.COMMUNITY,
          toursName: "community",
          icon: isI18N ? "communityIcon" : "websiteIcon"
        },
        {
          title: props2.theme === "dark" ? i18n.t("\u5207\u6362\u81F3\u6D45\u8272\u6A21\u5F0F") : i18n.t("\u5207\u6362\u81F3\u6DF1\u8272\u6A21\u5F0F"),
          enabled: theme2,
          type: "theme",
          value: props2.theme === "dark" ? "light" : "dark",
          toursName: "theme",
          icon: "colormodeIcon",
          divid: true
        },
        {
          title: props2.language === "en-US" ? i18n.t("\u5207\u6362\u81F3\u4E2D\u6587") : i18n.t("\u5207\u6362\u81F3\u82F1\u6587"),
          enabled: switchLanguage,
          type: "language",
          value: props2.language === "zh-CN" ? "en-US" : "zh-CN",
          toursName: "language",
          icon: "switchLanguageIcon"
        },
        {
          title: i18n.t("\u4E2A\u4EBA\u8BBE\u7F6E"),
          enabled: setting,
          type: "router",
          path: ROUTER_PATH.SETTING,
          toursName: "setting",
          icon: "settingIcon"
        },
        {
          title: i18n.t("\u9000\u51FA\u767B\u5F55"),
          enabled: logout2 && !platformInfo().isDingDing,
          type: "logout",
          toursName: "logout",
          icon: "logoutIcon"
        }
      ];
      props2.expandList.forEach((item) => {
        if (item.appendIndex !== void 0) {
          if (typeof item.appendIndex === "function") {
            let index2 = origin.findIndex((child) => item.appendIndex(child));
            if (item.position === "next") {
              index2 += 1;
            }
            origin.splice(index2, 0, item);
          } else {
            origin.splice(item.appendIndex, 0, item);
          }
          return;
        }
        origin.push(item);
      });
      return origin.filter((item) => item.enabled);
    });
    const closePortrait = () => {
      selectChoose.value = false;
    };
    const changeVisible = () => {
      selectChoose.value = !selectChoose.value;
    };
    const currentTheme = ref("");
    watch(
      () => props2.theme,
      (val) => {
        currentTheme.value = val;
      },
      { immediate: true }
    );
    const jumpHome = () => {
      const data2 = {};
      data2.action_position = props2.actionPosition;
      data2.action_parameter1 = "backworkplace";
      data2.action_detail = "backworkplace";
      sensors.track(SensorsType.EVENT_CLICK, data2);
      emitEvent(
        {
          type: "router",
          path: "/files/home"
        },
        1
      );
    };
    const emitEvent = async (value, level = 2) => {
      const data2 = {};
      if (value.type === "theme") {
        data2.action_detail = "mode";
        currentTheme.value = currentTheme.value === "dark" ? "light" : "dark";
      } else if (value.type === "logout") {
        data2.action_detail = "logout";
      } else {
        switch (value.path) {
          case ROUTER_PATH.FILES_HOME: {
            data2.action_detail = "workplace" + level;
            break;
          }
          case ROUTER_PATH.SETTING: {
            data2.action_detail = "setting";
            break;
          }
          case ROUTER_PATH.OFFICIAL_WEBSITE: {
            data2.action_detail = "officialwebsite";
            const fn2 = dingOpenWindowWithOAuth();
            if (fn2) {
              sendLog2(data2);
              await fn2(ROUTER_PATH.OFFICIAL_WEBSITE + "?stop_leave=1");
              return;
            }
            break;
          }
          case ROUTER_PATH.COMMUNITY_PROFILE: {
            const fn2 = dingOpenWindowWithOAuth();
            if (fn2) {
              sendLog2(data2);
              await fn2(ROUTER_PATH.COMMUNITY_PROFILE);
              return;
            }
            break;
          }
          case ROUTER_PATH.COMMUNITY: {
            const fn2 = dingOpenWindowWithOAuth();
            if (fn2) {
              sendLog2(data2);
              await fn2(ROUTER_PATH.COMMUNITY);
              return;
            }
          }
        }
      }
      sendLog2(data2);
      emit(value.type, value);
      changeVisible();
    };
    const sendLog2 = (data2 = {}) => {
      data2.action_position = props2.actionPosition;
      data2.action_parameter1 = props2.headType === "withButton" ? "backworkplace" : "image";
      sensors.track(SensorsType.EVENT_CLICK, data2);
      changeVisible();
    };
    return {
      jumpHome,
      emitEvent,
      currentTheme,
      sendLog: sendLog2,
      list,
      closePortrait,
      selectChoose,
      config
    };
  }
});
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(
  __vue2_script$a,
  render$b,
  staticRenderFns$a,
  false,
  __vue2_injectStyles$a,
  "45295d2e",
  null,
  null
);
function __vue2_injectStyles$a(context) {
  for (let o2 in __cssModules$a) {
    this[o2] = __cssModules$a[o2];
  }
}
var MHead = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var top$1 = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top$1, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
  if (node == null) {
    return window;
  }
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }
  return node;
}
function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function(name2) {
    var style = state.styles[name2] || {};
    var attributes = state.attributes[name2] || {};
    var element = state.elements[name2];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function(name3) {
      var value = attributes[name3];
      if (value === false) {
        element.removeAttribute(name3);
      } else {
        element.setAttribute(name3, value === true ? "" : value);
      }
    });
  });
}
function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name2) {
      var element = state.elements[name2];
      var attributes = state.attributes[name2] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name2) ? state.styles[name2] : initialStyles[name2]);
      var style = styleProperties.reduce(function(style2, property2) {
        style2[property2] = "";
        return style2;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement$1(placement) {
  return placement.split("-")[0];
}
var max = Math.max;
var min = Math.min;
var round = Math.round;
function getUAString() {
  var uaData = navigator.userAgentData;
  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function(item) {
      return item.brand + "/" + item.version;
    }).join(" ");
  }
  return navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;
  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }
  var _ref = isElement$1(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport;
  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width,
    height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x,
    y
  };
}
function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element);
  var width = element.offsetWidth;
  var height = element.offsetHeight;
  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }
  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width,
    height
  };
}
function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode();
  if (parent.contains(child)) {
    return true;
  } else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
  return ((isElement$1(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());
  if (isIE && isHTMLElement(element)) {
    var elementCss = getComputedStyle(element);
    if (elementCss.position === "fixed") {
      return null;
    }
  }
  var currentNode = getParentNode(element);
  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css2 = getComputedStyle(currentNode);
    if (css2.transform !== "none" || css2.perspective !== "none" || css2.contain === "paint" || ["transform", "perspective"].indexOf(css2.willChange) !== -1 || isFirefox && css2.willChange === "filter" || isFirefox && css2.filter && css2.filter !== "none") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static")) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min$1, value, max$12) {
  return max(min$1, min(value, max$12));
}
function withinMaxClamp(min2, value, max2) {
  var v = within(min2, value, max2);
  return v > max2 ? max2 : v;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys2) {
  return keys2.reduce(function(hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
var toPaddingObject = function toPaddingObject2(padding, state) {
  padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
  var _state$modifiersData$;
  var state = _ref.state, name2 = _ref.name, options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement$1(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top$1 : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min2 = paddingObject[minProp];
  var max2 = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min2, center, max2);
  var axisProp = axis;
  state.modifiersData[name2] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect$1(_ref2) {
  var state = _ref2.state, options = _ref2.options;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(placement) {
  return placement.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x, y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}
function mapToStyles(_ref2) {
  var _Object$assign2;
  var popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
  var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
    x,
    y
  }) : {
    x,
    y
  };
  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top$1;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    var heightProp = "clientHeight";
    var widthProp = "clientWidth";
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
      if (getComputedStyle(offsetParent).position !== "static" && position === "absolute") {
        heightProp = "scrollHeight";
        widthProp = "scrollWidth";
      }
    }
    offsetParent = offsetParent;
    if (placement === top$1 || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left || (placement === top$1 || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles = Object.assign({
    position
  }, adaptive && unsetSides);
  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x,
    y
  }, getWindow(popper2)) : {
    x,
    y
  };
  x = _ref4.x;
  y = _ref4.y;
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }
  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
  var state = _ref5.state, options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement$1(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration,
    isFixed: state.options.strategy === "fixed"
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive,
      roundOffsets
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false,
      roundOffsets
    })));
  }
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: true
};
function effect(_ref) {
  var state = _ref.state, instance = _ref.instance, options = _ref.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect,
  data: {}
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y
  };
}
function getDocumentRect(element) {
  var _element$ownerDocumen;
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;
  if (getComputedStyle(body || html).direction === "rtl") {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  var _element$ownerDocumen;
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === "fixed");
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement$1(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function computeOffsets(_ref) {
  var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement$1(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top$1:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== "number" ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top$1, bottom].indexOf(key) >= 0 ? "y" : "x";
      overflowOffsets[key] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding
    })[getBasePlacement$1(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a2, b2) {
    return overflows[a2] - overflows[b2];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement$1(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref) {
  var state = _ref.state, options = _ref.options, name2 = _ref.name;
  if (state.modifiersData[name2]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement$1(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement$1(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement$1(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top$1, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top$1;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name2]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top$1, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref) {
  var state = _ref.state, name2 = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name2] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement$1(placement);
  var invertDistance = [left, top$1].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref = typeof offset2 === "function" ? offset2(Object.assign({}, rects, {
    placement
  })) : offset2, skidding = _ref[0], distance = _ref[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref2) {
  var state = _ref2.state, options = _ref2.options, name2 = _ref2.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data2 = placements.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data2[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }
  state.modifiersData[name2] = data2;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(_ref) {
  var state = _ref.state, name2 = _ref.name;
  state.modifiersData[name2] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
  var state = _ref.state, options = _ref.options, name2 = _ref.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding,
    altBoundary
  });
  var basePlacement = getBasePlacement$1(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data2 = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var _offsetModifierState$;
    var mainSide = mainAxis === "y" ? top$1 : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min$1 = offset2 + overflow[mainSide];
    var max$12 = offset2 - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset2 + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset2, tether ? max(max$12, tetherMax) : max$12);
    popperOffsets2[mainAxis] = preventedOffset;
    data2[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _offsetModifierState$2;
    var _mainSide = mainAxis === "x" ? top$1 : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _len = altAxis === "y" ? "height" : "width";
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var isOriginSide = [top$1, left].indexOf(basePlacement) !== -1;
    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data2[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name2] = data2;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort2(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort2(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort2(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce$1(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key) {
    return merged[key];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(setOptionsAction) {
        var options2 = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options2);
        state.scrollParents = {
          reference: isElement$1(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name2 = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name: name2,
              instance
            }) || state;
          }
        }
      },
      update: debounce$1(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref) {
        var name2 = _ref.name, _ref$options = _ref.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect3 = _ref.effect;
        if (typeof effect3 === "function") {
          var cleanupFn = effect3({
            state,
            name: name2,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO2() {
  return document.body;
};
function getValueAtIndexOrReturn(value, index2, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index2];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index2] : defaultValue : v;
  }
  return value;
}
function isType(value, type2) {
  var str = {}.toString.call(value);
  return str.indexOf("[object") === 0 && str.indexOf(type2 + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === "function" ? value.apply(void 0, args) : value;
}
function debounce(fn2, ms2) {
  if (ms2 === 0) {
    return fn2;
  }
  var timeout;
  return function(arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      fn2(arg);
    }, ms2);
  };
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function(item, index2) {
    return arr.indexOf(item) === index2;
  });
}
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function(acc, key) {
    if (obj[key] !== void 0) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
function div() {
  return document.createElement("div");
}
function isElement(value) {
  return ["Element", "Fragment"].some(function(type2) {
    return isType(value, type2);
  });
}
function isNodeList(value) {
  return isType(value, "NodeList");
}
function isMouseEvent(value) {
  return isType(value, "MouseEvent");
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }
  if (isNodeList(value)) {
    return arrayFrom(value);
  }
  if (Array.isArray(value)) {
    return value;
  }
  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function(el2) {
    if (el2) {
      el2.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function(el2) {
    if (el2) {
      el2.setAttribute("data-state", state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;
  var _normalizeToArray = normalizeToArray(elementOrElements), element = _normalizeToArray[0];
  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX, clientY = event.clientY;
  return popperTreeData.every(function(_ref) {
    var popperRect = _ref.popperRect, popperState = _ref.popperState, props2 = _ref.props;
    var interactiveBorder = props2.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;
    if (!offsetData) {
      return true;
    }
    var topDistance = basePlacement === "bottom" ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === "top" ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === "right" ? offsetData.left.x : 0;
    var rightDistance = basePlacement === "left" ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(event) {
    box[method](event, listener);
  });
}
function actualContains(parent, child) {
  var target = child;
  while (target) {
    var _target$getRootNode;
    if (parent.contains(target)) {
      return true;
    }
    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }
  return false;
}
var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }
  currentInput.isTouch = true;
  if (window.performance) {
    document.addEventListener("mousemove", onDocumentMouseMove);
  }
}
function onDocumentMouseMove() {
  var now = performance.now();
  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener("mousemove", onDocumentMouseMove);
  }
  lastMouseMoveTime = now;
}
function onWindowBlur() {
  var activeElement = document.activeElement;
  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;
    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener("touchstart", onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener("blur", onWindowBlur);
}
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
var isIE11 = isBrowser ? !!window.msCrypto : false;
var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: "fade",
  arrow: true,
  content: "",
  inertia: false,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {
  },
  onBeforeUpdate: function onBeforeUpdate() {
  },
  onCreate: function onCreate() {
  },
  onDestroy: function onDestroy() {
  },
  onHidden: function onHidden() {
  },
  onHide: function onHide() {
  },
  onMount: function onMount() {
  },
  onShow: function onShow() {
  },
  onShown: function onShown() {
  },
  onTrigger: function onTrigger() {
  },
  onUntrigger: function onUntrigger() {
  },
  onClickOutside: function onClickOutside() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: "mouseenter focus",
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps2(partialProps) {
  var keys2 = Object.keys(partialProps);
  keys2.forEach(function(key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps2 = plugins.reduce(function(acc, plugin2) {
    var name2 = plugin2.name, defaultValue = plugin2.defaultValue;
    if (name2) {
      var _name;
      acc[name2] = passedProps[name2] !== void 0 ? passedProps[name2] : (_name = defaultProps[name2]) != null ? _name : defaultValue;
    }
    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps2);
}
function getDataAttributeProps(reference2, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins
  }))) : defaultKeys;
  var props2 = propKeys.reduce(function(acc, key) {
    var valueAsString = (reference2.getAttribute("data-tippy-" + key) || "").trim();
    if (!valueAsString) {
      return acc;
    }
    if (key === "content") {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e2) {
        acc[key] = valueAsString;
      }
    }
    return acc;
  }, {});
  return props2;
}
function evaluateProps(reference2, props2) {
  var out = Object.assign({}, props2, {
    content: invokeWithArgsOrReturn(props2.content, [reference2])
  }, props2.ignoreAttributes ? {} : getDataAttributeProps(reference2, props2.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === "auto" ? props2.interactive : out.aria.expanded,
    content: out.aria.content === "auto" ? props2.interactive ? null : "describedby" : out.aria.content
  };
  return out;
}
var innerHTML = function innerHTML2() {
  return "innerHTML";
};
function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}
function createArrowElement(value) {
  var arrow2 = div();
  if (value === true) {
    arrow2.className = ARROW_CLASS;
  } else {
    arrow2.className = SVG_ARROW_CLASS;
    if (isElement(value)) {
      arrow2.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow2, value);
    }
  }
  return arrow2;
}
function setContent(content, props2) {
  if (isElement(props2.content)) {
    dangerouslySetInnerHTML(content, "");
    content.appendChild(props2.content);
  } else if (typeof props2.content !== "function") {
    if (props2.allowHTML) {
      dangerouslySetInnerHTML(content, props2.content);
    } else {
      content.textContent = props2.content;
    }
  }
}
function getChildren(popper2) {
  var box = popper2.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box,
    content: boxChildren.find(function(node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function(node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function(node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render$a(instance) {
  var popper2 = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute("data-state", "hidden");
  box.setAttribute("tabindex", "-1");
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute("data-state", "hidden");
  setContent(content, instance.props);
  popper2.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);
  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren(popper2), box2 = _getChildren.box, content2 = _getChildren.content, arrow2 = _getChildren.arrow;
    if (nextProps.theme) {
      box2.setAttribute("data-theme", nextProps.theme);
    } else {
      box2.removeAttribute("data-theme");
    }
    if (typeof nextProps.animation === "string") {
      box2.setAttribute("data-animation", nextProps.animation);
    } else {
      box2.removeAttribute("data-animation");
    }
    if (nextProps.inertia) {
      box2.setAttribute("data-inertia", "");
    } else {
      box2.removeAttribute("data-inertia");
    }
    box2.style.maxWidth = typeof nextProps.maxWidth === "number" ? nextProps.maxWidth + "px" : nextProps.maxWidth;
    if (nextProps.role) {
      box2.setAttribute("role", nextProps.role);
    } else {
      box2.removeAttribute("role");
    }
    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content2, instance.props);
    }
    if (nextProps.arrow) {
      if (!arrow2) {
        box2.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box2.removeChild(arrow2);
        box2.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow2) {
      box2.removeChild(arrow2);
    }
  }
  return {
    popper: popper2,
    onUpdate
  };
}
render$a.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = [];
var mountedInstances = [];
function createTippy(reference2, passedProps) {
  var props2 = evaluateProps(reference2, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps))));
  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props2.interactiveDebounce);
  var currentTarget;
  var id2 = idCounter++;
  var popperInstance = null;
  var plugins = unique(props2.plugins);
  var state = {
    isEnabled: true,
    isVisible: false,
    isDestroyed: false,
    isMounted: false,
    isShown: false
  };
  var instance = {
    id: id2,
    reference: reference2,
    popper: div(),
    popperInstance,
    props: props2,
    state,
    plugins,
    clearDelayTimeouts,
    setProps,
    setContent: setContent2,
    show,
    hide: hide2,
    hideWithInteractivity,
    enable: enable2,
    disable: disable2,
    unmount,
    destroy
  };
  if (!props2.render) {
    return instance;
  }
  var _props$render = props2.render(instance), popper2 = _props$render.popper, onUpdate = _props$render.onUpdate;
  popper2.setAttribute("data-tippy-root", "");
  popper2.id = "tippy-" + instance.id;
  instance.popper = popper2;
  reference2._tippy = instance;
  popper2._tippy = instance;
  var pluginsHooks = plugins.map(function(plugin2) {
    return plugin2.fn(instance);
  });
  var hasAriaExpanded = reference2.hasAttribute("aria-expanded");
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook("onCreate", [instance]);
  if (props2.showOnCreate) {
    scheduleShow();
  }
  popper2.addEventListener("mouseenter", function() {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper2.addEventListener("mouseleave", function() {
    if (instance.props.interactive && instance.props.trigger.indexOf("mouseenter") >= 0) {
      getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    }
  });
  return instance;
  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }
  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === "hold";
  }
  function getIsDefaultRenderFn() {
    var _instance$props$rende;
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }
  function getCurrentTarget() {
    return currentTarget || reference2;
  }
  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }
  function getDefaultTemplateChildren() {
    return getChildren(popper2);
  }
  function getDelay(isShow) {
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") {
      return 0;
    }
    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }
  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }
    popper2.style.pointerEvents = instance.props.interactive && !fromHide ? "" : "none";
    popper2.style.zIndex = "" + instance.props.zIndex;
  }
  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }
    pluginsHooks.forEach(function(pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });
    if (shouldInvokePropsHook) {
      var _instance$props;
      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }
  function handleAriaContentAttribute() {
    var aria = instance.props.aria;
    if (!aria.content) {
      return;
    }
    var attr = "aria-" + aria.content;
    var id3 = popper2.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function(node) {
      var currentValue = node.getAttribute(attr);
      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id3 : id3);
      } else {
        var nextValue = currentValue && currentValue.replace(id3, "").trim();
        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }
  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function(node) {
      if (instance.props.interactive) {
        node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
      } else {
        node.removeAttribute("aria-expanded");
      }
    });
  }
  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener("mousemove", debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function(listener) {
      return listener !== debouncedOnMouseMove;
    });
  }
  function onDocumentPress(event) {
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === "mousedown") {
        return;
      }
    }
    var actualTarget = event.composedPath && event.composedPath()[0] || event.target;
    if (instance.props.interactive && actualContains(popper2, actualTarget)) {
      return;
    }
    if (normalizeToArray(instance.props.triggerTarget || reference2).some(function(el2) {
      return actualContains(el2, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }
      if (instance.state.isVisible && instance.props.trigger.indexOf("click") >= 0) {
        return;
      }
    } else {
      invokeHook("onClickOutside", [instance, event]);
    }
    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide();
      didHideDueToDocumentMouseDown = true;
      setTimeout(function() {
        didHideDueToDocumentMouseDown = false;
      });
      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }
  function onTouchMove() {
    didTouchMove = true;
  }
  function onTouchStart() {
    didTouchMove = false;
  }
  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener("mousedown", onDocumentPress, true);
    doc.addEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
  }
  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener("mousedown", onDocumentPress, true);
    doc.removeEventListener("touchend", onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener("touchstart", onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener("touchmove", onTouchMove, TOUCH_OPTIONS);
  }
  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function() {
      if (!instance.state.isVisible && popper2.parentNode && popper2.parentNode.contains(popper2)) {
        callback();
      }
    });
  }
  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }
  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;
    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, "remove", listener);
        callback();
      }
    }
    if (duration === 0) {
      return callback();
    }
    updateTransitionEndListener(box, "remove", currentTransitionEndListener);
    updateTransitionEndListener(box, "add", listener);
    currentTransitionEndListener = listener;
  }
  function on2(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference2);
    nodes.forEach(function(node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node,
        eventType,
        handler,
        options
      });
    });
  }
  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on2("touchstart", onTrigger2, {
        passive: true
      });
      on2("touchend", onMouseLeave, {
        passive: true
      });
    }
    splitBySpaces(instance.props.trigger).forEach(function(eventType) {
      if (eventType === "manual") {
        return;
      }
      on2(eventType, onTrigger2);
      switch (eventType) {
        case "mouseenter":
          on2("mouseleave", onMouseLeave);
          break;
        case "focus":
          on2(isIE11 ? "focusout" : "blur", onBlurOrFocusOut);
          break;
        case "focusin":
          on2("focusout", onBlurOrFocusOut);
          break;
      }
    });
  }
  function removeListeners() {
    listeners.forEach(function(_ref) {
      var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }
  function onTrigger2(event) {
    var _lastTriggerEvent;
    var shouldScheduleClickHide = false;
    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }
    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === "focus";
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();
    if (!instance.state.isVisible && isMouseEvent(event)) {
      mouseMoveListeners.forEach(function(listener) {
        return listener(event);
      });
    }
    if (event.type === "click" && (instance.props.trigger.indexOf("mouseenter") < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }
    if (event.type === "click") {
      isVisibleFromClick = !shouldScheduleClickHide;
    }
    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }
  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper2.contains(target);
    if (event.type === "mousemove" && isCursorOverReferenceOrPopper) {
      return;
    }
    var popperTreeData = getNestedPopperTree().concat(popper2).map(function(popper3) {
      var _instance$popperInsta;
      var instance2 = popper3._tippy;
      var state2 = (_instance$popperInsta = instance2.popperInstance) == null ? void 0 : _instance$popperInsta.state;
      if (state2) {
        return {
          popperRect: popper3.getBoundingClientRect(),
          popperState: state2,
          props: props2
        };
      }
      return null;
    }).filter(Boolean);
    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }
  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf("click") >= 0 && isVisibleFromClick;
    if (shouldBail) {
      return;
    }
    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }
    scheduleHide(event);
  }
  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf("focusin") < 0 && event.target !== getCurrentTarget()) {
      return;
    }
    if (instance.props.interactive && event.relatedTarget && popper2.contains(event.relatedTarget)) {
      return;
    }
    scheduleHide(event);
  }
  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf("touch") >= 0 : false;
  }
  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset2 = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
    var arrow2 = getIsDefaultRenderFn() ? getChildren(popper2).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference2;
    var tippyModifier = {
      name: "$$tippy",
      enabled: true,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function fn2(_ref2) {
        var state2 = _ref2.state;
        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(attr) {
            if (attr === "placement") {
              box.setAttribute("data-placement", state2.placement);
            } else {
              if (state2.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, "");
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state2.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: "offset",
      options: {
        offset: offset2
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];
    if (getIsDefaultRenderFn() && arrow2) {
      modifiers.push({
        name: "arrow",
        options: {
          element: arrow2,
          padding: 3
        }
      });
    }
    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = createPopper(computedReference, popper2, Object.assign({}, popperOptions, {
      placement,
      onFirstUpdate,
      modifiers
    }));
  }
  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }
  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode;
    var node = getCurrentTarget();
    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === "parent") {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    }
    if (!parentNode.contains(popper2)) {
      parentNode.appendChild(popper2);
    }
    instance.state.isMounted = true;
    createPopperInstance();
  }
  function getNestedPopperTree() {
    return arrayFrom(popper2.querySelectorAll("[data-tippy-root]"));
  }
  function scheduleShow(event) {
    instance.clearDelayTimeouts();
    if (event) {
      invokeHook("onTrigger", [instance, event]);
    }
    addDocumentPress();
    var delay = getDelay(true);
    var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
    if (currentInput.isTouch && touchValue === "hold" && touchDelay) {
      delay = touchDelay;
    }
    if (delay) {
      showTimeout = setTimeout(function() {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }
  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook("onUntrigger", [instance, event]);
    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    }
    if (instance.props.trigger.indexOf("mouseenter") >= 0 && instance.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }
    var delay = getDelay(false);
    if (delay) {
      hideTimeout = setTimeout(function() {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      scheduleHideAnimationFrame = requestAnimationFrame(function() {
        instance.hide();
      });
    }
  }
  function enable2() {
    instance.state.isEnabled = true;
  }
  function disable2() {
    instance.hide();
    instance.state.isEnabled = false;
  }
  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }
  function setProps(partialProps) {
    if (instance.state.isDestroyed) {
      return;
    }
    invokeHook("onBeforeUpdate", [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference2, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();
    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    }
    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
        node.removeAttribute("aria-expanded");
      });
    } else if (nextProps.triggerTarget) {
      reference2.removeAttribute("aria-expanded");
    }
    handleAriaExpandedAttribute();
    handleStyles();
    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }
    if (instance.popperInstance) {
      createPopperInstance();
      getNestedPopperTree().forEach(function(nestedPopper) {
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }
    invokeHook("onAfterUpdate", [instance, partialProps]);
  }
  function setContent2(content) {
    instance.setProps({
      content
    });
  }
  function show() {
    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    }
    if (getCurrentTarget().hasAttribute("disabled")) {
      return;
    }
    invokeHook("onShow", [instance], false);
    if (instance.props.onShow(instance) === false) {
      return;
    }
    instance.state.isVisible = true;
    if (getIsDefaultRenderFn()) {
      popper2.style.visibility = "visible";
    }
    handleStyles();
    addDocumentPress();
    if (!instance.state.isMounted) {
      popper2.style.transition = "none";
    }
    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
      setTransitionDuration([box, content], 0);
    }
    onFirstUpdate = function onFirstUpdate2() {
      var _instance$popperInsta2;
      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }
      ignoreOnFirstUpdate = true;
      void popper2.offsetHeight;
      popper2.style.transition = instance.props.moveTransition;
      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], "visible");
      }
      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance);
      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook("onMount", [instance]);
      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function() {
          instance.state.isShown = true;
          invokeHook("onShown", [instance]);
        });
      }
    };
    mount();
  }
  function hide2() {
    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }
    invokeHook("onHide", [instance], false);
    if (instance.props.onHide(instance) === false) {
      return;
    }
    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;
    if (getIsDefaultRenderFn()) {
      popper2.style.visibility = "hidden";
    }
    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);
    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], "hidden");
      }
    }
    handleAriaContentAttribute();
    handleAriaExpandedAttribute();
    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }
  function hideWithInteractivity(event) {
    getDocument().addEventListener("mousemove", debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }
  function unmount() {
    if (instance.state.isVisible) {
      instance.hide();
    }
    if (!instance.state.isMounted) {
      return;
    }
    destroyPopperInstance();
    getNestedPopperTree().forEach(function(nestedPopper) {
      nestedPopper._tippy.unmount();
    });
    if (popper2.parentNode) {
      popper2.parentNode.removeChild(popper2);
    }
    mountedInstances = mountedInstances.filter(function(i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook("onHidden", [instance]);
  }
  function destroy() {
    if (instance.state.isDestroyed) {
      return;
    }
    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference2._tippy;
    instance.state.isDestroyed = true;
    invokeHook("onDestroy", [instance]);
  }
}
function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }
  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins
  });
  var elements = getArrayOfElements(targets);
  var instances = elements.reduce(function(acc, reference2) {
    var instance = reference2 && createTippy(reference2, passedProps);
    if (instance) {
      acc.push(instance);
    }
    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
Object.assign({}, applyStyles$1, {
  effect: function effect2(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }
  }
});
tippy.setDefaultProps({
  render: render$a
});
var svgArrow = "";
var __vue2_script$9 = defineComponent({
  name: "Tooltip",
  props: {
    trigger: {
      type: String,
      default: "mouseenter"
    },
    placement: {
      type: String,
      default: "bottom"
    },
    hideOnClick: {
      type: [Boolean, String],
      default: true
    },
    interactive: {
      type: Boolean,
      default: true
    },
    offset: {
      type: Array
    }
  },
  data() {
    return {
      tippyInstance: null
    };
  },
  watch: {
    placement(newVal) {
      if (this.tippyInstance) {
        this.tippyInstance.setProps({ placement: newVal });
      }
    }
  },
  mounted() {
    this.tippyInstance = tippy(this.$refs.targetEl, {
      content: this.$refs.contentEl,
      duration: 0,
      trigger: this.trigger,
      placement: this.placement,
      hideOnClick: this.hideOnClick,
      zIndex: 9999999999,
      interactive: this.interactive,
      arrow: ROUND_ARROW,
      appendTo: () => document.body,
      offset: this.offset,
      onShow: () => {
        this.$emit("show");
      },
      onHide: () => {
        this.$emit("hide");
      }
    });
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
});
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "reason",
    on: {
      "click": _vm.onClick
    }
  }, [_c("div", {
    ref: "targetEl",
    staticClass: "reason__wrapper"
  }, [_vm._t("target")], 2), _c("div", {
    ref: "contentEl",
    staticClass: "reason__wrapper"
  }, [_vm._t("content")], 2)]);
};
var staticRenderFns$9 = [];
var Tooltip_vue_vue_type_style_index_0_scoped_true_lang = "";
var Tooltip_vue_vue_type_style_index_1_lang = "";
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$9,
  render$9,
  staticRenderFns$9,
  false,
  __vue2_injectStyles$9,
  "76b7f459",
  null,
  null
);
function __vue2_injectStyles$9(context) {
  for (let o2 in __cssModules$9) {
    this[o2] = __cssModules$9[o2];
  }
}
var MVersionTooltip = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", {
    staticClass: "version-check-icon",
    class: _vm.iconClass
  }, [_c("svg", {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "16",
      "height": "16",
      "viewBox": "0 0 16 16"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "master_svg0_110_82680/110_57002/110_33251"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "16",
      "height": "16",
      "rx": "8"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_110_82680/110_57002/110_33251)"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "16",
      "height": "16",
      "rx": "8",
      "fill": "currentColor",
      "fill-opacity": "1"
    }
  }), _c("g", {
    attrs: {
      "transform": "matrix(0.7071067690849304,0.7071067690849304,-0.7071067690849304,0.7071067690849304,4.596160198008874,-6.096111928665778)"
    }
  }, [_c("path", {
    attrs: {
      "d": "",
      "fill-opacity": "1"
    }
  }), _c("path", {
    attrs: {
      "d": "M14.65673828125,11.5L14.65673828125,2.5L12.65673828125,2.5L12.65673828125,9.5L9.65673828125,9.5L9.65673828125,11.5L14.65673828125,11.5Z",
      "fill-rule": "evenodd",
      "fill-opacity": "1"
    }
  })])])])]);
};
var staticRenderFns$8 = [];
var VersionCheckIcon_vue_vue_type_style_index_0_scoped_true_lang = "";
var VersionCheckIcon_vue_vue_type_style_index_1_lang = "";
const __vue2_script$8 = defineComponent({
  props: {
    type: {
      type: String,
      default: VersionType.Free
    }
  },
  setup(props2) {
    const type2 = ref(props2.type);
    const iconClass = computed(() => {
      const _type = type2.value;
      return {
        "icon-free": _type === VersionType.Free,
        "icon-team": _type === VersionType.Team,
        "icon-enterprise": _type === VersionType.Enterprise,
        "icon-private": _type === VersionType.Private
      };
    });
    return {
      iconClass
    };
  }
});
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$8,
  render$8,
  staticRenderFns$8,
  false,
  __vue2_injectStyles$8,
  "7845e9d9",
  null,
  null
);
function __vue2_injectStyles$8(context) {
  for (let o2 in __cssModules$8) {
    this[o2] = __cssModules$8[o2];
  }
}
var MVersionCheckIcon = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("li", {
    ref: "itemRef",
    staticClass: "version-item",
    class: _vm.itemClass
  }, [_c("div", {
    staticClass: "version-item__header"
  }, [_c("h1", {
    staticClass: "version-item__title"
  }, [_vm._v(" " + _vm._s(_vm.versionInfoData.title) + " "), _vm.versionInfoData.titleLabel ? _c("span", {
    staticClass: "version-item__title-desc"
  }, [_vm._v(_vm._s(_vm.versionInfoData.titleLabel))]) : _vm._e()]), _c("h2", {
    staticClass: "version-item__subtitle"
  }, [_vm._v(_vm._s(_vm.versionInfoData.desc))]), _c("h5", {
    staticClass: "version-item__price"
  }, [_vm.versionInfoData.seatPrice ? _c("div", {
    staticClass: "version-item__price-item version-item__price-item-single"
  }, [_vm._v(" " + _vm._s(_vm.versionInfoData.seatPrice) + " ")]) : _vm._l(_vm.versionInfoData.seatPriceData, function(seatItem) {
    return _c("div", {
      key: seatItem.version,
      staticClass: "version-item__price-item version-item__price-item-multi",
      class: {
        "has-line": seatItem.hasLine,
        "mobile-free": _vm.showMobileFree(seatItem)
      }
    }, [_vm.showMobileFree(seatItem) ? _c("div", [_vm._v(" " + _vm._s(seatItem.title) + " ")]) : [_c("div", {
      staticClass: "version-item__price-item-left"
    }, [_c("div", {
      staticClass: "version-item__price-item-left-title"
    }, [_c("span", {
      staticClass: "version-item__price-item-left-title-text"
    }, [_vm._v(_vm._s(seatItem.title))]), seatItem.titleIcon ? _c(_vm.icons[seatItem.titleIcon], {
      tag: "component",
      staticClass: "version-item__price-item-left-title-icon"
    }) : _vm._e()], 1), _c("div", {
      staticClass: "version-item__price-item-left-icon"
    }, _vm._l(seatItem.icons, function(iconItem) {
      return _c(_vm.icons[iconItem], {
        key: iconItem,
        tag: "component"
      });
    }), 1)]), seatItem.price ? _c("div", {
      staticClass: "version-item__price-item-right"
    }, [_c("span", {
      staticClass: "version-item__price-item-right-price"
    }, [_vm._v(_vm._s(seatItem.price))]), seatItem.originPrice ? _c("span", {
      staticClass: "version-item__price-item-right__label"
    }, [_vm._v(" " + _vm._s(_vm.$_t("\u539F\u4EF7")) + " "), _c("span", {
      staticClass: "version-item__price-item-right__price"
    }, [_vm._v(" \xA5" + _vm._s(seatItem.originPrice.replace(/[^0-9.]/g, "")) + " ")])]) : _vm._e()]) : _vm._e()]], 2);
  })], 2)]), _vm.versionInfoData.btnTip ? _c("Tooltip", {
    staticClass: "version-btn-tip",
    attrs: {
      "placement": "bottom",
      "interactive": true,
      "trigger": "mouseenter"
    }
  }, [_c("span", {
    staticClass: "tooltip-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.versionInfoData.btnTip))]), _c("MButton", {
    staticClass: "version-item__btn",
    attrs: {
      "slot": "target",
      "type": _vm.versionInfoData.btnType,
      "width": _vm.btnWidth,
      "size": _vm.btnSize,
      "disabled": _vm.versionInfoData.btnDisabled
    },
    on: {
      "click": _vm.handleClick
    },
    slot: "target"
  }, [_vm._v(" " + _vm._s(_vm.versionInfoData.btnText) + " ")])], 1) : _c("div", {
    staticClass: "version-item__button-container"
  }, [_c("MButton", {
    staticClass: "version-item__btn",
    attrs: {
      "type": _vm.versionInfoData.btnType,
      "width": _vm.btnWidth,
      "size": _vm.btnSize,
      "disabled": _vm.versionInfoData.btnDisabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._v(" " + _vm._s(_vm.versionInfoData.btnText) + " ")])], 1), _vm.versionInfoData.tip ? _c("p", {
    staticClass: "version-item__tip"
  }, [_vm._v(_vm._s(_vm.versionInfoData.tip))]) : _vm._e(), _c("ul", {
    staticClass: "version-item__details"
  }, _vm._l(_vm.versionInfoData.details, function(detail, index2) {
    return _c("li", {
      key: index2,
      staticClass: "version-item__detail-item"
    }, [_c("div", {
      staticClass: "version-item__item-left"
    }, [_c("MVersionCheckIcon", {
      attrs: {
        "type": _vm.versionInfoData.type
      }
    }), _c("span", {
      staticClass: "version-item__item-title"
    }, [_vm._v(_vm._s(detail.title))])], 1), _c("span", {
      staticClass: "version-item__item-content"
    }, [_vm._v(_vm._s(detail.content))])]);
  }), 0)], 1);
};
var staticRenderFns$7 = [];
var index_vue_vue_type_style_index_0_scoped_true_lang$1 = "";
var index_vue_vue_type_style_index_1_lang$1 = "";
const __vue2_script$7 = defineComponent({
  name: "MVersionItem",
  components: {
    MButton: MVersionButton,
    Tooltip: MVersionTooltip,
    MVersionCheckIcon
  },
  props: {
    versionInfo: {
      type: Object,
      default: () => ({})
    },
    isPage: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    versionInfoData() {
      return this.versionInfo;
    },
    btnWidth() {
      return this.isPage ? 240 : 202;
    },
    btnSize() {
      return this.isPage ? "lg" : "sm";
    },
    itemClass() {
      const _type = this.versionInfoData.type;
      return {
        "is-usage": this.versionInfoData.isUsage,
        "item-disabled": this.versionInfoData.btnDisabled,
        "item-free": _type === VersionType.Free,
        "item-team": _type === VersionType.Team,
        "item-enterprise": _type === VersionType.Enterprise,
        "item-private": _type === VersionType.Private,
        "item-page": this.isPage
      };
    }
  },
  setup() {
    const itemRef = ref();
    return {
      itemRef,
      icons
    };
  },
  methods: {
    showMobileFree(seatItem) {
      return isMobile() && !seatItem.originPrice;
    },
    handleClick() {
      if (this.versionInfoData.btnDisabled)
        return;
      this.$emit("btnClick");
    }
  }
});
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$7,
  render$7,
  staticRenderFns$7,
  false,
  __vue2_injectStyles$7,
  "398fd784",
  null,
  null
);
function __vue2_injectStyles$7(context) {
  for (let o2 in __cssModules$7) {
    this[o2] = __cssModules$7[o2];
  }
}
var MVersionItem = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "version-item-desc"
  }, [_c("span", {
    staticClass: "version-item-desc__title-text"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c("ul", {
    staticClass: "version-item-desc__sub-title-list"
  }, _vm._l(_vm.subTitles, function(subTitle) {
    return _c("li", {
      key: subTitle.title
    }, [_c(_vm.icons[subTitle.icon], {
      tag: "component",
      attrs: {
        "size": subTitle.iconSize || "12"
      }
    }), _c("span", {
      staticClass: "version-item-desc__sub-title-text"
    }, [_vm._v(" " + _vm._s(subTitle.title) + " ")])], 1);
  }), 0)]);
};
var staticRenderFns$6 = [];
var Desc_vue_vue_type_style_index_0_scoped_true_lang = "";
const __vue2_script$6 = defineComponent({
  name: "MVersionItemDesc",
  props: {
    title: {
      type: String,
      default: ""
    },
    subTitles: {
      type: Array,
      default: () => []
    }
  },
  setup(props2) {
    const title = ref(props2.title);
    const subTitles = computed(() => props2.subTitles);
    return {
      title,
      subTitles,
      icons
    };
  }
});
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$6,
  render$6,
  staticRenderFns$6,
  false,
  __vue2_injectStyles$6,
  "3255ac5e",
  null,
  null
);
function __vue2_injectStyles$6(context) {
  for (let o2 in __cssModules$6) {
    this[o2] = __cssModules$6[o2];
  }
}
var MVersionItemDesc = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var __vue2_script$5 = defineComponent({
  name: "VersionUpgradeItem",
  components: {
    MVersionCheckIcon
  },
  props: {
    version: {
      type: Object,
      required: true
    }
  },
  setup(props2) {
    const { version: version2 } = toRefs(props2);
    const handleClick = (link) => {
      if (link) {
        openTab(link);
      }
    };
    return {
      version: version2,
      handleClick
    };
  }
});
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("li", {
    staticClass: "version-upgrade-item",
    class: [`version-upgrade-item-${_vm.version.type}`]
  }, [_c("div", {
    staticClass: "version-upgrade-content"
  }, [_c("div", {
    staticClass: "version-upgrade-title"
  }, [_c("h2", {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.version.title))]), _c("p", {
    staticClass: "sub-title"
  }, [_vm._v(_vm._s(_vm.version.subTitle))])]), _c("ul", {
    staticClass: "version-upgrade__details"
  }, _vm._l(_vm.version.details, function(detail, index2) {
    return _c("li", {
      key: index2,
      staticClass: "version-upgrade__detail-item"
    }, [_c("div", {
      staticClass: "version-upgrade__item-left"
    }, [_c("MVersionCheckIcon", {
      class: [detail.hideIcon ? "hide-icon" : ""],
      attrs: {
        "type": _vm.version.type
      }
    }), detail.link ? _c("a", {
      staticClass: "version-upgrade__item-link",
      attrs: {
        "href": "javascript:void();"
      },
      on: {
        "click": function($event) {
          return _vm.handleClick(detail.link);
        }
      }
    }, [_vm._v(" " + _vm._s(detail.title) + " ")]) : _c("span", {
      staticClass: "version-upgrade__item-title"
    }, [_vm._v(_vm._s(detail.title))])], 1), _c("span", {
      staticClass: "version-upgrade__item-content"
    }, [_vm._v(_vm._s(detail.content))])]);
  }), 0)])]);
};
var staticRenderFns$5 = [];
var VersionUpgradeItem_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$5,
  render$5,
  staticRenderFns$5,
  false,
  __vue2_injectStyles$5,
  "c57a230e",
  null,
  null
);
function __vue2_injectStyles$5(context) {
  for (let o2 in __cssModules$5) {
    this[o2] = __cssModules$5[o2];
  }
}
var VersionUpgradeItem = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var CardVersionType = /* @__PURE__ */ ((CardVersionType2) => {
  CardVersionType2["Free"] = "free";
  CardVersionType2["Team"] = "team";
  CardVersionType2["Enterprise"] = "enterprise";
  CardVersionType2["Private"] = "private";
  return CardVersionType2;
})(CardVersionType || {});
var CardVersionTitle = ((CardVersionTitle2) => {
  CardVersionTitle2[CardVersionTitle2["Free"] = tFn("\u521D\u521B\u7248")] = "Free";
  CardVersionTitle2[CardVersionTitle2["Team"] = tFn("\u56E2\u961F\u7248")] = "Team";
  CardVersionTitle2[CardVersionTitle2["Enterprise"] = tFn("\u4F01\u4E1A\u7248")] = "Enterprise";
  CardVersionTitle2[CardVersionTitle2["Private"] = tFn("\u79C1\u6709\u90E8\u7F72\u7248")] = "Private";
  return CardVersionTitle2;
})(CardVersionTitle || {});
({
  ["free"]: CardVersionTitle.Free,
  ["team"]: CardVersionTitle.Team,
  ["enterprise"]: CardVersionTitle.Enterprise,
  ["private"]: CardVersionTitle.Private
});
const VersionUpgradeEnterpriseLink = "https://mastergo.com/pricing";
var DocSeatPermissionType = /* @__PURE__ */ ((DocSeatPermissionType2) => {
  DocSeatPermissionType2["Edit"] = "edit";
  DocSeatPermissionType2["Prototype"] = "prototype";
  DocSeatPermissionType2["Dev"] = "dev";
  DocSeatPermissionType2["ViewAuto"] = "viewAuto";
  DocSeatPermissionType2["View"] = "view";
  DocSeatPermissionType2["ViewAudit"] = "viewAudit";
  return DocSeatPermissionType2;
})(DocSeatPermissionType || {});
var __vue2_script$4 = defineComponent({
  name: "VersionUpgradeChoose",
  components: {
    VersionUpgradeItem
  },
  props: {
    chooseInfo: {
      type: Object,
      required: true
    }
  },
  setup(props2) {
    const { chooseInfo } = toRefs(props2);
    const versions = computed(() => {
      const { isFreeTeam, freeVersionSeatMax, freeVersionProjectFileMax, freeVersionPrefabTeamLibrary } = chooseInfo.value;
      const firstVersionCard = isFreeTeam ? {
        title: CardVersionTitle.Free,
        subTitle: tFn("\u5F53\u524D\u7248\u672C"),
        type: CardVersionType.Free,
        details: [
          {
            title: tFn("\u8BBE\u8BA1\u5E2D\u4F4D\u4E0A\u9650"),
            content: tFn("%{num} \u4E2A", { num: freeVersionSeatMax })
          },
          {
            title: tFn("\u6587\u4EF6\u6570"),
            content: tFn("%{num} \u4E2A", { num: freeVersionProjectFileMax })
          },
          {
            title: tFn("\u9884\u7F6E\u56E2\u961F\u5E93"),
            content: tFn("%{num} \u4E2A", { num: freeVersionPrefabTeamLibrary })
          }
        ]
      } : {
        title: CardVersionTitle.Team,
        subTitle: tFn("\u5F53\u524D\u7248\u672C"),
        type: CardVersionType.Free,
        details: [
          {
            title: tFn("\u8BBE\u8BA1\u5E2D\u4F4D\u4E0A\u9650"),
            content: "\u4E0D\u9650"
          },
          {
            title: tFn("\u6587\u4EF6\u6570"),
            content: "\u4E0D\u9650"
          },
          {
            title: tFn("\u7EC4\u4EF6\u5C5E\u6027/\u63D2\u69FD"),
            content: tFn("\u652F\u6301")
          },
          {
            title: "",
            content: "",
            hideIcon: true
          }
        ]
      };
      return [
        firstVersionCard,
        {
          title: CardVersionTitle.Enterprise,
          subTitle: tFn("\u63A8\u8350\u7248\u672C"),
          type: CardVersionType.Enterprise,
          details: [
            {
              title: tFn("\u521B\u5EFA/\u7F16\u8F91/\u5206\u4EAB\u539F\u578B\u6587\u4EF6"),
              content: tFn("\u652F\u6301")
            },
            {
              title: tFn("\u4F7F\u7528\u7814\u53D1\u6A21\u5F0F"),
              content: tFn("\u652F\u6301")
            },
            {
              title: tFn("\u5E2D\u4F4D\u4E0A\u9650/\u6587\u4EF6\u6570"),
              content: tFn("\u4E0D\u9650")
            },
            {
              title: tFn("\u67E5\u770B\u66F4\u591A\u6743\u76CA"),
              content: "",
              hideIcon: true,
              link: VersionUpgradeEnterpriseLink
            }
          ]
        }
      ];
    });
    return {
      versions
    };
  }
});
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ul", {
    staticClass: "versions"
  }, _vm._l(_vm.versions, function(version2, index2) {
    return _c("VersionUpgradeItem", {
      key: index2,
      attrs: {
        "version": version2
      }
    });
  }), 1);
};
var staticRenderFns$4 = [];
var VersionUpgradeChoose_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$4,
  render$4,
  staticRenderFns$4,
  false,
  __vue2_injectStyles$4,
  "3426b392",
  null,
  null
);
function __vue2_injectStyles$4(context) {
  for (let o2 in __cssModules$4) {
    this[o2] = __cssModules$4[o2];
  }
}
var VersionUpgradeChoose = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var __vue2_script$3 = defineComponent({
  name: "DoneIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 16 16"
    }
  }, [_c("defs", [_c("clipPath", {
    attrs: {
      "id": "mg-icon222a"
    }
  }, [_c("rect", {
    attrs: {
      "width": "16",
      "height": "16",
      "rx": "0"
    }
  })])]), _c("g", {
    attrs: {
      "clip-path": "url(#mg-icon222a)"
    }
  }, [_c("path", {
    attrs: {
      "fill": "currentcolor",
      "fill-opacity": ".85",
      "fill-rule": "evenodd",
      "d": "m6.5 11.707 6.354-6.353-.708-.708L6.5 10.293 3.354 7.146l-.708.708z"
    }
  })])]);
};
var staticRenderFns$3 = [];
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$3,
  render$3,
  staticRenderFns$3,
  false,
  __vue2_injectStyles$3,
  null,
  null,
  null
);
function __vue2_injectStyles$3(context) {
  for (let o2 in __cssModules$3) {
    this[o2] = __cssModules$3[o2];
  }
}
var DoneIcon = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("svg", {
    style: {
      fontSize: _vm.size,
      color: _vm.fill,
      transform: `rotate(${_vm.rotate}deg)`
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "fill": "none",
      "version": "1.1",
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 14 14"
    }
  }, [_c("clipPath", {
    attrs: {
      "id": "master_svg0_9_06772"
    }
  }, [_c("rect", {
    attrs: {
      "x": "0",
      "y": "0",
      "width": "14",
      "height": "14",
      "rx": "0"
    }
  })]), _c("g", {
    attrs: {
      "clip-path": "url(#master_svg0_9_06772)"
    }
  }, [_c("g", [_c("path", {
    attrs: {
      "d": "M2.4180149536743163,1.7121322360076905C2.3008579536743166,1.5949747360076905,2.1109079536743165,1.5949748360076905,1.9937509536743163,1.7121322360076905C1.9937509536743163,1.7121322360076905,1.7121329536743164,1.9937502360076904,1.7121329536743164,1.9937502360076904C1.5949757536743163,2.1109072360076904,1.5949757536743163,2.3008572360076904,1.7121329536743164,2.41801423600769C1.7121329536743164,2.41801423600769,6.294120953674317,6.9999982360076904,6.294120953674317,6.9999982360076904C6.294120953674317,6.9999982360076904,1.7122049536743165,11.581928236007691,1.7122049536743165,11.581928236007691C1.5950473536743164,11.69902823600769,1.5950473536743164,11.88902823600769,1.7122049536743165,12.00622823600769C1.7122049536743165,12.00622823600769,1.9938229536743164,12.287828236007691,1.9938229536743164,12.287828236007691C2.1109799536743163,12.40492823600769,2.3009299536743164,12.40492823600769,2.418086953674316,12.287828236007691C2.418086953674316,12.287828236007691,7.000000953674316,7.70587823600769,7.000000953674316,7.70587823600769C7.000000953674316,7.70587823600769,11.581900953674316,12.287828236007691,11.581900953674316,12.287828236007691C11.699100953674316,12.40492823600769,11.889000953674316,12.40492823600769,12.006200953674316,12.287828236007691C12.006200953674316,12.287828236007691,12.287800953674317,12.00612823600769,12.287800953674317,12.00612823600769C12.404900953674316,11.88902823600769,12.404900953674316,11.69902823600769,12.287800953674317,11.581928236007691C12.287800953674317,11.581928236007691,7.7058909536743165,6.9999982360076904,7.7058909536743165,6.9999982360076904C7.7058909536743165,6.9999982360076904,12.287900953674317,2.4179422360076903,12.287900953674317,2.4179422360076903C12.405000953674316,2.3007852360076906,12.405000953674316,2.1108372360076904,12.287900953674317,1.9936802360076904C12.287900953674317,1.9936802360076904,12.006200953674316,1.7120622360076905,12.006200953674316,1.7120622360076905C11.889100953674316,1.5949041360076905,11.699100953674316,1.5949048360076905,11.582000953674317,1.7120642360076905C11.582000953674317,1.7120642360076905,7.000000953674316,6.294118236007691,7.000000953674316,6.294118236007691C7.000000953674316,6.294118236007691,2.4180149536743163,1.7121322360076905,2.4180149536743163,1.7121322360076905C2.4180149536743163,1.7121322360076905,2.4180149536743163,1.7121322360076905,2.4180149536743163,1.7121322360076905Z",
      "fill-rule": "evenodd",
      "fill": "currentcolor",
      "fill-opacity": "1"
    }
  })])])]);
};
var staticRenderFns$2 = [];
const __vue2_script$2 = defineComponent({
  name: "OverlayCloseIcon",
  props: {
    size: {
      type: String,
      default: "inherit"
    },
    rotate: {
      type: String,
      default: "0"
    },
    fill: {
      type: String,
      default: "none"
    }
  }
});
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$2,
  render$2,
  staticRenderFns$2,
  false,
  __vue2_injectStyles$2,
  null,
  null,
  null
);
function __vue2_injectStyles$2(context) {
  for (let o2 in __cssModules$2) {
    this[o2] = __cssModules$2[o2];
  }
}
var OverlayCloseIcon = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var GuidePrototypeBanner = "data:image/png;base64,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";
var GuideDesignBanner = "data:image/png;base64,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";
var GuideDevBanner = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAyUAAAFFCAMAAADFIbLeAAABKVBMVEUAAAD///////88PDwgICBwcHD///////8pKSkhISFvb289PT1ubm4hISFubm49PT0oNmZqoE9mfajFrGwmpmTFgmxJSUmsrKz6+voICAiOjo7Hx8fExMRYWFgrKystpV1bu4qR0LAsjFo3V0f////F5dVsh14AO61SXoR8hKFrlFd4eHhNTU09SnVte2aEfm1iYmI3NzempqZqdouajW1ncZKvnW1oeZkQEBBscn2ZjW0zXKuU07BTU1OaeG1Nbak5OEyuqWUbGxuvfW3J6djFjWzW2OHAwMCEc20bVzNqc5Riu4Une0oRLx0aTKyamprFoGxhYWaGhobd3+Wagm2Cl16CimZVVFqBo1bL6ddueJhmcJFGRlR+fn6viG01NTWvkm04RXGYnmPiv2OWAAAADXRSTlMAczpAQEBWHYC/v7+AVrFVcgAAGXVJREFUeNrs2kGOwyAQBVFoWw3WqOX733biUSaWEiCwMcjUW2WRbek3Stw7EVUPzEpVgysSAgG8L4Qiz28IMC193lKSb0QlOGBuIWhmT+TIRxwA5/46kVQkNAL8C59FPMpRByAfhTAkwOnMgkiA6kwC5xaQObrk/OgAfPLev2aFH0mA4s3FvQUUMnEPgSkBvoyJMiVA2qsPpgQojsn3g2vB1VZcrfxPFSkdXEv82XE9w/W2bCrFSuKOKlRyE9uae5jkKlmYkVpUchtb+mGix54wJGMx9LKtyef7UQmRjMXQT6yuZNlRj0puZc1UQiRjMfRUWQkP9yZUci8xXQlTMhZDV+lKmJKxGLqKyUqYkrEY+kpWwpSMxdBXpJLxGZr0qGRHGyq5m41KxmfoLFUJj/exGNpQyYQMbahkQoY2VDIhQxsqmZChDZVMyNCGSn7ZuZecRmIgAMMnqGETjYpSlXDPxHfIIiuEhKIkYs39LzJ2xW2nY9LBiIGY1C/RbnfWn2znwQ0GVlum5AYDqy1TcoPBf+pxGlhvZ0p6CD6/1er+jVYm5a1MSQ/BXAIhEh3fWTFSZ05MSZ/BXEh6kTBqQhpwSqDqDSObzW632+zjegKWKekwmIkQQKlQYsKojUqQ4LRVbeQhtdv3y0SYEZmOZ0jjlBjzi82Zkh6CmZDGK6FkODlBaUAS2vTKRDBFEKI8y6+pE/hIpqSH4ExFBFO8B8iTEMpUTOqxQrJ7eOifCSGyHMY4INLRrLxG8IFMSQ/B+ZBHGCJCLGlhyUOtZDW3kiQm0F+MNHJh9XA0k3GmN+2Zkh6CszEyRB2oMUuBIagTvrSU7B9O63ExiSyyBDlyQZQeaWRryY9tfptx2HKLyPiQiUgSFqZLS8muUrLpUglDSnSPNdlcsc4+nCnpITgTITHD6fEDkRkJiHVyUcmD9rp92G7X6263XIxUn+WJjpggk8BJL8+/IfX7+RnOZUp6CM4kBMwQE5zuPZiAkUPp3FqqNlwJif4dmOw6/GwxK8kRYYzqWenXc2SSkLzAuUxJD8HZipJsAfmghFJMl5Wojtfwt1QzP0JJolGeC/F5Ji9zSExJD11WAlmJkByUjL1XyfZV15Ru1xIuGmRycqtnNZN5JKakh2aVlDF1ogRrJfW5ZBmUbKOUXndcggipeEcsmQ+FGdWYCpNfl5CYkh56hxJBvRYlhBqrkoun9/Vaz++v3Z7eAZEmn5Bwea6zYqZiEppH0q7k7xd3Z11SUj5eJM5KhDS5qGRzYLLdxove7zt8JxgIkcooes17rDKrlcDvl7CazNaoZLf4+v4YlPcoEZSIQ+8m33FEgUtbrlKvG66DAGRmRJrMdCqTWXNtSv4uvqW7W29eSYpRAGslhA3fUOl3KQkRY4glzQgn0zJrr03J4nva3d1480oKE8bxXEKqhKh4Kd3PM9n3uZRoItW0nrXXpOTv4nv6c3fjgTavRFGIjpIfMJNA2zfnO/6ByTsyJT83+NxqJvtdMrKxHyueZko6CT65x/u6/T7+nteQ1JmSPoJPb3VfZ0bO9XVK3BAvxw9cHiYNzpQ0K2nvcVVn/2joTJ+sxE1KAgYfLj5cHA6LnB/GwU9c4GBK7H87XlkfUvK01mG5XqyfFsfhNF+U4BDvEgFXlOAQnjpdbDSPQ8qUmJJr6SNKnpYuDi4M6yBlmkNXhhGCLiOFifdHSuJUXzrJlJiSa6ldSZDxlLEok3klejdgOXXE2USJC3+aavLedlym5LpqV+IUiSrRbZcymVEyoA+hH3P64pGS47yPUEyJKbmqmpXoEqIFLYpmeUFJQaI5xRCV4Fh24XHQbZkpMSXXVLOSp3HtcKpF91yzStJ55JRSUOJC6F0sPUV0h9VnMCWm5HpqVaKHkrKmTJnkN6nykJUspo07rgFxfOJ9EDNgemzvcZmS66lRiVMk5ViiLUcvPoTotTjkJaF+56ooyeuId/pA50NwYkpMyZXUomS6cGQvZXkpy0bZcSULg4v5rCSd0ctbWvkYY99QMSXXVqOSsnA4Hevju/e1ErVQaKibUYnDqQln31AxJf/Yu7vdpmEwjONHHBqKQMVK4ilFCupIOpyIcQTSuISBgBMQEvd/Edhv3LksTbK3DatTP39BY3fjJNoPx/1aaHGUdJ4t8YNdER0ldnmRBQnyu/li5b5S5O6+VTstWmtQAiXBxFHiN+uEw093yrtKaIuRGyaF3HnA1yrxz7wTDFKSS7c9gRIoCSW+EnJB25LupoRWB6/EjaQ7yNx/jZQ4PyvHy8yJkH0yXhZQAiWhxFdCWxO3LfGbEr9u3FfS4sgLWbQP7/pXOzofK7d6OGI0tndCCZQEEk+JX0w+tkrcwSMpXt5TYmyQEVoq7pyQksKj2L4m0r/WvsAjwVASSlwlVE5/afTxHpLcK/H7lMK/iF7e6fFPidDWhPxI1wqPcUFJQDGVDJev/LDIvahV7iGt/CDv/ruVLc/xSDCUhBTe9x5+AvGCkggT6KTN4rMdoQTxOqmS1y9PUvQfpy3QSZvDp2lH/zHBUHLyGEpMrx8/IIGSk4ffhRV+AvGCkggTiBeURJhAvE6gZIkeMSgJsVElT56ix03rJZSEFZQEmV5CSUBBSaBpKAknKAk29XAlF586XaB97TtTUDLn1IOU/P71Jd3TEu0t7dY0+gJKZpt+gBLVpKam0zO0t6YTnT8FJbONVpNBJWYdaUqBjmn5yUj5InqDksBTI0pUmsLIBJVp+lv0BSWhpwaVXDRAMkHE5Evv3gRKgm9QiU4bgSYpTX+JnqAk+NSQkib9JNAklf07EygJv2ElS4Emadm/LENJ+KkBJWkqEDP+uYSS8NNQwglK4gxKOEFJnCkoYQQlcQYlnKAkzjSUMIKSOOMrUVmWiIGqNtGXrsW0JUqEkT0zUHKWcZUkmUpkJvordWUqde/XJ1aSyUQEUXtmoCT0ftz8vHXHdk7TodhKEmlulFQDSmgZqc3hMZQomWRhKNmeGSgJu9ubm5sfO8efdByMraT9kVSjSoS2h9pdelV1bQd0S0rMgA6mShyTEiIUJe2ZgZLA+2FU/PRHUjKymLCVSKEU/TyMKCEMlb36soNSl1qL2k5prs3Ifp+m+48qGCVSKZVgXxJ+TsWtPTotT4fjKlEykVkik7F9iSYrdFNpMzA03FSbYVXSNVlNk51mroTODJQE3+2tO7jp6PUWX8nwvsTv3itBGEgD+aCBn9I12b8LyayVKIl9yfnGXkvsIcvG9yVaVLod3SmhqVXSpi2UnWatRGzPDJScYdx9iXI71WElZKJyLCq/lpAS+4c6LyXtmYGSc4yhxP9fKceVVCWxoIFT4qa1u9DS9Vkp2Z4ZKDnDRG9NI/ZfcqlMDu7eaxNt37WBUOtqK6cyh5ruawfntZYMnpkG78KadaK35XL/M8xSZkr0p9vq1kVJEOyNm9ZVTYNS2+M9JbN+hYqiM8M4lxSUzKEBJXhD7wFByTkGJYygJNKghBGURBqUMIKSSIMSRlASaVDCCEoiDUoYQUmkQQkjKIk0KGEEJZEGJYygJNKghBGURBqUMIKSSIMSRlASaVDCCEoibRolr6IMSmIJSqBk8t69t30wvTB9fm56a/v25s33q6urp7NrKiWL6IKSTsSDZPicEh+ReXP17umMghIomSTPY0yJt/J9LssKlEDJkVkhxIGjxFOZwxUYlEDJMXkhfCVeSuhQoARKDsxfZfGVdKV8D3mjAiVQcljv/CIyrmTmUKAESg6JiEyphAp1kwIlUMKN9iIcJZyC3KNMrmRNbRad7u5bXy8Wm/Vi7sWqhIgwlfCc/AnuymtyJZfXBsn1ZVfB9Xqr5NJ81+Vi7sWphIhwlbD7FtiCMr0SwrC53AwooYVl7sWohIwcqmTGF17/QwmZuLZW1ms7o4FVQgNSstlYKWZGWuzgEDibr67FA4KS4/JG+Erm7uQve3eQ6yYMhAH4BFh9ygY59i5CBImwARY9QBfdt6raVXv/Q3Q8OCUhSRVIsGfw/HqKCQTU176v43Fos44SHGo3+TrWSAa4gBIA0sHXcSgsx67rju44vrCEM+am/OXz+4kXi5JXgkYWK+HuZB0ldQlDiVvdp2ED96CZ41nJEQHBxnCcWUOflhIwElgJplAk8n4lQ0q37RuU4YlT0rkNX0u8p6PvYWpRQlcJGAmvBPPjuyKQFWpJDfFLvs5LjQoQRlciHK/E43BfeFyUEFWCRl5WwnnetVZfgnOo2teS2h/oOtw/UeIVSS2hqaTtd/GUYL6puFlTCW4hFcRRYz+PReNaifQlpJVAIXmLEtbTrhWVdMCi7o41AoEN34qUEyUIqOxECUUlYISAkujTrhWVAIyuQwvl8diBA9jltqZ9idvd1TLjoqekaXdElERd7aJxt2M5cGH2dvz2lYAROko+PqKVEyJKOvfA7c6urSsBI7SUfFQqTmgogfdYYHLGrJRsXUm7I6ckVjkhogS6fG5Gtq6k3VFUEqc7oaKEY7asBIzQVBJl1iVKRMltAAlZJR8/ws+6wio57DPIHnIeLYx6MloY9ZPjzQWzOxfUsy94SFtJuyOsJMKsK6wSnTGJTllJs3tv+j8fk/C7YyWkkoxNElbSvslG/xnSNApyOhWQyoXprEuUiJLLtC/jQBsPA2Sqit2sS5SIkjGvIfn8WT0VrC5VxYiJ9CXSl4zpAxAZc6q4MAmpZJ8xyT5RJf1iIo1aFph+cWAiSkSJz0IkPRJZHph8kWciSkTJkGYZEfVysKOnvSIs3bt075gmRCvyOKeKMpPZf7LaipJHSrRlq6SNaAQDTuje1TVXic61KHmgROeGq5IFSNT7U8x/f1EFyFwlNtdGB1wJtkbrYUNrPe566gQzOWFG7AIl+HvDVUlDwYjLqSJZTWYqyTKjw3Xvxujh72ebw5bJINoYLGf3o69OyK3bleMJAbp3m3FV0hAxAgEnBJnM7ksCKtE5/rzbLMs1mnG7LO56eALEHdX+BDwVTwiwxsVWCR0jLgU9JpSVGO0fdZ6hF1cs/vfTOB7NrQd23iVKHqenZMSloMYkpJJsZrTF0oBKfJEwetQA8U/19AQ7nmA8sFlJSkk/b2ErRE4VrbcXKStxQSFeRW6dAIjNx44Zj96ckPtfK3yJkv+nJVZIhpxIMaGuROf2Son1EEYmN0gQjih5Mi1FI5BZ067vas2spKT+MmTyGVV2wUqwsdm0luDzkUk+PWFUkYMS41ktXwn+ff5utqikJWpEzZt2NWrFrKSk/Orze3n37uuCp3B+NOayEUEw7jWjGeNH61ktUrK//93U21NCGImaU05+rMmE9hqX/QcgP1cUa/CpHpGMr7o8YDTaQFr4VNa47qUhjQTKCZFbuijfE6yNdfHdiUYCRmdWmwskIyZ8GQarkN9v4CI6l3uC72TG8laj4uRUkejgAyhZ3JfkQ4aykPt6YGBrdISPFgc8hjHjCX7LzixiiSh5dr7Vq3gpKDBhc+e8zRZG7px/lJb0bGvIDCZqrTBSsiii5D9pWCBxs67o78GLkmSV9DyQQKq4cy7a3ftbIv+i90Fa2n37VYqoTERJskpa8n37ZYqYrYkoSVVJw2W25VNEfNeE9krwWyL/a93d9LyQAJN4cy7p3hPt3ltuSIBJtBu6REmaShp+SIBJrGIiStJU0jNEEo+JdO9Jdu8No9WtyxRx1rnCKjkcMsjhMI4Wxv1k1DDqyeh82dvx9oLZ9IJ+1NML//eCW//EuJ4nEmASpZjIp49eJZFPH225vJl4myLGh8KLkgSVNCybEp8qQjERJQkq6RkjUacIcy5Rkp6ShmtTMqQI38CLkvSU9KyRAJPgxUSUJKekZdu5Y55j0qp3RpQkp4Q9EqWqwMVElKSmpGXcuZ9zCtyZiJLUlPT8kShVhC0moiQxJQ3vzv2cImgxESWJKek3gUSpoMVElKSlpGHfuasIxUSUpKVkK6UEmAQsJqIkKSWbKSWQgMVElCSlZDulJGgxYa5k/JyUZ5K8ki2VEqWqYMWEuZLyp8/vZ16dvJItlZKQxYS5kjkRJdsqJcAkVDERJQkp2VYpgYQqJqJElPyL4pZClJAPNyXNBm7gmiTQlEuUpKNkc6UkWDERJeko2V4pUUqUUA8zJc3GWndMEWTKJUqSUdJvahU4aDERJcko+cve/bw4DUQBHPfgQcV54EAlJKnHCBVa6YAhBptDKeypylLFi7uL//8f4e4Y8QfJ2Myb17xJ3veot+DHmTdJkykuJQDFJb5nEkzJLItJyWaSSwnAJbZcomQuSt5dfCmpjClL3VaWpqqAoOISWy63EslZREquDodPF1xKKlPqjkoCKW4l3wGfKBlWxEoW9/VDgZBVRrddAkpB+20sUTK4eJXsFzYLhXbD1a4iTiiA6oJbLlHiUbxKDtZIC4Vww2W07ZJORMlUGlvJxvrohQKY3EbonRRUp1yixK9olZwsjr+hfMJvuDyR2AwEqiD65o8o8SxaJXdWRh+UDfiEMIJfTui3XKLEt2iV2LGkG4qvEl8k+OVk2GKyAq9EiXexKtks+jsc7gBfpX0qwS/6wUSU+BerktPC1QnQGd02yq4r/B0TUYIoViV3TiVXgM1o70IwKUIPJqIEU6xKDi4ke/DIHwmeiSiZaOMq2VAqsUhGZuJU8hWGJkpQRarkPemGy2hkgG4VdjARJagiVUI6llQaWwnY3FuuL4BO9ZZlShqU37WkV3LjVAK4ND4DHlEOJnglyzxNFafSpeLRw5VhqYRyLCk1ByYEP+tFKUnzNE1yxac0YYI2zfM0yRkq2Sxc7QCT0UGqABfB3XeMkjRRSi0TLv99q2WS5jyU/Loy/JRc0Y0llQ4U4CoI7r5jlKTqviUfJUpxUfLzyjBUcqIbS0odKAOoCoLHghFKkqVashkEHmKj5OeV4TiX7MnGkkoHC1CtCcZ3XyV2R5HkCZdJgJmSJM+TdFZKSh0sA6iYKXnYeKd85hI2Storw3EuIRtLjA5YBZhWvJSk6r6c0yEXDyXq15Vhp4RueNdac1lMCoJDLsxcwugfJi8l9sqksSkB/yodNMBUEDzJ5a2k/b+S1WDCRMmvK8NOyY5qLCl10AwgWhMcBXsrsVuuZZ4oRjFR0l4ZftO7U8kNeFfpwAGiNcHzjph770mS5JyGdy5K2isTmZI78K7UgTOAiJcSKbanHXdEv+bV8ShZw9mJEnRRKrmhUVLp4AGiUM/OixJ0USrZ0xwElzp4BjwKfMNElIzWy2yrepqLkrpummaCSraZ/FgxUB/YKtmAbwORvG47Ho+9WErwrxhJyXX2RklB+phdq55GVgIe+Ywlzevf1bovOC9OSr7JlitQL7NsqXqiV3IgUWL0wJr76touJ7qvCryif0RF9fZKFpMB+S4lsSoptU+tEuRgwkmJus2yj0pC9y3b3qq+ZqWkbndcBErWYylRb7Mse/NBZnhMb75lzv0WvZIFiRIPI40lMjkl6nabdfZS6izr7PpWcVWyB9/OWTmOdfPPQlI/UGk08pCLmRL1anm93YoShJLrb0ulxlSyIVbi3l0dm7+RTFKJFKBZKrFIWid/ING1KJH4KQESJZV216KoWyfNsUXy8CcarYTTGZfUlSixSv6PpPlnTdG2oyiR+Cm5GmHHZZH8e/wrSqQ4ldyAb2cisTV1/cff1aJEikrJJ/DNfV/EQaHReCWMnuOSOpuUkgP45oXEJkqkuJT4PzlfIpBg772LkvlFrARolBgEEuwzwaJkfo2q5AQeuZTUFgmxEka/VZQ6i07JnkRJ1auk1t7BeYmS+TXqm4Z24Jv2Dz28M3rTkNSZKOH4DpW1KJl2kb4n2GjfsGOJKJlh1EpOCx4/fP9/cGac3qYtdRadkg2NEtChK+HcGH2/ROosOiUE38KiWUwq8G8lSqYduZJDgPGd+5cZnEo+w4BECcvIldzQKAEdNgMehX+ZtihhGbmSHZESo4NWgUfhj7hECcvIlZyoPhmnQ1bCuYmSGUaghOKQi/WXrFfhDoJFCcvIlQCVEuCylIQ94hIlDKNXcgjzvCPpYgKY1i9EycRzKrEBsn2g8Z2QiQFMbiUFDEqUMOwpvZId2ZYLdJhKQLUKObyLEoadoeQZILJKuC8mFaB6IUom3hlKngOuKzolYMbfb8HarQQGJUo49rhfCf0hlw1Qjb/fCj28ixJ+PepUEnYxWRAuJtXoSAKPJaKEX0/olNAPJjYzNhJ4IUom3qNuJWGZ7Ci3XGAuO7kP3HB9hYGJEnY9cSjBHwbTb7nwTCrAtgo8loiSH+3ZMWrDQBCFYe9iZm0XAl/DRVykEMopcoLc/xjJvqjTbCCWBi3o/8CF3f/sG9yZ66lZyaYH/FdYJfK+QySBg4tKuqJI3Eq2yiR+csm0102iwfWn5/B/VNKTs1uJqZJFJrfhdc/AySXTGPw/Sdsj4Cyhkm5cnBYsmT6eNZl8RlYi406RvN0DzhIq6YUicSrReyKrnpP4ybXyOBmnYQuPkLOESrqgRpqVFH1xQ7m9lMpH7OSSaYx9SHz3oLOESvZ1vV7OJ1+pgeh8B9CsZH5QALjmPjKPCSDNwcXkAtqsDi4eE6Ct1Dgk/eQCYCnVq0Ry4oAHHPZ7lbC5gIY5DDIBHH4WxugCpBWFsqkLDICoiOz9aHQCVHkZiRRTJ4SCoyvZkiLx5FSZWQYOy5LkdkSWAJgaaStmpILjMsuLRL4B1FzJb7Fl1IEAAAAASUVORK5CYII=";
const SEAT_BANNER = {
  [DocSeatPermissionType.Edit]: GuideDesignBanner,
  [DocSeatPermissionType.Dev]: GuideDevBanner,
  [DocSeatPermissionType.Prototype]: GuidePrototypeBanner
};
const SEAT_DESC = {
  [DocSeatPermissionType.Edit]: [
    {
      checked: true,
      text: tFn("\u4E13\u4E1A\u77E2\u91CF\u7F16\u8F91\uFF0C\u667A\u80FD\u8F85\u52A9\u5DE5\u5177\uFF0C\u5B9E\u65F6\u5728\u7EBF\u4EA4\u4ED8")
    },
    {
      checked: true,
      text: tFn("\u521B\u5EFA\u5E76\u590D\u7528\u7EC4\u4EF6\u4E0E\u6837\u5F0F\uFF0C\u4E00\u5904\u4FEE\u6539\uFF0C\u5168\u5C40\u540C\u6B65\uFF0C\u4FDD\u6301\u8BBE\u8BA1\u4E00\u81F4\u6027")
    },
    {
      checked: true,
      text: tFn("\u8BBE\u8BA1\u7CFB\u7EDF\u53D1\u5E03\u4E3A\u56E2\u961F\u5E93\uFF0C\u7EDF\u4E00\u7BA1\u7406\uFF0C\u5FEB\u901F\u5BF9\u9F50")
    },
    {
      checked: false,
      text: tFn("\u67E5\u770B\u66F4\u591A\u6743\u76CA"),
      link: VersionUpgradeEnterpriseLink
    }
  ],
  [DocSeatPermissionType.Dev]: [
    {
      checked: true,
      text: tFn("\u4F7F\u7528MasterGo MCP server \u5C06\u8BBE\u8BA1\u7A3F\u76F4\u63A5\u8F6C\u4EE3\u7801")
    },
    {
      checked: true,
      text: tFn("\u5B9A\u5236\u6807\u6CE8&\u4EE3\u7801\u7247\u6BB5\u63D2\u4EF6\uFF0C\u81EA\u5B9A\u4E49\u6807\u6CE8\u8BED\u8A00")
    },
    {
      checked: true,
      text: tFn("\u4F7F\u7528 VS code \u6269\u5C55\uFF0C\u7814\u53D1\u65E0\u9700\u79BB\u5F00\u5F00\u53D1\u73AF\u5883\u5373\u53EF\u83B7\u53D6\u8BBE\u8BA1\u6807\u6CE8")
    },
    {
      checked: false,
      text: tFn("\u67E5\u770B\u66F4\u591A\u6743\u76CA"),
      link: VersionUpgradeEnterpriseLink
    }
  ],
  [DocSeatPermissionType.Prototype]: [
    {
      checked: true,
      text: tFn("\u4EA7\u8BBE\u5DE5\u5177\u4E00\u4F53\u5316\uFF0C\u4E91\u7AEF\u7EDF\u4E00\u7BA1\u7406\u539F\u578B\u548C\u8BBE\u8BA1\u6587\u4EF6\uFF0C\u544A\u522B\u622A\u56FE\u6C9F\u901A")
    },
    {
      checked: true,
      text: tFn("\u4EA7\u54C1\u76F4\u63A5\u8C03\u7528\u8BBE\u8BA1\u7EC4\u4EF6\u5E93\uFF0C\u9AD8\u6548\u751F\u6210\u9AD8\u4FDD\u771F\u4E1A\u52A1\u539F\u578B")
    },
    {
      checked: false,
      text: tFn("\u52A8\u6001\u9762\u677F\u3001\u9AD8\u7EA7\u8868\u683C\u3001\u9AD8\u7EA7\u56FE\u8868\u3001\u53EF\u4EA4\u4E92\u63A7\u4EF6\u3001\u4EA4\u4E92\u6CE8\u91CA\u7B49\u80FD\u529B")
    },
    {
      checked: true,
      text: tFn("\u6D77\u91CF\u6A21\u7248\u8D44\u6E90\u548CElement\u3001Ant design\u7B49\u5927\u5382\u8D44\u6E90\u5E93")
    },
    {
      checked: false,
      text: tFn("\u67E5\u770B\u66F4\u591A\u6743\u76CA"),
      link: VersionUpgradeEnterpriseLink
    }
  ]
};
var __vue2_script$1 = defineComponent({
  name: "VersionUpgradeGuide",
  components: {
    DoneIcon
  },
  props: {
    seatType: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  setup(props2) {
    const { seatType, title } = toRefs(props2);
    const banner = computed(() => {
      return SEAT_BANNER[seatType.value];
    });
    const list = computed(() => {
      if (seatType.value in SEAT_DESC) {
        return SEAT_DESC[seatType.value];
      }
      return [];
    });
    return {
      title,
      banner,
      list,
      openTab
    };
  }
});
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "version-upgrade-guide"
  }, [_c("div", {
    staticClass: "version-upgrade-banner"
  }, [_c("img", {
    attrs: {
      "src": _vm.banner,
      "alt": "banner"
    }
  })]), _c("div", {
    staticClass: "version-upgrade-content"
  }, [_c("p", {
    staticClass: "version-upgrade-title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _c("ul", {
    staticClass: "version-upgrade-list"
  }, _vm._l(_vm.list, function(item) {
    return _c("li", {
      key: item.text,
      staticClass: "version-upgrade-list-item"
    }, [_c("div", {
      staticClass: "version-upgrade-list-item-icon",
      class: {
        checked: item.checked
      }
    }, [_c("DoneIcon", {
      staticStyle: {
        "color": "var(--mg-color-bg-success-hover)"
      },
      attrs: {
        "size": "16"
      }
    })], 1), _c("div", {
      staticClass: "version-upgrade-list-item-text"
    }, [item.link ? _c("a", {
      staticClass: "version-upgrade-list-item-text-link",
      attrs: {
        "href": "javascript:void();"
      },
      on: {
        "click": function($event) {
          return _vm.openTab(item.link);
        }
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]) : _c("span", [_vm._v(_vm._s(item.text))])])]);
  }), 0)])]);
};
var staticRenderFns$1 = [];
var VersionUpgradeGuide_vue_vue_type_style_index_0_scoped_true_lang = "";
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  "4543616b",
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o2 in __cssModules$1) {
    this[o2] = __cssModules$1[o2];
  }
}
var VersionUpgradeGuide = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var __vue2_script = defineComponent({
  name: "MVersionUpgrade",
  components: {
    MVersionDialog,
    MVersionButton,
    VersionUpgradeChoose,
    VersionUpgradeGuide,
    OverlayCloseIcon
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    initial: {
      type: Boolean,
      default: false
    },
    isShowCancel: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: ""
    },
    info: {
      type: Object,
      default: () => ({
        isShowVersionChoose: false,
        upgradeTitle: "",
        upgradeSubTitle: "",
        upgradeContentTitle: "",
        toSeatType: DocSeatPermissionType.Edit,
        isFreeTeam: false,
        freeVersionSeatMax: 0,
        freeVersionProjectFileMax: 0,
        freeVersionPrefabTeamLibrary: 0
      })
    }
  },
  emits: ["update:show", "update:confirm"],
  setup(props2, { emit }) {
    const { show, initial, info: info2 } = toRefs(props2);
    const showDialog = computed(() => show.value && initial.value);
    const isShowVersionChoose = computed(() => {
      var _a2;
      return (_a2 = info2.value) == null ? void 0 : _a2.isShowVersionChoose;
    });
    const isShowUpgradeButton = computed(() => {
      var _a2;
      return (_a2 = info2.value) == null ? void 0 : _a2.isShowUpgradeButton;
    });
    const upgradeTitle = computed(() => {
      var _a2;
      return (_a2 = info2.value) == null ? void 0 : _a2.upgradeTitle;
    });
    const upgradeSubTitle = computed(() => {
      var _a2;
      return (_a2 = info2.value) == null ? void 0 : _a2.upgradeSubTitle;
    });
    const upgradeContentTitle = computed(() => {
      var _a2;
      return (_a2 = info2.value) == null ? void 0 : _a2.upgradeContentTitle;
    });
    const showVersionChoose = computed(() => isShowVersionChoose.value);
    const width = computed(() => isShowVersionChoose.value ? "518px" : "436px");
    const toSeatType = computed(() => {
      var _a2;
      return (_a2 = info2.value) == null ? void 0 : _a2.toSeatType;
    });
    const isShowCancel = computed(() => props2.isShowCancel);
    const okButtonText = computed(() => {
      if (props2.buttonText) {
        return props2.buttonText;
      }
      return isShowUpgradeButton.value ? tFn("\u5347\u7EA7\u7248\u672C") : tFn("\u8D2D\u4E70\u5E2D\u4F4D");
    });
    const chooseInfo = computed(() => {
      var _a2, _b, _c, _d;
      return {
        isFreeTeam: ((_a2 = info2.value) == null ? void 0 : _a2.isFreeTeam) || false,
        freeVersionSeatMax: ((_b = info2.value) == null ? void 0 : _b.freeVersionSeatMax) || 0,
        freeVersionProjectFileMax: ((_c = info2.value) == null ? void 0 : _c.freeVersionProjectFileMax) || 0,
        freeVersionPrefabTeamLibrary: ((_d = info2.value) == null ? void 0 : _d.freeVersionPrefabTeamLibrary) || 0
      };
    });
    const handleClose = () => {
      emit("update:show", false);
    };
    const handleUpgrade = () => {
      emit("update:confirm");
    };
    return {
      showDialog,
      isShowVersionChoose,
      isShowUpgradeButton,
      upgradeTitle,
      upgradeSubTitle,
      upgradeContentTitle,
      showVersionChoose,
      width,
      toSeatType,
      chooseInfo,
      isShowCancel,
      okButtonText,
      handleClose,
      handleUpgrade
    };
  }
});
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("MVersionDialog", {
    staticClass: "version-upgrade-dialog",
    attrs: {
      "width": _vm.width,
      "visible": _vm.showDialog,
      "title": "",
      "centered": true,
      "mask": true,
      "divider": false,
      "closable": false,
      "showHeader": false,
      "showFooter": false
    },
    on: {
      "close": _vm.handleClose
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c("div", {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _c("div", {
    staticClass: "version-upgrade"
  }, [_c("div", {
    staticClass: "icon-close",
    attrs: {
      "title": _vm.$_t("\u5173\u95ED")
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleClose.apply(null, arguments);
      }
    }
  }, [_c("OverlayCloseIcon", {
    staticClass: "close-icon"
  })], 1), _c("div", {
    staticClass: "title"
  }, [_c("h2", {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.upgradeTitle))]), _c("p", {
    staticClass: "sub-title",
    domProps: {
      "innerHTML": _vm._s(_vm.upgradeSubTitle)
    }
  })]), _c("div", {
    staticClass: "spare-content"
  }, [_vm.showVersionChoose ? _c("VersionUpgradeChoose", {
    attrs: {
      "chooseInfo": _vm.chooseInfo
    }
  }) : _c("VersionUpgradeGuide", {
    attrs: {
      "seatType": _vm.toSeatType,
      "title": _vm.upgradeContentTitle
    }
  })], 1), _c("div", {
    staticClass: "footer"
  }, [_c("ul", {
    staticClass: "buttons"
  }, [_vm.isShowCancel ? _c("li", {
    staticClass: "button-item"
  }, [_c("MVersionButton", {
    staticClass: "button-item-btn",
    attrs: {
      "type": "secondary",
      "size": "sm",
      "width": "76"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(" " + _vm._s(_vm.$_t("\u53D6\u6D88")) + " ")])], 1) : _vm._e(), _c("li", {
    staticClass: "button-item"
  }, [_c("MVersionButton", {
    staticClass: "button-item-btn",
    attrs: {
      "type": "highlight",
      "size": "sm"
    },
    on: {
      "click": _vm.handleUpgrade
    }
  }, [_vm._v(" " + _vm._s(_vm.okButtonText) + " ")])], 1)])])]), _c("div", {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]);
};
var staticRenderFns = [];
var index_vue_vue_type_style_index_0_scoped_true_lang = "";
var index_vue_vue_type_style_index_1_lang = "";
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  __vue2_script,
  render,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  "42a08d6e",
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o2 in __cssModules) {
    this[o2] = __cssModules[o2];
  }
}
var MVersionUpgrade = /* @__PURE__ */ function() {
  return __component__.exports;
}();
function installLogin(Vue, options = {}) {
  const IS_I18N = !!options.isI18N;
  i18n.locale = options.locale;
  Vue.prototype.$_t = i18n.t.bind(i18n);
  Vue.prototype.isI18N = IS_I18N;
  updateEnLocale(IS_I18N);
  Vue.component("MLogin", MLogin);
  Vue.component("MHead", MHead);
  Vue.component("MVersionItem", MVersionItem);
  Vue.component("MVersionItemDesc", MVersionItemDesc);
  Vue.component("MVersionButton", MVersionButton);
  Vue.component("MVersionCheckIcon", MVersionCheckIcon);
  Vue.component("MVersionTooltip", MVersionTooltip);
  Vue.component("MVersionUpgrade", MVersionUpgrade);
  Vue.component("ResetConfirm", ResetConfirm);
}
export { MHead, MLogin, MVersionButton, MVersionCheckIcon, MVersionItem, MVersionItemDesc, MVersionTooltip, MVersionUpgrade, ResetConfirm, installLogin as default, index$1 as plugin };
